(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8ef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8ef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jlosq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createKyveLCDClient = void 0;

var $bhxP1 = parcelRequire("bhxP1");
var $e152f33a18154272$var$KyveLCDClient = /** @class */ function() {
    function KyveLCDClient(restEndpoint) {
        this.query = {
            v1beta1: new $bhxP1.KyveRegistryLCDClient(restEndpoint)
        };
    }
    return KyveLCDClient;
}();
function $e152f33a18154272$var$createKyveLCDClient(restEndpoint) {
    return {
        kyve: new $e152f33a18154272$var$KyveLCDClient(restEndpoint)
    };
}
module.exports.createKyveLCDClient = $e152f33a18154272$var$createKyveLCDClient;

});
parcelRegister("bhxP1", function(module, exports) {
"use strict";
var $836b84964d3fde35$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $836b84964d3fde35$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $836b84964d3fde35$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KyveRegistryLCDClient = void 0;

var $iWCny = parcelRequire("iWCny");
var $836b84964d3fde35$var$KyveRegistryLCDClient = /** @class */ function(_super) {
    $836b84964d3fde35$var$__extends(KyveRegistryLCDClient, _super);
    function KyveRegistryLCDClient(restEndpoint) {
        return _super.call(this, restEndpoint) || this;
    }
    KyveRegistryLCDClient.prototype.params = function() {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/params";
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** Pools **/ KyveRegistryLCDClient.prototype.pool = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/pool/".concat(params.id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.pools = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        if (typeof (params === null || params === void 0 ? void 0 : params.search) !== "undefined") parameters.search = params.search;
                        if (typeof (params === null || params === void 0 ? void 0 : params.runtime) !== "undefined") parameters.runtime = params.runtime;
                        if (typeof (params === null || params === void 0 ? void 0 : params.disabled) !== "undefined") parameters.disabled = params.disabled;
                        if (typeof (params === null || params === void 0 ? void 0 : params.storage_provider_id) !== "undefined") parameters.storageProviderId = params.storage_provider_id;
                        endpoint = "/kyve/query/v1beta1/pools";
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, parameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** end Pools **/ /** Stakers **/ KyveRegistryLCDClient.prototype.stakers = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        endpoint = "/kyve/query/v1beta1/stakers";
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, params)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.staker = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/staker/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.stakersByPool = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/stakers_by_pool/".concat(params.pool_id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** end stakers **/ // async finalizedBundles(
    //   params: PaginationPartialRequestUtilType<kyveQueryBundles.QueryFinalizedBundlesRequest>
    // ): Promise<
    //   PaginationResponseTypeUtil<kyveQueryRes.QueryFinalizedBundlesResponse>
    // > {
    //   const parameters: Record<string, any> = {};
    //
    //   if (typeof params?.pagination !== "undefined") {
    //     parameters.pagination = params.pagination;
    //   }
    //   const endpoint = `kyve/query/v1beta1/finalized_bundles/${params.pool_id}`;
    //   return await this.request(endpoint, parameters);
    // }
    /** Bundles **/ KyveRegistryLCDClient.prototype.finalizedBundle = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/v1/bundles/".concat(params.pool_id, "/").concat(params.id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.finalizedBundles = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        endpoint = "/kyve/v1/bundles/".concat(params.pool_id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, parameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.currentVoteStatus = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/current_vote_status/".concat(params.pool_id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.canValidate = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/can_validate/".concat(params.pool_id, "/").concat(params.valaddress);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.canPropose = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/can_propose/".concat(params.pool_id, "/").concat(params.staker, "/").concat(params.proposer, "/").concat(params.from_index);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.canVote = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/can_vote/".concat(params.pool_id, "/").concat(params.staker, "/").concat(params.voter, "/").concat(params.storage_id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** end Bundles **/ /** Delegations **/ KyveRegistryLCDClient.prototype.delegator = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/delegator/".concat(params.staker, "/").concat(params.delegator);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.delegatorsByStaker = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        endpoint = "/kyve/query/v1beta1/delegators_by_staker/".concat(params.staker);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, parameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.stakersByDelegator = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        endpoint = "/kyve/query/v1beta1/stakers_by_delegator/".concat(params.delegator);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, parameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** end Delegations **/ /*** Account **/ KyveRegistryLCDClient.prototype.accountAssets = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/account_assets/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.accountDelegationUnbondings = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/account_delegation_unbondings/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.accountFundedList = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/account_funded_list/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.accountRedelegation = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/account_redelegation/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** End Account **/ /** Funders **/ KyveRegistryLCDClient.prototype.funder = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/funder/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.funders = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var parameters, endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        parameters = {};
                        if (typeof (params === null || params === void 0 ? void 0 : params.pagination) !== "undefined") parameters.pagination = params.pagination;
                        if (typeof (params === null || params === void 0 ? void 0 : params.search) !== "undefined") parameters.search = params.search;
                        endpoint = "/kyve/query/v1beta1/funders";
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, parameters)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.fundings_by_funder = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/fundings_by_funder/".concat(params.address);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, params)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    KyveRegistryLCDClient.prototype.fundings_by_pool = function(params) {
        return $836b84964d3fde35$var$__awaiter(this, void 0, void 0, function() {
            var endpoint;
            return $836b84964d3fde35$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        endpoint = "/kyve/query/v1beta1/fundings_by_pool/".concat(params.pool_id);
                        return [
                            4 /*yield*/ ,
                            this.request(endpoint, params)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return KyveRegistryLCDClient;
}($iWCny.AbstractKyveLCDClient);
module.exports.KyveRegistryLCDClient = $836b84964d3fde35$var$KyveRegistryLCDClient;

});
parcelRegister("iWCny", function(module, exports) {
"use strict";
var $dcab6a0187737af7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractKyveLCDClient = void 0;

var $dcab6a0187737af7$var$axios_1 = $dcab6a0187737af7$var$__importDefault((parcelRequire("1zKtH")));

var $dcab6a0187737af7$var$qs_1 = $dcab6a0187737af7$var$__importDefault((parcelRequire("kddvv")));
$dcab6a0187737af7$var$axios_1.default.interceptors.request.use(function(config) {
    config.paramsSerializer = function(params) {
        return $dcab6a0187737af7$var$qs_1.default.stringify(params, {
            allowDots: true,
            encode: false
        });
    };
    return config;
});
var $dcab6a0187737af7$var$AbstractKyveLCDClient = /** @class */ function() {
    function AbstractKyveLCDClient(restEndpoint) {
        var _this = this;
        this.restEndpoint = restEndpoint;
        this.request = function(url, params) {
            var path = "".concat(_this.restEndpoint).concat(url);
            return $dcab6a0187737af7$var$axios_1.default.get(path, {
                params: params
            }).then(function(res) {
                return res.data;
            });
        };
    }
    return AbstractKyveLCDClient;
}();
module.exports.AbstractKyveLCDClient = $dcab6a0187737af7$var$AbstractKyveLCDClient;

});
parcelRegister("1zKtH", function(module, exports) {

module.exports = (parcelRequire("81tj9"));

});
parcelRegister("81tj9", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $cG9HX = parcelRequire("cG9HX");

var $hBrVA = parcelRequire("hBrVA");

var $2PhsF = parcelRequire("2PhsF");

var $juuss = parcelRequire("juuss");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    var context = new $hBrVA(defaultConfig);
    var instance = $cG9HX($hBrVA.prototype.request, context);
    // Copy axios.prototype to instance
    $eFc3n.extend(instance, $hBrVA.prototype, context);
    // Copy context to instance
    $eFc3n.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance($2PhsF(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance($juuss);
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = $hBrVA;

// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (parcelRequire("8yOyy"));

$5d7526a7a1e5b3fb$var$axios.CancelToken = (parcelRequire("4iFhx"));

$5d7526a7a1e5b3fb$var$axios.isCancel = (parcelRequire("lCgfr"));

$5d7526a7a1e5b3fb$var$axios.VERSION = (parcelRequire("6yYtd")).version;

$5d7526a7a1e5b3fb$var$axios.toFormData = (parcelRequire("lISaw"));

// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (parcelRequire("6wIUo"));
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5d7526a7a1e5b3fb$var$axios.spread = (parcelRequire("albzn"));

// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (parcelRequire("1YbHN"));
module.exports = $5d7526a7a1e5b3fb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5d7526a7a1e5b3fb$var$axios;

});
parcelRegister("eFc3n", function(module, exports) {
"use strict";

var $cG9HX = parcelRequire("cG9HX");
// utils is a library of generic helper functions non-specific to axios
var $aace3e920a0f1e4d$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $aace3e920a0f1e4d$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $aace3e920a0f1e4d$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $aace3e920a0f1e4d$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $aace3e920a0f1e4d$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $aace3e920a0f1e4d$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $aace3e920a0f1e4d$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $aace3e920a0f1e4d$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $aace3e920a0f1e4d$var$isPlainObject(val) {
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $aace3e920a0f1e4d$var$isFunction(val) {
    return $aace3e920a0f1e4d$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $aace3e920a0f1e4d$var$isStream(val) {
    return $aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $aace3e920a0f1e4d$var$isFormData(thing) {
    var pattern = "[object FormData]";
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$toString.call(thing) === pattern || $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $aace3e920a0f1e4d$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $aace3e920a0f1e4d$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($aace3e920a0f1e4d$var$isPlainObject(result[key]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge(result[key], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[key] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $aace3e920a0f1e4d$var$extend(a, b, thisArg) {
    $aace3e920a0f1e4d$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $cG9HX(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $aace3e920a0f1e4d$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $aace3e920a0f1e4d$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $aace3e920a0f1e4d$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $aace3e920a0f1e4d$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($aace3e920a0f1e4d$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $aace3e920a0f1e4d$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isStandardBrowserEnv: $aace3e920a0f1e4d$var$isStandardBrowserEnv,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList
};

});
parcelRegister("cG9HX", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("hBrVA", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $iOHZJ = parcelRequire("iOHZJ");

var $9ltoJ = parcelRequire("9ltoJ");

var $cUzFg = parcelRequire("cUzFg");

var $2PhsF = parcelRequire("2PhsF");

var $cgfHI = parcelRequire("cgfHI");

var $8zXsW = parcelRequire("8zXsW");
var $cd0b8e3cbef64068$var$validators = $8zXsW.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $cd0b8e3cbef64068$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $9ltoJ(),
        response: new $9ltoJ()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $cd0b8e3cbef64068$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $2PhsF(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $8zXsW.assertOptions(transitional, {
        silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
        forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
        clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $cUzFg,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $cUzFg(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$cd0b8e3cbef64068$var$Axios.prototype.getUri = function getUri(config) {
    config = $2PhsF(this.defaults, config);
    var fullPath = $cgfHI(config.baseURL, config.url);
    return $iOHZJ(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$eFc3n.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request($2PhsF(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($2PhsF(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
module.exports = $cd0b8e3cbef64068$var$Axios;

});
parcelRegister("iOHZJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($eFc3n.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $eFc3n.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($eFc3n.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $eFc3n.forEach(val, function parseValue(v) {
                if ($eFc3n.isDate(v)) v = v.toISOString();
                else if ($eFc3n.isObject(v)) v = JSON.stringify(v);
                parts.push($db2f05ec923f2ee7$var$encode(key) + "=" + $db2f05ec923f2ee7$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("9ltoJ", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
function $01c17f80085c95b1$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $01c17f80085c95b1$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $eFc3n.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $01c17f80085c95b1$var$InterceptorManager;

});

parcelRegister("cUzFg", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $kgh03 = parcelRequire("kgh03");

var $lCgfr = parcelRequire("lCgfr");

var $juuss = parcelRequire("juuss");

var $8yOyy = parcelRequire("8yOyy");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $8yOyy();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kgh03.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $eFc3n.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $eFc3n.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $juuss.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kgh03.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$lCgfr(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kgh03.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kgh03", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $juuss = parcelRequire("juuss");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $juuss;
    /*eslint no-param-reassign:0*/ $eFc3n.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("juuss", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $elOvr = parcelRequire("elOvr");

var $6wIUo = parcelRequire("6wIUo");

var $49WWV = parcelRequire("49WWV");

var $lISaw = parcelRequire("lISaw");
var $e30871f78dcd7f19$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $e30871f78dcd7f19$var$setContentTypeIfUnset(headers, value) {
    if (!$eFc3n.isUndefined(headers) && $eFc3n.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $e30871f78dcd7f19$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("8nTSD"));
    else if (typeof $ibaza !== "undefined" && Object.prototype.toString.call($ibaza) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("8nTSD"));
    return adapter;
}
function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ($eFc3n.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $eFc3n.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $e30871f78dcd7f19$var$defaults = {
    transitional: $49WWV,
    adapter: $e30871f78dcd7f19$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $elOvr(headers, "Accept");
            $elOvr(headers, "Content-Type");
            if ($eFc3n.isFormData(data) || $eFc3n.isArrayBuffer(data) || $eFc3n.isBuffer(data) || $eFc3n.isStream(data) || $eFc3n.isFile(data) || $eFc3n.isBlob(data)) return data;
            if ($eFc3n.isArrayBufferView(data)) return data.buffer;
            if ($eFc3n.isURLSearchParams(data)) {
                $e30871f78dcd7f19$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            var isObjectPayload = $eFc3n.isObject(data);
            var contentType = headers && headers["Content-Type"];
            var isFileList;
            if ((isFileList = $eFc3n.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
                var _FormData = this.env && this.env.FormData;
                return $lISaw(isFileList ? {
                    "files[]": data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === "application/json") {
                $e30871f78dcd7f19$var$setContentTypeIfUnset(headers, "application/json");
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $eFc3n.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $6wIUo.from(e, $6wIUo.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("bAbs8"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
$eFc3n.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
$eFc3n.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $e30871f78dcd7f19$var$defaults.headers[method] = $eFc3n.merge($e30871f78dcd7f19$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $e30871f78dcd7f19$var$defaults;

});
parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("elOvr", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $eFc3n.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("6wIUo", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$eFc3n.inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
var $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED"
].forEach(function(code) {
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    $eFc3n.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $0139f1d30f4d6bd5$var$AxiosError;

});

parcelRegister("49WWV", function(module, exports) {
"use strict";
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("lISaw", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $fd07b9cb0132c1f6$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return "";
        if ($eFc3n.isDate(value)) return value.toISOString();
        if ($eFc3n.isArrayBuffer(value) || $eFc3n.isTypedArray(value)) return typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($eFc3n.isPlainObject(data) || $eFc3n.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error("Circular reference detected in " + parentKey);
            stack.push(data);
            $eFc3n.forEach(data, function each(value, key) {
                if ($eFc3n.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + "." + key : key;
                var arr;
                if (value && !parentKey && typeof value === "object") {
                    if ($eFc3n.endsWith(key, "{}")) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($eFc3n.endsWith(key, "[]") && (arr = $eFc3n.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$eFc3n.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $fd07b9cb0132c1f6$var$toFormData;

});
parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $0934e0939605d48c$export$e4cf37d7f6fb9e0a, (v) => $0934e0939605d48c$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $0934e0939605d48c$export$599f31c3813fae4d, (v) => $0934e0939605d48c$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "byteLength", () => $8a0a73e6b73fd0c4$export$a48f0734ac7c2329, (v) => $8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = v);
$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("8nTSD", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");

var $gyIfz = parcelRequire("gyIfz");

var $6D8uh = parcelRequire("6D8uh");

var $iOHZJ = parcelRequire("iOHZJ");

var $cgfHI = parcelRequire("cgfHI");

var $4Ik1V = parcelRequire("4Ik1V");

var $4YUSN = parcelRequire("4YUSN");

var $49WWV = parcelRequire("49WWV");

var $6wIUo = parcelRequire("6wIUo");

var $8yOyy = parcelRequire("8yOyy");

var $drWk7 = parcelRequire("drWk7");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ($eFc3n.isFormData(requestData) && $eFc3n.isStandardBrowserEnv()) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $cgfHI(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $iOHZJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $4Ik1V(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gyIfz(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $6wIUo("Request aborted", $6wIUo.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $6wIUo("Network Error", $6wIUo.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = config.transitional || $49WWV;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $6wIUo(timeoutErrorMessage, transitional.clarifyTimeoutError ? $6wIUo.ETIMEDOUT : $6wIUo.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($eFc3n.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4YUSN(fullPath)) && config.xsrfCookieName ? $6D8uh.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $eFc3n.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$eFc3n.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $8yOyy() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $drWk7(fullPath);
        if (protocol && [
            "http",
            "https",
            "file"
        ].indexOf(protocol) === -1) {
            reject(new $6wIUo("Unsupported protocol " + protocol + ":", $6wIUo.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gyIfz", function(module, exports) {
"use strict";

var $6wIUo = parcelRequire("6wIUo");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $6wIUo("Request failed with status code " + response.status, [
        $6wIUo.ERR_BAD_REQUEST,
        $6wIUo.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("6D8uh", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($eFc3n.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($eFc3n.isString(path)) cookie.push("path=" + path);
            if ($eFc3n.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("cgfHI", function(module, exports) {
"use strict";

var $uAxSn = parcelRequire("uAxSn");

var $aFAjA = parcelRequire("aFAjA");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$uAxSn(requestedURL)) return $aFAjA(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("uAxSn", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("aFAjA", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("4Ik1V", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $36eacf0f5ae88424$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $eFc3n.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $eFc3n.trim(line.substr(0, i)).toLowerCase();
        val = $eFc3n.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4YUSN", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
module.exports = $eFc3n.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $eFc3n.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8yOyy", function(module, exports) {
"use strict";

var $6wIUo = parcelRequire("6wIUo");

var $eFc3n = parcelRequire("eFc3n");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $63b8b72909769bf2$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $6wIUo.call(this, message == null ? "canceled" : message, $6wIUo.ERR_CANCELED);
    this.name = "CanceledError";
}
$eFc3n.inherits($63b8b72909769bf2$var$CanceledError, $6wIUo, {
    __CANCEL__: true
});
module.exports = $63b8b72909769bf2$var$CanceledError;

});

parcelRegister("drWk7", function(module, exports) {
"use strict";
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
};

});


parcelRegister("bAbs8", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("lCgfr", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("2PhsF", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($eFc3n.isPlainObject(target) && $eFc3n.isPlainObject(source)) return $eFc3n.merge(target, source);
        else if ($eFc3n.isPlainObject(source)) return $eFc3n.merge({}, source);
        else if ($eFc3n.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$eFc3n.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$eFc3n.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
    };
    $eFc3n.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $eFc3n.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("8zXsW", function(module, exports) {
"use strict";

var $6yYtd = parcelRequire("6yYtd");
var $63efb8494987aa98$require$VERSION = $6yYtd.version;

var $6wIUo = parcelRequire("6wIUo");
var $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + $63efb8494987aa98$require$VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $6wIUo(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), $6wIUo.ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new $6wIUo("options must be an object", $6wIUo.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $6wIUo("option " + opt + " must be " + result, $6wIUo.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $6wIUo("Unknown option " + opt, $6wIUo.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};

});
parcelRegister("6yYtd", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("4iFhx", function(module, exports) {
"use strict";

var $8yOyy = parcelRequire("8yOyy");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $3218dd97b5460664$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $8yOyy(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $3218dd97b5460664$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $3218dd97b5460664$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $3218dd97b5460664$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $3218dd97b5460664$var$CancelToken.source = function source() {
    var cancel;
    var token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $3218dd97b5460664$var$CancelToken;

});

parcelRegister("albzn", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("1YbHN", function(module, exports) {
"use strict";

var $eFc3n = parcelRequire("eFc3n");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $eFc3n.isObject(payload) && payload.isAxiosError === true;
};

});



parcelRegister("kddvv", function(module, exports) {
"use strict";

var $2T9Py = parcelRequire("2T9Py");

var $btZEt = parcelRequire("btZEt");

var $jScx1 = parcelRequire("jScx1");
module.exports = {
    formats: $jScx1,
    parse: $btZEt,
    stringify: $2T9Py
};

});
parcelRegister("2T9Py", function(module, exports) {
"use strict";

var $aF2j2 = parcelRequire("aF2j2");

var $gHu7A = parcelRequire("gHu7A");

var $jScx1 = parcelRequire("jScx1");
var $21a857f2c632f015$var$has = Object.prototype.hasOwnProperty;
var $21a857f2c632f015$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $21a857f2c632f015$var$isArray = Array.isArray;
var $21a857f2c632f015$var$push = Array.prototype.push;
var $21a857f2c632f015$var$pushToArray = function(arr, valueOrArray) {
    $21a857f2c632f015$var$push.apply(arr, $21a857f2c632f015$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $21a857f2c632f015$var$toISO = Date.prototype.toISOString;
var $21a857f2c632f015$var$defaultFormat = $jScx1.default;
var $21a857f2c632f015$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $gHu7A.encode,
    encodeValuesOnly: false,
    format: $21a857f2c632f015$var$defaultFormat,
    formatter: $jScx1.formatters[$21a857f2c632f015$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $21a857f2c632f015$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $21a857f2c632f015$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $21a857f2c632f015$var$sentinel = {};
var $21a857f2c632f015$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($21a857f2c632f015$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($21a857f2c632f015$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) obj = $gHu7A.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($21a857f2c632f015$var$isNonNullishPrimitive(obj) || $gHu7A.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $21a857f2c632f015$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $21a857f2c632f015$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $21a857f2c632f015$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $gHu7A.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($21a857f2c632f015$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $21a857f2c632f015$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $21a857f2c632f015$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $aF2j2();
        valueSideChannel.set($21a857f2c632f015$var$sentinel, sideChannel);
        $21a857f2c632f015$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $21a857f2c632f015$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $21a857f2c632f015$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $21a857f2c632f015$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $21a857f2c632f015$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $jScx1.default;
    if (typeof opts.format !== "undefined") {
        if (!$21a857f2c632f015$var$has.call($jScx1.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $jScx1.formatters[format];
    var filter = $21a857f2c632f015$var$defaults.filter;
    if (typeof opts.filter === "function" || $21a857f2c632f015$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $21a857f2c632f015$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $21a857f2c632f015$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $21a857f2c632f015$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $21a857f2c632f015$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $21a857f2c632f015$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $21a857f2c632f015$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $21a857f2c632f015$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $21a857f2c632f015$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $21a857f2c632f015$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $21a857f2c632f015$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $21a857f2c632f015$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($21a857f2c632f015$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $21a857f2c632f015$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $21a857f2c632f015$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aF2j2();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $21a857f2c632f015$var$pushToArray(keys, $21a857f2c632f015$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("aF2j2", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $46SHr = parcelRequire("46SHr");

var $1vLFW = parcelRequire("1vLFW");
var $7c2f85ad8c1b0afb$var$$TypeError = $2DXy1("%TypeError%");
var $7c2f85ad8c1b0afb$var$$WeakMap = $2DXy1("%WeakMap%", true);
var $7c2f85ad8c1b0afb$var$$Map = $2DXy1("%Map%", true);
var $7c2f85ad8c1b0afb$var$$weakMapGet = $46SHr("WeakMap.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$weakMapSet = $46SHr("WeakMap.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$weakMapHas = $46SHr("WeakMap.prototype.has", true);
var $7c2f85ad8c1b0afb$var$$mapGet = $46SHr("Map.prototype.get", true);
var $7c2f85ad8c1b0afb$var$$mapSet = $46SHr("Map.prototype.set", true);
var $7c2f85ad8c1b0afb$var$$mapHas = $46SHr("Map.prototype.has", true);
/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */ var $7c2f85ad8c1b0afb$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $7c2f85ad8c1b0afb$var$listGet = function(objects, key) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    return node && node.value;
};
var $7c2f85ad8c1b0afb$var$listSet = function(objects, key, value) {
    var node = $7c2f85ad8c1b0afb$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $7c2f85ad8c1b0afb$var$listHas = function(objects, key) {
    return !!$7c2f85ad8c1b0afb$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $7c2f85ad8c1b0afb$var$$TypeError("Side channel does not contain " + $1vLFW(key));
        },
        get: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapGet($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapGet($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7c2f85ad8c1b0afb$var$$weakMapHas($wm, key);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if ($m) return $7c2f85ad8c1b0afb$var$$mapHas($m, key);
            } else {
                if ($o) return $7c2f85ad8c1b0afb$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($7c2f85ad8c1b0afb$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $7c2f85ad8c1b0afb$var$$WeakMap();
                $7c2f85ad8c1b0afb$var$$weakMapSet($wm, key, value);
            } else if ($7c2f85ad8c1b0afb$var$$Map) {
                if (!$m) $m = new $7c2f85ad8c1b0afb$var$$Map();
                $7c2f85ad8c1b0afb$var$$mapSet($m, key, value);
            } else {
                if (!$o) /*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */ $o = {
                    key: {},
                    next: null
                };
                $7c2f85ad8c1b0afb$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("2DXy1", function(module, exports) {
"use strict";
var $1ecd6a3b805ecadb$var$undefined1;
var $1ecd6a3b805ecadb$var$$SyntaxError = SyntaxError;
var $1ecd6a3b805ecadb$var$$Function = Function;
var $1ecd6a3b805ecadb$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $1ecd6a3b805ecadb$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1ecd6a3b805ecadb$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1ecd6a3b805ecadb$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1ecd6a3b805ecadb$var$$gOPD) try {
    $1ecd6a3b805ecadb$var$$gOPD({}, "");
} catch (e) {
    $1ecd6a3b805ecadb$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1ecd6a3b805ecadb$var$throwTypeError = function() {
    throw new $1ecd6a3b805ecadb$var$$TypeError();
};
var $1ecd6a3b805ecadb$var$ThrowTypeError = $1ecd6a3b805ecadb$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1ecd6a3b805ecadb$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1ecd6a3b805ecadb$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1ecd6a3b805ecadb$var$throwTypeError;
        }
    }
}() : $1ecd6a3b805ecadb$var$throwTypeError;

var $1ecd6a3b805ecadb$var$hasSymbols = (parcelRequire("dKI7M"))();

var $1ecd6a3b805ecadb$var$hasProto = (parcelRequire("eNnvx"))();
var $1ecd6a3b805ecadb$var$getProto = Object.getPrototypeOf || ($1ecd6a3b805ecadb$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1ecd6a3b805ecadb$var$needsEval = {};
var $1ecd6a3b805ecadb$var$TypedArray = typeof Uint8Array === "undefined" || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(Uint8Array);
var $1ecd6a3b805ecadb$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGenerator%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncGeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%AsyncIteratorPrototype%": $1ecd6a3b805ecadb$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1ecd6a3b805ecadb$var$$Function,
    "%GeneratorFunction%": $1ecd6a3b805ecadb$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1ecd6a3b805ecadb$var$hasSymbols || !$1ecd6a3b805ecadb$var$getProto ? undefined : $1ecd6a3b805ecadb$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1ecd6a3b805ecadb$var$hasSymbols && $1ecd6a3b805ecadb$var$getProto ? $1ecd6a3b805ecadb$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1ecd6a3b805ecadb$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $1ecd6a3b805ecadb$var$$SyntaxError,
    "%ThrowTypeError%": $1ecd6a3b805ecadb$var$ThrowTypeError,
    "%TypedArray%": $1ecd6a3b805ecadb$var$TypedArray,
    "%TypeError%": $1ecd6a3b805ecadb$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1ecd6a3b805ecadb$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1ecd6a3b805ecadb$var$errorProto = $1ecd6a3b805ecadb$var$getProto($1ecd6a3b805ecadb$var$getProto(e));
    $1ecd6a3b805ecadb$var$INTRINSICS["%Error.prototype%"] = $1ecd6a3b805ecadb$var$errorProto;
}
var $1ecd6a3b805ecadb$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1ecd6a3b805ecadb$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1ecd6a3b805ecadb$var$getProto) value = $1ecd6a3b805ecadb$var$getProto(gen.prototype);
    }
    $1ecd6a3b805ecadb$var$INTRINSICS[name] = value;
    return value;
};
var $1ecd6a3b805ecadb$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $6FqDH = parcelRequire("6FqDH");

var $aZPoB = parcelRequire("aZPoB");
var $1ecd6a3b805ecadb$var$$concat = $6FqDH.call(Function.call, Array.prototype.concat);
var $1ecd6a3b805ecadb$var$$spliceApply = $6FqDH.call(Function.apply, Array.prototype.splice);
var $1ecd6a3b805ecadb$var$$replace = $6FqDH.call(Function.call, String.prototype.replace);
var $1ecd6a3b805ecadb$var$$strSlice = $6FqDH.call(Function.call, String.prototype.slice);
var $1ecd6a3b805ecadb$var$$exec = $6FqDH.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1ecd6a3b805ecadb$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1ecd6a3b805ecadb$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1ecd6a3b805ecadb$var$stringToPath = function stringToPath(string) {
    var first = $1ecd6a3b805ecadb$var$$strSlice(string, 0, 1);
    var last = $1ecd6a3b805ecadb$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $1ecd6a3b805ecadb$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $1ecd6a3b805ecadb$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1ecd6a3b805ecadb$var$$replace(string, $1ecd6a3b805ecadb$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1ecd6a3b805ecadb$var$$replace(subString, $1ecd6a3b805ecadb$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1ecd6a3b805ecadb$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($aZPoB($1ecd6a3b805ecadb$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1ecd6a3b805ecadb$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicName)) {
        var value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicName];
        if (value === $1ecd6a3b805ecadb$var$needsEval) value = $1ecd6a3b805ecadb$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $1ecd6a3b805ecadb$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1ecd6a3b805ecadb$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $1ecd6a3b805ecadb$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $1ecd6a3b805ecadb$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($1ecd6a3b805ecadb$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1ecd6a3b805ecadb$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1ecd6a3b805ecadb$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1ecd6a3b805ecadb$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1ecd6a3b805ecadb$var$$spliceApply(parts, $1ecd6a3b805ecadb$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1ecd6a3b805ecadb$var$$strSlice(part, 0, 1);
        var last = $1ecd6a3b805ecadb$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $1ecd6a3b805ecadb$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($aZPoB($1ecd6a3b805ecadb$var$INTRINSICS, intrinsicRealName)) value = $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $1ecd6a3b805ecadb$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1ecd6a3b805ecadb$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1ecd6a3b805ecadb$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $aZPoB(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1ecd6a3b805ecadb$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("dKI7M", function(module, exports) {
"use strict";
var $a031cc6b762c4e12$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $3ukNm = parcelRequire("3ukNm");
module.exports = function hasNativeSymbols() {
    if (typeof $a031cc6b762c4e12$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $a031cc6b762c4e12$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $3ukNm();
};

});
parcelRegister("3ukNm", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eNnvx", function(module, exports) {
"use strict";
var $ac57e0689712e64d$var$test = {
    foo: {}
};
var $ac57e0689712e64d$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $ac57e0689712e64d$var$test
    }).foo === $ac57e0689712e64d$var$test.foo && !(({
        __proto__: null
    }) instanceof $ac57e0689712e64d$var$$Object);
};

});

parcelRegister("6FqDH", function(module, exports) {
"use strict";

var $kfm3A = parcelRequire("kfm3A");
module.exports = Function.prototype.bind || $kfm3A;

});
parcelRegister("kfm3A", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $ebd6516147fbc56f$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $ebd6516147fbc56f$var$toStr = Object.prototype.toString;
var $ebd6516147fbc56f$var$max = Math.max;
var $ebd6516147fbc56f$var$funcType = "[object Function]";
var $ebd6516147fbc56f$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ebd6516147fbc56f$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ebd6516147fbc56f$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $ebd6516147fbc56f$var$toStr.apply(target) !== $ebd6516147fbc56f$var$funcType) throw new TypeError($ebd6516147fbc56f$var$ERROR_MESSAGE + target);
    var args = $ebd6516147fbc56f$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ebd6516147fbc56f$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ebd6516147fbc56f$var$concatty(args, arguments));
    };
    var boundLength = $ebd6516147fbc56f$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $ebd6516147fbc56f$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("aZPoB", function(module, exports) {
"use strict";
var $8017780892750505$var$call = Function.prototype.call;
var $8017780892750505$var$$hasOwn = Object.prototype.hasOwnProperty;

var $6FqDH = parcelRequire("6FqDH");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $6FqDH.call($8017780892750505$var$call, $8017780892750505$var$$hasOwn);

});


parcelRegister("46SHr", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $fxEK7 = parcelRequire("fxEK7");
var $2fe227279405861b$var$$indexOf = $fxEK7($2DXy1("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $2DXy1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $2fe227279405861b$var$$indexOf(name, ".prototype.") > -1) return $fxEK7(intrinsic);
    return intrinsic;
};

});
parcelRegister("fxEK7", function(module, exports) {
"use strict";

var $6FqDH = parcelRequire("6FqDH");

var $2DXy1 = parcelRequire("2DXy1");

var $ix8O9 = parcelRequire("ix8O9");
var $b5098ac553b04d45$var$$TypeError = $2DXy1("%TypeError%");
var $b5098ac553b04d45$var$$apply = $2DXy1("%Function.prototype.apply%");
var $b5098ac553b04d45$var$$call = $2DXy1("%Function.prototype.call%");
var $b5098ac553b04d45$var$$reflectApply = $2DXy1("%Reflect.apply%", true) || $6FqDH.call($b5098ac553b04d45$var$$call, $b5098ac553b04d45$var$$apply);
var $b5098ac553b04d45$var$$defineProperty = $2DXy1("%Object.defineProperty%", true);
var $b5098ac553b04d45$var$$max = $2DXy1("%Math.max%");
if ($b5098ac553b04d45$var$$defineProperty) try {
    $b5098ac553b04d45$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b5098ac553b04d45$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $b5098ac553b04d45$var$$TypeError("a function is required");
    var func = $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$call, arguments);
    return $ix8O9(func, 1 + $b5098ac553b04d45$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $b5098ac553b04d45$var$applyBind = function applyBind() {
    return $b5098ac553b04d45$var$$reflectApply($6FqDH, $b5098ac553b04d45$var$$apply, arguments);
};
if ($b5098ac553b04d45$var$$defineProperty) $b5098ac553b04d45$var$$defineProperty(module.exports, "apply", {
    value: $b5098ac553b04d45$var$applyBind
});
else module.exports.apply = $b5098ac553b04d45$var$applyBind;

});
parcelRegister("ix8O9", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");

var $326QS = parcelRequire("326QS");

var $d7e2241cf3c714ea$var$hasDescriptors = (parcelRequire("aszze"))();

var $liPrR = parcelRequire("liPrR");
var $d7e2241cf3c714ea$var$$TypeError = $2DXy1("%TypeError%");
var $d7e2241cf3c714ea$var$$floor = $2DXy1("%Math.floor%");
module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $d7e2241cf3c714ea$var$$TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $d7e2241cf3c714ea$var$$floor(length) !== length) throw new $d7e2241cf3c714ea$var$$TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $liPrR) {
        var desc = $liPrR(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($d7e2241cf3c714ea$var$hasDescriptors) $326QS(fn, "length", length, true, true);
        else $326QS(fn, "length", length);
    }
    return fn;
};

});
parcelRegister("326QS", function(module, exports) {
"use strict";

var $2356dfa83381ebc2$var$hasPropertyDescriptors = (parcelRequire("aszze"))();

var $2DXy1 = parcelRequire("2DXy1");
var $2356dfa83381ebc2$var$$defineProperty = $2356dfa83381ebc2$var$hasPropertyDescriptors && $2DXy1("%Object.defineProperty%", true);
if ($2356dfa83381ebc2$var$$defineProperty) try {
    $2356dfa83381ebc2$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $2356dfa83381ebc2$var$$defineProperty = false;
}
var $2356dfa83381ebc2$var$$SyntaxError = $2DXy1("%SyntaxError%");
var $2356dfa83381ebc2$var$$TypeError = $2DXy1("%TypeError%");

var $liPrR = parcelRequire("liPrR");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $2356dfa83381ebc2$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $2356dfa83381ebc2$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $2356dfa83381ebc2$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $2356dfa83381ebc2$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $2356dfa83381ebc2$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $2356dfa83381ebc2$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$liPrR && $liPrR(obj, property);
    if ($2356dfa83381ebc2$var$$defineProperty) $2356dfa83381ebc2$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $2356dfa83381ebc2$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("aszze", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $79d81bcf012c6ef5$var$$defineProperty = $2DXy1("%Object.defineProperty%", true);
var $79d81bcf012c6ef5$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($79d81bcf012c6ef5$var$$defineProperty) try {
        $79d81bcf012c6ef5$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$79d81bcf012c6ef5$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$79d81bcf012c6ef5$var$hasPropertyDescriptors()) return null;
    try {
        return $79d81bcf012c6ef5$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $79d81bcf012c6ef5$var$hasPropertyDescriptors;

});

parcelRegister("liPrR", function(module, exports) {
"use strict";

var $2DXy1 = parcelRequire("2DXy1");
var $f8232ffed2d58f72$var$$gOPD = $2DXy1("%Object.getOwnPropertyDescriptor%", true);
if ($f8232ffed2d58f72$var$$gOPD) try {
    $f8232ffed2d58f72$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f8232ffed2d58f72$var$$gOPD = null;
}
module.exports = $f8232ffed2d58f72$var$$gOPD;

});





parcelRegister("1vLFW", function(module, exports) {
var $119dab09bed9f066$var$hasMap = typeof Map === "function" && Map.prototype;
var $119dab09bed9f066$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $119dab09bed9f066$var$mapSize = $119dab09bed9f066$var$hasMap && $119dab09bed9f066$var$mapSizeDescriptor && typeof $119dab09bed9f066$var$mapSizeDescriptor.get === "function" ? $119dab09bed9f066$var$mapSizeDescriptor.get : null;
var $119dab09bed9f066$var$mapForEach = $119dab09bed9f066$var$hasMap && Map.prototype.forEach;
var $119dab09bed9f066$var$hasSet = typeof Set === "function" && Set.prototype;
var $119dab09bed9f066$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $119dab09bed9f066$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $119dab09bed9f066$var$setSize = $119dab09bed9f066$var$hasSet && $119dab09bed9f066$var$setSizeDescriptor && typeof $119dab09bed9f066$var$setSizeDescriptor.get === "function" ? $119dab09bed9f066$var$setSizeDescriptor.get : null;
var $119dab09bed9f066$var$setForEach = $119dab09bed9f066$var$hasSet && Set.prototype.forEach;
var $119dab09bed9f066$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $119dab09bed9f066$var$weakMapHas = $119dab09bed9f066$var$hasWeakMap ? WeakMap.prototype.has : null;
var $119dab09bed9f066$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $119dab09bed9f066$var$weakSetHas = $119dab09bed9f066$var$hasWeakSet ? WeakSet.prototype.has : null;
var $119dab09bed9f066$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $119dab09bed9f066$var$weakRefDeref = $119dab09bed9f066$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $119dab09bed9f066$var$booleanValueOf = Boolean.prototype.valueOf;
var $119dab09bed9f066$var$objectToString = Object.prototype.toString;
var $119dab09bed9f066$var$functionToString = Function.prototype.toString;
var $119dab09bed9f066$var$$match = String.prototype.match;
var $119dab09bed9f066$var$$slice = String.prototype.slice;
var $119dab09bed9f066$var$$replace = String.prototype.replace;
var $119dab09bed9f066$var$$toUpperCase = String.prototype.toUpperCase;
var $119dab09bed9f066$var$$toLowerCase = String.prototype.toLowerCase;
var $119dab09bed9f066$var$$test = RegExp.prototype.test;
var $119dab09bed9f066$var$$concat = Array.prototype.concat;
var $119dab09bed9f066$var$$join = Array.prototype.join;
var $119dab09bed9f066$var$$arrSlice = Array.prototype.slice;
var $119dab09bed9f066$var$$floor = Math.floor;
var $119dab09bed9f066$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $119dab09bed9f066$var$gOPS = Object.getOwnPropertySymbols;
var $119dab09bed9f066$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $119dab09bed9f066$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $119dab09bed9f066$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $119dab09bed9f066$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $119dab09bed9f066$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $119dab09bed9f066$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $119dab09bed9f066$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $119dab09bed9f066$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$119dab09bed9f066$var$$floor(-num) : $119dab09bed9f066$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $119dab09bed9f066$var$$slice.call(str, intStr.length + 1);
            return $119dab09bed9f066$var$$replace.call(intStr, sepRegex, "$&_") + "." + $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $119dab09bed9f066$var$$replace.call(str, sepRegex, "$&_");
}

var $foUwZ = parcelRequire("foUwZ");
var $119dab09bed9f066$var$inspectCustom = $foUwZ.custom;
var $119dab09bed9f066$var$inspectSymbol = $119dab09bed9f066$var$isSymbol($119dab09bed9f066$var$inspectCustom) ? $119dab09bed9f066$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($119dab09bed9f066$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($119dab09bed9f066$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $119dab09bed9f066$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($119dab09bed9f066$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($119dab09bed9f066$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $119dab09bed9f066$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $119dab09bed9f066$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $119dab09bed9f066$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $119dab09bed9f066$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($119dab09bed9f066$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $119dab09bed9f066$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($119dab09bed9f066$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$119dab09bed9f066$var$isRegExp(obj)) {
        var name = $119dab09bed9f066$var$nameOf(obj);
        var keys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $119dab09bed9f066$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($119dab09bed9f066$var$isSymbol(obj)) {
        var symString = $119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $119dab09bed9f066$var$symToString.call(obj);
        return typeof obj === "object" && !$119dab09bed9f066$var$hasShammedSymbols ? $119dab09bed9f066$var$markBoxed(symString) : symString;
    }
    if ($119dab09bed9f066$var$isElement(obj)) {
        var s = "<" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $119dab09bed9f066$var$wrapQuotes($119dab09bed9f066$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $119dab09bed9f066$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($119dab09bed9f066$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (indent && !$119dab09bed9f066$var$singleLineValues(xs)) return "[" + $119dab09bed9f066$var$indentedJoin(xs, indent) + "]";
        return "[ " + $119dab09bed9f066$var$$join.call(xs, ", ") + " ]";
    }
    if ($119dab09bed9f066$var$isError(obj)) {
        var parts = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$119dab09bed9f066$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $119dab09bed9f066$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($119dab09bed9f066$var$inspectSymbol && typeof obj[$119dab09bed9f066$var$inspectSymbol] === "function" && $foUwZ) return $foUwZ(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($119dab09bed9f066$var$isMap(obj)) {
        var mapParts = [];
        if ($119dab09bed9f066$var$mapForEach) $119dab09bed9f066$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Map", $119dab09bed9f066$var$mapSize.call(obj), mapParts, indent);
    }
    if ($119dab09bed9f066$var$isSet(obj)) {
        var setParts = [];
        if ($119dab09bed9f066$var$setForEach) $119dab09bed9f066$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $119dab09bed9f066$var$collectionOf("Set", $119dab09bed9f066$var$setSize.call(obj), setParts, indent);
    }
    if ($119dab09bed9f066$var$isWeakMap(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakMap");
    if ($119dab09bed9f066$var$isWeakSet(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakSet");
    if ($119dab09bed9f066$var$isWeakRef(obj)) return $119dab09bed9f066$var$weakCollectionOf("WeakRef");
    if ($119dab09bed9f066$var$isNumber(obj)) return $119dab09bed9f066$var$markBoxed(inspect(Number(obj)));
    if ($119dab09bed9f066$var$isBigInt(obj)) return $119dab09bed9f066$var$markBoxed(inspect($119dab09bed9f066$var$bigIntValueOf.call(obj)));
    if ($119dab09bed9f066$var$isBoolean(obj)) return $119dab09bed9f066$var$markBoxed($119dab09bed9f066$var$booleanValueOf.call(obj));
    if ($119dab09bed9f066$var$isString(obj)) return $119dab09bed9f066$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$119dab09bed9f066$var$isDate(obj) && !$119dab09bed9f066$var$isRegExp(obj)) {
        var ys = $119dab09bed9f066$var$arrObjKeys(obj, inspect);
        var isPlainObject = $119dab09bed9f066$var$gPO ? $119dab09bed9f066$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $119dab09bed9f066$var$toStringTag && Object(obj) === obj && $119dab09bed9f066$var$toStringTag in obj ? $119dab09bed9f066$var$$slice.call($119dab09bed9f066$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $119dab09bed9f066$var$$join.call($119dab09bed9f066$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $119dab09bed9f066$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $119dab09bed9f066$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $119dab09bed9f066$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $119dab09bed9f066$var$quote(s) {
    return $119dab09bed9f066$var$$replace.call(String(s), /"/g, "&quot;");
}
function $119dab09bed9f066$var$isArray(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Array]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isDate(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Date]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isRegExp(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object RegExp]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isError(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Error]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isString(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object String]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isNumber(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Number]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
function $119dab09bed9f066$var$isBoolean(obj) {
    return $119dab09bed9f066$var$toStr(obj) === "[object Boolean]" && (!$119dab09bed9f066$var$toStringTag || !(typeof obj === "object" && $119dab09bed9f066$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $119dab09bed9f066$var$isSymbol(obj) {
    if ($119dab09bed9f066$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$symToString) return false;
    try {
        $119dab09bed9f066$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$119dab09bed9f066$var$bigIntValueOf) return false;
    try {
        $119dab09bed9f066$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $119dab09bed9f066$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $119dab09bed9f066$var$has(obj, key) {
    return $119dab09bed9f066$var$hasOwn.call(obj, key);
}
function $119dab09bed9f066$var$toStr(obj) {
    return $119dab09bed9f066$var$objectToString.call(obj);
}
function $119dab09bed9f066$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $119dab09bed9f066$var$$match.call($119dab09bed9f066$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $119dab09bed9f066$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $119dab09bed9f066$var$isMap(x) {
    if (!$119dab09bed9f066$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$mapSize.call(x);
        try {
            $119dab09bed9f066$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakMap(x) {
    if (!$119dab09bed9f066$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        try {
            $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakRef(x) {
    if (!$119dab09bed9f066$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isSet(x) {
    if (!$119dab09bed9f066$var$setSize || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$setSize.call(x);
        try {
            $119dab09bed9f066$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isWeakSet(x) {
    if (!$119dab09bed9f066$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $119dab09bed9f066$var$weakSetHas.call(x, $119dab09bed9f066$var$weakSetHas);
        try {
            $119dab09bed9f066$var$weakMapHas.call(x, $119dab09bed9f066$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $119dab09bed9f066$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $119dab09bed9f066$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $119dab09bed9f066$var$inspectString($119dab09bed9f066$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $119dab09bed9f066$var$$replace.call($119dab09bed9f066$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $119dab09bed9f066$var$lowbyte);
    return $119dab09bed9f066$var$wrapQuotes(s, "single", opts);
}
function $119dab09bed9f066$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $119dab09bed9f066$var$$toUpperCase.call(n.toString(16));
}
function $119dab09bed9f066$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $119dab09bed9f066$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $119dab09bed9f066$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $119dab09bed9f066$var$indentedJoin(entries, indent) : $119dab09bed9f066$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $119dab09bed9f066$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($119dab09bed9f066$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $119dab09bed9f066$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $119dab09bed9f066$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $119dab09bed9f066$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $119dab09bed9f066$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $119dab09bed9f066$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $119dab09bed9f066$var$arrObjKeys(obj, inspect) {
    var isArr = $119dab09bed9f066$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $119dab09bed9f066$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $119dab09bed9f066$var$gOPS === "function" ? $119dab09bed9f066$var$gOPS(obj) : [];
    var symMap;
    if ($119dab09bed9f066$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$119dab09bed9f066$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($119dab09bed9f066$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($119dab09bed9f066$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $119dab09bed9f066$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($119dab09bed9f066$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});



parcelRegister("gHu7A", function(module, exports) {
"use strict";

var $jScx1 = parcelRequire("jScx1");
var $c28806fde4f5d743$var$has = Object.prototype.hasOwnProperty;
var $c28806fde4f5d743$var$isArray = Array.isArray;
var $c28806fde4f5d743$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $c28806fde4f5d743$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($c28806fde4f5d743$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $c28806fde4f5d743$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $c28806fde4f5d743$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($c28806fde4f5d743$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$c28806fde4f5d743$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($c28806fde4f5d743$var$isArray(target) && !$c28806fde4f5d743$var$isArray(source)) mergeTarget = $c28806fde4f5d743$var$arrayToObject(target, options);
    if ($c28806fde4f5d743$var$isArray(target) && $c28806fde4f5d743$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($c28806fde4f5d743$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($c28806fde4f5d743$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $c28806fde4f5d743$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $c28806fde4f5d743$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $c28806fde4f5d743$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $jScx1.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $c28806fde4f5d743$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($c28806fde4f5d743$var$hexTable[0xC0 | c >> 6] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($c28806fde4f5d743$var$hexTable[0xE0 | c >> 12] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $c28806fde4f5d743$var$hexTable[0xF0 | c >> 18] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 12 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c >> 6 & 0x3F] + $c28806fde4f5d743$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $c28806fde4f5d743$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $c28806fde4f5d743$var$compactQueue(queue);
    return value;
};
var $c28806fde4f5d743$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $c28806fde4f5d743$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $c28806fde4f5d743$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $c28806fde4f5d743$var$maybeMap = function maybeMap(val, fn) {
    if ($c28806fde4f5d743$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $c28806fde4f5d743$var$arrayToObject,
    assign: $c28806fde4f5d743$var$assign,
    combine: $c28806fde4f5d743$var$combine,
    compact: $c28806fde4f5d743$var$compact,
    decode: $c28806fde4f5d743$var$decode,
    encode: $c28806fde4f5d743$var$encode,
    isBuffer: $c28806fde4f5d743$var$isBuffer,
    isRegExp: $c28806fde4f5d743$var$isRegExp,
    maybeMap: $c28806fde4f5d743$var$maybeMap,
    merge: $c28806fde4f5d743$var$merge
};

});
parcelRegister("jScx1", function(module, exports) {
"use strict";
var $e77cc7fa9fbe3dde$var$replace = String.prototype.replace;
var $e77cc7fa9fbe3dde$var$percentTwenties = /%20/g;
var $e77cc7fa9fbe3dde$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $e77cc7fa9fbe3dde$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $e77cc7fa9fbe3dde$var$replace.call(value, $e77cc7fa9fbe3dde$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $e77cc7fa9fbe3dde$var$Format.RFC1738,
    RFC3986: $e77cc7fa9fbe3dde$var$Format.RFC3986
};

});



parcelRegister("btZEt", function(module, exports) {
"use strict";

var $gHu7A = parcelRequire("gHu7A");
var $85c239e60adf14b2$var$has = Object.prototype.hasOwnProperty;
var $85c239e60adf14b2$var$isArray = Array.isArray;
var $85c239e60adf14b2$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $gHu7A.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $85c239e60adf14b2$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $85c239e60adf14b2$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $85c239e60adf14b2$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $85c239e60adf14b2$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $85c239e60adf14b2$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $85c239e60adf14b2$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $85c239e60adf14b2$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $85c239e60adf14b2$var$defaults.decoder, charset, "key");
            val = $gHu7A.maybeMap($85c239e60adf14b2$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $85c239e60adf14b2$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $85c239e60adf14b2$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $85c239e60adf14b2$var$isArray(val) ? [
            val
        ] : val;
        if ($85c239e60adf14b2$var$has.call(obj, key)) obj[key] = $gHu7A.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $85c239e60adf14b2$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $85c239e60adf14b2$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $85c239e60adf14b2$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $85c239e60adf14b2$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $85c239e60adf14b2$var$parseObject(keys, val, options, valuesParsed);
};
var $85c239e60adf14b2$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $85c239e60adf14b2$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $85c239e60adf14b2$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $85c239e60adf14b2$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $85c239e60adf14b2$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $85c239e60adf14b2$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $85c239e60adf14b2$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $85c239e60adf14b2$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $85c239e60adf14b2$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $85c239e60adf14b2$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $gHu7A.isRegExp(opts.delimiter) ? opts.delimiter : $85c239e60adf14b2$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $85c239e60adf14b2$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $85c239e60adf14b2$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $85c239e60adf14b2$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $85c239e60adf14b2$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $85c239e60adf14b2$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $85c239e60adf14b2$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $85c239e60adf14b2$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $85c239e60adf14b2$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $gHu7A.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $gHu7A.compact(obj);
};

});





parcelRegister("1oIL0", function(module, exports) {
"use strict";
var $104ac02f9ca588c4$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $104ac02f9ca588c4$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $104ac02f9ca588c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3sP6O = parcelRequire("3sP6O");

var $104ac02f9ca588c4$var$base_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("c8gwn")));

var $104ac02f9ca588c4$var$bundles_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("bDDqC")));

var $104ac02f9ca588c4$var$delegation_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("8XE2k")));

var $104ac02f9ca588c4$var$funders_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("9ZslP")));

var $104ac02f9ca588c4$var$gov_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("iEKS9")));

var $104ac02f9ca588c4$var$stakers_1 = $104ac02f9ca588c4$var$__importDefault((parcelRequire("h4Gqo")));
var $104ac02f9ca588c4$var$KyveClient = /** @class */ function() {
    function KyveClient(client, account, config, aminoSigner) {
        this.account = account;
        this.config = config;
        this.nativeClient = client;
        this.aminoSigner = aminoSigner;
        this.kyve = {
            base: {
                v1beta1: new $104ac02f9ca588c4$var$base_1.default(this.nativeClient, this.account, config)
            },
            bundles: {
                v1beta1: new $104ac02f9ca588c4$var$bundles_1.default(this.nativeClient, this.account, config)
            },
            delegation: {
                v1beta1: new $104ac02f9ca588c4$var$delegation_1.default(this.nativeClient, this.account, config)
            },
            gov: {
                v1: new $104ac02f9ca588c4$var$gov_1.default(this.nativeClient, this.account, config)
            },
            funders: {
                v1beta1: new $104ac02f9ca588c4$var$funders_1.default(this.nativeClient, this.account, config)
            },
            stakers: {
                v1beta1: new $104ac02f9ca588c4$var$stakers_1.default(this.nativeClient, this.account, config)
            }
        };
    }
    KyveClient.prototype.signString = function(message) {
        return $104ac02f9ca588c4$var$__awaiter(this, void 0, void 0, function() {
            var signDoc, signature;
            return $104ac02f9ca588c4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.aminoSigner === null) throw new Error("Wallet doesn't support adr-036");
                        signDoc = (0, $3sP6O.makeADR36AminoSignDoc)(this.account.address, message);
                        return [
                            4 /*yield*/ ,
                            this.aminoSigner.signAmino(this.account.address, signDoc)
                        ];
                    case 1:
                        signature = _a.sent().signature;
                        return [
                            2 /*return*/ ,
                            signature
                        ];
                }
            });
        });
    };
    KyveClient.prototype.getKyveBalance = function() {
        return $104ac02f9ca588c4$var$__awaiter(this, void 0, void 0, function() {
            var data;
            return $104ac02f9ca588c4$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.getBalance(this.account.address, this.config.coinDenom)
                        ];
                    case 1:
                        data = _a.sent();
                        return [
                            2 /*return*/ ,
                            data.amount
                        ];
                }
            });
        });
    };
    return KyveClient;
}();
module.exports.default = $104ac02f9ca588c4$var$KyveClient;

});
parcelRegister("3sP6O", function(module, exports) {
"use strict";
var $285ba1c41a25e9d1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $285ba1c41a25e9d1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $285ba1c41a25e9d1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("dNSQN")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("cJDGK")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("3BVEn")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("15z4r")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("82M50")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("ezTaT")), module.exports);

$285ba1c41a25e9d1$var$__exportStar((parcelRequire("cbw6W")), module.exports);

});
parcelRegister("dNSQN", function(module, exports) {
"use strict";
var $a0ca6624333a32fc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAccount = void 0;

var $bRND2 = parcelRequire("bRND2");

var $f5BuS = parcelRequire("f5BuS");
class $a0ca6624333a32fc$var$BaseAccount {
    static fetchFromRest(rest, address, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = false) {
        return $a0ca6624333a32fc$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (0, $f5BuS.simpleFetch)(rest, `/cosmos/auth/v1beta1/accounts/${address}`, {
                validateStatus: function(status) {
                    // Permit 404 not found to handle the case of account not exists
                    return status >= 200 && status < 300 || status === 404;
                }
            });
            return $a0ca6624333a32fc$var$BaseAccount.fromProtoJSON(result.data, defaultBech32Address ? address : "");
        });
    }
    static fromProtoJSON(obj, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = "") {
        if (!obj.account) {
            // Case of not existing account.
            // {
            //   "code": 5,
            //   "message": "rpc error: code = NotFound desc = account {address} not found: key not found",
            //   "details": [
            //   ]
            // }
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            return new $a0ca6624333a32fc$var$BaseAccount("", defaultBech32Address, new $bRND2.Int(0), new $bRND2.Int(0));
        }
        let value = obj.account;
        const type = value["@type"] || "";
        // If the chain modifies the account type, handle the case where the account type embeds the base account.
        // (Actually, the only existent case is ethermint, and this is the line for handling ethermint)
        const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
        if (baseAccount) value = baseAccount;
        // If the chain modifies the account type, handle the case where the account type embeds the account.
        // (Actually, the only existent case is desmos, and this is the line for handling desmos)
        const embedAccount = value.account;
        if (embedAccount) value = embedAccount;
        // If the account is the vesting account that embeds the base vesting account,
        // the actual base account exists under the base vesting account.
        // But, this can be different according to the version of cosmos-sdk.
        // So, anyway, try to parse it by some ways...
        const baseVestingAccount = value.BaseVestingAccount || value.baseVestingAccount || value.base_vesting_account;
        if (baseVestingAccount) {
            value = baseVestingAccount;
            const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
            if (baseAccount) value = baseAccount;
        }
        let address = value.address;
        if (!address) {
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            address = defaultBech32Address;
        }
        const accountNumber = value.account_number;
        const sequence = value.sequence;
        return new $a0ca6624333a32fc$var$BaseAccount(type, address, new $bRND2.Int(accountNumber || "0"), new $bRND2.Int(sequence || "0"));
    }
    constructor(type, address, accountNumber, sequence){
        this.type = type;
        this.address = address;
        this.accountNumber = accountNumber;
        this.sequence = sequence;
    }
    getType() {
        return this.type;
    }
    getAddress() {
        return this.address;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    getSequence() {
        return this.sequence;
    }
}
module.exports.BaseAccount = $a0ca6624333a32fc$var$BaseAccount;

});
parcelRegister("bRND2", function(module, exports) {
"use strict";
var $8a3b242cd008b02e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8a3b242cd008b02e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8a3b242cd008b02e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8a3b242cd008b02e$var$__exportStar((parcelRequire("70O8a")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("gKlbj")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("hPGpe")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("adR1Z")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("h5C3s")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("hm0dN")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("jnpZq")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("6lExw")), module.exports);

$8a3b242cd008b02e$var$__exportStar((parcelRequire("ljAfy")), module.exports);

});
parcelRegister("70O8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntPretty = void 0;

var $adR1Z = parcelRequire("adR1Z");

var $h5C3s = parcelRequire("h5C3s");

var $jnpZq = parcelRequire("jnpZq");

var $hm0dN = parcelRequire("hm0dN");
class $51af6b68ab2d0db2$var$IntPretty {
    constructor(num){
        this.floatingDecimalPointRight = 0;
        this._options = {
            maxDecimals: 0,
            trim: false,
            shrink: false,
            ready: true,
            locale: true,
            inequalitySymbol: false,
            inequalitySymbolSeparator: " "
        };
        if (typeof num === "object" && "toDec" in num) num = num.toDec();
        else if (!(num instanceof $h5C3s.Dec)) num = new $h5C3s.Dec(num);
        if (num.isZero()) {
            this.dec = num;
            return;
        }
        let dec = num;
        let decPrecision = 0;
        for(let i = 0; i < 18; i++){
            if (!dec.truncate().equals(new $adR1Z.Int(0)) && dec.equals(new $h5C3s.Dec(dec.truncate()))) break;
            dec = dec.mul(new $h5C3s.Dec(10));
            decPrecision++;
        }
        this.dec = num;
        this._options.maxDecimals = decPrecision;
    }
    get options() {
        return this._options;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += -delta;
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += delta;
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty._options.maxDecimals = max;
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty._options.inequalitySymbol = bool;
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty._options.inequalitySymbolSeparator = str;
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty._options.trim = bool;
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty._options.shrink = bool;
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty._options.ready = bool;
        return pretty;
    }
    get isReady() {
        return this._options.ready;
    }
    add(target) {
        if (!(target instanceof $h5C3s.Dec)) target = target.toDec();
        const pretty = new $51af6b68ab2d0db2$var$IntPretty(this.toDec().add(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    sub(target) {
        if (!(target instanceof $h5C3s.Dec)) target = target.toDec();
        const pretty = new $51af6b68ab2d0db2$var$IntPretty(this.toDec().sub(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    mul(target) {
        if (!(target instanceof $h5C3s.Dec)) target = target.toDec();
        const pretty = new $51af6b68ab2d0db2$var$IntPretty(this.toDec().mul(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    quo(target) {
        if (!(target instanceof $h5C3s.Dec)) target = target.toDec();
        const pretty = new $51af6b68ab2d0db2$var$IntPretty(this.toDec().quo(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    toDec() {
        if (this.floatingDecimalPointRight === 0) return this.dec;
        else if (this.floatingDecimalPointRight > 0) return this.dec.mulTruncate($jnpZq.DecUtils.getTenExponentN(this.floatingDecimalPointRight));
        else {
            // Since a decimal in Dec cannot exceed 18, it cannot be computed at once.
            let i = -this.floatingDecimalPointRight;
            let dec = this.dec;
            while(i > 0)if (i >= $h5C3s.Dec.precision) {
                dec = dec.mulTruncate($jnpZq.DecUtils.getTenExponentN(-$h5C3s.Dec.precision));
                i -= $h5C3s.Dec.precision;
            } else {
                dec = dec.mulTruncate($jnpZq.DecUtils.getTenExponentN(-(i % $h5C3s.Dec.precision)));
                break;
            }
            return dec;
        }
    }
    toString() {
        return this.toStringWithSymbols("", "");
    }
    toStringWithSymbols(prefix, suffix) {
        const dec = this.toDec();
        if (this._options.inequalitySymbol && !dec.isZero() && dec.abs().lt($jnpZq.DecUtils.getTenExponentN(-this._options.maxDecimals))) {
            const isNeg = dec.isNegative();
            return `${isNeg ? ">" : "<"}${this._options.inequalitySymbolSeparator}${isNeg ? "-" : ""}${prefix}${$jnpZq.DecUtils.getTenExponentN(-this._options.maxDecimals).toString(this._options.maxDecimals, this._options.locale)}${suffix}`;
        }
        let result;
        if (!this._options.shrink) result = dec.toString(this._options.maxDecimals, this._options.locale);
        else result = $hm0dN.CoinUtils.shrinkDecimals(dec, 0, this._options.maxDecimals, this._options.locale);
        if (this._options.trim) result = $jnpZq.DecUtils.trim(result);
        const isNeg = result.charAt(0) === "-";
        if (isNeg) result = result.slice(1);
        return `${isNeg ? "-" : ""}${prefix}${result}${suffix}`;
    }
    clone() {
        const pretty = new $51af6b68ab2d0db2$var$IntPretty(this.dec);
        pretty.dec = this.dec;
        pretty.floatingDecimalPointRight = this.floatingDecimalPointRight;
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
}
module.exports.IntPretty = $51af6b68ab2d0db2$var$IntPretty;

});
parcelRegister("adR1Z", function(module, exports) {
"use strict";
var $771441223ba12c22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint = module.exports.Int = void 0;

const $771441223ba12c22$var$big_integer_1 = $771441223ba12c22$var$__importDefault((parcelRequire("8gM4d")));

var $kGqks = parcelRequire("kGqks");
class $771441223ba12c22$var$Int {
    /**
     * @param int - Parse a number | bigInteger | string into a bigInt.
     */ constructor(int){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (!(0, $kGqks.isValidIntegerString)(int)) {
                if ((0, $kGqks.isExponentDecString)(int)) int = (0, $kGqks.exponentDecStringToDecString)(int);
                else throw new Error(`invalid integer: ${int}`);
            }
            this.int = (0, $771441223ba12c22$var$big_integer_1.default)(int);
        } else if (typeof int === "bigint") this.int = (0, $771441223ba12c22$var$big_integer_1.default)(int);
        else this.int = (0, $771441223ba12c22$var$big_integer_1.default)(int);
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($771441223ba12c22$var$Int.maxInt)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    toString() {
        return this.int.toString(10);
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    isZero() {
        return this.int.eq((0, $771441223ba12c22$var$big_integer_1.default)(0));
    }
    equals(i) {
        return this.int.equals(i.int);
    }
    gt(i) {
        return this.int.gt(i.int);
    }
    gte(i) {
        return this.int.greaterOrEquals(i.int);
    }
    lt(i) {
        return this.int.lt(i.int);
    }
    lte(i) {
        return this.int.lesserOrEquals(i.int);
    }
    abs() {
        return new $771441223ba12c22$var$Int(this.int.abs());
    }
    absUInt() {
        return new $771441223ba12c22$var$Uint(this.int.abs());
    }
    add(i) {
        return new $771441223ba12c22$var$Int(this.int.add(i.int));
    }
    sub(i) {
        return new $771441223ba12c22$var$Int(this.int.subtract(i.int));
    }
    mul(i) {
        return new $771441223ba12c22$var$Int(this.int.multiply(i.int));
    }
    div(i) {
        return new $771441223ba12c22$var$Int(this.int.divide(i.int));
    }
    mod(i) {
        return new $771441223ba12c22$var$Int(this.int.mod(i.int));
    }
    neg() {
        return new $771441223ba12c22$var$Int(this.int.negate());
    }
    pow(i) {
        return new $771441223ba12c22$var$Int(this.int.pow(i.toBigNumber()));
    }
    toBigNumber() {
        return this.int;
    }
}
module.exports.Int = $771441223ba12c22$var$Int;
// (2 ** 256) - 1
$771441223ba12c22$var$Int.maxInt = (0, $771441223ba12c22$var$big_integer_1.default)("115792089237316195423570985008687907853269984665640564039457584007913129639935");
class $771441223ba12c22$var$Uint {
    /**
     * @param uint - Parse a number | bigInteger | string into a bigUint.
     */ constructor(uint){
        if (typeof uint === "number") uint = uint.toString();
        if (typeof uint === "string") {
            if (!(0, $kGqks.isValidIntegerString)(uint)) {
                if ((0, $kGqks.isExponentDecString)(uint)) uint = (0, $kGqks.exponentDecStringToDecString)(uint);
                else throw new Error(`invalid integer: ${uint}`);
            }
            this.uint = (0, $771441223ba12c22$var$big_integer_1.default)(uint);
        } else if (typeof uint === "bigint") this.uint = (0, $771441223ba12c22$var$big_integer_1.default)(uint);
        else this.uint = (0, $771441223ba12c22$var$big_integer_1.default)(uint);
        if (this.uint.isNegative()) throw new TypeError("Uint should not be negative");
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.uint.abs().bitLength().gt(256)) throw new Error(`Integer out of range ${this.uint.toString()}`);
    }
    toString() {
        return this.uint.toString(10);
    }
    isZero() {
        return this.uint.eq((0, $771441223ba12c22$var$big_integer_1.default)(0));
    }
    equals(i) {
        return this.uint.equals(i.uint);
    }
    gt(i) {
        return this.uint.gt(i.uint);
    }
    gte(i) {
        return this.uint.greaterOrEquals(i.uint);
    }
    lt(i) {
        return this.uint.lt(i.uint);
    }
    lte(i) {
        return this.uint.lesserOrEquals(i.uint);
    }
    add(i) {
        return new $771441223ba12c22$var$Uint(this.uint.add(i.uint));
    }
    sub(i) {
        return new $771441223ba12c22$var$Uint(this.uint.subtract(i.uint));
    }
    mul(i) {
        return new $771441223ba12c22$var$Uint(this.uint.multiply(i.uint));
    }
    div(i) {
        return new $771441223ba12c22$var$Uint(this.uint.divide(i.uint));
    }
    mod(i) {
        return new $771441223ba12c22$var$Uint(this.uint.mod(i.uint));
    }
    pow(i) {
        return new $771441223ba12c22$var$Uint(this.uint.pow(i.toBigNumber()));
    }
    toBigNumber() {
        return this.uint;
    }
}
module.exports.Uint = $771441223ba12c22$var$Uint;

});
parcelRegister("8gM4d", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < digits[i]) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRegister("kGqks", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exponentDecStringToDecString = module.exports.isExponentDecString = module.exports.isValidDecimalString = module.exports.isValidIntegerString = void 0;
const $f0ec2747b9012ca3$var$regexIntString = /^-?\d+$/;
const $f0ec2747b9012ca3$var$regexDecString = /^-?\d+.?\d*$/;
const $f0ec2747b9012ca3$var$regexExponentDecString = /^(-?)([\d.]+)e([-+])([\d]+)$/;
function $f0ec2747b9012ca3$var$isValidIntegerString(str) {
    return $f0ec2747b9012ca3$var$regexIntString.test(str);
}
module.exports.isValidIntegerString = $f0ec2747b9012ca3$var$isValidIntegerString;
function $f0ec2747b9012ca3$var$isValidDecimalString(str) {
    return $f0ec2747b9012ca3$var$regexDecString.test(str);
}
module.exports.isValidDecimalString = $f0ec2747b9012ca3$var$isValidDecimalString;
function $f0ec2747b9012ca3$var$isExponentDecString(str) {
    return $f0ec2747b9012ca3$var$regexExponentDecString.test(str);
}
module.exports.isExponentDecString = $f0ec2747b9012ca3$var$isExponentDecString;
function $f0ec2747b9012ca3$var$makeZerosStr(len) {
    let r = "";
    for(let i = 0; i < len; i++)r += "0";
    return r;
}
function $f0ec2747b9012ca3$var$removeHeadZeros(str) {
    while(str.length > 0 && str[0] === "0")str = str.slice(1);
    if (str.length === 0 || str[0] === ".") return "0" + str;
    return str;
}
function $f0ec2747b9012ca3$var$exponentDecStringToDecString(str) {
    const split = str.split($f0ec2747b9012ca3$var$regexExponentDecString);
    if (split.length !== 6) return str;
    const isNeg = split[1] === "-";
    let numStr = split[2];
    const numStrFractionIndex = numStr.indexOf(".");
    const exponentStr = split[4];
    let exponent = parseInt(exponentStr) * (split[3] === "-" ? -1 : 1);
    if (numStrFractionIndex >= 0) {
        const fractionLen = numStr.length - numStrFractionIndex - 1;
        exponent = exponent - fractionLen;
        numStr = $f0ec2747b9012ca3$var$removeHeadZeros(numStr.replace(".", ""));
    }
    const prefix = isNeg ? "-" : "";
    if (exponent < 0) {
        if (numStr.length > -exponent) {
            const fractionPosition = numStr.length + exponent;
            return prefix + (numStr.slice(0, fractionPosition) + "." + numStr.slice(fractionPosition));
        }
        return prefix + "0." + $f0ec2747b9012ca3$var$makeZerosStr(-(numStr.length + exponent)) + numStr;
    } else return prefix + numStr + $f0ec2747b9012ca3$var$makeZerosStr(exponent);
}
module.exports.exponentDecStringToDecString = $f0ec2747b9012ca3$var$exponentDecStringToDecString;

});


parcelRegister("h5C3s", function(module, exports) {
"use strict";
var $c7106c2bffaadf75$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dec = void 0;

const $c7106c2bffaadf75$var$big_integer_1 = $c7106c2bffaadf75$var$__importDefault((parcelRequire("8gM4d")));

var $adR1Z = parcelRequire("adR1Z");

var $kGqks = parcelRequire("kGqks");

var $ceNzq = parcelRequire("ceNzq");
class $c7106c2bffaadf75$var$Dec {
    static calcPrecisionMultiplier(prec) {
        if (prec < 0) throw new Error("Invalid prec");
        if (prec > $c7106c2bffaadf75$var$Dec.precision) throw new Error("Too much precision");
        const key = prec.toString();
        const cached = $c7106c2bffaadf75$var$Dec.precisionMultipliers.get(key);
        if (cached) return cached;
        const zerosToAdd = $c7106c2bffaadf75$var$Dec.precision - prec;
        const multiplier = (0, $c7106c2bffaadf75$var$big_integer_1.default)(10).pow(zerosToAdd);
        $c7106c2bffaadf75$var$Dec.precisionMultipliers.set(key, multiplier);
        return multiplier;
    }
    static reduceDecimalsFromString(str) {
        const decimalPointIndex = str.indexOf(".");
        if (decimalPointIndex < 0) return {
            res: str,
            isDownToZero: false
        };
        const exceededDecimals = str.length - 1 - decimalPointIndex - $c7106c2bffaadf75$var$Dec.precision;
        if (exceededDecimals <= 0) return {
            res: str,
            isDownToZero: false
        };
        const res = str.slice(0, str.length - exceededDecimals);
        return {
            res: res,
            isDownToZero: /^[0.]*$/.test(res)
        };
    }
    /**
     * Create a new Dec from integer with decimal place at prec
     * @param int - Parse a number | bigInteger | string into a Dec.
     * If int is string and contains dot(.), prec is ignored and automatically calculated.
     * @param prec - Precision
     */ constructor(int, prec = 0){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (int.length === 0) throw new Error("empty string");
            if (!(0, $kGqks.isValidDecimalString)(int)) {
                if ((0, $kGqks.isExponentDecString)(int)) int = (0, $kGqks.exponentDecStringToDecString)(int);
                else throw new Error(`invalid decimal: ${int}`);
            }
            // Even if an input with more than 18 decimals, it does not throw an error and ignores the rest.
            const reduced = $c7106c2bffaadf75$var$Dec.reduceDecimalsFromString(int);
            if (reduced.isDownToZero) // However, as a result, if the input becomes 0, a problem may occur in mul or quo. In this case, print a warning.
            console.log(`WARNING: Got ${int}. Dec can only handle up to 18 decimals. However, since the decimal point of the input exceeds 18 digits, the remainder is discarded. As a result, input becomes 0.`);
            int = reduced.res;
            if (int.indexOf(".") >= 0) {
                prec = int.length - int.indexOf(".") - 1;
                int = int.replace(".", "");
            }
            this.int = (0, $c7106c2bffaadf75$var$big_integer_1.default)(int);
        } else if (int instanceof $adR1Z.Int) this.int = (0, $c7106c2bffaadf75$var$big_integer_1.default)(int.toString());
        else if (int instanceof $adR1Z.Uint) this.int = (0, $c7106c2bffaadf75$var$big_integer_1.default)(int.toString());
        else if (typeof int === "bigint") this.int = (0, $c7106c2bffaadf75$var$big_integer_1.default)(int);
        else this.int = (0, $c7106c2bffaadf75$var$big_integer_1.default)(int);
        this.int = this.int.multiply($c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(prec));
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($c7106c2bffaadf75$var$Dec.maxDec)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    isZero() {
        return this.int.eq((0, $c7106c2bffaadf75$var$big_integer_1.default)(0));
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    equals(d2) {
        return this.int.eq(d2.int);
    }
    /**
     * Alias for the greater method.
     */ gt(d2) {
        return this.int.gt(d2.int);
    }
    /**
     * Alias for the greaterOrEquals method.
     */ gte(d2) {
        return this.int.geq(d2.int);
    }
    /**
     * Alias for the lesser method.
     */ lt(d2) {
        return this.int.lt(d2.int);
    }
    /**
     * Alias for the lesserOrEquals method.
     */ lte(d2) {
        return this.int.leq(d2.int);
    }
    /**
     * reverse the decimal sign.
     */ neg() {
        return new $c7106c2bffaadf75$var$Dec(this.int.negate(), $c7106c2bffaadf75$var$Dec.precision);
    }
    /**
     * Returns the absolute value of a decimals.
     */ abs() {
        return new $c7106c2bffaadf75$var$Dec(this.int.abs(), $c7106c2bffaadf75$var$Dec.precision);
    }
    add(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.int.add(d2.int), $c7106c2bffaadf75$var$Dec.precision);
    }
    sub(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.int.subtract(d2.int), $c7106c2bffaadf75$var$Dec.precision);
    }
    pow(n) {
        if (n.isZero()) return new $c7106c2bffaadf75$var$Dec(1);
        if (n.isNegative()) return new $c7106c2bffaadf75$var$Dec(1).quo(this.pow(n.abs()));
        let base = new $c7106c2bffaadf75$var$Dec(this.int, $c7106c2bffaadf75$var$Dec.precision);
        let tmp = new $c7106c2bffaadf75$var$Dec(1);
        for(let i = n; i.gt(new $adR1Z.Int(1)); i = i.div(new $adR1Z.Int(2))){
            if (!i.mod(new $adR1Z.Int(2)).isZero()) tmp = tmp.mul(base);
            base = base.mul(base);
        }
        return base.mul(tmp);
    }
    approxSqrt() {
        return this.approxRoot(2);
    }
    approxRoot(root, maxIters = 300) {
        if (this.isNegative()) return this.neg().approxRoot(root).neg();
        if (root === 1 || this.isZero() || this.equals($c7106c2bffaadf75$var$Dec.one)) return this;
        if (root === 0) return $c7106c2bffaadf75$var$Dec.one;
        let [guess, delta] = [
            $c7106c2bffaadf75$var$Dec.one,
            $c7106c2bffaadf75$var$Dec.one
        ];
        for(let i = 0; delta.abs().gt($c7106c2bffaadf75$var$Dec.smallestDec) && i < maxIters; i++){
            let prev = guess.pow(new $adR1Z.Int(root - 1));
            if (prev.isZero()) prev = $c7106c2bffaadf75$var$Dec.smallestDec;
            delta = this.quo(prev);
            delta = delta.sub(guess);
            delta = delta.quoTruncate(new $c7106c2bffaadf75$var$Dec(root));
            guess = guess.add(delta);
        }
        return guess;
    }
    mul(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.mulRaw(d2).chopPrecisionAndRound(), $c7106c2bffaadf75$var$Dec.precision);
    }
    mulTruncate(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.mulRaw(d2).chopPrecisionAndTruncate(), $c7106c2bffaadf75$var$Dec.precision);
    }
    mulRoundUp(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.mulRaw(d2).chopPrecisionAndRoundUp(), $c7106c2bffaadf75$var$Dec.precision);
    }
    mulRaw(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.int.multiply(d2.int), $c7106c2bffaadf75$var$Dec.precision);
    }
    quo(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.quoRaw(d2).chopPrecisionAndRound(), $c7106c2bffaadf75$var$Dec.precision);
    }
    quoTruncate(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.quoRaw(d2).chopPrecisionAndTruncate(), $c7106c2bffaadf75$var$Dec.precision);
    }
    quoRoundUp(d2) {
        return new $c7106c2bffaadf75$var$Dec(this.quoRaw(d2).chopPrecisionAndRoundUp(), $c7106c2bffaadf75$var$Dec.precision);
    }
    quoRaw(d2) {
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        // multiply precision twice
        const mul = this.int.multiply(precision).multiply(precision);
        return new $c7106c2bffaadf75$var$Dec(mul.divide(d2.int), $c7106c2bffaadf75$var$Dec.precision);
    }
    isInteger() {
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        return this.int.remainder(precision).equals((0, $c7106c2bffaadf75$var$big_integer_1.default)(0));
    }
    /**
     * Remove a Precision amount of rightmost digits and perform bankers rounding
     * on the remainder (gaussian rounding) on the digits which have been removed.
     */ chopPrecisionAndRound() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            const choped = absoulteDec.chopPrecisionAndRound();
            return choped.negate();
        }
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        const fivePrecision = precision.divide((0, $c7106c2bffaadf75$var$big_integer_1.default)(2));
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals((0, $c7106c2bffaadf75$var$big_integer_1.default)(0))) return quotient;
        if (remainder.lt(fivePrecision)) return quotient;
        else if (remainder.gt(fivePrecision)) return quotient.add((0, $c7106c2bffaadf75$var$big_integer_1.default)(1));
        else {
            // always round to an even number
            if (quotient.divide((0, $c7106c2bffaadf75$var$big_integer_1.default)(2)).equals((0, $c7106c2bffaadf75$var$big_integer_1.default)(0))) return quotient;
            else return quotient.add((0, $c7106c2bffaadf75$var$big_integer_1.default)(1));
        }
    }
    chopPrecisionAndRoundUp() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            // truncate since d is negative...
            const choped = absoulteDec.chopPrecisionAndTruncate();
            return choped.negate();
        }
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals((0, $c7106c2bffaadf75$var$big_integer_1.default)(0))) return quotient;
        return quotient.add((0, $c7106c2bffaadf75$var$big_integer_1.default)(1));
    }
    /**
     * Similar to chopPrecisionAndRound, but always rounds down
     */ chopPrecisionAndTruncate() {
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        return this.int.divide(precision);
    }
    toString(prec = $c7106c2bffaadf75$var$Dec.precision, locale = false) {
        const precision = $c7106c2bffaadf75$var$Dec.calcPrecisionMultiplier(0);
        const int = this.int.abs();
        const { quotient: integer, remainder: fraction } = int.divmod(precision);
        let fractionStr = fraction.toString(10);
        for(let i = 0, l = fractionStr.length; i < $c7106c2bffaadf75$var$Dec.precision - l; i++)fractionStr = "0" + fractionStr;
        fractionStr = fractionStr.substring(0, prec);
        const isNegative = this.isNegative() && !(integer.eq((0, $c7106c2bffaadf75$var$big_integer_1.default)(0)) && fractionStr.length === 0);
        const integerStr = locale ? (0, $ceNzq.integerStringToUSLocaleString)(integer.toString()) : integer.toString();
        return `${isNegative ? "-" : ""}${integerStr}${fractionStr.length > 0 ? "." + fractionStr : ""}`;
    }
    round() {
        return new $adR1Z.Int(this.chopPrecisionAndRound());
    }
    roundUp() {
        return new $adR1Z.Int(this.chopPrecisionAndRoundUp());
    }
    truncate() {
        return new $adR1Z.Int(this.chopPrecisionAndTruncate());
    }
    roundDec() {
        return new $c7106c2bffaadf75$var$Dec(this.chopPrecisionAndRound(), 0);
    }
    roundUpDec() {
        return new $c7106c2bffaadf75$var$Dec(this.chopPrecisionAndRoundUp(), 0);
    }
    truncateDec() {
        return new $c7106c2bffaadf75$var$Dec(this.chopPrecisionAndTruncate(), 0);
    }
}
module.exports.Dec = $c7106c2bffaadf75$var$Dec;
$c7106c2bffaadf75$var$Dec.precision = 18;
// Bytes required to represent the above precision is 18.
// Ceiling[Log2[999 999 999 999 999 999]]
$c7106c2bffaadf75$var$Dec.decimalPrecisionBits = 60;
// Max bit length for `Dec` is 256 + 60(decimalPrecisionBits)
// The int in the `Dec` is handled as integer assuming that it has 18 precision.
// (2 ** (256 + 60) - 1)
$c7106c2bffaadf75$var$Dec.maxDec = (0, $c7106c2bffaadf75$var$big_integer_1.default)("133499189745056880149688856635597007162669032647290798121690100488888732861290034376435130433535");
$c7106c2bffaadf75$var$Dec.precisionMultipliers = new Map();
$c7106c2bffaadf75$var$Dec.zero = new $c7106c2bffaadf75$var$Dec(0);
/** Smallest `Dec` with current precision. */ $c7106c2bffaadf75$var$Dec.smallestDec = new $c7106c2bffaadf75$var$Dec("1", $c7106c2bffaadf75$var$Dec.precision);
$c7106c2bffaadf75$var$Dec.one = new $c7106c2bffaadf75$var$Dec(1);
$adR1Z.Int.prototype.toDec = function() {
    return new $c7106c2bffaadf75$var$Dec(this);
};
$adR1Z.Uint.prototype.toDec = function() {
    return new $c7106c2bffaadf75$var$Dec(this);
};

});
parcelRegister("ceNzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.integerStringToUSLocaleString = void 0;
/**
 * Change the non-locale integer string to locale string.
 * Only support en-US format.
 * This method uses the BigInt if the environment supports the BigInt.
 * @param numberStr
 */ function $8e8d3e78b3b818a8$var$integerStringToUSLocaleString(numberStr) {
    if (numberStr.indexOf(".") >= 0) throw new Error(`${numberStr} is not integer`);
    if (typeof BigInt !== "undefined") return BigInt(numberStr).toLocaleString("en-US");
    const integer = numberStr;
    const chunks = [];
    for(let i = integer.length; i > 0; i -= 3)chunks.push(integer.slice(Math.max(0, i - 3), i));
    return chunks.reverse().join(",");
}
module.exports.integerStringToUSLocaleString = $8e8d3e78b3b818a8$var$integerStringToUSLocaleString;

});


parcelRegister("jnpZq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecUtils = void 0;

var $h5C3s = parcelRequire("h5C3s");

var $adR1Z = parcelRequire("adR1Z");
class $03a3f0d3e238bf2e$var$DecUtils {
    static trim(dec) {
        let decStr = typeof dec === "string" ? dec : dec.toString();
        if (decStr.indexOf(".") < 0) return decStr;
        for(let i = decStr.length - 1; i >= 0; i--){
            if (decStr[i] === "0") decStr = decStr.slice(0, i);
            else break;
        }
        if (decStr.length > 0) {
            if (decStr[decStr.length - 1] === ".") decStr = decStr.slice(0, decStr.length - 1);
        }
        return decStr;
    }
    static getTenExponentN(n) {
        if (n < -$h5C3s.Dec.precision) // Dec can only handle up to precision 18.
        // Anything less than 18 precision is 0, so there is a high probability of an error.
        throw new Error("Too little precision");
        if ($03a3f0d3e238bf2e$var$DecUtils.tenExponentNs[n.toString()]) return $03a3f0d3e238bf2e$var$DecUtils.tenExponentNs[n.toString()];
        const dec = new $h5C3s.Dec(10).pow(new $adR1Z.Int(n));
        $03a3f0d3e238bf2e$var$DecUtils.tenExponentNs[n.toString()] = dec;
        return dec;
    }
    static getTenExponentNInPrecisionRange(n) {
        if (n > $h5C3s.Dec.precision) throw new Error("Too much precision");
        return $03a3f0d3e238bf2e$var$DecUtils.getTenExponentN(n);
    }
    /**
     * @deprecated Use`getTenExponentNInPrecisionRange`
     */ static getPrecisionDec(precision) {
        return $03a3f0d3e238bf2e$var$DecUtils.getTenExponentNInPrecisionRange(precision);
    }
}
module.exports.DecUtils = $03a3f0d3e238bf2e$var$DecUtils;
$03a3f0d3e238bf2e$var$DecUtils.tenExponentNs = {};

});

parcelRegister("hm0dN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinUtils = void 0;

var $hPGpe = parcelRequire("hPGpe");

var $adR1Z = parcelRequire("adR1Z");

var $h5C3s = parcelRequire("h5C3s");

var $jnpZq = parcelRequire("jnpZq");

var $ceNzq = parcelRequire("ceNzq");
class $ca24a9bebacd4ee4$var$CoinUtils {
    static createCoinsFromPrimitives(coinPrimitives) {
        return coinPrimitives.map((primitive)=>{
            return new $hPGpe.Coin(primitive.denom, primitive.amount);
        });
    }
    static amountOf(coins, denom) {
        const coin = coins.find((coin)=>{
            return coin.denom === denom;
        });
        if (!coin) return new $adR1Z.Int(0);
        else return coin.amount;
    }
    static exclude(coins, demons) {
        return coins.filter((coin)=>{
            return demons.indexOf(coin.denom) === 0;
        });
    }
    static concat(...coins) {
        if (coins.length === 0) return [];
        const arr = coins.slice();
        const reducer = (accumulator, coin)=>{
            // Find the duplicated denom.
            const find = accumulator.find((c)=>c.denom === coin.denom);
            // If duplicated coin exists, add the amount to duplicated one.
            if (find) {
                const newCoin = new $hPGpe.Coin(find.denom, find.amount.add(coin.amount));
                accumulator.push(newCoin);
            } else {
                const newCoin = new $hPGpe.Coin(coin.denom, coin.amount);
                accumulator.push(newCoin);
            }
            return accumulator;
        };
        return arr.reduce(reducer, []);
    }
    static getCoinFromDecimals(currencies, decAmountStr, denom) {
        const currency = currencies.find((currency)=>{
            return currency.coinDenom === denom;
        });
        if (!currency) throw new Error("Invalid currency");
        let precision = new $h5C3s.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $h5C3s.Dec(10));
        let decAmount = new $h5C3s.Dec(decAmountStr);
        decAmount = decAmount.mul(precision);
        if (!new $h5C3s.Dec(decAmount.truncate()).equals(decAmount)) throw new Error("Can't divide anymore");
        return new $hPGpe.Coin(currency.coinMinimalDenom, decAmount.truncate());
    }
    static parseDecAndDenomFromCoin(currencies, coin) {
        let currency = currencies.find((currency)=>{
            return currency.coinMinimalDenom === coin.denom;
        });
        if (!currency) // If the currency is unknown, just use the raw currency.
        currency = {
            coinDecimals: 0,
            coinDenom: coin.denom,
            coinMinimalDenom: coin.denom
        };
        let precision = new $h5C3s.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $h5C3s.Dec(10));
        const decAmount = new $h5C3s.Dec(coin.amount).quoTruncate(precision);
        return {
            amount: decAmount.toString(currency.coinDecimals),
            denom: currency.coinDenom
        };
    }
    static shrinkDecimals(dec, minDecimals, maxDecimals, locale = false) {
        if (dec.equals(new $h5C3s.Dec(0))) return "0";
        const isNeg = dec.isNegative();
        const integer = dec.abs().truncate();
        const fraction = dec.abs().sub(new $h5C3s.Dec(integer));
        const decimals = Math.max(maxDecimals - integer.toString().length + 1, minDecimals);
        const fractionStr = decimals === 0 ? "" : fraction.toString(decimals).replace("0.", "");
        const integerStr = locale ? $ca24a9bebacd4ee4$var$CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return (isNeg ? "-" : "") + integerStr + (fractionStr.length > 0 ? "." : "") + fractionStr;
    }
    static coinToTrimmedString(coin, currency, separator = " ") {
        const dec = new $h5C3s.Dec(coin.amount).quoTruncate($jnpZq.DecUtils.getPrecisionDec(currency.coinDecimals));
        return `${$jnpZq.DecUtils.trim(dec)}${separator}${currency.coinDenom}`;
    }
}
module.exports.CoinUtils = $ca24a9bebacd4ee4$var$CoinUtils;
$ca24a9bebacd4ee4$var$CoinUtils.integerStringToUSLocaleString = $ceNzq.integerStringToUSLocaleString;

});
parcelRegister("hPGpe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coin = void 0;

var $adR1Z = parcelRequire("adR1Z");
class $cfb818077647ba73$var$Coin {
    static parse(str) {
        const re = new RegExp("([0-9]+)[ ]*([a-zA-Z]+)$");
        const execed = re.exec(str);
        if (!execed || execed.length !== 3) throw new Error("Invalid coin str");
        const denom = execed[2];
        const amount = execed[1];
        return new $cfb818077647ba73$var$Coin(denom, amount);
    }
    constructor(denom, amount){
        this.denom = denom;
        this.amount = amount instanceof $adR1Z.Int ? amount : new $adR1Z.Int(amount);
    }
    toString() {
        return `${this.amount.toString()}${this.denom}`;
    }
}
module.exports.Coin = $cfb818077647ba73$var$Coin;

});



parcelRegister("gKlbj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinPretty = void 0;

var $70O8a = parcelRequire("70O8a");

var $h5C3s = parcelRequire("h5C3s");

var $jnpZq = parcelRequire("jnpZq");
class $c3115f6bc3dd5149$var$CoinPretty {
    constructor(_currency, amount){
        this._currency = _currency;
        this._options = {
            separator: " ",
            upperCase: false,
            lowerCase: false,
            hideDenom: false,
            hideIBCMetadata: false
        };
        if (typeof amount === "object" && "toDec" in amount) amount = amount.toDec();
        else if (!(amount instanceof $h5C3s.Dec)) amount = new $h5C3s.Dec(amount);
        this.intPretty = new $70O8a.IntPretty(amount.quoTruncate($jnpZq.DecUtils.getTenExponentNInPrecisionRange(_currency.coinDecimals))).maxDecimals(_currency.coinDecimals);
    }
    get options() {
        return Object.assign(Object.assign({}, this._options), this.intPretty.options);
    }
    get denom() {
        return this.currency.coinDenom;
    }
    get currency() {
        return this._currency;
    }
    setCurrency(currency) {
        const pretty = this.clone();
        pretty.intPretty = this.intPretty.moveDecimalPointRight(this._currency.coinDecimals - currency.coinDecimals);
        pretty._currency = currency;
        return pretty;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    hideDenom(bool) {
        const pretty = this.clone();
        pretty._options.hideDenom = bool;
        return pretty;
    }
    hideIBCMetadata(bool) {
        const pretty = this.clone();
        pretty._options.hideIBCMetadata = bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const isCoinPretty = target instanceof $c3115f6bc3dd5149$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(isCoinPretty ? target : target.mul($jnpZq.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    sub(target) {
        const isCoinPretty = target instanceof $c3115f6bc3dd5149$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(isCoinPretty ? target : target.mul($jnpZq.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toCoin() {
        const amount = this.toDec().mulTruncate($jnpZq.DecUtils.getTenExponentNInPrecisionRange(this.currency.coinDecimals)).truncate();
        return {
            denom: this.currency.coinMinimalDenom,
            amount: amount.toString()
        };
    }
    toString() {
        let denom = this.denom;
        if (this._options.hideIBCMetadata && "originCurrency" in this.currency && this.currency.originCurrency) denom = this.currency.originCurrency.coinDenom;
        if (this._options.upperCase) denom = denom.toUpperCase();
        if (this._options.lowerCase) denom = denom.toLowerCase();
        let separator = this._options.separator;
        if (this._options.hideDenom) {
            denom = "";
            separator = "";
        }
        return this.intPretty.toStringWithSymbols("", `${separator}${denom}`);
    }
    clone() {
        const pretty = new $c3115f6bc3dd5149$var$CoinPretty(this._currency, 0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.CoinPretty = $c3115f6bc3dd5149$var$CoinPretty;

});

parcelRegister("6lExw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricePretty = void 0;

var $70O8a = parcelRequire("70O8a");

var $jnpZq = parcelRequire("jnpZq");
class $49f4269082e3144c$var$PricePretty {
    constructor(_fiatCurrency, amount){
        this._fiatCurrency = _fiatCurrency;
        this._options = {
            separator: "",
            upperCase: false,
            lowerCase: false,
            locale: "en-US"
        };
        this.intPretty = new $70O8a.IntPretty(amount).maxDecimals(_fiatCurrency.maxDecimals).shrink(true).trim(true).locale(false).inequalitySymbol(true);
        this._options.locale = _fiatCurrency.locale;
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    get symbol() {
        return this._fiatCurrency.symbol;
    }
    get fiatCurrency() {
        return this._fiatCurrency;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        let symbol = this.symbol;
        if (this._options.upperCase) symbol = symbol.toUpperCase();
        if (this._options.lowerCase) symbol = symbol.toLowerCase();
        const dec = this.toDec();
        const options = this.options;
        if (options.inequalitySymbol && !dec.isZero() && dec.abs().lt($jnpZq.DecUtils.getTenExponentN(-options.maxDecimals))) return this.intPretty.toStringWithSymbols(`${symbol}${this._options.separator}`, "");
        let localeString = parseFloat(this.intPretty.toString()).toLocaleString(options.locale, {
            maximumFractionDigits: options.maxDecimals
        });
        const isNeg = localeString.charAt(0) === "-";
        if (isNeg) localeString = localeString.slice(1);
        return `${isNeg ? "-" : ""}${symbol}${this._options.separator}${localeString}`;
    }
    clone() {
        const pretty = new $49f4269082e3144c$var$PricePretty(this._fiatCurrency, 0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.PricePretty = $49f4269082e3144c$var$PricePretty;

});

parcelRegister("ljAfy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RatePretty = void 0;

var $70O8a = parcelRequire("70O8a");
/**
 * RatePretty treats `Dec` in rate form for easy calculation, and displays it as a percentage to the user by using toString().
 * By default, if the value is less than maxDeciamls, it is displayed using an inequality sign (Ex. < 0.001%)
 */ class $f8477dd07797dac3$var$RatePretty {
    constructor(amount){
        this._options = {
            separator: "",
            symbol: "%"
        };
        this.intPretty = new $70O8a.IntPretty(amount);
        this.intPretty = this.intPretty.maxDecimals(3).shrink(false).trim(true).locale(true).inequalitySymbol(true);
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    symbol(str) {
        const pretty = this.clone();
        pretty._options.symbol = str;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        return this.intPretty.moveDecimalPointRight(2).toStringWithSymbols("", `${this._options.separator}${this._options.symbol}`);
    }
    clone() {
        const pretty = new $f8477dd07797dac3$var$RatePretty(0);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.RatePretty = $f8477dd07797dac3$var$RatePretty;

});


parcelRegister("f5BuS", function(module, exports) {
"use strict";
var $afc468c09513ac19$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $afc468c09513ac19$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $afc468c09513ac19$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$afc468c09513ac19$var$__exportStar((parcelRequire("e0af4")), module.exports);

$afc468c09513ac19$var$__exportStar((parcelRequire("kKDnh")), module.exports);

$afc468c09513ac19$var$__exportStar((parcelRequire("aVxfV")), module.exports);

});
parcelRegister("e0af4", function(module, exports) {
"use strict";
var $a31902a51b50e8e2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a31902a51b50e8e2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.simpleFetch = module.exports.makeURL = void 0;

var $kKDnh = parcelRequire("kKDnh");
function $a31902a51b50e8e2$var$makeURL(baseURL, url) {
    const baseURLInstance = new URL(baseURL);
    baseURL = $a31902a51b50e8e2$var$removeLastSlashIfIs(baseURLInstance.origin);
    url = $a31902a51b50e8e2$var$removeLastSlashIfIs(baseURLInstance.pathname) + "/" + $a31902a51b50e8e2$var$removeFirstSlashIfIs(url);
    return $a31902a51b50e8e2$var$removeLastSlashIfIs(baseURL + "/" + $a31902a51b50e8e2$var$removeFirstSlashIfIs(url));
}
module.exports.makeURL = $a31902a51b50e8e2$var$makeURL;
function $a31902a51b50e8e2$var$removeFirstSlashIfIs(str) {
    if (str.length > 0 && str[0] === "/") return str.slice(1);
    return str;
}
function $a31902a51b50e8e2$var$removeLastSlashIfIs(str) {
    if (str.length > 0 && str[str.length - 1] === "/") return str.slice(0, str.length - 1);
    return str;
}
function $a31902a51b50e8e2$var$simpleFetch(baseURL, url, options) {
    return $a31902a51b50e8e2$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof url !== "string") {
            if (url) options = url;
            url = "";
        }
        if (url === "/") // If url is "/", probably its mean should be to use only base url.
        // However, `URL` with "/" url generate the root url with removing trailing url from base url.
        // To prevent this invalid case, just handle "/" as "".
        url = "";
        const actualURL = $a31902a51b50e8e2$var$makeURL(baseURL, url);
        const _a = options || {}, { headers: optionHeaders } = _a, otherOptions = $a31902a51b50e8e2$var$__rest(_a, [
            "headers"
        ]);
        const fetched = yield fetch(actualURL, Object.assign({
            headers: Object.assign({
                accept: "application/json, text/plain, */*"
            }, optionHeaders)
        }, otherOptions));
        let data;
        if (fetched.status === 204) // 204 No Content
        data = undefined;
        else {
            const contentType = fetched.headers.get("content-type") || "";
            if (contentType.startsWith("application/json")) data = yield fetched.json();
            else {
                const r = yield fetched.text();
                const trim = r.trim();
                if (trim.startsWith("{") && trim.endsWith("}")) data = JSON.parse(trim);
                else data = r;
            }
        }
        const res = {
            url: actualURL,
            data: data,
            headers: fetched.headers,
            status: fetched.status,
            statusText: fetched.statusText
        };
        const validateStatusFn = (options === null || options === void 0 ? void 0 : options.validateStatus) || $a31902a51b50e8e2$var$defaultValidateStatusFn;
        if (!validateStatusFn(fetched.status)) throw new $kKDnh.SimpleFetchError(baseURL, url, res);
        return res;
    });
}
module.exports.simpleFetch = $a31902a51b50e8e2$var$simpleFetch;
function $a31902a51b50e8e2$var$defaultValidateStatusFn(status) {
    return status >= 200 && status < 300;
}

});
parcelRegister("kKDnh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSimpleFetchError = module.exports.SimpleFetchError = void 0;
class $f1b6a57d707033f4$var$SimpleFetchError extends Error {
    constructor(baseURL, url, response){
        super(`Failed to get response from ${new URL(url, baseURL).toString()}`);
        this.baseURL = baseURL;
        this.url = url;
        this.response = response;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $f1b6a57d707033f4$var$SimpleFetchError.prototype);
    }
}
module.exports.SimpleFetchError = $f1b6a57d707033f4$var$SimpleFetchError;
function $f1b6a57d707033f4$var$isSimpleFetchError(payload) {
    return payload instanceof $f1b6a57d707033f4$var$SimpleFetchError;
}
module.exports.isSimpleFetchError = $f1b6a57d707033f4$var$isSimpleFetchError;

});


parcelRegister("aVxfV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});



parcelRegister("cJDGK", function(module, exports) {
"use strict";
var $94587951e7d5302d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $94587951e7d5302d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $94587951e7d5302d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $94587951e7d5302d$var$__createBinding(result, mod, k);
    }
    $94587951e7d5302d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32Address = void 0;

const $94587951e7d5302d$var$bech32_1 = $94587951e7d5302d$var$__importStar((parcelRequire("ez8A1")));

var $N0o3H = parcelRequire("N0o3H");

var $81UJJ = parcelRequire("81UJJ");
class $94587951e7d5302d$var$Bech32Address {
    static shortenAddress(bech32, maxCharacters) {
        if (maxCharacters >= bech32.length) return bech32;
        const i = bech32.indexOf("1");
        const prefix = bech32.slice(0, i);
        const address = bech32.slice(i + 1);
        maxCharacters -= prefix.length;
        maxCharacters -= 3; // For "..."
        maxCharacters -= 1; // For "1"
        if (maxCharacters <= 0) return "";
        const mid = Math.floor(address.length / 2);
        let former = address.slice(0, mid);
        let latter = address.slice(mid);
        while(maxCharacters < former.length + latter.length)if ((former.length + latter.length) % 2 === 1 && former.length > 0) former = former.slice(0, former.length - 1);
        else latter = latter.slice(1);
        return prefix + "1" + former + "..." + latter;
    }
    static fromBech32(bech32Address, prefix) {
        const decoded = $94587951e7d5302d$var$bech32_1.default.decode(bech32Address);
        if (prefix && decoded.prefix !== prefix) throw new Error("Unmatched prefix");
        return new $94587951e7d5302d$var$Bech32Address(new Uint8Array((0, $94587951e7d5302d$var$bech32_1.fromWords)(decoded.words)));
    }
    static validate(bech32Address, prefix) {
        const { prefix: decodedPrefix } = $94587951e7d5302d$var$bech32_1.default.decode(bech32Address);
        if (prefix && prefix !== decodedPrefix) throw new Error(`Unexpected prefix (expected: ${prefix}, actual: ${decodedPrefix})`);
    }
    static defaultBech32Config(mainPrefix, validatorPrefix = "val", consensusPrefix = "cons", publicPrefix = "pub", operatorPrefix = "oper") {
        return {
            bech32PrefixAccAddr: mainPrefix,
            bech32PrefixAccPub: mainPrefix + publicPrefix,
            bech32PrefixValAddr: mainPrefix + validatorPrefix + operatorPrefix,
            bech32PrefixValPub: mainPrefix + validatorPrefix + operatorPrefix + publicPrefix,
            bech32PrefixConsAddr: mainPrefix + validatorPrefix + consensusPrefix,
            bech32PrefixConsPub: mainPrefix + validatorPrefix + consensusPrefix + publicPrefix
        };
    }
    constructor(address){
        this.address = address;
    }
    toBech32(prefix) {
        const words = $94587951e7d5302d$var$bech32_1.default.toWords(this.address);
        return $94587951e7d5302d$var$bech32_1.default.encode(prefix, words);
    }
    toHex(mixedCaseChecksum = true) {
        const hex = $N0o3H.Buffer.from(this.address).toString("hex");
        if (hex.length === 0) throw new Error("Empty address");
        if (mixedCaseChecksum) return (0, $81UJJ.getAddress)("0x" + hex);
        else return "0x" + hex;
    }
}
module.exports.Bech32Address = $94587951e7d5302d$var$Bech32Address;

});
parcelRegister("ez8A1", function(module, exports) {
"use strict";
var $a9aafd5dd9f23a54$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $a9aafd5dd9f23a54$var$ALPHABET_MAP = {};
for(var $a9aafd5dd9f23a54$var$z = 0; $a9aafd5dd9f23a54$var$z < $a9aafd5dd9f23a54$var$ALPHABET.length; $a9aafd5dd9f23a54$var$z++){
    var $a9aafd5dd9f23a54$var$x = $a9aafd5dd9f23a54$var$ALPHABET.charAt($a9aafd5dd9f23a54$var$z);
    if ($a9aafd5dd9f23a54$var$ALPHABET_MAP[$a9aafd5dd9f23a54$var$x] !== undefined) throw new TypeError($a9aafd5dd9f23a54$var$x + " is ambiguous");
    $a9aafd5dd9f23a54$var$ALPHABET_MAP[$a9aafd5dd9f23a54$var$x] = $a9aafd5dd9f23a54$var$z;
}
function $a9aafd5dd9f23a54$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $a9aafd5dd9f23a54$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $a9aafd5dd9f23a54$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $a9aafd5dd9f23a54$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $a9aafd5dd9f23a54$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $a9aafd5dd9f23a54$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $a9aafd5dd9f23a54$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $a9aafd5dd9f23a54$var$polymodStep(chk) ^ x;
        result += $a9aafd5dd9f23a54$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $a9aafd5dd9f23a54$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $a9aafd5dd9f23a54$var$ALPHABET.charAt(v);
    }
    return result;
}
function $a9aafd5dd9f23a54$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $a9aafd5dd9f23a54$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $a9aafd5dd9f23a54$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $a9aafd5dd9f23a54$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $a9aafd5dd9f23a54$var$decodeUnsafe() {
    var res = $a9aafd5dd9f23a54$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $a9aafd5dd9f23a54$var$decode(str) {
    var res = $a9aafd5dd9f23a54$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $a9aafd5dd9f23a54$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $a9aafd5dd9f23a54$var$toWordsUnsafe(bytes) {
    var res = $a9aafd5dd9f23a54$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $a9aafd5dd9f23a54$var$toWords(bytes) {
    var res = $a9aafd5dd9f23a54$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $a9aafd5dd9f23a54$var$fromWordsUnsafe(words) {
    var res = $a9aafd5dd9f23a54$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $a9aafd5dd9f23a54$var$fromWords(words) {
    var res = $a9aafd5dd9f23a54$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $a9aafd5dd9f23a54$var$decodeUnsafe,
    decode: $a9aafd5dd9f23a54$var$decode,
    encode: $a9aafd5dd9f23a54$var$encode,
    toWordsUnsafe: $a9aafd5dd9f23a54$var$toWordsUnsafe,
    toWords: $a9aafd5dd9f23a54$var$toWords,
    fromWordsUnsafe: $a9aafd5dd9f23a54$var$fromWordsUnsafe,
    fromWords: $a9aafd5dd9f23a54$var$fromWords
};

});

parcelRegister("81UJJ", function(module, exports) {

$parcel$export(module.exports, "getAddress", () => $5d8a6d6ebd6b6bfd$export$88411125f012957a);

var $2Zz8l = parcelRequire("2Zz8l");

var $3HDBd = parcelRequire("3HDBd");

var $Jhr88 = parcelRequire("Jhr88");

var $1iei8 = parcelRequire("1iei8");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $eFlRV = parcelRequire("eFlRV");
"use strict";
const $5d8a6d6ebd6b6bfd$var$logger = new (0, $l1ZqZ.Logger)((0, $eFlRV.version));
function $5d8a6d6ebd6b6bfd$var$getChecksumAddress(address) {
    if (!(0, $2Zz8l.isHexString)(address, 20)) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $2Zz8l.arrayify)((0, $Jhr88.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5d8a6d6ebd6b6bfd$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5d8a6d6ebd6b6bfd$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5d8a6d6ebd6b6bfd$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5d8a6d6ebd6b6bfd$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5d8a6d6ebd6b6bfd$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5d8a6d6ebd6b6bfd$var$safeDigits = Math.floor($5d8a6d6ebd6b6bfd$var$log10($5d8a6d6ebd6b6bfd$var$MAX_SAFE_INTEGER));
function $5d8a6d6ebd6b6bfd$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5d8a6d6ebd6b6bfd$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5d8a6d6ebd6b6bfd$var$safeDigits){
        let block = expanded.substring(0, $5d8a6d6ebd6b6bfd$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5d8a6d6ebd6b6bfd$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5d8a6d6ebd6b6bfd$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5d8a6d6ebd6b6bfd$var$ibanChecksum(address)) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $3HDBd._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5d8a6d6ebd6b6bfd$var$getChecksumAddress("0x" + result);
    } else $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5d8a6d6ebd6b6bfd$export$977e255126d763d6(address) {
    try {
        $5d8a6d6ebd6b6bfd$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5d8a6d6ebd6b6bfd$export$962c4ddada9f668f(address) {
    let base36 = (0, $3HDBd._base16To36)($5d8a6d6ebd6b6bfd$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5d8a6d6ebd6b6bfd$var$ibanChecksum("XE00" + base36) + base36;
}
function $5d8a6d6ebd6b6bfd$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5d8a6d6ebd6b6bfd$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $2Zz8l.stripZeros)((0, $2Zz8l.arrayify)((0, $3HDBd.BigNumber).from(transaction.nonce).toHexString()));
    return $5d8a6d6ebd6b6bfd$export$88411125f012957a((0, $2Zz8l.hexDataSlice)((0, $Jhr88.keccak256)((0, $1iei8.encode)([
        from,
        nonce
    ])), 12));
}
function $5d8a6d6ebd6b6bfd$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $2Zz8l.hexDataLength)(salt) !== 32) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $2Zz8l.hexDataLength)(initCodeHash) !== 32) $5d8a6d6ebd6b6bfd$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5d8a6d6ebd6b6bfd$export$88411125f012957a((0, $2Zz8l.hexDataSlice)((0, $Jhr88.keccak256)((0, $2Zz8l.concat)([
        "0xff",
        $5d8a6d6ebd6b6bfd$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("2Zz8l", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", () => $22dc881190706dd3$export$9a14abb1a440cd5e);
$parcel$export(module.exports, "isHexString", () => $22dc881190706dd3$export$b02a40aff8e4ad18);
$parcel$export(module.exports, "isBytes", () => $22dc881190706dd3$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "arrayify", () => $22dc881190706dd3$export$3131421a7d01b4fb);
$parcel$export(module.exports, "concat", () => $22dc881190706dd3$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "stripZeros", () => $22dc881190706dd3$export$a8f4574d0e56446c);
$parcel$export(module.exports, "hexlify", () => $22dc881190706dd3$export$2b0d6b5fbe698c70);
$parcel$export(module.exports, "hexDataLength", () => $22dc881190706dd3$export$13882f896d3c0683);
$parcel$export(module.exports, "hexDataSlice", () => $22dc881190706dd3$export$15da666eba198c18);

var $l1ZqZ = parcelRequire("l1ZqZ");

var $d446Z = parcelRequire("d446Z");
"use strict";
const $22dc881190706dd3$var$logger = new (0, $l1ZqZ.Logger)((0, $d446Z.version));
///////////////////////////////
function $22dc881190706dd3$var$isHexable(value) {
    return !!value.toHexString;
}
function $22dc881190706dd3$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $22dc881190706dd3$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $22dc881190706dd3$export$9a14abb1a440cd5e(value) {
    return $22dc881190706dd3$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $22dc881190706dd3$export$c6fabfbfd097fc30(value);
}
function $22dc881190706dd3$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $22dc881190706dd3$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$22dc881190706dd3$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$22dc881190706dd3$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $22dc881190706dd3$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $22dc881190706dd3$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $22dc881190706dd3$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($22dc881190706dd3$var$isHexable(value)) value = value.toHexString();
    if ($22dc881190706dd3$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $22dc881190706dd3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $22dc881190706dd3$var$addSlice(new Uint8Array(result));
    }
    if ($22dc881190706dd3$export$c6fabfbfd097fc30(value)) return $22dc881190706dd3$var$addSlice(new Uint8Array(value));
    return $22dc881190706dd3$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $22dc881190706dd3$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$22dc881190706dd3$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $22dc881190706dd3$var$addSlice(result);
}
function $22dc881190706dd3$export$a8f4574d0e56446c(value) {
    let result = $22dc881190706dd3$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $22dc881190706dd3$export$3cdc770bf8b2ed3d(value, length) {
    value = $22dc881190706dd3$export$3131421a7d01b4fb(value);
    if (value.length > length) $22dc881190706dd3$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $22dc881190706dd3$var$addSlice(result);
}
function $22dc881190706dd3$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $22dc881190706dd3$var$HexCharacters = "0123456789abcdef";
function $22dc881190706dd3$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $22dc881190706dd3$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $22dc881190706dd3$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($22dc881190706dd3$var$isHexable(value)) return value.toHexString();
    if ($22dc881190706dd3$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $22dc881190706dd3$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($22dc881190706dd3$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $22dc881190706dd3$var$HexCharacters[(v & 0xf0) >> 4] + $22dc881190706dd3$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $22dc881190706dd3$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $22dc881190706dd3$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $22dc881190706dd3$export$2b0d6b5fbe698c70(data);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $22dc881190706dd3$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $22dc881190706dd3$export$2b0d6b5fbe698c70(data);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(data) || data.length % 2) $22dc881190706dd3$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $22dc881190706dd3$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $22dc881190706dd3$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $22dc881190706dd3$export$6916af760a341dd3(value) {
    const trimmed = $22dc881190706dd3$export$967bc0082a978949($22dc881190706dd3$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $22dc881190706dd3$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $22dc881190706dd3$export$2b0d6b5fbe698c70(value);
    if (!$22dc881190706dd3$export$b02a40aff8e4ad18(value)) $22dc881190706dd3$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $22dc881190706dd3$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $22dc881190706dd3$export$2b0d6b5fbe698c70(value);
    else if (!$22dc881190706dd3$export$b02a40aff8e4ad18(value)) $22dc881190706dd3$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $22dc881190706dd3$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $22dc881190706dd3$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($22dc881190706dd3$export$9a14abb1a440cd5e(signature)) {
        let bytes = $22dc881190706dd3$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $22dc881190706dd3$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $22dc881190706dd3$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $22dc881190706dd3$export$3cdc770bf8b2ed3d($22dc881190706dd3$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $22dc881190706dd3$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $22dc881190706dd3$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $22dc881190706dd3$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $22dc881190706dd3$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$22dc881190706dd3$export$b02a40aff8e4ad18(result.r)) $22dc881190706dd3$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $22dc881190706dd3$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$22dc881190706dd3$export$b02a40aff8e4ad18(result.s)) $22dc881190706dd3$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $22dc881190706dd3$export$e9c46a54370b47e8(result.s, 32);
        const vs = $22dc881190706dd3$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $22dc881190706dd3$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $22dc881190706dd3$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$22dc881190706dd3$export$b02a40aff8e4ad18(result._vs)) $22dc881190706dd3$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $22dc881190706dd3$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $22dc881190706dd3$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $22dc881190706dd3$export$71bb9d78a59bbe25(signature) {
    signature = $22dc881190706dd3$export$7fb170f1e457988f(signature);
    return $22dc881190706dd3$export$2b0d6b5fbe698c70($22dc881190706dd3$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("l1ZqZ", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $f4f9588d0bf57552$export$efa9a398d6368992);

var $lApts = parcelRequire("lApts");
"use strict";
let $f4f9588d0bf57552$var$_permanentCensorErrors = false;
let $f4f9588d0bf57552$var$_censorErrors = false;
const $f4f9588d0bf57552$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $f4f9588d0bf57552$var$_logLevel = $f4f9588d0bf57552$var$LogLevels["default"];
let $f4f9588d0bf57552$var$_globalLogger = null;
function $f4f9588d0bf57552$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $f4f9588d0bf57552$var$_normalizeError = $f4f9588d0bf57552$var$_checkNormalize();
var $f4f9588d0bf57552$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($f4f9588d0bf57552$export$243e62d78d3b544d || ($f4f9588d0bf57552$export$243e62d78d3b544d = {}));
var $f4f9588d0bf57552$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($f4f9588d0bf57552$export$d4e71bc0b80dc0fb || ($f4f9588d0bf57552$export$d4e71bc0b80dc0fb = {}));
const $f4f9588d0bf57552$var$HEX = "0123456789abcdef";
class $f4f9588d0bf57552$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($f4f9588d0bf57552$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($f4f9588d0bf57552$var$_logLevel > $f4f9588d0bf57552$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($f4f9588d0bf57552$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($f4f9588d0bf57552$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $f4f9588d0bf57552$var$HEX[value[i] >> 4];
                        hex += $f4f9588d0bf57552$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $f4f9588d0bf57552$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($f4f9588d0bf57552$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $f4f9588d0bf57552$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $f4f9588d0bf57552$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$f4f9588d0bf57552$var$_globalLogger) $f4f9588d0bf57552$var$_globalLogger = new $f4f9588d0bf57552$export$efa9a398d6368992((0, $lApts.version));
        return $f4f9588d0bf57552$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($f4f9588d0bf57552$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $f4f9588d0bf57552$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $f4f9588d0bf57552$var$_censorErrors = !!censorship;
        $f4f9588d0bf57552$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $f4f9588d0bf57552$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $f4f9588d0bf57552$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $f4f9588d0bf57552$var$_logLevel = level;
    }
    static from(version) {
        return new $f4f9588d0bf57552$export$efa9a398d6368992(version);
    }
}
$f4f9588d0bf57552$export$efa9a398d6368992.errors = $f4f9588d0bf57552$export$d4e71bc0b80dc0fb;
$f4f9588d0bf57552$export$efa9a398d6368992.levels = $f4f9588d0bf57552$export$243e62d78d3b544d;

});
parcelRegister("lApts", function(module, exports) {

$parcel$export(module.exports, "version", () => $fb70b861ac0868f7$export$83d89fbfd8236492);
const $fb70b861ac0868f7$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("d446Z", function(module, exports) {

$parcel$export(module.exports, "version", () => $982ed69cee193712$export$83d89fbfd8236492);
const $982ed69cee193712$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("3HDBd", function(module, exports) {

$parcel$export(module.exports, "BigNumber", () => $2b241ad9f2c98830$export$d97aa349ed20696);
$parcel$export(module.exports, "_base36To16", () => $2b241ad9f2c98830$export$51e4a08295f7770f);
$parcel$export(module.exports, "_base16To36", () => $2b241ad9f2c98830$export$1293db5d29c264ff);

var $lONYJ = parcelRequire("lONYJ");

var $2Zz8l = parcelRequire("2Zz8l");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $7d92x = parcelRequire("7d92x");
"use strict";
var $2b241ad9f2c98830$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($lONYJ))).BN;
const $2b241ad9f2c98830$var$logger = new (0, $l1ZqZ.Logger)((0, $7d92x.version));
const $2b241ad9f2c98830$var$_constructorGuard = {};
const $2b241ad9f2c98830$var$MAX_SAFE = 0x1fffffffffffff;
function $2b241ad9f2c98830$export$a3d0a7fa9b65683b(value) {
    return value != null && ($2b241ad9f2c98830$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $2Zz8l.isHexString)(value) || typeof value === "bigint" || (0, $2Zz8l.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $2b241ad9f2c98830$var$_warnedToStringRadix = false;
class $2b241ad9f2c98830$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $2b241ad9f2c98830$var$_constructorGuard) $2b241ad9f2c98830$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $2b241ad9f2c98830$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).add($2b241ad9f2c98830$var$toBN(other)));
    }
    sub(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).sub($2b241ad9f2c98830$var$toBN(other)));
    }
    div(other) {
        const o = $2b241ad9f2c98830$export$d97aa349ed20696.from(other);
        if (o.isZero()) $2b241ad9f2c98830$var$throwFault("division-by-zero", "div");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).div($2b241ad9f2c98830$var$toBN(other)));
    }
    mul(other) {
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).mul($2b241ad9f2c98830$var$toBN(other)));
    }
    mod(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (value.isNeg()) $2b241ad9f2c98830$var$throwFault("division-by-zero", "mod");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (value.isNeg()) $2b241ad9f2c98830$var$throwFault("negative-power", "pow");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "and");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).and(value));
    }
    or(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "or");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $2b241ad9f2c98830$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $2b241ad9f2c98830$var$throwFault("unbound-bitwise-result", "xor");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "mask");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "shl");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $2b241ad9f2c98830$var$throwFault("negative-width", "shr");
        return $2b241ad9f2c98830$var$toBigNumber($2b241ad9f2c98830$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $2b241ad9f2c98830$var$toBN(this).eq($2b241ad9f2c98830$var$toBN(other));
    }
    lt(other) {
        return $2b241ad9f2c98830$var$toBN(this).lt($2b241ad9f2c98830$var$toBN(other));
    }
    lte(other) {
        return $2b241ad9f2c98830$var$toBN(this).lte($2b241ad9f2c98830$var$toBN(other));
    }
    gt(other) {
        return $2b241ad9f2c98830$var$toBN(this).gt($2b241ad9f2c98830$var$toBN(other));
    }
    gte(other) {
        return $2b241ad9f2c98830$var$toBN(this).gte($2b241ad9f2c98830$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $2b241ad9f2c98830$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $2b241ad9f2c98830$var$toBN(this).toNumber();
        } catch (error) {
            $2b241ad9f2c98830$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $2b241ad9f2c98830$var$logger.throwError("this platform does not support BigInt", (0, $l1ZqZ.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$2b241ad9f2c98830$var$_warnedToStringRadix) {
                    $2b241ad9f2c98830$var$_warnedToStringRadix = true;
                    $2b241ad9f2c98830$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $2b241ad9f2c98830$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $l1ZqZ.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $2b241ad9f2c98830$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $l1ZqZ.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $2b241ad9f2c98830$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $2b241ad9f2c98830$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $2b241ad9f2c98830$export$d97aa349ed20696($2b241ad9f2c98830$var$_constructorGuard, $2b241ad9f2c98830$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $2b241ad9f2c98830$export$d97aa349ed20696($2b241ad9f2c98830$var$_constructorGuard, $2b241ad9f2c98830$var$toHex(new $2b241ad9f2c98830$var$BN(value)));
            return $2b241ad9f2c98830$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $2b241ad9f2c98830$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $2b241ad9f2c98830$var$MAX_SAFE || value <= -$2b241ad9f2c98830$var$MAX_SAFE) $2b241ad9f2c98830$var$throwFault("overflow", "BigNumber.from", value);
            return $2b241ad9f2c98830$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $2b241ad9f2c98830$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $2Zz8l.isBytes)(anyValue)) return $2b241ad9f2c98830$export$d97aa349ed20696.from((0, $2Zz8l.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $2b241ad9f2c98830$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $2Zz8l.isHexString)(hex) || hex[0] === "-" && (0, $2Zz8l.isHexString)(hex.substring(1))) return $2b241ad9f2c98830$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $2b241ad9f2c98830$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $2b241ad9f2c98830$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $2b241ad9f2c98830$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $2b241ad9f2c98830$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $2b241ad9f2c98830$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $2b241ad9f2c98830$var$toBigNumber(value) {
    return $2b241ad9f2c98830$export$d97aa349ed20696.from($2b241ad9f2c98830$var$toHex(value));
}
function $2b241ad9f2c98830$var$toBN(value) {
    const hex = $2b241ad9f2c98830$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $2b241ad9f2c98830$var$BN("-" + hex.substring(3), 16);
    return new $2b241ad9f2c98830$var$BN(hex.substring(2), 16);
}
function $2b241ad9f2c98830$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $2b241ad9f2c98830$var$logger.throwError(fault, (0, $l1ZqZ.Logger).errors.NUMERIC_FAULT, params);
}
function $2b241ad9f2c98830$export$51e4a08295f7770f(value) {
    return new $2b241ad9f2c98830$var$BN(value, 36).toString(16);
}
function $2b241ad9f2c98830$export$1293db5d29c264ff(value) {
    return new $2b241ad9f2c98830$var$BN(value, 16).toString(36);
}

});
parcelRegister("lONYJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7d92x", function(module, exports) {

$parcel$export(module.exports, "version", () => $5400c274fe28c47d$export$83d89fbfd8236492);
const $5400c274fe28c47d$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("Jhr88", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $0881baa05d30c22b$export$f8151fce47ad1c35);

var $84nWc = parcelRequire("84nWc");

var $2Zz8l = parcelRequire("2Zz8l");
"use strict";
function $0881baa05d30c22b$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($84nWc))).keccak_256((0, $2Zz8l.arrayify)(data));
}

});
parcelRegister("84nWc", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $ibaza === "object" && $ibaza.versions && $ibaza.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("1iei8", function(module, exports) {

$parcel$export(module.exports, "encode", () => $0f128edc33e88c02$export$c564cdbbe6da493);

var $2Zz8l = parcelRequire("2Zz8l");

var $l1ZqZ = parcelRequire("l1ZqZ");

var $47e13 = parcelRequire("47e13");
"use strict";
const $0f128edc33e88c02$var$logger = new (0, $l1ZqZ.Logger)((0, $47e13.version));
function $0f128edc33e88c02$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $0f128edc33e88c02$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $0f128edc33e88c02$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($0f128edc33e88c02$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $0f128edc33e88c02$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $2Zz8l.isBytesLike)(object)) $0f128edc33e88c02$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $2Zz8l.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $0f128edc33e88c02$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $0f128edc33e88c02$export$c564cdbbe6da493(object) {
    return (0, $2Zz8l.hexlify)($0f128edc33e88c02$var$_encode(object));
}
function $0f128edc33e88c02$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $0f128edc33e88c02$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $0f128edc33e88c02$var$logger.throwError("child data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $0f128edc33e88c02$var$_decode(data, offset) {
    if (data.length === 0) $0f128edc33e88c02$var$logger.throwError("data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $0f128edc33e88c02$var$logger.throwError("data short segment too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const length = $0f128edc33e88c02$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $0f128edc33e88c02$var$logger.throwError("data long segment too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        return $0f128edc33e88c02$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        return $0f128edc33e88c02$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const length = $0f128edc33e88c02$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $0f128edc33e88c02$var$logger.throwError("data array too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $2Zz8l.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $0f128edc33e88c02$var$logger.throwError("data too short", (0, $l1ZqZ.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $2Zz8l.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $2Zz8l.hexlify)(data[offset])
    };
}
function $0f128edc33e88c02$export$2f872c0f2117be69(data) {
    const bytes = (0, $2Zz8l.arrayify)(data);
    const decoded = $0f128edc33e88c02$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $0f128edc33e88c02$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("47e13", function(module, exports) {

$parcel$export(module.exports, "version", () => $2ff2b023187d1738$export$83d89fbfd8236492);
const $2ff2b023187d1738$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("eFlRV", function(module, exports) {

$parcel$export(module.exports, "version", () => $aad5dbb91a9116b2$export$83d89fbfd8236492);
const $aad5dbb91a9116b2$export$83d89fbfd8236492 = "address/5.7.0";

});



parcelRegister("3BVEn", function(module, exports) {
"use strict";
var $2a118be8f6de4952$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a118be8f6de4952$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2a118be8f6de4952$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2a118be8f6de4952$var$__exportStar((parcelRequire("cVHh4")), module.exports);

$2a118be8f6de4952$var$__exportStar((parcelRequire("8j365")), module.exports);

});
parcelRegister("cVHh4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChainIdHelper = void 0;
class $969c604a0f41417e$var$ChainIdHelper {
    static parse(chainId) {
        // In the case of injective dev/testnet, there is a difficult problem to deal with keplr's chain identifier system...
        // Fundamentally, keplr's chain identifier system started when the app was created, so too mnay logic depends on chain identifier.
        // Temporarily deal with it in the way below.
        // There is a possibility of some kind of problem...
        // But anyway, it's not a big problem because it's dev/testnet...
        if (chainId === "injective-777" || chainId === "injective-888") return {
            identifier: chainId,
            version: 0
        };
        const split = chainId.split($969c604a0f41417e$var$ChainIdHelper.VersionFormatRegExp).filter(Boolean);
        if (split.length !== 2) return {
            identifier: chainId,
            version: 0
        };
        else return {
            identifier: split[0],
            version: parseInt(split[1])
        };
    }
    static hasChainVersion(chainId) {
        const version = $969c604a0f41417e$var$ChainIdHelper.parse(chainId);
        return version.identifier !== chainId;
    }
}
module.exports.ChainIdHelper = $969c604a0f41417e$var$ChainIdHelper;
// VersionFormatRegExp checks if a chainID is in the format required for parsing versions
// The chainID should be in the form: `{identifier}-{version}`
$969c604a0f41417e$var$ChainIdHelper.VersionFormatRegExp = /(.+)-([\d]+)/;

});

parcelRegister("8j365", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EthermintChainIdHelper = void 0;

var $cVHh4 = parcelRequire("cVHh4");
class $60c2801fc5456bf9$var$EthermintChainIdHelper {
    static parse(chainId) {
        const cosmosChainId = $cVHh4.ChainIdHelper.parse(chainId);
        if (chainId.startsWith("injective")) {
            const injectiveTestnetChainIds = [
                "injective-777",
                "injective-888"
            ];
            if (injectiveTestnetChainIds.includes(chainId)) return Object.assign({
                ethChainId: 5
            }, cosmosChainId);
            return Object.assign({
                ethChainId: 1
            }, cosmosChainId);
        }
        const matches = chainId.match("^([a-z]{1,})_{1}([1-9][0-9]*)-{1}([1-9][0-9]*)$");
        if (!matches || matches.length !== 4 || matches[1] === "" || Number.isNaN(parseFloat(matches[2])) || !Number.isInteger(parseFloat(matches[2]))) throw new Error(`Invalid chainId for ethermint: ${chainId}`);
        return Object.assign(Object.assign({}, cosmosChainId), {
            ethChainId: parseFloat(matches[2])
        });
    }
}
module.exports.EthermintChainIdHelper = $60c2801fc5456bf9$var$EthermintChainIdHelper;

});


parcelRegister("15z4r", function(module, exports) {
"use strict";
var $0cb17662b61905ec$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TendermintTxTracer = module.exports.WsReadyState = void 0;

var $N0o3H = parcelRequire("N0o3H");
var $0cb17662b61905ec$var$WsReadyState;
(function(WsReadyState) {
    WsReadyState[WsReadyState["CONNECTING"] = 0] = "CONNECTING";
    WsReadyState[WsReadyState["OPEN"] = 1] = "OPEN";
    WsReadyState[WsReadyState["CLOSING"] = 2] = "CLOSING";
    WsReadyState[WsReadyState["CLOSED"] = 3] = "CLOSED";
    // WS is not initialized or the ready state of WS is unknown
    WsReadyState[WsReadyState["NONE"] = 4] = "NONE";
})($0cb17662b61905ec$var$WsReadyState = module.exports.WsReadyState || (module.exports.WsReadyState = {}));
class $0cb17662b61905ec$var$TendermintTxTracer {
    constructor(url, wsEndpoint, options = {}){
        this.url = url;
        this.wsEndpoint = wsEndpoint;
        this.options = options;
        this.newBlockSubscribes = [];
        // Key is "id" for jsonrpc
        this.txSubscribes = new Map();
        // Key is "id" for jsonrpc
        this.pendingQueries = new Map();
        this.listeners = {};
        this.onOpen = (e)=>{
            var _a;
            if (this.newBlockSubscribes.length > 0) this.sendSubscribeBlockRpc();
            for (const [id, tx] of this.txSubscribes)this.sendSubscribeTxRpc(id, tx.params);
            for (const [id, query] of this.pendingQueries)this.sendQueryRpc(id, query.method, query.params);
            for (const listener of (_a = this.listeners.open) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.onMessage = (e)=>{
            var _a, _b, _c, _d, _e, _f;
            for (const listener of (_a = this.listeners.message) !== null && _a !== void 0 ? _a : [])listener(e);
            if (e.data) try {
                const obj = JSON.parse(e.data);
                if (obj === null || obj === void 0 ? void 0 : obj.id) {
                    if (this.pendingQueries.has(obj.id)) {
                        if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                        else // XXX: I'm not sure why this happens, but somtimes the form of tx id delivered under the "tx_result" field.
                        if ((_b = obj.result) === null || _b === void 0 ? void 0 : _b.tx_result) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result.tx_result);
                        else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result);
                        this.pendingQueries.delete(obj.id);
                    }
                }
                if (((_d = (_c = obj === null || obj === void 0 ? void 0 : obj.result) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.type) === "tendermint/event/NewBlock") for (const handler of this.newBlockSubscribes)handler.handler(obj.result.data.value);
                if (((_f = (_e = obj === null || obj === void 0 ? void 0 : obj.result) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.type) === "tendermint/event/Tx") {
                    if (obj === null || obj === void 0 ? void 0 : obj.id) {
                        if (this.txSubscribes.has(obj.id)) {
                            if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).resolver(obj.result.data.value.TxResult.result);
                            this.txSubscribes.delete(obj.id);
                        }
                    }
                }
            } catch (e) {
                console.log(`Tendermint websocket jsonrpc response is not JSON: ${e.message || e.toString()}`);
            }
        };
        this.onClose = (e)=>{
            var _a;
            for (const listener of (_a = this.listeners.close) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.onError = (e)=>{
            var _a;
            for (const listener of (_a = this.listeners.error) !== null && _a !== void 0 ? _a : [])listener(e);
            this.close();
        };
        this.ws = this.options.wsObject ? new this.options.wsObject(this.getWsEndpoint()) : new WebSocket(this.getWsEndpoint());
        this.ws.onopen = this.onOpen;
        this.ws.onmessage = this.onMessage;
        this.ws.onclose = this.onClose;
        this.ws.onerror = this.onError;
    }
    getWsEndpoint() {
        let url = this.url;
        if (url.startsWith("http")) url = url.replace("http", "ws");
        if (!url.endsWith(this.wsEndpoint)) {
            const wsEndpoint = this.wsEndpoint.startsWith("/") ? this.wsEndpoint : "/" + this.wsEndpoint;
            url = url.endsWith("/") ? url + wsEndpoint.slice(1) : url + wsEndpoint;
        }
        return url;
    }
    close() {
        this.ws.close();
    }
    get readyState() {
        switch(this.ws.readyState){
            case 0:
                return $0cb17662b61905ec$var$WsReadyState.CONNECTING;
            case 1:
                return $0cb17662b61905ec$var$WsReadyState.OPEN;
            case 2:
                return $0cb17662b61905ec$var$WsReadyState.CLOSING;
            case 3:
                return $0cb17662b61905ec$var$WsReadyState.CLOSED;
            default:
                return $0cb17662b61905ec$var$WsReadyState.NONE;
        }
    }
    addEventListener(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.listeners[type].push(listener);
    }
    /**
     * SubscribeBlock receives the handler for the block.
     * The handelrs shares the subscription of block.
     * @param handler
     * @return unsubscriber
     */ subscribeBlock(handler) {
        this.newBlockSubscribes.push({
            handler: handler
        });
        if (this.newBlockSubscribes.length === 1) this.sendSubscribeBlockRpc();
        return ()=>{
            this.newBlockSubscribes = this.newBlockSubscribes.filter((s)=>s.handler !== handler);
        };
    }
    sendSubscribeBlockRpc() {
        if (this.readyState === $0cb17662b61905ec$var$WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                "tm.event='NewBlock'"
            ],
            id: 1
        }));
    }
    // Query the tx and subscribe the tx.
    traceTx(query) {
        let resolved = false;
        return new Promise((resolve)=>{
            // At first, try to query the tx at the same time of subscribing the tx.
            // But, the querying's error will be ignored.
            this.queryTx(query).then((result)=>{
                if (query instanceof Uint8Array) {
                    resolve(result);
                    return;
                }
                if ((result === null || result === void 0 ? void 0 : result.total_count) !== "0") {
                    resolve(result);
                    return;
                }
            }).catch(()=>{
            // noop
            });
            (()=>$0cb17662b61905ec$var$__awaiter(this, void 0, void 0, function*() {
                    // We don't know why yet. For some unknown reason, there is a problem where Tendermint does not give value through subscribe forever.
                    // For now, as a simple solution, send tx_search periodically as well.
                    while(true){
                        if (resolved || this.readyState === $0cb17662b61905ec$var$WsReadyState.CLOSED || this.readyState === $0cb17662b61905ec$var$WsReadyState.CLOSING) break;
                        yield new Promise((resolve)=>setTimeout(resolve, 10000));
                        this.queryTx(query).then((result)=>{
                            if (query instanceof Uint8Array) {
                                resolve(result);
                                return;
                            }
                            if ((result === null || result === void 0 ? void 0 : result.total_count) !== "0") {
                                resolve(result);
                                return;
                            }
                        }).catch(()=>{
                        // noop
                        });
                    }
                }))();
            this.subscribeTx(query).then(resolve);
        }).then((tx)=>{
            resolved = true;
            // Occasionally, even if the subscribe tx event occurs, the state through query is not changed yet.
            // Perhaps it is because the block has not been committed yet even though the result of deliverTx in tendermint is complete.
            // This method is usually used to reflect the state change through query when tx is completed.
            // The simplest solution is to just add a little delay.
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(tx), 100);
            });
        });
    }
    subscribeTx(query) {
        if (query instanceof Uint8Array) {
            const id = this.createRandomId();
            const params = {
                query: `tm.event='Tx' AND tx.hash='${$N0o3H.Buffer.from(query).toString("hex").toUpperCase()}'`
            };
            return new Promise((resolve, reject)=>{
                this.txSubscribes.set(id, {
                    params: params,
                    resolver: resolve,
                    rejector: reject
                });
                this.sendSubscribeTxRpc(id, params);
            });
        } else {
            const id = this.createRandomId();
            const params = {
                query: `tm.event='Tx' and ` + Object.keys(query).map((key)=>{
                    return {
                        key: key,
                        value: query[key]
                    };
                }).map((obj)=>{
                    return `${obj.key}=${typeof obj.value === "string" ? `'${obj.value}'` : obj.value}`;
                }).join(" and "),
                page: "1",
                per_page: "1",
                order_by: "asc"
            };
            return new Promise((resolve, reject)=>{
                this.txSubscribes.set(id, {
                    params: params,
                    resolver: resolve,
                    rejector: reject
                });
                this.sendSubscribeTxRpc(id, params);
            });
        }
    }
    sendSubscribeTxRpc(id, params) {
        if (this.readyState === $0cb17662b61905ec$var$WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: params,
            id: id
        }));
    }
    queryTx(query) {
        if (query instanceof Uint8Array) return this.query("tx", {
            hash: $N0o3H.Buffer.from(query).toString("base64"),
            prove: false
        });
        else {
            const params = {
                query: Object.keys(query).map((key)=>{
                    return {
                        key: key,
                        value: query[key]
                    };
                }).map((obj)=>{
                    return `${obj.key}=${typeof obj.value === "string" ? `'${obj.value}'` : obj.value}`;
                }).join(" and "),
                page: "1",
                per_page: "1",
                order_by: "asc"
            };
            return this.query("tx_search", params);
        }
    }
    query(method, params) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.pendingQueries.set(id, {
                method: method,
                params: params,
                resolver: resolve,
                rejector: reject
            });
            this.sendQueryRpc(id, method, params);
        });
    }
    sendQueryRpc(id, method, params) {
        if (this.readyState === $0cb17662b61905ec$var$WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: method,
            params: params,
            id: id
        }));
    }
    createRandomId() {
        return parseInt(Array.from({
            length: 6
        }).map(()=>Math.floor(Math.random() * 100)).join(""));
    }
}
module.exports.TendermintTxTracer = $0cb17662b61905ec$var$TendermintTxTracer;

});

parcelRegister("82M50", function(module, exports) {
"use strict";
var $5db3ce4aec8291f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5db3ce4aec8291f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5db3ce4aec8291f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5db3ce4aec8291f0$var$__exportStar((parcelRequire("3MSR0")), module.exports);

$5db3ce4aec8291f0$var$__exportStar((parcelRequire("7Mse2")), module.exports);

$5db3ce4aec8291f0$var$__exportStar((parcelRequire("cPeRD")), module.exports);

});
parcelRegister("3MSR0", function(module, exports) {
"use strict";
var $2c20679f379cdb81$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c20679f379cdb81$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2c20679f379cdb81$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultProtoCodec = module.exports.ProtoCodec = void 0;

var $hPDJ8 = parcelRequire("hPDJ8");

var $3UcIe = parcelRequire("3UcIe");

var $f33iS = parcelRequire("f33iS");

var $71CQ5 = parcelRequire("71CQ5");

var $1mq1q = parcelRequire("1mq1q");

var $lkx7P = parcelRequire("lkx7P");

var $lrZui = parcelRequire("lrZui");

var $hp4R2 = parcelRequire("hp4R2");

var $8Qb1r = parcelRequire("8Qb1r");


var $kVVW2 = parcelRequire("kVVW2");

var $dBdH8 = parcelRequire("dBdH8");

var $dqCdR = parcelRequire("dqCdR");

var $fMIv2 = parcelRequire("fMIv2");

var $N0o3H = parcelRequire("N0o3H");

$2c20679f379cdb81$var$__exportStar((parcelRequire("l6vEO")), module.exports);
class $2c20679f379cdb81$var$ProtoCodec {
    constructor(){
        this.typeUrlMap = new Map();
    }
    unpackAnyFactory(typeUrl) {
        if (!this.typeUrlMap.has(typeUrl)) return undefined;
        return this.typeUrlMap.get(typeUrl);
    }
    /**
     * Unpack the any to the registered message.
     * NOTE: If there is no matched message, it will not throw an error but return the `UnknownMessage` class.
     * @param any
     */ unpackAny(any) {
        const factory = this.unpackAnyFactory(any.typeUrl);
        if (!factory) return new (parcelRequire("l6vEO")).UnknownMessage(any.typeUrl, any.value);
        const unpacked = factory.decode(any.value);
        return Object.assign(Object.assign({}, any), {
            unpacked: unpacked
        });
    }
    unpackedAnyToJSONRecursive(unpacked) {
        if (unpacked instanceof (parcelRequire("l6vEO")).UnknownMessage) return unpacked.toJSON();
        const factory = this.unpackAnyFactory(unpacked.typeUrl);
        if (factory && "unpacked" in unpacked && unpacked.unpacked) {
            const isJSONEncodedAny = (any)=>{
                const r = typeof any === "object" && !(any instanceof (parcelRequire("l6vEO")).UnknownMessage) && "typeUrl" in any && any.typeUrl && typeof any.typeUrl === "string" && "value" in any && any.value && typeof any.value === "string";
                if (r) try {
                    $N0o3H.Buffer.from(any.value, "base64");
                } catch (_a) {
                    return false;
                }
                return r;
            };
            const unpackJSONEncodedAnyInner = (jsonEncodedAny)=>{
                const factory = this.unpackAnyFactory(jsonEncodedAny.typeUrl);
                const bz = $N0o3H.Buffer.from(jsonEncodedAny.value, "base64");
                if (!factory) return new (parcelRequire("l6vEO")).UnknownMessage(jsonEncodedAny.typeUrl, bz).toJSON();
                const unpacked = factory.decode(bz);
                return {
                    typeUrl: jsonEncodedAny.typeUrl,
                    value: factory.toJSON(unpacked)
                };
            };
            const unpackedJSONEncodedAnyRecursive = (obj)=>{
                if (Array.isArray(obj)) for(let i = 0; i < obj.length; i++){
                    const value = obj[i];
                    if (isJSONEncodedAny(value)) obj[i] = unpackJSONEncodedAnyInner(value);
                    else if (typeof value === "object") obj[i] = unpackedJSONEncodedAnyRecursive(value);
                }
                else for(const key in obj){
                    const value = obj[key];
                    if (isJSONEncodedAny(value)) obj[key] = unpackJSONEncodedAnyInner(value);
                    else if (typeof value === "object") obj[key] = unpackedJSONEncodedAnyRecursive(value);
                }
                return obj;
            };
            // This is mutated by logic.
            let mutObj = factory.toJSON(unpacked.unpacked);
            if (mutObj && typeof mutObj === "object") {
                mutObj = unpackedJSONEncodedAnyRecursive(mutObj);
                return {
                    typeUrl: unpacked.typeUrl,
                    value: mutObj
                };
            }
        }
        return new (parcelRequire("l6vEO")).UnknownMessage(unpacked.typeUrl, unpacked.value).toJSON();
    }
    registerAny(typeUrl, message) {
        this.typeUrlMap.set(typeUrl, message);
    }
}
module.exports.ProtoCodec = $2c20679f379cdb81$var$ProtoCodec;
module.exports.defaultProtoCodec = new $2c20679f379cdb81$var$ProtoCodec();
module.exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgWalletSpendAction", $hPDJ8.MsgWalletSpendAction);
module.exports.defaultProtoCodec.registerAny("/agoric.swingset.MsgProvision", $hPDJ8.MsgProvision);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgSend", $3UcIe.MsgSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgMultiSend", $3UcIe.MsgMultiSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDelegate", $f33iS.MsgDelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUndelegate", $f33iS.MsgUndelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgBeginRedelegate", $f33iS.MsgBeginRedelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUnbondValidator", $f33iS.MsgUnbondValidator);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgCancelUnbondingDelegation", $f33iS.MsgCancelUnbondingDelegation);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgTokenizeShares", $f33iS.MsgTokenizeShares);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgRedeemTokensForShares", $f33iS.MsgRedeemTokensForShares);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgTransferTokenizeShareRecord", $f33iS.MsgTransferTokenizeShareRecord);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDisableTokenizeShares", $f33iS.MsgDisableTokenizeShares);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgEnableTokenizeShares", $f33iS.MsgEnableTokenizeShares);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgValidatorBond", $f33iS.MsgValidatorBond);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgExecuteContract", $lrZui.MsgExecuteContract);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgInstantiateContract", $lrZui.MsgInstantiateContract);
module.exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward", $lkx7P.MsgWithdrawDelegatorReward);
module.exports.defaultProtoCodec.registerAny("/cosmos.distribution.v1beta1.MsgSetWithdrawAddress", $lkx7P.MsgSetWithdrawAddress);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.transfer.v1.MsgTransfer", $hp4R2.MsgTransfer);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgPayPacketFee", $8Qb1r.MsgPayPacketFee);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgPayPacketFeeAsync", $8Qb1r.MsgPayPacketFeeAsync);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgRegisterPayee", $8Qb1r.MsgRegisterPayee);
module.exports.defaultProtoCodec.registerAny("/ibc.applications.fee.v1.MsgRegisterCounterpartyPayee", $8Qb1r.MsgRegisterCounterpartyPayee);
module.exports.defaultProtoCodec.registerAny("/cosmos.gov.v1beta1.MsgVote", $1mq1q.MsgVote);
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgGrant", $71CQ5.MsgGrant);
// ----- Authz grants -----
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.GenericAuthorization", $kVVW2.GenericAuthorization);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.StakeAuthorization", $dBdH8.StakeAuthorization);
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.SendAuthorization", $dqCdR.SendAuthorization);
// ----- Authz grants -----
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgRevoke", $71CQ5.MsgRevoke);
module.exports.defaultProtoCodec.registerAny("/cosmos.authz.v1beta1.MsgExec", $71CQ5.MsgExec);
// Stride
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgLiquidStake", $fMIv2.MsgLiquidStake);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgLSMLiquidStake", $fMIv2.MsgLSMLiquidStake);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRedeemStake", $fMIv2.MsgRedeemStake);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRegisterHostZone", $fMIv2.MsgRegisterHostZone);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgClaimUndelegatedTokens", $fMIv2.MsgClaimUndelegatedTokens);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRebalanceValidators", $fMIv2.MsgRebalanceValidators);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgAddValidators", $fMIv2.MsgAddValidators);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgChangeValidatorWeight", $fMIv2.MsgChangeValidatorWeight);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgDeleteValidator", $fMIv2.MsgDeleteValidator);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgRestoreInterchainAccount", $fMIv2.MsgRestoreInterchainAccount);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUpdateValidatorSharesExchRate", $fMIv2.MsgUpdateValidatorSharesExchRate);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgCalibrateDelegation", $fMIv2.MsgCalibrateDelegation);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgClearBalance", $fMIv2.MsgClearBalance);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUndelegateHost", $fMIv2.MsgUndelegateHost);
module.exports.defaultProtoCodec.registerAny("/stride.stakeibc.MsgUpdateInnerRedemptionRateBounds", $fMIv2.MsgUpdateInnerRedemptionRateBounds);

});
parcelRegister("hPDJ8", function(module, exports) {
"use strict";
var $cfb6040c865d6d4b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgInstallBundleResponse = module.exports.MsgInstallBundle = module.exports.MsgProvisionResponse = module.exports.MsgProvision = module.exports.MsgWalletSpendActionResponse = module.exports.MsgWalletSpendAction = module.exports.MsgWalletActionResponse = module.exports.MsgWalletAction = module.exports.MsgDeliverInboundResponse = module.exports.MsgDeliverInbound = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $cfb6040c865d6d4b$var$long_1 = $cfb6040c865d6d4b$var$__importDefault((parcelRequire("3gmZQ")));

const $cfb6040c865d6d4b$var$minimal_1 = $cfb6040c865d6d4b$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "agoric.swingset";
function $cfb6040c865d6d4b$var$createBaseMsgDeliverInbound() {
    return {
        messages: [],
        nums: [],
        ack: "0",
        submitter: new Uint8Array()
    };
}
module.exports.MsgDeliverInbound = {
    encode (message, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)writer.uint32(10).string(v);
        writer.uint32(18).fork();
        for (const v of message.nums)writer.uint64(v);
        writer.ldelim();
        if (message.ack !== "0") writer.uint32(24).uint64(message.ack);
        if (message.submitter.length !== 0) writer.uint32(34).bytes(message.submitter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgDeliverInbound();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push(reader.string());
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.nums.push($cfb6040c865d6d4b$var$longToString(reader.uint64()));
                    } else message.nums.push($cfb6040c865d6d4b$var$longToString(reader.uint64()));
                    break;
                case 3:
                    message.ack = $cfb6040c865d6d4b$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.submitter = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map((e)=>String(e)) : [],
            nums: Array.isArray(object === null || object === void 0 ? void 0 : object.nums) ? object.nums.map((e)=>String(e)) : [],
            ack: $cfb6040c865d6d4b$var$isSet(object.ack) ? String(object.ack) : "0",
            submitter: $cfb6040c865d6d4b$var$isSet(object.submitter) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.submitter) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e);
        else obj.messages = [];
        if (message.nums) obj.nums = message.nums.map((e)=>e);
        else obj.nums = [];
        message.ack !== undefined && (obj.ack = message.ack);
        message.submitter !== undefined && (obj.submitter = $cfb6040c865d6d4b$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $cfb6040c865d6d4b$var$createBaseMsgDeliverInbound();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        message.nums = ((_b = object.nums) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        message.ack = (_c = object.ack) !== null && _c !== void 0 ? _c : "0";
        message.submitter = (_d = object.submitter) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgDeliverInboundResponse() {
    return {};
}
module.exports.MsgDeliverInboundResponse = {
    encode (_, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgDeliverInboundResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cfb6040c865d6d4b$var$createBaseMsgDeliverInboundResponse();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgWalletAction() {
    return {
        owner: new Uint8Array(),
        action: ""
    };
}
module.exports.MsgWalletAction = {
    encode (message, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        if (message.owner.length !== 0) writer.uint32(10).bytes(message.owner);
        if (message.action !== "") writer.uint32(18).string(message.action);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletAction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.owner = reader.bytes();
                    break;
                case 2:
                    message.action = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            owner: $cfb6040c865d6d4b$var$isSet(object.owner) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.owner) : new Uint8Array(),
            action: $cfb6040c865d6d4b$var$isSet(object.action) ? String(object.action) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = $cfb6040c865d6d4b$var$base64FromBytes(message.owner !== undefined ? message.owner : new Uint8Array()));
        message.action !== undefined && (obj.action = message.action);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletAction();
        message.owner = (_a = object.owner) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.action = (_b = object.action) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgWalletActionResponse() {
    return {};
}
module.exports.MsgWalletActionResponse = {
    encode (_, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletActionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletActionResponse();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgWalletSpendAction() {
    return {
        owner: new Uint8Array(),
        spendAction: ""
    };
}
module.exports.MsgWalletSpendAction = {
    encode (message, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        if (message.owner.length !== 0) writer.uint32(10).bytes(message.owner);
        if (message.spendAction !== "") writer.uint32(18).string(message.spendAction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletSpendAction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.owner = reader.bytes();
                    break;
                case 2:
                    message.spendAction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            owner: $cfb6040c865d6d4b$var$isSet(object.owner) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.owner) : new Uint8Array(),
            spendAction: $cfb6040c865d6d4b$var$isSet(object.spendAction) ? String(object.spendAction) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.owner !== undefined && (obj.owner = $cfb6040c865d6d4b$var$base64FromBytes(message.owner !== undefined ? message.owner : new Uint8Array()));
        message.spendAction !== undefined && (obj.spendAction = message.spendAction);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletSpendAction();
        message.owner = (_a = object.owner) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.spendAction = (_b = object.spendAction) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgWalletSpendActionResponse() {
    return {};
}
module.exports.MsgWalletSpendActionResponse = {
    encode (_, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletSpendActionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cfb6040c865d6d4b$var$createBaseMsgWalletSpendActionResponse();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgProvision() {
    return {
        nickname: "",
        address: new Uint8Array(),
        powerFlags: [],
        submitter: new Uint8Array()
    };
}
module.exports.MsgProvision = {
    encode (message, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        if (message.nickname !== "") writer.uint32(10).string(message.nickname);
        if (message.address.length !== 0) writer.uint32(18).bytes(message.address);
        for (const v of message.powerFlags)writer.uint32(26).string(v);
        if (message.submitter.length !== 0) writer.uint32(34).bytes(message.submitter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgProvision();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nickname = reader.string();
                    break;
                case 2:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.powerFlags.push(reader.string());
                    break;
                case 4:
                    message.submitter = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nickname: $cfb6040c865d6d4b$var$isSet(object.nickname) ? String(object.nickname) : "",
            address: $cfb6040c865d6d4b$var$isSet(object.address) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.address) : new Uint8Array(),
            powerFlags: Array.isArray(object === null || object === void 0 ? void 0 : object.powerFlags) ? object.powerFlags.map((e)=>String(e)) : [],
            submitter: $cfb6040c865d6d4b$var$isSet(object.submitter) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.submitter) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.nickname !== undefined && (obj.nickname = message.nickname);
        message.address !== undefined && (obj.address = $cfb6040c865d6d4b$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        if (message.powerFlags) obj.powerFlags = message.powerFlags.map((e)=>e);
        else obj.powerFlags = [];
        message.submitter !== undefined && (obj.submitter = $cfb6040c865d6d4b$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $cfb6040c865d6d4b$var$createBaseMsgProvision();
        message.nickname = (_a = object.nickname) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.powerFlags = ((_c = object.powerFlags) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.submitter = (_d = object.submitter) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgProvisionResponse() {
    return {};
}
module.exports.MsgProvisionResponse = {
    encode (_, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgProvisionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cfb6040c865d6d4b$var$createBaseMsgProvisionResponse();
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgInstallBundle() {
    return {
        bundle: "",
        submitter: new Uint8Array(),
        compressedBundle: new Uint8Array(),
        uncompressedSize: "0"
    };
}
module.exports.MsgInstallBundle = {
    encode (message, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        if (message.bundle !== "") writer.uint32(10).string(message.bundle);
        if (message.submitter.length !== 0) writer.uint32(18).bytes(message.submitter);
        if (message.compressedBundle.length !== 0) writer.uint32(26).bytes(message.compressedBundle);
        if (message.uncompressedSize !== "0") writer.uint32(32).int64(message.uncompressedSize);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgInstallBundle();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bundle = reader.string();
                    break;
                case 2:
                    message.submitter = reader.bytes();
                    break;
                case 3:
                    message.compressedBundle = reader.bytes();
                    break;
                case 4:
                    message.uncompressedSize = $cfb6040c865d6d4b$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bundle: $cfb6040c865d6d4b$var$isSet(object.bundle) ? String(object.bundle) : "",
            submitter: $cfb6040c865d6d4b$var$isSet(object.submitter) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.submitter) : new Uint8Array(),
            compressedBundle: $cfb6040c865d6d4b$var$isSet(object.compressedBundle) ? $cfb6040c865d6d4b$var$bytesFromBase64(object.compressedBundle) : new Uint8Array(),
            uncompressedSize: $cfb6040c865d6d4b$var$isSet(object.uncompressedSize) ? String(object.uncompressedSize) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.bundle !== undefined && (obj.bundle = message.bundle);
        message.submitter !== undefined && (obj.submitter = $cfb6040c865d6d4b$var$base64FromBytes(message.submitter !== undefined ? message.submitter : new Uint8Array()));
        message.compressedBundle !== undefined && (obj.compressedBundle = $cfb6040c865d6d4b$var$base64FromBytes(message.compressedBundle !== undefined ? message.compressedBundle : new Uint8Array()));
        message.uncompressedSize !== undefined && (obj.uncompressedSize = message.uncompressedSize);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $cfb6040c865d6d4b$var$createBaseMsgInstallBundle();
        message.bundle = (_a = object.bundle) !== null && _a !== void 0 ? _a : "";
        message.submitter = (_b = object.submitter) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.compressedBundle = (_c = object.compressedBundle) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.uncompressedSize = (_d = object.uncompressedSize) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $cfb6040c865d6d4b$var$createBaseMsgInstallBundleResponse() {
    return {};
}
module.exports.MsgInstallBundleResponse = {
    encode (_, writer = $cfb6040c865d6d4b$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cfb6040c865d6d4b$var$minimal_1.default.Reader ? input : new $cfb6040c865d6d4b$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cfb6040c865d6d4b$var$createBaseMsgInstallBundleResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cfb6040c865d6d4b$var$createBaseMsgInstallBundleResponse();
        return message;
    }
};
var $cfb6040c865d6d4b$var$globalThis = (()=>{
    if (typeof $cfb6040c865d6d4b$var$globalThis !== "undefined") return $cfb6040c865d6d4b$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $cfb6040c865d6d4b$var$atob = $cfb6040c865d6d4b$var$globalThis.atob || ((b64)=>$cfb6040c865d6d4b$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $cfb6040c865d6d4b$var$bytesFromBase64(b64) {
    const bin = $cfb6040c865d6d4b$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $cfb6040c865d6d4b$var$btoa = $cfb6040c865d6d4b$var$globalThis.btoa || ((bin)=>$cfb6040c865d6d4b$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $cfb6040c865d6d4b$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $cfb6040c865d6d4b$var$btoa(bin.join(""));
}
function $cfb6040c865d6d4b$var$longToString(long) {
    return long.toString();
}
if ($cfb6040c865d6d4b$var$minimal_1.default.util.Long !== $cfb6040c865d6d4b$var$long_1.default) {
    $cfb6040c865d6d4b$var$minimal_1.default.util.Long = $cfb6040c865d6d4b$var$long_1.default;
    $cfb6040c865d6d4b$var$minimal_1.default.configure();
}
function $cfb6040c865d6d4b$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("3gmZQ", function(module, exports) {
module.exports = $2604b4554a1ada3e$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $2604b4554a1ada3e$var$wasm = null;
try {
    $2604b4554a1ada3e$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $2604b4554a1ada3e$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $2604b4554a1ada3e$var$Long.prototype.__isLong__;
Object.defineProperty($2604b4554a1ada3e$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $2604b4554a1ada3e$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$Long.isLong = $2604b4554a1ada3e$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $2604b4554a1ada3e$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $2604b4554a1ada3e$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $2604b4554a1ada3e$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $2604b4554a1ada3e$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $2604b4554a1ada3e$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $2604b4554a1ada3e$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $2604b4554a1ada3e$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $2604b4554a1ada3e$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $2604b4554a1ada3e$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromInt = $2604b4554a1ada3e$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $2604b4554a1ada3e$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $2604b4554a1ada3e$var$UZERO : $2604b4554a1ada3e$var$ZERO;
    if (unsigned) {
        if (value < 0) return $2604b4554a1ada3e$var$UZERO;
        if (value >= $2604b4554a1ada3e$var$TWO_PWR_64_DBL) return $2604b4554a1ada3e$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$2604b4554a1ada3e$var$TWO_PWR_63_DBL) return $2604b4554a1ada3e$var$MIN_VALUE;
        if (value + 1 >= $2604b4554a1ada3e$var$TWO_PWR_63_DBL) return $2604b4554a1ada3e$var$MAX_VALUE;
    }
    if (value < 0) return $2604b4554a1ada3e$var$fromNumber(-value, unsigned).neg();
    return $2604b4554a1ada3e$var$fromBits(value % $2604b4554a1ada3e$var$TWO_PWR_32_DBL | 0, value / $2604b4554a1ada3e$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromNumber = $2604b4554a1ada3e$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $2604b4554a1ada3e$var$fromBits(lowBits, highBits, unsigned) {
    return new $2604b4554a1ada3e$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromBits = $2604b4554a1ada3e$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $2604b4554a1ada3e$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $2604b4554a1ada3e$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $2604b4554a1ada3e$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $2604b4554a1ada3e$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $2604b4554a1ada3e$var$fromNumber($2604b4554a1ada3e$var$pow_dbl(radix, 8));
    var result = $2604b4554a1ada3e$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $2604b4554a1ada3e$var$fromNumber($2604b4554a1ada3e$var$pow_dbl(radix, size));
            result = result.mul(power).add($2604b4554a1ada3e$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($2604b4554a1ada3e$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromString = $2604b4554a1ada3e$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $2604b4554a1ada3e$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $2604b4554a1ada3e$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $2604b4554a1ada3e$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $2604b4554a1ada3e$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $2604b4554a1ada3e$var$Long.fromValue = $2604b4554a1ada3e$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_32_DBL = $2604b4554a1ada3e$var$TWO_PWR_16_DBL * $2604b4554a1ada3e$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_64_DBL = $2604b4554a1ada3e$var$TWO_PWR_32_DBL * $2604b4554a1ada3e$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_63_DBL = $2604b4554a1ada3e$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $2604b4554a1ada3e$var$TWO_PWR_24 = $2604b4554a1ada3e$var$fromInt($2604b4554a1ada3e$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$ZERO = $2604b4554a1ada3e$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.ZERO = $2604b4554a1ada3e$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$UZERO = $2604b4554a1ada3e$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.UZERO = $2604b4554a1ada3e$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$ONE = $2604b4554a1ada3e$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.ONE = $2604b4554a1ada3e$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$UONE = $2604b4554a1ada3e$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.UONE = $2604b4554a1ada3e$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$NEG_ONE = $2604b4554a1ada3e$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.NEG_ONE = $2604b4554a1ada3e$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$MAX_VALUE = $2604b4554a1ada3e$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.MAX_VALUE = $2604b4554a1ada3e$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$MAX_UNSIGNED_VALUE = $2604b4554a1ada3e$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.MAX_UNSIGNED_VALUE = $2604b4554a1ada3e$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $2604b4554a1ada3e$var$MIN_VALUE = $2604b4554a1ada3e$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $2604b4554a1ada3e$var$Long.MIN_VALUE = $2604b4554a1ada3e$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $2604b4554a1ada3e$var$LongPrototype = $2604b4554a1ada3e$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $2604b4554a1ada3e$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $2604b4554a1ada3e$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $2604b4554a1ada3e$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $2604b4554a1ada3e$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $2604b4554a1ada3e$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($2604b4554a1ada3e$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $2604b4554a1ada3e$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $2604b4554a1ada3e$var$fromNumber($2604b4554a1ada3e$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $2604b4554a1ada3e$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $2604b4554a1ada3e$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $2604b4554a1ada3e$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $2604b4554a1ada3e$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $2604b4554a1ada3e$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($2604b4554a1ada3e$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.eqz = $2604b4554a1ada3e$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.equals = function equals(other) {
    if (!$2604b4554a1ada3e$var$isLong(other)) other = $2604b4554a1ada3e$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.eq = $2604b4554a1ada3e$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.neq = $2604b4554a1ada3e$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.ne = $2604b4554a1ada3e$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.lt = $2604b4554a1ada3e$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.lte = $2604b4554a1ada3e$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.le = $2604b4554a1ada3e$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.gt = $2604b4554a1ada3e$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.gte = $2604b4554a1ada3e$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $2604b4554a1ada3e$var$LongPrototype.ge = $2604b4554a1ada3e$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $2604b4554a1ada3e$var$LongPrototype.compare = function compare(other) {
    if (!$2604b4554a1ada3e$var$isLong(other)) other = $2604b4554a1ada3e$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $2604b4554a1ada3e$var$LongPrototype.comp = $2604b4554a1ada3e$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $2604b4554a1ada3e$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($2604b4554a1ada3e$var$MIN_VALUE)) return $2604b4554a1ada3e$var$MIN_VALUE;
    return this.not().add($2604b4554a1ada3e$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $2604b4554a1ada3e$var$LongPrototype.neg = $2604b4554a1ada3e$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $2604b4554a1ada3e$var$LongPrototype.add = function add(addend) {
    if (!$2604b4554a1ada3e$var$isLong(addend)) addend = $2604b4554a1ada3e$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $2604b4554a1ada3e$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $2604b4554a1ada3e$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$2604b4554a1ada3e$var$isLong(subtrahend)) subtrahend = $2604b4554a1ada3e$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $2604b4554a1ada3e$var$LongPrototype.sub = $2604b4554a1ada3e$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $2604b4554a1ada3e$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $2604b4554a1ada3e$var$ZERO;
    if (!$2604b4554a1ada3e$var$isLong(multiplier)) multiplier = $2604b4554a1ada3e$var$fromValue(multiplier);
    // use wasm support if present
    if ($2604b4554a1ada3e$var$wasm) {
        var low = $2604b4554a1ada3e$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $2604b4554a1ada3e$var$fromBits(low, $2604b4554a1ada3e$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $2604b4554a1ada3e$var$ZERO;
    if (this.eq($2604b4554a1ada3e$var$MIN_VALUE)) return multiplier.isOdd() ? $2604b4554a1ada3e$var$MIN_VALUE : $2604b4554a1ada3e$var$ZERO;
    if (multiplier.eq($2604b4554a1ada3e$var$MIN_VALUE)) return this.isOdd() ? $2604b4554a1ada3e$var$MIN_VALUE : $2604b4554a1ada3e$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($2604b4554a1ada3e$var$TWO_PWR_24) && multiplier.lt($2604b4554a1ada3e$var$TWO_PWR_24)) return $2604b4554a1ada3e$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $2604b4554a1ada3e$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $2604b4554a1ada3e$var$LongPrototype.mul = $2604b4554a1ada3e$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $2604b4554a1ada3e$var$LongPrototype.divide = function divide(divisor) {
    if (!$2604b4554a1ada3e$var$isLong(divisor)) divisor = $2604b4554a1ada3e$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($2604b4554a1ada3e$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $2604b4554a1ada3e$var$wasm.div_u : $2604b4554a1ada3e$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $2604b4554a1ada3e$var$fromBits(low, $2604b4554a1ada3e$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $2604b4554a1ada3e$var$UZERO : $2604b4554a1ada3e$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($2604b4554a1ada3e$var$MIN_VALUE)) {
            if (divisor.eq($2604b4554a1ada3e$var$ONE) || divisor.eq($2604b4554a1ada3e$var$NEG_ONE)) return $2604b4554a1ada3e$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($2604b4554a1ada3e$var$MIN_VALUE)) return $2604b4554a1ada3e$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($2604b4554a1ada3e$var$ZERO)) return divisor.isNegative() ? $2604b4554a1ada3e$var$ONE : $2604b4554a1ada3e$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($2604b4554a1ada3e$var$MIN_VALUE)) return this.unsigned ? $2604b4554a1ada3e$var$UZERO : $2604b4554a1ada3e$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $2604b4554a1ada3e$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $2604b4554a1ada3e$var$UZERO;
        if (divisor.gt(this.shru(1))) return $2604b4554a1ada3e$var$UONE;
        res = $2604b4554a1ada3e$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $2604b4554a1ada3e$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $2604b4554a1ada3e$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $2604b4554a1ada3e$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $2604b4554a1ada3e$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $2604b4554a1ada3e$var$LongPrototype.div = $2604b4554a1ada3e$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $2604b4554a1ada3e$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$2604b4554a1ada3e$var$isLong(divisor)) divisor = $2604b4554a1ada3e$var$fromValue(divisor);
    // use wasm support if present
    if ($2604b4554a1ada3e$var$wasm) {
        var low = (this.unsigned ? $2604b4554a1ada3e$var$wasm.rem_u : $2604b4554a1ada3e$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $2604b4554a1ada3e$var$fromBits(low, $2604b4554a1ada3e$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $2604b4554a1ada3e$var$LongPrototype.mod = $2604b4554a1ada3e$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $2604b4554a1ada3e$var$LongPrototype.rem = $2604b4554a1ada3e$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $2604b4554a1ada3e$var$LongPrototype.not = function not() {
    return $2604b4554a1ada3e$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $2604b4554a1ada3e$var$LongPrototype.and = function and(other) {
    if (!$2604b4554a1ada3e$var$isLong(other)) other = $2604b4554a1ada3e$var$fromValue(other);
    return $2604b4554a1ada3e$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $2604b4554a1ada3e$var$LongPrototype.or = function or(other) {
    if (!$2604b4554a1ada3e$var$isLong(other)) other = $2604b4554a1ada3e$var$fromValue(other);
    return $2604b4554a1ada3e$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $2604b4554a1ada3e$var$LongPrototype.xor = function xor(other) {
    if (!$2604b4554a1ada3e$var$isLong(other)) other = $2604b4554a1ada3e$var$fromValue(other);
    return $2604b4554a1ada3e$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($2604b4554a1ada3e$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $2604b4554a1ada3e$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $2604b4554a1ada3e$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shl = $2604b4554a1ada3e$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($2604b4554a1ada3e$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $2604b4554a1ada3e$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $2604b4554a1ada3e$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shr = $2604b4554a1ada3e$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($2604b4554a1ada3e$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $2604b4554a1ada3e$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $2604b4554a1ada3e$var$fromBits(high, 0, this.unsigned);
        else return $2604b4554a1ada3e$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shru = $2604b4554a1ada3e$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $2604b4554a1ada3e$var$LongPrototype.shr_u = $2604b4554a1ada3e$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $2604b4554a1ada3e$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $2604b4554a1ada3e$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $2604b4554a1ada3e$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $2604b4554a1ada3e$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $2604b4554a1ada3e$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $2604b4554a1ada3e$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $2604b4554a1ada3e$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $2604b4554a1ada3e$var$Long.fromBytesLE(bytes, unsigned) : $2604b4554a1ada3e$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $2604b4554a1ada3e$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $2604b4554a1ada3e$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $2604b4554a1ada3e$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("1wC51", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("4SNyn"));

});
parcelRegister("4SNyn", function(module, exports) {
"use strict";
var $38e2a4dde4ee0499$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $38e2a4dde4ee0499$var$protobuf.build = "minimal";

// Serialization
$38e2a4dde4ee0499$var$protobuf.Writer = (parcelRequire("88LXr"));

$38e2a4dde4ee0499$var$protobuf.BufferWriter = (parcelRequire("g2Ye1"));

$38e2a4dde4ee0499$var$protobuf.Reader = (parcelRequire("b99Vw"));

$38e2a4dde4ee0499$var$protobuf.BufferReader = (parcelRequire("jVqnn"));

// Utility
$38e2a4dde4ee0499$var$protobuf.util = (parcelRequire("ikeUa"));

$38e2a4dde4ee0499$var$protobuf.rpc = (parcelRequire("joEbz"));

$38e2a4dde4ee0499$var$protobuf.roots = (parcelRequire("5y7CW"));
$38e2a4dde4ee0499$var$protobuf.configure = $38e2a4dde4ee0499$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $38e2a4dde4ee0499$var$configure() {
    $38e2a4dde4ee0499$var$protobuf.util._configure();
    $38e2a4dde4ee0499$var$protobuf.Writer._configure($38e2a4dde4ee0499$var$protobuf.BufferWriter);
    $38e2a4dde4ee0499$var$protobuf.Reader._configure($38e2a4dde4ee0499$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$38e2a4dde4ee0499$var$configure();

});
parcelRegister("88LXr", function(module, exports) {
"use strict";
module.exports = $5ed44579040d469c$var$Writer;

var $ikeUa = parcelRequire("ikeUa");
var $5ed44579040d469c$var$BufferWriter; // cyclic
var $5ed44579040d469c$var$LongBits = $ikeUa.LongBits, $5ed44579040d469c$var$base64 = $ikeUa.base64, $5ed44579040d469c$var$utf8 = $ikeUa.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $5ed44579040d469c$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $5ed44579040d469c$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $5ed44579040d469c$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $5ed44579040d469c$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $5ed44579040d469c$var$Op($5ed44579040d469c$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $5ed44579040d469c$var$create = function create() {
    return $ikeUa.Buffer ? function create_buffer_setup() {
        return ($5ed44579040d469c$var$Writer.create = function create_buffer() {
            return new $5ed44579040d469c$var$BufferWriter();
        })();
    } : function create_array() {
        return new $5ed44579040d469c$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $5ed44579040d469c$var$Writer.create = $5ed44579040d469c$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $5ed44579040d469c$var$Writer.alloc = function alloc(size) {
    return new $ikeUa.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($ikeUa.Array !== Array) $5ed44579040d469c$var$Writer.alloc = $ikeUa.pool($5ed44579040d469c$var$Writer.alloc, $ikeUa.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $5ed44579040d469c$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $5ed44579040d469c$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $5ed44579040d469c$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $5ed44579040d469c$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $5ed44579040d469c$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$5ed44579040d469c$var$VarintOp.prototype = Object.create($5ed44579040d469c$var$Op.prototype);
$5ed44579040d469c$var$VarintOp.prototype.fn = $5ed44579040d469c$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $5ed44579040d469c$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($5ed44579040d469c$var$writeVarint64, 10, $5ed44579040d469c$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $5ed44579040d469c$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $5ed44579040d469c$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $5ed44579040d469c$var$LongBits.from(value);
    return this._push($5ed44579040d469c$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $5ed44579040d469c$var$Writer.prototype.int64 = $5ed44579040d469c$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $5ed44579040d469c$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $5ed44579040d469c$var$LongBits.from(value).zzEncode();
    return this._push($5ed44579040d469c$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($5ed44579040d469c$var$writeByte, 1, value ? 1 : 0);
};
function $5ed44579040d469c$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($5ed44579040d469c$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.sfixed32 = $5ed44579040d469c$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $5ed44579040d469c$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $5ed44579040d469c$var$LongBits.from(value);
    return this._push($5ed44579040d469c$var$writeFixed32, 4, bits.lo)._push($5ed44579040d469c$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $5ed44579040d469c$var$Writer.prototype.sfixed64 = $5ed44579040d469c$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.float = function write_float(value) {
    return this._push($ikeUa.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.double = function write_double(value) {
    return this._push($ikeUa.float.writeDoubleLE, 8, value);
};
var $5ed44579040d469c$var$writeBytes = $ikeUa.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($5ed44579040d469c$var$writeByte, 1, 0);
    if ($ikeUa.isString(value)) {
        var buf = $5ed44579040d469c$var$Writer.alloc(len = $5ed44579040d469c$var$base64.length(value));
        $5ed44579040d469c$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($5ed44579040d469c$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.string = function write_string(value) {
    var len = $5ed44579040d469c$var$utf8.length(value);
    return len ? this.uint32(len)._push($5ed44579040d469c$var$utf8.write, len, value) : this._push($5ed44579040d469c$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.fork = function fork() {
    this.states = new $5ed44579040d469c$var$State(this);
    this.head = this.tail = new $5ed44579040d469c$var$Op($5ed44579040d469c$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $5ed44579040d469c$var$Op($5ed44579040d469c$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $5ed44579040d469c$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $5ed44579040d469c$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$5ed44579040d469c$var$Writer._configure = function(BufferWriter_) {
    $5ed44579040d469c$var$BufferWriter = BufferWriter_;
    $5ed44579040d469c$var$Writer.create = $5ed44579040d469c$var$create();
    $5ed44579040d469c$var$BufferWriter._configure();
};

});
parcelRegister("ikeUa", function(module, exports) {
"use strict";
var $d575a8098c78aed2$var$util = module.exports;

// used to return a Promise where callback is omitted
$d575a8098c78aed2$var$util.asPromise = (parcelRequire("ec8ee"));

// converts to / from base64 encoded strings
$d575a8098c78aed2$var$util.base64 = (parcelRequire("lJUiy"));

// base class of rpc.Service
$d575a8098c78aed2$var$util.EventEmitter = (parcelRequire("4QLVt"));

// float handling accross browsers
$d575a8098c78aed2$var$util.float = (parcelRequire("istuG"));

// requires modules optionally and hides the call from bundlers
$d575a8098c78aed2$var$util.inquire = (parcelRequire("d8YM7"));

// converts to / from utf8 encoded strings
$d575a8098c78aed2$var$util.utf8 = (parcelRequire("57d1e"));

// provides a node-like buffer pool in the browser
$d575a8098c78aed2$var$util.pool = (parcelRequire("ggssu"));

// utility to work with the low and high bits of a 64 bit value
$d575a8098c78aed2$var$util.LongBits = (parcelRequire("cXOSa"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $d575a8098c78aed2$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $d575a8098c78aed2$var$util.global = $d575a8098c78aed2$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $d575a8098c78aed2$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $d575a8098c78aed2$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $d575a8098c78aed2$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $d575a8098c78aed2$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $d575a8098c78aed2$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d575a8098c78aed2$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $d575a8098c78aed2$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $d575a8098c78aed2$var$util.Buffer = function() {
    try {
        var Buffer = $d575a8098c78aed2$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$d575a8098c78aed2$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$d575a8098c78aed2$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $d575a8098c78aed2$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $d575a8098c78aed2$var$util.Buffer ? $d575a8098c78aed2$var$util._Buffer_allocUnsafe(sizeOrArray) : new $d575a8098c78aed2$var$util.Array(sizeOrArray) : $d575a8098c78aed2$var$util.Buffer ? $d575a8098c78aed2$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $d575a8098c78aed2$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $d575a8098c78aed2$var$util.Long = /* istanbul ignore next */ $d575a8098c78aed2$var$util.global.dcodeIO && /* istanbul ignore next */ $d575a8098c78aed2$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $d575a8098c78aed2$var$util.global.Long || $d575a8098c78aed2$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $d575a8098c78aed2$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d575a8098c78aed2$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $d575a8098c78aed2$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $d575a8098c78aed2$var$util.longToHash = function longToHash(value) {
    return value ? $d575a8098c78aed2$var$util.LongBits.from(value).toHash() : $d575a8098c78aed2$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $d575a8098c78aed2$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $d575a8098c78aed2$var$util.LongBits.fromHash(hash);
    if ($d575a8098c78aed2$var$util.Long) return $d575a8098c78aed2$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $d575a8098c78aed2$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$d575a8098c78aed2$var$util.merge = $d575a8098c78aed2$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $d575a8098c78aed2$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $d575a8098c78aed2$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $d575a8098c78aed2$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$d575a8098c78aed2$var$util.newError = $d575a8098c78aed2$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $d575a8098c78aed2$var$util.ProtocolError = $d575a8098c78aed2$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $d575a8098c78aed2$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $d575a8098c78aed2$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $d575a8098c78aed2$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$d575a8098c78aed2$var$util._configure = function() {
    var Buffer = $d575a8098c78aed2$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $d575a8098c78aed2$var$util._Buffer_from = $d575a8098c78aed2$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $d575a8098c78aed2$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $d575a8098c78aed2$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRegister("ec8ee", function(module, exports) {
"use strict";
module.exports = $a55891add83f8a0b$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $a55891add83f8a0b$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRegister("lJUiy", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $fd39789d30184a4f$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $fd39789d30184a4f$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $fd39789d30184a4f$var$b64 = new Array(64);
// Base64 decoding table
var $fd39789d30184a4f$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $fd39789d30184a4f$var$i = 0; $fd39789d30184a4f$var$i < 64;)$fd39789d30184a4f$var$s64[$fd39789d30184a4f$var$b64[$fd39789d30184a4f$var$i] = $fd39789d30184a4f$var$i < 26 ? $fd39789d30184a4f$var$i + 65 : $fd39789d30184a4f$var$i < 52 ? $fd39789d30184a4f$var$i + 71 : $fd39789d30184a4f$var$i < 62 ? $fd39789d30184a4f$var$i - 4 : $fd39789d30184a4f$var$i - 59 | 43] = $fd39789d30184a4f$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $fd39789d30184a4f$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $fd39789d30184a4f$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $fd39789d30184a4f$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $fd39789d30184a4f$var$b64[t | b >> 6];
                chunk[i++] = $fd39789d30184a4f$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $fd39789d30184a4f$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $fd39789d30184a4f$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $fd39789d30184a4f$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $fd39789d30184a4f$var$s64[c]) === undefined) throw Error($fd39789d30184a4f$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($fd39789d30184a4f$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $fd39789d30184a4f$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRegister("4QLVt", function(module, exports) {
"use strict";
module.exports = $388131de7bf4eeda$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $388131de7bf4eeda$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $388131de7bf4eeda$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $388131de7bf4eeda$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $388131de7bf4eeda$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRegister("istuG", function(module, exports) {
"use strict";
module.exports = $d701b86ac16e2164$var$factory($d701b86ac16e2164$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $d701b86ac16e2164$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $d701b86ac16e2164$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $d701b86ac16e2164$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $d701b86ac16e2164$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $d701b86ac16e2164$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $d701b86ac16e2164$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $d701b86ac16e2164$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $d701b86ac16e2164$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $d701b86ac16e2164$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $d701b86ac16e2164$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $d701b86ac16e2164$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $d701b86ac16e2164$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $d701b86ac16e2164$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRegister("d8YM7", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRegister("57d1e", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $3b97b47da65ff101$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $3b97b47da65ff101$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $3b97b47da65ff101$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $3b97b47da65ff101$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRegister("ggssu", function(module, exports) {
"use strict";
module.exports = $bd743741c966abc2$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $bd743741c966abc2$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRegister("cXOSa", function(module, exports) {
"use strict";
module.exports = $970274f6a1a530bf$var$LongBits;

var $ikeUa = parcelRequire("ikeUa");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $970274f6a1a530bf$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $970274f6a1a530bf$var$zero = $970274f6a1a530bf$var$LongBits.zero = new $970274f6a1a530bf$var$LongBits(0, 0);
$970274f6a1a530bf$var$zero.toNumber = function() {
    return 0;
};
$970274f6a1a530bf$var$zero.zzEncode = $970274f6a1a530bf$var$zero.zzDecode = function() {
    return this;
};
$970274f6a1a530bf$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $970274f6a1a530bf$var$zeroHash = $970274f6a1a530bf$var$LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $970274f6a1a530bf$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $970274f6a1a530bf$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $970274f6a1a530bf$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $970274f6a1a530bf$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $970274f6a1a530bf$var$LongBits.fromNumber(value);
    if ($ikeUa.isString(value)) {
        /* istanbul ignore else */ if ($ikeUa.Long) value = $ikeUa.Long.fromString(value);
        else return $970274f6a1a530bf$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $970274f6a1a530bf$var$LongBits(value.low >>> 0, value.high >>> 0) : $970274f6a1a530bf$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $970274f6a1a530bf$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $970274f6a1a530bf$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $ikeUa.Long ? new $ikeUa.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $970274f6a1a530bf$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $970274f6a1a530bf$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $970274f6a1a530bf$var$zeroHash) return $970274f6a1a530bf$var$zero;
    return new $970274f6a1a530bf$var$LongBits(($970274f6a1a530bf$var$charCodeAt.call(hash, 0) | $970274f6a1a530bf$var$charCodeAt.call(hash, 1) << 8 | $970274f6a1a530bf$var$charCodeAt.call(hash, 2) << 16 | $970274f6a1a530bf$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($970274f6a1a530bf$var$charCodeAt.call(hash, 4) | $970274f6a1a530bf$var$charCodeAt.call(hash, 5) << 8 | $970274f6a1a530bf$var$charCodeAt.call(hash, 6) << 16 | $970274f6a1a530bf$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $970274f6a1a530bf$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $970274f6a1a530bf$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $970274f6a1a530bf$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $970274f6a1a530bf$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRegister("g2Ye1", function(module, exports) {
"use strict";
module.exports = $baeb8cafe9f94b25$var$BufferWriter;

var $88LXr = parcelRequire("88LXr");
($baeb8cafe9f94b25$var$BufferWriter.prototype = Object.create($88LXr.prototype)).constructor = $baeb8cafe9f94b25$var$BufferWriter;

var $ikeUa = parcelRequire("ikeUa");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $baeb8cafe9f94b25$var$BufferWriter() {
    $88LXr.call(this);
}
$baeb8cafe9f94b25$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $baeb8cafe9f94b25$var$BufferWriter.alloc = $ikeUa._Buffer_allocUnsafe;
    $baeb8cafe9f94b25$var$BufferWriter.writeBytesBuffer = $ikeUa.Buffer && $ikeUa.Buffer.prototype instanceof Uint8Array && $ikeUa.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $baeb8cafe9f94b25$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($ikeUa.isString(value)) value = $ikeUa._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($baeb8cafe9f94b25$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $baeb8cafe9f94b25$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $ikeUa.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $baeb8cafe9f94b25$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $ikeUa.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($baeb8cafe9f94b25$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $baeb8cafe9f94b25$var$BufferWriter._configure();

});

parcelRegister("b99Vw", function(module, exports) {
"use strict";
module.exports = $81d83c35130bec23$var$Reader;

var $ikeUa = parcelRequire("ikeUa");
var $81d83c35130bec23$var$BufferReader; // cyclic
var $81d83c35130bec23$var$LongBits = $ikeUa.LongBits, $81d83c35130bec23$var$utf8 = $ikeUa.utf8;
/* istanbul ignore next */ function $81d83c35130bec23$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $81d83c35130bec23$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $81d83c35130bec23$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $81d83c35130bec23$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $81d83c35130bec23$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $81d83c35130bec23$var$create = function create() {
    return $ikeUa.Buffer ? function create_buffer_setup(buffer) {
        return ($81d83c35130bec23$var$Reader.create = function create_buffer(buffer) {
            return $ikeUa.Buffer.isBuffer(buffer) ? new $81d83c35130bec23$var$BufferReader(buffer) : $81d83c35130bec23$var$create_array(buffer);
        })(buffer);
    } : $81d83c35130bec23$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $81d83c35130bec23$var$Reader.create = $81d83c35130bec23$var$create();
$81d83c35130bec23$var$Reader.prototype._slice = $ikeUa.Array.prototype.subarray || /* istanbul ignore next */ $ikeUa.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $81d83c35130bec23$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $81d83c35130bec23$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $81d83c35130bec23$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $81d83c35130bec23$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $81d83c35130bec23$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $81d83c35130bec23$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $81d83c35130bec23$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, 4);
    return $81d83c35130bec23$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, 4);
    return $81d83c35130bec23$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $81d83c35130bec23$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, 8);
    return new $81d83c35130bec23$var$LongBits($81d83c35130bec23$var$readFixed32_end(this.buf, this.pos += 4), $81d83c35130bec23$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, 4);
    var value = $ikeUa.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $81d83c35130bec23$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, 4);
    var value = $ikeUa.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $81d83c35130bec23$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $81d83c35130bec23$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $81d83c35130bec23$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $81d83c35130bec23$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $81d83c35130bec23$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $81d83c35130bec23$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $81d83c35130bec23$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$81d83c35130bec23$var$Reader._configure = function(BufferReader_) {
    $81d83c35130bec23$var$BufferReader = BufferReader_;
    $81d83c35130bec23$var$Reader.create = $81d83c35130bec23$var$create();
    $81d83c35130bec23$var$BufferReader._configure();
    var fn = $ikeUa.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $ikeUa.merge($81d83c35130bec23$var$Reader.prototype, {
        int64: function read_int64() {
            return $81d83c35130bec23$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $81d83c35130bec23$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $81d83c35130bec23$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $81d83c35130bec23$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $81d83c35130bec23$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRegister("jVqnn", function(module, exports) {
"use strict";
module.exports = $e817cce8320cf69d$var$BufferReader;

var $b99Vw = parcelRequire("b99Vw");
($e817cce8320cf69d$var$BufferReader.prototype = Object.create($b99Vw.prototype)).constructor = $e817cce8320cf69d$var$BufferReader;

var $ikeUa = parcelRequire("ikeUa");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $e817cce8320cf69d$var$BufferReader(buffer) {
    $b99Vw.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$e817cce8320cf69d$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($ikeUa.Buffer) $e817cce8320cf69d$var$BufferReader.prototype._slice = $ikeUa.Buffer.prototype.slice;
};
/**
 * @override
 */ $e817cce8320cf69d$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $e817cce8320cf69d$var$BufferReader._configure();

});

parcelRegister("joEbz", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $e1ef6e3eed9c3bbb$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $e1ef6e3eed9c3bbb$var$rpc.Service = (parcelRequire("kHrX0"));

});
parcelRegister("kHrX0", function(module, exports) {
"use strict";
module.exports = $f11d813806da6ab4$var$Service;

var $ikeUa = parcelRequire("ikeUa");
// Extends EventEmitter
($f11d813806da6ab4$var$Service.prototype = Object.create($ikeUa.EventEmitter.prototype)).constructor = $f11d813806da6ab4$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $f11d813806da6ab4$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $ikeUa.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $f11d813806da6ab4$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $ikeUa.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $f11d813806da6ab4$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRegister("5y7CW", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});




parcelRegister("3UcIe", function(module, exports) {
"use strict";
var $2d80767df0f9625c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgMultiSendResponse = module.exports.MsgMultiSend = module.exports.MsgSendResponse = module.exports.MsgSend = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $2d80767df0f9625c$var$long_1 = $2d80767df0f9625c$var$__importDefault((parcelRequire("3gmZQ")));

const $2d80767df0f9625c$var$minimal_1 = $2d80767df0f9625c$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");

var $hbfXb = parcelRequire("hbfXb");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $2d80767df0f9625c$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
module.exports.MsgSend = {
    encode (message, writer = $2d80767df0f9625c$var$minimal_1.default.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$lNGQx.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2d80767df0f9625c$var$minimal_1.default.Reader ? input : new $2d80767df0f9625c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2d80767df0f9625c$var$createBaseMsgSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: $2d80767df0f9625c$var$isSet(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: $2d80767df0f9625c$var$isSet(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $2d80767df0f9625c$var$createBaseMsgSend();
        message.fromAddress = (_a = object.fromAddress) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $2d80767df0f9625c$var$createBaseMsgSendResponse() {
    return {};
}
module.exports.MsgSendResponse = {
    encode (_, writer = $2d80767df0f9625c$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2d80767df0f9625c$var$minimal_1.default.Reader ? input : new $2d80767df0f9625c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2d80767df0f9625c$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $2d80767df0f9625c$var$createBaseMsgSendResponse();
        return message;
    }
};
function $2d80767df0f9625c$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
module.exports.MsgMultiSend = {
    encode (message, writer = $2d80767df0f9625c$var$minimal_1.default.Writer.create()) {
        for (const v of message.inputs)$hbfXb.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$hbfXb.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2d80767df0f9625c$var$minimal_1.default.Reader ? input : new $2d80767df0f9625c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2d80767df0f9625c$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($hbfXb.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($hbfXb.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inputs: Array.isArray(object === null || object === void 0 ? void 0 : object.inputs) ? object.inputs.map((e)=>$hbfXb.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object === null || object === void 0 ? void 0 : object.outputs) ? object.outputs.map((e)=>$hbfXb.Output.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $hbfXb.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $hbfXb.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $2d80767df0f9625c$var$createBaseMsgMultiSend();
        message.inputs = ((_a = object.inputs) === null || _a === void 0 ? void 0 : _a.map((e)=>$hbfXb.Input.fromPartial(e))) || [];
        message.outputs = ((_b = object.outputs) === null || _b === void 0 ? void 0 : _b.map((e)=>$hbfXb.Output.fromPartial(e))) || [];
        return message;
    }
};
function $2d80767df0f9625c$var$createBaseMsgMultiSendResponse() {
    return {};
}
module.exports.MsgMultiSendResponse = {
    encode (_, writer = $2d80767df0f9625c$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2d80767df0f9625c$var$minimal_1.default.Reader ? input : new $2d80767df0f9625c$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2d80767df0f9625c$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $2d80767df0f9625c$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
if ($2d80767df0f9625c$var$minimal_1.default.util.Long !== $2d80767df0f9625c$var$long_1.default) {
    $2d80767df0f9625c$var$minimal_1.default.util.Long = $2d80767df0f9625c$var$long_1.default;
    $2d80767df0f9625c$var$minimal_1.default.configure();
}
function $2d80767df0f9625c$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("lNGQx", function(module, exports) {
"use strict";
var $fdef68f8c16754ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $fdef68f8c16754ab$var$long_1 = $fdef68f8c16754ab$var$__importDefault((parcelRequire("3gmZQ")));

const $fdef68f8c16754ab$var$minimal_1 = $fdef68f8c16754ab$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
function $fdef68f8c16754ab$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.Coin = {
    encode (message, writer = $fdef68f8c16754ab$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fdef68f8c16754ab$var$minimal_1.default.Reader ? input : new $fdef68f8c16754ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fdef68f8c16754ab$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $fdef68f8c16754ab$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $fdef68f8c16754ab$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $fdef68f8c16754ab$var$createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $fdef68f8c16754ab$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.DecCoin = {
    encode (message, writer = $fdef68f8c16754ab$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fdef68f8c16754ab$var$minimal_1.default.Reader ? input : new $fdef68f8c16754ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fdef68f8c16754ab$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $fdef68f8c16754ab$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $fdef68f8c16754ab$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $fdef68f8c16754ab$var$createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $fdef68f8c16754ab$var$createBaseIntProto() {
    return {
        int: ""
    };
}
module.exports.IntProto = {
    encode (message, writer = $fdef68f8c16754ab$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fdef68f8c16754ab$var$minimal_1.default.Reader ? input : new $fdef68f8c16754ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fdef68f8c16754ab$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: $fdef68f8c16754ab$var$isSet(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $fdef68f8c16754ab$var$createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $fdef68f8c16754ab$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
module.exports.DecProto = {
    encode (message, writer = $fdef68f8c16754ab$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fdef68f8c16754ab$var$minimal_1.default.Reader ? input : new $fdef68f8c16754ab$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fdef68f8c16754ab$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: $fdef68f8c16754ab$var$isSet(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $fdef68f8c16754ab$var$createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
if ($fdef68f8c16754ab$var$minimal_1.default.util.Long !== $fdef68f8c16754ab$var$long_1.default) {
    $fdef68f8c16754ab$var$minimal_1.default.util.Long = $fdef68f8c16754ab$var$long_1.default;
    $fdef68f8c16754ab$var$minimal_1.default.configure();
}
function $fdef68f8c16754ab$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("hbfXb", function(module, exports) {
"use strict";
var $c81fd6c8e78d6316$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Metadata = module.exports.DenomUnit = module.exports.Supply = module.exports.Output = module.exports.Input = module.exports.SendEnabled = module.exports.Params = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $c81fd6c8e78d6316$var$long_1 = $c81fd6c8e78d6316$var$__importDefault((parcelRequire("3gmZQ")));

const $c81fd6c8e78d6316$var$minimal_1 = $c81fd6c8e78d6316$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $c81fd6c8e78d6316$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
module.exports.Params = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        for (const v of message.sendEnabled)module.exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push(module.exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object === null || object === void 0 ? void 0 : object.sendEnabled) ? object.sendEnabled.map((e)=>module.exports.SendEnabled.fromJSON(e)) : [],
            defaultSendEnabled: $c81fd6c8e78d6316$var$isSet(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? module.exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $c81fd6c8e78d6316$var$createBaseParams();
        message.sendEnabled = ((_a = object.sendEnabled) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SendEnabled.fromPartial(e))) || [];
        message.defaultSendEnabled = (_b = object.defaultSendEnabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
module.exports.SendEnabled = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $c81fd6c8e78d6316$var$isSet(object.denom) ? String(object.denom) : "",
            enabled: $c81fd6c8e78d6316$var$isSet(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $c81fd6c8e78d6316$var$createBaseSendEnabled();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Input = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$lNGQx.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseInput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $c81fd6c8e78d6316$var$isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $c81fd6c8e78d6316$var$createBaseInput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Output = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$lNGQx.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseOutput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $c81fd6c8e78d6316$var$isSet(object.address) ? String(object.address) : "",
            coins: Array.isArray(object === null || object === void 0 ? void 0 : object.coins) ? object.coins.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $c81fd6c8e78d6316$var$createBaseOutput();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.coins = ((_b = object.coins) === null || _b === void 0 ? void 0 : _b.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseSupply() {
    return {
        total: []
    };
}
module.exports.Supply = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        for (const v of message.total)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseSupply();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: Array.isArray(object === null || object === void 0 ? void 0 : object.total) ? object.total.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $c81fd6c8e78d6316$var$createBaseSupply();
        message.total = ((_a = object.total) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
module.exports.DenomUnit = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseDenomUnit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $c81fd6c8e78d6316$var$isSet(object.denom) ? String(object.denom) : "",
            exponent: $c81fd6c8e78d6316$var$isSet(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object === null || object === void 0 ? void 0 : object.aliases) ? object.aliases.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $c81fd6c8e78d6316$var$createBaseDenomUnit();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.exponent = (_b = object.exponent) !== null && _b !== void 0 ? _b : 0;
        message.aliases = ((_c = object.aliases) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
function $c81fd6c8e78d6316$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: ""
    };
}
module.exports.Metadata = {
    encode (message, writer = $c81fd6c8e78d6316$var$minimal_1.default.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)module.exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c81fd6c8e78d6316$var$minimal_1.default.Reader ? input : new $c81fd6c8e78d6316$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c81fd6c8e78d6316$var$createBaseMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(module.exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $c81fd6c8e78d6316$var$isSet(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object === null || object === void 0 ? void 0 : object.denomUnits) ? object.denomUnits.map((e)=>module.exports.DenomUnit.fromJSON(e)) : [],
            base: $c81fd6c8e78d6316$var$isSet(object.base) ? String(object.base) : "",
            display: $c81fd6c8e78d6316$var$isSet(object.display) ? String(object.display) : "",
            name: $c81fd6c8e78d6316$var$isSet(object.name) ? String(object.name) : "",
            symbol: $c81fd6c8e78d6316$var$isSet(object.symbol) ? String(object.symbol) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? module.exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $c81fd6c8e78d6316$var$createBaseMetadata();
        message.description = (_a = object.description) !== null && _a !== void 0 ? _a : "";
        message.denomUnits = ((_b = object.denomUnits) === null || _b === void 0 ? void 0 : _b.map((e)=>module.exports.DenomUnit.fromPartial(e))) || [];
        message.base = (_c = object.base) !== null && _c !== void 0 ? _c : "";
        message.display = (_d = object.display) !== null && _d !== void 0 ? _d : "";
        message.name = (_e = object.name) !== null && _e !== void 0 ? _e : "";
        message.symbol = (_f = object.symbol) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
if ($c81fd6c8e78d6316$var$minimal_1.default.util.Long !== $c81fd6c8e78d6316$var$long_1.default) {
    $c81fd6c8e78d6316$var$minimal_1.default.util.Long = $c81fd6c8e78d6316$var$long_1.default;
    $c81fd6c8e78d6316$var$minimal_1.default.configure();
}
function $c81fd6c8e78d6316$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("f33iS", function(module, exports) {
"use strict";
var $af49b2d0a8e01a91$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgValidatorBondResponse = module.exports.MsgValidatorBond = module.exports.MsgEnableTokenizeSharesResponse = module.exports.MsgEnableTokenizeShares = module.exports.MsgDisableTokenizeSharesResponse = module.exports.MsgDisableTokenizeShares = module.exports.MsgTransferTokenizeShareRecordResponse = module.exports.MsgTransferTokenizeShareRecord = module.exports.MsgRedeemTokensForSharesResponse = module.exports.MsgRedeemTokensForShares = module.exports.MsgTokenizeSharesResponse = module.exports.MsgTokenizeShares = module.exports.MsgCancelUnbondingDelegationResponse = module.exports.MsgCancelUnbondingDelegation = module.exports.MsgUnbondValidatorResponse = module.exports.MsgUnbondValidator = module.exports.MsgUndelegateResponse = module.exports.MsgUndelegate = module.exports.MsgBeginRedelegateResponse = module.exports.MsgBeginRedelegate = module.exports.MsgDelegateResponse = module.exports.MsgDelegate = module.exports.MsgEditValidatorResponse = module.exports.MsgEditValidator = module.exports.MsgCreateValidatorResponse = module.exports.MsgCreateValidator = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $af49b2d0a8e01a91$var$long_1 = $af49b2d0a8e01a91$var$__importDefault((parcelRequire("3gmZQ")));

const $af49b2d0a8e01a91$var$minimal_1 = $af49b2d0a8e01a91$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $8dBmJ = parcelRequire("8dBmJ");

var $fV2Ok = parcelRequire("fV2Ok");

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
function $af49b2d0a8e01a91$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
module.exports.MsgCreateValidator = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $8dBmJ.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $8dBmJ.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $fV2Ok.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $lNGQx.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $8dBmJ.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $8dBmJ.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $af49b2d0a8e01a91$var$isSet(object.description) ? $8dBmJ.Description.fromJSON(object.description) : undefined,
            commission: $af49b2d0a8e01a91$var$isSet(object.commission) ? $8dBmJ.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: $af49b2d0a8e01a91$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: $af49b2d0a8e01a91$var$isSet(object.pubkey) ? $fV2Ok.Any.fromJSON(object.pubkey) : undefined,
            value: $af49b2d0a8e01a91$var$isSet(object.value) ? $lNGQx.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $8dBmJ.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $8dBmJ.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $fV2Ok.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $lNGQx.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $8dBmJ.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $8dBmJ.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_a = object.minSelfDelegation) !== null && _a !== void 0 ? _a : "";
        message.delegatorAddress = (_b = object.delegatorAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorAddress = (_c = object.validatorAddress) !== null && _c !== void 0 ? _c : "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $fV2Ok.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $lNGQx.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
module.exports.MsgCreateValidatorResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
module.exports.MsgEditValidator = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.description !== undefined) $8dBmJ.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $8dBmJ.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: $af49b2d0a8e01a91$var$isSet(object.description) ? $8dBmJ.Description.fromJSON(object.description) : undefined,
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: $af49b2d0a8e01a91$var$isSet(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: $af49b2d0a8e01a91$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $8dBmJ.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $8dBmJ.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        message.commissionRate = (_b = object.commissionRate) !== null && _b !== void 0 ? _b : "";
        message.minSelfDelegation = (_c = object.minSelfDelegation) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgEditValidatorResponse() {
    return {};
}
module.exports.MsgEditValidatorResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgDelegate = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgDelegateResponse() {
    return {};
}
module.exports.MsgDelegateResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
module.exports.MsgBeginRedelegate = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $af49b2d0a8e01a91$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $af49b2d0a8e01a91$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $gqzXD.Timestamp.encode($af49b2d0a8e01a91$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $af49b2d0a8e01a91$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: $af49b2d0a8e01a91$var$isSet(object.completionTime) ? $af49b2d0a8e01a91$var$fromJsonTimestamp(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = (_a = object.completionTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgUndelegate = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUndelegate();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgUndelegateResponse = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $gqzXD.Timestamp.encode($af49b2d0a8e01a91$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $af49b2d0a8e01a91$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: $af49b2d0a8e01a91$var$isSet(object.completionTime) ? $af49b2d0a8e01a91$var$fromJsonTimestamp(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUndelegateResponse();
        message.completionTime = (_a = object.completionTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgUnbondValidator() {
    return {
        validatorAddress: ""
    };
}
module.exports.MsgUnbondValidator = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUnbondValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUnbondValidator();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgUnbondValidatorResponse() {
    return {};
}
module.exports.MsgUnbondValidatorResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgUnbondValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgUnbondValidatorResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: "0"
    };
}
module.exports.MsgCancelUnbondingDelegation = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (message.creationHeight !== "0") writer.uint32(32).int64(message.creationHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = $af49b2d0a8e01a91$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined,
            creationHeight: $af49b2d0a8e01a91$var$isSet(object.creationHeight) ? String(object.creationHeight) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined && (obj.creationHeight = message.creationHeight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight = (_c = object.creationHeight) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
module.exports.MsgCancelUnbondingDelegationResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgTokenizeShares() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        tokenizedShareOwner: ""
    };
}
module.exports.MsgTokenizeShares = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (message.tokenizedShareOwner !== "") writer.uint32(34).string(message.tokenizedShareOwner);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTokenizeShares();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.tokenizedShareOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined,
            tokenizedShareOwner: $af49b2d0a8e01a91$var$isSet(object.tokenizedShareOwner) ? String(object.tokenizedShareOwner) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        message.tokenizedShareOwner !== undefined && (obj.tokenizedShareOwner = message.tokenizedShareOwner);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTokenizeShares();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        message.tokenizedShareOwner = (_c = object.tokenizedShareOwner) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgTokenizeSharesResponse() {
    return {
        amount: undefined
    };
}
module.exports.MsgTokenizeSharesResponse = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTokenizeSharesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgTokenizeSharesResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForShares() {
    return {
        delegatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgRedeemTokensForShares = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForShares();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForShares();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForSharesResponse() {
    return {
        amount: undefined
    };
}
module.exports.MsgRedeemTokensForSharesResponse = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.amount !== undefined) $lNGQx.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForSharesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: $af49b2d0a8e01a91$var$isSet(object.amount) ? $lNGQx.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $lNGQx.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgRedeemTokensForSharesResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $lNGQx.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecord() {
    return {
        tokenizeShareRecordId: "0",
        sender: "",
        newOwner: ""
    };
}
module.exports.MsgTransferTokenizeShareRecord = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.tokenizeShareRecordId !== "0") writer.uint32(8).uint64(message.tokenizeShareRecordId);
        if (message.sender !== "") writer.uint32(18).string(message.sender);
        if (message.newOwner !== "") writer.uint32(26).string(message.newOwner);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecord();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tokenizeShareRecordId = $af49b2d0a8e01a91$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.newOwner = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tokenizeShareRecordId: $af49b2d0a8e01a91$var$isSet(object.tokenizeShareRecordId) ? String(object.tokenizeShareRecordId) : "0",
            sender: $af49b2d0a8e01a91$var$isSet(object.sender) ? String(object.sender) : "",
            newOwner: $af49b2d0a8e01a91$var$isSet(object.newOwner) ? String(object.newOwner) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.tokenizeShareRecordId !== undefined && (obj.tokenizeShareRecordId = message.tokenizeShareRecordId);
        message.sender !== undefined && (obj.sender = message.sender);
        message.newOwner !== undefined && (obj.newOwner = message.newOwner);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecord();
        message.tokenizeShareRecordId = (_a = object.tokenizeShareRecordId) !== null && _a !== void 0 ? _a : "0";
        message.sender = (_b = object.sender) !== null && _b !== void 0 ? _b : "";
        message.newOwner = (_c = object.newOwner) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecordResponse() {
    return {};
}
module.exports.MsgTransferTokenizeShareRecordResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecordResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgTransferTokenizeShareRecordResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeShares() {
    return {
        delegatorAddress: ""
    };
}
module.exports.MsgDisableTokenizeShares = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeShares();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeShares();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeSharesResponse() {
    return {};
}
module.exports.MsgDisableTokenizeSharesResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeSharesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgDisableTokenizeSharesResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeShares() {
    return {
        delegatorAddress: ""
    };
}
module.exports.MsgEnableTokenizeShares = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeShares();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeShares();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeSharesResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgEnableTokenizeSharesResponse = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.completionTime !== undefined) $gqzXD.Timestamp.encode($af49b2d0a8e01a91$var$toTimestamp(message.completionTime), writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeSharesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $af49b2d0a8e01a91$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: $af49b2d0a8e01a91$var$isSet(object.completionTime) ? $af49b2d0a8e01a91$var$fromJsonTimestamp(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $af49b2d0a8e01a91$var$createBaseMsgEnableTokenizeSharesResponse();
        message.completionTime = (_a = object.completionTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgValidatorBond() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.MsgValidatorBond = {
    encode (message, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgValidatorBond();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $af49b2d0a8e01a91$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $af49b2d0a8e01a91$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $af49b2d0a8e01a91$var$createBaseMsgValidatorBond();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $af49b2d0a8e01a91$var$createBaseMsgValidatorBondResponse() {
    return {};
}
module.exports.MsgValidatorBondResponse = {
    encode (_, writer = $af49b2d0a8e01a91$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $af49b2d0a8e01a91$var$minimal_1.default.Reader ? input : new $af49b2d0a8e01a91$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $af49b2d0a8e01a91$var$createBaseMsgValidatorBondResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $af49b2d0a8e01a91$var$createBaseMsgValidatorBondResponse();
        return message;
    }
};
function $af49b2d0a8e01a91$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $af49b2d0a8e01a91$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $af49b2d0a8e01a91$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $af49b2d0a8e01a91$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
function $af49b2d0a8e01a91$var$longToString(long) {
    return long.toString();
}
if ($af49b2d0a8e01a91$var$minimal_1.default.util.Long !== $af49b2d0a8e01a91$var$long_1.default) {
    $af49b2d0a8e01a91$var$minimal_1.default.util.Long = $af49b2d0a8e01a91$var$long_1.default;
    $af49b2d0a8e01a91$var$minimal_1.default.configure();
}
function $af49b2d0a8e01a91$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("gqzXD", function(module, exports) {
"use strict";
var $bf5af819feda4585$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $bf5af819feda4585$var$long_1 = $bf5af819feda4585$var$__importDefault((parcelRequire("3gmZQ")));

const $bf5af819feda4585$var$minimal_1 = $bf5af819feda4585$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $bf5af819feda4585$var$createBaseTimestamp() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Timestamp = {
    encode (message, writer = $bf5af819feda4585$var$minimal_1.default.Writer.create()) {
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bf5af819feda4585$var$minimal_1.default.Reader ? input : new $bf5af819feda4585$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bf5af819feda4585$var$createBaseTimestamp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = $bf5af819feda4585$var$longToString(reader.int64());
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: $bf5af819feda4585$var$isSet(object.seconds) ? String(object.seconds) : "0",
            nanos: $bf5af819feda4585$var$isSet(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = message.seconds);
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $bf5af819feda4585$var$createBaseTimestamp();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $bf5af819feda4585$var$longToString(long) {
    return long.toString();
}
if ($bf5af819feda4585$var$minimal_1.default.util.Long !== $bf5af819feda4585$var$long_1.default) {
    $bf5af819feda4585$var$minimal_1.default.util.Long = $bf5af819feda4585$var$long_1.default;
    $bf5af819feda4585$var$minimal_1.default.configure();
}
function $bf5af819feda4585$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("8dBmJ", function(module, exports) {
"use strict";
var $5fbc85aa756637ec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pool = module.exports.RedelegationResponse = module.exports.RedelegationEntryResponse = module.exports.DelegationResponse = module.exports.Params = module.exports.Redelegation = module.exports.RedelegationEntry = module.exports.UnbondingDelegationEntry = module.exports.UnbondingDelegation = module.exports.Delegation = module.exports.DVVTriplets = module.exports.DVVTriplet = module.exports.DVPairs = module.exports.DVPair = module.exports.ValAddresses = module.exports.Validator = module.exports.Description = module.exports.Commission = module.exports.CommissionRates = module.exports.HistoricalInfo = module.exports.bondStatusToJSON = module.exports.bondStatusFromJSON = module.exports.BondStatus = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $5fbc85aa756637ec$var$long_1 = $5fbc85aa756637ec$var$__importDefault((parcelRequire("3gmZQ")));

const $5fbc85aa756637ec$var$minimal_1 = $5fbc85aa756637ec$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $ic0Bb = parcelRequire("ic0Bb");

var $fV2Ok = parcelRequire("fV2Ok");

var $byZvw = parcelRequire("byZvw");

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $5fbc85aa756637ec$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($5fbc85aa756637ec$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $5fbc85aa756637ec$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $5fbc85aa756637ec$var$BondStatus.UNRECOGNIZED;
    }
}
module.exports.bondStatusFromJSON = $5fbc85aa756637ec$var$bondStatusFromJSON;
function $5fbc85aa756637ec$var$bondStatusToJSON(object) {
    switch(object){
        case $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $5fbc85aa756637ec$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        default:
            return "UNKNOWN";
    }
}
module.exports.bondStatusToJSON = $5fbc85aa756637ec$var$bondStatusToJSON;
function $5fbc85aa756637ec$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
module.exports.HistoricalInfo = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) $ic0Bb.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)module.exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $ic0Bb.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: $5fbc85aa756637ec$var$isSet(object.header) ? $ic0Bb.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object === null || object === void 0 ? void 0 : object.valset) ? object.valset.map((e)=>module.exports.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $ic0Bb.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $ic0Bb.Header.fromPartial(object.header) : undefined;
        message.valset = ((_a = object.valset) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.Validator.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
module.exports.CommissionRates = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseCommissionRates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rate: $5fbc85aa756637ec$var$isSet(object.rate) ? String(object.rate) : "",
            maxRate: $5fbc85aa756637ec$var$isSet(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: $5fbc85aa756637ec$var$isSet(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5fbc85aa756637ec$var$createBaseCommissionRates();
        message.rate = (_a = object.rate) !== null && _a !== void 0 ? _a : "";
        message.maxRate = (_b = object.maxRate) !== null && _b !== void 0 ? _b : "";
        message.maxChangeRate = (_c = object.maxChangeRate) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
module.exports.Commission = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.commissionRates !== undefined) module.exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $gqzXD.Timestamp.encode($5fbc85aa756637ec$var$toTimestamp(message.updateTime), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = module.exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $5fbc85aa756637ec$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commissionRates: $5fbc85aa756637ec$var$isSet(object.commissionRates) ? module.exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: $5fbc85aa756637ec$var$isSet(object.updateTime) ? $5fbc85aa756637ec$var$fromJsonTimestamp(object.updateTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? module.exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? module.exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = (_a = object.updateTime) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
module.exports.Description = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDescription();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moniker: $5fbc85aa756637ec$var$isSet(object.moniker) ? String(object.moniker) : "",
            identity: $5fbc85aa756637ec$var$isSet(object.identity) ? String(object.identity) : "",
            website: $5fbc85aa756637ec$var$isSet(object.website) ? String(object.website) : "",
            securityContact: $5fbc85aa756637ec$var$isSet(object.securityContact) ? String(object.securityContact) : "",
            details: $5fbc85aa756637ec$var$isSet(object.details) ? String(object.details) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $5fbc85aa756637ec$var$createBaseDescription();
        message.moniker = (_a = object.moniker) !== null && _a !== void 0 ? _a : "";
        message.identity = (_b = object.identity) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.securityContact = (_d = object.securityContact) !== null && _d !== void 0 ? _d : "";
        message.details = (_e = object.details) !== null && _e !== void 0 ? _e : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: "0",
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: ""
    };
}
module.exports.Validator = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $fV2Ok.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) module.exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (message.unbondingHeight !== "0") writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $gqzXD.Timestamp.encode($5fbc85aa756637ec$var$toTimestamp(message.unbondingTime), writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) module.exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = module.exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = $5fbc85aa756637ec$var$longToString(reader.int64());
                    break;
                case 9:
                    message.unbondingTime = $5fbc85aa756637ec$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.commission = module.exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: $5fbc85aa756637ec$var$isSet(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: $5fbc85aa756637ec$var$isSet(object.consensusPubkey) ? $fV2Ok.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: $5fbc85aa756637ec$var$isSet(object.jailed) ? Boolean(object.jailed) : false,
            status: $5fbc85aa756637ec$var$isSet(object.status) ? $5fbc85aa756637ec$var$bondStatusFromJSON(object.status) : 0,
            tokens: $5fbc85aa756637ec$var$isSet(object.tokens) ? String(object.tokens) : "",
            delegatorShares: $5fbc85aa756637ec$var$isSet(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: $5fbc85aa756637ec$var$isSet(object.description) ? module.exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: $5fbc85aa756637ec$var$isSet(object.unbondingHeight) ? String(object.unbondingHeight) : "0",
            unbondingTime: $5fbc85aa756637ec$var$isSet(object.unbondingTime) ? $5fbc85aa756637ec$var$fromJsonTimestamp(object.unbondingTime) : undefined,
            commission: $5fbc85aa756637ec$var$isSet(object.commission) ? module.exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: $5fbc85aa756637ec$var$isSet(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $fV2Ok.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $5fbc85aa756637ec$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? module.exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = message.unbondingHeight);
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime.toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? module.exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = $5fbc85aa756637ec$var$createBaseValidator();
        message.operatorAddress = (_a = object.operatorAddress) !== null && _a !== void 0 ? _a : "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $fV2Ok.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = (_b = object.jailed) !== null && _b !== void 0 ? _b : false;
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.tokens = (_d = object.tokens) !== null && _d !== void 0 ? _d : "";
        message.delegatorShares = (_e = object.delegatorShares) !== null && _e !== void 0 ? _e : "";
        message.description = object.description !== undefined && object.description !== null ? module.exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = (_f = object.unbondingHeight) !== null && _f !== void 0 ? _f : "0";
        message.unbondingTime = (_g = object.unbondingTime) !== null && _g !== void 0 ? _g : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? module.exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = (_h = object.minSelfDelegation) !== null && _h !== void 0 ? _h : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
module.exports.ValAddresses = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseValAddresses();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addresses: Array.isArray(object === null || object === void 0 ? void 0 : object.addresses) ? object.addresses.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseValAddresses();
        message.addresses = ((_a = object.addresses) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.DVPair = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDVPair();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5fbc85aa756637ec$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5fbc85aa756637ec$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5fbc85aa756637ec$var$createBaseDVPair();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
module.exports.DVPairs = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        for (const v of message.pairs)module.exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDVPairs();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push(module.exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pairs: Array.isArray(object === null || object === void 0 ? void 0 : object.pairs) ? object.pairs.map((e)=>module.exports.DVPair.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? module.exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseDVPairs();
        message.pairs = ((_a = object.pairs) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.DVPair.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
module.exports.DVVTriplet = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDVVTriplet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5fbc85aa756637ec$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $5fbc85aa756637ec$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $5fbc85aa756637ec$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5fbc85aa756637ec$var$createBaseDVVTriplet();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
module.exports.DVVTriplets = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        for (const v of message.triplets)module.exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDVVTriplets();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push(module.exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            triplets: Array.isArray(object === null || object === void 0 ? void 0 : object.triplets) ? object.triplets.map((e)=>module.exports.DVVTriplet.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? module.exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseDVVTriplets();
        message.triplets = ((_a = object.triplets) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.DVVTriplet.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
module.exports.Delegation = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5fbc85aa756637ec$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5fbc85aa756637ec$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: $5fbc85aa756637ec$var$isSet(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5fbc85aa756637ec$var$createBaseDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.shares = (_c = object.shares) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
module.exports.UnbondingDelegation = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)module.exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(module.exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5fbc85aa756637ec$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $5fbc85aa756637ec$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.UnbondingDelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5fbc85aa756637ec$var$createBaseUnbondingDelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        message.entries = ((_c = object.entries) === null || _c === void 0 ? void 0 : _c.map((e)=>module.exports.UnbondingDelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: "0",
        completionTime: undefined,
        initialBalance: "",
        balance: ""
    };
}
module.exports.UnbondingDelegationEntry = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.creationHeight !== "0") writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $gqzXD.Timestamp.encode($5fbc85aa756637ec$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = $5fbc85aa756637ec$var$longToString(reader.int64());
                    break;
                case 2:
                    message.completionTime = $5fbc85aa756637ec$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: $5fbc85aa756637ec$var$isSet(object.creationHeight) ? String(object.creationHeight) : "0",
            completionTime: $5fbc85aa756637ec$var$isSet(object.completionTime) ? $5fbc85aa756637ec$var$fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: $5fbc85aa756637ec$var$isSet(object.initialBalance) ? String(object.initialBalance) : "",
            balance: $5fbc85aa756637ec$var$isSet(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = message.creationHeight);
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $5fbc85aa756637ec$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = (_a = object.creationHeight) !== null && _a !== void 0 ? _a : "0";
        message.completionTime = (_b = object.completionTime) !== null && _b !== void 0 ? _b : undefined;
        message.initialBalance = (_c = object.initialBalance) !== null && _c !== void 0 ? _c : "";
        message.balance = (_d = object.balance) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseRedelegationEntry() {
    return {
        creationHeight: "0",
        completionTime: undefined,
        initialBalance: "",
        sharesDst: ""
    };
}
module.exports.RedelegationEntry = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.creationHeight !== "0") writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $gqzXD.Timestamp.encode($5fbc85aa756637ec$var$toTimestamp(message.completionTime), writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = $5fbc85aa756637ec$var$longToString(reader.int64());
                    break;
                case 2:
                    message.completionTime = $5fbc85aa756637ec$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: $5fbc85aa756637ec$var$isSet(object.creationHeight) ? String(object.creationHeight) : "0",
            completionTime: $5fbc85aa756637ec$var$isSet(object.completionTime) ? $5fbc85aa756637ec$var$fromJsonTimestamp(object.completionTime) : undefined,
            initialBalance: $5fbc85aa756637ec$var$isSet(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: $5fbc85aa756637ec$var$isSet(object.sharesDst) ? String(object.sharesDst) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = message.creationHeight);
        message.completionTime !== undefined && (obj.completionTime = message.completionTime.toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationEntry();
        message.creationHeight = (_a = object.creationHeight) !== null && _a !== void 0 ? _a : "0";
        message.completionTime = (_b = object.completionTime) !== null && _b !== void 0 ? _b : undefined;
        message.initialBalance = (_c = object.initialBalance) !== null && _c !== void 0 ? _c : "";
        message.sharesDst = (_d = object.sharesDst) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
module.exports.Redelegation = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)module.exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseRedelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(module.exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $5fbc85aa756637ec$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: $5fbc85aa756637ec$var$isSet(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: $5fbc85aa756637ec$var$isSet(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.RedelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $5fbc85aa756637ec$var$createBaseRedelegation();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorSrcAddress = (_b = object.validatorSrcAddress) !== null && _b !== void 0 ? _b : "";
        message.validatorDstAddress = (_c = object.validatorDstAddress) !== null && _c !== void 0 ? _c : "";
        message.entries = ((_d = object.entries) === null || _d === void 0 ? void 0 : _d.map((e)=>module.exports.RedelegationEntry.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: ""
    };
}
module.exports.Params = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.unbondingTime !== undefined) $byZvw.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $byZvw.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingTime: $5fbc85aa756637ec$var$isSet(object.unbondingTime) ? $byZvw.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: $5fbc85aa756637ec$var$isSet(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: $5fbc85aa756637ec$var$isSet(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: $5fbc85aa756637ec$var$isSet(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: $5fbc85aa756637ec$var$isSet(object.bondDenom) ? String(object.bondDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $byZvw.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $5fbc85aa756637ec$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $byZvw.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = (_a = object.maxValidators) !== null && _a !== void 0 ? _a : 0;
        message.maxEntries = (_b = object.maxEntries) !== null && _b !== void 0 ? _b : 0;
        message.historicalEntries = (_c = object.historicalEntries) !== null && _c !== void 0 ? _c : 0;
        message.bondDenom = (_d = object.bondDenom) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
module.exports.DelegationResponse = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.delegation !== undefined) module.exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $lNGQx.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = module.exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegation: $5fbc85aa756637ec$var$isSet(object.delegation) ? module.exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: $5fbc85aa756637ec$var$isSet(object.balance) ? $lNGQx.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? module.exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $lNGQx.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $5fbc85aa756637ec$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? module.exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $lNGQx.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
module.exports.RedelegationEntryResponse = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.redelegationEntry !== undefined) module.exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = module.exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationEntry: $5fbc85aa756637ec$var$isSet(object.redelegationEntry) ? module.exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: $5fbc85aa756637ec$var$isSet(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? module.exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? module.exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = (_a = object.balance) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
module.exports.RedelegationResponse = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.redelegation !== undefined) module.exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)module.exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = module.exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(module.exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegation: $5fbc85aa756637ec$var$isSet(object.redelegation) ? module.exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object === null || object === void 0 ? void 0 : object.entries) ? object.entries.map((e)=>module.exports.RedelegationEntryResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? module.exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5fbc85aa756637ec$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? module.exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = ((_a = object.entries) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.RedelegationEntryResponse.fromPartial(e))) || [];
        return message;
    }
};
function $5fbc85aa756637ec$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
module.exports.Pool = {
    encode (message, writer = $5fbc85aa756637ec$var$minimal_1.default.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5fbc85aa756637ec$var$minimal_1.default.Reader ? input : new $5fbc85aa756637ec$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5fbc85aa756637ec$var$createBasePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            notBondedTokens: $5fbc85aa756637ec$var$isSet(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: $5fbc85aa756637ec$var$isSet(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5fbc85aa756637ec$var$createBasePool();
        message.notBondedTokens = (_a = object.notBondedTokens) !== null && _a !== void 0 ? _a : "";
        message.bondedTokens = (_b = object.bondedTokens) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $5fbc85aa756637ec$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $5fbc85aa756637ec$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $5fbc85aa756637ec$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $5fbc85aa756637ec$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
function $5fbc85aa756637ec$var$longToString(long) {
    return long.toString();
}
if ($5fbc85aa756637ec$var$minimal_1.default.util.Long !== $5fbc85aa756637ec$var$long_1.default) {
    $5fbc85aa756637ec$var$minimal_1.default.util.Long = $5fbc85aa756637ec$var$long_1.default;
    $5fbc85aa756637ec$var$minimal_1.default.configure();
}
function $5fbc85aa756637ec$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("ic0Bb", function(module, exports) {
"use strict";
var $d3e9cfdd444b254e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxProof = module.exports.BlockMeta = module.exports.LightBlock = module.exports.SignedHeader = module.exports.Proposal = module.exports.CommitSig = module.exports.Commit = module.exports.Vote = module.exports.Data = module.exports.Header = module.exports.BlockID = module.exports.Part = module.exports.PartSetHeader = module.exports.signedMsgTypeToJSON = module.exports.signedMsgTypeFromJSON = module.exports.SignedMsgType = module.exports.blockIDFlagToJSON = module.exports.blockIDFlagFromJSON = module.exports.BlockIDFlag = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $d3e9cfdd444b254e$var$long_1 = $d3e9cfdd444b254e$var$__importDefault((parcelRequire("3gmZQ")));

const $d3e9cfdd444b254e$var$minimal_1 = $d3e9cfdd444b254e$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $fqyds = parcelRequire("fqyds");

var $eMHox = parcelRequire("eMHox");

var $94ExP = parcelRequire("94ExP");
module.exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $d3e9cfdd444b254e$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d3e9cfdd444b254e$var$BlockIDFlag = module.exports.BlockIDFlag || (module.exports.BlockIDFlag = {}));
function $d3e9cfdd444b254e$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d3e9cfdd444b254e$var$BlockIDFlag.UNRECOGNIZED;
    }
}
module.exports.blockIDFlagFromJSON = $d3e9cfdd444b254e$var$blockIDFlagFromJSON;
function $d3e9cfdd444b254e$var$blockIDFlagToJSON(object) {
    switch(object){
        case $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $d3e9cfdd444b254e$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        default:
            return "UNKNOWN";
    }
}
module.exports.blockIDFlagToJSON = $d3e9cfdd444b254e$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $d3e9cfdd444b254e$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d3e9cfdd444b254e$var$SignedMsgType = module.exports.SignedMsgType || (module.exports.SignedMsgType = {}));
function $d3e9cfdd444b254e$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d3e9cfdd444b254e$var$SignedMsgType.UNRECOGNIZED;
    }
}
module.exports.signedMsgTypeFromJSON = $d3e9cfdd444b254e$var$signedMsgTypeFromJSON;
function $d3e9cfdd444b254e$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $d3e9cfdd444b254e$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        default:
            return "UNKNOWN";
    }
}
module.exports.signedMsgTypeToJSON = $d3e9cfdd444b254e$var$signedMsgTypeToJSON;
function $d3e9cfdd444b254e$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
module.exports.PartSetHeader = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBasePartSetHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: $d3e9cfdd444b254e$var$isSet(object.total) ? Number(object.total) : 0,
            hash: $d3e9cfdd444b254e$var$isSet(object.hash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = $d3e9cfdd444b254e$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d3e9cfdd444b254e$var$createBasePartSetHeader();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : 0;
        message.hash = (_b = object.hash) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
module.exports.Part = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $fqyds.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBasePart();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $fqyds.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: $d3e9cfdd444b254e$var$isSet(object.index) ? Number(object.index) : 0,
            bytes: $d3e9cfdd444b254e$var$isSet(object.bytes) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.bytes) : new Uint8Array(),
            proof: $d3e9cfdd444b254e$var$isSet(object.proof) ? $fqyds.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = $d3e9cfdd444b254e$var$base64FromBytes(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $fqyds.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d3e9cfdd444b254e$var$createBasePart();
        message.index = (_a = object.index) !== null && _a !== void 0 ? _a : 0;
        message.bytes = (_b = object.bytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $fqyds.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
module.exports.BlockID = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) module.exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseBlockID();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = module.exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: $d3e9cfdd444b254e$var$isSet(object.hash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.hash) : new Uint8Array(),
            partSetHeader: $d3e9cfdd444b254e$var$isSet(object.partSetHeader) ? module.exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $d3e9cfdd444b254e$var$base64FromBytes(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? module.exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $d3e9cfdd444b254e$var$createBaseBlockID();
        message.hash = (_a = object.hash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? module.exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: "0",
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
module.exports.Header = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.version !== undefined) $eMHox.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.height !== "0") writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $gqzXD.Timestamp.encode($d3e9cfdd444b254e$var$toTimestamp(message.time), writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) module.exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $eMHox.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                case 4:
                    message.time = $d3e9cfdd444b254e$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.lastBlockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: $d3e9cfdd444b254e$var$isSet(object.version) ? $eMHox.Consensus.fromJSON(object.version) : undefined,
            chainId: $d3e9cfdd444b254e$var$isSet(object.chainId) ? String(object.chainId) : "",
            height: $d3e9cfdd444b254e$var$isSet(object.height) ? String(object.height) : "0",
            time: $d3e9cfdd444b254e$var$isSet(object.time) ? $d3e9cfdd444b254e$var$fromJsonTimestamp(object.time) : undefined,
            lastBlockId: $d3e9cfdd444b254e$var$isSet(object.lastBlockId) ? module.exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: $d3e9cfdd444b254e$var$isSet(object.lastCommitHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.lastCommitHash) : new Uint8Array(),
            dataHash: $d3e9cfdd444b254e$var$isSet(object.dataHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.dataHash) : new Uint8Array(),
            validatorsHash: $d3e9cfdd444b254e$var$isSet(object.validatorsHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: $d3e9cfdd444b254e$var$isSet(object.nextValidatorsHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: $d3e9cfdd444b254e$var$isSet(object.consensusHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.consensusHash) : new Uint8Array(),
            appHash: $d3e9cfdd444b254e$var$isSet(object.appHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.appHash) : new Uint8Array(),
            lastResultsHash: $d3e9cfdd444b254e$var$isSet(object.lastResultsHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: $d3e9cfdd444b254e$var$isSet(object.evidenceHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.evidenceHash) : new Uint8Array(),
            proposerAddress: $d3e9cfdd444b254e$var$isSet(object.proposerAddress) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $eMHox.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = message.height);
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? module.exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = $d3e9cfdd444b254e$var$base64FromBytes(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = $d3e9cfdd444b254e$var$base64FromBytes(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = $d3e9cfdd444b254e$var$base64FromBytes(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = $d3e9cfdd444b254e$var$base64FromBytes(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = $d3e9cfdd444b254e$var$base64FromBytes(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = $d3e9cfdd444b254e$var$base64FromBytes(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = $d3e9cfdd444b254e$var$base64FromBytes(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = $d3e9cfdd444b254e$var$base64FromBytes(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = $d3e9cfdd444b254e$var$base64FromBytes(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const message = $d3e9cfdd444b254e$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $eMHox.Consensus.fromPartial(object.version) : undefined;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.time = (_c = object.time) !== null && _c !== void 0 ? _c : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? module.exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = (_d = object.lastCommitHash) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.dataHash = (_e = object.dataHash) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.validatorsHash = (_f = object.validatorsHash) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.nextValidatorsHash = (_g = object.nextValidatorsHash) !== null && _g !== void 0 ? _g : new Uint8Array();
        message.consensusHash = (_h = object.consensusHash) !== null && _h !== void 0 ? _h : new Uint8Array();
        message.appHash = (_j = object.appHash) !== null && _j !== void 0 ? _j : new Uint8Array();
        message.lastResultsHash = (_k = object.lastResultsHash) !== null && _k !== void 0 ? _k : new Uint8Array();
        message.evidenceHash = (_l = object.evidenceHash) !== null && _l !== void 0 ? _l : new Uint8Array();
        message.proposerAddress = (_m = object.proposerAddress) !== null && _m !== void 0 ? _m : new Uint8Array();
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseData() {
    return {
        txs: []
    };
}
module.exports.Data = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object === null || object === void 0 ? void 0 : object.txs) ? object.txs.map((e)=>$d3e9cfdd444b254e$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>$d3e9cfdd444b254e$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $d3e9cfdd444b254e$var$createBaseData();
        message.txs = ((_a = object.txs) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseVote() {
    return {
        type: 0,
        height: "0",
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
module.exports.Vote = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.height !== "0") writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $gqzXD.Timestamp.encode($d3e9cfdd444b254e$var$toTimestamp(message.timestamp), writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $d3e9cfdd444b254e$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $d3e9cfdd444b254e$var$isSet(object.type) ? $d3e9cfdd444b254e$var$signedMsgTypeFromJSON(object.type) : 0,
            height: $d3e9cfdd444b254e$var$isSet(object.height) ? String(object.height) : "0",
            round: $d3e9cfdd444b254e$var$isSet(object.round) ? Number(object.round) : 0,
            blockId: $d3e9cfdd444b254e$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: $d3e9cfdd444b254e$var$isSet(object.timestamp) ? $d3e9cfdd444b254e$var$fromJsonTimestamp(object.timestamp) : undefined,
            validatorAddress: $d3e9cfdd444b254e$var$isSet(object.validatorAddress) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.validatorAddress) : new Uint8Array(),
            validatorIndex: $d3e9cfdd444b254e$var$isSet(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: $d3e9cfdd444b254e$var$isSet(object.signature) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $d3e9cfdd444b254e$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = $d3e9cfdd444b254e$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = $d3e9cfdd444b254e$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = $d3e9cfdd444b254e$var$createBaseVote();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.round = (_c = object.round) !== null && _c !== void 0 ? _c : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = (_d = object.timestamp) !== null && _d !== void 0 ? _d : undefined;
        message.validatorAddress = (_e = object.validatorAddress) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.validatorIndex = (_f = object.validatorIndex) !== null && _f !== void 0 ? _f : 0;
        message.signature = (_g = object.signature) !== null && _g !== void 0 ? _g : new Uint8Array();
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseCommit() {
    return {
        height: "0",
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
module.exports.Commit = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.height !== "0") writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)module.exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(module.exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: $d3e9cfdd444b254e$var$isSet(object.height) ? String(object.height) : "0",
            round: $d3e9cfdd444b254e$var$isSet(object.round) ? Number(object.round) : 0,
            blockId: $d3e9cfdd444b254e$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.CommitSig.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $d3e9cfdd444b254e$var$createBaseCommit();
        message.height = (_a = object.height) !== null && _a !== void 0 ? _a : "0";
        message.round = (_b = object.round) !== null && _b !== void 0 ? _b : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e)=>module.exports.CommitSig.fromPartial(e))) || [];
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.CommitSig = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $gqzXD.Timestamp.encode($d3e9cfdd444b254e$var$toTimestamp(message.timestamp), writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseCommitSig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $d3e9cfdd444b254e$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockIdFlag: $d3e9cfdd444b254e$var$isSet(object.blockIdFlag) ? $d3e9cfdd444b254e$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: $d3e9cfdd444b254e$var$isSet(object.validatorAddress) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.validatorAddress) : new Uint8Array(),
            timestamp: $d3e9cfdd444b254e$var$isSet(object.timestamp) ? $d3e9cfdd444b254e$var$fromJsonTimestamp(object.timestamp) : undefined,
            signature: $d3e9cfdd444b254e$var$isSet(object.signature) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $d3e9cfdd444b254e$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = $d3e9cfdd444b254e$var$base64FromBytes(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $d3e9cfdd444b254e$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $d3e9cfdd444b254e$var$createBaseCommitSig();
        message.blockIdFlag = (_a = object.blockIdFlag) !== null && _a !== void 0 ? _a : 0;
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.timestamp = (_c = object.timestamp) !== null && _c !== void 0 ? _c : undefined;
        message.signature = (_d = object.signature) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseProposal() {
    return {
        type: 0,
        height: "0",
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.Proposal = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.height !== "0") writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $gqzXD.Timestamp.encode($d3e9cfdd444b254e$var$toTimestamp(message.timestamp), writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $d3e9cfdd444b254e$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $d3e9cfdd444b254e$var$isSet(object.type) ? $d3e9cfdd444b254e$var$signedMsgTypeFromJSON(object.type) : 0,
            height: $d3e9cfdd444b254e$var$isSet(object.height) ? String(object.height) : "0",
            round: $d3e9cfdd444b254e$var$isSet(object.round) ? Number(object.round) : 0,
            polRound: $d3e9cfdd444b254e$var$isSet(object.polRound) ? Number(object.polRound) : 0,
            blockId: $d3e9cfdd444b254e$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: $d3e9cfdd444b254e$var$isSet(object.timestamp) ? $d3e9cfdd444b254e$var$fromJsonTimestamp(object.timestamp) : undefined,
            signature: $d3e9cfdd444b254e$var$isSet(object.signature) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $d3e9cfdd444b254e$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = message.height);
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp.toISOString());
        message.signature !== undefined && (obj.signature = $d3e9cfdd444b254e$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $d3e9cfdd444b254e$var$createBaseProposal();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : 0;
        message.height = (_b = object.height) !== null && _b !== void 0 ? _b : "0";
        message.round = (_c = object.round) !== null && _c !== void 0 ? _c : 0;
        message.polRound = (_d = object.polRound) !== null && _d !== void 0 ? _d : 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = (_e = object.timestamp) !== null && _e !== void 0 ? _e : undefined;
        message.signature = (_f = object.signature) !== null && _f !== void 0 ? _f : new Uint8Array();
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
module.exports.SignedHeader = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) module.exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseSignedHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = module.exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: $d3e9cfdd444b254e$var$isSet(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            commit: $d3e9cfdd444b254e$var$isSet(object.commit) ? module.exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d3e9cfdd444b254e$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? module.exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
module.exports.LightBlock = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.signedHeader !== undefined) module.exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $94ExP.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseLightBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = module.exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $94ExP.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: $d3e9cfdd444b254e$var$isSet(object.signedHeader) ? module.exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: $d3e9cfdd444b254e$var$isSet(object.validatorSet) ? $94ExP.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? module.exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $94ExP.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d3e9cfdd444b254e$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? module.exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $94ExP.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: "0",
        header: undefined,
        numTxs: "0"
    };
}
module.exports.BlockMeta = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (message.blockSize !== "0") writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (message.numTxs !== "0") writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseBlockMeta();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                case 3:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = $d3e9cfdd444b254e$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockId: $d3e9cfdd444b254e$var$isSet(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: $d3e9cfdd444b254e$var$isSet(object.blockSize) ? String(object.blockSize) : "0",
            header: $d3e9cfdd444b254e$var$isSet(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            numTxs: $d3e9cfdd444b254e$var$isSet(object.numTxs) ? String(object.numTxs) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = message.blockSize);
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = message.numTxs);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d3e9cfdd444b254e$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = (_a = object.blockSize) !== null && _a !== void 0 ? _a : "0";
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = (_b = object.numTxs) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $d3e9cfdd444b254e$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
module.exports.TxProof = {
    encode (message, writer = $d3e9cfdd444b254e$var$minimal_1.default.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $fqyds.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d3e9cfdd444b254e$var$minimal_1.default.Reader ? input : new $d3e9cfdd444b254e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d3e9cfdd444b254e$var$createBaseTxProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $fqyds.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rootHash: $d3e9cfdd444b254e$var$isSet(object.rootHash) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.rootHash) : new Uint8Array(),
            data: $d3e9cfdd444b254e$var$isSet(object.data) ? $d3e9cfdd444b254e$var$bytesFromBase64(object.data) : new Uint8Array(),
            proof: $d3e9cfdd444b254e$var$isSet(object.proof) ? $fqyds.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = $d3e9cfdd444b254e$var$base64FromBytes(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = $d3e9cfdd444b254e$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $fqyds.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d3e9cfdd444b254e$var$createBaseTxProof();
        message.rootHash = (_a = object.rootHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $fqyds.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
var $d3e9cfdd444b254e$var$globalThis = (()=>{
    if (typeof $d3e9cfdd444b254e$var$globalThis !== "undefined") return $d3e9cfdd444b254e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d3e9cfdd444b254e$var$atob = $d3e9cfdd444b254e$var$globalThis.atob || ((b64)=>$d3e9cfdd444b254e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d3e9cfdd444b254e$var$bytesFromBase64(b64) {
    const bin = $d3e9cfdd444b254e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d3e9cfdd444b254e$var$btoa = $d3e9cfdd444b254e$var$globalThis.btoa || ((bin)=>$d3e9cfdd444b254e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d3e9cfdd444b254e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d3e9cfdd444b254e$var$btoa(bin.join(""));
}
function $d3e9cfdd444b254e$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $d3e9cfdd444b254e$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $d3e9cfdd444b254e$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $d3e9cfdd444b254e$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
function $d3e9cfdd444b254e$var$longToString(long) {
    return long.toString();
}
if ($d3e9cfdd444b254e$var$minimal_1.default.util.Long !== $d3e9cfdd444b254e$var$long_1.default) {
    $d3e9cfdd444b254e$var$minimal_1.default.util.Long = $d3e9cfdd444b254e$var$long_1.default;
    $d3e9cfdd444b254e$var$minimal_1.default.configure();
}
function $d3e9cfdd444b254e$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("fqyds", function(module, exports) {
"use strict";
var $b3b3d35575e9e3b3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProofOps = module.exports.ProofOp = module.exports.DominoOp = module.exports.ValueOp = module.exports.Proof = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b3b3d35575e9e3b3$var$long_1 = $b3b3d35575e9e3b3$var$__importDefault((parcelRequire("3gmZQ")));

const $b3b3d35575e9e3b3$var$minimal_1 = $b3b3d35575e9e3b3$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.crypto";
function $b3b3d35575e9e3b3$var$createBaseProof() {
    return {
        total: "0",
        index: "0",
        leafHash: new Uint8Array(),
        aunts: []
    };
}
module.exports.Proof = {
    encode (message, writer = $b3b3d35575e9e3b3$var$minimal_1.default.Writer.create()) {
        if (message.total !== "0") writer.uint32(8).int64(message.total);
        if (message.index !== "0") writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3b3d35575e9e3b3$var$minimal_1.default.Reader ? input : new $b3b3d35575e9e3b3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3b3d35575e9e3b3$var$createBaseProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = $b3b3d35575e9e3b3$var$longToString(reader.int64());
                    break;
                case 2:
                    message.index = $b3b3d35575e9e3b3$var$longToString(reader.int64());
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: $b3b3d35575e9e3b3$var$isSet(object.total) ? String(object.total) : "0",
            index: $b3b3d35575e9e3b3$var$isSet(object.index) ? String(object.index) : "0",
            leafHash: $b3b3d35575e9e3b3$var$isSet(object.leafHash) ? $b3b3d35575e9e3b3$var$bytesFromBase64(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object === null || object === void 0 ? void 0 : object.aunts) ? object.aunts.map((e)=>$b3b3d35575e9e3b3$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = message.total);
        message.index !== undefined && (obj.index = message.index);
        message.leafHash !== undefined && (obj.leafHash = $b3b3d35575e9e3b3$var$base64FromBytes(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>$b3b3d35575e9e3b3$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b3b3d35575e9e3b3$var$createBaseProof();
        message.total = (_a = object.total) !== null && _a !== void 0 ? _a : "0";
        message.index = (_b = object.index) !== null && _b !== void 0 ? _b : "0";
        message.leafHash = (_c = object.leafHash) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.aunts = ((_d = object.aunts) === null || _d === void 0 ? void 0 : _d.map((e)=>e)) || [];
        return message;
    }
};
function $b3b3d35575e9e3b3$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
module.exports.ValueOp = {
    encode (message, writer = $b3b3d35575e9e3b3$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) module.exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3b3d35575e9e3b3$var$minimal_1.default.Reader ? input : new $b3b3d35575e9e3b3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3b3d35575e9e3b3$var$createBaseValueOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = module.exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $b3b3d35575e9e3b3$var$isSet(object.key) ? $b3b3d35575e9e3b3$var$bytesFromBase64(object.key) : new Uint8Array(),
            proof: $b3b3d35575e9e3b3$var$isSet(object.proof) ? module.exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $b3b3d35575e9e3b3$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? module.exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b3b3d35575e9e3b3$var$createBaseValueOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? module.exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $b3b3d35575e9e3b3$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
module.exports.DominoOp = {
    encode (message, writer = $b3b3d35575e9e3b3$var$minimal_1.default.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3b3d35575e9e3b3$var$minimal_1.default.Reader ? input : new $b3b3d35575e9e3b3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3b3d35575e9e3b3$var$createBaseDominoOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $b3b3d35575e9e3b3$var$isSet(object.key) ? String(object.key) : "",
            input: $b3b3d35575e9e3b3$var$isSet(object.input) ? String(object.input) : "",
            output: $b3b3d35575e9e3b3$var$isSet(object.output) ? String(object.output) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b3b3d35575e9e3b3$var$createBaseDominoOp();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.input = (_b = object.input) !== null && _b !== void 0 ? _b : "";
        message.output = (_c = object.output) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b3b3d35575e9e3b3$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
module.exports.ProofOp = {
    encode (message, writer = $b3b3d35575e9e3b3$var$minimal_1.default.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3b3d35575e9e3b3$var$minimal_1.default.Reader ? input : new $b3b3d35575e9e3b3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3b3d35575e9e3b3$var$createBaseProofOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: $b3b3d35575e9e3b3$var$isSet(object.type) ? String(object.type) : "",
            key: $b3b3d35575e9e3b3$var$isSet(object.key) ? $b3b3d35575e9e3b3$var$bytesFromBase64(object.key) : new Uint8Array(),
            data: $b3b3d35575e9e3b3$var$isSet(object.data) ? $b3b3d35575e9e3b3$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = $b3b3d35575e9e3b3$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = $b3b3d35575e9e3b3$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b3b3d35575e9e3b3$var$createBaseProofOp();
        message.type = (_a = object.type) !== null && _a !== void 0 ? _a : "";
        message.key = (_b = object.key) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.data = (_c = object.data) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $b3b3d35575e9e3b3$var$createBaseProofOps() {
    return {
        ops: []
    };
}
module.exports.ProofOps = {
    encode (message, writer = $b3b3d35575e9e3b3$var$minimal_1.default.Writer.create()) {
        for (const v of message.ops)module.exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3b3d35575e9e3b3$var$minimal_1.default.Reader ? input : new $b3b3d35575e9e3b3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3b3d35575e9e3b3$var$createBaseProofOps();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push(module.exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ops: Array.isArray(object === null || object === void 0 ? void 0 : object.ops) ? object.ops.map((e)=>module.exports.ProofOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? module.exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b3b3d35575e9e3b3$var$createBaseProofOps();
        message.ops = ((_a = object.ops) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.ProofOp.fromPartial(e))) || [];
        return message;
    }
};
var $b3b3d35575e9e3b3$var$globalThis = (()=>{
    if (typeof $b3b3d35575e9e3b3$var$globalThis !== "undefined") return $b3b3d35575e9e3b3$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b3b3d35575e9e3b3$var$atob = $b3b3d35575e9e3b3$var$globalThis.atob || ((b64)=>$b3b3d35575e9e3b3$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b3b3d35575e9e3b3$var$bytesFromBase64(b64) {
    const bin = $b3b3d35575e9e3b3$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b3b3d35575e9e3b3$var$btoa = $b3b3d35575e9e3b3$var$globalThis.btoa || ((bin)=>$b3b3d35575e9e3b3$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b3b3d35575e9e3b3$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b3b3d35575e9e3b3$var$btoa(bin.join(""));
}
function $b3b3d35575e9e3b3$var$longToString(long) {
    return long.toString();
}
if ($b3b3d35575e9e3b3$var$minimal_1.default.util.Long !== $b3b3d35575e9e3b3$var$long_1.default) {
    $b3b3d35575e9e3b3$var$minimal_1.default.util.Long = $b3b3d35575e9e3b3$var$long_1.default;
    $b3b3d35575e9e3b3$var$minimal_1.default.configure();
}
function $b3b3d35575e9e3b3$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("eMHox", function(module, exports) {
"use strict";
var $ac3735afd89ecf99$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consensus = module.exports.App = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ac3735afd89ecf99$var$long_1 = $ac3735afd89ecf99$var$__importDefault((parcelRequire("3gmZQ")));

const $ac3735afd89ecf99$var$minimal_1 = $ac3735afd89ecf99$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.version";
function $ac3735afd89ecf99$var$createBaseApp() {
    return {
        protocol: "0",
        software: ""
    };
}
module.exports.App = {
    encode (message, writer = $ac3735afd89ecf99$var$minimal_1.default.Writer.create()) {
        if (message.protocol !== "0") writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ac3735afd89ecf99$var$minimal_1.default.Reader ? input : new $ac3735afd89ecf99$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ac3735afd89ecf99$var$createBaseApp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = $ac3735afd89ecf99$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            protocol: $ac3735afd89ecf99$var$isSet(object.protocol) ? String(object.protocol) : "0",
            software: $ac3735afd89ecf99$var$isSet(object.software) ? String(object.software) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = message.protocol);
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ac3735afd89ecf99$var$createBaseApp();
        message.protocol = (_a = object.protocol) !== null && _a !== void 0 ? _a : "0";
        message.software = (_b = object.software) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $ac3735afd89ecf99$var$createBaseConsensus() {
    return {
        block: "0",
        app: "0"
    };
}
module.exports.Consensus = {
    encode (message, writer = $ac3735afd89ecf99$var$minimal_1.default.Writer.create()) {
        if (message.block !== "0") writer.uint32(8).uint64(message.block);
        if (message.app !== "0") writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ac3735afd89ecf99$var$minimal_1.default.Reader ? input : new $ac3735afd89ecf99$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ac3735afd89ecf99$var$createBaseConsensus();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $ac3735afd89ecf99$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.app = $ac3735afd89ecf99$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: $ac3735afd89ecf99$var$isSet(object.block) ? String(object.block) : "0",
            app: $ac3735afd89ecf99$var$isSet(object.app) ? String(object.app) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block);
        message.app !== undefined && (obj.app = message.app);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ac3735afd89ecf99$var$createBaseConsensus();
        message.block = (_a = object.block) !== null && _a !== void 0 ? _a : "0";
        message.app = (_b = object.app) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $ac3735afd89ecf99$var$longToString(long) {
    return long.toString();
}
if ($ac3735afd89ecf99$var$minimal_1.default.util.Long !== $ac3735afd89ecf99$var$long_1.default) {
    $ac3735afd89ecf99$var$minimal_1.default.util.Long = $ac3735afd89ecf99$var$long_1.default;
    $ac3735afd89ecf99$var$minimal_1.default.configure();
}
function $ac3735afd89ecf99$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("94ExP", function(module, exports) {
"use strict";
var $69b3f01a2cf1eb6e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleValidator = module.exports.Validator = module.exports.ValidatorSet = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $69b3f01a2cf1eb6e$var$long_1 = $69b3f01a2cf1eb6e$var$__importDefault((parcelRequire("3gmZQ")));

const $69b3f01a2cf1eb6e$var$minimal_1 = $69b3f01a2cf1eb6e$var$__importDefault((parcelRequire("1wC51")));

var $9nqYs = parcelRequire("9nqYs");
module.exports.protobufPackage = "tendermint.types";
function $69b3f01a2cf1eb6e$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: "0"
    };
}
module.exports.ValidatorSet = {
    encode (message, writer = $69b3f01a2cf1eb6e$var$minimal_1.default.Writer.create()) {
        for (const v of message.validators)module.exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) module.exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (message.totalVotingPower !== "0") writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $69b3f01a2cf1eb6e$var$minimal_1.default.Reader ? input : new $69b3f01a2cf1eb6e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $69b3f01a2cf1eb6e$var$createBaseValidatorSet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = $69b3f01a2cf1eb6e$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map((e)=>module.exports.Validator.fromJSON(e)) : [],
            proposer: $69b3f01a2cf1eb6e$var$isSet(object.proposer) ? module.exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: $69b3f01a2cf1eb6e$var$isSet(object.totalVotingPower) ? String(object.totalVotingPower) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? module.exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = message.totalVotingPower);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $69b3f01a2cf1eb6e$var$createBaseValidatorSet();
        message.validators = ((_a = object.validators) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.Validator.fromPartial(e))) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? module.exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = (_b = object.totalVotingPower) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $69b3f01a2cf1eb6e$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: "0",
        proposerPriority: "0"
    };
}
module.exports.Validator = {
    encode (message, writer = $69b3f01a2cf1eb6e$var$minimal_1.default.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $9nqYs.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (message.votingPower !== "0") writer.uint32(24).int64(message.votingPower);
        if (message.proposerPriority !== "0") writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $69b3f01a2cf1eb6e$var$minimal_1.default.Reader ? input : new $69b3f01a2cf1eb6e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $69b3f01a2cf1eb6e$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $9nqYs.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = $69b3f01a2cf1eb6e$var$longToString(reader.int64());
                    break;
                case 4:
                    message.proposerPriority = $69b3f01a2cf1eb6e$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $69b3f01a2cf1eb6e$var$isSet(object.address) ? $69b3f01a2cf1eb6e$var$bytesFromBase64(object.address) : new Uint8Array(),
            pubKey: $69b3f01a2cf1eb6e$var$isSet(object.pubKey) ? $9nqYs.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: $69b3f01a2cf1eb6e$var$isSet(object.votingPower) ? String(object.votingPower) : "0",
            proposerPriority: $69b3f01a2cf1eb6e$var$isSet(object.proposerPriority) ? String(object.proposerPriority) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = $69b3f01a2cf1eb6e$var$base64FromBytes(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $9nqYs.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = message.votingPower);
        message.proposerPriority !== undefined && (obj.proposerPriority = message.proposerPriority);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $69b3f01a2cf1eb6e$var$createBaseValidator();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $9nqYs.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = (_b = object.votingPower) !== null && _b !== void 0 ? _b : "0";
        message.proposerPriority = (_c = object.proposerPriority) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $69b3f01a2cf1eb6e$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: "0"
    };
}
module.exports.SimpleValidator = {
    encode (message, writer = $69b3f01a2cf1eb6e$var$minimal_1.default.Writer.create()) {
        if (message.pubKey !== undefined) $9nqYs.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (message.votingPower !== "0") writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $69b3f01a2cf1eb6e$var$minimal_1.default.Reader ? input : new $69b3f01a2cf1eb6e$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $69b3f01a2cf1eb6e$var$createBaseSimpleValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $9nqYs.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = $69b3f01a2cf1eb6e$var$longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: $69b3f01a2cf1eb6e$var$isSet(object.pubKey) ? $9nqYs.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: $69b3f01a2cf1eb6e$var$isSet(object.votingPower) ? String(object.votingPower) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $9nqYs.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = message.votingPower);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $69b3f01a2cf1eb6e$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $9nqYs.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = (_a = object.votingPower) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
var $69b3f01a2cf1eb6e$var$globalThis = (()=>{
    if (typeof $69b3f01a2cf1eb6e$var$globalThis !== "undefined") return $69b3f01a2cf1eb6e$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $69b3f01a2cf1eb6e$var$atob = $69b3f01a2cf1eb6e$var$globalThis.atob || ((b64)=>$69b3f01a2cf1eb6e$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $69b3f01a2cf1eb6e$var$bytesFromBase64(b64) {
    const bin = $69b3f01a2cf1eb6e$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $69b3f01a2cf1eb6e$var$btoa = $69b3f01a2cf1eb6e$var$globalThis.btoa || ((bin)=>$69b3f01a2cf1eb6e$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $69b3f01a2cf1eb6e$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $69b3f01a2cf1eb6e$var$btoa(bin.join(""));
}
function $69b3f01a2cf1eb6e$var$longToString(long) {
    return long.toString();
}
if ($69b3f01a2cf1eb6e$var$minimal_1.default.util.Long !== $69b3f01a2cf1eb6e$var$long_1.default) {
    $69b3f01a2cf1eb6e$var$minimal_1.default.util.Long = $69b3f01a2cf1eb6e$var$long_1.default;
    $69b3f01a2cf1eb6e$var$minimal_1.default.configure();
}
function $69b3f01a2cf1eb6e$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("9nqYs", function(module, exports) {
"use strict";
var $6d3b2f8cf73314f6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6d3b2f8cf73314f6$var$long_1 = $6d3b2f8cf73314f6$var$__importDefault((parcelRequire("3gmZQ")));

const $6d3b2f8cf73314f6$var$minimal_1 = $6d3b2f8cf73314f6$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.crypto";
function $6d3b2f8cf73314f6$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
module.exports.PublicKey = {
    encode (message, writer = $6d3b2f8cf73314f6$var$minimal_1.default.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d3b2f8cf73314f6$var$minimal_1.default.Reader ? input : new $6d3b2f8cf73314f6$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d3b2f8cf73314f6$var$createBasePublicKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ed25519: $6d3b2f8cf73314f6$var$isSet(object.ed25519) ? $6d3b2f8cf73314f6$var$bytesFromBase64(object.ed25519) : undefined,
            secp256k1: $6d3b2f8cf73314f6$var$isSet(object.secp256k1) ? $6d3b2f8cf73314f6$var$bytesFromBase64(object.secp256k1) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? $6d3b2f8cf73314f6$var$base64FromBytes(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? $6d3b2f8cf73314f6$var$base64FromBytes(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $6d3b2f8cf73314f6$var$createBasePublicKey();
        message.ed25519 = (_a = object.ed25519) !== null && _a !== void 0 ? _a : undefined;
        message.secp256k1 = (_b = object.secp256k1) !== null && _b !== void 0 ? _b : undefined;
        return message;
    }
};
var $6d3b2f8cf73314f6$var$globalThis = (()=>{
    if (typeof $6d3b2f8cf73314f6$var$globalThis !== "undefined") return $6d3b2f8cf73314f6$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $6d3b2f8cf73314f6$var$atob = $6d3b2f8cf73314f6$var$globalThis.atob || ((b64)=>$6d3b2f8cf73314f6$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $6d3b2f8cf73314f6$var$bytesFromBase64(b64) {
    const bin = $6d3b2f8cf73314f6$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $6d3b2f8cf73314f6$var$btoa = $6d3b2f8cf73314f6$var$globalThis.btoa || ((bin)=>$6d3b2f8cf73314f6$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $6d3b2f8cf73314f6$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $6d3b2f8cf73314f6$var$btoa(bin.join(""));
}
if ($6d3b2f8cf73314f6$var$minimal_1.default.util.Long !== $6d3b2f8cf73314f6$var$long_1.default) {
    $6d3b2f8cf73314f6$var$minimal_1.default.util.Long = $6d3b2f8cf73314f6$var$long_1.default;
    $6d3b2f8cf73314f6$var$minimal_1.default.configure();
}
function $6d3b2f8cf73314f6$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("fV2Ok", function(module, exports) {
"use strict";
var $b96e5c0cd6a4e791$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b96e5c0cd6a4e791$var$long_1 = $b96e5c0cd6a4e791$var$__importDefault((parcelRequire("3gmZQ")));

const $b96e5c0cd6a4e791$var$minimal_1 = $b96e5c0cd6a4e791$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $b96e5c0cd6a4e791$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
module.exports.Any = {
    encode (message, writer = $b96e5c0cd6a4e791$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b96e5c0cd6a4e791$var$minimal_1.default.Reader ? input : new $b96e5c0cd6a4e791$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b96e5c0cd6a4e791$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: $b96e5c0cd6a4e791$var$isSet(object.typeUrl) ? String(object.typeUrl) : "",
            value: $b96e5c0cd6a4e791$var$isSet(object.value) ? $b96e5c0cd6a4e791$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $b96e5c0cd6a4e791$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b96e5c0cd6a4e791$var$createBaseAny();
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $b96e5c0cd6a4e791$var$globalThis = (()=>{
    if (typeof $b96e5c0cd6a4e791$var$globalThis !== "undefined") return $b96e5c0cd6a4e791$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $b96e5c0cd6a4e791$var$atob = $b96e5c0cd6a4e791$var$globalThis.atob || ((b64)=>$b96e5c0cd6a4e791$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $b96e5c0cd6a4e791$var$bytesFromBase64(b64) {
    const bin = $b96e5c0cd6a4e791$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $b96e5c0cd6a4e791$var$btoa = $b96e5c0cd6a4e791$var$globalThis.btoa || ((bin)=>$b96e5c0cd6a4e791$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $b96e5c0cd6a4e791$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $b96e5c0cd6a4e791$var$btoa(bin.join(""));
}
if ($b96e5c0cd6a4e791$var$minimal_1.default.util.Long !== $b96e5c0cd6a4e791$var$long_1.default) {
    $b96e5c0cd6a4e791$var$minimal_1.default.util.Long = $b96e5c0cd6a4e791$var$long_1.default;
    $b96e5c0cd6a4e791$var$minimal_1.default.configure();
}
function $b96e5c0cd6a4e791$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("byZvw", function(module, exports) {
"use strict";
var $86b294c3ffe97ed9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $86b294c3ffe97ed9$var$long_1 = $86b294c3ffe97ed9$var$__importDefault((parcelRequire("3gmZQ")));

const $86b294c3ffe97ed9$var$minimal_1 = $86b294c3ffe97ed9$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $86b294c3ffe97ed9$var$createBaseDuration() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Duration = {
    encode (message, writer = $86b294c3ffe97ed9$var$minimal_1.default.Writer.create()) {
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $86b294c3ffe97ed9$var$minimal_1.default.Reader ? input : new $86b294c3ffe97ed9$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $86b294c3ffe97ed9$var$createBaseDuration();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = $86b294c3ffe97ed9$var$longToString(reader.int64());
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: $86b294c3ffe97ed9$var$isSet(object.seconds) ? String(object.seconds) : "0",
            nanos: $86b294c3ffe97ed9$var$isSet(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = message.seconds);
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $86b294c3ffe97ed9$var$createBaseDuration();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $86b294c3ffe97ed9$var$longToString(long) {
    return long.toString();
}
if ($86b294c3ffe97ed9$var$minimal_1.default.util.Long !== $86b294c3ffe97ed9$var$long_1.default) {
    $86b294c3ffe97ed9$var$minimal_1.default.util.Long = $86b294c3ffe97ed9$var$long_1.default;
    $86b294c3ffe97ed9$var$minimal_1.default.configure();
}
function $86b294c3ffe97ed9$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("71CQ5", function(module, exports) {
"use strict";
var $51d6c102d275a75d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgRevokeResponse = module.exports.MsgRevoke = module.exports.MsgGrantResponse = module.exports.MsgExec = module.exports.MsgExecResponse = module.exports.MsgGrant = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $51d6c102d275a75d$var$long_1 = $51d6c102d275a75d$var$__importDefault((parcelRequire("3gmZQ")));

const $51d6c102d275a75d$var$minimal_1 = $51d6c102d275a75d$var$__importDefault((parcelRequire("1wC51")));

var $kVVW2 = parcelRequire("kVVW2");

var $fV2Ok = parcelRequire("fV2Ok");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $51d6c102d275a75d$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
module.exports.MsgGrant = {
    encode (message, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $kVVW2.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $kVVW2.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: $51d6c102d275a75d$var$isSet(object.granter) ? String(object.granter) : "",
            grantee: $51d6c102d275a75d$var$isSet(object.grantee) ? String(object.grantee) : "",
            grant: $51d6c102d275a75d$var$isSet(object.grant) ? $kVVW2.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $kVVW2.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $51d6c102d275a75d$var$createBaseMsgGrant();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.grant = object.grant !== undefined && object.grant !== null ? $kVVW2.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $51d6c102d275a75d$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
module.exports.MsgExecResponse = {
    encode (message, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            results: Array.isArray(object === null || object === void 0 ? void 0 : object.results) ? object.results.map((e)=>$51d6c102d275a75d$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>$51d6c102d275a75d$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $51d6c102d275a75d$var$createBaseMsgExecResponse();
        message.results = ((_a = object.results) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $51d6c102d275a75d$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
module.exports.MsgExec = {
    encode (message, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$fV2Ok.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($fV2Ok.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: $51d6c102d275a75d$var$isSet(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object === null || object === void 0 ? void 0 : object.msgs) ? object.msgs.map((e)=>$fV2Ok.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $fV2Ok.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $51d6c102d275a75d$var$createBaseMsgExec();
        message.grantee = (_a = object.grantee) !== null && _a !== void 0 ? _a : "";
        message.msgs = ((_b = object.msgs) === null || _b === void 0 ? void 0 : _b.map((e)=>$fV2Ok.Any.fromPartial(e))) || [];
        return message;
    }
};
function $51d6c102d275a75d$var$createBaseMsgGrantResponse() {
    return {};
}
module.exports.MsgGrantResponse = {
    encode (_, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $51d6c102d275a75d$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $51d6c102d275a75d$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
module.exports.MsgRevoke = {
    encode (message, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgRevoke();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: $51d6c102d275a75d$var$isSet(object.granter) ? String(object.granter) : "",
            grantee: $51d6c102d275a75d$var$isSet(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: $51d6c102d275a75d$var$isSet(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $51d6c102d275a75d$var$createBaseMsgRevoke();
        message.granter = (_a = object.granter) !== null && _a !== void 0 ? _a : "";
        message.grantee = (_b = object.grantee) !== null && _b !== void 0 ? _b : "";
        message.msgTypeUrl = (_c = object.msgTypeUrl) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $51d6c102d275a75d$var$createBaseMsgRevokeResponse() {
    return {};
}
module.exports.MsgRevokeResponse = {
    encode (_, writer = $51d6c102d275a75d$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $51d6c102d275a75d$var$minimal_1.default.Reader ? input : new $51d6c102d275a75d$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $51d6c102d275a75d$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $51d6c102d275a75d$var$createBaseMsgRevokeResponse();
        return message;
    }
};
var $51d6c102d275a75d$var$globalThis = (()=>{
    if (typeof $51d6c102d275a75d$var$globalThis !== "undefined") return $51d6c102d275a75d$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $51d6c102d275a75d$var$atob = $51d6c102d275a75d$var$globalThis.atob || ((b64)=>$51d6c102d275a75d$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $51d6c102d275a75d$var$bytesFromBase64(b64) {
    const bin = $51d6c102d275a75d$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $51d6c102d275a75d$var$btoa = $51d6c102d275a75d$var$globalThis.btoa || ((bin)=>$51d6c102d275a75d$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $51d6c102d275a75d$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $51d6c102d275a75d$var$btoa(bin.join(""));
}
if ($51d6c102d275a75d$var$minimal_1.default.util.Long !== $51d6c102d275a75d$var$long_1.default) {
    $51d6c102d275a75d$var$minimal_1.default.util.Long = $51d6c102d275a75d$var$long_1.default;
    $51d6c102d275a75d$var$minimal_1.default.configure();
}
function $51d6c102d275a75d$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("kVVW2", function(module, exports) {
"use strict";
var $f3d6123968d40b4a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Grant = module.exports.GenericAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f3d6123968d40b4a$var$long_1 = $f3d6123968d40b4a$var$__importDefault((parcelRequire("3gmZQ")));

const $f3d6123968d40b4a$var$minimal_1 = $f3d6123968d40b4a$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $fV2Ok = parcelRequire("fV2Ok");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $f3d6123968d40b4a$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
module.exports.GenericAuthorization = {
    encode (message, writer = $f3d6123968d40b4a$var$minimal_1.default.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f3d6123968d40b4a$var$minimal_1.default.Reader ? input : new $f3d6123968d40b4a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f3d6123968d40b4a$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msg: $f3d6123968d40b4a$var$isSet(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f3d6123968d40b4a$var$createBaseGenericAuthorization();
        message.msg = (_a = object.msg) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $f3d6123968d40b4a$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
module.exports.Grant = {
    encode (message, writer = $f3d6123968d40b4a$var$minimal_1.default.Writer.create()) {
        if (message.authorization !== undefined) $fV2Ok.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $gqzXD.Timestamp.encode($f3d6123968d40b4a$var$toTimestamp(message.expiration), writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f3d6123968d40b4a$var$minimal_1.default.Reader ? input : new $f3d6123968d40b4a$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f3d6123968d40b4a$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $f3d6123968d40b4a$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authorization: $f3d6123968d40b4a$var$isSet(object.authorization) ? $fV2Ok.Any.fromJSON(object.authorization) : undefined,
            expiration: $f3d6123968d40b4a$var$isSet(object.expiration) ? $f3d6123968d40b4a$var$fromJsonTimestamp(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $fV2Ok.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = message.expiration.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f3d6123968d40b4a$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $fV2Ok.Any.fromPartial(object.authorization) : undefined;
        message.expiration = (_a = object.expiration) !== null && _a !== void 0 ? _a : undefined;
        return message;
    }
};
function $f3d6123968d40b4a$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $f3d6123968d40b4a$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $f3d6123968d40b4a$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $f3d6123968d40b4a$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
if ($f3d6123968d40b4a$var$minimal_1.default.util.Long !== $f3d6123968d40b4a$var$long_1.default) {
    $f3d6123968d40b4a$var$minimal_1.default.util.Long = $f3d6123968d40b4a$var$long_1.default;
    $f3d6123968d40b4a$var$minimal_1.default.configure();
}
function $f3d6123968d40b4a$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("1mq1q", function(module, exports) {
"use strict";
var $0fdc07f3f76ee5c0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0fdc07f3f76ee5c0$var$long_1 = $0fdc07f3f76ee5c0$var$__importDefault((parcelRequire("3gmZQ")));

const $0fdc07f3f76ee5c0$var$minimal_1 = $0fdc07f3f76ee5c0$var$__importDefault((parcelRequire("1wC51")));

var $4nMKf = parcelRequire("4nMKf");

var $fV2Ok = parcelRequire("fV2Ok");

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
function $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode (message, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        if (message.content !== undefined) $fV2Ok.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$lNGQx.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: $0fdc07f3f76ee5c0$var$isSet(object.content) ? $fV2Ok.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.initialDeposit) ? object.initialDeposit.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            proposer: $0fdc07f3f76ee5c0$var$isSet(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $fV2Ok.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $fV2Ok.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = ((_a = object.initialDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.proposer = (_b = object.proposer) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: "0"
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $0fdc07f3f76ee5c0$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $0fdc07f3f76ee5c0$var$isSet(object.proposalId) ? String(object.proposalId) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgVote() {
    return {
        proposalId: "0",
        voter: "",
        option: 0
    };
}
module.exports.MsgVote = {
    encode (message, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $0fdc07f3f76ee5c0$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $0fdc07f3f76ee5c0$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $0fdc07f3f76ee5c0$var$isSet(object.voter) ? String(object.voter) : "",
            option: $0fdc07f3f76ee5c0$var$isSet(object.option) ? (0, $4nMKf.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $4nMKf.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVote();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.option = (_c = object.option) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode (_, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: "0",
        voter: "",
        options: []
    };
}
module.exports.MsgVoteWeighted = {
    encode (message, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$4nMKf.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $0fdc07f3f76ee5c0$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($4nMKf.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $0fdc07f3f76ee5c0$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $0fdc07f3f76ee5c0$var$isSet(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map((e)=>$4nMKf.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $4nMKf.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeighted();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map((e)=>$4nMKf.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
module.exports.MsgVoteWeightedResponse = {
    encode (_, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgDeposit() {
    return {
        proposalId: "0",
        depositor: "",
        amount: []
    };
}
module.exports.MsgDeposit = {
    encode (message, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$lNGQx.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $0fdc07f3f76ee5c0$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $0fdc07f3f76ee5c0$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            depositor: $0fdc07f3f76ee5c0$var$isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgDeposit();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$createBaseMsgDepositResponse() {
    return {};
}
module.exports.MsgDepositResponse = {
    encode (_, writer = $0fdc07f3f76ee5c0$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0fdc07f3f76ee5c0$var$minimal_1.default.Reader ? input : new $0fdc07f3f76ee5c0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0fdc07f3f76ee5c0$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $0fdc07f3f76ee5c0$var$longToString(long) {
    return long.toString();
}
if ($0fdc07f3f76ee5c0$var$minimal_1.default.util.Long !== $0fdc07f3f76ee5c0$var$long_1.default) {
    $0fdc07f3f76ee5c0$var$minimal_1.default.util.Long = $0fdc07f3f76ee5c0$var$long_1.default;
    $0fdc07f3f76ee5c0$var$minimal_1.default.configure();
}
function $0fdc07f3f76ee5c0$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("4nMKf", function(module, exports) {
"use strict";
var $330f1f245d2773cf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.TextProposal = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $330f1f245d2773cf$var$long_1 = $330f1f245d2773cf$var$__importDefault((parcelRequire("3gmZQ")));

const $330f1f245d2773cf$var$minimal_1 = $330f1f245d2773cf$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $lNGQx = parcelRequire("lNGQx");

var $fV2Ok = parcelRequire("fV2Ok");

var $byZvw = parcelRequire("byZvw");
module.exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $330f1f245d2773cf$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($330f1f245d2773cf$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $330f1f245d2773cf$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $330f1f245d2773cf$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $330f1f245d2773cf$var$voteOptionFromJSON;
function $330f1f245d2773cf$var$voteOptionToJSON(object) {
    switch(object){
        case $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $330f1f245d2773cf$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        default:
            return "UNKNOWN";
    }
}
module.exports.voteOptionToJSON = $330f1f245d2773cf$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $330f1f245d2773cf$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default propopsal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($330f1f245d2773cf$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $330f1f245d2773cf$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $330f1f245d2773cf$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $330f1f245d2773cf$var$proposalStatusFromJSON;
function $330f1f245d2773cf$var$proposalStatusToJSON(object) {
    switch(object){
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $330f1f245d2773cf$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        default:
            return "UNKNOWN";
    }
}
module.exports.proposalStatusToJSON = $330f1f245d2773cf$var$proposalStatusToJSON;
function $330f1f245d2773cf$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
module.exports.WeightedVoteOption = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: $330f1f245d2773cf$var$isSet(object.option) ? $330f1f245d2773cf$var$voteOptionFromJSON(object.option) : 0,
            weight: $330f1f245d2773cf$var$isSet(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $330f1f245d2773cf$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $330f1f245d2773cf$var$createBaseWeightedVoteOption();
        message.option = (_a = object.option) !== null && _a !== void 0 ? _a : 0;
        message.weight = (_b = object.weight) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.TextProposal = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseTextProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $330f1f245d2773cf$var$isSet(object.title) ? String(object.title) : "",
            description: $330f1f245d2773cf$var$isSet(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $330f1f245d2773cf$var$createBaseTextProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseDeposit() {
    return {
        proposalId: "0",
        depositor: "",
        amount: []
    };
}
module.exports.Deposit = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$lNGQx.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $330f1f245d2773cf$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $330f1f245d2773cf$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            depositor: $330f1f245d2773cf$var$isSet(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $330f1f245d2773cf$var$createBaseDeposit();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseProposal() {
    return {
        proposalId: "0",
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
module.exports.Proposal = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $fV2Ok.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $gqzXD.Timestamp.encode($330f1f245d2773cf$var$toTimestamp(message.submitTime), writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $gqzXD.Timestamp.encode($330f1f245d2773cf$var$toTimestamp(message.depositEndTime), writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$lNGQx.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $gqzXD.Timestamp.encode($330f1f245d2773cf$var$toTimestamp(message.votingStartTime), writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $gqzXD.Timestamp.encode($330f1f245d2773cf$var$toTimestamp(message.votingEndTime), writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $330f1f245d2773cf$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.content = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $330f1f245d2773cf$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.depositEndTime = $330f1f245d2773cf$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.totalDeposit.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $330f1f245d2773cf$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.votingEndTime = $330f1f245d2773cf$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $330f1f245d2773cf$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            content: $330f1f245d2773cf$var$isSet(object.content) ? $fV2Ok.Any.fromJSON(object.content) : undefined,
            status: $330f1f245d2773cf$var$isSet(object.status) ? $330f1f245d2773cf$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: $330f1f245d2773cf$var$isSet(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: $330f1f245d2773cf$var$isSet(object.submitTime) ? $330f1f245d2773cf$var$fromJsonTimestamp(object.submitTime) : undefined,
            depositEndTime: $330f1f245d2773cf$var$isSet(object.depositEndTime) ? $330f1f245d2773cf$var$fromJsonTimestamp(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.totalDeposit) ? object.totalDeposit.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            votingStartTime: $330f1f245d2773cf$var$isSet(object.votingStartTime) ? $330f1f245d2773cf$var$fromJsonTimestamp(object.votingStartTime) : undefined,
            votingEndTime: $330f1f245d2773cf$var$isSet(object.votingEndTime) ? $330f1f245d2773cf$var$fromJsonTimestamp(object.votingEndTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.content !== undefined && (obj.content = message.content ? $fV2Ok.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $330f1f245d2773cf$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = message.submitTime.toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = message.depositEndTime.toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = message.votingStartTime.toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = message.votingEndTime.toISOString());
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = $330f1f245d2773cf$var$createBaseProposal();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.content = object.content !== undefined && object.content !== null ? $fV2Ok.Any.fromPartial(object.content) : undefined;
        message.status = (_b = object.status) !== null && _b !== void 0 ? _b : 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = (_c = object.submitTime) !== null && _c !== void 0 ? _c : undefined;
        message.depositEndTime = (_d = object.depositEndTime) !== null && _d !== void 0 ? _d : undefined;
        message.totalDeposit = ((_e = object.totalDeposit) === null || _e === void 0 ? void 0 : _e.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.votingStartTime = (_f = object.votingStartTime) !== null && _f !== void 0 ? _f : undefined;
        message.votingEndTime = (_g = object.votingEndTime) !== null && _g !== void 0 ? _g : undefined;
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
module.exports.TallyResult = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yes: $330f1f245d2773cf$var$isSet(object.yes) ? String(object.yes) : "",
            abstain: $330f1f245d2773cf$var$isSet(object.abstain) ? String(object.abstain) : "",
            no: $330f1f245d2773cf$var$isSet(object.no) ? String(object.no) : "",
            noWithVeto: $330f1f245d2773cf$var$isSet(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $330f1f245d2773cf$var$createBaseTallyResult();
        message.yes = (_a = object.yes) !== null && _a !== void 0 ? _a : "";
        message.abstain = (_b = object.abstain) !== null && _b !== void 0 ? _b : "";
        message.no = (_c = object.no) !== null && _c !== void 0 ? _c : "";
        message.noWithVeto = (_d = object.noWithVeto) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseVote() {
    return {
        proposalId: "0",
        voter: "",
        option: 0,
        options: []
    };
}
module.exports.Vote = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.proposalId !== "0") writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = $330f1f245d2773cf$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: $330f1f245d2773cf$var$isSet(object.proposalId) ? String(object.proposalId) : "0",
            voter: $330f1f245d2773cf$var$isSet(object.voter) ? String(object.voter) : "",
            option: $330f1f245d2773cf$var$isSet(object.option) ? $330f1f245d2773cf$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map((e)=>module.exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = message.proposalId);
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $330f1f245d2773cf$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? module.exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $330f1f245d2773cf$var$createBaseVote();
        message.proposalId = (_a = object.proposalId) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.option = (_c = object.option) !== null && _c !== void 0 ? _c : 0;
        message.options = ((_d = object.options) === null || _d === void 0 ? void 0 : _d.map((e)=>module.exports.WeightedVoteOption.fromPartial(e))) || [];
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
module.exports.DepositParams = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        for (const v of message.minDeposit)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $byZvw.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $byZvw.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object === null || object === void 0 ? void 0 : object.minDeposit) ? object.minDeposit.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            maxDepositPeriod: $330f1f245d2773cf$var$isSet(object.maxDepositPeriod) ? $byZvw.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $byZvw.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $330f1f245d2773cf$var$createBaseDepositParams();
        message.minDeposit = ((_a = object.minDeposit) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $byZvw.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
module.exports.VotingParams = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.votingPeriod !== undefined) $byZvw.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $byZvw.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: $330f1f245d2773cf$var$isSet(object.votingPeriod) ? $byZvw.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $byZvw.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $330f1f245d2773cf$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $byZvw.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $330f1f245d2773cf$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
module.exports.TallyParams = {
    encode (message, writer = $330f1f245d2773cf$var$minimal_1.default.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $330f1f245d2773cf$var$minimal_1.default.Reader ? input : new $330f1f245d2773cf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $330f1f245d2773cf$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: $330f1f245d2773cf$var$isSet(object.quorum) ? $330f1f245d2773cf$var$bytesFromBase64(object.quorum) : new Uint8Array(),
            threshold: $330f1f245d2773cf$var$isSet(object.threshold) ? $330f1f245d2773cf$var$bytesFromBase64(object.threshold) : new Uint8Array(),
            vetoThreshold: $330f1f245d2773cf$var$isSet(object.vetoThreshold) ? $330f1f245d2773cf$var$bytesFromBase64(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = $330f1f245d2773cf$var$base64FromBytes(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = $330f1f245d2773cf$var$base64FromBytes(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = $330f1f245d2773cf$var$base64FromBytes(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $330f1f245d2773cf$var$createBaseTallyParams();
        message.quorum = (_a = object.quorum) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.threshold = (_b = object.threshold) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.vetoThreshold = (_c = object.vetoThreshold) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
var $330f1f245d2773cf$var$globalThis = (()=>{
    if (typeof $330f1f245d2773cf$var$globalThis !== "undefined") return $330f1f245d2773cf$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $330f1f245d2773cf$var$atob = $330f1f245d2773cf$var$globalThis.atob || ((b64)=>$330f1f245d2773cf$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $330f1f245d2773cf$var$bytesFromBase64(b64) {
    const bin = $330f1f245d2773cf$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $330f1f245d2773cf$var$btoa = $330f1f245d2773cf$var$globalThis.btoa || ((bin)=>$330f1f245d2773cf$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $330f1f245d2773cf$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $330f1f245d2773cf$var$btoa(bin.join(""));
}
function $330f1f245d2773cf$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $330f1f245d2773cf$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $330f1f245d2773cf$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $330f1f245d2773cf$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
function $330f1f245d2773cf$var$longToString(long) {
    return long.toString();
}
if ($330f1f245d2773cf$var$minimal_1.default.util.Long !== $330f1f245d2773cf$var$long_1.default) {
    $330f1f245d2773cf$var$minimal_1.default.util.Long = $330f1f245d2773cf$var$long_1.default;
    $330f1f245d2773cf$var$minimal_1.default.configure();
}
function $330f1f245d2773cf$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("lkx7P", function(module, exports) {
"use strict";
var $f8752935aaac8daf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgFundCommunityPoolResponse = module.exports.MsgFundCommunityPool = module.exports.MsgWithdrawValidatorCommissionResponse = module.exports.MsgWithdrawValidatorCommission = module.exports.MsgWithdrawDelegatorRewardResponse = module.exports.MsgWithdrawDelegatorReward = module.exports.MsgSetWithdrawAddressResponse = module.exports.MsgSetWithdrawAddress = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f8752935aaac8daf$var$long_1 = $f8752935aaac8daf$var$__importDefault((parcelRequire("3gmZQ")));

const $f8752935aaac8daf$var$minimal_1 = $f8752935aaac8daf$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
function $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
module.exports.MsgSetWithdrawAddress = {
    encode (message, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $f8752935aaac8daf$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: $f8752935aaac8daf$var$isSet(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.withdrawAddress = (_b = object.withdrawAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
module.exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f8752935aaac8daf$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: $f8752935aaac8daf$var$isSet(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: $f8752935aaac8daf$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = (_a = object.delegatorAddress) !== null && _a !== void 0 ? _a : "";
        message.validatorAddress = (_b = object.validatorAddress) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {};
}
module.exports.MsgWithdrawDelegatorRewardResponse = {
    encode (_, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawDelegatorRewardResponse();
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: $f8752935aaac8daf$var$isSet(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = (_a = object.validatorAddress) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {};
}
module.exports.MsgWithdrawValidatorCommissionResponse = {
    encode (_, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f8752935aaac8daf$var$createBaseMsgWithdrawValidatorCommissionResponse();
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
module.exports.MsgFundCommunityPool = {
    encode (message, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            depositor: $f8752935aaac8daf$var$isSet(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f8752935aaac8daf$var$createBaseMsgFundCommunityPool();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $f8752935aaac8daf$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
module.exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $f8752935aaac8daf$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f8752935aaac8daf$var$minimal_1.default.Reader ? input : new $f8752935aaac8daf$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f8752935aaac8daf$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f8752935aaac8daf$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
if ($f8752935aaac8daf$var$minimal_1.default.util.Long !== $f8752935aaac8daf$var$long_1.default) {
    $f8752935aaac8daf$var$minimal_1.default.util.Long = $f8752935aaac8daf$var$long_1.default;
    $f8752935aaac8daf$var$minimal_1.default.configure();
}
function $f8752935aaac8daf$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("lrZui", function(module, exports) {
"use strict";
var $f9dbd0bb86a60d65$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClearAdminResponse = module.exports.MsgClearAdmin = module.exports.MsgUpdateAdminResponse = module.exports.MsgUpdateAdmin = module.exports.MsgMigrateContractResponse = module.exports.MsgMigrateContract = module.exports.MsgExecuteContractResponse = module.exports.MsgExecuteContract = module.exports.MsgInstantiateContractResponse = module.exports.MsgInstantiateContract = module.exports.MsgStoreCodeResponse = module.exports.MsgStoreCode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f9dbd0bb86a60d65$var$long_1 = $f9dbd0bb86a60d65$var$__importDefault((parcelRequire("3gmZQ")));

const $f9dbd0bb86a60d65$var$minimal_1 = $f9dbd0bb86a60d65$var$__importDefault((parcelRequire("1wC51")));

var $e20Kg = parcelRequire("e20Kg");

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
function $f9dbd0bb86a60d65$var$createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined
    };
}
module.exports.MsgStoreCode = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $e20Kg.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgStoreCode();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $e20Kg.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            wasmByteCode: $f9dbd0bb86a60d65$var$isSet(object.wasmByteCode) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: $f9dbd0bb86a60d65$var$isSet(object.instantiatePermission) ? $e20Kg.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $f9dbd0bb86a60d65$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $e20Kg.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgStoreCode();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.wasmByteCode = (_b = object.wasmByteCode) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $e20Kg.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgStoreCodeResponse() {
    return {
        codeId: "0"
    };
}
module.exports.MsgStoreCodeResponse = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.codeId !== "0") writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgStoreCodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = $f9dbd0bb86a60d65$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $f9dbd0bb86a60d65$var$isSet(object.codeId) ? String(object.codeId) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = message.codeId);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgStoreCodeResponse();
        message.codeId = (_a = object.codeId) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: "0",
        label: "",
        msg: new Uint8Array(),
        funds: []
    };
}
module.exports.MsgInstantiateContract = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.codeId !== "0") writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$lNGQx.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = $f9dbd0bb86a60d65$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            admin: $f9dbd0bb86a60d65$var$isSet(object.admin) ? String(object.admin) : "",
            codeId: $f9dbd0bb86a60d65$var$isSet(object.codeId) ? String(object.codeId) : "0",
            label: $f9dbd0bb86a60d65$var$isSet(object.label) ? String(object.label) : "",
            msg: $f9dbd0bb86a60d65$var$isSet(object.msg) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $f9dbd0bb86a60d65$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.codeId = (_c = object.codeId) !== null && _c !== void 0 ? _c : "0";
        message.label = (_d = object.label) !== null && _d !== void 0 ? _d : "";
        message.msg = (_e = object.msg) !== null && _e !== void 0 ? _e : new Uint8Array();
        message.funds = ((_f = object.funds) === null || _f === void 0 ? void 0 : _f.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
module.exports.MsgInstantiateContractResponse = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $f9dbd0bb86a60d65$var$isSet(object.address) ? String(object.address) : "",
            data: $f9dbd0bb86a60d65$var$isSet(object.data) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = $f9dbd0bb86a60d65$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgInstantiateContractResponse();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: []
    };
}
module.exports.MsgExecuteContract = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        for (const v of message.funds)$lNGQx.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgExecuteContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $f9dbd0bb86a60d65$var$isSet(object.contract) ? String(object.contract) : "",
            msg: $f9dbd0bb86a60d65$var$isSet(object.msg) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $f9dbd0bb86a60d65$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgExecuteContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.funds = ((_d = object.funds) === null || _d === void 0 ? void 0 : _d.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array()
    };
}
module.exports.MsgExecuteContractResponse = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgExecuteContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $f9dbd0bb86a60d65$var$isSet(object.data) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $f9dbd0bb86a60d65$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgExecuteContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: "0",
        msg: new Uint8Array()
    };
}
module.exports.MsgMigrateContract = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.codeId !== "0") writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgMigrateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = $f9dbd0bb86a60d65$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $f9dbd0bb86a60d65$var$isSet(object.contract) ? String(object.contract) : "",
            codeId: $f9dbd0bb86a60d65$var$isSet(object.codeId) ? String(object.codeId) : "0",
            msg: $f9dbd0bb86a60d65$var$isSet(object.msg) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.msg !== undefined && (obj.msg = $f9dbd0bb86a60d65$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgMigrateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.codeId = (_c = object.codeId) !== null && _c !== void 0 ? _c : "0";
        message.msg = (_d = object.msg) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array()
    };
}
module.exports.MsgMigrateContractResponse = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgMigrateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $f9dbd0bb86a60d65$var$isSet(object.data) ? $f9dbd0bb86a60d65$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $f9dbd0bb86a60d65$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgMigrateContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: ""
    };
}
module.exports.MsgUpdateAdmin = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            newAdmin: $f9dbd0bb86a60d65$var$isSet(object.newAdmin) ? String(object.newAdmin) : "",
            contract: $f9dbd0bb86a60d65$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.newAdmin = (_b = object.newAdmin) !== null && _b !== void 0 ? _b : "";
        message.contract = (_c = object.contract) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdminResponse() {
    return {};
}
module.exports.MsgUpdateAdminResponse = {
    encode (_, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f9dbd0bb86a60d65$var$createBaseMsgUpdateAdminResponse();
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: ""
    };
}
module.exports.MsgClearAdmin = {
    encode (message, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgClearAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $f9dbd0bb86a60d65$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $f9dbd0bb86a60d65$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgClearAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $f9dbd0bb86a60d65$var$createBaseMsgClearAdminResponse() {
    return {};
}
module.exports.MsgClearAdminResponse = {
    encode (_, writer = $f9dbd0bb86a60d65$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f9dbd0bb86a60d65$var$minimal_1.default.Reader ? input : new $f9dbd0bb86a60d65$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f9dbd0bb86a60d65$var$createBaseMsgClearAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f9dbd0bb86a60d65$var$createBaseMsgClearAdminResponse();
        return message;
    }
};
var $f9dbd0bb86a60d65$var$globalThis = (()=>{
    if (typeof $f9dbd0bb86a60d65$var$globalThis !== "undefined") return $f9dbd0bb86a60d65$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $f9dbd0bb86a60d65$var$atob = $f9dbd0bb86a60d65$var$globalThis.atob || ((b64)=>$f9dbd0bb86a60d65$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $f9dbd0bb86a60d65$var$bytesFromBase64(b64) {
    const bin = $f9dbd0bb86a60d65$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $f9dbd0bb86a60d65$var$btoa = $f9dbd0bb86a60d65$var$globalThis.btoa || ((bin)=>$f9dbd0bb86a60d65$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $f9dbd0bb86a60d65$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $f9dbd0bb86a60d65$var$btoa(bin.join(""));
}
function $f9dbd0bb86a60d65$var$longToString(long) {
    return long.toString();
}
if ($f9dbd0bb86a60d65$var$minimal_1.default.util.Long !== $f9dbd0bb86a60d65$var$long_1.default) {
    $f9dbd0bb86a60d65$var$minimal_1.default.util.Long = $f9dbd0bb86a60d65$var$long_1.default;
    $f9dbd0bb86a60d65$var$minimal_1.default.configure();
}
function $f9dbd0bb86a60d65$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("e20Kg", function(module, exports) {
"use strict";
var $a371d49027e459e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Model = module.exports.AbsoluteTxPosition = module.exports.ContractCodeHistoryEntry = module.exports.ContractInfo = module.exports.CodeInfo = module.exports.Params = module.exports.AccessConfig = module.exports.AccessTypeParam = module.exports.contractCodeHistoryOperationTypeToJSON = module.exports.contractCodeHistoryOperationTypeFromJSON = module.exports.ContractCodeHistoryOperationType = module.exports.accessTypeToJSON = module.exports.accessTypeFromJSON = module.exports.AccessType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $a371d49027e459e3$var$long_1 = $a371d49027e459e3$var$__importDefault((parcelRequire("3gmZQ")));

const $a371d49027e459e3$var$minimal_1 = $a371d49027e459e3$var$__importDefault((parcelRequire("1wC51")));

var $fV2Ok = parcelRequire("fV2Ok");
module.exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $a371d49027e459e3$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /** ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to an address */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a371d49027e459e3$var$AccessType = module.exports.AccessType || (module.exports.AccessType = {}));
function $a371d49027e459e3$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $a371d49027e459e3$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $a371d49027e459e3$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $a371d49027e459e3$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $a371d49027e459e3$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a371d49027e459e3$var$AccessType.UNRECOGNIZED;
    }
}
module.exports.accessTypeFromJSON = $a371d49027e459e3$var$accessTypeFromJSON;
function $a371d49027e459e3$var$accessTypeToJSON(object) {
    switch(object){
        case $a371d49027e459e3$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $a371d49027e459e3$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $a371d49027e459e3$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $a371d49027e459e3$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        default:
            return "UNKNOWN";
    }
}
module.exports.accessTypeToJSON = $a371d49027e459e3$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $a371d49027e459e3$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a371d49027e459e3$var$ContractCodeHistoryOperationType = module.exports.ContractCodeHistoryOperationType || (module.exports.ContractCodeHistoryOperationType = {}));
function $a371d49027e459e3$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a371d49027e459e3$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
module.exports.contractCodeHistoryOperationTypeFromJSON = $a371d49027e459e3$var$contractCodeHistoryOperationTypeFromJSON;
function $a371d49027e459e3$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $a371d49027e459e3$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        default:
            return "UNKNOWN";
    }
}
module.exports.contractCodeHistoryOperationTypeToJSON = $a371d49027e459e3$var$contractCodeHistoryOperationTypeToJSON;
function $a371d49027e459e3$var$createBaseAccessTypeParam() {
    return {
        value: 0
    };
}
module.exports.AccessTypeParam = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseAccessTypeParam();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            value: $a371d49027e459e3$var$isSet(object.value) ? $a371d49027e459e3$var$accessTypeFromJSON(object.value) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.value !== undefined && (obj.value = $a371d49027e459e3$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $a371d49027e459e3$var$createBaseAccessTypeParam();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $a371d49027e459e3$var$createBaseAccessConfig() {
    return {
        permission: 0,
        address: ""
    };
}
module.exports.AccessConfig = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseAccessConfig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            permission: $a371d49027e459e3$var$isSet(object.permission) ? $a371d49027e459e3$var$accessTypeFromJSON(object.permission) : 0,
            address: $a371d49027e459e3$var$isSet(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = $a371d49027e459e3$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $a371d49027e459e3$var$createBaseAccessConfig();
        message.permission = (_a = object.permission) !== null && _a !== void 0 ? _a : 0;
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $a371d49027e459e3$var$createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0,
        maxWasmCodeSize: "0"
    };
}
module.exports.Params = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.codeUploadAccess !== undefined) module.exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        if (message.maxWasmCodeSize !== "0") writer.uint32(24).uint64(message.maxWasmCodeSize);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                case 3:
                    message.maxWasmCodeSize = $a371d49027e459e3$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeUploadAccess: $a371d49027e459e3$var$isSet(object.codeUploadAccess) ? module.exports.AccessConfig.fromJSON(object.codeUploadAccess) : undefined,
            instantiateDefaultPermission: $a371d49027e459e3$var$isSet(object.instantiateDefaultPermission) ? $a371d49027e459e3$var$accessTypeFromJSON(object.instantiateDefaultPermission) : 0,
            maxWasmCodeSize: $a371d49027e459e3$var$isSet(object.maxWasmCodeSize) ? String(object.maxWasmCodeSize) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? module.exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $a371d49027e459e3$var$accessTypeToJSON(message.instantiateDefaultPermission));
        message.maxWasmCodeSize !== undefined && (obj.maxWasmCodeSize = message.maxWasmCodeSize);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $a371d49027e459e3$var$createBaseParams();
        message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? module.exports.AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
        message.instantiateDefaultPermission = (_a = object.instantiateDefaultPermission) !== null && _a !== void 0 ? _a : 0;
        message.maxWasmCodeSize = (_b = object.maxWasmCodeSize) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $a371d49027e459e3$var$createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined
    };
}
module.exports.CodeInfo = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) module.exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseCodeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = module.exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeHash: $a371d49027e459e3$var$isSet(object.codeHash) ? $a371d49027e459e3$var$bytesFromBase64(object.codeHash) : new Uint8Array(),
            creator: $a371d49027e459e3$var$isSet(object.creator) ? String(object.creator) : "",
            instantiateConfig: $a371d49027e459e3$var$isSet(object.instantiateConfig) ? module.exports.AccessConfig.fromJSON(object.instantiateConfig) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeHash !== undefined && (obj.codeHash = $a371d49027e459e3$var$base64FromBytes(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? module.exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $a371d49027e459e3$var$createBaseCodeInfo();
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? module.exports.AccessConfig.fromPartial(object.instantiateConfig) : undefined;
        return message;
    }
};
function $a371d49027e459e3$var$createBaseContractInfo() {
    return {
        codeId: "0",
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined
    };
}
module.exports.ContractInfo = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.codeId !== "0") writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) module.exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $fV2Ok.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseContractInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = $a371d49027e459e3$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $a371d49027e459e3$var$isSet(object.codeId) ? String(object.codeId) : "0",
            creator: $a371d49027e459e3$var$isSet(object.creator) ? String(object.creator) : "",
            admin: $a371d49027e459e3$var$isSet(object.admin) ? String(object.admin) : "",
            label: $a371d49027e459e3$var$isSet(object.label) ? String(object.label) : "",
            created: $a371d49027e459e3$var$isSet(object.created) ? module.exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: $a371d49027e459e3$var$isSet(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: $a371d49027e459e3$var$isSet(object.extension) ? $fV2Ok.Any.fromJSON(object.extension) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? module.exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $fV2Ok.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $a371d49027e459e3$var$createBaseContractInfo();
        message.codeId = (_a = object.codeId) !== null && _a !== void 0 ? _a : "0";
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.admin = (_c = object.admin) !== null && _c !== void 0 ? _c : "";
        message.label = (_d = object.label) !== null && _d !== void 0 ? _d : "";
        message.created = object.created !== undefined && object.created !== null ? module.exports.AbsoluteTxPosition.fromPartial(object.created) : undefined;
        message.ibcPortId = (_e = object.ibcPortId) !== null && _e !== void 0 ? _e : "";
        message.extension = object.extension !== undefined && object.extension !== null ? $fV2Ok.Any.fromPartial(object.extension) : undefined;
        return message;
    }
};
function $a371d49027e459e3$var$createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: "0",
        updated: undefined,
        msg: new Uint8Array()
    };
}
module.exports.ContractCodeHistoryEntry = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (message.codeId !== "0") writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) module.exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseContractCodeHistoryEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = $a371d49027e459e3$var$longToString(reader.uint64());
                    break;
                case 3:
                    message.updated = module.exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operation: $a371d49027e459e3$var$isSet(object.operation) ? $a371d49027e459e3$var$contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: $a371d49027e459e3$var$isSet(object.codeId) ? String(object.codeId) : "0",
            updated: $a371d49027e459e3$var$isSet(object.updated) ? module.exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: $a371d49027e459e3$var$isSet(object.msg) ? $a371d49027e459e3$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.operation !== undefined && (obj.operation = $a371d49027e459e3$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = message.codeId);
        message.updated !== undefined && (obj.updated = message.updated ? module.exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = $a371d49027e459e3$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $a371d49027e459e3$var$createBaseContractCodeHistoryEntry();
        message.operation = (_a = object.operation) !== null && _a !== void 0 ? _a : 0;
        message.codeId = (_b = object.codeId) !== null && _b !== void 0 ? _b : "0";
        message.updated = object.updated !== undefined && object.updated !== null ? module.exports.AbsoluteTxPosition.fromPartial(object.updated) : undefined;
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $a371d49027e459e3$var$createBaseAbsoluteTxPosition() {
    return {
        blockHeight: "0",
        txIndex: "0"
    };
}
module.exports.AbsoluteTxPosition = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.blockHeight !== "0") writer.uint32(8).uint64(message.blockHeight);
        if (message.txIndex !== "0") writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseAbsoluteTxPosition();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = $a371d49027e459e3$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.txIndex = $a371d49027e459e3$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockHeight: $a371d49027e459e3$var$isSet(object.blockHeight) ? String(object.blockHeight) : "0",
            txIndex: $a371d49027e459e3$var$isSet(object.txIndex) ? String(object.txIndex) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = message.blockHeight);
        message.txIndex !== undefined && (obj.txIndex = message.txIndex);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $a371d49027e459e3$var$createBaseAbsoluteTxPosition();
        message.blockHeight = (_a = object.blockHeight) !== null && _a !== void 0 ? _a : "0";
        message.txIndex = (_b = object.txIndex) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $a371d49027e459e3$var$createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array()
    };
}
module.exports.Model = {
    encode (message, writer = $a371d49027e459e3$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a371d49027e459e3$var$minimal_1.default.Reader ? input : new $a371d49027e459e3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a371d49027e459e3$var$createBaseModel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $a371d49027e459e3$var$isSet(object.key) ? $a371d49027e459e3$var$bytesFromBase64(object.key) : new Uint8Array(),
            value: $a371d49027e459e3$var$isSet(object.value) ? $a371d49027e459e3$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $a371d49027e459e3$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $a371d49027e459e3$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $a371d49027e459e3$var$createBaseModel();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $a371d49027e459e3$var$globalThis = (()=>{
    if (typeof $a371d49027e459e3$var$globalThis !== "undefined") return $a371d49027e459e3$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $a371d49027e459e3$var$atob = $a371d49027e459e3$var$globalThis.atob || ((b64)=>$a371d49027e459e3$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $a371d49027e459e3$var$bytesFromBase64(b64) {
    const bin = $a371d49027e459e3$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $a371d49027e459e3$var$btoa = $a371d49027e459e3$var$globalThis.btoa || ((bin)=>$a371d49027e459e3$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $a371d49027e459e3$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $a371d49027e459e3$var$btoa(bin.join(""));
}
function $a371d49027e459e3$var$longToString(long) {
    return long.toString();
}
if ($a371d49027e459e3$var$minimal_1.default.util.Long !== $a371d49027e459e3$var$long_1.default) {
    $a371d49027e459e3$var$minimal_1.default.util.Long = $a371d49027e459e3$var$long_1.default;
    $a371d49027e459e3$var$minimal_1.default.configure();
}
function $a371d49027e459e3$var$isSet(value) {
    return value !== null && value !== undefined;
}

});


parcelRegister("hp4R2", function(module, exports) {
"use strict";
var $cab88976d7bc57f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgTransferResponse = module.exports.MsgTransfer = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $cab88976d7bc57f0$var$long_1 = $cab88976d7bc57f0$var$__importDefault((parcelRequire("3gmZQ")));

const $cab88976d7bc57f0$var$minimal_1 = $cab88976d7bc57f0$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");

var $04OkZ = parcelRequire("04OkZ");
module.exports.protobufPackage = "ibc.applications.transfer.v1";
function $cab88976d7bc57f0$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: "0",
        memo: ""
    };
}
module.exports.MsgTransfer = {
    encode (message, writer = $cab88976d7bc57f0$var$minimal_1.default.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $lNGQx.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $04OkZ.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (message.timeoutTimestamp !== "0") writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cab88976d7bc57f0$var$minimal_1.default.Reader ? input : new $cab88976d7bc57f0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cab88976d7bc57f0$var$createBaseMsgTransfer();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $04OkZ.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = $cab88976d7bc57f0$var$longToString(reader.uint64());
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sourcePort: $cab88976d7bc57f0$var$isSet(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: $cab88976d7bc57f0$var$isSet(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: $cab88976d7bc57f0$var$isSet(object.token) ? $lNGQx.Coin.fromJSON(object.token) : undefined,
            sender: $cab88976d7bc57f0$var$isSet(object.sender) ? String(object.sender) : "",
            receiver: $cab88976d7bc57f0$var$isSet(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: $cab88976d7bc57f0$var$isSet(object.timeoutHeight) ? $04OkZ.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: $cab88976d7bc57f0$var$isSet(object.timeoutTimestamp) ? String(object.timeoutTimestamp) : "0",
            memo: $cab88976d7bc57f0$var$isSet(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $lNGQx.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $04OkZ.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = message.timeoutTimestamp);
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $cab88976d7bc57f0$var$createBaseMsgTransfer();
        message.sourcePort = (_a = object.sourcePort) !== null && _a !== void 0 ? _a : "";
        message.sourceChannel = (_b = object.sourceChannel) !== null && _b !== void 0 ? _b : "";
        message.token = object.token !== undefined && object.token !== null ? $lNGQx.Coin.fromPartial(object.token) : undefined;
        message.sender = (_c = object.sender) !== null && _c !== void 0 ? _c : "";
        message.receiver = (_d = object.receiver) !== null && _d !== void 0 ? _d : "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $04OkZ.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = (_e = object.timeoutTimestamp) !== null && _e !== void 0 ? _e : "0";
        message.memo = (_f = object.memo) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $cab88976d7bc57f0$var$createBaseMsgTransferResponse() {
    return {};
}
module.exports.MsgTransferResponse = {
    encode (_, writer = $cab88976d7bc57f0$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cab88976d7bc57f0$var$minimal_1.default.Reader ? input : new $cab88976d7bc57f0$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cab88976d7bc57f0$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cab88976d7bc57f0$var$createBaseMsgTransferResponse();
        return message;
    }
};
function $cab88976d7bc57f0$var$longToString(long) {
    return long.toString();
}
if ($cab88976d7bc57f0$var$minimal_1.default.util.Long !== $cab88976d7bc57f0$var$long_1.default) {
    $cab88976d7bc57f0$var$minimal_1.default.util.Long = $cab88976d7bc57f0$var$long_1.default;
    $cab88976d7bc57f0$var$minimal_1.default.configure();
}
function $cab88976d7bc57f0$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("04OkZ", function(module, exports) {
"use strict";
var $00e76bd6563d0ea7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Height = module.exports.UpgradeProposal = module.exports.ClientUpdateProposal = module.exports.ClientConsensusStates = module.exports.ConsensusStateWithHeight = module.exports.IdentifiedClientState = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $00e76bd6563d0ea7$var$long_1 = $00e76bd6563d0ea7$var$__importDefault((parcelRequire("3gmZQ")));

const $00e76bd6563d0ea7$var$minimal_1 = $00e76bd6563d0ea7$var$__importDefault((parcelRequire("1wC51")));

var $fV2Ok = parcelRequire("fV2Ok");

var $bHOXv = parcelRequire("bHOXv");
module.exports.protobufPackage = "ibc.core.client.v1";
function $00e76bd6563d0ea7$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
module.exports.IdentifiedClientState = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $fV2Ok.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: $00e76bd6563d0ea7$var$isSet(object.clientId) ? String(object.clientId) : "",
            clientState: $00e76bd6563d0ea7$var$isSet(object.clientState) ? $fV2Ok.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $fV2Ok.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $00e76bd6563d0ea7$var$createBaseIdentifiedClientState();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $fV2Ok.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
module.exports.ConsensusStateWithHeight = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.height !== undefined) module.exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $fV2Ok.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = module.exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: $00e76bd6563d0ea7$var$isSet(object.height) ? module.exports.Height.fromJSON(object.height) : undefined,
            consensusState: $00e76bd6563d0ea7$var$isSet(object.consensusState) ? $fV2Ok.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? module.exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $fV2Ok.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $00e76bd6563d0ea7$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? module.exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $fV2Ok.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
module.exports.ClientConsensusStates = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)module.exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(module.exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: $00e76bd6563d0ea7$var$isSet(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object === null || object === void 0 ? void 0 : object.consensusStates) ? object.consensusStates.map((e)=>module.exports.ConsensusStateWithHeight.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? module.exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $00e76bd6563d0ea7$var$createBaseClientConsensusStates();
        message.clientId = (_a = object.clientId) !== null && _a !== void 0 ? _a : "";
        message.consensusStates = ((_b = object.consensusStates) === null || _b === void 0 ? void 0 : _b.map((e)=>module.exports.ConsensusStateWithHeight.fromPartial(e))) || [];
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
module.exports.ClientUpdateProposal = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $00e76bd6563d0ea7$var$isSet(object.title) ? String(object.title) : "",
            description: $00e76bd6563d0ea7$var$isSet(object.description) ? String(object.description) : "",
            subjectClientId: $00e76bd6563d0ea7$var$isSet(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: $00e76bd6563d0ea7$var$isSet(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $00e76bd6563d0ea7$var$createBaseClientUpdateProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.subjectClientId = (_c = object.subjectClientId) !== null && _c !== void 0 ? _c : "";
        message.substituteClientId = (_d = object.substituteClientId) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
module.exports.UpgradeProposal = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $bHOXv.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $fV2Ok.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $bHOXv.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $00e76bd6563d0ea7$var$isSet(object.title) ? String(object.title) : "",
            description: $00e76bd6563d0ea7$var$isSet(object.description) ? String(object.description) : "",
            plan: $00e76bd6563d0ea7$var$isSet(object.plan) ? $bHOXv.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: $00e76bd6563d0ea7$var$isSet(object.upgradedClientState) ? $fV2Ok.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $bHOXv.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $fV2Ok.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $00e76bd6563d0ea7$var$createBaseUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan = object.plan !== undefined && object.plan !== null ? $bHOXv.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $fV2Ok.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseHeight() {
    return {
        revisionNumber: "0",
        revisionHeight: "0"
    };
}
module.exports.Height = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        if (message.revisionNumber !== "0") writer.uint32(8).uint64(message.revisionNumber);
        if (message.revisionHeight !== "0") writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = $00e76bd6563d0ea7$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.revisionHeight = $00e76bd6563d0ea7$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            revisionNumber: $00e76bd6563d0ea7$var$isSet(object.revisionNumber) ? String(object.revisionNumber) : "0",
            revisionHeight: $00e76bd6563d0ea7$var$isSet(object.revisionHeight) ? String(object.revisionHeight) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = message.revisionNumber);
        message.revisionHeight !== undefined && (obj.revisionHeight = message.revisionHeight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $00e76bd6563d0ea7$var$createBaseHeight();
        message.revisionNumber = (_a = object.revisionNumber) !== null && _a !== void 0 ? _a : "0";
        message.revisionHeight = (_b = object.revisionHeight) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $00e76bd6563d0ea7$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
module.exports.Params = {
    encode (message, writer = $00e76bd6563d0ea7$var$minimal_1.default.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $00e76bd6563d0ea7$var$minimal_1.default.Reader ? input : new $00e76bd6563d0ea7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $00e76bd6563d0ea7$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowedClients: Array.isArray(object === null || object === void 0 ? void 0 : object.allowedClients) ? object.allowedClients.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $00e76bd6563d0ea7$var$createBaseParams();
        message.allowedClients = ((_a = object.allowedClients) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $00e76bd6563d0ea7$var$longToString(long) {
    return long.toString();
}
if ($00e76bd6563d0ea7$var$minimal_1.default.util.Long !== $00e76bd6563d0ea7$var$long_1.default) {
    $00e76bd6563d0ea7$var$minimal_1.default.util.Long = $00e76bd6563d0ea7$var$long_1.default;
    $00e76bd6563d0ea7$var$minimal_1.default.configure();
}
function $00e76bd6563d0ea7$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("bHOXv", function(module, exports) {
"use strict";
var $885b3d34f06873f1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleVersion = module.exports.CancelSoftwareUpgradeProposal = module.exports.SoftwareUpgradeProposal = module.exports.Plan = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $885b3d34f06873f1$var$long_1 = $885b3d34f06873f1$var$__importDefault((parcelRequire("3gmZQ")));

const $885b3d34f06873f1$var$minimal_1 = $885b3d34f06873f1$var$__importDefault((parcelRequire("1wC51")));

var $gqzXD = parcelRequire("gqzXD");

var $fV2Ok = parcelRequire("fV2Ok");
module.exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $885b3d34f06873f1$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: "0",
        info: "",
        upgradedClientState: undefined
    };
}
module.exports.Plan = {
    encode (message, writer = $885b3d34f06873f1$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $gqzXD.Timestamp.encode($885b3d34f06873f1$var$toTimestamp(message.time), writer.uint32(18).fork()).ldelim();
        if (message.height !== "0") writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $fV2Ok.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $885b3d34f06873f1$var$minimal_1.default.Reader ? input : new $885b3d34f06873f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $885b3d34f06873f1$var$createBasePlan();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $885b3d34f06873f1$var$fromTimestamp($gqzXD.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.height = $885b3d34f06873f1$var$longToString(reader.int64());
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: $885b3d34f06873f1$var$isSet(object.name) ? String(object.name) : "",
            time: $885b3d34f06873f1$var$isSet(object.time) ? $885b3d34f06873f1$var$fromJsonTimestamp(object.time) : undefined,
            height: $885b3d34f06873f1$var$isSet(object.height) ? String(object.height) : "0",
            info: $885b3d34f06873f1$var$isSet(object.info) ? String(object.info) : "",
            upgradedClientState: $885b3d34f06873f1$var$isSet(object.upgradedClientState) ? $fV2Ok.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = message.time.toISOString());
        message.height !== undefined && (obj.height = message.height);
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $fV2Ok.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $885b3d34f06873f1$var$createBasePlan();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.time = (_b = object.time) !== null && _b !== void 0 ? _b : undefined;
        message.height = (_c = object.height) !== null && _c !== void 0 ? _c : "0";
        message.info = (_d = object.info) !== null && _d !== void 0 ? _d : "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $fV2Ok.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $885b3d34f06873f1$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
module.exports.SoftwareUpgradeProposal = {
    encode (message, writer = $885b3d34f06873f1$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) module.exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $885b3d34f06873f1$var$minimal_1.default.Reader ? input : new $885b3d34f06873f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $885b3d34f06873f1$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = module.exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $885b3d34f06873f1$var$isSet(object.title) ? String(object.title) : "",
            description: $885b3d34f06873f1$var$isSet(object.description) ? String(object.description) : "",
            plan: $885b3d34f06873f1$var$isSet(object.plan) ? module.exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? module.exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $885b3d34f06873f1$var$createBaseSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        message.plan = object.plan !== undefined && object.plan !== null ? module.exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $885b3d34f06873f1$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $885b3d34f06873f1$var$minimal_1.default.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $885b3d34f06873f1$var$minimal_1.default.Reader ? input : new $885b3d34f06873f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $885b3d34f06873f1$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: $885b3d34f06873f1$var$isSet(object.title) ? String(object.title) : "",
            description: $885b3d34f06873f1$var$isSet(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $885b3d34f06873f1$var$createBaseCancelSoftwareUpgradeProposal();
        message.title = (_a = object.title) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $885b3d34f06873f1$var$createBaseModuleVersion() {
    return {
        name: "",
        version: "0"
    };
}
module.exports.ModuleVersion = {
    encode (message, writer = $885b3d34f06873f1$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.version !== "0") writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $885b3d34f06873f1$var$minimal_1.default.Reader ? input : new $885b3d34f06873f1$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $885b3d34f06873f1$var$createBaseModuleVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = $885b3d34f06873f1$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: $885b3d34f06873f1$var$isSet(object.name) ? String(object.name) : "",
            version: $885b3d34f06873f1$var$isSet(object.version) ? String(object.version) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $885b3d34f06873f1$var$createBaseModuleVersion();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.version = (_b = object.version) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $885b3d34f06873f1$var$toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000).toString();
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $885b3d34f06873f1$var$fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function $885b3d34f06873f1$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return o;
    else if (typeof o === "string") return new Date(o);
    else return $885b3d34f06873f1$var$fromTimestamp($gqzXD.Timestamp.fromJSON(o));
}
function $885b3d34f06873f1$var$longToString(long) {
    return long.toString();
}
if ($885b3d34f06873f1$var$minimal_1.default.util.Long !== $885b3d34f06873f1$var$long_1.default) {
    $885b3d34f06873f1$var$minimal_1.default.util.Long = $885b3d34f06873f1$var$long_1.default;
    $885b3d34f06873f1$var$minimal_1.default.configure();
}
function $885b3d34f06873f1$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("8Qb1r", function(module, exports) {
"use strict";
var $66fbbaddc6a6b8f7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgPayPacketFeeAsyncResponse = module.exports.MsgPayPacketFeeAsync = module.exports.MsgPayPacketFeeResponse = module.exports.MsgPayPacketFee = module.exports.MsgRegisterCounterpartyPayeeResponse = module.exports.MsgRegisterCounterpartyPayee = module.exports.MsgRegisterPayeeResponse = module.exports.MsgRegisterPayee = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $66fbbaddc6a6b8f7$var$long_1 = $66fbbaddc6a6b8f7$var$__importDefault((parcelRequire("3gmZQ")));

const $66fbbaddc6a6b8f7$var$minimal_1 = $66fbbaddc6a6b8f7$var$__importDefault((parcelRequire("1wC51")));

var $hGY5l = parcelRequire("hGY5l");

var $l8ass = parcelRequire("l8ass");
module.exports.protobufPackage = "ibc.applications.fee.v1";
function $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayee() {
    return {
        portId: "",
        channelId: "",
        relayer: "",
        payee: ""
    };
}
module.exports.MsgRegisterPayee = {
    encode (message, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.relayer !== "") writer.uint32(26).string(message.relayer);
        if (message.payee !== "") writer.uint32(34).string(message.payee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.relayer = reader.string();
                    break;
                case 4:
                    message.payee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: $66fbbaddc6a6b8f7$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $66fbbaddc6a6b8f7$var$isSet(object.channelId) ? String(object.channelId) : "",
            relayer: $66fbbaddc6a6b8f7$var$isSet(object.relayer) ? String(object.relayer) : "",
            payee: $66fbbaddc6a6b8f7$var$isSet(object.payee) ? String(object.payee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.relayer !== undefined && (obj.relayer = message.relayer);
        message.payee !== undefined && (obj.payee = message.payee);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayee();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.relayer = (_c = object.relayer) !== null && _c !== void 0 ? _c : "";
        message.payee = (_d = object.payee) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayeeResponse() {
    return {};
}
module.exports.MsgRegisterPayeeResponse = {
    encode (_, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayeeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterPayeeResponse();
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayee() {
    return {
        portId: "",
        channelId: "",
        relayer: "",
        counterpartyPayee: ""
    };
}
module.exports.MsgRegisterCounterpartyPayee = {
    encode (message, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.relayer !== "") writer.uint32(26).string(message.relayer);
        if (message.counterpartyPayee !== "") writer.uint32(34).string(message.counterpartyPayee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.relayer = reader.string();
                    break;
                case 4:
                    message.counterpartyPayee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: $66fbbaddc6a6b8f7$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $66fbbaddc6a6b8f7$var$isSet(object.channelId) ? String(object.channelId) : "",
            relayer: $66fbbaddc6a6b8f7$var$isSet(object.relayer) ? String(object.relayer) : "",
            counterpartyPayee: $66fbbaddc6a6b8f7$var$isSet(object.counterpartyPayee) ? String(object.counterpartyPayee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.relayer !== undefined && (obj.relayer = message.relayer);
        message.counterpartyPayee !== undefined && (obj.counterpartyPayee = message.counterpartyPayee);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayee();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.relayer = (_c = object.relayer) !== null && _c !== void 0 ? _c : "";
        message.counterpartyPayee = (_d = object.counterpartyPayee) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayeeResponse() {
    return {};
}
module.exports.MsgRegisterCounterpartyPayeeResponse = {
    encode (_, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayeeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgRegisterCounterpartyPayeeResponse();
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFee() {
    return {
        fee: undefined,
        sourcePortId: "",
        sourceChannelId: "",
        signer: "",
        relayers: []
    };
}
module.exports.MsgPayPacketFee = {
    encode (message, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        if (message.fee !== undefined) $hGY5l.Fee.encode(message.fee, writer.uint32(10).fork()).ldelim();
        if (message.sourcePortId !== "") writer.uint32(18).string(message.sourcePortId);
        if (message.sourceChannelId !== "") writer.uint32(26).string(message.sourceChannelId);
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        for (const v of message.relayers)writer.uint32(42).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fee = $hGY5l.Fee.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.sourcePortId = reader.string();
                    break;
                case 3:
                    message.sourceChannelId = reader.string();
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                case 5:
                    message.relayers.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fee: $66fbbaddc6a6b8f7$var$isSet(object.fee) ? $hGY5l.Fee.fromJSON(object.fee) : undefined,
            sourcePortId: $66fbbaddc6a6b8f7$var$isSet(object.sourcePortId) ? String(object.sourcePortId) : "",
            sourceChannelId: $66fbbaddc6a6b8f7$var$isSet(object.sourceChannelId) ? String(object.sourceChannelId) : "",
            signer: $66fbbaddc6a6b8f7$var$isSet(object.signer) ? String(object.signer) : "",
            relayers: Array.isArray(object === null || object === void 0 ? void 0 : object.relayers) ? object.relayers.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fee !== undefined && (obj.fee = message.fee ? $hGY5l.Fee.toJSON(message.fee) : undefined);
        message.sourcePortId !== undefined && (obj.sourcePortId = message.sourcePortId);
        message.sourceChannelId !== undefined && (obj.sourceChannelId = message.sourceChannelId);
        message.signer !== undefined && (obj.signer = message.signer);
        if (message.relayers) obj.relayers = message.relayers.map((e)=>e);
        else obj.relayers = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFee();
        message.fee = object.fee !== undefined && object.fee !== null ? $hGY5l.Fee.fromPartial(object.fee) : undefined;
        message.sourcePortId = (_a = object.sourcePortId) !== null && _a !== void 0 ? _a : "";
        message.sourceChannelId = (_b = object.sourceChannelId) !== null && _b !== void 0 ? _b : "";
        message.signer = (_c = object.signer) !== null && _c !== void 0 ? _c : "";
        message.relayers = ((_d = object.relayers) === null || _d === void 0 ? void 0 : _d.map((e)=>e)) || [];
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeResponse() {
    return {};
}
module.exports.MsgPayPacketFeeResponse = {
    encode (_, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeResponse();
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsync() {
    return {
        packetId: undefined,
        packetFee: undefined
    };
}
module.exports.MsgPayPacketFeeAsync = {
    encode (message, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        if (message.packetId !== undefined) $l8ass.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
        if (message.packetFee !== undefined) $hGY5l.PacketFee.encode(message.packetFee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsync();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packetId = $l8ass.PacketId.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.packetFee = $hGY5l.PacketFee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packetId: $66fbbaddc6a6b8f7$var$isSet(object.packetId) ? $l8ass.PacketId.fromJSON(object.packetId) : undefined,
            packetFee: $66fbbaddc6a6b8f7$var$isSet(object.packetFee) ? $hGY5l.PacketFee.fromJSON(object.packetFee) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.packetId !== undefined && (obj.packetId = message.packetId ? $l8ass.PacketId.toJSON(message.packetId) : undefined);
        message.packetFee !== undefined && (obj.packetFee = message.packetFee ? $hGY5l.PacketFee.toJSON(message.packetFee) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsync();
        message.packetId = object.packetId !== undefined && object.packetId !== null ? $l8ass.PacketId.fromPartial(object.packetId) : undefined;
        message.packetFee = object.packetFee !== undefined && object.packetFee !== null ? $hGY5l.PacketFee.fromPartial(object.packetFee) : undefined;
        return message;
    }
};
function $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsyncResponse() {
    return {};
}
module.exports.MsgPayPacketFeeAsyncResponse = {
    encode (_, writer = $66fbbaddc6a6b8f7$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $66fbbaddc6a6b8f7$var$minimal_1.default.Reader ? input : new $66fbbaddc6a6b8f7$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsyncResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $66fbbaddc6a6b8f7$var$createBaseMsgPayPacketFeeAsyncResponse();
        return message;
    }
};
if ($66fbbaddc6a6b8f7$var$minimal_1.default.util.Long !== $66fbbaddc6a6b8f7$var$long_1.default) {
    $66fbbaddc6a6b8f7$var$minimal_1.default.util.Long = $66fbbaddc6a6b8f7$var$long_1.default;
    $66fbbaddc6a6b8f7$var$minimal_1.default.configure();
}
function $66fbbaddc6a6b8f7$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("hGY5l", function(module, exports) {
"use strict";
var $ce14f795191bed28$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentifiedPacketFees = module.exports.PacketFees = module.exports.PacketFee = module.exports.Fee = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ce14f795191bed28$var$long_1 = $ce14f795191bed28$var$__importDefault((parcelRequire("3gmZQ")));

const $ce14f795191bed28$var$minimal_1 = $ce14f795191bed28$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");

var $l8ass = parcelRequire("l8ass");
module.exports.protobufPackage = "ibc.applications.fee.v1";
function $ce14f795191bed28$var$createBaseFee() {
    return {
        recvFee: [],
        ackFee: [],
        timeoutFee: []
    };
}
module.exports.Fee = {
    encode (message, writer = $ce14f795191bed28$var$minimal_1.default.Writer.create()) {
        for (const v of message.recvFee)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.ackFee)$lNGQx.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.timeoutFee)$lNGQx.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce14f795191bed28$var$minimal_1.default.Reader ? input : new $ce14f795191bed28$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce14f795191bed28$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.recvFee.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.ackFee.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.timeoutFee.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            recvFee: Array.isArray(object === null || object === void 0 ? void 0 : object.recvFee) ? object.recvFee.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            ackFee: Array.isArray(object === null || object === void 0 ? void 0 : object.ackFee) ? object.ackFee.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            timeoutFee: Array.isArray(object === null || object === void 0 ? void 0 : object.timeoutFee) ? object.timeoutFee.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.recvFee) obj.recvFee = message.recvFee.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.recvFee = [];
        if (message.ackFee) obj.ackFee = message.ackFee.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.ackFee = [];
        if (message.timeoutFee) obj.timeoutFee = message.timeoutFee.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.timeoutFee = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $ce14f795191bed28$var$createBaseFee();
        message.recvFee = ((_a = object.recvFee) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.ackFee = ((_b = object.ackFee) === null || _b === void 0 ? void 0 : _b.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.timeoutFee = ((_c = object.timeoutFee) === null || _c === void 0 ? void 0 : _c.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $ce14f795191bed28$var$createBasePacketFee() {
    return {
        fee: undefined,
        refundAddress: "",
        relayers: []
    };
}
module.exports.PacketFee = {
    encode (message, writer = $ce14f795191bed28$var$minimal_1.default.Writer.create()) {
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(10).fork()).ldelim();
        if (message.refundAddress !== "") writer.uint32(18).string(message.refundAddress);
        for (const v of message.relayers)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce14f795191bed28$var$minimal_1.default.Reader ? input : new $ce14f795191bed28$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce14f795191bed28$var$createBasePacketFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.refundAddress = reader.string();
                    break;
                case 3:
                    message.relayers.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fee: $ce14f795191bed28$var$isSet(object.fee) ? module.exports.Fee.fromJSON(object.fee) : undefined,
            refundAddress: $ce14f795191bed28$var$isSet(object.refundAddress) ? String(object.refundAddress) : "",
            relayers: Array.isArray(object === null || object === void 0 ? void 0 : object.relayers) ? object.relayers.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        message.refundAddress !== undefined && (obj.refundAddress = message.refundAddress);
        if (message.relayers) obj.relayers = message.relayers.map((e)=>e);
        else obj.relayers = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $ce14f795191bed28$var$createBasePacketFee();
        message.fee = object.fee !== undefined && object.fee !== null ? module.exports.Fee.fromPartial(object.fee) : undefined;
        message.refundAddress = (_a = object.refundAddress) !== null && _a !== void 0 ? _a : "";
        message.relayers = ((_b = object.relayers) === null || _b === void 0 ? void 0 : _b.map((e)=>e)) || [];
        return message;
    }
};
function $ce14f795191bed28$var$createBasePacketFees() {
    return {
        packetFees: []
    };
}
module.exports.PacketFees = {
    encode (message, writer = $ce14f795191bed28$var$minimal_1.default.Writer.create()) {
        for (const v of message.packetFees)module.exports.PacketFee.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce14f795191bed28$var$minimal_1.default.Reader ? input : new $ce14f795191bed28$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce14f795191bed28$var$createBasePacketFees();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packetFees.push(module.exports.PacketFee.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packetFees: Array.isArray(object === null || object === void 0 ? void 0 : object.packetFees) ? object.packetFees.map((e)=>module.exports.PacketFee.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.packetFees) obj.packetFees = message.packetFees.map((e)=>e ? module.exports.PacketFee.toJSON(e) : undefined);
        else obj.packetFees = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $ce14f795191bed28$var$createBasePacketFees();
        message.packetFees = ((_a = object.packetFees) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.PacketFee.fromPartial(e))) || [];
        return message;
    }
};
function $ce14f795191bed28$var$createBaseIdentifiedPacketFees() {
    return {
        packetId: undefined,
        packetFees: []
    };
}
module.exports.IdentifiedPacketFees = {
    encode (message, writer = $ce14f795191bed28$var$minimal_1.default.Writer.create()) {
        if (message.packetId !== undefined) $l8ass.PacketId.encode(message.packetId, writer.uint32(10).fork()).ldelim();
        for (const v of message.packetFees)module.exports.PacketFee.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce14f795191bed28$var$minimal_1.default.Reader ? input : new $ce14f795191bed28$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce14f795191bed28$var$createBaseIdentifiedPacketFees();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packetId = $l8ass.PacketId.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.packetFees.push(module.exports.PacketFee.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packetId: $ce14f795191bed28$var$isSet(object.packetId) ? $l8ass.PacketId.fromJSON(object.packetId) : undefined,
            packetFees: Array.isArray(object === null || object === void 0 ? void 0 : object.packetFees) ? object.packetFees.map((e)=>module.exports.PacketFee.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.packetId !== undefined && (obj.packetId = message.packetId ? $l8ass.PacketId.toJSON(message.packetId) : undefined);
        if (message.packetFees) obj.packetFees = message.packetFees.map((e)=>e ? module.exports.PacketFee.toJSON(e) : undefined);
        else obj.packetFees = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $ce14f795191bed28$var$createBaseIdentifiedPacketFees();
        message.packetId = object.packetId !== undefined && object.packetId !== null ? $l8ass.PacketId.fromPartial(object.packetId) : undefined;
        message.packetFees = ((_a = object.packetFees) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.PacketFee.fromPartial(e))) || [];
        return message;
    }
};
if ($ce14f795191bed28$var$minimal_1.default.util.Long !== $ce14f795191bed28$var$long_1.default) {
    $ce14f795191bed28$var$minimal_1.default.util.Long = $ce14f795191bed28$var$long_1.default;
    $ce14f795191bed28$var$minimal_1.default.configure();
}
function $ce14f795191bed28$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("l8ass", function(module, exports) {
"use strict";
var $03f84c360a5986aa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timeout = module.exports.Acknowledgement = module.exports.PacketId = module.exports.PacketState = module.exports.Packet = module.exports.Counterparty = module.exports.IdentifiedChannel = module.exports.Channel = module.exports.orderToJSON = module.exports.orderFromJSON = module.exports.Order = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $03f84c360a5986aa$var$long_1 = $03f84c360a5986aa$var$__importDefault((parcelRequire("3gmZQ")));

const $03f84c360a5986aa$var$minimal_1 = $03f84c360a5986aa$var$__importDefault((parcelRequire("1wC51")));

var $04OkZ = parcelRequire("04OkZ");
module.exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $03f84c360a5986aa$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($03f84c360a5986aa$var$State = module.exports.State || (module.exports.State = {}));
function $03f84c360a5986aa$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $03f84c360a5986aa$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $03f84c360a5986aa$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $03f84c360a5986aa$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $03f84c360a5986aa$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $03f84c360a5986aa$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $03f84c360a5986aa$var$State.UNRECOGNIZED;
    }
}
module.exports.stateFromJSON = $03f84c360a5986aa$var$stateFromJSON;
function $03f84c360a5986aa$var$stateToJSON(object) {
    switch(object){
        case $03f84c360a5986aa$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $03f84c360a5986aa$var$State.STATE_INIT:
            return "STATE_INIT";
        case $03f84c360a5986aa$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $03f84c360a5986aa$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $03f84c360a5986aa$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        default:
            return "UNKNOWN";
    }
}
module.exports.stateToJSON = $03f84c360a5986aa$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $03f84c360a5986aa$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($03f84c360a5986aa$var$Order = module.exports.Order || (module.exports.Order = {}));
function $03f84c360a5986aa$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $03f84c360a5986aa$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $03f84c360a5986aa$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $03f84c360a5986aa$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $03f84c360a5986aa$var$Order.UNRECOGNIZED;
    }
}
module.exports.orderFromJSON = $03f84c360a5986aa$var$orderFromJSON;
function $03f84c360a5986aa$var$orderToJSON(object) {
    switch(object){
        case $03f84c360a5986aa$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $03f84c360a5986aa$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $03f84c360a5986aa$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        default:
            return "UNKNOWN";
    }
}
module.exports.orderToJSON = $03f84c360a5986aa$var$orderToJSON;
function $03f84c360a5986aa$var$createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: ""
    };
}
module.exports.Channel = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBaseChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: $03f84c360a5986aa$var$isSet(object.state) ? $03f84c360a5986aa$var$stateFromJSON(object.state) : 0,
            ordering: $03f84c360a5986aa$var$isSet(object.ordering) ? $03f84c360a5986aa$var$orderFromJSON(object.ordering) : 0,
            counterparty: $03f84c360a5986aa$var$isSet(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: $03f84c360a5986aa$var$isSet(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $03f84c360a5986aa$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $03f84c360a5986aa$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $03f84c360a5986aa$var$createBaseChannel();
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $03f84c360a5986aa$var$createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: ""
    };
}
module.exports.IdentifiedChannel = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBaseIdentifiedChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: $03f84c360a5986aa$var$isSet(object.state) ? $03f84c360a5986aa$var$stateFromJSON(object.state) : 0,
            ordering: $03f84c360a5986aa$var$isSet(object.ordering) ? $03f84c360a5986aa$var$orderFromJSON(object.ordering) : 0,
            counterparty: $03f84c360a5986aa$var$isSet(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object === null || object === void 0 ? void 0 : object.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: $03f84c360a5986aa$var$isSet(object.version) ? String(object.version) : "",
            portId: $03f84c360a5986aa$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $03f84c360a5986aa$var$isSet(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $03f84c360a5986aa$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $03f84c360a5986aa$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f;
        const message = $03f84c360a5986aa$var$createBaseIdentifiedChannel();
        message.state = (_a = object.state) !== null && _a !== void 0 ? _a : 0;
        message.ordering = (_b = object.ordering) !== null && _b !== void 0 ? _b : 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = ((_c = object.connectionHops) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        message.version = (_d = object.version) !== null && _d !== void 0 ? _d : "";
        message.portId = (_e = object.portId) !== null && _e !== void 0 ? _e : "";
        message.channelId = (_f = object.channelId) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $03f84c360a5986aa$var$createBaseCounterparty() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.Counterparty = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: $03f84c360a5986aa$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $03f84c360a5986aa$var$isSet(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $03f84c360a5986aa$var$createBaseCounterparty();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $03f84c360a5986aa$var$createBasePacket() {
    return {
        sequence: "0",
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: "0"
    };
}
module.exports.Packet = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.sequence !== "0") writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $04OkZ.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (message.timeoutTimestamp !== "0") writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBasePacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = $03f84c360a5986aa$var$longToString(reader.uint64());
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $04OkZ.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = $03f84c360a5986aa$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: $03f84c360a5986aa$var$isSet(object.sequence) ? String(object.sequence) : "0",
            sourcePort: $03f84c360a5986aa$var$isSet(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: $03f84c360a5986aa$var$isSet(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: $03f84c360a5986aa$var$isSet(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: $03f84c360a5986aa$var$isSet(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: $03f84c360a5986aa$var$isSet(object.data) ? $03f84c360a5986aa$var$bytesFromBase64(object.data) : new Uint8Array(),
            timeoutHeight: $03f84c360a5986aa$var$isSet(object.timeoutHeight) ? $04OkZ.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: $03f84c360a5986aa$var$isSet(object.timeoutTimestamp) ? String(object.timeoutTimestamp) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = message.sequence);
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = $03f84c360a5986aa$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $04OkZ.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = message.timeoutTimestamp);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = $03f84c360a5986aa$var$createBasePacket();
        message.sequence = (_a = object.sequence) !== null && _a !== void 0 ? _a : "0";
        message.sourcePort = (_b = object.sourcePort) !== null && _b !== void 0 ? _b : "";
        message.sourceChannel = (_c = object.sourceChannel) !== null && _c !== void 0 ? _c : "";
        message.destinationPort = (_d = object.destinationPort) !== null && _d !== void 0 ? _d : "";
        message.destinationChannel = (_e = object.destinationChannel) !== null && _e !== void 0 ? _e : "";
        message.data = (_f = object.data) !== null && _f !== void 0 ? _f : new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $04OkZ.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = (_g = object.timeoutTimestamp) !== null && _g !== void 0 ? _g : "0";
        return message;
    }
};
function $03f84c360a5986aa$var$createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: "0",
        data: new Uint8Array()
    };
}
module.exports.PacketState = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBasePacketState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = $03f84c360a5986aa$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: $03f84c360a5986aa$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $03f84c360a5986aa$var$isSet(object.channelId) ? String(object.channelId) : "",
            sequence: $03f84c360a5986aa$var$isSet(object.sequence) ? String(object.sequence) : "0",
            data: $03f84c360a5986aa$var$isSet(object.data) ? $03f84c360a5986aa$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        message.data !== undefined && (obj.data = $03f84c360a5986aa$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $03f84c360a5986aa$var$createBasePacketState();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = (_c = object.sequence) !== null && _c !== void 0 ? _c : "0";
        message.data = (_d = object.data) !== null && _d !== void 0 ? _d : new Uint8Array();
        return message;
    }
};
function $03f84c360a5986aa$var$createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: "0"
    };
}
module.exports.PacketId = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBasePacketId();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = $03f84c360a5986aa$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: $03f84c360a5986aa$var$isSet(object.portId) ? String(object.portId) : "",
            channelId: $03f84c360a5986aa$var$isSet(object.channelId) ? String(object.channelId) : "",
            sequence: $03f84c360a5986aa$var$isSet(object.sequence) ? String(object.sequence) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $03f84c360a5986aa$var$createBasePacketId();
        message.portId = (_a = object.portId) !== null && _a !== void 0 ? _a : "";
        message.channelId = (_b = object.channelId) !== null && _b !== void 0 ? _b : "";
        message.sequence = (_c = object.sequence) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $03f84c360a5986aa$var$createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined
    };
}
module.exports.Acknowledgement = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBaseAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: $03f84c360a5986aa$var$isSet(object.result) ? $03f84c360a5986aa$var$bytesFromBase64(object.result) : undefined,
            error: $03f84c360a5986aa$var$isSet(object.error) ? String(object.error) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? $03f84c360a5986aa$var$base64FromBytes(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $03f84c360a5986aa$var$createBaseAcknowledgement();
        message.result = (_a = object.result) !== null && _a !== void 0 ? _a : undefined;
        message.error = (_b = object.error) !== null && _b !== void 0 ? _b : undefined;
        return message;
    }
};
function $03f84c360a5986aa$var$createBaseTimeout() {
    return {
        height: undefined,
        timestamp: "0"
    };
}
module.exports.Timeout = {
    encode (message, writer = $03f84c360a5986aa$var$minimal_1.default.Writer.create()) {
        if (message.height !== undefined) $04OkZ.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.timestamp !== "0") writer.uint32(16).uint64(message.timestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f84c360a5986aa$var$minimal_1.default.Reader ? input : new $03f84c360a5986aa$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f84c360a5986aa$var$createBaseTimeout();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $04OkZ.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.timestamp = $03f84c360a5986aa$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: $03f84c360a5986aa$var$isSet(object.height) ? $04OkZ.Height.fromJSON(object.height) : undefined,
            timestamp: $03f84c360a5986aa$var$isSet(object.timestamp) ? String(object.timestamp) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? $04OkZ.Height.toJSON(message.height) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $03f84c360a5986aa$var$createBaseTimeout();
        message.height = object.height !== undefined && object.height !== null ? $04OkZ.Height.fromPartial(object.height) : undefined;
        message.timestamp = (_a = object.timestamp) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
var $03f84c360a5986aa$var$globalThis = (()=>{
    if (typeof $03f84c360a5986aa$var$globalThis !== "undefined") return $03f84c360a5986aa$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $03f84c360a5986aa$var$atob = $03f84c360a5986aa$var$globalThis.atob || ((b64)=>$03f84c360a5986aa$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $03f84c360a5986aa$var$bytesFromBase64(b64) {
    const bin = $03f84c360a5986aa$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $03f84c360a5986aa$var$btoa = $03f84c360a5986aa$var$globalThis.btoa || ((bin)=>$03f84c360a5986aa$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $03f84c360a5986aa$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $03f84c360a5986aa$var$btoa(bin.join(""));
}
function $03f84c360a5986aa$var$longToString(long) {
    return long.toString();
}
if ($03f84c360a5986aa$var$minimal_1.default.util.Long !== $03f84c360a5986aa$var$long_1.default) {
    $03f84c360a5986aa$var$minimal_1.default.util.Long = $03f84c360a5986aa$var$long_1.default;
    $03f84c360a5986aa$var$minimal_1.default.configure();
}
function $03f84c360a5986aa$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("l6vEO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownMessage = void 0;

var $N0o3H = parcelRequire("N0o3H");
class $f5d2b7029923448a$var$UnknownMessage {
    constructor(/** Any type_url. */ _typeUrl, /** Any value. */ _value){
        this._typeUrl = _typeUrl;
        this._value = _value;
    }
    get typeUrl() {
        return this._typeUrl;
    }
    get value() {
        return this._value;
    }
    toJSON() {
        return {
            typeUrl: this._typeUrl,
            value: $N0o3H.Buffer.from(this._value).toString("base64")
        };
    }
}
module.exports.UnknownMessage = $f5d2b7029923448a$var$UnknownMessage;

});

parcelRegister("dBdH8", function(module, exports) {
"use strict";
var $9e695a89f4381f07$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StakeAuthorization_Validators = module.exports.StakeAuthorization = module.exports.authorizationTypeToJSON = module.exports.authorizationTypeFromJSON = module.exports.AuthorizationType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9e695a89f4381f07$var$long_1 = $9e695a89f4381f07$var$__importDefault((parcelRequire("3gmZQ")));

const $9e695a89f4381f07$var$minimal_1 = $9e695a89f4381f07$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** AuthorizationType defines the type of staking module authorization type */ var $9e695a89f4381f07$var$AuthorizationType;
(function(AuthorizationType) {
    /** AUTHORIZATION_TYPE_UNSPECIFIED - AUTHORIZATION_TYPE_UNSPECIFIED specifies an unknown authorization type */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNSPECIFIED"] = 0] = "AUTHORIZATION_TYPE_UNSPECIFIED";
    /** AUTHORIZATION_TYPE_DELEGATE - AUTHORIZATION_TYPE_DELEGATE defines an authorization type for Msg/Delegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_DELEGATE"] = 1] = "AUTHORIZATION_TYPE_DELEGATE";
    /** AUTHORIZATION_TYPE_UNDELEGATE - AUTHORIZATION_TYPE_UNDELEGATE defines an authorization type for Msg/Undelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_UNDELEGATE"] = 2] = "AUTHORIZATION_TYPE_UNDELEGATE";
    /** AUTHORIZATION_TYPE_REDELEGATE - AUTHORIZATION_TYPE_REDELEGATE defines an authorization type for Msg/BeginRedelegate */ AuthorizationType[AuthorizationType["AUTHORIZATION_TYPE_REDELEGATE"] = 3] = "AUTHORIZATION_TYPE_REDELEGATE";
    AuthorizationType[AuthorizationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9e695a89f4381f07$var$AuthorizationType = module.exports.AuthorizationType || (module.exports.AuthorizationType = {}));
function $9e695a89f4381f07$var$authorizationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "AUTHORIZATION_TYPE_UNSPECIFIED":
            return $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED;
        case 1:
        case "AUTHORIZATION_TYPE_DELEGATE":
            return $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE;
        case 2:
        case "AUTHORIZATION_TYPE_UNDELEGATE":
            return $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE;
        case 3:
        case "AUTHORIZATION_TYPE_REDELEGATE":
            return $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9e695a89f4381f07$var$AuthorizationType.UNRECOGNIZED;
    }
}
module.exports.authorizationTypeFromJSON = $9e695a89f4381f07$var$authorizationTypeFromJSON;
function $9e695a89f4381f07$var$authorizationTypeToJSON(object) {
    switch(object){
        case $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_UNSPECIFIED:
            return "AUTHORIZATION_TYPE_UNSPECIFIED";
        case $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_DELEGATE:
            return "AUTHORIZATION_TYPE_DELEGATE";
        case $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_UNDELEGATE:
            return "AUTHORIZATION_TYPE_UNDELEGATE";
        case $9e695a89f4381f07$var$AuthorizationType.AUTHORIZATION_TYPE_REDELEGATE:
            return "AUTHORIZATION_TYPE_REDELEGATE";
        default:
            return "UNKNOWN";
    }
}
module.exports.authorizationTypeToJSON = $9e695a89f4381f07$var$authorizationTypeToJSON;
function $9e695a89f4381f07$var$createBaseStakeAuthorization() {
    return {
        maxTokens: undefined,
        allowList: undefined,
        denyList: undefined,
        authorizationType: 0
    };
}
module.exports.StakeAuthorization = {
    encode (message, writer = $9e695a89f4381f07$var$minimal_1.default.Writer.create()) {
        if (message.maxTokens !== undefined) $lNGQx.Coin.encode(message.maxTokens, writer.uint32(10).fork()).ldelim();
        if (message.allowList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.allowList, writer.uint32(18).fork()).ldelim();
        if (message.denyList !== undefined) module.exports.StakeAuthorization_Validators.encode(message.denyList, writer.uint32(26).fork()).ldelim();
        if (message.authorizationType !== 0) writer.uint32(32).int32(message.authorizationType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e695a89f4381f07$var$minimal_1.default.Reader ? input : new $9e695a89f4381f07$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9e695a89f4381f07$var$createBaseStakeAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTokens = $lNGQx.Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.denyList = module.exports.StakeAuthorization_Validators.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.authorizationType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxTokens: $9e695a89f4381f07$var$isSet(object.maxTokens) ? $lNGQx.Coin.fromJSON(object.maxTokens) : undefined,
            allowList: $9e695a89f4381f07$var$isSet(object.allowList) ? module.exports.StakeAuthorization_Validators.fromJSON(object.allowList) : undefined,
            denyList: $9e695a89f4381f07$var$isSet(object.denyList) ? module.exports.StakeAuthorization_Validators.fromJSON(object.denyList) : undefined,
            authorizationType: $9e695a89f4381f07$var$isSet(object.authorizationType) ? $9e695a89f4381f07$var$authorizationTypeFromJSON(object.authorizationType) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxTokens !== undefined && (obj.maxTokens = message.maxTokens ? $lNGQx.Coin.toJSON(message.maxTokens) : undefined);
        message.allowList !== undefined && (obj.allowList = message.allowList ? module.exports.StakeAuthorization_Validators.toJSON(message.allowList) : undefined);
        message.denyList !== undefined && (obj.denyList = message.denyList ? module.exports.StakeAuthorization_Validators.toJSON(message.denyList) : undefined);
        message.authorizationType !== undefined && (obj.authorizationType = $9e695a89f4381f07$var$authorizationTypeToJSON(message.authorizationType));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $9e695a89f4381f07$var$createBaseStakeAuthorization();
        message.maxTokens = object.maxTokens !== undefined && object.maxTokens !== null ? $lNGQx.Coin.fromPartial(object.maxTokens) : undefined;
        message.allowList = object.allowList !== undefined && object.allowList !== null ? module.exports.StakeAuthorization_Validators.fromPartial(object.allowList) : undefined;
        message.denyList = object.denyList !== undefined && object.denyList !== null ? module.exports.StakeAuthorization_Validators.fromPartial(object.denyList) : undefined;
        message.authorizationType = (_a = object.authorizationType) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $9e695a89f4381f07$var$createBaseStakeAuthorization_Validators() {
    return {
        address: []
    };
}
module.exports.StakeAuthorization_Validators = {
    encode (message, writer = $9e695a89f4381f07$var$minimal_1.default.Writer.create()) {
        for (const v of message.address)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9e695a89f4381f07$var$minimal_1.default.Reader ? input : new $9e695a89f4381f07$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9e695a89f4381f07$var$createBaseStakeAuthorization_Validators();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: Array.isArray(object === null || object === void 0 ? void 0 : object.address) ? object.address.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.address) obj.address = message.address.map((e)=>e);
        else obj.address = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $9e695a89f4381f07$var$createBaseStakeAuthorization_Validators();
        message.address = ((_a = object.address) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
if ($9e695a89f4381f07$var$minimal_1.default.util.Long !== $9e695a89f4381f07$var$long_1.default) {
    $9e695a89f4381f07$var$minimal_1.default.util.Long = $9e695a89f4381f07$var$long_1.default;
    $9e695a89f4381f07$var$minimal_1.default.configure();
}
function $9e695a89f4381f07$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("dqCdR", function(module, exports) {
"use strict";
var $9c6b5a4538a99f86$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendAuthorization = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $9c6b5a4538a99f86$var$long_1 = $9c6b5a4538a99f86$var$__importDefault((parcelRequire("3gmZQ")));

const $9c6b5a4538a99f86$var$minimal_1 = $9c6b5a4538a99f86$var$__importDefault((parcelRequire("1wC51")));

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $9c6b5a4538a99f86$var$createBaseSendAuthorization() {
    return {
        spendLimit: []
    };
}
module.exports.SendAuthorization = {
    encode (message, writer = $9c6b5a4538a99f86$var$minimal_1.default.Writer.create()) {
        for (const v of message.spendLimit)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9c6b5a4538a99f86$var$minimal_1.default.Reader ? input : new $9c6b5a4538a99f86$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9c6b5a4538a99f86$var$createBaseSendAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            spendLimit: Array.isArray(object === null || object === void 0 ? void 0 : object.spendLimit) ? object.spendLimit.map((e)=>$lNGQx.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $9c6b5a4538a99f86$var$createBaseSendAuthorization();
        message.spendLimit = ((_a = object.spendLimit) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        return message;
    }
};
if ($9c6b5a4538a99f86$var$minimal_1.default.util.Long !== $9c6b5a4538a99f86$var$long_1.default) {
    $9c6b5a4538a99f86$var$minimal_1.default.util.Long = $9c6b5a4538a99f86$var$long_1.default;
    $9c6b5a4538a99f86$var$minimal_1.default.configure();
}

});

parcelRegister("fMIv2", function(module, exports) {
"use strict";
var $b7dddb6307894edc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgCalibrateDelegationResponse = module.exports.MsgCalibrateDelegation = module.exports.MsgUndelegateHostResponse = module.exports.MsgUndelegateHost = module.exports.MsgUpdateValidatorSharesExchRateResponse = module.exports.MsgUpdateValidatorSharesExchRate = module.exports.MsgRestoreInterchainAccountResponse = module.exports.MsgRestoreInterchainAccount = module.exports.MsgDeleteValidatorResponse = module.exports.MsgDeleteValidator = module.exports.MsgChangeValidatorWeightResponse = module.exports.MsgChangeValidatorWeight = module.exports.MsgAddValidatorsResponse = module.exports.MsgAddValidators = module.exports.MsgRebalanceValidatorsResponse = module.exports.MsgRebalanceValidators = module.exports.MsgClaimUndelegatedTokensResponse = module.exports.MsgClaimUndelegatedTokens = module.exports.MsgRegisterHostZoneResponse = module.exports.MsgRegisterHostZone = module.exports.MsgRedeemStakeResponse = module.exports.MsgRedeemStake = module.exports.MsgClearBalanceResponse = module.exports.MsgClearBalance = module.exports.MsgLSMLiquidStakeResponse = module.exports.MsgLSMLiquidStake = module.exports.MsgLiquidStakeResponse = module.exports.MsgLiquidStake = module.exports.MsgUpdateInnerRedemptionRateBoundsResponse = module.exports.MsgUpdateInnerRedemptionRateBounds = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $b7dddb6307894edc$var$long_1 = $b7dddb6307894edc$var$__importDefault((parcelRequire("3gmZQ")));

const $b7dddb6307894edc$var$minimal_1 = $b7dddb6307894edc$var$__importDefault((parcelRequire("1wC51")));

var $vWG6F = parcelRequire("vWG6F");

var $kSUTd = parcelRequire("kSUTd");
module.exports.protobufPackage = "stride.stakeibc";
function $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBounds() {
    return {
        creator: "",
        chainId: "",
        minInnerRedemptionRate: "",
        maxInnerRedemptionRate: ""
    };
}
module.exports.MsgUpdateInnerRedemptionRateBounds = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.minInnerRedemptionRate !== "") writer.uint32(26).string(message.minInnerRedemptionRate);
        if (message.maxInnerRedemptionRate !== "") writer.uint32(34).string(message.maxInnerRedemptionRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBounds();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.minInnerRedemptionRate = reader.string();
                    break;
                case 4:
                    message.maxInnerRedemptionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            chainId: $b7dddb6307894edc$var$isSet(object.chainId) ? String(object.chainId) : "",
            minInnerRedemptionRate: $b7dddb6307894edc$var$isSet(object.minInnerRedemptionRate) ? String(object.minInnerRedemptionRate) : "",
            maxInnerRedemptionRate: $b7dddb6307894edc$var$isSet(object.maxInnerRedemptionRate) ? String(object.maxInnerRedemptionRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.minInnerRedemptionRate !== undefined && (obj.minInnerRedemptionRate = message.minInnerRedemptionRate);
        message.maxInnerRedemptionRate !== undefined && (obj.maxInnerRedemptionRate = message.maxInnerRedemptionRate);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBounds();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.minInnerRedemptionRate = (_c = object.minInnerRedemptionRate) !== null && _c !== void 0 ? _c : "";
        message.maxInnerRedemptionRate = (_d = object.maxInnerRedemptionRate) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBoundsResponse() {
    return {};
}
module.exports.MsgUpdateInnerRedemptionRateBoundsResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBoundsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateInnerRedemptionRateBoundsResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgLiquidStake() {
    return {
        creator: "",
        amount: "",
        hostDenom: ""
    };
}
module.exports.MsgLiquidStake = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        if (message.hostDenom !== "") writer.uint32(26).string(message.hostDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgLiquidStake();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.hostDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            amount: $b7dddb6307894edc$var$isSet(object.amount) ? String(object.amount) : "",
            hostDenom: $b7dddb6307894edc$var$isSet(object.hostDenom) ? String(object.hostDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.amount !== undefined && (obj.amount = message.amount);
        message.hostDenom !== undefined && (obj.hostDenom = message.hostDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgLiquidStake();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.hostDenom = (_c = object.hostDenom) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgLiquidStakeResponse() {
    return {};
}
module.exports.MsgLiquidStakeResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgLiquidStakeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgLiquidStakeResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgLSMLiquidStake() {
    return {
        creator: "",
        amount: "",
        lsmTokenIbcDenom: ""
    };
}
module.exports.MsgLSMLiquidStake = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        if (message.lsmTokenIbcDenom !== "") writer.uint32(26).string(message.lsmTokenIbcDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgLSMLiquidStake();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.lsmTokenIbcDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            amount: $b7dddb6307894edc$var$isSet(object.amount) ? String(object.amount) : "",
            lsmTokenIbcDenom: $b7dddb6307894edc$var$isSet(object.lsmTokenIbcDenom) ? String(object.lsmTokenIbcDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.amount !== undefined && (obj.amount = message.amount);
        message.lsmTokenIbcDenom !== undefined && (obj.lsmTokenIbcDenom = message.lsmTokenIbcDenom);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgLSMLiquidStake();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.lsmTokenIbcDenom = (_c = object.lsmTokenIbcDenom) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgLSMLiquidStakeResponse() {
    return {
        transactionComplete: false
    };
}
module.exports.MsgLSMLiquidStakeResponse = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.transactionComplete === true) writer.uint32(8).bool(message.transactionComplete);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgLSMLiquidStakeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.transactionComplete = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            transactionComplete: $b7dddb6307894edc$var$isSet(object.transactionComplete) ? Boolean(object.transactionComplete) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.transactionComplete !== undefined && (obj.transactionComplete = message.transactionComplete);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $b7dddb6307894edc$var$createBaseMsgLSMLiquidStakeResponse();
        message.transactionComplete = (_a = object.transactionComplete) !== null && _a !== void 0 ? _a : false;
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgClearBalance() {
    return {
        creator: "",
        chainId: "",
        amount: "",
        channel: ""
    };
}
module.exports.MsgClearBalance = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.amount !== "") writer.uint32(26).string(message.amount);
        if (message.channel !== "") writer.uint32(34).string(message.channel);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgClearBalance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.channel = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            chainId: $b7dddb6307894edc$var$isSet(object.chainId) ? String(object.chainId) : "",
            amount: $b7dddb6307894edc$var$isSet(object.amount) ? String(object.amount) : "",
            channel: $b7dddb6307894edc$var$isSet(object.channel) ? String(object.channel) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.amount !== undefined && (obj.amount = message.amount);
        message.channel !== undefined && (obj.channel = message.channel);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b7dddb6307894edc$var$createBaseMsgClearBalance();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.channel = (_d = object.channel) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgClearBalanceResponse() {
    return {};
}
module.exports.MsgClearBalanceResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgClearBalanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgClearBalanceResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRedeemStake() {
    return {
        creator: "",
        amount: "",
        hostZone: "",
        receiver: ""
    };
}
module.exports.MsgRedeemStake = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        if (message.hostZone !== "") writer.uint32(26).string(message.hostZone);
        if (message.receiver !== "") writer.uint32(34).string(message.receiver);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRedeemStake();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.hostZone = reader.string();
                    break;
                case 4:
                    message.receiver = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            amount: $b7dddb6307894edc$var$isSet(object.amount) ? String(object.amount) : "",
            hostZone: $b7dddb6307894edc$var$isSet(object.hostZone) ? String(object.hostZone) : "",
            receiver: $b7dddb6307894edc$var$isSet(object.receiver) ? String(object.receiver) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.amount !== undefined && (obj.amount = message.amount);
        message.hostZone !== undefined && (obj.hostZone = message.hostZone);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b7dddb6307894edc$var$createBaseMsgRedeemStake();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.hostZone = (_c = object.hostZone) !== null && _c !== void 0 ? _c : "";
        message.receiver = (_d = object.receiver) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRedeemStakeResponse() {
    return {};
}
module.exports.MsgRedeemStakeResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRedeemStakeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgRedeemStakeResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRegisterHostZone() {
    return {
        connectionId: "",
        bech32prefix: "",
        hostDenom: "",
        ibcDenom: "",
        creator: "",
        transferChannelId: "",
        unbondingPeriod: "0",
        minRedemptionRate: "",
        maxRedemptionRate: "",
        lsmLiquidStakeEnabled: false
    };
}
module.exports.MsgRegisterHostZone = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.bech32prefix !== "") writer.uint32(98).string(message.bech32prefix);
        if (message.hostDenom !== "") writer.uint32(34).string(message.hostDenom);
        if (message.ibcDenom !== "") writer.uint32(42).string(message.ibcDenom);
        if (message.creator !== "") writer.uint32(50).string(message.creator);
        if (message.transferChannelId !== "") writer.uint32(82).string(message.transferChannelId);
        if (message.unbondingPeriod !== "0") writer.uint32(88).uint64(message.unbondingPeriod);
        if (message.minRedemptionRate !== "") writer.uint32(106).string(message.minRedemptionRate);
        if (message.maxRedemptionRate !== "") writer.uint32(114).string(message.maxRedemptionRate);
        if (message.lsmLiquidStakeEnabled === true) writer.uint32(120).bool(message.lsmLiquidStakeEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRegisterHostZone();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 12:
                    message.bech32prefix = reader.string();
                    break;
                case 4:
                    message.hostDenom = reader.string();
                    break;
                case 5:
                    message.ibcDenom = reader.string();
                    break;
                case 6:
                    message.creator = reader.string();
                    break;
                case 10:
                    message.transferChannelId = reader.string();
                    break;
                case 11:
                    message.unbondingPeriod = $b7dddb6307894edc$var$longToString(reader.uint64());
                    break;
                case 13:
                    message.minRedemptionRate = reader.string();
                    break;
                case 14:
                    message.maxRedemptionRate = reader.string();
                    break;
                case 15:
                    message.lsmLiquidStakeEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: $b7dddb6307894edc$var$isSet(object.connectionId) ? String(object.connectionId) : "",
            bech32prefix: $b7dddb6307894edc$var$isSet(object.bech32prefix) ? String(object.bech32prefix) : "",
            hostDenom: $b7dddb6307894edc$var$isSet(object.hostDenom) ? String(object.hostDenom) : "",
            ibcDenom: $b7dddb6307894edc$var$isSet(object.ibcDenom) ? String(object.ibcDenom) : "",
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            transferChannelId: $b7dddb6307894edc$var$isSet(object.transferChannelId) ? String(object.transferChannelId) : "",
            unbondingPeriod: $b7dddb6307894edc$var$isSet(object.unbondingPeriod) ? String(object.unbondingPeriod) : "0",
            minRedemptionRate: $b7dddb6307894edc$var$isSet(object.minRedemptionRate) ? String(object.minRedemptionRate) : "",
            maxRedemptionRate: $b7dddb6307894edc$var$isSet(object.maxRedemptionRate) ? String(object.maxRedemptionRate) : "",
            lsmLiquidStakeEnabled: $b7dddb6307894edc$var$isSet(object.lsmLiquidStakeEnabled) ? Boolean(object.lsmLiquidStakeEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.bech32prefix !== undefined && (obj.bech32prefix = message.bech32prefix);
        message.hostDenom !== undefined && (obj.hostDenom = message.hostDenom);
        message.ibcDenom !== undefined && (obj.ibcDenom = message.ibcDenom);
        message.creator !== undefined && (obj.creator = message.creator);
        message.transferChannelId !== undefined && (obj.transferChannelId = message.transferChannelId);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod);
        message.minRedemptionRate !== undefined && (obj.minRedemptionRate = message.minRedemptionRate);
        message.maxRedemptionRate !== undefined && (obj.maxRedemptionRate = message.maxRedemptionRate);
        message.lsmLiquidStakeEnabled !== undefined && (obj.lsmLiquidStakeEnabled = message.lsmLiquidStakeEnabled);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const message = $b7dddb6307894edc$var$createBaseMsgRegisterHostZone();
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        message.bech32prefix = (_b = object.bech32prefix) !== null && _b !== void 0 ? _b : "";
        message.hostDenom = (_c = object.hostDenom) !== null && _c !== void 0 ? _c : "";
        message.ibcDenom = (_d = object.ibcDenom) !== null && _d !== void 0 ? _d : "";
        message.creator = (_e = object.creator) !== null && _e !== void 0 ? _e : "";
        message.transferChannelId = (_f = object.transferChannelId) !== null && _f !== void 0 ? _f : "";
        message.unbondingPeriod = (_g = object.unbondingPeriod) !== null && _g !== void 0 ? _g : "0";
        message.minRedemptionRate = (_h = object.minRedemptionRate) !== null && _h !== void 0 ? _h : "";
        message.maxRedemptionRate = (_j = object.maxRedemptionRate) !== null && _j !== void 0 ? _j : "";
        message.lsmLiquidStakeEnabled = (_k = object.lsmLiquidStakeEnabled) !== null && _k !== void 0 ? _k : false;
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRegisterHostZoneResponse() {
    return {};
}
module.exports.MsgRegisterHostZoneResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRegisterHostZoneResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgRegisterHostZoneResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokens() {
    return {
        creator: "",
        hostZoneId: "",
        epoch: "0",
        sender: ""
    };
}
module.exports.MsgClaimUndelegatedTokens = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.hostZoneId !== "") writer.uint32(18).string(message.hostZoneId);
        if (message.epoch !== "0") writer.uint32(24).uint64(message.epoch);
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokens();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.hostZoneId = reader.string();
                    break;
                case 3:
                    message.epoch = $b7dddb6307894edc$var$longToString(reader.uint64());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            hostZoneId: $b7dddb6307894edc$var$isSet(object.hostZoneId) ? String(object.hostZoneId) : "",
            epoch: $b7dddb6307894edc$var$isSet(object.epoch) ? String(object.epoch) : "0",
            sender: $b7dddb6307894edc$var$isSet(object.sender) ? String(object.sender) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.hostZoneId !== undefined && (obj.hostZoneId = message.hostZoneId);
        message.epoch !== undefined && (obj.epoch = message.epoch);
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokens();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.hostZoneId = (_b = object.hostZoneId) !== null && _b !== void 0 ? _b : "";
        message.epoch = (_c = object.epoch) !== null && _c !== void 0 ? _c : "0";
        message.sender = (_d = object.sender) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokensResponse() {
    return {};
}
module.exports.MsgClaimUndelegatedTokensResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokensResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgClaimUndelegatedTokensResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRebalanceValidators() {
    return {
        creator: "",
        hostZone: "",
        numRebalance: "0"
    };
}
module.exports.MsgRebalanceValidators = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.hostZone !== "") writer.uint32(18).string(message.hostZone);
        if (message.numRebalance !== "0") writer.uint32(24).uint64(message.numRebalance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRebalanceValidators();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.hostZone = reader.string();
                    break;
                case 3:
                    message.numRebalance = $b7dddb6307894edc$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            hostZone: $b7dddb6307894edc$var$isSet(object.hostZone) ? String(object.hostZone) : "",
            numRebalance: $b7dddb6307894edc$var$isSet(object.numRebalance) ? String(object.numRebalance) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.hostZone !== undefined && (obj.hostZone = message.hostZone);
        message.numRebalance !== undefined && (obj.numRebalance = message.numRebalance);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgRebalanceValidators();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.hostZone = (_b = object.hostZone) !== null && _b !== void 0 ? _b : "";
        message.numRebalance = (_c = object.numRebalance) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRebalanceValidatorsResponse() {
    return {};
}
module.exports.MsgRebalanceValidatorsResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRebalanceValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgRebalanceValidatorsResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgAddValidators() {
    return {
        creator: "",
        hostZone: "",
        validators: []
    };
}
module.exports.MsgAddValidators = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.hostZone !== "") writer.uint32(18).string(message.hostZone);
        for (const v of message.validators)$kSUTd.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgAddValidators();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.hostZone = reader.string();
                    break;
                case 3:
                    message.validators.push($kSUTd.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            hostZone: $b7dddb6307894edc$var$isSet(object.hostZone) ? String(object.hostZone) : "",
            validators: Array.isArray(object === null || object === void 0 ? void 0 : object.validators) ? object.validators.map((e)=>$kSUTd.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.hostZone !== undefined && (obj.hostZone = message.hostZone);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $kSUTd.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgAddValidators();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.hostZone = (_b = object.hostZone) !== null && _b !== void 0 ? _b : "";
        message.validators = ((_c = object.validators) === null || _c === void 0 ? void 0 : _c.map((e)=>$kSUTd.Validator.fromPartial(e))) || [];
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgAddValidatorsResponse() {
    return {};
}
module.exports.MsgAddValidatorsResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgAddValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgAddValidatorsResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeight() {
    return {
        creator: "",
        hostZone: "",
        valAddr: "",
        weight: "0"
    };
}
module.exports.MsgChangeValidatorWeight = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.hostZone !== "") writer.uint32(18).string(message.hostZone);
        if (message.valAddr !== "") writer.uint32(26).string(message.valAddr);
        if (message.weight !== "0") writer.uint32(32).uint64(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.hostZone = reader.string();
                    break;
                case 3:
                    message.valAddr = reader.string();
                    break;
                case 4:
                    message.weight = $b7dddb6307894edc$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            hostZone: $b7dddb6307894edc$var$isSet(object.hostZone) ? String(object.hostZone) : "",
            valAddr: $b7dddb6307894edc$var$isSet(object.valAddr) ? String(object.valAddr) : "",
            weight: $b7dddb6307894edc$var$isSet(object.weight) ? String(object.weight) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.hostZone !== undefined && (obj.hostZone = message.hostZone);
        message.valAddr !== undefined && (obj.valAddr = message.valAddr);
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeight();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.hostZone = (_b = object.hostZone) !== null && _b !== void 0 ? _b : "";
        message.valAddr = (_c = object.valAddr) !== null && _c !== void 0 ? _c : "";
        message.weight = (_d = object.weight) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeightResponse() {
    return {};
}
module.exports.MsgChangeValidatorWeightResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeightResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgChangeValidatorWeightResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgDeleteValidator() {
    return {
        creator: "",
        hostZone: "",
        valAddr: ""
    };
}
module.exports.MsgDeleteValidator = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.hostZone !== "") writer.uint32(18).string(message.hostZone);
        if (message.valAddr !== "") writer.uint32(26).string(message.valAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgDeleteValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.hostZone = reader.string();
                    break;
                case 3:
                    message.valAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            hostZone: $b7dddb6307894edc$var$isSet(object.hostZone) ? String(object.hostZone) : "",
            valAddr: $b7dddb6307894edc$var$isSet(object.valAddr) ? String(object.valAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.hostZone !== undefined && (obj.hostZone = message.hostZone);
        message.valAddr !== undefined && (obj.valAddr = message.valAddr);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgDeleteValidator();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.hostZone = (_b = object.hostZone) !== null && _b !== void 0 ? _b : "";
        message.valAddr = (_c = object.valAddr) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgDeleteValidatorResponse() {
    return {};
}
module.exports.MsgDeleteValidatorResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgDeleteValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgDeleteValidatorResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccount() {
    return {
        creator: "",
        chainId: "",
        accountType: 0
    };
}
module.exports.MsgRestoreInterchainAccount = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.accountType !== 0) writer.uint32(24).int32(message.accountType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.accountType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            chainId: $b7dddb6307894edc$var$isSet(object.chainId) ? String(object.chainId) : "",
            accountType: $b7dddb6307894edc$var$isSet(object.accountType) ? (0, $vWG6F.iCAAccountTypeFromJSON)(object.accountType) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountType !== undefined && (obj.accountType = (0, $vWG6F.iCAAccountTypeToJSON)(message.accountType));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccount();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.accountType = (_c = object.accountType) !== null && _c !== void 0 ? _c : 0;
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccountResponse() {
    return {};
}
module.exports.MsgRestoreInterchainAccountResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgRestoreInterchainAccountResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRate() {
    return {
        creator: "",
        chainId: "",
        valoper: ""
    };
}
module.exports.MsgUpdateValidatorSharesExchRate = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.valoper !== "") writer.uint32(26).string(message.valoper);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.valoper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            chainId: $b7dddb6307894edc$var$isSet(object.chainId) ? String(object.chainId) : "",
            valoper: $b7dddb6307894edc$var$isSet(object.valoper) ? String(object.valoper) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.valoper !== undefined && (obj.valoper = message.valoper);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRate();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.valoper = (_c = object.valoper) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRateResponse() {
    return {};
}
module.exports.MsgUpdateValidatorSharesExchRateResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgUpdateValidatorSharesExchRateResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgUndelegateHost() {
    return {
        creator: "",
        amount: ""
    };
}
module.exports.MsgUndelegateHost = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUndelegateHost();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            amount: $b7dddb6307894edc$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $b7dddb6307894edc$var$createBaseMsgUndelegateHost();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgUndelegateHostResponse() {
    return {};
}
module.exports.MsgUndelegateHostResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgUndelegateHostResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgUndelegateHostResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgCalibrateDelegation() {
    return {
        creator: "",
        chainId: "",
        valoper: ""
    };
}
module.exports.MsgCalibrateDelegation = {
    encode (message, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.valoper !== "") writer.uint32(26).string(message.valoper);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgCalibrateDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.valoper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creator: $b7dddb6307894edc$var$isSet(object.creator) ? String(object.creator) : "",
            chainId: $b7dddb6307894edc$var$isSet(object.chainId) ? String(object.chainId) : "",
            valoper: $b7dddb6307894edc$var$isSet(object.valoper) ? String(object.valoper) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.valoper !== undefined && (obj.valoper = message.valoper);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $b7dddb6307894edc$var$createBaseMsgCalibrateDelegation();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.chainId = (_b = object.chainId) !== null && _b !== void 0 ? _b : "";
        message.valoper = (_c = object.valoper) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b7dddb6307894edc$var$createBaseMsgCalibrateDelegationResponse() {
    return {};
}
module.exports.MsgCalibrateDelegationResponse = {
    encode (_, writer = $b7dddb6307894edc$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b7dddb6307894edc$var$minimal_1.default.Reader ? input : new $b7dddb6307894edc$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b7dddb6307894edc$var$createBaseMsgCalibrateDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $b7dddb6307894edc$var$createBaseMsgCalibrateDelegationResponse();
        return message;
    }
};
function $b7dddb6307894edc$var$longToString(long) {
    return long.toString();
}
if ($b7dddb6307894edc$var$minimal_1.default.util.Long !== $b7dddb6307894edc$var$long_1.default) {
    $b7dddb6307894edc$var$minimal_1.default.util.Long = $b7dddb6307894edc$var$long_1.default;
    $b7dddb6307894edc$var$minimal_1.default.configure();
}
function $b7dddb6307894edc$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("vWG6F", function(module, exports) {
"use strict";
var $0600699f02087846$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iCAAccountTypeToJSON = module.exports.iCAAccountTypeFromJSON = module.exports.ICAAccountType = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0600699f02087846$var$long_1 = $0600699f02087846$var$__importDefault((parcelRequire("3gmZQ")));

const $0600699f02087846$var$minimal_1 = $0600699f02087846$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "stride.stakeibc";
var $0600699f02087846$var$ICAAccountType;
(function(ICAAccountType) {
    ICAAccountType[ICAAccountType["DELEGATION"] = 0] = "DELEGATION";
    ICAAccountType[ICAAccountType["FEE"] = 1] = "FEE";
    ICAAccountType[ICAAccountType["WITHDRAWAL"] = 2] = "WITHDRAWAL";
    ICAAccountType[ICAAccountType["REDEMPTION"] = 3] = "REDEMPTION";
    ICAAccountType[ICAAccountType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0600699f02087846$var$ICAAccountType = module.exports.ICAAccountType || (module.exports.ICAAccountType = {}));
function $0600699f02087846$var$iCAAccountTypeFromJSON(object) {
    switch(object){
        case 0:
        case "DELEGATION":
            return $0600699f02087846$var$ICAAccountType.DELEGATION;
        case 1:
        case "FEE":
            return $0600699f02087846$var$ICAAccountType.FEE;
        case 2:
        case "WITHDRAWAL":
            return $0600699f02087846$var$ICAAccountType.WITHDRAWAL;
        case 3:
        case "REDEMPTION":
            return $0600699f02087846$var$ICAAccountType.REDEMPTION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0600699f02087846$var$ICAAccountType.UNRECOGNIZED;
    }
}
module.exports.iCAAccountTypeFromJSON = $0600699f02087846$var$iCAAccountTypeFromJSON;
function $0600699f02087846$var$iCAAccountTypeToJSON(object) {
    switch(object){
        case $0600699f02087846$var$ICAAccountType.DELEGATION:
            return "DELEGATION";
        case $0600699f02087846$var$ICAAccountType.FEE:
            return "FEE";
        case $0600699f02087846$var$ICAAccountType.WITHDRAWAL:
            return "WITHDRAWAL";
        case $0600699f02087846$var$ICAAccountType.REDEMPTION:
            return "REDEMPTION";
        default:
            return "UNKNOWN";
    }
}
module.exports.iCAAccountTypeToJSON = $0600699f02087846$var$iCAAccountTypeToJSON;
if ($0600699f02087846$var$minimal_1.default.util.Long !== $0600699f02087846$var$long_1.default) {
    $0600699f02087846$var$minimal_1.default.util.Long = $0600699f02087846$var$long_1.default;
    $0600699f02087846$var$minimal_1.default.configure();
}

});

parcelRegister("kSUTd", function(module, exports) {
"use strict";
var $f344fade40a494c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Validator = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $f344fade40a494c5$var$long_1 = $f344fade40a494c5$var$__importDefault((parcelRequire("3gmZQ")));

const $f344fade40a494c5$var$minimal_1 = $f344fade40a494c5$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "stride.stakeibc";
function $f344fade40a494c5$var$createBaseValidator() {
    return {
        name: "",
        address: "",
        weight: "0",
        delegation: "",
        slashQueryProgressTracker: "",
        slashQueryCheckpoint: "",
        sharesToTokensRate: "",
        delegationChangesInProgress: "0",
        slashQueryInProgress: false
    };
}
module.exports.Validator = {
    encode (message, writer = $f344fade40a494c5$var$minimal_1.default.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.address !== "") writer.uint32(18).string(message.address);
        if (message.weight !== "0") writer.uint32(48).uint64(message.weight);
        if (message.delegation !== "") writer.uint32(42).string(message.delegation);
        if (message.slashQueryProgressTracker !== "") writer.uint32(74).string(message.slashQueryProgressTracker);
        if (message.slashQueryCheckpoint !== "") writer.uint32(98).string(message.slashQueryCheckpoint);
        if (message.sharesToTokensRate !== "") writer.uint32(82).string(message.sharesToTokensRate);
        if (message.delegationChangesInProgress !== "0") writer.uint32(88).int64(message.delegationChangesInProgress);
        if (message.slashQueryInProgress === true) writer.uint32(104).bool(message.slashQueryInProgress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f344fade40a494c5$var$minimal_1.default.Reader ? input : new $f344fade40a494c5$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f344fade40a494c5$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 6:
                    message.weight = $f344fade40a494c5$var$longToString(reader.uint64());
                    break;
                case 5:
                    message.delegation = reader.string();
                    break;
                case 9:
                    message.slashQueryProgressTracker = reader.string();
                    break;
                case 12:
                    message.slashQueryCheckpoint = reader.string();
                    break;
                case 10:
                    message.sharesToTokensRate = reader.string();
                    break;
                case 11:
                    message.delegationChangesInProgress = $f344fade40a494c5$var$longToString(reader.int64());
                    break;
                case 13:
                    message.slashQueryInProgress = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: $f344fade40a494c5$var$isSet(object.name) ? String(object.name) : "",
            address: $f344fade40a494c5$var$isSet(object.address) ? String(object.address) : "",
            weight: $f344fade40a494c5$var$isSet(object.weight) ? String(object.weight) : "0",
            delegation: $f344fade40a494c5$var$isSet(object.delegation) ? String(object.delegation) : "",
            slashQueryProgressTracker: $f344fade40a494c5$var$isSet(object.slashQueryProgressTracker) ? String(object.slashQueryProgressTracker) : "",
            slashQueryCheckpoint: $f344fade40a494c5$var$isSet(object.slashQueryCheckpoint) ? String(object.slashQueryCheckpoint) : "",
            sharesToTokensRate: $f344fade40a494c5$var$isSet(object.sharesToTokensRate) ? String(object.sharesToTokensRate) : "",
            delegationChangesInProgress: $f344fade40a494c5$var$isSet(object.delegationChangesInProgress) ? String(object.delegationChangesInProgress) : "0",
            slashQueryInProgress: $f344fade40a494c5$var$isSet(object.slashQueryInProgress) ? Boolean(object.slashQueryInProgress) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.delegation !== undefined && (obj.delegation = message.delegation);
        message.slashQueryProgressTracker !== undefined && (obj.slashQueryProgressTracker = message.slashQueryProgressTracker);
        message.slashQueryCheckpoint !== undefined && (obj.slashQueryCheckpoint = message.slashQueryCheckpoint);
        message.sharesToTokensRate !== undefined && (obj.sharesToTokensRate = message.sharesToTokensRate);
        message.delegationChangesInProgress !== undefined && (obj.delegationChangesInProgress = message.delegationChangesInProgress);
        message.slashQueryInProgress !== undefined && (obj.slashQueryInProgress = message.slashQueryInProgress);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = $f344fade40a494c5$var$createBaseValidator();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : "";
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        message.weight = (_c = object.weight) !== null && _c !== void 0 ? _c : "0";
        message.delegation = (_d = object.delegation) !== null && _d !== void 0 ? _d : "";
        message.slashQueryProgressTracker = (_e = object.slashQueryProgressTracker) !== null && _e !== void 0 ? _e : "";
        message.slashQueryCheckpoint = (_f = object.slashQueryCheckpoint) !== null && _f !== void 0 ? _f : "";
        message.sharesToTokensRate = (_g = object.sharesToTokensRate) !== null && _g !== void 0 ? _g : "";
        message.delegationChangesInProgress = (_h = object.delegationChangesInProgress) !== null && _h !== void 0 ? _h : "0";
        message.slashQueryInProgress = (_j = object.slashQueryInProgress) !== null && _j !== void 0 ? _j : false;
        return message;
    }
};
function $f344fade40a494c5$var$longToString(long) {
    return long.toString();
}
if ($f344fade40a494c5$var$minimal_1.default.util.Long !== $f344fade40a494c5$var$long_1.default) {
    $f344fade40a494c5$var$minimal_1.default.util.Long = $f344fade40a494c5$var$long_1.default;
    $f344fade40a494c5$var$minimal_1.default.configure();
}
function $f344fade40a494c5$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("7Mse2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProtoSignDocDecoder = void 0;

var $2Y0YW = parcelRequire("2Y0YW");

var $3MSR0 = parcelRequire("3MSR0");
class $5aa2e918268b0fea$var$ProtoSignDocDecoder {
    static decode(bytes) {
        return new $5aa2e918268b0fea$var$ProtoSignDocDecoder($2Y0YW.SignDoc.decode(bytes));
    }
    constructor(signDoc, protoCodec = $3MSR0.defaultProtoCodec){
        this.signDoc = signDoc;
        this.protoCodec = protoCodec;
    }
    get txBody() {
        if (!this._txBody) this._txBody = $2Y0YW.TxBody.decode(this.signDoc.bodyBytes);
        return this._txBody;
    }
    get txMsgs() {
        const msgs = [];
        for (const msg of this.txBody.messages)msgs.push(this.protoCodec.unpackAny(msg));
        return msgs;
    }
    get authInfo() {
        if (!this._authInfo) this._authInfo = $2Y0YW.AuthInfo.decode(this.signDoc.authInfoBytes);
        return this._authInfo;
    }
    get chainId() {
        return this.signDoc.chainId;
    }
    get accountNumber() {
        return this.signDoc.accountNumber.toString();
    }
    toBytes() {
        return $2Y0YW.SignDoc.encode(this.signDoc).finish();
    }
    toJSON() {
        return {
            txBody: Object.assign(Object.assign({}, $2Y0YW.TxBody.toJSON(this.txBody)), {
                messages: this.txMsgs.map((msg)=>{
                    return this.protoCodec.unpackedAnyToJSONRecursive(msg);
                })
            }),
            authInfo: $2Y0YW.AuthInfo.toJSON(this.authInfo),
            chainId: this.chainId,
            accountNumber: this.accountNumber
        };
    }
}
module.exports.ProtoSignDocDecoder = $5aa2e918268b0fea$var$ProtoSignDocDecoder;

});
parcelRegister("2Y0YW", function(module, exports) {
"use strict";
var $2291f25e32331d64$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fee = module.exports.ModeInfo_Multi = module.exports.ModeInfo_Single = module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.SignDoc = module.exports.TxRaw = module.exports.Tx = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $2291f25e32331d64$var$long_1 = $2291f25e32331d64$var$__importDefault((parcelRequire("3gmZQ")));

const $2291f25e32331d64$var$minimal_1 = $2291f25e32331d64$var$__importDefault((parcelRequire("1wC51")));

var $8stwJ = parcelRequire("8stwJ");

var $fV2Ok = parcelRequire("fV2Ok");

var $iBs9a = parcelRequire("iBs9a");

var $lNGQx = parcelRequire("lNGQx");
module.exports.protobufPackage = "cosmos.tx.v1beta1";
function $2291f25e32331d64$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
module.exports.Tx = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.body !== undefined) module.exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) module.exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = module.exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = module.exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            body: $2291f25e32331d64$var$isSet(object.body) ? module.exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: $2291f25e32331d64$var$isSet(object.authInfo) ? module.exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$2291f25e32331d64$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? module.exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? module.exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$2291f25e32331d64$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $2291f25e32331d64$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? module.exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? module.exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $2291f25e32331d64$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
module.exports.TxRaw = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseTxRaw();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: $2291f25e32331d64$var$isSet(object.bodyBytes) ? $2291f25e32331d64$var$bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: $2291f25e32331d64$var$isSet(object.authInfoBytes) ? $2291f25e32331d64$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$2291f25e32331d64$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $2291f25e32331d64$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $2291f25e32331d64$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$2291f25e32331d64$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $2291f25e32331d64$var$createBaseTxRaw();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.signatures = ((_c = object.signatures) === null || _c === void 0 ? void 0 : _c.map((e)=>e)) || [];
        return message;
    }
};
function $2291f25e32331d64$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: "0"
    };
}
module.exports.SignDoc = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (message.accountNumber !== "0") writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseSignDoc();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = $2291f25e32331d64$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: $2291f25e32331d64$var$isSet(object.bodyBytes) ? $2291f25e32331d64$var$bytesFromBase64(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: $2291f25e32331d64$var$isSet(object.authInfoBytes) ? $2291f25e32331d64$var$bytesFromBase64(object.authInfoBytes) : new Uint8Array(),
            chainId: $2291f25e32331d64$var$isSet(object.chainId) ? String(object.chainId) : "",
            accountNumber: $2291f25e32331d64$var$isSet(object.accountNumber) ? String(object.accountNumber) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = $2291f25e32331d64$var$base64FromBytes(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = $2291f25e32331d64$var$base64FromBytes(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = message.accountNumber);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $2291f25e32331d64$var$createBaseSignDoc();
        message.bodyBytes = (_a = object.bodyBytes) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.authInfoBytes = (_b = object.authInfoBytes) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.chainId = (_c = object.chainId) !== null && _c !== void 0 ? _c : "";
        message.accountNumber = (_d = object.accountNumber) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $2291f25e32331d64$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: "0",
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
module.exports.TxBody = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        for (const v of message.messages)$fV2Ok.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (message.timeoutHeight !== "0") writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$fV2Ok.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$fV2Ok.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseTxBody();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($fV2Ok.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = $2291f25e32331d64$var$longToString(reader.uint64());
                    break;
                case 1023:
                    message.extensionOptions.push($fV2Ok.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($fV2Ok.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map((e)=>$fV2Ok.Any.fromJSON(e)) : [],
            memo: $2291f25e32331d64$var$isSet(object.memo) ? String(object.memo) : "",
            timeoutHeight: $2291f25e32331d64$var$isSet(object.timeoutHeight) ? String(object.timeoutHeight) : "0",
            extensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.extensionOptions) ? object.extensionOptions.map((e)=>$fV2Ok.Any.fromJSON(e)) : [],
            nonCriticalExtensionOptions: Array.isArray(object === null || object === void 0 ? void 0 : object.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map((e)=>$fV2Ok.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $fV2Ok.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight);
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $fV2Ok.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $fV2Ok.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $2291f25e32331d64$var$createBaseTxBody();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map((e)=>$fV2Ok.Any.fromPartial(e))) || [];
        message.memo = (_b = object.memo) !== null && _b !== void 0 ? _b : "";
        message.timeoutHeight = (_c = object.timeoutHeight) !== null && _c !== void 0 ? _c : "0";
        message.extensionOptions = ((_d = object.extensionOptions) === null || _d === void 0 ? void 0 : _d.map((e)=>$fV2Ok.Any.fromPartial(e))) || [];
        message.nonCriticalExtensionOptions = ((_e = object.nonCriticalExtensionOptions) === null || _e === void 0 ? void 0 : _e.map((e)=>$fV2Ok.Any.fromPartial(e))) || [];
        return message;
    }
};
function $2291f25e32331d64$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined
    };
}
module.exports.AuthInfo = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        for (const v of message.signerInfos)module.exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseAuthInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push(module.exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signerInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.signerInfos) ? object.signerInfos.map((e)=>module.exports.SignerInfo.fromJSON(e)) : [],
            fee: $2291f25e32331d64$var$isSet(object.fee) ? module.exports.Fee.fromJSON(object.fee) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? module.exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $2291f25e32331d64$var$createBaseAuthInfo();
        message.signerInfos = ((_a = object.signerInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignerInfo.fromPartial(e))) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? module.exports.Fee.fromPartial(object.fee) : undefined;
        return message;
    }
};
function $2291f25e32331d64$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: "0"
    };
}
module.exports.SignerInfo = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $fV2Ok.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) module.exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseSignerInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = module.exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = $2291f25e32331d64$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: $2291f25e32331d64$var$isSet(object.publicKey) ? $fV2Ok.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: $2291f25e32331d64$var$isSet(object.modeInfo) ? module.exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: $2291f25e32331d64$var$isSet(object.sequence) ? String(object.sequence) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $fV2Ok.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? module.exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $2291f25e32331d64$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $fV2Ok.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? module.exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = (_a = object.sequence) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $2291f25e32331d64$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.ModeInfo = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseModeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: $2291f25e32331d64$var$isSet(object.single) ? module.exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: $2291f25e32331d64$var$isSet(object.multi) ? module.exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2291f25e32331d64$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? module.exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $2291f25e32331d64$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
module.exports.ModeInfo_Single = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: $2291f25e32331d64$var$isSet(object.mode) ? (0, $8stwJ.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, $8stwJ.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $2291f25e32331d64$var$createBaseModeInfo_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $2291f25e32331d64$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
module.exports.ModeInfo_Multi = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $iBs9a.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)module.exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $iBs9a.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(module.exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: $2291f25e32331d64$var$isSet(object.bitarray) ? $iBs9a.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object === null || object === void 0 ? void 0 : object.modeInfos) ? object.modeInfos.map((e)=>module.exports.ModeInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $iBs9a.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? module.exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $2291f25e32331d64$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $iBs9a.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = ((_a = object.modeInfos) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.ModeInfo.fromPartial(e))) || [];
        return message;
    }
};
function $2291f25e32331d64$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: "0",
        payer: "",
        granter: ""
    };
}
module.exports.Fee = {
    encode (message, writer = $2291f25e32331d64$var$minimal_1.default.Writer.create()) {
        for (const v of message.amount)$lNGQx.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.gasLimit !== "0") writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2291f25e32331d64$var$minimal_1.default.Reader ? input : new $2291f25e32331d64$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2291f25e32331d64$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($lNGQx.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = $2291f25e32331d64$var$longToString(reader.uint64());
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map((e)=>$lNGQx.Coin.fromJSON(e)) : [],
            gasLimit: $2291f25e32331d64$var$isSet(object.gasLimit) ? String(object.gasLimit) : "0",
            payer: $2291f25e32331d64$var$isSet(object.payer) ? String(object.payer) : "",
            granter: $2291f25e32331d64$var$isSet(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $lNGQx.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = message.gasLimit);
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $2291f25e32331d64$var$createBaseFee();
        message.amount = ((_a = object.amount) === null || _a === void 0 ? void 0 : _a.map((e)=>$lNGQx.Coin.fromPartial(e))) || [];
        message.gasLimit = (_b = object.gasLimit) !== null && _b !== void 0 ? _b : "0";
        message.payer = (_c = object.payer) !== null && _c !== void 0 ? _c : "";
        message.granter = (_d = object.granter) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
var $2291f25e32331d64$var$globalThis = (()=>{
    if (typeof $2291f25e32331d64$var$globalThis !== "undefined") return $2291f25e32331d64$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $2291f25e32331d64$var$atob = $2291f25e32331d64$var$globalThis.atob || ((b64)=>$2291f25e32331d64$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $2291f25e32331d64$var$bytesFromBase64(b64) {
    const bin = $2291f25e32331d64$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $2291f25e32331d64$var$btoa = $2291f25e32331d64$var$globalThis.btoa || ((bin)=>$2291f25e32331d64$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $2291f25e32331d64$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $2291f25e32331d64$var$btoa(bin.join(""));
}
function $2291f25e32331d64$var$longToString(long) {
    return long.toString();
}
if ($2291f25e32331d64$var$minimal_1.default.util.Long !== $2291f25e32331d64$var$long_1.default) {
    $2291f25e32331d64$var$minimal_1.default.util.Long = $2291f25e32331d64$var$long_1.default;
    $2291f25e32331d64$var$minimal_1.default.configure();
}
function $2291f25e32331d64$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("8stwJ", function(module, exports) {
"use strict";
var $6287d7a9cd73df60$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureDescriptor_Data_Multi = module.exports.SignatureDescriptor_Data_Single = module.exports.SignatureDescriptor_Data = module.exports.SignatureDescriptor = module.exports.SignatureDescriptors = module.exports.signModeToJSON = module.exports.signModeFromJSON = module.exports.SignMode = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $6287d7a9cd73df60$var$long_1 = $6287d7a9cd73df60$var$__importDefault((parcelRequire("3gmZQ")));

const $6287d7a9cd73df60$var$minimal_1 = $6287d7a9cd73df60$var$__importDefault((parcelRequire("1wC51")));

var $fV2Ok = parcelRequire("fV2Ok");

var $iBs9a = parcelRequire("iBs9a");
module.exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/** SignMode represents a signing mode with its own security guarantees. */ var $6287d7a9cd73df60$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6287d7a9cd73df60$var$SignMode = module.exports.SignMode || (module.exports.SignMode = {}));
function $6287d7a9cd73df60$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $6287d7a9cd73df60$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $6287d7a9cd73df60$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $6287d7a9cd73df60$var$SignMode.SIGN_MODE_TEXTUAL;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $6287d7a9cd73df60$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6287d7a9cd73df60$var$SignMode.UNRECOGNIZED;
    }
}
module.exports.signModeFromJSON = $6287d7a9cd73df60$var$signModeFromJSON;
function $6287d7a9cd73df60$var$signModeToJSON(object) {
    switch(object){
        case $6287d7a9cd73df60$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $6287d7a9cd73df60$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $6287d7a9cd73df60$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $6287d7a9cd73df60$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        default:
            return "UNKNOWN";
    }
}
module.exports.signModeToJSON = $6287d7a9cd73df60$var$signModeToJSON;
function $6287d7a9cd73df60$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
module.exports.SignatureDescriptors = {
    encode (message, writer = $6287d7a9cd73df60$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)module.exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6287d7a9cd73df60$var$minimal_1.default.Reader ? input : new $6287d7a9cd73df60$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(module.exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptors();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignatureDescriptor.fromPartial(e))) || [];
        return message;
    }
};
function $6287d7a9cd73df60$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: "0"
    };
}
module.exports.SignatureDescriptor = {
    encode (message, writer = $6287d7a9cd73df60$var$minimal_1.default.Writer.create()) {
        if (message.publicKey !== undefined) $fV2Ok.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) module.exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.sequence !== "0") writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6287d7a9cd73df60$var$minimal_1.default.Reader ? input : new $6287d7a9cd73df60$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $fV2Ok.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = $6287d7a9cd73df60$var$longToString(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: $6287d7a9cd73df60$var$isSet(object.publicKey) ? $fV2Ok.Any.fromJSON(object.publicKey) : undefined,
            data: $6287d7a9cd73df60$var$isSet(object.data) ? module.exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: $6287d7a9cd73df60$var$isSet(object.sequence) ? String(object.sequence) : "0"
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $fV2Ok.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? module.exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = message.sequence);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $fV2Ok.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? module.exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = (_a = object.sequence) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.SignatureDescriptor_Data = {
    encode (message, writer = $6287d7a9cd73df60$var$minimal_1.default.Writer.create()) {
        if (message.single !== undefined) module.exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6287d7a9cd73df60$var$minimal_1.default.Reader ? input : new $6287d7a9cd73df60$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: $6287d7a9cd73df60$var$isSet(object.single) ? module.exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: $6287d7a9cd73df60$var$isSet(object.multi) ? module.exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? module.exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
module.exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $6287d7a9cd73df60$var$minimal_1.default.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6287d7a9cd73df60$var$minimal_1.default.Reader ? input : new $6287d7a9cd73df60$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: $6287d7a9cd73df60$var$isSet(object.mode) ? $6287d7a9cd73df60$var$signModeFromJSON(object.mode) : 0,
            signature: $6287d7a9cd73df60$var$isSet(object.signature) ? $6287d7a9cd73df60$var$bytesFromBase64(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $6287d7a9cd73df60$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = $6287d7a9cd73df60$var$base64FromBytes(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Single();
        message.mode = (_a = object.mode) !== null && _a !== void 0 ? _a : 0;
        message.signature = (_b = object.signature) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
module.exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $6287d7a9cd73df60$var$minimal_1.default.Writer.create()) {
        if (message.bitarray !== undefined) $iBs9a.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)module.exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6287d7a9cd73df60$var$minimal_1.default.Reader ? input : new $6287d7a9cd73df60$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $iBs9a.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: $6287d7a9cd73df60$var$isSet(object.bitarray) ? $iBs9a.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor_Data.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $iBs9a.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $6287d7a9cd73df60$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $iBs9a.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>module.exports.SignatureDescriptor_Data.fromPartial(e))) || [];
        return message;
    }
};
var $6287d7a9cd73df60$var$globalThis = (()=>{
    if (typeof $6287d7a9cd73df60$var$globalThis !== "undefined") return $6287d7a9cd73df60$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $6287d7a9cd73df60$var$atob = $6287d7a9cd73df60$var$globalThis.atob || ((b64)=>$6287d7a9cd73df60$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $6287d7a9cd73df60$var$bytesFromBase64(b64) {
    const bin = $6287d7a9cd73df60$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $6287d7a9cd73df60$var$btoa = $6287d7a9cd73df60$var$globalThis.btoa || ((bin)=>$6287d7a9cd73df60$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $6287d7a9cd73df60$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $6287d7a9cd73df60$var$btoa(bin.join(""));
}
function $6287d7a9cd73df60$var$longToString(long) {
    return long.toString();
}
if ($6287d7a9cd73df60$var$minimal_1.default.util.Long !== $6287d7a9cd73df60$var$long_1.default) {
    $6287d7a9cd73df60$var$minimal_1.default.util.Long = $6287d7a9cd73df60$var$long_1.default;
    $6287d7a9cd73df60$var$minimal_1.default.configure();
}
function $6287d7a9cd73df60$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("iBs9a", function(module, exports) {
"use strict";
var $d8b1841122a43167$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = module.exports.MultiSignature = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $d8b1841122a43167$var$long_1 = $d8b1841122a43167$var$__importDefault((parcelRequire("3gmZQ")));

const $d8b1841122a43167$var$minimal_1 = $d8b1841122a43167$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $d8b1841122a43167$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
module.exports.MultiSignature = {
    encode (message, writer = $d8b1841122a43167$var$minimal_1.default.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8b1841122a43167$var$minimal_1.default.Reader ? input : new $d8b1841122a43167$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8b1841122a43167$var$createBaseMultiSignature();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object === null || object === void 0 ? void 0 : object.signatures) ? object.signatures.map((e)=>$d8b1841122a43167$var$bytesFromBase64(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>$d8b1841122a43167$var$base64FromBytes(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $d8b1841122a43167$var$createBaseMultiSignature();
        message.signatures = ((_a = object.signatures) === null || _a === void 0 ? void 0 : _a.map((e)=>e)) || [];
        return message;
    }
};
function $d8b1841122a43167$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
module.exports.CompactBitArray = {
    encode (message, writer = $d8b1841122a43167$var$minimal_1.default.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8b1841122a43167$var$minimal_1.default.Reader ? input : new $d8b1841122a43167$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8b1841122a43167$var$createBaseCompactBitArray();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            extraBitsStored: $d8b1841122a43167$var$isSet(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: $d8b1841122a43167$var$isSet(object.elems) ? $d8b1841122a43167$var$bytesFromBase64(object.elems) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = $d8b1841122a43167$var$base64FromBytes(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $d8b1841122a43167$var$createBaseCompactBitArray();
        message.extraBitsStored = (_a = object.extraBitsStored) !== null && _a !== void 0 ? _a : 0;
        message.elems = (_b = object.elems) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $d8b1841122a43167$var$globalThis = (()=>{
    if (typeof $d8b1841122a43167$var$globalThis !== "undefined") return $d8b1841122a43167$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d8b1841122a43167$var$atob = $d8b1841122a43167$var$globalThis.atob || ((b64)=>$d8b1841122a43167$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d8b1841122a43167$var$bytesFromBase64(b64) {
    const bin = $d8b1841122a43167$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
const $d8b1841122a43167$var$btoa = $d8b1841122a43167$var$globalThis.btoa || ((bin)=>$d8b1841122a43167$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d8b1841122a43167$var$base64FromBytes(arr) {
    const bin = [];
    for (const byte of arr)bin.push(String.fromCharCode(byte));
    return $d8b1841122a43167$var$btoa(bin.join(""));
}
if ($d8b1841122a43167$var$minimal_1.default.util.Long !== $d8b1841122a43167$var$long_1.default) {
    $d8b1841122a43167$var$minimal_1.default.util.Long = $d8b1841122a43167$var$long_1.default;
    $d8b1841122a43167$var$minimal_1.default.configure();
}
function $d8b1841122a43167$var$isSet(value) {
    return value !== null && value !== undefined;
}

});




parcelRegister("cPeRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignDocWrapper = void 0;

var $7Mse2 = parcelRequire("7Mse2");

var $2Y0YW = parcelRequire("2Y0YW");

var $ezTaT = parcelRequire("ezTaT");
class $9565c7212bf6012c$var$SignDocWrapper {
    constructor(signDoc){
        this.signDoc = signDoc;
        if ("msgs" in signDoc) this.mode = "amino";
        else this.mode = "direct";
        if (this.mode === "amino") // Check that the sign doc is for ADR-36.
        // The validation should be performed on the background process.
        // So, here, we check once more, but the validation related to bech32 is considered to be done in the background process.
        this.isADR36SignDoc = (0, $ezTaT.checkAndValidateADR36AminoSignDoc)(this.aminoSignDoc);
        else // Currently, only support amino sign doc for ADR-36
        this.isADR36SignDoc = false;
    }
    static fromAminoSignDoc(signDoc) {
        return new $9565c7212bf6012c$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDoc(signDoc) {
        return new $9565c7212bf6012c$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDocBytes(signDocBytes) {
        return new $9565c7212bf6012c$var$SignDocWrapper($2Y0YW.SignDoc.decode(signDocBytes));
    }
    clone() {
        return new $9565c7212bf6012c$var$SignDocWrapper(this.signDoc);
    }
    get protoSignDoc() {
        if (this.mode === "amino") throw new Error("Sign doc is encoded as Amino Json");
        if ("msgs" in this.signDoc) throw new Error("Unexpected error");
        if (!this._protoSignDoc) this._protoSignDoc = new $7Mse2.ProtoSignDocDecoder(this.signDoc);
        return this._protoSignDoc;
    }
    get aminoSignDoc() {
        if (this.mode === "direct") throw new Error("Sign doc is encoded as Protobuf");
        if (!("msgs" in this.signDoc)) throw new Error("Unexpected error");
        return this.signDoc;
    }
    get chainId() {
        if (this.mode === "direct") return this.protoSignDoc.chainId;
        return this.aminoSignDoc.chain_id;
    }
    get memo() {
        if (this.mode === "direct") return this.protoSignDoc.txBody.memo;
        return this.aminoSignDoc.memo;
    }
    get fees() {
        var _a, _b;
        if (this.mode === "direct") {
            const fees = [];
            for (const coinObj of (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : []){
                if (coinObj.denom == null || coinObj.amount == null) throw new Error("Invalid fee");
                fees.push({
                    denom: coinObj.denom,
                    amount: coinObj.amount
                });
            }
            return fees;
        }
        return this.aminoSignDoc.fee.amount;
    }
    get payer() {
        var _a;
        if (this.mode === "direct") return (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.payer;
        return this.aminoSignDoc.fee.payer;
    }
    get granter() {
        var _a;
        if (this.mode === "direct") return (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.granter;
        return this.aminoSignDoc.fee.granter;
    }
    get gas() {
        var _a;
        if (this.mode === "direct") {
            if ((_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.gasLimit) return parseInt(this.protoSignDoc.authInfo.fee.gasLimit);
            else return 0;
        }
        return parseInt(this.aminoSignDoc.fee.gas);
    }
}
module.exports.SignDocWrapper = $9565c7212bf6012c$var$SignDocWrapper;

});
parcelRegister("ezTaT", function(module, exports) {
"use strict";
var $a9cf2219b204a306$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a9cf2219b204a306$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a9cf2219b204a306$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a9cf2219b204a306$var$__exportStar((parcelRequire("9Yqzw")), module.exports);

});
parcelRegister("9Yqzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyADR36Amino = module.exports.verifyADR36AminoSignDoc = module.exports.makeADR36AminoSignDoc = module.exports.checkAndValidateADR36AminoSignDoc = void 0;

var $cbw6W = parcelRequire("cbw6W");

var $cJDGK = parcelRequire("cJDGK");

var $N0o3H = parcelRequire("N0o3H");

var $3lWiI = parcelRequire("3lWiI");
/**
 * Check the sign doc is for ADR-36.
 * If the sign doc is expected to be ADR-36, validate the sign doc and throw an error if the sign doc is valid ADR-36.
 * @param signDoc
 * @param bech32PrefixAccAddr If this argument is provided, validate the signer in the `MsgSignData` with this prefix.
 *                            If not, validate the signer in the `MsgSignData` without considering the bech32 prefix.
 */ function $742e544ee1710893$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr) {
    const hasOnlyMsgSignData = (()=>{
        if (signDoc && signDoc.msgs && Array.isArray(signDoc.msgs) && signDoc.msgs.length === 1) {
            const msg = signDoc.msgs[0];
            return msg.type === "sign/MsgSignData";
        } else return false;
    })();
    if (!hasOnlyMsgSignData) return false;
    if (signDoc.chain_id !== "") throw new Error("Chain id should be empty string for ADR-36 signing");
    if (signDoc.memo !== "") throw new Error("Memo should be empty string for ADR-36 signing");
    if (signDoc.account_number !== "0") throw new Error('Account number should be "0" for ADR-36 signing');
    if (signDoc.sequence !== "0") throw new Error('Sequence should be "0" for ADR-36 signing');
    if (signDoc.fee.gas !== "0") throw new Error('Gas should be "0" for ADR-36 signing');
    if (signDoc.fee.amount.length !== 0) throw new Error("Fee amount should be empty array for ADR-36 signing");
    const msg = signDoc.msgs[0];
    if (msg.type !== "sign/MsgSignData") throw new Error(`Invalid type of ADR-36 sign msg: ${msg.type}`);
    if (!msg.value) throw new Error("Empty value in the msg");
    const signer = msg.value.signer;
    if (!signer) throw new Error("Empty signer in the ADR-36 msg");
    $cJDGK.Bech32Address.validate(signer, bech32PrefixAccAddr);
    const data = msg.value.data;
    if (!data) throw new Error("Empty data in the ADR-36 msg");
    const rawData = $N0o3H.Buffer.from(data, "base64");
    // Validate the data is encoded as base64.
    if (rawData.toString("base64") !== data) throw new Error("Data is not encoded by base64");
    if (rawData.length === 0) throw new Error("Empty data in the ADR-36 msg");
    return true;
}
module.exports.checkAndValidateADR36AminoSignDoc = $742e544ee1710893$var$checkAndValidateADR36AminoSignDoc;
function $742e544ee1710893$var$makeADR36AminoSignDoc(signer, data) {
    if (typeof data === "string") data = $N0o3H.Buffer.from(data).toString("base64");
    else data = $N0o3H.Buffer.from(data).toString("base64");
    return {
        chain_id: "",
        account_number: "0",
        sequence: "0",
        fee: {
            gas: "0",
            amount: []
        },
        msgs: [
            {
                type: "sign/MsgSignData",
                value: {
                    signer: signer,
                    data: data
                }
            }
        ],
        memo: ""
    };
}
module.exports.makeADR36AminoSignDoc = $742e544ee1710893$var$makeADR36AminoSignDoc;
function $742e544ee1710893$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature, algo = "secp256k1") {
    if (!$742e544ee1710893$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr)) throw new Error("Invalid sign doc for ADR-36");
    const cryptoPubKey = new $3lWiI.PubKeySecp256k1(pubKey);
    const expectedSigner = (()=>{
        if (algo === "ethsecp256k1") return new $cJDGK.Bech32Address(cryptoPubKey.getEthAddress()).toBech32(bech32PrefixAccAddr);
        return new $cJDGK.Bech32Address(cryptoPubKey.getCosmosAddress()).toBech32(bech32PrefixAccAddr);
    })();
    const signer = signDoc.msgs[0].value.signer;
    if (expectedSigner !== signer) throw new Error("Unmatched signer");
    const msg = (0, $cbw6W.serializeSignDoc)(signDoc);
    return cryptoPubKey.verifyDigest32((()=>{
        if (algo === "ethsecp256k1") return $3lWiI.Hash.keccak256(msg);
        return $3lWiI.Hash.sha256(msg);
    })(), signature);
}
module.exports.verifyADR36AminoSignDoc = $742e544ee1710893$var$verifyADR36AminoSignDoc;
function $742e544ee1710893$var$verifyADR36Amino(bech32PrefixAccAddr, signer, data, pubKey, signature, algo = "secp256k1") {
    const signDoc = $742e544ee1710893$var$makeADR36AminoSignDoc(signer, data);
    return $742e544ee1710893$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature, algo);
}
module.exports.verifyADR36Amino = $742e544ee1710893$var$verifyADR36Amino;

});
parcelRegister("cbw6W", function(module, exports) {
"use strict";
var $8def6baf2da744c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8def6baf2da744c4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8def6baf2da744c4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8def6baf2da744c4$var$__exportStar((parcelRequire("9tJJT")), module.exports);

});
parcelRegister("9tJJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.encodeSecp256k1Signature = module.exports.encodeSecp256k1Pubkey = void 0;

var $N0o3H = parcelRequire("N0o3H");

var $LEvpc = parcelRequire("LEvpc");
function $6e6a4d5e781bfe8e$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: "tendermint/PubKeySecp256k1",
        value: $N0o3H.Buffer.from(pubkey).toString("base64")
    };
}
module.exports.encodeSecp256k1Pubkey = $6e6a4d5e781bfe8e$var$encodeSecp256k1Pubkey;
function $6e6a4d5e781bfe8e$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: $6e6a4d5e781bfe8e$var$encodeSecp256k1Pubkey(pubkey),
        signature: $N0o3H.Buffer.from(signature).toString("base64")
    };
}
module.exports.encodeSecp256k1Signature = $6e6a4d5e781bfe8e$var$encodeSecp256k1Signature;
function $6e6a4d5e781bfe8e$var$serializeSignDoc(signDoc) {
    return $N0o3H.Buffer.from((0, $LEvpc.escapeHTML)((0, $LEvpc.sortedJsonByKeyStringify)(signDoc)));
}
module.exports.serializeSignDoc = $6e6a4d5e781bfe8e$var$serializeSignDoc;

});
parcelRegister("LEvpc", function(module, exports) {
"use strict";
var $08f3cf752e8c3c4b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $08f3cf752e8c3c4b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $08f3cf752e8c3c4b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("4HQ5N")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("2iAqQ")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("f7OAj")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("8iF3g")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("82nZe")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("cdZLN")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("flybR")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("kP4XT")), module.exports);

$08f3cf752e8c3c4b$var$__exportStar((parcelRequire("jXaVZ")), module.exports);

});
parcelRegister("4HQ5N", function(module, exports) {
"use strict";
var $36d39609188a083f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $36d39609188a083f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $36d39609188a083f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$36d39609188a083f$var$__exportStar((parcelRequire("Z0SK1")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("lwThv")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("222wc")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("8Var0")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("aWiKU")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("1wQxK")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("2GjgU")), module.exports);

$36d39609188a083f$var$__exportStar((parcelRequire("iOqtI")), module.exports);

});
parcelRegister("Z0SK1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lwThv", function(module, exports) {
"use strict";
var $fac777d6550d1c87$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtensionKVStore = void 0;

var $222wc = parcelRequire("222wc");
class $fac777d6550d1c87$var$ExtensionKVStore extends $222wc.BaseKVStore {
    constructor(prefix){
        if (!$fac777d6550d1c87$var$ExtensionKVStore.KVStoreProvider) {
            if (typeof browser === "undefined") console.log("You should use ExtensionKVStore on the extension environment.");
            else if (!browser.storage || !browser.storage.local) console.log("The 'browser' exists, but it doesn't seem to be an extension environment. This can happen in Safari browser.");
            else $fac777d6550d1c87$var$ExtensionKVStore.KVStoreProvider = {
                get: browser.storage.local.get,
                set: browser.storage.local.set,
                multiGet: browser.storage.local.get
            };
        }
        if (!$fac777d6550d1c87$var$ExtensionKVStore.KVStoreProvider) throw new Error("Can't initialize kv store for browser extension");
        super($fac777d6550d1c87$var$ExtensionKVStore.KVStoreProvider, prefix);
    }
    multiGet(keys) {
        var _a;
        return $fac777d6550d1c87$var$__awaiter(this, void 0, void 0, function*() {
            // Remove duplications
            keys = Array.from(new Set(keys));
            const res = (_a = yield $fac777d6550d1c87$var$ExtensionKVStore.KVStoreProvider.multiGet(keys.map((k)=>this.prefix() + "/" + k))) !== null && _a !== void 0 ? _a : {};
            const prefixedKeys = Object.keys(res);
            for (const prefixedKey of prefixedKeys){
                const key = prefixedKey.slice(this.prefix().length + 1);
                res[key] = res[prefixedKey];
                delete res[prefixedKey];
            }
            return res;
        });
    }
}
module.exports.ExtensionKVStore = $fac777d6550d1c87$var$ExtensionKVStore;

});
parcelRegister("222wc", function(module, exports) {
"use strict";
var $17adb8c3f322cb08$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseKVStore = void 0;
class $17adb8c3f322cb08$var$BaseKVStore {
    constructor(provider, _prefix){
        this.provider = provider;
        this._prefix = _prefix;
    }
    get(key) {
        return $17adb8c3f322cb08$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            const data = yield this.provider.get(k);
            return data[k];
        });
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        return this.provider.set({
            [k]: data
        });
    }
    prefix() {
        return this._prefix;
    }
}
module.exports.BaseKVStore = $17adb8c3f322cb08$var$BaseKVStore;

});


parcelRegister("8Var0", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MemoryKVStore = void 0;

var $222wc = parcelRequire("222wc");
class $67ebbdb06a77593a$var$MemoryKVStoreProvider {
    constructor(){
        this.store = {};
    }
    get(key) {
        return Promise.resolve({
            [key]: this.store[key]
        });
    }
    set(items) {
        // Generally, memory kv store is used for testing, and mocking.
        // However, we can store non-primitive type to memory even though local storage generally can't do that.
        // To mitigate the risk, we check the type of value to be stored if env is for testing.
        typeof $ibaza;
        this.store = Object.assign(Object.assign({}, this.store), items);
        return Promise.resolve();
    }
    checkNotPrimitiveField(items) {
        Object.keys(items).forEach((key)=>{
            const value = items[key];
            if (value != null && typeof value === "object") {
                if (value.constructor !== Object && value.constructor !== Array) throw new Error(`${key} may not be serializable: ${value.constructor.name}`);
                this.checkNotPrimitiveField(value);
            }
        });
    }
}
class $67ebbdb06a77593a$var$MemoryKVStore extends $222wc.BaseKVStore {
    constructor(prefix){
        super(new $67ebbdb06a77593a$var$MemoryKVStoreProvider(), prefix);
    }
}
module.exports.MemoryKVStore = $67ebbdb06a77593a$var$MemoryKVStore;

});

parcelRegister("aWiKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalKVStore = void 0;
class $7f6ddea024bbc3d8$var$LocalKVStore {
    constructor(_prefix){
        this._prefix = _prefix;
    }
    get(key) {
        const k = this.prefix() + "/" + key;
        const data = localStorage.getItem(k);
        if (data === null) return Promise.resolve(undefined);
        return Promise.resolve(JSON.parse(data));
    }
    set(key, data) {
        const k = this.prefix() + "/" + key;
        if (data === null) return Promise.resolve(localStorage.removeItem(k));
        return Promise.resolve(localStorage.setItem(k, JSON.stringify(data)));
    }
    prefix() {
        return this._prefix;
    }
}
module.exports.LocalKVStore = $7f6ddea024bbc3d8$var$LocalKVStore;

});

parcelRegister("1wQxK", function(module, exports) {
"use strict";
var $11d1899a4a50fccc$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IndexedDBKVStore = void 0;
class $11d1899a4a50fccc$var$IndexedDBKVStore {
    constructor(_prefix){
        this._prefix = _prefix;
    }
    get(key) {
        return $11d1899a4a50fccc$var$__awaiter(this, void 0, void 0, function*() {
            const tx = (yield this.getDB()).transaction([
                this.prefix()
            ], "readonly");
            const store = tx.objectStore(this.prefix());
            return new Promise((resolve, reject)=>{
                const request = store.get(key);
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onsuccess = ()=>{
                    if (!request.result) resolve(undefined);
                    else resolve(request.result.data);
                };
            });
        });
    }
    set(key, data) {
        return $11d1899a4a50fccc$var$__awaiter(this, void 0, void 0, function*() {
            if (data === null) {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.delete(key);
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            } else {
                const tx = (yield this.getDB()).transaction([
                    this.prefix()
                ], "readwrite");
                const store = tx.objectStore(this.prefix());
                return new Promise((resolve, reject)=>{
                    const request = store.put({
                        key: key,
                        data: data
                    });
                    request.onerror = (event)=>{
                        event.stopPropagation();
                        reject(event.target);
                    };
                    request.onsuccess = ()=>{
                        resolve();
                    };
                });
            }
        });
    }
    prefix() {
        return this._prefix;
    }
    getDB() {
        return $11d1899a4a50fccc$var$__awaiter(this, void 0, void 0, function*() {
            if (this.cachedDB) return this.cachedDB;
            return new Promise((resolve, reject)=>{
                const request = window.indexedDB.open(this.prefix());
                request.onerror = (event)=>{
                    event.stopPropagation();
                    reject(event.target);
                };
                request.onupgradeneeded = (event)=>{
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    const db = event.target.result;
                    db.createObjectStore(this.prefix(), {
                        keyPath: "key"
                    });
                };
                request.onsuccess = ()=>{
                    this.cachedDB = request.result;
                    resolve(request.result);
                };
            });
        });
    }
}
module.exports.IndexedDBKVStore = $11d1899a4a50fccc$var$IndexedDBKVStore;

});

parcelRegister("2GjgU", function(module, exports) {
"use strict";
var $1f3e73f6cfc593d9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrefixKVStore = void 0;
class $1f3e73f6cfc593d9$var$PrefixKVStore {
    constructor(kvStore, _prefix){
        this.kvStore = kvStore;
        this._prefix = _prefix;
    }
    prefix() {
        return this._prefix;
    }
    get(key) {
        return $1f3e73f6cfc593d9$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            return yield this.kvStore.get(k);
        });
    }
    set(key, data) {
        return $1f3e73f6cfc593d9$var$__awaiter(this, void 0, void 0, function*() {
            const k = this.prefix() + "/" + key;
            return yield this.kvStore.set(k, data);
        });
    }
}
module.exports.PrefixKVStore = $1f3e73f6cfc593d9$var$PrefixKVStore;

});

parcelRegister("iOqtI", function(module, exports) {
"use strict";
var $db216f892f8d2f96$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WrapMultiGetKVStore = void 0;
class $db216f892f8d2f96$var$WrapMultiGetKVStore {
    constructor(kvStore){
        this.kvStore = kvStore;
    }
    multiGet(keys) {
        return $db216f892f8d2f96$var$__awaiter(this, void 0, void 0, function*() {
            // Remove duplications
            keys = Array.from(new Set(keys));
            const res = {};
            const promises = [];
            for (const key of keys)promises.push((()=>$db216f892f8d2f96$var$__awaiter(this, void 0, void 0, function*() {
                    res[key] = yield this.kvStore.get(key);
                }))());
            yield Promise.all(promises);
            return res;
        });
    }
}
module.exports.WrapMultiGetKVStore = $db216f892f8d2f96$var$WrapMultiGetKVStore;

});


parcelRegister("2iAqQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DenomHelper = void 0;

var $N0o3H = parcelRequire("N0o3H");

var $3lWiI = parcelRequire("3lWiI");
class $1ac985d46b73aba5$var$DenomHelper {
    static ibcDenom(paths, coinMinimalDenom) {
        const prefixes = [];
        for (const path of paths)prefixes.push(`${path.portId}/${path.channelId}`);
        const prefix = prefixes.join("/");
        const denom = `${prefix}/${coinMinimalDenom}`;
        return "ibc/" + $N0o3H.Buffer.from($3lWiI.Hash.sha256($N0o3H.Buffer.from(denom))).toString("hex").toUpperCase();
    }
    constructor(_denom){
        this._denom = _denom;
        // Remember that the coin's actual denom should start with "type:contractAddress:denom" if it is for the token based on contract.
        const split = this.denom.split(/(\w+):(\w+):(.+)/).filter(Boolean);
        if (split.length !== 1 && split.length !== 3) throw new Error(`Invalid denom: ${this.denom}`);
        this._type = split.length === 3 ? split[0] : "";
        this._contractAddress = split.length === 3 ? split[1] : "";
    }
    get denom() {
        return this._denom;
    }
    get type() {
        return this._type || "native";
    }
    get contractAddress() {
        return this._contractAddress;
    }
}
module.exports.DenomHelper = $1ac985d46b73aba5$var$DenomHelper;

});
parcelRegister("3lWiI", function(module, exports) {
"use strict";
var $27108e98b3116bab$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $27108e98b3116bab$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $27108e98b3116bab$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$27108e98b3116bab$var$__exportStar((parcelRequire("iE7Nd")), module.exports);

$27108e98b3116bab$var$__exportStar((parcelRequire("9BV59")), module.exports);

$27108e98b3116bab$var$__exportStar((parcelRequire("25Pjl")), module.exports);

});
parcelRegister("iE7Nd", function(module, exports) {
"use strict";
var $d93201e8ab607259$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $eoscy = parcelRequire("eoscy");

var $gYtAa = parcelRequire("gYtAa");

var $kfzoe = parcelRequire("kfzoe");

var $N0o3H = parcelRequire("N0o3H");
class $d93201e8ab607259$var$Mnemonic {
    static generateWallet(rng, path = `m/44'/118'/0'/0/0`, password = "", strength = 256) {
        return $d93201e8ab607259$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = yield $d93201e8ab607259$var$Mnemonic.generateSeed(rng, strength);
            const privKey = $d93201e8ab607259$var$Mnemonic.generateWalletFromMnemonic(mnemonic, path, password);
            return {
                privKey: privKey,
                mnemonic: mnemonic
            };
        });
    }
    static validateMnemonic(mnemonic) {
        return $eoscy.validateMnemonic(mnemonic);
    }
    static generateSeed(rng, strength = 128) {
        return $d93201e8ab607259$var$__awaiter(this, void 0, void 0, function*() {
            if (strength % 32 !== 0) throw new TypeError("invalid entropy");
            let bytes = new Uint8Array(strength / 8);
            bytes = yield rng(bytes);
            return $eoscy.entropyToMnemonic($N0o3H.Buffer.from(bytes).toString("hex"));
        });
    }
    static generateWalletFromMnemonic(mnemonic, path = `m/44'/118'/0'/0/0`, password = "") {
        const seed = $eoscy.mnemonicToSeedSync(mnemonic, password);
        const masterSeed = $gYtAa.fromSeed(seed);
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
    static generateMasterSeedFromMnemonic(mnemonic, password = "") {
        const seed = $eoscy.mnemonicToSeedSync(mnemonic, password);
        const masterKey = $gYtAa.fromSeed(seed);
        return $N0o3H.Buffer.from($kfzoe.decode(masterKey.toBase58()));
    }
    static generatePrivateKeyFromMasterSeed(seed, path = `m/44'/118'/0'/0/0`) {
        const masterSeed = $gYtAa.fromBase58($kfzoe.encode(seed));
        const hd = masterSeed.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
}
module.exports.Mnemonic = $d93201e8ab607259$var$Mnemonic;

});
parcelRegister("eoscy", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $a7a92eca563b6077$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9mxSb = parcelRequire("9mxSb");

var $hyAd0 = parcelRequire("hyAd0");

var $bbrCz = parcelRequire("bbrCz");

var $9lwKa = parcelRequire("9lwKa");

var $cUFfJ = parcelRequire("cUFfJ");
let $a7a92eca563b6077$var$DEFAULT_WORDLIST = $cUFfJ._default;
const $a7a92eca563b6077$var$INVALID_MNEMONIC = "Invalid mnemonic";
const $a7a92eca563b6077$var$INVALID_ENTROPY = "Invalid entropy";
const $a7a92eca563b6077$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
const $a7a92eca563b6077$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $a7a92eca563b6077$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $a7a92eca563b6077$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $a7a92eca563b6077$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $a7a92eca563b6077$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$a7a92eca563b6077$var$lpad(x.toString(2), "0", 8)).join("");
}
function $a7a92eca563b6077$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $9mxSb.sha256(Uint8Array.from(entropyBuffer));
    return $a7a92eca563b6077$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $a7a92eca563b6077$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $a7a92eca563b6077$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($a7a92eca563b6077$require$Buffer.from($a7a92eca563b6077$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($a7a92eca563b6077$require$Buffer.from($a7a92eca563b6077$var$salt($a7a92eca563b6077$var$normalize(password)), "utf8"));
    const res = $bbrCz.pbkdf2($hyAd0.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return $a7a92eca563b6077$require$Buffer.from(res);
}
module.exports.mnemonicToSeedSync = $a7a92eca563b6077$var$mnemonicToSeedSync;
function $a7a92eca563b6077$var$mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($a7a92eca563b6077$require$Buffer.from($a7a92eca563b6077$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($a7a92eca563b6077$require$Buffer.from($a7a92eca563b6077$var$salt($a7a92eca563b6077$var$normalize(password)), "utf8"));
    return $bbrCz.pbkdf2Async($hyAd0.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>$a7a92eca563b6077$require$Buffer.from(res));
}
module.exports.mnemonicToSeed = $a7a92eca563b6077$var$mnemonicToSeed;
function $a7a92eca563b6077$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $a7a92eca563b6077$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($a7a92eca563b6077$var$WORDLIST_REQUIRED);
    const words = $a7a92eca563b6077$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($a7a92eca563b6077$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($a7a92eca563b6077$var$INVALID_MNEMONIC);
        return $a7a92eca563b6077$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($a7a92eca563b6077$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($a7a92eca563b6077$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($a7a92eca563b6077$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($a7a92eca563b6077$var$INVALID_ENTROPY);
    const entropy = $a7a92eca563b6077$require$Buffer.from(entropyBytes);
    const newChecksum = $a7a92eca563b6077$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($a7a92eca563b6077$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
module.exports.mnemonicToEntropy = $a7a92eca563b6077$var$mnemonicToEntropy;
function $a7a92eca563b6077$var$entropyToMnemonic(entropy, wordlist) {
    if (!$a7a92eca563b6077$require$Buffer.isBuffer(entropy)) entropy = $a7a92eca563b6077$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $a7a92eca563b6077$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($a7a92eca563b6077$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($a7a92eca563b6077$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($a7a92eca563b6077$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($a7a92eca563b6077$var$INVALID_ENTROPY);
    const entropyBits = $a7a92eca563b6077$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $a7a92eca563b6077$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $a7a92eca563b6077$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
module.exports.entropyToMnemonic = $a7a92eca563b6077$var$entropyToMnemonic;
function $a7a92eca563b6077$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($a7a92eca563b6077$var$INVALID_ENTROPY);
    rng = rng || ((size)=>$a7a92eca563b6077$require$Buffer.from($9lwKa.randomBytes(size)));
    return $a7a92eca563b6077$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $a7a92eca563b6077$var$generateMnemonic;
function $a7a92eca563b6077$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $a7a92eca563b6077$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $a7a92eca563b6077$var$validateMnemonic;
function $a7a92eca563b6077$var$setDefaultWordlist(language) {
    const result = $cUFfJ.wordlists[language];
    if (result) $a7a92eca563b6077$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $a7a92eca563b6077$var$setDefaultWordlist;
function $a7a92eca563b6077$var$getDefaultWordlist() {
    if (!$a7a92eca563b6077$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($cUFfJ.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return $cUFfJ.wordlists[lang].every((word, index)=>word === $a7a92eca563b6077$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $a7a92eca563b6077$var$getDefaultWordlist;

var $cUFfJ = parcelRequire("cUFfJ");
module.exports.wordlists = $cUFfJ.wordlists;

});
parcelRegister("9mxSb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $1dDg0 = parcelRequire("1dDg0");

var $9lwKa = parcelRequire("9lwKa");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $6d10719b26ee04ea$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $6d10719b26ee04ea$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $6d10719b26ee04ea$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $6d10719b26ee04ea$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $6d10719b26ee04ea$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $6d10719b26ee04ea$var$SHA256 extends $1dDg0.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $6d10719b26ee04ea$var$IV[0] | 0;
        this.B = $6d10719b26ee04ea$var$IV[1] | 0;
        this.C = $6d10719b26ee04ea$var$IV[2] | 0;
        this.D = $6d10719b26ee04ea$var$IV[3] | 0;
        this.E = $6d10719b26ee04ea$var$IV[4] | 0;
        this.F = $6d10719b26ee04ea$var$IV[5] | 0;
        this.G = $6d10719b26ee04ea$var$IV[6] | 0;
        this.H = $6d10719b26ee04ea$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$6d10719b26ee04ea$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $6d10719b26ee04ea$var$SHA256_W[i - 15];
            const W2 = $6d10719b26ee04ea$var$SHA256_W[i - 2];
            const s0 = (0, $9lwKa.rotr)(W15, 7) ^ (0, $9lwKa.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $9lwKa.rotr)(W2, 17) ^ (0, $9lwKa.rotr)(W2, 19) ^ W2 >>> 10;
            $6d10719b26ee04ea$var$SHA256_W[i] = s1 + $6d10719b26ee04ea$var$SHA256_W[i - 7] + s0 + $6d10719b26ee04ea$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $9lwKa.rotr)(E, 6) ^ (0, $9lwKa.rotr)(E, 11) ^ (0, $9lwKa.rotr)(E, 25);
            const T1 = H + sigma1 + $6d10719b26ee04ea$var$Chi(E, F, G) + $6d10719b26ee04ea$var$SHA256_K[i] + $6d10719b26ee04ea$var$SHA256_W[i] | 0;
            const sigma0 = (0, $9lwKa.rotr)(A, 2) ^ (0, $9lwKa.rotr)(A, 13) ^ (0, $9lwKa.rotr)(A, 22);
            const T2 = sigma0 + $6d10719b26ee04ea$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $6d10719b26ee04ea$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $6d10719b26ee04ea$var$SHA224 extends $6d10719b26ee04ea$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $9lwKa.wrapConstructor)(()=>new $6d10719b26ee04ea$var$SHA256());
module.exports.sha224 = (0, $9lwKa.wrapConstructor)(()=>new $6d10719b26ee04ea$var$SHA224());

});
parcelRegister("1dDg0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $1fAJj = parcelRequire("1fAJj");

var $9lwKa = parcelRequire("9lwKa");
// Polyfill for Safari 14
function $0e3575010152911f$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $0e3575010152911f$var$SHA2 extends $9lwKa.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9lwKa.createView)(this.buffer);
    }
    update(data) {
        (0, $1fAJj.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9lwKa.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9lwKa.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $1fAJj.exists)(this);
        (0, $1fAJj.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $0e3575010152911f$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9lwKa.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $0e3575010152911f$var$SHA2;

});
parcelRegister("1fAJj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $0e93aeef23318d6b$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $0e93aeef23318d6b$var$number;
function $0e93aeef23318d6b$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $0e93aeef23318d6b$var$bool;
// copied from utils
function $0e93aeef23318d6b$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $0e93aeef23318d6b$var$bytes(b, ...lengths) {
    if (!$0e93aeef23318d6b$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $0e93aeef23318d6b$var$bytes;
function $0e93aeef23318d6b$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $0e93aeef23318d6b$var$number(hash.outputLen);
    $0e93aeef23318d6b$var$number(hash.blockLen);
}
module.exports.hash = $0e93aeef23318d6b$var$hash;
function $0e93aeef23318d6b$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $0e93aeef23318d6b$var$exists;
function $0e93aeef23318d6b$var$output(out, instance) {
    $0e93aeef23318d6b$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $0e93aeef23318d6b$var$output;
const $0e93aeef23318d6b$var$assert = {
    number: $0e93aeef23318d6b$var$number,
    bool: $0e93aeef23318d6b$var$bool,
    bytes: $0e93aeef23318d6b$var$bytes,
    hash: $0e93aeef23318d6b$var$hash,
    exists: $0e93aeef23318d6b$var$exists,
    output: $0e93aeef23318d6b$var$output
};
module.exports.default = $0e93aeef23318d6b$var$assert;

});

parcelRegister("9lwKa", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $cmtNh = parcelRequire("cmtNh");
// Cast array to different type
const $6cdf796f4168eed9$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $6cdf796f4168eed9$var$u8;
const $6cdf796f4168eed9$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $6cdf796f4168eed9$var$u32;
function $6cdf796f4168eed9$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $6cdf796f4168eed9$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $6cdf796f4168eed9$var$createView;
// The rotate right (circular right shift) operation for uint32
const $6cdf796f4168eed9$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $6cdf796f4168eed9$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $6cdf796f4168eed9$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $6cdf796f4168eed9$var$bytesToHex(bytes) {
    if (!$6cdf796f4168eed9$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6cdf796f4168eed9$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $6cdf796f4168eed9$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $6cdf796f4168eed9$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $6cdf796f4168eed9$var$asciiToBase16(char) {
    if (char >= $6cdf796f4168eed9$var$asciis._0 && char <= $6cdf796f4168eed9$var$asciis._9) return char - $6cdf796f4168eed9$var$asciis._0;
    if (char >= $6cdf796f4168eed9$var$asciis._A && char <= $6cdf796f4168eed9$var$asciis._F) return char - ($6cdf796f4168eed9$var$asciis._A - 10);
    if (char >= $6cdf796f4168eed9$var$asciis._a && char <= $6cdf796f4168eed9$var$asciis._f) return char - ($6cdf796f4168eed9$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $6cdf796f4168eed9$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $6cdf796f4168eed9$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $6cdf796f4168eed9$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $6cdf796f4168eed9$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $6cdf796f4168eed9$var$nextTick = async ()=>{};
module.exports.nextTick = $6cdf796f4168eed9$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $6cdf796f4168eed9$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $6cdf796f4168eed9$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $6cdf796f4168eed9$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $6cdf796f4168eed9$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $6cdf796f4168eed9$var$toBytes(data) {
    if (typeof data === "string") data = $6cdf796f4168eed9$var$utf8ToBytes(data);
    if (!$6cdf796f4168eed9$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $6cdf796f4168eed9$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $6cdf796f4168eed9$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$6cdf796f4168eed9$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $6cdf796f4168eed9$var$concatBytes;
// For runtime check if class implements interface
class $6cdf796f4168eed9$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $6cdf796f4168eed9$var$Hash;
const $6cdf796f4168eed9$var$toStr = {}.toString;
function $6cdf796f4168eed9$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $6cdf796f4168eed9$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $6cdf796f4168eed9$var$checkOpts;
function $6cdf796f4168eed9$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($6cdf796f4168eed9$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $6cdf796f4168eed9$var$wrapConstructor;
function $6cdf796f4168eed9$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6cdf796f4168eed9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $6cdf796f4168eed9$var$wrapConstructorWithOpts;
function $6cdf796f4168eed9$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6cdf796f4168eed9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $6cdf796f4168eed9$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $6cdf796f4168eed9$var$randomBytes(bytesLength = 32) {
    if ($cmtNh.crypto && typeof $cmtNh.crypto.getRandomValues === "function") return $cmtNh.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $6cdf796f4168eed9$var$randomBytes;

});
parcelRegister("cmtNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("hyAd0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $1dDg0 = parcelRequire("1dDg0");

var $h21Cw = parcelRequire("h21Cw");

var $9lwKa = parcelRequire("9lwKa");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$cc81b2f102def1a5$var$SHA512_Kh, $cc81b2f102def1a5$var$SHA512_Kl] = /* @__PURE__ */ (()=>$h21Cw.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $cc81b2f102def1a5$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $cc81b2f102def1a5$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $cc81b2f102def1a5$var$SHA512 extends $1dDg0.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $cc81b2f102def1a5$var$SHA512_W_H[i] = view.getUint32(offset);
            $cc81b2f102def1a5$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $cc81b2f102def1a5$var$SHA512_W_H[i - 15] | 0;
            const W15l = $cc81b2f102def1a5$var$SHA512_W_L[i - 15] | 0;
            const s0h = $h21Cw.default.rotrSH(W15h, W15l, 1) ^ $h21Cw.default.rotrSH(W15h, W15l, 8) ^ $h21Cw.default.shrSH(W15h, W15l, 7);
            const s0l = $h21Cw.default.rotrSL(W15h, W15l, 1) ^ $h21Cw.default.rotrSL(W15h, W15l, 8) ^ $h21Cw.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $cc81b2f102def1a5$var$SHA512_W_H[i - 2] | 0;
            const W2l = $cc81b2f102def1a5$var$SHA512_W_L[i - 2] | 0;
            const s1h = $h21Cw.default.rotrSH(W2h, W2l, 19) ^ $h21Cw.default.rotrBH(W2h, W2l, 61) ^ $h21Cw.default.shrSH(W2h, W2l, 6);
            const s1l = $h21Cw.default.rotrSL(W2h, W2l, 19) ^ $h21Cw.default.rotrBL(W2h, W2l, 61) ^ $h21Cw.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $h21Cw.default.add4L(s0l, s1l, $cc81b2f102def1a5$var$SHA512_W_L[i - 7], $cc81b2f102def1a5$var$SHA512_W_L[i - 16]);
            const SUMh = $h21Cw.default.add4H(SUMl, s0h, s1h, $cc81b2f102def1a5$var$SHA512_W_H[i - 7], $cc81b2f102def1a5$var$SHA512_W_H[i - 16]);
            $cc81b2f102def1a5$var$SHA512_W_H[i] = SUMh | 0;
            $cc81b2f102def1a5$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $h21Cw.default.rotrSH(Eh, El, 14) ^ $h21Cw.default.rotrSH(Eh, El, 18) ^ $h21Cw.default.rotrBH(Eh, El, 41);
            const sigma1l = $h21Cw.default.rotrSL(Eh, El, 14) ^ $h21Cw.default.rotrSL(Eh, El, 18) ^ $h21Cw.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $h21Cw.default.add5L(Hl, sigma1l, CHIl, $cc81b2f102def1a5$var$SHA512_Kl[i], $cc81b2f102def1a5$var$SHA512_W_L[i]);
            const T1h = $h21Cw.default.add5H(T1ll, Hh, sigma1h, CHIh, $cc81b2f102def1a5$var$SHA512_Kh[i], $cc81b2f102def1a5$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $h21Cw.default.rotrSH(Ah, Al, 28) ^ $h21Cw.default.rotrBH(Ah, Al, 34) ^ $h21Cw.default.rotrBH(Ah, Al, 39);
            const sigma0l = $h21Cw.default.rotrSL(Ah, Al, 28) ^ $h21Cw.default.rotrBL(Ah, Al, 34) ^ $h21Cw.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $h21Cw.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $h21Cw.default.add3L(T1l, sigma0l, MAJl);
            Ah = $h21Cw.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $h21Cw.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $h21Cw.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $h21Cw.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $h21Cw.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $h21Cw.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $h21Cw.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $h21Cw.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $h21Cw.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $cc81b2f102def1a5$var$SHA512_W_H.fill(0);
        $cc81b2f102def1a5$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $cc81b2f102def1a5$var$SHA512;
class $cc81b2f102def1a5$var$SHA512_224 extends $cc81b2f102def1a5$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $cc81b2f102def1a5$var$SHA512_256 extends $cc81b2f102def1a5$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $cc81b2f102def1a5$var$SHA384 extends $cc81b2f102def1a5$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $9lwKa.wrapConstructor)(()=>new $cc81b2f102def1a5$var$SHA512());
module.exports.sha512_224 = (0, $9lwKa.wrapConstructor)(()=>new $cc81b2f102def1a5$var$SHA512_224());
module.exports.sha512_256 = (0, $9lwKa.wrapConstructor)(()=>new $cc81b2f102def1a5$var$SHA512_256());
module.exports.sha384 = (0, $9lwKa.wrapConstructor)(()=>new $cc81b2f102def1a5$var$SHA384());

});
parcelRegister("h21Cw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c663e1592340423c$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c663e1592340423c$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c663e1592340423c$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c663e1592340423c$var$U32_MASK64),
        l: Number(n >> $c663e1592340423c$var$_32n & $c663e1592340423c$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c663e1592340423c$var$_32n & $c663e1592340423c$var$U32_MASK64) | 0,
        l: Number(n & $c663e1592340423c$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c663e1592340423c$var$fromBig;
function $c663e1592340423c$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c663e1592340423c$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c663e1592340423c$var$split;
const $c663e1592340423c$var$toBig = (h, l)=>BigInt(h >>> 0) << $c663e1592340423c$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c663e1592340423c$var$toBig;
// for Shift in [0, 32)
const $c663e1592340423c$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $c663e1592340423c$var$shrSH;
const $c663e1592340423c$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c663e1592340423c$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c663e1592340423c$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c663e1592340423c$var$rotrSH;
const $c663e1592340423c$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c663e1592340423c$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c663e1592340423c$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c663e1592340423c$var$rotrBH;
const $c663e1592340423c$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c663e1592340423c$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c663e1592340423c$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $c663e1592340423c$var$rotr32H;
const $c663e1592340423c$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $c663e1592340423c$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c663e1592340423c$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c663e1592340423c$var$rotlSH;
const $c663e1592340423c$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c663e1592340423c$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c663e1592340423c$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c663e1592340423c$var$rotlBH;
const $c663e1592340423c$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c663e1592340423c$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c663e1592340423c$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c663e1592340423c$var$add;
// Addition with more than 2 elements
const $c663e1592340423c$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c663e1592340423c$var$add3L;
const $c663e1592340423c$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c663e1592340423c$var$add3H;
const $c663e1592340423c$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c663e1592340423c$var$add4L;
const $c663e1592340423c$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c663e1592340423c$var$add4H;
const $c663e1592340423c$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c663e1592340423c$var$add5L;
const $c663e1592340423c$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c663e1592340423c$var$add5H;
// prettier-ignore
const $c663e1592340423c$var$u64 = {
    fromBig: $c663e1592340423c$var$fromBig,
    split: $c663e1592340423c$var$split,
    toBig: $c663e1592340423c$var$toBig,
    shrSH: $c663e1592340423c$var$shrSH,
    shrSL: $c663e1592340423c$var$shrSL,
    rotrSH: $c663e1592340423c$var$rotrSH,
    rotrSL: $c663e1592340423c$var$rotrSL,
    rotrBH: $c663e1592340423c$var$rotrBH,
    rotrBL: $c663e1592340423c$var$rotrBL,
    rotr32H: $c663e1592340423c$var$rotr32H,
    rotr32L: $c663e1592340423c$var$rotr32L,
    rotlSH: $c663e1592340423c$var$rotlSH,
    rotlSL: $c663e1592340423c$var$rotlSL,
    rotlBH: $c663e1592340423c$var$rotlBH,
    rotlBL: $c663e1592340423c$var$rotlBL,
    add: $c663e1592340423c$var$add,
    add3L: $c663e1592340423c$var$add3L,
    add3H: $c663e1592340423c$var$add3H,
    add4L: $c663e1592340423c$var$add4L,
    add4H: $c663e1592340423c$var$add4H,
    add5H: $c663e1592340423c$var$add5H,
    add5L: $c663e1592340423c$var$add5L
};
module.exports.default = $c663e1592340423c$var$u64;

});


parcelRegister("bbrCz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $1fAJj = parcelRequire("1fAJj");

var $jvksk = parcelRequire("jvksk");

var $9lwKa = parcelRequire("9lwKa");
// Common prologue and epilogue for sync/async functions
function $824625c74b476d1f$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $1fAJj.hash)(hash);
    const opts = (0, $9lwKa.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $1fAJj.number)(c);
    (0, $1fAJj.number)(dkLen);
    (0, $1fAJj.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $9lwKa.toBytes)(_password);
    const salt = (0, $9lwKa.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $jvksk.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $824625c74b476d1f$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $824625c74b476d1f$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $824625c74b476d1f$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $9lwKa.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $824625c74b476d1f$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $824625c74b476d1f$var$pbkdf2;
async function $824625c74b476d1f$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $824625c74b476d1f$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $9lwKa.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $9lwKa.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $824625c74b476d1f$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $824625c74b476d1f$var$pbkdf2Async;

});
parcelRegister("jvksk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $1fAJj = parcelRequire("1fAJj");

var $9lwKa = parcelRequire("9lwKa");
// HMAC (RFC 2104)
class $e330c7b2c6f4e326$var$HMAC extends $9lwKa.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $1fAJj.hash)(hash);
        const key = (0, $9lwKa.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $1fAJj.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $1fAJj.exists)(this);
        (0, $1fAJj.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $e330c7b2c6f4e326$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $e330c7b2c6f4e326$var$hmac = (hash, key, message)=>new $e330c7b2c6f4e326$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $e330c7b2c6f4e326$var$hmac;
module.exports.hmac.create = (hash, key)=>new $e330c7b2c6f4e326$var$HMAC(hash, key);

});


parcelRegister("cUFfJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $966ab6ed361896f3$var$wordlists = {};
module.exports.wordlists = $966ab6ed361896f3$var$wordlists;
let $966ab6ed361896f3$var$_default;
module.exports._default = $966ab6ed361896f3$var$_default;

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("8JCb6"));
    $966ab6ed361896f3$var$wordlists.czech = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("aktD1"));
    $966ab6ed361896f3$var$wordlists.chinese_simplified = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("D7Oto"));
    $966ab6ed361896f3$var$wordlists.chinese_traditional = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("1osHi"));
    $966ab6ed361896f3$var$wordlists.korean = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("dmUHU"));
    $966ab6ed361896f3$var$wordlists.french = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("gu8gV"));
    $966ab6ed361896f3$var$wordlists.italian = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("8HE54"));
    $966ab6ed361896f3$var$wordlists.spanish = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("j3WV3"));
    $966ab6ed361896f3$var$wordlists.japanese = $966ab6ed361896f3$var$_default;
    $966ab6ed361896f3$var$wordlists.JA = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("7WfCF"));
    $966ab6ed361896f3$var$wordlists.portuguese = $966ab6ed361896f3$var$_default;
} catch (err) {}

try {
    module.exports._default = $966ab6ed361896f3$var$_default = (parcelRequire("2pskv"));
    $966ab6ed361896f3$var$wordlists.english = $966ab6ed361896f3$var$_default;
    $966ab6ed361896f3$var$wordlists.EN = $966ab6ed361896f3$var$_default;
} catch (err) {}

});
parcelRegister("8JCb6", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRegister("aktD1", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("D7Oto", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("1osHi", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("dmUHU", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("gu8gV", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRegister("8HE54", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("j3WV3", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("7WfCF", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRegister("2pskv", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});



parcelRegister("gYtAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fwkhH = parcelRequire("fwkhH");
module.exports.fromSeed = $fwkhH.fromSeed;
module.exports.fromBase58 = $fwkhH.fromBase58;
module.exports.fromPublicKey = $fwkhH.fromPublicKey;
module.exports.fromPrivateKey = $fwkhH.fromPrivateKey;

});
parcelRegister("fwkhH", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $b4c99444f28f1382$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ciLVY = parcelRequire("ciLVY");

var $kfzoe = parcelRequire("kfzoe");

var $didLZ = parcelRequire("didLZ");

var $h3VQr = parcelRequire("h3VQr");

var $j8PAC = parcelRequire("j8PAC");
const $b4c99444f28f1382$var$UINT256_TYPE = $h3VQr.BufferN(32);
const $b4c99444f28f1382$var$NETWORK_TYPE = $h3VQr.compile({
    wif: $h3VQr.UInt8,
    bip32: {
        public: $h3VQr.UInt32,
        private: $h3VQr.UInt32
    }
});
const $b4c99444f28f1382$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $b4c99444f28f1382$var$HIGHEST_BIT = 0x80000000;
const $b4c99444f28f1382$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $b4c99444f28f1382$var$BIP32Path(value) {
    return $h3VQr.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $b4c99444f28f1382$var$UInt31(value) {
    return $h3VQr.UInt32(value) && value <= $b4c99444f28f1382$var$UINT31_MAX;
}
class $b4c99444f28f1382$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $h3VQr($b4c99444f28f1382$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $didLZ.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $ciLVY.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $b4c99444f28f1382$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $b4c99444f28f1382$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $kfzoe.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $j8PAC.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $h3VQr($h3VQr.UInt32, index);
        const isHardened = index >= $b4c99444f28f1382$var$HIGHEST_BIT;
        const data = $b4c99444f28f1382$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $ciLVY.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$didLZ.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $didLZ.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $b4c99444f28f1382$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $didLZ.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $b4c99444f28f1382$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $h3VQr($b4c99444f28f1382$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $b4c99444f28f1382$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $h3VQr($b4c99444f28f1382$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $didLZ.sign(hash, this.privateKey);
        else {
            let sig = $didLZ.sign(hash, this.privateKey);
            const extraData = $b4c99444f28f1382$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $didLZ.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $didLZ.verify(hash, this.publicKey, signature);
    }
}
function $b4c99444f28f1382$var$fromBase58(inString, network) {
    const buffer = $kfzoe.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $b4c99444f28f1382$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $b4c99444f28f1382$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $b4c99444f28f1382$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $b4c99444f28f1382$var$fromBase58;
function $b4c99444f28f1382$var$fromPrivateKey(privateKey, chainCode, network) {
    return $b4c99444f28f1382$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $b4c99444f28f1382$var$fromPrivateKey;
function $b4c99444f28f1382$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $h3VQr({
        privateKey: $b4c99444f28f1382$var$UINT256_TYPE,
        chainCode: $b4c99444f28f1382$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $b4c99444f28f1382$var$BITCOIN;
    if (!$didLZ.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $b4c99444f28f1382$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $b4c99444f28f1382$var$fromPublicKey(publicKey, chainCode, network) {
    return $b4c99444f28f1382$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $b4c99444f28f1382$var$fromPublicKey;
function $b4c99444f28f1382$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $h3VQr({
        publicKey: $h3VQr.BufferN(33),
        chainCode: $b4c99444f28f1382$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $b4c99444f28f1382$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$didLZ.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $b4c99444f28f1382$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $b4c99444f28f1382$var$fromSeed(seed, network) {
    $h3VQr($h3VQr.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $b4c99444f28f1382$var$BITCOIN;
    const I = $ciLVY.hmacSHA512($b4c99444f28f1382$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $b4c99444f28f1382$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $b4c99444f28f1382$var$fromSeed;

});
parcelRegister("ciLVY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5dKmo = parcelRequire("5dKmo");

var $cWxOP = parcelRequire("cWxOP");
function $8f4c59282e9c5642$var$hash160(buffer) {
    const sha256Hash = $5dKmo("sha256").update(buffer).digest();
    try {
        return $5dKmo("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $5dKmo("ripemd160").update(sha256Hash).digest();
    }
}
module.exports.hash160 = $8f4c59282e9c5642$var$hash160;
function $8f4c59282e9c5642$var$hmacSHA512(key, data) {
    return $cWxOP("sha512", key).update(data).digest();
}
module.exports.hmacSHA512 = $8f4c59282e9c5642$var$hmacSHA512;

});
parcelRegister("5dKmo", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $bHoGp = parcelRequire("bHoGp");

var $c61JU = parcelRequire("c61JU");

var $4msE6 = parcelRequire("4msE6");

var $cfJt1 = parcelRequire("cfJt1");
function $3cd220d675ab66df$var$Hash(hash) {
    $cfJt1.call(this, "digest");
    this._hash = hash;
}
$ajIeE($3cd220d675ab66df$var$Hash, $cfJt1);
$3cd220d675ab66df$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$3cd220d675ab66df$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $bHoGp();
    if (alg === "rmd160" || alg === "ripemd160") return new $c61JU();
    return new $3cd220d675ab66df$var$Hash($4msE6(alg));
};

});
parcelRegister("ajIeE", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("bHoGp", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $dH4Vo = parcelRequire("dH4Vo");

var $fx8YU = parcelRequire("fx8YU");
var $8846db63ee280ed5$require$Buffer = $fx8YU.Buffer;
var $8846db63ee280ed5$var$ARRAY16 = new Array(16);
function $8846db63ee280ed5$var$MD5() {
    $dH4Vo.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$ajIeE($8846db63ee280ed5$var$MD5, $dH4Vo);
$8846db63ee280ed5$var$MD5.prototype._update = function() {
    var M = $8846db63ee280ed5$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $8846db63ee280ed5$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $8846db63ee280ed5$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $8846db63ee280ed5$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $8846db63ee280ed5$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $8846db63ee280ed5$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $8846db63ee280ed5$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $8846db63ee280ed5$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $8846db63ee280ed5$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $8846db63ee280ed5$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $8846db63ee280ed5$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $8846db63ee280ed5$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $8846db63ee280ed5$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $8846db63ee280ed5$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $8846db63ee280ed5$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $8846db63ee280ed5$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $8846db63ee280ed5$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $8846db63ee280ed5$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $8846db63ee280ed5$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $8846db63ee280ed5$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $8846db63ee280ed5$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $8846db63ee280ed5$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $8846db63ee280ed5$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $8846db63ee280ed5$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $8846db63ee280ed5$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $8846db63ee280ed5$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $8846db63ee280ed5$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $8846db63ee280ed5$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $8846db63ee280ed5$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $8846db63ee280ed5$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $8846db63ee280ed5$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $8846db63ee280ed5$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $8846db63ee280ed5$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $8846db63ee280ed5$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $8846db63ee280ed5$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $8846db63ee280ed5$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $8846db63ee280ed5$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $8846db63ee280ed5$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $8846db63ee280ed5$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $8846db63ee280ed5$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $8846db63ee280ed5$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $8846db63ee280ed5$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $8846db63ee280ed5$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $8846db63ee280ed5$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $8846db63ee280ed5$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $8846db63ee280ed5$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $8846db63ee280ed5$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $8846db63ee280ed5$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $8846db63ee280ed5$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $8846db63ee280ed5$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $8846db63ee280ed5$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $8846db63ee280ed5$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $8846db63ee280ed5$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $8846db63ee280ed5$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $8846db63ee280ed5$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $8846db63ee280ed5$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $8846db63ee280ed5$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $8846db63ee280ed5$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $8846db63ee280ed5$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $8846db63ee280ed5$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $8846db63ee280ed5$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $8846db63ee280ed5$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $8846db63ee280ed5$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $8846db63ee280ed5$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $8846db63ee280ed5$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$8846db63ee280ed5$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8846db63ee280ed5$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $8846db63ee280ed5$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8846db63ee280ed5$var$fnF(a, b, c, d, m, k, s) {
    return $8846db63ee280ed5$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $8846db63ee280ed5$var$fnG(a, b, c, d, m, k, s) {
    return $8846db63ee280ed5$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $8846db63ee280ed5$var$fnH(a, b, c, d, m, k, s) {
    return $8846db63ee280ed5$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $8846db63ee280ed5$var$fnI(a, b, c, d, m, k, s) {
    return $8846db63ee280ed5$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $8846db63ee280ed5$var$MD5;

});
parcelRegister("dH4Vo", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $9f831c783831cfce$require$Buffer = $fx8YU.Buffer;

var $gvRey = parcelRequire("gvRey");
var $9f831c783831cfce$require$Transform = $gvRey.Transform;

var $ajIeE = parcelRequire("ajIeE");
function $9f831c783831cfce$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$9f831c783831cfce$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $9f831c783831cfce$var$HashBase(blockSize) {
    $9f831c783831cfce$require$Transform.call(this);
    this._block = $9f831c783831cfce$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$ajIeE($9f831c783831cfce$var$HashBase, $9f831c783831cfce$require$Transform);
$9f831c783831cfce$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$9f831c783831cfce$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$9f831c783831cfce$var$HashBase.prototype.update = function(data, encoding) {
    $9f831c783831cfce$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$9f831c783831cfce$require$Buffer.isBuffer(data)) data = $9f831c783831cfce$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$9f831c783831cfce$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$9f831c783831cfce$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$9f831c783831cfce$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $9f831c783831cfce$var$HashBase;

});
parcelRegister("fx8YU", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $N0o3H = parcelRequire("N0o3H");
var $b4f0e7985342bd1b$var$Buffer = $N0o3H.Buffer;
// alternative to using Object.keys for old browsers
function $b4f0e7985342bd1b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b4f0e7985342bd1b$var$Buffer.from && $b4f0e7985342bd1b$var$Buffer.alloc && $b4f0e7985342bd1b$var$Buffer.allocUnsafe && $b4f0e7985342bd1b$var$Buffer.allocUnsafeSlow) module.exports = $N0o3H;
else {
    // Copy properties from require('buffer')
    $b4f0e7985342bd1b$var$copyProps($N0o3H, module.exports);
    module.exports.Buffer = $b4f0e7985342bd1b$var$SafeBuffer;
}
function $b4f0e7985342bd1b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b4f0e7985342bd1b$var$Buffer(arg, encodingOrOffset, length);
}
$b4f0e7985342bd1b$var$SafeBuffer.prototype = Object.create($b4f0e7985342bd1b$var$Buffer.prototype);
// Copy static methods from Buffer
$b4f0e7985342bd1b$var$copyProps($b4f0e7985342bd1b$var$Buffer, $b4f0e7985342bd1b$var$SafeBuffer);
$b4f0e7985342bd1b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $b4f0e7985342bd1b$var$Buffer(arg, encodingOrOffset, length);
};
$b4f0e7985342bd1b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $b4f0e7985342bd1b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b4f0e7985342bd1b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $b4f0e7985342bd1b$var$Buffer(size);
};
$b4f0e7985342bd1b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $N0o3H.SlowBuffer(size);
};

});

parcelRegister("gvRey", function(module, exports) {

exports = module.exports = (parcelRequire("3FIls"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("fBs4s"));

exports.Duplex = (parcelRequire("2zm4f"));

exports.Transform = (parcelRequire("bQnl8"));

exports.PassThrough = (parcelRequire("k5VMI"));

exports.finished = (parcelRequire("9RUbc"));

exports.pipeline = (parcelRequire("7iugW"));

});
parcelRegister("3FIls", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ibaza = parcelRequire("ibaza");
"use strict";
module.exports = $2ac7996e175e24e5$var$Readable;
/*<replacement>*/ var $2ac7996e175e24e5$var$Duplex;
/*</replacement>*/ $2ac7996e175e24e5$var$Readable.ReadableState = $2ac7996e175e24e5$var$ReadableState;

var $9sqfU = parcelRequire("9sqfU");
var $2ac7996e175e24e5$require$EE = $9sqfU.EventEmitter;
var $2ac7996e175e24e5$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $Pd9Uo = parcelRequire("Pd9Uo");

var $N0o3H = parcelRequire("N0o3H");
var $2ac7996e175e24e5$require$Buffer = $N0o3H.Buffer;
var $2ac7996e175e24e5$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2ac7996e175e24e5$var$_uint8ArrayToBuffer(chunk) {
    return $2ac7996e175e24e5$require$Buffer.from(chunk);
}
function $2ac7996e175e24e5$var$_isUint8Array(obj) {
    return $2ac7996e175e24e5$require$Buffer.isBuffer(obj) || obj instanceof $2ac7996e175e24e5$var$OurUint8Array;
}

var $foUwZ = parcelRequire("foUwZ");
var $2ac7996e175e24e5$var$debug;
if ($foUwZ && $foUwZ.debuglog) $2ac7996e175e24e5$var$debug = $foUwZ.debuglog("stream");
else $2ac7996e175e24e5$var$debug = function debug() {};

var $ikZyt = parcelRequire("ikZyt");

var $7CELW = parcelRequire("7CELW");

var $bKeTG = parcelRequire("bKeTG");
var $2ac7996e175e24e5$var$getHighWaterMark = $bKeTG.getHighWaterMark;

var $7iME2 = parcelRequire("7iME2");
var $2ac7996e175e24e5$require$_require$codes = $7iME2.codes;
var $2ac7996e175e24e5$var$ERR_INVALID_ARG_TYPE = $2ac7996e175e24e5$require$_require$codes.ERR_INVALID_ARG_TYPE, $2ac7996e175e24e5$var$ERR_STREAM_PUSH_AFTER_EOF = $2ac7996e175e24e5$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $2ac7996e175e24e5$var$ERR_METHOD_NOT_IMPLEMENTED = $2ac7996e175e24e5$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2ac7996e175e24e5$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $2ac7996e175e24e5$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $2ac7996e175e24e5$var$StringDecoder;
var $2ac7996e175e24e5$var$createReadableStreamAsyncIterator;
var $2ac7996e175e24e5$var$from;

(parcelRequire("ajIeE"))($2ac7996e175e24e5$var$Readable, $Pd9Uo);
var $2ac7996e175e24e5$var$errorOrDestroy = $7CELW.errorOrDestroy;
var $2ac7996e175e24e5$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $2ac7996e175e24e5$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $2ac7996e175e24e5$var$ReadableState(options, stream, isDuplex) {
    $2ac7996e175e24e5$var$Duplex = $2ac7996e175e24e5$var$Duplex || (parcelRequire("2zm4f"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2ac7996e175e24e5$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $2ac7996e175e24e5$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $ikZyt();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$2ac7996e175e24e5$var$StringDecoder) $2ac7996e175e24e5$var$StringDecoder = (parcelRequire("jJ0xG")).StringDecoder;
        this.decoder = new $2ac7996e175e24e5$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $2ac7996e175e24e5$var$Readable(options) {
    $2ac7996e175e24e5$var$Duplex = $2ac7996e175e24e5$var$Duplex || (parcelRequire("2zm4f"));
    if (!(this instanceof $2ac7996e175e24e5$var$Readable)) return new $2ac7996e175e24e5$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2ac7996e175e24e5$var$Duplex;
    this._readableState = new $2ac7996e175e24e5$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $Pd9Uo.call(this);
}
Object.defineProperty($2ac7996e175e24e5$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$2ac7996e175e24e5$var$Readable.prototype.destroy = $7CELW.destroy;
$2ac7996e175e24e5$var$Readable.prototype._undestroy = $7CELW.undestroy;
$2ac7996e175e24e5$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$2ac7996e175e24e5$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $2ac7996e175e24e5$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $2ac7996e175e24e5$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$2ac7996e175e24e5$var$Readable.prototype.unshift = function(chunk) {
    return $2ac7996e175e24e5$var$readableAddChunk(this, chunk, null, true, false);
};
function $2ac7996e175e24e5$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $2ac7996e175e24e5$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $2ac7996e175e24e5$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $2ac7996e175e24e5$var$chunkInvalid(state, chunk);
        if (er) $2ac7996e175e24e5$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $2ac7996e175e24e5$require$Buffer.prototype) chunk = $2ac7996e175e24e5$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $2ac7996e175e24e5$var$errorOrDestroy(stream, new $2ac7996e175e24e5$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $2ac7996e175e24e5$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $2ac7996e175e24e5$var$errorOrDestroy(stream, new $2ac7996e175e24e5$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $2ac7996e175e24e5$var$addChunk(stream, state, chunk, false);
                    else $2ac7996e175e24e5$var$maybeReadMore(stream, state);
                } else $2ac7996e175e24e5$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $2ac7996e175e24e5$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $2ac7996e175e24e5$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $2ac7996e175e24e5$var$emitReadable(stream);
    }
    $2ac7996e175e24e5$var$maybeReadMore(stream, state);
}
function $2ac7996e175e24e5$var$chunkInvalid(state, chunk) {
    var er;
    if (!$2ac7996e175e24e5$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $2ac7996e175e24e5$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$2ac7996e175e24e5$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$2ac7996e175e24e5$var$Readable.prototype.setEncoding = function(enc) {
    if (!$2ac7996e175e24e5$var$StringDecoder) $2ac7996e175e24e5$var$StringDecoder = (parcelRequire("jJ0xG")).StringDecoder;
    var decoder = new $2ac7996e175e24e5$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $2ac7996e175e24e5$var$MAX_HWM = 0x40000000;
function $2ac7996e175e24e5$var$computeNewHighWaterMark(n) {
    if (n >= $2ac7996e175e24e5$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $2ac7996e175e24e5$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2ac7996e175e24e5$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $2ac7996e175e24e5$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$2ac7996e175e24e5$var$Readable.prototype.read = function(n) {
    $2ac7996e175e24e5$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $2ac7996e175e24e5$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $2ac7996e175e24e5$var$endReadable(this);
        else $2ac7996e175e24e5$var$emitReadable(this);
        return null;
    }
    n = $2ac7996e175e24e5$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $2ac7996e175e24e5$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $2ac7996e175e24e5$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $2ac7996e175e24e5$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $2ac7996e175e24e5$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $2ac7996e175e24e5$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $2ac7996e175e24e5$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $2ac7996e175e24e5$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $2ac7996e175e24e5$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $2ac7996e175e24e5$var$onEofChunk(stream, state) {
    $2ac7996e175e24e5$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $2ac7996e175e24e5$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $2ac7996e175e24e5$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $2ac7996e175e24e5$var$emitReadable(stream) {
    var state = stream._readableState;
    $2ac7996e175e24e5$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $2ac7996e175e24e5$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $ibaza.nextTick($2ac7996e175e24e5$var$emitReadable_, stream);
    }
}
function $2ac7996e175e24e5$var$emitReadable_(stream) {
    var state = stream._readableState;
    $2ac7996e175e24e5$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $2ac7996e175e24e5$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $2ac7996e175e24e5$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $ibaza.nextTick($2ac7996e175e24e5$var$maybeReadMore_, stream, state);
    }
}
function $2ac7996e175e24e5$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $2ac7996e175e24e5$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$2ac7996e175e24e5$var$Readable.prototype._read = function(n) {
    $2ac7996e175e24e5$var$errorOrDestroy(this, new $2ac7996e175e24e5$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$2ac7996e175e24e5$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $2ac7996e175e24e5$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $ibaza.stdout && dest !== $ibaza.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $ibaza.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $2ac7996e175e24e5$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $2ac7996e175e24e5$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $2ac7996e175e24e5$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $2ac7996e175e24e5$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $2ac7996e175e24e5$var$debug("ondata");
        var ret = dest.write(chunk);
        $2ac7996e175e24e5$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $2ac7996e175e24e5$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $2ac7996e175e24e5$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $2ac7996e175e24e5$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($2ac7996e175e24e5$var$EElistenerCount(dest, "error") === 0) $2ac7996e175e24e5$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $2ac7996e175e24e5$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $2ac7996e175e24e5$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $2ac7996e175e24e5$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $2ac7996e175e24e5$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $2ac7996e175e24e5$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $2ac7996e175e24e5$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $2ac7996e175e24e5$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $2ac7996e175e24e5$var$flow(src);
        }
    };
}
$2ac7996e175e24e5$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $2ac7996e175e24e5$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$2ac7996e175e24e5$var$Readable.prototype.on = function(ev, fn) {
    var res = $Pd9Uo.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $2ac7996e175e24e5$var$debug("on readable", state.length, state.reading);
            if (state.length) $2ac7996e175e24e5$var$emitReadable(this);
            else if (!state.reading) $ibaza.nextTick($2ac7996e175e24e5$var$nReadingNextTick, this);
        }
    }
    return res;
};
$2ac7996e175e24e5$var$Readable.prototype.addListener = $2ac7996e175e24e5$var$Readable.prototype.on;
$2ac7996e175e24e5$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $Pd9Uo.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ibaza.nextTick($2ac7996e175e24e5$var$updateReadableListening, this);
    return res;
};
$2ac7996e175e24e5$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $Pd9Uo.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ibaza.nextTick($2ac7996e175e24e5$var$updateReadableListening, this);
    return res;
};
function $2ac7996e175e24e5$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $2ac7996e175e24e5$var$nReadingNextTick(self1) {
    $2ac7996e175e24e5$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$2ac7996e175e24e5$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $2ac7996e175e24e5$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $2ac7996e175e24e5$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $2ac7996e175e24e5$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $ibaza.nextTick($2ac7996e175e24e5$var$resume_, stream, state);
    }
}
function $2ac7996e175e24e5$var$resume_(stream, state) {
    $2ac7996e175e24e5$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $2ac7996e175e24e5$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$2ac7996e175e24e5$var$Readable.prototype.pause = function() {
    $2ac7996e175e24e5$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $2ac7996e175e24e5$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $2ac7996e175e24e5$var$flow(stream) {
    var state = stream._readableState;
    $2ac7996e175e24e5$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$2ac7996e175e24e5$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $2ac7996e175e24e5$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $2ac7996e175e24e5$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $2ac7996e175e24e5$var$kProxyEvents.length; n++)stream.on($2ac7996e175e24e5$var$kProxyEvents[n], this.emit.bind(this, $2ac7996e175e24e5$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $2ac7996e175e24e5$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $2ac7996e175e24e5$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($2ac7996e175e24e5$var$createReadableStreamAsyncIterator === undefined) $2ac7996e175e24e5$var$createReadableStreamAsyncIterator = (parcelRequire("aXIm7"));
    return $2ac7996e175e24e5$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($2ac7996e175e24e5$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($2ac7996e175e24e5$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($2ac7996e175e24e5$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$2ac7996e175e24e5$var$Readable._fromList = $2ac7996e175e24e5$var$fromList;
Object.defineProperty($2ac7996e175e24e5$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $2ac7996e175e24e5$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $2ac7996e175e24e5$var$endReadable(stream) {
    var state = stream._readableState;
    $2ac7996e175e24e5$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $ibaza.nextTick($2ac7996e175e24e5$var$endReadableNT, state, stream);
    }
}
function $2ac7996e175e24e5$var$endReadableNT(state, stream) {
    $2ac7996e175e24e5$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $2ac7996e175e24e5$var$Readable.from = function(iterable, opts) {
    if ($2ac7996e175e24e5$var$from === undefined) $2ac7996e175e24e5$var$from = (parcelRequire("jseUY"));
    return $2ac7996e175e24e5$var$from($2ac7996e175e24e5$var$Readable, iterable, opts);
};
function $2ac7996e175e24e5$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("9sqfU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $6e2b186194ca9ee7$var$R = typeof Reflect === "object" ? Reflect : null;
var $6e2b186194ca9ee7$var$ReflectApply = $6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.apply === "function" ? $6e2b186194ca9ee7$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6e2b186194ca9ee7$var$ReflectOwnKeys;
if ($6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.ownKeys === "function") $6e2b186194ca9ee7$var$ReflectOwnKeys = $6e2b186194ca9ee7$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6e2b186194ca9ee7$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6e2b186194ca9ee7$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6e2b186194ca9ee7$var$EventEmitter() {
    $6e2b186194ca9ee7$var$EventEmitter.init.call(this);
}
module.exports = $6e2b186194ca9ee7$var$EventEmitter;
module.exports.once = $6e2b186194ca9ee7$var$once;
// Backwards-compat with node 0.10.x
$6e2b186194ca9ee7$var$EventEmitter.EventEmitter = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$var$EventEmitter.prototype._events = undefined;
$6e2b186194ca9ee7$var$EventEmitter.prototype._eventsCount = 0;
$6e2b186194ca9ee7$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6e2b186194ca9ee7$var$defaultMaxListeners = 10;
function $6e2b186194ca9ee7$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6e2b186194ca9ee7$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $6e2b186194ca9ee7$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $6e2b186194ca9ee7$var$defaultMaxListeners = arg;
    }
});
$6e2b186194ca9ee7$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6e2b186194ca9ee7$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $6e2b186194ca9ee7$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6e2b186194ca9ee7$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6e2b186194ca9ee7$var$_getMaxListeners(this);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $6e2b186194ca9ee7$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6e2b186194ca9ee7$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6e2b186194ca9ee7$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6e2b186194ca9ee7$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6e2b186194ca9ee7$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6e2b186194ca9ee7$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, false);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.on = $6e2b186194ca9ee7$var$EventEmitter.prototype.addListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, true);
};
function $6e2b186194ca9ee7$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6e2b186194ca9ee7$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6e2b186194ca9ee7$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.once = function once(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.on(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.prependListener(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6e2b186194ca9ee7$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.off = $6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6e2b186194ca9ee7$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6e2b186194ca9ee7$var$unwrapListeners(evlistener) : $6e2b186194ca9ee7$var$arrayClone(evlistener, evlistener.length);
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, true);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, false);
};
$6e2b186194ca9ee7$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $6e2b186194ca9ee7$var$listenerCount.call(emitter, type);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.listenerCount = $6e2b186194ca9ee7$var$listenerCount;
function $6e2b186194ca9ee7$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6e2b186194ca9ee7$var$ReflectOwnKeys(this._events) : [];
};
function $6e2b186194ca9ee7$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6e2b186194ca9ee7$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6e2b186194ca9ee7$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6e2b186194ca9ee7$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("Pd9Uo", function(module, exports) {

module.exports = (parcelRequire("9sqfU")).EventEmitter;

});

parcelRegister("ikZyt", function(module, exports) {
"use strict";
function $d599d7d1fba2dc7c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d599d7d1fba2dc7c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $d599d7d1fba2dc7c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $d599d7d1fba2dc7c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $d599d7d1fba2dc7c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d599d7d1fba2dc7c$var$_defineProperty(obj, key, value) {
    key = $d599d7d1fba2dc7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d599d7d1fba2dc7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d599d7d1fba2dc7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d599d7d1fba2dc7c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d599d7d1fba2dc7c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d599d7d1fba2dc7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d599d7d1fba2dc7c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d599d7d1fba2dc7c$var$_toPropertyKey(arg) {
    var key = $d599d7d1fba2dc7c$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $d599d7d1fba2dc7c$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $N0o3H = parcelRequire("N0o3H");
var $d599d7d1fba2dc7c$var$Buffer = $N0o3H.Buffer;

var $foUwZ = parcelRequire("foUwZ");
var $d599d7d1fba2dc7c$var$inspect = $foUwZ.inspect;
var $d599d7d1fba2dc7c$var$custom = $d599d7d1fba2dc7c$var$inspect && $d599d7d1fba2dc7c$var$inspect.custom || "inspect";
function $d599d7d1fba2dc7c$var$copyBuffer(src, target, offset) {
    $d599d7d1fba2dc7c$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $d599d7d1fba2dc7c$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $d599d7d1fba2dc7c$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $d599d7d1fba2dc7c$var$Buffer.alloc(0);
                var ret = $d599d7d1fba2dc7c$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $d599d7d1fba2dc7c$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $d599d7d1fba2dc7c$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $d599d7d1fba2dc7c$var$custom,
            value: function value(_, options) {
                return $d599d7d1fba2dc7c$var$inspect(this, $d599d7d1fba2dc7c$var$_objectSpread($d599d7d1fba2dc7c$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("7CELW", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $58cbb58867ae5051$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $ibaza.nextTick($58cbb58867ae5051$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $ibaza.nextTick($58cbb58867ae5051$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $ibaza.nextTick($58cbb58867ae5051$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $ibaza.nextTick($58cbb58867ae5051$var$emitErrorAndCloseNT, _this, err);
            } else $ibaza.nextTick($58cbb58867ae5051$var$emitCloseNT, _this);
        } else if (cb) {
            $ibaza.nextTick($58cbb58867ae5051$var$emitCloseNT, _this);
            cb(err);
        } else $ibaza.nextTick($58cbb58867ae5051$var$emitCloseNT, _this);
    });
    return this;
}
function $58cbb58867ae5051$var$emitErrorAndCloseNT(self, err) {
    $58cbb58867ae5051$var$emitErrorNT(self, err);
    $58cbb58867ae5051$var$emitCloseNT(self);
}
function $58cbb58867ae5051$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $58cbb58867ae5051$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $58cbb58867ae5051$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $58cbb58867ae5051$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $58cbb58867ae5051$var$destroy,
    undestroy: $58cbb58867ae5051$var$undestroy,
    errorOrDestroy: $58cbb58867ae5051$var$errorOrDestroy
};

});

parcelRegister("bKeTG", function(module, exports) {
"use strict";

var $88cf8bd7837b28dd$var$ERR_INVALID_OPT_VALUE = (parcelRequire("7iME2")).codes.ERR_INVALID_OPT_VALUE;
function $88cf8bd7837b28dd$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $88cf8bd7837b28dd$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $88cf8bd7837b28dd$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $88cf8bd7837b28dd$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $88cf8bd7837b28dd$var$getHighWaterMark
};

});
parcelRegister("7iME2", function(module, exports) {

$parcel$export(module.exports, "codes", () => $550ff2a88b89e50c$export$e45cb6485273080e, (v) => $550ff2a88b89e50c$export$e45cb6485273080e = v);
var $550ff2a88b89e50c$export$e45cb6485273080e;
"use strict";
function $550ff2a88b89e50c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $550ff2a88b89e50c$var$codes = {};
function $550ff2a88b89e50c$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $550ff2a88b89e50c$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $550ff2a88b89e50c$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $550ff2a88b89e50c$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $550ff2a88b89e50c$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $550ff2a88b89e50c$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $550ff2a88b89e50c$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$550ff2a88b89e50c$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$550ff2a88b89e50c$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $550ff2a88b89e50c$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($550ff2a88b89e50c$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($550ff2a88b89e50c$var$oneOf(expected, "type"));
    else {
        var type = $550ff2a88b89e50c$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($550ff2a88b89e50c$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$550ff2a88b89e50c$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$550ff2a88b89e50c$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$550ff2a88b89e50c$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$550ff2a88b89e50c$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$550ff2a88b89e50c$export$e45cb6485273080e = $550ff2a88b89e50c$var$codes;

});


parcelRegister("2zm4f", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $ibaza = parcelRequire("ibaza");
"use strict";
/*<replacement>*/ var $1deff7cc385e4b84$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1deff7cc385e4b84$var$Duplex;

var $3FIls = parcelRequire("3FIls");

var $fBs4s = parcelRequire("fBs4s");

(parcelRequire("ajIeE"))($1deff7cc385e4b84$var$Duplex, $3FIls);
// Allow the keys array to be GC'ed.
var $1deff7cc385e4b84$var$keys = $1deff7cc385e4b84$var$objectKeys($fBs4s.prototype);
for(var $1deff7cc385e4b84$var$v = 0; $1deff7cc385e4b84$var$v < $1deff7cc385e4b84$var$keys.length; $1deff7cc385e4b84$var$v++){
    var $1deff7cc385e4b84$var$method = $1deff7cc385e4b84$var$keys[$1deff7cc385e4b84$var$v];
    if (!$1deff7cc385e4b84$var$Duplex.prototype[$1deff7cc385e4b84$var$method]) $1deff7cc385e4b84$var$Duplex.prototype[$1deff7cc385e4b84$var$method] = $fBs4s.prototype[$1deff7cc385e4b84$var$method];
}
function $1deff7cc385e4b84$var$Duplex(options) {
    if (!(this instanceof $1deff7cc385e4b84$var$Duplex)) return new $1deff7cc385e4b84$var$Duplex(options);
    $3FIls.call(this, options);
    $fBs4s.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $1deff7cc385e4b84$var$onend);
        }
    }
}
Object.defineProperty($1deff7cc385e4b84$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1deff7cc385e4b84$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1deff7cc385e4b84$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $1deff7cc385e4b84$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $ibaza.nextTick($1deff7cc385e4b84$var$onEndNT, this);
}
function $1deff7cc385e4b84$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1deff7cc385e4b84$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("fBs4s", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $ibaza = parcelRequire("ibaza");
"use strict";
module.exports = $b5c01607b2d746e1$var$Writable;
/* <replacement> */ function $b5c01607b2d746e1$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $b5c01607b2d746e1$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $b5c01607b2d746e1$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $b5c01607b2d746e1$var$Duplex;
/*</replacement>*/ $b5c01607b2d746e1$var$Writable.WritableState = $b5c01607b2d746e1$var$WritableState;

/*<replacement>*/ var $b5c01607b2d746e1$var$internalUtil = {
    deprecate: (parcelRequire("lBmIa"))
};

var $Pd9Uo = parcelRequire("Pd9Uo");

var $N0o3H = parcelRequire("N0o3H");
var $b5c01607b2d746e1$require$Buffer = $N0o3H.Buffer;
var $b5c01607b2d746e1$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $b5c01607b2d746e1$var$_uint8ArrayToBuffer(chunk) {
    return $b5c01607b2d746e1$require$Buffer.from(chunk);
}
function $b5c01607b2d746e1$var$_isUint8Array(obj) {
    return $b5c01607b2d746e1$require$Buffer.isBuffer(obj) || obj instanceof $b5c01607b2d746e1$var$OurUint8Array;
}

var $7CELW = parcelRequire("7CELW");

var $bKeTG = parcelRequire("bKeTG");
var $b5c01607b2d746e1$var$getHighWaterMark = $bKeTG.getHighWaterMark;

var $7iME2 = parcelRequire("7iME2");
var $b5c01607b2d746e1$require$_require$codes = $7iME2.codes;
var $b5c01607b2d746e1$var$ERR_INVALID_ARG_TYPE = $b5c01607b2d746e1$require$_require$codes.ERR_INVALID_ARG_TYPE, $b5c01607b2d746e1$var$ERR_METHOD_NOT_IMPLEMENTED = $b5c01607b2d746e1$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $b5c01607b2d746e1$var$ERR_MULTIPLE_CALLBACK = $b5c01607b2d746e1$require$_require$codes.ERR_MULTIPLE_CALLBACK, $b5c01607b2d746e1$var$ERR_STREAM_CANNOT_PIPE = $b5c01607b2d746e1$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $b5c01607b2d746e1$var$ERR_STREAM_DESTROYED = $b5c01607b2d746e1$require$_require$codes.ERR_STREAM_DESTROYED, $b5c01607b2d746e1$var$ERR_STREAM_NULL_VALUES = $b5c01607b2d746e1$require$_require$codes.ERR_STREAM_NULL_VALUES, $b5c01607b2d746e1$var$ERR_STREAM_WRITE_AFTER_END = $b5c01607b2d746e1$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $b5c01607b2d746e1$var$ERR_UNKNOWN_ENCODING = $b5c01607b2d746e1$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $b5c01607b2d746e1$var$errorOrDestroy = $7CELW.errorOrDestroy;

(parcelRequire("ajIeE"))($b5c01607b2d746e1$var$Writable, $Pd9Uo);
function $b5c01607b2d746e1$var$nop() {}

function $b5c01607b2d746e1$var$WritableState(options, stream, isDuplex) {
    $b5c01607b2d746e1$var$Duplex = $b5c01607b2d746e1$var$Duplex || (parcelRequire("2zm4f"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $b5c01607b2d746e1$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $b5c01607b2d746e1$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $b5c01607b2d746e1$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $b5c01607b2d746e1$var$CorkedRequest(this);
}
$b5c01607b2d746e1$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($b5c01607b2d746e1$var$WritableState.prototype, "buffer", {
            get: $b5c01607b2d746e1$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $b5c01607b2d746e1$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $b5c01607b2d746e1$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($b5c01607b2d746e1$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($b5c01607b2d746e1$var$realHasInstance.call(this, object)) return true;
            if (this !== $b5c01607b2d746e1$var$Writable) return false;
            return object && object._writableState instanceof $b5c01607b2d746e1$var$WritableState;
        }
    });
} else $b5c01607b2d746e1$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $b5c01607b2d746e1$var$Writable(options) {
    $b5c01607b2d746e1$var$Duplex = $b5c01607b2d746e1$var$Duplex || (parcelRequire("2zm4f"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $b5c01607b2d746e1$var$Duplex;
    if (!isDuplex && !$b5c01607b2d746e1$var$realHasInstance.call($b5c01607b2d746e1$var$Writable, this)) return new $b5c01607b2d746e1$var$Writable(options);
    this._writableState = new $b5c01607b2d746e1$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $Pd9Uo.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$b5c01607b2d746e1$var$Writable.prototype.pipe = function() {
    $b5c01607b2d746e1$var$errorOrDestroy(this, new $b5c01607b2d746e1$var$ERR_STREAM_CANNOT_PIPE());
};
function $b5c01607b2d746e1$var$writeAfterEnd(stream, cb) {
    var er = new $b5c01607b2d746e1$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $b5c01607b2d746e1$var$errorOrDestroy(stream, er);
    $ibaza.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $b5c01607b2d746e1$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $b5c01607b2d746e1$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $b5c01607b2d746e1$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $b5c01607b2d746e1$var$errorOrDestroy(stream, er);
        $ibaza.nextTick(cb, er);
        return false;
    }
    return true;
}
$b5c01607b2d746e1$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $b5c01607b2d746e1$var$_isUint8Array(chunk);
    if (isBuf && !$b5c01607b2d746e1$require$Buffer.isBuffer(chunk)) chunk = $b5c01607b2d746e1$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $b5c01607b2d746e1$var$nop;
    if (state.ending) $b5c01607b2d746e1$var$writeAfterEnd(this, cb);
    else if (isBuf || $b5c01607b2d746e1$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $b5c01607b2d746e1$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$b5c01607b2d746e1$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$b5c01607b2d746e1$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b5c01607b2d746e1$var$clearBuffer(this, state);
    }
};
$b5c01607b2d746e1$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $b5c01607b2d746e1$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($b5c01607b2d746e1$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $b5c01607b2d746e1$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $b5c01607b2d746e1$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($b5c01607b2d746e1$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b5c01607b2d746e1$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $b5c01607b2d746e1$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $b5c01607b2d746e1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $b5c01607b2d746e1$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $b5c01607b2d746e1$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b5c01607b2d746e1$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $ibaza.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $ibaza.nextTick($b5c01607b2d746e1$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $b5c01607b2d746e1$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $b5c01607b2d746e1$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $b5c01607b2d746e1$var$finishMaybe(stream, state);
    }
}
function $b5c01607b2d746e1$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $b5c01607b2d746e1$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $b5c01607b2d746e1$var$ERR_MULTIPLE_CALLBACK();
    $b5c01607b2d746e1$var$onwriteStateUpdate(state);
    if (er) $b5c01607b2d746e1$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $b5c01607b2d746e1$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b5c01607b2d746e1$var$clearBuffer(stream, state);
        if (sync) $ibaza.nextTick($b5c01607b2d746e1$var$afterWrite, stream, state, finished, cb);
        else $b5c01607b2d746e1$var$afterWrite(stream, state, finished, cb);
    }
}
function $b5c01607b2d746e1$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $b5c01607b2d746e1$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $b5c01607b2d746e1$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $b5c01607b2d746e1$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $b5c01607b2d746e1$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $b5c01607b2d746e1$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $b5c01607b2d746e1$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $b5c01607b2d746e1$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$b5c01607b2d746e1$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $b5c01607b2d746e1$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$b5c01607b2d746e1$var$Writable.prototype._writev = null;
$b5c01607b2d746e1$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $b5c01607b2d746e1$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($b5c01607b2d746e1$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $b5c01607b2d746e1$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $b5c01607b2d746e1$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $b5c01607b2d746e1$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $b5c01607b2d746e1$var$finishMaybe(stream, state);
    });
}
function $b5c01607b2d746e1$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $ibaza.nextTick($b5c01607b2d746e1$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $b5c01607b2d746e1$var$finishMaybe(stream, state) {
    var need = $b5c01607b2d746e1$var$needFinish(state);
    if (need) {
        $b5c01607b2d746e1$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $b5c01607b2d746e1$var$endWritable(stream, state, cb) {
    state.ending = true;
    $b5c01607b2d746e1$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $ibaza.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $b5c01607b2d746e1$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($b5c01607b2d746e1$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$b5c01607b2d746e1$var$Writable.prototype.destroy = $7CELW.destroy;
$b5c01607b2d746e1$var$Writable.prototype._undestroy = $7CELW.undestroy;
$b5c01607b2d746e1$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("lBmIa", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $fb9eaba8ccf915df$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $fb9eaba8ccf915df$var$deprecate(fn, msg) {
    if ($fb9eaba8ccf915df$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($fb9eaba8ccf915df$var$config("throwDeprecation")) throw new Error(msg);
            else if ($fb9eaba8ccf915df$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $fb9eaba8ccf915df$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("jJ0xG", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $e5c2a3f70c10f900$export$63a7aa211a91ed69, (v) => $e5c2a3f70c10f900$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $e5c2a3f70c10f900$export$63a7aa211a91ed69;
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $e5c2a3f70c10f900$require$Buffer = $fx8YU.Buffer;
/*</replacement>*/ var $e5c2a3f70c10f900$var$isEncoding = $e5c2a3f70c10f900$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $e5c2a3f70c10f900$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $e5c2a3f70c10f900$var$normalizeEncoding(enc) {
    var nenc = $e5c2a3f70c10f900$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($e5c2a3f70c10f900$require$Buffer.isEncoding === $e5c2a3f70c10f900$var$isEncoding || !$e5c2a3f70c10f900$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$e5c2a3f70c10f900$export$63a7aa211a91ed69 = $e5c2a3f70c10f900$var$StringDecoder;
function $e5c2a3f70c10f900$var$StringDecoder(encoding) {
    this.encoding = $e5c2a3f70c10f900$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $e5c2a3f70c10f900$var$utf16Text;
            this.end = $e5c2a3f70c10f900$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $e5c2a3f70c10f900$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $e5c2a3f70c10f900$var$base64Text;
            this.end = $e5c2a3f70c10f900$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $e5c2a3f70c10f900$var$simpleWrite;
            this.end = $e5c2a3f70c10f900$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $e5c2a3f70c10f900$require$Buffer.allocUnsafe(nb);
}
$e5c2a3f70c10f900$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$e5c2a3f70c10f900$var$StringDecoder.prototype.end = $e5c2a3f70c10f900$var$utf8End;
// Returns only complete characters in a Buffer
$e5c2a3f70c10f900$var$StringDecoder.prototype.text = $e5c2a3f70c10f900$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$e5c2a3f70c10f900$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $e5c2a3f70c10f900$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $e5c2a3f70c10f900$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e5c2a3f70c10f900$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $e5c2a3f70c10f900$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $e5c2a3f70c10f900$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $e5c2a3f70c10f900$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $e5c2a3f70c10f900$var$utf8Text(buf, i) {
    var total = $e5c2a3f70c10f900$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $e5c2a3f70c10f900$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $e5c2a3f70c10f900$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $e5c2a3f70c10f900$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $e5c2a3f70c10f900$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $e5c2a3f70c10f900$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $e5c2a3f70c10f900$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $e5c2a3f70c10f900$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("aXIm7", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
var $7fb1d234192189b8$var$_Object$setPrototypeO;
function $7fb1d234192189b8$var$_defineProperty(obj, key, value) {
    key = $7fb1d234192189b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7fb1d234192189b8$var$_toPropertyKey(arg) {
    var key = $7fb1d234192189b8$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7fb1d234192189b8$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $9RUbc = parcelRequire("9RUbc");
var $7fb1d234192189b8$var$kLastResolve = Symbol("lastResolve");
var $7fb1d234192189b8$var$kLastReject = Symbol("lastReject");
var $7fb1d234192189b8$var$kError = Symbol("error");
var $7fb1d234192189b8$var$kEnded = Symbol("ended");
var $7fb1d234192189b8$var$kLastPromise = Symbol("lastPromise");
var $7fb1d234192189b8$var$kHandlePromise = Symbol("handlePromise");
var $7fb1d234192189b8$var$kStream = Symbol("stream");
function $7fb1d234192189b8$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $7fb1d234192189b8$var$readAndResolve(iter) {
    var resolve = iter[$7fb1d234192189b8$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$7fb1d234192189b8$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$7fb1d234192189b8$var$kLastPromise] = null;
            iter[$7fb1d234192189b8$var$kLastResolve] = null;
            iter[$7fb1d234192189b8$var$kLastReject] = null;
            resolve($7fb1d234192189b8$var$createIterResult(data, false));
        }
    }
}
function $7fb1d234192189b8$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $ibaza.nextTick($7fb1d234192189b8$var$readAndResolve, iter);
}
function $7fb1d234192189b8$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$7fb1d234192189b8$var$kEnded]) {
                resolve($7fb1d234192189b8$var$createIterResult(undefined, true));
                return;
            }
            iter[$7fb1d234192189b8$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $7fb1d234192189b8$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $7fb1d234192189b8$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($7fb1d234192189b8$var$_Object$setPrototypeO = {
    get stream () {
        return this[$7fb1d234192189b8$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$7fb1d234192189b8$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$7fb1d234192189b8$var$kEnded]) return Promise.resolve($7fb1d234192189b8$var$createIterResult(undefined, true));
        if (this[$7fb1d234192189b8$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $ibaza.nextTick(function() {
                if (_this[$7fb1d234192189b8$var$kError]) reject(_this[$7fb1d234192189b8$var$kError]);
                else resolve($7fb1d234192189b8$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$7fb1d234192189b8$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($7fb1d234192189b8$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$7fb1d234192189b8$var$kStream].read();
            if (data !== null) return Promise.resolve($7fb1d234192189b8$var$createIterResult(data, false));
            promise = new Promise(this[$7fb1d234192189b8$var$kHandlePromise]);
        }
        this[$7fb1d234192189b8$var$kLastPromise] = promise;
        return promise;
    }
}, $7fb1d234192189b8$var$_defineProperty($7fb1d234192189b8$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $7fb1d234192189b8$var$_defineProperty($7fb1d234192189b8$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$7fb1d234192189b8$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($7fb1d234192189b8$var$createIterResult(undefined, true));
        });
    });
}), $7fb1d234192189b8$var$_Object$setPrototypeO), $7fb1d234192189b8$var$AsyncIteratorPrototype);
var $7fb1d234192189b8$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($7fb1d234192189b8$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kStream, {
        value: stream,
        writable: true
    }), $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kLastResolve, {
        value: null,
        writable: true
    }), $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kLastReject, {
        value: null,
        writable: true
    }), $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kError, {
        value: null,
        writable: true
    }), $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $7fb1d234192189b8$var$_defineProperty(_Object$create, $7fb1d234192189b8$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$7fb1d234192189b8$var$kStream].read();
            if (data) {
                iterator[$7fb1d234192189b8$var$kLastPromise] = null;
                iterator[$7fb1d234192189b8$var$kLastResolve] = null;
                iterator[$7fb1d234192189b8$var$kLastReject] = null;
                resolve($7fb1d234192189b8$var$createIterResult(data, false));
            } else {
                iterator[$7fb1d234192189b8$var$kLastResolve] = resolve;
                iterator[$7fb1d234192189b8$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$7fb1d234192189b8$var$kLastPromise] = null;
    $9RUbc(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$7fb1d234192189b8$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$7fb1d234192189b8$var$kLastPromise] = null;
                iterator[$7fb1d234192189b8$var$kLastResolve] = null;
                iterator[$7fb1d234192189b8$var$kLastReject] = null;
                reject(err);
            }
            iterator[$7fb1d234192189b8$var$kError] = err;
            return;
        }
        var resolve = iterator[$7fb1d234192189b8$var$kLastResolve];
        if (resolve !== null) {
            iterator[$7fb1d234192189b8$var$kLastPromise] = null;
            iterator[$7fb1d234192189b8$var$kLastResolve] = null;
            iterator[$7fb1d234192189b8$var$kLastReject] = null;
            resolve($7fb1d234192189b8$var$createIterResult(undefined, true));
        }
        iterator[$7fb1d234192189b8$var$kEnded] = true;
    });
    stream.on("readable", $7fb1d234192189b8$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $7fb1d234192189b8$var$createReadableStreamAsyncIterator;

});
parcelRegister("9RUbc", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $72f4a4664289a3fc$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("7iME2")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $72f4a4664289a3fc$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $72f4a4664289a3fc$var$noop() {}
function $72f4a4664289a3fc$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $72f4a4664289a3fc$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $72f4a4664289a3fc$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $72f4a4664289a3fc$var$once(callback || $72f4a4664289a3fc$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $72f4a4664289a3fc$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $72f4a4664289a3fc$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($72f4a4664289a3fc$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $72f4a4664289a3fc$var$eos;

});


parcelRegister("jseUY", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("bQnl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $89f6a7ddfd9b4da7$var$Transform;

var $7iME2 = parcelRequire("7iME2");
var $89f6a7ddfd9b4da7$require$_require$codes = $7iME2.codes;
var $89f6a7ddfd9b4da7$var$ERR_METHOD_NOT_IMPLEMENTED = $89f6a7ddfd9b4da7$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $89f6a7ddfd9b4da7$var$ERR_MULTIPLE_CALLBACK = $89f6a7ddfd9b4da7$require$_require$codes.ERR_MULTIPLE_CALLBACK, $89f6a7ddfd9b4da7$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $89f6a7ddfd9b4da7$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $89f6a7ddfd9b4da7$var$ERR_TRANSFORM_WITH_LENGTH_0 = $89f6a7ddfd9b4da7$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $2zm4f = parcelRequire("2zm4f");

(parcelRequire("ajIeE"))($89f6a7ddfd9b4da7$var$Transform, $2zm4f);
function $89f6a7ddfd9b4da7$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $89f6a7ddfd9b4da7$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $89f6a7ddfd9b4da7$var$Transform(options) {
    if (!(this instanceof $89f6a7ddfd9b4da7$var$Transform)) return new $89f6a7ddfd9b4da7$var$Transform(options);
    $2zm4f.call(this, options);
    this._transformState = {
        afterTransform: $89f6a7ddfd9b4da7$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $89f6a7ddfd9b4da7$var$prefinish);
}
function $89f6a7ddfd9b4da7$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $89f6a7ddfd9b4da7$var$done(_this, er, data);
    });
    else $89f6a7ddfd9b4da7$var$done(this, null, null);
}
$89f6a7ddfd9b4da7$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2zm4f.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$89f6a7ddfd9b4da7$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $89f6a7ddfd9b4da7$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$89f6a7ddfd9b4da7$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$89f6a7ddfd9b4da7$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$89f6a7ddfd9b4da7$var$Transform.prototype._destroy = function(err, cb) {
    $2zm4f.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $89f6a7ddfd9b4da7$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $89f6a7ddfd9b4da7$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $89f6a7ddfd9b4da7$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("k5VMI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $ea11191edb1967bf$var$PassThrough;

var $bQnl8 = parcelRequire("bQnl8");

(parcelRequire("ajIeE"))($ea11191edb1967bf$var$PassThrough, $bQnl8);
function $ea11191edb1967bf$var$PassThrough(options) {
    if (!(this instanceof $ea11191edb1967bf$var$PassThrough)) return new $ea11191edb1967bf$var$PassThrough(options);
    $bQnl8.call(this, options);
}
$ea11191edb1967bf$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("7iugW", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $5501b248b6c40ce0$var$eos;
function $5501b248b6c40ce0$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $7iME2 = parcelRequire("7iME2");
var $5501b248b6c40ce0$require$_require$codes = $7iME2.codes;
var $5501b248b6c40ce0$var$ERR_MISSING_ARGS = $5501b248b6c40ce0$require$_require$codes.ERR_MISSING_ARGS, $5501b248b6c40ce0$var$ERR_STREAM_DESTROYED = $5501b248b6c40ce0$require$_require$codes.ERR_STREAM_DESTROYED;
function $5501b248b6c40ce0$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $5501b248b6c40ce0$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $5501b248b6c40ce0$var$destroyer(stream, reading, writing, callback) {
    callback = $5501b248b6c40ce0$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($5501b248b6c40ce0$var$eos === undefined) $5501b248b6c40ce0$var$eos = (parcelRequire("9RUbc"));
    $5501b248b6c40ce0$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($5501b248b6c40ce0$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $5501b248b6c40ce0$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $5501b248b6c40ce0$var$call(fn) {
    fn();
}
function $5501b248b6c40ce0$var$pipe(from, to) {
    return from.pipe(to);
}
function $5501b248b6c40ce0$var$popCallback(streams) {
    if (!streams.length) return $5501b248b6c40ce0$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $5501b248b6c40ce0$var$noop;
    return streams.pop();
}
function $5501b248b6c40ce0$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $5501b248b6c40ce0$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $5501b248b6c40ce0$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $5501b248b6c40ce0$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($5501b248b6c40ce0$var$call);
            if (reading) return;
            destroys.forEach($5501b248b6c40ce0$var$call);
            callback(error);
        });
    });
    return streams.reduce($5501b248b6c40ce0$var$pipe);
}
module.exports = $5501b248b6c40ce0$var$pipeline;

});




parcelRegister("c61JU", function(module, exports) {
"use strict";

var $N0o3H = parcelRequire("N0o3H");
var $8ce764fa279e2fd7$require$Buffer = $N0o3H.Buffer;

var $ajIeE = parcelRequire("ajIeE");

var $dH4Vo = parcelRequire("dH4Vo");
var $8ce764fa279e2fd7$var$ARRAY16 = new Array(16);
var $8ce764fa279e2fd7$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8ce764fa279e2fd7$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8ce764fa279e2fd7$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8ce764fa279e2fd7$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8ce764fa279e2fd7$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8ce764fa279e2fd7$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8ce764fa279e2fd7$var$RIPEMD160() {
    $dH4Vo.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$ajIeE($8ce764fa279e2fd7$var$RIPEMD160, $dH4Vo);
$8ce764fa279e2fd7$var$RIPEMD160.prototype._update = function() {
    var words = $8ce764fa279e2fd7$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8ce764fa279e2fd7$var$fn1(al, bl, cl, dl, el, words[$8ce764fa279e2fd7$var$zl[i]], $8ce764fa279e2fd7$var$hl[0], $8ce764fa279e2fd7$var$sl[i]);
            tr = $8ce764fa279e2fd7$var$fn5(ar, br, cr, dr, er, words[$8ce764fa279e2fd7$var$zr[i]], $8ce764fa279e2fd7$var$hr[0], $8ce764fa279e2fd7$var$sr[i]);
        } else if (i < 32) {
            tl = $8ce764fa279e2fd7$var$fn2(al, bl, cl, dl, el, words[$8ce764fa279e2fd7$var$zl[i]], $8ce764fa279e2fd7$var$hl[1], $8ce764fa279e2fd7$var$sl[i]);
            tr = $8ce764fa279e2fd7$var$fn4(ar, br, cr, dr, er, words[$8ce764fa279e2fd7$var$zr[i]], $8ce764fa279e2fd7$var$hr[1], $8ce764fa279e2fd7$var$sr[i]);
        } else if (i < 48) {
            tl = $8ce764fa279e2fd7$var$fn3(al, bl, cl, dl, el, words[$8ce764fa279e2fd7$var$zl[i]], $8ce764fa279e2fd7$var$hl[2], $8ce764fa279e2fd7$var$sl[i]);
            tr = $8ce764fa279e2fd7$var$fn3(ar, br, cr, dr, er, words[$8ce764fa279e2fd7$var$zr[i]], $8ce764fa279e2fd7$var$hr[2], $8ce764fa279e2fd7$var$sr[i]);
        } else if (i < 64) {
            tl = $8ce764fa279e2fd7$var$fn4(al, bl, cl, dl, el, words[$8ce764fa279e2fd7$var$zl[i]], $8ce764fa279e2fd7$var$hl[3], $8ce764fa279e2fd7$var$sl[i]);
            tr = $8ce764fa279e2fd7$var$fn2(ar, br, cr, dr, er, words[$8ce764fa279e2fd7$var$zr[i]], $8ce764fa279e2fd7$var$hr[3], $8ce764fa279e2fd7$var$sr[i]);
        } else {
            tl = $8ce764fa279e2fd7$var$fn5(al, bl, cl, dl, el, words[$8ce764fa279e2fd7$var$zl[i]], $8ce764fa279e2fd7$var$hl[4], $8ce764fa279e2fd7$var$sl[i]);
            tr = $8ce764fa279e2fd7$var$fn1(ar, br, cr, dr, er, words[$8ce764fa279e2fd7$var$zr[i]], $8ce764fa279e2fd7$var$hr[4], $8ce764fa279e2fd7$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8ce764fa279e2fd7$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8ce764fa279e2fd7$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8ce764fa279e2fd7$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8ce764fa279e2fd7$require$Buffer.alloc ? $8ce764fa279e2fd7$require$Buffer.alloc(20) : new $8ce764fa279e2fd7$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $8ce764fa279e2fd7$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8ce764fa279e2fd7$var$fn1(a, b, c, d, e, m, k, s) {
    return $8ce764fa279e2fd7$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8ce764fa279e2fd7$var$fn2(a, b, c, d, e, m, k, s) {
    return $8ce764fa279e2fd7$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8ce764fa279e2fd7$var$fn3(a, b, c, d, e, m, k, s) {
    return $8ce764fa279e2fd7$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8ce764fa279e2fd7$var$fn4(a, b, c, d, e, m, k, s) {
    return $8ce764fa279e2fd7$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8ce764fa279e2fd7$var$fn5(a, b, c, d, e, m, k, s) {
    return $8ce764fa279e2fd7$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $8ce764fa279e2fd7$var$RIPEMD160;

});

parcelRegister("4msE6", function(module, exports) {
var $32cf6ff318045da9$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $32cf6ff318045da9$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$32cf6ff318045da9$var$exports.sha = (parcelRequire("hSBvF"));

$32cf6ff318045da9$var$exports.sha1 = (parcelRequire("gsIOo"));

$32cf6ff318045da9$var$exports.sha224 = (parcelRequire("1cEyb"));

$32cf6ff318045da9$var$exports.sha256 = (parcelRequire("fFIVt"));

$32cf6ff318045da9$var$exports.sha384 = (parcelRequire("gxq4g"));

$32cf6ff318045da9$var$exports.sha512 = (parcelRequire("3CTkn"));

});
parcelRegister("hSBvF", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $ajIeE = parcelRequire("ajIeE");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $d044937444937760$require$Buffer = $fx8YU.Buffer;
var $d044937444937760$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $d044937444937760$var$W = new Array(80);
function $d044937444937760$var$Sha() {
    this.init();
    this._w = $d044937444937760$var$W;
    $j6MlD.call(this, 64, 56);
}
$ajIeE($d044937444937760$var$Sha, $j6MlD);
$d044937444937760$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $d044937444937760$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $d044937444937760$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $d044937444937760$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$d044937444937760$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $d044937444937760$var$rotl5(a) + $d044937444937760$var$ft(s, b, c, d) + e + W[j] + $d044937444937760$var$K[s] | 0;
        e = d;
        d = c;
        c = $d044937444937760$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$d044937444937760$var$Sha.prototype._hash = function() {
    var H = $d044937444937760$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $d044937444937760$var$Sha;

});
parcelRegister("j6MlD", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $de9414c75ad74e74$require$Buffer = $fx8YU.Buffer;
// prototype class for hash functions
function $de9414c75ad74e74$var$Hash(blockSize, finalSize) {
    this._block = $de9414c75ad74e74$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$de9414c75ad74e74$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $de9414c75ad74e74$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$de9414c75ad74e74$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$de9414c75ad74e74$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $de9414c75ad74e74$var$Hash;

});


parcelRegister("gsIOo", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $ajIeE = parcelRequire("ajIeE");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $bfc2058eb2fa3080$require$Buffer = $fx8YU.Buffer;
var $bfc2058eb2fa3080$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bfc2058eb2fa3080$var$W = new Array(80);
function $bfc2058eb2fa3080$var$Sha1() {
    this.init();
    this._w = $bfc2058eb2fa3080$var$W;
    $j6MlD.call(this, 64, 56);
}
$ajIeE($bfc2058eb2fa3080$var$Sha1, $j6MlD);
$bfc2058eb2fa3080$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bfc2058eb2fa3080$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $bfc2058eb2fa3080$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bfc2058eb2fa3080$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bfc2058eb2fa3080$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bfc2058eb2fa3080$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $bfc2058eb2fa3080$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bfc2058eb2fa3080$var$rotl5(a) + $bfc2058eb2fa3080$var$ft(s, b, c, d) + e + W[j] + $bfc2058eb2fa3080$var$K[s] | 0;
        e = d;
        d = c;
        c = $bfc2058eb2fa3080$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bfc2058eb2fa3080$var$Sha1.prototype._hash = function() {
    var H = $bfc2058eb2fa3080$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bfc2058eb2fa3080$var$Sha1;

});

parcelRegister("1cEyb", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $ajIeE = parcelRequire("ajIeE");

var $fFIVt = parcelRequire("fFIVt");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $0e065de23a8a2a41$require$Buffer = $fx8YU.Buffer;
var $0e065de23a8a2a41$var$W = new Array(64);
function $0e065de23a8a2a41$var$Sha224() {
    this.init();
    this._w = $0e065de23a8a2a41$var$W // new Array(64)
    ;
    $j6MlD.call(this, 64, 56);
}
$ajIeE($0e065de23a8a2a41$var$Sha224, $fFIVt);
$0e065de23a8a2a41$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$0e065de23a8a2a41$var$Sha224.prototype._hash = function() {
    var H = $0e065de23a8a2a41$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $0e065de23a8a2a41$var$Sha224;

});
parcelRegister("fFIVt", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $ajIeE = parcelRequire("ajIeE");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $b68d88b2d3e81941$require$Buffer = $fx8YU.Buffer;
var $b68d88b2d3e81941$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $b68d88b2d3e81941$var$W = new Array(64);
function $b68d88b2d3e81941$var$Sha256() {
    this.init();
    this._w = $b68d88b2d3e81941$var$W // new Array(64)
    ;
    $j6MlD.call(this, 64, 56);
}
$ajIeE($b68d88b2d3e81941$var$Sha256, $j6MlD);
$b68d88b2d3e81941$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $b68d88b2d3e81941$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $b68d88b2d3e81941$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $b68d88b2d3e81941$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $b68d88b2d3e81941$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $b68d88b2d3e81941$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $b68d88b2d3e81941$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$b68d88b2d3e81941$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $b68d88b2d3e81941$var$gamma1(W[i - 2]) + W[i - 7] + $b68d88b2d3e81941$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $b68d88b2d3e81941$var$sigma1(e) + $b68d88b2d3e81941$var$ch(e, f, g) + $b68d88b2d3e81941$var$K[j] + W[j] | 0;
        var T2 = $b68d88b2d3e81941$var$sigma0(a) + $b68d88b2d3e81941$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$b68d88b2d3e81941$var$Sha256.prototype._hash = function() {
    var H = $b68d88b2d3e81941$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $b68d88b2d3e81941$var$Sha256;

});


parcelRegister("gxq4g", function(module, exports) {

var $ajIeE = parcelRequire("ajIeE");

var $3CTkn = parcelRequire("3CTkn");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $c0a3f2e7a9eea13f$require$Buffer = $fx8YU.Buffer;
var $c0a3f2e7a9eea13f$var$W = new Array(160);
function $c0a3f2e7a9eea13f$var$Sha384() {
    this.init();
    this._w = $c0a3f2e7a9eea13f$var$W;
    $j6MlD.call(this, 128, 112);
}
$ajIeE($c0a3f2e7a9eea13f$var$Sha384, $3CTkn);
$c0a3f2e7a9eea13f$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$c0a3f2e7a9eea13f$var$Sha384.prototype._hash = function() {
    var H = $c0a3f2e7a9eea13f$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $c0a3f2e7a9eea13f$var$Sha384;

});
parcelRegister("3CTkn", function(module, exports) {

var $ajIeE = parcelRequire("ajIeE");

var $j6MlD = parcelRequire("j6MlD");

var $fx8YU = parcelRequire("fx8YU");
var $2a3fd6a1f0c84e16$require$Buffer = $fx8YU.Buffer;
var $2a3fd6a1f0c84e16$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $2a3fd6a1f0c84e16$var$W = new Array(160);
function $2a3fd6a1f0c84e16$var$Sha512() {
    this.init();
    this._w = $2a3fd6a1f0c84e16$var$W;
    $j6MlD.call(this, 128, 112);
}
$ajIeE($2a3fd6a1f0c84e16$var$Sha512, $j6MlD);
$2a3fd6a1f0c84e16$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $2a3fd6a1f0c84e16$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a3fd6a1f0c84e16$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a3fd6a1f0c84e16$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $2a3fd6a1f0c84e16$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $2a3fd6a1f0c84e16$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $2a3fd6a1f0c84e16$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $2a3fd6a1f0c84e16$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $2a3fd6a1f0c84e16$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $2a3fd6a1f0c84e16$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$2a3fd6a1f0c84e16$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $2a3fd6a1f0c84e16$var$Gamma0(xh, xl);
        var gamma0l = $2a3fd6a1f0c84e16$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $2a3fd6a1f0c84e16$var$Gamma1(xh, xl);
        var gamma1l = $2a3fd6a1f0c84e16$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $2a3fd6a1f0c84e16$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $2a3fd6a1f0c84e16$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $2a3fd6a1f0c84e16$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $2a3fd6a1f0c84e16$var$maj(ah, bh, ch);
        var majl = $2a3fd6a1f0c84e16$var$maj(al, bl, cl);
        var sigma0h = $2a3fd6a1f0c84e16$var$sigma0(ah, al);
        var sigma0l = $2a3fd6a1f0c84e16$var$sigma0(al, ah);
        var sigma1h = $2a3fd6a1f0c84e16$var$sigma1(eh, el);
        var sigma1l = $2a3fd6a1f0c84e16$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $2a3fd6a1f0c84e16$var$K[j];
        var Kil = $2a3fd6a1f0c84e16$var$K[j + 1];
        var chh = $2a3fd6a1f0c84e16$var$Ch(eh, fh, gh);
        var chl = $2a3fd6a1f0c84e16$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $2a3fd6a1f0c84e16$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $2a3fd6a1f0c84e16$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $2a3fd6a1f0c84e16$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $2a3fd6a1f0c84e16$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $2a3fd6a1f0c84e16$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $2a3fd6a1f0c84e16$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $2a3fd6a1f0c84e16$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $2a3fd6a1f0c84e16$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $2a3fd6a1f0c84e16$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $2a3fd6a1f0c84e16$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $2a3fd6a1f0c84e16$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $2a3fd6a1f0c84e16$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $2a3fd6a1f0c84e16$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $2a3fd6a1f0c84e16$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $2a3fd6a1f0c84e16$var$getCarry(this._hl, hl) | 0;
};
$2a3fd6a1f0c84e16$var$Sha512.prototype._hash = function() {
    var H = $2a3fd6a1f0c84e16$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $2a3fd6a1f0c84e16$var$Sha512;

});



parcelRegister("cfJt1", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $8eba27963edd6022$require$Buffer = $fx8YU.Buffer;

var $irUIE = parcelRequire("irUIE");
var $8eba27963edd6022$require$Transform = $irUIE.Transform;

var $jJ0xG = parcelRequire("jJ0xG");
var $8eba27963edd6022$require$StringDecoder = $jJ0xG.StringDecoder;

var $ajIeE = parcelRequire("ajIeE");
function $8eba27963edd6022$var$CipherBase(hashMode) {
    $8eba27963edd6022$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$ajIeE($8eba27963edd6022$var$CipherBase, $8eba27963edd6022$require$Transform);
$8eba27963edd6022$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $8eba27963edd6022$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$8eba27963edd6022$var$CipherBase.prototype.setAutoPadding = function() {};
$8eba27963edd6022$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$8eba27963edd6022$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$8eba27963edd6022$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$8eba27963edd6022$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$8eba27963edd6022$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$8eba27963edd6022$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $8eba27963edd6022$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$8eba27963edd6022$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $8eba27963edd6022$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $8eba27963edd6022$var$CipherBase;

});
parcelRegister("irUIE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6e6bee0ead712e7$var$Stream;

var $9sqfU = parcelRequire("9sqfU");
var $d6e6bee0ead712e7$require$EE = $9sqfU.EventEmitter;

var $ajIeE = parcelRequire("ajIeE");
$ajIeE($d6e6bee0ead712e7$var$Stream, $d6e6bee0ead712e7$require$EE);

$d6e6bee0ead712e7$var$Stream.Readable = (parcelRequire("3FIls"));

$d6e6bee0ead712e7$var$Stream.Writable = (parcelRequire("fBs4s"));

$d6e6bee0ead712e7$var$Stream.Duplex = (parcelRequire("2zm4f"));

$d6e6bee0ead712e7$var$Stream.Transform = (parcelRequire("bQnl8"));

$d6e6bee0ead712e7$var$Stream.PassThrough = (parcelRequire("k5VMI"));

$d6e6bee0ead712e7$var$Stream.finished = (parcelRequire("9RUbc"));

$d6e6bee0ead712e7$var$Stream.pipeline = (parcelRequire("7iugW"));
// Backwards-compat with node 0.4.x
$d6e6bee0ead712e7$var$Stream.Stream = $d6e6bee0ead712e7$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6e6bee0ead712e7$var$Stream() {
    $d6e6bee0ead712e7$require$EE.call(this);
}
$d6e6bee0ead712e7$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6e6bee0ead712e7$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("cWxOP", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $iI6rg = parcelRequire("iI6rg");

var $cfJt1 = parcelRequire("cfJt1");

var $fx8YU = parcelRequire("fx8YU");
var $96c522873a5cb609$require$Buffer = $fx8YU.Buffer;

var $duCUQ = parcelRequire("duCUQ");

var $c61JU = parcelRequire("c61JU");

var $4msE6 = parcelRequire("4msE6");
var $96c522873a5cb609$var$ZEROS = $96c522873a5cb609$require$Buffer.alloc(128);
function $96c522873a5cb609$var$Hmac(alg, key) {
    $cfJt1.call(this, "digest");
    if (typeof key === "string") key = $96c522873a5cb609$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $c61JU() : $4msE6(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $96c522873a5cb609$require$Buffer.concat([
        key,
        $96c522873a5cb609$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $96c522873a5cb609$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $96c522873a5cb609$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $c61JU() : $4msE6(alg);
    this._hash.update(ipad);
}
$ajIeE($96c522873a5cb609$var$Hmac, $cfJt1);
$96c522873a5cb609$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$96c522873a5cb609$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $c61JU() : $4msE6(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $96c522873a5cb609$var$Hmac("rmd160", key);
    if (alg === "md5") return new $iI6rg($duCUQ, key);
    return new $96c522873a5cb609$var$Hmac(alg, key);
};

});
parcelRegister("iI6rg", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $fx8YU = parcelRequire("fx8YU");
var $d9f154a6e41a1c65$require$Buffer = $fx8YU.Buffer;

var $cfJt1 = parcelRequire("cfJt1");
var $d9f154a6e41a1c65$var$ZEROS = $d9f154a6e41a1c65$require$Buffer.alloc(128);
var $d9f154a6e41a1c65$var$blocksize = 64;
function $d9f154a6e41a1c65$var$Hmac(alg, key) {
    $cfJt1.call(this, "digest");
    if (typeof key === "string") key = $d9f154a6e41a1c65$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $d9f154a6e41a1c65$var$blocksize) key = alg(key);
    else if (key.length < $d9f154a6e41a1c65$var$blocksize) key = $d9f154a6e41a1c65$require$Buffer.concat([
        key,
        $d9f154a6e41a1c65$var$ZEROS
    ], $d9f154a6e41a1c65$var$blocksize);
    var ipad = this._ipad = $d9f154a6e41a1c65$require$Buffer.allocUnsafe($d9f154a6e41a1c65$var$blocksize);
    var opad = this._opad = $d9f154a6e41a1c65$require$Buffer.allocUnsafe($d9f154a6e41a1c65$var$blocksize);
    for(var i = 0; i < $d9f154a6e41a1c65$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$ajIeE($d9f154a6e41a1c65$var$Hmac, $cfJt1);
$d9f154a6e41a1c65$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$d9f154a6e41a1c65$var$Hmac.prototype._final = function() {
    var h = this._alg($d9f154a6e41a1c65$require$Buffer.concat(this._hash));
    return this._alg($d9f154a6e41a1c65$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $d9f154a6e41a1c65$var$Hmac;

});

parcelRegister("duCUQ", function(module, exports) {

var $bHoGp = parcelRequire("bHoGp");
module.exports = function(buffer) {
    return new $bHoGp().update(buffer).digest();
};

});



parcelRegister("kfzoe", function(module, exports) {
"use strict";

var $5dKmo = parcelRequire("5dKmo");

var $cjzdT = parcelRequire("cjzdT");
// SHA256(SHA256(buffer))
function $ebe0a906333de430$var$sha256x2(buffer) {
    var tmp = $5dKmo("sha256").update(buffer).digest();
    return $5dKmo("sha256").update(tmp).digest();
}
module.exports = $cjzdT($ebe0a906333de430$var$sha256x2);

});
parcelRegister("cjzdT", function(module, exports) {
"use strict";

var $edavl = parcelRequire("edavl");

var $fx8YU = parcelRequire("fx8YU");
var $8f7294edfdafdebd$require$Buffer = $fx8YU.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $edavl.encode($8f7294edfdafdebd$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $edavl.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $edavl.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("edavl", function(module, exports) {

var $fq3eW = parcelRequire("fq3eW");
var $a58a6d91d9c648ad$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $fq3eW($a58a6d91d9c648ad$var$ALPHABET);

});
parcelRegister("fq3eW", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $b39bcc183b73bed5$require$_Buffer = $fx8YU.Buffer;
function $b39bcc183b73bed5$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $b39bcc183b73bed5$require$_Buffer.from(source);
        if (!$b39bcc183b73bed5$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $b39bcc183b73bed5$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $b39bcc183b73bed5$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $b39bcc183b73bed5$var$base;

});




parcelRegister("didLZ", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $9ad7a3d17c0496ad$require$Buffer = $N0o3H.Buffer;

var $jCiTy = parcelRequire("jCiTy");

var $7kgn0 = parcelRequire("7kgn0");
var $9ad7a3d17c0496ad$require$EC = $7kgn0.ec;
const $9ad7a3d17c0496ad$var$secp256k1 = new $9ad7a3d17c0496ad$require$EC("secp256k1");

var $jSrFg = parcelRequire("jSrFg");
const $9ad7a3d17c0496ad$var$ZERO32 = $9ad7a3d17c0496ad$require$Buffer.alloc(32, 0);
const $9ad7a3d17c0496ad$var$EC_GROUP_ORDER = $9ad7a3d17c0496ad$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $9ad7a3d17c0496ad$var$EC_P = $9ad7a3d17c0496ad$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $9ad7a3d17c0496ad$var$n = $9ad7a3d17c0496ad$var$secp256k1.curve.n;
const $9ad7a3d17c0496ad$var$nDiv2 = $9ad7a3d17c0496ad$var$n.shrn(1);
const $9ad7a3d17c0496ad$var$G = $9ad7a3d17c0496ad$var$secp256k1.curve.g;
const $9ad7a3d17c0496ad$var$THROW_BAD_PRIVATE = "Expected Private";
const $9ad7a3d17c0496ad$var$THROW_BAD_POINT = "Expected Point";
const $9ad7a3d17c0496ad$var$THROW_BAD_TWEAK = "Expected Tweak";
const $9ad7a3d17c0496ad$var$THROW_BAD_HASH = "Expected Hash";
const $9ad7a3d17c0496ad$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $9ad7a3d17c0496ad$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $9ad7a3d17c0496ad$var$isScalar(x) {
    return $9ad7a3d17c0496ad$require$Buffer.isBuffer(x) && x.length === 32;
}
function $9ad7a3d17c0496ad$var$isOrderScalar(x) {
    if (!$9ad7a3d17c0496ad$var$isScalar(x)) return false;
    return x.compare($9ad7a3d17c0496ad$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $9ad7a3d17c0496ad$var$isPoint(p) {
    if (!$9ad7a3d17c0496ad$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($9ad7a3d17c0496ad$var$ZERO32) === 0) return false;
    if (x.compare($9ad7a3d17c0496ad$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $9ad7a3d17c0496ad$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($9ad7a3d17c0496ad$var$ZERO32) === 0) return false;
    if (y.compare($9ad7a3d17c0496ad$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $9ad7a3d17c0496ad$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $9ad7a3d17c0496ad$var$isPointCompressed(p) {
    if (!$9ad7a3d17c0496ad$var$isPoint(p)) return false;
    return $9ad7a3d17c0496ad$var$__isPointCompressed(p);
}
function $9ad7a3d17c0496ad$var$isPrivate(x) {
    if (!$9ad7a3d17c0496ad$var$isScalar(x)) return false;
    return x.compare($9ad7a3d17c0496ad$var$ZERO32) > 0 && // > 0
    x.compare($9ad7a3d17c0496ad$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $9ad7a3d17c0496ad$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $9ad7a3d17c0496ad$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($9ad7a3d17c0496ad$var$EC_GROUP_ORDER) < 0 && s.compare($9ad7a3d17c0496ad$var$EC_GROUP_ORDER) < 0;
}
function $9ad7a3d17c0496ad$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $9ad7a3d17c0496ad$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $9ad7a3d17c0496ad$var$fromBuffer(d) {
    return new $jCiTy(d);
}
function $9ad7a3d17c0496ad$var$toBuffer(d) {
    return d.toArrayLike($9ad7a3d17c0496ad$require$Buffer, "be", 32);
}
function $9ad7a3d17c0496ad$var$decodeFrom(P) {
    return $9ad7a3d17c0496ad$var$secp256k1.curve.decodePoint(P);
}
function $9ad7a3d17c0496ad$var$getEncoded(P, compressed) {
    return $9ad7a3d17c0496ad$require$Buffer.from(P._encode(compressed));
}
function $9ad7a3d17c0496ad$var$pointAdd(pA, pB, __compressed) {
    if (!$9ad7a3d17c0496ad$var$isPoint(pA)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    if (!$9ad7a3d17c0496ad$var$isPoint(pB)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    const a = $9ad7a3d17c0496ad$var$decodeFrom(pA);
    const b = $9ad7a3d17c0496ad$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $9ad7a3d17c0496ad$var$assumeCompression(__compressed, pA);
    return $9ad7a3d17c0496ad$var$getEncoded(pp, compressed);
}
function $9ad7a3d17c0496ad$var$pointAddScalar(p, tweak, __compressed) {
    if (!$9ad7a3d17c0496ad$var$isPoint(p)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    if (!$9ad7a3d17c0496ad$var$isOrderScalar(tweak)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_TWEAK);
    const compressed = $9ad7a3d17c0496ad$var$assumeCompression(__compressed, p);
    const pp = $9ad7a3d17c0496ad$var$decodeFrom(p);
    if (tweak.compare($9ad7a3d17c0496ad$var$ZERO32) === 0) return $9ad7a3d17c0496ad$var$getEncoded(pp, compressed);
    const tt = $9ad7a3d17c0496ad$var$fromBuffer(tweak);
    const qq = $9ad7a3d17c0496ad$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $9ad7a3d17c0496ad$var$getEncoded(uu, compressed);
}
function $9ad7a3d17c0496ad$var$pointCompress(p, __compressed) {
    if (!$9ad7a3d17c0496ad$var$isPoint(p)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    const pp = $9ad7a3d17c0496ad$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    const compressed = $9ad7a3d17c0496ad$var$assumeCompression(__compressed, p);
    return $9ad7a3d17c0496ad$var$getEncoded(pp, compressed);
}
function $9ad7a3d17c0496ad$var$pointFromScalar(d, __compressed) {
    if (!$9ad7a3d17c0496ad$var$isPrivate(d)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_PRIVATE);
    const dd = $9ad7a3d17c0496ad$var$fromBuffer(d);
    const pp = $9ad7a3d17c0496ad$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $9ad7a3d17c0496ad$var$assumeCompression(__compressed);
    return $9ad7a3d17c0496ad$var$getEncoded(pp, compressed);
}
function $9ad7a3d17c0496ad$var$pointMultiply(p, tweak, __compressed) {
    if (!$9ad7a3d17c0496ad$var$isPoint(p)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    if (!$9ad7a3d17c0496ad$var$isOrderScalar(tweak)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_TWEAK);
    const compressed = $9ad7a3d17c0496ad$var$assumeCompression(__compressed, p);
    const pp = $9ad7a3d17c0496ad$var$decodeFrom(p);
    const tt = $9ad7a3d17c0496ad$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $9ad7a3d17c0496ad$var$getEncoded(qq, compressed);
}
function $9ad7a3d17c0496ad$var$privateAdd(d, tweak) {
    if (!$9ad7a3d17c0496ad$var$isPrivate(d)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_PRIVATE);
    if (!$9ad7a3d17c0496ad$var$isOrderScalar(tweak)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_TWEAK);
    const dd = $9ad7a3d17c0496ad$var$fromBuffer(d);
    const tt = $9ad7a3d17c0496ad$var$fromBuffer(tweak);
    const dt = $9ad7a3d17c0496ad$var$toBuffer(dd.add(tt).umod($9ad7a3d17c0496ad$var$n));
    if (!$9ad7a3d17c0496ad$var$isPrivate(dt)) return null;
    return dt;
}
function $9ad7a3d17c0496ad$var$privateSub(d, tweak) {
    if (!$9ad7a3d17c0496ad$var$isPrivate(d)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_PRIVATE);
    if (!$9ad7a3d17c0496ad$var$isOrderScalar(tweak)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_TWEAK);
    const dd = $9ad7a3d17c0496ad$var$fromBuffer(d);
    const tt = $9ad7a3d17c0496ad$var$fromBuffer(tweak);
    const dt = $9ad7a3d17c0496ad$var$toBuffer(dd.sub(tt).umod($9ad7a3d17c0496ad$var$n));
    if (!$9ad7a3d17c0496ad$var$isPrivate(dt)) return null;
    return dt;
}
function $9ad7a3d17c0496ad$var$sign(hash, x) {
    return $9ad7a3d17c0496ad$var$__sign(hash, x);
}
function $9ad7a3d17c0496ad$var$signWithEntropy(hash, x, addData) {
    return $9ad7a3d17c0496ad$var$__sign(hash, x, addData);
}
function $9ad7a3d17c0496ad$var$__sign(hash, x, addData) {
    if (!$9ad7a3d17c0496ad$var$isScalar(hash)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_HASH);
    if (!$9ad7a3d17c0496ad$var$isPrivate(x)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$9ad7a3d17c0496ad$var$isScalar(addData)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_EXTRA_DATA);
    const d = $9ad7a3d17c0496ad$var$fromBuffer(x);
    const e = $9ad7a3d17c0496ad$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $9ad7a3d17c0496ad$var$fromBuffer(k);
        const Q = $9ad7a3d17c0496ad$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($9ad7a3d17c0496ad$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($9ad7a3d17c0496ad$var$n).mul(e.add(d.mul(r))).umod($9ad7a3d17c0496ad$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $jSrFg(hash, x, checkSig, $9ad7a3d17c0496ad$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($9ad7a3d17c0496ad$var$nDiv2) > 0) s = $9ad7a3d17c0496ad$var$n.sub(s);
    const buffer = $9ad7a3d17c0496ad$require$Buffer.allocUnsafe(64);
    $9ad7a3d17c0496ad$var$toBuffer(r).copy(buffer, 0);
    $9ad7a3d17c0496ad$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $9ad7a3d17c0496ad$var$verify(hash, q, signature, strict) {
    if (!$9ad7a3d17c0496ad$var$isScalar(hash)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_HASH);
    if (!$9ad7a3d17c0496ad$var$isPoint(q)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$9ad7a3d17c0496ad$var$isSignature(signature)) throw new TypeError($9ad7a3d17c0496ad$var$THROW_BAD_SIGNATURE);
    const Q = $9ad7a3d17c0496ad$var$decodeFrom(q);
    const r = $9ad7a3d17c0496ad$var$fromBuffer(signature.slice(0, 32));
    const s = $9ad7a3d17c0496ad$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($9ad7a3d17c0496ad$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $9ad7a3d17c0496ad$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($9ad7a3d17c0496ad$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($9ad7a3d17c0496ad$var$n);
    const u2 = r.mul(sInv).umod($9ad7a3d17c0496ad$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $9ad7a3d17c0496ad$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($9ad7a3d17c0496ad$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $9ad7a3d17c0496ad$var$isPoint,
    isPointCompressed: $9ad7a3d17c0496ad$var$isPointCompressed,
    isPrivate: $9ad7a3d17c0496ad$var$isPrivate,
    pointAdd: $9ad7a3d17c0496ad$var$pointAdd,
    pointAddScalar: $9ad7a3d17c0496ad$var$pointAddScalar,
    pointCompress: $9ad7a3d17c0496ad$var$pointCompress,
    pointFromScalar: $9ad7a3d17c0496ad$var$pointFromScalar,
    pointMultiply: $9ad7a3d17c0496ad$var$pointMultiply,
    privateAdd: $9ad7a3d17c0496ad$var$privateAdd,
    privateSub: $9ad7a3d17c0496ad$var$privateSub,
    sign: $9ad7a3d17c0496ad$var$sign,
    signWithEntropy: $9ad7a3d17c0496ad$var$signWithEntropy,
    verify: $9ad7a3d17c0496ad$var$verify
};

});
parcelRegister("jCiTy", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7kgn0", function(module, exports) {
"use strict";
var $55571963976dc5f0$var$elliptic = module.exports;

$55571963976dc5f0$var$elliptic.version = (parcelRequire("iQA2x")).version;

$55571963976dc5f0$var$elliptic.utils = (parcelRequire("36pBX"));

$55571963976dc5f0$var$elliptic.rand = (parcelRequire("2iwIf"));

$55571963976dc5f0$var$elliptic.curve = (parcelRequire("44ON9"));

$55571963976dc5f0$var$elliptic.curves = (parcelRequire("izsNn"));

// Protocols
$55571963976dc5f0$var$elliptic.ec = (parcelRequire("1WfU3"));

$55571963976dc5f0$var$elliptic.eddsa = (parcelRequire("92zjz"));

});
parcelRegister("iQA2x", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("36pBX", function(module, exports) {
"use strict";
var $2425cc77e9f342ae$var$utils = module.exports;

var $bk4ev = parcelRequire("bk4ev");

var $i1Wrq = parcelRequire("i1Wrq");

var $fg9XS = parcelRequire("fg9XS");
$2425cc77e9f342ae$var$utils.assert = $i1Wrq;
$2425cc77e9f342ae$var$utils.toArray = $fg9XS.toArray;
$2425cc77e9f342ae$var$utils.zero2 = $fg9XS.zero2;
$2425cc77e9f342ae$var$utils.toHex = $fg9XS.toHex;
$2425cc77e9f342ae$var$utils.encode = $fg9XS.encode;
// Represent num in a w-NAF form
function $2425cc77e9f342ae$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$2425cc77e9f342ae$var$utils.getNAF = $2425cc77e9f342ae$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $2425cc77e9f342ae$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$2425cc77e9f342ae$var$utils.getJSF = $2425cc77e9f342ae$var$getJSF;
function $2425cc77e9f342ae$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$2425cc77e9f342ae$var$utils.cachedProperty = $2425cc77e9f342ae$var$cachedProperty;
function $2425cc77e9f342ae$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $2425cc77e9f342ae$var$utils.toArray(bytes, "hex") : bytes;
}
$2425cc77e9f342ae$var$utils.parseBytes = $2425cc77e9f342ae$var$parseBytes;
function $2425cc77e9f342ae$var$intFromLE(bytes) {
    return new $bk4ev(bytes, "hex", "le");
}
$2425cc77e9f342ae$var$utils.intFromLE = $2425cc77e9f342ae$var$intFromLE;

});
parcelRegister("bk4ev", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("i1Wrq", function(module, exports) {
module.exports = $d205a7337b0d47dd$var$assert;
function $d205a7337b0d47dd$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$d205a7337b0d47dd$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("fg9XS", function(module, exports) {
"use strict";
var $b1c0146f37a72dc0$var$utils = module.exports;
function $b1c0146f37a72dc0$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$b1c0146f37a72dc0$var$utils.toArray = $b1c0146f37a72dc0$var$toArray;
function $b1c0146f37a72dc0$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$b1c0146f37a72dc0$var$utils.zero2 = $b1c0146f37a72dc0$var$zero2;
function $b1c0146f37a72dc0$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $b1c0146f37a72dc0$var$zero2(msg[i].toString(16));
    return res;
}
$b1c0146f37a72dc0$var$utils.toHex = $b1c0146f37a72dc0$var$toHex;
$b1c0146f37a72dc0$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $b1c0146f37a72dc0$var$toHex(arr);
    else return arr;
};

});


parcelRegister("2iwIf", function(module, exports) {
var $1ac6a343ba01bd4f$var$r;
module.exports = function rand(len) {
    if (!$1ac6a343ba01bd4f$var$r) $1ac6a343ba01bd4f$var$r = new $1ac6a343ba01bd4f$var$Rand(null);
    return $1ac6a343ba01bd4f$var$r.generate(len);
};
function $1ac6a343ba01bd4f$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $1ac6a343ba01bd4f$var$Rand;
$1ac6a343ba01bd4f$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $1ac6a343ba01bd4f$var$crypto = (parcelRequire("foUwZ"));
    if (typeof $1ac6a343ba01bd4f$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $1ac6a343ba01bd4f$var$Rand.prototype._rand = function _rand(n) {
        return $1ac6a343ba01bd4f$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("44ON9", function(module, exports) {
"use strict";
var $2f7eef4f46648465$var$curve = module.exports;

$2f7eef4f46648465$var$curve.base = (parcelRequire("6dmRQ"));

$2f7eef4f46648465$var$curve.short = (parcelRequire("5aw4j"));

$2f7eef4f46648465$var$curve.mont = (parcelRequire("lkVI7"));

$2f7eef4f46648465$var$curve.edwards = (parcelRequire("9Luck"));

});
parcelRegister("6dmRQ", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $36pBX = parcelRequire("36pBX");
var $4865b1fb7dacdcbc$var$getNAF = $36pBX.getNAF;
var $4865b1fb7dacdcbc$var$getJSF = $36pBX.getJSF;
var $4865b1fb7dacdcbc$var$assert = $36pBX.assert;
function $4865b1fb7dacdcbc$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $bk4ev(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $bk4ev.red(conf.prime) : $bk4ev.mont(this.p);
    // Useful for many curves
    this.zero = new $bk4ev(0).toRed(this.red);
    this.one = new $bk4ev(1).toRed(this.red);
    this.two = new $bk4ev(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $bk4ev(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $4865b1fb7dacdcbc$var$BaseCurve;
$4865b1fb7dacdcbc$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $4865b1fb7dacdcbc$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $4865b1fb7dacdcbc$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $4865b1fb7dacdcbc$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $4865b1fb7dacdcbc$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $4865b1fb7dacdcbc$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $4865b1fb7dacdcbc$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $4865b1fb7dacdcbc$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $4865b1fb7dacdcbc$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$4865b1fb7dacdcbc$var$BaseCurve.BasePoint = $4865b1fb7dacdcbc$var$BasePoint;
$4865b1fb7dacdcbc$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$4865b1fb7dacdcbc$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $36pBX.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $4865b1fb7dacdcbc$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $4865b1fb7dacdcbc$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $36pBX.encode(this._encode(compact), enc);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$4865b1fb7dacdcbc$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$4865b1fb7dacdcbc$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("5aw4j", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");

var $bk4ev = parcelRequire("bk4ev");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");
var $3c36c310abdf7c1b$var$assert = $36pBX.assert;
function $3c36c310abdf7c1b$var$ShortCurve(conf) {
    $6dmRQ.call(this, "short", conf);
    this.a = new $bk4ev(conf.a, 16).toRed(this.red);
    this.b = new $bk4ev(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$ajIeE($3c36c310abdf7c1b$var$ShortCurve, $6dmRQ);
module.exports = $3c36c310abdf7c1b$var$ShortCurve;
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $bk4ev(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $bk4ev(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $3c36c310abdf7c1b$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $bk4ev(vec.a, 16),
            b: new $bk4ev(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $bk4ev.mont(num);
    var tinv = new $bk4ev(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $bk4ev(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $bk4ev(1);
    var y1 = new $bk4ev(0);
    var x2 = new $bk4ev(0);
    var y2 = new $bk4ev(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $bk4ev(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$3c36c310abdf7c1b$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $3c36c310abdf7c1b$var$Point(curve, x, y, isRed) {
    $6dmRQ.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $bk4ev(x, 16);
        this.y = new $bk4ev(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$ajIeE($3c36c310abdf7c1b$var$Point, $6dmRQ.BasePoint);
$3c36c310abdf7c1b$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $3c36c310abdf7c1b$var$Point(this, x, y, isRed);
};
$3c36c310abdf7c1b$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $3c36c310abdf7c1b$var$Point.fromJSON(this, obj, red);
};
$3c36c310abdf7c1b$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$3c36c310abdf7c1b$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$3c36c310abdf7c1b$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$3c36c310abdf7c1b$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$3c36c310abdf7c1b$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$3c36c310abdf7c1b$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$3c36c310abdf7c1b$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$3c36c310abdf7c1b$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$3c36c310abdf7c1b$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$3c36c310abdf7c1b$var$Point.prototype.mul = function mul(k) {
    k = new $bk4ev(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$3c36c310abdf7c1b$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$3c36c310abdf7c1b$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$3c36c310abdf7c1b$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$3c36c310abdf7c1b$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$3c36c310abdf7c1b$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $3c36c310abdf7c1b$var$JPoint(curve, x, y, z) {
    $6dmRQ.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $bk4ev(0);
    } else {
        this.x = new $bk4ev(x, 16);
        this.y = new $bk4ev(y, 16);
        this.z = new $bk4ev(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$ajIeE($3c36c310abdf7c1b$var$JPoint, $6dmRQ.BasePoint);
$3c36c310abdf7c1b$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $3c36c310abdf7c1b$var$JPoint(this, x, y, z);
};
$3c36c310abdf7c1b$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$3c36c310abdf7c1b$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$3c36c310abdf7c1b$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$3c36c310abdf7c1b$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$3c36c310abdf7c1b$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $bk4ev(k, kbase);
    return this.curve._wnafMul(this, k);
};
$3c36c310abdf7c1b$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$3c36c310abdf7c1b$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$3c36c310abdf7c1b$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$3c36c310abdf7c1b$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("lkVI7", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");

var $36pBX = parcelRequire("36pBX");
function $f8883b579039ee41$var$MontCurve(conf) {
    $6dmRQ.call(this, "mont", conf);
    this.a = new $bk4ev(conf.a, 16).toRed(this.red);
    this.b = new $bk4ev(conf.b, 16).toRed(this.red);
    this.i4 = new $bk4ev(4).toRed(this.red).redInvm();
    this.two = new $bk4ev(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$ajIeE($f8883b579039ee41$var$MontCurve, $6dmRQ);
module.exports = $f8883b579039ee41$var$MontCurve;
$f8883b579039ee41$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $f8883b579039ee41$var$Point(curve, x, z) {
    $6dmRQ.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $bk4ev(x, 16);
        this.z = new $bk4ev(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$ajIeE($f8883b579039ee41$var$Point, $6dmRQ.BasePoint);
$f8883b579039ee41$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($36pBX.toArray(bytes, enc), 1);
};
$f8883b579039ee41$var$MontCurve.prototype.point = function point(x, z) {
    return new $f8883b579039ee41$var$Point(this, x, z);
};
$f8883b579039ee41$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $f8883b579039ee41$var$Point.fromJSON(this, obj);
};
$f8883b579039ee41$var$Point.prototype.precompute = function precompute() {
// No-op
};
$f8883b579039ee41$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$f8883b579039ee41$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $f8883b579039ee41$var$Point(curve, obj[0], obj[1] || curve.one);
};
$f8883b579039ee41$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$f8883b579039ee41$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$f8883b579039ee41$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$f8883b579039ee41$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$f8883b579039ee41$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$f8883b579039ee41$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$f8883b579039ee41$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$f8883b579039ee41$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$f8883b579039ee41$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("9Luck", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");

var $bk4ev = parcelRequire("bk4ev");

var $ajIeE = parcelRequire("ajIeE");

var $6dmRQ = parcelRequire("6dmRQ");
var $71bfed7d2474acbf$var$assert = $36pBX.assert;
function $71bfed7d2474acbf$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $6dmRQ.call(this, "edwards", conf);
    this.a = new $bk4ev(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $bk4ev(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $bk4ev(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $71bfed7d2474acbf$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$ajIeE($71bfed7d2474acbf$var$EdwardsCurve, $6dmRQ);
module.exports = $71bfed7d2474acbf$var$EdwardsCurve;
$71bfed7d2474acbf$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$71bfed7d2474acbf$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $bk4ev(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $bk4ev(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $71bfed7d2474acbf$var$Point(curve, x, y, z, t) {
    $6dmRQ.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $bk4ev(x, 16);
        this.y = new $bk4ev(y, 16);
        this.z = z ? new $bk4ev(z, 16) : this.curve.one;
        this.t = t && new $bk4ev(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$ajIeE($71bfed7d2474acbf$var$Point, $6dmRQ.BasePoint);
$71bfed7d2474acbf$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $71bfed7d2474acbf$var$Point.fromJSON(this, obj);
};
$71bfed7d2474acbf$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $71bfed7d2474acbf$var$Point(this, x, y, z, t);
};
$71bfed7d2474acbf$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $71bfed7d2474acbf$var$Point(curve, obj[0], obj[1], obj[2]);
};
$71bfed7d2474acbf$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$71bfed7d2474acbf$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$71bfed7d2474acbf$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$71bfed7d2474acbf$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$71bfed7d2474acbf$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$71bfed7d2474acbf$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$71bfed7d2474acbf$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$71bfed7d2474acbf$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$71bfed7d2474acbf$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$71bfed7d2474acbf$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$71bfed7d2474acbf$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$71bfed7d2474acbf$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$71bfed7d2474acbf$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$71bfed7d2474acbf$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$71bfed7d2474acbf$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$71bfed7d2474acbf$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$71bfed7d2474acbf$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$71bfed7d2474acbf$var$Point.prototype.toP = $71bfed7d2474acbf$var$Point.prototype.normalize;
$71bfed7d2474acbf$var$Point.prototype.mixedAdd = $71bfed7d2474acbf$var$Point.prototype.add;

});


parcelRegister("izsNn", function(module, exports) {
"use strict";
var $d851d50bfb4785eb$var$curves = module.exports;

var $dyCsH = parcelRequire("dyCsH");

var $44ON9 = parcelRequire("44ON9");

var $36pBX = parcelRequire("36pBX");
var $d851d50bfb4785eb$var$assert = $36pBX.assert;
function $d851d50bfb4785eb$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $44ON9.short(options);
    else if (options.type === "edwards") this.curve = new $44ON9.edwards(options);
    else this.curve = new $44ON9.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $d851d50bfb4785eb$var$assert(this.g.validate(), "Invalid curve");
    $d851d50bfb4785eb$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$d851d50bfb4785eb$var$curves.PresetCurve = $d851d50bfb4785eb$var$PresetCurve;
function $d851d50bfb4785eb$var$defineCurve(name, options) {
    Object.defineProperty($d851d50bfb4785eb$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $d851d50bfb4785eb$var$PresetCurve(options);
            Object.defineProperty($d851d50bfb4785eb$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$d851d50bfb4785eb$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $dyCsH.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$d851d50bfb4785eb$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $dyCsH.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$d851d50bfb4785eb$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$d851d50bfb4785eb$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $dyCsH.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $d851d50bfb4785eb$var$pre;

try {
    $d851d50bfb4785eb$var$pre = (parcelRequire("apL0e"));
} catch (e) {
    $d851d50bfb4785eb$var$pre = undefined;
}
$d851d50bfb4785eb$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $dyCsH.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $d851d50bfb4785eb$var$pre
    ]
});

});
parcelRegister("dyCsH", function(module, exports) {
var $9dec490f984e8399$var$hash = module.exports;

$9dec490f984e8399$var$hash.utils = (parcelRequire("47Ha9"));

$9dec490f984e8399$var$hash.common = (parcelRequire("dkCMM"));

$9dec490f984e8399$var$hash.sha = (parcelRequire("9KjOr"));

$9dec490f984e8399$var$hash.ripemd = (parcelRequire("6xYCQ"));

$9dec490f984e8399$var$hash.hmac = (parcelRequire("2W6lw"));
// Proxy hash functions to the main object
$9dec490f984e8399$var$hash.sha1 = $9dec490f984e8399$var$hash.sha.sha1;
$9dec490f984e8399$var$hash.sha256 = $9dec490f984e8399$var$hash.sha.sha256;
$9dec490f984e8399$var$hash.sha224 = $9dec490f984e8399$var$hash.sha.sha224;
$9dec490f984e8399$var$hash.sha384 = $9dec490f984e8399$var$hash.sha.sha384;
$9dec490f984e8399$var$hash.sha512 = $9dec490f984e8399$var$hash.sha.sha512;
$9dec490f984e8399$var$hash.ripemd160 = $9dec490f984e8399$var$hash.ripemd.ripemd160;

});
parcelRegister("47Ha9", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $30094c111d7673fd$export$69f1b2dcda23c5f8, (v) => $30094c111d7673fd$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $30094c111d7673fd$export$45b10814cc054894, (v) => $30094c111d7673fd$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $30094c111d7673fd$export$7ea66e3774a60b67, (v) => $30094c111d7673fd$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $30094c111d7673fd$export$34a52f00f601f6f1, (v) => $30094c111d7673fd$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $30094c111d7673fd$export$812b0cbd5e8a72ab, (v) => $30094c111d7673fd$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $30094c111d7673fd$export$f24f9e11d63bb314, (v) => $30094c111d7673fd$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $30094c111d7673fd$export$b71357c7e07ca1f1, (v) => $30094c111d7673fd$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $30094c111d7673fd$export$2e58a4b541fdcbe8, (v) => $30094c111d7673fd$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $30094c111d7673fd$export$183b950bde9faab8, (v) => $30094c111d7673fd$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $30094c111d7673fd$export$4785c77169fea59e, (v) => $30094c111d7673fd$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $30094c111d7673fd$export$242a185dfcffac5b, (v) => $30094c111d7673fd$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $30094c111d7673fd$export$58c04ae0ae31877d, (v) => $30094c111d7673fd$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $30094c111d7673fd$export$d058ca695f8c6f11, (v) => $30094c111d7673fd$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $30094c111d7673fd$export$a1efd7fc3e986367, (v) => $30094c111d7673fd$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $30094c111d7673fd$export$bbfea4a2b5abaab4, (v) => $30094c111d7673fd$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $30094c111d7673fd$export$97ad4afc7de86152, (v) => $30094c111d7673fd$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $30094c111d7673fd$export$ce4673d9a79f6a4b, (v) => $30094c111d7673fd$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $30094c111d7673fd$export$786cc99fc6eedc0b, (v) => $30094c111d7673fd$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $30094c111d7673fd$export$45c59b9a1848dd0, (v) => $30094c111d7673fd$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $30094c111d7673fd$export$50d8f613e76d3034, (v) => $30094c111d7673fd$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $30094c111d7673fd$export$b8e83683c60ee162, (v) => $30094c111d7673fd$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $30094c111d7673fd$export$aeeb51790d1bcc4a, (v) => $30094c111d7673fd$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $30094c111d7673fd$export$bb7c616f719ad9c, (v) => $30094c111d7673fd$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $30094c111d7673fd$export$4d63290824f9d7df, (v) => $30094c111d7673fd$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $30094c111d7673fd$export$2f64ceb90ef28ea1, (v) => $30094c111d7673fd$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $30094c111d7673fd$export$8d2089d465f6d10d, (v) => $30094c111d7673fd$export$8d2089d465f6d10d = v);
var $30094c111d7673fd$export$69f1b2dcda23c5f8;
var $30094c111d7673fd$export$45b10814cc054894;
var $30094c111d7673fd$export$7ea66e3774a60b67;
var $30094c111d7673fd$export$34a52f00f601f6f1;
var $30094c111d7673fd$export$812b0cbd5e8a72ab;
var $30094c111d7673fd$export$f24f9e11d63bb314;
var $30094c111d7673fd$export$b71357c7e07ca1f1;
var $30094c111d7673fd$export$2e58a4b541fdcbe8;
var $30094c111d7673fd$export$183b950bde9faab8;
var $30094c111d7673fd$export$4785c77169fea59e;
var $30094c111d7673fd$export$242a185dfcffac5b;
var $30094c111d7673fd$export$58c04ae0ae31877d;
var $30094c111d7673fd$export$d058ca695f8c6f11;
var $30094c111d7673fd$export$a1efd7fc3e986367;
var $30094c111d7673fd$export$bbfea4a2b5abaab4;
var $30094c111d7673fd$export$97ad4afc7de86152;
var $30094c111d7673fd$export$ce4673d9a79f6a4b;
var $30094c111d7673fd$export$786cc99fc6eedc0b;
var $30094c111d7673fd$export$45c59b9a1848dd0;
var $30094c111d7673fd$export$50d8f613e76d3034;
var $30094c111d7673fd$export$b8e83683c60ee162;
var $30094c111d7673fd$export$aeeb51790d1bcc4a;
var $30094c111d7673fd$export$bb7c616f719ad9c;
var $30094c111d7673fd$export$4d63290824f9d7df;
var $30094c111d7673fd$export$2f64ceb90ef28ea1;
var $30094c111d7673fd$export$8d2089d465f6d10d;
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");

var $ajIeE = parcelRequire("ajIeE");
$30094c111d7673fd$export$69f1b2dcda23c5f8 = $ajIeE;
function $30094c111d7673fd$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $30094c111d7673fd$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($30094c111d7673fd$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$30094c111d7673fd$export$45b10814cc054894 = $30094c111d7673fd$var$toArray;
function $30094c111d7673fd$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $30094c111d7673fd$var$zero2(msg[i].toString(16));
    return res;
}
$30094c111d7673fd$export$7ea66e3774a60b67 = $30094c111d7673fd$var$toHex;
function $30094c111d7673fd$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$30094c111d7673fd$export$34a52f00f601f6f1 = $30094c111d7673fd$var$htonl;
function $30094c111d7673fd$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $30094c111d7673fd$var$htonl(w);
        res += $30094c111d7673fd$var$zero8(w.toString(16));
    }
    return res;
}
$30094c111d7673fd$export$812b0cbd5e8a72ab = $30094c111d7673fd$var$toHex32;
function $30094c111d7673fd$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$30094c111d7673fd$export$f24f9e11d63bb314 = $30094c111d7673fd$var$zero2;
function $30094c111d7673fd$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$30094c111d7673fd$export$b71357c7e07ca1f1 = $30094c111d7673fd$var$zero8;
function $30094c111d7673fd$var$join32(msg, start, end, endian) {
    var len = end - start;
    $i1Wrq(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$30094c111d7673fd$export$2e58a4b541fdcbe8 = $30094c111d7673fd$var$join32;
function $30094c111d7673fd$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$30094c111d7673fd$export$183b950bde9faab8 = $30094c111d7673fd$var$split32;
function $30094c111d7673fd$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$30094c111d7673fd$export$4785c77169fea59e = $30094c111d7673fd$var$rotr32;
function $30094c111d7673fd$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$30094c111d7673fd$export$242a185dfcffac5b = $30094c111d7673fd$var$rotl32;
function $30094c111d7673fd$var$sum32(a, b) {
    return a + b >>> 0;
}
$30094c111d7673fd$export$58c04ae0ae31877d = $30094c111d7673fd$var$sum32;
function $30094c111d7673fd$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$30094c111d7673fd$export$d058ca695f8c6f11 = $30094c111d7673fd$var$sum32_3;
function $30094c111d7673fd$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$30094c111d7673fd$export$a1efd7fc3e986367 = $30094c111d7673fd$var$sum32_4;
function $30094c111d7673fd$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$30094c111d7673fd$export$bbfea4a2b5abaab4 = $30094c111d7673fd$var$sum32_5;
function $30094c111d7673fd$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$30094c111d7673fd$export$97ad4afc7de86152 = $30094c111d7673fd$var$sum64;
function $30094c111d7673fd$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$30094c111d7673fd$export$ce4673d9a79f6a4b = $30094c111d7673fd$var$sum64_hi;
function $30094c111d7673fd$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$30094c111d7673fd$export$786cc99fc6eedc0b = $30094c111d7673fd$var$sum64_lo;
function $30094c111d7673fd$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$30094c111d7673fd$export$45c59b9a1848dd0 = $30094c111d7673fd$var$sum64_4_hi;
function $30094c111d7673fd$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$30094c111d7673fd$export$50d8f613e76d3034 = $30094c111d7673fd$var$sum64_4_lo;
function $30094c111d7673fd$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$30094c111d7673fd$export$b8e83683c60ee162 = $30094c111d7673fd$var$sum64_5_hi;
function $30094c111d7673fd$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$30094c111d7673fd$export$aeeb51790d1bcc4a = $30094c111d7673fd$var$sum64_5_lo;
function $30094c111d7673fd$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$bb7c616f719ad9c = $30094c111d7673fd$var$rotr64_hi;
function $30094c111d7673fd$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$4d63290824f9d7df = $30094c111d7673fd$var$rotr64_lo;
function $30094c111d7673fd$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$30094c111d7673fd$export$2f64ceb90ef28ea1 = $30094c111d7673fd$var$shr64_hi;
function $30094c111d7673fd$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$30094c111d7673fd$export$8d2089d465f6d10d = $30094c111d7673fd$var$shr64_lo;

});

parcelRegister("dkCMM", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $9b4b3aa5aeec247d$export$8687658379b577e6, (v) => $9b4b3aa5aeec247d$export$8687658379b577e6 = v);
var $9b4b3aa5aeec247d$export$8687658379b577e6;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $i1Wrq = parcelRequire("i1Wrq");
function $9b4b3aa5aeec247d$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$9b4b3aa5aeec247d$export$8687658379b577e6 = $9b4b3aa5aeec247d$var$BlockHash;
$9b4b3aa5aeec247d$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $47Ha9.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $47Ha9.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$9b4b3aa5aeec247d$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $i1Wrq(this.pending === null);
    return this._digest(enc);
};
$9b4b3aa5aeec247d$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("9KjOr", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $7187c74c8c77d892$export$5091bdda49ba90f5, (v) => $7187c74c8c77d892$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $7187c74c8c77d892$export$97b70509d4e397ea, (v) => $7187c74c8c77d892$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $7187c74c8c77d892$export$bced8d2aada2d1c9, (v) => $7187c74c8c77d892$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $7187c74c8c77d892$export$612d47d55dedde45, (v) => $7187c74c8c77d892$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $7187c74c8c77d892$export$a888d2532e6dc7bb, (v) => $7187c74c8c77d892$export$a888d2532e6dc7bb = v);
var $7187c74c8c77d892$export$5091bdda49ba90f5;
var $7187c74c8c77d892$export$97b70509d4e397ea;
var $7187c74c8c77d892$export$bced8d2aada2d1c9;
var $7187c74c8c77d892$export$612d47d55dedde45;
var $7187c74c8c77d892$export$a888d2532e6dc7bb;
"use strict";

$7187c74c8c77d892$export$5091bdda49ba90f5 = (parcelRequire("fByOn"));

$7187c74c8c77d892$export$97b70509d4e397ea = (parcelRequire("dcRbx"));

$7187c74c8c77d892$export$bced8d2aada2d1c9 = (parcelRequire("dOBNm"));

$7187c74c8c77d892$export$612d47d55dedde45 = (parcelRequire("ayeNF"));

$7187c74c8c77d892$export$a888d2532e6dc7bb = (parcelRequire("9l5nO"));

});
parcelRegister("fByOn", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $kPVmf = parcelRequire("kPVmf");
var $b5c5508adf6649f2$var$rotl32 = $47Ha9.rotl32;
var $b5c5508adf6649f2$var$sum32 = $47Ha9.sum32;
var $b5c5508adf6649f2$var$sum32_5 = $47Ha9.sum32_5;
var $b5c5508adf6649f2$var$ft_1 = $kPVmf.ft_1;
var $b5c5508adf6649f2$var$BlockHash = $dkCMM.BlockHash;
var $b5c5508adf6649f2$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $b5c5508adf6649f2$var$SHA1() {
    if (!(this instanceof $b5c5508adf6649f2$var$SHA1)) return new $b5c5508adf6649f2$var$SHA1();
    $b5c5508adf6649f2$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$47Ha9.inherits($b5c5508adf6649f2$var$SHA1, $b5c5508adf6649f2$var$BlockHash);
module.exports = $b5c5508adf6649f2$var$SHA1;
$b5c5508adf6649f2$var$SHA1.blockSize = 512;
$b5c5508adf6649f2$var$SHA1.outSize = 160;
$b5c5508adf6649f2$var$SHA1.hmacStrength = 80;
$b5c5508adf6649f2$var$SHA1.padLength = 64;
$b5c5508adf6649f2$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $b5c5508adf6649f2$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $b5c5508adf6649f2$var$sum32_5($b5c5508adf6649f2$var$rotl32(a, 5), $b5c5508adf6649f2$var$ft_1(s, b, c, d), e, W[i], $b5c5508adf6649f2$var$sha1_K[s]);
        e = d;
        d = c;
        c = $b5c5508adf6649f2$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $b5c5508adf6649f2$var$sum32(this.h[0], a);
    this.h[1] = $b5c5508adf6649f2$var$sum32(this.h[1], b);
    this.h[2] = $b5c5508adf6649f2$var$sum32(this.h[2], c);
    this.h[3] = $b5c5508adf6649f2$var$sum32(this.h[3], d);
    this.h[4] = $b5c5508adf6649f2$var$sum32(this.h[4], e);
};
$b5c5508adf6649f2$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};

});
parcelRegister("kPVmf", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $f2b51028871b9afe$export$5a92649d7ddb9f63, (v) => $f2b51028871b9afe$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $f2b51028871b9afe$export$c6d0d020c3a6269, (v) => $f2b51028871b9afe$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $f2b51028871b9afe$export$eb90c27fca05f956, (v) => $f2b51028871b9afe$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $f2b51028871b9afe$export$14a4a98e063b1999, (v) => $f2b51028871b9afe$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $f2b51028871b9afe$export$d20cecfa1564c686, (v) => $f2b51028871b9afe$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $f2b51028871b9afe$export$44fd472a12fc6db, (v) => $f2b51028871b9afe$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $f2b51028871b9afe$export$1ed238bb6ea1dd47, (v) => $f2b51028871b9afe$export$1ed238bb6ea1dd47 = v);
var $f2b51028871b9afe$export$5a92649d7ddb9f63;
var $f2b51028871b9afe$export$c6d0d020c3a6269;
var $f2b51028871b9afe$export$eb90c27fca05f956;
var $f2b51028871b9afe$export$cc992891a14496a1;
var $f2b51028871b9afe$export$14a4a98e063b1999;
var $f2b51028871b9afe$export$d20cecfa1564c686;
var $f2b51028871b9afe$export$44fd472a12fc6db;
var $f2b51028871b9afe$export$1ed238bb6ea1dd47;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");
var $f2b51028871b9afe$var$rotr32 = $47Ha9.rotr32;
function $f2b51028871b9afe$var$ft_1(s, x, y, z) {
    if (s === 0) return $f2b51028871b9afe$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $f2b51028871b9afe$var$p32(x, y, z);
    if (s === 2) return $f2b51028871b9afe$var$maj32(x, y, z);
}
$f2b51028871b9afe$export$5a92649d7ddb9f63 = $f2b51028871b9afe$var$ft_1;
function $f2b51028871b9afe$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$f2b51028871b9afe$export$c6d0d020c3a6269 = $f2b51028871b9afe$var$ch32;
function $f2b51028871b9afe$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$f2b51028871b9afe$export$eb90c27fca05f956 = $f2b51028871b9afe$var$maj32;
function $f2b51028871b9afe$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$f2b51028871b9afe$export$cc992891a14496a1 = $f2b51028871b9afe$var$p32;
function $f2b51028871b9afe$var$s0_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 2) ^ $f2b51028871b9afe$var$rotr32(x, 13) ^ $f2b51028871b9afe$var$rotr32(x, 22);
}
$f2b51028871b9afe$export$14a4a98e063b1999 = $f2b51028871b9afe$var$s0_256;
function $f2b51028871b9afe$var$s1_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 6) ^ $f2b51028871b9afe$var$rotr32(x, 11) ^ $f2b51028871b9afe$var$rotr32(x, 25);
}
$f2b51028871b9afe$export$d20cecfa1564c686 = $f2b51028871b9afe$var$s1_256;
function $f2b51028871b9afe$var$g0_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 7) ^ $f2b51028871b9afe$var$rotr32(x, 18) ^ x >>> 3;
}
$f2b51028871b9afe$export$44fd472a12fc6db = $f2b51028871b9afe$var$g0_256;
function $f2b51028871b9afe$var$g1_256(x) {
    return $f2b51028871b9afe$var$rotr32(x, 17) ^ $f2b51028871b9afe$var$rotr32(x, 19) ^ x >>> 10;
}
$f2b51028871b9afe$export$1ed238bb6ea1dd47 = $f2b51028871b9afe$var$g1_256;

});


parcelRegister("dcRbx", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dOBNm = parcelRequire("dOBNm");
function $99d5a6d1c0c2bec1$var$SHA224() {
    if (!(this instanceof $99d5a6d1c0c2bec1$var$SHA224)) return new $99d5a6d1c0c2bec1$var$SHA224();
    $dOBNm.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$47Ha9.inherits($99d5a6d1c0c2bec1$var$SHA224, $dOBNm);
module.exports = $99d5a6d1c0c2bec1$var$SHA224;
$99d5a6d1c0c2bec1$var$SHA224.blockSize = 512;
$99d5a6d1c0c2bec1$var$SHA224.outSize = 224;
$99d5a6d1c0c2bec1$var$SHA224.hmacStrength = 192;
$99d5a6d1c0c2bec1$var$SHA224.padLength = 64;
$99d5a6d1c0c2bec1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $47Ha9.toHex32(this.h.slice(0, 7), "big");
    else return $47Ha9.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("dOBNm", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $kPVmf = parcelRequire("kPVmf");

var $i1Wrq = parcelRequire("i1Wrq");
var $a0ed43387f1c7a03$var$sum32 = $47Ha9.sum32;
var $a0ed43387f1c7a03$var$sum32_4 = $47Ha9.sum32_4;
var $a0ed43387f1c7a03$var$sum32_5 = $47Ha9.sum32_5;
var $a0ed43387f1c7a03$var$ch32 = $kPVmf.ch32;
var $a0ed43387f1c7a03$var$maj32 = $kPVmf.maj32;
var $a0ed43387f1c7a03$var$s0_256 = $kPVmf.s0_256;
var $a0ed43387f1c7a03$var$s1_256 = $kPVmf.s1_256;
var $a0ed43387f1c7a03$var$g0_256 = $kPVmf.g0_256;
var $a0ed43387f1c7a03$var$g1_256 = $kPVmf.g1_256;
var $a0ed43387f1c7a03$var$BlockHash = $dkCMM.BlockHash;
var $a0ed43387f1c7a03$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $a0ed43387f1c7a03$var$SHA256() {
    if (!(this instanceof $a0ed43387f1c7a03$var$SHA256)) return new $a0ed43387f1c7a03$var$SHA256();
    $a0ed43387f1c7a03$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $a0ed43387f1c7a03$var$sha256_K;
    this.W = new Array(64);
}
$47Ha9.inherits($a0ed43387f1c7a03$var$SHA256, $a0ed43387f1c7a03$var$BlockHash);
module.exports = $a0ed43387f1c7a03$var$SHA256;
$a0ed43387f1c7a03$var$SHA256.blockSize = 512;
$a0ed43387f1c7a03$var$SHA256.outSize = 256;
$a0ed43387f1c7a03$var$SHA256.hmacStrength = 192;
$a0ed43387f1c7a03$var$SHA256.padLength = 64;
$a0ed43387f1c7a03$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $a0ed43387f1c7a03$var$sum32_4($a0ed43387f1c7a03$var$g1_256(W[i - 2]), W[i - 7], $a0ed43387f1c7a03$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $i1Wrq(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $a0ed43387f1c7a03$var$sum32_5(h, $a0ed43387f1c7a03$var$s1_256(e), $a0ed43387f1c7a03$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $a0ed43387f1c7a03$var$sum32($a0ed43387f1c7a03$var$s0_256(a), $a0ed43387f1c7a03$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $a0ed43387f1c7a03$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $a0ed43387f1c7a03$var$sum32(T1, T2);
    }
    this.h[0] = $a0ed43387f1c7a03$var$sum32(this.h[0], a);
    this.h[1] = $a0ed43387f1c7a03$var$sum32(this.h[1], b);
    this.h[2] = $a0ed43387f1c7a03$var$sum32(this.h[2], c);
    this.h[3] = $a0ed43387f1c7a03$var$sum32(this.h[3], d);
    this.h[4] = $a0ed43387f1c7a03$var$sum32(this.h[4], e);
    this.h[5] = $a0ed43387f1c7a03$var$sum32(this.h[5], f);
    this.h[6] = $a0ed43387f1c7a03$var$sum32(this.h[6], g);
    this.h[7] = $a0ed43387f1c7a03$var$sum32(this.h[7], h);
};
$a0ed43387f1c7a03$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};

});


parcelRegister("ayeNF", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $9l5nO = parcelRequire("9l5nO");
function $7ae88f57acc3df9f$var$SHA384() {
    if (!(this instanceof $7ae88f57acc3df9f$var$SHA384)) return new $7ae88f57acc3df9f$var$SHA384();
    $9l5nO.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$47Ha9.inherits($7ae88f57acc3df9f$var$SHA384, $9l5nO);
module.exports = $7ae88f57acc3df9f$var$SHA384;
$7ae88f57acc3df9f$var$SHA384.blockSize = 1024;
$7ae88f57acc3df9f$var$SHA384.outSize = 384;
$7ae88f57acc3df9f$var$SHA384.hmacStrength = 192;
$7ae88f57acc3df9f$var$SHA384.padLength = 128;
$7ae88f57acc3df9f$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h.slice(0, 12), "big");
    else return $47Ha9.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("9l5nO", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");

var $i1Wrq = parcelRequire("i1Wrq");
var $6cca402b55dff2d4$var$rotr64_hi = $47Ha9.rotr64_hi;
var $6cca402b55dff2d4$var$rotr64_lo = $47Ha9.rotr64_lo;
var $6cca402b55dff2d4$var$shr64_hi = $47Ha9.shr64_hi;
var $6cca402b55dff2d4$var$shr64_lo = $47Ha9.shr64_lo;
var $6cca402b55dff2d4$var$sum64 = $47Ha9.sum64;
var $6cca402b55dff2d4$var$sum64_hi = $47Ha9.sum64_hi;
var $6cca402b55dff2d4$var$sum64_lo = $47Ha9.sum64_lo;
var $6cca402b55dff2d4$var$sum64_4_hi = $47Ha9.sum64_4_hi;
var $6cca402b55dff2d4$var$sum64_4_lo = $47Ha9.sum64_4_lo;
var $6cca402b55dff2d4$var$sum64_5_hi = $47Ha9.sum64_5_hi;
var $6cca402b55dff2d4$var$sum64_5_lo = $47Ha9.sum64_5_lo;
var $6cca402b55dff2d4$var$BlockHash = $dkCMM.BlockHash;
var $6cca402b55dff2d4$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $6cca402b55dff2d4$var$SHA512() {
    if (!(this instanceof $6cca402b55dff2d4$var$SHA512)) return new $6cca402b55dff2d4$var$SHA512();
    $6cca402b55dff2d4$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $6cca402b55dff2d4$var$sha512_K;
    this.W = new Array(160);
}
$47Ha9.inherits($6cca402b55dff2d4$var$SHA512, $6cca402b55dff2d4$var$BlockHash);
module.exports = $6cca402b55dff2d4$var$SHA512;
$6cca402b55dff2d4$var$SHA512.blockSize = 1024;
$6cca402b55dff2d4$var$SHA512.outSize = 512;
$6cca402b55dff2d4$var$SHA512.hmacStrength = 192;
$6cca402b55dff2d4$var$SHA512.padLength = 128;
$6cca402b55dff2d4$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $6cca402b55dff2d4$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $6cca402b55dff2d4$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $6cca402b55dff2d4$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $6cca402b55dff2d4$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $6cca402b55dff2d4$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $6cca402b55dff2d4$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$6cca402b55dff2d4$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $i1Wrq(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $6cca402b55dff2d4$var$s1_512_hi(eh, el);
        var c1_lo = $6cca402b55dff2d4$var$s1_512_lo(eh, el);
        var c2_hi = $6cca402b55dff2d4$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $6cca402b55dff2d4$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $6cca402b55dff2d4$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $6cca402b55dff2d4$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $6cca402b55dff2d4$var$s0_512_hi(ah, al);
        c0_lo = $6cca402b55dff2d4$var$s0_512_lo(ah, al);
        c1_hi = $6cca402b55dff2d4$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $6cca402b55dff2d4$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $6cca402b55dff2d4$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $6cca402b55dff2d4$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $6cca402b55dff2d4$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $6cca402b55dff2d4$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $6cca402b55dff2d4$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $6cca402b55dff2d4$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $6cca402b55dff2d4$var$sum64(this.h, 0, ah, al);
    $6cca402b55dff2d4$var$sum64(this.h, 2, bh, bl);
    $6cca402b55dff2d4$var$sum64(this.h, 4, ch, cl);
    $6cca402b55dff2d4$var$sum64(this.h, 6, dh, dl);
    $6cca402b55dff2d4$var$sum64(this.h, 8, eh, el);
    $6cca402b55dff2d4$var$sum64(this.h, 10, fh, fl);
    $6cca402b55dff2d4$var$sum64(this.h, 12, gh, gl);
    $6cca402b55dff2d4$var$sum64(this.h, 14, hh, hl);
};
$6cca402b55dff2d4$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "big");
    else return $47Ha9.split32(this.h, "big");
};
function $6cca402b55dff2d4$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s0_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s0_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s1_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$s1_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g0_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $6cca402b55dff2d4$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g0_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $6cca402b55dff2d4$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g1_512_hi(xh, xl) {
    var c0_hi = $6cca402b55dff2d4$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $6cca402b55dff2d4$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $6cca402b55dff2d4$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $6cca402b55dff2d4$var$g1_512_lo(xh, xl) {
    var c0_lo = $6cca402b55dff2d4$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $6cca402b55dff2d4$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $6cca402b55dff2d4$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("6xYCQ", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $4c44da224496b72f$export$d1cea0ee4e3f0d3e, (v) => $4c44da224496b72f$export$d1cea0ee4e3f0d3e = v);
var $4c44da224496b72f$export$d1cea0ee4e3f0d3e;
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $dkCMM = parcelRequire("dkCMM");
var $4c44da224496b72f$var$rotl32 = $47Ha9.rotl32;
var $4c44da224496b72f$var$sum32 = $47Ha9.sum32;
var $4c44da224496b72f$var$sum32_3 = $47Ha9.sum32_3;
var $4c44da224496b72f$var$sum32_4 = $47Ha9.sum32_4;
var $4c44da224496b72f$var$BlockHash = $dkCMM.BlockHash;
function $4c44da224496b72f$var$RIPEMD160() {
    if (!(this instanceof $4c44da224496b72f$var$RIPEMD160)) return new $4c44da224496b72f$var$RIPEMD160();
    $4c44da224496b72f$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$47Ha9.inherits($4c44da224496b72f$var$RIPEMD160, $4c44da224496b72f$var$BlockHash);
$4c44da224496b72f$export$d1cea0ee4e3f0d3e = $4c44da224496b72f$var$RIPEMD160;
$4c44da224496b72f$var$RIPEMD160.blockSize = 512;
$4c44da224496b72f$var$RIPEMD160.outSize = 160;
$4c44da224496b72f$var$RIPEMD160.hmacStrength = 192;
$4c44da224496b72f$var$RIPEMD160.padLength = 64;
$4c44da224496b72f$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $4c44da224496b72f$var$sum32($4c44da224496b72f$var$rotl32($4c44da224496b72f$var$sum32_4(A, $4c44da224496b72f$var$f(j, B, C, D), msg[$4c44da224496b72f$var$r[j] + start], $4c44da224496b72f$var$K(j)), $4c44da224496b72f$var$s[j]), E);
        A = E;
        E = D;
        D = $4c44da224496b72f$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $4c44da224496b72f$var$sum32($4c44da224496b72f$var$rotl32($4c44da224496b72f$var$sum32_4(Ah, $4c44da224496b72f$var$f(79 - j, Bh, Ch, Dh), msg[$4c44da224496b72f$var$rh[j] + start], $4c44da224496b72f$var$Kh(j)), $4c44da224496b72f$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $4c44da224496b72f$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $4c44da224496b72f$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $4c44da224496b72f$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $4c44da224496b72f$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $4c44da224496b72f$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $4c44da224496b72f$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$4c44da224496b72f$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $47Ha9.toHex32(this.h, "little");
    else return $47Ha9.split32(this.h, "little");
};
function $4c44da224496b72f$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $4c44da224496b72f$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $4c44da224496b72f$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $4c44da224496b72f$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $4c44da224496b72f$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $4c44da224496b72f$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $4c44da224496b72f$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("2W6lw", function(module, exports) {
"use strict";

var $47Ha9 = parcelRequire("47Ha9");

var $i1Wrq = parcelRequire("i1Wrq");
function $2235ebc0e5a6911c$var$Hmac(hash, key, enc) {
    if (!(this instanceof $2235ebc0e5a6911c$var$Hmac)) return new $2235ebc0e5a6911c$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($47Ha9.toArray(key, enc));
}
module.exports = $2235ebc0e5a6911c$var$Hmac;
$2235ebc0e5a6911c$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $i1Wrq(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$2235ebc0e5a6911c$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$2235ebc0e5a6911c$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("apL0e", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("1WfU3", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $ceJ7V = parcelRequire("ceJ7V");

var $36pBX = parcelRequire("36pBX");

var $izsNn = parcelRequire("izsNn");

var $2iwIf = parcelRequire("2iwIf");
var $16978b404b64dbd7$var$assert = $36pBX.assert;

var $jI9Ts = parcelRequire("jI9Ts");

var $3OEw3 = parcelRequire("3OEw3");
function $16978b404b64dbd7$var$EC(options) {
    if (!(this instanceof $16978b404b64dbd7$var$EC)) return new $16978b404b64dbd7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $16978b404b64dbd7$var$assert(Object.prototype.hasOwnProperty.call($izsNn, options), "Unknown curve " + options);
        options = $izsNn[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $izsNn.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $16978b404b64dbd7$var$EC;
$16978b404b64dbd7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $jI9Ts(this, options);
};
$16978b404b64dbd7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $jI9Ts.fromPrivate(this, priv, enc);
};
$16978b404b64dbd7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $jI9Ts.fromPublic(this, pub, enc);
};
$16978b404b64dbd7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $ceJ7V({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $2iwIf(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $bk4ev(2));
    for(;;){
        var priv = new $bk4ev(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$16978b404b64dbd7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$16978b404b64dbd7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $bk4ev(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $ceJ7V({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $bk4ev(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $bk4ev(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3OEw3({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$16978b404b64dbd7$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $bk4ev(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $3OEw3(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$16978b404b64dbd7$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $16978b404b64dbd7$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $3OEw3(signature, enc);
    var n = this.n;
    var e = new $bk4ev(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$16978b404b64dbd7$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3OEw3(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("ceJ7V", function(module, exports) {
"use strict";

var $dyCsH = parcelRequire("dyCsH");

var $fg9XS = parcelRequire("fg9XS");

var $i1Wrq = parcelRequire("i1Wrq");
function $8e89cc172437d525$var$HmacDRBG(options) {
    if (!(this instanceof $8e89cc172437d525$var$HmacDRBG)) return new $8e89cc172437d525$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $fg9XS.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $fg9XS.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $fg9XS.toArray(options.pers, options.persEnc || "hex");
    $i1Wrq(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $8e89cc172437d525$var$HmacDRBG;
$8e89cc172437d525$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$8e89cc172437d525$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $dyCsH.hmac(this.hash, this.K);
};
$8e89cc172437d525$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$8e89cc172437d525$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $fg9XS.toArray(entropy, entropyEnc);
    add = $fg9XS.toArray(add, addEnc);
    $i1Wrq(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$8e89cc172437d525$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $fg9XS.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $fg9XS.encode(res, enc);
};

});

parcelRegister("jI9Ts", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $36pBX = parcelRequire("36pBX");
var $e599cd09ab6c1c14$var$assert = $36pBX.assert;
function $e599cd09ab6c1c14$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $e599cd09ab6c1c14$var$KeyPair;
$e599cd09ab6c1c14$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $e599cd09ab6c1c14$var$KeyPair) return pub;
    return new $e599cd09ab6c1c14$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$e599cd09ab6c1c14$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $e599cd09ab6c1c14$var$KeyPair) return priv;
    return new $e599cd09ab6c1c14$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$e599cd09ab6c1c14$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$e599cd09ab6c1c14$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$e599cd09ab6c1c14$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $bk4ev(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$e599cd09ab6c1c14$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $e599cd09ab6c1c14$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $e599cd09ab6c1c14$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$e599cd09ab6c1c14$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $e599cd09ab6c1c14$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$e599cd09ab6c1c14$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$e599cd09ab6c1c14$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("3OEw3", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $36pBX = parcelRequire("36pBX");
var $2c75783bdfa2c803$var$assert = $36pBX.assert;
function $2c75783bdfa2c803$var$Signature(options, enc) {
    if (options instanceof $2c75783bdfa2c803$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2c75783bdfa2c803$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $bk4ev(options.r, 16);
    this.s = new $bk4ev(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2c75783bdfa2c803$var$Signature;
function $2c75783bdfa2c803$var$Position() {
    this.place = 0;
}
function $2c75783bdfa2c803$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2c75783bdfa2c803$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2c75783bdfa2c803$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $36pBX.toArray(data, enc);
    var p = new $2c75783bdfa2c803$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2c75783bdfa2c803$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2c75783bdfa2c803$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2c75783bdfa2c803$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $bk4ev(r);
    this.s = new $bk4ev(s);
    this.recoveryParam = null;
    return true;
};
function $2c75783bdfa2c803$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2c75783bdfa2c803$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2c75783bdfa2c803$var$rmPadding(r);
    s = $2c75783bdfa2c803$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2c75783bdfa2c803$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2c75783bdfa2c803$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2c75783bdfa2c803$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $36pBX.encode(res, enc);
};

});


parcelRegister("92zjz", function(module, exports) {
"use strict";

var $dyCsH = parcelRequire("dyCsH");

var $izsNn = parcelRequire("izsNn");

var $36pBX = parcelRequire("36pBX");
var $694fb1b2156dae42$var$assert = $36pBX.assert;
var $694fb1b2156dae42$var$parseBytes = $36pBX.parseBytes;

var $4yLDU = parcelRequire("4yLDU");

var $eydmk = parcelRequire("eydmk");
function $694fb1b2156dae42$var$EDDSA(curve) {
    $694fb1b2156dae42$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $694fb1b2156dae42$var$EDDSA)) return new $694fb1b2156dae42$var$EDDSA(curve);
    curve = $izsNn[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $dyCsH.sha512;
}
module.exports = $694fb1b2156dae42$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $694fb1b2156dae42$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $694fb1b2156dae42$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $694fb1b2156dae42$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $694fb1b2156dae42$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$694fb1b2156dae42$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $36pBX.intFromLE(hash.digest()).umod(this.curve.n);
};
$694fb1b2156dae42$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $4yLDU.fromPublic(this, pub);
};
$694fb1b2156dae42$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $4yLDU.fromSecret(this, secret);
};
$694fb1b2156dae42$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $eydmk) return sig;
    return new $eydmk(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $694fb1b2156dae42$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$694fb1b2156dae42$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $36pBX.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $36pBX.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$694fb1b2156dae42$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$694fb1b2156dae42$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $36pBX.intFromLE(bytes);
};
$694fb1b2156dae42$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("4yLDU", function(module, exports) {
"use strict";

var $36pBX = parcelRequire("36pBX");
var $351f4b3a682f8cc4$var$assert = $36pBX.assert;
var $351f4b3a682f8cc4$var$parseBytes = $36pBX.parseBytes;
var $351f4b3a682f8cc4$var$cachedProperty = $36pBX.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $351f4b3a682f8cc4$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $351f4b3a682f8cc4$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $351f4b3a682f8cc4$var$parseBytes(params.pub);
}
$351f4b3a682f8cc4$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $351f4b3a682f8cc4$var$KeyPair) return pub;
    return new $351f4b3a682f8cc4$var$KeyPair(eddsa, {
        pub: pub
    });
};
$351f4b3a682f8cc4$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $351f4b3a682f8cc4$var$KeyPair) return secret;
    return new $351f4b3a682f8cc4$var$KeyPair(eddsa, {
        secret: secret
    });
};
$351f4b3a682f8cc4$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$351f4b3a682f8cc4$var$cachedProperty($351f4b3a682f8cc4$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$351f4b3a682f8cc4$var$KeyPair.prototype.sign = function sign(message) {
    $351f4b3a682f8cc4$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $351f4b3a682f8cc4$var$assert(this._secret, "KeyPair is public only");
    return $36pBX.encode(this.secret(), enc);
};
$351f4b3a682f8cc4$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $36pBX.encode(this.pubBytes(), enc);
};
module.exports = $351f4b3a682f8cc4$var$KeyPair;

});

parcelRegister("eydmk", function(module, exports) {
"use strict";

var $bk4ev = parcelRequire("bk4ev");

var $36pBX = parcelRequire("36pBX");
var $a97e9a82228c997a$var$assert = $36pBX.assert;
var $a97e9a82228c997a$var$cachedProperty = $36pBX.cachedProperty;
var $a97e9a82228c997a$var$parseBytes = $36pBX.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $a97e9a82228c997a$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $a97e9a82228c997a$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $a97e9a82228c997a$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $bk4ev) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$a97e9a82228c997a$var$cachedProperty($a97e9a82228c997a$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$a97e9a82228c997a$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$a97e9a82228c997a$var$Signature.prototype.toHex = function toHex() {
    return $36pBX.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $a97e9a82228c997a$var$Signature;

});



parcelRegister("jSrFg", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $e7888513ff9e25d0$require$Buffer = $N0o3H.Buffer;

var $cWxOP = parcelRequire("cWxOP");
const $e7888513ff9e25d0$var$ONE1 = $e7888513ff9e25d0$require$Buffer.alloc(1, 1);
const $e7888513ff9e25d0$var$ZERO1 = $e7888513ff9e25d0$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $e7888513ff9e25d0$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $e7888513ff9e25d0$require$Buffer.alloc(32, 0);
    let v = $e7888513ff9e25d0$require$Buffer.alloc(32, 1);
    // Step D
    k = $cWxOP("sha256", k).update(v).update($e7888513ff9e25d0$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $cWxOP("sha256", k).update(v).digest();
    // Step F
    k = $cWxOP("sha256", k).update(v).update($e7888513ff9e25d0$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $cWxOP("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $cWxOP("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $cWxOP("sha256", k).update(v).update($e7888513ff9e25d0$var$ZERO1).digest();
        v = $cWxOP("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $cWxOP("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $e7888513ff9e25d0$var$deterministicGenerateK;

});


parcelRegister("h3VQr", function(module, exports) {

var $afPAP = parcelRequire("afPAP");

var $cSMS1 = parcelRequire("cSMS1");
// short-hand
var $c6bf96459d4fc8ea$var$tfJSON = $afPAP.tfJSON;
var $c6bf96459d4fc8ea$var$TfTypeError = $afPAP.TfTypeError;
var $c6bf96459d4fc8ea$var$TfPropertyTypeError = $afPAP.TfPropertyTypeError;
var $c6bf96459d4fc8ea$var$tfSubError = $afPAP.tfSubError;
var $c6bf96459d4fc8ea$var$getValueTypeName = $afPAP.getValueTypeName;
var $c6bf96459d4fc8ea$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $c6bf96459d4fc8ea$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$cSMS1.Array(array)) return false;
            if ($cSMS1.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $c6bf96459d4fc8ea$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $c6bf96459d4fc8ea$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $c6bf96459d4fc8ea$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $c6bf96459d4fc8ea$var$compile(type);
        function _maybe(value, strict) {
            return $cSMS1.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $c6bf96459d4fc8ea$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $c6bf96459d4fc8ea$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $c6bf96459d4fc8ea$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$cSMS1.Object(value)) return false;
            if ($cSMS1.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $c6bf96459d4fc8ea$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $c6bf96459d4fc8ea$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $c6bf96459d4fc8ea$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $c6bf96459d4fc8ea$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $c6bf96459d4fc8ea$var$tfJSON(propertyKeyType) + ": " + $c6bf96459d4fc8ea$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $c6bf96459d4fc8ea$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $c6bf96459d4fc8ea$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$cSMS1.Object(value)) return false;
            if ($cSMS1.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $c6bf96459d4fc8ea$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $c6bf96459d4fc8ea$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $c6bf96459d4fc8ea$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $c6bf96459d4fc8ea$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($c6bf96459d4fc8ea$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $c6bf96459d4fc8ea$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($c6bf96459d4fc8ea$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($c6bf96459d4fc8ea$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $c6bf96459d4fc8ea$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($c6bf96459d4fc8ea$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $c6bf96459d4fc8ea$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($c6bf96459d4fc8ea$var$compile);
        function _tuple(values, strict) {
            if ($cSMS1.Nil(values)) return false;
            if ($cSMS1.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $c6bf96459d4fc8ea$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $c6bf96459d4fc8ea$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($c6bf96459d4fc8ea$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$c6bf96459d4fc8ea$var$TYPES.oneOf = $c6bf96459d4fc8ea$var$TYPES.anyOf;
function $c6bf96459d4fc8ea$var$compile(type) {
    if ($cSMS1.String(type)) {
        if (type[0] === "?") return $c6bf96459d4fc8ea$var$TYPES.maybe(type.slice(1));
        return $cSMS1[type] || $c6bf96459d4fc8ea$var$TYPES.quacksLike(type);
    } else if (type && $cSMS1.Object(type)) {
        if ($cSMS1.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $c6bf96459d4fc8ea$var$TYPES.arrayOf(type[0]);
        }
        return $c6bf96459d4fc8ea$var$TYPES.object(type);
    } else if ($cSMS1.Function(type)) return type;
    return $c6bf96459d4fc8ea$var$TYPES.value(type);
}
function $c6bf96459d4fc8ea$var$typeforce(type, value, strict, surrogate) {
    if ($cSMS1.Function(type)) {
        if (type(value, strict)) return true;
        throw new $c6bf96459d4fc8ea$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $c6bf96459d4fc8ea$var$typeforce($c6bf96459d4fc8ea$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $c6bf96459d4fc8ea$var$typeName in $cSMS1)$c6bf96459d4fc8ea$var$typeforce[$c6bf96459d4fc8ea$var$typeName] = $cSMS1[$c6bf96459d4fc8ea$var$typeName];
for($c6bf96459d4fc8ea$var$typeName in $c6bf96459d4fc8ea$var$TYPES)$c6bf96459d4fc8ea$var$typeforce[$c6bf96459d4fc8ea$var$typeName] = $c6bf96459d4fc8ea$var$TYPES[$c6bf96459d4fc8ea$var$typeName];

var $iJGcb = parcelRequire("iJGcb");
for($c6bf96459d4fc8ea$var$typeName in $iJGcb)$c6bf96459d4fc8ea$var$typeforce[$c6bf96459d4fc8ea$var$typeName] = $iJGcb[$c6bf96459d4fc8ea$var$typeName];
$c6bf96459d4fc8ea$var$typeforce.compile = $c6bf96459d4fc8ea$var$compile;
$c6bf96459d4fc8ea$var$typeforce.TfTypeError = $c6bf96459d4fc8ea$var$TfTypeError;
$c6bf96459d4fc8ea$var$typeforce.TfPropertyTypeError = $c6bf96459d4fc8ea$var$TfPropertyTypeError;
module.exports = $c6bf96459d4fc8ea$var$typeforce;

});
parcelRegister("afPAP", function(module, exports) {

var $cSMS1 = parcelRequire("cSMS1");
function $777353688ce124a5$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $777353688ce124a5$var$getValueTypeName(value) {
    return $cSMS1.Nil(value) ? "" : $777353688ce124a5$var$getTypeName(value.constructor);
}
function $777353688ce124a5$var$getValue(value) {
    if ($cSMS1.Function(value)) return "";
    if ($cSMS1.String(value)) return JSON.stringify(value);
    if (value && $cSMS1.Object(value)) return "";
    return value;
}
function $777353688ce124a5$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $777353688ce124a5$var$tfJSON(type) {
    if ($cSMS1.Function(type)) return type.toJSON ? type.toJSON() : $777353688ce124a5$var$getTypeName(type);
    if ($cSMS1.Array(type)) return "Array";
    if (type && $cSMS1.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $777353688ce124a5$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $777353688ce124a5$var$getValue(value);
    return "Expected " + $777353688ce124a5$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $777353688ce124a5$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $777353688ce124a5$var$getValueTypeName(value);
    this.message = $777353688ce124a5$var$tfErrorString(type, value, valueTypeName);
    $777353688ce124a5$var$captureStackTrace(this, $777353688ce124a5$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$777353688ce124a5$var$TfTypeError.prototype = Object.create(Error.prototype);
$777353688ce124a5$var$TfTypeError.prototype.constructor = $777353688ce124a5$var$TfTypeError;
function $777353688ce124a5$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $777353688ce124a5$var$tfErrorString('property "' + $777353688ce124a5$var$tfJSON(name) + description + $777353688ce124a5$var$tfJSON(type), value, valueTypeName);
}
function $777353688ce124a5$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $777353688ce124a5$var$getValueTypeName(value);
        this.message = $777353688ce124a5$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $777353688ce124a5$var$captureStackTrace(this, $777353688ce124a5$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$777353688ce124a5$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$777353688ce124a5$var$TfPropertyTypeError.prototype.constructor = $777353688ce124a5$var$TfTypeError;
function $777353688ce124a5$var$tfCustomError(expected, actual) {
    return new $777353688ce124a5$var$TfTypeError(expected, {}, actual);
}
function $777353688ce124a5$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $777353688ce124a5$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $777353688ce124a5$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $777353688ce124a5$var$TfTypeError) e = new $777353688ce124a5$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $777353688ce124a5$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $777353688ce124a5$var$TfTypeError,
    TfPropertyTypeError: $777353688ce124a5$var$TfPropertyTypeError,
    tfCustomError: $777353688ce124a5$var$tfCustomError,
    tfSubError: $777353688ce124a5$var$tfSubError,
    tfJSON: $777353688ce124a5$var$tfJSON,
    getValueTypeName: $777353688ce124a5$var$getValueTypeName
};

});
parcelRegister("cSMS1", function(module, exports) {
var $96106fc8f6776935$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$96106fc8f6776935$var$types.Null = $96106fc8f6776935$var$types.Nil;
for(var $96106fc8f6776935$var$typeName in $96106fc8f6776935$var$types)$96106fc8f6776935$var$types[$96106fc8f6776935$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $96106fc8f6776935$var$typeName);
module.exports = $96106fc8f6776935$var$types;

});


parcelRegister("iJGcb", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $da3d291a751b93e5$require$Buffer = $N0o3H.Buffer;

var $cSMS1 = parcelRequire("cSMS1");

var $afPAP = parcelRequire("afPAP");
function $da3d291a751b93e5$var$_Buffer(value) {
    return $da3d291a751b93e5$require$Buffer.isBuffer(value);
}
function $da3d291a751b93e5$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $da3d291a751b93e5$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $afPAP.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $da3d291a751b93e5$var$_ArrayN = $da3d291a751b93e5$var$_LengthN.bind(null, $cSMS1.Array);
var $da3d291a751b93e5$var$_BufferN = $da3d291a751b93e5$var$_LengthN.bind(null, $da3d291a751b93e5$var$_Buffer);
var $da3d291a751b93e5$var$_HexN = $da3d291a751b93e5$var$_LengthN.bind(null, $da3d291a751b93e5$var$Hex);
var $da3d291a751b93e5$var$_StringN = $da3d291a751b93e5$var$_LengthN.bind(null, $cSMS1.String);
function $da3d291a751b93e5$var$Range(a, b, f) {
    f = f || $cSMS1.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $da3d291a751b93e5$var$INT53_MAX = Math.pow(2, 53) - 1;
function $da3d291a751b93e5$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $da3d291a751b93e5$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $da3d291a751b93e5$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $da3d291a751b93e5$var$Int32(value) {
    return (value | 0) === value;
}
function $da3d291a751b93e5$var$Int53(value) {
    return typeof value === "number" && value >= -$da3d291a751b93e5$var$INT53_MAX && value <= $da3d291a751b93e5$var$INT53_MAX && Math.floor(value) === value;
}
function $da3d291a751b93e5$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $da3d291a751b93e5$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $da3d291a751b93e5$var$UInt32(value) {
    return value >>> 0 === value;
}
function $da3d291a751b93e5$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $da3d291a751b93e5$var$INT53_MAX && Math.floor(value) === value;
}
var $da3d291a751b93e5$var$types = {
    ArrayN: $da3d291a751b93e5$var$_ArrayN,
    Buffer: $da3d291a751b93e5$var$_Buffer,
    BufferN: $da3d291a751b93e5$var$_BufferN,
    Finite: $da3d291a751b93e5$var$Finite,
    Hex: $da3d291a751b93e5$var$Hex,
    HexN: $da3d291a751b93e5$var$_HexN,
    Int8: $da3d291a751b93e5$var$Int8,
    Int16: $da3d291a751b93e5$var$Int16,
    Int32: $da3d291a751b93e5$var$Int32,
    Int53: $da3d291a751b93e5$var$Int53,
    Range: $da3d291a751b93e5$var$Range,
    StringN: $da3d291a751b93e5$var$_StringN,
    UInt8: $da3d291a751b93e5$var$UInt8,
    UInt16: $da3d291a751b93e5$var$UInt16,
    UInt32: $da3d291a751b93e5$var$UInt32,
    UInt53: $da3d291a751b93e5$var$UInt53
};
for(var $da3d291a751b93e5$var$typeName in $da3d291a751b93e5$var$types)$da3d291a751b93e5$var$types[$da3d291a751b93e5$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $da3d291a751b93e5$var$typeName);
module.exports = $da3d291a751b93e5$var$types;

});


parcelRegister("j8PAC", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $0398a02245c8fe10$require$Buffer = $N0o3H.Buffer;

var $kfzoe = parcelRequire("kfzoe");
function $0398a02245c8fe10$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $0398a02245c8fe10$var$encodeRaw(version, privateKey, compressed) {
    var result = new $0398a02245c8fe10$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $0398a02245c8fe10$var$decode(string, version) {
    return $0398a02245c8fe10$var$decodeRaw($kfzoe.decode(string), version);
}
function $0398a02245c8fe10$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $kfzoe.encode($0398a02245c8fe10$var$encodeRaw(version, privateKey, compressed));
    return $kfzoe.encode($0398a02245c8fe10$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $0398a02245c8fe10$var$decode,
    decodeRaw: $0398a02245c8fe10$var$decodeRaw,
    encode: $0398a02245c8fe10$var$encode,
    encodeRaw: $0398a02245c8fe10$var$encodeRaw
};

});




parcelRegister("9BV59", function(module, exports) {
"use strict";
var $6ff3d912a1a149d2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PubKeySecp256k1 = module.exports.PrivKeySecp256k1 = void 0;

var $7kgn0 = parcelRequire("7kgn0");

const $6ff3d912a1a149d2$var$crypto_js_1 = $6ff3d912a1a149d2$var$__importDefault((parcelRequire("iRdU6")));

var $N0o3H = parcelRequire("N0o3H");

var $25Pjl = parcelRequire("25Pjl");
class $6ff3d912a1a149d2$var$PrivKeySecp256k1 {
    static generateRandomKey() {
        const secp256k1 = new $7kgn0.ec("secp256k1");
        return new $6ff3d912a1a149d2$var$PrivKeySecp256k1($N0o3H.Buffer.from(secp256k1.genKeyPair().getPrivate().toArray()));
    }
    constructor(privKey){
        this.privKey = privKey;
    }
    toBytes() {
        return new Uint8Array(this.privKey);
    }
    getPubKey() {
        const secp256k1 = new $7kgn0.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        return new $6ff3d912a1a149d2$var$PubKeySecp256k1(new Uint8Array(key.getPublic().encodeCompressed("array")));
    }
    signDigest32(digest) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to sign: ${digest.length}`);
        const secp256k1 = new $7kgn0.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        const signature = key.sign(digest, {
            canonical: true
        });
        return {
            r: new Uint8Array(signature.r.toArray("be", 32)),
            s: new Uint8Array(signature.s.toArray("be", 32)),
            v: signature.recoveryParam
        };
    }
}
module.exports.PrivKeySecp256k1 = $6ff3d912a1a149d2$var$PrivKeySecp256k1;
class $6ff3d912a1a149d2$var$PubKeySecp256k1 {
    constructor(pubKey){
        this.pubKey = pubKey;
        if (pubKey.length !== 33 && pubKey.length !== 65) throw new Error(`Invalid length of public key: ${pubKey.length}`);
    }
    toBytes(uncompressed) {
        if (uncompressed && this.pubKey.length === 65) return this.pubKey;
        if (!uncompressed && this.pubKey.length === 33) return this.pubKey;
        const keyPair = this.toKeyPair();
        if (uncompressed) return new Uint8Array($N0o3H.Buffer.from(keyPair.getPublic().encode("hex", false), "hex"));
        else return new Uint8Array($N0o3H.Buffer.from(keyPair.getPublic().encodeCompressed("hex"), "hex"));
    }
    /**
     * @deprecated Use `getCosmosAddress()` instead.
     */ getAddress() {
        return this.getCosmosAddress();
    }
    getCosmosAddress() {
        let hash = $6ff3d912a1a149d2$var$crypto_js_1.default.SHA256($6ff3d912a1a149d2$var$crypto_js_1.default.lib.WordArray.create(this.toBytes(false))).toString();
        hash = $6ff3d912a1a149d2$var$crypto_js_1.default.RIPEMD160($6ff3d912a1a149d2$var$crypto_js_1.default.enc.Hex.parse(hash)).toString();
        return new Uint8Array($N0o3H.Buffer.from(hash, "hex"));
    }
    getEthAddress() {
        // Should be uncompressed.
        // And remove prefix byte.
        // And hash by keccak256.
        // Use last 20 bytes.
        return $25Pjl.Hash.keccak256(this.toBytes(true).slice(1)).slice(-20);
    }
    toKeyPair() {
        const secp256k1 = new $7kgn0.ec("secp256k1");
        return secp256k1.keyFromPublic($N0o3H.Buffer.from(this.pubKey).toString("hex"), "hex");
    }
    verifyDigest32(digest, signature) {
        if (digest.length !== 32) throw new Error(`Invalid length of digest to verify: ${digest.length}`);
        if (signature.length !== 64) throw new Error(`Invalid length of signature: ${signature.length}`);
        const secp256k1 = new $7kgn0.ec("secp256k1");
        const r = signature.slice(0, 32);
        const s = signature.slice(32);
        return secp256k1.verify(digest, {
            r: $N0o3H.Buffer.from(r).toString("hex"),
            s: $N0o3H.Buffer.from(s).toString("hex")
        }, this.toKeyPair());
    }
}
module.exports.PubKeySecp256k1 = $6ff3d912a1a149d2$var$PubKeySecp256k1;

});
parcelRegister("iRdU6", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("aXmnC")), (parcelRequire("eQ8Zr")), (parcelRequire("c8103")), (parcelRequire("jvzhn")), (parcelRequire("dMSCn")), (parcelRequire("48msz")), (parcelRequire("cXkgz")), (parcelRequire("1AknP")), (parcelRequire("7Owt5")), (parcelRequire("i42pO")), (parcelRequire("iIspk")), (parcelRequire("hWLSr")), (parcelRequire("f5G1W")), (parcelRequire("euibh")), (parcelRequire("8GMy5")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")), (parcelRequire("jPEON")), (parcelRequire("9Rzrs")), (parcelRequire("eeths")), (parcelRequire("2rHrC")), (parcelRequire("c71vM")), (parcelRequire("lEdDq")), (parcelRequire("6enLv")), (parcelRequire("eZVSw")), (parcelRequire("bWI4T")), (parcelRequire("dc0Ib")), (parcelRequire("9iW1U")), (parcelRequire("2wURc")), (parcelRequire("iKlAD")), (parcelRequire("6kPKX")), (parcelRequire("4GdrH")), (parcelRequire("l7F9r")), (parcelRequire("icnB6")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("kSeFg", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("foUwZ"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRegister("aXmnC", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("eQ8Zr", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("c8103", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("jvzhn", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("dMSCn", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRegister("48msz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("cXkgz", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("1AknP", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("7Owt5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("1AknP")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("i42pO", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("aXmnC")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("iIspk", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("aXmnC")), (parcelRequire("i42pO")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("hWLSr", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("aXmnC")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("f5G1W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("euibh", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("8GMy5", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("1AknP")), (parcelRequire("euibh")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("6F6dY", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("cXkgz")), (parcelRequire("euibh")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("2gPcz", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("6F6dY")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("jPEON", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("9Rzrs", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("eeths", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("2rHrC", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("c71vM", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("lEdDq", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("6enLv", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("eZVSw", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("bWI4T", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("dc0Ib", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("9iW1U", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("2wURc", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("iKlAD", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("6kPKX", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("4GdrH", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("l7F9r", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRegister("icnB6", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("kSeFg")), (parcelRequire("jvzhn")), (parcelRequire("48msz")), (parcelRequire("6F6dY")), (parcelRequire("2gPcz")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});


parcelRegister("25Pjl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $4msE6 = parcelRequire("4msE6");

var $Jhr88 = parcelRequire("Jhr88");

var $N0o3H = parcelRequire("N0o3H");
class $1863d9ac7403fef1$var$Hash {
    static sha256(data) {
        return new Uint8Array(new $4msE6.sha256().update(data).digest());
    }
    static keccak256(data) {
        return $N0o3H.Buffer.from((0, $Jhr88.keccak256)(data).replace("0x", ""), "hex");
    }
    static truncHashPortion(str, firstCharCount = str.length, endCharCount = 0) {
        return str.substring(0, firstCharCount) + "\u2026" + str.substring(str.length - endCharCount, str.length);
    }
}
module.exports.Hash = $1863d9ac7403fef1$var$Hash;

});




parcelRegister("f7OAj", function(module, exports) {
"use strict";
var $b02ebf808533e4e7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b02ebf808533e4e7$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b02ebf808533e4e7$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b02ebf808533e4e7$var$__exportStar((parcelRequire("eaJKl")), module.exports);

$b02ebf808533e4e7$var$__exportStar((parcelRequire("iY5cE")), module.exports);

});
parcelRegister("eaJKl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toGenerator = void 0;
// Copied from the mobx-state-tree repository.
/**
 * @experimental
 * experimental api - might change on minor/patch releases
 *
 * Convert a promise to a generator yielding that promise
 * This is intended to allow for usage of `yield*` in async actions to
 * retain the promise return type.
 *
 * Example:
 * ```ts
 * function getDataAsync(input: string): Promise<number> { ... }
 *
 * const someModel.actions(self => ({
 *   someAction: flow(function*() {
 *     // value is typed as number
 *     const value = yield* toGenerator(getDataAsync("input value"));
 *     ...
 *   })
 * }))
 * ```
 */ function* $a5157c2d9819f1e9$var$toGenerator(p) {
    return yield p;
}
module.exports.toGenerator = $a5157c2d9819f1e9$var$toGenerator;

});

parcelRegister("iY5cE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DebounceActionTimer = void 0;

var $2SBKn = parcelRequire("2SBKn");
class $dcf1ddcda056393c$var$DebounceActionTimer {
    constructor(debounceMs, handler){
        this.debounceMs = debounceMs;
        this.handler = handler;
        this.requests = [];
        this.startTime = 0;
        this.tick = ()=>{
            let shouldExec = this.debounceMs <= 0;
            if (this.debounceMs > 0) {
                const now = Date.now();
                if (now - this.startTime >= this.debounceMs) shouldExec = true;
            }
            if (shouldExec) {
                // Should use sliced (copied) array
                const requests = this.requests.slice();
                const responses = this.handler(requests);
                if (typeof responses === "object" && "then" in responses) Promise.resolve(responses).then((responses)=>{
                    this.handleResponses(requests, responses);
                });
                else this.handleResponses(requests, responses);
                this.requests = [];
            } else this.nextTick(this.tick);
        };
        this.handleResponses = (requests, responses)=>{
            (0, $2SBKn.runInAction)(()=>{
                for(let i = 0; i < requests.length; i++){
                    const req = requests[i];
                    const res = responses[i];
                    req.action(res);
                }
            });
            for (const req of requests)req.resolver();
        };
    }
    call(args, action) {
        return new Promise((resolve)=>{
            const newStart = this.requests.length === 0;
            this.requests.push({
                args: args,
                action: action,
                resolver: resolve
            });
            if (newStart) this.startTimer();
        });
    }
    startTimer() {
        this.startTime = Date.now();
        this.nextTick(this.tick);
    }
    nextTick(fn) {
        if (this.debounceMs <= 0) {
            Promise.resolve().then(fn);
            return;
        }
        if (typeof window !== "undefined" && window.requestAnimationFrame) window.requestAnimationFrame(fn);
        else setTimeout(fn, this.debounceMs);
    }
}
module.exports.DebounceActionTimer = $dcf1ddcda056393c$var$DebounceActionTimer;

});
parcelRegister("2SBKn", function(module, exports) {

$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
function isES6Map(thing) {
    return thing instanceof Map;
}
function isES6Set(thing) {
    return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.isPendingUnobservation_ = false;
        this.isBeingObserved_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // onBecomeObservedListeners
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return Atom;
}();
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    // Backwards/Legacy behavior, expects makeObservable(this)
    if (kind == "field") {
        addInitializer(function() {
            storeAnnotation(this, name, ann);
        });
        return;
    }
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    _inheritsLoose(ObservableValue, _Atom);
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ _Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    // during tracking it's an array with new observed observers
    // to check for cycles
    // N.B: unminified as it is used by MST
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        this.newObserving_ = null;
        this.isBeingObserved_ = false;
        this.isPendingUnobservation_ = false;
        this.observers_ = new Set();
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.isComputing_ = false;
        this.isRunningSetter_ = false;
        this.derivation = void 0;
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ ;
    _proto.get = function get() {
        if (this.isComputing_) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter_) die(33, this.name_);
            this.isRunningSetter_ = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter_ = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing_ = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing_ = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[_Symbol$toPrimitive$1] = function() {
        return this.valueOf();
    };
    return ComputedValue;
}();
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0(derivation);
    derivation.newObserving_ = new Array(derivation.observing_.length + 100);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue_ === 0) {
            dep.diffValue_ = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue_ === 0) removeObserver(_dep, derivation);
        _dep.diffValue_ = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue_ === 1) {
            _dep2.diffValue_ = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    this.version = 6;
    this.UNCHANGED = {};
    this.trackingDerivation = null;
    this.trackingContext = null;
    this.runId = 0;
    this.mobxGuid = 0;
    this.inBatch = 0;
    this.pendingUnobservations = [];
    this.pendingReactions = [];
    this.isRunningReactions = false;
    this.allowStateChanges = false;
    this.allowStateReads = true;
    this.enforceActions = true;
    this.spyListeners = [];
    this.globalReactionErrorHandlers = [];
    this.computedRequiresReaction = false;
    this.reactionRequiresObservable = false;
    this.observableRequiresReaction = false;
    this.disableErrorBoundaries = false;
    this.suppressReactionErrors = false;
    this.useProxies = true;
    this.verifyProxies = false;
    this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation_ === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation_ = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation_ = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved_) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved_ = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved_ && globalState.trackingContext) {
                observable.isBeingObserved_ = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved_;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    // nodes we are looking at. Our value depends on these nodes
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.diffValue_ = 0;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.isDisposed_ = false;
        this.isScheduled_ = false;
        this.isTrackPending_ = false;
        this.isRunning_ = false;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled_) {
            this.isScheduled_ = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.isScheduled = function isScheduled() {
        return this.isScheduled_;
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed_) {
            startBatch();
            this.isScheduled_ = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending_ = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed_) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning_ = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning_ = false;
        this.isTrackPending_ = false;
        if (this.isDisposed_) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed_) {
            this.isDisposed_ = true;
            if (!this.isRunning_) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return Reaction;
}();
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts2$signal, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed_) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2$signal = _opts2.signal) != null && _opts2$signal.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts4$signal, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var oldValue;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed_) return;
        var changed = false;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            oldValue = value;
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4$signal = _opts4.signal) != null && _opts4$signal.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed_) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    // this is the prop that gets proxied, so can't replace it!
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks recieve correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks recieve correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /*#__PURE__*/ function() {
    // hasMap, not hashMap >-).
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterable({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[_Symbol$iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (other.constructor !== Map) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
    return ObservableMap;
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
        // ideally, value = change.value would be done here, so that values can be
        // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var nextIndex = 0;
        var keys = Array.from(this.keys());
        var values = Array.from(this.values());
        return makeIterable({
            next: function next() {
                var index = nextIndex;
                nextIndex += 1;
                return index < values.length ? {
                    value: [
                        keys[index],
                        values[index]
                    ],
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var nextIndex = 0;
        var observableValues = Array.from(this.data_.values());
        return makeIterable({
            next: function next() {
                return nextIndex < observableValues.length ? {
                    value: self1.dehanceValue_(observableValues[nextIndex++]),
                    done: false
                } : {
                    done: true
                };
            }
        });
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[_Symbol$iterator$1] = function() {
        return this.values();
    };
    _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: _Symbol$toStringTag$1,
            get: function get() {
                return "Set";
            }
        }
    ]);
    return ObservableSet;
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_, _this$pendingKeys_$ge;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_$ge.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2, _this$pendingKeys_2$g;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2$g.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray, _Symbol$toStringTag, _Symbol$iterator) {
    _inheritsLoose(LegacyObservableArray, _StubArray);
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _assertThisInitialized(_this);
            addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
        });
        return _this;
    }
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[_Symbol$iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: _Symbol$toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
    return LegacyObservableArray;
}(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var key;
        length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = keys[length];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return iterator;
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});



parcelRegister("8iF3g", function(module, exports) {
"use strict";
var $60afd932192a19cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60afd932192a19cf$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $60afd932192a19cf$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$60afd932192a19cf$var$__exportStar((parcelRequire("SsOsG")), module.exports);

});
parcelRegister("SsOsG", function(module, exports) {
"use strict";
var $0a3b64e6c4bb3867$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Debouncer = void 0;
class $0a3b64e6c4bb3867$var$Debouncer {
    static promise(fn) {
        let currentPromise;
        return (...arguments_)=>$0a3b64e6c4bb3867$var$__awaiter(this, void 0, void 0, function*() {
                if (currentPromise) return currentPromise;
                try {
                    currentPromise = fn.apply(this, arguments_);
                    return yield currentPromise;
                } finally{
                    currentPromise = undefined;
                }
            });
    }
}
module.exports.Debouncer = $0a3b64e6c4bb3867$var$Debouncer;

});


parcelRegister("82nZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unescapeHTML = module.exports.escapeHTML = void 0;
/**
 * Escapes <,>,& in string.
 * Golang's json marshaller escapes <,>,& by default.
 * However, because JS doesn't do that by default, to match the sign doc with cosmos-sdk,
 * we should escape <,>,& in string manually.
 * @param str
 */ function $5da11de2cc13eaa4$var$escapeHTML(str) {
    return str.replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026");
}
module.exports.escapeHTML = $5da11de2cc13eaa4$var$escapeHTML;
/**
 * Unescapes \u003c/(<),\u003e(>),\u0026(&) in string.
 * Golang's json marshaller escapes <,>,& by default, whilst for most of the users, such escape characters are unfamiliar.
 * This function can be used to show the escaped characters with more familiar characters.
 * @param str
 */ function $5da11de2cc13eaa4$var$unescapeHTML(str) {
    return str.replace(/\\u003c/g, "<").replace(/\\u003e/g, ">").replace(/\\u0026/g, "&");
}
module.exports.unescapeHTML = $5da11de2cc13eaa4$var$unescapeHTML;

});

parcelRegister("cdZLN", function(module, exports) {
"use strict";
var $8e669d2d00993594$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8e669d2d00993594$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $8e669d2d00993594$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$8e669d2d00993594$var$__exportStar((parcelRequire("4q27I")), module.exports);

});
parcelRegister("4q27I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sortedJsonByKeyStringify = module.exports.sortObjectByKey = void 0;
function $337b3cd335bfd394$var$sortObjectByKey(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($337b3cd335bfd394$var$sortObjectByKey);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    sortedKeys.forEach((key)=>{
        result[key] = $337b3cd335bfd394$var$sortObjectByKey(obj[key]);
    });
    return result;
}
module.exports.sortObjectByKey = $337b3cd335bfd394$var$sortObjectByKey;
function $337b3cd335bfd394$var$sortedJsonByKeyStringify(obj) {
    return JSON.stringify($337b3cd335bfd394$var$sortObjectByKey(obj));
}
module.exports.sortedJsonByKeyStringify = $337b3cd335bfd394$var$sortedJsonByKeyStringify;

});


parcelRegister("flybR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateICNSName = module.exports.parseICNSName = void 0;
function $b2c356a4a2a95d0a$var$parseICNSName(name) {
    const split = name.split(".");
    if (split.length === 2) {
        if (split[0].length > 0 && split[1].length > 0) return [
            split[0],
            split[1]
        ];
    }
    return undefined;
}
module.exports.parseICNSName = $b2c356a4a2a95d0a$var$parseICNSName;
function $b2c356a4a2a95d0a$var$validateICNSName(name, bech32Prefix) {
    const parsed = $b2c356a4a2a95d0a$var$parseICNSName(name);
    if (!parsed) return false;
    return parsed[1] === bech32Prefix;
}
module.exports.validateICNSName = $b2c356a4a2a95d0a$var$validateICNSName;

});

parcelRegister("kP4XT", function(module, exports) {
"use strict";
var $f28c6c04270f083b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.retryInfinite = module.exports.retry = void 0;

var $jXaVZ = parcelRequire("jXaVZ");
function $f28c6c04270f083b$var$retry(task, opts) {
    return $f28c6c04270f083b$var$__awaiter(this, void 0, void 0, function*() {
        let retries = 0;
        while(true)try {
            const promise = task();
            return yield promise;
        } catch (e) {
            if (retries >= opts.maxRetries) throw e;
            if (opts.onFailed) opts.onFailed(e);
            let waitMs = opts.waitMsAfterError || 0;
            if (waitMs > 0) {
                if (opts.maxWaitMsAfterError != null && opts.maxWaitMsAfterError > 0) {
                    waitMs = Math.pow(2, retries) * waitMs;
                    waitMs = Math.min(waitMs, opts.maxWaitMsAfterError);
                }
                yield (0, $jXaVZ.sleep)(waitMs);
            }
            retries++;
        }
    });
}
module.exports.retry = $f28c6c04270f083b$var$retry;
function $f28c6c04270f083b$var$retryInfinite(task, opts) {
    return $f28c6c04270f083b$var$retry(task, Object.assign(Object.assign({}, opts), {
        maxRetries: Number.MAX_SAFE_INTEGER
    }));
}
module.exports.retryInfinite = $f28c6c04270f083b$var$retryInfinite;

});
parcelRegister("jXaVZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
function $e86c025b9401ca7d$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $e86c025b9401ca7d$var$sleep;

});










parcelRegister("c8gwn", function(module, exports) {
"use strict";
var $8d530c223b7f5777$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8d530c223b7f5777$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fReUp = parcelRequire("fReUp");

var $8d530c223b7f5777$var$bignumber_js_1 = $8d530c223b7f5777$var$__importDefault((parcelRequire("44pFF")));

var $eqANf = parcelRequire("eqANf");
var $8d530c223b7f5777$var$KyveBaseMsg = /** @class */ function(_super) {
    $8d530c223b7f5777$var$__extends(KyveBaseMsg, _super);
    function KyveBaseMsg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveBaseMsg.prototype.transfer = function(recipient, amount, options) {
        var _this = this;
        var tx = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: this.account.address,
                toAddress: recipient,
                amount: (0, $fReUp.coins)(amount, this.config.coinDenom)
            }
        };
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveBaseMsg.prototype.multiTransfer = function(recipient, amount, options) {
        var _this = this;
        var allAmount = new $8d530c223b7f5777$var$bignumber_js_1.default(amount).multipliedBy(recipient.length);
        var tx = {
            typeUrl: "/cosmos.bank.v1beta1.MsgMultiSend",
            value: {
                inputs: [
                    {
                        address: this.account.address,
                        coins: (0, $fReUp.coins)(allAmount.toString(), this.config.coinDenom)
                    }
                ],
                outputs: recipient.map(function(address) {
                    return {
                        address: address,
                        coins: (0, $fReUp.coins)(amount, _this.config.coinDenom)
                    };
                })
            }
        };
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveBaseMsg.prototype.txsAll = function(txs, options) {
        var _this = this;
        var txMessages = txs.map(function(tx) {
            return tx.tx;
        }).flat();
        return new $eqANf.PendingTx({
            tx: txMessages
        }, function() {
            return _this.getPendingSignedTx(txMessages, options);
        });
    };
    return KyveBaseMsg;
}($eqANf.KyveSigning);
module.exports.default = $8d530c223b7f5777$var$KyveBaseMsg;

});
parcelRegister("fReUp", function(module, exports) {
"use strict";
var $02fab313f81a4fb4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $02fab313f81a4fb4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $02fab313f81a4fb4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $02fab313f81a4fb4$var$__createBinding(result, mod, k);
    }
    $02fab313f81a4fb4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgWithdrawDelegatorRewardEncodeObject = module.exports.isMsgVoteWeightedEncodeObject = module.exports.isMsgVoteEncodeObject = module.exports.isMsgUndelegateEncodeObject = module.exports.isMsgTransferEncodeObject = module.exports.isMsgSubmitProposalEncodeObject = module.exports.isMsgSendEncodeObject = module.exports.isMsgEditValidatorEncodeObject = module.exports.isMsgDepositEncodeObject = module.exports.isMsgDelegateEncodeObject = module.exports.isMsgCreateValidatorEncodeObject = module.exports.isMsgBeginRedelegateEncodeObject = module.exports.isAminoMsgWithdrawValidatorCommission = module.exports.isAminoMsgWithdrawDelegatorReward = module.exports.isAminoMsgVoteWeighted = module.exports.isAminoMsgVote = module.exports.isAminoMsgVerifyInvariant = module.exports.isAminoMsgUnjail = module.exports.isAminoMsgUndelegate = module.exports.isAminoMsgTransfer = module.exports.isAminoMsgSubmitProposal = module.exports.isAminoMsgSubmitEvidence = module.exports.isAminoMsgSetWithdrawAddress = module.exports.isAminoMsgSend = module.exports.isAminoMsgMultiSend = module.exports.isAminoMsgFundCommunityPool = module.exports.isAminoMsgEditValidator = module.exports.isAminoMsgDeposit = module.exports.isAminoMsgDelegate = module.exports.isAminoMsgCreateVestingAccount = module.exports.isAminoMsgCreateValidator = module.exports.isAminoMsgBeginRedelegate = module.exports.createVestingAminoConverters = module.exports.createStakingAminoConverters = module.exports.createSlashingAminoConverters = module.exports.createIbcAminoConverters = module.exports.createGroupAminoConverters = module.exports.createGovAminoConverters = module.exports.createFeegrantAminoConverters = module.exports.createEvidenceAminoConverters = module.exports.createDistributionAminoConverters = module.exports.createCrysisAminoConverters = module.exports.createBankAminoConverters = module.exports.createAuthzAminoConverters = module.exports.logs = module.exports.GasPrice = module.exports.calculateFee = module.exports.fromTendermintEvent = module.exports.AminoTypes = module.exports.accountFromAny = void 0;
module.exports.parseCoins = module.exports.makeCosmoshubPath = module.exports.coins = module.exports.coin = module.exports.TimeoutError = module.exports.StargateClient = module.exports.isDeliverTxSuccess = module.exports.isDeliverTxFailure = module.exports.BroadcastTxError = module.exports.assertIsDeliverTxSuccess = module.exports.assertIsDeliverTxFailure = module.exports.SigningStargateClient = module.exports.defaultRegistryTypes = module.exports.createDefaultAminoConverters = module.exports.QueryClient = module.exports.decodeCosmosSdkDecFromProto = module.exports.createProtobufRpcClient = module.exports.createPagination = module.exports.makeMultisignedTxBytes = module.exports.makeMultisignedTx = module.exports.setupTxExtension = module.exports.setupStakingExtension = module.exports.setupSlashingExtension = module.exports.setupMintExtension = module.exports.setupIbcExtension = module.exports.setupGovExtension = module.exports.setupFeegrantExtension = module.exports.setupDistributionExtension = module.exports.setupBankExtension = module.exports.setupAuthzExtension = module.exports.setupAuthExtension = void 0;

var $kewCN = parcelRequire("kewCN");
Object.defineProperty(module.exports, "accountFromAny", {
    enumerable: true,
    get: function() {
        return $kewCN.accountFromAny;
    }
});

var $7iLoQ = parcelRequire("7iLoQ");
Object.defineProperty(module.exports, "AminoTypes", {
    enumerable: true,
    get: function() {
        return $7iLoQ.AminoTypes;
    }
});

var $7a0MP = parcelRequire("7a0MP");
Object.defineProperty(module.exports, "fromTendermintEvent", {
    enumerable: true,
    get: function() {
        return $7a0MP.fromTendermintEvent;
    }
});

var $c8wER = parcelRequire("c8wER");
Object.defineProperty(module.exports, "calculateFee", {
    enumerable: true,
    get: function() {
        return $c8wER.calculateFee;
    }
});
Object.defineProperty(module.exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $c8wER.GasPrice;
    }
});

module.exports.logs = $02fab313f81a4fb4$var$__importStar((parcelRequire("jqoFk")));

var $6qSFW = parcelRequire("6qSFW");
Object.defineProperty(module.exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createAuthzAminoConverters;
    }
});
Object.defineProperty(module.exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createBankAminoConverters;
    }
});
Object.defineProperty(module.exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createCrysisAminoConverters;
    }
});
Object.defineProperty(module.exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createDistributionAminoConverters;
    }
});
Object.defineProperty(module.exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createEvidenceAminoConverters;
    }
});
Object.defineProperty(module.exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createFeegrantAminoConverters;
    }
});
Object.defineProperty(module.exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createGovAminoConverters;
    }
});
Object.defineProperty(module.exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createGroupAminoConverters;
    }
});
Object.defineProperty(module.exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createIbcAminoConverters;
    }
});
Object.defineProperty(module.exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createSlashingAminoConverters;
    }
});
Object.defineProperty(module.exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createStakingAminoConverters;
    }
});
Object.defineProperty(module.exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $6qSFW.createVestingAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty(module.exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgCreateValidator;
    }
});
Object.defineProperty(module.exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgCreateVestingAccount;
    }
});
Object.defineProperty(module.exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgDelegate;
    }
});
Object.defineProperty(module.exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgDeposit;
    }
});
Object.defineProperty(module.exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgEditValidator;
    }
});
Object.defineProperty(module.exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty(module.exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgMultiSend;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgSend;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgSubmitEvidence;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty(module.exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgTransfer;
    }
});
Object.defineProperty(module.exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgUndelegate;
    }
});
Object.defineProperty(module.exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgUnjail;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgVerifyInvariant;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgVote;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgVoteWeighted;
    }
});
Object.defineProperty(module.exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty(module.exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $6qSFW.isAminoMsgWithdrawValidatorCommission;
    }
});
Object.defineProperty(module.exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgDepositEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgSendEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgTransferEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgVoteEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgVoteWeightedEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $6qSFW.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupAuthExtension;
    }
});
Object.defineProperty(module.exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupAuthzExtension;
    }
});
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupBankExtension;
    }
});
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupDistributionExtension;
    }
});
Object.defineProperty(module.exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupFeegrantExtension;
    }
});
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupGovExtension;
    }
});
Object.defineProperty(module.exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupIbcExtension;
    }
});
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupMintExtension;
    }
});
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupSlashingExtension;
    }
});
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupStakingExtension;
    }
});
Object.defineProperty(module.exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $6qSFW.setupTxExtension;
    }
});

var $jvj3I = parcelRequire("jvj3I");
Object.defineProperty(module.exports, "makeMultisignedTx", {
    enumerable: true,
    get: function() {
        return $jvj3I.makeMultisignedTx;
    }
});
Object.defineProperty(module.exports, "makeMultisignedTxBytes", {
    enumerable: true,
    get: function() {
        return $jvj3I.makeMultisignedTxBytes;
    }
});

var $5E3xG = parcelRequire("5E3xG");
Object.defineProperty(module.exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $5E3xG.createPagination;
    }
});
Object.defineProperty(module.exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $5E3xG.createProtobufRpcClient;
    }
});
Object.defineProperty(module.exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $5E3xG.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty(module.exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $5E3xG.QueryClient;
    }
});

var $9NBGi = parcelRequire("9NBGi");
Object.defineProperty(module.exports, "createDefaultAminoConverters", {
    enumerable: true,
    get: function() {
        return $9NBGi.createDefaultAminoConverters;
    }
});
Object.defineProperty(module.exports, "defaultRegistryTypes", {
    enumerable: true,
    get: function() {
        return $9NBGi.defaultRegistryTypes;
    }
});
Object.defineProperty(module.exports, "SigningStargateClient", {
    enumerable: true,
    get: function() {
        return $9NBGi.SigningStargateClient;
    }
});

var $d6b9W = parcelRequire("d6b9W");
Object.defineProperty(module.exports, "assertIsDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $d6b9W.assertIsDeliverTxFailure;
    }
});
Object.defineProperty(module.exports, "assertIsDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $d6b9W.assertIsDeliverTxSuccess;
    }
});
Object.defineProperty(module.exports, "BroadcastTxError", {
    enumerable: true,
    get: function() {
        return $d6b9W.BroadcastTxError;
    }
});
Object.defineProperty(module.exports, "isDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $d6b9W.isDeliverTxFailure;
    }
});
Object.defineProperty(module.exports, "isDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $d6b9W.isDeliverTxSuccess;
    }
});
Object.defineProperty(module.exports, "StargateClient", {
    enumerable: true,
    get: function() {
        return $d6b9W.StargateClient;
    }
});
Object.defineProperty(module.exports, "TimeoutError", {
    enumerable: true,
    get: function() {
        return $d6b9W.TimeoutError;
    }
});

var $dtY18 = parcelRequire("dtY18");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $dtY18.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $dtY18.coins;
    }
});
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $dtY18.makeCosmoshubPath;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $dtY18.parseCoins;
    }
});

});
parcelRegister("kewCN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accountFromAny = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $dtY18 = parcelRequire("dtY18");

var $hm8y1 = parcelRequire("hm8y1");

var $295om = parcelRequire("295om");

var $de2Rr = parcelRequire("de2Rr");
function $ebae6c084f066162$var$uint64FromProto(input) {
    return $h3uvW.Uint64.fromString(input.toString());
}
function $ebae6c084f066162$var$accountFromBaseAccount(input) {
    const { address: address, pubKey: pubKey, accountNumber: accountNumber, sequence: sequence } = input;
    const pubkey = pubKey ? (0, $dtY18.decodePubkey)(pubKey) : null;
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: $ebae6c084f066162$var$uint64FromProto(accountNumber).toNumber(),
        sequence: $ebae6c084f066162$var$uint64FromProto(sequence).toNumber()
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */ function $ebae6c084f066162$var$accountFromAny(input) {
    const { typeUrl: typeUrl, value: value } = input;
    switch(typeUrl){
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return $ebae6c084f066162$var$accountFromBaseAccount($295om.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount":
            {
                const baseAccount = $295om.ModuleAccount.decode(value).baseAccount;
                (0, $hm8y1.assert)(baseAccount);
                return $ebae6c084f066162$var$accountFromBaseAccount(baseAccount);
            }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
            {
                const baseAccount = $de2Rr.BaseVestingAccount.decode(value)?.baseAccount;
                (0, $hm8y1.assert)(baseAccount);
                return $ebae6c084f066162$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
            {
                const baseAccount = $de2Rr.ContinuousVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $hm8y1.assert)(baseAccount);
                return $ebae6c084f066162$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
            {
                const baseAccount = $de2Rr.DelayedVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $hm8y1.assert)(baseAccount);
                return $ebae6c084f066162$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
            {
                const baseAccount = $de2Rr.PeriodicVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $hm8y1.assert)(baseAccount);
                return $ebae6c084f066162$var$accountFromBaseAccount(baseAccount);
            }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
module.exports.accountFromAny = $ebae6c084f066162$var$accountFromAny;

});
parcelRegister("h3uvW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $9uFAc = parcelRequire("9uFAc");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $9uFAc.Decimal;
    }
});

var $kcC57 = parcelRequire("kcC57");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $kcC57.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $kcC57.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $kcC57.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $kcC57.Uint64;
    }
});

});
parcelRegister("9uFAc", function(module, exports) {
"use strict";
var $6e972be39ea51f37$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $6e972be39ea51f37$var$bn_js_1 = $6e972be39ea51f37$var$__importDefault((parcelRequire("lONYJ")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $6e972be39ea51f37$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $6e972be39ea51f37$var$Decimal {
    static fromUserInput(input, fractionalDigits) {
        $6e972be39ea51f37$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input === "") {
            whole = "0";
            fractional = "";
        } else if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $6e972be39ea51f37$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $6e972be39ea51f37$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $6e972be39ea51f37$var$Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static zero(fractionalDigits) {
        $6e972be39ea51f37$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $6e972be39ea51f37$var$Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static one(fractionalDigits) {
        $6e972be39ea51f37$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $6e972be39ea51f37$var$Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $6e972be39ea51f37$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$6e972be39ea51f37$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $6e972be39ea51f37$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    constructor(atomics, fractionalDigits){
        if (!atomics.match(/^[0-9]+$/)) throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        this.data = {
            atomics: new $6e972be39ea51f37$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    /** Creates a new instance with the same value */ clone() {
        return new $6e972be39ea51f37$var$Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */ floor() {
        const factor = new $6e972be39ea51f37$var$bn_js_1.default(10).pow(new $6e972be39ea51f37$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $6e972be39ea51f37$var$Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */ ceil() {
        const factor = new $6e972be39ea51f37$var$bn_js_1.default(10).pow(new $6e972be39ea51f37$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $6e972be39ea51f37$var$Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
    }
    toString() {
        const factor = new $6e972be39ea51f37$var$bn_js_1.default(10).pow(new $6e972be39ea51f37$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $6e972be39ea51f37$var$bn_js_1.default(b.atomics));
        return new $6e972be39ea51f37$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $6e972be39ea51f37$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $6e972be39ea51f37$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $6e972be39ea51f37$var$bn_js_1.default(b.toString()));
        return new $6e972be39ea51f37$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $6e972be39ea51f37$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $6e972be39ea51f37$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $6e972be39ea51f37$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $6e972be39ea51f37$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $6e972be39ea51f37$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $6e972be39ea51f37$var$Decimal;

});

parcelRegister("kcC57", function(module, exports) {
"use strict";
var $eb5277dac872ad82$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $eb5277dac872ad82$var$bn_js_1 = $eb5277dac872ad82$var$__importDefault((parcelRequire("lONYJ")));
const $eb5277dac872ad82$var$uint64MaxValue = new $eb5277dac872ad82$var$bn_js_1.default("18446744073709551615", 10, "be");
class $eb5277dac872ad82$var$Uint32 {
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $eb5277dac872ad82$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $eb5277dac872ad82$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $eb5277dac872ad82$var$Uint32(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $eb5277dac872ad82$var$Uint32;
class $eb5277dac872ad82$var$Int53 {
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $eb5277dac872ad82$var$Int53(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $eb5277dac872ad82$var$Int53;
class $eb5277dac872ad82$var$Uint53 {
    static fromString(str) {
        const signed = $eb5277dac872ad82$var$Int53.fromString(str);
        return new $eb5277dac872ad82$var$Uint53(signed.toNumber());
    }
    constructor(input){
        const signed = new $eb5277dac872ad82$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    toNumber() {
        return this.data.toNumber();
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $eb5277dac872ad82$var$Uint53;
class $eb5277dac872ad82$var$Uint64 {
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $eb5277dac872ad82$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $eb5277dac872ad82$var$Uint64(new $eb5277dac872ad82$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $eb5277dac872ad82$var$Uint64(new $eb5277dac872ad82$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $eb5277dac872ad82$var$bn_js_1.default(input);
        } catch  {
            throw new Error("Input is not a safe integer");
        }
        return new $eb5277dac872ad82$var$Uint64(bigint);
    }
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($eb5277dac872ad82$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toBigInt() {
        return BigInt(this.toString());
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $eb5277dac872ad82$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $eb5277dac872ad82$var$_int53Class = $eb5277dac872ad82$var$Int53;
const $eb5277dac872ad82$var$_uint53Class = $eb5277dac872ad82$var$Uint53;
const $eb5277dac872ad82$var$_uint32Class = $eb5277dac872ad82$var$Uint32;
const $eb5277dac872ad82$var$_uint64Class = $eb5277dac872ad82$var$Uint64;

});


parcelRegister("dtY18", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.coins = module.exports.coin = module.exports.executeKdf = module.exports.makeSignDoc = module.exports.makeSignBytes = module.exports.makeAuthInfoBytes = module.exports.isOfflineDirectSigner = module.exports.Registry = module.exports.isTxBodyEncodeObject = module.exports.isTsProtoGeneratedType = module.exports.isPbjsGeneratedType = module.exports.encodePubkey = module.exports.decodePubkey = module.exports.anyToSinglePubkey = module.exports.makeCosmoshubPath = module.exports.DirectSecp256k1Wallet = module.exports.extractKdfConfiguration = module.exports.DirectSecp256k1HdWallet = module.exports.decodeTxRaw = module.exports.parseCoins = void 0;

var $53Aub = parcelRequire("53Aub");
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $53Aub.parseCoins;
    }
});

var $kcKtj = parcelRequire("kcKtj");
Object.defineProperty(module.exports, "decodeTxRaw", {
    enumerable: true,
    get: function() {
        return $kcKtj.decodeTxRaw;
    }
});

var $hgtSC = parcelRequire("hgtSC");
Object.defineProperty(module.exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $hgtSC.DirectSecp256k1HdWallet;
    }
});
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $hgtSC.extractKdfConfiguration;
    }
});

var $dS9aH = parcelRequire("dS9aH");
Object.defineProperty(module.exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $dS9aH.DirectSecp256k1Wallet;
    }
});

var $2EKyl = parcelRequire("2EKyl");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $2EKyl.makeCosmoshubPath;
    }
});

var $lwiyx = parcelRequire("lwiyx");
Object.defineProperty(module.exports, "anyToSinglePubkey", {
    enumerable: true,
    get: function() {
        return $lwiyx.anyToSinglePubkey;
    }
});
Object.defineProperty(module.exports, "decodePubkey", {
    enumerable: true,
    get: function() {
        return $lwiyx.decodePubkey;
    }
});
Object.defineProperty(module.exports, "encodePubkey", {
    enumerable: true,
    get: function() {
        return $lwiyx.encodePubkey;
    }
});

var $45qwh = parcelRequire("45qwh");
Object.defineProperty(module.exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function() {
        return $45qwh.isPbjsGeneratedType;
    }
});
Object.defineProperty(module.exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function() {
        return $45qwh.isTsProtoGeneratedType;
    }
});
Object.defineProperty(module.exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function() {
        return $45qwh.isTxBodyEncodeObject;
    }
});
Object.defineProperty(module.exports, "Registry", {
    enumerable: true,
    get: function() {
        return $45qwh.Registry;
    }
});

var $1FNkZ = parcelRequire("1FNkZ");
Object.defineProperty(module.exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function() {
        return $1FNkZ.isOfflineDirectSigner;
    }
});

var $7eoti = parcelRequire("7eoti");
Object.defineProperty(module.exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function() {
        return $7eoti.makeAuthInfoBytes;
    }
});
Object.defineProperty(module.exports, "makeSignBytes", {
    enumerable: true,
    get: function() {
        return $7eoti.makeSignBytes;
    }
});
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $7eoti.makeSignDoc;
    }
});

var $lLiFz = parcelRequire("lLiFz");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $lLiFz.executeKdf;
    }
});

var $bVJSA = parcelRequire("bVJSA");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $bVJSA.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $bVJSA.coins;
    }
});

});
parcelRegister("53Aub", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */ function $3ae988e84689b8e5$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
module.exports.parseCoins = $3ae988e84689b8e5$var$parseCoins;

});

parcelRegister("kcKtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeTxRaw = void 0;

var $bkT1A = parcelRequire("bkT1A");
/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $eb58f9f848745971$var$decodeTxRaw(tx) {
    const txRaw = $bkT1A.TxRaw.decode(tx);
    return {
        authInfo: $bkT1A.AuthInfo.decode(txRaw.authInfoBytes),
        body: $bkT1A.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
module.exports.decodeTxRaw = $eb58f9f848745971$var$decodeTxRaw;

});
parcelRegister("bkT1A", function(module, exports) {
"use strict";
var $840c3eb844eacc7b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $840c3eb844eacc7b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $840c3eb844eacc7b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $840c3eb844eacc7b$var$__createBinding(result, mod, k);
    }
    $840c3eb844eacc7b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuxSignerData = module.exports.Tip = module.exports.Fee = module.exports.ModeInfo_Multi = module.exports.ModeInfo_Single = module.exports.ModeInfo = module.exports.SignerInfo = module.exports.AuthInfo = module.exports.TxBody = module.exports.SignDocDirectAux = module.exports.SignDoc = module.exports.TxRaw = module.exports.Tx = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $67U77 = parcelRequire("67U77");

var $eNZfD = parcelRequire("eNZfD");

var $efcGD = parcelRequire("efcGD");

var $dkaBG = parcelRequire("dkaBG");

const $840c3eb844eacc7b$var$_m0 = $840c3eb844eacc7b$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.tx.v1beta1";
function $840c3eb844eacc7b$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
module.exports.Tx = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.body !== undefined) module.exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) module.exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = module.exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = module.exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            body: (0, $dkaBG.isSet)(object.body) ? module.exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: (0, $dkaBG.isSet)(object.authInfo) ? module.exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? module.exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? module.exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? module.exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? module.exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
module.exports.TxRaw = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseTxRaw();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $dkaBG.isSet)(object.bodyBytes) ? (0, $dkaBG.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $dkaBG.isSet)(object.authInfoBytes) ? (0, $dkaBG.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $dkaBG.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $dkaBG.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseTxRaw();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: $dkaBG.Long.UZERO
    };
}
module.exports.SignDoc = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseSignDoc();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $dkaBG.isSet)(object.bodyBytes) ? (0, $dkaBG.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $dkaBG.isSet)(object.authInfoBytes) ? (0, $dkaBG.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            chainId: (0, $dkaBG.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $dkaBG.isSet)(object.accountNumber) ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $dkaBG.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $dkaBG.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseSignDoc();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseSignDocDirectAux() {
    return {
        bodyBytes: new Uint8Array(),
        publicKey: undefined,
        chainId: "",
        accountNumber: $dkaBG.Long.UZERO,
        sequence: $dkaBG.Long.UZERO,
        tip: undefined
    };
}
module.exports.SignDocDirectAux = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.publicKey !== undefined) $axIO3.Any.encode(message.publicKey, writer.uint32(18).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(40).uint64(message.sequence);
        if (message.tip !== undefined) module.exports.Tip.encode(message.tip, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseSignDocDirectAux();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.publicKey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                case 5:
                    message.sequence = reader.uint64();
                    break;
                case 6:
                    message.tip = module.exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $dkaBG.isSet)(object.bodyBytes) ? (0, $dkaBG.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            publicKey: (0, $dkaBG.isSet)(object.publicKey) ? $axIO3.Any.fromJSON(object.publicKey) : undefined,
            chainId: (0, $dkaBG.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $dkaBG.isSet)(object.accountNumber) ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO,
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO,
            tip: (0, $dkaBG.isSet)(object.tip) ? module.exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $dkaBG.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $axIO3.Any.toJSON(message.publicKey) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $dkaBG.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        message.tip !== undefined && (obj.tip = message.tip ? module.exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseSignDocDirectAux();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $axIO3.Any.fromPartial(object.publicKey) : undefined;
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        message.tip = object.tip !== undefined && object.tip !== null ? module.exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: $dkaBG.Long.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
module.exports.TxBody = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        for (const v of message.messages)$axIO3.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$axIO3.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$axIO3.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseTxBody();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            memo: (0, $dkaBG.isSet)(object.memo) ? String(object.memo) : "",
            timeoutHeight: (0, $dkaBG.isSet)(object.timeoutHeight) ? $dkaBG.Long.fromValue(object.timeoutHeight) : $dkaBG.Long.UZERO,
            extensionOptions: Array.isArray(object?.extensionOptions) ? object.extensionOptions.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            nonCriticalExtensionOptions: Array.isArray(object?.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $dkaBG.Long.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseTxBody();
        message.messages = object.messages?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.memo = object.memo ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $dkaBG.Long.fromValue(object.timeoutHeight) : $dkaBG.Long.UZERO;
        message.extensionOptions = object.extensionOptions?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.nonCriticalExtensionOptions = object.nonCriticalExtensionOptions?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined,
        tip: undefined
    };
}
module.exports.AuthInfo = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        for (const v of message.signerInfos)module.exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) module.exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        if (message.tip !== undefined) module.exports.Tip.encode(message.tip, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseAuthInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push(module.exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = module.exports.Fee.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tip = module.exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signerInfos: Array.isArray(object?.signerInfos) ? object.signerInfos.map((e)=>module.exports.SignerInfo.fromJSON(e)) : [],
            fee: (0, $dkaBG.isSet)(object.fee) ? module.exports.Fee.fromJSON(object.fee) : undefined,
            tip: (0, $dkaBG.isSet)(object.tip) ? module.exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? module.exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? module.exports.Fee.toJSON(message.fee) : undefined);
        message.tip !== undefined && (obj.tip = message.tip ? module.exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseAuthInfo();
        message.signerInfos = object.signerInfos?.map((e)=>module.exports.SignerInfo.fromPartial(e)) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? module.exports.Fee.fromPartial(object.fee) : undefined;
        message.tip = object.tip !== undefined && object.tip !== null ? module.exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.SignerInfo = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $axIO3.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) module.exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseSignerInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = module.exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $dkaBG.isSet)(object.publicKey) ? $axIO3.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: (0, $dkaBG.isSet)(object.modeInfo) ? module.exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $axIO3.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? module.exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $axIO3.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? module.exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.ModeInfo = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.single !== undefined) module.exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseModeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $dkaBG.isSet)(object.single) ? module.exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: (0, $dkaBG.isSet)(object.multi) ? module.exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? module.exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
module.exports.ModeInfo_Single = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $dkaBG.isSet)(object.mode) ? (0, $67U77.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, $67U77.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseModeInfo_Single();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
module.exports.ModeInfo_Multi = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $eNZfD.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)module.exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $eNZfD.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push(module.exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $dkaBG.isSet)(object.bitarray) ? $eNZfD.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object?.modeInfos) ? object.modeInfos.map((e)=>module.exports.ModeInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $eNZfD.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? module.exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $eNZfD.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = object.modeInfos?.map((e)=>module.exports.ModeInfo.fromPartial(e)) || [];
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: $dkaBG.Long.UZERO,
        payer: "",
        granter: ""
    };
}
module.exports.Fee = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            gasLimit: (0, $dkaBG.isSet)(object.gasLimit) ? $dkaBG.Long.fromValue(object.gasLimit) : $dkaBG.Long.UZERO,
            payer: (0, $dkaBG.isSet)(object.payer) ? String(object.payer) : "",
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $dkaBG.Long.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseFee();
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $dkaBG.Long.fromValue(object.gasLimit) : $dkaBG.Long.UZERO;
        message.payer = object.payer ?? "";
        message.granter = object.granter ?? "";
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseTip() {
    return {
        amount: [],
        tipper: ""
    };
}
module.exports.Tip = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.tipper !== "") writer.uint32(18).string(message.tipper);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseTip();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tipper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            tipper: (0, $dkaBG.isSet)(object.tipper) ? String(object.tipper) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.tipper !== undefined && (obj.tipper = message.tipper);
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseTip();
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.tipper = object.tipper ?? "";
        return message;
    }
};
function $840c3eb844eacc7b$var$createBaseAuxSignerData() {
    return {
        address: "",
        signDoc: undefined,
        mode: 0,
        sig: new Uint8Array()
    };
}
module.exports.AuxSignerData = {
    encode (message, writer = $840c3eb844eacc7b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.signDoc !== undefined) module.exports.SignDocDirectAux.encode(message.signDoc, writer.uint32(18).fork()).ldelim();
        if (message.mode !== 0) writer.uint32(24).int32(message.mode);
        if (message.sig.length !== 0) writer.uint32(34).bytes(message.sig);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $840c3eb844eacc7b$var$_m0.Reader ? input : new $840c3eb844eacc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $840c3eb844eacc7b$var$createBaseAuxSignerData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.signDoc = module.exports.SignDocDirectAux.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.mode = reader.int32();
                    break;
                case 4:
                    message.sig = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            signDoc: (0, $dkaBG.isSet)(object.signDoc) ? module.exports.SignDocDirectAux.fromJSON(object.signDoc) : undefined,
            mode: (0, $dkaBG.isSet)(object.mode) ? (0, $67U77.signModeFromJSON)(object.mode) : 0,
            sig: (0, $dkaBG.isSet)(object.sig) ? (0, $dkaBG.bytesFromBase64)(object.sig) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.signDoc !== undefined && (obj.signDoc = message.signDoc ? module.exports.SignDocDirectAux.toJSON(message.signDoc) : undefined);
        message.mode !== undefined && (obj.mode = (0, $67U77.signModeToJSON)(message.mode));
        message.sig !== undefined && (obj.sig = (0, $dkaBG.base64FromBytes)(message.sig !== undefined ? message.sig : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $840c3eb844eacc7b$var$createBaseAuxSignerData();
        message.address = object.address ?? "";
        message.signDoc = object.signDoc !== undefined && object.signDoc !== null ? module.exports.SignDocDirectAux.fromPartial(object.signDoc) : undefined;
        message.mode = object.mode ?? 0;
        message.sig = object.sig ?? new Uint8Array();
        return message;
    }
};

});
parcelRegister("axIO3", function(module, exports) {
"use strict";
var $7acfbe09db876a0d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7acfbe09db876a0d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7acfbe09db876a0d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7acfbe09db876a0d$var$__createBinding(result, mod, k);
    }
    $7acfbe09db876a0d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $7acfbe09db876a0d$var$_m0 = $7acfbe09db876a0d$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "google.protobuf";
function $7acfbe09db876a0d$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
module.exports.Any = {
    encode (message, writer = $7acfbe09db876a0d$var$_m0.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7acfbe09db876a0d$var$_m0.Reader ? input : new $7acfbe09db876a0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7acfbe09db876a0d$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: (0, $dkaBG.isSet)(object.typeUrl) ? String(object.typeUrl) : "",
            value: (0, $dkaBG.isSet)(object.value) ? (0, $dkaBG.bytesFromBase64)(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = (0, $dkaBG.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $7acfbe09db876a0d$var$createBaseAny();
        message.typeUrl = object.typeUrl ?? "";
        message.value = object.value ?? new Uint8Array();
        return message;
    }
};

});
parcelRegister("dkaBG", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $9b355ee2cbe0a1af$require$Buffer = $N0o3H.Buffer;
"use strict";
/* eslint-disable */ /**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.94.1
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */ var $9b355ee2cbe0a1af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9b355ee2cbe0a1af$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9b355ee2cbe0a1af$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9b355ee2cbe0a1af$var$__createBinding(result, mod, k);
    }
    $9b355ee2cbe0a1af$var$__setModuleDefault(result, mod);
    return result;
};
var $9b355ee2cbe0a1af$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromJsonTimestamp = module.exports.fromTimestamp = module.exports.toTimestamp = module.exports.setPaginationParams = module.exports.isObject = module.exports.isSet = module.exports.fromDuration = module.exports.toDuration = module.exports.omitDefault = module.exports.base64FromBytes = module.exports.bytesFromBase64 = module.exports.Long = void 0;

const $9b355ee2cbe0a1af$var$_m0 = $9b355ee2cbe0a1af$var$__importStar((parcelRequire("1wC51")));

const $9b355ee2cbe0a1af$var$long_1 = $9b355ee2cbe0a1af$var$__importDefault((parcelRequire("3gmZQ")));
module.exports.Long = $9b355ee2cbe0a1af$var$long_1.default;
// @ts-ignore
if ($9b355ee2cbe0a1af$var$_m0.util.Long !== $9b355ee2cbe0a1af$var$long_1.default) {
    $9b355ee2cbe0a1af$var$_m0.util.Long = $9b355ee2cbe0a1af$var$long_1.default;
    $9b355ee2cbe0a1af$var$_m0.configure();
}
var $9b355ee2cbe0a1af$var$globalThis = (()=>{
    if (typeof $9b355ee2cbe0a1af$var$globalThis !== "undefined") return $9b355ee2cbe0a1af$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $9b355ee2cbe0a1af$var$atob = $9b355ee2cbe0a1af$var$globalThis.atob || ((b64)=>$9b355ee2cbe0a1af$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $9b355ee2cbe0a1af$var$bytesFromBase64(b64) {
    const bin = $9b355ee2cbe0a1af$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
module.exports.bytesFromBase64 = $9b355ee2cbe0a1af$var$bytesFromBase64;
const $9b355ee2cbe0a1af$var$btoa = $9b355ee2cbe0a1af$var$globalThis.btoa || ((bin)=>$9b355ee2cbe0a1af$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $9b355ee2cbe0a1af$var$base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte)=>{
        bin.push(String.fromCharCode(byte));
    });
    return $9b355ee2cbe0a1af$var$btoa(bin.join(""));
}
module.exports.base64FromBytes = $9b355ee2cbe0a1af$var$base64FromBytes;
function $9b355ee2cbe0a1af$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($9b355ee2cbe0a1af$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type ${typeof input}`);
}
module.exports.omitDefault = $9b355ee2cbe0a1af$var$omitDefault;
function $9b355ee2cbe0a1af$var$toDuration(duration) {
    return {
        seconds: $9b355ee2cbe0a1af$var$long_1.default.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000
    };
}
module.exports.toDuration = $9b355ee2cbe0a1af$var$toDuration;
function $9b355ee2cbe0a1af$var$fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
module.exports.fromDuration = $9b355ee2cbe0a1af$var$fromDuration;
function $9b355ee2cbe0a1af$var$isSet(value) {
    return value !== null && value !== undefined;
}
module.exports.isSet = $9b355ee2cbe0a1af$var$isSet;
function $9b355ee2cbe0a1af$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
module.exports.isObject = $9b355ee2cbe0a1af$var$isObject;
const $9b355ee2cbe0a1af$var$setPaginationParams = (options, pagination)=>{
    if (!pagination) return options;
    if (typeof pagination?.countTotal !== "undefined") options.params["pagination.count_total"] = pagination.countTotal;
    if (typeof pagination?.key !== "undefined") // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
    // Uint8Array to String
    options.params["pagination.key"] = $9b355ee2cbe0a1af$require$Buffer.from(pagination.key).toString("base64");
    if (typeof pagination?.limit !== "undefined") options.params["pagination.limit"] = pagination.limit.toString();
    if (typeof pagination?.offset !== "undefined") options.params["pagination.offset"] = pagination.offset.toString();
    if (typeof pagination?.reverse !== "undefined") options.params["pagination.reverse"] = pagination.reverse;
    return options;
};
module.exports.setPaginationParams = $9b355ee2cbe0a1af$var$setPaginationParams;
function $9b355ee2cbe0a1af$var$toTimestamp(date) {
    const seconds = $9b355ee2cbe0a1af$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
module.exports.toTimestamp = $9b355ee2cbe0a1af$var$toTimestamp;
function $9b355ee2cbe0a1af$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
module.exports.fromTimestamp = $9b355ee2cbe0a1af$var$fromTimestamp;
const $9b355ee2cbe0a1af$var$fromJSON = (object)=>{
    return {
        seconds: $9b355ee2cbe0a1af$var$isSet(object.seconds) ? $9b355ee2cbe0a1af$var$long_1.default.fromString(object.seconds) : $9b355ee2cbe0a1af$var$long_1.default.ZERO,
        nanos: $9b355ee2cbe0a1af$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
const $9b355ee2cbe0a1af$var$timestampFromJSON = (object)=>{
    return {
        seconds: $9b355ee2cbe0a1af$var$isSet(object.seconds) ? $9b355ee2cbe0a1af$var$long_1.default.fromValue(object.seconds) : $9b355ee2cbe0a1af$var$long_1.default.ZERO,
        nanos: $9b355ee2cbe0a1af$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
function $9b355ee2cbe0a1af$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $9b355ee2cbe0a1af$var$toTimestamp(o);
    else if (typeof o === "string") return $9b355ee2cbe0a1af$var$toTimestamp(new Date(o));
    else return $9b355ee2cbe0a1af$var$timestampFromJSON(o);
}
module.exports.fromJsonTimestamp = $9b355ee2cbe0a1af$var$fromJsonTimestamp;
function $9b355ee2cbe0a1af$var$numberToLong(number) {
    return $9b355ee2cbe0a1af$var$long_1.default.fromNumber(number);
}

});


parcelRegister("67U77", function(module, exports) {
"use strict";
var $475eec9009ba2cee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $475eec9009ba2cee$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $475eec9009ba2cee$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $475eec9009ba2cee$var$__createBinding(result, mod, k);
    }
    $475eec9009ba2cee$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignatureDescriptor_Data_Multi = module.exports.SignatureDescriptor_Data_Single = module.exports.SignatureDescriptor_Data = module.exports.SignatureDescriptor = module.exports.SignatureDescriptors = module.exports.signModeToJSON = module.exports.signModeFromJSON = module.exports.SignMode = module.exports.protobufPackage = void 0;

var $eNZfD = parcelRequire("eNZfD");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $475eec9009ba2cee$var$_m0 = $475eec9009ba2cee$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/**
 * SignMode represents a signing mode with its own security guarantees.
 *
 * This enum should be considered a registry of all known sign modes
 * in the Cosmos ecosystem. Apps are not expected to support all known
 * sign modes. Apps that would like to support custom  sign modes are
 * encouraged to open a small PR against this file to add a new case
 * to this SignMode enum describing their sign mode so that different
 * apps have a consistent version of this enum.
 */ var $475eec9009ba2cee$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected.
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx.
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT. It is currently not supported.
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_DIRECT_AUX - SIGN_MODE_DIRECT_AUX specifies a signing mode which uses
     * SignDocDirectAux. As opposed to SIGN_MODE_DIRECT, this sign mode does not
     * require signers signing over other signers' `signer_info`. It also allows
     * for adding Tips in transactions.
     *
     * Since: cosmos-sdk 0.46
     */ SignMode[SignMode["SIGN_MODE_DIRECT_AUX"] = 3] = "SIGN_MODE_DIRECT_AUX";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future.
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */ SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($475eec9009ba2cee$var$SignMode = module.exports.SignMode || (module.exports.SignMode = {}));
function $475eec9009ba2cee$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return $475eec9009ba2cee$var$SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $475eec9009ba2cee$var$SignMode.UNRECOGNIZED;
    }
}
module.exports.signModeFromJSON = $475eec9009ba2cee$var$signModeFromJSON;
function $475eec9009ba2cee$var$signModeToJSON(object) {
    switch(object){
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_DIRECT_AUX:
            return "SIGN_MODE_DIRECT_AUX";
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case $475eec9009ba2cee$var$SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case $475eec9009ba2cee$var$SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.signModeToJSON = $475eec9009ba2cee$var$signModeToJSON;
function $475eec9009ba2cee$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
module.exports.SignatureDescriptors = {
    encode (message, writer = $475eec9009ba2cee$var$_m0.Writer.create()) {
        for (const v of message.signatures)module.exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $475eec9009ba2cee$var$_m0.Reader ? input : new $475eec9009ba2cee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(module.exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptors();
        message.signatures = object.signatures?.map((e)=>module.exports.SignatureDescriptor.fromPartial(e)) || [];
        return message;
    }
};
function $475eec9009ba2cee$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.SignatureDescriptor = {
    encode (message, writer = $475eec9009ba2cee$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $axIO3.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) module.exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $475eec9009ba2cee$var$_m0.Reader ? input : new $475eec9009ba2cee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $dkaBG.isSet)(object.publicKey) ? $axIO3.Any.fromJSON(object.publicKey) : undefined,
            data: (0, $dkaBG.isSet)(object.data) ? module.exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $axIO3.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? module.exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $axIO3.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? module.exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
module.exports.SignatureDescriptor_Data = {
    encode (message, writer = $475eec9009ba2cee$var$_m0.Writer.create()) {
        if (message.single !== undefined) module.exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) module.exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $475eec9009ba2cee$var$_m0.Reader ? input : new $475eec9009ba2cee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = module.exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = module.exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $dkaBG.isSet)(object.single) ? module.exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: (0, $dkaBG.isSet)(object.multi) ? module.exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? module.exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? module.exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? module.exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? module.exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
module.exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $475eec9009ba2cee$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $475eec9009ba2cee$var$_m0.Reader ? input : new $475eec9009ba2cee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $dkaBG.isSet)(object.mode) ? $475eec9009ba2cee$var$signModeFromJSON(object.mode) : 0,
            signature: (0, $dkaBG.isSet)(object.signature) ? (0, $dkaBG.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $475eec9009ba2cee$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = (0, $dkaBG.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Single();
        message.mode = object.mode ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
module.exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $475eec9009ba2cee$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $eNZfD.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)module.exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $475eec9009ba2cee$var$_m0.Reader ? input : new $475eec9009ba2cee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $eNZfD.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push(module.exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $dkaBG.isSet)(object.bitarray) ? $eNZfD.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>module.exports.SignatureDescriptor_Data.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $eNZfD.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $475eec9009ba2cee$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $eNZfD.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = object.signatures?.map((e)=>module.exports.SignatureDescriptor_Data.fromPartial(e)) || [];
        return message;
    }
};

});
parcelRegister("eNZfD", function(module, exports) {
"use strict";
var $ac752785454fa07f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ac752785454fa07f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ac752785454fa07f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ac752785454fa07f$var$__createBinding(result, mod, k);
    }
    $ac752785454fa07f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompactBitArray = module.exports.MultiSignature = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $ac752785454fa07f$var$_m0 = $ac752785454fa07f$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $ac752785454fa07f$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
module.exports.MultiSignature = {
    encode (message, writer = $ac752785454fa07f$var$_m0.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ac752785454fa07f$var$_m0.Reader ? input : new $ac752785454fa07f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ac752785454fa07f$var$createBaseMultiSignature();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ac752785454fa07f$var$createBaseMultiSignature();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $ac752785454fa07f$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
module.exports.CompactBitArray = {
    encode (message, writer = $ac752785454fa07f$var$_m0.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ac752785454fa07f$var$_m0.Reader ? input : new $ac752785454fa07f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ac752785454fa07f$var$createBaseCompactBitArray();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            extraBitsStored: (0, $dkaBG.isSet)(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: (0, $dkaBG.isSet)(object.elems) ? (0, $dkaBG.bytesFromBase64)(object.elems) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = (0, $dkaBG.base64FromBytes)(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $ac752785454fa07f$var$createBaseCompactBitArray();
        message.extraBitsStored = object.extraBitsStored ?? 0;
        message.elems = object.elems ?? new Uint8Array();
        return message;
    }
};

});


parcelRegister("efcGD", function(module, exports) {
"use strict";
var $a5ec4eb37264d21c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a5ec4eb37264d21c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a5ec4eb37264d21c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a5ec4eb37264d21c$var$__createBinding(result, mod, k);
    }
    $a5ec4eb37264d21c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $a5ec4eb37264d21c$var$_m0 = $a5ec4eb37264d21c$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.base.v1beta1";
function $a5ec4eb37264d21c$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.Coin = {
    encode (message, writer = $a5ec4eb37264d21c$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a5ec4eb37264d21c$var$_m0.Reader ? input : new $a5ec4eb37264d21c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a5ec4eb37264d21c$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $a5ec4eb37264d21c$var$createBaseCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $a5ec4eb37264d21c$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.DecCoin = {
    encode (message, writer = $a5ec4eb37264d21c$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a5ec4eb37264d21c$var$_m0.Reader ? input : new $a5ec4eb37264d21c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a5ec4eb37264d21c$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $a5ec4eb37264d21c$var$createBaseDecCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $a5ec4eb37264d21c$var$createBaseIntProto() {
    return {
        int: ""
    };
}
module.exports.IntProto = {
    encode (message, writer = $a5ec4eb37264d21c$var$_m0.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a5ec4eb37264d21c$var$_m0.Reader ? input : new $a5ec4eb37264d21c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a5ec4eb37264d21c$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: (0, $dkaBG.isSet)(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = $a5ec4eb37264d21c$var$createBaseIntProto();
        message.int = object.int ?? "";
        return message;
    }
};
function $a5ec4eb37264d21c$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
module.exports.DecProto = {
    encode (message, writer = $a5ec4eb37264d21c$var$_m0.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a5ec4eb37264d21c$var$_m0.Reader ? input : new $a5ec4eb37264d21c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a5ec4eb37264d21c$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: (0, $dkaBG.isSet)(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = $a5ec4eb37264d21c$var$createBaseDecProto();
        message.dec = object.dec ?? "";
        return message;
    }
};

});



parcelRegister("hgtSC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectSecp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $hm8y1 = parcelRequire("hm8y1");

var $7eoti = parcelRequire("7eoti");

var $lLiFz = parcelRequire("lLiFz");
const $c91b1bd0dc069919$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $c91b1bd0dc069919$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $c91b1bd0dc069919$var$isDerivationJson(thing) {
    if (!(0, $hm8y1.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $c91b1bd0dc069919$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $c91b1bd0dc069919$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $c91b1bd0dc069919$var$serializationTypeV1:
            return $c91b1bd0dc069919$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $c91b1bd0dc069919$var$extractKdfConfiguration;
const $c91b1bd0dc069919$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $bVJSA.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ class $c91b1bd0dc069919$var$DirectSecp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $c162L.EnglishMnemonic(mnemonic);
        const seed = await $c162L.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $c91b1bd0dc069919$var$DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $c162L.Random.getBytes(entropyLength);
        const mnemonic = $c162L.Bip39.encode(entropy);
        return $c91b1bd0dc069919$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $c91b1bd0dc069919$var$serializationTypeV1:
                return $c91b1bd0dc069919$var$DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $c91b1bd0dc069919$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $lLiFz.decrypt)((0, $94ZnX.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $94ZnX.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $hm8y1.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$c91b1bd0dc069919$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $c162L.stringToPath)(hdPath));
                    return $c91b1bd0dc069919$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $lLiFz.executeKdf)(password, root.kdf);
        return $c91b1bd0dc069919$var$DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const prefix = options.prefix ?? $c91b1bd0dc069919$var$defaultOptions.prefix;
        const hdPaths = options.hdPaths ?? $c91b1bd0dc069919$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const signBytes = (0, $7eoti.makeSignBytes)(signDoc);
        const hashedMessage = (0, $c162L.sha256)(signBytes);
        const signature = await $c162L.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $bVJSA.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $c91b1bd0dc069919$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $lLiFz.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $c162L.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $94ZnX.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $lLiFz.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $lLiFz.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $c91b1bd0dc069919$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $94ZnX.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $c162L.Slip10.derivePath($c162L.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $c162L.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $c162L.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $94ZnX.toBech32)(prefix, (0, $bVJSA.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
module.exports.DirectSecp256k1HdWallet = $c91b1bd0dc069919$var$DirectSecp256k1HdWallet;

});
parcelRegister("bVJSA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.executeKdf = module.exports.makeStdTx = module.exports.isStdTx = module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.encodeSecp256k1Signature = module.exports.decodeSignature = module.exports.Secp256k1Wallet = module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = module.exports.pubkeyType = module.exports.isSinglePubkey = module.exports.isSecp256k1Pubkey = module.exports.isMultisigThresholdPubkey = module.exports.isEd25519Pubkey = module.exports.makeCosmoshubPath = module.exports.createMultisigThresholdPubkey = module.exports.encodeSecp256k1Pubkey = module.exports.encodeEd25519Pubkey = module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.parseCoins = module.exports.coins = module.exports.coin = module.exports.addCoins = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = module.exports.pubkeyToRawAddress = module.exports.pubkeyToAddress = void 0;

var $lqG7A = parcelRequire("lqG7A");
Object.defineProperty(module.exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $lqG7A.pubkeyToAddress;
    }
});
Object.defineProperty(module.exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $lqG7A.pubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $lqG7A.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $lqG7A.rawSecp256k1PubkeyToRawAddress;
    }
});

var $kZ3LA = parcelRequire("kZ3LA");
Object.defineProperty(module.exports, "addCoins", {
    enumerable: true,
    get: function() {
        return $kZ3LA.addCoins;
    }
});
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $kZ3LA.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $kZ3LA.coins;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $kZ3LA.parseCoins;
    }
});

var $dKZ7y = parcelRequire("dKZ7y");
Object.defineProperty(module.exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.decodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.decodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.encodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.encodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.encodeEd25519Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $dKZ7y.encodeSecp256k1Pubkey;
    }
});

var $kNcaC = parcelRequire("kNcaC");
Object.defineProperty(module.exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $kNcaC.createMultisigThresholdPubkey;
    }
});

var $6XJya = parcelRequire("6XJya");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $6XJya.makeCosmoshubPath;
    }
});

var $1cagW = parcelRequire("1cagW");
Object.defineProperty(module.exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $1cagW.isEd25519Pubkey;
    }
});
Object.defineProperty(module.exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $1cagW.isMultisigThresholdPubkey;
    }
});
Object.defineProperty(module.exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $1cagW.isSecp256k1Pubkey;
    }
});
Object.defineProperty(module.exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $1cagW.isSinglePubkey;
    }
});
Object.defineProperty(module.exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $1cagW.pubkeyType;
    }
});

var $f9Sbi = parcelRequire("f9Sbi");
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $f9Sbi.extractKdfConfiguration;
    }
});
Object.defineProperty(module.exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $f9Sbi.Secp256k1HdWallet;
    }
});

var $gJUqF = parcelRequire("gJUqF");
Object.defineProperty(module.exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $gJUqF.Secp256k1Wallet;
    }
});

var $1N7ou = parcelRequire("1N7ou");
Object.defineProperty(module.exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $1N7ou.decodeSignature;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $1N7ou.encodeSecp256k1Signature;
    }
});

var $eYcgy = parcelRequire("eYcgy");
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $eYcgy.makeSignDoc;
    }
});
Object.defineProperty(module.exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $eYcgy.serializeSignDoc;
    }
});

var $fgHvd = parcelRequire("fgHvd");
Object.defineProperty(module.exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $fgHvd.isStdTx;
    }
});
Object.defineProperty(module.exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $fgHvd.makeStdTx;
    }
});

var $kxKRt = parcelRequire("kxKRt");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $kxKRt.executeKdf;
    }
});

});
parcelRegister("lqG7A", function(module, exports) {
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyToAddress = module.exports.pubkeyToRawAddress = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $dKZ7y = parcelRequire("dKZ7y");

var $1cagW = parcelRequire("1cagW");
function $f99cb31be5952f61$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $c162L.sha256)(pubkeyData).slice(0, 20);
}
module.exports.rawEd25519PubkeyToRawAddress = $f99cb31be5952f61$var$rawEd25519PubkeyToRawAddress;
function $f99cb31be5952f61$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $c162L.ripemd160)((0, $c162L.sha256)(pubkeyData));
}
module.exports.rawSecp256k1PubkeyToRawAddress = $f99cb31be5952f61$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $f99cb31be5952f61$var$pubkeyToRawAddress(pubkey) {
    if ((0, $1cagW.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $94ZnX.fromBase64)(pubkey.value);
        return $f99cb31be5952f61$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $1cagW.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $94ZnX.fromBase64)(pubkey.value);
        return $f99cb31be5952f61$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $1cagW.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $dKZ7y.encodeAminoPubkey)(pubkey);
        return (0, $c162L.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
module.exports.pubkeyToRawAddress = $f99cb31be5952f61$var$pubkeyToRawAddress;
function $f99cb31be5952f61$var$pubkeyToAddress(pubkey, prefix) {
    return (0, $94ZnX.toBech32)(prefix, $f99cb31be5952f61$var$pubkeyToRawAddress(pubkey));
}
module.exports.pubkeyToAddress = $f99cb31be5952f61$var$pubkeyToAddress;

});
parcelRegister("c162L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.isArgon2idOptions = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.Argon2id = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $fS7ZO = parcelRequire("fS7ZO");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $fS7ZO.Bip39;
    }
});
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $fS7ZO.EnglishMnemonic;
    }
});

var $7p4Gq = parcelRequire("7p4Gq");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $7p4Gq.Hmac;
    }
});

var $5TGBY = parcelRequire("5TGBY");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $5TGBY.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $5TGBY.keccak256;
    }
});

var $buZqa = parcelRequire("buZqa");
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $buZqa.Argon2id;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $buZqa.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $buZqa.Ed25519Keypair;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $buZqa.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $buZqa.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $buZqa.Xchacha20poly1305Ietf;
    }
});

var $e5tSL = parcelRequire("e5tSL");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $e5tSL.Random;
    }
});

var $gTsoG = parcelRequire("gTsoG");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $gTsoG.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $gTsoG.ripemd160;
    }
});

var $iR4fK = parcelRequire("iR4fK");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $iR4fK.Secp256k1;
    }
});

var $3mmn4 = parcelRequire("3mmn4");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $3mmn4.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $3mmn4.Secp256k1Signature;
    }
});

var $gfTDf = parcelRequire("gfTDf");
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $gfTDf.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $gfTDf.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $gfTDf.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $gfTDf.sha512;
    }
});

var $fQNhx = parcelRequire("fQNhx");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $fQNhx.pathToString;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $fQNhx.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $fQNhx.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $fQNhx.slip10CurveFromString;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $fQNhx.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $fQNhx.stringToPath;
    }
});

});
parcelRegister("fS7ZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = module.exports.EnglishMnemonic = module.exports.mnemonicToEntropy = module.exports.entropyToMnemonic = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $6OQRS = parcelRequire("6OQRS");

var $gfTDf = parcelRequire("gfTDf");
const $b8e21a0067fb736b$var$wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
function $b8e21a0067fb736b$var$bytesToBitstring(bytes) {
    return Array.from(bytes).map((byte)=>byte.toString(2).padStart(8, "0")).join("");
}
function $b8e21a0067fb736b$var$deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, $gfTDf.sha256)(entropy);
    return $b8e21a0067fb736b$var$bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function $b8e21a0067fb736b$var$bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const $b8e21a0067fb736b$var$allowedEntropyLengths = [
    16,
    20,
    24,
    28,
    32
];
const $b8e21a0067fb736b$var$allowedWordLengths = [
    12,
    15,
    18,
    21,
    24
];
function $b8e21a0067fb736b$var$entropyToMnemonic(entropy) {
    if ($b8e21a0067fb736b$var$allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
    const entropyBits = $b8e21a0067fb736b$var$bytesToBitstring(entropy);
    const checksumBits = $b8e21a0067fb736b$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary)=>{
        const index = $b8e21a0067fb736b$var$bitstringToByte(binary);
        return $b8e21a0067fb736b$var$wordlist[index];
    });
    return words.join(" ");
}
module.exports.entropyToMnemonic = $b8e21a0067fb736b$var$entropyToMnemonic;
const $b8e21a0067fb736b$var$invalidNumberOfWorks = "Invalid number of words";
const $b8e21a0067fb736b$var$wordNotInWordlist = "Found word that is not in the wordlist";
const $b8e21a0067fb736b$var$invalidEntropy = "Invalid entropy";
const $b8e21a0067fb736b$var$invalidChecksum = "Invalid mnemonic checksum";
function $b8e21a0067fb736b$var$normalize(str) {
    return str.normalize("NFKD");
}
function $b8e21a0067fb736b$var$mnemonicToEntropy(mnemonic) {
    const words = $b8e21a0067fb736b$var$normalize(mnemonic).split(" ");
    if (!$b8e21a0067fb736b$var$allowedWordLengths.includes(words.length)) throw new Error($b8e21a0067fb736b$var$invalidNumberOfWorks);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = $b8e21a0067fb736b$var$wordlist.indexOf(word);
        if (index === -1) throw new Error($b8e21a0067fb736b$var$wordNotInWordlist);
        return index.toString(2).padStart(11, "0");
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($b8e21a0067fb736b$var$bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) throw new Error($b8e21a0067fb736b$var$invalidEntropy);
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = $b8e21a0067fb736b$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($b8e21a0067fb736b$var$invalidChecksum);
    return entropy;
}
module.exports.mnemonicToEntropy = $b8e21a0067fb736b$var$mnemonicToEntropy;
class $b8e21a0067fb736b$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$b8e21a0067fb736b$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($b8e21a0067fb736b$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $b8e21a0067fb736b$var$mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $b8e21a0067fb736b$var$EnglishMnemonic;
$b8e21a0067fb736b$var$EnglishMnemonic.wordlist = $b8e21a0067fb736b$var$wordlist;
// list of space separated lower case words (1 or more)
$b8e21a0067fb736b$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class $b8e21a0067fb736b$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        return new $b8e21a0067fb736b$var$EnglishMnemonic($b8e21a0067fb736b$var$entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return $b8e21a0067fb736b$var$mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, $94ZnX.toUtf8)($b8e21a0067fb736b$var$normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $b8e21a0067fb736b$var$normalize(password) : "");
        const saltBytes = (0, $94ZnX.toUtf8)(salt);
        return (0, $6OQRS.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
module.exports.Bip39 = $b8e21a0067fb736b$var$Bip39;

});
parcelRegister("94ZnX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.toBech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $agWYi = parcelRequire("agWYi");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $agWYi.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $agWYi.toAscii;
    }
});

var $l7Kue = parcelRequire("l7Kue");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $l7Kue.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $l7Kue.toBase64;
    }
});

var $6Ql5y = parcelRequire("6Ql5y");
Object.defineProperty(module.exports, "fromBech32", {
    enumerable: true,
    get: function() {
        return $6Ql5y.fromBech32;
    }
});
Object.defineProperty(module.exports, "normalizeBech32", {
    enumerable: true,
    get: function() {
        return $6Ql5y.normalizeBech32;
    }
});
Object.defineProperty(module.exports, "toBech32", {
    enumerable: true,
    get: function() {
        return $6Ql5y.toBech32;
    }
});

var $cAvV5 = parcelRequire("cAvV5");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $cAvV5.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $cAvV5.toHex;
    }
});

var $376iC = parcelRequire("376iC");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $376iC.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $376iC.toRfc3339;
    }
});

var $azr1z = parcelRequire("azr1z");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $azr1z.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $azr1z.toUtf8;
    }
});

});
parcelRegister("agWYi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $77a92482f854731d$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $77a92482f854731d$var$toAscii;
function $77a92482f854731d$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $77a92482f854731d$var$fromAscii;

});

parcelRegister("l7Kue", function(module, exports) {
"use strict";
var $f60e4fb124163417$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f60e4fb124163417$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f60e4fb124163417$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f60e4fb124163417$var$__createBinding(result, mod, k);
    }
    $f60e4fb124163417$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $f60e4fb124163417$var$base64js = $f60e4fb124163417$var$__importStar((parcelRequire("bQMRt")));
function $f60e4fb124163417$var$toBase64(data) {
    return $f60e4fb124163417$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $f60e4fb124163417$var$toBase64;
function $f60e4fb124163417$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $f60e4fb124163417$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $f60e4fb124163417$var$fromBase64;

});

parcelRegister("6Ql5y", function(module, exports) {
"use strict";
var $4fb7f527ae3abe8f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4fb7f527ae3abe8f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4fb7f527ae3abe8f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4fb7f527ae3abe8f$var$__createBinding(result, mod, k);
    }
    $4fb7f527ae3abe8f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBech32 = void 0;

const $4fb7f527ae3abe8f$var$bech32 = $4fb7f527ae3abe8f$var$__importStar((parcelRequire("6SVUn")));
function $4fb7f527ae3abe8f$var$toBech32(prefix, data, limit) {
    const address = $4fb7f527ae3abe8f$var$bech32.encode(prefix, $4fb7f527ae3abe8f$var$bech32.toWords(data), limit);
    return address;
}
module.exports.toBech32 = $4fb7f527ae3abe8f$var$toBech32;
function $4fb7f527ae3abe8f$var$fromBech32(address, limit = Infinity) {
    const decodedAddress = $4fb7f527ae3abe8f$var$bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array($4fb7f527ae3abe8f$var$bech32.fromWords(decodedAddress.words))
    };
}
module.exports.fromBech32 = $4fb7f527ae3abe8f$var$fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */ function $4fb7f527ae3abe8f$var$normalizeBech32(address) {
    const { prefix: prefix, data: data } = $4fb7f527ae3abe8f$var$fromBech32(address);
    return $4fb7f527ae3abe8f$var$toBech32(prefix, data);
}
module.exports.normalizeBech32 = $4fb7f527ae3abe8f$var$normalizeBech32;

});
parcelRegister("6SVUn", function(module, exports) {
"use strict";
var $5034b497e4f3aacf$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $5034b497e4f3aacf$var$ALPHABET_MAP = {};
for(var $5034b497e4f3aacf$var$z = 0; $5034b497e4f3aacf$var$z < $5034b497e4f3aacf$var$ALPHABET.length; $5034b497e4f3aacf$var$z++){
    var $5034b497e4f3aacf$var$x = $5034b497e4f3aacf$var$ALPHABET.charAt($5034b497e4f3aacf$var$z);
    if ($5034b497e4f3aacf$var$ALPHABET_MAP[$5034b497e4f3aacf$var$x] !== undefined) throw new TypeError($5034b497e4f3aacf$var$x + " is ambiguous");
    $5034b497e4f3aacf$var$ALPHABET_MAP[$5034b497e4f3aacf$var$x] = $5034b497e4f3aacf$var$z;
}
function $5034b497e4f3aacf$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $5034b497e4f3aacf$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $5034b497e4f3aacf$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $5034b497e4f3aacf$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $5034b497e4f3aacf$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $5034b497e4f3aacf$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $5034b497e4f3aacf$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $5034b497e4f3aacf$var$polymodStep(chk) ^ x;
        result += $5034b497e4f3aacf$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $5034b497e4f3aacf$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $5034b497e4f3aacf$var$ALPHABET.charAt(v);
    }
    return result;
}
function $5034b497e4f3aacf$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $5034b497e4f3aacf$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $5034b497e4f3aacf$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $5034b497e4f3aacf$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $5034b497e4f3aacf$var$decodeUnsafe() {
    var res = $5034b497e4f3aacf$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $5034b497e4f3aacf$var$decode(str) {
    var res = $5034b497e4f3aacf$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $5034b497e4f3aacf$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $5034b497e4f3aacf$var$toWordsUnsafe(bytes) {
    var res = $5034b497e4f3aacf$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $5034b497e4f3aacf$var$toWords(bytes) {
    var res = $5034b497e4f3aacf$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $5034b497e4f3aacf$var$fromWordsUnsafe(words) {
    var res = $5034b497e4f3aacf$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $5034b497e4f3aacf$var$fromWords(words) {
    var res = $5034b497e4f3aacf$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $5034b497e4f3aacf$var$decodeUnsafe,
    decode: $5034b497e4f3aacf$var$decode,
    encode: $5034b497e4f3aacf$var$encode,
    toWordsUnsafe: $5034b497e4f3aacf$var$toWordsUnsafe,
    toWords: $5034b497e4f3aacf$var$toWords,
    fromWordsUnsafe: $5034b497e4f3aacf$var$fromWordsUnsafe,
    fromWords: $5034b497e4f3aacf$var$fromWords
};

});


parcelRegister("cAvV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $92a19b66c2dbced6$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $92a19b66c2dbced6$var$toHex;
function $92a19b66c2dbced6$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const out = new Uint8Array(hexstring.length / 2);
    for(let i = 0; i < out.length; i++){
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
module.exports.fromHex = $92a19b66c2dbced6$var$fromHex;

});

parcelRegister("376iC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $2446e97969d01d78$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $2446e97969d01d78$var$padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function $2446e97969d01d78$var$fromRfc3339(str) {
    const matches = $2446e97969d01d78$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $2446e97969d01d78$var$fromRfc3339;
function $2446e97969d01d78$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $2446e97969d01d78$var$padded(date.getUTCMonth() + 1);
    const day = $2446e97969d01d78$var$padded(date.getUTCDate());
    const hour = $2446e97969d01d78$var$padded(date.getUTCHours());
    const minute = $2446e97969d01d78$var$padded(date.getUTCMinutes());
    const second = $2446e97969d01d78$var$padded(date.getUTCSeconds());
    const ms = $2446e97969d01d78$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $2446e97969d01d78$var$toRfc3339;

});

parcelRegister("azr1z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $7b2222b5dbc40a37$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
module.exports.toUtf8 = $7b2222b5dbc40a37$var$toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */ function $7b2222b5dbc40a37$var$fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", {
        fatal: fatal
    }).decode(data);
}
module.exports.fromUtf8 = $7b2222b5dbc40a37$var$fromUtf8;

});


parcelRegister("6OQRS", function(module, exports) {
"use strict";
var $4f706c1583c6e822$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f706c1583c6e822$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4f706c1583c6e822$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4f706c1583c6e822$var$__createBinding(result, mod, k);
    }
    $4f706c1583c6e822$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Sha512 = module.exports.pbkdf2Sha512Noble = module.exports.pbkdf2Sha512NodeCrypto = module.exports.pbkdf2Sha512Subtle = module.exports.getSubtle = module.exports.getNodeCrypto = void 0;

var $hm8y1 = parcelRequire("hm8y1");

var $bbrCz = parcelRequire("bbrCz");

var $hyAd0 = parcelRequire("hyAd0");

/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */ async function $4f706c1583c6e822$var$getNodeCrypto() {
    try {
        const nodeCrypto = await Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("eKUBg")));
        }).then((res)=>$4f706c1583c6e822$var$__importStar(res));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof nodeCrypto === "object" && Object.keys(nodeCrypto).length <= 1) return undefined;
        return nodeCrypto;
    } catch  {
        return undefined;
    }
}
module.exports.getNodeCrypto = $4f706c1583c6e822$var$getNodeCrypto;
async function $4f706c1583c6e822$var$getSubtle() {
    // From Node.js 15 onwards, webcrypto is available in globalThis.
    // In version 15 and 16 this was stored under the webcrypto key.
    // With Node.js 17 it was moved to the same locations where browsers
    // make it available.
    // Loading `require("crypto")` here seems unnecessary since it only
    // causes issues with bundlers and does not increase compatibility.
    // Browsers and Node.js 17+
    let subtle = globalThis?.crypto?.subtle;
    // Node.js 15+
    if (!subtle) subtle = globalThis?.crypto?.webcrypto?.subtle;
    return subtle;
}
module.exports.getSubtle = $4f706c1583c6e822$var$getSubtle;
async function $4f706c1583c6e822$var$pbkdf2Sha512Subtle(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, $hm8y1.assert)(subtle, "Argument subtle is falsy");
    (0, $hm8y1.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, $hm8y1.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, $hm8y1.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then((key)=>subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: "SHA-512"
            }
        }, key, keylen * 8).then((buffer)=>new Uint8Array(buffer)));
}
module.exports.pbkdf2Sha512Subtle = $4f706c1583c6e822$var$pbkdf2Sha512Subtle;
/**
 * Implements pbkdf2-sha512 using the Node.js crypro module (`import "crypto"`).
 * This does not use subtle from [Crypto](https://developer.mozilla.org/en-US/docs/Web/API/Crypto).
 */ async function $4f706c1583c6e822$var$pbkdf2Sha512NodeCrypto(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
nodeCrypto, secret, salt, iterations, keylen) {
    (0, $hm8y1.assert)(nodeCrypto, "Argument nodeCrypto is falsy");
    (0, $hm8y1.assert)(typeof nodeCrypto === "object", "Argument nodeCrypto is not of type object");
    (0, $hm8y1.assert)(typeof nodeCrypto.pbkdf2 === "function", "nodeCrypto.pbkdf2 is not a function");
    return new Promise((resolve, reject)=>{
        nodeCrypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result)=>{
            if (error) reject(error);
            else resolve(Uint8Array.from(result));
        });
    });
}
module.exports.pbkdf2Sha512NodeCrypto = $4f706c1583c6e822$var$pbkdf2Sha512NodeCrypto;
async function $4f706c1583c6e822$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, $bbrCz.pbkdf2Async)($hyAd0.sha512, secret, salt, {
        c: iterations,
        dkLen: keylen
    });
}
module.exports.pbkdf2Sha512Noble = $4f706c1583c6e822$var$pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */ async function $4f706c1583c6e822$var$pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await $4f706c1583c6e822$var$getSubtle();
    if (subtle) return $4f706c1583c6e822$var$pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    else {
        const nodeCrypto = await $4f706c1583c6e822$var$getNodeCrypto();
        if (nodeCrypto) return $4f706c1583c6e822$var$pbkdf2Sha512NodeCrypto(nodeCrypto, secret, salt, iterations, keylen);
        else return $4f706c1583c6e822$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen);
    }
}
module.exports.pbkdf2Sha512 = $4f706c1583c6e822$var$pbkdf2Sha512;

});
parcelRegister("hm8y1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.isDefined = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $57bbA = parcelRequire("57bbA");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $57bbA.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $57bbA.arrayContentStartsWith;
    }
});

var $ersro = parcelRequire("ersro");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $ersro.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $ersro.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $ersro.assertDefinedAndNotNull;
    }
});

var $fd7nS = parcelRequire("fd7nS");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $fd7nS.sleep;
    }
});

var $dJR29 = parcelRequire("dJR29");
Object.defineProperty(module.exports, "isDefined", {
    enumerable: true,
    get: function() {
        return $dJR29.isDefined;
    }
});
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $dJR29.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $dJR29.isUint8Array;
    }
});

});
parcelRegister("57bbA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $3b96487baa30ce0f$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $3b96487baa30ce0f$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $3b96487baa30ce0f$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $3b96487baa30ce0f$var$arrayContentStartsWith;

});

parcelRegister("ersro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $a839a60ed493532f$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $a839a60ed493532f$var$assert;
function $a839a60ed493532f$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg ?? "value is undefined");
}
module.exports.assertDefined = $a839a60ed493532f$var$assertDefined;
function $a839a60ed493532f$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg ?? "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $a839a60ed493532f$var$assertDefinedAndNotNull;

});

parcelRegister("fd7nS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $b12dcc3c86202c23$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $b12dcc3c86202c23$var$sleep;

});

parcelRegister("dJR29", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $a0089db81d768a7a$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefined = module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a0089db81d768a7a$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $a0089db81d768a7a$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $a0089db81d768a7a$var$isUint8Array(data) {
    if (!$a0089db81d768a7a$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $a0089db81d768a7a$require$Buffer !== "undefined" && typeof $a0089db81d768a7a$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($a0089db81d768a7a$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $a0089db81d768a7a$var$isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */ function $a0089db81d768a7a$var$isDefined(value) {
    return value !== undefined;
}
module.exports.isDefined = $a0089db81d768a7a$var$isDefined;

});


parcelRegister("eKUBg", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $abe14424788adc2b$export$5f828d93ff035aa8, (v) => $abe14424788adc2b$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $abe14424788adc2b$export$cd94982b18c6332c, (v) => $abe14424788adc2b$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $abe14424788adc2b$export$1d518568e4f529b0, (v) => $abe14424788adc2b$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $abe14424788adc2b$export$5285b6d41c912b41, (v) => $abe14424788adc2b$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $abe14424788adc2b$export$2fb37efbf6ae0c0e, (v) => $abe14424788adc2b$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $abe14424788adc2b$export$ab85ecd77ce6a5cd, (v) => $abe14424788adc2b$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $abe14424788adc2b$export$da39cf97e1eb7c91, (v) => $abe14424788adc2b$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $abe14424788adc2b$export$52a9039d7177394f, (v) => $abe14424788adc2b$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $abe14424788adc2b$export$f7201db400317331, (v) => $abe14424788adc2b$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $abe14424788adc2b$export$448fa22aedc9dbca, (v) => $abe14424788adc2b$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $abe14424788adc2b$export$b80c7ba289c8fa56, (v) => $abe14424788adc2b$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $abe14424788adc2b$export$26e5786e8ac8e530, (v) => $abe14424788adc2b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $abe14424788adc2b$export$bdd223f16383713e, (v) => $abe14424788adc2b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $abe14424788adc2b$export$20533d26f07f1ee0, (v) => $abe14424788adc2b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $abe14424788adc2b$export$2f64596b8cbf08b4, (v) => $abe14424788adc2b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $abe14424788adc2b$export$2ce6d8d0e8b04e1a, (v) => $abe14424788adc2b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $abe14424788adc2b$export$12ada9414fbc594c, (v) => $abe14424788adc2b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $abe14424788adc2b$export$f5e7e39d57cd9700, (v) => $abe14424788adc2b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $abe14424788adc2b$export$36b6d6ef312eab39, (v) => $abe14424788adc2b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $abe14424788adc2b$export$58a258485f1e49f6, (v) => $abe14424788adc2b$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $abe14424788adc2b$export$dedd8dc3dc62b370, (v) => $abe14424788adc2b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $abe14424788adc2b$export$971862a2fcb1bb40, (v) => $abe14424788adc2b$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $abe14424788adc2b$export$c6ff6a88acbeaf40, (v) => $abe14424788adc2b$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $abe14424788adc2b$export$fdc27893e98845cc, (v) => $abe14424788adc2b$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $abe14424788adc2b$export$6671fb9a1323bed, (v) => $abe14424788adc2b$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $abe14424788adc2b$export$d74daf141a551db, (v) => $abe14424788adc2b$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $abe14424788adc2b$export$45df7cae684751af, (v) => $abe14424788adc2b$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $abe14424788adc2b$export$1db683ad541682f6, (v) => $abe14424788adc2b$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $abe14424788adc2b$export$6f65485f87568e37, (v) => $abe14424788adc2b$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $abe14424788adc2b$export$91a8e56769aeb334, (v) => $abe14424788adc2b$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $abe14424788adc2b$export$2d4117e99c2179e4, (v) => $abe14424788adc2b$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $abe14424788adc2b$export$512823e338ddb1b7, (v) => $abe14424788adc2b$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $abe14424788adc2b$export$9d0e0c0c4a8d30f3, (v) => $abe14424788adc2b$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $abe14424788adc2b$export$b9d55ff329113abd, (v) => $abe14424788adc2b$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $abe14424788adc2b$export$7efb24e2fddf99b9, (v) => $abe14424788adc2b$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $abe14424788adc2b$export$bb1abf2ce84fc7e8, (v) => $abe14424788adc2b$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $abe14424788adc2b$export$2f7171e78e524d5e, (v) => $abe14424788adc2b$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $abe14424788adc2b$export$e1d879b482f37d98, (v) => $abe14424788adc2b$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $abe14424788adc2b$export$1a988e7317c65621, (v) => $abe14424788adc2b$export$1a988e7317c65621 = v);
var $abe14424788adc2b$export$5f828d93ff035aa8;
var $abe14424788adc2b$export$cd94982b18c6332c;
var $abe14424788adc2b$export$1d518568e4f529b0;
var $abe14424788adc2b$export$5285b6d41c912b41;
var $abe14424788adc2b$export$2fb37efbf6ae0c0e;
var $abe14424788adc2b$export$ab85ecd77ce6a5cd;
var $abe14424788adc2b$export$da39cf97e1eb7c91;
var $abe14424788adc2b$export$52a9039d7177394f;
var $abe14424788adc2b$export$f7201db400317331;
var $abe14424788adc2b$export$448fa22aedc9dbca;
var $abe14424788adc2b$export$b80c7ba289c8fa56;
var $abe14424788adc2b$export$26e5786e8ac8e530;
var $abe14424788adc2b$export$bdd223f16383713e;
var $abe14424788adc2b$export$20533d26f07f1ee0;
var $abe14424788adc2b$export$2f64596b8cbf08b4;
var $abe14424788adc2b$export$2ce6d8d0e8b04e1a;
var $abe14424788adc2b$export$12ada9414fbc594c;
var $abe14424788adc2b$export$f5e7e39d57cd9700;
var $abe14424788adc2b$export$36b6d6ef312eab39;
var $abe14424788adc2b$export$58a258485f1e49f6;
var $abe14424788adc2b$export$dedd8dc3dc62b370;
var $abe14424788adc2b$export$971862a2fcb1bb40;
var $abe14424788adc2b$export$c6ff6a88acbeaf40;
var $abe14424788adc2b$export$fdc27893e98845cc;
var $abe14424788adc2b$export$6671fb9a1323bed;
var $abe14424788adc2b$export$d74daf141a551db;
var $abe14424788adc2b$export$45df7cae684751af;
var $abe14424788adc2b$export$1db683ad541682f6;
var $abe14424788adc2b$export$6f65485f87568e37;
var $abe14424788adc2b$export$91a8e56769aeb334;
var $abe14424788adc2b$export$2d4117e99c2179e4;
var $abe14424788adc2b$export$512823e338ddb1b7;
var $abe14424788adc2b$export$9d0e0c0c4a8d30f3;
var $abe14424788adc2b$export$b9d55ff329113abd;
var $abe14424788adc2b$export$7efb24e2fddf99b9;
var $abe14424788adc2b$export$bb1abf2ce84fc7e8;
var $abe14424788adc2b$export$2f7171e78e524d5e;
var $abe14424788adc2b$export$e1d879b482f37d98;
var $abe14424788adc2b$export$1a988e7317c65621;
"use strict";

$abe14424788adc2b$export$5f828d93ff035aa8 = $abe14424788adc2b$export$cd94982b18c6332c = $abe14424788adc2b$export$1d518568e4f529b0 = $abe14424788adc2b$export$5285b6d41c912b41 = (parcelRequire("e3qkY"));

$abe14424788adc2b$export$2fb37efbf6ae0c0e = $abe14424788adc2b$export$ab85ecd77ce6a5cd = (parcelRequire("5dKmo"));

$abe14424788adc2b$export$da39cf97e1eb7c91 = $abe14424788adc2b$export$52a9039d7177394f = (parcelRequire("cWxOP"));

var $7qbfX = parcelRequire("7qbfX");
var $abe14424788adc2b$var$algoKeys = Object.keys($7qbfX);
var $abe14424788adc2b$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($abe14424788adc2b$var$algoKeys);
$abe14424788adc2b$export$f7201db400317331 = function() {
    return $abe14424788adc2b$var$hashes;
};

var $aKSjA = parcelRequire("aKSjA");
$abe14424788adc2b$export$448fa22aedc9dbca = $aKSjA.pbkdf2;
$abe14424788adc2b$export$b80c7ba289c8fa56 = $aKSjA.pbkdf2Sync;

var $e8E87 = parcelRequire("e8E87");
$abe14424788adc2b$export$26e5786e8ac8e530 = $e8E87.Cipher;
$abe14424788adc2b$export$bdd223f16383713e = $e8E87.createCipher;
$abe14424788adc2b$export$20533d26f07f1ee0 = $e8E87.Cipheriv;
$abe14424788adc2b$export$2f64596b8cbf08b4 = $e8E87.createCipheriv;
$abe14424788adc2b$export$2ce6d8d0e8b04e1a = $e8E87.Decipher;
$abe14424788adc2b$export$12ada9414fbc594c = $e8E87.createDecipher;
$abe14424788adc2b$export$f5e7e39d57cd9700 = $e8E87.Decipheriv;
$abe14424788adc2b$export$36b6d6ef312eab39 = $e8E87.createDecipheriv;
$abe14424788adc2b$export$58a258485f1e49f6 = $e8E87.getCiphers;
$abe14424788adc2b$export$dedd8dc3dc62b370 = $e8E87.listCiphers;

var $65cae = parcelRequire("65cae");
$abe14424788adc2b$export$971862a2fcb1bb40 = $65cae.DiffieHellmanGroup;
$abe14424788adc2b$export$c6ff6a88acbeaf40 = $65cae.createDiffieHellmanGroup;
$abe14424788adc2b$export$fdc27893e98845cc = $65cae.getDiffieHellman;
$abe14424788adc2b$export$6671fb9a1323bed = $65cae.createDiffieHellman;
$abe14424788adc2b$export$d74daf141a551db = $65cae.DiffieHellman;

var $79ovU = parcelRequire("79ovU");
$abe14424788adc2b$export$45df7cae684751af = $79ovU.createSign;
$abe14424788adc2b$export$1db683ad541682f6 = $79ovU.Sign;
$abe14424788adc2b$export$6f65485f87568e37 = $79ovU.createVerify;
$abe14424788adc2b$export$91a8e56769aeb334 = $79ovU.Verify;

$abe14424788adc2b$export$2d4117e99c2179e4 = (parcelRequire("ewTwP"));

var $8nyac = parcelRequire("8nyac");
$abe14424788adc2b$export$512823e338ddb1b7 = $8nyac.publicEncrypt;
$abe14424788adc2b$export$9d0e0c0c4a8d30f3 = $8nyac.privateEncrypt;
$abe14424788adc2b$export$b9d55ff329113abd = $8nyac.publicDecrypt;
$abe14424788adc2b$export$7efb24e2fddf99b9 = $8nyac.privateDecrypt;

var $41YOR = parcelRequire("41YOR");
$abe14424788adc2b$export$bb1abf2ce84fc7e8 = $41YOR.randomFill;
$abe14424788adc2b$export$2f7171e78e524d5e = $41YOR.randomFillSync;
$abe14424788adc2b$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$abe14424788adc2b$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("e3qkY", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $a3b5c684ccf51f24$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $a3b5c684ccf51f24$var$MAX_UINT32 = 4294967295;
function $a3b5c684ccf51f24$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $fx8YU = parcelRequire("fx8YU");
var $a3b5c684ccf51f24$require$Buffer = $fx8YU.Buffer;
var $a3b5c684ccf51f24$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($a3b5c684ccf51f24$var$crypto && $a3b5c684ccf51f24$var$crypto.getRandomValues) module.exports = $a3b5c684ccf51f24$var$randomBytes;
else module.exports = $a3b5c684ccf51f24$var$oldBrowser;
function $a3b5c684ccf51f24$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $a3b5c684ccf51f24$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $a3b5c684ccf51f24$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $a3b5c684ccf51f24$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $a3b5c684ccf51f24$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $a3b5c684ccf51f24$var$crypto.getRandomValues(bytes.slice(generated, generated + $a3b5c684ccf51f24$var$MAX_BYTES));
        else $a3b5c684ccf51f24$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $ibaza.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("7qbfX", function(module, exports) {
"use strict";

module.exports = (parcelRequire("34BYE"));

});
parcelRegister("34BYE", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("aKSjA", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $7d48551806bfb08e$export$448fa22aedc9dbca, (v) => $7d48551806bfb08e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $7d48551806bfb08e$export$b80c7ba289c8fa56, (v) => $7d48551806bfb08e$export$b80c7ba289c8fa56 = v);
var $7d48551806bfb08e$export$448fa22aedc9dbca;
var $7d48551806bfb08e$export$b80c7ba289c8fa56;

$7d48551806bfb08e$export$448fa22aedc9dbca = (parcelRequire("5J58a"));

$7d48551806bfb08e$export$b80c7ba289c8fa56 = (parcelRequire("aEypU"));

});
parcelRegister("5J58a", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $42b52291243bef3c$require$Buffer = $fx8YU.Buffer;

var $cI0tX = parcelRequire("cI0tX");

var $iFCV2 = parcelRequire("iFCV2");

var $aEypU = parcelRequire("aEypU");

var $7VNWV = parcelRequire("7VNWV");
var $42b52291243bef3c$var$ZERO_BUF;
var $42b52291243bef3c$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $42b52291243bef3c$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $42b52291243bef3c$var$checks = [];
function $42b52291243bef3c$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$42b52291243bef3c$var$subtle || !$42b52291243bef3c$var$subtle.importKey || !$42b52291243bef3c$var$subtle.deriveBits) return Promise.resolve(false);
    if ($42b52291243bef3c$var$checks[algo] !== undefined) return $42b52291243bef3c$var$checks[algo];
    $42b52291243bef3c$var$ZERO_BUF = $42b52291243bef3c$var$ZERO_BUF || $42b52291243bef3c$require$Buffer.alloc(8);
    var prom = $42b52291243bef3c$var$browserPbkdf2($42b52291243bef3c$var$ZERO_BUF, $42b52291243bef3c$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $42b52291243bef3c$var$checks[algo] = prom;
    return prom;
}
var $42b52291243bef3c$var$nextTick;
function $42b52291243bef3c$var$getNextTick() {
    if ($42b52291243bef3c$var$nextTick) return $42b52291243bef3c$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $42b52291243bef3c$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $42b52291243bef3c$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $42b52291243bef3c$var$nextTick = $parcel$global.setImmediate;
    else $42b52291243bef3c$var$nextTick = $parcel$global.setTimeout;
    return $42b52291243bef3c$var$nextTick;
}
function $42b52291243bef3c$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $42b52291243bef3c$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $42b52291243bef3c$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $42b52291243bef3c$require$Buffer.from(res);
    });
}
function $42b52291243bef3c$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $42b52291243bef3c$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $42b52291243bef3c$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $42b52291243bef3c$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $42b52291243bef3c$var$getNextTick()(function() {
            var out;
            try {
                out = $aEypU(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $cI0tX(iterations, keylen);
    password = $7VNWV(password, $iFCV2, "Password");
    salt = $7VNWV(salt, $iFCV2, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $42b52291243bef3c$var$resolvePromise($42b52291243bef3c$var$checkNative(algo).then(function(resp) {
        if (resp) return $42b52291243bef3c$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $aEypU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("cI0tX", function(module, exports) {
var $9409f7d62acd781b$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $9409f7d62acd781b$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("iFCV2", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
var $d97a3ed1f72e7cbe$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $d97a3ed1f72e7cbe$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $d97a3ed1f72e7cbe$var$pVersionMajor = parseInt($ibaza.version.split(".")[0].slice(1), 10);
    $d97a3ed1f72e7cbe$var$defaultEncoding = $d97a3ed1f72e7cbe$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $d97a3ed1f72e7cbe$var$defaultEncoding = "utf-8";
module.exports = $d97a3ed1f72e7cbe$var$defaultEncoding;

});

parcelRegister("aEypU", function(module, exports) {

var $duCUQ = parcelRequire("duCUQ");

var $c61JU = parcelRequire("c61JU");

var $4msE6 = parcelRequire("4msE6");

var $fx8YU = parcelRequire("fx8YU");
var $7c18564ab3246890$require$Buffer = $fx8YU.Buffer;

var $cI0tX = parcelRequire("cI0tX");

var $iFCV2 = parcelRequire("iFCV2");

var $7VNWV = parcelRequire("7VNWV");
var $7c18564ab3246890$var$ZEROS = $7c18564ab3246890$require$Buffer.alloc(128);
var $7c18564ab3246890$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $7c18564ab3246890$var$Hmac(alg, key, saltLen) {
    var hash = $7c18564ab3246890$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $7c18564ab3246890$require$Buffer.concat([
        key,
        $7c18564ab3246890$var$ZEROS
    ], blocksize);
    var ipad = $7c18564ab3246890$require$Buffer.allocUnsafe(blocksize + $7c18564ab3246890$var$sizes[alg]);
    var opad = $7c18564ab3246890$require$Buffer.allocUnsafe(blocksize + $7c18564ab3246890$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $7c18564ab3246890$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $7c18564ab3246890$var$sizes[alg];
}
$7c18564ab3246890$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $7c18564ab3246890$var$getDigest(alg) {
    function shaFunc(data) {
        return $4msE6(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $c61JU().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $duCUQ;
    return shaFunc;
}
function $7c18564ab3246890$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $cI0tX(iterations, keylen);
    password = $7VNWV(password, $iFCV2, "Password");
    salt = $7VNWV(salt, $iFCV2, "Salt");
    digest = digest || "sha1";
    var hmac = new $7c18564ab3246890$var$Hmac(digest, password, salt.length);
    var DK = $7c18564ab3246890$require$Buffer.allocUnsafe(keylen);
    var block1 = $7c18564ab3246890$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $7c18564ab3246890$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $7c18564ab3246890$var$pbkdf2;

});
parcelRegister("7VNWV", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $5c649a2ed88d2abe$require$Buffer = $fx8YU.Buffer;
module.exports = function(thing, encoding, name) {
    if ($5c649a2ed88d2abe$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $5c649a2ed88d2abe$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $5c649a2ed88d2abe$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("e8E87", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a4b0f105557915f9$export$bdd223f16383713e, (v) => $a4b0f105557915f9$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a4b0f105557915f9$export$26e5786e8ac8e530, (v) => $a4b0f105557915f9$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a4b0f105557915f9$export$2f64596b8cbf08b4, (v) => $a4b0f105557915f9$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a4b0f105557915f9$export$20533d26f07f1ee0, (v) => $a4b0f105557915f9$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a4b0f105557915f9$export$12ada9414fbc594c, (v) => $a4b0f105557915f9$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a4b0f105557915f9$export$2ce6d8d0e8b04e1a, (v) => $a4b0f105557915f9$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a4b0f105557915f9$export$36b6d6ef312eab39, (v) => $a4b0f105557915f9$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a4b0f105557915f9$export$f5e7e39d57cd9700, (v) => $a4b0f105557915f9$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a4b0f105557915f9$export$dedd8dc3dc62b370, (v) => $a4b0f105557915f9$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a4b0f105557915f9$export$58a258485f1e49f6, (v) => $a4b0f105557915f9$export$58a258485f1e49f6 = v);
var $a4b0f105557915f9$export$bdd223f16383713e;
var $a4b0f105557915f9$export$26e5786e8ac8e530;
var $a4b0f105557915f9$export$2f64596b8cbf08b4;
var $a4b0f105557915f9$export$20533d26f07f1ee0;
var $a4b0f105557915f9$export$12ada9414fbc594c;
var $a4b0f105557915f9$export$2ce6d8d0e8b04e1a;
var $a4b0f105557915f9$export$36b6d6ef312eab39;
var $a4b0f105557915f9$export$f5e7e39d57cd9700;
var $a4b0f105557915f9$export$dedd8dc3dc62b370;
var $a4b0f105557915f9$export$58a258485f1e49f6;

var $ihw76 = parcelRequire("ihw76");

var $dSiaU = parcelRequire("dSiaU");

var $27wJJ = parcelRequire("27wJJ");

var $aQ0CP = parcelRequire("aQ0CP");

var $42eaE = parcelRequire("42eaE");
function $a4b0f105557915f9$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($27wJJ[suite]) {
        keyLen = $27wJJ[suite].key;
        ivLen = $27wJJ[suite].iv;
    } else if ($aQ0CP[suite]) {
        keyLen = $aQ0CP[suite].key * 8;
        ivLen = $aQ0CP[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $42eaE(password, false, keyLen, ivLen);
    return $a4b0f105557915f9$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a4b0f105557915f9$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($27wJJ[suite]) {
        keyLen = $27wJJ[suite].key;
        ivLen = $27wJJ[suite].iv;
    } else if ($aQ0CP[suite]) {
        keyLen = $aQ0CP[suite].key * 8;
        ivLen = $aQ0CP[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $42eaE(password, false, keyLen, ivLen);
    return $a4b0f105557915f9$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a4b0f105557915f9$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($27wJJ[suite]) return $dSiaU.createCipheriv(suite, key, iv);
    if ($aQ0CP[suite]) return new $ihw76({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a4b0f105557915f9$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($27wJJ[suite]) return $dSiaU.createDecipheriv(suite, key, iv);
    if ($aQ0CP[suite]) return new $ihw76({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a4b0f105557915f9$var$getCiphers() {
    return Object.keys($aQ0CP).concat($dSiaU.getCiphers());
}
$a4b0f105557915f9$export$bdd223f16383713e = $a4b0f105557915f9$export$26e5786e8ac8e530 = $a4b0f105557915f9$var$createCipher;
$a4b0f105557915f9$export$2f64596b8cbf08b4 = $a4b0f105557915f9$export$20533d26f07f1ee0 = $a4b0f105557915f9$var$createCipheriv;
$a4b0f105557915f9$export$12ada9414fbc594c = $a4b0f105557915f9$export$2ce6d8d0e8b04e1a = $a4b0f105557915f9$var$createDecipher;
$a4b0f105557915f9$export$36b6d6ef312eab39 = $a4b0f105557915f9$export$f5e7e39d57cd9700 = $a4b0f105557915f9$var$createDecipheriv;
$a4b0f105557915f9$export$dedd8dc3dc62b370 = $a4b0f105557915f9$export$58a258485f1e49f6 = $a4b0f105557915f9$var$getCiphers;

});
parcelRegister("ihw76", function(module, exports) {

var $cfJt1 = parcelRequire("cfJt1");

var $5YEjx = parcelRequire("5YEjx");

var $ajIeE = parcelRequire("ajIeE");

var $fx8YU = parcelRequire("fx8YU");
var $d4f2b9961c11a37f$require$Buffer = $fx8YU.Buffer;
var $d4f2b9961c11a37f$var$modes = {
    "des-ede3-cbc": $5YEjx.CBC.instantiate($5YEjx.EDE),
    "des-ede3": $5YEjx.EDE,
    "des-ede-cbc": $5YEjx.CBC.instantiate($5YEjx.EDE),
    "des-ede": $5YEjx.EDE,
    "des-cbc": $5YEjx.CBC.instantiate($5YEjx.DES),
    "des-ecb": $5YEjx.DES
};
$d4f2b9961c11a37f$var$modes.des = $d4f2b9961c11a37f$var$modes["des-cbc"];
$d4f2b9961c11a37f$var$modes.des3 = $d4f2b9961c11a37f$var$modes["des-ede3-cbc"];
module.exports = $d4f2b9961c11a37f$var$DES;
$ajIeE($d4f2b9961c11a37f$var$DES, $cfJt1);
function $d4f2b9961c11a37f$var$DES(opts) {
    $cfJt1.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $d4f2b9961c11a37f$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$d4f2b9961c11a37f$require$Buffer.isBuffer(key)) key = $d4f2b9961c11a37f$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $d4f2b9961c11a37f$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$d4f2b9961c11a37f$require$Buffer.isBuffer(iv)) iv = $d4f2b9961c11a37f$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$d4f2b9961c11a37f$var$DES.prototype._update = function(data) {
    return $d4f2b9961c11a37f$require$Buffer.from(this._des.update(data));
};
$d4f2b9961c11a37f$var$DES.prototype._final = function() {
    return $d4f2b9961c11a37f$require$Buffer.from(this._des.final());
};

});
parcelRegister("5YEjx", function(module, exports) {

$parcel$export(module.exports, "DES", () => $45a1d3e842b3e6a5$export$cc8859615686b300, (v) => $45a1d3e842b3e6a5$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $45a1d3e842b3e6a5$export$8ad3f227af08fcc5, (v) => $45a1d3e842b3e6a5$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $45a1d3e842b3e6a5$export$947646e34766044f, (v) => $45a1d3e842b3e6a5$export$947646e34766044f = v);
var $45a1d3e842b3e6a5$export$eab97d15b1788b8d;
var $45a1d3e842b3e6a5$export$26e5786e8ac8e530;
var $45a1d3e842b3e6a5$export$cc8859615686b300;
var $45a1d3e842b3e6a5$export$8ad3f227af08fcc5;
var $45a1d3e842b3e6a5$export$947646e34766044f;
"use strict";

$45a1d3e842b3e6a5$export$eab97d15b1788b8d = (parcelRequire("ezwP4"));

$45a1d3e842b3e6a5$export$26e5786e8ac8e530 = (parcelRequire("l0qDL"));

$45a1d3e842b3e6a5$export$cc8859615686b300 = (parcelRequire("kFz5u"));

$45a1d3e842b3e6a5$export$8ad3f227af08fcc5 = (parcelRequire("g2Bbh"));

$45a1d3e842b3e6a5$export$947646e34766044f = (parcelRequire("d2EOO"));

});
parcelRegister("ezwP4", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $a9bdcb7bc87ecd3a$export$cfaef8ed399428b0, (v) => $a9bdcb7bc87ecd3a$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $a9bdcb7bc87ecd3a$export$a80c7deaea7cbd80, (v) => $a9bdcb7bc87ecd3a$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $a9bdcb7bc87ecd3a$export$ed7577ae6e1cd0ef, (v) => $a9bdcb7bc87ecd3a$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $a9bdcb7bc87ecd3a$export$5dcbef3aa594f567, (v) => $a9bdcb7bc87ecd3a$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $a9bdcb7bc87ecd3a$export$5bc8001ca71ed9c5, (v) => $a9bdcb7bc87ecd3a$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $a9bdcb7bc87ecd3a$export$3e714e2c5d5d8cb2, (v) => $a9bdcb7bc87ecd3a$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $a9bdcb7bc87ecd3a$export$94c3e544fd062b7f, (v) => $a9bdcb7bc87ecd3a$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $a9bdcb7bc87ecd3a$export$9f77e0932fb78f72, (v) => $a9bdcb7bc87ecd3a$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $a9bdcb7bc87ecd3a$export$d865ce2836f5927f, (v) => $a9bdcb7bc87ecd3a$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $a9bdcb7bc87ecd3a$export$95e62ad65da8b7d2, (v) => $a9bdcb7bc87ecd3a$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $a9bdcb7bc87ecd3a$export$209139ff098c441a, (v) => $a9bdcb7bc87ecd3a$export$209139ff098c441a = v);
var $a9bdcb7bc87ecd3a$export$cfaef8ed399428b0;
var $a9bdcb7bc87ecd3a$export$a80c7deaea7cbd80;
var $a9bdcb7bc87ecd3a$export$ed7577ae6e1cd0ef;
var $a9bdcb7bc87ecd3a$export$5dcbef3aa594f567;
var $a9bdcb7bc87ecd3a$export$5bc8001ca71ed9c5;
var $a9bdcb7bc87ecd3a$export$3e714e2c5d5d8cb2;
var $a9bdcb7bc87ecd3a$export$94c3e544fd062b7f;
var $a9bdcb7bc87ecd3a$export$9f77e0932fb78f72;
var $a9bdcb7bc87ecd3a$export$d865ce2836f5927f;
var $a9bdcb7bc87ecd3a$export$95e62ad65da8b7d2;
var $a9bdcb7bc87ecd3a$export$209139ff098c441a;
"use strict";
$a9bdcb7bc87ecd3a$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$a9bdcb7bc87ecd3a$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$a9bdcb7bc87ecd3a$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$a9bdcb7bc87ecd3a$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$a9bdcb7bc87ecd3a$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$a9bdcb7bc87ecd3a$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $a9bdcb7bc87ecd3a$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$a9bdcb7bc87ecd3a$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $a9bdcb7bc87ecd3a$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $a9bdcb7bc87ecd3a$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $a9bdcb7bc87ecd3a$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $a9bdcb7bc87ecd3a$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$a9bdcb7bc87ecd3a$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $a9bdcb7bc87ecd3a$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$a9bdcb7bc87ecd3a$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $a9bdcb7bc87ecd3a$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $a9bdcb7bc87ecd3a$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $a9bdcb7bc87ecd3a$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$a9bdcb7bc87ecd3a$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $a9bdcb7bc87ecd3a$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $a9bdcb7bc87ecd3a$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$a9bdcb7bc87ecd3a$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("l0qDL", function(module, exports) {
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");
function $f4ae43455d056d46$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $f4ae43455d056d46$var$Cipher;
$f4ae43455d056d46$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$f4ae43455d056d46$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$f4ae43455d056d46$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$f4ae43455d056d46$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$f4ae43455d056d46$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$f4ae43455d056d46$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$f4ae43455d056d46$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$f4ae43455d056d46$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$f4ae43455d056d46$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$f4ae43455d056d46$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$f4ae43455d056d46$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $i1Wrq.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("kFz5u", function(module, exports) {
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");

var $ajIeE = parcelRequire("ajIeE");

var $ezwP4 = parcelRequire("ezwP4");

var $l0qDL = parcelRequire("l0qDL");
function $f0c2daa31a5b8d40$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f0c2daa31a5b8d40$var$DES(options) {
    $l0qDL.call(this, options);
    var state = new $f0c2daa31a5b8d40$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$ajIeE($f0c2daa31a5b8d40$var$DES, $l0qDL);
module.exports = $f0c2daa31a5b8d40$var$DES;
$f0c2daa31a5b8d40$var$DES.create = function create(options) {
    return new $f0c2daa31a5b8d40$var$DES(options);
};
var $f0c2daa31a5b8d40$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f0c2daa31a5b8d40$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $i1Wrq.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $ezwP4.readUInt32BE(key, 0);
    var kR = $ezwP4.readUInt32BE(key, 4);
    $ezwP4.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f0c2daa31a5b8d40$var$shiftTable[i >>> 1];
        kL = $ezwP4.r28shl(kL, shift);
        kR = $ezwP4.r28shl(kR, shift);
        $ezwP4.pc2(kL, kR, state.keys, i);
    }
};
$f0c2daa31a5b8d40$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $ezwP4.readUInt32BE(inp, inOff);
    var r = $ezwP4.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $ezwP4.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $ezwP4.writeUInt32BE(out, l, outOff);
    $ezwP4.writeUInt32BE(out, r, outOff + 4);
};
$f0c2daa31a5b8d40$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f0c2daa31a5b8d40$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$i1Wrq.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f0c2daa31a5b8d40$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $ezwP4.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $ezwP4.substitute(keyL, keyR);
        var f = $ezwP4.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $ezwP4.rip(r, l, out, off);
};
$f0c2daa31a5b8d40$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $ezwP4.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $ezwP4.substitute(keyL, keyR);
        var f = $ezwP4.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $ezwP4.rip(l, r, out, off);
};

});

parcelRegister("g2Bbh", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $bad9ac9a70977337$export$f9bb8d20ccc7477a, (v) => $bad9ac9a70977337$export$f9bb8d20ccc7477a = v);
var $bad9ac9a70977337$export$f9bb8d20ccc7477a;
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");

var $ajIeE = parcelRequire("ajIeE");
var $bad9ac9a70977337$var$proto = {};
function $bad9ac9a70977337$var$CBCState(iv) {
    $i1Wrq.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $bad9ac9a70977337$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $ajIeE(CBC, Base);
    var keys = Object.keys($bad9ac9a70977337$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $bad9ac9a70977337$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$bad9ac9a70977337$export$f9bb8d20ccc7477a = $bad9ac9a70977337$var$instantiate;
$bad9ac9a70977337$var$proto._cbcInit = function _cbcInit() {
    var state = new $bad9ac9a70977337$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$bad9ac9a70977337$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("d2EOO", function(module, exports) {
"use strict";

var $i1Wrq = parcelRequire("i1Wrq");

var $ajIeE = parcelRequire("ajIeE");

var $l0qDL = parcelRequire("l0qDL");

var $kFz5u = parcelRequire("kFz5u");
function $97eb20013472e3bf$var$EDEState(type, key) {
    $i1Wrq.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $kFz5u.create({
            type: "encrypt",
            key: k1
        }),
        $kFz5u.create({
            type: "decrypt",
            key: k2
        }),
        $kFz5u.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $kFz5u.create({
            type: "decrypt",
            key: k3
        }),
        $kFz5u.create({
            type: "encrypt",
            key: k2
        }),
        $kFz5u.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $97eb20013472e3bf$var$EDE(options) {
    $l0qDL.call(this, options);
    var state = new $97eb20013472e3bf$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$ajIeE($97eb20013472e3bf$var$EDE, $l0qDL);
module.exports = $97eb20013472e3bf$var$EDE;
$97eb20013472e3bf$var$EDE.create = function create(options) {
    return new $97eb20013472e3bf$var$EDE(options);
};
$97eb20013472e3bf$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$97eb20013472e3bf$var$EDE.prototype._pad = $kFz5u.prototype._pad;
$97eb20013472e3bf$var$EDE.prototype._unpad = $kFz5u.prototype._unpad;

});



parcelRegister("dSiaU", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $a19e6aa75e98733b$export$2f64596b8cbf08b4, (v) => $a19e6aa75e98733b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $a19e6aa75e98733b$export$36b6d6ef312eab39, (v) => $a19e6aa75e98733b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $a19e6aa75e98733b$export$58a258485f1e49f6, (v) => $a19e6aa75e98733b$export$58a258485f1e49f6 = v);
var $a19e6aa75e98733b$export$bdd223f16383713e;
var $a19e6aa75e98733b$export$26e5786e8ac8e530;
var $a19e6aa75e98733b$export$2f64596b8cbf08b4;
var $a19e6aa75e98733b$export$20533d26f07f1ee0;
var $a19e6aa75e98733b$export$12ada9414fbc594c;
var $a19e6aa75e98733b$export$2ce6d8d0e8b04e1a;
var $a19e6aa75e98733b$export$36b6d6ef312eab39;
var $a19e6aa75e98733b$export$f5e7e39d57cd9700;
var $a19e6aa75e98733b$export$dedd8dc3dc62b370;
var $a19e6aa75e98733b$export$58a258485f1e49f6;

var $89O5P = parcelRequire("89O5P");

var $6RVoW = parcelRequire("6RVoW");

var $aRER5 = parcelRequire("aRER5");
function $a19e6aa75e98733b$var$getCiphers() {
    return Object.keys($aRER5);
}
$a19e6aa75e98733b$export$bdd223f16383713e = $a19e6aa75e98733b$export$26e5786e8ac8e530 = $89O5P.createCipher;
$a19e6aa75e98733b$export$2f64596b8cbf08b4 = $a19e6aa75e98733b$export$20533d26f07f1ee0 = $89O5P.createCipheriv;
$a19e6aa75e98733b$export$12ada9414fbc594c = $a19e6aa75e98733b$export$2ce6d8d0e8b04e1a = $6RVoW.createDecipher;
$a19e6aa75e98733b$export$36b6d6ef312eab39 = $a19e6aa75e98733b$export$f5e7e39d57cd9700 = $6RVoW.createDecipheriv;
$a19e6aa75e98733b$export$dedd8dc3dc62b370 = $a19e6aa75e98733b$export$58a258485f1e49f6 = $a19e6aa75e98733b$var$getCiphers;

});
parcelRegister("89O5P", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5f060572803abb9b$export$2f64596b8cbf08b4, (v) => $5f060572803abb9b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $5f060572803abb9b$export$bdd223f16383713e, (v) => $5f060572803abb9b$export$bdd223f16383713e = v);
var $5f060572803abb9b$export$2f64596b8cbf08b4;
var $5f060572803abb9b$export$bdd223f16383713e;

var $27wJJ = parcelRequire("27wJJ");

var $jnnNZ = parcelRequire("jnnNZ");

var $fx8YU = parcelRequire("fx8YU");
var $5f060572803abb9b$require$Buffer = $fx8YU.Buffer;

var $013Q1 = parcelRequire("013Q1");

var $cfJt1 = parcelRequire("cfJt1");

var $kNcKN = parcelRequire("kNcKN");

var $42eaE = parcelRequire("42eaE");

var $ajIeE = parcelRequire("ajIeE");
function $5f060572803abb9b$var$Cipher(mode, key, iv) {
    $cfJt1.call(this);
    this._cache = new $5f060572803abb9b$var$Splitter();
    this._cipher = new $kNcKN.AES(key);
    this._prev = $5f060572803abb9b$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$ajIeE($5f060572803abb9b$var$Cipher, $cfJt1);
$5f060572803abb9b$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $5f060572803abb9b$require$Buffer.concat(out);
};
var $5f060572803abb9b$var$PADDING = $5f060572803abb9b$require$Buffer.alloc(16, 0x10);
$5f060572803abb9b$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($5f060572803abb9b$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$5f060572803abb9b$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $5f060572803abb9b$var$Splitter() {
    this.cache = $5f060572803abb9b$require$Buffer.allocUnsafe(0);
}
$5f060572803abb9b$var$Splitter.prototype.add = function(data) {
    this.cache = $5f060572803abb9b$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$5f060572803abb9b$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$5f060572803abb9b$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $5f060572803abb9b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $5f060572803abb9b$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $5f060572803abb9b$var$createCipheriv(suite, password, iv) {
    var config = $27wJJ[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $5f060572803abb9b$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $5f060572803abb9b$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $013Q1(config.module, password, iv);
    else if (config.type === "auth") return new $jnnNZ(config.module, password, iv);
    return new $5f060572803abb9b$var$Cipher(config.module, password, iv);
}
function $5f060572803abb9b$var$createCipher(suite, password) {
    var config = $27wJJ[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $42eaE(password, false, config.key, config.iv);
    return $5f060572803abb9b$var$createCipheriv(suite, keys.key, keys.iv);
}
$5f060572803abb9b$export$2f64596b8cbf08b4 = $5f060572803abb9b$var$createCipheriv;
$5f060572803abb9b$export$bdd223f16383713e = $5f060572803abb9b$var$createCipher;

});
parcelRegister("27wJJ", function(module, exports) {








var $18b5a1006d7b955f$var$modeModules = {
    ECB: (parcelRequire("9CzFk")),
    CBC: (parcelRequire("iIACv")),
    CFB: (parcelRequire("f58yZ")),
    CFB8: (parcelRequire("rZinp")),
    CFB1: (parcelRequire("5Yu2V")),
    OFB: (parcelRequire("a2NH7")),
    CTR: (parcelRequire("aHrxD")),
    GCM: (parcelRequire("aHrxD"))
};

var $aRER5 = parcelRequire("aRER5");
for(var $18b5a1006d7b955f$var$key in $aRER5)$aRER5[$18b5a1006d7b955f$var$key].module = $18b5a1006d7b955f$var$modeModules[$aRER5[$18b5a1006d7b955f$var$key].mode];
module.exports = $aRER5;

});
parcelRegister("9CzFk", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $701354206d01dd7c$export$5b0f6292f11d1d18, (v) => $701354206d01dd7c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $701354206d01dd7c$export$e85a0c9a1067c5d3, (v) => $701354206d01dd7c$export$e85a0c9a1067c5d3 = v);
var $701354206d01dd7c$export$5b0f6292f11d1d18;
var $701354206d01dd7c$export$e85a0c9a1067c5d3;
$701354206d01dd7c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$701354206d01dd7c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("iIACv", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $da08be0aeb2eebc7$export$5b0f6292f11d1d18, (v) => $da08be0aeb2eebc7$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $da08be0aeb2eebc7$export$e85a0c9a1067c5d3, (v) => $da08be0aeb2eebc7$export$e85a0c9a1067c5d3 = v);
var $da08be0aeb2eebc7$export$5b0f6292f11d1d18;
var $da08be0aeb2eebc7$export$e85a0c9a1067c5d3;

var $dHQXb = parcelRequire("dHQXb");
$da08be0aeb2eebc7$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dHQXb(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$da08be0aeb2eebc7$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dHQXb(out, pad);
};

});
parcelRegister("dHQXb", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $9fa85e00e641ee8d$require$Buffer = $N0o3H.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $9fa85e00e641ee8d$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("f58yZ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afadf72432ea4352$export$5b0f6292f11d1d18, (v) => $afadf72432ea4352$export$5b0f6292f11d1d18 = v);
var $afadf72432ea4352$export$5b0f6292f11d1d18;

var $fx8YU = parcelRequire("fx8YU");
var $afadf72432ea4352$require$Buffer = $fx8YU.Buffer;

var $dHQXb = parcelRequire("dHQXb");
function $afadf72432ea4352$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dHQXb(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $afadf72432ea4352$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$afadf72432ea4352$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $afadf72432ea4352$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $afadf72432ea4352$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $afadf72432ea4352$require$Buffer.concat([
                out,
                $afadf72432ea4352$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $afadf72432ea4352$require$Buffer.concat([
                out,
                $afadf72432ea4352$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("rZinp", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $054211b86e73135c$export$5b0f6292f11d1d18, (v) => $054211b86e73135c$export$5b0f6292f11d1d18 = v);
var $054211b86e73135c$export$5b0f6292f11d1d18;

var $fx8YU = parcelRequire("fx8YU");
var $054211b86e73135c$require$Buffer = $fx8YU.Buffer;
function $054211b86e73135c$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $054211b86e73135c$require$Buffer.concat([
        self._prev.slice(1),
        $054211b86e73135c$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$054211b86e73135c$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $054211b86e73135c$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $054211b86e73135c$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("5Yu2V", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $4599dcdf2c33141f$export$5b0f6292f11d1d18, (v) => $4599dcdf2c33141f$export$5b0f6292f11d1d18 = v);
var $4599dcdf2c33141f$export$5b0f6292f11d1d18;

var $fx8YU = parcelRequire("fx8YU");
var $4599dcdf2c33141f$require$Buffer = $fx8YU.Buffer;
function $4599dcdf2c33141f$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4599dcdf2c33141f$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4599dcdf2c33141f$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4599dcdf2c33141f$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4599dcdf2c33141f$require$Buffer.concat([
        buffer,
        $4599dcdf2c33141f$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4599dcdf2c33141f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4599dcdf2c33141f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4599dcdf2c33141f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("a2NH7", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $7500a392b8d1f80c$export$5b0f6292f11d1d18, (v) => $7500a392b8d1f80c$export$5b0f6292f11d1d18 = v);
var $7500a392b8d1f80c$export$5b0f6292f11d1d18;

var $N0o3H = parcelRequire("N0o3H");
var $7500a392b8d1f80c$require$Buffer = $N0o3H.Buffer;

var $dHQXb = parcelRequire("dHQXb");
function $7500a392b8d1f80c$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$7500a392b8d1f80c$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $7500a392b8d1f80c$require$Buffer.concat([
        self._cache,
        $7500a392b8d1f80c$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dHQXb(chunk, pad);
};

});

parcelRegister("aHrxD", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $7ca348b5336f9b58$export$5b0f6292f11d1d18, (v) => $7ca348b5336f9b58$export$5b0f6292f11d1d18 = v);
var $7ca348b5336f9b58$export$5b0f6292f11d1d18;

var $dHQXb = parcelRequire("dHQXb");

var $fx8YU = parcelRequire("fx8YU");
var $7ca348b5336f9b58$require$Buffer = $fx8YU.Buffer;

var $cM96m = parcelRequire("cM96m");
function $7ca348b5336f9b58$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $cM96m(self._prev);
    return out;
}
var $7ca348b5336f9b58$var$blockSize = 16;
$7ca348b5336f9b58$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $7ca348b5336f9b58$var$blockSize);
    var start = self._cache.length;
    self._cache = $7ca348b5336f9b58$require$Buffer.concat([
        self._cache,
        $7ca348b5336f9b58$require$Buffer.allocUnsafe(chunkNum * $7ca348b5336f9b58$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $7ca348b5336f9b58$var$getBlock(self);
        var offset = start + i * $7ca348b5336f9b58$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dHQXb(chunk, pad);
};

});
parcelRegister("cM96m", function(module, exports) {
function $94d107249f851e69$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $94d107249f851e69$var$incr32;

});


parcelRegister("aRER5", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("jnnNZ", function(module, exports) {

var $kNcKN = parcelRequire("kNcKN");

var $fx8YU = parcelRequire("fx8YU");
var $e1b2a18bf5783345$require$Buffer = $fx8YU.Buffer;

var $cfJt1 = parcelRequire("cfJt1");

var $ajIeE = parcelRequire("ajIeE");

var $krJ7h = parcelRequire("krJ7h");

var $dHQXb = parcelRequire("dHQXb");

var $cM96m = parcelRequire("cM96m");
function $e1b2a18bf5783345$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $e1b2a18bf5783345$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $e1b2a18bf5783345$require$Buffer.concat([
            iv,
            $e1b2a18bf5783345$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $e1b2a18bf5783345$require$Buffer.concat([
            iv,
            $e1b2a18bf5783345$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $krJ7h(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($e1b2a18bf5783345$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($e1b2a18bf5783345$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $e1b2a18bf5783345$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $e1b2a18bf5783345$require$Buffer.from(self._finID);
    $cM96m(out);
    return out;
}
function $e1b2a18bf5783345$var$StreamCipher(mode, key, iv, decrypt) {
    $cfJt1.call(this);
    var h = $e1b2a18bf5783345$require$Buffer.alloc(4, 0);
    this._cipher = new $kNcKN.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $krJ7h(ck);
    iv = $e1b2a18bf5783345$var$calcIv(this, iv, ck);
    this._prev = $e1b2a18bf5783345$require$Buffer.from(iv);
    this._cache = $e1b2a18bf5783345$require$Buffer.allocUnsafe(0);
    this._secCache = $e1b2a18bf5783345$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$ajIeE($e1b2a18bf5783345$var$StreamCipher, $cfJt1);
$e1b2a18bf5783345$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $e1b2a18bf5783345$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$e1b2a18bf5783345$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dHQXb(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $e1b2a18bf5783345$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$e1b2a18bf5783345$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$e1b2a18bf5783345$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$e1b2a18bf5783345$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$e1b2a18bf5783345$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $e1b2a18bf5783345$var$StreamCipher;

});
parcelRegister("kNcKN", function(module, exports) {

$parcel$export(module.exports, "AES", () => $f23246e0fc5dd731$export$b80fbe1c3a2b92b5, (v) => $f23246e0fc5dd731$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $f23246e0fc5dd731$export$b80fbe1c3a2b92b5;

var $fx8YU = parcelRequire("fx8YU");
var $f23246e0fc5dd731$require$Buffer = $fx8YU.Buffer;
function $f23246e0fc5dd731$var$asUInt32Array(buf) {
    if (!$f23246e0fc5dd731$require$Buffer.isBuffer(buf)) buf = $f23246e0fc5dd731$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $f23246e0fc5dd731$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $f23246e0fc5dd731$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $f23246e0fc5dd731$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $f23246e0fc5dd731$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $f23246e0fc5dd731$var$AES(key) {
    this._key = $f23246e0fc5dd731$var$asUInt32Array(key);
    this._reset();
}
$f23246e0fc5dd731$var$AES.blockSize = 16;
$f23246e0fc5dd731$var$AES.keySize = 32;
$f23246e0fc5dd731$var$AES.prototype.blockSize = $f23246e0fc5dd731$var$AES.blockSize;
$f23246e0fc5dd731$var$AES.prototype.keySize = $f23246e0fc5dd731$var$AES.keySize;
$f23246e0fc5dd731$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $f23246e0fc5dd731$var$G.SBOX[t >>> 24] << 24 | $f23246e0fc5dd731$var$G.SBOX[t >>> 16 & 0xff] << 16 | $f23246e0fc5dd731$var$G.SBOX[t >>> 8 & 0xff] << 8 | $f23246e0fc5dd731$var$G.SBOX[t & 0xff];
            t ^= $f23246e0fc5dd731$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $f23246e0fc5dd731$var$G.SBOX[t >>> 24] << 24 | $f23246e0fc5dd731$var$G.SBOX[t >>> 16 & 0xff] << 16 | $f23246e0fc5dd731$var$G.SBOX[t >>> 8 & 0xff] << 8 | $f23246e0fc5dd731$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $f23246e0fc5dd731$var$G.INV_SUB_MIX[0][$f23246e0fc5dd731$var$G.SBOX[tt >>> 24]] ^ $f23246e0fc5dd731$var$G.INV_SUB_MIX[1][$f23246e0fc5dd731$var$G.SBOX[tt >>> 16 & 0xff]] ^ $f23246e0fc5dd731$var$G.INV_SUB_MIX[2][$f23246e0fc5dd731$var$G.SBOX[tt >>> 8 & 0xff]] ^ $f23246e0fc5dd731$var$G.INV_SUB_MIX[3][$f23246e0fc5dd731$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$f23246e0fc5dd731$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $f23246e0fc5dd731$var$asUInt32Array(M);
    return $f23246e0fc5dd731$var$cryptBlock(M, this._keySchedule, $f23246e0fc5dd731$var$G.SUB_MIX, $f23246e0fc5dd731$var$G.SBOX, this._nRounds);
};
$f23246e0fc5dd731$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $f23246e0fc5dd731$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$f23246e0fc5dd731$var$AES.prototype.decryptBlock = function(M) {
    M = $f23246e0fc5dd731$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $f23246e0fc5dd731$var$cryptBlock(M, this._invKeySchedule, $f23246e0fc5dd731$var$G.INV_SUB_MIX, $f23246e0fc5dd731$var$G.INV_SBOX, this._nRounds);
    var buf = $f23246e0fc5dd731$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$f23246e0fc5dd731$var$AES.prototype.scrub = function() {
    $f23246e0fc5dd731$var$scrubVec(this._keySchedule);
    $f23246e0fc5dd731$var$scrubVec(this._invKeySchedule);
    $f23246e0fc5dd731$var$scrubVec(this._key);
};
$f23246e0fc5dd731$export$b80fbe1c3a2b92b5 = $f23246e0fc5dd731$var$AES;

});

parcelRegister("krJ7h", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $ee29536c01ea64e2$require$Buffer = $fx8YU.Buffer;
var $ee29536c01ea64e2$var$ZEROES = $ee29536c01ea64e2$require$Buffer.alloc(16, 0);
function $ee29536c01ea64e2$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $ee29536c01ea64e2$var$fromArray(out) {
    var buf = $ee29536c01ea64e2$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $ee29536c01ea64e2$var$GHASH(key) {
    this.h = key;
    this.state = $ee29536c01ea64e2$require$Buffer.alloc(16, 0);
    this.cache = $ee29536c01ea64e2$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$ee29536c01ea64e2$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$ee29536c01ea64e2$var$GHASH.prototype._multiply = function() {
    var Vi = $ee29536c01ea64e2$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $ee29536c01ea64e2$var$fromArray(Zi);
};
$ee29536c01ea64e2$var$GHASH.prototype.update = function(buf) {
    this.cache = $ee29536c01ea64e2$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$ee29536c01ea64e2$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($ee29536c01ea64e2$require$Buffer.concat([
        this.cache,
        $ee29536c01ea64e2$var$ZEROES
    ], 16));
    this.ghash($ee29536c01ea64e2$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $ee29536c01ea64e2$var$GHASH;

});


parcelRegister("013Q1", function(module, exports) {

var $kNcKN = parcelRequire("kNcKN");

var $fx8YU = parcelRequire("fx8YU");
var $0033124b9ea2242a$require$Buffer = $fx8YU.Buffer;

var $cfJt1 = parcelRequire("cfJt1");

var $ajIeE = parcelRequire("ajIeE");
function $0033124b9ea2242a$var$StreamCipher(mode, key, iv, decrypt) {
    $cfJt1.call(this);
    this._cipher = new $kNcKN.AES(key);
    this._prev = $0033124b9ea2242a$require$Buffer.from(iv);
    this._cache = $0033124b9ea2242a$require$Buffer.allocUnsafe(0);
    this._secCache = $0033124b9ea2242a$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$ajIeE($0033124b9ea2242a$var$StreamCipher, $cfJt1);
$0033124b9ea2242a$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$0033124b9ea2242a$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $0033124b9ea2242a$var$StreamCipher;

});

parcelRegister("42eaE", function(module, exports) {

var $fx8YU = parcelRequire("fx8YU");
var $2f025757bd7902d5$require$Buffer = $fx8YU.Buffer;

var $bHoGp = parcelRequire("bHoGp");
/* eslint-disable camelcase */ function $2f025757bd7902d5$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$2f025757bd7902d5$require$Buffer.isBuffer(password)) password = $2f025757bd7902d5$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$2f025757bd7902d5$require$Buffer.isBuffer(salt)) salt = $2f025757bd7902d5$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $2f025757bd7902d5$require$Buffer.alloc(keyLen);
    var iv = $2f025757bd7902d5$require$Buffer.alloc(ivLen || 0);
    var tmp = $2f025757bd7902d5$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $bHoGp();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $2f025757bd7902d5$var$EVP_BytesToKey;

});


parcelRegister("6RVoW", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $50043807c52ea96d$export$12ada9414fbc594c, (v) => $50043807c52ea96d$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $50043807c52ea96d$export$36b6d6ef312eab39, (v) => $50043807c52ea96d$export$36b6d6ef312eab39 = v);
var $50043807c52ea96d$export$12ada9414fbc594c;
var $50043807c52ea96d$export$36b6d6ef312eab39;

var $jnnNZ = parcelRequire("jnnNZ");

var $fx8YU = parcelRequire("fx8YU");
var $50043807c52ea96d$require$Buffer = $fx8YU.Buffer;

var $27wJJ = parcelRequire("27wJJ");

var $013Q1 = parcelRequire("013Q1");

var $cfJt1 = parcelRequire("cfJt1");

var $kNcKN = parcelRequire("kNcKN");

var $42eaE = parcelRequire("42eaE");

var $ajIeE = parcelRequire("ajIeE");
function $50043807c52ea96d$var$Decipher(mode, key, iv) {
    $cfJt1.call(this);
    this._cache = new $50043807c52ea96d$var$Splitter();
    this._last = void 0;
    this._cipher = new $kNcKN.AES(key);
    this._prev = $50043807c52ea96d$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$ajIeE($50043807c52ea96d$var$Decipher, $cfJt1);
$50043807c52ea96d$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $50043807c52ea96d$require$Buffer.concat(out);
};
$50043807c52ea96d$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $50043807c52ea96d$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$50043807c52ea96d$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $50043807c52ea96d$var$Splitter() {
    this.cache = $50043807c52ea96d$require$Buffer.allocUnsafe(0);
}
$50043807c52ea96d$var$Splitter.prototype.add = function(data) {
    this.cache = $50043807c52ea96d$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$50043807c52ea96d$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$50043807c52ea96d$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $50043807c52ea96d$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $50043807c52ea96d$var$createDecipheriv(suite, password, iv) {
    var config = $27wJJ[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $50043807c52ea96d$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $50043807c52ea96d$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $013Q1(config.module, password, iv, true);
    else if (config.type === "auth") return new $jnnNZ(config.module, password, iv, true);
    return new $50043807c52ea96d$var$Decipher(config.module, password, iv);
}
function $50043807c52ea96d$var$createDecipher(suite, password) {
    var config = $27wJJ[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $42eaE(password, false, config.key, config.iv);
    return $50043807c52ea96d$var$createDecipheriv(suite, keys.key, keys.iv);
}
$50043807c52ea96d$export$12ada9414fbc594c = $50043807c52ea96d$var$createDecipher;
$50043807c52ea96d$export$36b6d6ef312eab39 = $50043807c52ea96d$var$createDecipheriv;

});


parcelRegister("aQ0CP", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $7e3f3ee6c90ae505$export$116f8a5cee447347, (v) => $7e3f3ee6c90ae505$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $7e3f3ee6c90ae505$export$7483c4066bfb7ae9, (v) => $7e3f3ee6c90ae505$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $7e3f3ee6c90ae505$export$e7a565d2e588bb06, (v) => $7e3f3ee6c90ae505$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $7e3f3ee6c90ae505$export$aaa2f54a426f3eb8, (v) => $7e3f3ee6c90ae505$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $7e3f3ee6c90ae505$export$eba20568dde4ada, (v) => $7e3f3ee6c90ae505$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $7e3f3ee6c90ae505$export$d3b5e5996938f5ae, (v) => $7e3f3ee6c90ae505$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $7e3f3ee6c90ae505$export$57c08356130bc99b, (v) => $7e3f3ee6c90ae505$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $7e3f3ee6c90ae505$export$c7169791d5c1e65d, (v) => $7e3f3ee6c90ae505$export$c7169791d5c1e65d = v);
var $7e3f3ee6c90ae505$export$116f8a5cee447347;
var $7e3f3ee6c90ae505$export$7483c4066bfb7ae9;
var $7e3f3ee6c90ae505$export$e7a565d2e588bb06;
var $7e3f3ee6c90ae505$export$aaa2f54a426f3eb8;
var $7e3f3ee6c90ae505$export$eba20568dde4ada;
var $7e3f3ee6c90ae505$export$d3b5e5996938f5ae;
var $7e3f3ee6c90ae505$export$57c08356130bc99b;
var $7e3f3ee6c90ae505$export$c7169791d5c1e65d;
$7e3f3ee6c90ae505$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$7e3f3ee6c90ae505$export$7483c4066bfb7ae9 = $7e3f3ee6c90ae505$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$7e3f3ee6c90ae505$export$aaa2f54a426f3eb8 = $7e3f3ee6c90ae505$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$7e3f3ee6c90ae505$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$7e3f3ee6c90ae505$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$7e3f3ee6c90ae505$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("65cae", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $46dca53c1da219bc$export$971862a2fcb1bb40, (v) => $46dca53c1da219bc$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $46dca53c1da219bc$export$c6ff6a88acbeaf40, (v) => $46dca53c1da219bc$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $46dca53c1da219bc$export$fdc27893e98845cc, (v) => $46dca53c1da219bc$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $46dca53c1da219bc$export$6671fb9a1323bed, (v) => $46dca53c1da219bc$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $46dca53c1da219bc$export$d74daf141a551db, (v) => $46dca53c1da219bc$export$d74daf141a551db = v);
var $46dca53c1da219bc$export$971862a2fcb1bb40;
var $46dca53c1da219bc$export$c6ff6a88acbeaf40;
var $46dca53c1da219bc$export$fdc27893e98845cc;
var $46dca53c1da219bc$export$6671fb9a1323bed;
var $46dca53c1da219bc$export$d74daf141a551db;

var $N0o3H = parcelRequire("N0o3H");
var $46dca53c1da219bc$require$Buffer = $N0o3H.Buffer;

var $dip75 = parcelRequire("dip75");

var $6CFZX = parcelRequire("6CFZX");

var $bMVP5 = parcelRequire("bMVP5");
function $46dca53c1da219bc$var$getDiffieHellman(mod) {
    var prime = new $46dca53c1da219bc$require$Buffer($6CFZX[mod].prime, "hex");
    var gen = new $46dca53c1da219bc$require$Buffer($6CFZX[mod].gen, "hex");
    return new $bMVP5(prime, gen);
}
var $46dca53c1da219bc$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $46dca53c1da219bc$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($46dca53c1da219bc$require$Buffer.isBuffer(enc) || $46dca53c1da219bc$var$ENCODINGS[enc] === undefined) return $46dca53c1da219bc$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $46dca53c1da219bc$require$Buffer([
        2
    ]);
    if (!$46dca53c1da219bc$require$Buffer.isBuffer(generator)) generator = new $46dca53c1da219bc$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $bMVP5($dip75(prime, generator), generator, true);
    if (!$46dca53c1da219bc$require$Buffer.isBuffer(prime)) prime = new $46dca53c1da219bc$require$Buffer(prime, enc);
    return new $bMVP5(prime, generator, true);
}
$46dca53c1da219bc$export$971862a2fcb1bb40 = $46dca53c1da219bc$export$c6ff6a88acbeaf40 = $46dca53c1da219bc$export$fdc27893e98845cc = $46dca53c1da219bc$var$getDiffieHellman;
$46dca53c1da219bc$export$6671fb9a1323bed = $46dca53c1da219bc$export$d74daf141a551db = $46dca53c1da219bc$var$createDiffieHellman;

});
parcelRegister("dip75", function(module, exports) {

var $e3qkY = parcelRequire("e3qkY");
module.exports = $9ae06fc46ed01f88$var$findPrime;
$9ae06fc46ed01f88$var$findPrime.simpleSieve = $9ae06fc46ed01f88$var$simpleSieve;
$9ae06fc46ed01f88$var$findPrime.fermatTest = $9ae06fc46ed01f88$var$fermatTest;

var $igEWc = parcelRequire("igEWc");
var $9ae06fc46ed01f88$var$TWENTYFOUR = new $igEWc(24);

var $icyjz = parcelRequire("icyjz");
var $9ae06fc46ed01f88$var$millerRabin = new $icyjz();
var $9ae06fc46ed01f88$var$ONE = new $igEWc(1);
var $9ae06fc46ed01f88$var$TWO = new $igEWc(2);
var $9ae06fc46ed01f88$var$FIVE = new $igEWc(5);
var $9ae06fc46ed01f88$var$SIXTEEN = new $igEWc(16);
var $9ae06fc46ed01f88$var$EIGHT = new $igEWc(8);
var $9ae06fc46ed01f88$var$TEN = new $igEWc(10);
var $9ae06fc46ed01f88$var$THREE = new $igEWc(3);
var $9ae06fc46ed01f88$var$SEVEN = new $igEWc(7);
var $9ae06fc46ed01f88$var$ELEVEN = new $igEWc(11);
var $9ae06fc46ed01f88$var$FOUR = new $igEWc(4);
var $9ae06fc46ed01f88$var$TWELVE = new $igEWc(12);
var $9ae06fc46ed01f88$var$primes = null;
function $9ae06fc46ed01f88$var$_getPrimes() {
    if ($9ae06fc46ed01f88$var$primes !== null) return $9ae06fc46ed01f88$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $9ae06fc46ed01f88$var$primes = res;
    return res;
}
function $9ae06fc46ed01f88$var$simpleSieve(p) {
    var primes = $9ae06fc46ed01f88$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $9ae06fc46ed01f88$var$fermatTest(p) {
    var red = $igEWc.mont(p);
    return $9ae06fc46ed01f88$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $9ae06fc46ed01f88$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $igEWc([
            0x8c,
            0x7b
        ]);
        else return new $igEWc([
            0x8c,
            0x27
        ]);
    }
    gen = new $igEWc(gen);
    var num, n2;
    while(true){
        num = new $igEWc($e3qkY(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($9ae06fc46ed01f88$var$ONE);
        if (!num.testn(1)) num.iadd($9ae06fc46ed01f88$var$TWO);
        if (!gen.cmp($9ae06fc46ed01f88$var$TWO)) while(num.mod($9ae06fc46ed01f88$var$TWENTYFOUR).cmp($9ae06fc46ed01f88$var$ELEVEN))num.iadd($9ae06fc46ed01f88$var$FOUR);
        else if (!gen.cmp($9ae06fc46ed01f88$var$FIVE)) while(num.mod($9ae06fc46ed01f88$var$TEN).cmp($9ae06fc46ed01f88$var$THREE))num.iadd($9ae06fc46ed01f88$var$FOUR);
        n2 = num.shrn(1);
        if ($9ae06fc46ed01f88$var$simpleSieve(n2) && $9ae06fc46ed01f88$var$simpleSieve(num) && $9ae06fc46ed01f88$var$fermatTest(n2) && $9ae06fc46ed01f88$var$fermatTest(num) && $9ae06fc46ed01f88$var$millerRabin.test(n2) && $9ae06fc46ed01f88$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("igEWc", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("icyjz", function(module, exports) {

var $cZUlJ = parcelRequire("cZUlJ");

var $2iwIf = parcelRequire("2iwIf");
function $d403f72ae5f1596b$var$MillerRabin(rand) {
    this.rand = rand || new $2iwIf.Rand();
}
module.exports = $d403f72ae5f1596b$var$MillerRabin;
$d403f72ae5f1596b$var$MillerRabin.create = function create(rand) {
    return new $d403f72ae5f1596b$var$MillerRabin(rand);
};
$d403f72ae5f1596b$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $cZUlJ(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$d403f72ae5f1596b$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$d403f72ae5f1596b$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $cZUlJ.mont(n);
    var rone = new $cZUlJ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $cZUlJ(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$d403f72ae5f1596b$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $cZUlJ.mont(n);
    var rone = new $cZUlJ(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $cZUlJ(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("cZUlJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});



parcelRegister("6CFZX", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("bMVP5", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $895107d2f954ff29$require$Buffer = $N0o3H.Buffer;

var $igEWc = parcelRequire("igEWc");

var $icyjz = parcelRequire("icyjz");
var $895107d2f954ff29$var$millerRabin = new $icyjz();
var $895107d2f954ff29$var$TWENTYFOUR = new $igEWc(24);
var $895107d2f954ff29$var$ELEVEN = new $igEWc(11);
var $895107d2f954ff29$var$TEN = new $igEWc(10);
var $895107d2f954ff29$var$THREE = new $igEWc(3);
var $895107d2f954ff29$var$SEVEN = new $igEWc(7);

var $dip75 = parcelRequire("dip75");

var $e3qkY = parcelRequire("e3qkY");
module.exports = $895107d2f954ff29$var$DH;
function $895107d2f954ff29$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$895107d2f954ff29$require$Buffer.isBuffer(pub)) pub = new $895107d2f954ff29$require$Buffer(pub, enc);
    this._pub = new $igEWc(pub);
    return this;
}
function $895107d2f954ff29$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$895107d2f954ff29$require$Buffer.isBuffer(priv)) priv = new $895107d2f954ff29$require$Buffer(priv, enc);
    this._priv = new $igEWc(priv);
    return this;
}
var $895107d2f954ff29$var$primeCache = {};
function $895107d2f954ff29$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $895107d2f954ff29$var$primeCache) return $895107d2f954ff29$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$dip75.simpleSieve || !$dip75.fermatTest(prime) || !$895107d2f954ff29$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $895107d2f954ff29$var$primeCache[hex] = error;
        return error;
    }
    if (!$895107d2f954ff29$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($895107d2f954ff29$var$TWENTYFOUR).cmp($895107d2f954ff29$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($895107d2f954ff29$var$TEN);
            if (rem.cmp($895107d2f954ff29$var$THREE) && rem.cmp($895107d2f954ff29$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $895107d2f954ff29$var$primeCache[hex] = error;
    return error;
}
function $895107d2f954ff29$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $igEWc(prime);
    this._prime = $igEWc.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $895107d2f954ff29$var$setPublicKey;
        this.setPrivateKey = $895107d2f954ff29$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($895107d2f954ff29$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $895107d2f954ff29$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$895107d2f954ff29$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $igEWc($e3qkY(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$895107d2f954ff29$var$DH.prototype.computeSecret = function(other) {
    other = new $igEWc(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $895107d2f954ff29$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $895107d2f954ff29$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $895107d2f954ff29$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$895107d2f954ff29$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $895107d2f954ff29$var$formatReturnValue(this._pub, enc);
};
$895107d2f954ff29$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $895107d2f954ff29$var$formatReturnValue(this._priv, enc);
};
$895107d2f954ff29$var$DH.prototype.getPrime = function(enc) {
    return $895107d2f954ff29$var$formatReturnValue(this.__prime, enc);
};
$895107d2f954ff29$var$DH.prototype.getGenerator = function(enc) {
    return $895107d2f954ff29$var$formatReturnValue(this._gen, enc);
};
$895107d2f954ff29$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$895107d2f954ff29$require$Buffer.isBuffer(gen)) gen = new $895107d2f954ff29$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $igEWc(gen);
    return this;
};
function $895107d2f954ff29$var$formatReturnValue(bn, enc) {
    var buf = new $895107d2f954ff29$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("79ovU", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $534c638e475f28be$require$Buffer = $fx8YU.Buffer;

var $5dKmo = parcelRequire("5dKmo");

var $gvRey = parcelRequire("gvRey");

var $ajIeE = parcelRequire("ajIeE");

var $lzv05 = parcelRequire("lzv05");

var $72STX = parcelRequire("72STX");

var $34BYE = parcelRequire("34BYE");
Object.keys($34BYE).forEach(function(key) {
    $34BYE[key].id = $534c638e475f28be$require$Buffer.from($34BYE[key].id, "hex");
    $34BYE[key.toLowerCase()] = $34BYE[key];
});
function $534c638e475f28be$var$Sign(algorithm) {
    $gvRey.Writable.call(this);
    var data = $34BYE[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $5dKmo(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$ajIeE($534c638e475f28be$var$Sign, $gvRey.Writable);
$534c638e475f28be$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$534c638e475f28be$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $534c638e475f28be$require$Buffer.from(data, enc) : data);
    return this;
};
$534c638e475f28be$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $lzv05(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $534c638e475f28be$var$Verify(algorithm) {
    $gvRey.Writable.call(this);
    var data = $34BYE[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $5dKmo(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$ajIeE($534c638e475f28be$var$Verify, $gvRey.Writable);
$534c638e475f28be$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$534c638e475f28be$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $534c638e475f28be$require$Buffer.from(data, enc) : data);
    return this;
};
$534c638e475f28be$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $534c638e475f28be$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $72STX(sigBuffer, hash, key, this._signType, this._tag);
};
function $534c638e475f28be$var$createSign(algorithm) {
    return new $534c638e475f28be$var$Sign(algorithm);
}
function $534c638e475f28be$var$createVerify(algorithm) {
    return new $534c638e475f28be$var$Verify(algorithm);
}
module.exports = {
    Sign: $534c638e475f28be$var$createSign,
    Verify: $534c638e475f28be$var$createVerify,
    createSign: $534c638e475f28be$var$createSign,
    createVerify: $534c638e475f28be$var$createVerify
};

});
parcelRegister("lzv05", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $fb44e9de384e6712$require$Buffer = $fx8YU.Buffer;

var $cWxOP = parcelRequire("cWxOP");

var $aMu6D = parcelRequire("aMu6D");

var $7kgn0 = parcelRequire("7kgn0");
var $fb44e9de384e6712$require$EC = $7kgn0.ec;

var $lONYJ = parcelRequire("lONYJ");

var $igmhr = parcelRequire("igmhr");

var $5GWRF = parcelRequire("5GWRF");
var $fb44e9de384e6712$var$RSA_PKCS1_PADDING = 1;
function $fb44e9de384e6712$var$sign(hash, key, hashType, signType, tag) {
    var priv = $igmhr(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $fb44e9de384e6712$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $fb44e9de384e6712$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $fb44e9de384e6712$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $fb44e9de384e6712$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $aMu6D(pad, priv);
    return out;
}
function $fb44e9de384e6712$var$ecSign(hash, priv) {
    var curveId = $5GWRF[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $fb44e9de384e6712$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $fb44e9de384e6712$require$Buffer.from(out.toDER());
}
function $fb44e9de384e6712$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $lONYJ(0);
    var k;
    var H = $fb44e9de384e6712$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $fb44e9de384e6712$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $fb44e9de384e6712$var$makeKey(q, kv, algo);
        r = $fb44e9de384e6712$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $lONYJ(0);
        }
    }
    return $fb44e9de384e6712$var$toDER(r, s);
}
function $fb44e9de384e6712$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $fb44e9de384e6712$require$Buffer.from(res);
}
function $fb44e9de384e6712$var$getKey(x, q, hash, algo) {
    x = $fb44e9de384e6712$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $fb44e9de384e6712$require$Buffer.alloc(q.byteLength() - x.length);
        x = $fb44e9de384e6712$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $fb44e9de384e6712$var$bits2octets(hash, q);
    var v = $fb44e9de384e6712$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $fb44e9de384e6712$require$Buffer.alloc(hlen);
    k = $cWxOP(algo, k).update(v).update($fb44e9de384e6712$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cWxOP(algo, k).update(v).digest();
    k = $cWxOP(algo, k).update(v).update($fb44e9de384e6712$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cWxOP(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $fb44e9de384e6712$var$bits2int(obits, q) {
    var bits = new $lONYJ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $fb44e9de384e6712$var$bits2octets(bits, q) {
    bits = $fb44e9de384e6712$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $fb44e9de384e6712$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $fb44e9de384e6712$require$Buffer.alloc(q.byteLength() - out.length);
        out = $fb44e9de384e6712$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $fb44e9de384e6712$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $fb44e9de384e6712$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cWxOP(algo, kv.k).update(kv.v).digest();
            t = $fb44e9de384e6712$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $fb44e9de384e6712$var$bits2int(t, q);
        kv.k = $cWxOP(algo, kv.k).update(kv.v).update($fb44e9de384e6712$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cWxOP(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $fb44e9de384e6712$var$makeR(g, k, p, q) {
    return g.toRed($lONYJ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $fb44e9de384e6712$var$sign;
module.exports.getKey = $fb44e9de384e6712$var$getKey;
module.exports.makeKey = $fb44e9de384e6712$var$makeKey;

});
parcelRegister("aMu6D", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $7d95bd81e58b40f2$require$Buffer = $N0o3H.Buffer;

var $lONYJ = parcelRequire("lONYJ");

var $e3qkY = parcelRequire("e3qkY");
function $7d95bd81e58b40f2$var$blind(priv) {
    var r = $7d95bd81e58b40f2$var$getr(priv);
    var blinder = r.toRed($lONYJ.mont(priv.modulus)).redPow(new $lONYJ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $7d95bd81e58b40f2$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $lONYJ($e3qkY(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $7d95bd81e58b40f2$var$crt(msg, priv) {
    var blinds = $7d95bd81e58b40f2$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $lONYJ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($lONYJ.mont(priv.prime1));
    var c2 = blinded.toRed($lONYJ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($7d95bd81e58b40f2$require$Buffer, "be", len);
}
$7d95bd81e58b40f2$var$crt.getr = $7d95bd81e58b40f2$var$getr;
module.exports = $7d95bd81e58b40f2$var$crt;

});

parcelRegister("igmhr", function(module, exports) {

var $eKCUH = parcelRequire("eKCUH");

var $dvIC4 = parcelRequire("dvIC4");

var $dEnC5 = parcelRequire("dEnC5");

var $dSiaU = parcelRequire("dSiaU");

var $aKSjA = parcelRequire("aKSjA");

var $fx8YU = parcelRequire("fx8YU");
var $d4bb0101d2a4933c$require$Buffer = $fx8YU.Buffer;
module.exports = $d4bb0101d2a4933c$var$parseKeys;
function $d4bb0101d2a4933c$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$d4bb0101d2a4933c$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $d4bb0101d2a4933c$require$Buffer.from(buffer);
    var stripped = $dEnC5(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $eKCUH.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $eKCUH.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $eKCUH.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $eKCUH.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $eKCUH.EncryptedPrivateKey.decode(data, "der");
            data = $d4bb0101d2a4933c$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $eKCUH.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $eKCUH.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $eKCUH.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $eKCUH.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $eKCUH.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $eKCUH.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $eKCUH.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $eKCUH.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$d4bb0101d2a4933c$var$parseKeys.signature = $eKCUH.signature;
function $d4bb0101d2a4933c$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $dvIC4[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $aKSjA.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $dSiaU.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $d4bb0101d2a4933c$require$Buffer.concat(out);
}

});
parcelRegister("eKCUH", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $abd38bf9328631e4$export$c98397a6eb8d0678, (v) => $abd38bf9328631e4$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $abd38bf9328631e4$export$f4aab6816f64fa6b, (v) => $abd38bf9328631e4$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $abd38bf9328631e4$export$4471f5c65d097c11, (v) => $abd38bf9328631e4$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $abd38bf9328631e4$export$ca8b6604d6ce14de, (v) => $abd38bf9328631e4$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $abd38bf9328631e4$export$8f54525b330fd87b, (v) => $abd38bf9328631e4$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $abd38bf9328631e4$export$23cd2842b44ca3e7, (v) => $abd38bf9328631e4$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $abd38bf9328631e4$export$245c9aaa9f5ce4ce, (v) => $abd38bf9328631e4$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $abd38bf9328631e4$export$8ad762e3e6399afe, (v) => $abd38bf9328631e4$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $abd38bf9328631e4$export$32ef6f92e22c6ab0, (v) => $abd38bf9328631e4$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $abd38bf9328631e4$export$c9cd164b539ebb63, (v) => $abd38bf9328631e4$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $abd38bf9328631e4$export$c98397a6eb8d0678;
var $abd38bf9328631e4$export$f4aab6816f64fa6b;
var $abd38bf9328631e4$export$4471f5c65d097c11;
var $abd38bf9328631e4$export$ca8b6604d6ce14de;
var $abd38bf9328631e4$export$8f54525b330fd87b;
var $abd38bf9328631e4$export$23cd2842b44ca3e7;
var $abd38bf9328631e4$export$245c9aaa9f5ce4ce;
var $abd38bf9328631e4$export$8ad762e3e6399afe;
var $abd38bf9328631e4$export$32ef6f92e22c6ab0;
var $abd38bf9328631e4$export$c9cd164b539ebb63;
"use strict";

var $dQaGD = parcelRequire("dQaGD");

$abd38bf9328631e4$export$c98397a6eb8d0678 = (parcelRequire("3HZgi"));
var $abd38bf9328631e4$var$RSAPrivateKey = $dQaGD.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$abd38bf9328631e4$export$f4aab6816f64fa6b = $abd38bf9328631e4$var$RSAPrivateKey;
var $abd38bf9328631e4$var$RSAPublicKey = $dQaGD.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$abd38bf9328631e4$export$4471f5c65d097c11 = $abd38bf9328631e4$var$RSAPublicKey;
var $abd38bf9328631e4$var$PublicKey = $dQaGD.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($abd38bf9328631e4$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$abd38bf9328631e4$export$ca8b6604d6ce14de = $abd38bf9328631e4$var$PublicKey;
var $abd38bf9328631e4$var$AlgorithmIdentifier = $dQaGD.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $abd38bf9328631e4$var$PrivateKeyInfo = $dQaGD.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($abd38bf9328631e4$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$abd38bf9328631e4$export$8f54525b330fd87b = $abd38bf9328631e4$var$PrivateKeyInfo;
var $abd38bf9328631e4$var$EncryptedPrivateKeyInfo = $dQaGD.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$abd38bf9328631e4$export$23cd2842b44ca3e7 = $abd38bf9328631e4$var$EncryptedPrivateKeyInfo;
var $abd38bf9328631e4$var$DSAPrivateKey = $dQaGD.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$abd38bf9328631e4$export$245c9aaa9f5ce4ce = $abd38bf9328631e4$var$DSAPrivateKey;
$abd38bf9328631e4$export$8ad762e3e6399afe = $dQaGD.define("DSAparam", function() {
    this.int();
});
var $abd38bf9328631e4$var$ECPrivateKey = $dQaGD.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($abd38bf9328631e4$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$abd38bf9328631e4$export$32ef6f92e22c6ab0 = $abd38bf9328631e4$var$ECPrivateKey;
var $abd38bf9328631e4$var$ECParameters = $dQaGD.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$abd38bf9328631e4$export$c9cd164b539ebb63 = $dQaGD.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("dQaGD", function(module, exports) {
"use strict";
const $a1386bd04611b668$var$asn1 = module.exports;

$a1386bd04611b668$var$asn1.bignum = (parcelRequire("6BMQw"));

$a1386bd04611b668$var$asn1.define = (parcelRequire("E7OzO")).define;

$a1386bd04611b668$var$asn1.base = (parcelRequire("6eCQU"));

$a1386bd04611b668$var$asn1.constants = (parcelRequire("f3dyg"));

$a1386bd04611b668$var$asn1.decoders = (parcelRequire("046bN"));

$a1386bd04611b668$var$asn1.encoders = (parcelRequire("1MN0x"));

});
parcelRegister("6BMQw", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("E7OzO", function(module, exports) {
"use strict";

var $1MN0x = parcelRequire("1MN0x");

var $046bN = parcelRequire("046bN");

var $ajIeE = parcelRequire("ajIeE");
const $0789cc63747882f4$var$api = module.exports;
$0789cc63747882f4$var$api.define = function define(name, body) {
    return new $0789cc63747882f4$var$Entity(name, body);
};
function $0789cc63747882f4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$0789cc63747882f4$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $ajIeE(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$0789cc63747882f4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($046bN[enc]);
    return this.decoders[enc];
};
$0789cc63747882f4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$0789cc63747882f4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($1MN0x[enc]);
    return this.encoders[enc];
};
$0789cc63747882f4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("1MN0x", function(module, exports) {
"use strict";
const $14d04a107d355f08$var$encoders = module.exports;

$14d04a107d355f08$var$encoders.der = (parcelRequire("gJtGu"));

$14d04a107d355f08$var$encoders.pem = (parcelRequire("dBBIV"));

});
parcelRegister("gJtGu", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $aavGG = parcelRequire("aavGG");
var $c2e7e0003fff6aff$require$Buffer = $aavGG.Buffer;

var $iHFN6 = parcelRequire("iHFN6");

var $bV1gt = parcelRequire("bV1gt");
function $c2e7e0003fff6aff$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $c2e7e0003fff6aff$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $c2e7e0003fff6aff$var$DEREncoder;
$c2e7e0003fff6aff$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $c2e7e0003fff6aff$var$DERNode(parent) {
    $iHFN6.call(this, "der", parent);
}
$ajIeE($c2e7e0003fff6aff$var$DERNode, $iHFN6);
$c2e7e0003fff6aff$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $c2e7e0003fff6aff$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $c2e7e0003fff6aff$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $c2e7e0003fff6aff$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$c2e7e0003fff6aff$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $c2e7e0003fff6aff$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$c2e7e0003fff6aff$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $c2e7e0003fff6aff$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $c2e7e0003fff6aff$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$c2e7e0003fff6aff$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $c2e7e0003fff6aff$var$two(date.getUTCFullYear()),
        $c2e7e0003fff6aff$var$two(date.getUTCMonth() + 1),
        $c2e7e0003fff6aff$var$two(date.getUTCDate()),
        $c2e7e0003fff6aff$var$two(date.getUTCHours()),
        $c2e7e0003fff6aff$var$two(date.getUTCMinutes()),
        $c2e7e0003fff6aff$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $c2e7e0003fff6aff$var$two(date.getUTCFullYear() % 100),
        $c2e7e0003fff6aff$var$two(date.getUTCMonth() + 1),
        $c2e7e0003fff6aff$var$two(date.getUTCDate()),
        $c2e7e0003fff6aff$var$two(date.getUTCHours()),
        $c2e7e0003fff6aff$var$two(date.getUTCMinutes()),
        $c2e7e0003fff6aff$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$c2e7e0003fff6aff$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$c2e7e0003fff6aff$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$c2e7e0003fff6aff$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $c2e7e0003fff6aff$require$Buffer.from(numArray);
    }
    if ($c2e7e0003fff6aff$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $c2e7e0003fff6aff$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($c2e7e0003fff6aff$require$Buffer.from(out));
};
$c2e7e0003fff6aff$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$c2e7e0003fff6aff$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$c2e7e0003fff6aff$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $c2e7e0003fff6aff$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($bV1gt.tagByName.hasOwnProperty(tag)) res = $bV1gt.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $bV1gt.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("aavGG", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ibaza = parcelRequire("ibaza");
"use strict";

var $N0o3H = parcelRequire("N0o3H");
var $76736b097c9b8317$var$Buffer = $N0o3H.Buffer;
var $76736b097c9b8317$var$safer = {};
var $76736b097c9b8317$var$key;
for($76736b097c9b8317$var$key in $N0o3H){
    if (!$N0o3H.hasOwnProperty($76736b097c9b8317$var$key)) continue;
    if ($76736b097c9b8317$var$key === "SlowBuffer" || $76736b097c9b8317$var$key === "Buffer") continue;
    $76736b097c9b8317$var$safer[$76736b097c9b8317$var$key] = $N0o3H[$76736b097c9b8317$var$key];
}
var $76736b097c9b8317$var$Safer = $76736b097c9b8317$var$safer.Buffer = {};
for($76736b097c9b8317$var$key in $76736b097c9b8317$var$Buffer){
    if (!$76736b097c9b8317$var$Buffer.hasOwnProperty($76736b097c9b8317$var$key)) continue;
    if ($76736b097c9b8317$var$key === "allocUnsafe" || $76736b097c9b8317$var$key === "allocUnsafeSlow") continue;
    $76736b097c9b8317$var$Safer[$76736b097c9b8317$var$key] = $76736b097c9b8317$var$Buffer[$76736b097c9b8317$var$key];
}
$76736b097c9b8317$var$safer.Buffer.prototype = $76736b097c9b8317$var$Buffer.prototype;
if (!$76736b097c9b8317$var$Safer.from || $76736b097c9b8317$var$Safer.from === Uint8Array.from) $76736b097c9b8317$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $76736b097c9b8317$var$Buffer(value, encodingOrOffset, length);
};
if (!$76736b097c9b8317$var$Safer.alloc) $76736b097c9b8317$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $76736b097c9b8317$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$76736b097c9b8317$var$safer.kStringMaxLength) try {
    $76736b097c9b8317$var$safer.kStringMaxLength = $ibaza.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$76736b097c9b8317$var$safer.constants) {
    $76736b097c9b8317$var$safer.constants = {
        MAX_LENGTH: $76736b097c9b8317$var$safer.kMaxLength
    };
    if ($76736b097c9b8317$var$safer.kStringMaxLength) $76736b097c9b8317$var$safer.constants.MAX_STRING_LENGTH = $76736b097c9b8317$var$safer.kStringMaxLength;
}
module.exports = $76736b097c9b8317$var$safer;

});

parcelRegister("iHFN6", function(module, exports) {
"use strict";

var $fUEpq = parcelRequire("fUEpq");
var $d9dca8f382cd435b$require$Reporter = $fUEpq.Reporter;

var $89alT = parcelRequire("89alT");
var $d9dca8f382cd435b$require$EncoderBuffer = $89alT.EncoderBuffer;

var $89alT = parcelRequire("89alT");
var $d9dca8f382cd435b$require$DecoderBuffer = $89alT.DecoderBuffer;

var $i1Wrq = parcelRequire("i1Wrq");
// Supported tags
const $d9dca8f382cd435b$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $d9dca8f382cd435b$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($d9dca8f382cd435b$var$tags);
// Overrided methods list
const $d9dca8f382cd435b$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $d9dca8f382cd435b$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $d9dca8f382cd435b$var$Node;
const $d9dca8f382cd435b$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$d9dca8f382cd435b$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $d9dca8f382cd435b$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$d9dca8f382cd435b$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $d9dca8f382cd435b$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$d9dca8f382cd435b$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $i1Wrq(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $i1Wrq.equal(state.children.length, 1, "Root node can have only one child");
};
$d9dca8f382cd435b$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $i1Wrq(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $i1Wrq(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$d9dca8f382cd435b$var$overrided.forEach(function(method) {
    $d9dca8f382cd435b$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$d9dca8f382cd435b$var$tags.forEach(function(tag) {
    $d9dca8f382cd435b$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $i1Wrq(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$d9dca8f382cd435b$var$Node.prototype.use = function use(item) {
    $i1Wrq(item);
    const state = this._baseState;
    $i1Wrq(state.use === null);
    state.use = item;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $i1Wrq(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $i1Wrq(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $i1Wrq(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $i1Wrq(state.key === null);
    state.key = newKey;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $i1Wrq(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$d9dca8f382cd435b$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $i1Wrq(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$d9dca8f382cd435b$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $d9dca8f382cd435b$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$d9dca8f382cd435b$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$d9dca8f382cd435b$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $i1Wrq(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$d9dca8f382cd435b$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$d9dca8f382cd435b$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $d9dca8f382cd435b$require$EncoderBuffer(data, this.reporter);
};
$d9dca8f382cd435b$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$d9dca8f382cd435b$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $d9dca8f382cd435b$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$d9dca8f382cd435b$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $i1Wrq(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$d9dca8f382cd435b$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$d9dca8f382cd435b$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$d9dca8f382cd435b$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("fUEpq", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $b95b6e5fd66e04e1$export$957313a2f485e5ed, (v) => $b95b6e5fd66e04e1$export$957313a2f485e5ed = v);
var $b95b6e5fd66e04e1$export$957313a2f485e5ed;
"use strict";

var $ajIeE = parcelRequire("ajIeE");
function $b95b6e5fd66e04e1$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$b95b6e5fd66e04e1$export$957313a2f485e5ed = $b95b6e5fd66e04e1$var$Reporter;
$b95b6e5fd66e04e1$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $b95b6e5fd66e04e1$var$ReporterError;
};
$b95b6e5fd66e04e1$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$b95b6e5fd66e04e1$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$b95b6e5fd66e04e1$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$b95b6e5fd66e04e1$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$b95b6e5fd66e04e1$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$b95b6e5fd66e04e1$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$b95b6e5fd66e04e1$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$b95b6e5fd66e04e1$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$b95b6e5fd66e04e1$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $b95b6e5fd66e04e1$var$ReporterError;
    if (inherited) err = msg;
    else err = new $b95b6e5fd66e04e1$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$b95b6e5fd66e04e1$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $b95b6e5fd66e04e1$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$ajIeE($b95b6e5fd66e04e1$var$ReporterError, Error);
$b95b6e5fd66e04e1$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $b95b6e5fd66e04e1$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("89alT", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $5ee731b522044f02$export$bf9f79cdc4a49163, (v) => $5ee731b522044f02$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $5ee731b522044f02$export$8ff24f7760c7a78e, (v) => $5ee731b522044f02$export$8ff24f7760c7a78e = v);
var $5ee731b522044f02$export$bf9f79cdc4a49163;
var $5ee731b522044f02$export$8ff24f7760c7a78e;
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $fUEpq = parcelRequire("fUEpq");
var $5ee731b522044f02$require$Reporter = $fUEpq.Reporter;

var $aavGG = parcelRequire("aavGG");
var $5ee731b522044f02$require$Buffer = $aavGG.Buffer;
function $5ee731b522044f02$var$DecoderBuffer(base, options) {
    $5ee731b522044f02$require$Reporter.call(this, options);
    if (!$5ee731b522044f02$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$ajIeE($5ee731b522044f02$var$DecoderBuffer, $5ee731b522044f02$require$Reporter);
$5ee731b522044f02$export$bf9f79cdc4a49163 = $5ee731b522044f02$var$DecoderBuffer;
$5ee731b522044f02$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $5ee731b522044f02$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $5ee731b522044f02$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$5ee731b522044f02$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $5ee731b522044f02$require$Reporter.prototype.save.call(this)
    };
};
$5ee731b522044f02$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $5ee731b522044f02$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $5ee731b522044f02$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$5ee731b522044f02$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$5ee731b522044f02$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$5ee731b522044f02$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $5ee731b522044f02$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$5ee731b522044f02$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $5ee731b522044f02$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$5ee731b522044f02$var$EncoderBuffer.isEncoderBuffer(item)) item = new $5ee731b522044f02$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $5ee731b522044f02$require$Buffer.byteLength(value);
    } else if ($5ee731b522044f02$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$5ee731b522044f02$export$8ff24f7760c7a78e = $5ee731b522044f02$var$EncoderBuffer;
$5ee731b522044f02$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $5ee731b522044f02$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$5ee731b522044f02$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $5ee731b522044f02$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($5ee731b522044f02$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("bV1gt", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $8ad5ffb6711bf37e$export$3584c46ed60baee8, (v) => $8ad5ffb6711bf37e$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $8ad5ffb6711bf37e$export$f18596ef8d632e49, (v) => $8ad5ffb6711bf37e$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $8ad5ffb6711bf37e$export$2b067c6666111485, (v) => $8ad5ffb6711bf37e$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $8ad5ffb6711bf37e$export$f17df38a421ab9e3, (v) => $8ad5ffb6711bf37e$export$f17df38a421ab9e3 = v);
var $8ad5ffb6711bf37e$export$3584c46ed60baee8;
var $8ad5ffb6711bf37e$export$f18596ef8d632e49;
var $8ad5ffb6711bf37e$export$2b067c6666111485;
var $8ad5ffb6711bf37e$export$f17df38a421ab9e3;
"use strict";
// Helper
function $8ad5ffb6711bf37e$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$8ad5ffb6711bf37e$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$8ad5ffb6711bf37e$export$f18596ef8d632e49 = $8ad5ffb6711bf37e$var$reverse($8ad5ffb6711bf37e$export$3584c46ed60baee8);
$8ad5ffb6711bf37e$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$8ad5ffb6711bf37e$export$f17df38a421ab9e3 = $8ad5ffb6711bf37e$var$reverse($8ad5ffb6711bf37e$export$2b067c6666111485);

});


parcelRegister("dBBIV", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $gJtGu = parcelRequire("gJtGu");
function $9e7bfe293ba058de$var$PEMEncoder(entity) {
    $gJtGu.call(this, entity);
    this.enc = "pem";
}
$ajIeE($9e7bfe293ba058de$var$PEMEncoder, $gJtGu);
module.exports = $9e7bfe293ba058de$var$PEMEncoder;
$9e7bfe293ba058de$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $gJtGu.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("046bN", function(module, exports) {
"use strict";
const $00c52ce84d020b09$var$decoders = module.exports;

$00c52ce84d020b09$var$decoders.der = (parcelRequire("88kut"));

$00c52ce84d020b09$var$decoders.pem = (parcelRequire("2LBrY"));

});
parcelRegister("88kut", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $6BMQw = parcelRequire("6BMQw");

var $89alT = parcelRequire("89alT");
var $5ebef71475e2a5b8$require$DecoderBuffer = $89alT.DecoderBuffer;

var $iHFN6 = parcelRequire("iHFN6");

var $bV1gt = parcelRequire("bV1gt");
function $5ebef71475e2a5b8$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $5ebef71475e2a5b8$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $5ebef71475e2a5b8$var$DERDecoder;
$5ebef71475e2a5b8$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$5ebef71475e2a5b8$require$DecoderBuffer.isDecoderBuffer(data)) data = new $5ebef71475e2a5b8$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $5ebef71475e2a5b8$var$DERNode(parent) {
    $iHFN6.call(this, "der", parent);
}
$ajIeE($5ebef71475e2a5b8$var$DERNode, $iHFN6);
$5ebef71475e2a5b8$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $5ebef71475e2a5b8$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $5ebef71475e2a5b8$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $5ebef71475e2a5b8$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$5ebef71475e2a5b8$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $5ebef71475e2a5b8$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $5ebef71475e2a5b8$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$5ebef71475e2a5b8$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $6BMQw(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$5ebef71475e2a5b8$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $5ebef71475e2a5b8$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $bV1gt.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $bV1gt.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $5ebef71475e2a5b8$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("2LBrY", function(module, exports) {
"use strict";

var $ajIeE = parcelRequire("ajIeE");

var $aavGG = parcelRequire("aavGG");
var $203d0562f9ac5803$require$Buffer = $aavGG.Buffer;

var $88kut = parcelRequire("88kut");
function $203d0562f9ac5803$var$PEMDecoder(entity) {
    $88kut.call(this, entity);
    this.enc = "pem";
}
$ajIeE($203d0562f9ac5803$var$PEMDecoder, $88kut);
module.exports = $203d0562f9ac5803$var$PEMDecoder;
$203d0562f9ac5803$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $203d0562f9ac5803$require$Buffer.from(base64, "base64");
    return $88kut.prototype.decode.call(this, input, options);
};

});



parcelRegister("6eCQU", function(module, exports) {
"use strict";
const $48a230243ea94473$var$base = module.exports;

$48a230243ea94473$var$base.Reporter = (parcelRequire("fUEpq")).Reporter;

$48a230243ea94473$var$base.DecoderBuffer = (parcelRequire("89alT")).DecoderBuffer;

$48a230243ea94473$var$base.EncoderBuffer = (parcelRequire("89alT")).EncoderBuffer;

$48a230243ea94473$var$base.Node = (parcelRequire("iHFN6"));

});

parcelRegister("f3dyg", function(module, exports) {
"use strict";
const $af51a5e444ca4196$var$constants = module.exports;
// Helper
$af51a5e444ca4196$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$af51a5e444ca4196$var$constants.der = (parcelRequire("bV1gt"));

});


parcelRegister("3HZgi", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $dQaGD = parcelRequire("dQaGD");
var $2b34e896e31be158$var$Time = $dQaGD.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $2b34e896e31be158$var$AttributeTypeValue = $dQaGD.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $2b34e896e31be158$var$AlgorithmIdentifier = $dQaGD.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $2b34e896e31be158$var$SubjectPublicKeyInfo = $dQaGD.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($2b34e896e31be158$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $2b34e896e31be158$var$RelativeDistinguishedName = $dQaGD.define("RelativeDistinguishedName", function() {
    this.setof($2b34e896e31be158$var$AttributeTypeValue);
});
var $2b34e896e31be158$var$RDNSequence = $dQaGD.define("RDNSequence", function() {
    this.seqof($2b34e896e31be158$var$RelativeDistinguishedName);
});
var $2b34e896e31be158$var$Name = $dQaGD.define("Name", function() {
    this.choice({
        rdnSequence: this.use($2b34e896e31be158$var$RDNSequence)
    });
});
var $2b34e896e31be158$var$Validity = $dQaGD.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($2b34e896e31be158$var$Time), this.key("notAfter").use($2b34e896e31be158$var$Time));
});
var $2b34e896e31be158$var$Extension = $dQaGD.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $2b34e896e31be158$var$TBSCertificate = $dQaGD.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($2b34e896e31be158$var$AlgorithmIdentifier), this.key("issuer").use($2b34e896e31be158$var$Name), this.key("validity").use($2b34e896e31be158$var$Validity), this.key("subject").use($2b34e896e31be158$var$Name), this.key("subjectPublicKeyInfo").use($2b34e896e31be158$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($2b34e896e31be158$var$Extension).optional());
});
var $2b34e896e31be158$var$X509Certificate = $dQaGD.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($2b34e896e31be158$var$TBSCertificate), this.key("signatureAlgorithm").use($2b34e896e31be158$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $2b34e896e31be158$var$X509Certificate;

});


parcelRegister("dvIC4", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("dEnC5", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $9f0153e22dee2de3$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $9f0153e22dee2de3$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $9f0153e22dee2de3$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $42eaE = parcelRequire("42eaE");

var $dSiaU = parcelRequire("dSiaU");

var $fx8YU = parcelRequire("fx8YU");
var $9f0153e22dee2de3$require$Buffer = $fx8YU.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($9f0153e22dee2de3$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($9f0153e22dee2de3$var$fullRegex);
        decrypted = $9f0153e22dee2de3$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $9f0153e22dee2de3$require$Buffer.from(match[2], "hex");
        var cipherText = $9f0153e22dee2de3$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $42eaE(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $dSiaU.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $9f0153e22dee2de3$require$Buffer.concat(out);
    }
    var tag = key.match($9f0153e22dee2de3$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("5GWRF", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("72STX", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $52134e9afe4a615b$require$Buffer = $fx8YU.Buffer;

var $lONYJ = parcelRequire("lONYJ");

var $7kgn0 = parcelRequire("7kgn0");
var $52134e9afe4a615b$require$EC = $7kgn0.ec;

var $igmhr = parcelRequire("igmhr");

var $5GWRF = parcelRequire("5GWRF");
function $52134e9afe4a615b$var$verify(sig, hash, key, signType, tag) {
    var pub = $igmhr(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $52134e9afe4a615b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $52134e9afe4a615b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $52134e9afe4a615b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $52134e9afe4a615b$require$Buffer.from(pad);
    var red = $lONYJ.mont(pub.modulus);
    sig = new $lONYJ(sig).toRed(red);
    sig = sig.redPow(new $lONYJ(pub.publicExponent));
    sig = $52134e9afe4a615b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $52134e9afe4a615b$var$ecVerify(sig, hash, pub) {
    var curveId = $5GWRF[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $52134e9afe4a615b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $52134e9afe4a615b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $igmhr.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $52134e9afe4a615b$var$checkValue(s, q);
    $52134e9afe4a615b$var$checkValue(r, q);
    var montp = $lONYJ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $lONYJ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $52134e9afe4a615b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = $52134e9afe4a615b$var$verify;

});


parcelRegister("ewTwP", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $a93f20aaa5da200f$require$Buffer = $N0o3H.Buffer;

var $7kgn0 = parcelRequire("7kgn0");

var $e78FA = parcelRequire("e78FA");
module.exports = function createECDH(curve) {
    return new $a93f20aaa5da200f$var$ECDH(curve);
};
var $a93f20aaa5da200f$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$a93f20aaa5da200f$var$aliases.p224 = $a93f20aaa5da200f$var$aliases.secp224r1;
$a93f20aaa5da200f$var$aliases.p256 = $a93f20aaa5da200f$var$aliases.secp256r1 = $a93f20aaa5da200f$var$aliases.prime256v1;
$a93f20aaa5da200f$var$aliases.p192 = $a93f20aaa5da200f$var$aliases.secp192r1 = $a93f20aaa5da200f$var$aliases.prime192v1;
$a93f20aaa5da200f$var$aliases.p384 = $a93f20aaa5da200f$var$aliases.secp384r1;
$a93f20aaa5da200f$var$aliases.p521 = $a93f20aaa5da200f$var$aliases.secp521r1;
function $a93f20aaa5da200f$var$ECDH(curve) {
    this.curveType = $a93f20aaa5da200f$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $7kgn0.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$a93f20aaa5da200f$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$a93f20aaa5da200f$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$a93f20aaa5da200f$require$Buffer.isBuffer(other)) other = new $a93f20aaa5da200f$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $a93f20aaa5da200f$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$a93f20aaa5da200f$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $a93f20aaa5da200f$var$formatReturnValue(key, enc);
};
$a93f20aaa5da200f$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $a93f20aaa5da200f$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$a93f20aaa5da200f$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$a93f20aaa5da200f$require$Buffer.isBuffer(pub)) pub = new $a93f20aaa5da200f$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$a93f20aaa5da200f$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$a93f20aaa5da200f$require$Buffer.isBuffer(priv)) priv = new $a93f20aaa5da200f$require$Buffer(priv, enc);
    var _priv = new $e78FA(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $a93f20aaa5da200f$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $a93f20aaa5da200f$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $a93f20aaa5da200f$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $a93f20aaa5da200f$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("e78FA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8nyac", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $619af8dbea7c66e1$export$512823e338ddb1b7, (v) => $619af8dbea7c66e1$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $619af8dbea7c66e1$export$7efb24e2fddf99b9, (v) => $619af8dbea7c66e1$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $619af8dbea7c66e1$export$9d0e0c0c4a8d30f3, (v) => $619af8dbea7c66e1$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $619af8dbea7c66e1$export$b9d55ff329113abd, (v) => $619af8dbea7c66e1$export$b9d55ff329113abd = v);
var $619af8dbea7c66e1$export$512823e338ddb1b7;
var $619af8dbea7c66e1$export$7efb24e2fddf99b9;
var $619af8dbea7c66e1$export$9d0e0c0c4a8d30f3;
var $619af8dbea7c66e1$export$b9d55ff329113abd;

$619af8dbea7c66e1$export$512823e338ddb1b7 = (parcelRequire("jCPFh"));

$619af8dbea7c66e1$export$7efb24e2fddf99b9 = (parcelRequire("4HAoO"));
$619af8dbea7c66e1$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $619af8dbea7c66e1$export$512823e338ddb1b7(key, buf, true);
};
$619af8dbea7c66e1$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $619af8dbea7c66e1$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("jCPFh", function(module, exports) {

var $igmhr = parcelRequire("igmhr");

var $e3qkY = parcelRequire("e3qkY");

var $5dKmo = parcelRequire("5dKmo");

var $3uICI = parcelRequire("3uICI");

var $1Zh1C = parcelRequire("1Zh1C");

var $6LLhs = parcelRequire("6LLhs");

var $hoGP5 = parcelRequire("hoGP5");

var $aMu6D = parcelRequire("aMu6D");

var $fx8YU = parcelRequire("fx8YU");
var $e499a47c183af6c7$require$Buffer = $fx8YU.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $igmhr(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $e499a47c183af6c7$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $e499a47c183af6c7$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6LLhs(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $aMu6D(paddedMsg, key);
    else return $hoGP5(paddedMsg, key);
};
function $e499a47c183af6c7$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $5dKmo("sha1").update($e499a47c183af6c7$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $e499a47c183af6c7$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $e3qkY(hLen);
    var maskedDb = $1Zh1C($e499a47c183af6c7$require$Buffer.concat([
        iHash,
        ps,
        $e499a47c183af6c7$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $3uICI(seed, dblen));
    var maskedSeed = $1Zh1C(seed, $3uICI(maskedDb, hLen));
    return new $6LLhs($e499a47c183af6c7$require$Buffer.concat([
        $e499a47c183af6c7$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $e499a47c183af6c7$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $e499a47c183af6c7$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $e499a47c183af6c7$var$nonZero(k - mLen - 3);
    return new $6LLhs($e499a47c183af6c7$require$Buffer.concat([
        $e499a47c183af6c7$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $e499a47c183af6c7$require$Buffer.alloc(1),
        msg
    ], k));
}
function $e499a47c183af6c7$var$nonZero(len) {
    var out = $e499a47c183af6c7$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $e3qkY(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $e3qkY(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("3uICI", function(module, exports) {

var $5dKmo = parcelRequire("5dKmo");

var $fx8YU = parcelRequire("fx8YU");
var $28b6c9ba149e0df9$require$Buffer = $fx8YU.Buffer;
module.exports = function(seed, len) {
    var t = $28b6c9ba149e0df9$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $28b6c9ba149e0df9$var$i2ops(i++);
        t = $28b6c9ba149e0df9$require$Buffer.concat([
            t,
            $5dKmo("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $28b6c9ba149e0df9$var$i2ops(c) {
    var out = $28b6c9ba149e0df9$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("1Zh1C", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6LLhs", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("hoGP5", function(module, exports) {

var $6LLhs = parcelRequire("6LLhs");

var $fx8YU = parcelRequire("fx8YU");
var $caa5e5549c591fce$require$Buffer = $fx8YU.Buffer;
function $caa5e5549c591fce$var$withPublic(paddedMsg, key) {
    return $caa5e5549c591fce$require$Buffer.from(paddedMsg.toRed($6LLhs.mont(key.modulus)).redPow(new $6LLhs(key.publicExponent)).fromRed().toArray());
}
module.exports = $caa5e5549c591fce$var$withPublic;

});


parcelRegister("4HAoO", function(module, exports) {

var $igmhr = parcelRequire("igmhr");

var $3uICI = parcelRequire("3uICI");

var $1Zh1C = parcelRequire("1Zh1C");

var $6LLhs = parcelRequire("6LLhs");

var $aMu6D = parcelRequire("aMu6D");

var $5dKmo = parcelRequire("5dKmo");

var $hoGP5 = parcelRequire("hoGP5");

var $fx8YU = parcelRequire("fx8YU");
var $36c769ae85d89b19$require$Buffer = $fx8YU.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $igmhr(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6LLhs(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $hoGP5(new $6LLhs(enc), key);
    else msg = $aMu6D(enc, key);
    var zBuffer = $36c769ae85d89b19$require$Buffer.alloc(k - msg.length);
    msg = $36c769ae85d89b19$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $36c769ae85d89b19$var$oaep(key, msg);
    else if (padding === 1) return $36c769ae85d89b19$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $36c769ae85d89b19$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $5dKmo("sha1").update($36c769ae85d89b19$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $1Zh1C(maskedSeed, $3uICI(maskedDb, hLen));
    var db = $1Zh1C(maskedDb, $3uICI(seed, k - hLen - 1));
    if ($36c769ae85d89b19$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $36c769ae85d89b19$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $36c769ae85d89b19$var$compare(a, b) {
    a = $36c769ae85d89b19$require$Buffer.from(a);
    b = $36c769ae85d89b19$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("41YOR", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $2ef66ee1e6a7b999$export$bb1abf2ce84fc7e8, (v) => $2ef66ee1e6a7b999$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $2ef66ee1e6a7b999$export$2f7171e78e524d5e, (v) => $2ef66ee1e6a7b999$export$2f7171e78e524d5e = v);
var $2ef66ee1e6a7b999$export$bb1abf2ce84fc7e8;
var $2ef66ee1e6a7b999$export$2f7171e78e524d5e;

var $ibaza = parcelRequire("ibaza");
"use strict";
function $2ef66ee1e6a7b999$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $fx8YU = parcelRequire("fx8YU");

var $e3qkY = parcelRequire("e3qkY");
var $2ef66ee1e6a7b999$var$Buffer = $fx8YU.Buffer;
var $2ef66ee1e6a7b999$var$kBufferMaxLength = $fx8YU.kMaxLength;
var $2ef66ee1e6a7b999$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $2ef66ee1e6a7b999$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $2ef66ee1e6a7b999$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $2ef66ee1e6a7b999$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $2ef66ee1e6a7b999$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $2ef66ee1e6a7b999$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $2ef66ee1e6a7b999$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $2ef66ee1e6a7b999$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($2ef66ee1e6a7b999$var$crypto && $2ef66ee1e6a7b999$var$crypto.getRandomValues || false) {
    $2ef66ee1e6a7b999$export$bb1abf2ce84fc7e8 = $2ef66ee1e6a7b999$var$randomFill;
    $2ef66ee1e6a7b999$export$2f7171e78e524d5e = $2ef66ee1e6a7b999$var$randomFillSync;
} else {
    $2ef66ee1e6a7b999$export$bb1abf2ce84fc7e8 = $2ef66ee1e6a7b999$var$oldBrowser;
    $2ef66ee1e6a7b999$export$2f7171e78e524d5e = $2ef66ee1e6a7b999$var$oldBrowser;
}
function $2ef66ee1e6a7b999$var$randomFill(buf, offset, size, cb) {
    if (!$2ef66ee1e6a7b999$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $2ef66ee1e6a7b999$var$assertOffset(offset, buf.length);
    $2ef66ee1e6a7b999$var$assertSize(size, offset, buf.length);
    return $2ef66ee1e6a7b999$var$actualFill(buf, offset, size, cb);
}
function $2ef66ee1e6a7b999$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $2ef66ee1e6a7b999$var$crypto.getRandomValues(uint);
    if (cb) {
        $ibaza.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $e3qkY(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $e3qkY(size);
    bytes.copy(buf, offset);
    return buf;
}
function $2ef66ee1e6a7b999$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$2ef66ee1e6a7b999$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $2ef66ee1e6a7b999$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $2ef66ee1e6a7b999$var$assertSize(size, offset, buf.length);
    return $2ef66ee1e6a7b999$var$actualFill(buf, offset, size);
}

});



parcelRegister("gfTDf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = void 0;

var $9mxSb = parcelRequire("9mxSb");

var $hyAd0 = parcelRequire("hyAd0");

var $iuTQ4 = parcelRequire("iuTQ4");
class $bd59336b4c21759c$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $9mxSb.sha256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $iuTQ4.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha256 = $bd59336b4c21759c$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $bd59336b4c21759c$var$sha256(data) {
    return new $bd59336b4c21759c$var$Sha256(data).digest();
}
module.exports.sha256 = $bd59336b4c21759c$var$sha256;
class $bd59336b4c21759c$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $hyAd0.sha512.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $iuTQ4.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha512 = $bd59336b4c21759c$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $bd59336b4c21759c$var$sha512(data) {
    return new $bd59336b4c21759c$var$Sha512(data).digest();
}
module.exports.sha512 = $bd59336b4c21759c$var$sha512;

});
parcelRegister("iuTQ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function $d77657c30a21f15f$var$toRealUint8Array(data) {
    if (data instanceof Uint8Array) return data;
    else return Uint8Array.from(data);
}
module.exports.toRealUint8Array = $d77657c30a21f15f$var$toRealUint8Array;

});



parcelRegister("7p4Gq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $563e8035100dc548$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $563e8035100dc548$var$Hmac;

});

parcelRegister("5TGBY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

var $iHHgP = parcelRequire("iHHgP");

var $iuTQ4 = parcelRequire("iuTQ4");
class $011ba9e158fcfd22$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $iHHgP.keccak_256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $iuTQ4.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Keccak256 = $011ba9e158fcfd22$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $011ba9e158fcfd22$var$keccak256(data) {
    return new $011ba9e158fcfd22$var$Keccak256(data).digest();
}
module.exports.keccak256 = $011ba9e158fcfd22$var$keccak256;

});
parcelRegister("iHHgP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $1fAJj = parcelRequire("1fAJj");

var $h21Cw = parcelRequire("h21Cw");

var $9lwKa = parcelRequire("9lwKa");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$d9ddcec2d36d6a94$var$SHA3_PI, $d9ddcec2d36d6a94$var$SHA3_ROTL, $d9ddcec2d36d6a94$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $d9ddcec2d36d6a94$var$_0n = /* @__PURE__ */ BigInt(0);
const $d9ddcec2d36d6a94$var$_1n = /* @__PURE__ */ BigInt(1);
const $d9ddcec2d36d6a94$var$_2n = /* @__PURE__ */ BigInt(2);
const $d9ddcec2d36d6a94$var$_7n = /* @__PURE__ */ BigInt(7);
const $d9ddcec2d36d6a94$var$_256n = /* @__PURE__ */ BigInt(256);
const $d9ddcec2d36d6a94$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $d9ddcec2d36d6a94$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $d9ddcec2d36d6a94$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $d9ddcec2d36d6a94$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $d9ddcec2d36d6a94$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $d9ddcec2d36d6a94$var$_1n ^ (R >> $d9ddcec2d36d6a94$var$_7n) * $d9ddcec2d36d6a94$var$_0x71n) % $d9ddcec2d36d6a94$var$_256n;
        if (R & $d9ddcec2d36d6a94$var$_2n) t ^= $d9ddcec2d36d6a94$var$_1n << ($d9ddcec2d36d6a94$var$_1n << /* @__PURE__ */ BigInt(j)) - $d9ddcec2d36d6a94$var$_1n;
    }
    $d9ddcec2d36d6a94$var$_SHA3_IOTA.push(t);
}
const [$d9ddcec2d36d6a94$var$SHA3_IOTA_H, $d9ddcec2d36d6a94$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $h21Cw.split)($d9ddcec2d36d6a94$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $d9ddcec2d36d6a94$var$rotlH = (h, l, s)=>s > 32 ? (0, $h21Cw.rotlBH)(h, l, s) : (0, $h21Cw.rotlSH)(h, l, s);
const $d9ddcec2d36d6a94$var$rotlL = (h, l, s)=>s > 32 ? (0, $h21Cw.rotlBL)(h, l, s) : (0, $h21Cw.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $d9ddcec2d36d6a94$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $d9ddcec2d36d6a94$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $d9ddcec2d36d6a94$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $d9ddcec2d36d6a94$var$SHA3_ROTL[t];
            const Th = $d9ddcec2d36d6a94$var$rotlH(curH, curL, shift);
            const Tl = $d9ddcec2d36d6a94$var$rotlL(curH, curL, shift);
            const PI = $d9ddcec2d36d6a94$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $d9ddcec2d36d6a94$var$SHA3_IOTA_H[round];
        s[1] ^= $d9ddcec2d36d6a94$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $d9ddcec2d36d6a94$var$keccakP;
class $d9ddcec2d36d6a94$var$Keccak extends $9lwKa.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $1fAJj.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $9lwKa.u32)(this.state);
    }
    keccak() {
        $d9ddcec2d36d6a94$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $1fAJj.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $9lwKa.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $1fAJj.exists)(this, false);
        (0, $1fAJj.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $1fAJj.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $1fAJj.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $d9ddcec2d36d6a94$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $d9ddcec2d36d6a94$var$Keccak;
const $d9ddcec2d36d6a94$var$gen = (suffix, blockLen, outputLen)=>(0, $9lwKa.wrapConstructor)(()=>new $d9ddcec2d36d6a94$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $d9ddcec2d36d6a94$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $d9ddcec2d36d6a94$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $d9ddcec2d36d6a94$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $d9ddcec2d36d6a94$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $d9ddcec2d36d6a94$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $d9ddcec2d36d6a94$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $d9ddcec2d36d6a94$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $d9ddcec2d36d6a94$var$gen(0x01, 72, 64);
const $d9ddcec2d36d6a94$var$genShake = (suffix, blockLen, outputLen)=>(0, $9lwKa.wrapXOFConstructorWithOpts)((opts = {})=>new $d9ddcec2d36d6a94$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $d9ddcec2d36d6a94$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $d9ddcec2d36d6a94$var$genShake(0x1f, 136, 32);

});


parcelRegister("buZqa", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $85f223fe6e3b6654$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $hm8y1 = parcelRequire("hm8y1");

// Using crypto_pwhash requires sumo. Once we migrate to a standalone
// Argon2 implementation, we can use the normal libsodium-wrappers
// again: https://github.com/cosmos/cosmjs/issues/1031
const $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1 = $85f223fe6e3b6654$var$__importDefault((parcelRequire("5i3O9")));
function $85f223fe6e3b6654$var$isArgon2idOptions(thing) {
    if (!(0, $hm8y1.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $85f223fe6e3b6654$var$isArgon2idOptions;
class $85f223fe6e3b6654$var$Argon2id {
    static async execute(password, salt, options) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        return $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $85f223fe6e3b6654$var$Argon2id;
class $85f223fe6e3b6654$var$Ed25519Keypair {
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $85f223fe6e3b6654$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $85f223fe6e3b6654$var$Ed25519Keypair;
class $85f223fe6e3b6654$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        const keypair = $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(seed);
        return $85f223fe6e3b6654$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        return $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        return $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $85f223fe6e3b6654$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $85f223fe6e3b6654$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $85f223fe6e3b6654$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $85f223fe6e3b6654$var$Xchacha20poly1305Ietf;

});
parcelRegister("5i3O9", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\x00"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\x00"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium-sumo"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("j74of"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRegister("j74of", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
var $dea2138707f9c17c$var$__dirname = "node_modules/libsodium-sumo/dist/modules-sumo";

var $N0o3H = parcelRequire("N0o3H");
var $dea2138707f9c17c$require$Buffer = $N0o3H.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $ibaza && "object" == typeof $ibaza.versions && "string" == typeof $ibaza.versions.node, _ = "";
                    if (a) {
                        var c = (parcelRequire("foUwZ")), t = (parcelRequire("foUwZ"));
                        _ = E ? t.dirname(_) + "/" : $dea2138707f9c17c$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $ibaza.argv.length > 1 && $ibaza.argv[1].replace(/\\/g, "/"), $ibaza.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, E && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, e = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var y, s = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, o = I, E = C.length, a = I + (3 * E >> 2) - ("=" == C[E - 2]) - ("=" == C[E - 1]); i < E; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[o++] = g[C.charCodeAt(i)] << 2 | B >> 4, o < a && (A[o++] = B << 4 | Q >> 2), o < a && (A[o++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | wB(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(o), o = new Int8Array(Q), new Int16Array(Q), E = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), _ = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var o = new Int8Array(i), E = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), _ = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), t = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), e = g.c, y = g.d, s = g.e, h = 103648, D = 0, p = 0, w = 0;
                                    function f(A, I) {
                                        var g, C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = E = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, sA = E = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, E = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, j = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = E, SA = E = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, S = E, EA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, wA = E = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = E = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, z = E, oA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, DA = E = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, X = E, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E = (_A = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + S | 0, P = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, E = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > P >>> 0 ? E + 1 | 0 : E) | 0, E = (QA = (_ = P) >>> 0 > (P = P + QA | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, iA = eA = P + rA | 0, eA = E = eA >>> 0 < P >>> 0 ? E + 1 | 0 : E, P = KI(P ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), kA = E = w, E = E + 1013904242 | 0, QA = P, Z = E = (P = P - 23791573 | 0) >>> 0 < 4271175723 ? E + 1 | 0 : E, _A = KI(P ^ aA, E ^ _A, 40), E = (E = eA) + (eA = w) | 0, aA = KI(QA ^ (h = aA = _A + iA | 0), kA ^ (D = h >>> 0 < _A >>> 0 ? E + 1 | 0 : E), 48), E = Z + (v = w) | 0, k = E = (aA = P + (p = aA) | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, aA = E = KI(_A ^ (n = aA), eA ^ E, 1), Z = P = w, eA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, kA = E = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, tA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, P = (_A = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, E = (GA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (bA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, E = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (P >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (iA = (_ = P) >>> 0 > (P = P + tA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = P + eA | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, _ = KI(P ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), e = KI(QA ^ (c = _ - 2067093701 | 0), bA ^ (x = (J = P = w) - ((_ >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), E = (L = w) + E | 0, E = (d = (F = P = e + tA | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) + Z | 0, E = (F >>> 0 > (P = F + aA | 0) >>> 0 ? E + 1 | 0 : E) + X | 0, E = (QA = (t = P) >>> 0 > (P = P + oA | 0) >>> 0 ? E + 1 | 0 : E) + z | 0, m = z = P + g | 0, s = E = z >>> 0 < P >>> 0 ? E + 1 | 0 : E, f = aA, fA = Z, Z = P, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, P = E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, bA = E = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, X = E, E = (FA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, E = Q + ((z = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (t = z + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = (X = t + X | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + P | 0, pA = t = X + aA | 0, t = E = t >>> 0 < X >>> 0 ? E + 1 | 0 : E, y = z, z = KI(X ^ (a[0 | (E = A - -64 | 0)] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24) ^ -1377402159, tA ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24) ^ 1359893119, 32), tA = E = w, E = E + 1779033703 | 0, X = z, K = E = (z = z - 205731576 | 0) >>> 0 < 4089235720 ? E + 1 | 0 : E, r = KI(y ^ (N = z), E ^ r, 40), E = (l = w) + t | 0, y = KI(X ^ (t = z = r + pA | 0), tA ^ (G = r >>> 0 > t >>> 0 ? E + 1 | 0 : E), 48), E = KI(y ^ Z, (T = w) ^ iA, 32), V = z = w, u = E, C = E = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, tA = pA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, b = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, z = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (X = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, E = (NA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (U = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, E = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (z >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, E = C + (Z = (M = z) >>> 0 > (z = b + z | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (b = z + tA | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Z = KI(z ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, Z ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), X = KI(X ^ (tA = Z + 1595750129 | 0), (M = U) ^ (U = (H = z = w) - ((Z >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), E = (IA = w) + E | 0, z = KI((b = z = X + b | 0) ^ Z, H ^ (M = b >>> 0 < X >>> 0 ? E + 1 | 0 : E), 48), E = U + ($ = w) | 0, Y = E = (z = tA + (U = z) | 0) >>> 0 < tA >>> 0 ? E + 1 | 0 : E, E = V + E | 0, O = f ^ (Z = u + (H = z) | 0), f = E = Z >>> 0 < H >>> 0 ? E + 1 | 0 : E, tA = KI(O, E ^ fA, 40), E = (fA = w) + s | 0, z = KI(m = u ^ (s = z = tA + m | 0), V ^ (u = s >>> 0 < tA >>> 0 ? E + 1 | 0 : E), 48), E = f + (CA = w) | 0, V = E = (f = Z + (m = z) | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, z = (R = KI(f ^ tA, fA ^ E, 1)) + (Z = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, E = (hA = w) + (fA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, nA = z, q = z >>> 0 < Z >>> 0 ? E + 1 | 0 : E, W = sA, z = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, tA = E = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, X = (E = h) + (h = KI(H ^ X, Y ^ IA, 1)) | 0, E = (H = w) + D | 0, E = (h >>> 0 > X >>> 0 ? E + 1 | 0 : E) + tA | 0, E = (D = (D = X) >>> 0 > (X = z + X | 0) >>> 0 ? E + 1 | 0 : E) + W | 0, O = Y = X + gA | 0, Y = E = Y >>> 0 < X >>> 0 ? E + 1 | 0 : E, F = KI(_ ^ F, d ^ J, 48), d = E = KI(F ^ X, (J = w) ^ D, 32), E = K + T | 0, E = (IA = X = w) + (N = (X = y + N | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, K = E = (D = X) >>> 0 > (y = D + d | 0) >>> 0 ? E + 1 | 0 : E, h = KI(y ^ h, H ^ E, 40), E = (T = w) + Y | 0, E = (H = h >>> 0 > (Y = X = h + O | 0) >>> 0 ? E + 1 | 0 : E) + q | 0, E = (_ = Y >>> 0 > (X = Y + nA | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, nA = q = X + EA | 0, q = E = q >>> 0 < X >>> 0 ? E + 1 | 0 : E, O = X, W = _, X = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = KI(r ^ D, N ^ l, 1), E = (l = w) + M | 0, E = ((_ = r + b | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) + X | 0, E = (D = (N = _) >>> 0 > (_ = I + _ | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, MA = N = _ + EA | 0, N = E = N >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ p, D ^ v, 32), AA = _ = w, p = E, D = _, E = J + x | 0, F = _ = c + F | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + D | 0, M = _ = _ + p | 0, v = E = F >>> 0 > _ >>> 0 ? E + 1 | 0 : E, D = KI(_ ^ r, l ^ E, 40), E = (l = w) + N | 0, p = KI((_ = D + MA | 0) ^ p, AA ^ (c = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(p ^ O, (MA = w) ^ W, 32), AA = r = w, N = E, O = r, e = KI(e ^ F, b ^ L, 1), E = G + (F = w) | 0, E = ((r = t) >>> 0 > (t = t + e | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, E = (t = (r = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + fA | 0, W = G = r + Z | 0, G = E = G >>> 0 < r >>> 0 ? E + 1 | 0 : E, b = e, r = KI(r ^ U, t ^ $, 32), E = (U = w) + k | 0, n = KI(b ^ (t = e = r + n | 0), (k = r >>> 0 > t >>> 0 ? E + 1 | 0 : E) ^ F, 40), E = ($ = w) + G | 0, F = e = n + W | 0, e = KI(r ^ e, U ^ (G = e >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = k + (i = w) | 0, k = e, U = E = (e = t + e | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + O | 0, E = (b = e) >>> 0 > (e = e + N | 0) >>> 0 ? E + 1 | 0 : E, O = e, e ^= R, R = E, r = KI(e, hA ^ E, 40), E = (hA = w) + q | 0, q = e = r + nA | 0, E = B + (W = r >>> 0 > e >>> 0 ? E + 1 | 0 : E) | 0, nA = e = e + g | 0, J = E = e >>> 0 < g >>> 0 ? E + 1 | 0 : E, e = _, x = gA, L = sA, _ = KI(d ^ Y, H ^ IA, 48), E = K + (IA = w) | 0, d = _, K = E = (t = y + _ | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ h, T ^ E, 1), E = (y = w) + L | 0, E = ((h = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) + c | 0, E = NA + (e = (c = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, Y = h = c + iA | 0, h = E = h >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ k, e ^ i, 32), E = V + (H = w) | 0, k = c, f = E = (c = f + c | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ c, E ^ y, 40), E = (E = h) + (h = w) | 0, y = _ = e + Y | 0, _ = KI(_ ^ k, H ^ (Y = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = f + (T = w) | 0, H = _, V = E = (f = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ f, h ^ E, 1), E = (h = w) + J | 0, E = C + (e = (c = _ + nA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, nA = k = c + pA | 0, k = E = k >>> 0 < pA >>> 0 ? E + 1 | 0 : E, J = _, x = h, E = v + MA | 0, E = (_ = p + M | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = _, M = E, E = KI(_ ^ D, l ^ E, 1), D = h = w, _ = E, E = G + X | 0, E = ((F = I + F | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + h | 0, E = DA + (F = (h = _ + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E) | 0, v = G = h + oA | 0, G = E = G >>> 0 < oA >>> 0 ? E + 1 | 0 : E, h = KI(h ^ m, F ^ CA, 32), E = K + (m = w) | 0, F = h, K = E = (K = t) >>> 0 > (t = t + h | 0) >>> 0 ? E + 1 | 0 : E, h = KI(_ ^ t, E ^ D, 40), E = (l = w) + G | 0, D = _ = h + v | 0, _ = KI(G = _ ^ F, m ^ (F = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = K + (CA = w) | 0, K = _, G = _ = t + _ | 0, m = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, v = c, L = e, _ = KI(n ^ b, U ^ $, 1), E = (t = w) + S | 0, E = u + ((c = _ + cA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (e = (c = c + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, u = s = c + j | 0, s = E = s >>> 0 < c >>> 0 ? E + 1 | 0 : E, n = _, _ = (c = KI(c ^ d, e ^ IA, 32)) + p | 0, E = (p = w) + M | 0, e = _, t = KI(_ ^ n, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ t, 40), E = (IA = w) + s | 0, s = _ = t + u | 0, b = KI(_ ^ c, p ^ (u = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), c = KI(b ^ v, (E = L) ^ (L = w), 32), E = (v = w) + m | 0, p = _ = c + G | 0, n = KI(_ ^ J, (M = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ x, 40), E = (J = w) + k | 0, k = _ = n + nA | 0, _ = KI(_ ^ c, v ^ (U = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = M + ($ = w) | 0, M = _, v = E = (c = p) >>> 0 > (p = p + _ | 0) >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ n, J ^ E, 1), E = wA + (nA = w) | 0, J = _, MA = _ = EA + _ | 0, n = E = _ >>> 0 < EA >>> 0 ? E + 1 | 0 : E, c = rA, _ = KI(h ^ G, l ^ m, 1), E = Y + (h = w) | 0, E = ((G = y) >>> 0 > (y = _ + y | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = (G = (c = c + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) + kA | 0, x = y = c + eA | 0, Y = E = y >>> 0 < c >>> 0 ? E + 1 | 0 : E, m = _, y = KI(N ^ q, W ^ AA, 48), E = KI(y ^ c, (l = w) ^ G, 32), AA = _ = w, N = E, c = _, E = d + L | 0, E = (_ = e + b | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _, d = E, E = E + c | 0, G = _ = _ + N | 0, b = E = e >>> 0 > _ >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ m, E ^ h, 40), E = (E = Y) + (Y = w) | 0, m = _ = c + x | 0, q = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + n | 0, W = E = (h = _ + MA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, n = E, _ = KI(t ^ e, d ^ IA, 1), E = P + (t = w) | 0, E = F + ((e = _ + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = tA + (D = (e = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, x = F = e + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, d = _, E = KI(e ^ H, D ^ T, 32), L = _ = w, e = E, D = _, E = l + R | 0, H = _ = y + O | 0, R = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + D | 0, E = (y = _ + e | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = y ^ d, d = E, D = KI(_, E ^ t, 40), E = (T = w) + F | 0, t = _ = D + x | 0, O = KI(_ ^ e, L ^ (F = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(O ^ h, (IA = w) ^ n, 32), MA = _ = w, x = E, n = _, _ = KI(r ^ H, R ^ hA, 1), E = u + (r = w) | 0, E = FA + ((e = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (e = e + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) + GA | 0, H = u = e + _A | 0, u = E = u >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(e ^ K, s ^ CA, 32), E = V + (R = w) | 0, K = e, s = r, r = E = (e = f + e | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ e, s ^ E, 40), E = (CA = w) + u | 0, f = _ = s + H | 0, _ = KI(H = _ ^ K, R ^ (K = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = r + (l = w) | 0, r = _, u = _ = e + _ | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + n | 0, V = E = (n = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, e = KI(n ^ J, nA ^ E, 40), E = W + (R = w) | 0, E = ((_ = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + sA | 0, h = _, W = _ = _ + gA | 0, J = E = h >>> 0 > _ >>> 0 ? E + 1 | 0 : E, L = BA, h = KI(N ^ m, q ^ AA, 48), E = (hA = w) + b | 0, N = _ = h + G | 0, E = KI(_ ^ c, (G = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E) ^ Y, 1), Y = c = w, _ = E, E = F + B | 0, E = ((t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = (t = (c = _ + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + L | 0, b = F = c + j | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = KI(c ^ r, t ^ l, 32), E = v + (m = w) | 0, p = E = (r = c + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ r, E ^ Y, 40), E = (q = w) + F | 0, F = _ = t + b | 0, c = KI(_ ^ c, m ^ (Y = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (b = w) | 0, m = E = (p = c + r | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ p, q ^ E, 1), E = (q = w) + J | 0, E = fA + ((r = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + S | 0, nA = S = r + cA | 0, S = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = _, L = r, l = t, r = rA, _ = KI(s ^ u, H ^ CA, 1), E = U + (s = w) | 0, E = ((t = k) >>> 0 > (k = _ + k | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = GA + (t = (r = r + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E) | 0, U = k = r + _A | 0, u = E = k >>> 0 < _A >>> 0 ? E + 1 | 0 : E, k = _, t = E = KI(r ^ h, t ^ hA, 32), E = d + IA | 0, E = (H = _ = w) + (y = (_ = y + O | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, d = E = (h = _ + t | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = KI(h ^ k, E ^ s, 40), E = (IA = w) + u | 0, u = KI(U = (r = k + U | 0) ^ t, H ^ (t = r >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = KI(u ^ L, (CA = w) ^ l, 32), hA = s = w, U = E, H = s, _ = KI(_ ^ D, y ^ T, 1), E = tA + (s = w) | 0, E = K + ((y = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = FA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = D = y + QA | 0, D = E = D >>> 0 < QA >>> 0 ? E + 1 | 0 : E, K = _, O = s, y = KI(y ^ M, f ^ $, 32), E = (M = w) + G | 0, s = _ = y + N | 0, f = KI(_ ^ K, (N = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ O, 40), E = (T = w) + D | 0, K = _ = f + L | 0, _ = KI(_ ^ y, M ^ (G = _ >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = N + (L = w) | 0, D = _, N = _ = s + _ | 0, M = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = E + H | 0, H = _ = _ + U | 0, y = q, q = E = N >>> 0 > _ >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ v, y ^ E, 40), E = (E = S) + (S = w) | 0, O = _ = y + nA | 0, v = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = t, _ = KI(x ^ W, J ^ MA, 48), E = V + ($ = w) | 0, V = _, t = (_ = n + _ | 0) ^ e, e = E = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E, t = KI(t, E ^ R, 1), E = (R = w) + s | 0, E = C + ((r = t + r | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + P | 0, W = n = r + aA | 0, n = E = n >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = KI(r ^ D, s ^ L, 32), E = m + (J = w) | 0, m = r, p = E = (s = p + r | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, R ^ E, 40), E = (E = n) + (n = w) | 0, D = r = t + W | 0, r = KI(x = r ^ m, J ^ (m = r >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (nA = w) | 0, R = r, W = E = (p = s + r | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, r = KI(t ^ p, n ^ E, 1), E = (n = w) + v | 0, E = B + ((t = r + O | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = X + (s = (t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, MA = J = I + t | 0, J = E = J >>> 0 < I >>> 0 ? E + 1 | 0 : E, x = r, L = n, n = t, l = s, r = KI(f ^ N, M ^ T, 1), E = (s = w) + Y | 0, E = DA + ((t = r + F | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (f = (t = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + X | 0, Y = F = I + t | 0, F = E = F >>> 0 < t >>> 0 ? E + 1 | 0 : E, N = r, t = E = KI(t ^ V, f ^ $, 32), f = r = w, E = d + CA | 0, d = E = (r = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + f | 0, E = (h = r) >>> 0 > (r = r + t | 0) >>> 0 ? E + 1 | 0 : E, u = r, r ^= N, N = E, s = KI(r, E ^ s, 40), E = (T = w) + F | 0, f = KI(F = (r = s + Y | 0) ^ t, f ^ (t = r >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(f ^ n, (E = l) ^ (l = w), 32), $ = n = w, F = E, Y = e, e = c, E = KI(h ^ k, d ^ IA, 1), M = c = w, h = E, E = G + kA | 0, E = ((k = K + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + c | 0, k = E = (c = h + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ b, 32), E = (E = Y) + (Y = w) | 0, h = KI((_ = e + _ | 0) ^ h, M ^ (d = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = k + (IA = w) | 0, K = h, E = NA + ((G = c) >>> 0 > (c = c + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, G = E = (h = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ h, Y ^ E, 48), E = d + (CA = w) | 0, b = _, e = c, d = _ = _ + c | 0, Y = E = b >>> 0 > _ >>> 0 ? E + 1 | 0 : E, E = E + n | 0, b = E = (n = _ + F | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = (k = KI(n ^ x, E ^ L, 40)) + MA | 0, E = (MA = w) + J | 0, M = _, V = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ O, v ^ hA, 48), E = (U = w) + q | 0, H = c = _ + H | 0, x = S, S = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(c ^ y, x ^ E, 1), O = c = w, y = E, E = t + C | 0, E = ((r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + c | 0, E = fA + (r = (c = r + y | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, v = t = c + Z | 0, t = E = t >>> 0 < Z >>> 0 ? E + 1 | 0 : E, c = KI(c ^ e, r ^ CA, 32), E = W + (J = w) | 0, q = c, c = (e = p + c | 0) ^ y, y = E = e >>> 0 < p >>> 0 ? E + 1 | 0 : E, r = KI(c, O ^ E, 40), E = (E = t) + (t = w) | 0, O = c = r + v | 0, c = KI(p = c ^ q, J ^ (q = c >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = y + (CA = w) | 0, W = c, e = E = (c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = KI(c ^ r, t ^ E, 1), E = (p = w) + V | 0, E = wA + ((t = r + M | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (y = (t = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + BA | 0, AA = v = t + j | 0, v = E = v >>> 0 < t >>> 0 ? E + 1 | 0 : E, J = r, x = t, L = y, r = KI(K ^ d, Y ^ IA, 1), E = (Y = w) + sA | 0, E = m + (r >>> 0 > (t = r + gA | 0) >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ t, E ^ U, 32), U = _ = w, D = E, E = N + l | 0, E = (_ = f + u | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, f = _, d = E, E = U + E | 0, N = _ = _ + D | 0, K = E = f >>> 0 > _ >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ r, Y ^ E, 40), E = y + (l = w) | 0, u = _, E = tA + ((_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (_ = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Y = _, _ ^= D, D = E, y = KI(_, U ^ E, 48), E = KI(y ^ x, (E = L) ^ (L = w), 32), IA = _ = w, U = E, m = _, _ = KI(s ^ f, d ^ T, 1), E = kA + (t = w) | 0, E = G + ((r = _ + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + P | 0, G = f = r + aA | 0, f = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, h = _, d = t, _ = (r = KI(r ^ R, s ^ nA, 32)) + H | 0, E = (H = w) + S | 0, t = _, s = KI(s = _ ^ h, (h = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = (T = w) + f | 0, f = _ = s + G | 0, r = KI(_ ^ r, H ^ (S = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (d = w) | 0, G = _ = r + t | 0, H = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + m | 0, m = E = (h = _ + U | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(h ^ J, E ^ p, 40), E = (R = w) + v | 0, v = _ = t + AA | 0, J = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, _ = c, p = e, e = r, c = KI(F ^ M, V ^ $, 48), E = b + (AA = w) | 0, F = c, n = E = (r = n + c | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, E = KI(r ^ k, MA ^ E, 1), b = c = w, k = E, E = D + SA | 0, E = ((D = Y + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + c | 0, D = E = (c = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ d, 32), E = (Y = w) + p | 0, k = KI((_ = e + _ | 0) ^ k, b ^ (p = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = D + (M = w) | 0, E = FA + ((D = c) >>> 0 > (c = c + k | 0) >>> 0 ? E + 1 | 0 : E) | 0, d = E = (D = c + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ D, Y ^ E, 48), E = p + ($ = w) | 0, Y = c, b = E = (p = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ k, M ^ E, 1), E = (k = w) + J | 0, E = DA + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = wA + (e = (c = c + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, hA = M = c + EA | 0, M = E = M >>> 0 < EA >>> 0 ? E + 1 | 0 : E, V = _, x = c, _ = KI(s ^ G, H ^ T, 1), E = (s = w) + q | 0, E = GA + ((c = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = NA + (G = (c = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, O = H = c + iA | 0, H = E = H >>> 0 < iA >>> 0 ? E + 1 | 0 : E, q = _, E = KI(c ^ F, G ^ AA, 32), AA = _ = w, c = E, E = K + L | 0, N = _ = y + N | 0, F = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = AA + E | 0, K = E = (y = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(y ^ q, E ^ s, 40), E = (L = w) + H | 0, G = _ = s + O | 0, q = KI(_ ^ c, AA ^ (H = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(q ^ x, (AA = w) ^ e, 32), T = _ = w, O = E, e = _, c = rA, _ = KI(N ^ u, F ^ l, 1), E = S + (F = w) | 0, E = ((N = f) >>> 0 > (f = _ + f | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = DA + (f = (c = c + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, N = S = c + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ W, f ^ CA, 32), E = n + (u = w) | 0, n = c, E = (c = r + c | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = F, F = E, r = KI(_ ^ c, r ^ E, 40), E = (l = w) + S | 0, f = _ = r + N | 0, _ = KI(_ ^ n, u ^ (S = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = F + (x = w) | 0, F = _, N = _ = c + _ | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + e | 0, E = (n = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = n ^ V, V = E, k = KI(_, E ^ k, 40), E = (CA = w) + M | 0, M = _ = k + hA | 0, W = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ v, J ^ IA, 48), E = m + (IA = w) | 0, U = _, E = (_ = h + _ | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, m = E, E = KI(_ ^ t, E ^ R, 1), R = _ = w, e = E, E = H + fA | 0, E = ((c = G + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + _ | 0, E = FA + (c = (_ = c + e | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, G = t = _ + QA | 0, t = E = t >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ F, c ^ x, 32), E = b + (H = w) | 0, F = _, p = E = (c = p + _ | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, R ^ E, 40), E = (R = w) + t | 0, G = _ = e + G | 0, _ = KI(t = _ ^ F, H ^ (F = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = p + (hA = w) | 0, p = _, b = E = (t = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ e, R ^ E, 1), E = (H = w) + W | 0, E = kA + ((c = _ + M | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (e = (c = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + sA | 0, nA = R = c + gA | 0, R = E = R >>> 0 < c >>> 0 ? E + 1 | 0 : E, v = _, J = c, x = e, _ = KI(r ^ N, l ^ u, 1), E = GA + (e = w) | 0, E = d + ((c = _ + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = SA + (r = (c = c + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, u = D = c + cA | 0, D = E = D >>> 0 < cA >>> 0 ? E + 1 | 0 : E, d = _, N = e, E = KI(c ^ U, r ^ IA, 32), U = _ = w, r = E, c = _, E = K + AA | 0, E = (_ = y + q | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, y = _, K = E, E = E + c | 0, E = (e = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = e ^ d, d = E, _ = KI(_, E ^ N, 40), E = (E = D) + (D = w) | 0, N = c = _ + u | 0, u = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, U = KI(c ^ r, U ^ E, 48), E = KI(U ^ J, (E = x) ^ (x = w), 32), l = c = w, q = E, c = KI(y ^ s, K ^ L, 1), E = (y = w) + yA | 0, E = S + ((r = c + rA | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, E = C + (s = (r = r + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = f = r + pA | 0, f = E = f >>> 0 < pA >>> 0 ? E + 1 | 0 : E, S = c, K = y, r = KI(r ^ Y, s ^ $, 32), E = (Y = w) + m | 0, y = c = r + h | 0, c = (s = KI(c ^ S, (h = c >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ K, 40)) + L | 0, E = (L = w) + f | 0, S = c, c = KI(c ^ r, Y ^ (K = c >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (AA = w) | 0, Y = c, m = c = y + c | 0, J = E = c >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = l + E | 0, E = (r = c + q | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = H, H = E, y = KI(r ^ v, c ^ E, 40), E = (IA = w) + R | 0, f = c = y + nA | 0, E = KI(c ^ q, l ^ (R = c >>> 0 < y >>> 0 ? E + 1 | 0 : E), 48), l = c = w, q = E, c = _, E = d + x | 0, d = _ = e + U | 0, U = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ c, E ^ D, 1), e = c = w, _ = E, E = K + B | 0, E = ((h = S + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = tA + (h = (c = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, x = D = c + z | 0, D = E = D >>> 0 < z >>> 0 ? E + 1 | 0 : E, S = _, K = e, _ = KI(M ^ O, W ^ T, 48), E = V + (T = w) | 0, M = _, E = (_ = n + _ | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, n = _, c = KI(c ^ p, h ^ hA, 32), V = E, E = E + (O = w) | 0, e = _ = c + _ | 0, h = KI(_ ^ S, (p = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ K, 40), E = (W = w) + D | 0, D = _ = h + x | 0, _ = KI(_ ^ c, O ^ (S = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, K = _, O = E = (p = e + _ | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ p, W ^ E, 1), E = FA + (x = w) | 0, W = _, hA = _ = QA + _ | 0, e = E = _ >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(k ^ n, V ^ CA, 1), E = (h = w) + u | 0, E = NA + ((c = _ + N | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (n = (c = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, V = k = c + j | 0, k = E = k >>> 0 < j >>> 0 ? E + 1 | 0 : E, N = h, c = KI(c ^ Y, n ^ AA, 32), E = b + (AA = w) | 0, u = c, E = (h = t + c | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = N, N = E, n = KI(_ ^ h, t ^ E, 40), E = (CA = w) + k | 0, Y = _ = n + V | 0, E = (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) + e | 0, k = E = (e = _ + hA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, V = E = KI(e ^ q, E ^ l, 32), v = _ = w, _ = KI(s ^ m, J ^ L, 1), E = (t = w) + F | 0, E = X + ((c = _ + G | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (c = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + P | 0, J = F = c + aA | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, G = _, m = t, c = KI(c ^ M, s ^ T, 32), E = (M = w) + U | 0, t = _ = c + d | 0, _ = (s = KI(_ ^ G, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ m, 40)) + J | 0, E = (J = w) + F | 0, F = _, _ = KI(_ ^ c, M ^ (G = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = d + (T = w) | 0, d = _, M = E = (_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + v | 0, U = E = (t = _) >>> 0 > (_ = _ + V | 0) >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ W, x ^ E, 40), E = k + (x = w) | 0, m = c, E = B + ((c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, W = c = c + g | 0, e = c ^ V, V = E = c >>> 0 < g >>> 0 ? E + 1 | 0 : E, c = KI(e, v ^ E, 48), E = U + (v = w) | 0, U = E = (k = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = E = KI(k ^ m, x ^ E, 1), m = e = w, e = KI(t ^ s, M ^ J, 1), E = S + (s = w) | 0, E = NA + ((t = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, E = DA + (D = (t = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, x = S = t + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, M = e, J = s, E = H + l | 0, E = (e = r + q | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, H = e, u = KI(Y ^ u, b ^ AA, 48), s = KI(t ^ u, D ^ (AA = w), 32), Y = E, E = E + (hA = w) | 0, D = e = s + e | 0, e = KI(e ^ M, (b = e >>> 0 < s >>> 0 ? E + 1 | 0 : E) ^ J, 40), E = (M = w) + S | 0, J = E = (r = e + x | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + m | 0, E = C + ((q = r) >>> 0 > (r = _ + r | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + yA | 0, nA = S = r + rA | 0, x = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, L = _, l = r, E = KI(y ^ H, Y ^ IA, 1), y = r = w, _ = E, E = G + GA | 0, E = ((S = F + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) + r | 0, E = tA + (S = (r = _ + S | 0) >>> 0 < S >>> 0 ? E + 1 | 0 : E) | 0, Y = F = r + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, G = _, E = KI(r ^ K, S ^ $, 32), H = _ = w, r = E, S = _, E = N + AA | 0, N = _ = h + u | 0, K = E = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + S | 0, E = (h = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E;
                                        _ = h ^ G, G = E, S = KI(_, E ^ y, 40), E = (AA = w) + F | 0, u = KI(F = (_ = S + Y | 0) ^ r, H ^ (r = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 48), E = KI(E = u ^ l, (l = w) ^ t, 32), IA = t = w, Y = E, F = t, t = KI(n ^ N, K ^ CA, 1), E = BA + (n = w) | 0, E = R + ((y = t + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, K = N = y + eA | 0, N = E = N >>> 0 < eA >>> 0 ? E + 1 | 0 : E, y = KI(y ^ d, f ^ T, 32), E = O + (H = w) | 0, d = y, p = E = (y = p + y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, f = KI(t ^ y, E ^ n, 40), E = (T = w) + N | 0, n = t = f + K | 0, t = KI(N = t ^ d, H ^ (d = t >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, N = t, K = t = y + t | 0, H = E = t >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + F | 0, E = (y = t + Y | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = m, m = E, p = KI(y ^ L, t ^ E, 40), E = (R = w) + x | 0, F = t = p + nA | 0, t = KI(x = t ^ Y, IA ^ (Y = t >>> 0 < p >>> 0 ? E + 1 | 0 : E), 48), E = m + (IA = w) | 0, m = t, y = E = (t = y + t | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, R = E = KI(t ^ p, R ^ E, 1), CA = E, O = p = w, p = r, r = e, e = KI(s ^ q, J ^ hA, 48), E = b + (hA = w) | 0, b = e, E = (e = D + e | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _, _ = r ^ e, r = E, _ = KI(_, E ^ M, 1), E = (M = w) + p | 0, E = SA + (_ >>> 0 > (s = D + _ | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = sA + (D = (s = s + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = p = s + gA | 0, p = E = p >>> 0 < gA >>> 0 ? E + 1 | 0 : E, s = KI(s ^ N, D ^ $, 32), E = U + (J = w) | 0, N = E = (D = s + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(_ ^ D, M ^ E, 40), E = ($ = w) + p | 0, M = _ = k + q | 0, s = KI(_ ^ s, J ^ (U = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = N + (q = w) | 0, J = _ = s + D | 0, N = _, x = E = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = e, p = r, E = G + l | 0, E = (_ = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, _ ^= S, S = E, E = KI(_, AA ^ E, 1), L = _ = w, G = E, r = E, E = d + P | 0, E = ((e = n + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) + _ | 0, n = E = (_ = e) >>> 0 > (e = r + e | 0) >>> 0 ? E + 1 | 0 : E, r = KI(c ^ e, E ^ v, 32), E = (E = p) + (p = w) | 0, u = _ = r + D | 0, c = KI(c = _ ^ G, L ^ (G = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 40), E = n + (v = w) | 0, E = fA + ((_ = c + e | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, L = E = (D = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, p = KI(r ^ D, p ^ E, 48), nA = E = w, _ = KI(f ^ K, H ^ T, 1), E = (r = w) + V | 0, E = wA + ((e = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = X + (f = (e = e + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, V = n = I + e | 0, K = E = n >>> 0 < I >>> 0 ? E + 1 | 0 : E, H = _, n = KI(e ^ b, f ^ hA, 32), E = (T = w) + S | 0, S = _ = n + h | 0, e = KI(_ ^ H, (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ r, 40), E = (E = K) + (K = w) | 0, H = _ = e + V | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = E, E = X + O | 0, E = ((f = I + R | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + r | 0, d = E = (r = _ + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, nA ^ E, 32), E = (R = w) + x | 0, h = KI((f = _ + N | 0) ^ CA, (E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ O, 40), O = E, E = sA + (N = w) | 0, E = d + ((W = h + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = r + W | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = R, R = E, r = KI(_ ^ d, r ^ E, 48), E = (E = O) + (O = w) | 0, _ = h ^ (f = r + f | 0), h = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, W = E = KI(_, E ^ N, 1), CA = E, l = _ = w, N = t, AA = y, t = e, e = KI(n ^ H, V ^ T, 48), E = b + (H = w) | 0, n = _ = e + S | 0, S = E = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ K, 1), E = (V = w) + SA | 0, E = L + ((_ = t + cA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, D = E = (y = _ + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, _ = KI(y ^ s, E ^ q, 32), E = (K = w) + AA | 0, N = s = _ + N | 0, b = E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, E ^ V, 40), E = DA + (hA = w) | 0, V = t, E = D + ((t = oA + t | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ t, E ^ K, 48), E = (E = b) + (b = w) | 0, q = _ = s + N | 0, K = _, L = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = G + nA | 0, N = (_ = p + u | 0) ^ c, c = E = _ >>> 0 < p >>> 0 ? E + 1 | 0 : E, E = KI(N, E ^ v, 1), v = D = w, N = E, E = U + tA | 0, E = ((p = M + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + D | 0, G = E = (G = p) >>> 0 > (p = p + N | 0) >>> 0 ? E + 1 | 0 : E, u = D = KI(p ^ m, IA ^ E, 32), M = E = w, E = E + S | 0, U = D = D + n | 0, m = E = u >>> 0 > D >>> 0 ? E + 1 | 0 : E, D = KI(D ^ N, v ^ E, 40), E = yA + (v = w) | 0, E = G + ((n = D + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = E = (N = p) >>> 0 > (p = p + n | 0) >>> 0 ? E + 1 | 0 : E, N = KI(p ^ u, E ^ M, 48), IA = E = w, S = E, k = KI(k ^ J, x ^ $, 1), G = E = w, u = e, E = E + P | 0, E = Y + ((e = k + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (e = e + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = e ^ u, u = E, F = KI(F, E ^ H, 32), E = ($ = w) + c | 0, Y = _ = F + _ | 0, c = KI(_ ^ k, (c = G) ^ (G = _ >>> 0 < F >>> 0 ? E + 1 | 0 : E), 40), E = wA + (M = w) | 0, E = u + ((_ = c + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, u = _ = _ + e | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + NA | 0, E = ((k = W + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) + e | 0, W = E = (e = _ + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ N, E ^ S, 32), E = (J = w) + L | 0, S = KI((k = _ + K | 0) ^ CA, (E = k >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = K = w, l = E, E = K + kA | 0, E = W + ((K = S + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, W = E = (K = e + K | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ K, E ^ J, 48), E = (J = w) + l | 0, _ = (k = e + k | 0) ^ S, S = E = k >>> 0 < e >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = f, T = s, s = c, c = KI(F ^ u, H ^ $, 48), E = (F = w) + G | 0, G = _ = c + Y | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, E ^ M, 1), E = (M = w) + FA | 0, E = ((_ = s + QA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) + n | 0, p = E = (f = _ + p | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(f ^ T, E ^ b, 32), E = (n = w) + h | 0, Y = h = _ + AA | 0, b = E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = C + (T = w) | 0, M = s, E = p + ((s = pA + s | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, H = E = (h = s + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ h, E ^ n, 48), E = (E = b) + (b = w) | 0, Y = _ = s + Y | 0, AA = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, p = r, f = t, E = m + IA | 0, r = E = (_ = N + U | 0) >>> 0 < N >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ D, E ^ v, 1), E = (D = w) + BA | 0, E = ((n = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + y | 0, y = KI(p ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ O, 32), n = E, N = t, E = (p = w) + u | 0, E = (t = y + G | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ D, 40), E = B + (u = w) | 0, E = ((D = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + n | 0, U = E = (n = D) >>> 0 > (D = D + f | 0) >>> 0 ? E + 1 | 0 : E, p = KI(y ^ D, E ^ p, 48), IA = E = w, f = E, y = KI(q ^ V, L ^ hA, 1), m = E = w, V = r, E = E + fA | 0, E = R + ((r = y + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, n = F, F = E = (r = r + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, n = KI(c ^ r, n ^ E, 32), E = ($ = w) + V | 0, d = _ = n + _ | 0, c = KI(_ ^ y, (c = m) ^ (m = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 40), E = GA + (V = w) | 0, E = F + ((_ = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, R = _ = _ + r | 0, q = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + tA | 0, E = ((y = z + x | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, E ^ f, 32), E = (O = w) + AA | 0, f = KI((y = _ + Y | 0) ^ x, (E = y >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = P + (v = w) | 0, E = F + ((L = f + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + L | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = O, O = E, r = KI(_ ^ F, r ^ E, 48), E = (E = x) + (x = w) | 0, _ = (y = r + y | 0) ^ f, f = E = y >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), L = _ = w, l = s, s = c, c = KI(n ^ R, q ^ $, 48), E = (E = m) + (m = w) | 0, d = _ = c + d | 0, n = V, V = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, n ^ E, 1), E = (R = w) + kA | 0, E = U + ((_ = s + eA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, n = D, D = _ + D | 0, _ = b, b = E = n >>> 0 > D >>> 0 ? E + 1 | 0 : E, _ = KI(D ^ l, _ ^ E, 32), E = (E = S) + (S = w) | 0, U = E = (n = _ + k | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = n, s = KI(s ^ n, E ^ R, 40), E = fA + ($ = w) | 0, R = s, E = b + ((s = Z + s | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, b = E = (n = s + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ n, E ^ S, 48), E = (E = U) + (U = w) | 0, q = _ = s + k | 0, l = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, k = e, E = N + IA | 0, e = E = (_ = p + G | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = sA + (p = w) | 0, E = H + ((D = t + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, N = (D = h + D | 0) ^ k, k = E = D >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = KI(N, E ^ J, 32), S = E = w, N = t, E = E + V | 0, E = (t = h + d | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ p, 40), E = B + (u = w) | 0, E = k + ((p = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, H = E = (p = D + p | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, k = KI(h ^ p, E ^ S, 48), IA = E = w, D = E, h = KI(M ^ Y, T ^ AA, 1), d = E = w, Y = e, E = E + C | 0, E = W + ((e = h + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, K = E = (e = e + K | 0) >>> 0 < K >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ m, 32), E = (CA = w) + Y | 0, Y = _ = S + _ | 0, c = KI(_ ^ h, (M = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = X + (m = w) | 0, E = K + ((_ = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, K = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = L + wA | 0, E = ((h = v + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + l | 0, D = KI((h = _ + q | 0) ^ v, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), J = E, E = SA + (v = w) | 0, E = d + ((L = D + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + L | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = J) + (J = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), hA = E, L = _ = w, AA = y, T = s, y = c, c = KI(S ^ K, V ^ CA, 48), E = (S = w) + M | 0, K = _ = c + Y | 0, Y = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ m, 1), E = (m = w) + yA | 0, E = H + ((_ = y + rA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (M = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = FA + (CA = w) | 0, H = y, E = p + ((y = QA + y | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = M, M = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = N + IA | 0, r = E = (_ = k + G | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = (k = w) + GA | 0, E = b + ((f = t + _A | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, s = KI(s ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = n = w, n = E, G = t, E = N + Y | 0, E = (t = s + K | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, K = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = DA + (u = w) | 0, E = ((k = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + n | 0, b = N, N = E = (n = f + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, l ^ $, 1), Y = E = w, b = r, E = E + BA | 0, E = O + ((r = s + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + b | 0, b = _ = S + _ | 0, c = KI(_ ^ s, (c = Y) ^ (Y = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = NA + (R = w) | 0, E = F + ((_ = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = L + B | 0, E = ((s = v + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ hA, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), L = E, E = kA + (x = w) | 0, E = F + ((l = f + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + Y | 0, Y = _ = c + b | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + FA | 0, E = N + ((_ = y + QA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = BA + ($ = w) | 0, R = y, E = n + ((y = j + y | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + K | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = NA + (k = w) | 0, E = M + ((D = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ J, 32), K = E = w, G = t, E = E + b | 0, E = (t = h + Y | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = wA + (Y = w) | 0, E = p + ((k = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + X | 0, E = W + ((e = I + h | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = fA + (H = w) | 0, E = d + ((_ = c + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + sA | 0, E = ((h = x + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ x, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = C + (J = w) | 0, E = d + ((l = D + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + tA | 0, E = K + ((_ = y + z | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = GA + (CA = w) | 0, H = y, E = p + ((y = _A + y | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + DA | 0, E = N + ((f = t + oA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = yA + (Y = w) | 0, E = n + ((k = t + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + P | 0, E = v + ((r = s + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (R = w) | 0, E = F + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + C | 0, E = ((s = J + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = NA + (J = w) | 0, E = F + ((l = f + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + P | 0, E = N + ((_ = y + aA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = yA + ($ = w) | 0, R = y, E = n + ((y = rA + y | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = DA + (k = w) | 0, E = K + ((D = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = GA + (Y = w) | 0, E = p + ((k = t + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + BA | 0, E = W + ((e = h + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (H = w) | 0, E = d + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + fA | 0, E = ((h = J + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = X + (J = w) | 0, E = d + ((l = I + D | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + wA | 0, E = K + ((_ = y + EA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = B + (CA = w) | 0, H = y, E = p + ((y = g + y | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + sA | 0, E = N + ((f = t + gA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = FA + (Y = w) | 0, E = n + ((k = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + kA | 0, E = v + ((r = s + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = tA + (R = w) | 0, E = F + ((_ = c + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + SA | 0, E = ((s = J + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = yA + (J = w) | 0, E = F + ((l = f + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + NA | 0, E = N + ((_ = y + iA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = C + ($ = w) | 0, R = y, E = n + ((y = pA + y | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = FA + (k = w) | 0, E = K + ((D = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = P + (Y = w) | 0, E = p + ((k = t + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + GA | 0, E = W + ((e = h + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = kA + (H = w) | 0, E = d + ((_ = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + DA | 0, E = ((h = J + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = B + (J = w) | 0, E = d + ((l = D + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (m = w) + BA | 0, E = K + ((_ = y + j | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = f = _ + AA | 0, H = E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = fA + (AA = w) | 0, m = y, E = p + ((y = Z + y | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, f = y + s | 0, y = K, K = E = f >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ f, y ^ E, 48), E = (E = H) + (H = w) | 0, U = _ = y + U | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + X | 0, E = N + ((p = I + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (p = p + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, N = s = KI(s ^ p, E ^ L, 32), G = E = w, u = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, Y = t, t ^= u, u = E, t = KI(t, E ^ k, 40), E = wA + (b = w) | 0, E = n + ((s = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, M = (s = s + p | 0) ^ N, N = E = s >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = KI(M, E ^ G, 48), L = E = w, k = E, G = n = KI(q ^ R, O ^ $, 1), M = E = w, R = r, E = E + tA | 0, E = v + ((r = n + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = S, S = E, n = KI(c ^ r, F ^ E, 32), E = (T = w) + R | 0, F = _ = n + _ | 0, c = KI(c = _ ^ G, (G = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ M, 40), E = sA + (M = w) | 0, E = S + ((_ = c + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, S = _ = _ + r | 0, R = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + fA | 0, E = ((v = Z) >>> 0 > (Z = J + Z | 0) >>> 0 ? E + 1 | 0 : E) + r | 0, fA = E = (_ = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, Z = KI(_ ^ p, E ^ k, 32), E = (q = w) + V | 0, k = KI((r = U + Z | 0) ^ J, (E = r >>> 0 < Z >>> 0 ? E + 1 | 0 : E) ^ l, 40), v = E, E = wA + (O = w) | 0, E = fA + ((J = EA) >>> 0 > (EA = k + EA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (EA = _ + EA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = Z ^ EA, Z = E;
                                        wA = KI(_, E ^ q, 48), E = (fA = w) + v | 0, r = E = (_ = r + wA | 0) >>> 0 < wA >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ k, E ^ O, 1), k = w, q = E, O = h, h = gA, v = sA, sA = KI(n ^ S, R ^ T, 48), E = (n = w) + G | 0, G = h, F = E = (gA = F + sA | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E, h = KI(c ^ (S = gA), E ^ M, 1), E = (M = w) + v | 0, E = N + (h >>> 0 > (gA = G + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, c = E = (gA = s + gA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(y ^ gA, E ^ H, 32), E = (E = D) + (D = w) | 0, N = s = y + O | 0, G = E = s >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = (M = w) + NA | 0, E = (s >>> 0 > (iA = s + iA | 0) >>> 0 ? E + 1 | 0 : E) + c | 0, c = E = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? E + 1 | 0 : E, y = KI(y ^ iA, E ^ D, 48), E = (h = w) + G | 0, D = gA = y + N | 0, NA = E = gA >>> 0 < y >>> 0 ? E + 1 | 0 : E, N = I, G = X, E = u + L | 0, gA = E = (I = p + Y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, X = KI(I ^ t, E ^ b, 1), E = (p = w) + G | 0, E = K + ((t = N + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, e = KI((t = t + f | 0) ^ e, (E = t >>> 0 < f >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = E, K = oA, oA = X, E = (f = w) + F | 0, F = p, p = E = (X = e + S | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, oA = KI(X ^ oA, F ^ E, 40), E = (S = w) + DA | 0, E = ((DA = K + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + N | 0, N = DA, t = e ^ (DA = t + DA | 0), e = E = N >>> 0 > DA >>> 0 ? E + 1 | 0 : E, E = KI(t, E ^ f, 48), u = t = w, f = E, F = j, N = BA, j = KI(U ^ m, V ^ AA, 1), G = E = w, E = E + SA | 0, E = W + ((j = (K = j) + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, cA = E = (j = d + j | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, BA = KI(j ^ sA, E ^ n, 32), E = (d = w) + gA | 0, gA = I = BA + I | 0, sA = KI(I ^ K, (n = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ G, 40), E = (E = N) + (N = w) | 0, E = cA + ((I = sA + F | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E) | 0, cA = I = I + j | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = E, E = k + FA | 0, E = ((K = QA) >>> 0 > (QA = q + QA | 0) >>> 0 ? E + 1 | 0 : E) + j | 0, FA = E = (j = I + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, QA = KI(f ^ j, E ^ t, 32), E = (K = w) + NA | 0, t = I = QA + D | 0, I = KI(I ^ q, (F = k) ^ (k = I >>> 0 < QA >>> 0 ? E + 1 | 0 : E), 40), E = GA + (G = w) | 0, GA = I, E = FA + ((I = _A + I | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, FA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, F = E, b = E ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), j = KI(BA ^ cA, d ^ SA, 48), E = (cA = w) + n | 0, n = I = j + gA | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, BA = rA, E = p + u | 0, rA = E = (I = f + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E, oA = KI(I ^ oA, E ^ S, 1), E = (f = w) + yA | 0, E = ((BA = oA + BA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + c | 0, BA = E = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? E + 1 | 0 : E, gA = KI(yA ^ wA, E ^ fA, 32), E = (X = w) + SA | 0, iA = E = (_A = gA + n | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E, wA = gA, gA = KI(oA ^ _A, E ^ f, 40), E = (c = w) + kA | 0, E = (gA >>> 0 > (oA = gA + eA | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, p = X, X = E = (yA = oA + yA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, oA = KI(wA ^ (eA = yA), p ^ E, 48), E = (f = w) + iA | 0, E = (BA = oA + _A | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, _A = BA, BA ^= Y, o[A + 8 | 0] = BA, o[A + 9 | 0] = BA >>> 8, o[A + 10 | 0] = BA >>> 16, o[A + 11 | 0] = BA >>> 24, iA = E, E ^= b, o[A + 12 | 0] = E, o[A + 13 | 0] = E >>> 8, o[A + 14 | 0] = E >>> 16, o[A + 15 | 0] = E >>> 24, yA = I, BA = rA, I = j, j = KI(s ^ D, M ^ NA, 1), E = (kA = w) + B | 0, E = (j >>> 0 > (rA = j + g | 0) >>> 0 ? E + 1 | 0 : E) + Z | 0, EA = E = (D = rA) >>> 0 > (rA = EA + rA | 0) >>> 0 ? E + 1 | 0 : E, I = KI(I ^ rA, E ^ cA, 32), E = (E = BA) + (BA = w) | 0, cA = E = (yA = I + yA | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, wA = I, yA = KI(j ^ (Z = yA), E ^ kA, 40), E = (s = w) + C | 0, E = EA + ((I = yA + pA | 0) >>> 0 < yA >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E, EA = I, I ^= wA, wA = E, rA = KI(I, E ^ BA, 48), E = (D = w) + cA | 0, Z = I = rA + Z | 0, cA = I >>> 0 < rA >>> 0 ? E + 1 | 0 : E, sA = I = KI(n ^ sA, N ^ SA, 1), kA = E = w, E = E + P | 0, E = e + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, P = E = (j = I + DA | 0) >>> 0 < DA >>> 0 ? E + 1 | 0 : E, I = (BA = KI(y ^ j, E ^ h, 32)) + _ | 0, E = (_ = w) + r | 0, DA = I, I = (aA = KI(e = I ^ sA, (sA = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ kA, 40)) + z | 0, E = (z = w) + tA | 0, E = P + (I >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (P = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = P ^ bA ^ Z, o[0 | (I = A)] = j, o[I + 1 | 0] = j >>> 8, o[I + 2 | 0] = j >>> 16, o[I + 3 | 0] = j >>> 24, j = E ^ Q ^ cA, o[I + 4 | 0] = j, o[I + 5 | 0] = j >>> 8, o[I + 6 | 0] = j >>> 16, o[I + 7 | 0] = j >>> 24, j = (BA = KI(P ^ BA, E ^ _, 48)) + DA | 0, E = (DA = w) + sA | 0, E = (sA = j >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ wA, P = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ EA ^ j, o[I + 16 | 0] = P, o[I + 17 | 0] = P >>> 8, o[I + 18 | 0] = P >>> 16, o[I + 19 | 0] = P >>> 24, o[I + 20 | 0] = E, o[I + 21 | 0] = E >>> 8, o[I + 22 | 0] = E >>> 16, o[I + 23 | 0] = E >>> 24, I = KI(QA ^ FA, F ^ K, 48), P = w, EA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ KI(gA ^ _A, c ^ iA, 1) ^ I, o[A + 32 | 0] = E, o[A + 33 | 0] = E >>> 8, o[A + 34 | 0] = E >>> 16, o[A + 35 | 0] = E >>> 24, E = w ^ EA ^ P, o[A + 36 | 0] = E, o[A + 37 | 0] = E >>> 8, o[A + 38 | 0] = E >>> 16, o[A + 39 | 0] = E >>> 24, E = k + P | 0, E = (EA = I + t | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ X ^ E, P = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ eA ^ EA, o[I + 24 | 0] = P, o[I + 25 | 0] = P >>> 8, o[I + 26 | 0] = P >>> 16, o[I + 27 | 0] = P >>> 24, o[I + 28 | 0] = gA, o[I + 29 | 0] = gA >>> 8, o[I + 30 | 0] = gA >>> 16, o[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ KI(j ^ aA, z ^ sA, 1), o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, I = D ^ w ^ gA, o[A + 44 | 0] = I, o[A + 45 | 0] = I >>> 8, o[A + 46 | 0] = I >>> 16, o[A + 47 | 0] = I >>> 24, j = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ KI(Z ^ yA, s ^ cA, 1), o[A + 56 | 0] = I, o[A + 57 | 0] = I >>> 8, o[A + 58 | 0] = I >>> 16, o[A + 59 | 0] = I >>> 24, I = DA ^ w ^ j, o[A + 60 | 0] = I, o[A + 61 | 0] = I >>> 8, o[A + 62 | 0] = I >>> 16, o[A + 63 | 0] = I >>> 24, j = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = oA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ KI(EA ^ GA, E ^ G, 1), o[A + 48 | 0] = I, o[A + 49 | 0] = I >>> 8, o[A + 50 | 0] = I >>> 16, o[A + 51 | 0] = I >>> 24, I = f ^ w ^ j, o[A + 52 | 0] = I, o[A + 53 | 0] = I >>> 8, o[A + 54 | 0] = I >>> 16, o[A + 55 | 0] = I >>> 24;
                                    }
                                    function n(A, I, g, C, B, Q, i) {
                                        var _, c, t, r, e, y, s, D, p, f, n, k, F, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA, iA, oA, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0, zA = 0, jA = 0, XA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, TA = 0, $A = 0, AI = 0, II = 0;
                                        return h = t = h - 560 | 0, SI(_A = t + 352 | 0), i && nA(_A, 35600, 34, 0), kI(t + 288 | 0, Q, 32, 0), nA(cA = t + 352 | 0, t + 320 | 0, 32, 0), nA(cA, g, C, B), z(cA, yA = t + 224 | 0), sA = a[(aA = Q) + 32 | 0] | a[aA + 33 | 0] << 8 | a[aA + 34 | 0] << 16 | a[aA + 35 | 0] << 24, DA = a[aA + 36 | 0] | a[aA + 37 | 0] << 8 | a[aA + 38 | 0] << 16 | a[aA + 39 | 0] << 24, tA = a[aA + 40 | 0] | a[aA + 41 | 0] << 8 | a[aA + 42 | 0] << 16 | a[aA + 43 | 0] << 24, EA = a[aA + 44 | 0] | a[aA + 45 | 0] << 8 | a[aA + 46 | 0] << 16 | a[aA + 47 | 0] << 24, _A = a[aA + 48 | 0] | a[aA + 49 | 0] << 8 | a[aA + 50 | 0] << 16 | a[aA + 51 | 0] << 24, Q = a[aA + 52 | 0] | a[aA + 53 | 0] << 8 | a[aA + 54 | 0] << 16 | a[aA + 55 | 0] << 24, rA = a[aA + 60 | 0] | a[aA + 61 | 0] << 8 | a[aA + 62 | 0] << 16 | a[aA + 63 | 0] << 24, aA = a[aA + 56 | 0] | a[aA + 57 | 0] << 8 | a[aA + 58 | 0] << 16 | a[aA + 59 | 0] << 24, o[A + 56 | 0] = aA, o[A + 57 | 0] = aA >>> 8, o[A + 58 | 0] = aA >>> 16, o[A + 59 | 0] = aA >>> 24, o[A + 60 | 0] = rA, o[A + 61 | 0] = rA >>> 8, o[A + 62 | 0] = rA >>> 16, o[A + 63 | 0] = rA >>> 24, o[A + 48 | 0] = _A, o[A + 49 | 0] = _A >>> 8, o[A + 50 | 0] = _A >>> 16, o[A + 51 | 0] = _A >>> 24, o[A + 52 | 0] = Q, o[A + 53 | 0] = Q >>> 8, o[A + 54 | 0] = Q >>> 16, o[A + 55 | 0] = Q >>> 24, o[A + 40 | 0] = tA, o[A + 41 | 0] = tA >>> 8, o[A + 42 | 0] = tA >>> 16, o[A + 43 | 0] = tA >>> 24, o[A + 44 | 0] = EA, o[A + 45 | 0] = EA >>> 8, o[A + 46 | 0] = EA >>> 16, o[A + 47 | 0] = EA >>> 24, o[0 | (Q = A + 32 | 0)] = sA, o[Q + 1 | 0] = sA >>> 8, o[Q + 2 | 0] = sA >>> 16, o[Q + 3 | 0] = sA >>> 24, o[Q + 4 | 0] = DA, o[Q + 5 | 0] = DA >>> 8, o[Q + 6 | 0] = DA >>> 16, o[Q + 7 | 0] = DA >>> 24, N(yA), kA(t, yA), tg(A, t), SI(cA), i && nA(cA, 35600, 34, 0), nA(i = t + 352 | 0, A, 64, 0), nA(i, g, C, B), z(i, eA = t + 160 | 0), N(eA), o[t + 288 | 0] = 248 & a[t + 288 | 0], o[t + 319 | 0] = 63 & a[t + 319 | 0] | 64, g = a[23 + (A = c = t + 288 | 0) | 0], tA = Ig(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, e = (a[eA + 28 | 0] | a[eA + 29 | 0] << 8 | a[eA + 30 | 0] << 16 | a[eA + 31 | 0] << 24) >>> 7 | 0, 0), _A = w, g = (A = a[eA + 27 | 0]) >>> 24 | 0, B = A << 8 | (EA = a[eA + 23 | 0] | a[eA + 24 | 0] << 8 | a[eA + 25 | 0] << 16 | a[eA + 26 | 0] << 24) >>> 24, A = Ig(y = 2097151 & ((3 & (DA = (A = (C = a[eA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, s = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = w + _A | 0, C = A >>> 0 > (B = A + tA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D = (g = a[eA + 23 | 0]) << 16 & 2031616 | a[eA + 21 | 0] | a[eA + 22 | 0] << 8, 0, p = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = w + C | 0, _A = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = Ig(f = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, n = EA >>> 5 & 2097151, 0), g = w + B | 0, aA = C = A + _A | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, EA = Ig(s, 0, n, 0), _A = w, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (SA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = Ig(k = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, DA = C >>> 3 | 0, e, 0), A = w + _A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = Ig(r, 0, y, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > (EA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[eA + 19 | 0]) >>> 24 | 0, _A = A << 8 | (NA = a[eA + 15 | 0] | a[eA + 16 | 0] << 8 | a[eA + 17 | 0] << 16 | a[eA + 18 | 0] << 24) >>> 24, A = Ig(F = (7 & (tA = (A = (i = a[eA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | _A) >>> 3, S = tA >>> 3 | 0, p, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D, 0, f, 0), g = w + g | 0, sA = g = A >>> 0 > (yA = A + C | 0) >>> 0 ? g + 1 | 0 : g, pA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, EA = C = (A = (2097151 & A) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (aA = A + aA | 0) >>> 0 ? C + 1 | 0 : C, fA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & A) << 11 | (_A = aA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = Ig(p, 0, n, 0), g = w, C = A, A = Ig(e, 0, s, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = C) + (C = Ig(y, 0, f, 0)) | 0, A = w + g | 0, A = C >>> 0 > wA >>> 0 ? A + 1 | 0 : A, cA = wA - (g = -2097152 & (C = wA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > wA >>> 0) | 0) | 0) + i | 0, v = g = (A = cA + rA | 0) >>> 0 < cA >>> 0 ? g + 1 | 0 : g, L = A, cA = Ig(A, g, 470296, 0), rA = w, g = Ig(e, 0, f, 0), A = w, i = g, g = Ig(y, 0, p, 0), A = w + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, HA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, P = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, q = g = aA - (C = -2097152 & _A) | 0, j = B = EA - ((C >>> 0 > aA >>> 0) + fA | 0) | 0, X = A, C = Ig(A, i, 666643, 0), A = w + rA | 0, A = C >>> 0 > (i = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(g, B, 654183, 0), g = w + A | 0, hA = B = C + i | 0, _A = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, wA = yA - (A = -2097152 & tA) | 0, pA = sA - ((A >>> 0 > yA >>> 0) + pA | 0) | 0, g = Ig(y, 0, k, DA), C = w, B = (A = g) + (g = Ig(G = SA >>> 6 & 2097151, 0, e, 0)) | 0, A = w + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, D, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, n, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, M = NA >>> 6 & 2097151, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, F, S), g = w + A | 0, yA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = Ig(b = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, e, 0), A = w, C = g, g = Ig(y, 0, G, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(n, 0, k, DA)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(s, 0, F, S), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, D, 0), g = w + g | 0, tA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[eA + 14 | 0]) >>> 24 | 0, EA = A << 8 | (aA = a[eA + 10 | 0] | a[eA + 11 | 0] << 8 | a[eA + 12 | 0] << 16 | a[eA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[eA + 15 | 0]) >>> 16 | 0, g = Ig(K = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | EA) >>> 1), 0, p, 0), A = w + B | 0, A = g >>> 0 > (C = g + tA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, M, 0), A = w + A | 0, EA = A = g >>> 0 > (tA = g + C | 0) >>> 0 ? A + 1 | 0 : A, YA = g = A - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, rA = C = (g = (2097151 & g) << 11 | (cA = tA - -1048576 | 0) >>> 21) >>> 0 > (fA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, MA = g = C - ((fA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + pA | 0, O = A = (g = (C = (2097151 & g) << 11 | (yA = fA - -1048576 | 0) >>> 21) + wA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, V = g, A = Ig(g, A, -997805, -1), g = w + _A | 0, hA = C = A + hA | 0, _A = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, wA = (UA = a[23 + (_ = t + 224 | 0) | 0] | a[_ + 24 | 0] << 8 | a[_ + 25 | 0] << 16 | a[_ + 26 | 0] << 24) >>> 5 & 2097151, C = Ig(H = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, n, 0), g = w, B = (A = Ig(D, 0, Y = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(d = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, M, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(K, 0, J = sA >>> 4 & 2097151, 0), A = w + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = Ig(U = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, F, S), A = w + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(G, 0, l = (a[eA + 7 | 0] | a[eA + 8 | 0] << 8 | a[eA + 9 | 0] << 16 | a[eA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = Ig(b, 0, bA = aA >>> 4 & 2097151, 0), A = w + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[eA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (aA = a[eA + 2 | 0] | a[eA + 3 | 0] << 8 | a[eA + 4 | 0] << 16 | a[eA + 5 | 0] << 24) >>> 24, g = A, A = Ig(k, DA, m = 2097151 & ((3 & (g |= C = (A = a[eA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = w + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = Ig(u = (A = a[eA + 2 | 0]) << 16 & 2031616 | a[0 | eA] | a[eA + 1 | 0] << 8, 0, s, 0), A = w + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, x = aA >>> 5 & 2097151, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + wA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[_ + 21 | 0] | a[_ + 22 | 0] << 8, A = Ig(D, 0, H, 0), g = w, aA = (C = A) + (A = Ig(F, S, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, d, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, bA, 0), g = w + g | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = C) + (C = Ig(M, 0, U, 0)) | 0, A = w + g | 0, A = C >>> 0 > aA >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, aA = (g = Ig(b, 0, l, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, x, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, u, 0), g = w + g | 0, A = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[_ + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, eA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (aA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + _A | 0, A = (_A = i + hA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, SA = i - -1048576 | 0, FA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, GA = _A - (g = -2097152 & SA) | 0, dA = A - ((g >>> 0 > _A >>> 0) + i | 0) | 0, sA = B, _A = C, A = Ig(q, j, 470296, 0), g = w, C = A, A = Ig(L, v, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(V, O, 654183, 0)) | 0, A = w + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(F, S, H, 0), A = w, C = g, g = Ig(M, 0, Y, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, bA, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, l, 0), C = w + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, U, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(b, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(k, DA, u, 0)) | 0, g = w + A | 0, wA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 19 | 0]) >>> 24 | 0, pA = A << 8 | (hA = a[_ + 15 | 0] | a[_ + 16 | 0] << 8 | a[_ + 17 | 0] << 16 | a[_ + 18 | 0] << 24) >>> 24, C = ((JA = (A = (B = a[_ + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, wA = B = (g = (7 & JA) << 29 | (g = (B <<= 16) | pA) >>> 3) + wA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, pA = hA >>> 6 & 2097151, A = Ig(M, 0, H, 0), g = w, C = A, A = Ig(K, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, hA = (A = C) + (C = Ig(d, 0, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > hA >>> 0 ? A + 1 | 0 : A, C = Ig(J, 0, m, 0), g = w + A | 0, g = C >>> 0 > (hA = C + hA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(U, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (hA = C + hA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, u, 0), C = w + A | 0, C = g >>> 0 > (hA = g + hA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, x, 0), g = w + C | 0, A = A >>> 0 > (hA = A + hA | 0) >>> 0 ? g + 1 | 0 : g, qA = A = (mA = hA + pA | 0) >>> 0 < hA >>> 0 ? A + 1 | 0 : A, WA = A = A - ((mA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (LA = mA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, jA = A = C >>> 0 > (zA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, TA = A = A - ((zA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (xA = zA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + _A | 0, _A = (C = B + sA | 0) - (A = -2097152 & aA) | 0, eA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + eA | 0) | 0, $A = A = A - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (RA = _A - -1048576 | 0) >>> 21, A = (A >> 21) + dA | 0, B = A = C >>> 0 > (i = C + GA | 0) >>> 0 ? A + 1 | 0 : A, ZA = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, vA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, JA = fA - (A = -2097152 & yA) | 0, MA = rA - ((A >>> 0 > fA >>> 0) + MA | 0) | 0, A = Ig(e, 0, p, 0), PA = g = w, GA = A, hA = A - -1048576 | 0, uA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, Z = A = g >>> 21 | 0, A = Ig(R = (2097151 & g) << 11 | hA >>> 21, A, -683901, -1), g = w + EA | 0, g = A >>> 0 > (C = A + tA | 0) >>> 0 ? g + 1 | 0 : g, yA = C - (A = -2097152 & cA) | 0, aA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = Ig(n, 0, G, 0), A = w, C = g, g = Ig(e, 0, J, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, b, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = C) + (C = Ig(D, 0, k, DA)) | 0, g = w + A | 0, g = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, A = Ig(s, 0, M, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, F, S), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, K, 0), A = w + A | 0, tA = C = g + EA | 0, EA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = Ig(y, 0, J, 0), g = w, C = A, A = Ig(e, 0, d, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = Ig(D, 0, G, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = Ig(n, 0, b, 0), g = w + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(k, DA, F, S), A = w + g | 0, A = C >>> 0 > (rA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, K, 0), A = w + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = C) + (C = Ig(r, 0, M, 0)) | 0, g = w + A | 0, g = C >>> 0 > rA >>> 0 ? g + 1 | 0 : g, A = Ig(p, 0, l, 0), C = w + g | 0, C = A >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(f, 0, bA, 0), g = w + C | 0, pA = g = A >>> 0 > (wA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, OA = A = g - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (fA = wA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, cA = A = g >>> 0 > (YA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, lA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + aA | 0, yA = g = (A = (2097151 & A) << 11 | (rA = YA - -1048576 | 0) >>> 21) >>> 0 > (dA = A + yA | 0) >>> 0 ? g + 1 | 0 : g, XA = A = g - ((dA >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & A) << 11 | (aA = dA - -1048576 | 0) >>> 21, A = (A >> 21) + MA | 0, W = A = (g = EA + JA | 0) >>> 0 < EA >>> 0 ? A + 1 | 0 : A, T = g, A = Ig(g, A, -683901, -1), g = w + sA | 0, vA = C = A + vA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(y, 0, H, 0), g = w, C = A, A = Ig(n, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(F, S, d, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, J, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(D, 0, U, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(G, 0, bA, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(b, 0, K, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(k, DA, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, x, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(r, 0, m, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, u, 0), g = w + A | 0, MA = EA = C + EA | 0, C = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 27 | 0]) >>> 24 | 0, tA = A << 8 | UA >>> 24, EA = 2097151 & ((3 & (g |= A = (EA = a[_ + 28 | 0]) >>> 16 | 0)) << 30 | (A = (EA <<= 16) | tA) >>> 2), g = C, tA = A = EA + MA | 0, EA = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g, JA = Ig(X, P, 470296, 0), MA = w, A = (C = (2097151 & HA) << 11 | KA >>> 21) + (GA - (g = -2097152 & hA) | 0) | 0, g = PA - ((524287 & uA) + (g >>> 0 > GA >>> 0) | 0) + (HA >>> 21) | 0, $ = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, AA = A, g = Ig(A, g, 666643, 0), A = w + MA | 0, A = g >>> 0 > (C = g + JA | 0) >>> 0 ? A + 1 | 0 : A, hA = (g = Ig(L, v, 654183, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > hA >>> 0 ? C + 1 | 0 : C, g = Ig(q, j, -997805, -1), A = w + C | 0, A = g >>> 0 > (hA = g + hA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(V, O, 136657, 0), g = w + A | 0, SA = (A = (2097151 & FA) << 11 | SA >>> 21) + (hA = C + hA | 0) | 0, g = (FA >>> 21 | 0) + (C >>> 0 > hA >>> 0 ? g + 1 | 0 : g) | 0, uA = hA = EA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > SA >>> 0 ? g + 1 | 0 : g) + EA | 0, g = (EA = tA + SA | 0) - (C = -2097152 & (PA = tA - -1048576 | 0)) | 0, C = (A = (A = EA >>> 0 < SA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > EA >>> 0) + hA | 0) | 0) + sA | 0, JA = EA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, GA = (C = (tA = g + vA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (MA = g - -1048576 | 0)) >>> 0 > tA >>> 0) + EA | 0) | 0, UA = A = tA - g | 0, EA = i, i = B, VA = dA - (A = -2097152 & aA) | 0, hA = yA - ((A >>> 0 > dA >>> 0) + XA | 0) | 0, A = Ig(AA, $, -683901, -1), g = w, B = (C = A) + (A = Ig(R, Z, 136657, 0)) | 0, C = w + g | 0, g = cA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, rA = (C = B + YA | 0) - (A = -2097152 & rA) | 0, yA = (g = C >>> 0 < YA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + lA | 0) | 0, g = Ig(R, Z, -997805, -1), A = w + pA | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(AA, $, 136657, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(X, P, -683901, -1), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = B - (A = -2097152 & fA) | 0, sA = g - ((A >>> 0 > B >>> 0) + OA | 0) | 0, g = Ig(n, 0, J, 0), A = w, C = g, g = Ig(y, 0, d, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(e, 0, U, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(F, S, G, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(D, 0, b, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, M, 0), g = w + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, K, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(p, 0, m, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(f, 0, l, 0), A = w + g | 0, tA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(n, 0, d, 0), g = w, C = A, A = Ig(e, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, cA = (A = C) + (C = Ig(D, 0, J, 0)) | 0, A = w + g | 0, A = C >>> 0 > cA >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, U, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(G, 0, M, 0), g = w + C | 0, g = A >>> 0 > (cA = A + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, b, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, K, 0), g = w + A | 0, g = C >>> 0 > (cA = C + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, l, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, bA, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, cA = (A = Ig(p, 0, x, 0)) + cA | 0, g = w + C | 0, C = Ig(f, 0, m, 0), A = w + (A >>> 0 > cA >>> 0 ? g + 1 | 0 : g) | 0, dA = A = C >>> 0 > (XA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, gA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = XA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (vA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, CA = A = A - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (FA = vA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, SA = A = C >>> 0 > (YA = C + aA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = YA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, B = A = C >>> 0 > (aA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, yA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = aA - -1048576 | 0) >>> 21, A = (A >> 21) + hA | 0, OA = A = (tA = sA + VA | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, lA = tA, A = Ig(tA, A, -683901, -1), g = w, tA = A, A = Ig(T, W, 136657, 0), g = w + g | 0, A = (A >>> 0 > (tA = tA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, AI = (i = EA + tA | 0) - (g = -2097152 & NA) | 0, II = (A = i >>> 0 < tA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + ZA | 0) | 0, sA = _A, tA = eA, _A = Ig(lA, OA, 136657, 0), i = w, VA = A = aA - (g = -2097152 & C) | 0, IA = B = B - ((g >>> 0 > aA >>> 0) + yA | 0) | 0, C = Ig(T, W, -997805, -1), g = w + i | 0, g = C >>> 0 > (_A = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(A, B, -683901, -1), A = w + g | 0, ZA = B = C + _A | 0, EA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(V, O, 470296, 0), g = w, B = (C = A) + (A = Ig(q, j, 666643, 0)) | 0, C = w + g | 0, g = jA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, hA = A = B + zA | 0, i = g = A >>> 0 < zA >>> 0 ? g + 1 | 0 : g, g = Ig(V, O, 666643, 0), A = w + qA | 0, A = g >>> 0 > (C = g + mA | 0) >>> 0 ? A + 1 | 0 : A, rA = C - (g = -2097152 & LA) | 0, wA = A - ((g >>> 0 > C >>> 0) + WA | 0) | 0, g = Ig(K, 0, H, 0), A = w, C = g, g = Ig(Y, 0, bA, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, m, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(J, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, l, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, u, 0), g = w + C | 0, aA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 14 | 0]) >>> 24 | 0, _A = A << 8 | (yA = a[_ + 10 | 0] | a[_ + 11 | 0] << 8 | a[_ + 12 | 0] << 16 | a[_ + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[_ + 15 | 0]) >>> 16 | 0)) << 31 | (A = _A | A << 16) >>> 1), A = B, aA = C = g + aA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, _A = yA >>> 4 & 2097151, A = Ig(H, 0, bA, 0), g = w, C = A, A = Ig(Y, 0, l, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(d, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, yA = (A = C) + (C = Ig(J, 0, u, 0)) | 0, A = w + g | 0, A = C >>> 0 > yA >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, m, 0), C = w + A | 0, A = g >>> 0 > (yA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, eA = A = (LA = _A + yA | 0) >>> 0 < yA >>> 0 ? A + 1 | 0 : A, QA = A = A - ((LA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, fA = g = (A = (2097151 & A) << 11 | (NA = LA - -1048576 | 0) >>> 21) >>> 0 > (jA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, iA = A = g - ((jA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (cA = jA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + wA | 0, yA = A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, oA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, WA = g = (g = (A = (2097151 & A) << 11 | (aA = rA - -1048576 | 0) >>> 21) >>> 0 > (B = A + hA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & xA) >>> 0 > B >>> 0) + TA | 0) | 0, xA = A = B - C | 0, _A = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + EA | 0, g = ((A = (2097151 & A) << 11 | _A >>> 21) >>> 0 > (B = A + ZA | 0) >>> 0 ? C + 1 | 0 : C) + tA | 0, mA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & RA) >>> 0 > B >>> 0) + $A | 0) | 0, tA = A = B - C | 0, i = A - -1048576 | 0, qA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + II | 0, RA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (EA = A + AI | 0) >>> 0 ? C + 1 | 0 : C) - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, hA = UA - -1048576 | 0, wA = GA - ((UA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = EA - -1048576 | 0) >>> 21, A = (A >> 21) + GA | 0, $A = (UA = sA + UA | 0) - (g = -2097152 & hA) | 0, AI = (sA >>> 0 > UA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > UA >>> 0) + wA | 0) | 0, II = EA - (A = -2097152 & B) | 0, ZA = C - ((A >>> 0 > EA >>> 0) + RA | 0) | 0, zA = tA - (A = -2097152 & i) | 0, UA = mA - ((A >>> 0 > tA >>> 0) + qA | 0) | 0, A = Ig(lA, OA, -997805, -1), g = w, C = A, A = Ig(T, W, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(VA, IA, 136657, 0)) | 0, A = w + g | 0, g = WA + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, mA = (C = B + xA | 0) - (A = -2097152 & _A) | 0, qA = (g = C >>> 0 < xA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + TA | 0) | 0, xA = YA - (A = -2097152 & pA) | 0, GA = SA - ((A >>> 0 > YA >>> 0) + BA | 0) | 0, g = Ig(AA, $, -997805, -1), A = w, C = g, g = Ig(R, Z, 654183, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(X, P, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(L, v, -683901, -1), C = w + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = B + vA | 0) - (A = -2097152 & FA) | 0, SA = (g = C >>> 0 < vA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + CA | 0) | 0, g = Ig(AA, $, 654183, 0), A = w, C = g, g = Ig(R, Z, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(X, P, -997805, -1)) + C | 0, C = w + A | 0, g = dA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + XA | 0) >>> 0 < XA >>> 0 ? g + 1 | 0 : g, C = A, A = Ig(L, v, 136657, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(q, j, -683901, -1)) | 0, A = w + g | 0, _A = B - (g = -2097152 & HA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + gA | 0) | 0, B = (a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24) >>> 7 | 0, A = Ig(e, 0, H, 0), g = w, EA = (C = A) + (A = Ig(y, 0, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > EA >>> 0 ? C + 1 | 0 : C, A = Ig(D, 0, d, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, J, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(n, 0, U, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, K, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, b, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, bA, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, m, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(r, 0, l, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, u, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, x, 0), C = w + A | 0, g = C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & uA) << 11 | PA >>> 21) + (A = B + EA | 0) | 0, A = (uA >>> 21 | 0) + (g = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, RA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, tA = C = (g = (2097151 & g) << 11 | (DA = KA - -1048576 | 0) >>> 21) >>> 0 > (FA = g + _A | 0) >>> 0 ? C + 1 | 0 : C, PA = g = C - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + SA | 0, _A = A = (g = (2097151 & g) << 11 | (EA = FA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + pA | 0) >>> 0 ? A + 1 | 0 : A, HA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + GA | 0, uA = C = (g = (B = (2097151 & g) << 11 | (i = pA - -1048576 | 0) >>> 21) + xA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, GA = g, A = Ig(g, C, -683901, -1), g = w + qA | 0, SA = C = A + mA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = Ig(T, W, 470296, 0), A = w + yA | 0, A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(lA, OA, 654183, 0), A = w + (A - (((C = -2097152 & aA) >>> 0 > rA >>> 0) + oA | 0) | 0) | 0, A = g >>> 0 > (aA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(VA, IA, -997805, -1), g = w + A | 0, g = C >>> 0 > (aA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, dA = C = pA - (A = -2097152 & i) | 0, bA = _A = _A - ((A >>> 0 > pA >>> 0) + HA | 0) | 0, aA = (i = Ig(GA, uA, 136657, 0)) + aA | 0, A = w + g | 0, C = Ig(C, _A, -683901, -1), g = w + (i >>> 0 > aA >>> 0 ? A + 1 | 0 : A) | 0, _A = g = C >>> 0 > (yA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = yA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, pA = g = (A = g >>> 0 > (aA = g + SA | 0) >>> 0 ? A + 1 | 0 : A) - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & g) << 11 | (B = aA - -1048576 | 0) >>> 21, g = (g >> 21) + UA | 0, zA = SA = rA + zA | 0, SA = rA >>> 0 > SA >>> 0 ? g + 1 | 0 : g, UA = aA - (g = -2097152 & B) | 0, XA = A - ((g >>> 0 > aA >>> 0) + pA | 0) | 0, mA = yA - (A = -2097152 & i) | 0, qA = _A - ((A >>> 0 > yA >>> 0) + HA | 0) | 0, A = Ig(T, W, 666643, 0), C = fA + w | 0, C = (i = A + jA | 0) >>> 0 < jA >>> 0 ? C + 1 | 0 : C, B = (A = Ig(lA, OA, 470296, 0)) + (i - (g = -2097152 & cA) | 0) | 0, g = w + (C - ((g >>> 0 > i >>> 0) + iA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(VA, IA, 654183, 0), A = w + g | 0, aA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = FA - (A = -2097152 & EA) | 0, _A = tA - ((A >>> 0 > FA >>> 0) + PA | 0) | 0, A = Ig(AA, $, 470296, 0), g = w, C = A, A = Ig(R, Z, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(X, P, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(L, v, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(q, j, 136657, 0), A = w + A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = Ig(V, O, -683901, -1)) + C | 0, C = w + A | 0, g = sA + (g >>> 0 > EA >>> 0 ? C + 1 | 0 : C) | 0, FA = (C = (2097151 & JA) << 11 | MA >>> 21) + ((EA = EA + KA | 0) - (A = -2097152 & DA) | 0) | 0, A = ((g = EA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > EA >>> 0) + RA | 0) | 0) + (JA >> 21) | 0, pA = A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (cA = FA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, HA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = Ig(C, A, -683901, -1), g = w + B | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(GA, uA, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(dA, bA, 136657, 0), C = w + A | 0, MA = B = g + B | 0, tA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, aA = LA - (A = -2097152 & NA) | 0, sA = eA - ((A >>> 0 > LA >>> 0) + QA | 0) | 0, g = Ig(H, 0, l, 0), A = w, C = g, g = Ig(Y, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(d, 0, u, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(U, 0, x, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, DA = C = (A = (a[_ + 7 | 0] | a[_ + 8 | 0] << 8 | a[_ + 9 | 0] << 16 | a[_ + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, EA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(H, 0, m, 0), g = w, C = A, A = Ig(Y, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(U, 0, u, 0)) | 0, A = w + g | 0, _A = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[_ + 6 | 0]) >>> 24 | 0, i = g << 8 | (RA = a[_ + 2 | 0] | a[_ + 3 | 0] << 8 | a[_ + 4 | 0] << 16 | a[_ + 5 | 0] << 24) >>> 24, C = A, g = (A = a[_ + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (_A = A + _A | 0) >>> 0 ? C + 1 | 0 : C, vA = A = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (fA = _A - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, rA = A = C >>> 0 > (eA = C + DA | 0) >>> 0 ? A + 1 | 0 : A, PA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (yA = eA - -1048576 | 0) >>> 21) >>> 0 > (B = A + aA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(lA, OA, 666643, 0), A = w + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(VA, IA, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(KA, HA, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = Ig(dA, bA, -997805, -1)) + C | 0, C = w + g | 0, sA = C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, JA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (DA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + tA | 0, MA = C = (A = C >>> 0 > (B = C + MA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & C) << 11 | (tA = B - -1048576 | 0) >>> 21, C = (C >> 21) + qA | 0, YA = NA = EA + mA | 0, NA = EA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, EA = B, g = A, B = (FA - (A = -2097152 & cA) | 0) + (cA = (2097151 & wA) << 11 | hA >>> 21) | 0, A = (pA - ((A >>> 0 > FA >>> 0) + xA | 0) | 0) + (wA >> 21) | 0, hA = A = B >>> 0 < cA >>> 0 ? A + 1 | 0 : A, mA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, FA = C = A >> 21, A = Ig(lA = (2097151 & A) << 11 | (wA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, qA = C - (A = -2097152 & tA) | 0, LA = g - ((A >>> 0 > C >>> 0) + MA | 0) | 0, g = Ig(lA, FA, 136657, 0), A = w + sA | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, jA = C - (g = -2097152 & DA) | 0, JA = A - ((g >>> 0 > C >>> 0) + JA | 0) | 0, g = Ig(VA, IA, 666643, 0), A = w + (rA - (((C = -2097152 & yA) >>> 0 > eA >>> 0) + PA | 0) | 0) | 0, A = g >>> 0 > (EA = g + (eA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(KA, HA, -997805, -1), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 470296, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 654183, 0), A = w + C | 0, MA = EA = g + EA | 0, sA = g >>> 0 > EA >>> 0 ? A + 1 | 0 : A, C = RA >>> 5 & 2097151, A = Ig(H, 0, x, 0), g = w, tA = A, A = Ig(Y, 0, u, 0), g = w + g | 0, A = A >>> 0 > (EA = tA + A | 0) >>> 0 ? g + 1 | 0 : g, tA = g = C + EA | 0, C = A = g >>> 0 < EA >>> 0 ? A + 1 | 0 : A, eA = (g = Ig(H, 0, u, 0)) + (A = (A = a[_ + 2 | 0]) << 16 & 2031616 | a[0 | _] | a[_ + 1 | 0] << 8) | 0, g = w, cA = g = A >>> 0 > eA >>> 0 ? g + 1 | 0 : g, xA = g = g - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, yA = A = (g = (2097151 & g) << 11 | (rA = eA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, RA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (aA = pA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (EA = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(KA, HA, 654183, 0), A = w + (g - (((i = -2097152 & fA) >>> 0 > EA >>> 0) + vA | 0) | 0) | 0, A = C >>> 0 > (_A = C + (EA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(GA, uA, 666643, 0), A = w + A | 0, A = g >>> 0 > (C = g + _A | 0) >>> 0 ? A + 1 | 0 : A, DA = (g = C) + (C = Ig(dA, bA, 470296, 0)) | 0, g = w + A | 0, tA = g = C >>> 0 > DA >>> 0 ? g + 1 | 0 : g, PA = g = g - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, fA = g = (C = (g = (2097151 & g) << 11 | (EA = DA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + MA | 0) >>> 0 ? C + 1 | 0 : C) - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = _A - -1048576 | 0) >>> 21, g = (g >> 21) + JA | 0, uA = GA = sA + jA | 0, sA = sA >>> 0 > GA >>> 0 ? g + 1 | 0 : g, A = Ig(lA, FA, -997805, -1), g = w + C | 0, g = A >>> 0 > (_A = A + _A | 0) >>> 0 ? g + 1 | 0 : g, JA = _A - (A = -2097152 & i) | 0, MA = g - ((A >>> 0 > _A >>> 0) + fA | 0) | 0, g = Ig(lA, FA, 654183, 0), A = w + tA | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, GA = C - (g = -2097152 & EA) | 0, fA = A - ((g >>> 0 > C >>> 0) + PA | 0) | 0, A = Ig(KA, HA, 470296, 0), C = w + (yA - (((g = -2097152 & aA) >>> 0 > pA >>> 0) + RA | 0) | 0) | 0, C = A >>> 0 > (i = A + (pA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 666643, 0), A = w + C | 0, _A = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = Ig(KA, HA, 666643, 0), A = w + (cA - ((4095 & xA) + ((i = -2097152 & rA) >>> 0 > eA >>> 0) | 0) | 0) | 0, DA = A = g >>> 0 > (aA = g + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, cA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (tA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (EA = i + _A | 0) >>> 0 ? A + 1 | 0 : A, rA = A = A - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (_A = EA - -1048576 | 0) >>> 21, A = (A >> 21) + fA | 0, i = i >>> 0 > (yA = i + GA | 0) >>> 0 ? A + 1 | 0 : A, A = Ig(lA, FA, 470296, 0), C = w + C | 0, C = A >>> 0 > (g = A + EA | 0) >>> 0 ? C + 1 | 0 : C, EA = g - (A = -2097152 & _A) | 0, _A = C - ((A >>> 0 > g >>> 0) + rA | 0) | 0, g = Ig(lA, FA, 666643, 0), A = w + (DA - (((C = -2097152 & tA) >>> 0 > aA >>> 0) + cA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (pA = g + (aA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + _A | 0, A = (A = (g = (A = (2097151 & A) << 11 | pA >>> 21) >>> 0 > (fA = A + EA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | fA >>> 21) >>> 0 > (cA = g + yA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + MA | 0, C = (A = (g = (A = (2097151 & A) << 11 | cA >>> 21) >>> 0 > (i = A + JA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (rA = g + uA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + LA | 0, g = (C = (A = (C = (2097151 & C) << 11 | rA >>> 21) >>> 0 > (yA = C + qA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | yA >>> 21) >>> 0 > (aA = A + YA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + XA | 0, g = (g = (A = (g = (2097151 & g) << 11 | aA >>> 21) >>> 0 > (sA = g + UA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + SA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (DA = A + zA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, A = (g = (C = (g = (2097151 & g) << 11 | DA >>> 21) >>> 0 > (tA = g + II | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + AI | 0, _A = (wA = B - (g = -2097152 & wA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | tA >>> 21) >>> 0 > (EA = C + $A | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | EA >>> 21) | 0, A = (hA - ((g >>> 0 > B >>> 0) + mA | 0) | 0) + (A >> 21) | 0, wA = g = (A = _A >>> 0 < wA >>> 0 ? A + 1 | 0 : A) >> 21, pA = (A = Ig(NA = (2097151 & A) << 11 | _A >>> 21, g, 666643, 0)) + (g = 2097151 & pA) | 0, A = w, B = A = g >>> 0 > pA >>> 0 ? A + 1 | 0 : A, o[0 | Q] = pA, o[Q + 1 | 0] = (255 & A) << 24 | pA >>> 8, A = 2097151 & fA, g = Ig(NA, wA, 470296, 0) + A | 0, C = w, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (hA = (2097151 & B) << 11 | pA >>> 21) >>> 0 > (fA = hA + g | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 4 | 0] = (2047 & A) << 21 | fA >>> 11, g = A, C = fA, o[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, o[Q + 2 | 0] = 31 & ((65535 & B) << 16 | pA >>> 16) | C << 5, B = 2097151 & cA, cA = Ig(NA, wA, 654183, 0) + B | 0, A = w, fA = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > cA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (cA = fA + cA | 0) >>> 0 < fA >>> 0 ? g + 1 | 0 : g, o[Q + 6 | 0] = (63 & A) << 26 | cA >>> 6, B = cA, cA = 0, o[Q + 5 | 0] = cA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = Ig(NA, wA, -997805, -1) + C | 0, g = w, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, cA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = cA + i | 0) >>> 0 < cA >>> 0 ? C + 1 | 0 : C, o[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, o[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, o[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & rA, B = Ig(NA, wA, 136657, 0) + g | 0, A = w, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, rA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = rA + B | 0) >>> 0 < rA >>> 0 ? g + 1 | 0 : g, o[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, o[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, o[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & yA, i = Ig(NA, wA, -683901, -1) + B | 0, A = w, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (yA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, o[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, o[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & aA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, o[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, o[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, o[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & DA) + (DA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < DA >>> 0 ? g + 1 | 0 : g, DA = B, o[Q + 21 | 0] = B, sA = 0, o[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, o[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & tA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, o[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, o[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, o[Q + 23 | 0] = 31 & ((65535 & g) << 16 | DA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & EA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, o[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & _A) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, o[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, o[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, o[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, o[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, XC(c, 64), XC(_, 64), I && (E[I >> 2] = 64, E[I + 4 >> 2] = 0), h = t + 560 | 0, 0;
                                    }
                                    function k(A, I, g) {
                                        var C, B, Q, i, E, _, c, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0;
                                        W = Ig(C = (V = a[g + 2 | 0]) << 16 & 2031616 | a[0 | g] | a[g + 1 | 0] << 8, 0, B = (QA = a[I + 23 | 0] | a[I + 24 | 0] << 8 | a[I + 25 | 0] << 16 | a[I + 26 | 0] << 24) >>> 5 & 2097151, 0), Z = w, O = Ig(Q = (V = a[I + 23 | 0]) << 16 & 2031616 | a[I + 21 | 0] | a[I + 22 | 0] << 8, 0, i = (T = a[g + 2 | 0] | a[g + 3 | 0] << 8 | a[g + 4 | 0] << 16 | a[g + 5 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(E = (a[g + 7 | 0] | a[g + 8 | 0] << 8 | a[g + 9 | 0] << 16 | a[g + 10 | 0] << 24) >>> 7 & 2097151, 0, _ = (oA = a[I + 15 | 0] | a[I + 16 | 0] << 8 | a[I + 17 | 0] << 16 | a[I + 18 | 0] << 24) >>> 6 & 2097151, 0), O = w + V | 0, IA = W = Z + W | 0, Z = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = (V = a[I + 14 | 0]) >>> 24 | 0, $ = V << 8 | (gA = a[I + 10 | 0] | a[I + 11 | 0] << 8 | a[I + 12 | 0] << 16 | a[I + 13 | 0] << 24) >>> 24, O = Ig(c = 2097151 & ((1 & (CA = (V = O) | (O = (W = a[I + 15 | 0]) >>> 16 | 0))) << 31 | (V = (W <<= 16) | $) >>> 1), 0, t = (AA = a[g + 10 | 0] | a[g + 11 | 0] << 8 | a[g + 12 | 0] << 16 | a[g + 13 | 0] << 24) >>> 4 & 2097151, 0), Z = w + Z | 0, CA = V = O + IA | 0, W = V >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, Z = (O = a[g + 6 | 0]) >>> 24 | 0, IA = O << 8 | T >>> 24, T = r = 2097151 & ((3 & (Z |= O = (V = a[g + 7 | 0]) >>> 16 | 0)) << 30 | (V = IA | V << 16) >>> 2), IA = 0, $ = (V = a[I + 19 | 0]) << 8 | oA >>> 24, Z = O = V >>> 24 | 0, V = (O = a[I + 20 | 0]) >>> 16 | 0, G = Z = (V |= Z) >>> 3 | 0, O = Ig(T, IA, e = (7 & V) << 29 | (O = O << 16 | $) >>> 3, Z), V = w + W | 0, V = O >>> 0 > ($ = O + CA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y = (T = a[g + 15 | 0] | a[g + 16 | 0] << 8 | a[g + 17 | 0] << 16 | a[g + 18 | 0] << 24) >>> 6 & 2097151, 0, s = (a[I + 7 | 0] | a[I + 8 | 0] << 8 | a[I + 9 | 0] << 16 | a[I + 10 | 0] << 24) >>> 7 & 2097151, 0), O = w + V | 0, IA = W = Z + $ | 0, W = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, $ = (V = a[g + 14 | 0]) << 8 | AA >>> 24, V = O = V >>> 24 | 0, Z = (O = a[g + 15 | 0]) >>> 16 | 0, O = Ig(h = 2097151 & ((1 & (Z |= V)) << 31 | (V = (O <<= 16) | $) >>> 1), 0, D = gA >>> 4 & 2097151, 0), V = w + W | 0, AA = Z = O + IA | 0, IA = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, V = (O = a[g + 19 | 0]) >>> 24 | 0, W = O << 8 | T >>> 24, Z = (O = a[g + 20 | 0]) >>> 16 | 0, p = (7 & (Z |= V)) << 29 | (O = W | O << 16) >>> 3, eA = V = Z >>> 3 | 0, W = V, V = (O = a[I + 6 | 0]) >>> 24 | 0, T = O << 8 | (CA = a[I + 2 | 0] | a[I + 3 | 0] << 8 | a[I + 4 | 0] << 16 | a[I + 5 | 0] << 24) >>> 24, Z = V, V = (O = a[I + 7 | 0]) >>> 16 | 0, V = Ig(p, W, f = 2097151 & ((3 & (V |= Z)) << 30 | (O = O << 16 | T) >>> 2), 0), O = w + IA | 0, Z = V >>> 0 > (W = V + AA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(n = (V = a[g + 23 | 0]) << 16 & 2031616 | a[g + 21 | 0] | a[g + 22 | 0] << 8, 0, k = CA >>> 5 & 2097151, 0), O = w + Z | 0, Z = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, O = Ig(F = (V = a[I + 2 | 0]) << 16 & 2031616 | a[0 | I] | a[I + 1 | 0] << 8, 0, DA = (CA = a[g + 23 | 0] | a[g + 24 | 0] << 8 | a[g + 25 | 0] << 16 | a[g + 26 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, T = W = O + W | 0, IA = O >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(Q, 0, C, 0), V = w, W = (Z = O) + (O = Ig(e, G, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, O = Ig(E, 0, c, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(t, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(_, 0, r, 0), O = w + O | 0, O = V >>> 0 > (Z = V + W | 0) >>> 0 ? O + 1 | 0 : O, W = (V = Z) + (Z = Ig(y, 0, f, 0)) | 0, V = w + O | 0, V = Z >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, s, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, W = (O = Ig(p, eA, k, 0)) + W | 0, V = w + Z | 0, Z = Ig(n, 0, F, 0), O = w + (O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, W = O = Z >>> 0 > ($ = Z + W | 0) >>> 0 ? O + 1 | 0 : O, EA = O = O - (($ >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >>> 21 | 0) + IA | 0, aA = Z = (V = (O = (2097151 & O) << 11 | (cA = $ - -1048576 | 0) >>> 21) >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, iA = T - (O = -2097152 & (tA = T - -1048576 | 0)) | 0, BA = V - ((O >>> 0 > T >>> 0) + Z | 0) | 0, IA = (V = a[g + 27 | 0]) << 8 | CA >>> 24, Z = O = V >>> 24 | 0, T = Ig(N = 2097151 & ((3 & (Z |= V = (O = a[g + 28 | 0]) >>> 16 | 0)) << 30 | (V = (O <<= 16) | IA) >>> 2), 0, wA = (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) >>> 7 | 0, 0), IA = w, V = (O = a[I + 27 | 0]) >>> 24 | 0, I = Ig(S = 2097151 & ((3 & (V |= Z = (I = a[I + 28 | 0]) >>> 16 | 0)) << 30 | (O = O << 8 | QA >>> 24 | I << 16) >>> 2), 0, fA = (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) >>> 7 | 0, 0), O = w + IA | 0, O = I >>> 0 > (g = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = g, I = Ig(B, 0, fA, 0), g = w, IA = (V = I) + (I = Ig(DA, 0, wA, 0)) | 0, V = w + g | 0, V = I >>> 0 > IA >>> 0 ? V + 1 | 0 : V, I = Ig(N, 0, S, 0), V = w + V | 0, IA = V = I >>> 0 > (CA = I + IA | 0) >>> 0 ? V + 1 | 0 : V, AA = I = V - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, V = I >>> 21 | 0, T = (I = (2097151 & I) << 11 | (g = CA - -1048576 | 0) >>> 21) + Z | 0, Z = V + O | 0, oA = V = (Z = I >>> 0 > T >>> 0 ? Z + 1 | 0 : Z) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, I = T - (O = -2097152 & (gA = T - -1048576 | 0)) | 0, b = O = Z - ((131071 & V) + (O >>> 0 > T >>> 0) | 0) | 0, K = I, I = Ig(I, O, 666643, 0), O = w + BA | 0, kA = V = I + iA | 0, T = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, iA = CA - (I = -2097152 & g) | 0, sA = IA - ((131071 & AA) + (I >>> 0 > CA >>> 0) | 0) | 0, I = Ig(n, 0, wA, 0), g = w, V = (O = I) + (I = Ig(DA, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, fA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, N, 0), O = w + V | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, g = Ig(B, 0, DA, 0), O = w, Z = (V = g) + (g = Ig(p, eA, wA, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = (g = Ig(n, 0, S, 0)) + Z | 0, Z = w + V | 0, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(e, G, fA, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, BA = (g = Ig(Q, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > BA >>> 0 ? V + 1 | 0 : V, _A = g = V - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (O = g >>> 21 | 0) | 0, g = V = (g = (2097151 & g) << 11 | (IA = BA - -1048576 | 0) >>> 21) >>> 0 > (AA = g + AA | 0) >>> 0 ? V + 1 | 0 : V, QA = V = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, O = iA, iA = (2097151 & V) << 11 | (I = AA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + sA | 0, H = V = (Z = O + iA | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, Y = I = AA - (O = -2097152 & I) | 0, d = AA = g - ((O >>> 0 > AA >>> 0) + QA | 0) | 0, J = Z, g = Ig(Z, V, 470296, 0), O = w + T | 0, O = g >>> 0 > (V = g + kA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(I, AA, 654183, 0), Z = w + O | 0, sA = g = I + V | 0, T = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, QA = BA - (I = -2097152 & IA) | 0, BA = CA - ((I >>> 0 > BA >>> 0) + _A | 0) | 0, I = Ig(p, eA, S, 0), g = w, V = (O = I) + (I = Ig(y, 0, wA, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, DA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, n, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(_, 0, fA, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, N, 0), V = w + O | 0, CA = g = I + g | 0, IA = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, wA, 0), g = w, V = (O = I) + (I = Ig(y, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(B, 0, p, eA)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(e, G, DA, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, n, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(c, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_, 0, N, 0), O = w + V | 0, I = O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, yA = O = O - ((g >>> 0 < 4293918720) - 1 | 0) | 0, Z = (V = O >>> 21 | 0) + IA | 0, iA = Z = (O = (2097151 & O) << 11 | (_A = g - -1048576 | 0) >>> 21) >>> 0 > (hA = O + CA | 0) >>> 0 ? Z + 1 | 0 : Z, dA = O = Z - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, IA = (2097151 & O) << 11 | (AA = hA - -1048576 | 0) >>> 21, O = (O >>> 21 | 0) + BA | 0, U = O = (Z = IA + QA | 0) >>> 0 < IA >>> 0 ? O + 1 | 0 : O, l = Z, O = Ig(Z, O, -997805, -1), V = w + T | 0, BA = Z = O + sA | 0, T = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = $, $ = W, O = Ig(C, 0, e, G), V = w, W = (Z = O) + (O = Ig(_, 0, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, D, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, s, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(c, 0, r, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(y, 0, k, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, f, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(p, eA, F, 0), O = w + Z | 0, CA = W = V + W | 0, W = V >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = Ig(C, 0, _, 0), V = w, Z = O, O = Ig(c, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, QA = (O = Z) + (Z = Ig(E, 0, s, 0)) | 0, O = w + V | 0, O = Z >>> 0 > QA >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, f, 0), V = w + O | 0, V = Z >>> 0 > (QA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(r, 0, D, 0), Z = w + V | 0, Z = O >>> 0 > (QA = O + QA | 0) >>> 0 ? Z + 1 | 0 : Z, QA = (V = Ig(y, 0, F, 0)) + QA | 0, O = w + Z | 0, Z = Ig(h, 0, k, 0), V = w + (V >>> 0 > QA >>> 0 ? O + 1 | 0 : O) | 0, GA = V = Z >>> 0 > (SA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, xA = V = V - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (NA = SA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + W | 0, rA = V = Z >>> 0 > (MA = Z + CA | 0) >>> 0 ? V + 1 | 0 : V, RA = V = V - ((MA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (kA = MA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + $ | 0, V = Z >>> 0 > (IA = Z + IA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(J, H, 666643, 0), V = w + (V - (((Z = -2097152 & cA) >>> 0 > IA >>> 0) + EA | 0) | 0) | 0, V = O >>> 0 > (W = O + (IA - Z | 0) | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(Y, d, 470296, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(l, U, 654183, 0), V = w + O | 0, sA = V = Z >>> 0 > (pA = Z + W | 0) >>> 0 ? V + 1 | 0 : V, lA = V = V - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, O = (O = V >> 21) + T | 0, BA = O = (V = (2097151 & V) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (EA = V + BA | 0) >>> 0 ? O + 1 | 0 : O, bA = V = O - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, JA = (2097151 & V) << 11 | (cA = EA - -1048576 | 0) >>> 21, CA = V >> 21, O = Ig(C, 0, S, 0), V = w, Z = O, O = Ig(B, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, W = (O = Ig(E, 0, e, G)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(_, 0, t, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(Q, 0, r, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(c, 0, h, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(s, 0, p, eA), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(k, 0, DA, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(f, 0, n, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = (O = W) + (W = Ig(N, 0, F, 0)) | 0, O = w + V | 0, T = Z, IA = Z >>> 0 < W >>> 0 ? O + 1 | 0 : O, FA = Ig(wA, 0, fA, 0), $ = Z = (KA = w) - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, V = FA - (O = -2097152 & (W = FA - -1048576 | 0)) | 0, O = (oA >>> 21 | 0) + (O = KA - ((524287 & Z) + (O >>> 0 > FA >>> 0) | 0) | 0) | 0, m = O = (Z = (gA = (2097151 & oA) << 11 | gA >>> 21) + V | 0) >>> 0 < gA >>> 0 ? O + 1 | 0 : O, u = Z, V = (2097151 & aA) << 11 | tA >>> 21, gA = Ig(Z, O, 666643, 0) + V | 0, O = w + (aA >>> 21 | 0) | 0, O = V >>> 0 > gA >>> 0 ? O + 1 | 0 : O, Z = Ig(K, b, 470296, 0), V = w + O | 0, V = (Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V) + IA | 0, V = (O = T + gA | 0) >>> 0 < gA >>> 0 ? V + 1 | 0 : V, gA = (Z = Ig(J, H, 654183, 0)) + O | 0, O = w + V | 0, UA = T - -1048576 | 0, FA = IA = IA - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = Ig(Y, d, -997805, -1), Z = w + (Z >>> 0 > gA >>> 0 ? O + 1 | 0 : O) | 0, Z = V >>> 0 > (T = V + gA | 0) >>> 0 ? Z + 1 | 0 : Z, tA = (O = Ig(l, U, 136657, 0)) + (T - (V = -2097152 & UA) | 0) | 0, V = w + (Z - ((V >>> 0 > T >>> 0) + IA | 0) | 0) | 0, Z = (oA = O >>> 0 > tA >>> 0 ? V + 1 | 0 : V) + CA | 0, HA = O = tA + JA | 0, gA = Z = O >>> 0 < tA >>> 0 ? Z + 1 | 0 : Z, KA = hA - (O = -2097152 & AA) | 0, hA = iA - ((O >>> 0 > hA >>> 0) + dA | 0) | 0, x = Z = $ >>> 21 | 0, V = (O = g) + (g = Ig(M = (2097151 & $) << 11 | W >>> 21, Z, -683901, -1)) | 0, O = w + I | 0, iA = V - (I = -2097152 & _A) | 0, aA = (g >>> 0 > V >>> 0 ? O + 1 | 0 : O) - ((I >>> 0 > V >>> 0) + yA | 0) | 0, I = Ig(B, 0, y, 0), g = w, O = I, I = Ig(t, 0, wA, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, S, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, p, eA), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(_, 0, DA, 0), O = w + O | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, n, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(D, 0, fA, 0), V = w + V | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(c, 0, N, 0), Z = w + V | 0, W = g = I + g | 0, I = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, g = Ig(t, 0, S, 0), O = w, V = g, g = Ig(E, 0, wA, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, y, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (g = Ig(B, 0, h, 0)) + V | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(e, G, p, eA), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(c, 0, DA, 0), Z = w + V | 0, Z = g >>> 0 > (O = g + O | 0) >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(_, 0, n, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = Ig(s, 0, fA, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, AA = (g = Ig(D, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > AA >>> 0 ? V + 1 | 0 : V, YA = g = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (O = g >>> 21 | 0) | 0, IA = Z = (g = (2097151 & g) << 11 | (T = AA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + W | 0) >>> 0 ? Z + 1 | 0 : Z, yA = I = Z - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >>> 21 | 0) + aA | 0, W = V = (I = (2097151 & I) << 11 | ($ = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = I + iA | 0) >>> 0 ? V + 1 | 0 : V, aA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + hA | 0, R = Z = (g = (V = (2097151 & g) << 11 | (I = iA - -1048576 | 0) >>> 21) + KA | 0) >>> 0 < V >>> 0 ? Z + 1 | 0 : Z, dA = tA - -1048576 | 0, JA = V = oA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, mA = g, g = Ig(g, Z, -683901, -1), O = w + gA | 0, KA = O = (V = (O = g >>> 0 > (Z = g + HA | 0) >>> 0 ? O + 1 | 0 : O) - (((g = -2097152 & dA) >>> 0 > Z >>> 0) + V | 0) | 0) - (((gA = Z - g | 0) >>> 0 < 4293918720) - 1 | 0) | 0, P = gA - (g = -2097152 & (hA = gA - -1048576 | 0)) | 0, vA = V - ((g >>> 0 > gA >>> 0) + O | 0) | 0, g = Ig(mA, R, 136657, 0), V = w + (BA - (((O = -2097152 & cA) >>> 0 > EA >>> 0) + bA | 0) | 0) | 0, uA = Z = g + (EA - O | 0) | 0, g = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, nA = iA - (I &= -2097152) | 0, cA = W - ((I >>> 0 > iA >>> 0) + aA | 0) | 0, I = Ig(u, m, -683901, -1), O = w, V = I, I = Ig(M, x, 136657, 0), O = w + O | 0, V = IA + (I >>> 0 > (Z = V + I | 0) >>> 0 ? O + 1 | 0 : O) | 0, oA = (O = Z + _A | 0) - (I = -2097152 & $) | 0, gA = (V = O >>> 0 < _A >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 > O >>> 0) + yA | 0) | 0, I = Ig(M, x, -997805, -1), O = w + CA | 0, O = I >>> 0 > (V = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(u, m, 136657, 0), O = w + O | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(K, b, -683901, -1)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = Z - (I = -2097152 & T) | 0, $ = V - ((I >>> 0 > Z >>> 0) + YA | 0) | 0, I = Ig(B, 0, t, 0), O = w, Z = (V = I) + (I = Ig(E, 0, S, 0)) | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, wA, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(y, 0, e, G), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(Q, 0, h, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, V = (I = Ig(_, 0, p, eA)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, O = (I = Ig(D, 0, DA, 0)) + V | 0, V = w + Z | 0, V = I >>> 0 > O >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(c, 0, n, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, I = Ig(f, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(s, 0, N, 0), O = w + V | 0, W = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(B, 0, E, 0), V = w, T = (Z = O) + (O = Ig(i, 0, wA, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > T >>> 0 ? Z + 1 | 0 : Z, O = Ig(Q, 0, t, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, S, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(_, 0, y, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(e, G, h, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(c, 0, p, eA), Z = w + O | 0, Z = V >>> 0 > (T = V + T | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(s, 0, DA, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(D, 0, n, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(k, 0, fA, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(f, 0, N, 0), O = w + V | 0, EA = O = Z >>> 0 > (bA = Z + T | 0) >>> 0 ? O + 1 | 0 : O, q = O = O - ((bA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (V = O >>> 21 | 0) | 0, tA = V = (O = (2097151 & O) << 11 | (aA = bA - -1048576 | 0) >>> 21) >>> 0 > (HA = O + W | 0) >>> 0 ? V + 1 | 0 : V, z = I = V - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + $ | 0, iA = O = (I = (2097151 & I) << 11 | (_A = HA - -1048576 | 0) >>> 21) >>> 0 > (YA = I + IA | 0) >>> 0 ? O + 1 | 0 : O, j = I = O - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = I >> 21) + gA | 0, CA = V = (I = (2097151 & I) << 11 | (BA = YA - -1048576 | 0) >>> 21) >>> 0 > (yA = I + oA | 0) >>> 0 ? V + 1 | 0 : V, LA = I = V - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + cA | 0, v = O = (I = (Z = (2097151 & I) << 11 | (W = yA - -1048576 | 0) >>> 21) + nA | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, nA = I, I = Ig(I, O, -683901, -1), Z = w + g | 0, PA = O = I + uA | 0, T = I >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, qA = pA - (I = -2097152 & QA) | 0, lA = sA - ((I >>> 0 > pA >>> 0) + lA | 0) | 0, I = Ig(Y, d, 666643, 0), O = w + (rA - (((g = -2097152 & kA) >>> 0 > MA >>> 0) + RA | 0) | 0) | 0, O = I >>> 0 > (V = I + (MA - g | 0) | 0) >>> 0 ? O + 1 | 0 : O, g = (I = Ig(l, U, 470296, 0)) + V | 0, V = w + O | 0, kA = g, g = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, AA = SA - (I = -2097152 & NA) | 0, IA = GA - ((I >>> 0 > SA >>> 0) + xA | 0) | 0, I = Ig(C, 0, c, 0), O = w, V = I, I = Ig(i, 0, D, 0), Z = w + O | 0, Z = I >>> 0 > (V = V + I | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(E, 0, f, 0), O = w + Z | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(t, 0, k, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, s, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(h, 0, F, 0), V = w + O | 0, $ = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = Ig(C, 0, D, 0), V = w, gA = (Z = O) + (O = Ig(i, 0, s, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > gA >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, k, 0), O = w + Z | 0, O = V >>> 0 > (gA = V + gA | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, F, 0), V = w + O | 0, V = Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, f, 0), O = w + V | 0, sA = O = Z >>> 0 > (pA = Z + gA | 0) >>> 0 ? O + 1 | 0 : O, X = O = O - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (V = O >>> 21 | 0) | 0, cA = Z = (O = (2097151 & O) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (GA = O + $ | 0) >>> 0 ? Z + 1 | 0 : Z, xA = I = Z - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (oA = GA - -1048576 | 0) >>> 21) >>> 0 > (Z = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(l, U, 666643, 0), V = w + O | 0, gA = V = I >>> 0 > (NA = I + Z | 0) >>> 0 ? V + 1 | 0 : V, RA = I = V - ((NA >>> 0 < 4293918720) - 1 | 0) | 0, O = g + (O = I >> 21) | 0, IA = O = (I = (2097151 & I) << 11 | (AA = NA - -1048576 | 0) >>> 21) >>> 0 > (rA = I + kA | 0) >>> 0 ? O + 1 | 0 : O, uA = I = O - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >> 21) + lA | 0, V = (I = (2097151 & I) << 11 | ($ = rA - -1048576 | 0) >>> 21) >>> 0 > (g = I + qA | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(mA, R, -997805, -1), Z = w + V | 0, Z = I >>> 0 > (O = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, MA = I = yA - (g = -2097152 & W) | 0, L = V = CA - ((g >>> 0 > yA >>> 0) + LA | 0) | 0, W = (g = Ig(nA, v, 136657, 0)) + O | 0, O = w + Z | 0, I = Ig(I, V, -683901, -1), O = w + (g >>> 0 > W >>> 0 ? O + 1 | 0 : O) | 0, W = O = I >>> 0 > (CA = I + W | 0) >>> 0 ? O + 1 | 0 : O, SA = I = O - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + T | 0, g = O = (T = kA = (I = (2097151 & I) << 11 | (Z = CA - -1048576 | 0) >>> 21) + PA | 0) >>> 0 < I >>> 0 ? O + 1 | 0 : O, yA = O = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, kA = (2097151 & O) << 11 | (I = T - -1048576 | 0) >>> 21, O = (O >> 21) + vA | 0, vA = lA = kA + P | 0, kA = kA >>> 0 > lA >>> 0 ? O + 1 | 0 : O, LA = T - (I &= -2097152) | 0, PA = g - ((I >>> 0 > T >>> 0) + yA | 0) | 0, qA = CA - (I = -2097152 & Z) | 0, lA = W - ((I >>> 0 > CA >>> 0) + SA | 0) | 0, I = Ig(mA, R, 654183, 0), V = w + (IA - (((g = -2097152 & $) >>> 0 > rA >>> 0) + uA | 0) | 0) | 0, V = I >>> 0 > (O = I + (rA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = (I = Ig(nA, v, -997805, -1)) + O | 0, O = w + V | 0, O = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, I = Ig(MA, L, 136657, 0), O = w + O | 0, uA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, SA = YA - (g = -2097152 & BA) | 0, rA = iA - ((g >>> 0 > YA >>> 0) + j | 0) | 0, g = Ig(u, m, -997805, -1), O = w, Z = (V = g) + (g = Ig(M, x, 654183, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, 136657, 0), O = w + V | 0, O = g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(J, H, -683901, -1), O = w + O | 0, V = tA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, BA = (O = Z + HA | 0) - (g = -2097152 & _A) | 0, tA = (V = O >>> 0 < HA >>> 0 ? V + 1 | 0 : V) - ((g >>> 0 > O >>> 0) + z | 0) | 0, g = Ig(u, m, 654183, 0), O = w, Z = (V = g) + (g = Ig(M, x, 470296, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, -997805, -1), O = w + V | 0, V = EA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, V = (g = Z + bA | 0) >>> 0 < bA >>> 0 ? V + 1 | 0 : V, Z = (O = g) + (g = Ig(J, H, 136657, 0)) | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (g = Ig(Y, d, -683901, -1)) + Z | 0, Z = w + O | 0, Z = g >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, $ = V - (g = -2097152 & aA) | 0, W = Z - ((g >>> 0 > V >>> 0) + q | 0) | 0, g = Ig(C, 0, wA, 0), O = w, V = g, g = Ig(i, 0, S, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, E, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(e, G, t, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(B, 0, r, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(y, 0, c, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(_, 0, h, 0)) + O | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, g = Ig(D, 0, p, eA), O = w + O | 0, O = g >>> 0 > (V = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(f, 0, DA, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(s, 0, n, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(F, 0, fA, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(N, 0, k, 0)) + O | 0, O = w + V | 0, O = (FA >>> 21 | 0) + (O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O) | 0, CA = O = (g = (2097151 & FA) << 11 | UA >>> 21) >>> 0 > (_A = g + Z | 0) >>> 0 ? O + 1 | 0 : O, bA = g = O - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >>> 21 | 0) + W | 0, IA = V = (g = (2097151 & g) << 11 | (T = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = g + $ | 0) >>> 0 ? V + 1 | 0 : V, yA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >> 21) + tA | 0, W = O = (g = (2097151 & g) << 11 | ($ = iA - -1048576 | 0) >>> 21) >>> 0 > (BA = g + BA | 0) >>> 0 ? O + 1 | 0 : O, aA = O = O - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >> 21) + rA | 0, rA = V = (O = (Z = (2097151 & O) << 11 | (g = BA - -1048576 | 0) >>> 21) + SA | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, UA = O, V = Ig(O, V, -683901, -1), O = w + I | 0, tA = Z = V + uA | 0, I = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(mA, R, 470296, 0), Z = w + (gA - (((V = -2097152 & AA) >>> 0 > NA >>> 0) + RA | 0) | 0) | 0, Z = O >>> 0 > (AA = O + (NA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, v, 654183, 0), V = w + Z | 0, V = O >>> 0 > (AA = O + AA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(MA, L, -997805, -1), O = w + V | 0, O = Z >>> 0 > (AA = Z + AA | 0) >>> 0 ? O + 1 | 0 : O, FA = g = BA - (V = -2097152 & g) | 0, eA = W = W - ((V >>> 0 > BA >>> 0) + aA | 0) | 0, AA = (Z = Ig(UA, rA, 136657, 0)) + AA | 0, V = w + O | 0, g = Ig(g, W, -683901, -1), Z = w + (Z >>> 0 > AA >>> 0 ? V + 1 | 0 : V) | 0, W = Z = g >>> 0 > (gA = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, EA = V = Z - ((gA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (g = gA - -1048576 | 0) >>> 21, V = (V >> 21) + I | 0, aA = Z = (V = Z >>> 0 > (AA = Z + tA | 0) >>> 0 ? V + 1 | 0 : V) - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, BA = (2097151 & Z) << 11 | (I = AA - -1048576 | 0) >>> 21, Z = (Z >> 21) + lA | 0, tA = BA >>> 0 > (DA = tA = BA + qA | 0) >>> 0 ? Z + 1 | 0 : Z, wA = AA - (I &= -2097152) | 0, fA = V - ((I >>> 0 > AA >>> 0) + aA | 0) | 0, HA = gA - (I = -2097152 & g) | 0, YA = W - ((I >>> 0 > gA >>> 0) + EA | 0) | 0, I = Ig(mA, R, 666643, 0), V = w + (cA - (((g = -2097152 & oA) >>> 0 > GA >>> 0) + xA | 0) | 0) | 0, V = I >>> 0 > (O = I + (GA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(nA, v, 470296, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(MA, L, 654183, 0), V = w + Z | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, $ = iA - (g = -2097152 & $) | 0, W = IA - ((g >>> 0 > iA >>> 0) + yA | 0) | 0, g = Ig(u, m, 470296, 0), O = w, V = g, g = Ig(M, x, 666643, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(K, b, 654183, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(J, H, -997805, -1)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(Y, d, 136657, 0), V = w + V | 0, O = CA + (g >>> 0 > (Z = g + O | 0) >>> 0 ? V + 1 | 0 : V) | 0, O = (g = Z + _A | 0) >>> 0 < _A >>> 0 ? O + 1 | 0 : O, V = g, g = Ig(l, U, -683901, -1), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, EA = (g = (2097151 & JA) << 11 | dA >>> 21) + (Z - (V = -2097152 & T) | 0) | 0, V = (O - ((V >>> 0 > Z >>> 0) + bA | 0) | 0) + (JA >> 21) | 0, iA = V = g >>> 0 > EA >>> 0 ? V + 1 | 0 : V, yA = g = V - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = g >> 21) + W | 0, dA = V = (g = (Z = (2097151 & g) << 11 | (BA = EA - -1048576 | 0) >>> 21) + $ | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, JA = g, g = Ig(g, V, -683901, -1), Z = w + I | 0, Z = g >>> 0 > (O = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(UA, rA, -997805, -1), V = w + Z | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(FA, eA, 136657, 0), O = w + V | 0, _A = g = I + g | 0, $ = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, T = pA - (I = -2097152 & QA) | 0, IA = sA - ((I >>> 0 > pA >>> 0) + X | 0) | 0, I = Ig(C, 0, s, 0), g = w, O = I, I = Ig(i, 0, f, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(E, 0, F, 0), V = w + V | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, k, 0), O = w + V | 0, I = I >>> 0 > (V = g = I + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, f, 0), O = w, W = (Z = g) + (g = Ig(i, 0, k, 0)) | 0, Z = w + O | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(r, 0, F, 0), O = w + Z | 0, g = O = g >>> 0 > (W = g + W | 0) >>> 0 ? O + 1 | 0 : O, mA = O = O - ((W >>> 0 < 4293918720) - 1 | 0) | 0, Z = O >>> 21 | 0, aA = (O = (2097151 & O) << 11 | (cA = W - -1048576 | 0) >>> 21) + V | 0, V = I + Z | 0, oA = V = O >>> 0 > aA >>> 0 ? V + 1 | 0 : V, pA = I = V - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, O = (Z = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (gA = aA - -1048576 | 0) >>> 21) >>> 0 > (V = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(nA, v, 666643, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(MA, L, 470296, 0), V = w + V | 0, V = I >>> 0 > (O = I + Z | 0) >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(JA, dA, 136657, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (I = Ig(UA, rA, 654183, 0)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, I = Ig(FA, eA, -997805, -1), O = w + Z | 0, CA = O = I >>> 0 > (AA = I + V | 0) >>> 0 ? O + 1 | 0 : O, GA = I = O - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = (Z = I >> 21) + $ | 0, NA = O = (V = (I = (O = (2097151 & I) << 11 | (T = AA - -1048576 | 0) >>> 21) + _A | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 < 4293918720) - 1 | 0) | 0, $ = (2097151 & O) << 11 | (IA = I - -1048576 | 0) >>> 21, O = (O >> 21) + YA | 0, SA = QA = $ + HA | 0, _A = $ >>> 0 > QA >>> 0 ? O + 1 | 0 : O, $ = I, Z = V, V = (iA - (((O = -2097152 & BA) >>> 0 > EA >>> 0) + yA | 0) | 0) + (KA >> 21) | 0, sA = V = (I = (EA - O | 0) + (BA = (2097151 & KA) << 11 | hA >>> 21) | 0) >>> 0 < BA >>> 0 ? V + 1 | 0 : V, bA = V = V - ((I >>> 0 < 4293918720) - 1 | 0) | 0, EA = O = V >> 21, V = Ig(nA = (2097151 & V) << 11 | (QA = I - -1048576 | 0) >>> 21, O, -683901, -1), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, HA = $ - (V = -2097152 & IA) | 0, YA = O - ((V >>> 0 > $ >>> 0) + NA | 0) | 0, O = Ig(nA, EA, 136657, 0), V = w + CA | 0, V = O >>> 0 > (Z = O + AA | 0) >>> 0 ? V + 1 | 0 : V, yA = Z - (O = -2097152 & T) | 0, KA = V - ((O >>> 0 > Z >>> 0) + GA | 0) | 0, Z = (O = Ig(MA, L, 666643, 0)) + (aA - (V = -2097152 & gA) | 0) | 0, V = w + (oA - ((V >>> 0 > aA >>> 0) + pA | 0) | 0) | 0, V = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, $ = (O = Ig(JA, dA, -997805, -1)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > $ >>> 0 ? Z + 1 | 0 : Z, V = Ig(UA, rA, 470296, 0), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(FA, eA, 654183, 0), V = w + O | 0, hA = $ = Z + $ | 0, CA = Z >>> 0 > $ >>> 0 ? V + 1 | 0 : V, $ = W, W = g, g = Ig(i, 0, F, 0), O = w, V = g, g = Ig(C, 0, k, 0), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, F, 0), pA = V = w, iA = g, oA = g - -1048576 | 0, GA = g = V - ((g >>> 0 < 4293918720) - 1 | 0) | 0, V = g >>> 21 | 0, BA = (g = (2097151 & g) << 11 | oA >>> 21) + Z | 0, Z = V + O | 0, gA = Z = g >>> 0 > BA >>> 0 ? Z + 1 | 0 : Z, NA = g = Z - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >>> 21 | 0) + W | 0, O = (g = (2097151 & g) << 11 | (AA = BA - -1048576 | 0) >>> 21) >>> 0 > (Z = g + $ | 0) >>> 0 ? O + 1 | 0 : O, W = (g = Ig(JA, dA, 654183, 0)) + (Z - (V = -2097152 & cA) | 0) | 0, Z = w + (O - ((8191 & mA) + (V >>> 0 > Z >>> 0) | 0) | 0) | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(UA, rA, 666643, 0), V = w + Z | 0, V = g >>> 0 > (O = g + W | 0) >>> 0 ? V + 1 | 0 : V, T = (g = Ig(FA, eA, 470296, 0)) + O | 0, O = w + V | 0, IA = O = g >>> 0 > T >>> 0 ? O + 1 | 0 : O, aA = g = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >> 21) + CA | 0, Z = V = (g = (2097151 & g) << 11 | ($ = T - -1048576 | 0) >>> 21) >>> 0 > (W = g + hA | 0) >>> 0 ? V + 1 | 0 : V, cA = O = V - ((W >>> 0 < 4293918720) - 1 | 0) | 0, CA = (2097151 & O) << 11 | (g = W - -1048576 | 0) >>> 21, O = (O >> 21) + KA | 0, CA = CA >>> 0 > (rA = hA = CA + yA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(nA, EA, -997805, -1), O = w + Z | 0, UA = (W = V + W | 0) - (g &= -2097152) | 0, KA = (V >>> 0 > W >>> 0 ? O + 1 | 0 : O) - ((g >>> 0 > W >>> 0) + cA | 0) | 0, g = Ig(nA, EA, 654183, 0), Z = w + IA | 0, Z = g >>> 0 > (O = g + T | 0) >>> 0 ? Z + 1 | 0 : Z, hA = O - (g = -2097152 & $) | 0, aA = Z - ((g >>> 0 > O >>> 0) + aA | 0) | 0, g = Ig(JA, dA, 470296, 0), V = w + (gA - ((8191 & NA) + ((O = -2097152 & AA) >>> 0 > BA >>> 0) | 0) | 0) | 0, V = g >>> 0 > (Z = g + (BA - O | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(FA, eA, 666643, 0), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, W = O, g = Ig(JA, dA, 666643, 0), Z = w + (pA - ((2047 & GA) + ((O = -2097152 & oA) >>> 0 > iA >>> 0) | 0) | 0) | 0, T = Z = g >>> 0 > (AA = g + (iA - O | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, cA = g = Z - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = V + (O = g >> 21) | 0, oA = g = (V = (g = (2097151 & g) << 11 | (IA = AA - -1048576 | 0) >>> 21) >>> 0 > ($ = g + W | 0) >>> 0 ? V + 1 | 0 : V) - (($ >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + aA | 0, g = (g = (2097151 & g) << 11 | (W = $ - -1048576 | 0) >>> 21) >>> 0 > (gA = g + hA | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, EA, 470296, 0), V = w + V | 0, V = O >>> 0 > (Z = O + $ | 0) >>> 0 ? V + 1 | 0 : V, W = Z - (O = -2097152 & W) | 0, $ = V - ((O >>> 0 > Z >>> 0) + oA | 0) | 0, O = Ig(nA, EA, 666643, 0), Z = w + (T - (((V = -2097152 & IA) >>> 0 > AA >>> 0) + cA | 0) | 0) | 0, O = (V = (Z = O >>> 0 > (iA = O + (AA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + $ | 0, V = g + (Z = (O = (Z = (2097151 & Z) << 11 | iA >>> 21) >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O) >> 21) | 0, O = (O = (V = (g = $ = (O = (2097151 & O) << 11 | W >>> 21) + gA | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) >> 21) + KA | 0, V = (V = (O = (V = (2097151 & V) << 11 | g >>> 21) >>> 0 > (BA = V + UA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + CA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | BA >>> 21) >>> 0 > (cA = O + rA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + YA | 0, O = (V = (Z = (V = (2097151 & V) << 11 | cA >>> 21) >>> 0 > (oA = V + HA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + _A | 0, V = (Z = (O = (Z = (2097151 & Z) << 11 | oA >>> 21) >>> 0 > (gA = Z + SA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + fA | 0, O = (O = (V = (O = (2097151 & O) << 11 | gA >>> 21) >>> 0 > (AA = O + wA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + tA | 0, V = (V = (O = (V = (2097151 & V) << 11 | AA >>> 21) >>> 0 > (CA = V + DA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + PA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | CA >>> 21) >>> 0 > (T = O + LA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + kA | 0, V = (sA - ((I >>> 0 < (O = -2097152 & QA) >>> 0) + bA | 0) | 0) + ((Z = (V = (2097151 & V) << 11 | T >>> 21) >>> 0 > (IA = V + vA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) | 0, QA = O = (V = ($ = (QA = I - O | 0) + ((2097151 & Z) << 11 | IA >>> 21) | 0) >>> 0 < QA >>> 0 ? V + 1 | 0 : V) >> 21, I = (I = Ig(sA = (2097151 & V) << 11 | $ >>> 21, O, 666643, 0)) + (O = 2097151 & iA) | 0, Z = w, o[0 | A] = I, Z = I >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, o[A + 1 | 0] = (255 & Z) << 24 | I >>> 8, O = 2097151 & W, W = Ig(sA, QA, 470296, 0) + O | 0, V = w, V = (Z >> 21) + (V = O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, V = (W = (iA = (2097151 & Z) << 11 | I >>> 21) + W | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, o[A + 4 | 0] = (2047 & V) << 21 | W >>> 11;
                                        o[A + 3 | 0] = (7 & V) << 29 | W >>> 3, o[A + 2 | 0] = 31 & ((65535 & Z) << 16 | I >>> 16) | W << 5, I = 2097151 & g, g = Ig(sA, QA, 654183, 0) + I | 0, Z = w, Z = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, I = V, O = (V >>= 21) + Z | 0, I = O = (I = (2097151 & I) << 11 | W >>> 21) >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, o[A + 6 | 0] = (63 & O) << 26 | g >>> 6, V = 0, o[A + 5 | 0] = V << 13 | (1572864 & W) >>> 19 | g << 2, V = 2097151 & BA, Z = Ig(sA, QA, -997805, -1) + V | 0, O = w, O = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (V = I >> 21) + O | 0, V = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, o[A + 9 | 0] = (511 & V) << 23 | I >>> 9, o[A + 8 | 0] = (1 & V) << 31 | I >>> 1, O = 0, o[A + 7 | 0] = O << 18 | (2080768 & g) >>> 14 | I << 7, g = 2097151 & cA, O = Ig(sA, QA, 136657, 0) + g | 0, Z = w, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, g = (W = (2097151 & (g = V)) << 11 | I >>> 21) + O | 0, O = (V >>= 21) + Z | 0, O = g >>> 0 < W >>> 0 ? O + 1 | 0 : O, o[A + 12 | 0] = (4095 & O) << 20 | g >>> 12, o[A + 11 | 0] = (15 & O) << 28 | g >>> 4, V = 0, o[A + 10 | 0] = V << 15 | (1966080 & I) >>> 17 | g << 4, I = 2097151 & oA, Z = Ig(sA, QA, -683901, -1) + I | 0, V = w, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = O, O = V + (O >>= 21) | 0, O = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, o[A + 14 | 0] = (127 & O) << 25 | I >>> 7, V = 0, o[A + 13 | 0] = V << 12 | (1048576 & g) >>> 20 | I << 1, V = O >> 21, V = (g = (O = (2097151 & O) << 11 | I >>> 21) + (2097151 & gA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 17 | 0] = (1023 & V) << 22 | g >>> 10, o[A + 16 | 0] = (3 & V) << 30 | g >>> 2, O = 0, o[A + 15 | 0] = O << 17 | (2064384 & I) >>> 15 | g << 6, I = V, V >>= 21, Z = (I = (O = (2097151 & I) << 11 | g >>> 21) + (2097151 & AA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 20 | 0] = (8191 & Z) << 19 | I >>> 13, o[A + 19 | 0] = (31 & Z) << 27 | I >>> 5, O = Z >> 21, O = (V = (W = (2097151 & Z) << 11 | I >>> 21) + (2097151 & CA) | 0) >>> 0 < W >>> 0 ? O + 1 | 0 : O, W = V, o[A + 21 | 0] = V, V = 0, o[A + 18 | 0] = V << 14 | (1835008 & g) >>> 18 | I << 3, o[A + 22 | 0] = (255 & O) << 24 | W >>> 8, V = O >> 21, V = (I = (g = (2097151 & O) << 11 | W >>> 21) + (2097151 & T) | 0) >>> 0 < g >>> 0 ? V + 1 | 0 : V, o[A + 25 | 0] = (2047 & V) << 21 | I >>> 11, o[A + 24 | 0] = (7 & V) << 29 | I >>> 3, o[A + 23 | 0] = 31 & ((65535 & O) << 16 | W >>> 16) | I << 5, O = (2097151 & V) << 11 | I >>> 21, V >>= 21, V = (g = O + (2097151 & IA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 27 | 0] = (63 & V) << 26 | g >>> 6, O = 0, o[A + 26 | 0] = O << 13 | (1572864 & I) >>> 19 | g << 2, O = V >> 21, O = (I = (V = (2097151 & V) << 11 | g >>> 21) + (2097151 & $) | 0) >>> 0 < V >>> 0 ? O + 1 | 0 : O, o[A + 31 | 0] = (131071 & O) << 15 | I >>> 17, o[A + 30 | 0] = (511 & O) << 23 | I >>> 9, o[A + 29 | 0] = (1 & O) << 31 | I >>> 1, V = 0, o[A + 28 | 0] = V << 18 | (2080768 & g) >>> 14 | I << 7;
                                    }
                                    function F(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0; i = (B = _ << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, G = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, t = (o = 16711680 & Q) << 24, o = o >>> 8 | 0, B = (e = -16777216 & Q) >>> 24 | 0, E[i >> 2] = t | e << 8 | -16777216 & ((255 & G) << 24 | Q >>> 8) | 16711680 & ((16777215 & G) << 8 | Q >>> 24) | G >>> 8 & 65280 | G >>> 24, Q = B | o | c, B = 0, E[i + 4 >> 2] = Q | B | B, 16 != (0 | (_ = _ + 1 | 0)););
                                        for(I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I, I = E[A + 60 >> 2], E[C + 56 >> 2] = E[A + 56 >> 2], E[C + 60 >> 2] = I, I = E[A + 52 >> 2], E[C + 48 >> 2] = E[A + 48 >> 2], E[C + 52 >> 2] = I, I = E[A + 44 >> 2], E[C + 40 >> 2] = E[A + 40 >> 2], E[C + 44 >> 2] = I, I = E[A + 36 >> 2], E[C + 32 >> 2] = E[A + 32 >> 2], E[C + 36 >> 2] = I, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I; i = E[C + 56 >> 2], o = E[C + 60 >> 2], B = E[(I = G = (M = P << 3) + g | 0) >> 2], I = E[I + 4 >> 2], k = Q = E[C + 36 >> 2], Q = KI(p = E[C + 32 >> 2], Q, 50), _ = w, Q = KI(p, k, 46) ^ Q, _ ^= w, Q = KI(p, k, 23) ^ Q, I = (w ^ _) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (_ = E[(Q = M + 34816 | 0) >> 2]) + B | 0, I = E[Q + 4 >> 2] + I | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = ((t = E[C + 48 >> 2]) ^ (y = E[C + 40 >> 2])) & p ^ t) + B | 0, B = (((f = E[C + 52 >> 2]) ^ (F = E[C + 44 >> 2])) & k ^ f) + I | 0, I = (Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + o | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _ = (Q = E[C + 24 >> 2]) + i | 0, B = E[C + 28 >> 2] + I | 0, s = B = Q >>> 0 > _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, n = B = E[C + 4 >> 2], B = KI(Q = E[C >> 2], B, 36), o = w, B = KI(Q, n, 30) ^ B, o ^= w, e = i + (KI(Q, n, 25) ^ B) | 0, B = I + (w ^ o) | 0, B = i >>> 0 > e >>> 0 ? B + 1 | 0 : B, c = (I = e) + (e = Q & ((o = E[C + 16 >> 2]) | (i = E[C + 8 >> 2])) | i & o) | 0, I = (I = B) + (n & ((B = E[C + 20 >> 2]) | (h = E[C + 12 >> 2])) | B & h) | 0, e = I = c >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = c, E[C + 60 >> 2] = I, r = o, D = B, S = E[(I = m = (N = 8 | M) + g | 0) >> 2], K = E[I + 4 >> 2], B = ((k ^ F) & s ^ F) + f | 0, B = (I = (o = (y ^ p) & _ ^ y) + t | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = KI(_, s, 50), t = w, o = KI(_, s, 46) ^ o, t ^= w, o = (f = KI(_, s, 23) ^ o) + I | 0, I = (w ^ t) + B | 0, I = (o >>> 0 < f >>> 0 ? I + 1 | 0 : I) + K | 0, I = (B = o + S | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (o = B) + (t = E[(B = N + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (I = o >>> 0 < t >>> 0 ? B + 1 | 0 : B) + D | 0, f = B = (t = o + r | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + ((h | n) & e | h & n) | 0, I = (B = o + ((Q | i) & c | Q & i) | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(c, e, 36), r = w, o = KI(c, e, 30) ^ o, r ^= w, D = B, B = KI(c, e, 25) ^ o, I = (w ^ r) + I | 0, r = I = B >>> 0 > (o = D + B | 0) >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = o, E[C + 52 >> 2] = I, D = i, N = h, I = (h = E[(B = d = (i = 16 | M) + g | 0) >> 2]) + y | 0, B = E[B + 4 >> 2] + F | 0, B = I >>> 0 < h >>> 0 ? B + 1 | 0 : B, i = (y = I) + (h = E[(I = i + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = ((s ^ k) & f ^ k) + (I = i >>> 0 < h >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (_ ^ p) & t ^ p) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = KI(t, f, 50), h = w, i = KI(t, f, 46) ^ i, h ^= w, i = (y = KI(t, f, 23) ^ i) + B | 0, B = (w ^ h) + I | 0, B = (y = i >>> 0 < y >>> 0 ? B + 1 | 0 : B) + N | 0, N = B = (h = i) >>> 0 > (i = i + D | 0) >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = i, E[C + 12 >> 2] = B, I = KI(o, r, 36), B = w, I = KI(o, r, 30) ^ I, B ^= w, F = KI(o, r, 25) ^ I, I = ((e | n) & r | e & n) + (w ^ B) | 0, B = y + ((D = F + ((Q | c) & o | Q & c) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) | 0, h = B = (y = h + D | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = y, E[C + 44 >> 2] = B, D = Q, B = (B = p) + (p = E[(I = u = (Q = 24 | M) + g | 0) >> 2]) | 0, I = E[I + 4 >> 2] + k | 0, I = B >>> 0 < p >>> 0 ? I + 1 | 0 : I, Q = (F = B) + (p = E[(B = Q + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (s ^ (s ^ f) & N) + (B = Q >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = _ ^ (_ ^ t) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(i, N, 50), p = w, Q = KI(i, N, 46) ^ Q, p ^= w, Q = (k = KI(i, N, 23) ^ Q) + I | 0, I = (w ^ p) + B | 0, B = (I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) + n | 0, k = B = (n = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C >> 2] = n, E[C + 4 >> 2] = B, B = KI(y, h, 36), p = w, B = KI(y, h, 30) ^ B, D = w ^ p, F = KI(y, h, 25) ^ B, B = ((e | r) & h | e & r) + (w ^ D) | 0, I = I + ((p = F + ((o | c) & y | o & c) | 0) >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, p = I = (D = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = D, E[C + 36 >> 2] = I, Q = E[(B = l = (I = 32 | M) + g | 0) >> 2], B = s + E[B + 4 >> 2] | 0, B = (Q = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, Q = (_ = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (f ^ (f ^ N) & k) + (I = Q >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (i ^ t) & n) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(n, k, 50), _ = w, Q = KI(n, k, 46) ^ Q, _ ^= w, Q = (s = KI(n, k, 23) ^ Q) + B | 0, B = (w ^ _) + I | 0, F = B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B, I = B, B = KI(D, p, 36), _ = w, B = KI(D, p, 30) ^ B, s = w ^ _, S = KI(D, p, 25) ^ B, B = ((r | h) & p | r & h) + (w ^ s) | 0, I = ((_ = S + ((o | y) & D | o & y) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, _ = I = (s = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[C + 24 >> 2] = s, E[C + 28 >> 2] = I, B = e + F | 0, F = B = (e = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = e, E[C + 60 >> 2] = B, Q = E[(I = J = (B = 40 | M) + g | 0) >> 2], I = f + E[I + 4 >> 2] | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, Q = (c = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ n) & e) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(e, F, 50), c = w, Q = KI(e, F, 46) ^ Q, c ^= w, Q = (t = KI(e, F, 23) ^ Q) + I | 0, I = (w ^ c) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = KI(s, _, 36), c = w, B = KI(s, _, 30) ^ B, t = w ^ c, f = KI(s, _, 25) ^ B, B = ((h | p) & _ | h & p) + (w ^ t) | 0, B = ((c = f + ((y | D) & s | y & D) | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (t = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + r | 0, S = I = (r = Q + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = r, E[C + 52 >> 2] = I, Q = E[(B = Y = (I = 48 | M) + g | 0) >> 2], B = N + E[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = n ^ (e ^ n) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(r, S, 50), i = w, Q = KI(r, S, 46) ^ Q, i ^= w, Q = (o = KI(r, S, 23) ^ Q) + B | 0, B = (w ^ i) + I | 0, o = B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = B, B = KI(t, c, 36), i = w, B = KI(t, c, 30) ^ B, f = w ^ i, N = KI(t, c, 25) ^ B, B = ((_ | p) & c | _ & p) + (w ^ f) | 0, I = ((i = N + ((s | D) & t | s & D) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, E[C + 8 >> 2] = i, E[C + 12 >> 2] = I, B = o + h | 0, N = B = (K = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = K, E[C + 44 >> 2] = B, Q = E[(I = U = (B = 56 | M) + g | 0) >> 2], I = k + E[I + 4 >> 2] | 0, I = (Q = Q + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, Q = (o = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (F ^ (F ^ S) & N) + (B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = e ^ (e ^ r) & K) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(K, N, 50), o = w, Q = KI(K, N, 46) ^ Q, o ^= w, Q = (h = KI(K, N, 23) ^ Q) + I | 0, I = (w ^ o) + B | 0, I = Q >>> 0 < h >>> 0 ? I + 1 | 0 : I, B = KI(i, f, 36), o = w, B = KI(i, f, 30) ^ B, h = w ^ o, y = KI(i, f, 25) ^ B, B = ((_ | c) & f | _ & c) + (w ^ h) | 0, B = ((o = y + ((t | s) & i | t & s) | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) + I | 0, h = B = (h = o) >>> 0 > (o = Q + o | 0) >>> 0 ? B + 1 | 0 : B, E[C >> 2] = o, E[C + 4 >> 2] = B, I = I + p | 0, k = I = (y = Q + D | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = y, E[C + 36 >> 2] = I, Q = E[(B = x = (I = 64 | M) + g | 0) >> 2], B = F + E[B + 4 >> 2] | 0, B = (Q = Q + e | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (e = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (S ^ (N ^ S) & k) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ K) & y) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(y, k, 50), e = w, Q = KI(y, k, 46) ^ Q, e ^= w, Q = (n = KI(y, k, 23) ^ Q) + B | 0, B = (w ^ e) + I | 0, p = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = KI(o, h, 36), e = w, B = KI(o, h, 30) ^ B, n = w ^ e, D = KI(o, h, 25) ^ B, B = ((c | f) & h | c & f) + (w ^ n) | 0, I = ((e = D + ((i | t) & o | i & t) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = n, E[C + 60 >> 2] = I, B = _ + p | 0, F = B = (_ = Q + s | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, Q = E[(I = H = (B = 72 | M) + g | 0) >> 2], I = S + E[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = K ^ (y ^ K) & _) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(_, F, 50), r = w, Q = KI(_, F, 46) ^ Q, r ^= w, Q = (p = KI(_, F, 23) ^ Q) + I | 0, I = (w ^ r) + B | 0, I = Q >>> 0 < p >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 36), r = w, B = KI(n, e, 30) ^ B, p = w ^ r, D = KI(n, e, 25) ^ B, B = ((h | f) & e | h & f) + (w ^ p) | 0, B = ((r = D + ((i | o) & n | i & o) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (p = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, E[C + 48 >> 2] = p, E[C + 52 >> 2] = B, I = I + c | 0, S = I = (c = Q + t | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = c, E[C + 20 >> 2] = I, I = (I = K) + (t = E[(B = K = (Q = 80 | M) + g | 0) >> 2]) | 0, B = E[B + 4 >> 2] + N | 0, B = I >>> 0 < t >>> 0 ? B + 1 | 0 : B, Q = (s = I) + (t = E[(I = Q + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = y ^ (_ ^ y) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(c, S, 50), t = w, Q = KI(c, S, 46) ^ Q, t ^= w, Q = (D = KI(c, S, 23) ^ Q) + B | 0, B = (w ^ t) + I | 0, s = B = Q >>> 0 < D >>> 0 ? B + 1 | 0 : B, I = B, B = KI(p, r, 36), t = w, B = KI(p, r, 30) ^ B, D = w ^ t, N = KI(p, r, 25) ^ B, B = ((e | h) & r | e & h) + (w ^ D) | 0, I = ((t = N + ((o | n) & p | o & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, t = I = (D = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C + 40 >> 2] = D, E[C + 44 >> 2] = I, B = s + f | 0, f = B = (s = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = s, E[C + 12 >> 2] = B, B = 34816 + (I = 88 | M) | 0, i = E[(I = b = I + g | 0) >> 2], Q = E[B >> 2] + i | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = k + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (F ^ (F ^ S) & f) + (B = (I = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = _ ^ (_ ^ c) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(s, f, 50), i = w, Q = KI(s, f, 46) ^ Q, i ^= w, Q = (y = KI(s, f, 23) ^ Q) + I | 0, I = (w ^ i) + B | 0, I = Q >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = KI(D, t, 36), i = w, B = KI(D, t, 30) ^ B, y = w ^ i, N = KI(D, t, 25) ^ B, B = ((e | r) & t | e & r) + (w ^ y) | 0, B = ((i = N + ((p | n) & D | p & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, y = B = (y = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, I = I + h | 0, h = I = (B = o) >>> 0 > (o = Q + o | 0) >>> 0 ? I + 1 | 0 : I, E[C >> 2] = o, E[C + 4 >> 2] = I, B = 34816 + (I = 96 | M) | 0, N = E[(I = R = I + g | 0) >> 2], Q = E[B >> 2] + N | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = F + (Q >>> 0 < N >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = c ^ (c ^ s) & o) + B | 0, B = (S ^ (f ^ S) & h) + I | 0, B = Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B, I = KI(o, h, 50), _ = w, I = KI(o, h, 46) ^ I, _ ^= w, F = Q, Q = KI(o, h, 23) ^ I, B = (w ^ _) + B | 0, k = B = (I = F + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = KI(i, y, 36), _ = w, I = KI(i, y, 30) ^ I, N = w ^ _, F = KI(i, y, 25) ^ I, I = ((t | r) & y | t & r) + (w ^ N) | 0, B = ((_ = F + ((p | D) & i | p & D) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) + B | 0, _ = B = (N = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = N, E[C + 28 >> 2] = B, B = e + k | 0, e = B = (n = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = n, E[C + 60 >> 2] = B, B = 34816 + (I = 104 | M) | 0, k = E[(I = L = I + g | 0) >> 2], Q = E[B >> 2] + k | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = S + (Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = s ^ (o ^ s) & n) + I | 0, I = (f ^ (h ^ f) & e) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 50), c = w, B = KI(n, e, 46) ^ B, c ^= w, k = KI(n, e, 23) ^ B, B = (w ^ c) + I | 0, F = B = (Q = k + Q | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, I = B, B = KI(N, _, 36), c = w, B = KI(N, _, 30) ^ B, k = w ^ c, S = KI(N, _, 25) ^ B, B = ((t | y) & _ | t & y) + (w ^ k) | 0, I = ((c = S + ((i | D) & N | i & D) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (k = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = k, E[C + 20 >> 2] = I, I = r + F | 0, r = I = (p = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = p, E[C + 52 >> 2] = I, B = 34816 + (I = 112 | M) | 0, F = E[(Q = S = I + g | 0) >> 2], I = E[B >> 2] + F | 0, B = E[B + 4 >> 2] + E[Q + 4 >> 2] | 0, B = f + (I >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, B = (h ^ (e ^ h) & r) + (B = (I = I + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = o ^ (o ^ n) & p) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(p, r, 50), s = w, Q = KI(p, r, 46) ^ Q, s ^= w, Q = (f = KI(p, r, 23) ^ Q) + I | 0, I = (w ^ s) + B | 0, F = I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I, B = I, I = KI(k, c, 36), s = w, I = KI(k, c, 30) ^ I, f = w ^ s, v = KI(k, c, 25) ^ I, I = ((_ | y) & c | _ & y) + (w ^ f) | 0, B = ((s = v + ((i | N) & k | i & N) | 0) >>> 0 < v >>> 0 ? I + 1 | 0 : I) + B | 0, s = B = (f = Q + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = f, E[C + 12 >> 2] = B, B = t + F | 0, Q = B = (t = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = t, E[C + 44 >> 2] = B, B = 34816 + (I = 120 | M) | 0, M = E[(I = D = I + g | 0) >> 2], F = E[B >> 2] + M | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = h + (F >>> 0 < M >>> 0 ? B + 1 | 0 : B) | 0, I = (e ^ (e ^ r) & Q) + (I = (B = o + F | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (o = n ^ (p ^ n) & t) + B | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(t, Q, 50), e = w, o = KI(t, Q, 46) ^ o, e ^= w, Q = (o = KI(t, Q, 23) ^ o) + B | 0, B = (w ^ e) + I | 0, B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Q, e = B, I = B, B = KI(f, s, 36), t = w, B = KI(f, s, 30) ^ B, r = w ^ t, h = KI(f, s, 25) ^ B, B = ((_ | c) & s | _ & c) + (w ^ r) | 0, I = ((t = h + ((k | N) & f | k & N) | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C >> 2] = Q, E[C + 4 >> 2] = I, B = e + y | 0, B = (r = i) >>> 0 > (i = i + o | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, 64 != (0 | P);)c = ((P = P + 16 | 0) << 3) + g | 0, o = E[G >> 2], _ = E[G + 4 >> 2], v = E[H >> 2], e = I = E[H + 4 >> 2], B = I, Q = I = E[S + 4 >> 2], I = KI(N = E[S >> 2], I, 45), i = w, r = ((63 & Q) << 26 | N >>> 6) ^ (I = KI(N, Q, 3) ^ I), I = (Q >>> 6 ^ (t = w ^ i)) + B | 0, B = ((i = r + v | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + _ | 0, B = (I = i + o | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o = i = E[m + 4 >> 2], i = KI(_ = E[m >> 2], i, 63), t = w, i = ((127 & o) << 25 | _ >>> 7) ^ KI(_, o, 56) ^ i, B = (w ^ t ^ o >>> 7) + B | 0, i = B = i >>> 0 > (k = i + I | 0) >>> 0 ? B + 1 | 0 : B, E[c >> 2] = k, E[c + 4 >> 2] = B, _ = (S = E[K >> 2]) + _ | 0, I = (c = E[K + 4 >> 2]) + o | 0, B = _ >>> 0 < S >>> 0 ? I + 1 | 0 : I, o = I = E[D + 4 >> 2], I = KI(F = E[D >> 2], I, 45), t = w, r = _, _ = ((63 & o) << 26 | F >>> 6) ^ KI(F, o, 3) ^ I, B = (w ^ t ^ o >>> 6) + B | 0, _ = _ >>> 0 > (r = r + _ | 0) >>> 0 ? B + 1 | 0 : B, B = KI(t = E[d >> 2], I = E[d + 4 >> 2], 63), h = w, s = r, r = ((127 & I) << 25 | t >>> 7) ^ KI(t, I, 56) ^ B, B = (w ^ h ^ I >>> 7) + _ | 0, _ = B = r >>> 0 > (f = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 136 >> 2] = f, E[G + 140 >> 2] = B, B = (K = E[b >> 2]) + t | 0, I = (t = E[b + 4 >> 2]) + I | 0, r = KI(k, i, 45), h = w, r = (y = ((63 & i) << 26 | k >>> 6) ^ KI(k, i, 3) ^ r) + B | 0, B = (w ^ h ^ i >>> 6) + (B >>> 0 < K >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < y >>> 0 ? B + 1 | 0 : B, h = I = E[u + 4 >> 2], I = KI(y = E[u >> 2], I, 63), n = w, s = r, r = ((127 & h) << 25 | y >>> 7) ^ KI(y, h, 56) ^ I, B = (w ^ n ^ h >>> 7) + B | 0, r = B = r >>> 0 > (M = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 144 >> 2] = M, E[G + 148 >> 2] = B, y = (m = E[R >> 2]) + y | 0, I = (I = h) + (h = E[R + 4 >> 2]) | 0, B = y >>> 0 < m >>> 0 ? I + 1 | 0 : I, I = KI(f, _, 45), n = w, p = ((63 & _) << 26 | f >>> 6) ^ KI(f, _, 3) ^ I, B = (w ^ n ^ _ >>> 6) + B | 0, B = (y = p + y | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, n = I = E[l + 4 >> 2], I = KI(p = E[l >> 2], I, 63), D = w, s = y, y = ((127 & n) << 25 | p >>> 7) ^ KI(p, n, 56) ^ I, B = (w ^ D ^ n >>> 7) + B | 0, y = B = y >>> 0 > (d = s + y | 0) >>> 0 ? B + 1 | 0 : B, E[G + 152 >> 2] = d, E[G + 156 >> 2] = B, I = (u = E[L >> 2]) + p | 0, B = (B = n) + (n = E[L + 4 >> 2]) | 0, p = KI(M, r, 45), D = w, p = ((63 & r) << 26 | M >>> 6) ^ KI(M, r, 3) ^ p, B = (w ^ D ^ r >>> 6) + (I >>> 0 < u >>> 0 ? B + 1 | 0 : B) | 0, p = (s = p + I | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, B = KI(D = E[J >> 2], I = E[J + 4 >> 2], 63), l = w, b = s, s = ((127 & I) << 25 | D >>> 7) ^ (B = KI(D, I, 56) ^ B), B = (I >>> 7 ^ (J = w ^ l)) + p | 0, p = B = s >>> 0 > (l = b + s | 0) >>> 0 ? B + 1 | 0 : B, E[G + 160 >> 2] = l, E[G + 164 >> 2] = B, I = I + Q | 0, I = (B = D + N | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, D = KI(d, y, 45), s = w, D = (J = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ D) + B | 0, B = (w ^ s ^ y >>> 6) + I | 0, B = D >>> 0 < J >>> 0 ? B + 1 | 0 : B, s = E[Y >> 2], Y = I = E[Y + 4 >> 2], I = KI(s, I, 63), J = w, I = KI(s, Y, 56) ^ I, b = D, B = (Y >>> 7 ^ (H = w ^ J)) + B | 0, D = B = (D = ((127 & Y) << 25 | s >>> 7) ^ I) >>> 0 > (J = b + D | 0) >>> 0 ? B + 1 | 0 : B, E[G + 168 >> 2] = J, E[G + 172 >> 2] = B, I = o + Y | 0, I = (B = s + F | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, b = s = E[U + 4 >> 2], s = KI(H = E[U >> 2], s, 63), Y = w, s = (U = ((127 & b) << 25 | H >>> 7) ^ KI(H, b, 56) ^ s) + B | 0, B = (w ^ Y ^ b >>> 7) + I | 0, I = s >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = KI(l, p, 45), Y = w, B = KI(l, p, 3) ^ B, U = w ^ Y, Y = s, I = (p >>> 6 ^ U) + I | 0, s = I = (s = ((63 & p) << 26 | l >>> 6) ^ B) >>> 0 > (Y = Y + s | 0) >>> 0 ? I + 1 | 0 : I, E[G + 176 >> 2] = Y, E[G + 180 >> 2] = I, R = E[x >> 2], x = I = E[x + 4 >> 2], U = I, I = KI(v, e, 63), B = w, L = ((127 & e) << 25 | v >>> 7) ^ KI(v, e, 56) ^ I, I = (w ^ B ^ e >>> 7) + _ | 0, B = ((f = L + f | 0) >>> 0 < L >>> 0 ? I + 1 | 0 : I) + U | 0, B = (I = f + R | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, _ = KI(Y, s, 45), f = w, U = (_ = ((63 & s) << 26 | Y >>> 6) ^ KI(Y, s, 3) ^ _) + I | 0, I = (w ^ f ^ s >>> 6) + B | 0, _ = I = _ >>> 0 > U >>> 0 ? I + 1 | 0 : I, E[G + 192 >> 2] = U, E[G + 196 >> 2] = I, B = i + b | 0, B = (I = k + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, f = KI(R, x, 63), H = w, b = ((127 & x) << 25 | R >>> 7) ^ KI(R, x, 56) ^ f, B = (w ^ H ^ x >>> 7) + B | 0, I = (f = b + I | 0) >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = KI(J, D, 45), H = w, B = KI(J, D, 3) ^ B, x = f, I = (D >>> 6 ^ (b = w ^ H)) + I | 0, f = I = (f = ((63 & D) << 26 | J >>> 6) ^ B) >>> 0 > (H = x + f | 0) >>> 0 ? I + 1 | 0 : I, E[G + 184 >> 2] = H, E[G + 188 >> 2] = I, I = KI(K, t, 63), B = w, I = ((127 & t) << 25 | K >>> 7) ^ KI(K, t, 56) ^ I, B = (w ^ B ^ t >>> 7) + c | 0, I = y + (I >>> 0 > (b = I + S | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + b | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, y = KI(U, _, 45), d = w, y = KI(U, _, 3) ^ y, b = w ^ d, d = (y ^= (63 & _) << 26 | U >>> 6) + B | 0, B = (_ >>> 6 ^ b) + I | 0, y = B = y >>> 0 > d >>> 0 ? B + 1 | 0 : B, E[G + 208 >> 2] = d, E[G + 212 >> 2] = B, I = KI(S, c, 63), B = w, b = KI(S, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ w ^ B) + e | 0, I = r + ((c = (S = b ^ ((127 & c) << 25 | S >>> 7)) + v | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + M | 0) >>> 0 < M >>> 0 ? I + 1 | 0 : I, e = KI(H, f, 45), c = w, r = (e = ((63 & f) << 26 | H >>> 6) ^ KI(H, f, 3) ^ e) + B | 0, B = (w ^ c ^ f >>> 6) + I | 0, e = B = e >>> 0 > r >>> 0 ? B + 1 | 0 : B, E[G + 200 >> 2] = r, E[G + 204 >> 2] = B, I = KI(u, n, 63), B = w, S = ((127 & n) << 25 | u >>> 7) ^ KI(u, n, 56) ^ I, I = (w ^ B ^ n >>> 7) + h | 0, B = D + ((c = S + m | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + J | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, c = KI(d, y, 45), D = w, S = I, I = y >>> 6 | 0, c = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ c, B = (I ^ w ^ D) + B | 0, c = B = c >>> 0 > (y = S + c | 0) >>> 0 ? B + 1 | 0 : B, E[G + 224 >> 2] = y, E[G + 228 >> 2] = B, I = KI(m, h, 63), B = w, I = KI(m, h, 56) ^ I, D = w ^ B, S = ((127 & h) << 25 | m >>> 7) ^ I, I = ((B = h >>> 7 | 0) ^ D) + t | 0, B = p + ((h = S + K | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = h + l | 0) >>> 0 < l >>> 0 ? B + 1 | 0 : B, t = KI(r, e, 45), h = w, D = I, I = e >>> 6 | 0, e = ((63 & e) << 26 | r >>> 6) ^ KI(r, e, 3) ^ t, I = (I ^ w ^ h) + B | 0, e = I = (t = D + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[G + 216 >> 2] = t, E[G + 220 >> 2] = I, I = KI(F, o, 63), B = w, h = ((127 & o) << 25 | F >>> 7) ^ KI(F, o, 56) ^ I, B = (w ^ B ^ o >>> 7) + Q | 0, B = f + ((I = h + N | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, B = KI(y, c, 45), h = w, D = r, r = KI(y, c, 3) ^ B, B = c >>> 6 | 0, c = D + (r ^= (63 & c) << 26 | y >>> 6) | 0, I = (B ^ w ^ h) + I | 0, E[G + 240 >> 2] = c, E[G + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = KI(N, Q, 63), B = w, I = KI(N, Q, 56) ^ I, c = w ^ B, B = ((B = Q >>> 7 | 0) ^ c) + n | 0, I = s + ((I ^= (127 & Q) << 25 | N >>> 7) >>> 0 > (Q = I + u | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = KI(t, e, 45), c = w, r = B, B = e >>> 6 | 0, Q = ((63 & e) << 26 | t >>> 6) ^ KI(t, e, 3) ^ Q, B = (B ^ w ^ c) + I | 0, Q = B = Q >>> 0 > (e = r + Q | 0) >>> 0 ? B + 1 | 0 : B, E[G + 232 >> 2] = e, E[G + 236 >> 2] = B, I = KI(k, i, 63), B = w, r = KI(k, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ w ^ B) + o | 0, I = _ + ((i = (c = r ^ ((127 & i) << 25 | k >>> 7)) + F | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + U | 0) >>> 0 < U >>> 0 ? I + 1 | 0 : I, i = KI(e, Q, 45), o = w, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | e >>> 6) ^ KI(e, Q, 3) ^ i) | 0, B = (B ^ w ^ o) + I | 0, E[G + 248 >> 2] = Q, E[G + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + E[A + 4 >> 2] | 0, I = (g = Q + E[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[A >> 2] = g, E[A + 4 >> 2] = I, B = E[A + 12 >> 2] + E[C + 12 >> 2] | 0, I = (g = E[C + 8 >> 2]) + E[A + 8 >> 2] | 0, E[A + 8 >> 2] = I, E[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 20 >> 2] + E[C + 20 >> 2] | 0, I = (g = E[C + 16 >> 2]) + E[A + 16 >> 2] | 0, E[A + 16 >> 2] = I, E[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 28 >> 2] + E[C + 28 >> 2] | 0, g = (B = E[C + 24 >> 2]) + E[A + 24 >> 2] | 0, E[A + 24 >> 2] = g, E[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 36 >> 2] + E[C + 36 >> 2] | 0, I = (g = E[C + 32 >> 2]) + E[A + 32 >> 2] | 0, E[A + 32 >> 2] = I, E[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 44 >> 2] + E[C + 44 >> 2] | 0, g = (B = E[C + 40 >> 2]) + E[A + 40 >> 2] | 0, E[A + 40 >> 2] = g, E[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 52 >> 2] + E[C + 52 >> 2] | 0, I = (g = E[C + 48 >> 2]) + E[A + 48 >> 2] | 0, E[A + 48 >> 2] = I, E[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 60 >> 2] + E[C + 60 >> 2] | 0, I = (g = E[C + 56 >> 2]) + E[A + 56 >> 2] | 0, E[A + 56 >> 2] = I, E[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function N(A) {
                                        var I, g, C, B, Q, i, E, _, c, t, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        s = (N = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, y = Ig(U = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), e = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = w, f = r = e >>> 0 > (n = y + e | 0) >>> 0 ? r + 1 | 0 : r, b = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, y = r >> 21, r = (e = s) + (s = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21) | 0, e = y, P = e = r >>> 0 < s >>> 0 ? e + 1 | 0 : e, q = r, Y = Ig(r, e, -683901, -1), k = w, p = Ig(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), y = (r = a[A + 27 | 0]) >>> 24 | 0, s = r << 8 | (S = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, e = (r = a[A + 28 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = s | r << 16) >>> 2), r = w, r = e >>> 0 > (y = e + p | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(R = (G = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = w + r | 0, p = y = e + y | 0, y = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, h = (e = a[A + 48 | 0]) << 8 | N >>> 24, e = r = e >>> 24 | 0, r = Ig(g = 2097151 & ((3 & (N = (r = (s = a[A + 49 | 0]) >>> 16 | 0) | e)) << 30 | (e = (s <<= 16) | h) >>> 2), 0, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + p | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + e | 0, e = w + y | 0, p = s, y = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, e = (r = a[A + 56 | 0]) >>> 24 | 0, h = r << 8 | G >>> 24, e = Ig(B = 2097151 & ((1 & (G = (r = (s = a[A + 57 | 0]) >>> 16 | 0) | e)) << 31 | (e = (s <<= 16) | h) >>> 1), 0, 470296, 0), r = w + y | 0, e = (r = (y = s = e + p | 0) >>> 0 < e >>> 0 ? r + 1 | 0 : r) + k | 0, e = y >>> 0 > (s = y + Y | 0) >>> 0 ? e + 1 | 0 : e, K = y - -1048576 | 0, H = y = r - ((y >>> 0 < 4293918720) - 1 | 0) | 0, k = s - (r = -2097152 & K) | 0, Y = e - ((r >>> 0 > s >>> 0) + y | 0) | 0, e = Ig(I, 0, 654183, 0), r = w, r = e >>> 0 > (y = e + (S >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(R, 0, 470296, 0)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + s | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(B, X, 666643, 0)) | 0, r = w + e | 0, h = s, s = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, p = (y = Ig(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, y = w, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, p = (e = Ig(R, 0, 666643, 0)) + p | 0, r = w + y | 0, y = Ig(g, j, 654183, 0), e = w + (e >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = e = y >>> 0 > (S = y + p | 0) >>> 0 ? e + 1 | 0 : e, x = e = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >>> 21 | 0) + s | 0, y = r = (e = (2097151 & e) << 11 | (p = S - -1048576 | 0) >>> 21) >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, F = e = r - ((h >>> 0 < 4293918720) - 1 | 0) | 0, r = k, k = (2097151 & e) << 11 | (s = h - -1048576 | 0) >>> 21, e = (e >> 21) + Y | 0, N = k = (e = k >>> 0 > (M = r + k | 0) >>> 0 ? e + 1 | 0 : e) - ((M >>> 0 < 4293918720) - 1 | 0) | 0, v = M - (r = -2097152 & (Y = M - -1048576 | 0)) | 0, O = e - ((r >>> 0 > M >>> 0) + k | 0) | 0, r = Ig(q, P, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, J = e - (r = -2097152 & s) | 0, L = y - ((r >>> 0 > e >>> 0) + F | 0) | 0, M = n - (r = -2097152 & D) | 0, b = f - ((r >>> 0 > n >>> 0) + b | 0) | 0, f = Ig(U, 0, 136657, 0), e = (r = a[A + 40 | 0]) >>> 24 | 0, s = r << 8 | (D = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, y = (r = a[A + 41 | 0]) >>> 16 | 0, e = (y |= e) >>> 3 | 0, y = (7 & y) << 29 | (r = s | r << 16) >>> 3, r = e + w | 0, r = y >>> 0 > (s = y + f | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(C, 0, -683901, -1), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, h = y, e = Ig(U, 0, -997805, -1), y = w, y = e >>> 0 > (s = e + (D >>> 6 & 2097151) | 0) >>> 0 ? y + 1 | 0 : y, D = (e = s) + (s = Ig(C, 0, 136657, 0)) | 0, e = w + y | 0, y = Ig(B, X, -683901, -1), e = w + (s >>> 0 > D >>> 0 ? e + 1 | 0 : e) | 0, k = e = y >>> 0 > (l = y + D | 0) >>> 0 ? e + 1 | 0 : e, V = y = e - ((l >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >> 21) | 0, D = r = (y = (2097151 & y) << 11 | (n = l - -1048576 | 0) >>> 21) >>> 0 > (F = y + h | 0) >>> 0 ? r + 1 | 0 : r, m = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >> 21) + b | 0, z = e = (r = (y = (2097151 & r) << 11 | (h = F - -1048576 | 0) >>> 21) + M | 0) >>> 0 < y >>> 0 ? e + 1 | 0 : e, u = r, e = Ig(r, e, -683901, -1), r = w + L | 0, d = y = e + J | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, L = S - (r = -2097152 & p) | 0, b = G - ((4095 & x) + (r >>> 0 > S >>> 0) | 0) | 0, S = Ig(I, 0, 666643, 0), r = (e = a[A + 19 | 0]) >>> 24 | 0, p = e << 8 | (G = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, y = r, e = (7 & (y |= e = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (e = (r <<= 16) | p) >>> 3, y = w + (y >>> 3 | 0) | 0, y = e >>> 0 > (p = e + S | 0) >>> 0 ? y + 1 | 0 : y, r = Ig(g, j, 470296, 0), e = w + y | 0, r = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, y = Ig(g, j, 666643, 0), e = w, S = e = y >>> 0 > (J = y + (G >>> 6 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, Z = y = e - ((J >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >>> 21 | 0) | 0, G = r = (y = (2097151 & y) << 11 | (f = J - -1048576 | 0) >>> 21) >>> 0 > (M = y + p | 0) >>> 0 ? r + 1 | 0 : r, W = r = r - ((M >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >>> 21 | 0) + b | 0, e = (r = (2097151 & r) << 11 | (p = M - -1048576 | 0) >>> 21) >>> 0 > (y = r + L | 0) >>> 0 ? e + 1 | 0 : e, b = (r = y) + (y = Ig(q, P, -997805, -1)) | 0, r = w + e | 0, r = y >>> 0 > b >>> 0 ? r + 1 | 0 : r, x = e = F - (y = -2097152 & h) | 0, Q = h = D - ((y >>> 0 > F >>> 0) + m | 0) | 0, y = Ig(u, z, 136657, 0), r = w + r | 0, r = y >>> 0 > (D = y + b | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(e, h, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (b = y + D | 0) >>> 0 ? e + 1 | 0 : e, m = r = e - ((b >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = b - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, d = e = (r = e >>> 0 > (F = e + d | 0) >>> 0 ? r + 1 | 0 : r) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, L = (2097151 & e) << 11 | (s = F - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, E = v = L + v | 0, L = v >>> 0 < L >>> 0 ? e + 1 | 0 : e, _ = F - (e = -2097152 & s) | 0, c = r - ((e >>> 0 > F >>> 0) + d | 0) | 0, v = b - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > b >>> 0) + m | 0) | 0, y = (r = Ig(q, P, 654183, 0)) + (M - (e = -2097152 & p) | 0) | 0, e = w + (G - ((2147483647 & W) + (e >>> 0 > M >>> 0) | 0) | 0) | 0, e = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, r = Ig(u, z, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(x, Q, 136657, 0)) | 0, r = w + e | 0, d = s, D = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, M = l - (r = -2097152 & n) | 0, F = k - ((r >>> 0 > l >>> 0) + V | 0) | 0, G = Ig(R, 0, -683901, -1), r = (e = a[A + 35 | 0]) >>> 24 | 0, s = e << 8 | (p = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, y = r, e = (r = a[A + 36 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + G | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(U, 0, 654183, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, y = Ig(C, 0, -997805, -1), r = w + e | 0, r = y >>> 0 > (s = y + s | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 136657, 0), r = w + r | 0, h = y = e + s | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(I, 0, -683901, -1), e = w, e = r >>> 0 > (y = r + (p >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, p = (r = Ig(R, 0, 136657, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, r = Ig(U, 0, 470296, 0), e = w + y | 0, e = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, p = (y = Ig(C, 0, 654183, 0)) + p | 0, r = w + e | 0, e = Ig(B, X, -997805, -1), r = w + (y >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = r = e >>> 0 > (k = e + p | 0) >>> 0 ? r + 1 | 0 : r, t = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, y = (r = e >> 21) + s | 0, b = e = (y = (e = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21) >>> 0 > (n = e + h | 0) >>> 0 ? y + 1 | 0 : y) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >> 21) + F | 0, m = r = (e = (s = (2097151 & e) << 11 | (h = n - -1048576 | 0) >>> 21) + M | 0) >>> 0 < s >>> 0 ? r + 1 | 0 : r, s = d, d = e, r = Ig(e, r, -683901, -1), e = w + D | 0, F = s = s + r | 0, s = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, D = (r = Ig(q, P, 470296, 0)) + (J - (e = -2097152 & f) | 0) | 0, e = w + (S - ((2047 & Z) + (e >>> 0 > J >>> 0) | 0) | 0) | 0, e = r >>> 0 > D >>> 0 ? e + 1 | 0 : e, f = (r = D) + (D = Ig(u, z, 654183, 0)) | 0, r = w + e | 0, r = D >>> 0 > f >>> 0 ? r + 1 | 0 : r, D = Ig(x, Q, -997805, -1), e = w + r | 0, e = D >>> 0 > (f = D + f | 0) >>> 0 ? e + 1 | 0 : e, l = h = n - (r = -2097152 & h) | 0, i = D = y - ((r >>> 0 > n >>> 0) + b | 0) | 0, y = Ig(d, m, 136657, 0), r = w + e | 0, r = y >>> 0 > (f = y + f | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(h, D, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (S = y + f | 0) >>> 0 ? e + 1 | 0 : e, b = r = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = S - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, F = e = (r = e >>> 0 > (f = e + F | 0) >>> 0 ? r + 1 | 0 : r) - ((f >>> 0 < 4293918720) - 1 | 0) | 0, n = (2097151 & e) << 11 | (s = f - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, V = M = n + v | 0, M = n >>> 0 > M >>> 0 ? e + 1 | 0 : e, Z = f - (e = -2097152 & s) | 0, W = r - ((e >>> 0 > f >>> 0) + F | 0) | 0, v = S - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > S >>> 0) + b | 0) | 0, D = Ig(q, P, 666643, 0), r = (e = a[A + 14 | 0]) >>> 24 | 0, s = e << 8 | (b = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, y = r, e = (r = a[A + 15 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + D | 0) >>> 0 ? y + 1 | 0 : y, s = (r = e) + (e = Ig(u, z, 470296, 0)) | 0, r = w + y | 0, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, e = Ig(x, Q, 654183, 0), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(d, m, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 136657, 0), e = w + e | 0, S = y = r + s | 0, s = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, p = k - (r = -2097152 & p) | 0, D = G - ((r >>> 0 > k >>> 0) + t | 0) | 0, y = Ig(I, 0, 136657, 0), r = w, r = (e = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (y = e + y | 0) >>> 0 ? r + 1 | 0 : r, h = (e = y) + (y = Ig(R, 0, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -683901, -1), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = Ig(U, 0, 666643, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > h >>> 0 ? y + 1 | 0 : y, e = Ig(C, 0, 470296, 0), r = w + y | 0, r = e >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 654183, 0), r = w + r | 0, e = (H >> 21) + (e >>> 0 > (y = e + h | 0) >>> 0 ? r + 1 | 0 : r) | 0, n = e = (h = (2097151 & H) << 11 | K >>> 21) >>> 0 > (K = h + y | 0) >>> 0 ? e + 1 | 0 : e, F = r = e - ((K >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (f = K - -1048576 | 0) >>> 21, r = (r >> 21) + D | 0, J = r = (e = h + p | 0) >>> 0 < h >>> 0 ? r + 1 | 0 : r, H = e, e = Ig(e, r, -683901, -1), r = w + s | 0, h = y = e + S | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(u, z, 666643, 0), e = w, e = r >>> 0 > (y = r + (b >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(x, Q, 470296, 0), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, D = (r = Ig(d, m, 654183, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(l, i, -997805, -1), r = w + y | 0, r = e >>> 0 > (D = e + D | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(H, J, 136657, 0), r = w + r | 0, G = r = e >>> 0 > (k = e + D | 0) >>> 0 ? r + 1 | 0 : r, P = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, r = h, h = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21, e = (e >> 21) + s | 0, u = s = (e = (y = r + h | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e) - ((y >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = s >> 21) + O | 0, q = h = (s = (2097151 & s) << 11 | (D = y - -1048576 | 0) >>> 21) + v | 0, S = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, h = y, y = e, s = (K - (e = -2097152 & f) | 0) + (f = (2097151 & N) << 11 | Y >>> 21) | 0, e = (n - ((e >>> 0 > K >>> 0) + F | 0) | 0) + (N >> 21) | 0, b = e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, R = e = e - ((s >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = e >> 21, r = Ig(U = (2097151 & e) << 11 | (F = s - -1048576 | 0) >>> 21, r, -683901, -1), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, j = e - (r = -2097152 & D) | 0, X = y - ((r >>> 0 > e >>> 0) + u | 0) | 0, r = Ig(U, Y, 136657, 0), e = G + w | 0, z = (y = r + k | 0) - (r = -2097152 & p) | 0, u = (e = y >>> 0 < k >>> 0 ? e + 1 | 0 : e) - ((r >>> 0 > y >>> 0) + P | 0) | 0, e = Ig(x, Q, 666643, 0), y = w, y = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (e = r + e | 0) >>> 0 ? y + 1 | 0 : y, h = (r = Ig(d, m, 470296, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 654183, 0), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = y) + (y = Ig(H, J, -997805, -1)) | 0, r = w + e | 0, f = h, h = y >>> 0 > h >>> 0 ? r + 1 | 0 : r, G = Ig(d, m, 666643, 0), r = (e = a[A + 6 | 0]) >>> 24 | 0, D = e << 8 | (K = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, y = r, e = (r = a[A + 7 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = r << 16 | D) >>> 2), r = w, r = e >>> 0 > (y = e + G | 0) >>> 0 ? r + 1 | 0 : r, D = (e = Ig(l, i, 470296, 0)) + y | 0, y = w + r | 0, y = e >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(H, J, 654183, 0), r = w + y | 0, G = r = e >>> 0 > (n = e + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, e = (y = r >> 21) + h | 0, k = r = (e = (r = (2097151 & r) << 11 | (p = n - -1048576 | 0) >>> 21) >>> 0 > (D = r + f | 0) >>> 0 ? e + 1 | 0 : e) - ((D >>> 0 < 4293918720) - 1 | 0) | 0, f = (2097151 & r) << 11 | (h = D - -1048576 | 0) >>> 21, r = (r >> 21) + u | 0, u = d = f + z | 0, f = f >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + D | 0) >>> 0 ? e + 1 | 0 : e, x = y - (r = -2097152 & h) | 0, m = e - ((r >>> 0 > y >>> 0) + k | 0) | 0, e = Ig(U, Y, 654183, 0), r = G + w | 0, d = (y = e + n | 0) - (e = -2097152 & p) | 0, N = (r = y >>> 0 < n >>> 0 ? r + 1 | 0 : r) - ((e >>> 0 > y >>> 0) + N | 0) | 0, r = Ig(l, i, 666643, 0), e = w, e = r >>> 0 > (y = r + (K >>> 5 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(H, J, 470296, 0), e = w + e | 0, D = y = r + y | 0, y = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, h = Ig(H, J, 666643, 0), e = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = w, G = r = e >>> 0 > (k = h + e | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (p = k - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, y = r = h >>> 0 > (n = h + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21, r = (r >> 21) + N | 0, h = h >>> 0 > (N = H = h + d | 0) >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, 470296, 0), y = y + w | 0, y = (e = r + n | 0) >>> 0 < n >>> 0 ? y + 1 | 0 : y, n = e - (r = -2097152 & D) | 0, D = y - ((r >>> 0 > e >>> 0) + K | 0) | 0, e = Ig(U, Y, 666643, 0), r = w + (G - (((y = -2097152 & p) >>> 0 > k >>> 0) + J | 0) | 0) | 0, e = (y = (r = e >>> 0 > (H = e + (k - y | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + D | 0, r = (r = (e = (r = (2097151 & r) << 11 | H >>> 21) >>> 0 > (K = r + n | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + h | 0, e = (e = (r = (e = (2097151 & e) << 11 | K >>> 21) >>> 0 > (N = e + N | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + m | 0, y = (r = (e = (r = (2097151 & r) << 11 | N >>> 21) >>> 0 > (h = r + x | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + f | 0, r = (e = (y = (e = (2097151 & e) << 11 | h >>> 21) >>> 0 > (Y = e + u | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + X | 0, e = (y = (r = (y = (2097151 & y) << 11 | Y >>> 21) >>> 0 > (k = y + j | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + S | 0, r = (r = (e = (r = (2097151 & r) << 11 | k >>> 21) >>> 0 > (n = r + q | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + W | 0, e = (e = (r = (e = (2097151 & e) << 11 | n >>> 21) >>> 0 > (S = e + Z | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + M | 0, y = (r = (e = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (f = r + V | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + c | 0, r = (e = (y = (e = (2097151 & e) << 11 | f >>> 21) >>> 0 > (G = e + _ | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + L | 0, D = (F = s - (e = -2097152 & F) | 0) + ((2097151 & (r = (y = (2097151 & y) << 11 | G >>> 21) >>> 0 > (p = y + E | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | p >>> 21) | 0, r = (b - ((e >>> 0 > s >>> 0) + R | 0) | 0) + (r >> 21) | 0, F = e = (r = D >>> 0 < F >>> 0 ? r + 1 | 0 : r) >> 21, H = (r = Ig(M = (2097151 & r) << 11 | D >>> 21, e, 666643, 0)) + (e = 2097151 & H) | 0, r = w, s = r = e >>> 0 > H >>> 0 ? r + 1 | 0 : r, o[0 | A] = H, o[A + 1 | 0] = (255 & r) << 24 | H >>> 8, r = 2097151 & K, e = Ig(M, F, 470296, 0) + r | 0, y = w, r = (s >> 21) + (r >>> 0 > e >>> 0 ? y + 1 | 0 : y) | 0, r = (b = (2097151 & s) << 11 | H >>> 21) >>> 0 > (K = b + e | 0) >>> 0 ? r + 1 | 0 : r, o[A + 4 | 0] = (2047 & r) << 21 | K >>> 11, e = r, y = K, o[A + 3 | 0] = (7 & r) << 29 | y >>> 3, o[A + 2 | 0] = 31 & ((65535 & s) << 16 | H >>> 16) | y << 5, s = 2097151 & N, N = Ig(M, F, 654183, 0) + s | 0, r = w, K = (2097151 & e) << 11 | y >>> 21, e = (e >> 21) + (s = s >>> 0 > N >>> 0 ? r + 1 | 0 : r) | 0, r = e = (N = K + N | 0) >>> 0 < K >>> 0 ? e + 1 | 0 : e, o[A + 6 | 0] = (63 & r) << 26 | N >>> 6, s = N, N = 0, o[A + 5 | 0] = N << 13 | (1572864 & y) >>> 19 | s << 2, y = 2097151 & h, h = Ig(M, F, -997805, -1) + y | 0, e = w, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, N = (2097151 & (y = r)) << 11 | s >>> 21, y = (r >>= 21) + e | 0, y = (h = N + h | 0) >>> 0 < N >>> 0 ? y + 1 | 0 : y, o[A + 9 | 0] = (511 & y) << 23 | h >>> 9, o[A + 8 | 0] = (1 & y) << 31 | h >>> 1, e = 0, o[A + 7 | 0] = e << 18 | (2080768 & s) >>> 14 | h << 7, e = 2097151 & Y, s = Ig(M, F, 136657, 0) + e | 0, r = w, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (e = y)) << 11 | h >>> 21, e = r + (y = e >> 21) | 0, e = (s = Y + s | 0) >>> 0 < Y >>> 0 ? e + 1 | 0 : e, o[A + 12 | 0] = (4095 & e) << 20 | s >>> 12, y = s, o[A + 11 | 0] = (15 & e) << 28 | y >>> 4, s = 0, o[A + 10 | 0] = s << 15 | (1966080 & h) >>> 17 | y << 4, s = 2097151 & k, h = Ig(M, F, -683901, -1) + s | 0, r = w, r = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, s = e, e = r + (e >>= 21) | 0, e = (s = (d = h) + (h = (2097151 & s) << 11 | y >>> 21) | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e, o[A + 14 | 0] = (127 & e) << 25 | s >>> 7, h = 0, o[A + 13 | 0] = h << 12 | (1048576 & y) >>> 20 | s << 1, r = e >> 21, y = (e = (2097151 & e) << 11 | s >>> 21) >>> 0 > (h = e + (2097151 & n) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 17 | 0] = (1023 & y) << 22 | h >>> 10, o[A + 16 | 0] = (3 & y) << 30 | h >>> 2, e = 0, o[A + 15 | 0] = e << 17 | (2064384 & s) >>> 15 | h << 6, r = y >> 21, r = (e = (2097151 & y) << 11 | h >>> 21) >>> 0 > (y = e + (2097151 & S) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 20 | 0] = (8191 & r) << 19 | y >>> 13, o[A + 19 | 0] = (31 & r) << 27 | y >>> 5, s = (e = 2097151 & f) + (f = (2097151 & r) << 11 | y >>> 21) | 0, e = r >> 21, e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, f = s, o[A + 21 | 0] = s, S = 0, o[A + 18 | 0] = S << 14 | (1835008 & h) >>> 18 | y << 3, o[A + 22 | 0] = (255 & e) << 24 | s >>> 8, y = e >> 21, y = (s = (h = (2097151 & e) << 11 | s >>> 21) + (2097151 & G) | 0) >>> 0 < h >>> 0 ? y + 1 | 0 : y, o[A + 25 | 0] = (2047 & y) << 21 | s >>> 11, o[A + 24 | 0] = (7 & y) << 29 | s >>> 3, o[A + 23 | 0] = 31 & ((65535 & e) << 16 | f >>> 16) | s << 5, r = y >> 21, r = (e = (2097151 & y) << 11 | s >>> 21) >>> 0 > (y = e + (2097151 & p) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 27 | 0] = (63 & r) << 26 | y >>> 6, h = 0, o[A + 26 | 0] = h << 13 | (1572864 & s) >>> 19 | y << 2, e = r >> 21, e = (r = (s = (2097151 & r) << 11 | y >>> 21) + (2097151 & D) | 0) >>> 0 < s >>> 0 ? e + 1 | 0 : e, o[A + 31 | 0] = (131071 & e) << 15 | r >>> 17, o[A + 30 | 0] = (511 & e) << 23 | r >>> 9, o[A + 29 | 0] = (1 & e) << 31 | r >>> 1, s = 0, o[A + 28 | 0] = s << 18 | (2080768 & y) >>> 14 | r << 7;
                                    }
                                    function S(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0;
                                        if (h = g = h - 4096 | 0, A) {
                                            A: {
                                                I: {
                                                    if (2 == (0 | (_ = E[A + 36 >> 2]))) {
                                                        if (iA = E[A + 4 >> 2], (T = E[I >> 2]) | (X = a[I + 8 | 0]) >>> 0 >= 2) break I;
                                                        T = 0;
                                                    } else X = a[I + 8 | 0], iA = E[A + 4 >> 2], T = E[I >> 2];
                                                    if (Hg(g + 3072 | 0, 0, 1024), Hg(g + 2104 | 0, 0, 968), E[g + 2048 >> 2] = T, E[g + 2052 >> 2] = 0, u = E[I + 4 >> 2], E[g + 2064 >> 2] = X, E[g + 2068 >> 2] = 0, E[g + 2056 >> 2] = u, E[g + 2060 >> 2] = 0, E[g + 2072 >> 2] = E[A + 16 >> 2], E[g + 2076 >> 2] = 0, u = E[A + 8 >> 2], E[g + 2088 >> 2] = _, E[g + 2092 >> 2] = 0, E[g + 2080 >> 2] = u, E[g + 2084 >> 2] = 0, !E[A + 20 >> 2]) break A;
                                                    for(u = 0; (N = 127 & r) || (u = (P = P + 1 | 0) ? u : u + 1 | 0, E[g + 2096 >> 2] = P, E[g + 2100 >> 2] = u, _ = Hg(g, 0, 1024), Hg(_ + 1024 | 0, 0, 1024), G(C = _ + 3072 | 0, _ + 2048 | 0, _), G(C, _, _ + 1024 | 0)), N = E[4 + (_ = (g + 1024 | 0) + (N << 3) | 0) >> 2], E[(C = (r << 3) + iA | 0) >> 2] = E[_ >> 2], E[C + 4 >> 2] = N, (N = E[A + 20 >> 2]) >>> 0 > (r = r + 1 | 0) >>> 0;);
                                                    break A;
                                                }
                                                N = E[A + 20 >> 2], _A = 1;
                                            }
                                            if (!((u = (EA = !(X | T)) << 1) >>> 0 >= N >>> 0)) for(_ = E[A + 24 >> 2], QA = E[I + 4 >> 2], r = (P = (c(_, QA) + u | 0) + c(N, X) | 0) + ((P >>> 0) % (_ >>> 0) | 0 ? -1 : _ - 1 | 0) | 0, cA = X + 1 | 0;;){
                                                C = E[A + 28 >> 2], oA = 1 == ((P >>> 0) % ((_ = E[A + 24 >> 2]) >>> 0) | 0) ? P - 1 | 0 : r, r = _A ? E[E[A >> 2] + 4 >> 2] + (oA << 10) | 0 : (u << 3) + iA | 0, B = E[r >> 2], r = E[r + 4 >> 2], E[I + 12 >> 2] = u, C = EA ? QA : (r >>> 0) % (C >>> 0) | 0;
                                                A: if (T) r = _ + ((0 | C) == (0 | QA) ? (-1 ^ N) + u | 0 : (u ? 0 : -1) - N | 0) | 0, i = 0, 3 != (0 | X) && (i = c(N, cA));
                                                else {
                                                    if (!X) {
                                                        r = u - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    if (r = c(N, X), (0 | C) == (0 | QA)) {
                                                        r = (r + u | 0) - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    r = r - !u | 0, i = 0;
                                                }
                                                if (e = (N = E[E[A >> 2] + 4 >> 2]) + (c(C, _) << 10) | 0, i = (o = C = r - 1 | 0) >>> 0 > (C = C + i | 0) >>> 0, Ig(B, 0, B, 0), Ig(r, 0, w, 0), oI(C - (r = w) | 0, i - (C >>> 0 < r >>> 0) | 0, _), w = p, r = (D << 10) + e | 0, _ = N + (oA << 10) | 0, aA = N + (P << 10) | 0, T) G(_, r, aA);
                                                else {
                                                    for(Sg(g + 3072 | 0, r, 1024), r = 0; i = E[(B = (N = r << 3) + (C = g + 3072 | 0) | 0) >> 2], s = E[(e = _ + N | 0) >> 2], e = E[B + 4 >> 2] ^ E[e + 4 >> 2], E[B >> 2] = i ^ s, E[B + 4 >> 2] = e, e = E[(B = (i = 8 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, e = E[(B = (i = 16 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, i = E[(N = (B = 24 | N) + C | 0) >> 2], e = E[(B = B + _ | 0) >> 2], B = E[N + 4 >> 2] ^ E[B + 4 >> 2], E[N >> 2] = i ^ e, E[N + 4 >> 2] = B, 128 != (0 | (r = r + 4 | 0)););
                                                    for(Sg(g + 2048 | 0, C, 1024), N = 0, r = 0; e = (i = E[56 + (_ = (g + 3072 | 0) + (r << 7) | 0) >> 2]) + (B = E[_ + 24 >> 2]) | 0, s = (o = E[_ + 60 >> 2]) + (C = E[_ + 28 >> 2]) | 0, t = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), i, 0), B = w + (B >>> 0 > e >>> 0 ? s + 1 | 0 : s) | 0, e = (C = t + e | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = (s = KI(C ^ E[_ + 120 >> 2], e ^ E[_ + 124 >> 2], 32)) + (B = E[_ + 88 >> 2]) | 0, Q = (n = w) + (U = E[_ + 92 >> 2]) | 0, y = i, U = Ig(s, 0, B << 1 & -2, 1 & (U << 1 | B >>> 31)), B = w + (B >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) | 0, J = KI(y ^ (i = U + t | 0), o ^ (R = i >>> 0 < U >>> 0 ? B + 1 | 0 : B), 40), t = 1 + (B = e + (gA = w) | 0) | 0, o = B, t = (B = C + J | 0) >>> 0 < C >>> 0 ? t : o, U = (C = Ig(J, 0, C << 1 & -2, 1 & (e << 1 | C >>> 31))) + B | 0, B = w + t | 0, k = KI(U ^ s, n ^ (z = C >>> 0 > U >>> 0 ? B + 1 | 0 : B), 48), H = y = w, e = (f = E[_ + 44 >> 2]) + (C = E[_ + 12 >> 2]) | 0, t = (s = E[_ + 40 >> 2]) + (B = E[_ + 8 >> 2]) | 0, Q = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), s, 0), B = w + (B >>> 0 > t >>> 0 ? e + 1 | 0 : e) | 0, t = (C = t + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o = (Q = KI(C ^ E[_ + 104 >> 2], t ^ E[_ + 108 >> 2], 32)) + (e = E[_ + 72 >> 2]) | 0, n = (S = w) + (B = E[_ + 76 >> 2]) | 0, F = s, s = Ig(Q, 0, e << 1 & -2, 1 & (B << 1 | e >>> 31)), e = w + (e >>> 0 > o >>> 0 ? n + 1 | 0 : n) | 0, s = KI(F ^ (B = s + o | 0), f ^ (o = B >>> 0 < s >>> 0 ? e + 1 | 0 : e), 40), F = 1 + (e = t + (n = w) | 0) | 0, f = e, f = (e = C + s | 0) >>> 0 < C >>> 0 ? F : f, C = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31)), t = w + f | 0, f = KI((e = C + e | 0) ^ Q, S ^ (j = C >>> 0 > e >>> 0 ? t + 1 | 0 : t), 48), Q = 1 + (C = o + (CA = w) | 0) | 0, t = C, t = (C = B + f | 0) >>> 0 < B >>> 0 ? Q : t, Q = s, s = C, C = Ig(f, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31)), B = w + t | 0, S = KI(Q ^ (s = s + C | 0), n ^ (O = C >>> 0 > s >>> 0 ? B + 1 | 0 : B), 1), $ = M = w, t = (d = E[_ + 36 >> 2]) + (C = E[_ + 4 >> 2]) | 0, o = (Q = E[_ + 32 >> 2]) + (B = E[_ >> 2]) | 0, n = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), Q, 0), B = w + (B >>> 0 > o >>> 0 ? t + 1 | 0 : t) | 0, o = (C = o + n | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = (V = KI(C ^ E[_ + 96 >> 2], o ^ E[_ + 100 >> 2], 32)) + (B = E[(t = q = _ - -64 | 0) >> 2]) | 0, F = (BA = w) + (t = E[t + 4 >> 2]) | 0, b = Q, Q = Ig(V, 0, B << 1 & -2, 1 & (t << 1 | B >>> 31)), B = w + (B >>> 0 > n >>> 0 ? F + 1 | 0 : F) | 0, F = KI(b ^ (t = Q + n | 0), d ^ (L = Q >>> 0 > t >>> 0 ? B + 1 | 0 : B), 40), n = 1 + (B = o + (Z = w) | 0) | 0, Q = B, Q = (B = C + F | 0) >>> 0 < C >>> 0 ? n : Q, n = B, B = Ig(F, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), Q = w + Q | 0, Q = 1 + (B = (x = (C = n + B | 0) >>> 0 < B >>> 0 ? Q + 1 | 0 : Q) + M | 0) | 0, o = B, o = (B = C + S | 0) >>> 0 < C >>> 0 ? Q : o, Q = B, B = Ig(S, 0, C << 1 & -2, 1 & (x << 1 | C >>> 31)), o = w + o | 0, y = KI((Q = Q + B | 0) ^ k, (m = B >>> 0 > Q >>> 0 ? o + 1 | 0 : o) ^ y, 32), W = w, n = (Y = E[_ + 52 >> 2]) + (B = E[_ + 20 >> 2]) | 0, d = (M = E[_ + 48 >> 2]) + (o = E[_ + 16 >> 2]) | 0, l = Ig(o << 1 & -2, 1 & (B << 1 | o >>> 31), M, 0), o = w + (o >>> 0 > d >>> 0 ? n + 1 | 0 : n) | 0, d = (B = d + l | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, v = (l = KI(B ^ E[_ + 112 >> 2], d ^ E[_ + 116 >> 2], 32)) + (n = E[_ + 80 >> 2]) | 0, b = (AA = w) + (o = E[_ + 84 >> 2]) | 0, K = M, M = Ig(l, 0, n << 1 & -2, 1 & (o << 1 | n >>> 31)), n = w + (n >>> 0 > v >>> 0 ? b + 1 | 0 : b) | 0, M = KI(K ^ (o = M + v | 0), Y ^ (v = o >>> 0 < M >>> 0 ? n + 1 | 0 : n), 40), K = 1 + (n = d + (Y = w) | 0) | 0, b = n, b = (n = B + M | 0) >>> 0 < B >>> 0 ? K : b, B = Ig(M, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), d = w + b | 0, d = KI(K = (n = B + n | 0) ^ l, AA ^ (l = B >>> 0 > n >>> 0 ? d + 1 | 0 : d), 48), K = 1 + (B = v + (AA = w) | 0) | 0, b = B, b = (B = o + d | 0) >>> 0 < o >>> 0 ? K : b, o = Ig(d, 0, o << 1 & -2, 1 & (v << 1 | o >>> 31)), v = w + b | 0, K = 1 + (o = (v = (B = o + B | 0) >>> 0 < o >>> 0 ? v + 1 | 0 : v) + W | 0) | 0, b = o, b = (o = B + y | 0) >>> 0 < B >>> 0 ? K : b, K = S, S = Ig(y, 0, B << 1 & -2, 1 & (v << 1 | B >>> 31)), b = w + b | 0, S = KI(K ^ (o = S + o | 0), $ ^ (b = o >>> 0 < S >>> 0 ? b + 1 | 0 : b), 40), tA = 1 + (K = m + ($ = w) | 0) | 0, IA = K, IA = (K = Q + S | 0) >>> 0 < Q >>> 0 ? tA : IA, Q = (m = Ig(S, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31))) + K | 0, E[_ >> 2] = Q, K = w + IA | 0, m = Q >>> 0 < m >>> 0 ? K + 1 | 0 : K, E[_ + 4 >> 2] = m, Q = KI(Q ^ y, m ^ W, 48), E[_ + 120 >> 2] = Q, y = w, E[_ + 124 >> 2] = y, IA = 1 + (y = y + b | 0) | 0, K = y, m = (y = Q + o | 0) >>> 0 < o >>> 0 ? IA : K, Q = (o = Ig(Q, 0, o << 1 & -2, 1 & (b << 1 | o >>> 31))) + y | 0, E[_ + 80 >> 2] = Q, y = w + m | 0, o = Q >>> 0 < o >>> 0 ? y + 1 | 0 : y, E[_ + 84 >> 2] = o, rA = _, eA = KI(Q ^ S, o ^ $, 1), E[rA + 40 >> 2] = eA, E[_ + 44 >> 2] = w, Q = KI(B ^ M, v ^ Y, 1), y = 1 + (B = j + (M = w) | 0) | 0, o = B, o = (B = Q + e | 0) >>> 0 < e >>> 0 ? y : o, B = B + (S = Ig(Q, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) | 0, e = w + o | 0, o = KI(C ^ V, x ^ BA, 48), e = KI(o ^ B, (S = B >>> 0 < S >>> 0 ? e + 1 | 0 : e) ^ (j = w), 32), V = y = w, b = 1 + (C = R + H | 0) | 0, H = C, x = (C = i + k | 0) >>> 0 < i >>> 0 ? b : H, i = Ig(k, 0, i << 1 & -2, 1 & (R << 1 | i >>> 31)), k = w + x | 0, H = 1 + (i = (k = (C = i + C | 0) >>> 0 < i >>> 0 ? k + 1 | 0 : k) + y | 0) | 0, y = i, y = (i = C + e | 0) >>> 0 < C >>> 0 ? H : y, H = Q, Q = Ig(e, 0, C << 1 & -2, 1 & (k << 1 | C >>> 31)), y = w + y | 0, Q = KI(H ^ (i = Q + i | 0), M ^ (y = i >>> 0 < Q >>> 0 ? y + 1 | 0 : y), 40), b = 1 + (R = S + (M = w) | 0) | 0, H = R, x = (R = B + Q | 0) >>> 0 < B >>> 0 ? b : H, H = e, e = Ig(Q, 0, B << 1 & -2, 1 & (S << 1 | B >>> 31)), S = w + x | 0, e = KI(H ^ (B = e + R | 0), V ^ (S = B >>> 0 < e >>> 0 ? S + 1 | 0 : S), 48), E[_ + 96 >> 2] = e, R = w, E[_ + 100 >> 2] = R, E[_ + 8 >> 2] = B, E[_ + 12 >> 2] = S, S = 1 + (B = y + R | 0) | 0, H = B, S = (B = i + e | 0) >>> 0 < i >>> 0 ? S : H, i = Ig(e, 0, i << 1 & -2, 1 & (y << 1 | i >>> 31)), e = w + S | 0, rA = _, eA = KI((B = i + B | 0) ^ Q, M ^ (i = B >>> 0 < i >>> 0 ? e + 1 | 0 : e), 1), E[rA + 48 >> 2] = eA, E[_ + 52 >> 2] = w, E[_ + 88 >> 2] = B, E[_ + 92 >> 2] = i, i = KI(C ^ J, k ^ gA, 1), e = 1 + (C = l + (J = w) | 0) | 0, B = C, e = (C = i + n | 0) >>> 0 < n >>> 0 ? e : B, B = C, C = Ig(i, 0, n << 1 & -2, 1 & (l << 1 | n >>> 31)), e = w + e | 0, e = KI((B = B + C | 0) ^ f, CA ^ (Q = C >>> 0 > B >>> 0 ? e + 1 | 0 : e), 32), k = n = w, f = 1 + (C = L + j | 0) | 0, y = C, f = (C = o + t | 0) >>> 0 < t >>> 0 ? f : y, t = Ig(o, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31)), o = w + f | 0, f = 1 + (t = (o = (C = t + C | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + n | 0) | 0, y = t, n = (t = C + e | 0) >>> 0 < C >>> 0 ? f : y, y = i, i = t, t = Ig(e, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), n = w + n | 0, t = KI(y ^ (i = i + t | 0), J ^ (n = i >>> 0 < t >>> 0 ? n + 1 | 0 : n), 40), M = 1 + (f = Q + (J = w) | 0) | 0, y = f, S = (f = B + t | 0) >>> 0 < B >>> 0 ? M : y, B = (Q = Ig(t, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31))) + f | 0, E[_ + 16 >> 2] = B, f = w + S | 0, Q = B >>> 0 < Q >>> 0 ? f + 1 | 0 : f, E[_ + 20 >> 2] = Q, B = KI(B ^ e, Q ^ k, 48), E[_ + 104 >> 2] = B, e = w, E[_ + 108 >> 2] = e, Q = 1 + (e = e + n | 0) | 0, y = e, Q = (e = B + i | 0) >>> 0 < i >>> 0 ? Q : y, i = (B = Ig(B, 0, i << 1 & -2, 1 & (n << 1 | i >>> 31))) + e | 0, e = w + Q | 0, n = B = B >>> 0 > i >>> 0 ? e + 1 | 0 : e, E[q >> 2] = i, E[q + 4 >> 2] = B, e = (B = KI(C ^ F, o ^ Z, 1)) + U | 0, Q = (k = w) + z | 0, C = (o = Ig(U << 1 & -2, 1 & (z << 1 | U >>> 31), B, 0)) + e | 0, e = w + (B >>> 0 > e >>> 0 ? Q + 1 | 0 : Q) | 0, e = KI(C ^ d, AA ^ (Q = C >>> 0 < o >>> 0 ? e + 1 | 0 : e), 32), f = 1 + (o = O + (U = w) | 0) | 0, y = o, f = (o = e + s | 0) >>> 0 < s >>> 0 ? f : y, y = B, B = (s = Ig(e, 0, s << 1 & -2, 1 & (O << 1 | s >>> 31))) + o | 0, o = w + f | 0, s = KI(y ^ B, k ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), F = 1 + (f = Q + (k = w) | 0) | 0, y = f, S = (f = C + s | 0) >>> 0 < C >>> 0 ? F : y, y = e, C = Ig(s, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), Q = w + S | 0, C = KI(y ^ (e = C + f | 0), U ^ (Q = C >>> 0 > e >>> 0 ? Q + 1 | 0 : Q), 48), F = 1 + (f = o + (U = w) | 0) | 0, y = f, S = (f = C + B | 0) >>> 0 < B >>> 0 ? F : y, B = (o = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + f | 0, E[_ + 72 >> 2] = B, f = w + S | 0, o = B >>> 0 < o >>> 0 ? f + 1 | 0 : f, E[_ + 76 >> 2] = o, E[_ + 112 >> 2] = C, E[_ + 116 >> 2] = U, E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = Q, rA = _, eA = KI(i ^ t, n ^ J, 1), E[rA + 56 >> 2] = eA, E[_ + 60 >> 2] = w, rA = _, eA = KI(B ^ s, o ^ k, 1), E[rA + 32 >> 2] = eA, E[_ + 36 >> 2] = w, 8 != (0 | (r = r + 1 | 0)););
                                                    for(; i = (B = E[392 + (_ = (g + 3072 | 0) + (N << 4) | 0) >> 2]) + (C = E[_ + 136 >> 2]) | 0, e = (Q = E[_ + 396 >> 2]) + (r = E[_ + 140 >> 2]) | 0, s = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), B, 0), C = w + (C >>> 0 > i >>> 0 ? e + 1 | 0 : e) | 0, i = (r = s + i | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C, s = (e = KI(r ^ E[_ + 904 >> 2], i ^ E[_ + 908 >> 2], 32)) + (C = E[_ + 648 >> 2]) | 0, t = (o = w) + (n = E[_ + 652 >> 2]) | 0, y = B, n = Ig(e, 0, C << 1 & -2, 1 & (n << 1 | C >>> 31)), C = w + (C >>> 0 > s >>> 0 ? t + 1 | 0 : t) | 0, U = KI(y ^ (B = n + s | 0), Q ^ (d = B >>> 0 < n >>> 0 ? C + 1 | 0 : C), 40), y = 1 + (C = i + (v = w) | 0) | 0, t = C, s = (C = r + U | 0) >>> 0 < r >>> 0 ? y : t, n = (r = Ig(U, 0, r << 1 & -2, 1 & (i << 1 | r >>> 31))) + C | 0, C = w + s | 0, J = KI(n ^ e, o ^ (R = r >>> 0 > n >>> 0 ? C + 1 | 0 : C), 48), b = F = w, i = (k = E[_ + 268 >> 2]) + (r = E[_ + 12 >> 2]) | 0, s = (e = E[_ + 264 >> 2]) + (C = E[_ + 8 >> 2]) | 0, t = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), e, 0), C = w + (C >>> 0 > s >>> 0 ? i + 1 | 0 : i) | 0, s = (r = s + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C, Q = (t = KI(r ^ E[_ + 776 >> 2], s ^ E[_ + 780 >> 2], 32)) + (i = E[_ + 520 >> 2]) | 0, o = (f = w) + (C = E[_ + 524 >> 2]) | 0, y = e, e = Ig(t, 0, i << 1 & -2, 1 & (C << 1 | i >>> 31)), i = w + (i >>> 0 > Q >>> 0 ? o + 1 | 0 : o) | 0, e = KI(y ^ (C = e + Q | 0), k ^ (Q = C >>> 0 < e >>> 0 ? i + 1 | 0 : i), 40), k = 1 + (i = s + (o = w) | 0) | 0, y = i, k = (i = r + e | 0) >>> 0 < r >>> 0 ? k : y, r = Ig(e, 0, r << 1 & -2, 1 & (s << 1 | r >>> 31)), s = w + k | 0, k = KI((i = r + i | 0) ^ t, f ^ (z = i >>> 0 < r >>> 0 ? s + 1 | 0 : s), 48), y = 1 + (r = Q + (gA = w) | 0) | 0, t = r, s = (r = C + k | 0) >>> 0 < C >>> 0 ? y : t, t = e, e = r, r = Ig(k, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), C = w + s | 0, f = KI(t ^ (e = e + r | 0), o ^ (j = r >>> 0 > e >>> 0 ? C + 1 | 0 : C), 1), H = y = w, s = (M = E[_ + 260 >> 2]) + (r = E[_ + 4 >> 2]) | 0, Q = (t = E[_ + 256 >> 2]) + (C = E[_ >> 2]) | 0, o = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), t, 0), C = w + (C >>> 0 > Q >>> 0 ? s + 1 | 0 : s) | 0, Q = (r = Q + o | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, o = (O = KI(r ^ E[_ + 768 >> 2], Q ^ E[_ + 772 >> 2], 32)) + (C = E[_ + 512 >> 2]) | 0, S = (CA = w) + (s = E[_ + 516 >> 2]) | 0, Y = t, t = Ig(O, 0, C << 1 & -2, 1 & (s << 1 | C >>> 31)), C = w + (C >>> 0 > o >>> 0 ? S + 1 | 0 : S) | 0, S = KI(Y ^ (s = t + o | 0), M ^ (V = t >>> 0 > s >>> 0 ? C + 1 | 0 : C), 40), t = 1 + (C = Q + ($ = w) | 0) | 0, o = C, t = (C = r + S | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(S, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), t = w + t | 0, t = 1 + (C = (q = C >>> 0 > (r = o + C | 0) >>> 0 ? t + 1 | 0 : t) + y | 0) | 0, o = C, Q = (C = r + f | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(f, 0, r << 1 & -2, 1 & (q << 1 | r >>> 31)), Q = w + Q | 0, F = KI((t = o + C | 0) ^ J, (L = C >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) ^ F, 32), BA = w, o = (Z = E[_ + 388 >> 2]) + (C = E[_ + 132 >> 2]) | 0, M = (y = E[_ + 384 >> 2]) + (Q = E[_ + 128 >> 2]) | 0, x = Ig(Q << 1 & -2, 1 & (C << 1 | Q >>> 31), y, 0), Q = w + (Q >>> 0 > M >>> 0 ? o + 1 | 0 : o) | 0, M = (C = M + x | 0) >>> 0 < x >>> 0 ? Q + 1 | 0 : Q, m = (x = KI(C ^ E[_ + 896 >> 2], M ^ E[_ + 900 >> 2], 32)) + (o = E[_ + 640 >> 2]) | 0, l = (W = w) + (Q = E[_ + 644 >> 2]) | 0, Y = y, y = Ig(x, 0, o << 1 & -2, 1 & (Q << 1 | o >>> 31)), o = w + (o >>> 0 > m >>> 0 ? l + 1 | 0 : l) | 0, y = KI(Y ^ (Q = y + m | 0), Z ^ (m = Q >>> 0 < y >>> 0 ? o + 1 | 0 : o), 40), K = 1 + (o = M + (Z = w) | 0) | 0, Y = o, l = (o = C + y | 0) >>> 0 < C >>> 0 ? K : Y, C = Ig(y, 0, C << 1 & -2, 1 & (M << 1 | C >>> 31)), M = w + l | 0, M = KI(Y = (o = C + o | 0) ^ x, W ^ (x = C >>> 0 > o >>> 0 ? M + 1 | 0 : M), 48), K = 1 + (C = m + (W = w) | 0) | 0, Y = C, l = (C = Q + M | 0) >>> 0 < Q >>> 0 ? K : Y, Q = Ig(M, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31)), m = w + l | 0, K = 1 + (Q = (m = (C = Q + C | 0) >>> 0 < Q >>> 0 ? m + 1 | 0 : m) + BA | 0) | 0, Y = Q, l = (Q = C + F | 0) >>> 0 < C >>> 0 ? K : Y, Y = f, f = Ig(F, 0, C << 1 & -2, 1 & (m << 1 | C >>> 31)), l = w + l | 0, f = KI(Y ^ (Q = f + Q | 0), H ^ (l = Q >>> 0 < f >>> 0 ? l + 1 | 0 : l), 40), IA = 1 + (Y = L + (H = w) | 0) | 0, K = Y, AA = (Y = t + f | 0) >>> 0 < t >>> 0 ? IA : K, t = (L = Ig(f, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31))) + Y | 0, E[_ >> 2] = t, Y = w + AA | 0, L = t >>> 0 < L >>> 0 ? Y + 1 | 0 : Y, E[_ + 4 >> 2] = L, t = KI(t ^ F, L ^ BA, 48), E[_ + 904 >> 2] = t, F = w, E[_ + 908 >> 2] = F, K = 1 + (F = F + l | 0) | 0, Y = F, L = (F = Q + t | 0) >>> 0 < Q >>> 0 ? K : Y, t = (Q = Ig(t, 0, Q << 1 & -2, 1 & (l << 1 | Q >>> 31))) + F | 0, E[_ + 640 >> 2] = t, F = w + L | 0, Q = Q >>> 0 > t >>> 0 ? F + 1 | 0 : F, E[_ + 644 >> 2] = Q, rA = _, eA = KI(t ^ f, Q ^ H, 1), E[rA + 264 >> 2] = eA, E[_ + 268 >> 2] = w, t = KI(C ^ y, m ^ Z, 1), f = 1 + (C = z + (y = w) | 0) | 0, Q = C, Q = (C = i + t | 0) >>> 0 < i >>> 0 ? f : Q, C = C + (f = Ig(t, 0, i << 1 & -2, 1 & (z << 1 | i >>> 31))) | 0, i = w + Q | 0, Q = KI(r ^ O, q ^ CA, 48), i = KI(Q ^ C, (f = C >>> 0 < f >>> 0 ? i + 1 | 0 : i) ^ (z = w), 32), O = F = w, b = 1 + (r = d + b | 0) | 0, H = r, q = (r = B + J | 0) >>> 0 < B >>> 0 ? b : H, B = Ig(J, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), J = w + q | 0, H = 1 + (B = (J = B >>> 0 > (r = B + r | 0) >>> 0 ? J + 1 | 0 : J) + F | 0) | 0, F = B, F = (B = i + r | 0) >>> 0 < r >>> 0 ? H : F, H = t, t = Ig(i, 0, r << 1 & -2, 1 & (J << 1 | r >>> 31)), F = w + F | 0, t = KI(H ^ (B = t + B | 0), y ^ (F = B >>> 0 < t >>> 0 ? F + 1 | 0 : F), 40), b = 1 + (d = f + (y = w) | 0) | 0, H = d, q = (d = C + t | 0) >>> 0 < C >>> 0 ? b : H, H = i, i = Ig(t, 0, C << 1 & -2, 1 & (f << 1 | C >>> 31)), f = w + q | 0, i = KI(H ^ (C = i + d | 0), O ^ (f = C >>> 0 < i >>> 0 ? f + 1 | 0 : f), 48), E[_ + 768 >> 2] = i, d = w, E[_ + 772 >> 2] = d, E[_ + 8 >> 2] = C, E[_ + 12 >> 2] = f, H = 1 + (C = F + d | 0) | 0, f = C, f = (C = B + i | 0) >>> 0 < B >>> 0 ? H : f, B = Ig(i, 0, B << 1 & -2, 1 & (F << 1 | B >>> 31)), i = w + f | 0, rA = _, eA = KI((C = B + C | 0) ^ t, y ^ (B = C >>> 0 < B >>> 0 ? i + 1 | 0 : i), 1), E[rA + 384 >> 2] = eA, E[_ + 388 >> 2] = w, E[_ + 648 >> 2] = C, E[_ + 652 >> 2] = B, B = KI(r ^ U, J ^ v, 1), i = 1 + (r = x + (U = w) | 0) | 0, C = r, i = (r = B + o | 0) >>> 0 < o >>> 0 ? i : C, C = r, r = Ig(B, 0, o << 1 & -2, 1 & (x << 1 | o >>> 31)), i = w + i | 0, i = KI((C = C + r | 0) ^ k, gA ^ (t = C >>> 0 < r >>> 0 ? i + 1 | 0 : i), 32), J = o = w, f = 1 + (r = z + V | 0) | 0, y = r, k = (r = Q + s | 0) >>> 0 < s >>> 0 ? f : y, s = Ig(Q, 0, s << 1 & -2, 1 & (V << 1 | s >>> 31)), Q = w + k | 0, y = 1 + (s = (Q = (r = s + r | 0) >>> 0 < s >>> 0 ? Q + 1 | 0 : Q) + o | 0) | 0, o = s, o = (s = i + r | 0) >>> 0 < r >>> 0 ? y : o, y = B, B = s, s = Ig(i, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), o = w + o | 0, s = KI(y ^ (B = B + s | 0), U ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), f = 1 + (k = t + (U = w) | 0) | 0, y = k, f = (k = C + s | 0) >>> 0 < C >>> 0 ? f : y, C = (t = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31))) + k | 0, E[_ + 128 >> 2] = C, k = w + f | 0, t = C >>> 0 < t >>> 0 ? k + 1 | 0 : k, E[_ + 132 >> 2] = t, C = KI(C ^ i, t ^ J, 48), E[_ + 776 >> 2] = C, i = w, E[_ + 780 >> 2] = i, y = 1 + (i = i + o | 0) | 0, t = i, t = (i = C + B | 0) >>> 0 < B >>> 0 ? y : t, B = (C = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + i | 0, i = w + t | 0, o = C = C >>> 0 > B >>> 0 ? i + 1 | 0 : i, E[_ + 512 >> 2] = B, E[_ + 516 >> 2] = C, i = (C = KI(r ^ S, Q ^ $, 1)) + n | 0, t = (J = w) + R | 0, r = (Q = Ig(n << 1 & -2, 1 & (R << 1 | n >>> 31), C, 0)) + i | 0, i = w + (C >>> 0 > i >>> 0 ? t + 1 | 0 : t) | 0, i = KI(r ^ M, W ^ (t = Q >>> 0 > r >>> 0 ? i + 1 | 0 : i), 32), f = 1 + (Q = j + (n = w) | 0) | 0, y = Q, k = (Q = i + e | 0) >>> 0 < e >>> 0 ? f : y, y = C, C = (e = Ig(i, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) + Q | 0, Q = w + k | 0, e = KI(y ^ C, J ^ (Q = C >>> 0 < e >>> 0 ? Q + 1 | 0 : Q), 40), f = 1 + (k = t + (J = w) | 0) | 0, y = k, f = (k = r + e | 0) >>> 0 < r >>> 0 ? f : y, y = i, r = Ig(e, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), t = w + f | 0, r = KI(y ^ (i = r + k | 0), n ^ (t = i >>> 0 < r >>> 0 ? t + 1 | 0 : t), 48), f = 1 + (k = Q + (n = w) | 0) | 0, y = k, f = (k = C + r | 0) >>> 0 < C >>> 0 ? f : y, C = (Q = Ig(r, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31))) + k | 0, E[_ + 520 >> 2] = C, k = w + f | 0, Q = C >>> 0 < Q >>> 0 ? k + 1 | 0 : k, E[_ + 524 >> 2] = Q, E[_ + 896 >> 2] = r, E[_ + 900 >> 2] = n, E[_ + 136 >> 2] = i, E[_ + 140 >> 2] = t, rA = _, eA = KI(B ^ s, o ^ U, 1), E[rA + 392 >> 2] = eA, E[_ + 396 >> 2] = w, rA = _, eA = KI(C ^ e, Q ^ J, 1), E[rA + 256 >> 2] = eA, E[_ + 260 >> 2] = w, 8 != (0 | (N = N + 1 | 0)););
                                                    for(_ = Sg(aA, g + 2048 | 0, 1024), r = 0; i = E[(C = (N = r << 3) + _ | 0) >> 2], s = E[(e = (B = g + 3072 | 0) + N | 0) >> 2], e = E[C + 4 >> 2] ^ E[e + 4 >> 2], E[C >> 2] = i ^ s, E[C + 4 >> 2] = e, e = E[(C = (i = 8 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, e = E[(C = (i = 16 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, i = E[(N = (C = 24 | N) + _ | 0) >> 2], B = E[(C = C + B | 0) >> 2], C = E[N + 4 >> 2] ^ E[C + 4 >> 2], E[N >> 2] = B ^ i, E[N + 4 >> 2] = C, 128 != (0 | (r = r + 4 | 0)););
                                                }
                                                if (r = oA + 1 | 0, P = P + 1 | 0, !((N = E[A + 20 >> 2]) >>> 0 > (u = u + 1 | 0) >>> 0)) break;
                                            }
                                        }
                                        h = g + 4096 | 0;
                                    }
                                    function G(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0;
                                        for(h = o = h - 2048 | 0, Sg(o + 1024 | 0, I, 1024), I = 0; Q = E[(_ = (i = o + 1024 | 0) + (B = I << 3) | 0) >> 2], a = E[(c = A + B | 0) >> 2], c = E[_ + 4 >> 2] ^ E[c + 4 >> 2], E[_ >> 2] = Q ^ a, E[_ + 4 >> 2] = c, c = E[(_ = (Q = 8 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, c = E[(_ = (Q = 16 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, Q = E[(B = (_ = 24 | B) + i | 0) >> 2], c = E[(_ = A + _ | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ c, E[B + 4 >> 2] = _, 128 != (0 | (I = I + 4 | 0)););
                                        for(C = Sg(o, i, 1024), A = 0, I = 0; o = E[(B = (i = I << 3) + C | 0) >> 2], Q = E[(_ = g + i | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ o, E[B + 4 >> 2] = _, _ = E[(B = (o = 8 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, _ = E[(B = (o = 16 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, o = E[(i = (B = 24 | i) + C | 0) >> 2], _ = E[(B = g + B | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, 128 != (0 | (I = I + 4 | 0)););
                                        for(; c = (Q = E[56 + (i = (C + 1024 | 0) + (A << 7) | 0) >> 2]) + (B = E[i + 24 >> 2]) | 0, I = (t = E[i + 60 >> 2]) + (o = E[i + 28 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 120 >> 2] ^ B, _ ^ E[i + 124 >> 2], 32)) + (o = E[i + 88 >> 2]) | 0, I = (y = w) + (a = E[i + 92 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (z = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), j = I = w, p = Y, e = I, a = (c = E[i + 40 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 44 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 104 >> 2] ^ B, Q ^ E[i + 108 >> 2], 32)) + (_ = E[i + 72 >> 2]) | 0, I = (f = w) + (r = E[i + 76 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (v = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), L = I = w, k = M, t = I, f = (r = E[i + 32 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 36 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 96 >> 2] ^ Q, a ^ E[i + 100 >> 2], 32)) + (c = E[(I = N = i - -64 | 0) >> 2]) | 0, I = (q = w) + (f = E[I + 4 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (X = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), P = I = w, S = I, k = (p = E[i + 48 >> 2]) + (r = E[i + 16 >> 2]) | 0, I = (m = E[i + 52 >> 2]) + (e = E[i + 20 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = (k = KI(E[i + 112 >> 2] ^ r, t ^ E[i + 116 >> 2], 32)) + (e = E[i + 80 >> 2]) | 0, I = (u = w) + (b = E[i + 84 >> 2]) | 0, K = e >>> 0 > G >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(G = (e = b + G | 0) ^ p, m ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (m = w) | 0, K = (G = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(G = (r = t + G | 0) ^ k, u ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (u = w) | 0, t = (G = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + G | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = G + t | 0) ^ M, L ^ (M = t >>> 0 < G >>> 0 ? I + 1 | 0 : I), 40), I = D + (L = w) | 0, G = (O = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + O | 0, I = w + G | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ P, 48), E[i + 120 >> 2] = a, I = w, E[i + 124 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 80 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 84 >> 2] = I, V = i, Z = KI(a ^ S, I ^ L, 1), E[V + 40 >> 2] = Z, E[i + 44 >> 2] = w, I = s + j | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ m, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ q, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(S = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 96 >> 2] = B, y = w, E[i + 100 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 48 >> 2] = Z, E[i + 52 >> 2] = w, E[i + 88 >> 2] = B, E[i + 92 >> 2] = I, e = KI(t ^ x, a ^ z, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, v ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 16 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 20 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 104 >> 2] = B, I = w, E[i + 108 >> 2] = I, a = N, I = I + r | 0, t = (s = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + t | 0, r = B = Q + s | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[a >> 2] = B, E[a + 4 >> 2] = I, c = KI(o ^ J, c ^ X, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, u ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 72 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 76 >> 2] = I, E[i + 112 >> 2] = B, E[i + 116 >> 2] = F, E[i + 24 >> 2] = Q, E[i + 28 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 56 >> 2] = Z, E[i + 60 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 32 >> 2] = Z, E[i + 36 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(A = 0; c = (Q = E[392 + (i = (C + 1024 | 0) + (A << 4) | 0) >> 2]) + (B = E[i + 136 >> 2]) | 0, I = (t = E[i + 396 >> 2]) + (o = E[i + 140 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 904 >> 2] ^ B, _ ^ E[i + 908 >> 2], 32)) + (o = E[i + 648 >> 2]) | 0, I = (y = w) + (a = E[i + 652 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (G = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), z = I = w, p = Y, e = I, a = (c = E[i + 264 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 268 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 776 >> 2] ^ B, Q ^ E[i + 780 >> 2], 32)) + (_ = E[i + 520 >> 2]) | 0, I = (f = w) + (r = E[i + 524 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (j = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), v = I = w, k = M, t = I, f = (r = E[i + 256 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 260 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 768 >> 2] ^ Q, a ^ E[i + 772 >> 2], 32)) + (c = E[i + 512 >> 2]) | 0, I = (L = w) + (f = E[i + 516 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (q = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), X = I = w, S = I, k = (p = E[i + 384 >> 2]) + (r = E[i + 128 >> 2]) | 0, I = (P = E[i + 388 >> 2]) + (e = E[i + 132 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = (k = KI(E[i + 896 >> 2] ^ r, t ^ E[i + 900 >> 2], 32)) + (e = E[i + 640 >> 2]) | 0, I = (m = w) + (b = E[i + 644 >> 2]) | 0, K = e >>> 0 > N >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(N = (e = b + N | 0) ^ p, P ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (P = w) | 0, K = (N = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(N = (r = t + N | 0) ^ k, m ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (m = w) | 0, t = (N = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + N | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = N + t | 0) ^ M, v ^ (M = t >>> 0 < N >>> 0 ? I + 1 | 0 : I), 40), I = D + (v = w) | 0, N = (u = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + u | 0, I = w + N | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ X, 48), E[i + 904 >> 2] = a, I = w, E[i + 908 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 640 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 644 >> 2] = I, V = i, Z = KI(a ^ S, I ^ v, 1), E[V + 264 >> 2] = Z, E[i + 268 >> 2] = w, I = s + z | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ P, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ L, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(N = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 768 >> 2] = B, y = w, E[i + 772 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 384 >> 2] = Z, E[i + 388 >> 2] = w, E[i + 648 >> 2] = B, E[i + 652 >> 2] = I, e = KI(t ^ x, a ^ G, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, j ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 128 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 132 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 776 >> 2] = B, I = w, E[i + 780 >> 2] = I, I = I + r | 0, a = (t = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + a | 0, r = B = Q + t | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[i + 512 >> 2] = B, E[i + 516 >> 2] = I, c = KI(o ^ J, c ^ q, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, m ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 520 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 524 >> 2] = I, E[i + 896 >> 2] = B, E[i + 900 >> 2] = F, E[i + 136 >> 2] = Q, E[i + 140 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 392 >> 2] = Z, E[i + 396 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 256 >> 2] = Z, E[i + 260 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(I = Sg(g, C, 1024), A = 0; B = E[(i = (g = A << 3) + I | 0) >> 2], Q = E[(_ = (o = a = C + 1024 | 0) + g | 0) >> 2], _ = E[i + 4 >> 2] ^ E[_ + 4 >> 2], E[i >> 2] = B ^ Q, E[i + 4 >> 2] = _, _ = E[(i = (B = 8 | g) + I | 0) >> 2], o = E[(B = B + o | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, o = E[(i = (B = 16 | g) + I | 0) >> 2], _ = E[(B = B + a | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, B = E[(g = (i = 24 | g) + I | 0) >> 2], o = E[(i = i + a | 0) >> 2], i = E[g + 4 >> 2] ^ E[i + 4 >> 2], E[g >> 2] = B ^ o, E[g + 4 >> 2] = i, 128 != (0 | (A = A + 4 | 0)););
                                        h = C + 2048 | 0;
                                    }
                                    function M(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        for(h = C = h - 800 | 0, k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, f = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, b = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, K = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Q = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, i = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, _ = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, c = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, t = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, r = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g - -64 | 0, e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I >> 2] = 33620224 ^ e, E[g + 56 >> 2] = 1496785429, E[g + 60 >> 2] = 1652156816, E[(A = g + 48 | 0) >> 2] = 33620224, E[A + 4 >> 2] = 218629379, E[g + 40 >> 2] = 1110511904, E[g + 44 >> 2] = -584534669, E[(B = g + 32 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, y = n ^ e, E[g >> 2] = y, E[g + 92 >> 2] = -584534669 ^ r, E[g + 88 >> 2] = 1110511904 ^ t, E[g + 84 >> 2] = -248528275 ^ c, E[(n = g + 80 | 0) >> 2] = 1427652059 ^ _, E[g + 76 >> 2] = 1652156816 ^ o, E[g + 72 >> 2] = 1496785429 ^ i, E[g + 68 >> 2] = 218629379 ^ Q, K ^= r, E[g + 28 >> 2] = K, b ^= t, E[g + 24 >> 2] = b, s = f ^ c, E[g + 20 >> 2] = s, M ^= _, E[(f = g + 16 | 0) >> 2] = M, G ^= o, E[g + 12 >> 2] = G, D = N ^ i, E[g + 8 >> 2] = D, p = k ^ Q, E[g + 4 >> 2] = p, N = 0; k = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = k, k = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = k, k = E[I + 12 >> 2], E[C + 760 >> 2] = E[I + 8 >> 2], E[C + 764 >> 2] = k, k = E[I + 4 >> 2], E[C + 752 >> 2] = E[I >> 2], E[C + 756 >> 2] = k, k = E[n + 12 >> 2], E[C + 744 >> 2] = E[n + 8 >> 2], E[C + 748 >> 2] = k, k = E[n + 4 >> 2], E[C + 736 >> 2] = E[n >> 2], E[C + 740 >> 2] = k, $A(k = C + 768 | 0, C + 752 | 0, C + 736 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 728 >> 2] = E[A + 8 >> 2], E[C + 732 >> 2] = w, w = E[A + 4 >> 2], E[C + 720 >> 2] = E[A >> 2], E[C + 724 >> 2] = w, w = E[I + 12 >> 2], E[C + 712 >> 2] = E[I + 8 >> 2], E[C + 716 >> 2] = w, w = E[I + 4 >> 2], E[C + 704 >> 2] = E[I >> 2], E[C + 708 >> 2] = w, $A(k, C + 720 | 0, C + 704 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 696 >> 2] = E[B + 8 >> 2], E[C + 700 >> 2] = w, w = E[B + 4 >> 2], E[C + 688 >> 2] = E[B >> 2], E[C + 692 >> 2] = w, w = E[A + 12 >> 2], E[C + 680 >> 2] = E[A + 8 >> 2], E[C + 684 >> 2] = w, w = E[A + 4 >> 2], E[C + 672 >> 2] = E[A >> 2], E[C + 676 >> 2] = w, $A(k, C + 688 | 0, C + 672 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 664 >> 2] = E[f + 8 >> 2], E[C + 668 >> 2] = w, w = E[f + 4 >> 2], E[C + 656 >> 2] = E[f >> 2], E[C + 660 >> 2] = w, w = E[B + 12 >> 2], E[C + 648 >> 2] = E[B + 8 >> 2], E[C + 652 >> 2] = w, w = E[B + 4 >> 2], E[C + 640 >> 2] = E[B >> 2], E[C + 644 >> 2] = w, $A(k, C + 656 | 0, C + 640 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 632 >> 2] = E[g + 8 >> 2], E[C + 636 >> 2] = w, w = E[g + 4 >> 2], E[C + 624 >> 2] = E[g >> 2], E[C + 628 >> 2] = w, w = E[f + 12 >> 2], E[C + 616 >> 2] = E[f + 8 >> 2], E[C + 620 >> 2] = w, w = E[f + 4 >> 2], E[C + 608 >> 2] = E[f >> 2], E[C + 612 >> 2] = w, $A(k, C + 624 | 0, C + 608 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 600 >> 2] = E[C + 792 >> 2], E[C + 604 >> 2] = w, w = E[C + 788 >> 2], E[C + 592 >> 2] = E[C + 784 >> 2], E[C + 596 >> 2] = w, w = E[g + 12 >> 2], E[C + 584 >> 2] = E[g + 8 >> 2], E[C + 588 >> 2] = w, w = E[g + 4 >> 2], E[C + 576 >> 2] = E[g >> 2], E[C + 580 >> 2] = w, $A(k, C + 592 | 0, C + 576 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ o, E[g + 8 >> 2] = S ^ i, E[g + 4 >> 2] = F ^ Q, E[g >> 2] = w ^ e, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 568 >> 2] = E[I + 8 >> 2], E[C + 572 >> 2] = w, w = E[I + 4 >> 2], E[C + 560 >> 2] = E[I >> 2], E[C + 564 >> 2] = w, w = E[n + 12 >> 2], E[C + 552 >> 2] = E[n + 8 >> 2], E[C + 556 >> 2] = w, w = E[n + 4 >> 2], E[C + 544 >> 2] = E[n >> 2], E[C + 548 >> 2] = w, $A(k, C + 560 | 0, C + 544 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 536 >> 2] = E[A + 8 >> 2], E[C + 540 >> 2] = w, w = E[A + 4 >> 2], E[C + 528 >> 2] = E[A >> 2], E[C + 532 >> 2] = w, w = E[I + 12 >> 2], E[C + 520 >> 2] = E[I + 8 >> 2], E[C + 524 >> 2] = w, w = E[I + 4 >> 2], E[C + 512 >> 2] = E[I >> 2], E[C + 516 >> 2] = w, $A(k, C + 528 | 0, C + 512 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 504 >> 2] = E[B + 8 >> 2], E[C + 508 >> 2] = w, w = E[B + 4 >> 2], E[C + 496 >> 2] = E[B >> 2], E[C + 500 >> 2] = w, w = E[A + 12 >> 2], E[C + 488 >> 2] = E[A + 8 >> 2], E[C + 492 >> 2] = w, w = E[A + 4 >> 2], E[C + 480 >> 2] = E[A >> 2], E[C + 484 >> 2] = w, $A(k, C + 496 | 0, C + 480 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 472 >> 2] = E[f + 8 >> 2], E[C + 476 >> 2] = w, w = E[f + 4 >> 2], E[C + 464 >> 2] = E[f >> 2], E[C + 468 >> 2] = w, w = E[B + 12 >> 2], E[C + 456 >> 2] = E[B + 8 >> 2], E[C + 460 >> 2] = w, w = E[B + 4 >> 2], E[C + 448 >> 2] = E[B >> 2], E[C + 452 >> 2] = w, $A(k, C + 464 | 0, C + 448 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 440 >> 2] = E[g + 8 >> 2], E[C + 444 >> 2] = w, w = E[g + 4 >> 2], E[C + 432 >> 2] = E[g >> 2], E[C + 436 >> 2] = w, w = E[f + 12 >> 2], E[C + 424 >> 2] = E[f + 8 >> 2], E[C + 428 >> 2] = w, w = E[f + 4 >> 2], E[C + 416 >> 2] = E[f >> 2], E[C + 420 >> 2] = w, $A(k, C + 432 | 0, C + 416 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 408 >> 2] = E[C + 792 >> 2], E[C + 412 >> 2] = w, w = E[C + 788 >> 2], E[C + 400 >> 2] = E[C + 784 >> 2], E[C + 404 >> 2] = w, w = E[g + 12 >> 2], E[C + 392 >> 2] = E[g + 8 >> 2], E[C + 396 >> 2] = w, w = E[g + 4 >> 2], E[C + 384 >> 2] = E[g >> 2], E[C + 388 >> 2] = w, $A(k, C + 400 | 0, C + 384 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ r, E[g + 8 >> 2] = S ^ t, E[g + 4 >> 2] = F ^ c, E[g >> 2] = w ^ _, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 376 >> 2] = E[I + 8 >> 2], E[C + 380 >> 2] = w, w = E[I + 4 >> 2], E[C + 368 >> 2] = E[I >> 2], E[C + 372 >> 2] = w, w = E[n + 12 >> 2], E[C + 360 >> 2] = E[n + 8 >> 2], E[C + 364 >> 2] = w, w = E[n + 4 >> 2], E[C + 352 >> 2] = E[n >> 2], E[C + 356 >> 2] = w, $A(k, C + 368 | 0, C + 352 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 344 >> 2] = E[A + 8 >> 2], E[C + 348 >> 2] = w, w = E[A + 4 >> 2], E[C + 336 >> 2] = E[A >> 2], E[C + 340 >> 2] = w, w = E[I + 12 >> 2], E[C + 328 >> 2] = E[I + 8 >> 2], E[C + 332 >> 2] = w, w = E[I + 4 >> 2], E[C + 320 >> 2] = E[I >> 2], E[C + 324 >> 2] = w, $A(k, C + 336 | 0, C + 320 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 312 >> 2] = E[B + 8 >> 2], E[C + 316 >> 2] = w, w = E[B + 4 >> 2], E[C + 304 >> 2] = E[B >> 2], E[C + 308 >> 2] = w, w = E[A + 12 >> 2], E[C + 296 >> 2] = E[A + 8 >> 2], E[C + 300 >> 2] = w, w = E[A + 4 >> 2], E[C + 288 >> 2] = E[A >> 2], E[C + 292 >> 2] = w, $A(k, C + 304 | 0, C + 288 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 280 >> 2] = E[f + 8 >> 2], E[C + 284 >> 2] = w, w = E[f + 4 >> 2], E[C + 272 >> 2] = E[f >> 2], E[C + 276 >> 2] = w, w = E[B + 12 >> 2], E[C + 264 >> 2] = E[B + 8 >> 2], E[C + 268 >> 2] = w, w = E[B + 4 >> 2], E[C + 256 >> 2] = E[B >> 2], E[C + 260 >> 2] = w, $A(k, C + 272 | 0, C + 256 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 248 >> 2] = E[g + 8 >> 2], E[C + 252 >> 2] = w, w = E[g + 4 >> 2], E[C + 240 >> 2] = E[g >> 2], E[C + 244 >> 2] = w, w = E[f + 12 >> 2], E[C + 232 >> 2] = E[f + 8 >> 2], E[C + 236 >> 2] = w, w = E[f + 4 >> 2], E[C + 224 >> 2] = E[f >> 2], E[C + 228 >> 2] = w, $A(k, C + 240 | 0, C + 224 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 216 >> 2] = E[C + 792 >> 2], E[C + 220 >> 2] = w, w = E[C + 788 >> 2], E[C + 208 >> 2] = E[C + 784 >> 2], E[C + 212 >> 2] = w, w = E[g + 12 >> 2], E[C + 200 >> 2] = E[g + 8 >> 2], E[C + 204 >> 2] = w, w = E[g + 4 >> 2], E[C + 192 >> 2] = E[g >> 2], E[C + 196 >> 2] = w, $A(k, C + 208 | 0, C + 192 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = G ^ E[C + 780 >> 2], E[g + 8 >> 2] = S ^ D, E[g + 4 >> 2] = F ^ p, E[g >> 2] = w ^ y, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 184 >> 2] = E[I + 8 >> 2], E[C + 188 >> 2] = w, w = E[I + 4 >> 2], E[C + 176 >> 2] = E[I >> 2], E[C + 180 >> 2] = w, w = E[n + 12 >> 2], E[C + 168 >> 2] = E[n + 8 >> 2], E[C + 172 >> 2] = w, w = E[n + 4 >> 2], E[C + 160 >> 2] = E[n >> 2], E[C + 164 >> 2] = w, $A(k, C + 176 | 0, C + 160 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 152 >> 2] = E[A + 8 >> 2], E[C + 156 >> 2] = w, w = E[A + 4 >> 2], E[C + 144 >> 2] = E[A >> 2], E[C + 148 >> 2] = w, w = E[I + 12 >> 2], E[C + 136 >> 2] = E[I + 8 >> 2], E[C + 140 >> 2] = w, w = E[I + 4 >> 2], E[C + 128 >> 2] = E[I >> 2], E[C + 132 >> 2] = w, $A(k, C + 144 | 0, C + 128 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 120 >> 2] = E[B + 8 >> 2], E[C + 124 >> 2] = w, w = E[B + 4 >> 2], E[C + 112 >> 2] = E[B >> 2], E[C + 116 >> 2] = w, w = E[A + 12 >> 2], E[C + 104 >> 2] = E[A + 8 >> 2], E[C + 108 >> 2] = w, w = E[A + 4 >> 2], E[C + 96 >> 2] = E[A >> 2], E[C + 100 >> 2] = w, $A(k, C + 112 | 0, C + 96 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 88 >> 2] = E[f + 8 >> 2], E[C + 92 >> 2] = w, w = E[f + 4 >> 2], E[C + 80 >> 2] = E[f >> 2], E[C + 84 >> 2] = w, w = E[B + 12 >> 2], E[C + 72 >> 2] = E[B + 8 >> 2], E[C + 76 >> 2] = w, w = E[B + 4 >> 2], E[C + 64 >> 2] = E[B >> 2], E[C + 68 >> 2] = w, $A(k, C + 80 | 0, C - -64 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[f + 12 >> 2], E[C + 40 >> 2] = E[f + 8 >> 2], E[C + 44 >> 2] = w, w = E[f + 4 >> 2], E[C + 32 >> 2] = E[f >> 2], E[C + 36 >> 2] = w, $A(k, C + 48 | 0, C + 32 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 24 >> 2] = E[C + 792 >> 2], E[C + 28 >> 2] = w, w = E[C + 788 >> 2], E[C + 16 >> 2] = E[C + 784 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(k, C + 16 | 0, C), k = E[C + 768 >> 2], w = E[C + 772 >> 2], F = E[C + 776 >> 2], E[g + 12 >> 2] = K ^ E[C + 780 >> 2], E[g + 8 >> 2] = F ^ b, E[g + 4 >> 2] = w ^ s, E[g >> 2] = k ^ M, 4 != (0 | (N = N + 1 | 0)););
                                        h = C + 800 | 0;
                                    }
                                    function b(A, I) {
                                        var g, C, B, i, _, c, t, r, e, s, D, p, f, n, k, F, N, S, G, M, b, K, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        for(h = g = h - 48 | 0, J = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, d = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[A + 24 | 0] = d, o[A + 25 | 0] = d >>> 8, o[A + 26 | 0] = d >>> 16, o[A + 27 | 0] = d >>> 24, o[A + 28 | 0] = J, o[A + 29 | 0] = J >>> 8, o[A + 30 | 0] = J >>> 16, o[A + 31 | 0] = J >>> 24, J = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, d = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[0 | A] = d, o[A + 1 | 0] = d >>> 8, o[A + 2 | 0] = d >>> 16, o[A + 3 | 0] = d >>> 24, o[A + 4 | 0] = J, o[A + 5 | 0] = J >>> 8, o[A + 6 | 0] = J >>> 16, o[A + 7 | 0] = J >>> 24, J = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 16 | 0] = d, o[A + 17 | 0] = d >>> 8, o[A + 18 | 0] = d >>> 16, o[A + 19 | 0] = d >>> 24, o[A + 20 | 0] = J, o[A + 21 | 0] = J >>> 8, o[A + 22 | 0] = J >>> 16, o[A + 23 | 0] = J >>> 24, d = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, o[A + 12 | 0] = d, o[A + 13 | 0] = d >>> 8, o[A + 14 | 0] = d >>> 16, o[A + 15 | 0] = d >>> 24, I = a[A + 31 | 0], o[A + 31 | 0] = 127 & I, pA(g, A), s = 128 & I, h = I = h - 960 | 0, R(d = I + 304 | 0, g), E[I + 304 >> 2] = E[I + 304 >> 2] + 1, vA(d, d), J = Ig(d = E[I + 340 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, L = J - (-33554432 & q) | 0, H = Ig(d = E[I + 336 >> 2], d >> 31, 486662, 0), J = w, U = Ig(d = E[I + 332 >> 2], d >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, d = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, C = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 292 >> 2] = 0 - C, Z = l - (-67108864 & J) | 0, E[I + 288 >> 2] = 0 - Z, L = U - (-33554432 & m) | 0, J = Ig(d = E[I + 328 >> 2], d >> 31, 486662, 0), d = w, m = Ig(H = E[I + 324 >> 2], H >> 31, 486662, 0), H = w, x = J, d = d + (J = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) | 0, d = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, B = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 284 >> 2] = 0 - B, i = H - (-67108864 & J) | 0, E[I + 280 >> 2] = 0 - i, L = m - (-33554432 & l) | 0, H = Ig(d = E[I + 320 >> 2], d >> 31, 486662, 0), d = w, m = Ig(J = E[I + 316 >> 2], J >> 31, 486662, 0), J = w, x = H, d = (H = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + d | 0, H = d = (J = x + (U = (33554431 & J) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, _ = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | U >>> 26) + L | 0, E[I + 276 >> 2] = 0 - _, c = J - (-67108864 & U) | 0, E[I + 272 >> 2] = 0 - c, x = m - (-33554432 & l) | 0, d = Ig(d = E[I + 312 >> 2], d >> 31, 486662, 0), L = w, U = Ig(J = E[I + 308 >> 2], J >> 31, 486662, 0), H = w, J = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + L | 0, J = J >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, t = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + x | 0, E[I + 268 >> 2] = 0 - t, r = l - (-67108864 & d) | 0, E[I + 264 >> 2] = 0 - r, l = U - (-33554432 & m) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, U = J, J = Ig(H = E[I + 304 >> 2], H >> 31, 486662, 0), d = w + d | 0, J = (H = U + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, e = ((67108863 & (J = (d = H + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + l | 0, E[I + 260 >> 2] = 0 - e, P = H - (-67108864 & d) | 0, E[I + 256 >> 2] = 0 - P, v(J = I + 208 | 0, d = I + 256 | 0), Y(I + 160 | 0, d, J), D = E[I + 196 >> 2], p = E[I + 160 >> 2], z = E[I + 208 >> 2], f = E[I + 164 >> 2], n = E[I + 168 >> 2], j = E[I + 212 >> 2], X = E[I + 216 >> 2], k = E[I + 172 >> 2], F = E[I + 176 >> 2], O = E[I + 220 >> 2], V = E[I + 224 >> 2], N = E[I + 180 >> 2], S = E[I + 184 >> 2], x = E[I + 228 >> 2], L = E[I + 232 >> 2], G = E[I + 188 >> 2], M = E[I + 192 >> 2], J = Ig(d = E[I + 244 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, b = J - (-33554432 & q) | 0, d = Ig(d = E[I + 240 >> 2], d >> 31, 486662, 0), K = w, U = Ig(J = E[I + 236 >> 2], J >> 31, 486662, 0), H = w, J = d, d = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + K | 0, d = d >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + b | 0, E[I + 244 >> 2] = H, E[I + 388 >> 2] = H + (D - C | 0), d = l - (-67108864 & J) | 0, E[I + 240 >> 2] = d, E[I + 384 >> 2] = d + (M - Z | 0), Z = U - (-33554432 & m) | 0, d = Ig(L, L >> 31, 486662, 0), U = w, m = Ig(x, x >> 31, 486662, 0), J = w, x = d, d = (d = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + U | 0, H = d = (H = (33554431 & J) << 7 | l >>> 25) >>> 0 > (J = x + H | 0) >>> 0 ? d + 1 | 0 : d, U = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | (d = U) >>> 26) + Z | 0, E[I + 236 >> 2] = U, E[I + 380 >> 2] = U + (G - B | 0), d = J - (-67108864 & d) | 0, E[I + 232 >> 2] = d, E[I + 376 >> 2] = d + (S - i | 0), L = m - (-33554432 & l) | 0, H = Ig(V, V >> 31, 486662, 0), J = w, U = Ig(O, O >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, J = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + L | 0, E[I + 228 >> 2] = H, E[I + 372 >> 2] = H + (N - _ | 0), d = l - (-67108864 & d) | 0, E[I + 224 >> 2] = d, E[I + 368 >> 2] = d + (F - c | 0), L = U - (-33554432 & m) | 0, d = Ig(X, X >> 31, 486662, 0), J = w, m = Ig(j, j >> 31, 486662, 0), H = w, x = d, J = (d = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) + J | 0, d = J = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? J + 1 | 0 : J, U = ((67108863 & (d = (U = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | (J = U) >>> 26) + L | 0, E[I + 220 >> 2] = U, E[I + 364 >> 2] = U + (k - t | 0), d = H - (-67108864 & J) | 0, E[I + 216 >> 2] = d, E[I + 360 >> 2] = d + (n - r | 0), l = m - (-33554432 & l) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, H = J, J = Ig(z, z >> 31, 486662, 0), d = w + d | 0, d = (H = H + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, u = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + l | 0, E[I + 212 >> 2] = u, E[I + 356 >> 2] = u + (f - e | 0), d = H - (-67108864 & J) | 0, E[I + 208 >> 2] = d, E[I + 352 >> 2] = d + (p - P | 0), Y(d = I + 624 | 0, J = I + 352 | 0, J), Y(I, J, d), v(J = I + 784 | 0, I), v(J, J), Y(d = I + 912 | 0, I, J), v(J = I + 576 | 0, d), v(J, J), v(J, J), v(J, J), Y(H = I + 528 | 0, d, J), v(H, H), v(H, H), Y(H, H, I), d = E[I + 564 >> 2], E[I + 512 >> 2] = E[I + 560 >> 2], E[I + 516 >> 2] = d, d = E[I + 556 >> 2], E[I + 504 >> 2] = E[I + 552 >> 2], E[I + 508 >> 2] = d, d = E[I + 548 >> 2], E[I + 496 >> 2] = E[I + 544 >> 2], E[I + 500 >> 2] = d, d = E[I + 540 >> 2], E[I + 488 >> 2] = E[I + 536 >> 2], E[I + 492 >> 2] = d, d = E[I + 532 >> 2], E[I + 480 >> 2] = E[I + 528 >> 2], E[I + 484 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d = I + 480 | 0), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J = I + 432 | 0), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d; v(d = I + 528 | 0, d), 120 != (0 | (W = W + 1 | 0)););
                                        Y(d, d, I + 432 | 0), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), Y(d, d, I + 480 | 0), v(d, d), v(d, d), v(d, d), Y(d, d, I), v(d, d), BI(I + 400 | 0, d), z = E[I + 256 >> 2], j = E[I + 260 >> 2], X = E[I + 264 >> 2], O = E[I + 268 >> 2], V = E[I + 272 >> 2], l = E[I + 276 >> 2], u = E[I + 280 >> 2], H = E[I + 284 >> 2], J = E[I + 288 >> 2], x = (P = 0 - (1 & o[I + 401 | 0]) | 0) & (0 - (d = E[I + 292 >> 2]) ^ d) ^ d, E[I + 660 >> 2] = x, L = J ^ P & (J ^ 0 - J), E[I + 656 >> 2] = L, q = H ^ P & (H ^ 0 - H), E[I + 652 >> 2] = q, U = u ^ P & (u ^ 0 - u), E[I + 648 >> 2] = U, m = l ^ P & (l ^ 0 - l), E[I + 644 >> 2] = m, l = V ^ P & (V ^ 0 - V), E[I + 640 >> 2] = l, u = O ^ P & (O ^ 0 - O), E[I + 636 >> 2] = u, H = X ^ P & (X ^ 0 - X), E[I + 632 >> 2] = H, J = j ^ P & (j ^ 0 - j), E[I + 628 >> 2] = J, d = (z ^ P & (z ^ 0 - z)) - (486662 & P) | 0, E[I + 624 >> 2] = d + 1, E[I + 820 >> 2] = x, E[I + 816 >> 2] = L, E[I + 812 >> 2] = q, E[I + 808 >> 2] = U, E[I + 804 >> 2] = m, E[I + 800 >> 2] = l, E[I + 796 >> 2] = u, E[I + 792 >> 2] = H, E[I + 788 >> 2] = J, E[I + 784 >> 2] = d - 1, vA(I, I + 624 | 0), Y(d = I + 912 | 0, I + 784 | 0, I), BI(A, d), o[A + 31 | 0] = a[A + 31 | 0] | s, bA(I, A) && (y(), Q()), d = E[I + 36 >> 2], E[I + 816 >> 2] = E[I + 32 >> 2], E[I + 820 >> 2] = d, d = E[I + 28 >> 2], E[I + 808 >> 2] = E[I + 24 >> 2], E[I + 812 >> 2] = d, d = E[I + 20 >> 2], E[I + 800 >> 2] = E[I + 16 >> 2], E[I + 804 >> 2] = d, d = E[I + 12 >> 2], E[I + 792 >> 2] = E[I + 8 >> 2], E[I + 796 >> 2] = d, d = E[I + 52 >> 2], E[I + 832 >> 2] = E[I + 48 >> 2], E[I + 836 >> 2] = d, d = E[I + 60 >> 2], E[I + 840 >> 2] = E[I + 56 >> 2], E[I + 844 >> 2] = d, d = E[4 + (J = I - -64 | 0) >> 2], E[I + 848 >> 2] = E[J >> 2], E[I + 852 >> 2] = d, d = E[I + 76 >> 2], E[I + 856 >> 2] = E[I + 72 >> 2], E[I + 860 >> 2] = d, d = E[I + 4 >> 2], E[I + 784 >> 2] = E[I >> 2], E[I + 788 >> 2] = d, d = E[I + 44 >> 2], E[I + 824 >> 2] = E[I + 40 >> 2], E[I + 828 >> 2] = d, d = E[I + 116 >> 2], E[I + 896 >> 2] = E[I + 112 >> 2], E[I + 900 >> 2] = d, d = E[I + 108 >> 2], E[I + 888 >> 2] = E[I + 104 >> 2], E[I + 892 >> 2] = d, d = E[I + 100 >> 2], E[I + 880 >> 2] = E[I + 96 >> 2], E[I + 884 >> 2] = d, d = E[I + 92 >> 2], E[I + 872 >> 2] = E[I + 88 >> 2], E[I + 876 >> 2] = d, d = E[I + 84 >> 2], E[I + 864 >> 2] = E[I + 80 >> 2], E[I + 868 >> 2] = d, KA(U = I + 624 | 0, m = I + 784 | 0), Y(m, U, l = I + 744 | 0), Y(J = I + 824 | 0, H = I + 664 | 0, u = I + 704 | 0), Y(d = I + 864 | 0, u, l), KA(U, m), Y(m, U, l), Y(J, H, u), Y(d, u, l), KA(U, m), Y(I, U, l), Y(J = I + 40 | 0, H, u), Y(d = I + 80 | 0, u, l), Y(I + 120 | 0, U, H), vA(U, d), Y(m, I, U), Y(d = I + 912 | 0, J, U), BI(A, d), BI(I + 576 | 0, m), o[A + 31 | 0] = a[A + 31 | 0] ^ a[I + 576 | 0] << 7, h = I + 960 | 0, h = g + 48 | 0;
                                    }
                                    function K(A) {
                                        var I, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, c = 0, r = 0, e = 0, y = 0, s = 0, D = 0;
                                        h = I = h - 16 | 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            r: {
                                                                                                if ((A |= 0) >>> 0 <= 244) {
                                                                                                    if (3 & (g = (o = E[9393]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                        g = 37612 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[B + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (s = 37572, D = Lg(-2, C) & o, E[s >> 2] = D), A = B + 8 | 0, g = C << 3, E[B + 4 >> 2] = 3 | g, E[4 + (g = g + B | 0) >> 2] = 1 | E[g + 4 >> 2];
                                                                                                        break A;
                                                                                                    }
                                                                                                    if ((y = E[9395]) >>> 0 >= c >>> 0) break r;
                                                                                                    if (g) {
                                                                                                        g = 37612 + (A = (B = FC((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[Q + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (o = Lg(-2, B) & o, E[9393] = o), E[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, E[4 + (C = Q + c | 0) >> 2] = 1 | B, E[A + Q >> 2] = B, y && (g = 37612 + (-8 & y) | 0, i = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = i, E[A + 12 >> 2] = i, E[i + 12 >> 2] = g, E[i + 8 >> 2] = A), A = Q + 8 | 0, E[9398] = C, E[9395] = B;
                                                                                                        break A;
                                                                                                    }
                                                                                                    if (!(e = E[9394])) break r;
                                                                                                    for(C = E[37876 + (FC(e) << 2) >> 2], i = (-8 & E[C + 4 >> 2]) - c | 0, g = C; (A = E[g + 16 >> 2]) || (A = E[g + 20 >> 2]);)i = (B = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                    if (r = E[C + 24 >> 2], (0 | (B = E[C + 12 >> 2])) != (0 | C)) {
                                                                                                        A = E[C + 8 >> 2], E[A + 12 >> 2] = B, E[B + 8 >> 2] = A;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (!(A = E[(g = C + 20 | 0) >> 2])) {
                                                                                                        if (!(A = E[C + 16 >> 2])) break t;
                                                                                                        g = C + 16 | 0;
                                                                                                    }
                                                                                                    for(; Q = g, B = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = E[B + 16 >> 2]););
                                                                                                    E[Q >> 2] = 0;
                                                                                                    break I;
                                                                                                }
                                                                                                if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), e = E[9394])) {
                                                                                                    i = 0 - c | 0, o = 0, c >>> 0 < 256 || (o = 31, c >>> 0 > 16777215 || (o = 62 + ((c >>> 38 - (A = t(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            if (g = E[37876 + (o << 2) >> 2]) for(A = 0, C = c << (31 != (0 | o) ? 25 - (o >>> 1 | 0) | 0 : 0);;){
                                                                                                                if (!((Q = (-8 & E[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                    i = 0, A = g;
                                                                                                                    break y;
                                                                                                                }
                                                                                                                if (Q = E[g + 20 >> 2], g = E[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                            }
                                                                                                            else A = 0;
                                                                                                            if (!(A | B)) {
                                                                                                                if (B = 0, !(A = (0 - (A = 2 << o) | A) & e)) break r;
                                                                                                                A = E[37876 + (FC(A) << 2) >> 2];
                                                                                                            }
                                                                                                            if (!A) break e;
                                                                                                        }
                                                                                                        for(; i = (C = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = E[A + 16 >> 2]) || E[A + 20 >> 2];);
                                                                                                    }
                                                                                                    if (!(!B | E[9395] - c >>> 0 <= i >>> 0)) {
                                                                                                        if (o = E[B + 24 >> 2], (0 | B) != (0 | (C = E[B + 12 >> 2]))) {
                                                                                                            A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[C + 8 >> 2] = A;
                                                                                                            break g;
                                                                                                        }
                                                                                                        if (!(A = E[(g = B + 20 | 0) >> 2])) {
                                                                                                            if (!(A = E[B + 16 >> 2])) break c;
                                                                                                            g = B + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, C = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = E[C + 16 >> 2]););
                                                                                                        E[Q >> 2] = 0;
                                                                                                        break g;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            if ((A = E[9395]) >>> 0 >= c >>> 0) {
                                                                                                B = E[9398], (g = A - c | 0) >>> 0 >= 16 ? (E[4 + (C = B + c | 0) >> 2] = 1 | g, E[A + B >> 2] = g, E[B + 4 >> 2] = 3 | c) : (E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2], C = 0, g = 0), E[9395] = g, E[9398] = C, A = B + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if ((r = E[9396]) >>> 0 > c >>> 0) {
                                                                                                g = r - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if (A = 0, e = c + 47 | 0, E[9511] ? C = E[9513] : (E[9514] = -1, E[9515] = -1, E[9512] = 4096, E[9513] = 4096, E[9511] = I + 12 & -16 ^ 1431655768, E[9516] = 0, E[9504] = 0, C = 4096), (g = (Q = e + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                            if ((B = E[9503]) && B >>> 0 < (o = (C = E[9501]) + g | 0) >>> 0 | C >>> 0 >= o >>> 0) break A;
                                                                                            r: {
                                                                                                if (!(4 & a[38016])) {
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            s: {
                                                                                                                h: {
                                                                                                                    if (B = E[9399]) for(A = 38020;;){
                                                                                                                        if ((C = E[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + E[A + 4 >> 2] >>> 0) break h;
                                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                                    }
                                                                                                                    if (-1 == (0 | (C = cg(0)))) break e;
                                                                                                                    if (o = g, (A = (B = E[9512]) - 1 | 0) & C && (o = (g - C | 0) + (A + C & 0 - B) | 0), o >>> 0 <= c >>> 0) break e;
                                                                                                                    if ((B = E[9503]) && B >>> 0 < (i = (A = E[9501]) + o | 0) >>> 0 | A >>> 0 >= i >>> 0) break e;
                                                                                                                    if ((0 | C) != (0 | (A = cg(o)))) break s;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if ((0 | (C = cg(o = i & Q - r))) == (E[A >> 2] + E[A + 4 >> 2] | 0)) break y;
                                                                                                                A = C;
                                                                                                            }
                                                                                                            if (-1 == (0 | A)) break e;
                                                                                                            if (c + 48 >>> 0 <= o >>> 0) {
                                                                                                                C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 == (0 | cg(C = (C = E[9513]) + (e - o | 0) & 0 - C))) break e;
                                                                                                            o = C + o | 0, C = A;
                                                                                                            break r;
                                                                                                        }
                                                                                                        if (-1 != (0 | C)) break r;
                                                                                                    }
                                                                                                    E[9504] = 4 | E[9504];
                                                                                                }
                                                                                                if (-1 == (0 | (C = cg(g))) | -1 == (0 | (A = cg(0))) | A >>> 0 <= C >>> 0) break E;
                                                                                                if ((o = A - C | 0) >>> 0 <= c + 40 >>> 0) break E;
                                                                                            }
                                                                                            A = E[9501] + o | 0, E[9501] = A, A >>> 0 > _[9502] && (E[9502] = A);
                                                                                            r: {
                                                                                                if (Q = E[9399]) {
                                                                                                    for(A = 38020;;){
                                                                                                        if (((B = E[A >> 2]) + (g = E[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                    }
                                                                                                    break _;
                                                                                                }
                                                                                                for((A = E[9397]) >>> 0 <= C >>> 0 && A || (E[9397] = C), A = 0, E[9506] = o, E[9505] = C, E[9401] = -1, E[9402] = E[9511], E[9508] = 0; g = 37612 + (B = A << 3) | 0, E[B + 37620 >> 2] = g, E[B + 37624 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                                break a;
                                                                                            }
                                                                                            if (8 & E[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break _;
                                                                                            E[A + 4 >> 2] = g + o, C = (A = -8 - Q & 7) + Q | 0, E[9399] = C, A = (g = E[9396] + o | 0) - A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[4 + (g + Q | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                            break a;
                                                                                        }
                                                                                        B = 0;
                                                                                        break I;
                                                                                    }
                                                                                    C = 0;
                                                                                    break g;
                                                                                }
                                                                                _[9397] > C >>> 0 && (E[9397] = C), g = C + o | 0, A = 38020;
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            for(;;){
                                                                                                if ((0 | g) != E[A >> 2]) {
                                                                                                    if (A = E[A + 8 >> 2]) continue;
                                                                                                    break t;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            if (!(8 & a[A + 12 | 0])) break c;
                                                                                        }
                                                                                        for(A = 38020;;){
                                                                                            if ((g = E[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + E[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break _;
                                                                                            A = E[A + 8 >> 2];
                                                                                        }
                                                                                    }
                                                                                    if (E[A >> 2] = C, E[A + 4 >> 2] = E[A + 4 >> 2] + o, E[4 + (e = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (o = g + (-8 - g & 7) | 0) - (r = c + e | 0) | 0, (0 | Q) == (0 | o)) {
                                                                                        E[9399] = r, A = E[9396] + A | 0, E[9396] = A, E[r + 4 >> 2] = 1 | A;
                                                                                        break C;
                                                                                    }
                                                                                    if (E[9398] == (0 | o)) {
                                                                                        E[9398] = r, A = E[9395] + A | 0, E[9395] = A, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A;
                                                                                        break C;
                                                                                    }
                                                                                    if (1 != (3 & (i = E[o + 4 >> 2]))) break B;
                                                                                    if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                        if ((0 | (C = E[o + 12 >> 2])) == (0 | (g = E[o + 8 >> 2]))) {
                                                                                            s = 37572, D = E[9393] & Lg(-2, i >>> 3 | 0), E[s >> 2] = D;
                                                                                            break Q;
                                                                                        }
                                                                                        E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break Q;
                                                                                    }
                                                                                    if (c = E[o + 24 >> 2], (0 | o) != (0 | (C = E[o + 12 >> 2]))) {
                                                                                        g = E[o + 8 >> 2], E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break i;
                                                                                    }
                                                                                    if (!(i = E[(g = o + 20 | 0) >> 2])) {
                                                                                        if (!(i = E[o + 16 >> 2])) break o;
                                                                                        g = o + 16 | 0;
                                                                                    }
                                                                                    for(; B = g, (i = E[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = E[C + 16 >> 2]););
                                                                                    E[B >> 2] = 0;
                                                                                    break i;
                                                                                }
                                                                                for(g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515], E[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = E[9508], E[B + 16 >> 2] = E[9507], E[B + 20 >> 2] = A, A = E[9506], E[B + 8 >> 2] = E[9505], E[B + 12 >> 2] = A, E[9507] = B + 8, E[9506] = o, E[9505] = C, E[9508] = 0, A = B + 24 | 0; E[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                if ((0 | B) != (0 | Q)) {
                                                                                    if (E[B + 4 >> 2] = -2 & E[B + 4 >> 2], i = B - Q | 0, E[Q + 4 >> 2] = 1 | i, E[B >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    else {
                                                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                                                        _: {
                                                                                            if ((B = E[9394]) & (C = 1 << A)) {
                                                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = E[g >> 2];;){
                                                                                                    if ((0 | i) == (-8 & E[(g = B) + 4 >> 2])) break _;
                                                                                                    if (C = A >>> 29 | 0, A <<= 1, !(B = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                }
                                                                                                E[C + 16 >> 2] = Q;
                                                                                            } else E[9394] = C | B, E[g >> 2] = Q;
                                                                                            E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                                                            break a;
                                                                                        }
                                                                                        A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (!((A = E[9396]) >>> 0 <= c >>> 0)) {
                                                                                g = A - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                break A;
                                                                            }
                                                                        }
                                                                        E[9392] = 48, A = 0;
                                                                        break A;
                                                                    }
                                                                    C = 0;
                                                                }
                                                                if (c) {
                                                                    B = E[o + 28 >> 2];
                                                                    i: {
                                                                        if (E[(g = 37876 + (B << 2) | 0) >> 2] == (0 | o)) {
                                                                            if (E[g >> 2] = C, C) break i;
                                                                            s = 37576, D = E[9394] & Lg(-2, B), E[s >> 2] = D;
                                                                            break Q;
                                                                        }
                                                                        if (E[c + (E[c + 16 >> 2] == (0 | o) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                    }
                                                                    E[C + 24 >> 2] = c, (g = E[o + 16 >> 2]) && (E[C + 16 >> 2] = g, E[g + 24 >> 2] = C), (g = E[o + 20 >> 2]) && (E[C + 20 >> 2] = g, E[g + 24 >> 2] = C);
                                                                }
                                                            }
                                                            A = A + Q | 0, i = E[4 + (o = Q + o | 0) >> 2];
                                                        }
                                                        if (E[o + 4 >> 2] = -2 & i, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A, A >>> 0 <= 255) g = 37612 + (-8 & A) | 0, (C = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = r, E[A + 12 >> 2] = r, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        else {
                                                            i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = t(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), E[r + 28 >> 2] = i, E[r + 16 >> 2] = 0, E[r + 20 >> 2] = 0, g = 37876 + (i << 2) | 0;
                                                            B: {
                                                                if ((B = E[9394]) & (C = 1 << i)) {
                                                                    for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = E[g >> 2];;){
                                                                        if (g = C, (-8 & E[C + 4 >> 2]) == (0 | A)) break B;
                                                                        if (B = i >>> 29 | 0, i <<= 1, !(C = E[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                    }
                                                                    E[B + 16 >> 2] = r;
                                                                } else E[9394] = C | B, E[g >> 2] = r;
                                                                E[r + 24 >> 2] = g, E[r + 12 >> 2] = r, E[r + 8 >> 2] = r;
                                                                break C;
                                                            }
                                                            A = E[g + 8 >> 2], E[A + 12 >> 2] = r, E[g + 8 >> 2] = r, E[r + 24 >> 2] = 0, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        }
                                                    }
                                                    A = e + 8 | 0;
                                                    break A;
                                                }
                                                g: if (o) {
                                                    g = E[B + 28 >> 2];
                                                    C: {
                                                        if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                            if (E[A >> 2] = C, C) break C;
                                                            e = Lg(-2, g) & e, E[9394] = e;
                                                            break g;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                    }
                                                    E[C + 24 >> 2] = o, (A = E[B + 16 >> 2]) && (E[C + 16 >> 2] = A, E[A + 24 >> 2] = C), (A = E[B + 20 >> 2]) && (E[C + 20 >> 2] = A, E[A + 24 >> 2] = C);
                                                }
                                                g: if (i >>> 0 <= 15) A = i + c | 0, E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2];
                                                else if (E[B + 4 >> 2] = 3 | c, E[4 + (Q = B + c | 0) >> 2] = 1 | i, E[Q + i >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                else {
                                                    A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                    C: {
                                                        if ((C = 1 << A) & e) {
                                                            for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = E[g >> 2];;){
                                                                if ((-8 & E[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                if (C = A >>> 29 | 0, A <<= 1, !(c = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                            }
                                                            E[C + 16 >> 2] = Q;
                                                        } else E[9394] = C | e, E[g >> 2] = Q;
                                                        E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                        break g;
                                                    }
                                                    A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                }
                                                A = B + 8 | 0;
                                                break A;
                                            }
                                            I: if (r) {
                                                g = E[C + 28 >> 2];
                                                g: {
                                                    if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                        if (E[A >> 2] = B, B) break g;
                                                        s = 37576, D = Lg(-2, g) & e, E[s >> 2] = D;
                                                        break I;
                                                    }
                                                    if (E[r + (E[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                }
                                                E[B + 24 >> 2] = r, (A = E[C + 16 >> 2]) && (E[B + 16 >> 2] = A, E[A + 24 >> 2] = B), (A = E[C + 20 >> 2]) && (E[B + 20 >> 2] = A, E[A + 24 >> 2] = B);
                                            }
                                            i >>> 0 <= 15 ? (A = i + c | 0, E[C + 4 >> 2] = 3 | A, E[4 + (A = A + C | 0) >> 2] = 1 | E[A + 4 >> 2]) : (E[C + 4 >> 2] = 3 | c, E[4 + (B = C + c | 0) >> 2] = 1 | i, E[B + i >> 2] = i, y && (g = 37612 + (-8 & y) | 0, Q = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A), E[9398] = B, E[9395] = i), A = C + 8 | 0;
                                        }
                                        return h = I + 16 | 0, 0 | A;
                                    }
                                    function H(A, I, g, C, B, Q) {
                                        var i, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0;
                                        if (h = i = h - 592 | 0, r = -1, ZI(t = A + 32 | 0) && !bI(A) && GI(B) && !bI(B) && !qA(y = i + 128 | 0, B)) {
                                            for(SI(r = i + 384 | 0), Q && nA(r, 35600, 34, 0), nA(r, A, 32, 0), nA(r, B, 32, 0), nA(r, I, g, C), z(I = r, r = i + 320 | 0), N(r), C = i + 8 | 0, g = t, B = 0, I = 0, h = _ = h - 2272 | 0; t = r + (B >>> 3 | 0) | 0, o[(Q = _ + 2016 | 0) + B | 0] = a[0 | t] >>> (6 & B) & 1, o[(e = Q) + (Q = 1 | B) | 0] = a[0 | t] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (Q = I) + 1 | 0;
                                                A: if (!(Q >>> 0 > 254) && a[0 | (D = (B = _ + 2016 | 0) + Q | 0)]) {
                                                    I: if (B = o[0 | (s = I + B | 0)]) {
                                                        if ((0 | (B = (r = B << 1) + (t = o[0 | D]) | 0)) <= 15) o[0 | D] = B, o[0 | s] = 0;
                                                        else {
                                                            if ((0 | (B = t - r | 0)) < -15) break A;
                                                            for(o[0 | D] = B, B = I;;){
                                                                if (!a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                    o[0 | t] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, !t) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(Q >>> 0 > 253)) {
                                                        I: if (t = o[0 | (e = (B = Q + 2 | 0) + (_ + 2016 | 0) | 0)]) {
                                                            if ((0 | (t = (s = t << 2) + (r = o[0 | D]) | 0)) >= 16) {
                                                                if ((0 | (t = r - s | 0)) < -15) break A;
                                                                for(o[0 | D] = t;;){
                                                                    if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                        if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | t] = 1;
                                                            } else o[0 | D] = t, o[0 | e] = 0;
                                                        }
                                                        if (!(Q >>> 0 > 252)) {
                                                            I: if (t = o[0 | (e = (B = Q + 3 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                if ((0 | (t = (s = t << 3) + (r = o[0 | D]) | 0)) >= 16) {
                                                                    if ((0 | (t = r - s | 0)) < -15) break A;
                                                                    for(o[0 | D] = t;;){
                                                                        if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                            if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | t] = 1;
                                                                } else o[0 | D] = t, o[0 | e] = 0;
                                                            }
                                                            if (!(Q >>> 0 > 251)) {
                                                                I: if (t = o[0 | (e = (B = Q + 4 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                    if ((0 | (t = (s = t << 4) + (r = o[0 | D]) | 0)) >= 16) {
                                                                        if ((0 | (t = r - s | 0)) < -15) break A;
                                                                        for(o[0 | D] = t;;){
                                                                            if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | t] = 1;
                                                                    } else o[0 | D] = t, o[0 | e] = 0;
                                                                }
                                                                if (!(Q >>> 0 > 250)) {
                                                                    I: if (t = o[0 | (e = (B = Q + 5 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                        if ((0 | (t = (s = t << 5) + (r = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (t = r - s | 0)) < -15) break A;
                                                                            for(o[0 | D] = t;;){
                                                                                if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | t] = 1;
                                                                        } else o[0 | D] = t, o[0 | e] = 0;
                                                                    }
                                                                    if (!(Q >>> 0 > 249) && (Q = o[0 | (s = (B = Q + 6 | 0) + (_ + 2016 | 0) | 0)])) {
                                                                        if ((0 | (Q = (r = Q << 6) + (t = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | D] = Q;;){
                                                                                if (a[0 | (Q = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | D] = Q, o[0 | s] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; Q = g + (B >>> 3 | 0) | 0, o[(I = _ + 1760 | 0) + B | 0] = a[0 | Q] >>> (6 & B) & 1, o[(t = I) + (I = 1 | B) | 0] = a[0 | Q] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                g = I, I = I + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (e = (B = _ + 1760 | 0) + g | 0)]) {
                                                    I: if (B = o[0 | (r = I + B | 0)]) {
                                                        if ((0 | (B = (t = B << 1) + (Q = o[0 | e]) | 0)) <= 15) o[0 | e] = B, o[0 | r] = 0;
                                                        else {
                                                            if ((0 | (B = Q - t | 0)) < -15) break A;
                                                            for(o[0 | e] = B, B = I;;){
                                                                if (!a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                    o[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = o[0 | (s = (B = g + 2 | 0) + (_ + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (r = Q << 2) + (t = o[0 | e]) | 0)) >= 16) {
                                                                if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                for(o[0 | e] = Q;;){
                                                                    if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                        if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | Q] = 1;
                                                            } else o[0 | e] = Q, o[0 | s] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = o[0 | (s = (B = g + 3 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (r = Q << 3) + (t = o[0 | e]) | 0)) >= 16) {
                                                                    if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                    for(o[0 | e] = Q;;){
                                                                        if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                            if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | Q] = 1;
                                                                } else o[0 | e] = Q, o[0 | s] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = o[0 | (s = (B = g + 4 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (r = Q << 4) + (t = o[0 | e]) | 0)) >= 16) {
                                                                        if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                        for(o[0 | e] = Q;;){
                                                                            if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | Q] = 1;
                                                                    } else o[0 | e] = Q, o[0 | s] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = o[0 | (s = (B = g + 5 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (r = Q << 5) + (t = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | e] = Q;;){
                                                                                if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | e] = Q, o[0 | s] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = o[0 | (r = (B = g + 6 | 0) + (_ + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (t = g << 6) + (Q = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - t | 0)) < -15) break A;
                                                                            for(o[0 | e] = g;;){
                                                                                if (a[0 | (g = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | g] = 1;
                                                                        } else o[0 | e] = g, o[0 | r] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(TA(B = _ + 480 | 0, y), I = E[y + 36 >> 2], E[_ + 192 >> 2] = E[y + 32 >> 2], E[_ + 196 >> 2] = I, I = E[y + 28 >> 2], E[_ + 184 >> 2] = E[y + 24 >> 2], E[_ + 188 >> 2] = I, I = E[y + 20 >> 2], E[_ + 176 >> 2] = E[y + 16 >> 2], E[_ + 180 >> 2] = I, I = E[y + 12 >> 2], E[_ + 168 >> 2] = E[y + 8 >> 2], E[_ + 172 >> 2] = I, I = E[y + 4 >> 2], E[_ + 160 >> 2] = E[y >> 2], E[_ + 164 >> 2] = I, I = E[y + 52 >> 2], E[_ + 208 >> 2] = E[y + 48 >> 2], E[_ + 212 >> 2] = I, I = E[y + 60 >> 2], E[_ + 216 >> 2] = E[y + 56 >> 2], E[_ + 220 >> 2] = I, I = E[4 + (g = y - -64 | 0) >> 2], E[_ + 224 >> 2] = E[g >> 2], E[_ + 228 >> 2] = I, I = E[y + 76 >> 2], E[_ + 232 >> 2] = E[y + 72 >> 2], E[_ + 236 >> 2] = I, I = E[y + 44 >> 2], E[_ + 200 >> 2] = E[y + 40 >> 2], E[_ + 204 >> 2] = I, I = E[y + 92 >> 2], E[_ + 248 >> 2] = E[y + 88 >> 2], E[_ + 252 >> 2] = I, I = E[y + 100 >> 2], E[_ + 256 >> 2] = E[y + 96 >> 2], E[_ + 260 >> 2] = I, I = E[y + 108 >> 2], E[_ + 264 >> 2] = E[y + 104 >> 2], E[_ + 268 >> 2] = I, I = E[y + 116 >> 2], E[_ + 272 >> 2] = E[y + 112 >> 2], E[_ + 276 >> 2] = I, I = E[y + 84 >> 2], E[_ + 240 >> 2] = E[y + 80 >> 2], E[_ + 244 >> 2] = I, KA(Q = _ + 320 | 0, g = _ + 160 | 0), Y(_, Q, p = _ + 440 | 0), Y(_ + 40 | 0, w = _ + 360 | 0, f = _ + 400 | 0), Y(_ + 80 | 0, f, p), Y(_ + 120 | 0, Q, w), sA(Q, _, B), Y(g, Q, p), Y(k = _ + 200 | 0, w, f), Y(F = _ + 240 | 0, f, p), Y(n = _ + 280 | 0, Q, w), TA(I = _ + 640 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 800 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 960 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1120 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1280 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1440 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(_ + 1600 | 0, g), E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, E[C + 8 >> 2] = 0, E[C + 12 >> 2] = 0, E[C >> 2] = 0, E[C + 4 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[(R = C + 40 | 0) >> 2] = 1, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = 0, E[C + 68 >> 2] = 0, E[C + 72 >> 2] = 0, E[C + 84 >> 2] = 0, E[C + 88 >> 2] = 0, E[C + 76 >> 2] = 0, E[C + 80 >> 2] = 1, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, O = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = _ + 2016 | 0) + I | 0] && !a[(B = _ + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; KA(B = _ + 320 | 0, C), g = I, (0 | (Q = o[I + (_ + 2016 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), sA(B, I, (_ + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), hA(B, I, (_ + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (u = o[g + (_ + 1760 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), DA(B, I, c((254 & u) >>> 1 | 0, 120) + 1744 | 0)) : (0 | u) >= 0 || (Y(_ + 160 | 0, x = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, x, w), S = E[_ + 160 >> 2], G = E[_ + 200 >> 2], M = E[_ + 164 >> 2], b = E[_ + 204 >> 2], K = E[_ + 168 >> 2], H = E[_ + 208 >> 2], d = E[_ + 172 >> 2], J = E[_ + 212 >> 2], U = E[_ + 176 >> 2], l = E[_ + 216 >> 2], m = E[_ + 180 >> 2], D = E[_ + 220 >> 2], e = E[_ + 184 >> 2], s = E[_ + 224 >> 2], r = E[_ + 188 >> 2], y = E[_ + 228 >> 2], t = E[_ + 192 >> 2], Q = E[_ + 232 >> 2], B = E[_ + 236 >> 2], I = E[_ + 196 >> 2], E[_ + 396 >> 2] = B - I, E[_ + 392 >> 2] = Q - t, E[_ + 388 >> 2] = y - r, E[_ + 384 >> 2] = s - e, E[_ + 380 >> 2] = D - m, E[_ + 376 >> 2] = l - U, E[_ + 372 >> 2] = J - d, E[_ + 368 >> 2] = H - K, E[_ + 364 >> 2] = b - M, E[_ + 360 >> 2] = G - S, E[_ + 356 >> 2] = I + B, E[_ + 352 >> 2] = Q + t, E[_ + 348 >> 2] = r + y, E[_ + 344 >> 2] = e + s, E[_ + 340 >> 2] = D + m, E[_ + 336 >> 2] = U + l, E[_ + 332 >> 2] = d + J, E[_ + 328 >> 2] = K + H, E[_ + 324 >> 2] = M + b, E[_ + 320 >> 2] = S + G, Y(f, x, 40 + (I = c((0 - u & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), Y(w, w, I), Y(p, I + 80 | 0, n), V = E[_ + 276 >> 2], Z = E[_ + 272 >> 2], u = E[_ + 268 >> 2], x = E[_ + 264 >> 2], e = E[_ + 260 >> 2], s = E[_ + 256 >> 2], r = E[_ + 252 >> 2], y = E[_ + 248 >> 2], t = E[_ + 244 >> 2], Q = E[_ + 240 >> 2], v = E[_ + 360 >> 2], L = E[_ + 400 >> 2], P = E[_ + 364 >> 2], q = E[_ + 404 >> 2], j = E[_ + 368 >> 2], X = E[_ + 408 >> 2], S = E[_ + 372 >> 2], G = E[_ + 412 >> 2], M = E[_ + 376 >> 2], b = E[_ + 416 >> 2], K = E[_ + 380 >> 2], H = E[_ + 420 >> 2], d = E[_ + 384 >> 2], J = E[_ + 424 >> 2], U = E[_ + 388 >> 2], l = E[_ + 428 >> 2], m = E[_ + 392 >> 2], D = E[_ + 432 >> 2], B = E[_ + 396 >> 2], I = E[_ + 436 >> 2], E[_ + 396 >> 2] = B + I, E[_ + 392 >> 2] = D + m, E[_ + 388 >> 2] = U + l, E[_ + 384 >> 2] = d + J, E[_ + 380 >> 2] = K + H, E[_ + 376 >> 2] = M + b, E[_ + 372 >> 2] = S + G, E[_ + 368 >> 2] = j + X, E[_ + 364 >> 2] = P + q, E[_ + 360 >> 2] = v + L, E[_ + 356 >> 2] = I - B, E[_ + 352 >> 2] = D - m, E[_ + 348 >> 2] = l - U, E[_ + 344 >> 2] = J - d, E[_ + 340 >> 2] = H - K, E[_ + 336 >> 2] = b - M, E[_ + 332 >> 2] = G - S, E[_ + 328 >> 2] = X - j, E[_ + 324 >> 2] = q - P, E[_ + 320 >> 2] = L - v, S = Q << 1, G = E[_ + 440 >> 2], E[_ + 400 >> 2] = S - G, M = t << 1, b = E[_ + 444 >> 2], E[_ + 404 >> 2] = M - b, K = y << 1, H = E[_ + 448 >> 2], E[_ + 408 >> 2] = K - H, d = r << 1, J = E[_ + 452 >> 2], E[_ + 412 >> 2] = d - J, U = s << 1, l = E[_ + 456 >> 2], E[_ + 416 >> 2] = U - l, m = e << 1, D = E[_ + 460 >> 2], E[_ + 420 >> 2] = m - D, e = x << 1, s = E[_ + 464 >> 2], E[_ + 424 >> 2] = e - s, r = u << 1, y = E[_ + 468 >> 2], E[_ + 428 >> 2] = r - y, t = Z << 1, Q = E[_ + 472 >> 2], E[_ + 432 >> 2] = t - Q, B = V << 1, I = E[_ + 476 >> 2], E[_ + 436 >> 2] = B - I, E[_ + 440 >> 2] = S + G, E[_ + 444 >> 2] = M + b, E[_ + 448 >> 2] = K + H, E[_ + 452 >> 2] = d + J, E[_ + 456 >> 2] = U + l, E[_ + 460 >> 2] = D + m, E[_ + 464 >> 2] = e + s, E[_ + 468 >> 2] = r + y, E[_ + 472 >> 2] = Q + t, E[_ + 476 >> 2] = I + B), Y(C, _ + 320 | 0, p), Y(R, w, f), Y(O, f, p), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            h = _ + 2272 | 0, tg(I = i + 288 | 0, C), W = -1, T = SC(I, A), r = ((0 | A) == (0 | I) ? W : T) | MI(A, I, 32);
                                        }
                                        return h = i + 592 | 0, r;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        QA = Ig(C = E[g + 4 >> 2], e = C >> 31, fA = (f = E[I + 20 >> 2]) << 1, l = fA >> 31), oA = w, iA = (hA = Ig(pA = E[g >> 2], Q = pA >> 31, B = E[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, rA = Ig(o = E[g + 8 >> 2], h = o >> 31, hA = E[I + 16 >> 2], a = hA >> 31), oA = w + QA | 0, oA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? oA + 1 | 0 : oA, QA = (rA = Ig(y = E[g + 12 >> 2], n = y >> 31, b = (k = E[I + 12 >> 2]) << 1, m = b >> 31)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, oA = (DA = Ig(D = E[g + 16 >> 2], K = D >> 31, rA = E[I + 8 >> 2], _ = rA >> 31)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < DA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(F = E[g + 20 >> 2], u = F >> 31, H = (N = E[I + 4 >> 2]) << 1, x = H >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, W = cA = E[g + 24 >> 2], oA = (eA = Ig(cA, V = cA >> 31, DA = E[I >> 2], t = DA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, R = E[g + 28 >> 2], QA = (eA = Ig(sA = c(R, 19), S = sA >> 31, Y = (G = E[I + 36 >> 2]) << 1, v = Y >> 31)) + oA | 0, oA = w + iA | 0, oA = QA >>> 0 < eA >>> 0 ? oA + 1 | 0 : oA, NA = E[g + 32 >> 2], iA = (tA = Ig(EA = c(NA, 19), p = EA >> 31, eA = E[I + 32 >> 2], r = eA >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, T = E[g + 36 >> 2], g = Ig(tA = c(T, 19), s = tA >> 31, d = (M = E[I + 28 >> 2]) << 1, L = d >> 31), QA = w + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = Ig(hA, a, C, e), QA = w, iA = Ig(pA, Q, f, P = f >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(o, h, k, q = k >> 31), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(rA, _, y, n), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(D, K, N, z = N >> 31), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(DA, t, F, u), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(cA = c(cA, 19), J = cA >> 31, G, j = G >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(eA, r, sA, S), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(EA, p, M, X = M >> 31), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(tA, s, B, i), QA = w + QA | 0, GA = I = iA + I | 0, nA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = Ig(C, e, b, m), QA = w, iA = Ig(pA, Q, hA, a), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(rA, _, o, h), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(y, n, H, x), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(DA, t, D, K), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(U = c(F, 19), O = U >> 31, Y, v), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(eA, r, cA, J), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(sA, S, d, L), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(EA, p, B, i), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(tA, s, fA, l), QA = w + iA | 0, $ = I = oA + I | 0, AA = QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, oA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + nA | 0, GA = I = oA + GA | 0, QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (oA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (oA = (33554431 & oA) << 7 | I >>> 25) + aA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, kA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 24 >> 2] = iA - (-67108864 & g), g = Ig(C, e, H, x), QA = w, iA = Ig(pA, Q, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = (QA = g) + (g = Ig(DA, t, o, h)) | 0, QA = w + oA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(g = c(y, 19), FA = g >> 31, Y, v), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(eA, r, nA = c(D, 19), Z = nA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = Ig(d, L, U, O), QA = w + iA | 0, QA = (oA = aA + oA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = Ig(B, i, cA, J)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < aA >>> 0 ? oA + 1 | 0 : oA, aA = Ig(sA, S, fA, l), QA = w + oA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, hA, a), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(tA, s, b, m)) + iA | 0, iA = w + QA | 0, yA = oA, MA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(DA, t, C, e), iA = w, oA = (aA = Ig(pA, Q, N, z)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(o, 19), iA = (_A = Ig(iA, SA = iA >> 31, G, j)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(eA, r, g, FA), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(nA, Z, M, X), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (_A = Ig(B, i, U, O)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < _A >>> 0 ? iA + 1 | 0 : iA, _A = Ig(cA, J, f, P), QA = w + iA | 0, QA = (oA = _A + oA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, iA = (_A = Ig(hA, a, sA, S)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(EA, p, k, q), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(tA, s, rA, _), QA = w + QA | 0, bA = iA = oA + iA | 0, _A = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, QA = Ig(QA = c(C, 19), QA >> 31, Y, v), iA = w, oA = Ig(pA, Q, DA, t), iA = w + iA | 0, iA = (QA = oA + QA | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = (aA = Ig(eA, r, aA, SA)) + QA | 0, QA = w + iA | 0, g = (iA = Ig(g, FA, d, L)) + oA | 0, oA = w + (oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, oA = g >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(B, i, nA, Z), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(fA, l, U, O), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, cA, J), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(sA, S, b, m), QA = w + iA | 0, QA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(EA, p, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(tA, s, H, x), QA = w + oA | 0, aA = g = iA + g | 0, FA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, SA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (oA = QA >> 26) + _A | 0, _A = g = (QA = (67108863 & QA) << 6 | g >>> 26) + bA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, bA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + MA | 0, QA = (g = iA + yA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = iA = (oA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 8 >> 2] = oA - (-67108864 & iA), QA = Ig(B, i, C, e), oA = w, iA = (yA = Ig(pA, Q, M, X)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, f, P), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, y, n), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, yA = Ig(D, K, k, q), oA = w + QA | 0, oA = (iA = yA + iA | 0) >>> 0 < yA >>> 0 ? oA + 1 | 0 : oA, QA = (yA = Ig(rA, _, F, u)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA, oA = (yA = Ig(N, z, W, V)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(DA, t, R, yA = R >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, G, j), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, wA = Ig(tA, s, eA, r), oA = w + QA | 0, QA = I >> 26, I = (kA = (67108863 & I) << 6 | kA >>> 26) + (iA = wA + iA | 0) | 0, iA = QA + (iA >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA) | 0, QA = (oA = I) >>> 0 < kA >>> 0 ? iA + 1 | 0 : iA, kA = iA = oA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 28 >> 2] = oA - (-33554432 & iA), QA = Ig(rA, _, C, e), iA = w, wA = Ig(pA, Q, k, q), oA = w + iA | 0, oA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA, wA = Ig(o, h, N, z), iA = w + oA | 0, iA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? iA + 1 | 0 : iA, oA = (wA = Ig(DA, t, y, n)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(nA, Z, G, j), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(eA, r, U, O), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = Ig(cA, J, M, X)) + iA | 0, oA = w + QA | 0, QA = (sA = Ig(B, i, sA, S)) + iA | 0, iA = w + (iA >>> 0 < cA >>> 0 ? oA + 1 | 0 : oA) | 0, oA = (EA = Ig(EA, p, f, P)) + QA | 0, QA = w + (QA >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(tA, s, hA, a), QA = w + QA | 0, EA = iA = iA + oA | 0, QA = (QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, EA = g = EA + (oA = (67108863 & g) << 6 | MA >>> 26) | 0, QA = g >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, sA = iA = g + 16777216 | 0, g = oA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 12 >> 2] = EA - (-33554432 & iA), QA = Ig(C, e, d, L), oA = w, iA = (EA = Ig(pA, Q, eA, r)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(B, i, o, h), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = Ig(y, n, fA, l), oA = w + QA | 0, oA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? oA + 1 | 0 : oA, QA = (EA = Ig(hA, a, D, K)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, oA = (EA = Ig(b, m, F, u)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(rA, _, W, V), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(R, yA, H, x), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = Ig(DA, t, EA = NA, cA = EA >> 31)) + iA | 0, oA = w + QA | 0, QA = (tA = Ig(tA, s, Y, v)) + iA | 0, iA = w + (iA >>> 0 < fA >>> 0 ? oA + 1 | 0 : oA) | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, NA = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = NA + (oA = (33554431 & I) << 7 | kA >>> 25) | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, tA = iA = (oA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 32 >> 2] = oA - (-67108864 & iA), iA = g >> 25, g = (sA = (33554431 & g) << 7 | sA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (oA = GA - (-33554432 & CA) | 0) | 0, E[A + 20 >> 2] = QA, E[A + 16 >> 2] = iA - (-67108864 & g), g = Ig(eA, r, C, e), QA = w, iA = Ig(pA, Q, G, j), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, M, X), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(B, i, y, n), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(D, K, f, P), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(hA, a, F, u), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(k, q, W, V), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(rA, _, R, yA), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(EA, cA, N, z), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(DA, t, T, T >> 31), QA = w + oA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (oA = g) + (g = (67108863 & I) << 6 | tA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 36 >> 2] = g - (-33554432 & I), oA = _A - (-33554432 & bA) | 0, iA = aA - (g = -67108864 & SA) | 0, pA = FA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = Ig((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = w + pA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + oA | 0, E[A + 4 >> 2] = QA, E[A >> 2] = g - (-67108864 & I);
                                    }
                                    function d(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        for(h = Q = h - 288 | 0, D = (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ C >>> 29, p = (a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24) ^ C << 3, w = (a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24) ^ g >>> 29, C = (a[0 | (c = B + 32 | 0)] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24) ^ g << 3, y = B + 16 | 0, r = B + 48 | 0, _ = B - -64 | 0, e = B + 80 | 0, i = B + 96 | 0, t = B + 112 | 0; g = E[t + 12 >> 2], E[Q + 280 >> 2] = E[t + 8 >> 2], E[Q + 284 >> 2] = g, g = E[t + 4 >> 2], E[Q + 272 >> 2] = E[t >> 2], E[Q + 276 >> 2] = g, g = E[i + 12 >> 2], E[Q + 248 >> 2] = E[i + 8 >> 2], E[Q + 252 >> 2] = g, g = E[i + 4 >> 2], E[Q + 240 >> 2] = E[i >> 2], E[Q + 244 >> 2] = g, g = E[t + 12 >> 2], E[Q + 232 >> 2] = E[t + 8 >> 2], E[Q + 236 >> 2] = g, g = E[t + 4 >> 2], E[Q + 224 >> 2] = E[t >> 2], E[Q + 228 >> 2] = g, $A(s = Q + 256 | 0, Q + 240 | 0, Q + 224 | 0), g = E[Q + 268 >> 2], E[t + 8 >> 2] = E[Q + 264 >> 2], E[t + 12 >> 2] = g, g = E[Q + 260 >> 2], E[t >> 2] = E[Q + 256 >> 2], E[t + 4 >> 2] = g, g = E[e + 12 >> 2], E[Q + 216 >> 2] = E[e + 8 >> 2], E[Q + 220 >> 2] = g, g = E[e + 4 >> 2], E[Q + 208 >> 2] = E[e >> 2], E[Q + 212 >> 2] = g, g = E[i + 12 >> 2], E[Q + 200 >> 2] = E[i + 8 >> 2], E[Q + 204 >> 2] = g, g = E[i + 4 >> 2], E[Q + 192 >> 2] = E[i >> 2], E[Q + 196 >> 2] = g, $A(s, Q + 208 | 0, Q + 192 | 0), g = E[Q + 268 >> 2], E[i + 8 >> 2] = E[Q + 264 >> 2], E[i + 12 >> 2] = g, g = E[Q + 260 >> 2], E[i >> 2] = E[Q + 256 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 184 >> 2] = E[_ + 8 >> 2], E[Q + 188 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 176 >> 2] = E[_ >> 2], E[Q + 180 >> 2] = g, g = E[e + 12 >> 2], E[Q + 168 >> 2] = E[e + 8 >> 2], E[Q + 172 >> 2] = g, g = E[e + 4 >> 2], E[Q + 160 >> 2] = E[e >> 2], E[Q + 164 >> 2] = g, $A(s, Q + 176 | 0, Q + 160 | 0), g = E[Q + 268 >> 2], E[e + 8 >> 2] = E[Q + 264 >> 2], E[e + 12 >> 2] = g, g = E[Q + 260 >> 2], E[e >> 2] = E[Q + 256 >> 2], E[e + 4 >> 2] = g, g = E[r + 12 >> 2], E[Q + 152 >> 2] = E[r + 8 >> 2], E[Q + 156 >> 2] = g, g = E[r + 4 >> 2], E[Q + 144 >> 2] = E[r >> 2], E[Q + 148 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 136 >> 2] = E[_ + 8 >> 2], E[Q + 140 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 128 >> 2] = E[_ >> 2], E[Q + 132 >> 2] = g, $A(s, Q + 144 | 0, Q + 128 | 0), g = E[Q + 268 >> 2], E[_ + 8 >> 2] = E[Q + 264 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 260 >> 2], E[_ >> 2] = E[Q + 256 >> 2], E[_ + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[r + 12 >> 2], E[Q + 104 >> 2] = E[r + 8 >> 2], E[Q + 108 >> 2] = g, g = E[r + 4 >> 2], E[Q + 96 >> 2] = E[r >> 2], E[Q + 100 >> 2] = g, $A(s, Q + 112 | 0, Q + 96 | 0), g = E[Q + 268 >> 2], E[r + 8 >> 2] = E[Q + 264 >> 2], E[r + 12 >> 2] = g, g = E[Q + 260 >> 2], E[r >> 2] = E[Q + 256 >> 2], E[r + 4 >> 2] = g, g = E[y + 12 >> 2], E[Q + 88 >> 2] = E[y + 8 >> 2], E[Q + 92 >> 2] = g, g = E[y + 4 >> 2], E[Q + 80 >> 2] = E[y >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(s, Q + 80 | 0, Q - -64 | 0), g = E[Q + 268 >> 2], E[c + 8 >> 2] = E[Q + 264 >> 2], E[c + 12 >> 2] = g, g = E[Q + 260 >> 2], E[c >> 2] = E[Q + 256 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[y + 12 >> 2], E[Q + 40 >> 2] = E[y + 8 >> 2], E[Q + 44 >> 2] = g, g = E[y + 4 >> 2], E[Q + 32 >> 2] = E[y >> 2], E[Q + 36 >> 2] = g, $A(s, Q + 48 | 0, Q + 32 | 0), g = E[Q + 268 >> 2], E[y + 8 >> 2] = E[Q + 264 >> 2], E[y + 12 >> 2] = g, g = E[Q + 260 >> 2], E[y >> 2] = E[Q + 256 >> 2], E[y + 4 >> 2] = g, g = E[Q + 284 >> 2], E[Q + 24 >> 2] = E[Q + 280 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 276 >> 2], E[Q + 16 >> 2] = E[Q + 272 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(s, Q + 16 | 0, Q), g = E[Q + 268 >> 2], E[B + 8 >> 2] = E[Q + 264 >> 2], E[B + 12 >> 2] = g, g = E[Q + 260 >> 2], E[B >> 2] = E[Q + 256 >> 2], E[B + 4 >> 2] = g, n = D ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), E[B + 12 >> 2] = n, k = p ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), E[B + 8 >> 2] = k, F = w ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E[B + 4 >> 2] = F, N = C ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[B >> 2] = N, S = C ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), E[_ >> 2] = S, G = w ^ (a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24), E[B + 68 >> 2] = G, M = p ^ (a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24), E[B + 72 >> 2] = M, b = D ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), E[B + 76 >> 2] = b, 7 != (0 | (f = f + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    _ = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, c = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, y = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, r = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, e = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, t = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, s = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, D = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, p = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, w = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, f = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, I = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, B = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24) ^ b, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = w ^ f ^ C ^ I ^ g ^ M ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = i ^ t ^ s ^ D ^ p ^ G ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = _ ^ c ^ y ^ r ^ e ^ S ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                t = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, s = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, D = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, p = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, w = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, f = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, g = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, I = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, i = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24), o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, I = C ^ I ^ g ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = p ^ w ^ f ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = t ^ s ^ D ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, r = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[B + 112 | 0] | a[B + 113 | 0] << 8 | a[B + 114 | 0] << 16 | a[B + 115 | 0] << 24, t = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, s = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, D = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, p = a[B + 116 | 0] | a[B + 117 | 0] << 8 | a[B + 118 | 0] << 16 | a[B + 119 | 0] << 24, w = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, f = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, C = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, g = a[B + 120 | 0] | a[B + 121 | 0] << 8 | a[B + 122 | 0] << 16 | a[B + 123 | 0] << 24, I = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, B = (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24) ^ (a[B + 124 | 0] | a[B + 125 | 0] << 8 | a[B + 126 | 0] << 16 | a[B + 127 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = f ^ C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ p ^ w, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = r ^ e ^ i ^ t, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 288 | 0;
                                    }
                                    function J(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I, I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I; _ = E[C + 28 >> 2], B = (I = n << 2) + g | 0, i = E[C + 16 >> 2], c = E[B >> 2] + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0, r = (_ = ((Q = E[I + 34432 >> 2] + c | 0) + (i & ((c = E[C + 24 >> 2]) ^ (e = E[C + 20 >> 2])) ^ c) | 0) + _ | 0) + E[C + 12 >> 2] | 0, E[C + 12 >> 2] = r, _ = (s = _ + (Lg(t = E[C >> 2], 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) + (t & ((Q = E[C + 8 >> 2]) | (o = E[C + 4 >> 2])) | Q & o) | 0, E[C + 28 >> 2] = _, Q = (s = Q) + (c = (E[(D = (Q = 4 | I) + g | 0) >> 2] + ((c + (e ^ r & (i ^ e)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) | 0) + E[Q + 34432 >> 2] | 0) | 0, E[C + 8 >> 2] = Q, c = (c + (_ & (o | t) | o & t) | 0) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0, E[C + 24 >> 2] = c, e = (s = o) + (o = (((e + E[(f = (o = 8 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) | 0, E[C + 4 >> 2] = e, o = o + ((c & (_ | t) | _ & t) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 20 >> 2] = o, i = (s = t) + (t = (((i + E[(k = (t = 12 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (r ^ e & (Q ^ r)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) | 0, E[C >> 2] = i, t = t + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 16 >> 2] = t, r = (y = ((((s = r) + E[(F = (r = 16 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 12 >> 2] = r, y = _ + y | 0, E[C + 28 >> 2] = y, _ = (Q = (((Q + E[(N = (_ = 20 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 8 >> 2] = _, Q = Q + c | 0, E[C + 24 >> 2] = Q, c = (e = (((e + E[(S = (c = 24 | I) + g | 0) >> 2] | 0) + E[c + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 4 >> 2] = c, e = o + e | 0, E[C + 20 >> 2] = e, o = (i = (((i + E[(G = (o = 28 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C >> 2] = o, i = i + t | 0, E[C + 16 >> 2] = i, t = (y = (((y + E[(M = (t = 32 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 28 >> 2] = t, y = r + y | 0, E[C + 12 >> 2] = y, r = (Q = (((Q + E[(b = (r = 36 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 24 >> 2] = r, Q = Q + _ | 0, E[C + 8 >> 2] = Q, _ = (e = (((e + E[(K = (_ = 40 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 20 >> 2] = _, e = c + e | 0, E[C + 4 >> 2] = e, s = (c = 44 | I) + g | 0, c = (i = ((i + (E[c + 34432 >> 2] + E[s >> 2] | 0) | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 16 >> 2] = c, o = o + i | 0, E[C >> 2] = o, w = (i = 48 | I) + g | 0, i = (y = ((y + (E[i + 34432 >> 2] + E[w >> 2] | 0) | 0) + (Q ^ o & (Q ^ e)) | 0) + (Lg(o, 26) ^ Lg(o, 21) ^ Lg(o, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 12 >> 2] = i, t = t + y | 0, E[C + 28 >> 2] = t, p = (y = 52 | I) + g | 0, Q = (y = (((E[y + 34432 >> 2] + E[p >> 2] | 0) + Q | 0) + (e ^ t & (o ^ e)) | 0) + (Lg(t, 26) ^ Lg(t, 21) ^ Lg(t, 7)) | 0) + ((i & (_ | c) | _ & c) + (Lg(i, 30) ^ Lg(i, 19) ^ Lg(i, 10)) | 0) | 0, E[C + 8 >> 2] = Q, r = r + y | 0, E[C + 24 >> 2] = r, y = (h = 56 | I) + g | 0, e = (h = (((E[h + 34432 >> 2] + E[y >> 2] | 0) + e | 0) + (o ^ r & (o ^ t)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) + ((Q & (c | i) | c & i) + (Lg(Q, 30) ^ Lg(Q, 19) ^ Lg(Q, 10)) | 0) | 0, E[C + 4 >> 2] = e, _ = _ + h | 0, E[C + 20 >> 2] = _, h = (I |= 60) + g | 0, _ = (I = ((o + (E[I + 34432 >> 2] + E[h >> 2] | 0) | 0) + (t ^ _ & (t ^ r)) | 0) + (Lg(_, 26) ^ Lg(_, 21) ^ Lg(_, 7)) | 0) + ((e & (Q | i) | Q & i) + (Lg(e, 30) ^ Lg(e, 19) ^ Lg(e, 10)) | 0) | 0, E[C >> 2] = _, E[C + 16 >> 2] = I + c, 48 != (0 | n);)o = E[b >> 2], n = n + 16 | 0, I = E[y >> 2], _ = (Q = E[B >> 2] + (o + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0) | 0) + (Lg(c = E[D >> 2], 25) ^ Lg(c, 14) ^ c >>> 3) | 0, E[(n << 2) + g >> 2] = _, r = (i = (Q = (t = E[K >> 2]) + c | 0) + (Lg(c = E[h >> 2], 15) ^ Lg(c, 13) ^ c >>> 10) | 0) + (Lg(Q = E[f >> 2], 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0, E[B + 68 >> 2] = r, e = (s = ((i = Q) + (Q = E[s >> 2]) | 0) + (Lg(_, 15) ^ Lg(_, 13) ^ _ >>> 10) | 0) + (Lg(i = E[k >> 2], 25) ^ Lg(i, 14) ^ i >>> 3) | 0, E[B + 72 >> 2] = e, y = (h = ((s = i) + (i = E[w >> 2]) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0) + (Lg(s = E[F >> 2], 25) ^ Lg(s, 14) ^ s >>> 3) | 0, E[B + 76 >> 2] = y, w = (h = ((h = s) + (s = E[p >> 2]) | 0) + (Lg(e, 15) ^ Lg(e, 13) ^ e >>> 10) | 0) + (Lg(p = E[N >> 2], 25) ^ Lg(p, 14) ^ p >>> 3) | 0, E[B + 80 >> 2] = w, p = (D = (I + p | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0) + (Lg(h = E[S >> 2], 25) ^ Lg(h, 14) ^ h >>> 3) | 0, E[B + 84 >> 2] = p, h = ((c + h | 0) + (Lg(f = E[G >> 2], 25) ^ Lg(f, 14) ^ f >>> 3) | 0) + (Lg(w, 15) ^ Lg(w, 13) ^ w >>> 10) | 0, E[B + 88 >> 2] = h, r = ((D = E[M >> 2]) + (r + (Lg(o, 25) ^ Lg(o, 14) ^ o >>> 3) | 0) | 0) + (Lg(h, 15) ^ Lg(h, 13) ^ h >>> 10) | 0, E[B + 96 >> 2] = r, D = ((_ + f | 0) + (Lg(D, 25) ^ Lg(D, 14) ^ D >>> 3) | 0) + (Lg(p, 15) ^ Lg(p, 13) ^ p >>> 10) | 0, E[B + 92 >> 2] = D, y = (y + (t + (Lg(Q, 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0, E[B + 104 >> 2] = y, o = (e + (o + (Lg(t, 25) ^ Lg(t, 14) ^ t >>> 3) | 0) | 0) + (Lg(D, 15) ^ Lg(D, 13) ^ D >>> 10) | 0, E[B + 100 >> 2] = o, t = (p + (i + (Lg(s, 25) ^ Lg(s, 14) ^ s >>> 3) | 0) | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0, E[B + 112 >> 2] = t, o = (w + (Q + (Lg(i, 25) ^ Lg(i, 14) ^ i >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 108 >> 2] = o, H = B, Y = (D + (I + (Lg(c, 25) ^ Lg(c, 14) ^ c >>> 3) | 0) | 0) + (Lg(t, 15) ^ Lg(t, 13) ^ t >>> 10) | 0, E[H + 120 >> 2] = Y, I = (h + (s + (Lg(I, 25) ^ Lg(I, 14) ^ I >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 116 >> 2] = I, H = B, Y = (r + (c + (Lg(_, 25) ^ Lg(_, 14) ^ _ >>> 3) | 0) | 0) + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0, E[H + 124 >> 2] = Y;
                                        E[A >> 2] = _ + E[A >> 2], E[A + 4 >> 2] = E[A + 4 >> 2] + E[C + 4 >> 2], E[A + 8 >> 2] = E[A + 8 >> 2] + E[C + 8 >> 2], E[A + 12 >> 2] = E[A + 12 >> 2] + E[C + 12 >> 2], E[A + 16 >> 2] = E[A + 16 >> 2] + E[C + 16 >> 2], E[A + 20 >> 2] = E[A + 20 >> 2] + E[C + 20 >> 2], E[A + 24 >> 2] = E[A + 24 >> 2] + E[C + 24 >> 2], E[A + 28 >> 2] = E[A + 28 >> 2] + E[C + 28 >> 2];
                                    }
                                    function U(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0;
                                        h = C = h - 288 | 0, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, e = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, p = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, J = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, n = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, H = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, U = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, k = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, F = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, K = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, Y = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, l = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, N = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, S = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, Q = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, d = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, m = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, G = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, M = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, i = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, b = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, B = (_ = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (c = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, m = d ^ i & M ^ m ^ G, o[A + 24 | 0] = m, o[A + 25 | 0] = m >>> 8, o[A + 26 | 0] = m >>> 16, o[A + 27 | 0] = m >>> 24, l = Y ^ Q & S ^ l ^ N, o[A + 20 | 0] = l, o[A + 21 | 0] = l >>> 8, o[A + 22 | 0] = l >>> 16, o[A + 23 | 0] = l >>> 24, U = H ^ K & F ^ U ^ k, o[A + 16 | 0] = U, o[A + 17 | 0] = U >>> 8, o[A + 18 | 0] = U >>> 16, o[A + 19 | 0] = U >>> 24, J = n & _ ^ J ^ f ^ c, o[A + 12 | 0] = J, o[A + 13 | 0] = J >>> 8, o[A + 14 | 0] = J >>> 16, o[A + 15 | 0] = J >>> 24, d = d & w ^ D ^ p ^ i, o[A + 8 | 0] = d, o[A + 9 | 0] = d >>> 8, o[A + 10 | 0] = d >>> 16, o[A + 11 | 0] = d >>> 24, Y = Y & s ^ e ^ y ^ Q, o[A + 4 | 0] = Y, o[A + 5 | 0] = Y >>> 8, o[A + 6 | 0] = Y >>> 16, o[A + 7 | 0] = Y >>> 24, H = K ^ H & r ^ t ^ b, o[0 | A] = H, o[A + 1 | 0] = H >>> 8, o[A + 2 | 0] = H >>> 16, o[A + 3 | 0] = H >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, K = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = K, K = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = K, K = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = K, $A(I, C + 176 | 0, C + 160 | 0), K = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = K, K = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = K, K = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = K, K = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = K, K = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = K, K = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = K, $A(I, C + 144 | 0, C + 128 | 0), K = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = K, K = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = K, K = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = K, K = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = K, K = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = K, K = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = K, $A(I, C + 112 | 0, C + 96 | 0), K = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = K, K = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = K, K = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = K, K = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = K, K = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = K, $A(I, C + 80 | 0, C - -64 | 0), K = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = K, K = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = K, K = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = K, K = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = K, K = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = K, $A(I, C + 48 | 0, C + 32 | 0), K = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = K, K = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = K, K = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = K, K = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = K, K = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = K, K = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = K, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = J ^ (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24), E[g + 8 >> 2] = d ^ (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24), E[g + 4 >> 2] = Y ^ (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24), E[g >> 2] = H ^ (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[g + 68 >> 2] = l ^ (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24), E[g + 72 >> 2] = m ^ (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24), E[g + 76 >> 2] = B ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function l(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0;
                                        h = C = h - 288 | 0, k = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, F = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, M = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, b = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, K = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, m = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, _ = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, H = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Y = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, c = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, t = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, r = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, J = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, e = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, y = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, s = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, U = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, l = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, D = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (w = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (f = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ (n = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24), o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = D & l ^ U ^ s ^ y, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = e & J ^ d ^ r ^ t, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = m ^ c & Y ^ H ^ _, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = K & w ^ b ^ i ^ n, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = y & M ^ G ^ Q ^ D, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = t & S ^ N ^ B ^ e, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = m & F ^ k ^ p ^ c, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, m = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = m, m = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = m, m = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = m, $A(I, C + 176 | 0, C + 160 | 0), m = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = m, m = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = m, m = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = m, m = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = m, m = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = m, m = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = m, $A(I, C + 144 | 0, C + 128 | 0), m = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = m, m = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = m, m = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = m, m = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = m, m = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = m, m = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = m, $A(I, C + 112 | 0, C + 96 | 0), m = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = m, m = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = m, m = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = m, m = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = m, m = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = m, $A(I, C + 80 | 0, C - -64 | 0), m = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = m, m = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = m, m = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = m, m = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = m, m = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = m, $A(I, C + 48 | 0, C + 32 | 0), m = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = m, m = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = m, m = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = m, m = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = m, m = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = m, m = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = m, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ i, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ Q, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ B, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ _, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ r, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ s, E[g + 76 >> 2] = f ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function m(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = Q = h - 224 | 0, p = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ C >>> 29, w = (a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24) ^ C << 3, e = (a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24) ^ g >>> 29, s = (a[0 | (i = B + 48 | 0)] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24) ^ g << 3, _ = B + 16 | 0, c = B + 32 | 0, t = B - -64 | 0, r = B + 80 | 0; g = E[r + 12 >> 2], E[Q + 216 >> 2] = E[r + 8 >> 2], E[Q + 220 >> 2] = g, g = E[r + 4 >> 2], E[Q + 208 >> 2] = E[r >> 2], E[Q + 212 >> 2] = g, g = E[t + 12 >> 2], E[Q + 184 >> 2] = E[t + 8 >> 2], E[Q + 188 >> 2] = g, g = E[t + 4 >> 2], E[Q + 176 >> 2] = E[t >> 2], E[Q + 180 >> 2] = g, g = E[r + 12 >> 2], E[Q + 168 >> 2] = E[r + 8 >> 2], E[Q + 172 >> 2] = g, g = E[r + 4 >> 2], E[Q + 160 >> 2] = E[r >> 2], E[Q + 164 >> 2] = g, $A(C = Q + 192 | 0, Q + 176 | 0, Q + 160 | 0), g = E[Q + 204 >> 2], E[r + 8 >> 2] = E[Q + 200 >> 2], E[r + 12 >> 2] = g, g = E[Q + 196 >> 2], E[r >> 2] = E[Q + 192 >> 2], E[r + 4 >> 2] = g, g = E[i + 12 >> 2], E[Q + 152 >> 2] = E[i + 8 >> 2], E[Q + 156 >> 2] = g, g = E[i + 4 >> 2], E[Q + 144 >> 2] = E[i >> 2], E[Q + 148 >> 2] = g, g = E[t + 12 >> 2], E[Q + 136 >> 2] = E[t + 8 >> 2], E[Q + 140 >> 2] = g, g = E[t + 4 >> 2], E[Q + 128 >> 2] = E[t >> 2], E[Q + 132 >> 2] = g, $A(C, Q + 144 | 0, Q + 128 | 0), g = E[Q + 204 >> 2], E[t + 8 >> 2] = E[Q + 200 >> 2], E[t + 12 >> 2] = g, g = E[Q + 196 >> 2], E[t >> 2] = E[Q + 192 >> 2], E[t + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[i + 12 >> 2], E[Q + 104 >> 2] = E[i + 8 >> 2], E[Q + 108 >> 2] = g, g = E[i + 4 >> 2], E[Q + 96 >> 2] = E[i >> 2], E[Q + 100 >> 2] = g, $A(C, Q + 112 | 0, Q + 96 | 0), g = E[Q + 204 >> 2], E[i + 8 >> 2] = E[Q + 200 >> 2], E[i + 12 >> 2] = g, g = E[Q + 196 >> 2], E[i >> 2] = E[Q + 192 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 88 >> 2] = E[_ + 8 >> 2], E[Q + 92 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 80 >> 2] = E[_ >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(C, Q + 80 | 0, Q - -64 | 0), g = E[Q + 204 >> 2], E[c + 8 >> 2] = E[Q + 200 >> 2], E[c + 12 >> 2] = g, g = E[Q + 196 >> 2], E[c >> 2] = E[Q + 192 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 40 >> 2] = E[_ + 8 >> 2], E[Q + 44 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 32 >> 2] = E[_ >> 2], E[Q + 36 >> 2] = g, $A(C, Q + 48 | 0, Q + 32 | 0), g = E[Q + 204 >> 2], E[_ + 8 >> 2] = E[Q + 200 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 196 >> 2], E[_ >> 2] = E[Q + 192 >> 2], E[_ + 4 >> 2] = g, g = E[Q + 220 >> 2], E[Q + 24 >> 2] = E[Q + 216 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 212 >> 2], E[Q + 16 >> 2] = E[Q + 208 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(C, Q + 16 | 0, Q), D = E[Q + 192 >> 2], C = E[Q + 196 >> 2], g = E[Q + 200 >> 2], f = p ^ E[Q + 204 >> 2], E[B + 12 >> 2] = f, n = g ^ w, E[B + 8 >> 2] = n, k = C ^ e, E[B + 4 >> 2] = k, F = s ^ D, E[B >> 2] = F, 7 != (0 | (y = y + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    N = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, i = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, _ = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, c = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, t = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, r = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, p = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, w = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, e = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, s = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, D = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, y = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = f ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = n ^ D ^ I ^ g ^ C ^ y, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ r ^ p ^ w ^ e ^ s, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ N ^ i ^ _ ^ c ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                s = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, D = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, y = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, g = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, e = f ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24), o[A + 12 | 0] = e, o[A + 13 | 0] = e >>> 8, o[A + 14 | 0] = e >>> 16, o[A + 15 | 0] = e >>> 24, I = n ^ I ^ g, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ C ^ y, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ s ^ D, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, p = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, w = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, s = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, D = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, y = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, C = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ y, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p ^ e ^ w, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 224 | 0;
                                    }
                                    function u(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = C = h - 4032 | 0, TA(C + 160 | 0, g), _ = E[g + 36 >> 2], E[(i = C + 3840 | 0) >> 2] = E[g + 32 >> 2], E[i + 4 >> 2] = _, c = E[g + 28 >> 2], E[(_ = C + 3832 | 0) >> 2] = E[g + 24 >> 2], E[_ + 4 >> 2] = c, r = E[g + 20 >> 2], E[(c = C + 3824 | 0) >> 2] = E[g + 16 >> 2], E[c + 4 >> 2] = r, e = E[g + 12 >> 2], E[(r = C + 3816 | 0) >> 2] = E[g + 8 >> 2], E[r + 4 >> 2] = e, e = E[g + 4 >> 2], E[C + 3808 >> 2] = E[g >> 2], E[C + 3812 >> 2] = e, D = E[g + 52 >> 2], E[(e = C + 3856 | 0) >> 2] = E[g + 48 >> 2], E[e + 4 >> 2] = D, p = E[g + 60 >> 2], E[(D = C + 3864 | 0) >> 2] = E[g + 56 >> 2], E[D + 4 >> 2] = p, y = E[4 + (w = g - -64 | 0) >> 2], E[(p = C + 3872 | 0) >> 2] = E[w >> 2], E[p + 4 >> 2] = y, y = E[g + 76 >> 2], E[(w = C + 3880 | 0) >> 2] = E[g + 72 >> 2], E[w + 4 >> 2] = y, y = E[g + 44 >> 2], E[C + 3848 >> 2] = E[g + 40 >> 2], E[C + 3852 >> 2] = y, n = E[g + 92 >> 2], E[(y = C + 3896 | 0) >> 2] = E[g + 88 >> 2], E[y + 4 >> 2] = n, k = E[g + 100 >> 2], E[(n = C + 3904 | 0) >> 2] = E[g + 96 >> 2], E[n + 4 >> 2] = k, F = E[g + 108 >> 2], E[(k = C + 3912 | 0) >> 2] = E[g + 104 >> 2], E[k + 4 >> 2] = F, N = E[g + 116 >> 2], E[(F = C + 3920 | 0) >> 2] = E[g + 112 >> 2], E[F + 4 >> 2] = N, N = E[g + 84 >> 2], E[C + 3888 >> 2] = E[g + 80 >> 2], E[C + 3892 >> 2] = N, KA(B = C + 3528 | 0, N = C + 3808 | 0), Y(Q = C + 2408 | 0, B, t = C + 3648 | 0), Y(C + 2448 | 0, s = C + 3568 | 0, f = C + 3608 | 0), Y(C + 2488 | 0, f, t), Y(C + 2528 | 0, B, s), TA(t = C + 320 | 0, Q), sA(B = C + 3368 | 0, g, t), Y(Q = C + 2248 | 0, B, t = C + 3488 | 0), Y(C + 2288 | 0, s = C + 3408 | 0, f = C + 3448 | 0), Y(C + 2328 | 0, f, t), Y(C + 2368 | 0, B, s), TA(C + 480 | 0, Q), Q = E[4 + (B = C + 2440 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2432 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2424 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2416 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2456 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2464 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2472 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2480 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2412 >> 2], E[C + 3808 >> 2] = E[C + 2408 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2452 >> 2], E[C + 3848 >> 2] = E[C + 2448 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2520 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2512 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2504 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2496 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2492 >> 2], E[C + 3888 >> 2] = E[C + 2488 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 3208 | 0, N), Y(Q = C + 2088 | 0, B, t = C + 3328 | 0), Y(C + 2128 | 0, s = C + 3248 | 0, f = C + 3288 | 0), Y(C + 2168 | 0, f, t), Y(C + 2208 | 0, B, s), TA(t = C + 640 | 0, Q), sA(B = C + 3048 | 0, g, t), Y(Q = C + 1928 | 0, B, t = C + 3168 | 0), Y(C + 1968 | 0, s = C + 3088 | 0, f = C + 3128 | 0), Y(C + 2008 | 0, f, t), Y(C + 2048 | 0, B, s), TA(C + 800 | 0, Q), Q = E[4 + (B = C + 2280 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2272 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2264 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2256 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2296 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2304 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2312 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2320 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2252 >> 2], E[C + 3808 >> 2] = E[C + 2248 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2292 >> 2], E[C + 3848 >> 2] = E[C + 2288 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2360 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2352 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2344 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2336 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2332 >> 2], E[C + 3888 >> 2] = E[C + 2328 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 2888 | 0, N), Y(Q = C + 1768 | 0, B, t = C + 3008 | 0), Y(C + 1808 | 0, s = C + 2928 | 0, f = C + 2968 | 0), Y(C + 1848 | 0, f, t), Y(C + 1888 | 0, B, s), TA(t = C + 960 | 0, Q), sA(B = C + 2728 | 0, g, t), Y(g = C + 1608 | 0, B, Q = C + 2848 | 0), Y(C + 1648 | 0, t = C + 2768 | 0, s = C + 2808 | 0), Y(C + 1688 | 0, s, Q), Y(C + 1728 | 0, B, t), TA(C + 1120 | 0, g), B = E[4 + (g = C + 2120 | 0) >> 2], E[i >> 2] = E[g >> 2], E[i + 4 >> 2] = B, i = E[4 + (g = C + 2112 | 0) >> 2], E[_ >> 2] = E[g >> 2], E[_ + 4 >> 2] = i, i = E[4 + (g = C + 2104 | 0) >> 2], E[c >> 2] = E[g >> 2], E[c + 4 >> 2] = i, i = E[4 + (g = C + 2096 | 0) >> 2], E[r >> 2] = E[g >> 2], E[r + 4 >> 2] = i, i = E[4 + (g = C + 2136 | 0) >> 2], E[e >> 2] = E[g >> 2], E[e + 4 >> 2] = i, i = E[4 + (g = C + 2144 | 0) >> 2], E[D >> 2] = E[g >> 2], E[D + 4 >> 2] = i, i = E[4 + (g = C + 2152 | 0) >> 2], E[p >> 2] = E[g >> 2], E[p + 4 >> 2] = i, i = E[4 + (g = C + 2160 | 0) >> 2], E[w >> 2] = E[g >> 2], E[w + 4 >> 2] = i, g = E[C + 2092 >> 2], E[C + 3808 >> 2] = E[C + 2088 >> 2], E[C + 3812 >> 2] = g, g = E[C + 2132 >> 2], E[C + 3848 >> 2] = E[C + 2128 >> 2], E[C + 3852 >> 2] = g, i = E[4 + (g = C + 2200 | 0) >> 2], E[F >> 2] = E[g >> 2], E[F + 4 >> 2] = i, i = E[4 + (g = C + 2192 | 0) >> 2], E[k >> 2] = E[g >> 2], E[k + 4 >> 2] = i, i = E[4 + (g = C + 2184 | 0) >> 2], E[n >> 2] = E[g >> 2], E[n + 4 >> 2] = i, i = E[4 + (g = C + 2176 | 0) >> 2], E[y >> 2] = E[g >> 2], E[y + 4 >> 2] = i, g = E[C + 2172 >> 2], E[C + 3888 >> 2] = E[C + 2168 >> 2], E[C + 3892 >> 2] = g, KA(g = C + 2568 | 0, N), Y(i = C + 1448 | 0, g, _ = C + 2688 | 0), Y(C + 1488 | 0, c = C + 2608 | 0, r = C + 2648 | 0), Y(C + 1528 | 0, r, _), Y(C + 1568 | 0, g, c), TA(C + 1280 | 0, i), i = 0, g = 0; c = (_ = C + 3968 | 0) + (g << 1) | 0, r = a[I + g | 0], o[c + 1 | 0] = r >>> 4, o[0 | c] = 15 & r, _ = _ + ((c = 1 | g) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (g = g + 2 | 0)););
                                        for(I = 0; g = 8 + (_ = (g = I) + a[0 | (I = (C + 3968 | 0) + i | 0)] | 0) | 0, o[0 | I] = _ - (240 & g), g = 8 + (_ = a[I + 1 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & g), g = 8 + (_ = a[I + 2 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & g), I = g << 24 >> 24 >> 4, 63 != (0 | (i = i + 3 | 0)););
                                        for(o[C + 4031 | 0] = a[C + 4031 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(p = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), w = A + 120 | 0, y = A + 80 | 0, r = C + 3768 | 0, g = C + 3888 | 0, _ = C + 3848 | 0, e = C + 3728 | 0, i = C + 3928 | 0, D = 63; HA(C, n = C + 160 | 0, o[(C + 3968 | 0) + D | 0]), sA(I = C + 3808 | 0, A, C), Y(c = C + 3688 | 0, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), D = D - 1 | 0;);
                                        HA(C, n, o[C + 3968 | 0]), sA(I, A, C), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), h = C + 4032 | 0;
                                    }
                                    function x(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0;
                                        h = B = h - 320 | 0, d = 32 - g | 0, H = Hg((Y = B + 256 | 0) + g | 0, 0, g >>> 0 <= 31 ? d : 0), Sg(Y, I, g), o = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, r = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, e = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, y = a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24, s = a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24, I = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, D = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, p = a[C + 112 | 0] | a[C + 113 | 0] << 8 | a[C + 114 | 0] << 16 | a[C + 115 | 0] << 24, J = a[C + 96 | 0] | a[C + 97 | 0] << 8 | a[C + 98 | 0] << 16 | a[C + 99 | 0] << 24, U = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, w = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, f = a[C + 116 | 0] | a[C + 117 | 0] << 8 | a[C + 118 | 0] << 16 | a[C + 119 | 0] << 24, l = a[C + 100 | 0] | a[C + 101 | 0] << 8 | a[C + 102 | 0] << 16 | a[C + 103 | 0] << 24, m = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, n = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, k = a[C + 120 | 0] | a[C + 121 | 0] << 8 | a[C + 122 | 0] << 16 | a[C + 123 | 0] << 24, u = a[C + 104 | 0] | a[C + 105 | 0] << 8 | a[C + 106 | 0] << 16 | a[C + 107 | 0] << 24, F = E[B + 256 >> 2], N = E[B + 260 >> 2], S = E[B + 264 >> 2], G = E[B + 268 >> 2], M = E[B + 272 >> 2], b = E[B + 276 >> 2], K = E[B + 280 >> 2], Q = a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24, i = a[C + 108 | 0] | a[C + 109 | 0] << 8 | a[C + 110 | 0] << 16 | a[C + 111 | 0] << 24, E[B + 284 >> 2] = Q ^ i & (a[C + 124 | 0] | a[C + 125 | 0] << 8 | a[C + 126 | 0] << 16 | a[C + 127 | 0] << 24) ^ E[B + 284 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 280 >> 2] = m ^ u & k ^ n ^ K, E[B + 276 >> 2] = U ^ l & f ^ w ^ b, E[B + 272 >> 2] = I ^ J & p ^ D ^ M, E[B + 268 >> 2] = s & Q ^ y ^ G ^ i, E[B + 264 >> 2] = u ^ m & e ^ r ^ S, E[B + 260 >> 2] = l ^ U & t ^ c ^ N, E[B + 256 >> 2] = J ^ I & _ ^ o ^ F, Hg(H, 0, d), Sg(A, Y, g), g = E[B + 284 >> 2], Y = E[B + 280 >> 2], J = E[B + 276 >> 2], U = E[B + 272 >> 2], l = E[B + 256 >> 2], m = E[B + 260 >> 2], u = E[B + 264 >> 2], d = E[B + 268 >> 2], A = E[C + 124 >> 2], E[B + 312 >> 2] = E[C + 120 >> 2], E[B + 316 >> 2] = A, A = E[C + 116 >> 2], E[B + 304 >> 2] = E[C + 112 >> 2], E[B + 308 >> 2] = A, A = E[C + 108 >> 2], E[B + 248 >> 2] = E[C + 104 >> 2], E[B + 252 >> 2] = A, A = E[C + 100 >> 2], E[B + 240 >> 2] = E[C + 96 >> 2], E[B + 244 >> 2] = A, A = E[C + 124 >> 2], E[B + 232 >> 2] = E[C + 120 >> 2], E[B + 236 >> 2] = A, A = E[C + 116 >> 2], E[B + 224 >> 2] = E[C + 112 >> 2], E[B + 228 >> 2] = A, $A(I = B + 288 | 0, B + 240 | 0, B + 224 | 0), A = E[B + 300 >> 2], E[C + 120 >> 2] = E[B + 296 >> 2], E[C + 124 >> 2] = A, A = E[B + 292 >> 2], E[C + 112 >> 2] = E[B + 288 >> 2], E[C + 116 >> 2] = A, A = E[C + 92 >> 2], E[B + 216 >> 2] = E[C + 88 >> 2], E[B + 220 >> 2] = A, A = E[C + 84 >> 2], E[B + 208 >> 2] = E[C + 80 >> 2], E[B + 212 >> 2] = A, A = E[C + 108 >> 2], E[B + 200 >> 2] = E[C + 104 >> 2], E[B + 204 >> 2] = A, A = E[C + 100 >> 2], E[B + 192 >> 2] = E[C + 96 >> 2], E[B + 196 >> 2] = A, $A(I, B + 208 | 0, B + 192 | 0), A = E[B + 300 >> 2], E[C + 104 >> 2] = E[B + 296 >> 2], E[C + 108 >> 2] = A, A = E[B + 292 >> 2], E[C + 96 >> 2] = E[B + 288 >> 2], E[C + 100 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, H = E[4 + (A = C - -64 | 0) >> 2], E[B + 176 >> 2] = E[A >> 2], E[B + 180 >> 2] = H, H = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = H, H = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = H, $A(I, B + 176 | 0, B + 160 | 0), H = E[B + 300 >> 2], E[C + 88 >> 2] = E[B + 296 >> 2], E[C + 92 >> 2] = H, H = E[B + 292 >> 2], E[C + 80 >> 2] = E[B + 288 >> 2], E[C + 84 >> 2] = H, H = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = H, H = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = H, H = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = H, H = E[A + 4 >> 2], E[B + 128 >> 2] = E[A >> 2], E[B + 132 >> 2] = H, $A(I, B + 144 | 0, B + 128 | 0), H = E[B + 300 >> 2], E[C + 72 >> 2] = E[B + 296 >> 2], E[C + 76 >> 2] = H, H = E[B + 292 >> 2], E[A >> 2] = E[B + 288 >> 2], E[A + 4 >> 2] = H, H = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = H, H = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = H, H = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = H, H = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = H, $A(I, B + 112 | 0, B + 96 | 0), H = E[B + 300 >> 2], E[C + 56 >> 2] = E[B + 296 >> 2], E[C + 60 >> 2] = H, H = E[B + 292 >> 2], E[C + 48 >> 2] = E[B + 288 >> 2], E[C + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = H, H = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = H, H = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = H, H = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = H, $A(I, B + 80 | 0, B - -64 | 0), H = E[B + 300 >> 2], E[C + 40 >> 2] = E[B + 296 >> 2], E[C + 44 >> 2] = H, H = E[B + 292 >> 2], E[C + 32 >> 2] = E[B + 288 >> 2], E[C + 36 >> 2] = H, H = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = H, H = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = H, H = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = H, $A(I, B + 48 | 0, B + 32 | 0), H = E[B + 300 >> 2], E[C + 24 >> 2] = E[B + 296 >> 2], E[C + 28 >> 2] = H, H = E[B + 292 >> 2], E[C + 16 >> 2] = E[B + 288 >> 2], E[C + 20 >> 2] = H, H = E[B + 316 >> 2], E[B + 24 >> 2] = E[B + 312 >> 2], E[B + 28 >> 2] = H, H = E[B + 308 >> 2], E[B + 16 >> 2] = E[B + 304 >> 2], E[B + 20 >> 2] = H, H = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = H, H = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = H, $A(I, B + 16 | 0, B), I = E[B + 300 >> 2], E[C + 8 >> 2] = E[B + 296 >> 2], E[C + 12 >> 2] = I, I = E[B + 292 >> 2], E[C >> 2] = E[B + 288 >> 2], E[C + 4 >> 2] = I, E[C + 12 >> 2] = d ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), E[C + 8 >> 2] = u ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), E[C + 4 >> 2] = m ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24), E[C >> 2] = l ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[C + 68 >> 2] = J ^ (a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24), E[C + 72 >> 2] = Y ^ (a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24), E[C + 76 >> 2] = g ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24), h = B + 320 | 0;
                                    }
                                    function R(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0;
                                        v = Ig(C = (D = E[I + 12 >> 2]) << 1, o = C >> 31, $ = (q = E[I + 4 >> 2]) << 1, B = $ >> 31), P = w, F = Z = E[I + 8 >> 2], L = (W = Ig(Z, p = Z >> 31, Z, p)) + v | 0, v = w + P | 0, v = L >>> 0 < W >>> 0 ? v + 1 | 0 : v, P = Ig(j = E[I + 16 >> 2], a = j >> 31, W = (z = E[I >> 2]) << 1, Q = W >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, e = E[I + 28 >> 2], P = Ig(BA = c(e, 38), f = BA >> 31, e, N = e >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, P = L, y = E[I + 32 >> 2], X = Ig(O = c(y, 19), _ = O >> 31, L = (g = E[I + 24 >> 2]) << 1, L >> 31), L = w + v | 0, L = (P = P + X | 0) >>> 0 < X >>> 0 ? L + 1 | 0 : L, Y = E[I + 36 >> 2], v = Ig(X = c(Y, 38), i = X >> 31, AA = (t = E[I + 20 >> 2]) << 1, s = AA >> 31), I = w + L | 0, J = v = (v >>> 0 > (P = v + P | 0) >>> 0 ? I + 1 | 0 : I) << 1 | P >>> 31, U = L = 33554432 + (S = P << 1) | 0, l = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, T = (67108863 & v) << 6 | L >>> 26, v = Ig($, B, j, a), P = w, L = (IA = Ig(Z <<= 1, h = Z >> 31, D, G = D >> 31)) + v | 0, v = w + P | 0, v = L >>> 0 < IA >>> 0 ? v + 1 | 0 : v, P = (IA = Ig(t, n = t >> 31, W, Q)) + L | 0, L = w + v | 0, L = P >>> 0 < IA >>> 0 ? L + 1 | 0 : L, iA = Ig(O, _, IA = e << 1, M = IA >> 31), v = w + L | 0, v = (P = iA + P | 0) >>> 0 < iA >>> 0 ? v + 1 | 0 : v, L = Ig(X, i, g, r = g >> 31), v = w + v | 0, I = I + (L = (L >>> 0 > (P = L + P | 0) >>> 0 ? v + 1 | 0 : v) << 1 | P >>> 31) | 0, iA = P = (v = P << 1) + T | 0, v = I = v >>> 0 > P >>> 0 ? I + 1 | 0 : I, m = P = P + 16777216 | 0, T = (33554431 & (v = P >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | P >>> 25, P = v >> 25, I = Ig(C, o, D, G), v = w, L = Ig(j, a, Z, h), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (gA = Ig(W, Q, g, r)) + I | 0, I = w + v | 0, I = L >>> 0 < gA >>> 0 ? I + 1 | 0 : I, gA = Ig(O, _, y, k = y >> 31), v = w + I | 0, v = (L = gA + L | 0) >>> 0 < gA >>> 0 ? v + 1 | 0 : v, I = (gA = Ig(X, i, IA, M)) + L | 0, L = w + v | 0, I = ((v = I) >>> 0 < gA >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = T, T = v << 1, v = I + P | 0, v = (L = L + T | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, gA = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 24 >> 2] = L - (-67108864 & I), L = Ig(I = c(t, 38), I >> 31, t, n), T = w, I = (v = Ig(I = z, v = I >> 31, I, v)) + L | 0, L = w + T | 0, L = I >>> 0 < v >>> 0 ? L + 1 | 0 : L, CA = Ig(z = c(g, 19), b = z >> 31, T = j << 1, K = T >> 31), v = w + L | 0, v = (I = CA + I | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (CA = Ig(O, _, Z, h)) + I | 0, I = w + v | 0, I = L >>> 0 < CA >>> 0 ? I + 1 | 0 : I, CA = Ig($, B, X, i), v = w + I | 0, CA = v = ((L = CA + L | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v) << 1 | L >>> 31, u = I = 33554432 + (H = L << 1) | 0, x = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, QA = (67108863 & L) << 6 | I >>> 26, oA = L >> 26, I = Ig(z, b, AA, s), v = w, L = Ig(W, Q, q, d = q >> 31), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (V = Ig(j, a, BA, f)) + I | 0, I = w + v | 0, I = L >>> 0 < V >>> 0 ? I + 1 | 0 : I, V = Ig(O, _, C, o), v = w + I | 0, v = (L = V + L | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, V = (I = Ig(X, i, F, p)) + L | 0, L = w + v | 0, v = (I = (I >>> 0 > V >>> 0 ? L + 1 | 0 : L) << 1 | V >>> 31) + oA | 0, v = (L = (V <<= 1) + QA | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, oA = L, V = L = L + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, QA = v >> 25, I = Ig(W, Q, F, p), v = w, L = Ig($, B, q, d), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, q = Ig(z, b, g, r), L = w + v | 0, L = (I = q + I | 0) >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(AA, s, BA, f), v = w + L | 0, v = (I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, L = Ig(O, _, T, K), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (q = Ig(X, i, C, o)) + I | 0, I = w + v | 0, v = (v = (L >>> 0 < q >>> 0 ? I + 1 | 0 : I) << 1 | L >>> 31) + QA | 0, z = I = (L <<= 1) + R | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, QA = I = I + 33554432 | 0, q = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 8 >> 2] = z - (-67108864 & I), I = Ig(Z, h, t, n), L = w, v = (z = Ig(j, a, C, o)) + I | 0, I = w + L | 0, I = v >>> 0 < z >>> 0 ? I + 1 | 0 : I, L = (z = Ig($, B, g, r)) + v | 0, v = w + I | 0, v = L >>> 0 < z >>> 0 ? v + 1 | 0 : v, I = (z = Ig(W, Q, e, N)) + L | 0, L = w + v | 0, L = I >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = Ig(X, i, y, k), v = w + L | 0, v = (v = ((I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31) + (L = P >> 26) | 0, I = (L = P = (z = I << 1) + (I = (67108863 & P) << 6 | gA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, z = v = L + 16777216 | 0, P = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = L - (-33554432 & v), I = Ig(W, Q, D, G), v = w, L = Ig($, B, F, p), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(g, r, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (O = Ig(O, _, AA, s)) + I | 0, I = w + v | 0, I = L >>> 0 < O >>> 0 ? I + 1 | 0 : I, v = (O = Ig(X, i, j, a)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < O >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = q >> 26) + v | 0, v = (L = L + (q = (67108863 & q) << 6 | QA >>> 26) | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, O = I = L + 16777216 | 0, q = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, E[A + 12 >> 2] = L - (-33554432 & I), I = Ig(g, r, Z, h), v = w, L = Ig(j, a, j, a), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, IA, M), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (j = Ig(W, Q, y, k)) + I | 0, I = w + v | 0, I = L >>> 0 < j >>> 0 ? I + 1 | 0 : I, v = (j = Ig(v = X, i, X = Y, AA = X >> 31)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < j >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = P >> 25) + v | 0, v = (L = L + (P = (33554431 & P) << 7 | z >>> 25) | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, j = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 32 >> 2] = L - (-67108864 & I), v = q >> 25, L = (q = (33554431 & q) << 7 | O >>> 25) + (S - (I = -67108864 & U) | 0) | 0, I = v + (J - ((I >>> 0 > S >>> 0) + l | 0) | 0) | 0, I = L >>> 0 < q >>> 0 ? I + 1 | 0 : I, q = L, v = I, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? v + 1 | 0 : v)) << 6 | L >>> 26) + (BA = iA - (-33554432 & m) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = q - (-67108864 & L), I = Ig(C, o, g, r), L = w, v = (q = Ig(t, n, T, K)) + I | 0, I = w + L | 0, I = v >>> 0 < q >>> 0 ? I + 1 | 0 : I, L = (q = Ig(Z, h, e, N)) + v | 0, v = w + I | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, I = (q = Ig($, B, y, k)) + L | 0, L = w + v | 0, L = I >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(W, Q, X, AA), v = w + L | 0, v = ((I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31, q = I << 1, v = v + (L = P >> 26) | 0, I = (I = (67108863 & P) << 6 | j >>> 26) >>> 0 > (P = q + I | 0) >>> 0 ? v + 1 | 0 : v, I = (v = P + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = P - (-33554432 & v), q = oA - (-33554432 & V) | 0, P = H - (L = -67108864 & u) | 0, $ = CA - ((L >>> 0 > H >>> 0) + x | 0) | 0, I = Ig((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), L = w + $ | 0, P = v = I + P | 0, I = I >>> 0 > v >>> 0 ? L + 1 | 0 : L, I = ((67108863 & (I = (v = v + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + q | 0, E[A + 4 >> 2] = I, E[A >> 2] = P - (-67108864 & v);
                                    }
                                    function v(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        m = Ig(C = (p = E[I + 12 >> 2]) << 1, o = C >> 31, p, N = p >> 31), x = w, u = (z = Ig(v = E[I + 16 >> 2], a = v >> 31, _ = (R = E[I + 8 >> 2]) << 1, y = _ >> 31)) + m | 0, m = w + x | 0, m = u >>> 0 < z >>> 0 ? m + 1 | 0 : m, x = (j = Ig(V = (t = E[I + 20 >> 2]) << 1, s = V >> 31, z = (L = E[I + 4 >> 2]) << 1, B = z >> 31)) + u | 0, u = w + m | 0, u = x >>> 0 < j >>> 0 ? u + 1 | 0 : u, P = Ig(g = E[I + 24 >> 2], r = g >> 31, j = (T = E[I >> 2]) << 1, Q = j >> 31), m = w + u | 0, m = (x = P + x | 0) >>> 0 < P >>> 0 ? m + 1 | 0 : m, u = x, h = E[I + 32 >> 2], x = Ig(X = c(h, 19), e = X >> 31, h, n = h >> 31), m = w + m | 0, m = (u = u + x | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, K = E[I + 36 >> 2], x = Ig(P = c(K, 38), i = P >> 31, k = (D = E[I + 28 >> 2]) << 1, S = k >> 31), I = w + m | 0, W = u = x + u | 0, x = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, I = Ig(z, B, v, a), m = w, u = Ig(_, y, p, N), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, q = Ig(t, F = t >> 31, j, Q), u = w + m | 0, u = (I = q + I | 0) >>> 0 < q >>> 0 ? u + 1 | 0 : u, q = Ig(X, e, k, S), m = w + u | 0, m = (I = q + I | 0) >>> 0 < q >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, g, r), m = w + m | 0, CA = I = u + I | 0, O = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, m = Ig(z, B, C, o), u = w, G = I = R, R = Ig(I, Z = I >> 31, I, Z), I = w + u | 0, I = (m = R + m | 0) >>> 0 < R >>> 0 ? I + 1 | 0 : I, u = (R = Ig(j, Q, v, a)) + m | 0, m = w + I | 0, m = u >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (R = Ig(q = c(D, 38), f = q >> 31, D, M = D >> 31)) + u | 0, u = w + m | 0, u = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, I = (m = I) + (R = Ig(X, e, I = g << 1, I >> 31)) | 0, m = w + u | 0, m = I >>> 0 < R >>> 0 ? m + 1 | 0 : m, u = I, I = Ig(P, i, V, s), m = w + m | 0, H = u = u + I | 0, Y = m = I >>> 0 > u >>> 0 ? m + 1 | 0 : m, I = m, d = u = u + 33554432 | 0, J = I = u >>> 0 < 33554432 ? I + 1 | 0 : I, m = (m = I >> 26) + O | 0, CA = I = (u = (67108863 & I) << 6 | u >>> 26) + CA | 0, m = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, U = I = I + 16777216 | 0, m = (m = (u = I >>> 0 < 16777216 ? m + 1 | 0 : m) >> 25) + x | 0, I = (I = (33554431 & u) << 7 | I >>> 25) >>> 0 > (u = I + W | 0) >>> 0 ? m + 1 | 0 : m, W = m = u + 33554432 | 0, R = I = m >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 24 >> 2] = u - (-67108864 & m), I = Ig(j, Q, G, Z), m = w, x = Ig(z, B, L, $ = L >> 31), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, O = Ig(x = c(g, 19), gA = x >> 31, g, r), m = w + u | 0, m = (I = O + I | 0) >>> 0 < O >>> 0 ? m + 1 | 0 : m, u = (O = Ig(V, s, q, f)) + I | 0, I = w + m | 0, I = u >>> 0 < O >>> 0 ? I + 1 | 0 : I, AA = Ig(X, e, O = v << 1, b = O >> 31), m = w + I | 0, m = (u = AA + u | 0) >>> 0 < AA >>> 0 ? m + 1 | 0 : m, I = u, u = Ig(P, i, C, o), m = w + m | 0, IA = I = I + u | 0, AA = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, I = Ig(V, s, x, gA), m = w, L = Ig(j, Q, L, $), u = w + m | 0, u = (I = L + I | 0) >>> 0 < L >>> 0 ? u + 1 | 0 : u, L = Ig(v, a, q, f), m = w + u | 0, m = (I = L + I | 0) >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = (L = Ig(X, e, C, o)) + I | 0, I = w + m | 0, I = u >>> 0 < L >>> 0 ? I + 1 | 0 : I, L = Ig(P, i, G, Z), m = w + I | 0, BA = u = L + u | 0, $ = u >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = Ig(I = c(t, 38), I >> 31, t, F), L = w, I = T, T = u, u = Ig(I, m = I >> 31, I, m), m = w + L | 0, m = (I = T + u | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, x = Ig(x, gA, O, b), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = Ig(C, o, q, f), m = w + u | 0, m = (I = x + I | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, u = (x = Ig(X, e, _, y)) + I | 0, I = w + m | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = Ig(z, B, P, i), m = w + I | 0, L = u = x + u | 0, T = m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, gA = u = u + 33554432 | 0, l = m = u >>> 0 < 33554432 ? m + 1 | 0 : m, I = m >> 26, m = (67108863 & m) << 6 | u >>> 26, u = I + $ | 0, $ = x = m + BA | 0, m = m >>> 0 > x >>> 0 ? u + 1 | 0 : u, BA = u = x + 16777216 | 0, x = (33554431 & (m = u >>> 0 < 16777216 ? m + 1 | 0 : m)) << 7 | u >>> 25, m = (m >> 25) + AA | 0, m = (u = x + IA | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, AA = I = u + 33554432 | 0, x = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 8 >> 2] = u - (-67108864 & I), I = Ig(_, y, t, F), m = w, u = Ig(v, a, C, o), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(z, B, g, r), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(j, Q, D, M), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, IA = (u = Ig(P, i, h, n)) + I | 0, I = w + m | 0, u = (m = R >> 26) + (u = u >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, W = I = (R = (67108863 & R) << 6 | W >>> 26) + IA | 0, m = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, IA = I = I + 16777216 | 0, R = m = I >>> 0 < 16777216 ? m + 1 | 0 : m, E[A + 28 >> 2] = W - (-33554432 & I), I = Ig(j, Q, p, N), u = w, m = (Z = Ig(z, B, G, Z)) + I | 0, I = w + u | 0, I = m >>> 0 < Z >>> 0 ? I + 1 | 0 : I, m = (q = Ig(g, r, q, f)) + m | 0, u = w + I | 0, I = (X = Ig(X, e, V, s)) + m | 0, m = w + (m >>> 0 < q >>> 0 ? u + 1 | 0 : u) | 0, m = I >>> 0 < X >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, v, a), m = w + m | 0, m = (m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m) + (u = x >> 26) | 0, I = (u = x = (W = I) + (I = (67108863 & x) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? m + 1 | 0 : m, X = m = u + 16777216 | 0, x = I = m >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 12 >> 2] = u - (-33554432 & m), I = Ig(g, r, _, y), m = w, u = Ig(v, a, v, a), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(C, o, V, s), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = (v = Ig(z, B, k, S)) + I | 0, I = w + m | 0, I = u >>> 0 < v >>> 0 ? I + 1 | 0 : I, m = (v = Ig(j, Q, h, n)) + u | 0, u = w + I | 0, u = m >>> 0 < v >>> 0 ? u + 1 | 0 : u, I = (v = Ig(I = P, i, P = K, V = P >> 31)) + m | 0, m = w + u | 0, m = I >>> 0 < v >>> 0 ? m + 1 | 0 : m, u = I, m = (I = R >> 25) + m | 0, m = (u = u + (R = (33554431 & R) << 7 | IA >>> 25) | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, v = I = u + 33554432 | 0, R = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 32 >> 2] = u - (-67108864 & I), m = x >> 25, u = (x = (33554431 & x) << 7 | X >>> 25) + (H - (I = -67108864 & d) | 0) | 0, I = m + (Y - ((I >>> 0 > H >>> 0) + J | 0) | 0) | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = u, I = ((67108863 & (m = (u = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | u >>> 26) + (q = CA - (-33554432 & U) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = x - (-67108864 & u), I = Ig(C, o, g, r), u = w, m = (x = Ig(t, F, O, b)) + I | 0, I = w + u | 0, I = m >>> 0 < x >>> 0 ? I + 1 | 0 : I, u = (x = Ig(_, y, D, M)) + m | 0, m = w + I | 0, m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, I = (x = Ig(z, B, h, n)) + u | 0, u = w + m | 0, u = I >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = (m = I) + (I = Ig(j, Q, P, V)) | 0, m = w + u | 0, m = (I = I >>> 0 > x >>> 0 ? m + 1 | 0 : m) + (m = R >> 26) | 0, I = (u = (R = (67108863 & R) << 6 | v >>> 26) + x | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (m = u + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = u - (-33554432 & m), R = $ - (-33554432 & BA) | 0, x = L - (u = -67108864 & gA) | 0, z = T - ((u >>> 0 > L >>> 0) + l | 0) | 0, I = Ig((33554431 & I) << 7 | m >>> 25, I >> 25, 19, 0), m = w + z | 0, I = I >>> 0 > (u = I + x | 0) >>> 0 ? m + 1 | 0 : m, I = ((67108863 & (I = (m = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | m >>> 26) + R | 0, E[A + 4 >> 2] = I, E[A >> 2] = u - (-67108864 & m);
                                    }
                                    function L(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        if (h = g = h - 48 | 0, !((C = pI(A)) || (C = -26, I - 3 >>> 0 < 4294967294))) {
                                            Q = E[A + 44 >> 2], C = E[A + 48 >> 2], E[g + 4 >> 2] = 0, B = E[A + 40 >> 2], E[g + 32 >> 2] = C, E[g + 16 >> 2] = -1, E[g + 12 >> 2] = B, C = ((r = (B = C << 3) >>> 0 < Q >>> 0 ? Q : B) >>> 0) / ((Q = C << 2) >>> 0) | 0, E[g + 24 >> 2] = C, E[g + 28 >> 2] = C << 2, E[g + 20 >> 2] = c(C, Q), C = E[A + 52 >> 2], E[g + 40 >> 2] = I, E[g + 36 >> 2] = C, f = I = h, h = C = I - 1152 & -64, I = -25;
                                            A: {
                                                if (!(!(Q = g + 4 | 0) | !A) && (B = K(E[Q + 20 >> 2] << 3), E[Q + 4 >> 2] = B, I = -22, B)) {
                                                    I: {
                                                        if ((I = E[Q + 16 >> 2]) && 1024 == (((B = I << 10) >>> 0) / (I >>> 0) | 0) && (I = K(12), E[Q >> 2] = I, I)) {
                                                            if (E[I >> 2] = 0, E[I + 4 >> 2] = 0, I = _I(C + 128 | 0, B), E[9392] = I, I) E[C + 128 >> 2] = 0;
                                                            else if (I = E[C + 128 >> 2]) break I;
                                                            gA(E[Q >> 2]), E[Q >> 2] = 0;
                                                        }
                                                        VI(Q, E[A + 56 >> 2]), h = f, I = -22;
                                                        break A;
                                                    }
                                                    if (E[E[Q >> 2] >> 2] = I, E[E[Q >> 2] + 4 >> 2] = I, E[E[Q >> 2] + 8 >> 2] = B, D = E[Q + 36 >> 2], eA(I = C + 128 | 0, 0, 0, 64), E[C + 124 >> 2] = E[A + 48 >> 2], XA(I, B = C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 4 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 44 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 40 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = 19, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = D, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 12 >> 2], XA(C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 8 >> 2]) && (XA(I, B, E[A + 12 >> 2], 0), 1 & o[A + 56 | 0] && (XC(E[A + 8 >> 2], E[A + 12 >> 2]), E[A + 12 >> 2] = 0)), E[C + 124 >> 2] = E[A + 20 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 16 >> 2]) && XA(I, B, E[A + 20 >> 2], 0), E[C + 124 >> 2] = E[A + 28 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 24 >> 2]) && (XA(I, B, E[A + 28 >> 2], 0), 2 & a[A + 56 | 0] && (XC(E[A + 24 >> 2], E[A + 28 >> 2]), E[A + 28 >> 2] = 0)), E[C + 124 >> 2] = E[A + 36 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 32 >> 2]) && XA(I, B, E[A + 36 >> 2], 0), Yg(C + 128 | 0, C + 48 | 0, 64), XC(C + 112 | 0, 8), E[Q + 28 >> 2]) for(B = 0;;){
                                                        for(E[C + 112 >> 2] = 0, E[C + 116 >> 2] = B, aA(C + 128 | 0, 1024, C + 48 | 0, 72), D = E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, e = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = e, 128 != (0 | (I = I + 4 | 0)););
                                                        for(E[C + 112 >> 2] = 1, aA(r, 1024, C + 48 | 0, 72), D = 1024 + (E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, r = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = r, 128 != (0 | (I = I + 4 | 0)););
                                                        if (!((B = B + 1 | 0) >>> 0 < _[Q + 28 >> 2])) break;
                                                    }
                                                    XC(C + 128 | 0, 1024), XC(C + 48 | 0, 72), I = 0;
                                                }
                                                h = f;
                                            }
                                            if (C = I, !I) {
                                                if (E[g + 12 >> 2]) for(;;){
                                                    if (h = I = h - 80 | 0, !(!(Q = g + 4 | 0) | !E[Q + 28 >> 2])) {
                                                        for(o[I + 72 | 0] = 0, E[I + 64 >> 2] = y, C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 56 >> 2] = E[I + 72 >> 2], E[I + 60 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 48 >> 2] = E[I + 64 >> 2], E[I + 52 >> 2] = B, S(Q, I + 48 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                        if (o[I + 72 | 0] = 1, B) {
                                                            for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 40 >> 2] = E[I + 72 >> 2], E[I + 44 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 32 >> 2] = E[I + 64 >> 2], E[I + 36 >> 2] = B, S(Q, I + 32 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                            if (o[I + 72 | 0] = 2, B) {
                                                                for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 24 >> 2] = E[I + 72 >> 2], E[I + 28 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 16 >> 2] = E[I + 64 >> 2], E[I + 20 >> 2] = B, S(Q, I + 16 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                                if (o[I + 72 | 0] = 3, B) for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 8 >> 2] = E[I + 72 >> 2], E[I + 12 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I >> 2] = E[I + 64 >> 2], E[I + 4 >> 2] = B, S(Q, I), (C = C + 1 | 0) >>> 0 < _[Q + 28 >> 2];);
                                                            }
                                                        }
                                                    }
                                                    if (h = I + 80 | 0, !((y = y + 1 | 0) >>> 0 < _[g + 12 >> 2])) break;
                                                }
                                                if (h = I = h - 2048 | 0, !(!A | !(C = g + 4 | 0))) {
                                                    if (i = E[C >> 2], f = E[C + 24 >> 2], Sg(I + 1024 | 0, (E[i + 4 >> 2] + (f << 10) | 0) - 1024 | 0, 1024), (e = E[C + 28 >> 2]) >>> 0 >= 2) for(p = f - 1 | 0, D = 1;;){
                                                        for(Q = E[i + 4 >> 2] + (c(D, f) + p << 10) | 0, t = 0; s = E[(y = (B = t << 3) + (r = I + 1024 | 0) | 0) >> 2], n = E[(w = B + Q | 0) >> 2], w = E[y + 4 >> 2] ^ E[w + 4 >> 2], E[y >> 2] = s ^ n, E[y + 4 >> 2] = w, w = E[(y = (s = 8 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, w = E[(y = (s = 16 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, y = E[(B = (y = r) + (r = 24 | B) | 0) >> 2], s = E[(r = Q + r | 0) >> 2], r = E[B + 4 >> 2] ^ E[r + 4 >> 2], E[B >> 2] = y ^ s, E[B + 4 >> 2] = r, 128 != (0 | (t = t + 4 | 0)););
                                                        if ((0 | e) == (0 | (D = D + 1 | 0))) break;
                                                    }
                                                    Q = Sg(I, I + 1024 | 0, 1024), aA(E[A >> 2], E[A + 4 >> 2], Q, 1024), XC(Q + 1024 | 0, 1024), XC(Q, 1024), VI(C, E[A + 56 >> 2]);
                                                }
                                                h = I + 2048 | 0, C = 0;
                                            }
                                        }
                                        return h = g + 48 | 0, C;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0;
                                        for(h = C = h - 288 | 0, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, D = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, c = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, t = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, r = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g + 112 | 0, A = 33620224 ^ (e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[I >> 2] = A, E[(o = g + 96 | 0) >> 2] = 1427652059 ^ e, E[(_ = g + 80 | 0) >> 2] = A, f = e ^ p, E[(A = g - -64 | 0) >> 2] = f, E[g + 56 >> 2] = 1110511904, E[g + 60 >> 2] = -584534669, E[(B = g + 48 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, E[g + 40 >> 2] = 1496785429, E[g + 44 >> 2] = 1652156816, E[(Q = g + 32 | 0) >> 2] = 33620224, E[Q + 4 >> 2] = 218629379, E[g + 24 >> 2] = 1110511904, E[g + 28 >> 2] = -584534669, E[(i = g + 16 | 0) >> 2] = 1427652059, E[i + 4 >> 2] = -248528275, E[g >> 2] = f, f = 1652156816 ^ r, E[g + 124 >> 2] = f, n = 1496785429 ^ t, E[g + 120 >> 2] = n, w = 218629379 ^ c, E[g + 116 >> 2] = w, E[g + 108 >> 2] = -584534669 ^ r, E[g + 104 >> 2] = 1110511904 ^ t, E[g + 100 >> 2] = -248528275 ^ c, E[g + 92 >> 2] = f, E[g + 88 >> 2] = n, E[g + 84 >> 2] = w, f = r ^ D, E[g + 76 >> 2] = f, n = t ^ s, E[g + 72 >> 2] = n, w = c ^ y, E[g + 68 >> 2] = w, E[g + 12 >> 2] = f, E[g + 8 >> 2] = n, E[g + 4 >> 2] = w, n = 0; f = E[I + 12 >> 2], E[C + 280 >> 2] = E[I + 8 >> 2], E[C + 284 >> 2] = f, f = E[I + 4 >> 2], E[C + 272 >> 2] = E[I >> 2], E[C + 276 >> 2] = f, f = E[o + 12 >> 2], E[C + 248 >> 2] = E[o + 8 >> 2], E[C + 252 >> 2] = f, f = E[o + 4 >> 2], E[C + 240 >> 2] = E[o >> 2], E[C + 244 >> 2] = f, f = E[I + 12 >> 2], E[C + 232 >> 2] = E[I + 8 >> 2], E[C + 236 >> 2] = f, f = E[I + 4 >> 2], E[C + 224 >> 2] = E[I >> 2], E[C + 228 >> 2] = f, $A(f = C + 256 | 0, C + 240 | 0, C + 224 | 0), w = E[C + 268 >> 2], E[I + 8 >> 2] = E[C + 264 >> 2], E[I + 12 >> 2] = w, w = E[C + 260 >> 2], E[I >> 2] = E[C + 256 >> 2], E[I + 4 >> 2] = w, w = E[_ + 12 >> 2], E[C + 216 >> 2] = E[_ + 8 >> 2], E[C + 220 >> 2] = w, w = E[_ + 4 >> 2], E[C + 208 >> 2] = E[_ >> 2], E[C + 212 >> 2] = w, w = E[o + 12 >> 2], E[C + 200 >> 2] = E[o + 8 >> 2], E[C + 204 >> 2] = w, w = E[o + 4 >> 2], E[C + 192 >> 2] = E[o >> 2], E[C + 196 >> 2] = w, $A(f, C + 208 | 0, C + 192 | 0), w = E[C + 268 >> 2], E[o + 8 >> 2] = E[C + 264 >> 2], E[o + 12 >> 2] = w, w = E[C + 260 >> 2], E[o >> 2] = E[C + 256 >> 2], E[o + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 184 >> 2] = E[A + 8 >> 2], E[C + 188 >> 2] = w, w = E[A + 4 >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = w, w = E[_ + 12 >> 2], E[C + 168 >> 2] = E[_ + 8 >> 2], E[C + 172 >> 2] = w, w = E[_ + 4 >> 2], E[C + 160 >> 2] = E[_ >> 2], E[C + 164 >> 2] = w, $A(f, C + 176 | 0, C + 160 | 0), w = E[C + 268 >> 2], E[_ + 8 >> 2] = E[C + 264 >> 2], E[_ + 12 >> 2] = w, w = E[C + 260 >> 2], E[_ >> 2] = E[C + 256 >> 2], E[_ + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 152 >> 2] = E[B + 8 >> 2], E[C + 156 >> 2] = w, w = E[B + 4 >> 2], E[C + 144 >> 2] = E[B >> 2], E[C + 148 >> 2] = w, w = E[A + 12 >> 2], E[C + 136 >> 2] = E[A + 8 >> 2], E[C + 140 >> 2] = w, w = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = w, $A(f, C + 144 | 0, C + 128 | 0), w = E[C + 268 >> 2], E[A + 8 >> 2] = E[C + 264 >> 2], E[A + 12 >> 2] = w, w = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = w, w = E[Q + 12 >> 2], E[C + 120 >> 2] = E[Q + 8 >> 2], E[C + 124 >> 2] = w, w = E[Q + 4 >> 2], E[C + 112 >> 2] = E[Q >> 2], E[C + 116 >> 2] = w, w = E[B + 12 >> 2], E[C + 104 >> 2] = E[B + 8 >> 2], E[C + 108 >> 2] = w, w = E[B + 4 >> 2], E[C + 96 >> 2] = E[B >> 2], E[C + 100 >> 2] = w, $A(f, C + 112 | 0, C + 96 | 0), w = E[C + 268 >> 2], E[B + 8 >> 2] = E[C + 264 >> 2], E[B + 12 >> 2] = w, w = E[C + 260 >> 2], E[B >> 2] = E[C + 256 >> 2], E[B + 4 >> 2] = w, w = E[i + 12 >> 2], E[C + 88 >> 2] = E[i + 8 >> 2], E[C + 92 >> 2] = w, w = E[i + 4 >> 2], E[C + 80 >> 2] = E[i >> 2], E[C + 84 >> 2] = w, w = E[Q + 12 >> 2], E[C + 72 >> 2] = E[Q + 8 >> 2], E[C + 76 >> 2] = w, w = E[Q + 4 >> 2], E[C + 64 >> 2] = E[Q >> 2], E[C + 68 >> 2] = w, $A(f, C + 80 | 0, C - -64 | 0), w = E[C + 268 >> 2], E[Q + 8 >> 2] = E[C + 264 >> 2], E[Q + 12 >> 2] = w, w = E[C + 260 >> 2], E[Q >> 2] = E[C + 256 >> 2], E[Q + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[i + 12 >> 2], E[C + 40 >> 2] = E[i + 8 >> 2], E[C + 44 >> 2] = w, w = E[i + 4 >> 2], E[C + 32 >> 2] = E[i >> 2], E[C + 36 >> 2] = w, $A(f, C + 48 | 0, C + 32 | 0), w = E[C + 268 >> 2], E[i + 8 >> 2] = E[C + 264 >> 2], E[i + 12 >> 2] = w, w = E[C + 260 >> 2], E[i >> 2] = E[C + 256 >> 2], E[i + 4 >> 2] = w, w = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = w, w = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(f, C + 16 | 0, C), f = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = f, f = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = f, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ D, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ s, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ y, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ e, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ c, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ t, E[g + 76 >> 2] = (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ r, 10 != (0 | (n = n + 1 | 0)););
                                        h = C + 288 | 0;
                                    }
                                    function q(A, I, g, C, B) {
                                        var Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = h + -64 | 0, i = E[A + 60 >> 2], _ = E[A + 56 >> 2], P = E[A + 52 >> 2], L = E[A + 48 >> 2], c = E[A + 44 >> 2], t = E[A + 40 >> 2], r = E[A + 36 >> 2], e = E[A + 32 >> 2], y = E[A + 28 >> 2], s = E[A + 24 >> 2], D = E[A + 20 >> 2], p = E[A + 16 >> 2], w = E[A + 12 >> 2], f = E[A + 8 >> 2], n = E[A + 4 >> 2], k = E[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) F = g;
                                            else {
                                                if (E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, E[Q + 8 >> 2] = 0, E[Q + 12 >> 2] = 0, E[Q >> 2] = 0, E[Q + 4 >> 2] = 0, S = 0, C | B) for(; o[S + Q | 0] = a[I + S | 0], !B & (S = S + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = F = Q, O = g;
                                            }
                                            for(q = 20, N = k, d = n, J = f, m = w, S = p, g = D, M = s, b = y, K = e, x = r, U = t, G = i, R = _, u = P, l = L, H = c; Y = S, N = Lg((S = N + S | 0) ^ l, 16), Y = l = Lg(Y ^ (K = N + K | 0), 12), l = Lg((v = S + l | 0) ^ N, 8), S = Lg(Y ^ (K = l + K | 0), 7), G = Lg((N = b + m | 0) ^ G, 16), b = Lg((H = G + H | 0) ^ b, 12), m = Lg((J = M + J | 0) ^ R, 16), M = Lg((U = m + U | 0) ^ M, 12), R = (z = N + b | 0) + S | 0, j = Lg((J = M + J | 0) ^ m, 8), N = Lg(R ^ j, 16), m = Lg((d = g + d | 0) ^ u, 16), g = Lg((x = m + x | 0) ^ g, 12), Y = S, u = Lg((d = g + d | 0) ^ m, 8), Y = Lg(Y ^ (S = (X = u + x | 0) + N | 0), 12), R = Lg(N ^ (m = Y + R | 0), 8), S = Lg((x = R + S | 0) ^ Y, 7), Y = K, K = J, N = Lg(G ^ z, 8), J = Lg((G = N + H | 0) ^ b, 7), u = Lg((K = K + J | 0) ^ u, 16), H = Lg((b = Y + u | 0) ^ J, 12), u = Lg(u ^ (J = H + K | 0), 8), b = Lg((K = b + u | 0) ^ H, 7), H = G, G = d, d = Lg((U = U + j | 0) ^ M, 7), M = H + (l = Lg((G = G + d | 0) ^ l, 16)) | 0, H = G, G = Lg(M ^ d, 12), l = Lg(l ^ (d = H + G | 0), 8), M = Lg((H = M + l | 0) ^ G, 7), Y = U, G = N, N = Lg(g ^ X, 7), G = Lg(G ^ (U = N + v | 0), 16), v = Lg((g = Y + G | 0) ^ N, 12), G = Lg(G ^ (N = v + U | 0), 8), g = Lg((U = g + G | 0) ^ v, 7), q = q - 2 | 0;);
                                            if (q = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, v = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, z = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, j = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, X = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, V = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Z = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, W = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, T = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, N = N + k ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[0 | F] = N, o[F + 1 | 0] = N >>> 8, o[F + 2 | 0] = N >>> 16, o[F + 3 | 0] = N >>> 24, N = G + i ^ CA, o[F + 60 | 0] = N, o[F + 61 | 0] = N >>> 8, o[F + 62 | 0] = N >>> 16, o[F + 63 | 0] = N >>> 24, N = R + _ ^ gA, o[F + 56 | 0] = N, o[F + 57 | 0] = N >>> 8, o[F + 58 | 0] = N >>> 16, o[F + 59 | 0] = N >>> 24, N = u + P ^ IA, o[F + 52 | 0] = N, o[F + 53 | 0] = N >>> 8, o[F + 54 | 0] = N >>> 16, o[F + 55 | 0] = N >>> 24, N = l + L ^ AA, o[F + 48 | 0] = N, o[F + 49 | 0] = N >>> 8, o[F + 50 | 0] = N >>> 16, o[F + 51 | 0] = N >>> 24, N = H + c ^ $, o[F + 44 | 0] = N, o[F + 45 | 0] = N >>> 8, o[F + 46 | 0] = N >>> 16, o[F + 47 | 0] = N >>> 24, N = U + t ^ T, o[F + 40 | 0] = N, o[F + 41 | 0] = N >>> 8, o[F + 42 | 0] = N >>> 16, o[F + 43 | 0] = N >>> 24, N = x + r ^ W, o[F + 36 | 0] = N, o[F + 37 | 0] = N >>> 8, o[F + 38 | 0] = N >>> 16, o[F + 39 | 0] = N >>> 24, N = K + e ^ Z, o[F + 32 | 0] = N, o[F + 33 | 0] = N >>> 8, o[F + 34 | 0] = N >>> 16, o[F + 35 | 0] = N >>> 24, b = b + y ^ V, o[F + 28 | 0] = b, o[F + 29 | 0] = b >>> 8, o[F + 30 | 0] = b >>> 16, o[F + 31 | 0] = b >>> 24, M = Y ^ M + s, o[F + 24 | 0] = M, o[F + 25 | 0] = M >>> 8, o[F + 26 | 0] = M >>> 16, o[F + 27 | 0] = M >>> 24, g = X ^ g + D, o[F + 20 | 0] = g, o[F + 21 | 0] = g >>> 8, o[F + 22 | 0] = g >>> 16, o[F + 23 | 0] = g >>> 24, g = j ^ S + p, o[F + 16 | 0] = g, o[F + 17 | 0] = g >>> 8, o[F + 18 | 0] = g >>> 16, o[F + 19 | 0] = g >>> 24, g = z ^ m + w, o[F + 12 | 0] = g, o[F + 13 | 0] = g >>> 8, o[F + 14 | 0] = g >>> 16, o[F + 15 | 0] = g >>> 24, g = v ^ J + f, o[F + 8 | 0] = g, o[F + 9 | 0] = g >>> 8, o[F + 10 | 0] = g >>> 16, o[F + 11 | 0] = g >>> 24, g = q ^ d + n, o[F + 4 | 0] = g, o[F + 5 | 0] = g >>> 8, o[F + 6 | 0] = g >>> 16, o[F + 7 | 0] = g >>> 24, P = !(L = L + 1 | 0) + P | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(S = 0; o[S + O | 0] = a[F + S | 0], C >>> 0 > (S = S + 1 | 0) >>> 0;);
                                                E[A + 52 >> 2] = P, E[A + 48 >> 2] = L;
                                                break;
                                            }
                                            I = I - -64 | 0, g = F - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function z(A, I) {
                                        I |= 0;
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, _ = 0, c = 0;
                                        return h = g = h - 704 | 0, C = 80 + ((B = E[72 + (A |= 0) >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (Sg(C, 35456, 128 - B | 0), F(A, B = A + 80 | 0, g, g + 640 | 0), Hg(B, 0, 112)) : Sg(C, 35456, 112 - B | 0), _ = (Q = E[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 192 | 0] = C, o[A + 193 | 0] = C >>> 8, o[A + 194 | 0] = C >>> 16, o[A + 195 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 196 | 0] = B, o[A + 197 | 0] = B >>> 8, o[A + 198 | 0] = B >>> 16, o[A + 199 | 0] = B >>> 24, _ = (Q = E[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 200 | 0] = C, o[A + 201 | 0] = C >>> 8, o[A + 202 | 0] = C >>> 16, o[A + 203 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 204 | 0] = B, o[A + 205 | 0] = B >>> 8, o[A + 206 | 0] = B >>> 16, o[A + 207 | 0] = B >>> 24, F(A, A + 80 | 0, g, g + 640 | 0), _ = (Q = E[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[0 | I] = C, o[I + 1 | 0] = C >>> 8, o[I + 2 | 0] = C >>> 16, o[I + 3 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, _ = (Q = E[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 8 | 0] = C, o[I + 9 | 0] = C >>> 8, o[I + 10 | 0] = C >>> 16, o[I + 11 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, _ = (Q = E[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 16 | 0] = C, o[I + 17 | 0] = C >>> 8, o[I + 18 | 0] = C >>> 16, o[I + 19 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, _ = (Q = E[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 24 | 0] = C, o[I + 25 | 0] = C >>> 8, o[I + 26 | 0] = C >>> 16, o[I + 27 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, _ = (Q = E[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 32 | 0] = C, o[I + 33 | 0] = C >>> 8, o[I + 34 | 0] = C >>> 16, o[I + 35 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 36 | 0] = B, o[I + 37 | 0] = B >>> 8, o[I + 38 | 0] = B >>> 16, o[I + 39 | 0] = B >>> 24, _ = (Q = E[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, _ = (Q = E[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 48 | 0] = C, o[I + 49 | 0] = C >>> 8, o[I + 50 | 0] = C >>> 16, o[I + 51 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 52 | 0] = B, o[I + 53 | 0] = B >>> 8, o[I + 54 | 0] = B >>> 16, o[I + 55 | 0] = B >>> 24, _ = (Q = E[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = E[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, o[C + 56 | 0] = I, o[C + 57 | 0] = I >>> 8, o[C + 58 | 0] = I >>> 16, o[C + 59 | 0] = I >>> 24, I = (I = B | i | _) | (B = 0) | B | 0, o[C + 60 | 0] = I, o[C + 61 | 0] = I >>> 8, o[C + 62 | 0] = I >>> 16, o[C + 63 | 0] = I >>> 24, XC(g, 704), XC(A, 208), h = g + 704 | 0, 0;
                                    }
                                    function j(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G = 0;
                                        h = C = h - 224 | 0, c = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, t = a[0 | (G = g - -64 | 0)] | a[G + 1 | 0] << 8 | a[G + 2 | 0] << 16 | a[G + 3 | 0] << 24, r = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, e = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, y = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, D = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, p = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, w = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, f = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, F = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, N = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, S = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (_ = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = N & S ^ k ^ F ^ n ^ Q, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = w & f ^ D ^ p ^ s ^ B, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = e & y ^ c ^ t ^ r ^ i, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[G + 4 >> 2], E[C + 176 >> 2] = E[G >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), I = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = I, I = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = I, I = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = I, I = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = I, I = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = I, I = E[G + 4 >> 2], E[C + 128 >> 2] = E[G >> 2], E[C + 132 >> 2] = I, $A(A, C + 144 | 0, C + 128 | 0), I = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = I, I = E[C + 196 >> 2], E[G >> 2] = E[C + 192 >> 2], E[G + 4 >> 2] = I, I = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = I, I = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = I, I = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = I, I = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = I, $A(A, C + 112 | 0, C + 96 | 0), I = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = I, I = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = I, I = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = I, I = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = I, I = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = I, $A(A, C + 80 | 0, C - -64 | 0), I = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = I, I = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = I, I = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = I, I = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = I, I = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = I, $A(A, C + 48 | 0, C + 32 | 0), I = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = I, I = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = I, I = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = I, I = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = I, I = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = I, I = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = I, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], I = E[C + 196 >> 2], G = E[C + 200 >> 2], E[g + 12 >> 2] = _ ^ E[C + 204 >> 2], E[g + 8 >> 2] = G ^ Q, E[g + 4 >> 2] = I ^ B, E[g >> 2] = A ^ i, h = C + 224 | 0;
                                    }
                                    function X(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        h = C = h - 224 | 0, F = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, k = a[0 | (n = g - -64 | 0)] | a[n + 1 | 0] << 8 | a[n + 2 | 0] << 16 | a[n + 3 | 0] << 24, B = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Q = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, i = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, _ = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, c = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, t = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, r = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, e = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, S = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, y = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, s = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, D = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, p = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, f = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, S = p & w ^ S ^ s ^ D ^ y, o[A + 8 | 0] = S, o[A + 9 | 0] = S >>> 8, o[A + 10 | 0] = S >>> 16, o[A + 11 | 0] = S >>> 24, N = r & e ^ N ^ c ^ t ^ _, o[A + 4 | 0] = N, o[A + 5 | 0] = N >>> 8, o[A + 6 | 0] = N >>> 16, o[A + 7 | 0] = N >>> 24, F = Q & i ^ F ^ k ^ B ^ f, o[0 | A] = F, o[A + 1 | 0] = F >>> 8, o[A + 2 | 0] = F >>> 16, o[A + 3 | 0] = F >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[n + 4 >> 2], E[C + 176 >> 2] = E[n >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), k = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = k, k = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = k, k = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = k, k = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = k, k = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = k, k = E[n + 4 >> 2], E[C + 128 >> 2] = E[n >> 2], E[C + 132 >> 2] = k, $A(A, C + 144 | 0, C + 128 | 0), k = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = k, k = E[C + 196 >> 2], E[n >> 2] = E[C + 192 >> 2], E[n + 4 >> 2] = k, n = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = n, n = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = n, n = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = n, n = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = n, $A(A, C + 112 | 0, C + 96 | 0), n = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = n, n = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = n, n = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = n, n = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = n, n = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = n, $A(A, C + 80 | 0, C - -64 | 0), n = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = n, n = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = n, n = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = n, n = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = n, n = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = n, $A(A, C + 48 | 0, C + 32 | 0), n = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = n, n = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = n, n = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = n, n = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = n, n = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = n, n = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = n, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], n = E[C + 196 >> 2], k = E[C + 200 >> 2], E[g + 12 >> 2] = I ^ E[C + 204 >> 2], E[g + 8 >> 2] = k ^ S, E[g + 4 >> 2] = n ^ N, E[g >> 2] = A ^ F, h = C + 224 | 0;
                                    }
                                    function O(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        h = g = h - 800 | 0, y = E[(s = I + 40 | 0) >> 2], D = E[I + 80 >> 2], p = E[I + 44 >> 2], w = E[I + 84 >> 2], f = E[I + 48 >> 2], S = E[I + 88 >> 2], n = E[I + 52 >> 2], b = E[I + 92 >> 2], G = E[I + 56 >> 2], K = E[I + 96 >> 2], H = E[I + 60 >> 2], d = E[I + 100 >> 2], J = E[(k = I - -64 | 0) >> 2], U = E[I + 104 >> 2], l = E[I + 68 >> 2], m = E[I + 108 >> 2], u = E[I + 72 >> 2], x = E[I + 112 >> 2], F = E[I + 76 >> 2], N = E[I + 116 >> 2], E[g + 324 >> 2] = F + N, E[g + 320 >> 2] = u + x, E[g + 316 >> 2] = l + m, E[g + 312 >> 2] = J + U, E[g + 308 >> 2] = H + d, E[g + 304 >> 2] = G + K, E[g + 300 >> 2] = n + b, E[g + 296 >> 2] = f + S, E[g + 292 >> 2] = p + w, E[g + 288 >> 2] = y + D, E[g + 36 >> 2] = N - F, E[g + 32 >> 2] = x - u, E[g + 28 >> 2] = m - l, E[g + 24 >> 2] = U - J, E[g + 20 >> 2] = d - H, E[g + 16 >> 2] = K - G, E[g + 12 >> 2] = b - n, E[g + 8 >> 2] = S - f, E[g + 4 >> 2] = w - p, E[g >> 2] = D - y, Y(y = g + 288 | 0, y, g), Y(p = g + 240 | 0, I, s), v(D = g + 192 | 0, p), Y(D, y, D), E[g + 452 >> 2] = 0, E[g + 456 >> 2] = 0, E[g + 460 >> 2] = 0, E[g + 464 >> 2] = 0, E[g + 468 >> 2] = 0, E[g + 436 >> 2] = 0, E[g + 440 >> 2] = 0, E[g + 444 >> 2] = 0, E[g + 448 >> 2] = 0, E[g + 432 >> 2] = 1, GA(w = g + 576 | 0, g + 432 | 0, D), Y(D = g + 720 | 0, w, y), Y(b = g + 672 | 0, w, p), Y(n = g + 48 | 0, D, b), Y(n, n, y = I + 120 | 0), Y(g + 528 | 0, I, 1648), Y(g + 480 | 0, s, 1648), Y(g + 624 | 0, D, 2960), Y(D = g + 336 | 0, y, n), BI(S = g + 384 | 0, D), P = a[g + 384 | 0], D = E[I + 36 >> 2], y = E[I + 32 >> 2], E[g + 176 >> 2] = y, E[g + 180 >> 2] = D, p = E[I + 28 >> 2], D = E[I + 24 >> 2], E[g + 168 >> 2] = D, E[g + 172 >> 2] = p, w = E[I + 20 >> 2], p = E[I + 16 >> 2], E[g + 160 >> 2] = p, E[g + 164 >> 2] = w, f = E[I + 12 >> 2], w = E[I + 8 >> 2], E[g + 152 >> 2] = w, E[g + 156 >> 2] = f, G = E[I + 4 >> 2], f = E[I >> 2], E[g + 144 >> 2] = f, E[g + 148 >> 2] = G, G = E[s >> 2], K = E[I + 44 >> 2], H = E[I + 48 >> 2], d = E[I + 52 >> 2], J = E[I + 56 >> 2], U = E[I + 60 >> 2], l = E[k >> 2], m = E[I + 68 >> 2], u = E[I + 72 >> 2], x = E[I + 76 >> 2], q = E[g + 484 >> 2], k = E[g + 148 >> 2], z = E[g + 492 >> 2], F = E[g + 156 >> 2], j = E[g + 500 >> 2], N = E[g + 164 >> 2], X = E[g + 508 >> 2], M = E[g + 172 >> 2], O = E[g + 516 >> 2], L = E[g + 180 >> 2], V = E[g + 480 >> 2], Z = E[g + 488 >> 2], W = E[g + 496 >> 2], R = E[g + 504 >> 2], s = 0 - (1 & P) | 0, E[g + 176 >> 2] = y ^ s & (y ^ E[g + 512 >> 2]), E[g + 168 >> 2] = D ^ s & (D ^ R), E[g + 160 >> 2] = p ^ s & (p ^ W), E[g + 152 >> 2] = w ^ s & (w ^ Z), E[g + 144 >> 2] = f ^ s & (f ^ V), E[g + 180 >> 2] = L ^ s & (L ^ O), E[g + 172 >> 2] = M ^ s & (M ^ X), E[g + 164 >> 2] = N ^ s & (N ^ j), E[g + 156 >> 2] = F ^ s & (F ^ z), E[g + 148 >> 2] = k ^ s & (k ^ q), L = E[g + 528 >> 2], P = E[g + 532 >> 2], q = E[g + 536 >> 2], z = E[g + 540 >> 2], j = E[g + 544 >> 2], X = E[g + 548 >> 2], O = E[g + 552 >> 2], V = E[g + 556 >> 2], Z = E[g + 560 >> 2], W = E[g + 564 >> 2], y = E[g + 672 >> 2], R = E[g + 624 >> 2], D = E[g + 676 >> 2], B = E[g + 628 >> 2], p = E[g + 680 >> 2], Q = E[g + 632 >> 2], w = E[g + 684 >> 2], i = E[g + 636 >> 2], f = E[g + 688 >> 2], _ = E[g + 640 >> 2], k = E[g + 692 >> 2], c = E[g + 644 >> 2], F = E[g + 696 >> 2], t = E[g + 648 >> 2], N = E[g + 700 >> 2], r = E[g + 652 >> 2], M = E[g + 704 >> 2], e = E[g + 656 >> 2], C = E[g + 708 >> 2], E[g + 708 >> 2] = C ^ s & (E[g + 660 >> 2] ^ C), E[g + 704 >> 2] = M ^ s & (M ^ e), E[g + 700 >> 2] = N ^ s & (N ^ r), E[g + 696 >> 2] = F ^ s & (F ^ t), E[g + 692 >> 2] = k ^ s & (k ^ c), E[g + 688 >> 2] = f ^ s & (f ^ _), E[g + 684 >> 2] = w ^ s & (w ^ i), E[g + 680 >> 2] = p ^ s & (p ^ Q), E[g + 676 >> 2] = D ^ s & (D ^ B), E[g + 672 >> 2] = y ^ s & (y ^ R), Y(y = g + 96 | 0, g + 144 | 0, n), BI(S, y), D = E[I + 80 >> 2], p = E[I + 84 >> 2], w = E[I + 88 >> 2], f = E[I + 92 >> 2], n = E[I + 96 >> 2], k = E[I + 100 >> 2], F = E[I + 104 >> 2], N = E[I + 108 >> 2], M = E[I + 112 >> 2], R = E[I + 116 >> 2], I = 0 - (1 & o[g + 384 | 0]) | 0, y = x ^ s & (x ^ W), E[g + 420 >> 2] = R - (I & (0 - y ^ y) ^ y), y = u ^ s & (u ^ Z), E[g + 416 >> 2] = M - (I & (0 - y ^ y) ^ y), y = m ^ s & (m ^ V), E[g + 412 >> 2] = N - (I & (0 - y ^ y) ^ y), y = l ^ s & (l ^ O), E[g + 408 >> 2] = F - (I & (0 - y ^ y) ^ y), y = U ^ s & (U ^ X), E[g + 404 >> 2] = k - (I & (0 - y ^ y) ^ y), y = J ^ s & (J ^ j), E[g + 400 >> 2] = n - (I & (0 - y ^ y) ^ y), y = d ^ s & (d ^ z), E[g + 396 >> 2] = f - (I & (0 - y ^ y) ^ y), y = H ^ s & (H ^ q), E[g + 392 >> 2] = w - (I & (0 - y ^ y) ^ y), y = K ^ s & (K ^ P), E[g + 388 >> 2] = p - (I & (0 - y ^ y) ^ y), y = I, I = G ^ s & (G ^ L), E[g + 384 >> 2] = D - (y & (0 - I ^ I) ^ I), Y(S, b, S), BI(g + 768 | 0, S), I = 0 - (1 & o[g + 768 | 0]) | 0, y = E[g + 384 >> 2], E[g + 384 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 388 >> 2], E[g + 388 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 392 >> 2], E[g + 392 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 396 >> 2], E[g + 396 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 400 >> 2], E[g + 400 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 404 >> 2], E[g + 404 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 408 >> 2], E[g + 408 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 412 >> 2], E[g + 412 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 416 >> 2], E[g + 416 >> 2] = I & (0 - y ^ y) ^ y, y = I, I = E[g + 420 >> 2], E[g + 420 >> 2] = y & (0 - I ^ I) ^ I, BI(A, S), h = g + 800 | 0;
                                    }
                                    function V(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r = 0, e = 0;
                                        h = g = h - 288 | 0, C = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, B = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, Q = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, i = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, _ = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, c = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, t = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, A = E[I + 124 >> 2], E[g + 280 >> 2] = E[I + 120 >> 2], E[g + 284 >> 2] = A, A = E[I + 116 >> 2], E[g + 272 >> 2] = E[I + 112 >> 2], E[g + 276 >> 2] = A, A = E[I + 108 >> 2], E[g + 248 >> 2] = E[I + 104 >> 2], E[g + 252 >> 2] = A, A = E[I + 100 >> 2], E[g + 240 >> 2] = E[I + 96 >> 2], E[g + 244 >> 2] = A, A = E[I + 124 >> 2], E[g + 232 >> 2] = E[I + 120 >> 2], E[g + 236 >> 2] = A, A = E[I + 116 >> 2], E[g + 224 >> 2] = E[I + 112 >> 2], E[g + 228 >> 2] = A, $A(e = g + 256 | 0, g + 240 | 0, g + 224 | 0), A = E[g + 268 >> 2], E[I + 120 >> 2] = E[g + 264 >> 2], E[I + 124 >> 2] = A, A = E[g + 260 >> 2], E[I + 112 >> 2] = E[g + 256 >> 2], E[I + 116 >> 2] = A, A = E[I + 92 >> 2], E[g + 216 >> 2] = E[I + 88 >> 2], E[g + 220 >> 2] = A, A = E[I + 84 >> 2], E[g + 208 >> 2] = E[I + 80 >> 2], E[g + 212 >> 2] = A, A = E[I + 108 >> 2], E[g + 200 >> 2] = E[I + 104 >> 2], E[g + 204 >> 2] = A, A = E[I + 100 >> 2], E[g + 192 >> 2] = E[I + 96 >> 2], E[g + 196 >> 2] = A, $A(e, g + 208 | 0, g + 192 | 0), A = E[g + 268 >> 2], E[I + 104 >> 2] = E[g + 264 >> 2], E[I + 108 >> 2] = A, A = E[g + 260 >> 2], E[I + 96 >> 2] = E[g + 256 >> 2], E[I + 100 >> 2] = A, A = E[I + 76 >> 2], E[g + 184 >> 2] = E[I + 72 >> 2], E[g + 188 >> 2] = A, r = E[4 + (A = I - -64 | 0) >> 2], E[g + 176 >> 2] = E[A >> 2], E[g + 180 >> 2] = r, r = E[I + 92 >> 2], E[g + 168 >> 2] = E[I + 88 >> 2], E[g + 172 >> 2] = r, r = E[I + 84 >> 2], E[g + 160 >> 2] = E[I + 80 >> 2], E[g + 164 >> 2] = r, $A(e, g + 176 | 0, g + 160 | 0), r = E[g + 268 >> 2], E[I + 88 >> 2] = E[g + 264 >> 2], E[I + 92 >> 2] = r, r = E[g + 260 >> 2], E[I + 80 >> 2] = E[g + 256 >> 2], E[I + 84 >> 2] = r, r = E[I + 60 >> 2], E[g + 152 >> 2] = E[I + 56 >> 2], E[g + 156 >> 2] = r, r = E[I + 52 >> 2], E[g + 144 >> 2] = E[I + 48 >> 2], E[g + 148 >> 2] = r, r = E[I + 76 >> 2], E[g + 136 >> 2] = E[I + 72 >> 2], E[g + 140 >> 2] = r, r = E[A + 4 >> 2], E[g + 128 >> 2] = E[A >> 2], E[g + 132 >> 2] = r, $A(e, g + 144 | 0, g + 128 | 0), r = E[g + 268 >> 2], E[I + 72 >> 2] = E[g + 264 >> 2], E[I + 76 >> 2] = r, r = E[g + 260 >> 2], E[A >> 2] = E[g + 256 >> 2], E[A + 4 >> 2] = r, r = E[I + 44 >> 2], E[g + 120 >> 2] = E[I + 40 >> 2], E[g + 124 >> 2] = r, r = E[I + 36 >> 2], E[g + 112 >> 2] = E[I + 32 >> 2], E[g + 116 >> 2] = r, r = E[I + 60 >> 2], E[g + 104 >> 2] = E[I + 56 >> 2], E[g + 108 >> 2] = r, r = E[I + 52 >> 2], E[g + 96 >> 2] = E[I + 48 >> 2], E[g + 100 >> 2] = r, $A(e, g + 112 | 0, g + 96 | 0), r = E[g + 268 >> 2], E[I + 56 >> 2] = E[g + 264 >> 2], E[I + 60 >> 2] = r, r = E[g + 260 >> 2], E[I + 48 >> 2] = E[g + 256 >> 2], E[I + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 88 >> 2] = E[I + 24 >> 2], E[g + 92 >> 2] = r, r = E[I + 20 >> 2], E[g + 80 >> 2] = E[I + 16 >> 2], E[g + 84 >> 2] = r, r = E[I + 44 >> 2], E[g + 72 >> 2] = E[I + 40 >> 2], E[g + 76 >> 2] = r, r = E[I + 36 >> 2], E[g + 64 >> 2] = E[I + 32 >> 2], E[g + 68 >> 2] = r, $A(e, g + 80 | 0, g - -64 | 0), r = E[g + 268 >> 2], E[I + 40 >> 2] = E[g + 264 >> 2], E[I + 44 >> 2] = r, r = E[g + 260 >> 2], E[I + 32 >> 2] = E[g + 256 >> 2], E[I + 36 >> 2] = r, r = E[I + 12 >> 2], E[g + 56 >> 2] = E[I + 8 >> 2], E[g + 60 >> 2] = r, r = E[I + 4 >> 2], E[g + 48 >> 2] = E[I >> 2], E[g + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 40 >> 2] = E[I + 24 >> 2], E[g + 44 >> 2] = r, r = E[I + 20 >> 2], E[g + 32 >> 2] = E[I + 16 >> 2], E[g + 36 >> 2] = r, $A(e, g + 48 | 0, g + 32 | 0), r = E[g + 268 >> 2], E[I + 24 >> 2] = E[g + 264 >> 2], E[I + 28 >> 2] = r, r = E[g + 260 >> 2], E[I + 16 >> 2] = E[g + 256 >> 2], E[I + 20 >> 2] = r, r = E[g + 284 >> 2], E[g + 24 >> 2] = E[g + 280 >> 2], E[g + 28 >> 2] = r, r = E[g + 276 >> 2], E[g + 16 >> 2] = E[g + 272 >> 2], E[g + 20 >> 2] = r, r = E[I + 12 >> 2], E[g + 8 >> 2] = E[I + 8 >> 2], E[g + 12 >> 2] = r, r = E[I + 4 >> 2], E[g >> 2] = E[I >> 2], E[g + 4 >> 2] = r, $A(e, g + 16 | 0, g), e = E[g + 268 >> 2], E[I + 8 >> 2] = E[g + 264 >> 2], E[I + 12 >> 2] = e, e = E[g + 260 >> 2], E[I >> 2] = E[g + 256 >> 2], E[I + 4 >> 2] = e, E[I + 12 >> 2] = (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ c, E[I + 8 >> 2] = (a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24) ^ _, E[I + 4 >> 2] = (a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) ^ o, E[I >> 2] = (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) ^ t, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ i, E[I + 68 >> 2] = (a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24) ^ Q, E[I + 72 >> 2] = (a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) ^ B, E[I + 76 >> 2] = (a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) ^ C, h = g + 288 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = B = h - 240 | 0, G = 16 - g | 0, M = Hg((S = B + 192 | 0) + g | 0, 0, g >>> 0 <= 15 ? G : 0), Sg(S, I, g), N = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, Q = a[0 | (I = C - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, o = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24, r = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, e = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, y = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, s = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, D = a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24, p = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, w = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, f = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, n = E[B + 192 >> 2], k = E[B + 196 >> 2], F = E[B + 200 >> 2], E[B + 204 >> 2] = (a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24) & (a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24) ^ (a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24) ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24) ^ E[B + 204 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 200 >> 2] = w & f ^ p ^ F ^ D ^ s, E[B + 196 >> 2] = e & y ^ r ^ k ^ t ^ c, E[B + 192 >> 2] = o & _ ^ N ^ Q ^ i ^ n, Hg(M, 0, G), Sg(A, S, g), g = E[B + 192 >> 2], S = E[B + 196 >> 2], G = E[B + 200 >> 2], M = E[B + 204 >> 2], A = E[C + 92 >> 2], E[B + 232 >> 2] = E[C + 88 >> 2], E[B + 236 >> 2] = A, A = E[C + 84 >> 2], E[B + 224 >> 2] = E[C + 80 >> 2], E[B + 228 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, A = E[I + 4 >> 2], E[B + 176 >> 2] = E[I >> 2], E[B + 180 >> 2] = A, A = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = A, A = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = A, $A(A = B + 208 | 0, B + 176 | 0, B + 160 | 0), N = E[B + 220 >> 2], E[C + 88 >> 2] = E[B + 216 >> 2], E[C + 92 >> 2] = N, N = E[B + 212 >> 2], E[C + 80 >> 2] = E[B + 208 >> 2], E[C + 84 >> 2] = N, N = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = N, N = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = N, N = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = N, N = E[I + 4 >> 2], E[B + 128 >> 2] = E[I >> 2], E[B + 132 >> 2] = N, $A(A, B + 144 | 0, B + 128 | 0), N = E[B + 220 >> 2], E[C + 72 >> 2] = E[B + 216 >> 2], E[C + 76 >> 2] = N, N = E[B + 212 >> 2], E[I >> 2] = E[B + 208 >> 2], E[I + 4 >> 2] = N, I = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = I, I = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = I, I = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = I, I = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = I, $A(A, B + 112 | 0, B + 96 | 0), I = E[B + 220 >> 2], E[C + 56 >> 2] = E[B + 216 >> 2], E[C + 60 >> 2] = I, I = E[B + 212 >> 2], E[C + 48 >> 2] = E[B + 208 >> 2], E[C + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = I, I = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = I, I = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = I, I = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = I, $A(A, B + 80 | 0, B - -64 | 0), I = E[B + 220 >> 2], E[C + 40 >> 2] = E[B + 216 >> 2], E[C + 44 >> 2] = I, I = E[B + 212 >> 2], E[C + 32 >> 2] = E[B + 208 >> 2], E[C + 36 >> 2] = I, I = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = I, I = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = I, I = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = I, $A(A, B + 48 | 0, B + 32 | 0), I = E[B + 220 >> 2], E[C + 24 >> 2] = E[B + 216 >> 2], E[C + 28 >> 2] = I, I = E[B + 212 >> 2], E[C + 16 >> 2] = E[B + 208 >> 2], E[C + 20 >> 2] = I, I = E[B + 236 >> 2], E[B + 24 >> 2] = E[B + 232 >> 2], E[B + 28 >> 2] = I, I = E[B + 228 >> 2], E[B + 16 >> 2] = E[B + 224 >> 2], E[B + 20 >> 2] = I, I = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = I, I = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = I, $A(A, B + 16 | 0, B), A = E[B + 208 >> 2], I = E[B + 212 >> 2], N = E[B + 216 >> 2], E[C + 12 >> 2] = E[B + 220 >> 2] ^ M, E[C + 8 >> 2] = N ^ G, E[C + 4 >> 2] = I ^ S, E[C >> 2] = A ^ g, h = B + 240 | 0;
                                    }
                                    function W(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                        if (_ = 1886610805 ^ (C = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), i = 1936682341 ^ (Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), c = 1852142177 ^ C, E = 1819895653 ^ Q, Q = 1852075885 ^ (C = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), B = 1685025377 ^ (r = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = 2037671283 ^ C, r ^= 1952801890, (0 | (C = (I + g | 0) - (s = 7 & g) | 0)) != (0 | I)) {
                                            for(; c = c + (t ^= n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0, E = E + (e = r ^ (k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) | 0, E = c >>> 0 < t >>> 0 ? E + 1 | 0 : E, y = 1 + (i = B + i | 0) | 0, r = i, r = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? y : r, _ = c + (B = KI(Q, B, 13) ^ i) | 0, Q = E + (y = w ^ r) | 0, y = KI(B, y, 17) ^ _, f = KI(y, p = (D = B >>> 0 > _ >>> 0 ? Q + 1 | 0 : Q) ^ w, 13), h = w, B = KI(t, e, 16), Q = E ^ w, E = B ^ c, c = KI(i, r, 32), i = w + Q | 0, r = 1 + (c = p + (t = (B = E + c | 0) >>> 0 < c >>> 0 ? i + 1 | 0 : i) | 0) | 0, i = c, i = (c = B + y | 0) >>> 0 < B >>> 0 ? r : i, p = KI(r = c ^ f, e = i ^ h, 17), f = w, Q = KI(E, Q, 21), E = t ^ w, t = B ^ Q, B = KI(_, D, 32), Q = w + E | 0, B = (D = B >>> 0 > (_ = t + B | 0) >>> 0 ? Q + 1 | 0 : Q) + e | 0, Q = (e = _ + r | 0) ^ p, B = (y = e >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ f, E = KI(t, E, 16), r = t = D ^ w, E = KI(_ ^= E, t, 21), D = w, t = (_ = (c = KI(c, i, 32)) + _ | 0) ^ E, i = w + r | 0, r = (i = _ >>> 0 < c >>> 0 ? i + 1 | 0 : i) ^ D, c = KI(e, y, 32), E = w, _ ^= n, i ^= k, (0 | C) != (0 | (I = I + 8 | 0)););
                                            I = C;
                                        }
                                        switch(g <<= 24, C = 0, s - 1 | 0){
                                            case 6:
                                                g |= a[I + 6 | 0] << 16;
                                            case 5:
                                                g |= a[I + 5 | 0] << 8;
                                            case 4:
                                                g |= a[I + 4 | 0];
                                            case 3:
                                                e = (C = a[I + 3 | 0]) >>> 8 | 0, C <<= 24, g |= e;
                                            case 2:
                                                C |= (e = a[I + 2 | 0]) << 16, g |= y = e >>> 16 | 0;
                                            case 1:
                                                C |= (e = a[I + 1 | 0]) << 8, g |= y = e >>> 24 | 0;
                                            case 0:
                                                C = a[0 | I] | C;
                                        }
                                        return r = KI(I = C ^ t, t = g ^ r, 16), E = E + t | 0, c = (I = I + c | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, r = KI(E = I ^ r, t = c ^ w, 21), e = w, h = 1 + (i = B + i | 0) | 0, y = i, y = _ = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? h : y, s = KI(i, _, 32), t = w + t | 0, e = KI(E = r ^ (_ = E + s | 0), r = e ^ (t = _ >>> 0 < s >>> 0 ? t + 1 | 0 : t), 16), s = w, B = KI(Q, B, 13) ^ i, Q = (i = c) + (c = w ^ y) | 0, y = KI(I = I + B | 0, i = I >>> 0 < B >>> 0 ? Q + 1 | 0 : Q, 32), r = w + r | 0, y = KI(E = e ^ (Q = E + y | 0), e = (r = Q >>> 0 < y >>> 0 ? r + 1 | 0 : r) ^ s, 21), s = w, I = _ + (B = c = KI(B, c, 17) ^ I) | 0, _ = (i ^= w) + t | 0, t = B = I >>> 0 < B >>> 0 ? _ + 1 | 0 : _, h = y, _ = E + (y = KI(I, B, 32)) | 0, E = w + e | 0, y = KI(B = h ^ _, e = (E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ s, 16), s = w, h = Q, i = KI(c, i, 13) ^ I, c = (t ^= w) + r | 0, r = Q = (I = h + (Q = i) | 0) >>> 0 < Q >>> 0 ? c + 1 | 0 : c, Q = KI(I, Q, 32), c = e + w | 0, e = (h = B) >>> 0 > (B = B + (255 ^ Q) | 0) >>> 0 ? c + 1 | 0 : c, y = KI(c = B ^ y, Q = s ^ e, 21), s = w, i = KI(i, t, 17) ^ I, g = (t = r ^ w) + (g ^ E) | 0, g = KI(I = i + (C ^= _) | 0, E = g = I >>> 0 < C >>> 0 ? g + 1 | 0 : g, 32), C = Q + w | 0, c = KI(_ = (g = g + c | 0) ^ y, C = (Q = g >>> 0 < c >>> 0 ? C + 1 | 0 : C) ^ s, 16), r = w, i = KI(i, t, 13) ^ I, t = e + (E ^= w) | 0, t = B = (I = B + i | 0) >>> 0 < B >>> 0 ? t + 1 | 0 : t, B = KI(I, B, 32), y = r, h = 1 + (C = C + w | 0) | 0, r = C, r = (C = B + _ | 0) >>> 0 < _ >>> 0 ? h : r, c = KI(_ = C ^ c, B = y ^ r, 21), e = w, i = KI(i, E, 17), h = 1 + (Q = Q + (E = t ^ w) | 0) | 0, y = Q, i = I = (t = g) >>> 0 > (g = g + (Q = I ^ i) | 0) >>> 0 ? h : y, I = KI(g, I, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, Q = KI(Q, E, 13), E = r + (i ^= w) | 0, r = C, g = KI(C = C + (Q ^= g) | 0, E = g = r >>> 0 > C >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, r = (g = g + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = g ^ c, B = r ^ e, 21), e = w, Q = KI(Q, i, 17), y = 1 + (E = t + (i = E ^ w) | 0) | 0, t = E, I = KI(C = I + (E = C ^ Q) | 0, Q = C >>> 0 < I >>> 0 ? y : t, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, i = KI(E, i, 13), E = r + (Q ^= w) | 0, g = KI(C = g + (i ^= C) | 0, E = g = C >>> 0 < g >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, _ = KI((g = g + _ | 0) ^ c, (B = g >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ e, 21), c = w, C = KI(i, Q, 17) ^ C, i = KI(C, Q = E ^ w, 13), Q = Q + t | 0, I = w ^ (I >>> 0 > (C = I + C | 0) >>> 0 ? Q + 1 | 0 : Q), _ = KI(C ^= i, I, 17) ^ _, Q = w ^ c, i = 1 + (I = I + B | 0) | 0, B = I, I = KI(I = g + C | 0, g = g >>> 0 > I >>> 0 ? i : B, 32) ^ _ ^ I, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, I = g ^ w ^ Q, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                    }
                                    function T(A, I) {
                                        var g, C, B, Q, i, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0;
                                        h = g = h - 624 | 0, v(o = g + 480 | 0, I), Y(o, 1648, o), c = E[g + 516 >> 2], E[g + 276 >> 2] = c, t = E[g + 512 >> 2], E[g + 272 >> 2] = t, r = E[g + 508 >> 2], E[g + 268 >> 2] = r, e = E[g + 504 >> 2], E[g + 264 >> 2] = e, y = E[g + 500 >> 2], E[g + 260 >> 2] = y, s = E[g + 496 >> 2], E[g + 256 >> 2] = s, D = E[g + 492 >> 2], E[g + 252 >> 2] = D, p = E[g + 488 >> 2], E[g + 248 >> 2] = p, w = E[g + 484 >> 2], E[g + 244 >> 2] = w, n = E[g + 480 >> 2], E[g + 240 >> 2] = n + 1, Y(_ = g + 240 | 0, _, 33984), E[g + 468 >> 2] = c - 12055116, E[g + 464 >> 2] = t - 18696448, E[g + 460 >> 2] = r - 3247719, E[g + 456 >> 2] = e - 6275908, E[g + 452 >> 2] = y - 8787816, E[g + 448 >> 2] = s + 114729, E[g + 444 >> 2] = D + 6949391, E[g + 440 >> 2] = p - 15372611, E[g + 436 >> 2] = w + 13857413, E[g + 432 >> 2] = n - 10913610, Y(f = g + 192 | 0, o, 1600), E[g + 228 >> 2] = 0 - E[g + 228 >> 2], E[g + 224 >> 2] = 0 - E[g + 224 >> 2], E[g + 220 >> 2] = 0 - E[g + 220 >> 2], E[g + 216 >> 2] = 0 - E[g + 216 >> 2], E[g + 212 >> 2] = 0 - E[g + 212 >> 2], E[g + 208 >> 2] = 0 - E[g + 208 >> 2], E[g + 204 >> 2] = 0 - E[g + 204 >> 2], E[g + 200 >> 2] = 0 - E[g + 200 >> 2], E[g + 196 >> 2] = 0 - E[g + 196 >> 2], E[g + 192 >> 2] = -1 ^ E[g + 192 >> 2], Y(f, f, g + 432 | 0), o = GA(C = g + 384 | 0, _, f), Y(_ = g + 336 | 0, C, I), BI(B = g + 576 | 0, _), i = a[g + 576 | 0], d = E[g + 420 >> 2], _ = E[g + 372 >> 2], J = E[g + 416 >> 2], k = E[g + 368 >> 2], U = E[g + 412 >> 2], F = E[g + 364 >> 2], l = E[g + 408 >> 2], N = E[g + 360 >> 2], m = E[g + 404 >> 2], S = E[g + 356 >> 2], u = E[g + 400 >> 2], G = E[g + 352 >> 2], x = E[g + 396 >> 2], M = E[g + 348 >> 2], R = E[g + 392 >> 2], b = E[g + 344 >> 2], L = E[g + 388 >> 2], K = E[g + 340 >> 2], Q = E[g + 384 >> 2], H = E[g + 336 >> 2], I = o - 1 | 0, E[g + 612 >> 2] = I & c, E[g + 608 >> 2] = I & t, E[g + 604 >> 2] = I & r, E[g + 600 >> 2] = I & e, E[g + 596 >> 2] = I & y, E[g + 592 >> 2] = I & s, E[g + 588 >> 2] = I & D, E[g + 584 >> 2] = I & p, E[g + 580 >> 2] = I & w, E[g + 576 >> 2] = n | 0 - o, H = I & (0 - (H ^ (o = 0 - (1 & i) | 0) & (H ^ 0 - H)) ^ Q) ^ Q, E[g + 384 >> 2] = H, K = L ^ I & (L ^ 0 - (K ^ o & (K ^ 0 - K))), E[g + 388 >> 2] = K, b = R ^ I & (R ^ 0 - (b ^ o & (b ^ 0 - b))), E[g + 392 >> 2] = b, M = x ^ I & (x ^ 0 - (M ^ o & (M ^ 0 - M))), E[g + 396 >> 2] = M, G = u ^ I & (u ^ 0 - (G ^ o & (G ^ 0 - G))), E[g + 400 >> 2] = G, S = m ^ I & (m ^ 0 - (S ^ o & (S ^ 0 - S))), E[g + 404 >> 2] = S, N = l ^ I & (l ^ 0 - (N ^ o & (N ^ 0 - N))), E[g + 408 >> 2] = N, F = U ^ I & (U ^ 0 - (F ^ o & (F ^ 0 - F))), E[g + 412 >> 2] = F, k = J ^ I & (J ^ 0 - (k ^ o & (k ^ 0 - k))), E[g + 416 >> 2] = k, o = d ^ I & (d ^ 0 - (_ ^ o & (_ ^ 0 - _))), E[g + 420 >> 2] = o, E[g + 564 >> 2] = c, E[g + 560 >> 2] = t, E[g + 556 >> 2] = r, E[g + 552 >> 2] = e, E[g + 548 >> 2] = y, E[g + 544 >> 2] = s, E[g + 540 >> 2] = D, E[g + 536 >> 2] = p, E[g + 532 >> 2] = w, E[g + 528 >> 2] = n - 1, Y(I = g + 528 | 0, I, B), Y(I, I, 34032), c = E[g + 192 >> 2], t = E[g + 528 >> 2], r = E[g + 196 >> 2], e = E[g + 532 >> 2], y = E[g + 200 >> 2], s = E[g + 536 >> 2], D = E[g + 204 >> 2], p = E[g + 540 >> 2], w = E[g + 208 >> 2], n = E[g + 544 >> 2], _ = E[g + 212 >> 2], d = E[g + 548 >> 2], J = E[g + 216 >> 2], U = E[g + 552 >> 2], l = E[g + 220 >> 2], m = E[g + 556 >> 2], u = E[g + 224 >> 2], x = E[g + 560 >> 2], R = E[g + 228 >> 2], L = E[g + 564 >> 2], E[g + 180 >> 2] = o << 1, E[g + 176 >> 2] = k << 1, E[g + 172 >> 2] = F << 1, E[g + 168 >> 2] = N << 1, E[g + 164 >> 2] = S << 1, E[g + 160 >> 2] = G << 1, E[g + 156 >> 2] = M << 1, E[g + 152 >> 2] = b << 1, E[g + 148 >> 2] = K << 1, E[g + 144 >> 2] = H << 1, E[g + 564 >> 2] = L - R, E[g + 560 >> 2] = x - u, E[g + 556 >> 2] = m - l, E[g + 552 >> 2] = U - J, E[g + 548 >> 2] = d - _, E[g + 544 >> 2] = n - w, E[g + 540 >> 2] = p - D, E[g + 536 >> 2] = s - y, E[g + 532 >> 2] = e - r, E[g + 528 >> 2] = t - c, Y(o = g + 144 | 0, o, f), Y(f = g + 96 | 0, I, 34080), v(g + 288 | 0, C), I = E[g + 324 >> 2], E[g + 84 >> 2] = 0 - I, c = E[g + 320 >> 2], E[g + 80 >> 2] = 0 - c, t = E[g + 316 >> 2], E[g + 76 >> 2] = 0 - t, r = E[g + 312 >> 2], E[g + 72 >> 2] = 0 - r, e = E[g + 308 >> 2], E[g + 68 >> 2] = 0 - e, y = E[g + 304 >> 2], E[g + 64 >> 2] = 0 - y, s = E[g + 300 >> 2], E[g + 60 >> 2] = 0 - s, D = E[g + 296 >> 2], E[g + 56 >> 2] = 0 - D, p = E[g + 292 >> 2], E[g + 52 >> 2] = 0 - p, w = E[g + 288 >> 2], E[g + 48 >> 2] = 1 - w, E[g + 36 >> 2] = I, E[g + 32 >> 2] = c, E[g + 28 >> 2] = t, E[g + 24 >> 2] = r, E[g + 20 >> 2] = e, E[g + 16 >> 2] = y, E[g + 12 >> 2] = s, E[g + 8 >> 2] = D, E[g + 4 >> 2] = p, E[g >> 2] = w + 1, Y(A, o, g), Y(A + 40 | 0, I = g + 48 | 0, f), Y(A + 80 | 0, f, g), Y(A + 120 | 0, o, I), h = g + 624 | 0;
                                    }
                                    function $(A, I, g) {
                                        var C, B = 0, i = 0, _ = 0, c = 0, t = 0, r = 0;
                                        h = C = h + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (_ = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, t = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = _ + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, o[0 | B] = c, o[B + 1 | 0] = c >>> 8, o[B + 2 | 0] = c >>> 16, o[B + 3 | 0] = c >>> 24, o[B + 4 | 0] = i, o[B + 5 | 0] = i >>> 8, o[B + 6 | 0] = i >>> 16, o[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | t) & _ >>> 0 > 4294967167) >>> 0 > (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, f(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        Sg(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, _ = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, _ = (t = i + c | 0) >>> 0 < c >>> 0 ? _ + 1 | 0 : _, o[0 | B] = t, o[B + 1 | 0] = t >>> 8, o[B + 2 | 0] = t >>> 16, o[B + 3 | 0] = t >>> 24, o[B + 4 | 0] = _, o[B + 5 | 0] = _ >>> 8, o[B + 6 | 0] = _ >>> 16, o[B + 7 | 0] = _ >>> 24, B = (0 | _) == (0 | r) & i >>> 0 > t >>> 0 | _ >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (o[A + 88 | 0] = 255, o[A + 89 | 0] = 255, o[A + 90 | 0] = 255, o[A + 91 | 0] = 255, o[A + 92 | 0] = 255, o[A + 93 | 0] = 255, o[A + 94 | 0] = 255, o[A + 95 | 0] = 255), o[A + 80 | 0] = 255, o[A + 81 | 0] = 255, o[A + 82 | 0] = 255, o[A + 83 | 0] = 255, o[A + 84 | 0] = 255, o[A + 85 | 0] = 255, o[A + 86 | 0] = 255, o[A + 87 | 0] = 255, Hg((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), f(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, E[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, E[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, E[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, E[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, E[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, E[C + 60 >> 2] = i, Sg(I, C, g), XC(A, 64), XC(B, 256), B = 0;
                                                }
                                                return h = C - -64 | 0, B;
                                            }
                                            yC(), Q();
                                        }
                                        e(1369, 1217, 306, 1142), Q();
                                    }
                                    function AA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0, _ = 0;
                                        h = C = h - 192 | 0, E[C + 144 >> 2] = 0, E[C + 148 >> 2] = 0, E[C + 152 >> 2] = 0, E[C + 156 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = E[8591], E[C + 168 >> 2] = E[8590], E[C + 172 >> 2] = i, i = E[8593], E[C + 176 >> 2] = E[8592], E[C + 180 >> 2] = i, i = E[8595], E[C + 184 >> 2] = E[8594], E[C + 188 >> 2] = i, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 136 >> 2] = 0, E[C + 140 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, i = E[8589], E[C + 160 >> 2] = E[8588], E[C + 164 >> 2] = i, i = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 80 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 88 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 92 >> 2] = i, i = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C + 64 >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 68 >> 2] = i, i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 72 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 76 >> 2] = i, Eg(g = C + 128 | 0, i = C - -64 | 0), N(g), _ = E[C + 156 >> 2], E[C + 24 >> 2] = E[C + 152 >> 2], E[C + 28 >> 2] = _, _ = E[C + 148 >> 2], E[C + 16 >> 2] = E[C + 144 >> 2], E[C + 20 >> 2] = _, _ = E[C + 140 >> 2], E[C + 8 >> 2] = E[C + 136 >> 2], E[C + 12 >> 2] = _, _ = E[C + 132 >> 2], E[C >> 2] = E[C + 128 >> 2], E[C + 4 >> 2] = _, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, _ = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = _, _ = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = _, _ = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, Q = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 64 >> 2] = Q, E[C + 68 >> 2] = I, E[C + 72 >> 2] = _, E[C + 76 >> 2] = B, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, og(i, C), I = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = I, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(g), I = E[C + 156 >> 2], i = E[C + 152 >> 2], o[A + 24 | 0] = i, o[A + 25 | 0] = i >>> 8, o[A + 26 | 0] = i >>> 16, o[A + 27 | 0] = i >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[C + 148 >> 2], i = E[C + 144 >> 2], o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[C + 140 >> 2], i = E[C + 136 >> 2], o[A + 8 | 0] = i, o[A + 9 | 0] = i >>> 8, o[A + 10 | 0] = i >>> 16, o[A + 11 | 0] = i >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[C + 132 >> 2], i = E[C + 128 >> 2], o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = C + 192 | 0;
                                    }
                                    function IA(A) {
                                        var I, g, C, B, Q, i, a, _, t, r, e = 0, y = 0, s = 0, D = 0, p = 0;
                                        for(h = I = h - 2048 | 0, TA(D = I + 640 | 0, A), e = E[A + 36 >> 2], E[I + 352 >> 2] = E[A + 32 >> 2], E[I + 356 >> 2] = e, e = E[A + 28 >> 2], E[I + 344 >> 2] = E[A + 24 >> 2], E[I + 348 >> 2] = e, e = E[A + 20 >> 2], E[I + 336 >> 2] = E[A + 16 >> 2], E[I + 340 >> 2] = e, e = E[A + 12 >> 2], E[I + 328 >> 2] = E[A + 8 >> 2], E[I + 332 >> 2] = e, e = E[A + 4 >> 2], E[I + 320 >> 2] = E[A >> 2], E[I + 324 >> 2] = e, e = E[A + 52 >> 2], E[I + 368 >> 2] = E[A + 48 >> 2], E[I + 372 >> 2] = e, e = E[A + 60 >> 2], E[I + 376 >> 2] = E[A + 56 >> 2], E[I + 380 >> 2] = e, e = E[4 + (s = A - -64 | 0) >> 2], E[I + 384 >> 2] = E[s >> 2], E[I + 388 >> 2] = e, e = E[A + 76 >> 2], E[I + 392 >> 2] = E[A + 72 >> 2], E[I + 396 >> 2] = e, e = E[A + 44 >> 2], E[I + 360 >> 2] = E[A + 40 >> 2], E[I + 364 >> 2] = e, e = E[A + 92 >> 2], E[I + 408 >> 2] = E[A + 88 >> 2], E[I + 412 >> 2] = e, e = E[A + 100 >> 2], E[I + 416 >> 2] = E[A + 96 >> 2], E[I + 420 >> 2] = e, e = E[A + 108 >> 2], E[I + 424 >> 2] = E[A + 104 >> 2], E[I + 428 >> 2] = e, e = E[A + 116 >> 2], E[I + 432 >> 2] = E[A + 112 >> 2], E[I + 436 >> 2] = e, e = E[A + 84 >> 2], E[I + 400 >> 2] = E[A + 80 >> 2], E[I + 404 >> 2] = e, KA(y = I + 480 | 0, s = I + 320 | 0), Y(e = I + 160 | 0, y, g = I + 600 | 0), Y(I + 200 | 0, C = I + 520 | 0, B = I + 560 | 0), Y(I + 240 | 0, B, g), Y(I + 280 | 0, y, C), sA(y, e, D), Y(s, y, g), Y(a = I + 360 | 0, C, B), Y(_ = I + 400 | 0, B, g), Y(t = I + 440 | 0, y, C), TA(A = I + 800 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 960 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1120 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1280 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1440 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1600 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(I + 1760 | 0, s), E[I + 32 >> 2] = 0, E[I + 36 >> 2] = 0, E[I + 24 >> 2] = 0, E[I + 28 >> 2] = 0, E[I + 16 >> 2] = 0, E[I + 20 >> 2] = 0, E[I + 8 >> 2] = 0, E[I + 12 >> 2] = 0, E[I + 44 >> 2] = 0, E[I + 48 >> 2] = 0, E[I + 52 >> 2] = 0, E[I + 56 >> 2] = 0, E[I + 60 >> 2] = 0, E[I + 64 >> 2] = 0, E[I + 68 >> 2] = 0, E[I + 72 >> 2] = 0, E[I + 76 >> 2] = 0, E[I + 80 >> 2] = 1, E[I >> 2] = 0, E[I + 4 >> 2] = 0, E[I + 40 >> 2] = 1, Hg(I + 84 | 0, 0, 76), r = I + 120 | 0, Q = I + 2008 | 0, i = I + 1968 | 0, D = I + 80 | 0, s = I + 40 | 0, A = 252; e = E[I + 36 >> 2], E[(y = I + 1960 | 0) >> 2] = E[I + 32 >> 2], E[y + 4 >> 2] = e, e = E[I + 28 >> 2], E[(y = I + 1952 | 0) >> 2] = E[I + 24 >> 2], E[y + 4 >> 2] = e, e = E[I + 20 >> 2], E[(y = I + 1944 | 0) >> 2] = E[I + 16 >> 2], E[y + 4 >> 2] = e, e = E[I + 12 >> 2], E[(y = I + 1936 | 0) >> 2] = E[I + 8 >> 2], E[y + 4 >> 2] = e, e = E[I + 4 >> 2], E[I + 1928 >> 2] = E[I >> 2], E[I + 1932 >> 2] = e, e = E[s + 36 >> 2], E[i + 32 >> 2] = E[s + 32 >> 2], E[i + 36 >> 2] = e, e = E[s + 28 >> 2], E[i + 24 >> 2] = E[s + 24 >> 2], E[i + 28 >> 2] = e, e = E[s + 20 >> 2], E[i + 16 >> 2] = E[s + 16 >> 2], E[i + 20 >> 2] = e, e = E[s + 12 >> 2], E[i + 8 >> 2] = E[s + 8 >> 2], E[i + 12 >> 2] = e, e = E[s + 4 >> 2], E[i >> 2] = E[s >> 2], E[i + 4 >> 2] = e, e = E[D + 36 >> 2], E[Q + 32 >> 2] = E[D + 32 >> 2], E[Q + 36 >> 2] = e, e = E[D + 28 >> 2], E[Q + 24 >> 2] = E[D + 24 >> 2], E[Q + 28 >> 2] = e, e = E[D + 20 >> 2], E[Q + 16 >> 2] = E[D + 16 >> 2], E[Q + 20 >> 2] = e, e = E[D + 12 >> 2], E[Q + 8 >> 2] = E[D + 8 >> 2], E[Q + 12 >> 2] = e, e = E[D + 4 >> 2], E[Q >> 2] = E[D >> 2], E[Q + 4 >> 2] = e, e = A, p = o[A + 33728 | 0], KA(y = I + 480 | 0, I + 1928 | 0), (0 | p) > 0 ? (Y(A = I + 320 | 0, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), sA(y, A, (I + 640 | 0) + c((254 & p) >>> 1 | 0, 160) | 0)) : (0 | p) >= 0 || (Y(A = I + 320 | 0, y = I + 480 | 0, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), hA(y, A, (I + 640 | 0) + c((0 - p & 254) >>> 1 | 0, 160) | 0)), Y(I, A = I + 480 | 0, g), Y(s, C, B), Y(D, B, g), Y(r, A, C), A = e - 1 | 0, e;);
                                        return BI(A = I + 640 | 0, I), A = NI(A, 32), h = I + 2048 | 0, A;
                                    }
                                    function gA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, c = 0;
                                        A: if (A |= 0) {
                                            Q = (C = A - 8 | 0) + (A = -8 & (I = E[A - 4 >> 2])) | 0;
                                            I: if (!(1 & I)) {
                                                if (!(3 & I)) break A;
                                                if ((C = C - (I = E[C >> 2]) | 0) >>> 0 < _[9397]) break A;
                                                A = A + I | 0;
                                                g: {
                                                    C: {
                                                        if (E[9398] != (0 | C)) {
                                                            if (I >>> 0 <= 255) {
                                                                if (B = I >>> 3 | 0, (0 | (I = E[C + 12 >> 2])) == (0 | (g = E[C + 8 >> 2]))) {
                                                                    a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                    break I;
                                                                }
                                                                E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break I;
                                                            }
                                                            if (o = E[C + 24 >> 2], (0 | C) != (0 | (I = E[C + 12 >> 2]))) {
                                                                g = E[C + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break g;
                                                            }
                                                            if (!(g = E[(B = C + 20 | 0) >> 2])) {
                                                                if (!(g = E[C + 16 >> 2])) break C;
                                                                B = C + 16 | 0;
                                                            }
                                                            for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                            E[i >> 2] = 0;
                                                            break g;
                                                        }
                                                        if (3 != (3 & (I = E[Q + 4 >> 2]))) break I;
                                                        return E[9395] = A, E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, void (E[Q >> 2] = A);
                                                    }
                                                    I = 0;
                                                }
                                                if (o) {
                                                    g = E[C + 28 >> 2];
                                                    g: {
                                                        if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (E[B >> 2] = I, I) break g;
                                                            a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                    }
                                                    E[I + 24 >> 2] = o, (g = E[C + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[C + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                }
                                            }
                                            if (!(C >>> 0 >= Q >>> 0) && 1 & (I = E[Q + 4 >> 2])) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!(2 & I)) {
                                                                    if (E[9399] == (0 | Q)) {
                                                                        if (E[9399] = C, A = E[9396] + A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[9398] != (0 | C)) break A;
                                                                        return E[9395] = 0, void (E[9398] = 0);
                                                                    }
                                                                    if (E[9398] == (0 | Q)) return E[9398] = C, A = E[9395] + A | 0, E[9395] = A, E[C + 4 >> 2] = 1 | A, void (E[A + C >> 2] = A);
                                                                    if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                        if (B = I >>> 3 | 0, (0 | (I = E[Q + 12 >> 2])) == (0 | (g = E[Q + 8 >> 2]))) {
                                                                            a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                            break g;
                                                                        }
                                                                        E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break g;
                                                                    }
                                                                    if (o = E[Q + 24 >> 2], (0 | Q) != (0 | (I = E[Q + 12 >> 2]))) {
                                                                        g = E[Q + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break C;
                                                                    }
                                                                    if (!(g = E[(B = Q + 20 | 0) >> 2])) {
                                                                        if (!(g = E[Q + 16 >> 2])) break B;
                                                                        B = Q + 16 | 0;
                                                                    }
                                                                    for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                                    E[i >> 2] = 0;
                                                                    break C;
                                                                }
                                                                E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A;
                                                                break I;
                                                            }
                                                            I = 0;
                                                        }
                                                        if (o) {
                                                            g = E[Q + 28 >> 2];
                                                            C: {
                                                                if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                    if (E[B >> 2] = I, I) break C;
                                                                    a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                                    break g;
                                                                }
                                                                if (E[o + (E[o + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                            }
                                                            E[I + 24 >> 2] = o, (g = E[Q + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[Q + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                        }
                                                    }
                                                    if (E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A, E[9398] == (0 | C)) return void (E[9395] = A);
                                                }
                                                if (A >>> 0 <= 255) return I = 37612 + (-8 & A) | 0, (g = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[I + 8 >> 2] : (E[9393] = A | g, A = I), E[I + 8 >> 2] = C, E[A + 12 >> 2] = C, E[C + 12 >> 2] = I, void (E[C + 8 >> 2] = A);
                                                g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = t(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), E[C + 28 >> 2] = g, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, I = 37876 + (g << 2) | 0;
                                                I: {
                                                    g: {
                                                        if ((B = E[9394]) & (i = 1 << g)) {
                                                            for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = E[I >> 2];;){
                                                                if (B = I, (-8 & E[I + 4 >> 2]) == (0 | A)) break g;
                                                                if (i = g >>> 29 | 0, g <<= 1, !(I = E[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                            }
                                                            E[i + 16 >> 2] = C, E[C + 24 >> 2] = B;
                                                        } else E[9394] = B | i, E[I >> 2] = C, E[C + 24 >> 2] = I;
                                                        E[C + 12 >> 2] = C, E[C + 8 >> 2] = C;
                                                        break I;
                                                    }
                                                    A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[B + 8 >> 2] = C, E[C + 24 >> 2] = 0, E[C + 12 >> 2] = B, E[C + 8 >> 2] = A;
                                                }
                                                A = E[9401] - 1 | 0, E[9401] = A || -1;
                                            }
                                        }
                                    }
                                    function CA(A, I, g, C, B) {
                                        var Q, i, E, _, c, t, r, e, y, s, h, D, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0;
                                        if (C ? (U = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, m = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, l = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, u = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24) : (U = 1797285236, l = 1634760805, m = 2036477234, u = 857760878), C = Q = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = i = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, K = E = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = U, N = _ = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, G = m, H = c = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = t = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = r = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, I = e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, b = u, p = y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = s = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, k = h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, g = D = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = l, (0 | B) > 0) for(; Y = Lg(g + b | 0, 7) ^ H, x = Lg(Y + b | 0, 9) ^ S, d = Lg(C + F | 0, 7) ^ p, R = Lg(d + F | 0, 9) ^ M, v = Lg(d + R | 0, 13) ^ C, J = Lg(f + N | 0, 7) ^ w, n = Lg(J + f | 0, 9) ^ n, w = Lg(n + J | 0, 13) ^ N, f = Lg(n + w | 0, 18) ^ f, p = Lg(I + G | 0, 7) ^ K, C = v ^ Lg(f + p | 0, 7), S = Lg(C + f | 0, 9) ^ x, K = Lg(C + S | 0, 13) ^ p, f = Lg(S + K | 0, 18) ^ f, k = Lg(p + G | 0, 9) ^ k, p = Lg(k + p | 0, 13) ^ I, I = Lg(p + k | 0, 18) ^ G, N = Lg(I + Y | 0, 7) ^ w, M = Lg(N + I | 0, 9) ^ R, H = Lg(N + M | 0, 13) ^ Y, G = Lg(M + H | 0, 18) ^ I, g = Lg(Y + x | 0, 13) ^ g, w = Lg(g + x | 0, 18) ^ b, I = Lg(w + d | 0, 7) ^ p, n = Lg(I + w | 0, 9) ^ n, p = Lg(I + n | 0, 13) ^ d, b = Lg(n + p | 0, 18) ^ w, F = Lg(R + v | 0, 18) ^ F, g = Lg(F + J | 0, 7) ^ g, k = Lg(g + F | 0, 9) ^ k, w = Lg(g + k | 0, 13) ^ J, F = Lg(k + w | 0, 18) ^ F, (0 | (L = L + 2 | 0)) < (0 | B););
                                        B = f + U | 0, o[A + 60 | 0] = B, o[A + 61 | 0] = B >>> 8, o[A + 62 | 0] = B >>> 16, o[A + 63 | 0] = B >>> 24, B = K + E | 0, o[A + 56 | 0] = B, o[A + 57 | 0] = B >>> 8, o[A + 58 | 0] = B >>> 16, o[A + 59 | 0] = B >>> 24, B = S + i | 0, o[A + 52 | 0] = B, o[A + 53 | 0] = B >>> 8, o[A + 54 | 0] = B >>> 16, o[A + 55 | 0] = B >>> 24, C = C + Q | 0, o[A + 48 | 0] = C, o[A + 49 | 0] = C >>> 8, o[A + 50 | 0] = C >>> 16, o[A + 51 | 0] = C >>> 24, C = N + _ | 0, o[A + 44 | 0] = C, o[A + 45 | 0] = C >>> 8, o[A + 46 | 0] = C >>> 16, o[A + 47 | 0] = C >>> 24, C = G + m | 0, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, C = H + c | 0, o[A + 36 | 0] = C, o[A + 37 | 0] = C >>> 8, o[A + 38 | 0] = C >>> 16, o[A + 39 | 0] = C >>> 24, C = M + t | 0, o[A + 32 | 0] = C, o[A + 33 | 0] = C >>> 8, o[A + 34 | 0] = C >>> 16, o[A + 35 | 0] = C >>> 24, C = n + r | 0, o[A + 28 | 0] = C, o[A + 29 | 0] = C >>> 8, o[A + 30 | 0] = C >>> 16, o[A + 31 | 0] = C >>> 24, I = I + e | 0, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = b + u | 0, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p + y | 0, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = w + s | 0, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = k + h | 0, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = g + D | 0, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F + l | 0, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                    }
                                    function BA(A, I, g, C, B, Q) {
                                        var i = 0;
                                        if (E[Q >> 2] = 8, !(I = (i = !I & A >>> 0 <= 32768) ? 0 : I) & g >>> 5 >>> 0 <= (A = i ? 32768 : A) >>> 0 | I) return i = 1, g >>> 0 < 4096 || (i = 2, g >>> 0 < 8192 || (i = 3, g >>> 0 < 16384 || (i = 4, g >>> 0 < 32768 || (i = 5, g >>> 0 < 65536 || (i = 6, g >>> 0 < 131072 || (i = 7, g >>> 0 < 262144 || (i = 8, g >>> 0 < 524288 || (i = 9, g >>> 0 < 1048576 || (i = 10, g >>> 0 < 2097152 || (i = 11, g >>> 0 < 4194304 || (i = 12, g >>> 0 < 8388608 || (i = 13, g >>> 0 < 16777216 || (i = 14, g >>> 0 < 33554432 || (i = 15, g >>> 0 < 67108864 || (i = 16, g >>> 0 < 134217728 || (i = 17, g >>> 0 < 268435456 || (i = 18, g >>> 0 < 536870912 || (i = 19, g >>> 0 < 1073741824 || (i = (0 | g) >= 0 ? 20 : 21))))))))))))))))))), g = i, E[C >> 2] = g, C = I >>> 2 | 0, I = (3 & I) << 30 | A >>> 2, A = 31 & g, (63 & g) >>> 0 >= 32 ? (g = 0, A = C >>> A | 0) : (g = C >>> A | 0, A = ((1 << A) - 1 & C) << 32 - A | I >>> A), void (E[B >> 2] = ((!g & A >>> 0 >= 1073741823 | g ? 1073741823 : A) >>> 0) / _[Q >> 2]);
                                        E[B >> 2] = 1, I = oI(A, I, E[Q >> 2] << 2), g = 1, !(A = w) & I >>> 0 < 4 || (g = 2, !A & I >>> 0 < 8 || (g = 3, !A & I >>> 0 < 16 || (g = 4, !A & I >>> 0 < 32 || (g = 5, !A & I >>> 0 < 64 || (g = 6, !A & I >>> 0 < 128 || (g = 7, !A & I >>> 0 < 256 || (g = 8, !A & I >>> 0 < 512 || (g = 9, !A & I >>> 0 < 1024 || (g = 10, !A & I >>> 0 < 2048 || (g = 11, !A & I >>> 0 < 4096 || (g = 12, !A & I >>> 0 < 8192 || (g = 13, !A & I >>> 0 < 16384 || (g = 14, !A & I >>> 0 < 32768 || (g = 15, !A & I >>> 0 < 65536 || (g = 16, !A & I >>> 0 < 131072 || (g = 17, !A & I >>> 0 < 262144 || (g = 18, !A & I >>> 0 < 524288 || (g = 19, !A & I >>> 0 < 1048576 || (g = 20, !A & I >>> 0 < 2097152 || (g = 21, !A & I >>> 0 < 4194304 || (g = 22, !A & I >>> 0 < 8388608 || (g = 23, !A & I >>> 0 < 16777216 || (g = 24, !A & I >>> 0 < 33554432 || (g = 25, !A & I >>> 0 < 67108864 || (g = 26, !A & I >>> 0 < 134217728 || (g = 27, !A & I >>> 0 < 268435456 || (g = 28, !A & I >>> 0 < 536870912 || (g = 29, !A & I >>> 0 < 1073741824 || (g = 30, !A & I >>> 0 < 2147483648 || (g = 31, A && (g = 32, A >>> 0 < 2 || (g = 33, A >>> 0 < 4 || (g = 34, A >>> 0 < 8 || (g = 35, A >>> 0 < 16 || (g = 36, A >>> 0 < 32 || (g = 37, A >>> 0 < 64 || (g = 38, A >>> 0 < 128 || (g = 39, A >>> 0 < 256 || (g = 40, A >>> 0 < 512 || (g = 41, A >>> 0 < 1024 || (g = 42, A >>> 0 < 2048 || (g = 43, A >>> 0 < 4096 || (g = 44, A >>> 0 < 8192 || (g = 45, A >>> 0 < 16384 || (g = 46, A >>> 0 < 32768 || (g = 47, A >>> 0 < 65536 || (g = 48, A >>> 0 < 131072 || (g = 49, A >>> 0 < 262144 || (g = 50, A >>> 0 < 524288 || (g = 51, A >>> 0 < 1048576 || (g = 52, A >>> 0 < 2097152 || (g = 53, A >>> 0 < 4194304 || (g = 54, A >>> 0 < 8388608 || (g = 55, A >>> 0 < 16777216 || (g = 56, A >>> 0 < 33554432 || (g = 57, A >>> 0 < 67108864 || (g = 58, A >>> 0 < 134217728 || (g = 59, A >>> 0 < 268435456 || (g = 60, A >>> 0 < 536870912 || (g = 61, A >>> 0 < 1073741824 || (g = (0 | A) > 0 | (0 | A) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), E[C >> 2] = g;
                                    }
                                    function QA(A, I, g, C, B, i, o, _, c) {
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            w = t = h, h = t = t - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((D = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), o = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), _ = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24)) : (r = 725511199, e = -1694144372, o = -1377402159, _ = 1359893119), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), p = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24), c = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24)) : (y = 327033209, s = 1541459225, p = -79577749, c = 528734635), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = p, E[t + 52 >> 2] = c, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = o, E[t + 36 >> 2] = _, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ (I << 8 | D), E[t + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = t + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(t + 96 | 0, o, 128), E[t + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), i = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24), I = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24)) : (r = 725511199, e = -1694144372, i = 1359893119, I = -1377402159), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), _ = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24), o = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24)) : (y = 327033209, s = 1541459225, _ = 528734635, o = -79577749), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = o, E[t + 52 >> 2] = _, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = I, E[t + 36 >> 2] = i, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ D, E[t + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(c = t + 224 | 0, _ = t + 96 | 0;;){
                                                        if (o = I + _ | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[t + 352 >> 2] = C + E[t + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[t + 352 >> 2] = i + E[t + 352 >> 2], r = I = E[t + 68 >> 2], I = (e = (o = E[t + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[t + 64 >> 2] = e, E[t + 68 >> 2] = I, I = E[t + 76 >> 2], I = (r = o = -1 == (0 | r) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[t + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[t + 72 >> 2] = o, E[t + 76 >> 2] = I, f(t, _), Sg(_, c, 128), I = E[t + 352 >> 2] - 128 | 0, E[t + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(t, A, D), h = w;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function iA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0;
                                        g = A + I | 0;
                                        A: {
                                            I: if (!(1 & (C = E[A + 4 >> 2]))) {
                                                if (!(3 & C)) break A;
                                                I = (C = E[A >> 2]) + I | 0;
                                                g: {
                                                    C: {
                                                        B: {
                                                            if ((0 | (A = A - C | 0)) != E[9398]) {
                                                                if (C >>> 0 <= 255) {
                                                                    if ((0 | (B = E[A + 8 >> 2])) != (0 | (Q = E[A + 12 >> 2]))) break B;
                                                                    a = 37572, _ = E[9393] & Lg(-2, C >>> 3 | 0), E[a >> 2] = _;
                                                                    break I;
                                                                }
                                                                if (o = E[A + 24 >> 2], (0 | (C = E[A + 12 >> 2])) != (0 | A)) {
                                                                    B = E[A + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (!(B = E[(Q = A + 20 | 0) >> 2])) {
                                                                    if (!(B = E[A + 16 >> 2])) break C;
                                                                    Q = A + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (C = E[g + 4 >> 2]))) break I;
                                                            return E[9395] = I, E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, void (E[g >> 2] = I);
                                                        }
                                                        E[B + 12 >> 2] = Q, E[Q + 8 >> 2] = B;
                                                        break I;
                                                    }
                                                    C = 0;
                                                }
                                                if (o) {
                                                    B = E[A + 28 >> 2];
                                                    g: {
                                                        if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | A)) {
                                                            if (E[Q >> 2] = C, C) break g;
                                                            a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | A) ? 16 : 20) >> 2] = C, !C) break I;
                                                    }
                                                    E[C + 24 >> 2] = o, (B = E[A + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[A + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                }
                                            }
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            if (!(2 & (C = E[g + 4 >> 2]))) {
                                                                if (E[9399] == (0 | g)) {
                                                                    if (E[9399] = A, I = E[9396] + I | 0, E[9396] = I, E[A + 4 >> 2] = 1 | I, E[9398] != (0 | A)) break A;
                                                                    return E[9395] = 0, void (E[9398] = 0);
                                                                }
                                                                if (E[9398] == (0 | g)) return E[9398] = A, I = E[9395] + I | 0, E[9395] = I, E[A + 4 >> 2] = 1 | I, void (E[A + I >> 2] = I);
                                                                if (I = (-8 & C) + I | 0, C >>> 0 <= 255) {
                                                                    if (Q = C >>> 3 | 0, (0 | (C = E[g + 12 >> 2])) == (0 | (B = E[g + 8 >> 2]))) {
                                                                        a = 37572, _ = E[9393] & Lg(-2, Q), E[a >> 2] = _;
                                                                        break g;
                                                                    }
                                                                    E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (o = E[g + 24 >> 2], (0 | g) != (0 | (C = E[g + 12 >> 2]))) {
                                                                    B = E[g + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break C;
                                                                }
                                                                if (!(B = E[(Q = g + 20 | 0) >> 2])) {
                                                                    if (!(B = E[g + 16 >> 2])) break B;
                                                                    Q = g + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break C;
                                                            }
                                                            E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I;
                                                            break I;
                                                        }
                                                        C = 0;
                                                    }
                                                    if (o) {
                                                        B = E[g + 28 >> 2];
                                                        C: {
                                                            if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | g)) {
                                                                if (E[Q >> 2] = C, C) break C;
                                                                a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                                break g;
                                                            }
                                                            if (E[o + (E[o + 16 >> 2] == (0 | g) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        E[C + 24 >> 2] = o, (B = E[g + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[g + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                    }
                                                }
                                                if (E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I, E[9398] == (0 | A)) return void (E[9395] = I);
                                            }
                                            if (I >>> 0 <= 255) return C = 37612 + (-8 & I) | 0, (B = E[9393]) & (I = 1 << (I >>> 3)) ? I = E[C + 8 >> 2] : (E[9393] = I | B, I = C), E[C + 8 >> 2] = A, E[I + 12 >> 2] = A, E[A + 12 >> 2] = C, void (E[A + 8 >> 2] = I);
                                            B = 31, I >>> 0 <= 16777215 && (B = 62 + ((I >>> 38 - (C = t(I >>> 8 | 0)) & 1) - (C << 1) | 0) | 0), E[A + 28 >> 2] = B, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, C = 37876 + (B << 2) | 0;
                                            I: {
                                                if ((Q = E[9394]) & (i = 1 << B)) {
                                                    for(B = I << (31 != (0 | B) ? 25 - (B >>> 1 | 0) | 0 : 0), C = E[C >> 2];;){
                                                        if (Q = C, (-8 & E[C + 4 >> 2]) == (0 | I)) break I;
                                                        if (i = B >>> 29 | 0, B <<= 1, !(C = E[16 + (i = C + (4 & i) | 0) >> 2])) break;
                                                    }
                                                    E[i + 16 >> 2] = A, E[A + 24 >> 2] = Q;
                                                } else E[9394] = Q | i, E[C >> 2] = A, E[A + 24 >> 2] = C;
                                                return E[A + 12 >> 2] = A, void (E[A + 8 >> 2] = A);
                                            }
                                            I = E[Q + 8 >> 2], E[I + 12 >> 2] = A, E[Q + 8 >> 2] = A, E[A + 24 >> 2] = 0, E[A + 12 >> 2] = Q, E[A + 8 >> 2] = I;
                                        }
                                    }
                                    function oA(A, I, g, C, B, Q, i) {
                                        var _, t, r = 0, e = 0, y = 0;
                                        if (h = _ = h + -64 | 0, t = K(32)) {
                                            E[_ + 36 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 28 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 24 >> 2] = 16, E[_ + 20 >> 2] = B, E[_ + 16 >> 2] = C, E[_ + 12 >> 2] = g, E[_ + 8 >> 2] = 32, E[_ + 4 >> 2] = t, E[_ + 60 >> 2] = 0, E[_ + 56 >> 2] = 1, E[_ + 52 >> 2] = 1, E[_ + 48 >> 2] = I, E[_ + 44 >> 2] = A;
                                            A: if (A = L(_ + 4 | 0, i)) XC(t, 32);
                                            else {
                                                if (Q) {
                                                    r = _ + 4 | 0, h = B = h - 32 | 0, A = -31;
                                                    I: {
                                                        g: {
                                                            C: switch(i - 1 | 0){
                                                                case 1:
                                                                    A = a[1417] | a[1418] << 8 | a[1419] << 16 | a[1420] << 24, I = a[1413] | a[1414] << 8 | a[1415] << 16 | a[1416] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1422] | a[1423] << 8 | a[1424] << 16 | a[1425] << 24, I = a[1418] | a[1419] << 8 | a[1420] << 16 | a[1421] << 24, o[Q + 5 | 0] = I, o[Q + 6 | 0] = I >>> 8, o[Q + 7 | 0] = I >>> 16, o[Q + 8 | 0] = I >>> 24, o[Q + 9 | 0] = A, o[Q + 10 | 0] = A >>> 8, o[Q + 11 | 0] = A >>> 16, o[Q + 12 | 0] = A >>> 24, g = -12, I = 12;
                                                                    break g;
                                                                case 0:
                                                                    break C;
                                                                default:
                                                                    break I;
                                                            }
                                                            A = a[1405] | a[1406] << 8 | a[1407] << 16 | a[1408] << 24, I = a[1401] | a[1402] << 8 | a[1403] << 16 | a[1404] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1409] | a[1410] << 8 | a[1411] << 16 | a[1412] << 24, o[Q + 8 | 0] = A, o[Q + 9 | 0] = A >>> 8, o[Q + 10 | 0] = A >>> 16, o[Q + 11 | 0] = A >>> 24, g = -11, I = 11;
                                                        }
                                                        if (!(A = pI(r))) {
                                                            if (o[B + 13 | 0] = 0, o[B + 11 | 0] = 49, o[B + 12 | 0] = 57, (g = g + 128 | 0) >>> 0 <= (A = LI(B + 11 | 0)) >>> 0) A = -31;
                                                            else if (I = Sg(I + Q | 0, B + 11 | 0, A + 1 | 0), (e = g - A | 0) >>> 0 < 4) A = -31;
                                                            else {
                                                                for(o[0 | (i = A + I | 0)] = 36, o[i + 1 | 0] = 109, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 44 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                else {
                                                                    for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 116, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 40 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                    if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                    else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                    else {
                                                                        for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 112, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 48 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                        Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0 ? A = -31 : (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (C = I - A | 0) >>> 0 < 2 ? A = -31 : (o[0 | (A = A + g | 0)] = 36, o[A + 1 | 0] = 0, LA(I = A + 1 | 0, g = C - 1 | 0, E[r + 16 >> 2], E[r + 20 >> 2], 3) ? (A = -31, (C = (C = g) - (g = LI(I)) | 0) >>> 0 < 2 || (o[0 | (A = I + g | 0)] = 36, o[A + 1 | 0] = 0, A = LA(A + 1 | 0, C - 1 | 0, E[r >> 2], E[r + 4 >> 2], 3) ? 0 : -31)) : A = -31));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (h = B + 32 | 0, A) {
                                                        XC(t, 32), XC(Q, 128), A = -31;
                                                        break A;
                                                    }
                                                }
                                                XC(t, 32), A = 0;
                                            }
                                            gA(t);
                                        } else A = -22;
                                        return h = _ - -64 | 0, A;
                                    }
                                    function EA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0;
                                        return h = g = h - 512 | 0, C = -1, Q = a[I + 31 | 0], B = a[0 | I], 1 & (((255 & (127 & (-1 ^ Q) | a[I + 1 | 0] & a[I + 2 | 0] & a[I + 3 | 0] & a[I + 4 | 0] & a[I + 5 | 0] & a[I + 6 | 0] & a[I + 7 | 0] & a[I + 8 | 0] & a[I + 9 | 0] & a[I + 10 | 0] & a[I + 11 | 0] & a[I + 12 | 0] & a[I + 13 | 0] & a[I + 14 | 0] & a[I + 15 | 0] & a[I + 16 | 0] & a[I + 17 | 0] & a[I + 18 | 0] & a[I + 19 | 0] & a[I + 20 | 0] & a[I + 21 | 0] & a[I + 22 | 0] & a[I + 23 | 0] & a[I + 24 | 0] & a[I + 25 | 0] & a[I + 26 | 0] & a[I + 27 | 0] & a[I + 28 | 0] & a[I + 29 | 0] & a[I + 30 | 0] ^ -1)) - 1 & 236 - B) >>> 8 | B | Q >>> 7) || (pA(Q = g + 336 | 0, I), v(g + 288 | 0, Q), I = E[g + 324 >> 2], E[g + 276 >> 2] = 0 - I, C = E[g + 320 >> 2], E[g + 272 >> 2] = 0 - C, B = E[g + 316 >> 2], E[g + 268 >> 2] = 0 - B, i = E[g + 312 >> 2], E[g + 264 >> 2] = 0 - i, _ = E[g + 308 >> 2], E[g + 260 >> 2] = 0 - _, c = E[g + 304 >> 2], E[g + 256 >> 2] = 0 - c, t = E[g + 300 >> 2], E[g + 252 >> 2] = 0 - t, r = E[g + 296 >> 2], E[g + 248 >> 2] = 0 - r, e = E[g + 292 >> 2], E[g + 244 >> 2] = 0 - e, y = E[g + 288 >> 2], E[g + 240 >> 2] = 1 - y, v(s = g + 144 | 0, w = g + 240 | 0), E[g + 228 >> 2] = I, E[g + 224 >> 2] = C, E[g + 220 >> 2] = B, E[g + 216 >> 2] = i, E[g + 212 >> 2] = _, E[g + 208 >> 2] = c, E[g + 204 >> 2] = t, E[g + 200 >> 2] = r, E[g + 196 >> 2] = e, E[g + 192 >> 2] = y + 1, v(C = g + 96 | 0, i = g + 192 | 0), Y(I = g + 48 | 0, 1600, s), B = E[g + 96 >> 2], _ = E[g + 48 >> 2], c = E[g + 100 >> 2], t = E[g + 52 >> 2], r = E[g + 104 >> 2], e = E[g + 56 >> 2], y = E[g + 108 >> 2], s = E[g + 60 >> 2], D = E[g + 112 >> 2], p = E[g + 64 >> 2], f = E[g + 116 >> 2], n = E[g + 68 >> 2], k = E[g + 120 >> 2], F = E[g + 72 >> 2], N = E[g + 124 >> 2], S = E[g + 76 >> 2], G = E[g + 128 >> 2], M = E[g + 80 >> 2], E[g + 84 >> 2] = 0 - (E[g + 84 >> 2] + E[g + 132 >> 2] | 0), E[g + 80 >> 2] = 0 - (G + M | 0), E[g + 76 >> 2] = 0 - (N + S | 0), E[g + 72 >> 2] = 0 - (k + F | 0), E[g + 68 >> 2] = 0 - (f + n | 0), E[g + 64 >> 2] = 0 - (D + p | 0), E[g + 60 >> 2] = 0 - (y + s | 0), E[g + 56 >> 2] = 0 - (r + e | 0), E[g + 52 >> 2] = 0 - (c + t | 0), E[g + 48 >> 2] = 0 - (B + _ | 0), Y(g, I, C), E[g + 404 >> 2] = 0, E[g + 408 >> 2] = 0, E[g + 412 >> 2] = 0, E[g + 416 >> 2] = 0, E[g + 420 >> 2] = 0, E[g + 388 >> 2] = 0, E[g + 392 >> 2] = 0, E[g + 384 >> 2] = 1, E[g + 396 >> 2] = 0, E[g + 400 >> 2] = 0, p = GA(B = g + 432 | 0, g + 384 | 0, g), Y(A, B, i), Y(C = A + 40 | 0, B, A), Y(C, C, I), Y(A, A, Q), Q = E[A + 36 >> 2] << 1, E[A + 36 >> 2] = Q, B = E[A + 32 >> 2] << 1, E[A + 32 >> 2] = B, i = E[A + 28 >> 2] << 1, E[A + 28 >> 2] = i, _ = E[A + 24 >> 2] << 1, E[A + 24 >> 2] = _, c = E[A + 20 >> 2] << 1, E[A + 20 >> 2] = c, t = E[A + 16 >> 2] << 1, E[A + 16 >> 2] = t, r = E[A + 12 >> 2] << 1, E[A + 12 >> 2] = r, e = E[A + 8 >> 2] << 1, E[A + 8 >> 2] = e, y = E[A + 4 >> 2] << 1, E[A + 4 >> 2] = y, s = E[A >> 2] << 1, E[A >> 2] = s, BI(D = g + 480 | 0, A), I = 0 - (1 & o[g + 480 | 0]) | 0, E[A + 36 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 32 >> 2] = B ^ I & (B ^ 0 - B), E[A + 28 >> 2] = i ^ I & (i ^ 0 - i), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = s ^ I & (s ^ 0 - s), Y(C, w, C), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, Y(I = A + 120 | 0, A, C), BI(D, I), A = a[g + 480 | 0], BI(D, C), C = 0 - (NI(D, 32) | 1 - p | 1 & A) | 0), h = g + 512 | 0, C;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0, i = 0;
                                        B = Q = h, h = Q = Q - 576 & -64, E[Q + 188 >> 2] = I;
                                        A: if (I >>> 0 <= 64) {
                                            if ((0 | eA(i = Q + 192 | 0, 0, 0, I)) < 0) break A;
                                            if ((0 | XA(i, Q + 188 | 0, 4, 0)) < 0) break A;
                                            if ((0 | XA(i, g, C, 0)) < 0) break A;
                                            Yg(i, A, I);
                                        } else if (!((0 | eA(i = Q + 192 | 0, 0, 0, 64)) < 0 || (0 | XA(i, Q + 188 | 0, 4, 0)) < 0 || (0 | XA(i, g, C, 0)) < 0 || (0 | Yg(i, Q + 112 | 0, 64)) < 0)) {
                                            if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, (I = I - 32 | 0) >>> 0 >= 65) for(;;){
                                                if (g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(Q + 112 | 0, 64, Q + 48 | 0, 64, 0, 0, 0)) < 0) break A;
                                                if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, !((I = I - 32 | 0) >>> 0 > 64)) break;
                                            }
                                            g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(g = Q + 112 | 0, I, Q + 48 | 0, 64, 0, 0, 0)) < 0 || Sg(A, g, I);
                                        }
                                        XC(Q + 192 | 0, 384), h = B;
                                    }
                                    function _A(A, I, g, C, B, Q, i, t, r, e, y) {
                                        var s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0;
                                        if (s = Ig(r, 0, t, 0), !(D = w) & s >>> 0 >= 1073741824 | D) return E[9392] = 22, -1;
                                        if (1 == (0 | i) | i >>> 0 > 1) return E[9392] = 22, -1;
                                        for(s = Q, f = i; s | f;)D = s, s &= s - 1, f &= f - !D, n = (k = k + 1 | 0) ? n : n + 1 | 0;
                                        if (!(!(w = n) & k >>> 0 < 2 & (!i & Q >>> 0 >= 2 | 0 != (0 | i)))) return E[9392] = 28, -1;
                                        if (!r || !t) return E[9392] = 28, -1;
                                        if (!(33554431 / (r >>> 0) >>> 0 < t >>> 0 | t >>> 0 > 16777215) & !i & Q >>> 0 <= 33554431 / (t >>> 0) >>> 0 && !((S = c(N = t << 7, r)) >>> 0 > (D = (k = c(Q, N)) + S | 0) >>> 0 || D >>> 0 > (s = (D + (t << 8) | 0) - -64 | 0) >>> 0)) {
                                            A: {
                                                if (s >>> 0 > _[A + 8 >> 2]) {
                                                    if (D = -1, vg(A)) break A;
                                                    if (h = f = h - 16 | 0, n = _I(f + 12 | 0, s), E[9392] = n, n = n ? 0 : E[f + 12 >> 2], E[A + 4 >> 2] = n, E[A >> 2] = n, E[A + 8 >> 2] = n ? s : 0, h = f + 16 | 0, !n) break A;
                                                }
                                                for(DI(I, g, C, B, M = E[A + 4 >> 2], S), d = (s = (G = S + M | 0) + k | 0) + (C = (A = t << 7) - 64 | 0) | 0, b = s + (t << 8) | 0, J = (f = A + s | 0) + C | 0, Y = Q - 1 | 0, n = t << 5;;){
                                                    for(k = c(N, H) + M | 0, D = 0; C = (A = D << 2) + k | 0, E[A + s >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 4 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 8 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = (A |= 12) + s | 0, A = A + k | 0, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, K = 0, C = 0, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    for(B = 0, A = 0; Sg(G + (c(B, n) << 2) | 0, s, N), tA(s, f, b, t), Sg(G + (c(n, 1 | B) << 2) | 0, f, N), tA(f, s, b, t), (0 | i) == (0 | (A = (B = B + 2 | 0) >>> 0 < 2 ? A + 1 | 0 : A)) & B >>> 0 < Q >>> 0 | A >>> 0 < i >>> 0;);
                                                    for(;;){
                                                        for(A = G + (c(n, Y & E[d >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        for(tA(s, f, b, t), A = G + (c(n, Y & E[J >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        if (tA(f, s, b, t), D = 0, C = A = (K = K + 2 | 0) >>> 0 < 2 ? C + 1 | 0 : C, !((0 | i) == (0 | A) & Q >>> 0 > K >>> 0 | A >>> 0 < i >>> 0)) break;
                                                    }
                                                    for(; C = (A = D << 2) + k | 0, B = E[A + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 4 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 8 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, A = (C = 12 | A) + k | 0, C = E[C + s >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    if ((0 | (H = H + 1 | 0)) == (0 | r)) break;
                                                }
                                                DI(I, g, M, S, e, y), D = 0;
                                            }
                                            return D;
                                        }
                                        return E[9392] = 48, -1;
                                    }
                                    function cA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0;
                                        h = C = h - 192 | 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = i, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = i, E[C + 68 >> 2] = I, E[C + 72 >> 2] = B, E[C + 76 >> 2] = Q, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, I = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 16 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 20 >> 2] = I, I = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 24 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 28 >> 2] = I, I = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 4 >> 2] = I, I = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 8 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 12 >> 2] = I, og(C - -64 | 0, C), g = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = g, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(I = C + 128 | 0), i = E[C + 156 >> 2], g = E[C + 152 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = i, o[A + 29 | 0] = i >>> 8, o[A + 30 | 0] = i >>> 16, o[A + 31 | 0] = i >>> 24, i = E[C + 148 >> 2], g = E[C + 144 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, i = E[C + 140 >> 2], g = E[C + 136 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, i = E[C + 132 >> 2], g = E[C + 128 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, XC(I, 64), h = C + 192 | 0;
                                    }
                                    function tA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, a = 0;
                                        if (i = E[4 + (B = ((C << 7) + A | 0) - 64 | 0) >> 2], E[g >> 2] = E[B >> 2], E[g + 4 >> 2] = i, i = E[B + 60 >> 2], E[g + 56 >> 2] = E[B + 56 >> 2], E[g + 60 >> 2] = i, i = E[B + 52 >> 2], E[g + 48 >> 2] = E[B + 48 >> 2], E[g + 52 >> 2] = i, i = E[B + 44 >> 2], E[g + 40 >> 2] = E[B + 40 >> 2], E[g + 44 >> 2] = i, i = E[B + 36 >> 2], E[g + 32 >> 2] = E[B + 32 >> 2], E[g + 36 >> 2] = i, i = E[B + 28 >> 2], E[g + 24 >> 2] = E[B + 24 >> 2], E[g + 28 >> 2] = i, i = E[B + 20 >> 2], E[g + 16 >> 2] = E[B + 16 >> 2], E[g + 20 >> 2] = i, i = E[B + 12 >> 2], E[g + 8 >> 2] = E[B + 8 >> 2], E[g + 12 >> 2] = i, C) for(i = C << 1, a = C << 4, C = 0; B = (Q = C << 6) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), o = E[g + 60 >> 2], E[56 + (B = (C << 5) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = o, o = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = o, o = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = o, o = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = o, o = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = o, o = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = o, o = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = o, o = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = o, B = (64 | Q) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), Q = E[g + 60 >> 2], E[56 + (B = ((C << 3) + a << 2) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = Q, Q = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = Q, Q = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = Q, Q = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = Q, Q = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = Q, Q = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = Q, Q = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = Q, Q = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = Q, i >>> 0 > (C = C + 2 | 0) >>> 0;);
                                    }
                                    function rA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        if (h = E[A + 36 >> 2], y = E[A + 32 >> 2], s = E[A + 28 >> 2], r = E[A + 24 >> 2], e = E[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(M = !a[A + 80 | 0] << 24, p = E[A + 4 >> 2], b = c(p, 5), n = E[A + 8 >> 2], S = c(n, 5), F = E[A + 12 >> 2], N = c(F, 5), G = E[A + 16 >> 2], k = c(G, 5), f = E[A >> 2]; B = Ig(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, F, 0), _ = w, e = (o = Ig(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + e | 0, 0, G, 0)) + B | 0, B = w + _ | 0, B = o >>> 0 > e >>> 0 ? B + 1 | 0 : B, _ = Ig(s = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + s | 0, 0, n, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(y = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + y | 0, 0, p, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(h = h + M + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, f, 0), B = w + B | 0, K = e = _ + e | 0, e = _ >>> 0 > e >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, n, 0), _ = w, o = Ig(r, 0, F, 0), Q = w + _ | 0, Q = (B = o + B | 0) >>> 0 < o >>> 0 ? Q + 1 | 0 : Q, _ = (o = Ig(s, 0, p, 0)) + B | 0, B = w + Q | 0, B = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, o = Ig(y, 0, f, 0), B = w + B | 0, B = o >>> 0 > (_ = o + _ | 0) >>> 0 ? B + 1 | 0 : B, o = Ig(h, 0, k, 0), B = w + B | 0, H = _ = o + _ | 0, _ = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, p, 0), t = w, o = (Q = Ig(r, 0, n, 0)) + B | 0, B = w + t | 0, B = Q >>> 0 > o >>> 0 ? B + 1 | 0 : B, t = Ig(s, 0, f, 0), Q = w + B | 0, Q = (o = t + o | 0) >>> 0 < t >>> 0 ? Q + 1 | 0 : Q, t = Ig(y, 0, k, 0), B = w + Q | 0, B = (o = t + o | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(h, 0, N, 0), B = w + B | 0, Y = o = t + o | 0, o = o >>> 0 < t >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, f, 0), Q = w, t = (D = Ig(r, 0, p, 0)) + B | 0, B = w + Q | 0, B = t >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = Ig(s, 0, k, 0), B = w + B | 0, B = Q >>> 0 > (t = Q + t | 0) >>> 0 ? B + 1 | 0 : B, D = Ig(y, 0, N, 0), Q = w + B | 0, Q = (t = D + t | 0) >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, D = Ig(h, 0, S, 0), B = w + Q | 0, B = (t = D + t | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = t, t = B, B = Ig(i, 0, k, 0), Q = w, i = (r = Ig(r, 0, f, 0)) + B | 0, B = w + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(s, 0, N, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(y, 0, S, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(h, 0, b, 0), Q = w + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = t, B = (i = (s = (67108863 & Q) << 6 | i >>> 26) + D | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, s = i, y = (67108863 & B) << 6 | i >>> 26, B = o, B = (i = y + Y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, Q = _, h = B = (i = (67108863 & B) << 6 | i >>> 26) + H | 0, _ = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = e, r = (67108863 & s) + ((B = c((67108863 & ((i = _ + K | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, s = 67108863 & y, y = 67108863 & h, h = 67108863 & i, e = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        E[A + 20 >> 2] = e, E[A + 36 >> 2] = h, E[A + 32 >> 2] = y, E[A + 28 >> 2] = s, E[A + 24 >> 2] = r;
                                    }
                                    function eA(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (h = B = h - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, Hg(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = Sg(B, I, g), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (yC(), Q()), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I ^= -222443256, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function yA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (Q = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, i = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, t = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24) : (Q = 2036477234, i = 857760878, B = 1634760805, t = 1797285236), E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, e = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _ = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, y = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, f = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, s = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, C = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, h = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, D = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; r = g, g = Lg((p = I) ^ (I = g + B | 0), 16), r = s = Lg(r ^ (B = g + s | 0), 12), w = Lg((p = I + s | 0) ^ g, 8), I = Lg(r ^ (s = w + B | 0), 7), E = Lg((g = C + t | 0) ^ E, 16), C = Lg((y = E + y | 0) ^ C, 12), r = h, Q = Lg((t = Q + h | 0) ^ e, 16), B = Lg(r ^ (h = Q + c | 0), 12), c = Lg((c = Q) ^ (Q = B + t | 0), 8), g = Lg(c ^ (t = (n = g + C | 0) + I | 0), 16), e = Lg((i = i + D | 0) ^ _, 16), D = Lg((_ = e + f | 0) ^ D, 12), r = I, I = Lg((i = D + i | 0) ^ e, 8), r = Lg(r ^ (_ = (k = I + _ | 0) + g | 0), 12), e = Lg(g ^ (t = r + t | 0), 8), g = Lg((f = e + _ | 0) ^ r, 7), E = Lg(E ^ n, 8), C = Lg((y = E + y | 0) ^ C, 7), _ = Lg((Q = C + Q | 0) ^ I, 16), C = Lg((I = _ + s | 0) ^ C, 12), _ = Lg(_ ^ (Q = C + Q | 0), 8), C = Lg((s = I + _ | 0) ^ C, 7), I = Lg((c = c + h | 0) ^ B, 7), h = Lg((i = I + i | 0) ^ w, 16), w = Lg(I ^ (B = h + y | 0), 12), I = Lg(h ^ (i = w + i | 0), 8), h = Lg((y = B + I | 0) ^ w, 7), r = c, c = E, B = Lg(D ^ k, 7), c = Lg(c ^ (E = B + p | 0), 16), p = Lg(B ^ (D = r + c | 0), 12), E = Lg(c ^ (B = p + E | 0), 8), D = Lg((c = D + E | 0) ^ p, 7), 10 != (0 | (F = F + 1 | 0)););
                                        return o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 24 | 0] = e, o[A + 25 | 0] = e >>> 8, o[A + 26 | 0] = e >>> 16, o[A + 27 | 0] = e >>> 24, o[A + 20 | 0] = _, o[A + 21 | 0] = _ >>> 8, o[A + 22 | 0] = _ >>> 16, o[A + 23 | 0] = _ >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = t, o[A + 13 | 0] = t >>> 8, o[A + 14 | 0] = t >>> 16, o[A + 15 | 0] = t >>> 24, o[A + 8 | 0] = Q, o[A + 9 | 0] = Q >>> 8, o[A + 10 | 0] = Q >>> 16, o[A + 11 | 0] = Q >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, 0;
                                    }
                                    function sA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = r << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = t << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = c << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = _ << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = a << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = o << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = i << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = Q << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = J << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = e << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function hA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g + 40 | 0), Y(y, y, g), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = E[A + 156 >> 2], g = r << 1, E[A + 156 >> 2] = I + g, y = E[A + 152 >> 2], s = t << 1, E[A + 152 >> 2] = y + s, D = E[A + 148 >> 2], p = c << 1, E[A + 148 >> 2] = D + p, w = E[A + 144 >> 2], f = _ << 1, E[A + 144 >> 2] = w + f, n = E[A + 140 >> 2], k = a << 1, E[A + 140 >> 2] = n + k, F = E[A + 136 >> 2], N = o << 1, E[A + 136 >> 2] = F + N, S = E[A + 132 >> 2], G = i << 1, E[A + 132 >> 2] = S + G, h = E[A + 128 >> 2], M = Q << 1, E[A + 128 >> 2] = h + M, b = E[A + 124 >> 2], K = J << 1, E[A + 124 >> 2] = b + K, H = E[A + 120 >> 2], d = e << 1, E[A + 120 >> 2] = H + d, E[A + 112 >> 2] = s - y, E[A + 108 >> 2] = p - D, E[A + 104 >> 2] = f - w, E[A + 100 >> 2] = k - n, E[A + 96 >> 2] = N - F, E[A + 92 >> 2] = G - S, E[A + 88 >> 2] = M - h, E[A + 84 >> 2] = K - b, E[A + 80 >> 2] = d - H, E[A + 116 >> 2] = g - I;
                                    }
                                    function DA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 80 | 0, I + 120 | 0), J = E[I + 80 >> 2], Q = E[I + 84 >> 2], i = E[I + 88 >> 2], o = E[I + 92 >> 2], a = E[I + 96 >> 2], _ = E[I + 100 >> 2], c = E[I + 104 >> 2], t = E[I + 108 >> 2], r = E[I + 112 >> 2], e = E[I + 116 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = e << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = r << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = t << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = c << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = _ << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = a << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = o << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = i << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = Q << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = J << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function pA(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r, e, y, s, h, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0;
                                        s = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], o = a[I + 9 | 0], _ = a[I + 8 | 0], c = a[I + 7 | 0], t = a[I + 12 | 0], b = a[I + 11 | 0], K = a[I + 10 | 0], r = a[I + 15 | 0], H = a[I + 14 | 0], e = a[I + 13 | 0], N = a[I + 28 | 0], M = a[I + 27 | 0], S = a[I + 26 | 0], F = a[I + 25 | 0], n = a[I + 24 | 0], f = a[I + 23 | 0], h = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, k = (p = a[I + 21 | 0]) << 15, p = D = p >>> 17 | 0, G = k, G |= (k = a[I + 20 | 0]) << 7, k = (D = k >>> 25 | 0) | p, p = (D = a[I + 22 | 0]) >>> 9 | 0, D = D << 23 | G, p |= k, y = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, k = D, D = (33554431 & (I = (G = y + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | G >>> 25, I = (I >>> 25 | 0) + p | 0, D = (p = k = k + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, I = (k = p + 33554432 | 0) >>> 0 < 33554432 ? D + 1 | 0 : D, E[A + 24 >> 2] = p - (-67108864 & k), D = (p = f >>> 27 | 0) | n >>> 19 | F >>> 11, p = f = (n = F << 21 | (f = n << 13 | f << 5)) + (p = (67108863 & (p = I)) << 6 | k >>> 26) | 0, I = D, D = (f = n + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = p - (1040187392 & f), p = (D = (I = D) >>> 25 | 0) + (p = M >>> 20 | S >>> 28 | N >>> 12) | 0, I = p = (D = f = (I = (33554431 & I) << 7 | f >>> 25) + (M << 12 | S << 4 | N << 20) | 0) >>> 0 < I >>> 0 ? p + 1 | 0 : p, f = (N = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 32 >> 2] = D - (-67108864 & N), p = t >>> 13 | (D = b >>> 21 | K >>> 29), I = (p = (M = 16777216 + (b = b << 11 | K << 3 | t << 19) | 0) >>> 0 < 16777216 ? p + 1 | 0 : p) >>> 25 | 0, p = (D = n = H << 10 | e << 2 | r << 18) + (n = (33554431 & p) << 7 | M >>> 25) | 0, D = I + (F = H >>> 22 | e >>> 30 | r >>> 14) | 0, I = D = p >>> 0 < n >>> 0 ? D + 1 | 0 : D, n = ((67108863 & (I = (n = p + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (D = n) >>> 26) + (S = y - (-33554432 & G) | 0) | 0, E[A + 20 >> 2] = n, E[A + 16 >> 2] = p - (-67108864 & D), D = Q >>> 18 | i >>> 26 | B >>> 10, p = (D = (S = 16777216 + (K = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? D + 1 | 0 : D) >>> 25 | 0, D = (I = n = _ << 13 | c << 5 | o << 21) + (n = (33554431 & D) << 7 | S >>> 25) | 0, I = p + (F = _ >>> 19 | c >>> 27 | o >>> 11) | 0, I = D >>> 0 < n >>> 0 ? I + 1 | 0 : I, p = (F = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 8 >> 2] = D - (-67108864 & F), N = (f = (67108863 & f) << 6 | N >>> 26) + (H = s << 18 & 33292288 | g << 10 | C << 2) | 0, I = D = g >>> 22 | C >>> 30, D = (f = H + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = N - (33554432 & f), p = b + ((67108863 & p) << 6 | F >>> 26) | 0, E[A + 12 >> 2] = p - (234881024 & M), n = K - (2113929216 & S) | 0, p = Ig((33554431 & (I = D)) << 7 | f >>> 25, D = I >>> 25 | 0, 19, 0), I = w, p = (D = p + h | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, f = ((67108863 & (p = (I = D + 33554432 | 0) >>> 0 < 33554432 ? p + 1 | 0 : p)) << 6 | I >>> 26) + n | 0, E[A + 4 >> 2] = f, E[A >> 2] = D - (-67108864 & I);
                                    }
                                    function wA(A, I, g, C, B, i, _, c) {
                                        A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, _ |= 0;
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    if (1 == (-7 & (c |= 0))) {
                                                                                        if (e = 0, !C) break o;
                                                                                        if (4 & c) break _;
                                                                                        for(;;){
                                                                                            e = r;
                                                                                            c: {
                                                                                                t: {
                                                                                                    r: {
                                                                                                        e: {
                                                                                                            for(;;){
                                                                                                                if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16336 ^ y) ^ -1) >>> 8 & 63 | (1 + (16340 ^ y) ^ -1) >>> 8 & 62, 255 != (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) break e;
                                                                                                                if (t = 0, !B) break E;
                                                                                                                if (!FI(B, y)) break;
                                                                                                                if ((e = e + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                            }
                                                                                                            r = e;
                                                                                                            break E;
                                                                                                        }
                                                                                                        if (D = t + (D << 6) | 0, s >>> 0 > 1) break t;
                                                                                                        s = s + 6 | 0;
                                                                                                        break c;
                                                                                                    }
                                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                    break E;
                                                                                                }
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, !((r = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break E;
                                                                                    }
                                                                                    yC(), Q();
                                                                                }
                                                                                _: for(;;){
                                                                                    for(e = r;;){
                                                                                        c: {
                                                                                            if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16288 ^ y) ^ -1) >>> 8 & 63 | (1 + (16338 ^ y) ^ -1) >>> 8 & 62, 255 == (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) {
                                                                                                if (t = 0, !B) break E;
                                                                                                if (FI(B, y)) break c;
                                                                                                r = e;
                                                                                                break E;
                                                                                            }
                                                                                            if (D = t + (D << 6) | 0, s >>> 0 < 2) s = s + 6 | 0;
                                                                                            else {
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, (r = e + 1 | 0) >>> 0 < C >>> 0) continue _;
                                                                                            break E;
                                                                                        }
                                                                                        if (!((e = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                break E;
                                                                            }
                                                                            r = e, E[9392] = 68, t = 1;
                                                                        }
                                                                        if (s >>> 0 > 4) break i;
                                                                        e = r;
                                                                    }
                                                                    if (A = e, I = -1, t) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if ((-1 << s ^ -1) & D) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if (2 & c) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (s >>> 0 < 2) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (r = A >>> 0 > C >>> 0 ? A : C, e = s >>> 1 | 0, !B) break Q;
                                                                    for(c = A;;){
                                                                        if ((0 | c) == (0 | r)) {
                                                                            t = 68;
                                                                            break C;
                                                                        }
                                                                        if (61 != (0 | (A = o[g + c | 0]))) {
                                                                            if (!FI(B, A)) {
                                                                                t = 28, r = c;
                                                                                break C;
                                                                            }
                                                                        } else e = e - 1 | 0;
                                                                        if (c = c + 1 | 0, !e) break;
                                                                    }
                                                                    break B;
                                                                }
                                                                I = -1;
                                                                break A;
                                                            }
                                                            if (t = 68, A >>> 0 >= C >>> 0) break C;
                                                            if (61 != a[A + g | 0]) {
                                                                r = A, t = 28;
                                                                break C;
                                                            }
                                                            if (c = A + e | 0, 1 != (0 | e)) {
                                                                if ((0 | (s = A + 1 | 0)) == (0 | r)) break C;
                                                                if (61 != a[g + s | 0]) {
                                                                    r = s, t = 28;
                                                                    break C;
                                                                }
                                                                if (2 != (0 | e)) {
                                                                    if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                    if (t = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                }
                                                            }
                                                        }
                                                        if (I = 0, B) break g;
                                                        break I;
                                                    }
                                                    E[9392] = t;
                                                    break A;
                                                }
                                                if (!(C >>> 0 <= c >>> 0)) {
                                                    for(;;){
                                                        if (!FI(B, o[g + c | 0])) break I;
                                                        if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                    }
                                                    c = C;
                                                }
                                            }
                                            r = c, p = h;
                                        }
                                        return _ ? E[_ >> 2] = g + r : (0 | C) != (0 | r) && (E[9392] = 28, I = -1), i && (E[i >> 2] = p), 0 | I;
                                    }
                                    function fA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (B = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, _ = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, c = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, C = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24) : (B = 1797285236, _ = 2036477234, c = 857760878, C = 1634760805), Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, p = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, w = 20, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, h = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, e = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, y = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; t = Lg(g + c | 0, 7) ^ Q, f = Lg(t + c | 0, 9) ^ D, r = Lg(C + s | 0, 7) ^ r, n = Lg(r + C | 0, 9) ^ E, k = Lg(n + r | 0, 13) ^ s, e = Lg(B + h | 0, 7) ^ e, i = Lg(e + B | 0, 9) ^ i, E = Lg(i + e | 0, 13) ^ h, B = Lg(i + E | 0, 18) ^ B, Q = Lg(I + _ | 0, 7) ^ p, s = k ^ Lg(B + Q | 0, 7), D = f ^ Lg(s + B | 0, 9), p = Lg(s + D | 0, 13) ^ Q, B = Lg(D + p | 0, 18) ^ B, y = Lg(Q + _ | 0, 9) ^ y, F = Lg(y + Q | 0, 13) ^ I, I = Lg(F + y | 0, 18) ^ _, h = Lg(I + t | 0, 7) ^ E, E = Lg(h + I | 0, 9) ^ n, Q = Lg(E + h | 0, 13) ^ t, _ = Lg(Q + E | 0, 18) ^ I, t = Lg(t + f | 0, 13) ^ g, g = Lg(t + f | 0, 18) ^ c, I = Lg(g + r | 0, 7) ^ F, i = Lg(I + g | 0, 9) ^ i, r = Lg(I + i | 0, 13) ^ r, c = Lg(i + r | 0, 18) ^ g, C = Lg(n + k | 0, 18) ^ C, g = Lg(C + e | 0, 7) ^ t, y = Lg(g + C | 0, 9) ^ y, e = Lg(g + y | 0, 13) ^ e, C = Lg(y + e | 0, 18) ^ C, t = w >>> 0 > 2, w = w - 2 | 0, t;);
                                        return o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 28 | 0] = Q, o[A + 29 | 0] = Q >>> 8, o[A + 30 | 0] = Q >>> 16, o[A + 31 | 0] = Q >>> 24, o[A + 24 | 0] = E, o[A + 25 | 0] = E >>> 8, o[A + 26 | 0] = E >>> 16, o[A + 27 | 0] = E >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, o[A + 8 | 0] = _, o[A + 9 | 0] = _ >>> 8, o[A + 10 | 0] = _ >>> 16, o[A + 11 | 0] = _ >>> 24, o[A + 4 | 0] = c, o[A + 5 | 0] = c >>> 8, o[A + 6 | 0] = c >>> 16, o[A + 7 | 0] = c >>> 24, 0;
                                    }
                                    function nA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = _ = E[A + 76 >> 2]) | 0, t = (r = E[A + 72 >> 2]) + (c = g << 3) | 0, E[A + 72 >> 2] = t, Q = c >>> 0 > t >>> 0 ? Q + 1 | 0 : Q, E[A + 76 >> 2] = Q, _ = E[4 + (c = A - -64 | 0) >> 2], _ = (e = Q = (0 | Q) == (0 | i) & t >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + E[c >> 2] | 0) >>> 0 ? _ + 1 | 0 : _, t = (e = C >>> 29 | 0) + Q | 0, Q = _, E[c >> 2] = t, E[c + 4 >> 2] = t >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (_ = e = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (t = 128 - c | 0) >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(w = 252 & t, r = A + 80 | 0; o[(Q = i + c | 0) + r | 0] = a[I + i | 0], o[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | D) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (s = 3 & t)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | s) != (0 | y) | (0 | r) != (0 | Q););
                                                if (F(A, A + 80 | 0, B, i = B + 640 | 0), I = I + t | 0, !(C = C - ((g >>> 0 < t >>> 0) + e | 0) | 0) & (g = g - t | 0) >>> 0 > 127 | C) for(; F(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (D = 3 & g, t = 0, y = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, s = A + 80 | 0, g = 0, C = 0; o[i + s | 0] = a[I + i | 0], o[(Q = 1 | i) + s | 0] = a[I + Q | 0], o[(Q = 2 | i) + s | 0] = a[I + Q | 0], o[(Q = 3 | i) + s | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (t | D) for(; o[80 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | D) | (0 | t) != (0 | Q););
                                                }
                                                XC(B, 704);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, C = A + 80 | 0; o[C + (Q = i + c | 0) | 0] = a[I + i | 0], o[C + (e = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | t) != (0 | D) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | y) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 704 | 0, 0;
                                    }
                                    function kA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        for(h = g = h - 480 | 0; c = (_ = g + 288 | 0) + (i << 1) | 0, t = a[I + i | 0], o[c + 1 | 0] = t >>> 4, o[0 | c] = 15 & t, _ = _ + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (_ = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, o[0 | I] = _ - (240 & i), i = 8 + (_ = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & i), i = 8 + (_ = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(o[g + 351 | 0] = a[g + 351 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(I = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, _ = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        for(i = E[A + 36 >> 2], E[g + 392 >> 2] = E[A + 32 >> 2], E[g + 396 >> 2] = i, i = E[A + 28 >> 2], E[g + 384 >> 2] = E[A + 24 >> 2], E[g + 388 >> 2] = i, i = E[A + 20 >> 2], E[g + 376 >> 2] = E[A + 16 >> 2], E[g + 380 >> 2] = i, i = E[A + 12 >> 2], E[g + 368 >> 2] = E[A + 8 >> 2], E[g + 372 >> 2] = i, i = E[A + 4 >> 2], E[g + 360 >> 2] = E[A >> 2], E[g + 364 >> 2] = i, i = E[I + 12 >> 2], E[g + 408 >> 2] = E[I + 8 >> 2], E[g + 412 >> 2] = i, i = E[I + 20 >> 2], E[g + 416 >> 2] = E[I + 16 >> 2], E[g + 420 >> 2] = i, i = E[I + 28 >> 2], E[g + 424 >> 2] = E[I + 24 >> 2], E[g + 428 >> 2] = i, i = E[I + 36 >> 2], E[g + 432 >> 2] = E[I + 32 >> 2], E[g + 436 >> 2] = i, i = E[I + 4 >> 2], E[g + 400 >> 2] = E[I >> 2], E[g + 404 >> 2] = i, i = E[r + 12 >> 2], E[g + 448 >> 2] = E[r + 8 >> 2], E[g + 452 >> 2] = i, i = E[r + 20 >> 2], E[g + 456 >> 2] = E[r + 16 >> 2], E[g + 460 >> 2] = i, i = E[r + 28 >> 2], E[g + 464 >> 2] = E[r + 24 >> 2], E[g + 468 >> 2] = i, i = E[r + 36 >> 2], E[g + 472 >> 2] = E[r + 32 >> 2], E[g + 476 >> 2] = i, i = E[r + 4 >> 2], E[g + 440 >> 2] = E[r >> 2], E[g + 444 >> 2] = i, KA(t, i = g + 360 | 0), Y(i, t, c), Y(e = g + 400 | 0, C, _), Y(Q = g + 440 | 0, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), i = 0; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), t = i >>> 0 < 62, i = i + 2 | 0, t;);
                                        h = g + 480 | 0;
                                    }
                                    function FA(A, I) {
                                        A |= 0;
                                        var g, C, B, Q, i, o = 0, E = 0, a = 0, _ = 0, c = 0, t = 0;
                                        for(h = g = h - 736 | 0, k(c = g + 704 | 0, I |= 0, I), k(E = g + 224 | 0, I, c), k(_ = g + 672 | 0, I, E), k(a = g + 640 | 0, _, _), k(C = g + 416 | 0, c, a), k(c = g + 320 | 0, I, C), k(o = g + 608 | 0, a, a), k(a = g + 288 | 0, c, c), k(t = g + 576 | 0, C, a), k(i = g + 448 | 0, o, a), k(B = g + 544 | 0, t, t), k(t = g + 384 | 0, o, B), k(Q = g + 352 | 0, E, t), k(E = g + 192 | 0, o, Q), k(o = g + 160 | 0, _, E), k(g + 96 | 0, _, o), k(E = g + 512 | 0, B, Q), k(o = g + 480 | 0, _, E), k(E = g + 256 | 0, i, o), k(g + 128 | 0, a, E), k(a = g - -64 | 0, t, o), k(o = g + 32 | 0, _, a), k(g, C, o), k(A, c, g), _ = 0; k(A, A, A), 126 != (0 | (_ = _ + 1 | 0)););
                                        return k(A, A, g + 352 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 704 | 0), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 160 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 256 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g - -64 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 96 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 320 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 512 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 192 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 480 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 128 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 32 | 0), h = g + 736 | 0, 0 - NI(I, 32) | 0;
                                    }
                                    function NA(A, I, g) {
                                        A |= 0;
                                        var C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0;
                                        return h = Q = h - 160 | 0, kI(I |= 0, g |= 0, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(Q, I), tg(A, Q), _ = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, t = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 24 | 0] = I, o[C + 25 | 0] = I >>> 8, o[C + 26 | 0] = I >>> 16, o[C + 27 | 0] = I >>> 24, o[C + 28 | 0] = i, o[C + 29 | 0] = i >>> 8, o[C + 30 | 0] = i >>> 16, o[C + 31 | 0] = i >>> 24, o[C + 16 | 0] = c, o[C + 17 | 0] = c >>> 8, o[C + 18 | 0] = c >>> 16, o[C + 19 | 0] = c >>> 24, o[C + 20 | 0] = t, o[C + 21 | 0] = t >>> 8, o[C + 22 | 0] = t >>> 16, o[C + 23 | 0] = t >>> 24, o[C + 8 | 0] = _, o[C + 9 | 0] = _ >>> 8, o[C + 10 | 0] = _ >>> 16, o[C + 11 | 0] = _ >>> 24, o[C + 12 | 0] = E, o[C + 13 | 0] = E >>> 8, o[C + 14 | 0] = E >>> 16, o[C + 15 | 0] = E >>> 24, o[0 | C] = r, o[C + 1 | 0] = r >>> 8, o[C + 2 | 0] = r >>> 16, o[C + 3 | 0] = r >>> 24, o[C + 4 | 0] = g, o[C + 5 | 0] = g >>> 8, o[C + 6 | 0] = g >>> 16, o[C + 7 | 0] = g >>> 24, c = a[(E = A) + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, t = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, r = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, g = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, I = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, A = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, _ = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, E = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[C + 56 | 0] = E, o[C + 57 | 0] = E >>> 8, o[C + 58 | 0] = E >>> 16, o[C + 59 | 0] = E >>> 24, o[C + 60 | 0] = _, o[C + 61 | 0] = _ >>> 8, o[C + 62 | 0] = _ >>> 16, o[C + 63 | 0] = _ >>> 24, o[C + 48 | 0] = r, o[C + 49 | 0] = r >>> 8, o[C + 50 | 0] = r >>> 16, o[C + 51 | 0] = r >>> 24, o[C + 52 | 0] = g, o[C + 53 | 0] = g >>> 8, o[C + 54 | 0] = g >>> 16, o[C + 55 | 0] = g >>> 24, o[C + 40 | 0] = c, o[C + 41 | 0] = c >>> 8, o[C + 42 | 0] = c >>> 16, o[C + 43 | 0] = c >>> 24, o[C + 44 | 0] = t, o[C + 45 | 0] = t >>> 8, o[C + 46 | 0] = t >>> 16, o[C + 47 | 0] = t >>> 24, o[C + 32 | 0] = I, o[C + 33 | 0] = I >>> 8, o[C + 34 | 0] = I >>> 16, o[C + 35 | 0] = I >>> 24, o[C + 36 | 0] = A, o[C + 37 | 0] = A >>> 8, o[C + 38 | 0] = A >>> 16, o[C + 39 | 0] = A >>> 24, h = Q + 160 | 0, 0;
                                    }
                                    function SA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], y = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, e = E[A >> 2], E[A >> 2] = g & (e ^ E[I >> 2]) ^ e, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ y), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(y = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], e = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ e), E[A + 68 >> 2] = t ^ g & (t ^ k), E[y >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], y = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], e = E[A + 116 >> 2], E[A + 116 >> 2] = g & (e ^ E[I + 116 >> 2]) ^ e, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ y), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s), B = E[A + 120 >> 2], s = E[I + 120 >> 2], Q = E[A + 124 >> 2], h = E[I + 124 >> 2], i = E[A + 128 >> 2], D = E[I + 128 >> 2], o = E[A + 132 >> 2], p = E[I + 132 >> 2], a = E[A + 136 >> 2], w = E[I + 136 >> 2], _ = E[A + 140 >> 2], f = E[I + 140 >> 2], c = E[A + 144 >> 2], y = E[I + 144 >> 2], t = E[A + 148 >> 2], n = E[I + 148 >> 2], r = E[A + 152 >> 2], k = E[I + 152 >> 2], e = E[I + 156 >> 2], I = E[A + 156 >> 2], E[A + 156 >> 2] = g & (e ^ I) ^ I, E[A + 152 >> 2] = r ^ g & (r ^ k), E[A + 148 >> 2] = t ^ g & (t ^ n), E[A + 144 >> 2] = c ^ g & (c ^ y), E[A + 140 >> 2] = _ ^ g & (_ ^ f), E[A + 136 >> 2] = a ^ g & (a ^ w), E[A + 132 >> 2] = o ^ g & (o ^ p), E[A + 128 >> 2] = i ^ g & (i ^ D), E[A + 124 >> 2] = Q ^ g & (Q ^ h), E[A + 120 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function GA(A, I, g) {
                                        var C, B, Q = 0, i = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        return h = C = h - 320 | 0, v(Q = C + 240 | 0, g), Y(Q, Q, g), v(A, Q), Y(A, A, g), Y(A, A, I), PA(A, A), Y(A, A, Q), Y(A, A, I), v(Q = C + 192 | 0, A), Y(Q, Q, g), i = E[I + 4 >> 2], s = E[I + 8 >> 2], p = E[I + 12 >> 2], w = E[I + 16 >> 2], f = E[I + 20 >> 2], n = E[I + 24 >> 2], k = E[I + 28 >> 2], F = E[I + 32 >> 2], N = E[I >> 2], g = E[C + 192 >> 2], Q = E[C + 196 >> 2], a = E[C + 200 >> 2], _ = E[C + 204 >> 2], c = E[C + 208 >> 2], t = E[C + 212 >> 2], r = E[C + 216 >> 2], e = E[C + 220 >> 2], y = E[C + 224 >> 2], D = E[C + 228 >> 2], S = E[I + 36 >> 2], E[C + 180 >> 2] = D - S, E[C + 176 >> 2] = y - F, E[C + 172 >> 2] = e - k, E[C + 168 >> 2] = r - n, E[C + 164 >> 2] = t - f, E[C + 160 >> 2] = c - w, E[C + 156 >> 2] = _ - p, E[C + 152 >> 2] = a - s, E[C + 148 >> 2] = Q - i, E[C + 144 >> 2] = g - N, E[C + 132 >> 2] = D + S, E[C + 128 >> 2] = y + F, E[C + 124 >> 2] = e + k, E[C + 120 >> 2] = r + n, E[C + 116 >> 2] = t + f, E[C + 112 >> 2] = c + w, E[C + 108 >> 2] = _ + p, E[C + 104 >> 2] = a + s, E[C + 100 >> 2] = Q + i, E[C + 96 >> 2] = g + N, Y(i = C + 48 | 0, I, 1648), E[C + 84 >> 2] = D + E[C + 84 >> 2], E[C + 80 >> 2] = y + E[C + 80 >> 2], E[C + 76 >> 2] = e + E[C + 76 >> 2], E[C + 72 >> 2] = r + E[C + 72 >> 2], E[C + 68 >> 2] = t + E[C + 68 >> 2], E[C + 64 >> 2] = c + E[C + 64 >> 2], E[C + 60 >> 2] = _ + E[C + 60 >> 2], E[C + 56 >> 2] = a + E[C + 56 >> 2], E[C + 52 >> 2] = Q + E[C + 52 >> 2], E[C + 48 >> 2] = g + E[C + 48 >> 2], BI(C, C + 144 | 0), p = NI(C, 32), BI(C, C + 96 | 0), s = NI(C, 32), BI(C, i), I = NI(C, 32), Y(C, A, 1648), y = E[A + 4 >> 2], e = E[A + 8 >> 2], r = E[A + 12 >> 2], t = E[A + 16 >> 2], c = E[A + 20 >> 2], _ = E[A + 24 >> 2], a = E[A + 28 >> 2], Q = E[A + 32 >> 2], i = E[A >> 2], w = E[C >> 2], f = E[C + 4 >> 2], n = E[C + 8 >> 2], k = E[C + 12 >> 2], F = E[C + 16 >> 2], N = E[C + 20 >> 2], D = E[C + 24 >> 2], S = E[C + 28 >> 2], B = E[C + 32 >> 2], g = (I = 0 - (I | s) | 0) & ((g = E[A + 36 >> 2]) ^ E[C + 36 >> 2]) ^ g, E[A + 36 >> 2] = g, Q ^= I & (Q ^ B), E[A + 32 >> 2] = Q, a ^= I & (a ^ S), E[A + 28 >> 2] = a, _ ^= I & (_ ^ D), E[A + 24 >> 2] = _, c ^= I & (c ^ N), E[A + 20 >> 2] = c, t ^= I & (t ^ F), E[A + 16 >> 2] = t, r ^= I & (r ^ k), E[A + 12 >> 2] = r, e ^= I & (e ^ n), E[A + 8 >> 2] = e, y ^= I & (y ^ f), E[A + 4 >> 2] = y, i ^= I & (i ^ w), E[A >> 2] = i, BI(C + 288 | 0, A), I = 0 - (1 & o[C + 288 | 0]) | 0, E[A + 36 >> 2] = g ^ I & (g ^ 0 - g), E[A + 32 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 28 >> 2] = a ^ I & (a ^ 0 - a), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = i ^ I & (i ^ 0 - i), h = C + 320 | 0, s | p;
                                    }
                                    function MA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 288 | 0, g | C) {
                                            if (Q = (i = E[A + 36 >> 2]) + (C << 3 | g >>> 29) | 0, _ = (r = E[A + 32 >> 2]) + (c = g << 3) | 0, E[A + 32 >> 2] = _, E[A + 36 >> 2] = _ >>> 0 < c >>> 0 ? Q + 1 | 0 : Q, c = 64 - (_ = t = 63 & ((7 & i) << 29 | r >>> 3)) | 0, (0 | C) == (0 | (_ = D = 0 - ((Q = 0) + (_ >>> 0 > 64) | 0) | 0)) & g >>> 0 >= c >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (63 ^ t) >>> 0 >= 3 | Q) for(w = 124 & c, r = A + 40 | 0; o[(Q = i + t | 0) + r | 0] = a[I + i | 0], o[r + (t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | s) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & c)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | e) | (0 | r) != (0 | Q););
                                                if (J(A, A + 40 | 0, B, i = B + 256 | 0), I = I + c | 0, !(C = C - ((g >>> 0 < c >>> 0) + D | 0) | 0) & (g = g - c | 0) >>> 0 > 63 | C) for(; J(A, I, B, i), I = I - -64 | 0, Q = C - 1 | 0, !(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | C;);
                                                if (g | C) {
                                                    if (s = 3 & g, c = 0, e = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, y = A + 40 | 0, g = 0, C = 0; o[i + y | 0] = a[I + i | 0], o[(Q = 1 | i) + y | 0] = a[I + Q | 0], o[(Q = 2 | i) + y | 0] = a[I + Q | 0], o[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | t) | (0 | r) != (0 | Q););
                                                    if (c | s) for(; o[40 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | e) != (0 | s) | (0 | c) != (0 | Q););
                                                }
                                                XC(B, 288);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, C = A + 40 | 0; o[C + (Q = i + t | 0) | 0] = a[I + i | 0], o[C + (D = t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | c) != (0 | s) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | e) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 288 | 0, 0;
                                    }
                                    function bA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        return h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(i = g + 240 | 0, C), Y(_ = g + 192 | 0, i, 1600), E[g + 192 >> 2] = E[g + 192 >> 2] + 1, c = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = c, t = E[g + 244 >> 2], r = E[g + 248 >> 2], e = E[g + 252 >> 2], y = E[g + 256 >> 2], s = E[g + 260 >> 2], D = E[g + 264 >> 2], p = E[g + 268 >> 2], w = E[g + 272 >> 2], f = E[g + 276 >> 2], Y(A, i, _), PA(A, A), Y(A, i, A), v(i = g + 144 | 0, A), Y(i, i, _), i = E[g + 180 >> 2], E[g + 132 >> 2] = i - f, _ = E[g + 176 >> 2], E[g + 128 >> 2] = _ - w, n = E[g + 172 >> 2], E[g + 124 >> 2] = n - p, k = E[g + 168 >> 2], E[g + 120 >> 2] = k - D, F = E[g + 164 >> 2], E[g + 116 >> 2] = F - s, N = E[g + 160 >> 2], E[g + 112 >> 2] = N - y, S = E[g + 156 >> 2], E[g + 108 >> 2] = S - e, G = E[g + 152 >> 2], E[g + 104 >> 2] = G - r, M = E[g + 148 >> 2], E[g + 100 >> 2] = M - t, b = E[g + 144 >> 2], E[g + 96 >> 2] = b - c, E[g + 84 >> 2] = i + f, E[g + 80 >> 2] = _ + w, E[g + 76 >> 2] = p + n, E[g + 72 >> 2] = D + k, E[g + 68 >> 2] = s + F, E[g + 64 >> 2] = y + N, E[g + 60 >> 2] = e + S, E[g + 56 >> 2] = r + G, E[g + 52 >> 2] = t + M, E[g + 48 >> 2] = c + b, BI(g, g + 96 | 0), w = NI(g, 32), BI(g, g + 48 | 0), n = NI(g, 32), Y(g, A, 1648), p = E[A + 4 >> 2], D = E[A + 8 >> 2], s = E[A + 12 >> 2], y = E[A + 16 >> 2], e = E[A + 20 >> 2], r = E[A + 24 >> 2], t = E[A + 28 >> 2], c = E[A + 32 >> 2], f = E[A >> 2], k = E[g >> 2], F = E[g + 4 >> 2], N = E[g + 8 >> 2], S = E[g + 12 >> 2], G = E[g + 16 >> 2], M = E[g + 20 >> 2], b = E[g + 24 >> 2], B = E[g + 28 >> 2], Q = E[g + 32 >> 2], _ = (i = w - 1 | 0) & ((_ = E[A + 36 >> 2]) ^ E[g + 36 >> 2]) ^ _, E[A + 36 >> 2] = _, c ^= i & (c ^ Q), E[A + 32 >> 2] = c, t ^= i & (t ^ B), E[A + 28 >> 2] = t, r ^= i & (r ^ b), E[A + 24 >> 2] = r, e ^= i & (e ^ M), E[A + 20 >> 2] = e, y ^= i & (y ^ G), E[A + 16 >> 2] = y, s ^= i & (s ^ S), E[A + 12 >> 2] = s, D ^= i & (D ^ N), E[A + 8 >> 2] = D, p ^= i & (p ^ F), E[A + 4 >> 2] = p, i = f ^ i & (f ^ k), E[A >> 2] = i, BI(g + 288 | 0, A), I = 0 - (1 & o[g + 288 | 0] ^ a[I + 31 | 0] >>> 7) | 0, E[A + 36 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 32 >> 2] = c ^ I & (c ^ 0 - c), E[A + 28 >> 2] = t ^ I & (t ^ 0 - t), E[A + 24 >> 2] = r ^ I & (r ^ 0 - r), E[A + 20 >> 2] = e ^ I & (e ^ 0 - e), E[A + 16 >> 2] = y ^ I & (y ^ 0 - y), E[A + 12 >> 2] = s ^ I & (s ^ 0 - s), E[A + 8 >> 2] = D ^ I & (D ^ 0 - D), E[A + 4 >> 2] = p ^ I & (p ^ 0 - p), E[A >> 2] = i ^ I & (i ^ 0 - i), Y(A + 120 | 0, A, C), h = g + 320 | 0, (w | n) - 1 | 0;
                                    }
                                    function KA(A, I) {
                                        var g, C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0;
                                        h = g = h - 48 | 0, v(A, I), v(A + 80 | 0, I + 40 | 0), R(A + 120 | 0, I + 80 | 0), n = E[I + 40 >> 2], D = E[I + 44 >> 2], s = E[I + 4 >> 2], p = E[I + 48 >> 2], k = E[I + 8 >> 2], w = E[I + 52 >> 2], F = E[I + 12 >> 2], f = E[I + 56 >> 2], b = E[I + 16 >> 2], N = E[I + 60 >> 2], K = E[I + 20 >> 2], S = E[I - -64 >> 2], H = E[I + 24 >> 2], G = E[I + 68 >> 2], Y = E[I + 28 >> 2], M = E[I + 72 >> 2], d = E[I + 32 >> 2], U = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] + E[I + 36 >> 2], E[A + 72 >> 2] = M + d, E[A + 68 >> 2] = G + Y, E[(C = A - -64 | 0) >> 2] = S + H, E[A + 60 >> 2] = N + K, E[A + 56 >> 2] = f + b, E[A + 52 >> 2] = w + F, E[A + 48 >> 2] = p + k, E[A + 44 >> 2] = D + s, E[(I = A + 40 | 0) >> 2] = n + U, v(g, I), n = E[A + 80 >> 2], D = E[A + 4 >> 2], s = E[A + 84 >> 2], p = E[A + 8 >> 2], k = E[A + 88 >> 2], w = E[A + 12 >> 2], F = E[A + 92 >> 2], f = E[A + 16 >> 2], b = E[A + 96 >> 2], N = E[A + 20 >> 2], K = E[A + 100 >> 2], S = E[A + 24 >> 2], H = E[A + 104 >> 2], G = E[A + 28 >> 2], Y = E[A + 108 >> 2], M = E[A + 32 >> 2], d = E[A + 112 >> 2], U = E[A >> 2], Q = (J = E[A + 116 >> 2]) - (B = E[A + 36 >> 2]) | 0, E[A + 116 >> 2] = Q, i = d - M | 0, E[A + 112 >> 2] = i, o = Y - G | 0, E[A + 108 >> 2] = o, a = H - S | 0, E[A + 104 >> 2] = a, _ = K - N | 0, E[A + 100 >> 2] = _, c = b - f | 0, E[A + 96 >> 2] = c, t = F - w | 0, E[A + 92 >> 2] = t, r = k - p | 0, E[A + 88 >> 2] = r, e = s - D | 0, E[A + 84 >> 2] = e, y = n - U | 0, E[A + 80 >> 2] = y, J = J + B | 0, E[A + 76 >> 2] = J, M = M + d | 0, E[A + 72 >> 2] = M, G = G + Y | 0, E[A + 68 >> 2] = G, S = S + H | 0, E[C >> 2] = S, N = N + K | 0, E[A + 60 >> 2] = N, f = f + b | 0, E[A + 56 >> 2] = f, w = w + F | 0, E[A + 52 >> 2] = w, p = p + k | 0, E[A + 48 >> 2] = p, D = D + s | 0, E[A + 44 >> 2] = D, s = I, I = n + U | 0, E[s >> 2] = I, n = E[g >> 2], s = E[g + 4 >> 2], k = E[g + 8 >> 2], F = E[g + 12 >> 2], b = E[g + 16 >> 2], K = E[g + 20 >> 2], H = E[g + 24 >> 2], Y = E[g + 28 >> 2], d = E[g + 32 >> 2], E[A + 36 >> 2] = E[g + 36 >> 2] - J, E[A + 32 >> 2] = d - M, E[A + 28 >> 2] = Y - G, E[A + 24 >> 2] = H - S, E[A + 20 >> 2] = K - N, E[A + 16 >> 2] = b - f, E[A + 12 >> 2] = F - w, E[A + 8 >> 2] = k - p, E[A + 4 >> 2] = s - D, E[A >> 2] = n - I, I = E[A + 120 >> 2], n = E[A + 124 >> 2], D = E[A + 128 >> 2], s = E[A + 132 >> 2], p = E[A + 136 >> 2], k = E[A + 140 >> 2], w = E[A + 144 >> 2], F = E[A + 148 >> 2], f = E[A + 152 >> 2], E[A + 156 >> 2] = E[A + 156 >> 2] - Q, E[A + 152 >> 2] = f - i, E[A + 148 >> 2] = F - o, E[A + 144 >> 2] = w - a, E[A + 140 >> 2] = k - _, E[A + 136 >> 2] = p - c, E[A + 132 >> 2] = s - t, E[A + 128 >> 2] = D - r, E[A + 124 >> 2] = n - e, E[A + 120 >> 2] = I - y, h = g + 48 | 0;
                                    }
                                    function HA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t = 0;
                                        h = C = h - 160 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), SA(A, I, (255 & (1 ^ (t = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), SA(A, I + 160 | 0, (255 & (2 ^ t)) - 1 >>> 31 | 0), SA(A, I + 320 | 0, (255 & (3 ^ t)) - 1 >>> 31 | 0), SA(A, I + 480 | 0, (255 & (4 ^ t)) - 1 >>> 31 | 0), SA(A, I + 640 | 0, (255 & (5 ^ t)) - 1 >>> 31 | 0), SA(A, I + 800 | 0, (255 & (6 ^ t)) - 1 >>> 31 | 0), SA(A, I + 960 | 0, (255 & (7 ^ t)) - 1 >>> 31 | 0), SA(A, I + 1120 | 0, (255 & (8 ^ t)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 32 >> 2] = E[A + 72 >> 2], E[C + 36 >> 2] = I, t = E[4 + (I = A - -64 | 0) >> 2], E[C + 24 >> 2] = E[I >> 2], E[C + 28 >> 2] = t, I = E[A + 60 >> 2], E[C + 16 >> 2] = E[A + 56 >> 2], E[C + 20 >> 2] = I, I = E[A + 52 >> 2], E[C + 8 >> 2] = E[A + 48 >> 2], E[C + 12 >> 2] = I, I = E[A + 44 >> 2], E[C >> 2] = E[A + 40 >> 2], E[C + 4 >> 2] = I, I = E[A + 36 >> 2], E[C + 72 >> 2] = E[A + 32 >> 2], E[C + 76 >> 2] = I, t = E[A + 28 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 24 >> 2], E[I + 4 >> 2] = t, I = E[A + 20 >> 2], E[C + 56 >> 2] = E[A + 16 >> 2], E[C + 60 >> 2] = I, I = E[A + 12 >> 2], E[C + 48 >> 2] = E[A + 8 >> 2], E[C + 52 >> 2] = I, I = E[A + 4 >> 2], E[C + 40 >> 2] = E[A >> 2], E[C + 44 >> 2] = I, I = E[A + 92 >> 2], E[C + 88 >> 2] = E[A + 88 >> 2], E[C + 92 >> 2] = I, I = E[A + 100 >> 2], E[C + 96 >> 2] = E[A + 96 >> 2], E[C + 100 >> 2] = I, I = E[A + 108 >> 2], E[C + 104 >> 2] = E[A + 104 >> 2], E[C + 108 >> 2] = I, I = E[A + 116 >> 2], E[C + 112 >> 2] = E[A + 112 >> 2], E[C + 116 >> 2] = I, I = E[A + 84 >> 2], E[C + 80 >> 2] = E[A + 80 >> 2], E[C + 84 >> 2] = I, I = E[A + 120 >> 2], t = E[A + 124 >> 2], B = E[A + 128 >> 2], Q = E[A + 132 >> 2], i = E[A + 136 >> 2], o = E[A + 140 >> 2], a = E[A + 144 >> 2], _ = E[A + 148 >> 2], c = E[A + 152 >> 2], E[C + 156 >> 2] = 0 - E[A + 156 >> 2], E[C + 152 >> 2] = 0 - c, E[C + 148 >> 2] = 0 - _, E[C + 144 >> 2] = 0 - a, E[C + 140 >> 2] = 0 - o, E[C + 136 >> 2] = 0 - i, E[C + 132 >> 2] = 0 - Q, E[C + 128 >> 2] = 0 - B, E[C + 124 >> 2] = 0 - t, E[C + 120 >> 2] = 0 - I, SA(A, C, (128 & g) >>> 7 | 0), h = C + 160 | 0;
                                    }
                                    function YA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C, B, Q, i, _ = 0, c = 0, t = 0;
                                        return h = c = h - 192 | 0, ag(c, 32), kI(I, c, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(t = c + 32 | 0, I), tg(A, t), g = c, t = E[c + 28 >> 2], c = E[c + 24 >> 2], o[I + 24 | 0] = c, o[I + 25 | 0] = c >>> 8, o[I + 26 | 0] = c >>> 16, o[I + 27 | 0] = c >>> 24, o[I + 28 | 0] = t, o[I + 29 | 0] = t >>> 8, o[I + 30 | 0] = t >>> 16, o[I + 31 | 0] = t >>> 24, t = E[g + 20 >> 2], c = E[g + 16 >> 2], o[I + 16 | 0] = c, o[I + 17 | 0] = c >>> 8, o[I + 18 | 0] = c >>> 16, o[I + 19 | 0] = c >>> 24, o[I + 20 | 0] = t, o[I + 21 | 0] = t >>> 8, o[I + 22 | 0] = t >>> 16, o[I + 23 | 0] = t >>> 24, t = E[g + 12 >> 2], c = E[g + 8 >> 2], o[I + 8 | 0] = c, o[I + 9 | 0] = c >>> 8, o[I + 10 | 0] = c >>> 16, o[I + 11 | 0] = c >>> 24, o[I + 12 | 0] = t, o[I + 13 | 0] = t >>> 8, o[I + 14 | 0] = t >>> 16, o[I + 15 | 0] = t >>> 24, t = E[g + 4 >> 2], c = E[g >> 2], o[0 | I] = c, o[I + 1 | 0] = c >>> 8, o[I + 2 | 0] = c >>> 16, o[I + 3 | 0] = c >>> 24, o[I + 4 | 0] = t, o[I + 5 | 0] = t >>> 8, o[I + 6 | 0] = t >>> 16, o[I + 7 | 0] = t >>> 24, C = a[(_ = A) + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, B = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, Q = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, c = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, A = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, i = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[I + 56 | 0] = _, o[I + 57 | 0] = _ >>> 8, o[I + 58 | 0] = _ >>> 16, o[I + 59 | 0] = _ >>> 24, o[I + 60 | 0] = i, o[I + 61 | 0] = i >>> 8, o[I + 62 | 0] = i >>> 16, o[I + 63 | 0] = i >>> 24, o[I + 48 | 0] = Q, o[I + 49 | 0] = Q >>> 8, o[I + 50 | 0] = Q >>> 16, o[I + 51 | 0] = Q >>> 24, o[I + 52 | 0] = t, o[I + 53 | 0] = t >>> 8, o[I + 54 | 0] = t >>> 16, o[I + 55 | 0] = t >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, o[I + 32 | 0] = c, o[I + 33 | 0] = c >>> 8, o[I + 34 | 0] = c >>> 16, o[I + 35 | 0] = c >>> 24, o[I + 36 | 0] = A, o[I + 37 | 0] = A >>> 8, o[I + 38 | 0] = A >>> 16, o[I + 39 | 0] = A >>> 24, XC(g, 32), h = g + 192 | 0, 0;
                                    }
                                    function dA(A, I) {
                                        I |= 0;
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        return h = g = h - 288 | 0, Q = 40 + ((B = E[32 + (A |= 0) >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (Sg(Q, 34688, 64 - B | 0), J(A, A + 40 | 0, g, g + 256 | 0), E[A + 88 >> 2] = 0, E[A + 92 >> 2] = 0, E[A + 80 >> 2] = 0, E[A + 84 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[(B = A - -64 | 0) >> 2] = 0, E[B + 4 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 52 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 44 >> 2] = 0) : Sg(Q, 34688, 56 - B | 0), i = (B = 16711680 & (Q = E[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, o[A + 96 | 0] = B, o[A + 97 | 0] = B >>> 8, o[A + 98 | 0] = B >>> 16, o[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, o[A + 100 | 0] = B, o[A + 101 | 0] = B >>> 8, o[A + 102 | 0] = B >>> 16, o[A + 103 | 0] = B >>> 24, J(A, A + 40 | 0, g, g + 256 | 0), B = (B = E[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, B = (B = E[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, B = (B = E[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, B = (B = E[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, B = (B = E[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, B = (B = E[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, B = (B = E[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, B = (B = E[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, XC(g, 288), XC(A, 104), h = g + 288 | 0, 0;
                                    }
                                    function JA(A, I) {
                                        A |= 0;
                                        var g, C = 0;
                                        h = g = h + -64 | 0, C = a[60 + (I |= 0) | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 56 >> 2] = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 60 >> 2] = C, C = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 48 >> 2] = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 52 >> 2] = C, C = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 40 >> 2] = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 44 >> 2] = C, C = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 32 >> 2] = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 36 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, N(g), I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0;
                                    }
                                    function UA(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        if (h = C = h - 96 | 0, (g |= 0) >>> 0 >= 65 && ($I(A), MA(A, I, g, 0), dA(A, C), g = 32, I = C), $I(A), E[C + 88 >> 2] = 909522486, E[C + 92 >> 2] = 909522486, E[C + 80 >> 2] = 909522486, E[C + 84 >> 2] = 909522486, E[C + 72 >> 2] = 909522486, E[C + 76 >> 2] = 909522486, E[(i = r = C - -64 | 0) >> 2] = 909522486, E[i + 4 >> 2] = 909522486, E[C + 56 >> 2] = 909522486, E[C + 60 >> 2] = 909522486, E[C + 48 >> 2] = 909522486, E[C + 52 >> 2] = 909522486, E[C + 40 >> 2] = 909522486, E[C + 44 >> 2] = 909522486, E[C + 32 >> 2] = 909522486, E[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(_ = 124 & g; o[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], o[0 | (e = (Q = 1 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (e = (Q = 2 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | _) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; o[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (t = t + 1 | 0)););
                                        }
                                        if (MA(A, C + 32 | 0, 64, 0), $I(i = A + 104 | 0), E[C + 88 >> 2] = 1549556828, E[C + 92 >> 2] = 1549556828, E[C + 80 >> 2] = 1549556828, E[C + 84 >> 2] = 1549556828, E[C + 72 >> 2] = 1549556828, E[C + 76 >> 2] = 1549556828, E[r >> 2] = 1549556828, E[r + 4 >> 2] = 1549556828, E[C + 56 >> 2] = 1549556828, E[C + 60 >> 2] = 1549556828, E[C + 48 >> 2] = 1549556828, E[C + 52 >> 2] = 1549556828, E[C + 40 >> 2] = 1549556828, E[C + 44 >> 2] = 1549556828, E[C + 32 >> 2] = 1549556828, E[C + 36 >> 2] = 1549556828, g) {
                                            if (t = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; o[0 | (_ = (A = C + 32 | 0) + B | 0)] = a[0 | _] ^ a[I + B | 0], o[0 | (Q = (_ = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (Q = (_ = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (_ = (Q = A) + (A = 3 | B) | 0)] = a[0 | _] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (t = t + 1 | 0)););
                                        }
                                        return MA(i, A = C + 32 | 0, 64, 0), XC(A, 64), XC(C, 32), h = C + 96 | 0, 0;
                                    }
                                    function lA(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            e = a = h, h = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((_ = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ (I << 8 | _), E[a + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = a + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(a + 96 | 0, o, 128), E[a + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ _, E[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(y = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (o = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[a + 352 >> 2] = C + E[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[a + 352 >> 2] = i + E[a + 352 >> 2], t = I = E[a + 68 >> 2], I = (r = (o = E[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[a + 64 >> 2] = r, E[a + 68 >> 2] = I, I = E[a + 76 >> 2], I = (t = o = -1 == (0 | t) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[a + 72 >> 2] = o, E[a + 76 >> 2] = I, f(a, c), Sg(c, y, 128), I = E[a + 352 >> 2] - 128 | 0, E[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(a, A, _), h = e;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function mA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, o[g + 64 | 0] = 1, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function uA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0;
                                        A: {
                                            if ((i = E[A + 56 >> 2]) | (B = E[A + 60 >> 2])) {
                                                if (y = Q = 16 - i | 0, c = (Q = (0 | (_ = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > _ >>> 0) ? y : g, y = Q = Q ? _ : C, Q | c) {
                                                    if (Q = 0, i = 0, !y & c >>> 0 >= 4 | y) for(t = -4 & c, _ = A - -64 | 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (s = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | e) != (0 | t) | (0 | y) != (0 | B););
                                                    if (_ = B = 0, B | (r = 3 & c)) for(; e = Q + E[A + 56 >> 2] | 0, o[(A + e | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                    i = E[A + 56 >> 2], B = E[A + 60 >> 2];
                                                }
                                                if (B = B + y | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[A + 56 >> 2] = i, E[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                rA(A, A - -64 | 0, 16, 0), E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + y | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (rA(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (h = 0, D = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, y = 0, _ = A - -64 | 0, e = 0, r = 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (t = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | e) | (0 | y) != (0 | B););
                                                if (_ = B = 0, B | (r = 3 & g)) for(; B = Q + E[A + 56 >> 2] | 0, o[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                i = C + E[A + 60 >> 2] | 0, i = (I = g + E[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, E[A + 56 >> 2] = I, E[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function xA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function RA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], e = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, y = E[A >> 2], E[A >> 2] = g & (y ^ E[I >> 2]) ^ y, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ e), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(e = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], y = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ y), E[A + 68 >> 2] = t ^ g & (t ^ k), E[e >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], e = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], y = E[I + 116 >> 2], I = E[A + 116 >> 2], E[A + 116 >> 2] = g & (y ^ I) ^ I, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ e), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function vA(A, I) {
                                        var g, C, B = 0;
                                        for(h = g = h - 192 | 0, v(C = g + 144 | 0, I), v(B = g + 96 | 0, C), v(B, B), Y(B, I, B), Y(C, C, B), v(I = g + 48 | 0, C), Y(B, B, I), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(I, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), I = 1; v(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        Y(I = g + 48 | 0, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B = g + 96 | 0, I, B), v(B, B), v(B, B), v(B, B), v(B, B), v(B, B), Y(A, B, g + 144 | 0), h = g + 192 | 0;
                                    }
                                    function LA(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var i = 0, E = 0, _ = 0, t = 0, r = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    if (1 == (-7 & (B |= 0)) && (r = (E = (C >>> 0) / 3 | 0) << 2, (E = c(E, -3) + C | 0) && (r = 2 & B ? (2 | r) + (E >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                        if (!(4 & B)) {
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            B = 0;
                                                                            break i;
                                                                        }
                                                                        if (!C) {
                                                                            B = 0;
                                                                            break C;
                                                                        }
                                                                        for(B = 0;;){
                                                                            for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 45 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 32705 ^ -1) >>> 8 & 95 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                            if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                        }
                                                                        if (!t) break B;
                                                                        E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 32705 | 0, s = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                        break Q;
                                                                    }
                                                                    yC(), Q();
                                                                }
                                                                for(;;){
                                                                    for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 43 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 16321 ^ -1) >>> 8 & 47 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                    if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                }
                                                                if (!t) break B;
                                                                E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 16321 | 0, s = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                            }
                                                            o[A + B | 0] = g | (-1 ^ y) >>> 8 & s | E | t | C, B = B + 1 | 0;
                                                        }
                                                        if (B >>> 0 > r >>> 0) break g;
                                                    }
                                                    if (B >>> 0 < r >>> 0) break I;
                                                    r = B;
                                                    break A;
                                                }
                                                e(1104, 1201, 231, 1505), Q();
                                            }
                                            Hg(A + B | 0, 61, r - B | 0);
                                        }
                                        return Hg(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                    }
                                    function PA(A, I) {
                                        var g, C = 0, B = 0;
                                        for(h = g = h - 144 | 0, v(B = g + 96 | 0, I), v(C = g + 48 | 0, B), v(C, C), Y(C, I, C), Y(B, B, C), v(B, B), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(C, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), C = 1; v(g, g), 100 != (0 | (C = C + 1 | 0)););
                                        Y(C = g + 48 | 0, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B = g + 96 | 0, C, B), v(B, B), v(B, B), Y(A, B, I), h = g + 144 | 0;
                                    }
                                    function qA(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(G = g + 240 | 0, C), Y(S = g + 192 | 0, G, 1600), M = -1, B = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = B, E[g + 192 >> 2] = E[g + 192 >> 2] + 1, Q = E[g + 244 >> 2], i = E[g + 248 >> 2], _ = E[g + 252 >> 2], c = E[g + 256 >> 2], t = E[g + 260 >> 2], r = E[g + 264 >> 2], e = E[g + 268 >> 2], y = E[g + 272 >> 2], s = E[g + 276 >> 2], v(N = g + 144 | 0, S), Y(N, N, S), v(A, N), Y(A, A, S), Y(A, A, G), PA(A, A), Y(A, A, N), Y(A, A, G), v(N = g + 96 | 0, A), Y(N, N, S), S = E[g + 132 >> 2], E[g + 84 >> 2] = S - s, N = E[g + 128 >> 2], E[g + 80 >> 2] = N - y, G = E[g + 124 >> 2], E[g + 76 >> 2] = G - e, D = E[g + 120 >> 2], E[g + 72 >> 2] = D - r, p = E[g + 116 >> 2], E[g + 68 >> 2] = p - t, w = E[g + 112 >> 2], E[g + 64 >> 2] = w - c, f = E[g + 108 >> 2], E[g + 60 >> 2] = f - _, n = E[g + 104 >> 2], E[g + 56 >> 2] = n - i, k = E[g + 100 >> 2], E[g + 52 >> 2] = k - Q, F = E[g + 96 >> 2], E[g + 48 >> 2] = F - B, BI(g, g + 48 | 0);
                                        A: {
                                            if (!NI(g, 32)) {
                                                if (E[g + 36 >> 2] = S + s, E[g + 32 >> 2] = N + y, E[g + 28 >> 2] = G + e, E[g + 24 >> 2] = r + D, E[g + 20 >> 2] = t + p, E[g + 16 >> 2] = c + w, E[g + 12 >> 2] = _ + f, E[g + 8 >> 2] = i + n, E[g + 4 >> 2] = Q + k, E[g >> 2] = B + F, BI(S = g + 288 | 0, g), !NI(S, 32)) break A;
                                                Y(A, A, 1648);
                                            }
                                            BI(g + 288 | 0, A), (1 & o[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (E[A >> 2] = 0 - E[A >> 2], E[A + 36 >> 2] = 0 - E[A + 36 >> 2], E[A + 32 >> 2] = 0 - E[A + 32 >> 2], E[A + 28 >> 2] = 0 - E[A + 28 >> 2], E[A + 24 >> 2] = 0 - E[A + 24 >> 2], E[A + 20 >> 2] = 0 - E[A + 20 >> 2], E[A + 16 >> 2] = 0 - E[A + 16 >> 2], E[A + 12 >> 2] = 0 - E[A + 12 >> 2], E[A + 8 >> 2] = 0 - E[A + 8 >> 2], E[A + 4 >> 2] = 0 - E[A + 4 >> 2]), Y(A + 120 | 0, A, C), M = 0;
                                        }
                                        return h = g + 320 | 0, M;
                                    }
                                    function zA(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r = 0;
                                        h = C = h - 128 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, Hg(A + 44 | 0, 0, 76), RA(A, I = c(I, 960) + 3008 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), RA(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), RA(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), RA(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), RA(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), RA(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), RA(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), RA(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 40 >> 2] = E[A + 72 >> 2], E[C + 44 >> 2] = I, r = E[4 + (I = A - -64 | 0) >> 2], E[C + 32 >> 2] = E[I >> 2], E[C + 36 >> 2] = r, I = E[A + 60 >> 2], E[C + 24 >> 2] = E[A + 56 >> 2], E[C + 28 >> 2] = I, I = E[A + 52 >> 2], E[C + 16 >> 2] = E[A + 48 >> 2], E[C + 20 >> 2] = I, I = E[A + 44 >> 2], E[C + 8 >> 2] = E[A + 40 >> 2], E[C + 12 >> 2] = I, I = E[A + 12 >> 2], E[C + 56 >> 2] = E[A + 8 >> 2], E[C + 60 >> 2] = I, r = E[A + 20 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 16 >> 2], E[I + 4 >> 2] = r, I = E[A + 28 >> 2], E[C + 72 >> 2] = E[A + 24 >> 2], E[C + 76 >> 2] = I, I = E[A + 36 >> 2], E[C + 80 >> 2] = E[A + 32 >> 2], E[C + 84 >> 2] = I, I = E[A + 4 >> 2], E[C + 48 >> 2] = E[A >> 2], E[C + 52 >> 2] = I, I = E[A + 80 >> 2], r = E[A + 84 >> 2], B = E[A + 88 >> 2], Q = E[A + 92 >> 2], i = E[A + 96 >> 2], o = E[A + 100 >> 2], a = E[A + 104 >> 2], _ = E[A + 108 >> 2], t = E[A + 112 >> 2], E[C + 124 >> 2] = 0 - E[A + 116 >> 2], E[C + 120 >> 2] = 0 - t, E[C + 116 >> 2] = 0 - _, E[C + 112 >> 2] = 0 - a, E[C + 108 >> 2] = 0 - o, E[C + 104 >> 2] = 0 - i, E[C + 100 >> 2] = 0 - Q, E[C + 96 >> 2] = 0 - B, E[C + 92 >> 2] = 0 - r, E[C + 88 >> 2] = 0 - I, RA(A, C + 8 | 0, (128 & g) >>> 7 | 0), h = C + 128 | 0;
                                    }
                                    function jA(A) {
                                        var I, g, C, B, Q, i, o, a, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        return h = I = h - 320 | 0, v(c = I + 240 | 0, A), v(t = I + 192 | 0, A + 40 | 0), v(_ = I + 144 | 0, A + 80 | 0), A = E[I + 240 >> 2], r = E[I + 192 >> 2], e = E[I + 244 >> 2], y = E[I + 196 >> 2], s = E[I + 248 >> 2], D = E[I + 200 >> 2], p = E[I + 252 >> 2], w = E[I + 204 >> 2], f = E[I + 256 >> 2], n = E[I + 208 >> 2], k = E[I + 260 >> 2], F = E[I + 212 >> 2], N = E[I + 264 >> 2], S = E[I + 216 >> 2], G = E[I + 268 >> 2], M = E[I + 220 >> 2], b = E[I + 272 >> 2], K = E[I + 224 >> 2], E[I + 84 >> 2] = E[I + 228 >> 2] - E[I + 276 >> 2], E[I + 80 >> 2] = K - b, E[I + 76 >> 2] = M - G, E[I + 72 >> 2] = S - N, E[I + 68 >> 2] = F - k, E[I + 64 >> 2] = n - f, E[I + 60 >> 2] = w - p, E[I + 56 >> 2] = D - s, E[I + 52 >> 2] = y - e, E[I + 48 >> 2] = r - A, Y(A = I + 48 | 0, A, _), Y(I, c, t), Y(I, I, 1600), v(I + 96 | 0, _), _ = E[I + 48 >> 2], c = E[I + 96 >> 2], t = E[I >> 2], r = E[I + 52 >> 2], e = E[I + 100 >> 2], y = E[I + 4 >> 2], s = E[I + 56 >> 2], D = E[I + 104 >> 2], p = E[I + 8 >> 2], w = E[I + 60 >> 2], f = E[I + 108 >> 2], n = E[I + 12 >> 2], k = E[I + 64 >> 2], F = E[I + 112 >> 2], N = E[I + 16 >> 2], S = E[I + 68 >> 2], G = E[I + 116 >> 2], M = E[I + 20 >> 2], b = E[I + 72 >> 2], K = E[I + 120 >> 2], g = E[I + 24 >> 2], C = E[I + 76 >> 2], B = E[I + 124 >> 2], Q = E[I + 28 >> 2], i = E[I + 80 >> 2], o = E[I + 128 >> 2], a = E[I + 32 >> 2], E[I + 84 >> 2] = E[I + 84 >> 2] - (E[I + 132 >> 2] + E[I + 36 >> 2] | 0), E[I + 80 >> 2] = i - (o + a | 0), E[I + 76 >> 2] = C - (B + Q | 0), E[I + 72 >> 2] = b - (K + g | 0), E[I + 68 >> 2] = S - (G + M | 0), E[I + 64 >> 2] = k - (F + N | 0), E[I + 60 >> 2] = w - (f + n | 0), E[I + 56 >> 2] = s - (D + p | 0), E[I + 52 >> 2] = r - (e + y | 0), E[I + 48 >> 2] = _ - (c + t | 0), BI(_ = I + 288 | 0, A), A = NI(_, 32), h = I + 320 | 0, A;
                                    }
                                    function XA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (g | C) A: for(t = A + 224 | 0, _ = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + _ | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                Sg(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (Sg(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (E = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, o[A + 64 | 0] = E, o[A + 65 | 0] = E >>> 8, o[A + 66 | 0] = E >>> 16, o[A + 67 | 0] = E >>> 24, o[A + 68 | 0] = Q, o[A + 69 | 0] = Q >>> 8, o[A + 70 | 0] = Q >>> 16, o[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, o[A + 72 | 0] = B, o[A + 73 | 0] = B >>> 8, o[A + 74 | 0] = B >>> 16, o[A + 75 | 0] = B >>> 24, o[A + 76 | 0] = Q, o[A + 77 | 0] = Q >>> 8, o[A + 78 | 0] = Q >>> 16, o[A + 79 | 0] = Q >>> 24, f(A, _), Sg(_, t, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function OA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        for(g = E[A + 60 >> 2], h = E[A + 56 >> 2], s = E[A + 52 >> 2], e = E[A + 48 >> 2], I = E[A + 44 >> 2], C = E[A + 40 >> 2], D = E[A + 36 >> 2], r = E[A + 32 >> 2], B = E[A + 28 >> 2], Q = E[A + 24 >> 2], i = E[A + 20 >> 2], o = E[A + 16 >> 2], a = E[A + 12 >> 2], _ = E[A + 8 >> 2], c = E[A + 4 >> 2], t = E[A >> 2]; y = Lg(i + c | 0, 7) ^ D, p = Lg(y + i | 0, 9) ^ s, o = Lg(t + e | 0, 7) ^ o, w = Lg(o + t | 0, 9) ^ r, f = Lg(w + o | 0, 13) ^ e, a = Lg(I + g | 0, 7) ^ a, B = Lg(a + g | 0, 9) ^ B, r = Lg(B + a | 0, 13) ^ I, g = Lg(B + r | 0, 18) ^ g, I = Lg(C + Q | 0, 7) ^ h, e = f ^ Lg(g + I | 0, 7), s = p ^ Lg(e + g | 0, 9), h = Lg(e + s | 0, 13) ^ I, g = Lg(s + h | 0, 18) ^ g, _ = Lg(I + C | 0, 9) ^ _, Q = Lg(_ + I | 0, 13) ^ Q, C = Lg(Q + _ | 0, 18) ^ C, I = Lg(C + y | 0, 7) ^ r, r = Lg(I + C | 0, 9) ^ w, D = Lg(I + r | 0, 13) ^ y, C = Lg(r + D | 0, 18) ^ C, c = Lg(y + p | 0, 13) ^ c, i = Lg(c + p | 0, 18) ^ i, Q = Lg(i + o | 0, 7) ^ Q, B = Lg(Q + i | 0, 9) ^ B, o = Lg(B + Q | 0, 13) ^ o, i = Lg(o + B | 0, 18) ^ i, t = Lg(w + f | 0, 18) ^ t, c = Lg(t + a | 0, 7) ^ c, _ = Lg(c + t | 0, 9) ^ _, a = Lg(_ + c | 0, 13) ^ a, t = Lg(a + _ | 0, 18) ^ t, y = n >>> 0 < 6, n = n + 2 | 0, y;);
                                        E[A >> 2] = E[A >> 2] + t, E[A + 4 >> 2] = E[A + 4 >> 2] + c, E[A + 8 >> 2] = E[A + 8 >> 2] + _, E[A + 12 >> 2] = E[A + 12 >> 2] + a, E[A + 16 >> 2] = E[A + 16 >> 2] + o, E[A + 20 >> 2] = E[A + 20 >> 2] + i, E[A + 24 >> 2] = E[A + 24 >> 2] + Q, E[A + 28 >> 2] = E[A + 28 >> 2] + B, E[A + 32 >> 2] = E[A + 32 >> 2] + r, E[A + 36 >> 2] = E[A + 36 >> 2] + D, E[A + 40 >> 2] = E[A + 40 >> 2] + C, E[A + 44 >> 2] = E[A + 44 >> 2] + I, E[A + 48 >> 2] = E[A + 48 >> 2] + e, E[A + 52 >> 2] = E[A + 52 >> 2] + s, E[A + 56 >> 2] = E[A + 56 >> 2] + h, E[A + 60 >> 2] = E[A + 60 >> 2] + g;
                                    }
                                    function VA(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 320 | 0, Q = -1, GI(g) && (bI(g) || bA(B, g) || IA(B) && (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], g = a[I + 31 | 0], C && (o[0 | A] = 248 & a[0 | A], g |= 64), o[A + 31 | 0] = 127 & g, u(g = B + 160 | 0, A, B), tg(A, g), (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (Q = NI(I, 32) ? -1 : 0))), h = B + 320 | 0, Q;
                                    }
                                    function ZA(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0;
                                        if (h = Q = h - 48 | 0, B && ag(B, 102), !(36 != a[0 | C] | 55 != a[C + 1 | 0] | 36 != a[C + 2 | 0]) && (r = uI(a[C + 3 | 0])) && (i = PI(Q + 12 | 0, C + 4 | 0)) && (t = PI(Q + 8 | 0, i))) {
                                            for(_ = LI(t) + 1 | 0; i = 0, _ && 36 != a[0 | (i = t + (_ = _ - 1 | 0) | 0)];);
                                            if (c = i - t | 0, i || (c = LI(t)), !((c = 45 + (_ = (i = c) + (t - C | 0) | 0) | 0) >>> 0 > 102 | i >>> 0 > c >>> 0 || (c = A, y = I, s = g, A = 31 & (r = r - 1024 | 0), (63 & r) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, _A(c, y, s, t, i, g, I, E[Q + 12 >> 2], E[Q + 8 >> 2], Q + 16 | 0, 32)))) {
                                                for(i = Sg(B, C, _), o[0 | (A = i + _ | 0)] = 36, e = (c = i + 102 | 0) - (B = A + 1 | 0) | 0, g = 0;;){
                                                    A: if ((I = g) >>> 0 > 31) C = B;
                                                    else if (A = B, g = (_ = I + 1 | 0) + (y = (g = 31 - I | 0) >>> 0 >= 2 ? 2 : g) | 0, C = 0, t = 0, B = a[(r = Q + 16 | 0) + I | 0], y && (B = a[_ + r | 0] << 8 | B, (0 | (I = I + 2 | 0)) != (0 | g) && (t = 1, B = a[I + r | 0] << 16 | B)), e && (o[0 | A] = a[1024 + (63 & B) | 0], 1 != (0 | e))) {
                                                        if (o[A + 1 | 0] = a[1024 + (B >>> 6 & 63) | 0], y = A + e | 0, I = A + 2 | 0, (0 | g) != (0 | _)) {
                                                            if (2 == (0 | e)) break A;
                                                            if (o[A + 2 | 0] = a[1024 + (B >>> 12 & 63) | 0], I = A + 3 | 0, t) {
                                                                if (3 == (0 | e)) break A;
                                                                o[A + 3 | 0] = a[1024 + (B >>> 18 | 0) | 0], I = A + 4 | 0;
                                                            }
                                                        }
                                                        if (e = y - (B = I) | 0, B) continue;
                                                    }
                                                    break;
                                                }
                                                XC(Q + 16 | 0, 32), e = 0, !C | C >>> 0 >= c >>> 0 || (o[0 | C] = 0, e = i);
                                            }
                                        }
                                        return h = Q + 48 | 0, e;
                                    }
                                    function WA(A, I, g) {
                                        var C, B, Q, i = 0, o = 0, _ = 0, t = 0;
                                        h = C = h - 16 | 0, B = E[A + 20 >> 2], E[A + 20 >> 2] = 0, Q = E[A + 4 >> 2], E[A + 4 >> 2] = 0, i = -26;
                                        A: {
                                            I: {
                                                g: {
                                                    C: switch(g - 1 | 0){
                                                        case 1:
                                                            if (i = -32, Cg(I, 1165, 9)) break A;
                                                            I = I + 9 | 0;
                                                            break g;
                                                        case 0:
                                                            break C;
                                                        default:
                                                            break A;
                                                    }
                                                    if (i = -32, Cg(I, 1156, 8)) break A;
                                                    I = I + 8 | 0;
                                                }
                                                if (!((i = Cg(I, 1422, 3)) || ((o = a[0 | (g = I + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                                                    for(t = i ? I : g, I = 0, i = o;;){
                                                        if (_ = g, I >>> 0 > 429496729) break I;
                                                        if ((i = (255 & i) - 48 | 0) >>> 0 > (-1 ^ (I = c(I, 10))) >>> 0) break I;
                                                        if (I = I + i | 0, !(((i = a[0 | (g = g + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                                    }
                                                    if (!(48 == (0 | o) & (0 | t) != (0 | _) | (0 | g) == (0 | t))) {
                                                        if (i = -26, 19 != (0 | I)) break A;
                                                        if (!Cg(g, 1434, 3) && (g = mI(_ + 4 | 0, I = C + 12 | 0)) && (E[A + 44 >> 2] = E[C + 12 >> 2], !Cg(g, 1426, 3) && (g = mI(g + 3 | 0, I)) && (E[A + 40 >> 2] = E[C + 12 >> 2], !Cg(g, 1430, 3) && (g = mI(g + 3 | 0, I)) && (i = E[C + 12 >> 2], E[A + 48 >> 2] = i, E[A + 52 >> 2] = i, 36 == a[0 | g] && (E[C + 12 >> 2] = B, !wA(i = E[A + 16 >> 2], B, _ = g = g + 1 | 0, o = LI(g), 0, I, g = C + 8 | 0, 3) && (E[A + 20 >> 2] = E[C + 12 >> 2], i = E[C + 8 >> 2], 36 == a[0 | i] && (E[C + 12 >> 2] = Q, i = i + 1 | 0, !wA(E[A >> 2], Q, i, LI(i), 0, I, g, 3)))))))) {
                                                            if (E[A + 4 >> 2] = E[C + 12 >> 2], I = E[C + 8 >> 2], i = pI(A)) break A;
                                                            i = a[0 | I] ? -32 : 0;
                                                            break A;
                                                        }
                                                    }
                                                }
                                            }
                                            i = -32;
                                        }
                                        return h = C + 16 | 0, i;
                                    }
                                    function TA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0;
                                        C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], h = E[(B = I - -64 | 0) >> 2], D = E[I + 28 >> 2], p = E[I + 68 >> 2], w = E[I + 32 >> 2], f = E[I + 72 >> 2], g = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = w + f, E[A + 28 >> 2] = D + p, E[A + 24 >> 2] = s + h, E[A + 20 >> 2] = e + y, E[A + 16 >> 2] = t + r, E[A + 12 >> 2] = _ + c, E[A + 8 >> 2] = o + a, E[A + 4 >> 2] = Q + i, E[A >> 2] = C + g, C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], B = E[B >> 2], h = E[I + 28 >> 2], D = E[I + 68 >> 2], p = E[I + 32 >> 2], w = E[I + 72 >> 2], f = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = w - p, E[A + 68 >> 2] = D - h, E[A - -64 >> 2] = B - s, E[A + 60 >> 2] = y - e, E[A + 56 >> 2] = r - t, E[A + 52 >> 2] = c - _, E[A + 48 >> 2] = a - o, E[A + 44 >> 2] = i - Q, E[A + 40 >> 2] = C - f, C = E[I + 84 >> 2], E[A + 80 >> 2] = E[I + 80 >> 2], E[A + 84 >> 2] = C, C = E[I + 92 >> 2], E[A + 88 >> 2] = E[I + 88 >> 2], E[A + 92 >> 2] = C, C = E[I + 100 >> 2], E[A + 96 >> 2] = E[I + 96 >> 2], E[A + 100 >> 2] = C, C = E[I + 108 >> 2], E[A + 104 >> 2] = E[I + 104 >> 2], E[A + 108 >> 2] = C, C = E[I + 116 >> 2], E[A + 112 >> 2] = E[I + 112 >> 2], E[A + 116 >> 2] = C, Y(A + 120 | 0, I + 120 | 0, 1696);
                                    }
                                    function $A(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0;
                                        s = E[I + 12 >> 2], D = E[I + 8 >> 2], p = E[I + 4 >> 2], C = h + -64 & -64, I = E[I >> 2], E[C >> 2] = E[35760 + ((255 & I) << 2) >> 2], E[C + 4 >> 2] = E[35760 + (p >>> 6 & 1020) >> 2], E[C + 8 >> 2] = E[35760 + (D >>> 14 & 1020) >> 2], E[C + 12 >> 2] = E[35760 + (s >>> 22 & 1020) >> 2], E[C + 16 >> 2] = E[35760 + ((255 & p) << 2) >> 2], E[C + 20 >> 2] = E[35760 + (D >>> 6 & 1020) >> 2], E[C + 24 >> 2] = E[35760 + (s >>> 14 & 1020) >> 2], E[C + 28 >> 2] = E[35760 + (I >>> 22 & 1020) >> 2], E[C + 32 >> 2] = E[35760 + ((255 & D) << 2) >> 2], E[C + 36 >> 2] = E[35760 + (s >>> 6 & 1020) >> 2], E[C + 40 >> 2] = E[35760 + (I >>> 14 & 1020) >> 2], E[C + 44 >> 2] = E[35760 + (p >>> 22 & 1020) >> 2], E[C + 48 >> 2] = E[35760 + ((255 & s) << 2) >> 2], E[C + 52 >> 2] = E[35760 + (I >>> 6 & 1020) >> 2], E[C + 56 >> 2] = E[35760 + (p >>> 14 & 1020) >> 2], E[C + 60 >> 2] = E[35760 + (D >>> 22 & 1020) >> 2], I = E[C + 12 >> 2], s = E[C >> 2], D = E[C + 4 >> 2], p = E[C + 8 >> 2], B = E[C + 28 >> 2], Q = E[C + 16 >> 2], i = E[C + 20 >> 2], o = E[C + 24 >> 2], a = E[C + 44 >> 2], _ = E[C + 32 >> 2], c = E[C + 36 >> 2], t = E[C + 40 >> 2], r = E[g >> 2], e = E[g + 4 >> 2], y = E[g + 8 >> 2], w = A, f = E[g + 12 >> 2] ^ E[C + 48 >> 2] ^ Lg(E[C + 52 >> 2], 8) ^ Lg(E[C + 56 >> 2], 16) ^ Lg(E[C + 60 >> 2], 24), E[w + 12 >> 2] = f, w = A, f = Lg(c, 8) ^ _ ^ Lg(t, 16) ^ Lg(a, 24) ^ y, E[w + 8 >> 2] = f, w = A, f = Lg(i, 8) ^ Q ^ Lg(o, 16) ^ Lg(B, 24) ^ e, E[w + 4 >> 2] = f, w = A, f = Lg(D, 8) ^ s ^ Lg(p, 16) ^ Lg(I, 24) ^ r, E[w >> 2] = f;
                                    }
                                    function AI(A, I, g) {
                                        var C, B = 0;
                                        return h = C = h - 160 | 0, o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], B = a[I + 31 | 0], g && (o[0 | A] = 248 & a[0 | A], B |= 64), o[A + 31 | 0] = 127 & B, kA(C, A), tg(A, C), g = -1, (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (g = NI(I, 32) ? -1 : 0), h = C + 160 | 0, g;
                                    }
                                    function II(A, I) {
                                        var g, C, B, Q, i, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        (a = E[A + 56 >> 2]) | (_ = E[A + 60 >> 2]) && (o[(r = A - -64 | 0) + a | 0] = 1, !((p = a + 1 | 0) ? _ : _ + 1 | 0) & p >>> 0 <= 15 && Hg(65 + (A + a | 0) | 0, 0, 15 - a | 0), o[A + 80 | 0] = 1, rA(A, r, 16, 0)), p = E[A + 52 >> 2], h = E[A + 48 >> 2], r = E[A + 44 >> 2], a = E[A + 24 >> 2], e = E[A + 28 >> 2] + (a >>> 26 | 0) | 0, t = E[A + 32 >> 2] + (e >>> 26 | 0) | 0, g = E[A + 36 >> 2] + (t >>> 26 | 0) | 0, _ = (s = (a = (a = (67108863 & a) + ((y = E[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (e = (t = (i = (67108863 & g) + ((Q = (C = 67108863 & t) + ((B = (D = 67108863 & e) + ((y = a + ((_ = 5 + (s = 67108863 & y) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | y & (t = 67108863 & (y = (t >>> 31 | 0) - 1 | 0))) << 26 | _ & t | e & s) + E[A + 40 >> 2] | 0, o[0 | I] = _, o[I + 1 | 0] = _ >>> 8, o[I + 2 | 0] = _ >>> 16, o[I + 3 | 0] = _ >>> 24, s = _ >>> 0 < s >>> 0, _ = 0, _ = (a = (D = e & D | t & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : _, _ = (r = a) >>> 0 > (a = a + s | 0) >>> 0 ? _ + 1 | 0 : _, o[I + 4 | 0] = a, o[I + 5 | 0] = a >>> 8, o[I + 6 | 0] = a >>> 16, o[I + 7 | 0] = a >>> 24, a = 0, r = (r = (t = e & C | t & Q) << 14 | D >>> 12) >>> 0 > (h = r + h | 0) >>> 0 ? 1 : a, a = h, h = _, a = a + _ | 0, _ = r, _ = a >>> 0 < h >>> 0 ? _ + 1 | 0 : _, o[I + 8 | 0] = a, o[I + 9 | 0] = a >>> 8, o[I + 10 | 0] = a >>> 16, o[I + 11 | 0] = a >>> 24, _ = (a = (a = (y & i | e & g) << 8 | t >>> 18) + p | 0) + _ | 0, o[I + 12 | 0] = _, o[I + 13 | 0] = _ >>> 8, o[I + 14 | 0] = _ >>> 16, o[I + 15 | 0] = _ >>> 24, XC(A, 88);
                                    }
                                    function gI(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B = 0;
                                        return h = C = h - 16 | 0, o[C + 15 | 0] = 0, B = -1, 0 | pB[E[8934]](A, I, g) || (o[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), h = C + 16 | 0, 0 | B;
                                    }
                                    function CI(A, I, g, C, B) {
                                        var Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0;
                                        A: {
                                            if (1 == (0 | C) | C >>> 0 > 1) E[9392] = 22;
                                            else {
                                                h = C = h - 128 | 0, E[C - -64 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, Q = LI(A), E[C + 28 >> 2] = Q, E[C + 44 >> 2] = Q, E[C + 12 >> 2] = Q, i = K(Q), E[C + 40 >> 2] = i, o = K(Q), E[C + 24 >> 2] = o, a = K(Q), E[C + 8 >> 2] = a;
                                                I: if (!a | !i | !o || !(Q = K(Q))) gA(i), gA(o), gA(a), A = -22;
                                                else {
                                                    if (A = WA(C + 8 | 0, A, B)) {
                                                        gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), gA(E[C + 8 >> 2]), gA(Q);
                                                        break I;
                                                    }
                                                    a = E[C + 28 >> 2], _ = E[C + 24 >> 2], A = E[C + 60 >> 2], c = E[C + 52 >> 2], t = E[C + 48 >> 2], ag(Q, i = E[C + 12 >> 2]), (o = K(i)) ? (E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 88 >> 2] = a, E[C + 84 >> 2] = _, E[C + 80 >> 2] = g, E[C + 76 >> 2] = I, E[C + 72 >> 2] = i, E[C + 68 >> 2] = o, E[C + 124 >> 2] = 0, E[C + 120 >> 2] = A, E[C + 116 >> 2] = A, E[C + 112 >> 2] = c, E[C + 108 >> 2] = t, (A = L(C + 68 | 0, B)) || Sg(Q, o, i), XC(o, i), gA(o)) : A = -22, gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), A || (A = MI(Q, E[C + 8 >> 2], E[C + 12 >> 2]) ? -35 : 0), gA(Q), gA(E[C + 8 >> 2]);
                                                }
                                                if (h = C + 128 | 0, I = A, !A) break A;
                                                -35 == (0 | A) && (E[9392] = 28);
                                            }
                                            I = -1;
                                        }
                                        return I;
                                    }
                                    function BI(A, I) {
                                        var g, C, B, Q, i, a, _, t = 0, r = 0;
                                        C = E[I + 32 >> 2], B = E[I + 28 >> 2], Q = E[I + 24 >> 2], i = E[I + 20 >> 2], a = E[I + 16 >> 2], _ = E[I + 12 >> 2], t = E[I + 4 >> 2], r = E[I >> 2], g = E[I + 36 >> 2], I = E[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (_ + ((t + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, o[0 | A] = r, o[A + 2 | 0] = r >>> 16, o[A + 1 | 0] = r >>> 8, t = t + (r >> 26) | 0, o[A + 5 | 0] = t >>> 14, o[A + 4 | 0] = t >>> 6, o[A + 3 | 0] = r >>> 24 & 3 | t << 2, I = I + (t >> 25) | 0, o[A + 8 | 0] = I >>> 13, o[A + 7 | 0] = I >>> 5, o[A + 6 | 0] = I << 3 | (29360128 & t) >>> 22, r = (I >> 26) + _ | 0, o[A + 11 | 0] = r >>> 11, o[A + 10 | 0] = r >>> 3, o[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, t = (r >> 25) + a | 0, o[A + 15 | 0] = t >>> 18, o[A + 14 | 0] = t >>> 10, o[A + 13 | 0] = t >>> 2, I = (t >> 26) + i | 0, o[A + 16 | 0] = I, o[A + 12 | 0] = t << 6 | (33030144 & r) >>> 19, o[A + 18 | 0] = I >>> 16, o[A + 17 | 0] = I >>> 8, t = (I >> 25) + Q | 0, o[A + 21 | 0] = t >>> 15, o[A + 20 | 0] = t >>> 7, o[A + 19 | 0] = I >>> 24 & 1 | t << 1, I = (t >> 26) + B | 0, o[A + 24 | 0] = I >>> 13, o[A + 23 | 0] = I >>> 5, o[A + 22 | 0] = I << 3 | (58720256 & t) >>> 23, t = (I >> 25) + C | 0, o[A + 27 | 0] = t >>> 12, o[A + 26 | 0] = t >>> 4, o[A + 25 | 0] = t << 4 | (31457280 & I) >>> 21, I = g + (t >> 26) | 0, o[A + 30 | 0] = I >>> 10, o[A + 29 | 0] = I >>> 2, o[A + 31 | 0] = (33292288 & I) >>> 18, o[A + 28 | 0] = I << 6 | (66060288 & t) >>> 20;
                                    }
                                    function QI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (h = C = h - 192 | 0, (g |= 0) >>> 0 >= 129 && (SI(A), nA(A, I, g, 0), z(A, C), g = 64, I = C), SI(A), Hg(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(t = 252 & g; o[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (_ = 3 & g) for(; o[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | _) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (nA(A, Q = C - -64 | 0, 128, 0), SI(i = A + 208 | 0), Hg(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(t = 252 & g, _ = 0; o[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return nA(i, A = C - -64 | 0, 128, 0), XC(A, 128), XC(C, 64), h = C + 192 | 0, 0;
                                    }
                                    function iI(A, I) {
                                        var g;
                                        return A |= 0, I |= 0, E[12 + (g = h - 16 | 0) >> 2] = A, E[g + 8 >> 2] = I, E[g + 4 >> 2] = 0, E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2]] ^ a[E[g + 8 >> 2]], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 1 | 0] ^ a[E[g + 8 >> 2] + 1 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 2 | 0] ^ a[E[g + 8 >> 2] + 2 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 3 | 0] ^ a[E[g + 8 >> 2] + 3 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 4 | 0] ^ a[E[g + 8 >> 2] + 4 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 5 | 0] ^ a[E[g + 8 >> 2] + 5 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 6 | 0] ^ a[E[g + 8 >> 2] + 6 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 7 | 0] ^ a[E[g + 8 >> 2] + 7 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 8 | 0] ^ a[E[g + 8 >> 2] + 8 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 9 | 0] ^ a[E[g + 8 >> 2] + 9 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 10 | 0] ^ a[E[g + 8 >> 2] + 10 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 11 | 0] ^ a[E[g + 8 >> 2] + 11 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 12 | 0] ^ a[E[g + 8 >> 2] + 12 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 13 | 0] ^ a[E[g + 8 >> 2] + 13 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 14 | 0] ^ a[E[g + 8 >> 2] + 14 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 15 | 0] ^ a[E[g + 8 >> 2] + 15 | 0], (E[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function oI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, a = 0, _ = 0, r = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            if (I) {
                                                                                if (!g) break E;
                                                                                break o;
                                                                            }
                                                                            return D = (I = A) - c(A = (A >>> 0) / (g >>> 0) | 0, g) | 0, p = 0, w = 0, A;
                                                                        }
                                                                        if (!A) break i;
                                                                        break Q;
                                                                    }
                                                                    if (!((C = g - 1 | 0) & g)) break B;
                                                                    Q = 0 - (i = (t(g) + 33 | 0) - t(I) | 0) | 0;
                                                                    break g;
                                                                }
                                                                return D = 0, p = I - c(A = (I >>> 0) / 0 | 0, 0) | 0, w = 0, A;
                                                            }
                                                            if ((C = 32 - t(I) | 0) >>> 0 < 31) break C;
                                                            break I;
                                                        }
                                                        if (D = A & C, p = 0, 1 == (0 | g)) break A;
                                                        return g = 31 & (C = FC(g)), (63 & C) >>> 0 >= 32 ? A = I >>> g | 0 : (B = I >>> g | 0, A = ((1 << g) - 1 & I) << 32 - g | A >>> g), w = B, A;
                                                    }
                                                    i = C + 1 | 0, Q = 63 - C | 0;
                                                }
                                                if (C = 31 & (B = 63 & i), B >>> 0 >= 32 ? (B = 0, o = I >>> C | 0) : (B = I >>> C | 0, o = ((1 << C) - 1 & I) << 32 - C | A >>> C), C = 31 & (Q &= 63), Q >>> 0 >= 32 ? (I = A << C, A = 0) : (I = (1 << C) - 1 & A >>> 32 - C | I << C, A <<= C), i) for(_ = -1 == (0 | (C = g - 1 | 0)) ? -1 : 0; E = B << 1 | o >>> 31, o = (B = o << 1 | I >>> 31) - (a = g & (Q = _ - (E + (B >>> 0 > C >>> 0) | 0) >> 31)) | 0, B = E - (B >>> 0 < a >>> 0) | 0, I = I << 1 | A >>> 31, A = r | A << 1, r = E = 1 & Q, i = i - 1 | 0;);
                                                return D = o, p = B, w = I << 1 | A >>> 31, E | A << 1;
                                            }
                                            D = A, p = I, A = 0, I = 0;
                                        }
                                        return w = I, A;
                                    }
                                    function EI(A, I, g, C, B) {
                                        var Q;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), dC(Q, I, g, C), fg(Q, Q + 416 | 0), I = E[Q + 444 >> 2], g = E[Q + 440 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 436 >> 2], g = E[Q + 432 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 428 >> 2], g = E[Q + 424 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 420 >> 2], g = E[Q + 416 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = Q + 480 | 0, 0;
                                    }
                                    function aI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0;
                                        return h = C = h + -64 | 0, kI(C, g |= 0, 32, 0), g = E[C + 28 >> 2], B = E[C + 24 >> 2], o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, o[I + 28 | 0] = g, o[I + 29 | 0] = g >>> 8, o[I + 30 | 0] = g >>> 16, o[I + 31 | 0] = g >>> 24, g = E[C + 20 >> 2], B = E[C + 16 >> 2], o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, o[I + 20 | 0] = g, o[I + 21 | 0] = g >>> 8, o[I + 22 | 0] = g >>> 16, o[I + 23 | 0] = g >>> 24, g = E[C + 12 >> 2], B = E[C + 8 >> 2], o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, o[I + 12 | 0] = g, o[I + 13 | 0] = g >>> 8, o[I + 14 | 0] = g >>> 16, o[I + 15 | 0] = g >>> 24, g = E[C + 4 >> 2], B = E[C >> 2], o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, o[I + 4 | 0] = g, o[I + 5 | 0] = g >>> 8, o[I + 6 | 0] = g >>> 16, o[I + 7 | 0] = g >>> 24, XC(C, 64), A = wC(A, I), h = C - -64 | 0, 0 | A;
                                    }
                                    function _I(A, I) {
                                        var g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        if (I >>> 0 > 4294967168) A = 48;
                                        else {
                                            if (I >>> 0 >= 4294967168 ? (E[9392] = 48, g = 0) : (g = 0, (I = K(76 + (Q = I >>> 0 < 11 ? 16 : I + 11 & -8) | 0)) && (g = I - 8 | 0, 63 & I ? (B = (-8 & (o = E[(i = I - 4 | 0) >> 2])) - (C = (I = ((I = (I + 63 & -64) - 8 | 0) - g >>> 0 <= 15 ? 64 : 0) + I | 0) - g | 0) | 0, 3 & o ? (E[I + 4 >> 2] = B | 1 & E[I + 4 >> 2] | 2, E[4 + (B = I + B | 0) >> 2] = 1 | E[B + 4 >> 2], E[i >> 2] = C | 1 & E[i >> 2] | 2, E[4 + (B = g + C | 0) >> 2] = 1 | E[B + 4 >> 2], iA(g, C)) : (g = E[g >> 2], E[I + 4 >> 2] = B, E[I >> 2] = g + C)) : I = g, 3 & (g = E[I + 4 >> 2]) && ((C = -8 & g) >>> 0 <= Q + 16 >>> 0 || (E[I + 4 >> 2] = Q | 1 & g | 2, g = I + Q | 0, Q = C - Q | 0, E[g + 4 >> 2] = 3 | Q, E[4 + (C = I + C | 0) >> 2] = 1 | E[C + 4 >> 2], iA(g, Q))), g = I + 8 | 0)), !g) return 48;
                                            E[A >> 2] = g, A = 0;
                                        }
                                        return A;
                                    }
                                    function cI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!((!a & o >>> 0 >= 3 | 0 != (0 | a)) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 1 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 1)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function tI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!(!!(o | a) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 2 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 2)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function rI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, yA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), ug(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && Ug(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function eI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, fA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), aC(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && oC(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function yI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, fA(o, Q, i, 0), pC(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), XC(o + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || oC(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function sI(A, I, g, C, B, Q, i, o, _, c) {
                                        var t, r;
                                        return h = t = h - 400 | 0, E[t + 4 >> 2] = 0, yA(r = t + 16 | 0, _, c, 0), c = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[t + 8 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[t + 12 >> 2] = c, Xg(c = t + 80 | 0, 64, 0, t + 4 | 0, r), fC(_ = t + 144 | 0, c), XC(c, 64), NC(_, Q, i, o), NC(_, 35680, 0 - i & 15, 0), NC(_, I, g, C), NC(_, 35680, 0 - g & 15, 0), E[t + 72 >> 2] = i, E[t + 76 >> 2] = o, NC(_, Q = t + 72 | 0, 8, 0), E[t + 72 >> 2] = g, E[t + 76 >> 2] = C, NC(_, Q, 8, 0), nC(_, Q = t + 48 | 0), XC(_, 256), _ = iI(Q, B), XC(Q, 16), A && (_ ? (Hg(A, 0, g), _ = -1) : (Og(A, I, g, C, t + 4 | 0, t + 16 | 0), _ = 0)), XC(t + 16 | 0, 32), h = t + 400 | 0, _;
                                    }
                                    function hI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, yA(o, Q, i, 0), jg(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Q = 0, !B & C >>> 0 < 33 || Ug(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function DI(A, I, g, C, B, Q) {
                                        var i, a;
                                        if (h = i = h - 496 | 0, UA(a = i + 288 | 0, A, I), YC(a, g, C, 0), Q) for(A = 0, I = 0; g = (I = I + 1 | 0) << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, o[i + 76 | 0] = g, o[i + 77 | 0] = g >>> 8, o[i + 78 | 0] = g >>> 16, o[i + 79 | 0] = g >>> 24, Sg(g = i + 80 | 0, i + 288 | 0, 208), YC(g, i + 76 | 0, 4, 0), Fg(g, i + 32 | 0), g = E[i + 60 >> 2], E[i + 24 >> 2] = E[i + 56 >> 2], E[i + 28 >> 2] = g, g = E[i + 52 >> 2], E[i + 16 >> 2] = E[i + 48 >> 2], E[i + 20 >> 2] = g, g = E[i + 44 >> 2], E[i + 8 >> 2] = E[i + 40 >> 2], E[i + 12 >> 2] = g, g = E[i + 36 >> 2], E[i >> 2] = E[i + 32 >> 2], E[i + 4 >> 2] = g, Sg(g = A + B | 0, i, (A = Q - A | 0) >>> 0 >= 32 ? 32 : A), Q >>> 0 > (A = I << 5) >>> 0;);
                                        XC(i + 288 | 0, 208), h = i + 496 | 0;
                                    }
                                    function pI(A) {
                                        var I = 0, g = 0, C = 0;
                                        if (!A) return -25;
                                        if (!E[A >> 2]) return -1;
                                        if (I = -2, !(_[A + 4 >> 2] < 16) && (E[A + 8 >> 2] || (I = -18, !E[A + 12 >> 2]))) {
                                            if (g = E[A + 20 >> 2], !E[A + 16 >> 2]) return g ? -19 : -6;
                                            if (I = -6, !(g >>> 0 < 8) && (E[A + 24 >> 2] || (I = -20, !E[A + 28 >> 2])) && (E[A + 32 >> 2] || (I = -21, !E[A + 36 >> 2]))) {
                                                if (!(g = E[A + 48 >> 2])) return -16;
                                                if (I = -17, !(g >>> 0 > 16777215 || (I = -14, (C = E[A + 44 >> 2]) >>> 0 < 8 || (I = -15, C >>> 0 > 2097152 || (I = -14, g << 3 >>> 0 > C >>> 0))))) {
                                                    if (!E[A + 40 >> 2]) return -12;
                                                    if (!(A = E[A + 52 >> 2])) return -28;
                                                    I = A >>> 0 > 16777215 ? -29 : 0;
                                                }
                                            }
                                        }
                                        return I;
                                    }
                                    function wI(A, I, g, C, B, Q) {
                                        var i, E, a = 0;
                                        return h = i = h - 32 | 0, a = -1, (E = g >>> 0 < 32) & !C || (Kg(i, 32, 0, B, Q), DC(I + 16 | 0, I + 32 | 0, g - 32 | 0, C - E | 0, i) || (Gg(A, I, g, C, B, Q), o[A + 24 | 0] = 0, o[A + 25 | 0] = 0, o[A + 26 | 0] = 0, o[A + 27 | 0] = 0, o[A + 28 | 0] = 0, o[A + 29 | 0] = 0, o[A + 30 | 0] = 0, o[A + 31 | 0] = 0, o[A + 16 | 0] = 0, o[A + 17 | 0] = 0, o[A + 18 | 0] = 0, o[A + 19 | 0] = 0, o[A + 20 | 0] = 0, o[A + 21 | 0] = 0, o[A + 22 | 0] = 0, o[A + 23 | 0] = 0, o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, a = 0)), h = i + 32 | 0, a;
                                    }
                                    function fI(A, I, g, C, B, Q, i, o, _, c, t) {
                                        var r, e, y;
                                        return h = r = h - 384 | 0, E[r + 4 >> 2] = 0, yA(e = r + 16 | 0, c, t, 0), t = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, E[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, E[r + 12 >> 2] = t, Xg(t = r - -64 | 0, 64, 0, y = r + 4 | 0, e), fC(c = r + 128 | 0, t), XC(t, 64), NC(c, i, o, _), NC(c, 35680, 0 - o & 15, 0), Og(A, C, B, Q, y, e), NC(c, A, B, Q), NC(c, 35680, 0 - B & 15, 0), E[r + 56 >> 2] = o, E[r + 60 >> 2] = _, NC(c, A = r + 56 | 0, 8, 0), E[r + 56 >> 2] = B, E[r + 60 >> 2] = Q, NC(c, A, 8, 0), nC(c, I), XC(c, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), XC(r + 16 | 0, 32), h = r + 384 | 0, 0;
                                    }
                                    function nI(A, I, g, C, B) {
                                        var Q, i, o = 0;
                                        return h = Q = h + -64 | 0, !g & (i = LI(A)) >>> 0 < 128 ? (E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 56 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 48 >> 2] = 0, g = 0, i && (g = i, (1 | i) >>> 0 < 65536 || (g = i)), !(o = K(g)) | !(3 & a[o - 4 | 0]) || Hg(o, 0, g), o ? (E[Q + 36 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 12 >> 2] = o, E[Q + 20 >> 2] = o, E[Q + 24 >> 2] = i, E[Q + 4 >> 2] = o, E[Q + 16 >> 2] = i, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 8 >> 2] = i, WA(Q + 4 | 0, A, B) ? (E[9392] = 28, A = -1) : A = E[Q + 44 >> 2] != (0 | I) | E[Q + 48 >> 2] != (C >>> 10 | 0), gA(o)) : A = -1) : (E[9392] = 28, A = -1), h = Q - -64 | 0, A;
                                    }
                                    function kI(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 208 | 0, E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, Q = E[8691], E[B + 8 >> 2] = E[8690], E[B + 12 >> 2] = Q, Q = E[8693], E[B + 16 >> 2] = E[8692], E[B + 20 >> 2] = Q, Q = E[8695], E[B + 24 >> 2] = E[8694], E[B + 28 >> 2] = Q, Q = E[8697], E[B + 32 >> 2] = E[8696], E[B + 36 >> 2] = Q, Q = E[8699], E[B + 40 >> 2] = E[8698], E[B + 44 >> 2] = Q, Q = E[8701], E[B + 48 >> 2] = E[8700], E[B + 52 >> 2] = Q, Q = E[8703], E[B + 56 >> 2] = E[8702], E[B + 60 >> 2] = Q, E[B + 64 >> 2] = 0, E[B + 68 >> 2] = 0, Q = E[8689], E[B >> 2] = E[8688], E[B + 4 >> 2] = Q, nA(B, I, g, C), z(B, A), h = B + 208 | 0, 0;
                                    }
                                    function FI(A, I) {
                                        var g = 0, C = 0;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(g = a[0 | A]) | (0 | g) == (255 & I)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (g = E[A >> 2])) & g - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (g ^= C)) & g - 16843009 & -2139062144) break I;
                                                if (g = E[A + 4 >> 2], A = A + 4 | 0, g - 16843009 & (-1 ^ g) & -2139062144) break;
                                            }
                                            for(; g = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & I)););
                                            A = g;
                                        } else A = LI(A) + A | 0;
                                        return a[0 | A] == (255 & I) ? A : 0;
                                    }
                                    function NI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (o[15 + (g = h - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function SI(A) {
                                        var I = 0;
                                        return E[64 + (A |= 0) >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, I = E[8689], E[A >> 2] = E[8688], E[A + 4 >> 2] = I, I = E[8691], E[A + 8 >> 2] = E[8690], E[A + 12 >> 2] = I, I = E[8693], E[A + 16 >> 2] = E[8692], E[A + 20 >> 2] = I, I = E[8695], E[A + 24 >> 2] = E[8694], E[A + 28 >> 2] = I, I = E[8697], E[A + 32 >> 2] = E[8696], E[A + 36 >> 2] = I, I = E[8699], E[A + 40 >> 2] = E[8698], E[A + 44 >> 2] = I, I = E[8701], E[A + 48 >> 2] = E[8700], E[A + 52 >> 2] = I, I = E[8703], E[A + 56 >> 2] = E[8702], E[A + 60 >> 2] = I, 0;
                                    }
                                    function GI(A) {
                                        return ((127 & (-1 ^ a[A + 31 | 0]) | a[A + 1 | 0] & a[A + 2 | 0] & a[A + 3 | 0] & a[A + 4 | 0] & a[A + 5 | 0] & a[A + 6 | 0] & a[A + 7 | 0] & a[A + 8 | 0] & a[A + 9 | 0] & a[A + 10 | 0] & a[A + 11 | 0] & a[A + 12 | 0] & a[A + 13 | 0] & a[A + 14 | 0] & a[A + 15 | 0] & a[A + 16 | 0] & a[A + 17 | 0] & a[A + 18 | 0] & a[A + 19 | 0] & a[A + 20 | 0] & a[A + 21 | 0] & a[A + 22 | 0] & a[A + 23 | 0] & a[A + 24 | 0] & a[A + 25 | 0] & a[A + 26 | 0] & a[A + 27 | 0] & a[A + 28 | 0] & a[A + 30 | 0] & a[A + 29 | 0] ^ 255) - 1 & 236 - a[0 | A] ^ -1) >>> 8 & 1;
                                    }
                                    function MI(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, o[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], B = 1 | A, o[C + 7 | 0] = a[C + 7 | 0] | a[B + E[C + 12 >> 2] | 0] ^ a[E[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function bI(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, _ = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2704 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, o = g ^ a[I + 128 | 0] | o, E = g ^ a[I + 96 | 0] | E, _ = g ^ a[I - -64 | 0] | _, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | o)) - 1 | (255 & (122 ^ A | E)) - 1 | (255 & (5 ^ A | _)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function KI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), w = g | Q, A | i;
                                    }
                                    function HI(A, I, g, C, B, Q) {
                                        A |= 0, I |= 0, g |= 0;
                                        var i = 0, o = 0;
                                        A: I: {
                                            g: {
                                                if (!(!(B |= 0) & (C |= 0) >>> 0 < 64 || (o = 1 + (B = B - 1 | 0) | 0, i = B, !(C = (B = C + -64 | 0) >>> 0 < 4294967232 ? o : i) & B >>> 0 > 4294967231 | C))) {
                                                    if (!H(i = g, g = g - -64 | 0, B, C, Q |= 0, 0)) break g;
                                                    A && Hg(A, 0, B);
                                                }
                                                if (C = -1, !I) break I;
                                                E[I >> 2] = 0, E[I + 4 >> 2] = 0, C = -1;
                                                break A;
                                            }
                                            I && (E[I >> 2] = B, E[I + 4 >> 2] = C), C = 0, A && yg(A, g, B);
                                        }
                                        return 0 | C;
                                    }
                                    function YI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, Xg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), NC(t, 35648, 0 - i & 15, 0), NC(t, I, g, C), NC(t, 35648, 0 - g & 15, 0), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (gg(A, I, g, C, a, 1, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function dI(A, I, g, C, B, Q) {
                                        var i, o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, h = i = h - 32 | 0, o = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 24 >> 2] = 0, E[i + 28 >> 2] = 0, E[i + 16 >> 2] = o, E[i + 20 >> 2] = B, E[i + 8 >> 2] = 0, E[i + 12 >> 2] = 0, E[i >> 2] = g, E[i + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (E[9392] = 28, A = -1) : A = QA(A, I, 0, 0, 0, Q, 32, i, i + 16 | 0), h = i + 32 | 0, 0 | A;
                                    }
                                    function JI(A, I, g, C, B) {
                                        var Q, i;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 512 | 0, QI(i = Q + 32 | 0, B |= 0, 32), dC(i, I, g, C), fg(i, Q + 448 | 0), I = E[Q + 476 >> 2], E[Q + 24 >> 2] = E[Q + 472 >> 2], E[Q + 28 >> 2] = I, I = E[Q + 468 >> 2], E[Q + 16 >> 2] = E[Q + 464 >> 2], E[Q + 20 >> 2] = I, I = E[Q + 460 >> 2], E[Q + 8 >> 2] = E[Q + 456 >> 2], E[Q + 12 >> 2] = I, I = E[Q + 452 >> 2], E[Q >> 2] = E[Q + 448 >> 2], E[Q + 4 >> 2] = I, I = SC(A, Q), g = MI(Q, A, 32), h = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                    }
                                    function UI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, jg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), NC(t, I, g, C), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (Ug(A, I, g, C, a, 1, 0, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function lI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, Xg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), NC(r, 35648, 0 - o & 15, 0), gg(A, C, B, Q, _, 1, c), NC(r, A, B, Q), NC(r, 35648, 0 - B & 15, 0), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, A = t + 8 | 0, 8, 0), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, A, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function mI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        A: if (!(((g = a[0 | A]) - 58 & 255) >>> 0 < 246)) {
                                            for(C = g, B = A;;){
                                                if (i = B, Q >>> 0 > 429496729) break A;
                                                if ((C = (255 & C) - 48 | 0) >>> 0 > (-1 ^ (Q = c(Q, 10))) >>> 0) break A;
                                                if (Q = Q + C | 0, !(((C = a[0 | (B = B + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                            }
                                            48 == (0 | g) & (0 | A) != (0 | i) | (0 | A) == (0 | B) || (E[I >> 2] = Q, o = B);
                                        }
                                        return o;
                                    }
                                    function uI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        I = 65, g = 1024;
                                        A: {
                                            I: {
                                                if ((0 | (C = 255 & A)) != a[1024]) for(C = c(C, 16843009);;){
                                                    if ((-1 ^ (B = C ^ E[g >> 2])) & B - 16843009 & -2139062144) break I;
                                                    if (g = g + 4 | 0, !((I = I - 4 | 0) >>> 0 > 3)) break;
                                                }
                                                if (!I) break A;
                                            }
                                            for(A &= 255;;){
                                                if ((0 | A) == a[0 | g]) return g;
                                                if (g = g + 1 | 0, !(I = I - 1 | 0)) break;
                                            }
                                        }
                                        return 0;
                                    }
                                    function xI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, jg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, i = t + 8 | 0, 8, 0), Ug(A, C, B, Q, _, 1, 0, c), NC(r, A, B, Q), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, i, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function RI(A, I, g, C, B, Q) {
                                        return !C & g >>> 0 >= 32 | C ? (Gg(A, I, g, C, B, Q), hC(A + 16 | 0, A + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, A), o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, A = 0) : A = -1, A;
                                    }
                                    function vI(A, I, g, C, B, Q) {
                                        I |= 0, B |= 0, Q |= 0;
                                        var i, o = 0;
                                        return h = i = h - 16 | 0, n(A |= 0, i + 8 | 0, yg(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), E[i + 12 >> 2] | 64 != E[i + 8 >> 2] ? (I && (E[I >> 2] = 0, E[I + 4 >> 2] = 0), Hg(A, 0, C - -64 | 0), o = -1) : I && (E[I >> 2] = C - -64, E[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), h = i + 16 | 0, 0 | o;
                                    }
                                    function LI(A) {
                                        var I = 0, g = 0, C = 0;
                                        A: {
                                            I: if (3 & (I = A)) {
                                                if (!a[0 | I]) return 0;
                                                for(;;){
                                                    if (!(3 & (I = I + 1 | 0))) break I;
                                                    if (!a[0 | I]) break;
                                                }
                                                break A;
                                            }
                                            for(; g = I, I = I + 4 | 0, !((-1 ^ (C = E[g >> 2])) & C - 16843009 & -2139062144););
                                            for(; g = (I = g) + 1 | 0, a[0 | I];);
                                        }
                                        return I - A | 0;
                                    }
                                    function PI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0;
                                        return (g = uI(a[0 | I])) && (C = uI(a[I + 1 | 0])) && (B = uI(a[I + 2 | 0])) && (Q = uI(a[I + 3 | 0])) && (i = uI(a[I + 4 | 0])) ? (E[A >> 2] = g - 1024 | C - 1024 << 6 | B - 1024 << 12 | Q - 1024 << 18 | i - 1024 << 24, I + 5 | 0) : (E[A >> 2] = 0, 0);
                                    }
                                    function qI(A, I, g) {
                                        var C;
                                        for(E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, E[C + 4 >> 2] = 0; E[C + 4 >> 2] = E[C + 4 >> 2] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], I = 1 | A, E[C + 4 >> 2] = E[C + 4 >> 2] | a[I + E[C + 12 >> 2] | 0] ^ a[I + E[C + 8 >> 2] | 0], (0 | g) != (0 | (A = A + 2 | 0)););
                                        return (E[C + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function zI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t = 0, r = 0, e = 0;
                                        return r = -1, (t = C >>> 0 < 32) & !B || !(t = B - t | 0) & (e = C - 32 | 0) >>> 0 > 4294967263 | t | !o & i >>> 0 > 4294967263 | o || (r = 0 | pB[E[c >> 2]](A, g, e, (g + C | 0) - 32 | 0, 32, Q, i, a, _)), I && (E[I >> 2] = r ? 0 : C - 32 | 0, E[I + 4 >> 2] = r ? 0 : B - (C >>> 0 < 32) | 0), r;
                                    }
                                    function jI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        h = g = h - 896 | 0, pA(C = g + 848 | 0, I), pA(B = g + 800 | 0, I + 32 | 0), T(Q = g + 320 | 0, C), T(I = g + 160 | 0, B), TA(C = g + 640 | 0, I), sA(I = g + 480 | 0, Q, C), Y(g, I, C = g + 600 | 0), Y(g + 40 | 0, B = g + 520 | 0, Q = g + 560 | 0), Y(g + 80 | 0, Q, C), Y(g + 120 | 0, I, B), O(A, g), h = g + 896 | 0;
                                    }
                                    function XI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, o[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function OI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? (!Q & B >>> 0 >= 3 | 0 != (0 | Q)) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 1) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function VI(A, I) {
                                        var g = 0;
                                        4 & I && ((I = E[A >> 2]) && XC(E[I + 4 >> 2], E[A + 16 >> 2] << 10), (I = E[A + 4 >> 2]) && XC(I, E[A + 20 >> 2] << 3)), gA(E[A + 4 >> 2]), E[A + 4 >> 2] = 0, (I = E[A >> 2]) && (g = E[I >> 2]) && gA(g), gA(I), E[A >> 2] = 0;
                                    }
                                    function ZI(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0;
                                        for(I = 32, g = 1; E = (B = a[(C = I - 2 | 0) + A | 0]) - (Q = a[C + 2928 | 0]) >> 8 & (I = ((i = a[2928 + (I = I - 1 | 0) | 0]) ^ (o = a[A + I | 0])) - 1 >> 8 & g) | 255 & (o - i >>> 8 & g | E), g = I & (B ^ Q) - 1 >> 8, I = C;);
                                        return 0 != (255 & E);
                                    }
                                    function WI(A, I, g, C, B, i, o, a, _, c, t) {
                                        return !B & C >>> 0 > 4294967263 | 0 != (0 | B) | !a & o >>> 0 >= 4294967264 | 0 != (0 | a) ? (yC(), Q()) : (A = 0 | pB[E[t >> 2]](A, A + C | 0, 32, g, C, i, o, _, c), I && (C = (g = C + 32 | 0) >>> 0 < 32 ? B + 1 | 0 : B, E[I >> 2] = A ? 0 : g, E[I + 4 >> 2] = A ? 0 : C)), A;
                                    }
                                    function TI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? !!(B | Q) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 2) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function $I(A) {
                                        var I = 0;
                                        return E[32 + (A |= 0) >> 2] = 0, E[A + 36 >> 2] = 0, I = E[8601], E[A >> 2] = E[8600], E[A + 4 >> 2] = I, I = E[8603], E[A + 8 >> 2] = E[8602], E[A + 12 >> 2] = I, I = E[8605], E[A + 16 >> 2] = E[8604], E[A + 20 >> 2] = I, I = E[8607], E[A + 24 >> 2] = E[8606], E[A + 28 >> 2] = I, 0;
                                    }
                                    function Ag(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0;
                                        return h = o = h + -64 | 0, a = -1, (E = g >>> 0 < 16) & !C || gI(_ = o + 32 | 0, i, Q) || yA(o, 35584, _, 0) || (a = hI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o - -64 | 0, a;
                                    }
                                    function Ig(A, I, g, C) {
                                        var B, Q, i, o, E = 0, a = 0;
                                        return o = c(E = g >>> 16 | 0, a = A >>> 16 | 0), E = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(E, Q) | 0, w = (c(I, g) + o | 0) + c(A, C) + (a >>> 16) + (E >>> 16) | 0, 65535 & i | E << 16;
                                    }
                                    function gg(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0;
                                        if (a = C, !(1 == (((a = (_ = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | _ >>> 6))) | 0) & i >>> 0 > (_ = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1)) return 0 | pB[E[8928]](A, I, g, C, B, i, o);
                                        yC(), Q();
                                    }
                                    function Cg(A, I, g) {
                                        var C = 0, B = 0;
                                        if (!g) return 0;
                                        if (C = a[0 | A]) A: {
                                            for(;;){
                                                if ((0 | (B = a[0 | I])) != (0 | C) | !B) break A;
                                                if (!(g = g - 1 | 0)) break A;
                                                if (I = I + 1 | 0, C = a[A + 1 | 0], A = A + 1 | 0, !C) break;
                                            }
                                            C = 0;
                                        }
                                        else C = 0;
                                        return C - a[0 | I] | 0;
                                    }
                                    function Bg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = wI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function Qg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = RI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function ig(A, I, g, C, B, i, o) {
                                        var E;
                                        if (h = E = h + -64 | 0, !C & g >>> 0 < 4294967280) return gI(E + 32 | 0, o, i) ? o = -1 : (o = -1, yA(E, 35584, E + 32 | 0, 0) || (o = rI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32))), h = E - -64 | 0, o;
                                        yC(), Q();
                                    }
                                    function og(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; C = A + B | 0, g = a[I + B | 0] + (a[0 | C] + g | 0) | 0, o[0 | C] = g, Q = (C = 1 | B) + A | 0, g = a[I + C | 0] + (a[0 | Q] + (g >>> 8 | 0) | 0) | 0, o[0 | Q] = g, g = g >>> 8 | 0, B = B + 2 | 0, 32 != (0 | (i = i + 2 | 0)););
                                    }
                                    function Eg(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; g = (a[0 | (C = A + B | 0)] - a[I + B | 0] | 0) + g | 0, o[0 | C] = g, g = (a[0 | (Q = (C = 1 | B) + A | 0)] - a[I + C | 0] | 0) + (g >> 8) | 0, o[0 | Q] = g, g >>= 8, B = B + 2 | 0, 64 != (0 | (i = i + 2 | 0)););
                                    }
                                    function ag(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (h = g = h - 16 | 0, I |= 0) for(; o[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(36800, g + 15 | 0, 0), o[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        h = g + 16 | 0;
                                    }
                                    function _g(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0;
                                        return h = o = h - 32 | 0, a = -1, (E = g >>> 0 < 16) & !C || cC(o, Q, i) || (a = yI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o + 32 | 0, a;
                                    }
                                    function cg(A) {
                                        var I, g;
                                        return (A = (I = E[8924]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > wB() << 16 >>> 0 && !(0 | s(0 | A)) ? (E[9392] = 48, -1) : (E[8924] = A, I);
                                    }
                                    function tg(A, I) {
                                        var g, C, B;
                                        h = g = h - 176 | 0, vA(C = g + 96 | 0, I + 80 | 0), Y(B = g + 48 | 0, I, C), Y(g, I + 40 | 0, C), BI(A, g), BI(g + 144 | 0, B), o[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, h = g + 176 | 0;
                                    }
                                    function rg(A, I, g, C, B, Q, i, o, E, a) {
                                        var _, c, t = 0, r = 0, e = 0;
                                        return h = _ = h - 16 | 0, t = -1, _C(c = _ + 4 | 0) || (r = -1, e = _A(c, A, I, g, C, B, Q, i, o, E, a), t = vg(c) ? r : e), h = _ + 16 | 0, t;
                                    }
                                    function eg(A, I, g, C, B, i, o, a, _, c, t, r) {
                                        return g && (E[g >> 2] = 32, E[g + 4 >> 2] = 0), !_ & a >>> 0 < 4294967264 & !i & B >>> 0 <= 4294967263 || (yC(), Q()), 0 | pB[E[r >> 2]](A, I, 32, C, B, o, a, c, t);
                                    }
                                    function yg(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return Sg(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, o[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function sg(A, I, g, C, B, i, o) {
                                        var E, a = 0;
                                        if (h = E = h - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, cC(E, i, o) || (a = eI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32)), h = E + 32 | 0, a;
                                        yC(), Q();
                                    }
                                    function hg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? yI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function Dg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? hI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function pg(A, I, g, C, B, Q, i, o, a, _, c) {
                                        return !C & g >>> 0 > 4294967263 | C | !o & i >>> 0 > 4294967263 | o ? -1 : 0 | pB[E[c >> 2]](A, I, g, B, 32, Q, i, a, _);
                                    }
                                    function wg(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = fA(A, 35664, C, 0)), h = C + 32 | 0, 0 | B;
                                    }
                                    function fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h + -64 | 0, z(A |= 0, g), nA(A = A + 208 | 0, g, 64, 0), z(A, I), XC(g, 64), h = g - -64 | 0, 0;
                                    }
                                    function ng(A, I, g, C) {
                                        var B;
                                        return I |= 0, g |= 0, C |= 0, h = B = h + -64 | 0, z(A |= 0, B), A = n(I, g, B, 64, 0, C, 1), h = B - -64 | 0, 0 | A;
                                    }
                                    function kg(A, I) {
                                        var g, C, B;
                                        Y(A, I, g = I + 120 | 0), Y(A + 40 | 0, C = I + 40 | 0, B = I + 80 | 0), Y(A + 80 | 0, B, g), Y(A + 120 | 0, I, C);
                                    }
                                    function Fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h - 32 | 0, dA(A |= 0, g), MA(A = A + 104 | 0, g, 32, 0), dA(A, I), XC(g, 32), h = g + 32 | 0, 0;
                                    }
                                    function Ng(A, I, g, C, B, Q, i) {
                                        return 0 | TI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                    }
                                    function Sg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Gg(A, I, g, C, B, Q) {
                                        var i;
                                        return h = i = h - 32 | 0, fA(i, B, Q, 0), A = oC(A, I, g, C, B + 16 | 0, 0, 0, i), XC(i, 32), h = i + 32 | 0, A;
                                    }
                                    function Mg(A) {
                                        for(A |= 0; ag(A, 32), o[A + 31 | 0] = 31 & a[A + 31 | 0], !ZI(A) || NI(A, 32););
                                    }
                                    function bg(A, I, g) {
                                        var C;
                                        return I |= 0, g |= 0, h = C = h + -64 | 0, z(A |= 0, C), A = H(I, C, 64, 0, g, 1), h = C - -64 | 0, 0 | A;
                                    }
                                    function Kg(A, I, g, C, B) {
                                        var Q;
                                        return h = Q = h - 32 | 0, fA(Q, C, B, 0), A = pC(A, I, g, C + 16 | 0, Q), XC(Q, 32), h = Q + 32 | 0, A;
                                    }
                                    function Hg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Yg(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (e(1349, 1262, 107, 1123), Q()), 0 | $(A, I, 255 & g);
                                    }
                                    function dg(A, I, g, C, B, Q, i) {
                                        return 0 | eI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Jg(A, I, g, C, B, Q, i) {
                                        return 0 | yI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Ug(A, I, g, C, B, i, o, a) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, i, o, a);
                                    }
                                    function lg(A, I, g, C, B, Q, i) {
                                        return 0 | rI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function mg(A, I, g, C, B, Q, i) {
                                        return 0 | hI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function ug(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, 0, 0, i);
                                    }
                                    function xg(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8928]](A, I, g, C, B, 0, i);
                                    }
                                    function Rg(A, I, g, C, B, Q) {
                                        return n(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                    }
                                    function vg(A) {
                                        var I;
                                        return (I = E[A >> 2]) && gA(I), E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function Lg(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function Pg(A, I, g, C, B, Q) {
                                        return 0 | RI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function qg(A, I, g, C, B, Q) {
                                        return 0 | wI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function zg(A, I, g, C, B, Q) {
                                        return 0 | Gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function jg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8925]](A, I, g, C, B);
                                    }
                                    function Xg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8926]](A, I, g, C, B);
                                    }
                                    function Og(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), pB[E[8928]](A, I, g, C, B, 1, i);
                                    }
                                    function Vg(A, I, g, C, B) {
                                        return 0 | H(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                    }
                                    function Zg(A, I, g, C, B) {
                                        return 0 | hC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Wg(A, I, g, C, B) {
                                        return 0 | DC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Tg(A, I, g, C, B) {
                                        return 0 | Kg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function $g() {
                                        var A;
                                        h = A = h - 16 | 0, o[A + 15 | 0] = 0, r(36836, A + 15 | 0, 0), h = A + 16 | 0;
                                    }
                                    function AC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 20), 0;
                                    }
                                    function IC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 12), 0;
                                    }
                                    function gC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 8), 0;
                                    }
                                    function CC(A, I, g, C) {
                                        return 0 | kI(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function BC(A, I, g, C) {
                                        return 0 | NC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function QC(A, I, g, C) {
                                        return 0 | nA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function iC(A, I, g, C) {
                                        return 0 | eA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function oC(A, I, g, C, B, Q, i, o) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, Q, i, o);
                                    }
                                    function EC(A, I, g, C) {
                                        return 0 | dC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function aC(A, I, g, C, B, Q) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function _C(A) {
                                        return E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function cC(A, I, g) {
                                        return 0 | wg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function tC(A, I, g) {
                                        return 0 | gI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function rC(A, I, g) {
                                        return 0 | Yg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function eC(A, I, g) {
                                        return 0 | QI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function yC() {
                                        var A;
                                        (A = E[9526]) && pB[0 | A](), y(), Q();
                                    }
                                    function sC(A, I) {
                                        return A |= 0, ag(I |= 0, 32), 0 | wC(A, I);
                                    }
                                    function hC(A, I, g, C, B) {
                                        return 0 | pB[E[8929]](A, I, g, C, B);
                                    }
                                    function DC(A, I, g, C, B) {
                                        return 0 | pB[E[8930]](A, I, g, C, B);
                                    }
                                    function pC(A, I, g, C, B) {
                                        return 0 | pB[E[8936]](A, I, g, C, B);
                                    }
                                    function wC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8935]](A, I);
                                    }
                                    function fC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8931]](A, I);
                                    }
                                    function nC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8933]](A, I);
                                    }
                                    function kC(A, I, g, C, B, Q, i) {
                                        return lA(A, I, g, C, B, Q, i);
                                    }
                                    function FC(A) {
                                        return A ? 31 - t(A - 1 ^ A) | 0 : 32;
                                    }
                                    function NC(A, I, g, C) {
                                        return 0 | pB[E[8932]](A, I, g, C);
                                    }
                                    function SC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 32);
                                    }
                                    function GC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 64);
                                    }
                                    function MC(A, I, g) {
                                        k(A |= 0, I |= 0, g |= 0);
                                    }
                                    function bC(A, I) {
                                        return 0 | wC(A |= 0, I |= 0);
                                    }
                                    function KC(A, I) {
                                        return 0 | sC(A |= 0, I |= 0);
                                    }
                                    function HC(A, I, g, C) {
                                        return CI(A, I, g, C, 2);
                                    }
                                    function YC(A, I, g, C) {
                                        return MA(A, I, g, C), 0;
                                    }
                                    function dC(A, I, g, C) {
                                        return nA(A, I, g, C), 0;
                                    }
                                    function JC(A, I, g, C) {
                                        return CI(A, I, g, C, 1);
                                    }
                                    function UC(A, I, g, C) {
                                        return nI(A, I, g, C, 1);
                                    }
                                    function lC(A, I, g, C) {
                                        return nI(A, I, g, C, 2);
                                    }
                                    function mC(A, I, g, C) {
                                        return XA(A, I, g, C);
                                    }
                                    function uC(A) {
                                        return SI(A |= 0), 0;
                                    }
                                    function xC() {
                                        return 1073741824;
                                    }
                                    function RC() {
                                        return -2147483648;
                                    }
                                    function vC() {
                                        return 268435456;
                                    }
                                    function LC(A) {
                                        ag(A |= 0, 32);
                                    }
                                    function PC() {
                                        return 67108864;
                                    }
                                    function qC(A) {
                                        ag(A |= 0, 16);
                                    }
                                    function zC() {
                                        return 16777216;
                                    }
                                    function jC() {
                                        return 33554432;
                                    }
                                    function XC(A, I) {
                                        Hg(A, 0, I);
                                    }
                                    function OC() {
                                        return 1559;
                                    }
                                    function VC() {
                                        return 1321;
                                    }
                                    function ZC() {
                                        return 8192;
                                    }
                                    function WC() {
                                        return 384;
                                    }
                                    function TC() {
                                        return 416;
                                    }
                                    function $C() {
                                        return 256;
                                    }
                                    function AB() {
                                        return 128;
                                    }
                                    function IB() {
                                        return 208;
                                    }
                                    function gB() {
                                        return 64;
                                    }
                                    function CB() {
                                        return 16;
                                    }
                                    function BB() {
                                        return 32;
                                    }
                                    function QB() {
                                        return 12;
                                    }
                                    function iB() {
                                        return -65;
                                    }
                                    function oB() {
                                        return -17;
                                    }
                                    function EB() {
                                        return 48;
                                    }
                                    function aB() {
                                        return -33;
                                    }
                                    function _B() {
                                        return 24;
                                    }
                                    function cB() {
                                        return 4;
                                    }
                                    function tB() {
                                        return -1;
                                    }
                                    function rB() {
                                        return 1;
                                    }
                                    function eB() {
                                        return 2;
                                    }
                                    function yB() {
                                        return 3;
                                    }
                                    function sB() {
                                        return 8;
                                    }
                                    function hB() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOQBobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), B(I, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), B(I, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2736, "AQ=="), B(I, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2959, "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"), B(I, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), B(I, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), B(I, 34160, "AQ=="), B(I, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 34383, "EA=="), B(I, 34400, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34752, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35696, "4JQBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0="), B(I, 35760, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOg4AAAAPAAAAEAAAABE=");
                                    var DB, pB = (DB = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o) {
                                            var _;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, h = _ = h + -64 | 0, (g |= 0) | (C |= 0) && (E[_ + 8 >> 2] = 2036477234, E[_ + 12 >> 2] = 1797285236, E[_ >> 2] = 1634760805, E[_ + 4 >> 2] = 857760878, E[_ + 16 >> 2] = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, E[_ + 20 >> 2] = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, E[_ + 24 >> 2] = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, E[_ + 28 >> 2] = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, E[_ + 32 >> 2] = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, E[_ + 36 >> 2] = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, E[_ + 40 >> 2] = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[_ + 44 >> 2] = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, E[_ + 48 >> 2] = Q, E[_ + 52 >> 2] = i, E[_ + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[_ + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, q(_, I, A, g, C), XC(_, 64)), h = _ - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var o;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, h = o = h + -64 | 0, (g |= 0) | (C |= 0) && (E[o + 8 >> 2] = 2036477234, E[o + 12 >> 2] = 1797285236, E[o >> 2] = 1634760805, E[o + 4 >> 2] = 857760878, E[o + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, E[o + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, E[o + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, E[o + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, E[o + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, E[o + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, E[o + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, E[o + 48 >> 2] = Q, E[o + 44 >> 2] = i, E[o + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[o + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[o + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, q(o, I, A, g, C), XC(o, 64)), h = o - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 128 & -64, E[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 20 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 16 >> 2] = _ >>> 8 & 1048575, E[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 80 | 0] = 0, E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = B, uA(Q, I, g, C), II(Q, A), h = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 192 & -64, E[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 84 >> 2] = 0, E[Q + 88 >> 2] = 0, E[Q + 92 >> 2] = 0, E[Q + 96 >> 2] = 0, E[Q + 100 >> 2] = 0, E[Q + 80 >> 2] = _ >>> 8 & 1048575, E[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 144 | 0] = 0, E[Q + 120 >> 2] = 0, E[Q + 124 >> 2] = 0, E[Q + 116 >> 2] = B, uA(B = Q - -64 | 0, I, g, C), II(B, I = Q + 48 | 0), A = iI(A, I), h = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, E[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, E[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, E[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 16 >> 2] = g >>> 8 & 1048575, E[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[A + 80 | 0] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return uA(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return II(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, wA = 0, fA = 0, nA = 0, kA = 0;
                                            for(h = C = h - 368 | 0; D = (i = a[g + B | 0]) ^ a[0 | (c = B + 34128 | 0)] | D, s = i ^ a[c + 192 | 0] | s, y = i ^ a[c + 160 | 0] | y, e = i ^ a[c + 128 | 0] | e, _ = i ^ a[c + 96 | 0] | _, t = i ^ a[c - -64 | 0] | t, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | s)) - 1 | (255 & (i | y)) - 1 | (255 & (i | e)) - 1 | (255 & (87 ^ c | _)) - 1 | (255 & (t | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | D)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[C + 336 >> 2] = I, E[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[C + 348 >> 2] = Q, o[C + 336 | 0] = 248 & I, o[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, pA(C + 288 | 0, g), E[C + 260 >> 2] = 0, E[C + 264 >> 2] = 0, E[C + 268 >> 2] = 0, E[C + 272 >> 2] = 0, E[C + 276 >> 2] = 0, E[C + 208 >> 2] = 0, E[C + 212 >> 2] = 0, E[C + 216 >> 2] = 0, E[C + 220 >> 2] = 0, E[C + 224 >> 2] = 0, E[C + 228 >> 2] = 0, I = E[C + 308 >> 2], E[C + 160 >> 2] = E[C + 304 >> 2], E[C + 164 >> 2] = I, I = E[C + 316 >> 2], E[C + 168 >> 2] = E[C + 312 >> 2], E[C + 172 >> 2] = I, I = E[C + 324 >> 2], E[C + 176 >> 2] = E[C + 320 >> 2], E[C + 180 >> 2] = I, E[C + 244 >> 2] = 0, E[C + 248 >> 2] = 0, E[C + 240 >> 2] = 1, E[C + 252 >> 2] = 0, E[C + 256 >> 2] = 0, E[C + 192 >> 2] = 0, E[C + 196 >> 2] = 0, E[C + 200 >> 2] = 0, E[C + 204 >> 2] = 0, I = E[C + 292 >> 2], E[C + 144 >> 2] = E[C + 288 >> 2], E[C + 148 >> 2] = I, I = E[C + 300 >> 2], E[C + 152 >> 2] = E[C + 296 >> 2], E[C + 156 >> 2] = I, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 96 >> 2] = 1, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, g = 254; W = E[C + 276 >> 2], i = E[C + 180 >> 2], T = E[C + 96 >> 2], $ = E[C + 192 >> 2], AA = E[C + 144 >> 2], IA = E[C + 240 >> 2], gA = E[C + 100 >> 2], CA = E[C + 196 >> 2], BA = E[C + 148 >> 2], QA = E[C + 244 >> 2], K = E[C + 104 >> 2], iA = E[C + 200 >> 2], H = E[C + 152 >> 2], oA = E[C + 248 >> 2], U = E[C + 108 >> 2], EA = E[C + 204 >> 2], l = E[C + 156 >> 2], aA = E[C + 252 >> 2], d = E[C + 112 >> 2], _A = E[C + 208 >> 2], M = E[C + 160 >> 2], cA = E[C + 256 >> 2], D = E[C + 116 >> 2], tA = E[C + 212 >> 2], r = E[C + 164 >> 2], rA = E[C + 260 >> 2], s = E[C + 120 >> 2], eA = E[C + 216 >> 2], y = E[C + 168 >> 2], yA = E[C + 264 >> 2], e = E[C + 124 >> 2], sA = E[C + 220 >> 2], _ = E[C + 172 >> 2], hA = E[C + 268 >> 2], t = E[C + 128 >> 2], DA = E[C + 224 >> 2], Q = E[C + 176 >> 2], G = E[C + 272 >> 2], wA = g, b = (F = (I = 0 - ((I = Z) ^ (Z = a[(fA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = E[C + 132 >> 2]) ^ (j = E[C + 228 >> 2]))) ^ B, E[C + 132 >> 2] = b, X = i ^ (N = I & (i ^ W)), E[C + 84 >> 2] = X - b, J = t ^ (f = I & (t ^ DA)), E[C + 128 >> 2] = J, O = (S = I & (Q ^ G)) ^ Q, E[C + 80 >> 2] = O - J, u = e ^ (n = I & (e ^ sA)), E[C + 124 >> 2] = u, nA = _ ^ (k = I & (_ ^ hA)), E[C + 76 >> 2] = nA - u, x = s ^ (p = I & (s ^ eA)), E[C + 120 >> 2] = x, kA = y ^ (c = I & (y ^ yA)), E[C + 72 >> 2] = kA - x, R = D ^ (i = I & (D ^ tA)), E[C + 116 >> 2] = R, L = r ^ (D = I & (r ^ rA)), E[C + 68 >> 2] = L - R, P = d ^ (s = I & (d ^ _A)), E[C + 112 >> 2] = P, m = M ^ (y = I & (M ^ cA)), E[C + 64 >> 2] = m - P, q = U ^ (e = I & (U ^ EA)), E[C + 108 >> 2] = q, V = l ^ (_ = I & (l ^ aA)), E[C + 60 >> 2] = V - q, z = K ^ (t = I & (K ^ iA)), E[C + 104 >> 2] = z, U = H ^ (Q = I & (H ^ oA)), E[C + 56 >> 2] = U - z, K = gA ^ (B = I & (gA ^ CA)), E[C + 100 >> 2] = K, l = BA ^ (g = I & (BA ^ QA)), E[C + 52 >> 2] = l - K, H = T ^ (d = I & (T ^ $)), E[C + 96 >> 2] = H, M = (I &= AA ^ IA) ^ AA, E[C + 48 >> 2] = M - H, r = N ^ W, F ^= j, E[C + 36 >> 2] = r - F, N = S ^ G, f ^= DA, E[C + 32 >> 2] = N - f, S = k ^ hA, n ^= sA, E[C + 28 >> 2] = S - n, k = c ^ yA, p ^= eA, E[C + 24 >> 2] = k - p, c = D ^ rA, i ^= tA, E[C + 20 >> 2] = c - i, D = y ^ cA, s ^= _A, E[C + 16 >> 2] = D - s, y = _ ^ aA, e ^= EA, E[C + 12 >> 2] = y - e, _ = Q ^ oA, t ^= iA, E[C + 8 >> 2] = _ - t, Q = g ^ QA, B ^= CA, E[C + 4 >> 2] = Q - B, g = I ^ IA, I = d ^ $, E[C >> 2] = g - I, E[C + 276 >> 2] = r + F, E[C + 272 >> 2] = N + f, E[C + 268 >> 2] = n + S, E[C + 264 >> 2] = p + k, E[C + 260 >> 2] = i + c, E[C + 256 >> 2] = s + D, E[C + 248 >> 2] = _ + t, E[C + 244 >> 2] = B + Q, E[C + 240 >> 2] = I + g, E[C + 252 >> 2] = e + y, E[C + 228 >> 2] = b + X, E[C + 224 >> 2] = J + O, E[C + 220 >> 2] = u + nA, E[C + 216 >> 2] = x + kA, E[C + 212 >> 2] = R + L, E[C + 208 >> 2] = m + P, E[C + 204 >> 2] = q + V, E[C + 200 >> 2] = U + z, E[C + 196 >> 2] = K + l, E[C + 192 >> 2] = M + H, Y(X = C + 96 | 0, J = C + 48 | 0, b = C + 240 | 0), Y(G = C + 192 | 0, G, C), v(J, C), v(C, b), r = E[C + 192 >> 2], F = E[C + 96 >> 2], N = E[C + 196 >> 2], f = E[C + 100 >> 2], S = E[C + 200 >> 2], n = E[C + 104 >> 2], k = E[C + 204 >> 2], p = E[C + 108 >> 2], c = E[C + 208 >> 2], i = E[C + 112 >> 2], D = E[C + 212 >> 2], s = E[C + 116 >> 2], y = E[C + 216 >> 2], e = E[C + 120 >> 2], _ = E[C + 220 >> 2], t = E[C + 124 >> 2], Q = E[C + 224 >> 2], B = E[C + 128 >> 2], g = E[C + 228 >> 2], I = E[C + 132 >> 2], E[C + 180 >> 2] = g + I, E[C + 176 >> 2] = B + Q, E[C + 172 >> 2] = _ + t, E[C + 168 >> 2] = e + y, E[C + 164 >> 2] = s + D, E[C + 160 >> 2] = i + c, E[C + 156 >> 2] = p + k, E[C + 152 >> 2] = n + S, E[C + 148 >> 2] = N + f, E[C + 144 >> 2] = r + F, E[C + 228 >> 2] = I - g, E[C + 224 >> 2] = B - Q, E[C + 220 >> 2] = t - _, E[C + 216 >> 2] = e - y, E[C + 212 >> 2] = s - D, E[C + 208 >> 2] = i - c, E[C + 204 >> 2] = p - k, E[C + 200 >> 2] = n - S, E[C + 196 >> 2] = f - N, E[C + 192 >> 2] = F - r, Y(b, C, J), u = E[C + 52 >> 2], p = E[C + 4 >> 2], x = E[C + 56 >> 2], c = E[C + 8 >> 2], R = E[C + 64 >> 2], y = E[C + 16 >> 2], P = E[C + 60 >> 2], e = E[C + 12 >> 2], q = E[C + 72 >> 2], _ = E[C + 24 >> 2], z = E[C + 68 >> 2], t = E[C + 20 >> 2], K = E[C + 80 >> 2], Q = E[C + 32 >> 2], H = E[C + 76 >> 2], B = E[C + 28 >> 2], j = E[C + 84 >> 2], I = E[C + 36 >> 2], O = E[C + 48 >> 2], g = E[C >> 2] - O | 0, E[C >> 2] = g, I = I - j | 0, E[C + 36 >> 2] = I, d = B - H | 0, E[C + 28 >> 2] = d, M = Q - K | 0, E[C + 32 >> 2] = M, i = t - z | 0, E[C + 20 >> 2] = i, D = _ - q | 0, E[C + 24 >> 2] = D, s = e - P | 0, E[C + 12 >> 2] = s, y = y - R | 0, E[C + 16 >> 2] = y, e = c - x | 0, E[C + 8 >> 2] = e, Q = p - u | 0, E[C + 4 >> 2] = Q, v(G, G), I = Ig(I, I >> 31, 121666, 0), B = w, V = I, I = Ig((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), t = w, B = I, I = Ig(g, g >> 31, 121666, 0), m = w + t | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? m + 1 | 0 : m, g = (_ = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, F = B - (-67108864 & _) | 0, E[C + 96 >> 2] = F, t = Ig(Q, Q >> 31, 121666, 0), B = w, B = (Q = t + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, N = (t - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | _ >>> 26) | 0, E[C + 100 >> 2] = N, m = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = Ig(e, e >> 31, 121666, 0) + B | 0, I = m + w | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = (f = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, S = g - (-67108864 & f) | 0, E[C + 104 >> 2] = S, B = Ig(y, y >> 31, 121666, 0), Q = w, g = Ig(s, s >> 31, 121666, 0), I = w, L = B, U = g, B = (33554431 & (I = (n = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | n >>> 25, I = (I >> 25) + Q | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, E[C + 112 >> 2] = p, B = Ig(D, D >> 31, 121666, 0), _ = w, g = Ig(i, i >> 31, 121666, 0), I = w, L = B, l = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + _ | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = g - (-67108864 & i) | 0, E[C + 120 >> 2] = D, _ = Ig(M, M >> 31, 121666, 0), e = w, g = Ig(d, d >> 31, 121666, 0), I = w, M = g, g = (33554431 & (I = (s = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | s >>> 25, I = (I >> 25) + e | 0, I = g >>> 0 > (_ = g + _ | 0) >>> 0 ? I + 1 | 0 : I, g = (y = _ + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, e = _ - (-67108864 & y) | 0, E[C + 128 >> 2] = e, _ = (t = U + ((67108863 & t) << 6 | f >>> 26) | 0) - (-33554432 & n) | 0, E[C + 108 >> 2] = _, t = (Q = l + ((67108863 & Q) << 6 | k >>> 26) | 0) - (-33554432 & c) | 0, E[C + 116 >> 2] = t, Q = (I = M + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & s) | 0, E[C + 124 >> 2] = Q, g = (g = V + ((67108863 & g) << 6 | y >>> 26) | 0) - (-33554432 & r) | 0, E[C + 132 >> 2] = g, v(I = C + 144 | 0, I), E[C + 84 >> 2] = g + j, E[C + 80 >> 2] = e + K, E[C + 76 >> 2] = Q + H, E[C + 72 >> 2] = D + q, E[C + 68 >> 2] = t + z, E[C + 64 >> 2] = p + R, E[C + 60 >> 2] = _ + P, E[C + 56 >> 2] = S + x, E[C + 52 >> 2] = N + u, E[C + 48 >> 2] = F + O, g = wA - 1 | 0, Y(X, C + 288 | 0, G), Y(G, C, J), wA;);
                                                D = E[C + 144 >> 2], F = E[C + 240 >> 2], s = E[C + 148 >> 2], N = E[C + 244 >> 2], y = E[C + 152 >> 2], f = E[C + 248 >> 2], e = E[C + 156 >> 2], S = E[C + 252 >> 2], _ = E[C + 160 >> 2], n = E[C + 256 >> 2], t = E[C + 164 >> 2], k = E[C + 260 >> 2], Q = E[C + 168 >> 2], p = E[C + 264 >> 2], B = E[C + 172 >> 2], c = E[C + 268 >> 2], g = E[C + 176 >> 2], i = E[C + 272 >> 2], r = 0 - Z | 0, I = E[C + 276 >> 2], E[C + 276 >> 2] = r & (I ^ E[C + 180 >> 2]) ^ I, E[C + 272 >> 2] = i ^ r & (g ^ i), E[C + 268 >> 2] = c ^ r & (B ^ c), E[C + 264 >> 2] = p ^ r & (Q ^ p), E[C + 260 >> 2] = k ^ r & (t ^ k), E[C + 256 >> 2] = n ^ r & (_ ^ n), E[C + 252 >> 2] = S ^ r & (e ^ S), E[C + 248 >> 2] = f ^ r & (y ^ f), E[C + 244 >> 2] = N ^ r & (s ^ N), E[C + 240 >> 2] = F ^ r & (D ^ F), F = E[C + 192 >> 2], D = E[C + 96 >> 2], N = E[C + 196 >> 2], s = E[C + 100 >> 2], f = E[C + 200 >> 2], y = E[C + 104 >> 2], S = E[C + 204 >> 2], e = E[C + 108 >> 2], n = E[C + 208 >> 2], _ = E[C + 112 >> 2], k = E[C + 212 >> 2], t = E[C + 116 >> 2], p = E[C + 216 >> 2], Q = E[C + 120 >> 2], c = E[C + 220 >> 2], B = E[C + 124 >> 2], i = E[C + 224 >> 2], g = E[C + 128 >> 2], I = E[C + 228 >> 2], E[C + 228 >> 2] = r & (I ^ E[C + 132 >> 2]) ^ I, E[C + 224 >> 2] = i ^ r & (g ^ i), E[C + 220 >> 2] = c ^ r & (B ^ c), E[C + 216 >> 2] = p ^ r & (Q ^ p), E[C + 212 >> 2] = k ^ r & (t ^ k), E[C + 208 >> 2] = n ^ r & (_ ^ n), E[C + 204 >> 2] = S ^ r & (e ^ S), E[C + 200 >> 2] = f ^ r & (y ^ f), E[C + 196 >> 2] = N ^ r & (s ^ N), E[C + 192 >> 2] = F ^ r & (D ^ F), vA(G, G), Y(b, b, G), BI(A, b), XC(fA, 32), B = 0;
                                            }
                                            return h = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N;
                                            return I |= 0, h = g = h - 304 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], o[0 | A] = 248 & a[0 | A], o[A + 31 | 0] = 63 & I | 64, kA(g + 48 | 0, A), I = E[g + 132 >> 2], C = E[g + 92 >> 2], B = E[g + 136 >> 2], Q = E[g + 96 >> 2], i = E[g + 140 >> 2], _ = E[g + 100 >> 2], c = E[g + 144 >> 2], t = E[g + 104 >> 2], r = E[g + 148 >> 2], e = E[g + 108 >> 2], y = E[g + 152 >> 2], s = E[g + 112 >> 2], D = E[g + 156 >> 2], p = E[g + 116 >> 2], w = E[g + 160 >> 2], f = E[g + 120 >> 2], n = E[g + 128 >> 2], k = E[g + 88 >> 2], F = E[g + 124 >> 2], N = E[g + 164 >> 2], E[g + 292 >> 2] = F + N, E[g + 288 >> 2] = w + f, E[g + 284 >> 2] = D + p, E[g + 280 >> 2] = y + s, E[g + 276 >> 2] = r + e, E[g + 272 >> 2] = c + t, E[g + 268 >> 2] = i + _, E[g + 264 >> 2] = B + Q, E[g + 260 >> 2] = I + C, E[g + 256 >> 2] = n + k, E[g + 244 >> 2] = N - F, E[g + 240 >> 2] = w - f, E[g + 236 >> 2] = D - p, E[g + 232 >> 2] = y - s, E[g + 228 >> 2] = r - e, E[g + 224 >> 2] = c - t, E[g + 220 >> 2] = i - _, E[g + 216 >> 2] = B - Q, E[g + 212 >> 2] = I - C, E[g + 208 >> 2] = n - k, vA(I = g + 208 | 0, I), Y(g, g + 256 | 0, I), BI(A, g), h = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = B, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; AC(A, Q + 96 | 0, Q, 0), C = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, o[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, o[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, o[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, o[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, o[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, o[Q + 110 | 0] = C, o[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, AC(Q + 32 | 0, Q + 96 | 0, Q, 0), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; _ = c = Q + 32 | 0, o[A + B | 0] = a[_ + B | 0], o[(t = 1 | B) + A | 0] = a[_ + t | 0], o[(_ = 2 | B) + A | 0] = a[_ + c | 0], o[(_ = 3 | B) + A | 0] = a[_ + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; o[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, _) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, _ |= 0;
                                            var c, t = 0;
                                            if (h = c = h - 112 | 0, (g |= 0) | (C |= 0)) {
                                                t = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, E[c + 24 >> 2] = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, E[c + 28 >> 2] = t, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[c + 16 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[c + 20 >> 2] = t, t = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E[c >> 2] = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, E[c + 4 >> 2] = t, t = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, E[c + 8 >> 2] = a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, E[c + 12 >> 2] = t, _ = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[c + 100 >> 2] = _, o[c + 104 | 0] = Q, o[c + 111 | 0] = i >>> 24, o[c + 110 | 0] = i >>> 16, o[c + 109 | 0] = i >>> 8, o[c + 108 | 0] = i, o[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, o[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, o[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0); Q = c + 32 | 0, o[A + _ | 0] = a[Q + _ | 0] ^ a[I + _ | 0], o[(B = 1 | _) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (_ = _ + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, o[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, o[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, o[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, o[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, o[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, o[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, o[c + 110 | 0] = B, o[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, o[A + _ | 0] = a[i + _ | 0] ^ a[I + _ | 0], o[(g = 1 | _) + A | 0] = a[g + i | 0] ^ a[I + g | 0], _ = _ + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (o[A + _ | 0] = a[(c + 32 | 0) + _ | 0] ^ a[I + _ | 0]);
                                                }
                                                XC(c + 32 | 0, 64), XC(c, 32);
                                            }
                                            return h = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 192 & -32, P(E |= 0, o |= 0, a - -64 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a - -64 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            if ((E = 31 & i) && (Hg((c = a + 32 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a - -64 | 0)), c = 32, o = 0, B >>> 0 < 32) E = 0;
                                            else for(; l(A + o | 0, C + o | 0, a - -64 | 0), o = E = c, (c = E + 32 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 31 & B) && (Hg((o = a + 32 | 0) | Q, 0, 32 - Q | 0), Sg(o, C + E | 0, Q), l(a, o, a - -64 | 0), Sg(A + E | 0, a, Q)), d(I, g, i, B, a - -64 | 0), h = _, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 224 & -32, P(E |= 0, o |= 0, a + 96 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            (E = 31 & i) && (Hg((c = a - -64 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a + 96 | 0));
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (c = 32, g >>> 0 < 32) break B;
                                                                    for(E = 0; U(A + E | 0, I + E | 0, a + 96 | 0), o = c, (c = (E = c) + 32 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (E = 32, g >>> 0 < 32) break g;
                                                                    for(c = 0; U(a + 32 | 0, I + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(E = 31 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(E = g)) break A;
                                                        }
                                                        x(A + o | 0, I + o | 0, E, a + 96 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(E = g)) break A;
                                                }
                                                x(a + 32 | 0, I + o | 0, E, a + 96 | 0);
                                            }
                                            d(a, B, i, g, a + 96 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(a, C);
                                                    break A;
                                                }
                                                o = SC(a, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = _, 0 | o;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 528 | 0, M(_ |= 0, o |= 0, c + 400 | 0), o = 0, i >>> 0 >= 16) for(r = c + 416 | 0, y = c + 432 | 0, s = c + 448 | 0, e = c + 464 | 0, D = c + 480 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 520 >> 2] = E[D + 8 >> 2], E[c + 524 >> 2] = o, o = E[D + 4 >> 2], E[c + 512 >> 2] = E[D >> 2], E[c + 516 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 496 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 508 >> 2], E[D + 8 >> 2] = E[c + 504 >> 2], E[D + 12 >> 2] = t, t = E[c + 500 >> 2], E[D >> 2] = E[c + 496 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 508 >> 2], E[e + 8 >> 2] = E[c + 504 >> 2], E[e + 12 >> 2] = t, t = E[c + 500 >> 2], E[e >> 2] = E[c + 496 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 508 >> 2], E[s + 8 >> 2] = E[c + 504 >> 2], E[s + 12 >> 2] = t, t = E[c + 500 >> 2], E[s >> 2] = E[c + 496 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 508 >> 2], E[y + 8 >> 2] = E[c + 504 >> 2], E[y + 12 >> 2] = t, t = E[c + 500 >> 2], E[y >> 2] = E[c + 496 >> 2], E[y + 4 >> 2] = t, t = E[c + 412 >> 2], E[c + 248 >> 2] = E[c + 408 >> 2], E[c + 252 >> 2] = t, t = E[c + 404 >> 2], E[c + 240 >> 2] = E[c + 400 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 508 >> 2], E[r + 8 >> 2] = E[c + 504 >> 2], E[r + 12 >> 2] = t, t = E[c + 500 >> 2], E[r >> 2] = E[c + 496 >> 2], E[r + 4 >> 2] = t, t = E[c + 524 >> 2], E[c + 216 >> 2] = E[c + 520 >> 2], E[c + 220 >> 2] = t, t = E[c + 412 >> 2], E[c + 200 >> 2] = E[c + 408 >> 2], E[c + 204 >> 2] = t, t = E[c + 516 >> 2], E[c + 208 >> 2] = E[c + 512 >> 2], E[c + 212 >> 2] = t, t = E[c + 404 >> 2], E[c + 192 >> 2] = E[c + 400 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 412 >> 2] = n ^ E[c + 508 >> 2], E[c + 408 >> 2] = E[c + 504 >> 2] ^ f, E[c + 404 >> 2] = E[c + 500 >> 2] ^ w, E[c + 400 >> 2] = E[c + 496 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            if ((_ = 15 & i) && (Hg((r = c + 384 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 384 >> 2], r = E[c + 388 >> 2], y = E[c + 392 >> 2], s = E[c + 396 >> 2], o = E[c + 492 >> 2], Q = E[c + 488 >> 2], E[c + 520 >> 2] = Q, E[c + 524 >> 2] = o, e = E[c + 476 >> 2], E[c + 184 >> 2] = E[c + 472 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 484 >> 2], Q = E[c + 480 >> 2], E[c + 512 >> 2] = Q, E[c + 516 >> 2] = o, e = E[c + 468 >> 2], E[c + 176 >> 2] = E[c + 464 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 496 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 508 >> 2], E[c + 488 >> 2] = E[c + 504 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 152 >> 2] = E[c + 456 >> 2], E[c + 156 >> 2] = o, o = E[c + 476 >> 2], E[c + 136 >> 2] = E[c + 472 >> 2], E[c + 140 >> 2] = o, o = E[c + 500 >> 2], E[c + 480 >> 2] = E[c + 496 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 144 >> 2] = E[c + 448 >> 2], E[c + 148 >> 2] = o, o = E[c + 468 >> 2], E[c + 128 >> 2] = E[c + 464 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 508 >> 2], E[c + 472 >> 2] = E[c + 504 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 120 >> 2] = E[c + 440 >> 2], E[c + 124 >> 2] = o, o = E[c + 460 >> 2], E[c + 104 >> 2] = E[c + 456 >> 2], E[c + 108 >> 2] = o, o = E[c + 500 >> 2], E[c + 464 >> 2] = E[c + 496 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 112 >> 2] = E[c + 432 >> 2], E[c + 116 >> 2] = o, o = E[c + 452 >> 2], E[c + 96 >> 2] = E[c + 448 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 508 >> 2], E[c + 456 >> 2] = E[c + 504 >> 2], E[c + 460 >> 2] = o, o = E[c + 428 >> 2], E[c + 88 >> 2] = E[c + 424 >> 2], E[c + 92 >> 2] = o, o = E[c + 444 >> 2], E[c + 72 >> 2] = E[c + 440 >> 2], E[c + 76 >> 2] = o, o = E[c + 500 >> 2], E[c + 448 >> 2] = E[c + 496 >> 2], E[c + 452 >> 2] = o, o = E[c + 420 >> 2], E[c + 80 >> 2] = E[c + 416 >> 2], E[c + 84 >> 2] = o, o = E[c + 436 >> 2], E[c + 64 >> 2] = E[c + 432 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 508 >> 2], E[c + 440 >> 2] = E[c + 504 >> 2], E[c + 444 >> 2] = o, o = E[c + 412 >> 2], E[c + 56 >> 2] = E[c + 408 >> 2], E[c + 60 >> 2] = o, o = E[c + 428 >> 2], E[c + 40 >> 2] = E[c + 424 >> 2], E[c + 44 >> 2] = o, o = E[c + 500 >> 2], E[c + 432 >> 2] = E[c + 496 >> 2], E[c + 436 >> 2] = o, o = E[c + 404 >> 2], E[c + 48 >> 2] = E[c + 400 >> 2], E[c + 52 >> 2] = o, o = E[c + 420 >> 2], E[c + 32 >> 2] = E[c + 416 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 508 >> 2], E[c + 424 >> 2] = E[c + 504 >> 2], E[c + 428 >> 2] = o, o = E[c + 524 >> 2], E[c + 24 >> 2] = E[c + 520 >> 2], E[c + 28 >> 2] = o, o = E[c + 412 >> 2], E[c + 8 >> 2] = E[c + 408 >> 2], E[c + 12 >> 2] = o, o = E[c + 500 >> 2], E[c + 416 >> 2] = E[c + 496 >> 2], E[c + 420 >> 2] = o, o = E[c + 516 >> 2], E[c + 16 >> 2] = E[c + 512 >> 2], E[c + 20 >> 2] = o, o = E[c + 404 >> 2], E[c >> 2] = E[c + 400 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 412 >> 2] = s ^ E[c + 508 >> 2], E[c + 408 >> 2] = y ^ E[c + 504 >> 2], E[c + 404 >> 2] = r ^ E[c + 500 >> 2], E[c + 400 >> 2] = _ ^ E[c + 496 >> 2]), Q = 16, o = 0, B >>> 0 < 16) _ = 0;
                                            else for(; j(A + o | 0, C + o | 0, c + 400 | 0), _ = Q, (Q = (o = Q) + 16 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 15 & B) && (Hg((o = c + 384 | 0) | Q, 0, 16 - Q | 0), Sg(o, C + _ | 0, Q), j(C = c + 512 | 0, o, c + 400 | 0), Sg(A + _ | 0, C, Q)), m(I, g, i, B, c + 400 | 0), h = c + 528 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 544 | 0, M(_ |= 0, o |= 0, c + 432 | 0), o = 0, i >>> 0 >= 16) for(r = c + 448 | 0, y = c + 464 | 0, s = c + 480 | 0, e = c + 496 | 0, D = c + 512 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 392 >> 2] = E[D + 8 >> 2], E[c + 396 >> 2] = o, o = E[D + 4 >> 2], E[c + 384 >> 2] = E[D >> 2], E[c + 388 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 528 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 540 >> 2], E[D + 8 >> 2] = E[c + 536 >> 2], E[D + 12 >> 2] = t, t = E[c + 532 >> 2], E[D >> 2] = E[c + 528 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 540 >> 2], E[e + 8 >> 2] = E[c + 536 >> 2], E[e + 12 >> 2] = t, t = E[c + 532 >> 2], E[e >> 2] = E[c + 528 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 540 >> 2], E[s + 8 >> 2] = E[c + 536 >> 2], E[s + 12 >> 2] = t, t = E[c + 532 >> 2], E[s >> 2] = E[c + 528 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 540 >> 2], E[y + 8 >> 2] = E[c + 536 >> 2], E[y + 12 >> 2] = t, t = E[c + 532 >> 2], E[y >> 2] = E[c + 528 >> 2], E[y + 4 >> 2] = t, t = E[c + 444 >> 2], E[c + 248 >> 2] = E[c + 440 >> 2], E[c + 252 >> 2] = t, t = E[c + 436 >> 2], E[c + 240 >> 2] = E[c + 432 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 540 >> 2], E[r + 8 >> 2] = E[c + 536 >> 2], E[r + 12 >> 2] = t, t = E[c + 532 >> 2], E[r >> 2] = E[c + 528 >> 2], E[r + 4 >> 2] = t, t = E[c + 396 >> 2], E[c + 216 >> 2] = E[c + 392 >> 2], E[c + 220 >> 2] = t, t = E[c + 444 >> 2], E[c + 200 >> 2] = E[c + 440 >> 2], E[c + 204 >> 2] = t, t = E[c + 388 >> 2], E[c + 208 >> 2] = E[c + 384 >> 2], E[c + 212 >> 2] = t, t = E[c + 436 >> 2], E[c + 192 >> 2] = E[c + 432 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 444 >> 2] = n ^ E[c + 540 >> 2], E[c + 440 >> 2] = E[c + 536 >> 2] ^ f, E[c + 436 >> 2] = E[c + 532 >> 2] ^ w, E[c + 432 >> 2] = E[c + 528 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            (_ = 15 & i) && (Hg((r = c + 416 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 416 >> 2], r = E[c + 420 >> 2], y = E[c + 424 >> 2], s = E[c + 428 >> 2], o = E[c + 524 >> 2], Q = E[c + 520 >> 2], E[c + 392 >> 2] = Q, E[c + 396 >> 2] = o, e = E[c + 508 >> 2], E[c + 184 >> 2] = E[c + 504 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 516 >> 2], Q = E[c + 512 >> 2], E[c + 384 >> 2] = Q, E[c + 388 >> 2] = o, e = E[c + 500 >> 2], E[c + 176 >> 2] = E[c + 496 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 528 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 540 >> 2], E[c + 520 >> 2] = E[c + 536 >> 2], E[c + 524 >> 2] = o, o = E[c + 492 >> 2], E[c + 152 >> 2] = E[c + 488 >> 2], E[c + 156 >> 2] = o, o = E[c + 508 >> 2], E[c + 136 >> 2] = E[c + 504 >> 2], E[c + 140 >> 2] = o, o = E[c + 532 >> 2], E[c + 512 >> 2] = E[c + 528 >> 2], E[c + 516 >> 2] = o, o = E[c + 484 >> 2], E[c + 144 >> 2] = E[c + 480 >> 2], E[c + 148 >> 2] = o, o = E[c + 500 >> 2], E[c + 128 >> 2] = E[c + 496 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 540 >> 2], E[c + 504 >> 2] = E[c + 536 >> 2], E[c + 508 >> 2] = o, o = E[c + 476 >> 2], E[c + 120 >> 2] = E[c + 472 >> 2], E[c + 124 >> 2] = o, o = E[c + 492 >> 2], E[c + 104 >> 2] = E[c + 488 >> 2], E[c + 108 >> 2] = o, o = E[c + 532 >> 2], E[c + 496 >> 2] = E[c + 528 >> 2], E[c + 500 >> 2] = o, o = E[c + 468 >> 2], E[c + 112 >> 2] = E[c + 464 >> 2], E[c + 116 >> 2] = o, o = E[c + 484 >> 2], E[c + 96 >> 2] = E[c + 480 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 540 >> 2], E[c + 488 >> 2] = E[c + 536 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 88 >> 2] = E[c + 456 >> 2], E[c + 92 >> 2] = o, o = E[c + 476 >> 2], E[c + 72 >> 2] = E[c + 472 >> 2], E[c + 76 >> 2] = o, o = E[c + 532 >> 2], E[c + 480 >> 2] = E[c + 528 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 80 >> 2] = E[c + 448 >> 2], E[c + 84 >> 2] = o, o = E[c + 468 >> 2], E[c + 64 >> 2] = E[c + 464 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 540 >> 2], E[c + 472 >> 2] = E[c + 536 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 56 >> 2] = E[c + 440 >> 2], E[c + 60 >> 2] = o, o = E[c + 460 >> 2], E[c + 40 >> 2] = E[c + 456 >> 2], E[c + 44 >> 2] = o, o = E[c + 532 >> 2], E[c + 464 >> 2] = E[c + 528 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 48 >> 2] = E[c + 432 >> 2], E[c + 52 >> 2] = o, o = E[c + 452 >> 2], E[c + 32 >> 2] = E[c + 448 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 540 >> 2], E[c + 456 >> 2] = E[c + 536 >> 2], E[c + 460 >> 2] = o, o = E[c + 396 >> 2], E[c + 24 >> 2] = E[c + 392 >> 2], E[c + 28 >> 2] = o, o = E[c + 444 >> 2], E[c + 8 >> 2] = E[c + 440 >> 2], E[c + 12 >> 2] = o, o = E[c + 532 >> 2], E[c + 448 >> 2] = E[c + 528 >> 2], E[c + 452 >> 2] = o, o = E[c + 388 >> 2], E[c + 16 >> 2] = E[c + 384 >> 2], E[c + 20 >> 2] = o, o = E[c + 436 >> 2], E[c >> 2] = E[c + 432 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 444 >> 2] = s ^ E[c + 540 >> 2], E[c + 440 >> 2] = y ^ E[c + 536 >> 2], E[c + 436 >> 2] = r ^ E[c + 532 >> 2], E[c + 432 >> 2] = _ ^ E[c + 528 >> 2]);
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (Q = 16, g >>> 0 < 16) break B;
                                                                    for(_ = 0; X(A + _ | 0, I + _ | 0, c + 432 | 0), _ = o = Q, (Q = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (_ = 16, g >>> 0 < 16) break g;
                                                                    for(Q = 0; X(c + 528 | 0, I + Q | 0, c + 432 | 0), Q = o = _, (_ = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(_ = 15 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(_ = g)) break A;
                                                        }
                                                        Z(A + o | 0, I + o | 0, _, c + 432 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(_ = g)) break A;
                                                }
                                                Z(c + 528 | 0, I + o | 0, _, c + 432 | 0);
                                            }
                                            m(c + 384 | 0, B, i, g, c + 432 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(c + 384 | 0, C);
                                                    break A;
                                                }
                                                o = SC(c + 384 | 0, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = c + 544 | 0, 0 | o;
                                        }
                                    ], DB.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, DB.set = function(A, I) {
                                        this[A] = I;
                                    }, DB.get = function(A) {
                                        return this[A];
                                    }, DB);
                                    function wB() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: CB,
                                        h: hB,
                                        i: CB,
                                        j: BB,
                                        k: aB,
                                        l: qC,
                                        m: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36784);
                                        },
                                        n: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36784);
                                        },
                                        o: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        p: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        q: BB,
                                        r: hB,
                                        s: BB,
                                        t: BB,
                                        u: aB,
                                        v: LC,
                                        w: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36792);
                                        },
                                        x: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36792);
                                        },
                                        y: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        z: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        A: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | xI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (xI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | lI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        D: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (lI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        E: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | UI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        F: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = UI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        G: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | YI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        H: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = YI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        I: BB,
                                        J: QB,
                                        K: hB,
                                        L: CB,
                                        M: oB,
                                        N: LC,
                                        O: BB,
                                        P: sB,
                                        Q: hB,
                                        R: CB,
                                        S: oB,
                                        T: LC,
                                        U: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | fI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        V: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (fI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        W: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | sI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        X: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = sI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        Y: BB,
                                        Z: _B,
                                        _: hB,
                                        $: CB,
                                        aa: oB,
                                        ba: LC,
                                        ca: BB,
                                        da: BB,
                                        ea: function() {
                                            return 1464;
                                        },
                                        fa: EI,
                                        ga: JI,
                                        ha: LC,
                                        ia: BB,
                                        ja: BB,
                                        ka: IB,
                                        la: LC,
                                        ma: UA,
                                        na: function(A, I, g, C) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oa: Fg,
                                        pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 240 | 0, UA(Q, B |= 0, 32), MA(Q, I, g, C), dA(Q, I = Q + 208 | 0), MA(g = Q + 104 | 0, I, 32, 0), dA(g, A), XC(I, 32), h = Q + 240 | 0, 0;
                                        },
                                        qa: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 272 | 0, UA(i = Q + 32 | 0, B |= 0, 32), MA(i, I, g, C), dA(i, I = Q + 240 | 0), MA(g = Q + 136 | 0, I, 32, 0), dA(g, Q), XC(I, 32), I = SC(A, Q), g = MI(Q, A, 32), h = Q + 272 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        ra: gB,
                                        sa: BB,
                                        ta: TC,
                                        ua: LC,
                                        va: QI,
                                        wa: EC,
                                        xa: fg,
                                        ya: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), nA(Q, I, g, C), z(Q, I = Q + 416 | 0), nA(g = Q + 208 | 0, I, 64, 0), z(g, A), XC(I, 64), h = Q + 480 | 0, 0;
                                        },
                                        za: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 544 | 0, QI(i = Q - -64 | 0, B |= 0, 32), nA(i, I, g, C), z(i, I = Q + 480 | 0), nA(g = Q + 272 | 0, I, 64, 0), z(g, Q), XC(I, 64), I = GC(A, Q), g = MI(Q, A, 64), h = Q + 544 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        Aa: BB,
                                        Ba: BB,
                                        Ca: TC,
                                        Da: LC,
                                        Ea: eC,
                                        Fa: EC,
                                        Ga: function(A, I) {
                                            I |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, fg(A |= 0, g), C = E[g + 28 >> 2], A = E[g + 24 >> 2], o[I + 24 | 0] = A, o[I + 25 | 0] = A >>> 8, o[I + 26 | 0] = A >>> 16, o[I + 27 | 0] = A >>> 24, o[I + 28 | 0] = C, o[I + 29 | 0] = C >>> 8, o[I + 30 | 0] = C >>> 16, o[I + 31 | 0] = C >>> 24, C = E[g + 20 >> 2], A = E[g + 16 >> 2], o[I + 16 | 0] = A, o[I + 17 | 0] = A >>> 8, o[I + 18 | 0] = A >>> 16, o[I + 19 | 0] = A >>> 24, o[I + 20 | 0] = C, o[I + 21 | 0] = C >>> 8, o[I + 22 | 0] = C >>> 16, o[I + 23 | 0] = C >>> 24, C = E[g + 12 >> 2], A = E[g + 8 >> 2], o[I + 8 | 0] = A, o[I + 9 | 0] = A >>> 8, o[I + 10 | 0] = A >>> 16, o[I + 11 | 0] = A >>> 24, o[I + 12 | 0] = C, o[I + 13 | 0] = C >>> 8, o[I + 14 | 0] = C >>> 16, o[I + 15 | 0] = C >>> 24, C = E[g + 4 >> 2], A = E[g >> 2], o[0 | I] = A, o[I + 1 | 0] = A >>> 8, o[I + 2 | 0] = A >>> 16, o[I + 3 | 0] = A >>> 24, o[I + 4 | 0] = C, o[I + 5 | 0] = C >>> 8, o[I + 6 | 0] = C >>> 16, o[I + 7 | 0] = C >>> 24, h = g - -64 | 0, 0;
                                        },
                                        Ha: EI,
                                        Ia: JI,
                                        Ja: BB,
                                        Ka: BB,
                                        La: BB,
                                        Ma: BB,
                                        Na: _B,
                                        Oa: BB,
                                        Pa: CB,
                                        Qa: CB,
                                        Ra: oB,
                                        Sa: function() {
                                            return 1478;
                                        },
                                        Ta: function(A, I, g) {
                                            return 0 | aI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ua: KC,
                                        Va: cC,
                                        Wa: Pg,
                                        Xa: qg,
                                        Ya: Qg,
                                        Za: Bg,
                                        _a: dg,
                                        $a: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = eI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        ab: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | eI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        bb: function(A, I, g, C, B, Q, i) {
                                            return 0 | sg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        cb: Jg,
                                        db: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = yI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        eb: hg,
                                        fb: function(A, I, g, C, B, Q, i) {
                                            return 0 | _g(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        gb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, KC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = sg(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        hb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = _g(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ib: EB,
                                        jb: aI,
                                        kb: sC,
                                        lb: wg,
                                        mb: Pg,
                                        nb: qg,
                                        ob: Qg,
                                        pb: Bg,
                                        qb: BB,
                                        rb: BB,
                                        sb: BB,
                                        tb: BB,
                                        ub: _B,
                                        vb: BB,
                                        wb: CB,
                                        xb: CB,
                                        yb: oB,
                                        zb: yA,
                                        Ab: BB,
                                        Bb: CB,
                                        Cb: BB,
                                        Db: CB,
                                        Eb: fA,
                                        Fb: BB,
                                        Gb: CB,
                                        Hb: BB,
                                        Ib: CB,
                                        Jb: AC,
                                        Kb: gB,
                                        Lb: CB,
                                        Mb: BB,
                                        Nb: CB,
                                        Ob: IC,
                                        Pb: gB,
                                        Qb: CB,
                                        Rb: BB,
                                        Sb: CB,
                                        Tb: gC,
                                        Ub: gB,
                                        Vb: CB,
                                        Wb: BB,
                                        Xb: CB,
                                        Yb: CB,
                                        Zb: gB,
                                        _b: BB,
                                        $b: CB,
                                        ac: gB,
                                        bc: BB,
                                        cc: VC,
                                        dc: WC,
                                        ec: function(A, I, g, C, B, Q, i) {
                                            return 0 | kC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fc: iC,
                                        gc: function(A, I, g, C) {
                                            return 0 | mC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        hc: rC,
                                        ic: LC,
                                        jc: CB,
                                        kc: gB,
                                        lc: BB,
                                        mc: CB,
                                        nc: gB,
                                        oc: BB,
                                        pc: CB,
                                        qc: CB,
                                        rc: WC,
                                        sc: LC,
                                        tc: kC,
                                        uc: function(A, I, g, C, B, Q, i, o, E) {
                                            return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0);
                                        },
                                        vc: eA,
                                        wc: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, B |= 0, i |= 0;
                                            var E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                            if (E = -1, !((C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64)) {
                                                A: {
                                                    if (!g || !I) {
                                                        if (((t = 255 & C) - 65 & 255) >>> 0 > 191) {
                                                            B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), I = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, I = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), E = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, E = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = E, o[A + 49 | 0] = E >>> 8, o[A + 50 | 0] = E >>> 16, o[A + 51 | 0] = E >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = I, o[A + 33 | 0] = I >>> 8, o[A + 34 | 0] = I >>> 16, o[A + 35 | 0] = I >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I = -222443256 ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106;
                                                            break A;
                                                        }
                                                        yC(), Q();
                                                    }
                                                    h = e = h - 128 | 0, !I | ((y = 255 & C) - 65 & 255) >>> 0 <= 191 | ((E = 255 & g) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, t = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), r = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, r = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = r, o[A + 49 | 0] = r >>> 8, o[A + 50 | 0] = r >>> 16, o[A + 51 | 0] = r >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = t, o[A + 33 | 0] = t >>> 8, o[A + 34 | 0] = t >>> 16, o[A + 35 | 0] = t >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, g = -222443256 ^ (E << 8 | y), o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, g = E >>> 24 ^ 1779033703, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, Hg(E + e | 0, 0, E << 24 >> 24 >= 0 ? 128 - E | 0 : 0), g = Sg(e, I, E), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0);
                                                }
                                                E = 0;
                                            }
                                            return 0 | E;
                                        },
                                        xc: mC,
                                        yc: Yg,
                                        zc: gB,
                                        Ac: CC,
                                        Bc: function() {
                                            return 1533;
                                        },
                                        Cc: BB,
                                        Dc: function() {
                                            return 104;
                                        },
                                        Ec: $I,
                                        Fc: function(A, I, g, C) {
                                            return 0 | MA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Gc: dA,
                                        Hc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0;
                                            return h = B = h - 112 | 0, Q = E[8603], E[B + 16 >> 2] = E[8602], E[B + 20 >> 2] = Q, Q = E[8605], E[B + 24 >> 2] = E[8604], E[B + 28 >> 2] = Q, Q = E[8607], E[B + 32 >> 2] = E[8606], E[B + 36 >> 2] = Q, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, Q = E[8601], E[B + 8 >> 2] = E[8600], E[B + 12 >> 2] = Q, MA(Q = B + 8 | 0, I, g, C), dA(Q, A), h = B + 112 | 0, 0;
                                        },
                                        Ic: gB,
                                        Jc: IB,
                                        Kc: SI,
                                        Lc: QC,
                                        Mc: z,
                                        Nc: CC,
                                        Oc: CB,
                                        Pc: gB,
                                        Qc: sB,
                                        Rc: BB,
                                        Sc: dI,
                                        Tc: VC,
                                        Uc: CB,
                                        Vc: gB,
                                        Wc: sB,
                                        Xc: BB,
                                        Yc: dI,
                                        Zc: LC,
                                        _c: function(A, I, g) {
                                            return 0 | UA(A |= 0, I |= 0, g |= 0);
                                        },
                                        $c: function(A, I, g) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        ad: function(A, I) {
                                            return Fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        bd: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 208 | 0, UA(Q, I |= 0, g |= 0), YC(Q, C, B, 0), Fg(Q, A), XC(Q, 4), h = Q + 208 | 0, 0;
                                        },
                                        cd: LC,
                                        dd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 256 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, UA(i = Q + 48 | 0, B, 32), _ && YC(i, (A + _ | 0) - 32 | 0, 32, 0), YC(i = Q + 48 | 0, g, C, 0), YC(i, Q + 15 | 0, 1, 0), Fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 31 & I) && (UA(I = Q + 48 | 0, B, 32), c && YC(I, (A + c | 0) - 32 | 0, 32, 0), YC(I = Q + 48 | 0, g, C, 0), YC(I, Q + 15 | 0, 1, 0), Fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 32)), XC(Q + 48 | 0, 208), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 256 | 0, 0 | A;
                                        },
                                        ed: BB,
                                        fd: hB,
                                        gd: function() {
                                            return 8160;
                                        },
                                        hd: IB,
                                        id: eC,
                                        jd: function(A, I, g) {
                                            return 0 | dC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        kd: function(A, I) {
                                            return fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        ld: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 416 | 0, QI(Q, I |= 0, g |= 0), dC(Q, C, B, 0), fg(Q, A), XC(Q, 4), h = Q + 416 | 0, 0;
                                        },
                                        md: function(A) {
                                            ag(A |= 0, 64);
                                        },
                                        nd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 496 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, QI(i = Q + 80 | 0, B, 64), _ && dC(i, (A + _ | 0) - 64 | 0, 64, 0), dC(i = Q + 80 | 0, g, C, 0), dC(i, Q + 15 | 0, 1, 0), fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 63 & I) && (QI(I = Q + 80 | 0, B, 64), c && dC(I, (A + c | 0) - 64 | 0, 64, 0), dC(I = Q + 80 | 0, g, C, 0), dC(I, Q + 15 | 0, 1, 0), fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 64)), XC(Q + 80 | 0, 416), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 496 | 0, 0 | A;
                                        },
                                        od: gB,
                                        pd: hB,
                                        qd: function() {
                                            return 16320;
                                        },
                                        rd: function(A, I, g) {
                                            return A |= 0, kC(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | bC(A, I);
                                        },
                                        sd: function(A, I) {
                                            return A |= 0, ag(I |= 0, 32), 0 | bC(A, I);
                                        },
                                        td: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, g, 32, 0), mC(I, B, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + i | 0] = a[0 | g], o[A + C | 0] = a[g + 32 | 0], o[(B = 1 | A) + i | 0] = a[I + B | 0], o[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        ud: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, B, 32, 0), mC(I, g, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + C | 0] = a[0 | g], o[A + i | 0] = a[g + 32 | 0], o[(B = 1 | A) + C | 0] = a[I + B | 0], o[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        vd: BB,
                                        wd: BB,
                                        xd: BB,
                                        yd: BB,
                                        zd: function() {
                                            return 1315;
                                        },
                                        Ad: $C,
                                        Bd: CB,
                                        Cd: BB,
                                        Dd: Zg,
                                        Ed: Wg,
                                        Fd: function(A, I) {
                                            return 0 | fC(A |= 0, I |= 0);
                                        },
                                        Gd: BC,
                                        Hd: function(A, I) {
                                            return 0 | nC(A |= 0, I |= 0);
                                        },
                                        Id: function() {
                                            return 1496;
                                        },
                                        Jd: LC,
                                        Kd: Zg,
                                        Ld: Wg,
                                        Md: fC,
                                        Nd: BC,
                                        Od: nC,
                                        Pd: CB,
                                        Qd: BB,
                                        Rd: $C,
                                        Sd: LC,
                                        Td: rB,
                                        Ud: CB,
                                        Vd: tB,
                                        Wd: hB,
                                        Xd: tB,
                                        Yd: CB,
                                        Zd: AB,
                                        _d: function() {
                                            return 1549;
                                        },
                                        $d: yB,
                                        ae: tB,
                                        be: ZC,
                                        ce: RC,
                                        de: cB,
                                        ee: jC,
                                        fe: function() {
                                            return 6;
                                        },
                                        ge: function() {
                                            return 134217728;
                                        },
                                        he: sB,
                                        ie: function() {
                                            return 536870912;
                                        },
                                        je: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | cI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        ke: function(A, I, g, C, B, Q, i) {
                                            return 0 | OI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                        },
                                        le: function(A, I, g, C) {
                                            return 0 | JC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        me: function(A, I, g, C) {
                                            return 0 | UC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        ne: function(A, I, g, C) {
                                            return 0 | lC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oe: eB,
                                        pe: CB,
                                        qe: tB,
                                        re: hB,
                                        se: tB,
                                        te: CB,
                                        ue: AB,
                                        ve: OC,
                                        we: rB,
                                        xe: tB,
                                        ye: ZC,
                                        ze: RC,
                                        Ae: eB,
                                        Be: PC,
                                        Ce: yB,
                                        De: vC,
                                        Ee: cB,
                                        Fe: xC,
                                        Ge: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | tI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        He: Ng,
                                        Ie: function(A, I, g, C) {
                                            return 0 | HC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Je: rB,
                                        Ke: eB,
                                        Le: eB,
                                        Me: CB,
                                        Ne: tB,
                                        Oe: hB,
                                        Pe: tB,
                                        Qe: CB,
                                        Re: AB,
                                        Se: OC,
                                        Te: rB,
                                        Ue: tB,
                                        Ve: ZC,
                                        We: RC,
                                        Xe: eB,
                                        Ye: PC,
                                        Ze: yB,
                                        _e: vC,
                                        $e: cB,
                                        af: xC,
                                        bf: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, I |= 0, B |= 0, o |= 0;
                                            A: {
                                                switch((c |= 0) - 1 | 0){
                                                    case 0:
                                                        A = cI(A, I, g, C, B, Q, i, o, a, _, 1);
                                                        break A;
                                                    case 1:
                                                        A = tI(A, I, g, C, B, Q, i, o, a, _, 2);
                                                        break A;
                                                }
                                                E[9392] = 28, A = -1;
                                            }
                                            return 0 | A;
                                        },
                                        cf: Ng,
                                        df: function(A, I, g, C, B, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, o |= 0, g |= 0, B |= 0;
                                            A: {
                                                switch((E |= 0) - 1 | 0){
                                                    case 1:
                                                        A = TI(A, I, g, C, B, i, o);
                                                        break A;
                                                    default:
                                                        yC(), Q();
                                                    case 0:
                                                }
                                                A = OI(A, I, g, C, B, i, o);
                                            }
                                            return 0 | A;
                                        },
                                        ef: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = JC(A, I, g, C) : A = HC(A, I, g, C), 0 | A;
                                        },
                                        ff: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = UC(A, I, g, C) : A = lC(A, I, g, C), 0 | A;
                                        },
                                        gf: function() {
                                            return 1157;
                                        },
                                        hf: function() {
                                            return 1438;
                                        },
                                        jf: bC,
                                        kf: tC,
                                        lf: BB,
                                        mf: BB,
                                        nf: gI,
                                        of: wC,
                                        pf: BB,
                                        qf: BB,
                                        rf: BB,
                                        sf: _B,
                                        tf: BB,
                                        uf: CB,
                                        vf: CB,
                                        wf: oB,
                                        xf: function() {
                                            return 1488;
                                        },
                                        yf: Pg,
                                        zf: qg,
                                        Af: LC,
                                        Bf: dg,
                                        Cf: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), eI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Df: Jg,
                                        Ef: hg,
                                        Ff: Pg,
                                        Gf: qg,
                                        Hf: BB,
                                        If: _B,
                                        Jf: BB,
                                        Kf: CB,
                                        Lf: CB,
                                        Mf: oB,
                                        Nf: LC,
                                        Of: LC,
                                        Pf: function(A, I, g) {
                                            return A |= 0, g |= 0, ag(I |= 0, 24), yA(A, I, g, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Qf: function(A, I, g) {
                                            return yA(A |= 0, I |= 0, g |= 0, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Rf: function(A) {
                                            var I, g = 0, C = 0;
                                            h = I = h - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[I + 36 >> 2] = g, xg(I, I, 40, 0, A + 32 | 0, A), g = E[I + 28 >> 2], C = E[I + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[I + 20 >> 2], C = E[I + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, g = E[I + 12 >> 2], C = E[I + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[I + 4 >> 2], C = E[I >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, C = E[I + 36 >> 2], g = E[I + 32 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, h = I + 48 | 0;
                                        },
                                        Sf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, _ |= 0, t |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0;
                                            return y = B |= 0, y |= B = 0, e = B | (c |= 0), h = B = h - 384 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), !i & y >>> 0 < 4294967279 ? (Xg(s = B + 16 | 0, 64, 0, D = A + 32 | 0, A), fC(c = B + 80 | 0, s), XC(s, 64), NC(c, _, e, t), NC(c, 34384, 0 - e & 15, 0), E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, E[(_ = B - -64 | 0) >> 2] = 0, E[_ + 4 >> 2] = 0, E[B + 56 >> 2] = 0, E[B + 60 >> 2] = 0, E[B + 48 >> 2] = 0, E[B + 52 >> 2] = 0, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, E[B + 32 >> 2] = 0, E[B + 36 >> 2] = 0, E[B + 16 >> 2] = 0, E[B + 20 >> 2] = 0, E[B + 24 >> 2] = 0, E[B + 28 >> 2] = 0, o[B + 16 | 0] = r, gg(s, s, 64, 0, D, 1, A), NC(c, s, 64, 0), o[0 | I] = a[B + 16 | 0], gg(I = I + 1 | 0, C, y, i, D, 2, A), NC(c, I, y, i), NC(c, 34384, 15 & y, 0), E[B + 8 >> 2] = e, E[B + 12 >> 2] = t, NC(c, C = B + 8 | 0, 8, 0), E[B + 8 >> 2] = y - -64, E[B + 12 >> 2] = i - ((y >>> 0 < 4294967232) - 1 | 0), NC(c, C, 8, 0), nC(c, I = I + y | 0), XC(c, 256), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], o[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], XI(D), (2 & r || NI(D, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[B + 372 >> 2] = I, xg(I = B + 336 | 0, I, 40, 0, D, A), I = E[B + 364 >> 2], C = E[B + 360 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[B + 356 >> 2], C = E[B + 352 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[B + 348 >> 2], C = E[B + 344 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[B + 340 >> 2], C = E[B + 336 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[B + 368 >> 2], C = E[B + 372 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24), g && (i = (A = y + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, E[g >> 2] = A, E[g + 4 >> 2] = i), h = B + 384 | 0) : (yC(), Q()), 0;
                                        },
                                        Tf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0;
                                            y = i |= 0, i = _ |= 0, s = 0 | y, e = t |= 0, h = _ = h - 400 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), C && (o[0 | C] = 255), f = -1;
                                            A: {
                                                I: {
                                                    if (!((t = s >>> 0 < 17) & !i)) {
                                                        if (w = y = i - t | 0, !y & (t = s - 17 | 0) >>> 0 >= 4294967279 | y) break I;
                                                        Xg(D = _ + 32 | 0, 64, 0, p = A + 32 | 0, A), fC(y = _ + 96 | 0, D), XC(D, 64), NC(y, c, e, r), NC(y, 34384, 0 - e & 15, 0), E[_ + 88 >> 2] = 0, E[_ + 92 >> 2] = 0, E[_ + 80 >> 2] = 0, E[_ + 84 >> 2] = 0, E[_ + 72 >> 2] = 0, E[_ + 76 >> 2] = 0, E[(c = _ - -64 | 0) >> 2] = 0, E[c + 4 >> 2] = 0, E[_ + 56 >> 2] = 0, E[_ + 60 >> 2] = 0, E[_ + 48 >> 2] = 0, E[_ + 52 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 44 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 36 >> 2] = 0, o[_ + 32 | 0] = a[0 | B], gg(D, D, 64, 0, p, 1, A), c = a[_ + 32 | 0], o[_ + 32 | 0] = a[0 | B], NC(y, D, 64, 0), NC(y, B = B + 1 | 0, t, w), NC(y, 34384, s - 1 & 15, 0), E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = r, NC(y, r = _ + 24 | 0, 8, 0), i = (s = s + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, E[_ + 24 >> 2] = s, E[_ + 28 >> 2] = i, NC(y, r, 8, 0), nC(y, _), XC(y, 256), MI(_, B + t | 0, 16) ? XC(_, 16) : (gg(I, B, t, w, p, 2, A), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | _], o[A + 37 | 0] = a[A + 37 | 0] ^ a[_ + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[_ + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[_ + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[_ + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[_ + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[_ + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[_ + 7 | 0], XI(p), (2 & c || NI(p, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[_ + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[_ + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[_ + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[_ + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[_ + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[_ + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[_ + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[_ + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[_ + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[_ + 388 >> 2] = I, xg(I = _ + 352 | 0, I, 40, 0, p, A), I = E[_ + 380 >> 2], B = E[_ + 376 >> 2], o[A + 24 | 0] = B, o[A + 25 | 0] = B >>> 8, o[A + 26 | 0] = B >>> 16, o[A + 27 | 0] = B >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[_ + 372 >> 2], B = E[_ + 368 >> 2], o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[_ + 364 >> 2], B = E[_ + 360 >> 2], o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[_ + 356 >> 2], B = E[_ + 352 >> 2], o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[_ + 384 >> 2], B = E[_ + 388 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = B, o[A + 41 | 0] = B >>> 8, o[A + 42 | 0] = B >>> 16, o[A + 43 | 0] = B >>> 24), g && (E[g >> 2] = t, E[g + 4 >> 2] = w), f = 0, C && (o[0 | C] = c));
                                                    }
                                                    h = _ + 400 | 0;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            return 0 | f;
                                        },
                                        Uf: function() {
                                            return 52;
                                        },
                                        Vf: function() {
                                            return 17;
                                        },
                                        Wf: _B,
                                        Xf: BB,
                                        Yf: function() {
                                            return -18;
                                        },
                                        Zf: hB,
                                        _f: rB,
                                        $f: eB,
                                        ag: yB,
                                        bg: sB,
                                        cg: CB,
                                        dg: function() {
                                            return 1523;
                                        },
                                        eg: W,
                                        fg: qC,
                                        gg: sB,
                                        hg: CB,
                                        ig: W,
                                        jg: IB,
                                        kg: gB,
                                        lg: BB,
                                        mg: BB,
                                        ng: gB,
                                        og: iB,
                                        pg: function() {
                                            return 1449;
                                        },
                                        qg: function(A, I, g) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0);
                                        },
                                        rg: function(A, I) {
                                            return 0 | YA(A |= 0, I |= 0);
                                        },
                                        sg: vI,
                                        tg: HI,
                                        ug: Rg,
                                        vg: Vg,
                                        wg: function(A) {
                                            return 0 | uC(A |= 0);
                                        },
                                        xg: QC,
                                        yg: function(A, I, g, C) {
                                            return 0 | ng(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        zg: function(A, I, g) {
                                            return 0 | bg(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ag: IB,
                                        Bg: gB,
                                        Cg: BB,
                                        Dg: BB,
                                        Eg: gB,
                                        Fg: iB,
                                        Gg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[8 + (_ = I |= 0) | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, C = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, B = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, Q = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, i = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, I = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = Q, o[A + 21 | 0] = Q >>> 8, o[A + 22 | 0] = Q >>> 16, o[A + 23 | 0] = Q >>> 24, o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = C, o[A + 13 | 0] = C >>> 8, o[A + 14 | 0] = C >>> 16, o[A + 15 | 0] = C >>> 24, o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                        },
                                        Hg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[32 + (_ = I |= 0) | 0] | a[_ + 33 | 0] << 8 | a[_ + 34 | 0] << 16 | a[_ + 35 | 0] << 24, C = a[_ + 36 | 0] | a[_ + 37 | 0] << 8 | a[_ + 38 | 0] << 16 | a[_ + 39 | 0] << 24, B = a[_ + 40 | 0] | a[_ + 41 | 0] << 8 | a[_ + 42 | 0] << 16 | a[_ + 43 | 0] << 24, Q = a[_ + 44 | 0] | a[_ + 45 | 0] << 8 | a[_ + 46 | 0] << 16 | a[_ + 47 | 0] << 24, i = a[_ + 48 | 0] | a[_ + 49 | 0] << 8 | a[_ + 50 | 0] << 16 | a[_ + 51 | 0] << 24, I = a[_ + 52 | 0] | a[_ + 53 | 0] << 8 | a[_ + 54 | 0] << 16 | a[_ + 55 | 0] << 24, E = a[_ + 60 | 0] | a[_ + 61 | 0] << 8 | a[_ + 62 | 0] << 16 | a[_ + 63 | 0] << 24, _ = a[_ + 56 | 0] | a[_ + 57 | 0] << 8 | a[_ + 58 | 0] << 16 | a[_ + 59 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = Q, o[A + 13 | 0] = Q >>> 8, o[A + 14 | 0] = Q >>> 16, o[A + 15 | 0] = Q >>> 24, o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, 0;
                                        },
                                        Ig: uC,
                                        Jg: QC,
                                        Kg: ng,
                                        Lg: bg,
                                        Mg: NA,
                                        Ng: YA,
                                        Og: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0;
                                            return h = g = h - 256 | 0, NA = -1, bI(I |= 0) || qA(C = g + 96 | 0, I) || IA(C) && (Q = E[g + 136 >> 2], E[g >> 2] = 1 - Q, NA = 0, u = E[g + 172 >> 2], E[g + 36 >> 2] = 0 - u, n = E[g + 168 >> 2], E[g + 32 >> 2] = 0 - n, x = E[g + 164 >> 2], E[g + 28 >> 2] = 0 - x, k = E[g + 160 >> 2], E[g + 24 >> 2] = 0 - k, R = E[g + 156 >> 2], E[g + 20 >> 2] = 0 - R, F = E[g + 152 >> 2], E[g + 16 >> 2] = 0 - F, v = E[g + 148 >> 2], E[g + 12 >> 2] = 0 - v, N = E[g + 144 >> 2], E[g + 8 >> 2] = 0 - N, L = E[g + 140 >> 2], E[g + 4 >> 2] = 0 - L, vA(g, g), I = Ig(S = E[g + 4 >> 2], U = S >> 31, G = R << 1, gA = G >> 31), C = w, B = Ig(p = E[g >> 2], M = p >> 31, k, b = k >> 31), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = Ig(K = E[g + 8 >> 2], P = K >> 31, F, H = F >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(l = E[g + 12 >> 2], j = l >> 31, V = v << 1, CA = V >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(q = E[g + 16 >> 2], Z = q >> 31, N, Y = N >> 31), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, pA = i = E[g + 20 >> 2], s = Ig(i, BA = i >> 31, W = L << 1, QA = W >> 31), B = w + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, wA = r = E[g + 24 >> 2], I = (Q = Ig(r, sA = r >> 31, s = Q + 1 | 0, d = s >> 31)) + C | 0, C = w + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, iA = E[g + 28 >> 2], B = (Q = Ig(f = c(iA, 19), X = f >> 31, T = u << 1, oA = T >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, SA = E[g + 32 >> 2], B = Ig(a = c(SA, 19), z = a >> 31, n, J = n >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, GA = E[g + 36 >> 2], B = Ig(y = c(GA, 19), m = y >> 31, $ = x << 1, EA = $ >> 31), I = w + I | 0, _ = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(F, H, S, U), C = w, o = Ig(p, M, R, aA = R >> 31), B = w + C | 0, B = (I = o + I | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Ig(K, P, v, _A = v >> 31), C = w + B | 0, C = (I = o + I | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(N, Y, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(q, Z, L, cA = L >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, d, i, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, o = Ig(r = c(r, 19), AA = r >> 31, u, tA = u >> 31), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(n, J, f, X)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(a, z, x, rA = x >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, k, b), I = w + I | 0, fA = C = C + B | 0, O = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(S, U, V, CA), B = w, C = (o = Ig(p, M, F, H)) + I | 0, I = w + B | 0, I = C >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(N, Y, K, P), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(l, j, W, QA)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(s, d, q, Z)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(o = c(i, 19), eA = o >> 31, T, oA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, r, AA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = Ig(f, X, $, EA), B = w + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = Ig(a, z, k, b)) + C | 0, C = w + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = Ig(y, m, G, gA)) + I | 0, I = w + C | 0, MA = B, bA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, KA = B = B + 33554432 | 0, HA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + O | 0, fA = i = B + fA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, YA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + _ | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, D = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 72 >> 2] = B - (-67108864 & C), I = Ig(S, U, W, QA), C = w, Q = Ig(p, M, N, Y), B = w + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(s, d, K, P)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(Q = c(l, 19), yA = Q >> 31, T, oA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(O = c(q, 19), hA = O >> 31, n, J)) + C | 0, C = w + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = Ig($, EA, o, eA), I = w + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = Ig(k, b, r, AA)) + B | 0, B = w + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = Ig(f, X, G, gA), I = w + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, F, H), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(y, m, V, CA)) + C | 0, C = w + I | 0, e = B, nA = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, I = Ig(s, d, S, U), C = w, B = (_ = Ig(p, M, L, cA)) + I | 0, I = w + C | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = C = c(K, 19), C = (t = Ig(C, DA = C >> 31, u, tA)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(n, J, Q, yA), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(O, hA, x, rA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (t = Ig(k, b, o, eA)) + C | 0, C = w + I | 0, C = B >>> 0 < t >>> 0 ? C + 1 | 0 : C, t = Ig(r, AA, R, aA), I = w + C | 0, I = (B = t + B | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = (t = Ig(F, H, f, X)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(a, z, v, _A), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(y, m, N, Y), I = w + I | 0, kA = C = B + C | 0, t = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(I = c(S, 19), I >> 31, T, oA), C = w, B = Ig(p, M, s, d), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (_ = Ig(n, J, _, DA)) + I | 0, I = w + C | 0, C = (Q = Ig(Q, yA, $, EA)) + B | 0, B = w + (B >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(k, b, O, hA), I = w + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(G, gA, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(F, H, r, AA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = Ig(f, X, V, CA), I = w + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = Ig(a, z, N, Y)) + B | 0, B = w + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(y, m, W, QA), I = w + B | 0, _ = C = Q + C | 0, yA = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, DA = C = C + 33554432 | 0, dA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + t | 0, t = Q = I + kA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, kA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + nA | 0, I = (C = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, nA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 56 >> 2] = B - (-67108864 & C), I = Ig(k, b, S, U), B = w, C = (e = Ig(p, M, x, rA)) + I | 0, I = w + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = Ig(K, P, R, aA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, l, j), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = Ig(q, Z, v, _A), B = w + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = Ig(N, Y, pA, BA)) + C | 0, C = w + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = Ig(L, cA, wA, sA)) + I | 0, I = w + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(iA, FA = iA >> 31, s, d), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, u, tA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (B = C) + (C = Ig(y, m, n, J)) | 0, B = w + I | 0, C = (I = i >> 26) + (C = C >>> 0 > e >>> 0 ? B + 1 | 0 : B) | 0, D = B = (i = (67108863 & i) << 6 | D >>> 26) + e | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, e = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 76 >> 2] = D - (-33554432 & B), I = Ig(N, Y, S, U), C = w, D = Ig(p, M, v, _A), B = w + C | 0, B = (I = D + I | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = Ig(K, P, L, cA), C = w + B | 0, C = (I = D + I | 0) >>> 0 < D >>> 0 ? C + 1 | 0 : C, B = (D = Ig(s, d, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < D >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(O, hA, u, tA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (r = Ig(r, AA, x, rA)) + C | 0, B = w + I | 0, I = (f = Ig(k, b, f, X)) + C | 0, C = w + (C >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (a = Ig(a, z, R, aA)) + I | 0, I = w + (I >>> 0 < f >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, F, H), I = w + I | 0, D = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, a = Q = D + (B = (67108863 & Q) << 6 | nA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, f = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 60 >> 2] = a - (-33554432 & C), I = Ig(S, U, $, EA), B = w, C = (a = Ig(p, M, n, J)) + I | 0, I = w + B | 0, I = C >>> 0 < a >>> 0 ? I + 1 | 0 : I, B = Ig(k, b, K, P), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, a = Ig(l, j, G, gA), B = w + I | 0, B = (C = a + C | 0) >>> 0 < a >>> 0 ? B + 1 | 0 : B, I = (a = Ig(F, H, q, Z)) + C | 0, C = w + B | 0, C = I >>> 0 < a >>> 0 ? C + 1 | 0 : C, B = (a = Ig(V, CA, pA, BA)) + I | 0, I = w + C | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(N, Y, wA, sA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = Ig(iA, FA, W, QA), I = w + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, a = C = SA, C = (G = Ig(C, r = C >> 31, s, d)) + B | 0, B = w + I | 0, I = (y = Ig(y, m, T, oA)) + C | 0, C = w + (C >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < y >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | e >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, y = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | f >>> 25) + (MA - (I = -67108864 & KA) | 0) | 0, I = C + (bA - ((I >>> 0 > MA >>> 0) + HA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (G = fA - (-33554432 & YA) | 0) | 0, E[g + 68 >> 2] = I, E[g + 64 >> 2] = B - (-67108864 & C), I = Ig(n, J, S, U), B = w, C = (Q = Ig(p, M, u, tA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(K, P, x, rA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = Ig(k, b, l, j)) + B | 0, B = w + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(q, Z, R, aA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, pA, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(v, _A, wA, sA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(N, Y, iA, FA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = Ig(a, r, L, cA)) + B | 0, B = w + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = Ig(I = GA, I >> 31, s, d), I = w + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | y >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 84 >> 2] = B - (-33554432 & C), i = t - (-33554432 & kA) | 0, Q = _ - (B = -67108864 & DA) | 0, p = yA - ((B >>> 0 > _ >>> 0) + dA | 0) | 0, I = Ig((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = w + p | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, E[g + 52 >> 2] = I, E[g + 48 >> 2] = B - (-67108864 & C), BI(A, g + 48 | 0)), h = g + 256 | 0, 0 | NA;
                                        },
                                        Pg: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, kI(g, I |= 0, 32, 0), o[0 | g] = 248 & a[0 | g], o[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0, 0;
                                        },
                                        Qg: Vg,
                                        Rg: HI,
                                        Sg: Rg,
                                        Tg: vI,
                                        Ug: BB,
                                        Vg: sB,
                                        Wg: tB,
                                        Xg: BB,
                                        Yg: QB,
                                        Zg: tB,
                                        _g: function(A, I, g, C, B) {
                                            return 0 | jg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        $g: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | Ug(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        ah: function(A, I, g, C, B, Q) {
                                            return 0 | ug(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        bh: function(A, I, g, C, B) {
                                            return 0 | Xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        ch: function(A, I, g, C, B, Q, i) {
                                            return 0 | gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        dh: function(A, I, g, C, B, Q) {
                                            return 0 | xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        eh: LC,
                                        fh: LC,
                                        gh: BB,
                                        hh: _B,
                                        ih: tB,
                                        jh: function() {
                                            return 1540;
                                        },
                                        kh: Tg,
                                        lh: zg,
                                        mh: LC,
                                        nh: BB,
                                        oh: sB,
                                        ph: tB,
                                        qh: function(A, I, g, C, B) {
                                            return 0 | pC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        rh: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | oC(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        sh: function(A, I, g, C, B, Q) {
                                            return 0 | aC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        th: LC,
                                        uh: Tg,
                                        vh: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, fA(E, B |= 0, o |= 0, 0), A = oC(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), XC(E, 32), h = E + 32 | 0, 0 | A;
                                        },
                                        wh: zg,
                                        xh: BB,
                                        yh: _B,
                                        zh: tB,
                                        Ah: LC,
                                        Bh: CB,
                                        Ch: BB,
                                        Dh: gB,
                                        Eh: iI,
                                        Fh: SC,
                                        Gh: GC,
                                        Hh: function() {
                                            return 1089;
                                        },
                                        Ih: function() {
                                            var A, I;
                                            return h = A = h - 16 | 0, o[A + 15 | 0] = 0, I = 0 | r(36800, A + 15 | 0, 0), h = A + 16 | 0, 0 | I;
                                        },
                                        Jh: $g,
                                        Kh: function(A) {
                                            var I, g = 0, C = 0;
                                            if (h = I = h - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; o[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(36800, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return h = I + 16 | 0, 0 | g;
                                        },
                                        Lh: ag,
                                        Mh: function(A, I, g) {
                                            Xg(A |= 0, I |= 0, 0, 1574, g |= 0);
                                        },
                                        Nh: BB,
                                        Oh: function() {
                                            var A = 0, I = 0;
                                            return (A = E[9524]) && (A = E[A + 20 >> 2]) && (I = 0 | pB[0 | A]()), 0 | I;
                                        },
                                        Ph: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, E = 0;
                                            if (h = C = h - 16 | 0, g |= 0) e(1329, 1175, 197, 1092), Q();
                                            else {
                                                if (I) for(; o[C + 15 | 0] = 0, i = A + B | 0, E = 0 | r(36800, C + 15 | 0, 0), o[0 | i] = E, (0 | I) != (0 | (B = B + 1 | 0)););
                                                h = C + 16 | 0;
                                            }
                                        },
                                        Qh: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, E = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (E = a[I + g | 0]), o[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = E >>> 4 | 0, o[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return o[I + A | 0] = 0, 0 | A;
                                            }
                                            yC(), Q();
                                        },
                                        Rh: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((s = (65526 + (t = (223 & (e = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (e ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                        if (t = t & s | e & h, 255 & r ? (o[A + y | 0] = B | t, y = y + 1 | 0) : B = t << 4, r ^= -1, (0 | (_ = _ + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    _ = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            o: {
                                                                                E: {
                                                                                    a: {
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = r = _ + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                                        if (c = t & e | s & h, !(255 & r)) break E;
                                                                                        o[A + y | 0] = c | p, y = y + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = _ + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break o;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= y >>> 0) break i;
                                                                                    c = t & e | s & h;
                                                                                }
                                                                                p = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            _ = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((_ = _ + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            E[9392] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    E[9392] = 28, D = -1, _ = _ - 1 | 0, y = 0;
                                                    break A;
                                                }
                                                c || (y = 0, D = -1);
                                            }
                                            return i ? E[i >> 2] = g + _ : (0 | C) != (0 | _) && (E[9392] = 28, D = -1), Q && (E[Q >> 2] = y), 0 | D;
                                        },
                                        Sh: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (yC(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        Th: LA,
                                        Uh: wA,
                                        Vh: function() {
                                            var A = 0;
                                            return E[9525] ? A = 1 : ($g(), ag(38080, 16), E[9525] = 1, A = 0), 0 | A;
                                        },
                                        Wh: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, _ = 0, c = 0, t = 0;
                                            h = i = h - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((_ = C - 1 | 0) & C ? (c = -1 ^ g, _ = _ - ((g >>> 0) % (C >>> 0) | 0) | 0) : _ &= c = -1 ^ g, c >>> 0 <= _ >>> 0) break A;
                                                    if (c = -1, !((g = g + _ | 0) >>> 0 >= B >>> 0)) for(A && (E[A >> 2] = g + 1), A = I + g | 0, c = 0, o[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, t = a[0 | I] & a[i + 15 | 0], I = (g ^ _) - 1 >>> 24 | 0, o[0 | B] = t | 128 & I, o[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return h = i + 16 | 0, 0 | c;
                                            }
                                            yC(), Q();
                                        },
                                        Xh: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, o = 0, _ = 0, c = 0;
                                            if (E[12 + (B = h - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; _ = ((128 ^ (i = a[c - g | 0])) - 1 & E[B + 12 >> 2] - 1 & o - 1) >>> 8 & 1, E[B + 12 >> 2] = E[B + 12 >> 2] | 0 - _ & g, I |= _, o |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                E[A >> 2] = Q - E[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        Yh: function() {
                                            return 1457;
                                        },
                                        Zh: function() {
                                            return 26;
                                        },
                                        _h: rB,
                                        $h: hB,
                                        ai: aI,
                                        bi: sC,
                                        ci: function(A, I, g) {
                                            A |= 0;
                                            var C, B = 0;
                                            return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = yA(A, 35584, C, 0)), h = C + 32 | 0, 0 | B;
                                        },
                                        di: lg,
                                        ei: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = rI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        fi: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | rI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        gi: function(A, I, g, C, B, Q, i) {
                                            return 0 | ig(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        hi: mg,
                                        ii: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = hI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        ji: Dg,
                                        ki: function(A, I, g, C, B, Q, i) {
                                            return 0 | Ag(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        li: BB,
                                        mi: BB,
                                        ni: BB,
                                        oi: BB,
                                        pi: _B,
                                        qi: CB,
                                        ri: oB,
                                        si: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, sC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = ig(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        ti: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = Ag(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ui: EB,
                                        vi: function(A) {
                                            var I, g = 0;
                                            return h = I = h - 160 | 0, GI(A |= 0) && (bI(A) || bA(I, A) || jA(I) && (g = 0 != (0 | IA(I)))), h = I + 160 | 0, 0 | g;
                                        },
                                        wi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        xi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        yi: function(A, I) {
                                            return b(A |= 0, I |= 0), 0;
                                        },
                                        zi: function(A) {
                                            var I;
                                            A |= 0, h = I = h - 32 | 0, ag(I, 32), b(A, I), h = I + 32 | 0;
                                        },
                                        Ai: Mg,
                                        Bi: FA,
                                        Ci: xA,
                                        Di: mA,
                                        Ei: cA,
                                        Fi: JA,
                                        Gi: AA,
                                        Hi: MC,
                                        Ii: BB,
                                        Ji: gB,
                                        Ki: BB,
                                        Li: gB,
                                        Mi: BB,
                                        Ni: function(A) {
                                            var I;
                                            return h = I = h - 160 | 0, A = EA(I, A |= 0), h = I + 160 | 0, 0 | !A;
                                        },
                                        Oi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Pi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Qi: function(A, I) {
                                            return jI(A |= 0, I |= 0), 0;
                                        },
                                        Ri: function(A) {
                                            var I;
                                            A |= 0, h = I = h + -64 | 0, ag(I, 64), jI(A, I), h = I - -64 | 0;
                                        },
                                        Si: function(A) {
                                            Mg(A |= 0);
                                        },
                                        Ti: function(A, I) {
                                            return 0 | FA(A |= 0, I |= 0);
                                        },
                                        Ui: function(A, I) {
                                            xA(A |= 0, I |= 0);
                                        },
                                        Vi: function(A, I) {
                                            mA(A |= 0, I |= 0);
                                        },
                                        Wi: function(A, I, g) {
                                            cA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Xi: function(A, I, g) {
                                            AA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Yi: MC,
                                        Zi: function(A, I) {
                                            JA(A |= 0, I |= 0);
                                        },
                                        _i: BB,
                                        $i: gB,
                                        aj: gB,
                                        bj: BB,
                                        cj: function(A, I, g, C, B, Q, i, o, E, a) {
                                            return 0 | rg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0);
                                        },
                                        dj: CB,
                                        ej: tB,
                                        fj: hB,
                                        gj: tB,
                                        hj: BB,
                                        ij: function() {
                                            return 102;
                                        },
                                        jj: function() {
                                            return 1570;
                                        },
                                        kj: function() {
                                            return 32768;
                                        },
                                        lj: tB,
                                        mj: zC,
                                        nj: tB,
                                        oj: function() {
                                            return 524288;
                                        },
                                        pj: zC,
                                        qj: jC,
                                        rj: xC,
                                        sj: function(A, I, g, C, B, Q, i, o, a, _) {
                                            var c, t, r;
                                            I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, a |= 0, _ |= 0, t = 0 | (o |= 0), h = o = h - 16 | 0, r = I |= 0, c = Hg(A |= 0, 0, I), A = 0 | B;
                                            A: if (1 == (0 | (B = g | Q)) | B >>> 0 > 1) E[9392] = 22, A = -1;
                                            else if (!g & I >>> 0 >= 16 | g) {
                                                if (BA(t, a, _, o + 12 | 0, o + 8 | 0, o + 4 | 0), (0 | C) == (0 | c)) {
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                B = A, A = 31 & (I = E[o + 12 >> 2]), (63 & I) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, A = rg(C, B, i, 32, g, I, E[o + 4 >> 2], E[o + 8 >> 2], c, r);
                                            } else E[9392] = 28, A = -1;
                                            return h = o + 16 | 0, 0 | A;
                                        },
                                        tj: function(A, I, g, C, B, Q, i) {
                                            I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0;
                                            var _, c, t, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0;
                                            r = B |= 0, r |= B = 0, h = _ = h - 128 | 0, c = Hg(A |= 0, 0, 102), D = 22, t = g | B;
                                            A: {
                                                if (!C) {
                                                    BA(r, Q, i, _ + 16 | 0, _ + 12 | 0, _ + 8 | 0), ag(e = _ + 96 | 0, 32), D = 28, g = _ + 32 | 0, Q = E[_ + 16 >> 2], i = Ig(A = E[_ + 12 >> 2], 0, C = E[_ + 8 >> 2], 0);
                                                    I: if (!(!(r = w) & i >>> 0 > 1073741823 | r | Q >>> 0 > 63) && (o[0 | g] = 36, o[g + 1 | 0] = 55, o[g + 2 | 0] = 36, o[g + 3 | 0] = a[Q + 1024 | 0], o[g + 4 | 0] = a[1024 + (63 & C) | 0], o[g + 5 | 0] = a[1024 + (C >>> 6 & 63) | 0], o[g + 6 | 0] = a[1024 + (C >>> 12 & 63) | 0], o[g + 7 | 0] = a[1024 + (C >>> 18 & 63) | 0], o[g + 8 | 0] = a[1024 + (C >>> 24 & 63) | 0], (C = g + 9 | 0) && (0 | C) != (0 | (y = g + 58 | 0)) && (o[0 | C] = a[1024 + (63 & A) | 0], 1 != (0 | (C = y - C | 0)) && (o[g + 10 | 0] = a[1024 + (A >>> 6 & 63) | 0], 2 != (0 | C) && (o[g + 11 | 0] = a[1024 + (A >>> 12 & 63) | 0], 3 != (0 | C) && (o[g + 12 | 0] = a[1024 + (A >>> 18 & 63) | 0], 4 != (0 | C) && (o[g + 13 | 0] = a[1024 + (A >>> 24 & 63) | 0], Q = g + 14 | 0))))))) {
                                                        for(r = y - Q | 0, A = 0;;){
                                                            if (C = Q, !(A >>> 0 >= 32)) {
                                                                if (Q = a[A + e | 0], (p = (i = A + 1 | 0) >>> 0 >= 32) ? s = 0 : (Q = a[i + e | 0] << 8 | Q, (i = A + 2 | 0) >>> 0 >= 32 ? s = 0 : (Q = a[i + e | 0] << 16 | Q, s = 1, i = A + 3 | 0)), A = i, !r) break I;
                                                                if (o[0 | C] = a[1024 + (63 & Q) | 0], 1 == (0 | r)) break I;
                                                                if (o[C + 1 | 0] = a[1024 + (Q >>> 6 & 63) | 0], f = C + r | 0, i = C + 2 | 0, !p) {
                                                                    if (2 == (0 | r)) break I;
                                                                    if (o[C + 2 | 0] = a[1024 + (Q >>> 12 & 63) | 0], i = C + 3 | 0, s) {
                                                                        if (3 == (0 | r)) break I;
                                                                        o[C + 3 | 0] = a[1024 + (Q >>> 18 | 0) | 0], i = C + 4 | 0;
                                                                    }
                                                                }
                                                                if (r = f - (Q = i) | 0, Q) continue;
                                                                break I;
                                                            }
                                                            break;
                                                        }
                                                        C >>> 0 >= y >>> 0 || (o[0 | C] = 0, B = g);
                                                    }
                                                    if (B) {
                                                        if (A = -1, _C(C = _ + 20 | 0)) break A;
                                                        if (I = ZA(C, I, t, g, c), vg(C), A = 0, I) break A;
                                                    }
                                                }
                                                E[9392] = D, A = -1;
                                            }
                                            return h = _ + 128 | 0, 0 | A;
                                        },
                                        uj: function(A, I, g, C) {
                                            I |= 0, C |= 0;
                                            var B, Q, i = 0;
                                            B = A |= 0, Q = g |= 0, g = 0, h = C = h - 128 | 0;
                                            A: {
                                                I: {
                                                    for(;;){
                                                        if (!a[g + B | 0]) {
                                                            A = g;
                                                            break I;
                                                        }
                                                        if (!a[B + (A = g + 1 | 0) | 0]) break I;
                                                        if (!a[B + (A = g + 2 | 0) | 0]) break I;
                                                        if (102 == (0 | (g = g + 3 | 0))) break;
                                                    }
                                                    g = -1;
                                                    break A;
                                                }
                                                g = -1, 101 == (0 | A) && (_C(i = C + 4 | 0) || (Hg(A = C + 16 | 0, 0, 102), I = ZA(i, I, Q, B, A), vg(i), I && (g = MI(A, B, 102), XC(A, 102))));
                                            }
                                            return h = C + 128 | 0, 0 | g;
                                        },
                                        vj: function(A, I, g, C) {
                                            var B, Q;
                                            Q = A |= 0, h = B = h - 32 | 0, BA(I |= 0, g |= 0, C |= 0, B + 28 | 0, B + 20 | 0, B + 12 | 0), A = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        for(;;){
                                                            if (a[A + Q | 0]) {
                                                                if (a[Q + (I = A + 1 | 0) | 0] && a[Q + (I = A + 2 | 0) | 0]) {
                                                                    if (102 != (0 | (A = A + 3 | 0))) continue;
                                                                    break g;
                                                                }
                                                            } else I = A;
                                                            break;
                                                        }
                                                        if (101 == (0 | I)) {
                                                            if (g = B + 8 | 0, C = B + 16 | 0, A = 0, 36 != a[0 | Q] | 55 != a[Q + 1 | 0] | 36 != a[Q + 2 | 0] || (I = uI(a[Q + 3 | 0]), E[B + 24 >> 2] = I ? I - 1024 | 0 : 0, I && (I = PI(g, Q + 4 | 0)) && (A = PI(C, I))), A) break I;
                                                            E[9392] = 28, A = -1;
                                                            break A;
                                                        }
                                                    }
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                A = 1, E[B + 28 >> 2] != E[B + 24 >> 2] | E[B + 12 >> 2] != E[B + 8 >> 2] || (A = E[B + 20 >> 2] != E[B + 16 >> 2]);
                                            }
                                            return h = B + 32 | 0, 0 | A;
                                        },
                                        wj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 1);
                                        },
                                        xj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        yj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 1);
                                        },
                                        zj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 0);
                                        },
                                        Aj: BB,
                                        Bj: BB,
                                        Cj: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return h = C = h - 320 | 0, B = -1, EA(C, g |= 0) || (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], u(I = C + 160 | 0, A, C), O(A, I), B = NI(A, 32) ? -1 : 0), h = C + 320 | 0, 0 | B;
                                        },
                                        Dj: function(A, I) {
                                            var g;
                                            return I |= 0, h = g = h - 160 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], kA(g, A), O(A, g), A = NI(A, 32), h = g + 160 | 0, 0 | (A ? -1 : 0);
                                        },
                                        Ej: BB,
                                        Fj: BB,
                                        Gj: lg,
                                        Hj: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), rI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Ij: mg,
                                        Jj: Dg,
                                        Kj: BB,
                                        Lj: _B,
                                        Mj: CB,
                                        Nj: oB,
                                        Oj: CB,
                                        Pj: CB,
                                        Qj: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                            if (n = 1886610805 ^ (E = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), D = 1936682341 ^ (i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E ^= 1852142177, _ = 1819895653 ^ i, k = 1852075907 ^ (i = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), p = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), c = 2037671283 ^ i, i = 1952801890 ^ B, h = g, (0 | (r = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (s = i ^ (f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + _ | 0, c = C = E + (B = c ^ (e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, t = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, E = C, C = g, g = D + p | 0, g = (i = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, y = (_ = KI(k, p, 13) ^ i) + E | 0, C = (E = w ^ g) + C | 0, E = KI(_, E, 17) ^ y, p = KI(E, C = (_ = _ >>> 0 > y >>> 0 ? C + 1 | 0 : C) ^ w, 13), D = w, s = KI(B, s, 16), B = t ^ w, s ^= c, t = KI(i, g, 32), g = w + B | 0, g = (c = C) + (C = (i = s + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) | 0, t = g = (c = i + E | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, p = KI(E = c ^ p, g ^= D, 17), D = w, s = KI(s, B, 21), B = C ^ w, s ^= i, i = KI(y, _, 32), C = w + B | 0, g = (i = i >>> 0 > (_ = s + i | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, k = (E = E + _ | 0) ^ p, C = g = E >>> 0 < _ >>> 0 ? g + 1 | 0 : g, p = g ^ D, g = KI(s, B, 16), s = i ^= w, y = KI(g ^= _, i, 21), _ = w, t = (i = KI(c, t, 32)) + g | 0, g = w + s | 0, c = t ^ y, i = (g = i >>> 0 > t >>> 0 ? g + 1 | 0 : g) ^ _, E = KI(E, C, 32), _ = w, n = e ^ t, D = g ^ f, (0 | r) != (0 | (I = I + 8 | 0)););
                                                I = r;
                                            }
                                            switch(e = 0, B = h << 24, Q - 1 | 0){
                                                case 6:
                                                    B |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    B |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    B |= a[I + 4 | 0];
                                                case 3:
                                                    e |= (g = a[I + 3 | 0]) << 24, B |= C = g >>> 8 | 0;
                                                case 2:
                                                    e |= (C = a[I + 2 | 0]) << 16, B |= g = C >>> 16 | 0;
                                                case 1:
                                                    e |= (g = a[I + 1 | 0]) << 8, B |= C = g >>> 24 | 0;
                                                case 0:
                                                    e = a[0 | I] | e;
                                            }
                                            return y = B, I = B ^ i, C = KI(B = c ^ e, I, 16), I = I + _ | 0, t = I = (c = B + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, r = KI(B = C ^ c, I ^= g = w, 21), i = w, g = D + p | 0, C = g = (E = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, _ = B, B = KI(E, g, 32), g = w + I | 0, I = i, i = g = B >>> 0 > (_ = _ + B | 0) >>> 0 ? g + 1 | 0 : g, D = KI(B = _ ^ r, I ^= g, 16), s = w, g = (E = h = KI(k, p, 13) ^ E) + c | 0, C = (c = w ^ C) + t | 0, t = B, B = KI(g, C = g >>> 0 < E >>> 0 ? C + 1 | 0 : C, 32), I = w + I | 0, p = B = (E = B >>> 0 > (r = t + B | 0) >>> 0 ? I + 1 | 0 : I) ^ s, t = D ^= r, s = KI(h, c, 17) ^ g, g = (h = w ^ C) + i | 0, I = g = (C = _ = (I = s) + _ | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, i = KI(C, g, 32), g = w + B | 0, _ = (c = i + t | 0) ^ e, y ^= t = i >>> 0 > c >>> 0 ? g + 1 | 0 : g, B = KI(s, h, 13) ^ C, C = KI(B, I ^= w, 17), I = I + E | 0, B = C ^ (i = B + r | 0), C = I = i >>> 0 < r >>> 0 ? I + 1 | 0 : I, g = (I ^= g = w) + y | 0, g = B >>> 0 > (_ = B + _ | 0) >>> 0 ? g + 1 | 0 : g, B = KI(B, I, 13) ^ _, E = g, r = KI(B, I = g ^ w, 17), e = w, y = KI(D, p, 21), h = t ^ w, t = c ^ y, i = 238 ^ KI(i, C, 32), g = w + h | 0, g = (c = I) + (I = (C = t + i | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g) | 0, i = g = (c = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ r, g ^= e, 13), y = w, t = KI(t, h, 16), h = I ^ w, r = C ^ t, C = KI(_, E, 32), I = w + h | 0, C = (_ = g) + (g = C >>> 0 > (E = r + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, _ = C = (t = B + E | 0) >>> 0 < E >>> 0 ? C + 1 | 0 : C, e = KI(B = e ^ t, I = C ^ y, 17), y = w, C = KI(r, h, 21), h = g ^ w, r = C ^ E, C = KI(c, i, 32), g = w + h | 0, g = (C = C >>> 0 > (E = r + C | 0) >>> 0 ? g + 1 | 0 : g) + I | 0, i = g = (c = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ e, I = g ^ y, 13), y = w, g = KI(r, h, 16), h = C ^ w, r = g ^ E, g = KI(t, _, 32), C = w + h | 0, g = (C = g >>> 0 > (E = r + g | 0) >>> 0 ? C + 1 | 0 : C) + I | 0, _ = g = (t = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, I = g ^ y, 17), y = w, g = KI(r, h, 21), h = C ^ w, r = g ^ E, E = KI(c, i, 32), g = w + h | 0, I = (g = (C = r + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g) + I | 0, E = I = (i = C + B | 0) >>> 0 < C >>> 0 ? I + 1 | 0 : I, e = KI(B = i ^ e, I ^= y, 13), y = w, c = KI(r, h, 16), r = g ^ w, c ^= C, _ = KI(t, _, 32), g = w + r | 0, g = (t = I) + (I = (C = c + _ | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g) | 0, _ = g = (t = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, g ^= y, 17), y = w, c = KI(c, r, 21), r = I ^ w, c ^= C, C = KI(i, E, 32), I = w + r | 0, C = (E = g) + (g = C >>> 0 > (i = c + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, E = B = (C = (I = B + i | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C) ^ y, y = I ^ e, c = KI(c, r, 16), r = g ^ w, i = (c ^= i) + (_ = KI(t, _, 32)) | 0, g = w + r | 0, I = KI(I, C, 32), e = w, C = g = i >>> 0 < _ >>> 0 ? g + 1 | 0 : g, _ = A, c = (t = KI(c, r, 21) ^ i) ^ I ^ i ^ y, o[0 | _] = c, o[_ + 1 | 0] = c >>> 8, o[_ + 2 | 0] = c >>> 16, o[_ + 3 | 0] = c >>> 24, g = (c = g ^ w) ^ e ^ g ^ B, o[_ + 4 | 0] = g, o[_ + 5 | 0] = g >>> 8, o[_ + 6 | 0] = g >>> 16, o[_ + 7 | 0] = g >>> 24, B = _, g = c + e | 0, g = (A = I + t | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, e = A, _ = KI(t, c, 16) ^ A, c = g, r = I = g ^ w, C = E + C | 0, y = (C = KI(i = (g = t = 221 ^ y) + i | 0, g = C = g >>> 0 > i >>> 0 ? C + 1 | 0 : C, 32)) + _ | 0, I = w + I | 0, f = KI(_, r, 21) ^ y, p = I = (_ = C >>> 0 > y >>> 0 ? I + 1 | 0 : I) ^ w, D = KI(f, I, 16), s = w, g = c + (r = g ^ (C = E << 13 | t >>> 19)) | 0, I = g = (C = A = e + (h = i ^ (t << 13 | E >>> 19)) | 0) >>> 0 < e >>> 0 ? g + 1 | 0 : g, A = KI(C, g, 32), g = p + w | 0, g = (i = (A = A + f | 0) >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ s, t = A, e = KI(s = D ^ A, g, 21), E = w, A = KI(h, r, 17), I = _ + (h = I ^ w) | 0, A = KI(C = y + (c = A ^ C) | 0, I = C >>> 0 < y >>> 0 ? I + 1 | 0 : I, 32), g = g + w | 0, r = g = (_ = E) ^ (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g), e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), g = i + (h = I ^ w) | 0, A = KI(I = t + (c = A ^ C) | 0, g = I >>> 0 < t >>> 0 ? g + 1 | 0 : g, 32), C = r + w | 0, r = i = (C = (A = A + s | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C) ^ y, t = A, e = KI(s = e ^ A, i, 21), y = w, A = KI(c, h, 17), g = E + (h = g ^ w) | 0, I = g = (i = _ + (c = A ^ I) | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g, A = KI(i, g, 32), g = r + w | 0, r = g = (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g) ^ y, e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), C = C + (c = I ^ w) | 0, A = KI(g = t + (i ^= A) | 0, C = g >>> 0 < t >>> 0 ? C + 1 | 0 : C, 32), I = r + w | 0, e = KI((A = A + s | 0) ^ e, (I = A >>> 0 < s >>> 0 ? I + 1 | 0 : I) ^ y, 21), y = w, t = KI(i, c, 17), i = C ^ w, t = KI(C = g ^ t, i, 13), g = E + i | 0, E = KI(i = (C = C + _ | 0) ^ t, g = w ^ (C >>> 0 < _ >>> 0 ? g + 1 | 0 : g), 17) ^ e, C = w ^ y, g = I + g | 0, I = A, A = KI(A = A + i | 0, g = I >>> 0 > A >>> 0 ? g + 1 | 0 : g, 32) ^ E ^ A, o[B + 8 | 0] = A, o[B + 9 | 0] = A >>> 8, o[B + 10 | 0] = A >>> 16, o[B + 11 | 0] = A >>> 24, A = g ^ w ^ C, o[B + 12 | 0] = A, o[B + 13 | 0] = A >>> 8, o[B + 14 | 0] = A >>> 16, o[B + 15 | 0] = A >>> 24, 0;
                                        },
                                        Rj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; IC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, IC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Sj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Tj: BB,
                                        Uj: sB,
                                        Vj: tB,
                                        Wj: LC,
                                        Xj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; gC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, gC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Yj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Zj: BB,
                                        _j: sB,
                                        $j: tB,
                                        ak: LC,
                                        bk: BB,
                                        ck: _B,
                                        dk: tB,
                                        ek: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, h = Q = h - 32 | 0, yA(Q, C |= 0, B |= 0, 0), A = jg(A, I, g, C + 16 | 0, Q), h = Q + 32 | 0, 0 | A;
                                        },
                                        fk: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, yA(E, B |= 0, o |= 0, 0), A = Ug(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), h = E + 32 | 0, 0 | A;
                                        },
                                        gk: function(A, I, g, C, B, Q) {
                                            var i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = i = h - 32 | 0, yA(i, B |= 0, Q |= 0, 0), A = Ug(A, I, g, C, B + 16 | 0, 0, 0, i), h = i + 32 | 0, 0 | A;
                                        },
                                        hk: LC,
                                        ik: K,
                                        jk: gA,
                                        kk: pB
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new s.Module(A);
                                    g({
                                        instance: new s.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof s && d("no native wasm support detected");
                    var h, D, p, w, f, n, k, F = !1;
                    function N() {
                        var A = y.buffer;
                        Q.HEAP8 = h = new Int8Array(A), Q.HEAP16 = p = new Int16Array(A), Q.HEAPU8 = D = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = w = new Int32Array(A), Q.HEAPU32 = f = new Uint32Array(A), Q.HEAPF32 = n = new Float32Array(A), Q.HEAPF64 = k = new Float64Array(A);
                    }
                    var S = Q.INITIAL_MEMORY || 50331648;
                    S >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + S + "! (STACK_SIZE=65536)"), y = Q.wasmMemory ? Q.wasmMemory : new s.Memory({
                        initial: S / 65536,
                        maximum: 32768
                    }), N(), S = y.buffer.byteLength;
                    var G = [], M = [], b = [], K = 0, H = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), e(A = "Aborted(" + A + ")"), F = !0, A += ". Build with -sASSERTIONS for more info.", new s.RuntimeError(A);
                    }
                    var J, U, l = "data:application/octet-stream;base64,";
                    function m(A) {
                        return A.startsWith(l);
                    }
                    m(J = "<<< WASM_BINARY_FILE >>>") || (U = J, J = Q.locateFile ? Q.locateFile(U, _) : _ + U);
                    var u, x = {
                        36800: ()=>Q.getRandomValue(),
                        36836: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("eKUBg")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, R = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, v = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && v) return v.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var o = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var E = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | o);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(D, A, I) : "", P = [], q = (A)=>{
                        var I = (A - y.buffer.byteLength + 65535) / 65536;
                        try {
                            return y.grow(I), N(), 1;
                        } catch (A) {}
                    }, z = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${L(A)}, at: ` + [
                                I ? L(I) : "unknown filename",
                                g,
                                C ? L(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(P.length = 0; g = D[A++];)I += 105 != g && I % 8 ? 4 : 0, P.push(105 == g ? w[I >> 2] : k[I >> 3]), I += 105 == g ? 4 : 8;
                                    return P;
                                })(I, g);
                                return x[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = D.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (q(i)) return !0;
                            }
                            return !1;
                        },
                        a: y
                    }, j = function() {
                        var A, I, g = {
                            a: z
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (j = C).kk, g = j.f, M.unshift(g), function(A) {
                                if (K--, Q.monitorRunDependencies && Q.monitorRunDependencies(K), 0 == K && (null !== H && (clearInterval(H), H = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (K++, Q.monitorRunDependencies && Q.monitorRunDependencies(K), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return e(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == J && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (m(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $dea2138707f9c17c$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(l.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(J).then((I)=>s.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            e(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function X() {
                        function A() {
                            u || (u = !0, Q.calledRun = !0, F || (R(M), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), b.unshift(A);
                                var A;
                                R(b);
                            }()));
                        }
                        K > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                            var A;
                            R(G);
                        }(), K > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = j.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = j.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = j.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = j.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = j.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = j.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = j.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = j.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = j.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = j.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = j.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = j.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = j.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = j.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = j.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = j.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = j.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = j.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = j.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = j.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = j.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = j.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = j.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = j.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = j.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = j.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = j.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = j.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = j.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = j.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = j.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = j.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = j.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = j.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = j.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = j.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = j.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = j.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = j.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = j.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = j.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = j.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = j.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = j.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = j.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = j.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = j._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = j.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = j.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = j.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = j.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = j.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = j.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = j.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = j.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = j.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = j.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = j.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = j.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = j.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = j.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = j.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = j.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = j.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = j.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = j.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = j.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = j.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = j.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = j.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = j.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = j.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = j.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = j.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = j.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = j.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = j.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = j.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = j.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = j.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = j.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = j.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = j.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = j.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = j.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = j.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = j.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = j.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = j.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = j.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = j.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = j.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = j.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = j.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = j.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = j.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = j.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = j.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = j.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = j.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = j._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = j.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = j.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = j.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = j.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = j.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = j.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = j.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = j.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = j.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = j.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = j.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = j.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = j.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = j.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = j.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = j.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = j.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = j.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = j.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = j.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = j.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = j.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = j.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = j.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = j.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = j.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = j.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = j.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = j.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = j.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = j.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = j.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = j.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = j.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = j.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = j.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = j.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = j.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = j.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = j.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = j.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = j.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = j.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = j.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = j.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = j.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = j.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = j.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = j.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = j.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = j.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = j.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = j.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = j._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = j.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = j.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = j.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = j.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = j.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = j.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = j.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = j.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = j.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = j.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = j.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = j.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = j.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = j.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = j.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = j.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = j.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = j.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = j.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = j.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = j.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = j.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = j.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = j.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = j.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = j.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = j.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = j.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = j.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = j.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = j.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = j.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = j.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = j.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = j.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = j.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = j.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = j.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = j.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = j.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = j.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = j.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = j.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = j.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = j.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = j.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = j.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = j.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = j.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = j.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = j.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = j.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = j.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = j._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = j.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = j.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = j.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = j.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = j.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = j.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = j.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = j.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = j.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = j.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = j.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = j.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = j.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = j.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = j.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = j.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = j.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = j.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = j.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = j.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = j.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = j.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = j.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = j.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = j.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = j.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = j.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = j.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = j.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = j.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = j.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = j.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = j.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = j.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = j.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = j.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = j.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = j.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = j.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = j.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = j.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = j.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = j.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = j.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = j.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = j.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = j.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = j.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = j.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = j.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = j.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = j.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = j.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = j._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = j.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = j.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = j.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = j.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = j.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = j.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = j.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = j.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = j.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = j.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = j.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = j.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = j.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = j.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = j.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = j.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = j.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = j.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = j.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = j.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = j.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = j.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = j.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = j.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = j.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = j.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = j.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = j.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = j.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = j.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = j.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = j.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = j.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = j.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = j.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = j.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = j.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = j.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = j.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = j.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = j.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = j.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = j.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = j.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = j.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = j.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = j.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = j.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = j.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = j.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = j.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = j.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = j.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = j._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = j.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = j.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = j.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = j.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = j.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = j.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = j.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = j.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = j.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = j.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = j.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = j.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = j.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = j.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = j.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = j.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = j.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = j.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = j.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = j.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = j.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = j.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = j.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = j.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = j.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = j.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = j.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = j.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = j.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = j.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = j.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = j.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = j.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = j.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = j.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = j.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = j.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = j.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = j.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = j.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = j.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = j.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = j.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = j.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = j.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = j.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = j.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = j.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = j.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = j.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = j.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = j.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = j._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = j.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = j.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = j.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = j.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = j.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = j.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = j.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = j.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = j.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = j.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = j.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = j.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = j.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = j.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = j.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = j.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = j.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = j.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = j.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = j.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = j.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = j.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = j.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = j.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = j.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = j.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = j.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = j.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = j.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = j.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = j.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = j.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = j.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = j.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = j.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = j.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = j.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = j.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = j.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = j.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = j.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = j.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = j.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = j.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = j.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = j.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = j.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = j.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = j.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = j.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = j.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = j.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = j.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = j._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = j.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = j.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = j.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = j.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = j.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = j.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = j.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = j.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = j.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = j.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = j.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = j.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = j.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = j.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = j.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = j.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = j.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = j.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = j.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = j.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = j.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = j.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = j.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = j.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = j.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = j.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = j.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = j.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = j.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = j.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = j.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = j.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = j.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = j.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = j.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = j.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = j.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = j.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = j.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = j.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = j.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = j.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = j.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = j.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = j.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = j.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = j.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = j.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = j.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = j.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = j.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = j.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = j.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = j._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = j.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = j.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = j.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = j.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = j.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = j.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = j.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = j.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = j.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = j.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = j.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = j.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = j.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = j.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = j.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = j.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = j.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = j.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = j.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = j.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = j.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = j.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = j.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = j.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = j.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = j.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = j.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = j.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = j.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = j.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = j.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = j.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = j.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = j.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = j.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = j.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = j.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = j.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = j.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = j.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = j.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = j.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = j.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = j.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = j.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = j.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = j.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = j.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = j.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = j.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = j.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = j.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = j.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = j._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = j.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = j.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = j.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = j.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = j.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = j.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = j.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = j.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = j.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = j.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = j.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = j.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = j.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = j.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = j.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = j.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = j.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = j.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = j.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = j.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = j.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = j.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = j.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = j.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = j.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = j.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = j.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = j.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = j.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = j.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = j.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = j.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = j.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = j.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = j.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = j.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = j.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = j.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = j.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = j.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = j.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = j.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = j.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = j.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = j.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = j.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = j.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = j.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = j.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = j.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = j.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = j.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = j.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = j._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = j.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = j.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = j.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = j.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = j.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = j.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = j.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = j.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = j.hk)(A), Q._malloc = (A)=>(Q._malloc = j.ik)(A), Q._free = (A)=>(Q._free = j.jk)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                h[A >> 0] = I;
                                break;
                            case "i16":
                                p[A >> 1] = I;
                                break;
                            case "i32":
                                w[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                n[A >> 2] = I;
                                break;
                            case "double":
                                k[A >> 3] = I;
                                break;
                            case "*":
                                f[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return h[A >> 0];
                            case "i16":
                                return p[A >> 1];
                            case "i32":
                                return w[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return n[A >> 2];
                            case "double":
                                return k[A >> 3];
                            case "*":
                                return f[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = L, Y = function A() {
                        u || X(), u || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    X();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $ibaza && "object" == typeof $ibaza.versions && "string" == typeof $ibaza.versions.node, _ = "";
            if (a) {
                var c = (parcelRequire("foUwZ")), t = (parcelRequire("foUwZ"));
                _ = E ? t.dirname(_) + "/" : $dea2138707f9c17c$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $ibaza.argv.length > 1 && $ibaza.argv[1].replace(/\\/g, "/"), $ibaza.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, E && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, e, y = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && H("no native wasm support detected");
            var s, h, D, p, w, f, n, k = !1;
            function F() {
                var A = e.buffer;
                Q.HEAP8 = s = new Int8Array(A), Q.HEAP16 = D = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = p = new Int32Array(A), Q.HEAPU32 = w = new Uint32Array(A), Q.HEAPF32 = f = new Float32Array(A), Q.HEAPF64 = n = new Float64Array(A);
            }
            var N = [], S = [], G = [], M = 0, b = null, K = null;
            function H(A) {
                throw Q.onAbort && Q.onAbort(A), y(A = "Aborted(" + A + ")"), k = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, J = "data:application/octet-stream;base64,";
            function U(A) {
                return A.startsWith(J);
            }
            U(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, _) : _ + d);
            var l, m = {
                36800: ()=>Q.getRandomValue(),
                36836: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("eKUBg")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, u = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, R = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var o = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var E = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | o);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(h, A, I) : "", v = [], L = (A)=>{
                var I = (A - e.buffer.byteLength + 65535) / 65536;
                try {
                    return e.grow(I), F(), 1;
                } catch (A) {}
            }, P = {
                b: (A, I, g, C)=>{
                    H(`Assertion failed: ${R(A)}, at: ` + [
                        I ? R(I) : "unknown filename",
                        g,
                        C ? R(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    H("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(v.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, v.push(105 == g ? p[I >> 2] : n[I >> 3]), I += 105 == g ? 4 : 8;
                            return v;
                        })(I, g);
                        return m[A].apply(null, C);
                    })(A, I, g),
                e: (A, I, g)=>h.copyWithin(A, I, I + g),
                d: (A)=>{
                    var I = h.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (L(i)) return !0;
                    }
                    return !1;
                }
            }, q = function() {
                var A, I, g = {
                    a: P
                };
                function C(A, I) {
                    var g = A.exports;
                    return e = (q = g).f, F(), q.kk, function(A) {
                        if (M--, Q.monitorRunDependencies && Q.monitorRunDependencies(M), 0 == M && (null !== b && (clearInterval(b), b = null), K)) {
                            var I = K;
                            K = null, I();
                        }
                    }(), g;
                }
                if (M++, Q.monitorRunDependencies && Q.monitorRunDependencies(M), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return y(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (U(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $dea2138707f9c17c$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(J.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    y(`failed to asynchronously prepare wasm: ${A}`), H(A);
                }), {};
            }();
            function z() {
                function A() {
                    l || (l = !0, Q.calledRun = !0, k || (u(S), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), G.unshift(A);
                        var A;
                        u(G);
                    }()));
                }
                M > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), N.unshift(A);
                    var A;
                    u(N);
                }(), M > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = q.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = q.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = q.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = q.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = q.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = q.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = q.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = q.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = q.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = q.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = q.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = q.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = q.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = q.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = q.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = q.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = q.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = q.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = q.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = q.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = q.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = q.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = q.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = q.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = q.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = q.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = q.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = q.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = q.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = q.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = q.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = q.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = q.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = q.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = q.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = q.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = q.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = q.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = q.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = q.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = q.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = q.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = q.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = q.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = q.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = q.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = q._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = q.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = q.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = q.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = q.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = q.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = q.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = q.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = q.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = q.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = q.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = q.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = q.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = q.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = q.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = q.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = q.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = q.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = q.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = q.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = q.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = q.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = q.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = q.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = q.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = q.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = q.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = q.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = q.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = q.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = q.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = q.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = q.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = q.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = q.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = q.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = q.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = q.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = q.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = q.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = q.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = q.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = q.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = q.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = q.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = q.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = q.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = q.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = q.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = q.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = q.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = q.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = q.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = q.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = q._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = q.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = q.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = q.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = q.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = q.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = q.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = q.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = q.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = q.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = q.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = q.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = q.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = q.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = q.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = q.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = q.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = q.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = q.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = q.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = q.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = q.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = q.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = q.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = q.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = q.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = q.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = q.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = q.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = q.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = q.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = q.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = q.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = q.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = q.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = q.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = q.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = q.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = q.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = q.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = q.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = q.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = q.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = q.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = q.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = q.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = q.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = q.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = q.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = q.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = q.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = q.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = q.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = q.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = q._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = q.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = q.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = q.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = q.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = q.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = q.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = q.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = q.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = q.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = q.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = q.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = q.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = q.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = q.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = q.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = q.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = q.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = q.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = q.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = q.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = q.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = q.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = q.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = q.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = q.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = q.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = q.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = q.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = q.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = q.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = q.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = q.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = q.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = q.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = q.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = q.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = q.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = q.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = q.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = q.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = q.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = q.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = q.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = q.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = q.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = q.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = q.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = q.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = q.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = q.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = q.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = q.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = q.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = q._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = q.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = q.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = q.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = q.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = q.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = q.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = q.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = q.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = q.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = q.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = q.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = q.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = q.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = q.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = q.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = q.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = q.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = q.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = q.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = q.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = q.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = q.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = q.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = q.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = q.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = q.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = q.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = q.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = q.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = q.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = q.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = q.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = q.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = q.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = q.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = q.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = q.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = q.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = q.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = q.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = q.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = q.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = q.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = q.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = q.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = q.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = q.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = q.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = q.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = q.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = q.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = q.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = q.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = q._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = q.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = q.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = q.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = q.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = q.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = q.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = q.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = q.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = q.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = q.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = q.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = q.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = q.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = q.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = q.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = q.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = q.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = q.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = q.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = q.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = q.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = q.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = q.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = q.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = q.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = q.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = q.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = q.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = q.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = q.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = q.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = q.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = q.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = q.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = q.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = q.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = q.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = q.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = q.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = q.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = q.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = q.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = q.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = q.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = q.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = q.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = q.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = q.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = q.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = q.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = q.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = q.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = q.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = q._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = q.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = q.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = q.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = q.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = q.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = q.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = q.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = q.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = q.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = q.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = q.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = q.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = q.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = q.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = q.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = q.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = q.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = q.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = q.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = q.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = q.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = q.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = q.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = q.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = q.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = q.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = q.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = q.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = q.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = q.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = q.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = q.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = q.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = q.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = q.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = q.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = q.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = q.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = q.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = q.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = q.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = q.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = q.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = q.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = q.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = q.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = q.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = q.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = q.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = q.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = q.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = q.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = q._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = q.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = q.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = q.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = q.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = q.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = q.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = q.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = q.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = q.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = q.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = q.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = q.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = q.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = q.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = q.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = q.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = q.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = q.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = q.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = q.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = q.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = q.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = q.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = q.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = q.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = q.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = q.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = q.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = q.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = q.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = q.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = q.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = q.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = q.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = q.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = q.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = q.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = q.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = q.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = q.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = q.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = q.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = q.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = q.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = q.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = q.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = q.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = q.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = q.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = q.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = q.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = q.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = q.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = q._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = q.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = q.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = q.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = q.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = q.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = q.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = q.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = q.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = q.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = q.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = q.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = q.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = q.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = q.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = q.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = q.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = q.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = q.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = q.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = q.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = q.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = q.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = q.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = q.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = q.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = q.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = q.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = q.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = q.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = q.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = q.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = q.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = q.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = q.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = q.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = q.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = q.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = q.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = q.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = q.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = q.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = q.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = q.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = q.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = q.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = q.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = q.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = q.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = q.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = q.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = q.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = q.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = q.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = q._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = q.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = q.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = q.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = q.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = q.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = q.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = q.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = q.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = q.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = q.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = q.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = q.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = q.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = q.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = q.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = q.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = q.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = q.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = q.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = q.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = q.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = q.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = q.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = q.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = q.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = q.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = q.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = q.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = q.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = q.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = q.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = q.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = q.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = q.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = q.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = q.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = q.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = q.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = q.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = q.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = q.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = q.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = q.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = q.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = q.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = q.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = q.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = q.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = q.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = q.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = q.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = q.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = q.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = q._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = q.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = q.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = q.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = q.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = q.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = q.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = q.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = q.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = q.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = q.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = q.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = q.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = q.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = q.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = q.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = q.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = q.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = q.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = q.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = q.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = q.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = q.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = q.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = q.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = q.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = q.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = q.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = q.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = q.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = q.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = q.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = q.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = q.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = q.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = q.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = q.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = q.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = q.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = q.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = q.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = q.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = q.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = q.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = q.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = q.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = q.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = q.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = q.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = q.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = q.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = q.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = q.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = q.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = q._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = q.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = q.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = q.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = q.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = q.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = q.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = q.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = q.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = q.hk)(A), Q._malloc = (A)=>(Q._malloc = q.ik)(A), Q._free = (A)=>(Q._free = q.jk)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        s[A >> 0] = I;
                        break;
                    case "i16":
                        D[A >> 1] = I;
                        break;
                    case "i32":
                        p[A >> 2] = I;
                        break;
                    case "i64":
                        H("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        f[A >> 2] = I;
                        break;
                    case "double":
                        n[A >> 3] = I;
                        break;
                    case "*":
                        w[A >> 2] = I;
                        break;
                    default:
                        H(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return s[A >> 0];
                    case "i16":
                        return D[A >> 1];
                    case "i32":
                        return p[A >> 2];
                    case "i64":
                        H("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return f[A >> 2];
                    case "double":
                        return n[A >> 3];
                    case "*":
                        return w[A >> 2];
                    default:
                        H(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = R, K = function A() {
                l || z(), l || (K = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            z();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});



parcelRegister("e5tSL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $a418b64e37b177c5$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch  {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("eKUBg"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch  {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $a418b64e37b177c5$var$Random;

});

parcelRegister("gTsoG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

var $5bhDk = parcelRequire("5bhDk");

var $iuTQ4 = parcelRequire("iuTQ4");
class $c4c7cf763abbd65a$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $5bhDk.ripemd160.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $iuTQ4.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Ripemd160 = $c4c7cf763abbd65a$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $c4c7cf763abbd65a$var$ripemd160(data) {
    return new $c4c7cf763abbd65a$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $c4c7cf763abbd65a$var$ripemd160;

});
parcelRegister("5bhDk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $1dDg0 = parcelRequire("1dDg0");

var $9lwKa = parcelRequire("9lwKa");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $3c5ba87025e068a4$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $3c5ba87025e068a4$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $3c5ba87025e068a4$var$Pi = /* @__PURE__ */ $3c5ba87025e068a4$var$Id.map((i)=>(9 * i + 5) % 16);
let $3c5ba87025e068a4$var$idxL = [
    $3c5ba87025e068a4$var$Id
];
let $3c5ba87025e068a4$var$idxR = [
    $3c5ba87025e068a4$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $3c5ba87025e068a4$var$idxL,
    $3c5ba87025e068a4$var$idxR
])j.push(j[i].map((k)=>$3c5ba87025e068a4$var$Rho[k]));
const $3c5ba87025e068a4$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $3c5ba87025e068a4$var$shiftsL = /* @__PURE__ */ $3c5ba87025e068a4$var$idxL.map((idx, i)=>idx.map((j)=>$3c5ba87025e068a4$var$shifts[i][j]));
const $3c5ba87025e068a4$var$shiftsR = /* @__PURE__ */ $3c5ba87025e068a4$var$idxR.map((idx, i)=>idx.map((j)=>$3c5ba87025e068a4$var$shifts[i][j]));
const $3c5ba87025e068a4$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $3c5ba87025e068a4$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $3c5ba87025e068a4$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $3c5ba87025e068a4$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $3c5ba87025e068a4$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $3c5ba87025e068a4$var$RIPEMD160 extends $1dDg0.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$3c5ba87025e068a4$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $3c5ba87025e068a4$var$Kl[group], hbr = $3c5ba87025e068a4$var$Kr[group]; // prettier-ignore
            const rl = $3c5ba87025e068a4$var$idxL[group], rr = $3c5ba87025e068a4$var$idxR[group]; // prettier-ignore
            const sl = $3c5ba87025e068a4$var$shiftsL[group], sr = $3c5ba87025e068a4$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $3c5ba87025e068a4$var$rotl(al + $3c5ba87025e068a4$var$f(group, bl, cl, dl) + $3c5ba87025e068a4$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $3c5ba87025e068a4$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $3c5ba87025e068a4$var$rotl(ar + $3c5ba87025e068a4$var$f(rGroup, br, cr, dr) + $3c5ba87025e068a4$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $3c5ba87025e068a4$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $3c5ba87025e068a4$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $3c5ba87025e068a4$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $9lwKa.wrapConstructor)(()=>new $3c5ba87025e068a4$var$RIPEMD160());

});


parcelRegister("iR4fK", function(module, exports) {
"use strict";
var $dba079c5af9d0a3c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $94ZnX = parcelRequire("94ZnX");

const $dba079c5af9d0a3c$var$bn_js_1 = $dba079c5af9d0a3c$var$__importDefault((parcelRequire("lONYJ")));

const $dba079c5af9d0a3c$var$elliptic_1 = $dba079c5af9d0a3c$var$__importDefault((parcelRequire("7kgn0")));

var $3mmn4 = parcelRequire("3mmn4");
const $dba079c5af9d0a3c$var$secp256k1 = new $dba079c5af9d0a3c$var$elliptic_1.default.ec("secp256k1");
const $dba079c5af9d0a3c$var$secp256k1N = new $dba079c5af9d0a3c$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $dba079c5af9d0a3c$var$Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */ static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $dba079c5af9d0a3c$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $dba079c5af9d0a3c$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($dba079c5af9d0a3c$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $94ZnX.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */ static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $dba079c5af9d0a3c$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $3mmn4.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $dba079c5af9d0a3c$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $94ZnX.toHex)(signature.r()),
            s: (0, $94ZnX.toHex)(signature.s())
        };
        const point = $dba079c5af9d0a3c$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $dba079c5af9d0a3c$var$secp256k1.keyFromPublic(point);
        return (0, $94ZnX.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */ static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($dba079c5af9d0a3c$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */ static uncompressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return Uint8Array.from($dba079c5af9d0a3c$var$secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $dba079c5af9d0a3c$var$Secp256k1;

});
parcelRegister("3mmn4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $2724c79bf85753b7$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $2724c79bf85753b7$var$derTagInteger = 0x02;
class $2724c79bf85753b7$var$Secp256k1Signature {
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $2724c79bf85753b7$var$Secp256k1Signature($2724c79bf85753b7$var$trimLeadingNullBytes(data.slice(0, 32)), $2724c79bf85753b7$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $2724c79bf85753b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $2724c79bf85753b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $2724c79bf85753b7$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $2724c79bf85753b7$var$trimLeadingNullBytes(rData), $2724c79bf85753b7$var$trimLeadingNullBytes(sData));
    }
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $2724c79bf85753b7$var$derTagInteger,
            rLength,
            ...rEncoded,
            $2724c79bf85753b7$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $2724c79bf85753b7$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $2724c79bf85753b7$var$ExtendedSecp256k1Signature extends $2724c79bf85753b7$var$Secp256k1Signature {
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $2724c79bf85753b7$var$ExtendedSecp256k1Signature($2724c79bf85753b7$var$trimLeadingNullBytes(data.slice(0, 32)), $2724c79bf85753b7$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $2724c79bf85753b7$var$ExtendedSecp256k1Signature;

});


parcelRegister("fQNhx", function(module, exports) {
"use strict";
var $b8a1f0b05a1510b5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

const $b8a1f0b05a1510b5$var$bn_js_1 = $b8a1f0b05a1510b5$var$__importDefault((parcelRequire("lONYJ")));

const $b8a1f0b05a1510b5$var$elliptic_1 = $b8a1f0b05a1510b5$var$__importDefault((parcelRequire("7kgn0")));

var $7p4Gq = parcelRequire("7p4Gq");

var $gfTDf = parcelRequire("gfTDf");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $b8a1f0b05a1510b5$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($b8a1f0b05a1510b5$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $b8a1f0b05a1510b5$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $b8a1f0b05a1510b5$var$Slip10Curve.Ed25519:
            return $b8a1f0b05a1510b5$var$Slip10Curve.Ed25519;
        case $b8a1f0b05a1510b5$var$Slip10Curve.Secp256k1:
            return $b8a1f0b05a1510b5$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $b8a1f0b05a1510b5$var$slip10CurveFromString;
class $b8a1f0b05a1510b5$var$Slip10RawIndex extends $h3uvW.Uint32 {
    static hardened(hardenedIndex) {
        return new $b8a1f0b05a1510b5$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $b8a1f0b05a1510b5$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $b8a1f0b05a1510b5$var$Slip10RawIndex;
const $b8a1f0b05a1510b5$var$secp256k1 = new $b8a1f0b05a1510b5$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $b8a1f0b05a1510b5$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $7p4Gq.Hmac($gfTDf.Sha512, (0, $94ZnX.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $b8a1f0b05a1510b5$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $7p4Gq.Hmac($gfTDf.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $b8a1f0b05a1510b5$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$b8a1f0b05a1510b5$var$Slip10.serializedPoint(curve, new $b8a1f0b05a1510b5$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $7p4Gq.Hmac($gfTDf.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $b8a1f0b05a1510b5$var$Slip10Curve.Secp256k1:
                return (0, $94ZnX.fromHex)($b8a1f0b05a1510b5$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $b8a1f0b05a1510b5$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $b8a1f0b05a1510b5$var$bn_js_1.default(il).add(new $b8a1f0b05a1510b5$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $7p4Gq.Hmac($gfTDf.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $b8a1f0b05a1510b5$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $b8a1f0b05a1510b5$var$Slip10Curve.Secp256k1:
                return new $b8a1f0b05a1510b5$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $b8a1f0b05a1510b5$var$Slip10;
function $b8a1f0b05a1510b5$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $b8a1f0b05a1510b5$var$pathToString;
function $b8a1f0b05a1510b5$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $h3uvW.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($b8a1f0b05a1510b5$var$Slip10RawIndex.hardened(value));
        else out.push($b8a1f0b05a1510b5$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $b8a1f0b05a1510b5$var$stringToPath;

});


parcelRegister("dKZ7y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.encodeEd25519Pubkey = module.exports.encodeSecp256k1Pubkey = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $hm8y1 = parcelRequire("hm8y1");

var $1cagW = parcelRequire("1cagW");
/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $a03efb8ea30d3978$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $1cagW.pubkeyType.secp256k1,
        value: (0, $94ZnX.toBase64)(pubkey)
    };
}
module.exports.encodeSecp256k1Pubkey = $a03efb8ea30d3978$var$encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $a03efb8ea30d3978$var$encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) throw new Error("Ed25519 public key must be 32 bytes long");
    return {
        type: $1cagW.pubkeyType.ed25519,
        value: (0, $94ZnX.toBase64)(pubkey)
    };
}
module.exports.encodeEd25519Pubkey = $a03efb8ea30d3978$var$encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $a03efb8ea30d3978$var$pubkeyAminoPrefixSecp256k1 = (0, $94ZnX.fromHex)("eb5ae98721" /* fixed length */ );
const $a03efb8ea30d3978$var$pubkeyAminoPrefixEd25519 = (0, $94ZnX.fromHex)("1624de6420" /* fixed length */ );
const $a03efb8ea30d3978$var$pubkeyAminoPrefixSr25519 = (0, $94ZnX.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $a03efb8ea30d3978$var$pubkeyAminoPrefixMultisigThreshold = (0, $94ZnX.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $a03efb8ea30d3978$var$decodeAminoPubkey(data) {
    if ((0, $hm8y1.arrayContentStartsWith)(data, $a03efb8ea30d3978$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($a03efb8ea30d3978$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $1cagW.pubkeyType.secp256k1,
            value: (0, $94ZnX.toBase64)(rest)
        };
    } else if ((0, $hm8y1.arrayContentStartsWith)(data, $a03efb8ea30d3978$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($a03efb8ea30d3978$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $1cagW.pubkeyType.ed25519,
            value: (0, $94ZnX.toBase64)(rest)
        };
    } else if ((0, $hm8y1.arrayContentStartsWith)(data, $a03efb8ea30d3978$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($a03efb8ea30d3978$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $1cagW.pubkeyType.sr25519,
            value: (0, $94ZnX.toBase64)(rest)
        };
    } else if ((0, $hm8y1.arrayContentStartsWith)(data, $a03efb8ea30d3978$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $a03efb8ea30d3978$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $94ZnX.toHex)(data.slice(0, 5)));
}
module.exports.decodeAminoPubkey = $a03efb8ea30d3978$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $a03efb8ea30d3978$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = (0, $94ZnX.fromBech32)(bechEncoded);
    return $a03efb8ea30d3978$var$decodeAminoPubkey(data);
}
module.exports.decodeBech32Pubkey = $a03efb8ea30d3978$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $a03efb8ea30d3978$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $a03efb8ea30d3978$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $a03efb8ea30d3978$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $hm8y1.arrayContentStartsWith)(prefixFromReader, $a03efb8ea30d3978$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $a03efb8ea30d3978$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $a03efb8ea30d3978$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $a03efb8ea30d3978$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $1cagW.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $a03efb8ea30d3978$var$encodeUvarint(value) {
    const checked = $h3uvW.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $a03efb8ea30d3978$var$encodeAminoPubkey(pubkey) {
    if ((0, $1cagW.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($a03efb8ea30d3978$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$a03efb8ea30d3978$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$a03efb8ea30d3978$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$a03efb8ea30d3978$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $1cagW.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$a03efb8ea30d3978$var$pubkeyAminoPrefixEd25519,
        ...(0, $94ZnX.fromBase64)(pubkey.value)
    ]);
    else if ((0, $1cagW.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$a03efb8ea30d3978$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $94ZnX.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
module.exports.encodeAminoPubkey = $a03efb8ea30d3978$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $a03efb8ea30d3978$var$encodeBech32Pubkey(pubkey, prefix) {
    return (0, $94ZnX.toBech32)(prefix, $a03efb8ea30d3978$var$encodeAminoPubkey(pubkey));
}
module.exports.encodeBech32Pubkey = $a03efb8ea30d3978$var$encodeBech32Pubkey;

});
parcelRegister("1cagW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMultisigThresholdPubkey = module.exports.isSinglePubkey = module.exports.pubkeyType = module.exports.isSecp256k1Pubkey = module.exports.isEd25519Pubkey = void 0;
function $0deee147f50a721f$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
module.exports.isEd25519Pubkey = $0deee147f50a721f$var$isEd25519Pubkey;
function $0deee147f50a721f$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
module.exports.isSecp256k1Pubkey = $0deee147f50a721f$var$isSecp256k1Pubkey;
module.exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $0deee147f50a721f$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        module.exports.pubkeyType.ed25519,
        module.exports.pubkeyType.secp256k1,
        module.exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
module.exports.isSinglePubkey = $0deee147f50a721f$var$isSinglePubkey;
function $0deee147f50a721f$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
module.exports.isMultisigThresholdPubkey = $0deee147f50a721f$var$isMultisigThresholdPubkey;

});



parcelRegister("kZ3LA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addCoins = module.exports.parseCoins = module.exports.coins = module.exports.coin = void 0;

var $h3uvW = parcelRequire("h3uvW");
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $03f13b910118cab4$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $h3uvW.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
module.exports.coin = $03f13b910118cab4$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $03f13b910118cab4$var$coins(amount, denom) {
    return [
        $03f13b910118cab4$var$coin(amount, denom)
    ];
}
module.exports.coins = $03f13b910118cab4$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $03f13b910118cab4$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
module.exports.parseCoins = $03f13b910118cab4$var$parseCoins;
/**
 * Function to sum up coins with type Coin
 */ function $03f13b910118cab4$var$addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom) throw new Error("Trying to add two coins with different denoms");
    return {
        amount: $h3uvW.Decimal.fromAtomics(lhs.amount, 0).plus($h3uvW.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom
    };
}
module.exports.addCoins = $03f13b910118cab4$var$addCoins;

});

parcelRegister("kNcaC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMultisigThresholdPubkey = module.exports.compareArrays = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $lqG7A = parcelRequire("lqG7A");
/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $f231d2fd93420191$var$compareArrays(a, b) {
    const aHex = (0, $94ZnX.toHex)(a);
    const bHex = (0, $94ZnX.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
module.exports.compareArrays = $f231d2fd93420191$var$compareArrays;
function $f231d2fd93420191$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $h3uvW.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $lqG7A.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $lqG7A.pubkeyToRawAddress)(rhs);
        return $f231d2fd93420191$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
module.exports.createMultisigThresholdPubkey = $f231d2fd93420191$var$createMultisigThresholdPubkey;

});

parcelRegister("6XJya", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $c162L = parcelRequire("c162L");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $511b960dce2b015a$var$makeCosmoshubPath(a) {
    return [
        $c162L.Slip10RawIndex.hardened(44),
        $c162L.Slip10RawIndex.hardened(118),
        $c162L.Slip10RawIndex.hardened(0),
        $c162L.Slip10RawIndex.normal(0),
        $c162L.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $511b960dce2b015a$var$makeCosmoshubPath;

});

parcelRegister("f9Sbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $hm8y1 = parcelRequire("hm8y1");

var $lqG7A = parcelRequire("lqG7A");

var $6XJya = parcelRequire("6XJya");

var $1N7ou = parcelRequire("1N7ou");

var $eYcgy = parcelRequire("eYcgy");

var $kxKRt = parcelRequire("kxKRt");
const $b091b9860905a57f$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $b091b9860905a57f$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $b091b9860905a57f$var$isDerivationJson(thing) {
    if (!(0, $hm8y1.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $b091b9860905a57f$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $b091b9860905a57f$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $b091b9860905a57f$var$serializationTypeV1:
            return $b091b9860905a57f$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $b091b9860905a57f$var$extractKdfConfiguration;
const $b091b9860905a57f$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $6XJya.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $b091b9860905a57f$var$Secp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $c162L.EnglishMnemonic(mnemonic);
        const seed = await $c162L.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $b091b9860905a57f$var$Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $c162L.Random.getBytes(entropyLength);
        const mnemonic = $c162L.Bip39.encode(entropy);
        return $b091b9860905a57f$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $b091b9860905a57f$var$serializationTypeV1:
                return $b091b9860905a57f$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $b091b9860905a57f$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $kxKRt.decrypt)((0, $94ZnX.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $94ZnX.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $hm8y1.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$b091b9860905a57f$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $c162L.stringToPath)(hdPath));
                    return $b091b9860905a57f$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $hm8y1.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $kxKRt.executeKdf)(password, root.kdf);
        return $b091b9860905a57f$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const hdPaths = options.hdPaths ?? $b091b9860905a57f$var$defaultOptions.hdPaths;
        const prefix = options.prefix ?? $b091b9860905a57f$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $c162L.sha256)((0, $eYcgy.serializeSignDoc)(signDoc));
        const signature = await $c162L.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $1N7ou.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $b091b9860905a57f$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $kxKRt.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $c162L.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $94ZnX.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $kxKRt.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $kxKRt.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $b091b9860905a57f$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $94ZnX.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $c162L.Slip10.derivePath($c162L.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $c162L.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $c162L.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $94ZnX.toBech32)(prefix, (0, $lqG7A.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
module.exports.Secp256k1HdWallet = $b091b9860905a57f$var$Secp256k1HdWallet;

});
parcelRegister("1N7ou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $dKZ7y = parcelRequire("dKZ7y");

var $1cagW = parcelRequire("1cagW");
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $14e01a5dafac4abe$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $dKZ7y.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $94ZnX.toBase64)(signature)
    };
}
module.exports.encodeSecp256k1Signature = $14e01a5dafac4abe$var$encodeSecp256k1Signature;
function $14e01a5dafac4abe$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $1cagW.pubkeyType.secp256k1:
            return {
                pubkey: (0, $94ZnX.fromBase64)(signature.pub_key.value),
                signature: (0, $94ZnX.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
module.exports.decodeSignature = $14e01a5dafac4abe$var$decodeSignature;

});

parcelRegister("eYcgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.escapeCharacters = module.exports.makeSignDoc = module.exports.sortedJsonStringify = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");
function $ae602f0b375296c4$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($ae602f0b375296c4$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $ae602f0b375296c4$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $ae602f0b375296c4$var$sortedJsonStringify(obj) {
    return JSON.stringify($ae602f0b375296c4$var$sortedObject(obj));
}
module.exports.sortedJsonStringify = $ae602f0b375296c4$var$sortedJsonStringify;
function $ae602f0b375296c4$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $h3uvW.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $h3uvW.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
module.exports.makeSignDoc = $ae602f0b375296c4$var$makeSignDoc;
/**
 * Takes a valid JSON document and performs the following escapings in string values:
 *
 * `&` -> `\u0026`
 * `<` -> `\u003c`
 * `>` -> `\u003e`
 *
 * Since those characters do not occur in other places of the JSON document, only
 * string values are affected.
 *
 * If the input is invalid JSON, the behaviour is undefined.
 */ function $ae602f0b375296c4$var$escapeCharacters(input) {
    // When we migrate to target es2021 or above, we can use replaceAll instead of global patterns.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
    const amp = /&/g;
    const lt = /</g;
    const gt = />/g;
    return input.replace(amp, "\\u0026").replace(lt, "\\u003c").replace(gt, "\\u003e");
}
module.exports.escapeCharacters = $ae602f0b375296c4$var$escapeCharacters;
function $ae602f0b375296c4$var$serializeSignDoc(signDoc) {
    const serialized = $ae602f0b375296c4$var$escapeCharacters($ae602f0b375296c4$var$sortedJsonStringify(signDoc));
    return (0, $94ZnX.toUtf8)(serialized);
}
module.exports.serializeSignDoc = $ae602f0b375296c4$var$serializeSignDoc;

});

parcelRegister("kxKRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = (0, $94ZnX.toAscii)("The CosmJS salt.");
async function $ef4b3d67cb5dbcd6$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $c162L.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $c162L.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $ef4b3d67cb5dbcd6$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $ef4b3d67cb5dbcd6$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $c162L.Random.getBytes($c162L.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $c162L.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $ef4b3d67cb5dbcd6$var$encrypt;
async function $ef4b3d67cb5dbcd6$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $c162L.xchacha20NonceLength);
                return $c162L.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($c162L.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $ef4b3d67cb5dbcd6$var$decrypt;

});


parcelRegister("gJUqF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $lqG7A = parcelRequire("lqG7A");

var $1N7ou = parcelRequire("1N7ou");

var $eYcgy = parcelRequire("eYcgy");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $c2fc9efaf8f84fa6$var$Secp256k1Wallet {
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $c162L.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $c2fc9efaf8f84fa6$var$Secp256k1Wallet(privkey, $c162L.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $94ZnX.toBech32)(this.prefix, (0, $lqG7A.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $c162L.Sha256((0, $eYcgy.serializeSignDoc)(signDoc)).digest();
        const signature = await $c162L.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $1N7ou.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
module.exports.Secp256k1Wallet = $c2fc9efaf8f84fa6$var$Secp256k1Wallet;

});

parcelRegister("fgHvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeStdTx = module.exports.isStdTx = void 0;
function $b1da1855a3f6d5cb$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
module.exports.isStdTx = $b1da1855a3f6d5cb$var$isStdTx;
function $b1da1855a3f6d5cb$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
module.exports.makeStdTx = $b1da1855a3f6d5cb$var$makeStdTx;

});


parcelRegister("7eoti", function(module, exports) {
"use strict";
var $543cd2c3202a2625$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeSignBytes = module.exports.makeSignDoc = module.exports.makeAuthInfoBytes = void 0;

var $hm8y1 = parcelRequire("hm8y1");

var $67U77 = parcelRequire("67U77");

var $bkT1A = parcelRequire("bkT1A");

const $543cd2c3202a2625$var$long_1 = $543cd2c3202a2625$var$__importDefault((parcelRequire("3gmZQ")));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $543cd2c3202a2625$var$makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey: pubkey, sequence: sequence })=>({
            publicKey: pubkey,
            modeInfo: {
                single: {
                    mode: signMode
                }
            },
            sequence: $543cd2c3202a2625$var$long_1.default.fromNumber(sequence)
        }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $543cd2c3202a2625$var$makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = $67U77.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, $hm8y1.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, $hm8y1.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = $bkT1A.AuthInfo.fromPartial({
        signerInfos: $543cd2c3202a2625$var$makeSignerInfos(signers, signMode),
        fee: {
            amount: [
                ...feeAmount
            ],
            gasLimit: $543cd2c3202a2625$var$long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer
        }
    });
    return $bkT1A.AuthInfo.encode(authInfo).finish();
}
module.exports.makeAuthInfoBytes = $543cd2c3202a2625$var$makeAuthInfoBytes;
function $543cd2c3202a2625$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $543cd2c3202a2625$var$long_1.default.fromNumber(accountNumber)
    };
}
module.exports.makeSignDoc = $543cd2c3202a2625$var$makeSignDoc;
function $543cd2c3202a2625$var$makeSignBytes({ accountNumber: accountNumber, authInfoBytes: authInfoBytes, bodyBytes: bodyBytes, chainId: chainId }) {
    const signDoc = $bkT1A.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $bkT1A.SignDoc.encode(signDoc).finish();
}
module.exports.makeSignBytes = $543cd2c3202a2625$var$makeSignBytes;

});

parcelRegister("lLiFz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = (0, $94ZnX.toAscii)("The CosmJS salt.");
async function $fd7c781e628e67de$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $c162L.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $c162L.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $fd7c781e628e67de$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $fd7c781e628e67de$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $c162L.Random.getBytes($c162L.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $c162L.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $fd7c781e628e67de$var$encrypt;
async function $fd7c781e628e67de$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $c162L.xchacha20NonceLength);
                return $c162L.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($c162L.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $fd7c781e628e67de$var$decrypt;

});


parcelRegister("dS9aH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DirectSecp256k1Wallet = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $7eoti = parcelRequire("7eoti");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ class $a1976ec7cd857a60$var$DirectSecp256k1Wallet {
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $c162L.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $a1976ec7cd857a60$var$DirectSecp256k1Wallet(privkey, $c162L.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $94ZnX.toBech32)(this.prefix, (0, $bVJSA.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, $7eoti.makeSignBytes)(signDoc);
        if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
        const hashedMessage = (0, $c162L.sha256)(signBytes);
        const signature = await $c162L.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $bVJSA.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
}
module.exports.DirectSecp256k1Wallet = $a1976ec7cd857a60$var$DirectSecp256k1Wallet;

});

parcelRegister("2EKyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $c162L = parcelRequire("c162L");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $1ef36daac8e7a2af$var$makeCosmoshubPath(a) {
    return [
        $c162L.Slip10RawIndex.hardened(44),
        $c162L.Slip10RawIndex.hardened(118),
        $c162L.Slip10RawIndex.hardened(0),
        $c162L.Slip10RawIndex.normal(0),
        $c162L.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $1ef36daac8e7a2af$var$makeCosmoshubPath;

});

parcelRegister("lwiyx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodePubkey = module.exports.anyToSinglePubkey = module.exports.encodePubkey = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $8ZPtS = parcelRequire("8ZPtS");

var $dIDcl = parcelRequire("dIDcl");

var $jCCqQ = parcelRequire("jCCqQ");

var $axIO3 = parcelRequire("axIO3");
/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */ function $faaafaf4c1ea4983$var$encodePubkey(pubkey) {
    if ((0, $bVJSA.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = $jCCqQ.PubKey.fromPartial({
            key: (0, $94ZnX.fromBase64)(pubkey.value)
        });
        return $axIO3.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($jCCqQ.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $bVJSA.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = $8ZPtS.PubKey.fromPartial({
            key: (0, $94ZnX.fromBase64)(pubkey.value)
        });
        return $axIO3.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from($8ZPtS.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $bVJSA.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = $dIDcl.LegacyAminoPubKey.fromPartial({
            threshold: $h3uvW.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($faaafaf4c1ea4983$var$encodePubkey)
        });
        return $axIO3.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($dIDcl.LegacyAminoPubKey.encode(pubkeyProto).finish())
        });
    } else throw new Error(`Pubkey type ${pubkey.type} not recognized`);
}
module.exports.encodePubkey = $faaafaf4c1ea4983$var$encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`.
 */ function $faaafaf4c1ea4983$var$anyToSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                const { key: key } = $jCCqQ.PubKey.decode(pubkey.value);
                return (0, $bVJSA.encodeSecp256k1Pubkey)(key);
            }
        case "/cosmos.crypto.ed25519.PubKey":
            {
                const { key: key } = $8ZPtS.PubKey.decode(pubkey.value);
                return (0, $bVJSA.encodeEd25519Pubkey)(key);
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
module.exports.anyToSinglePubkey = $faaafaf4c1ea4983$var$anyToSinglePubkey;
/**
 * Decodes a pubkey from a protobuf `Any` into `Pubkey`.
 * This supports single pubkeys such as Cosmos ed25519 and secp256k1 keys
 * as well as multisig threshold pubkeys.
 */ function $faaafaf4c1ea4983$var$decodePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey":
            return $faaafaf4c1ea4983$var$anyToSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                const { threshold: threshold, publicKeys: publicKeys } = $dIDcl.LegacyAminoPubKey.decode(pubkey.value);
                const out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($faaafaf4c1ea4983$var$anyToSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
module.exports.decodePubkey = $faaafaf4c1ea4983$var$decodePubkey;

});
parcelRegister("8ZPtS", function(module, exports) {
"use strict";
var $68cbf444a028573d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $68cbf444a028573d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $68cbf444a028573d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $68cbf444a028573d$var$__createBinding(result, mod, k);
    }
    $68cbf444a028573d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivKey = module.exports.PubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $68cbf444a028573d$var$_m0 = $68cbf444a028573d$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.crypto.ed25519";
function $68cbf444a028573d$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
module.exports.PubKey = {
    encode (message, writer = $68cbf444a028573d$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68cbf444a028573d$var$_m0.Reader ? input : new $68cbf444a028573d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $68cbf444a028573d$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $68cbf444a028573d$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $68cbf444a028573d$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
module.exports.PrivKey = {
    encode (message, writer = $68cbf444a028573d$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $68cbf444a028573d$var$_m0.Reader ? input : new $68cbf444a028573d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $68cbf444a028573d$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $68cbf444a028573d$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};

});

parcelRegister("dIDcl", function(module, exports) {
"use strict";
var $9fcdca5954a3ad6b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9fcdca5954a3ad6b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9fcdca5954a3ad6b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9fcdca5954a3ad6b$var$__createBinding(result, mod, k);
    }
    $9fcdca5954a3ad6b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LegacyAminoPubKey = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

const $9fcdca5954a3ad6b$var$_m0 = $9fcdca5954a3ad6b$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.crypto.multisig";
function $9fcdca5954a3ad6b$var$createBaseLegacyAminoPubKey() {
    return {
        threshold: 0,
        publicKeys: []
    };
}
module.exports.LegacyAminoPubKey = {
    encode (message, writer = $9fcdca5954a3ad6b$var$_m0.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$axIO3.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9fcdca5954a3ad6b$var$_m0.Reader ? input : new $9fcdca5954a3ad6b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9fcdca5954a3ad6b$var$createBaseLegacyAminoPubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $dkaBG.isSet)(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object?.publicKeys) ? object.publicKeys.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9fcdca5954a3ad6b$var$createBaseLegacyAminoPubKey();
        message.threshold = object.threshold ?? 0;
        message.publicKeys = object.publicKeys?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};

});

parcelRegister("jCCqQ", function(module, exports) {
"use strict";
var $e48f60baf9f2ac5e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e48f60baf9f2ac5e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e48f60baf9f2ac5e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e48f60baf9f2ac5e$var$__createBinding(result, mod, k);
    }
    $e48f60baf9f2ac5e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrivKey = module.exports.PubKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $e48f60baf9f2ac5e$var$_m0 = $e48f60baf9f2ac5e$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.crypto.secp256k1";
function $e48f60baf9f2ac5e$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
module.exports.PubKey = {
    encode (message, writer = $e48f60baf9f2ac5e$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e48f60baf9f2ac5e$var$_m0.Reader ? input : new $e48f60baf9f2ac5e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e48f60baf9f2ac5e$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e48f60baf9f2ac5e$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $e48f60baf9f2ac5e$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
module.exports.PrivKey = {
    encode (message, writer = $e48f60baf9f2ac5e$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e48f60baf9f2ac5e$var$_m0.Reader ? input : new $e48f60baf9f2ac5e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e48f60baf9f2ac5e$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e48f60baf9f2ac5e$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};

});


parcelRegister("45qwh", function(module, exports) {

var $N0o3H = parcelRequire("N0o3H");
var $2f9c334713a83174$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Registry = module.exports.isTxBodyEncodeObject = module.exports.isPbjsGeneratedType = module.exports.isTsProtoGeneratedType = void 0;

var $12h3v = parcelRequire("12h3v");

var $efcGD = parcelRequire("efcGD");

var $bkT1A = parcelRequire("bkT1A");

var $axIO3 = parcelRequire("axIO3");
function $2f9c334713a83174$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
module.exports.isTsProtoGeneratedType = $2f9c334713a83174$var$isTsProtoGeneratedType;
function $2f9c334713a83174$var$isPbjsGeneratedType(type) {
    return !$2f9c334713a83174$var$isTsProtoGeneratedType(type);
}
module.exports.isPbjsGeneratedType = $2f9c334713a83174$var$isPbjsGeneratedType;
const $2f9c334713a83174$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $2f9c334713a83174$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
module.exports.isTxBodyEncodeObject = $2f9c334713a83174$var$isTxBodyEncodeObject;
class $2f9c334713a83174$var$Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */ constructor(customTypes){
        const { cosmosCoin: cosmosCoin, cosmosMsgSend: cosmosMsgSend } = $2f9c334713a83174$var$defaultTypeUrls;
        this.types = customTypes ? new Map([
            ...customTypes
        ]) : new Map([
            [
                cosmosCoin,
                $efcGD.Coin
            ],
            [
                cosmosMsgSend,
                $12h3v.MsgSend
            ]
        ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) throw new Error(`Unregistered type url: ${typeUrl}`);
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */ encode(encodeObject) {
        const { value: value, typeUrl: typeUrl } = encodeObject;
        if ($2f9c334713a83174$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const instance = $2f9c334713a83174$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */ encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return $axIO3.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message)=>this.encodeAsAny(message));
        const txBody = $bkT1A.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages
        });
        return $bkT1A.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl: typeUrl, value: value }) {
        if (typeUrl === $2f9c334713a83174$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val])=>{
            if (typeof $2f9c334713a83174$require$Buffer !== "undefined" && typeof $2f9c334713a83174$require$Buffer.isBuffer !== "undefined" && $2f9c334713a83174$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = $bkT1A.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value: value })=>{
                if (!typeUrl) throw new Error("Missing type_url in Any");
                if (!value) throw new Error("Missing value in Any");
                return this.decode({
                    typeUrl: typeUrl,
                    value: value
                });
            })
        };
    }
}
module.exports.Registry = $2f9c334713a83174$var$Registry;

});
parcelRegister("12h3v", function(module, exports) {
"use strict";
var $0c1335386ffceaee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0c1335386ffceaee$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0c1335386ffceaee$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0c1335386ffceaee$var$__createBinding(result, mod, k);
    }
    $0c1335386ffceaee$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgSetSendEnabledResponse = module.exports.MsgSetSendEnabled = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgMultiSendResponse = module.exports.MsgMultiSend = module.exports.MsgSendResponse = module.exports.MsgSend = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $gc7so = parcelRequire("gc7so");

const $0c1335386ffceaee$var$_m0 = $0c1335386ffceaee$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $0c1335386ffceaee$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
module.exports.MsgSend = {
    encode (message, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $dkaBG.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $dkaBG.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0c1335386ffceaee$var$createBaseMsgSend();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgSendResponse() {
    return {};
}
module.exports.MsgSendResponse = {
    encode (_, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0c1335386ffceaee$var$createBaseMsgSendResponse();
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
module.exports.MsgMultiSend = {
    encode (message, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        for (const v of message.inputs)$gc7so.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$gc7so.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($gc7so.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($gc7so.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inputs: Array.isArray(object?.inputs) ? object.inputs.map((e)=>$gc7so.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object?.outputs) ? object.outputs.map((e)=>$gc7so.Output.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $gc7so.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $gc7so.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0c1335386ffceaee$var$createBaseMsgMultiSend();
        message.inputs = object.inputs?.map((e)=>$gc7so.Input.fromPartial(e)) || [];
        message.outputs = object.outputs?.map((e)=>$gc7so.Output.fromPartial(e)) || [];
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgMultiSendResponse() {
    return {};
}
module.exports.MsgMultiSendResponse = {
    encode (_, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0c1335386ffceaee$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
module.exports.MsgUpdateParams = {
    encode (message, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $gc7so.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $gc7so.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $dkaBG.isSet)(object.params) ? $gc7so.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $gc7so.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0c1335386ffceaee$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $gc7so.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode (_, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0c1335386ffceaee$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgSetSendEnabled() {
    return {
        authority: "",
        sendEnabled: [],
        useDefaultFor: []
    };
}
module.exports.MsgSetSendEnabled = {
    encode (message, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        for (const v of message.sendEnabled)$gc7so.SendEnabled.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.useDefaultFor)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgSetSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.sendEnabled.push($gc7so.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.useDefaultFor.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$gc7so.SendEnabled.fromJSON(e)) : [],
            useDefaultFor: Array.isArray(object?.useDefaultFor) ? object.useDefaultFor.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $gc7so.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        if (message.useDefaultFor) obj.useDefaultFor = message.useDefaultFor.map((e)=>e);
        else obj.useDefaultFor = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0c1335386ffceaee$var$createBaseMsgSetSendEnabled();
        message.authority = object.authority ?? "";
        message.sendEnabled = object.sendEnabled?.map((e)=>$gc7so.SendEnabled.fromPartial(e)) || [];
        message.useDefaultFor = object.useDefaultFor?.map((e)=>e) || [];
        return message;
    }
};
function $0c1335386ffceaee$var$createBaseMsgSetSendEnabledResponse() {
    return {};
}
module.exports.MsgSetSendEnabledResponse = {
    encode (_, writer = $0c1335386ffceaee$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0c1335386ffceaee$var$_m0.Reader ? input : new $0c1335386ffceaee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0c1335386ffceaee$var$createBaseMsgSetSendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0c1335386ffceaee$var$createBaseMsgSetSendEnabledResponse();
        return message;
    }
};
class $0c1335386ffceaee$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(request) {
        const data = module.exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data)=>module.exports.MsgSendResponse.decode(new $0c1335386ffceaee$var$_m0.Reader(data)));
    }
    MultiSend(request) {
        const data = module.exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data)=>module.exports.MsgMultiSendResponse.decode(new $0c1335386ffceaee$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = module.exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>module.exports.MsgUpdateParamsResponse.decode(new $0c1335386ffceaee$var$_m0.Reader(data)));
    }
    SetSendEnabled(request) {
        const data = module.exports.MsgSetSendEnabled.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", data);
        return promise.then((data)=>module.exports.MsgSetSendEnabledResponse.decode(new $0c1335386ffceaee$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $0c1335386ffceaee$var$MsgClientImpl;

});
parcelRegister("gc7so", function(module, exports) {
"use strict";
var $bca38d24ca74d4bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bca38d24ca74d4bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bca38d24ca74d4bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bca38d24ca74d4bf$var$__createBinding(result, mod, k);
    }
    $bca38d24ca74d4bf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Metadata = module.exports.DenomUnit = module.exports.Supply = module.exports.Output = module.exports.Input = module.exports.SendEnabled = module.exports.Params = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

const $bca38d24ca74d4bf$var$_m0 = $bca38d24ca74d4bf$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $bca38d24ca74d4bf$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
module.exports.Params = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)module.exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push(module.exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>module.exports.SendEnabled.fromJSON(e)) : [],
            defaultSendEnabled: (0, $dkaBG.isSet)(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? module.exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseParams();
        message.sendEnabled = object.sendEnabled?.map((e)=>module.exports.SendEnabled.fromPartial(e)) || [];
        message.defaultSendEnabled = object.defaultSendEnabled ?? false;
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
module.exports.SendEnabled = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : "",
            enabled: (0, $dkaBG.isSet)(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseSendEnabled();
        message.denom = object.denom ?? "";
        message.enabled = object.enabled ?? false;
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Input = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseInput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseInput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
module.exports.Output = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseOutput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseOutput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseSupply() {
    return {
        total: []
    };
}
module.exports.Supply = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        for (const v of message.total)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseSupply();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: Array.isArray(object?.total) ? object.total.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseSupply();
        message.total = object.total?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
module.exports.DenomUnit = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseDenomUnit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : "",
            exponent: (0, $dkaBG.isSet)(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object?.aliases) ? object.aliases.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseDenomUnit();
        message.denom = object.denom ?? "";
        message.exponent = object.exponent ?? 0;
        message.aliases = object.aliases?.map((e)=>e) || [];
        return message;
    }
};
function $bca38d24ca74d4bf$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: "",
        uri: "",
        uriHash: ""
    };
}
module.exports.Metadata = {
    encode (message, writer = $bca38d24ca74d4bf$var$_m0.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)module.exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        if (message.uri !== "") writer.uint32(58).string(message.uri);
        if (message.uriHash !== "") writer.uint32(66).string(message.uriHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bca38d24ca74d4bf$var$_m0.Reader ? input : new $bca38d24ca74d4bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bca38d24ca74d4bf$var$createBaseMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push(module.exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.uri = reader.string();
                    break;
                case 8:
                    message.uriHash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object?.denomUnits) ? object.denomUnits.map((e)=>module.exports.DenomUnit.fromJSON(e)) : [],
            base: (0, $dkaBG.isSet)(object.base) ? String(object.base) : "",
            display: (0, $dkaBG.isSet)(object.display) ? String(object.display) : "",
            name: (0, $dkaBG.isSet)(object.name) ? String(object.name) : "",
            symbol: (0, $dkaBG.isSet)(object.symbol) ? String(object.symbol) : "",
            uri: (0, $dkaBG.isSet)(object.uri) ? String(object.uri) : "",
            uriHash: (0, $dkaBG.isSet)(object.uriHash) ? String(object.uriHash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? module.exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.uri !== undefined && (obj.uri = message.uri);
        message.uriHash !== undefined && (obj.uriHash = message.uriHash);
        return obj;
    },
    fromPartial (object) {
        const message = $bca38d24ca74d4bf$var$createBaseMetadata();
        message.description = object.description ?? "";
        message.denomUnits = object.denomUnits?.map((e)=>module.exports.DenomUnit.fromPartial(e)) || [];
        message.base = object.base ?? "";
        message.display = object.display ?? "";
        message.name = object.name ?? "";
        message.symbol = object.symbol ?? "";
        message.uri = object.uri ?? "";
        message.uriHash = object.uriHash ?? "";
        return message;
    }
};

});



parcelRegister("1FNkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isOfflineDirectSigner = void 0;
function $137fe43226f5173b$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
module.exports.isOfflineDirectSigner = $137fe43226f5173b$var$isOfflineDirectSigner;

});


parcelRegister("295om", function(module, exports) {
"use strict";
var $19009ac7c4d0304b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $19009ac7c4d0304b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $19009ac7c4d0304b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $19009ac7c4d0304b$var$__createBinding(result, mod, k);
    }
    $19009ac7c4d0304b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.ModuleCredential = module.exports.ModuleAccount = module.exports.BaseAccount = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $19009ac7c4d0304b$var$_m0 = $19009ac7c4d0304b$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.auth.v1beta1";
function $19009ac7c4d0304b$var$createBaseBaseAccount() {
    return {
        address: "",
        pubKey: undefined,
        accountNumber: $dkaBG.Long.UZERO,
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.BaseAccount = {
    encode (message, writer = $19009ac7c4d0304b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $axIO3.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $19009ac7c4d0304b$var$_m0.Reader ? input : new $19009ac7c4d0304b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $19009ac7c4d0304b$var$createBaseBaseAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            pubKey: (0, $dkaBG.isSet)(object.pubKey) ? $axIO3.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: (0, $dkaBG.isSet)(object.accountNumber) ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO,
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $axIO3.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $dkaBG.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $19009ac7c4d0304b$var$createBaseBaseAccount();
        message.address = object.address ?? "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $axIO3.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $dkaBG.Long.fromValue(object.accountNumber) : $dkaBG.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $19009ac7c4d0304b$var$createBaseModuleAccount() {
    return {
        baseAccount: undefined,
        name: "",
        permissions: []
    };
}
module.exports.ModuleAccount = {
    encode (message, writer = $19009ac7c4d0304b$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) module.exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $19009ac7c4d0304b$var$_m0.Reader ? input : new $19009ac7c4d0304b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $19009ac7c4d0304b$var$createBaseModuleAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = module.exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $dkaBG.isSet)(object.baseAccount) ? module.exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: (0, $dkaBG.isSet)(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object?.permissions) ? object.permissions.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? module.exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $19009ac7c4d0304b$var$createBaseModuleAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? module.exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.name = object.name ?? "";
        message.permissions = object.permissions?.map((e)=>e) || [];
        return message;
    }
};
function $19009ac7c4d0304b$var$createBaseModuleCredential() {
    return {
        moduleName: "",
        derivationKeys: []
    };
}
module.exports.ModuleCredential = {
    encode (message, writer = $19009ac7c4d0304b$var$_m0.Writer.create()) {
        if (message.moduleName !== "") writer.uint32(10).string(message.moduleName);
        for (const v of message.derivationKeys)writer.uint32(18).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $19009ac7c4d0304b$var$_m0.Reader ? input : new $19009ac7c4d0304b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $19009ac7c4d0304b$var$createBaseModuleCredential();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moduleName = reader.string();
                    break;
                case 2:
                    message.derivationKeys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moduleName: (0, $dkaBG.isSet)(object.moduleName) ? String(object.moduleName) : "",
            derivationKeys: Array.isArray(object?.derivationKeys) ? object.derivationKeys.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.moduleName !== undefined && (obj.moduleName = message.moduleName);
        if (message.derivationKeys) obj.derivationKeys = message.derivationKeys.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.derivationKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $19009ac7c4d0304b$var$createBaseModuleCredential();
        message.moduleName = object.moduleName ?? "";
        message.derivationKeys = object.derivationKeys?.map((e)=>e) || [];
        return message;
    }
};
function $19009ac7c4d0304b$var$createBaseParams() {
    return {
        maxMemoCharacters: $dkaBG.Long.UZERO,
        txSigLimit: $dkaBG.Long.UZERO,
        txSizeCostPerByte: $dkaBG.Long.UZERO,
        sigVerifyCostEd25519: $dkaBG.Long.UZERO,
        sigVerifyCostSecp256k1: $dkaBG.Long.UZERO
    };
}
module.exports.Params = {
    encode (message, writer = $19009ac7c4d0304b$var$_m0.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $19009ac7c4d0304b$var$_m0.Reader ? input : new $19009ac7c4d0304b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $19009ac7c4d0304b$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxMemoCharacters: (0, $dkaBG.isSet)(object.maxMemoCharacters) ? $dkaBG.Long.fromValue(object.maxMemoCharacters) : $dkaBG.Long.UZERO,
            txSigLimit: (0, $dkaBG.isSet)(object.txSigLimit) ? $dkaBG.Long.fromValue(object.txSigLimit) : $dkaBG.Long.UZERO,
            txSizeCostPerByte: (0, $dkaBG.isSet)(object.txSizeCostPerByte) ? $dkaBG.Long.fromValue(object.txSizeCostPerByte) : $dkaBG.Long.UZERO,
            sigVerifyCostEd25519: (0, $dkaBG.isSet)(object.sigVerifyCostEd25519) ? $dkaBG.Long.fromValue(object.sigVerifyCostEd25519) : $dkaBG.Long.UZERO,
            sigVerifyCostSecp256k1: (0, $dkaBG.isSet)(object.sigVerifyCostSecp256k1) ? $dkaBG.Long.fromValue(object.sigVerifyCostSecp256k1) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $dkaBG.Long.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $dkaBG.Long.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $dkaBG.Long.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $dkaBG.Long.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $19009ac7c4d0304b$var$createBaseParams();
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $dkaBG.Long.fromValue(object.maxMemoCharacters) : $dkaBG.Long.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $dkaBG.Long.fromValue(object.txSigLimit) : $dkaBG.Long.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $dkaBG.Long.fromValue(object.txSizeCostPerByte) : $dkaBG.Long.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $dkaBG.Long.fromValue(object.sigVerifyCostEd25519) : $dkaBG.Long.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $dkaBG.Long.fromValue(object.sigVerifyCostSecp256k1) : $dkaBG.Long.UZERO;
        return message;
    }
};

});

parcelRegister("de2Rr", function(module, exports) {
"use strict";
var $9a0ecd520d4e7cea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9a0ecd520d4e7cea$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9a0ecd520d4e7cea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9a0ecd520d4e7cea$var$__createBinding(result, mod, k);
    }
    $9a0ecd520d4e7cea$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PermanentLockedAccount = module.exports.PeriodicVestingAccount = module.exports.Period = module.exports.DelayedVestingAccount = module.exports.ContinuousVestingAccount = module.exports.BaseVestingAccount = module.exports.protobufPackage = void 0;

var $295om = parcelRequire("295om");

var $efcGD = parcelRequire("efcGD");

var $dkaBG = parcelRequire("dkaBG");

const $9a0ecd520d4e7cea$var$_m0 = $9a0ecd520d4e7cea$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.vesting.v1beta1";
function $9a0ecd520d4e7cea$var$createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: $dkaBG.Long.ZERO
    };
}
module.exports.BaseVestingAccount = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) $295om.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$efcGD.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBaseBaseVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $295om.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $dkaBG.isSet)(object.baseAccount) ? $295om.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object?.originalVesting) ? object.originalVesting.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            delegatedFree: Array.isArray(object?.delegatedFree) ? object.delegatedFree.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            delegatedVesting: Array.isArray(object?.delegatedVesting) ? object.delegatedVesting.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            endTime: (0, $dkaBG.isSet)(object.endTime) ? $dkaBG.Long.fromValue(object.endTime) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $295om.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBaseBaseVestingAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $295om.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.originalVesting = object.originalVesting?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.delegatedFree = object.delegatedFree?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.delegatedVesting = object.delegatedVesting?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $dkaBG.Long.fromValue(object.endTime) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $9a0ecd520d4e7cea$var$createBaseContinuousVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $dkaBG.Long.ZERO
    };
}
module.exports.ContinuousVestingAccount = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBaseContinuousVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $dkaBG.isSet)(object.baseVestingAccount) ? module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $dkaBG.isSet)(object.startTime) ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBaseContinuousVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $9a0ecd520d4e7cea$var$createBaseDelayedVestingAccount() {
    return {
        baseVestingAccount: undefined
    };
}
module.exports.DelayedVestingAccount = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBaseDelayedVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $dkaBG.isSet)(object.baseVestingAccount) ? module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBaseDelayedVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
function $9a0ecd520d4e7cea$var$createBasePeriod() {
    return {
        length: $dkaBG.Long.ZERO,
        amount: []
    };
}
module.exports.Period = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBasePeriod();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            length: (0, $dkaBG.isSet)(object.length) ? $dkaBG.Long.fromValue(object.length) : $dkaBG.Long.ZERO,
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $dkaBG.Long.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBasePeriod();
        message.length = object.length !== undefined && object.length !== null ? $dkaBG.Long.fromValue(object.length) : $dkaBG.Long.ZERO;
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $9a0ecd520d4e7cea$var$createBasePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $dkaBG.Long.ZERO,
        vestingPeriods: []
    };
}
module.exports.PeriodicVestingAccount = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)module.exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBasePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push(module.exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $dkaBG.isSet)(object.baseVestingAccount) ? module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $dkaBG.isSet)(object.startTime) ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>module.exports.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $dkaBG.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? module.exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBasePeriodicVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>module.exports.Period.fromPartial(e)) || [];
        return message;
    }
};
function $9a0ecd520d4e7cea$var$createBasePermanentLockedAccount() {
    return {
        baseVestingAccount: undefined
    };
}
module.exports.PermanentLockedAccount = {
    encode (message, writer = $9a0ecd520d4e7cea$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) module.exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9a0ecd520d4e7cea$var$_m0.Reader ? input : new $9a0ecd520d4e7cea$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9a0ecd520d4e7cea$var$createBasePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = module.exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $dkaBG.isSet)(object.baseVestingAccount) ? module.exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? module.exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $9a0ecd520d4e7cea$var$createBasePermanentLockedAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? module.exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};

});


parcelRegister("7iLoQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AminoTypes = void 0;
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */ class $550efb71bf40f8bf$var$AminoTypes {
    constructor(types){
        this.register = types;
    }
    toAmino({ typeUrl: typeUrl, value: value }) {
        const converter = this.register[typeUrl];
        if (!converter) throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        return {
            type: converter.aminoType,
            value: converter.toAmino(value)
        };
    }
    fromAmino({ type: type, value: value }) {
        const matches = Object.entries(this.register).filter(([_typeUrl, { aminoType: aminoType }])=>aminoType === type);
        switch(matches.length){
            case 0:
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            case 1:
                {
                    const [typeUrl, converter] = matches[0];
                    return {
                        typeUrl: typeUrl,
                        value: converter.fromAmino(value)
                    };
                }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` + matches.map(([key, _value])=>key).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
        }
    }
}
module.exports.AminoTypes = $550efb71bf40f8bf$var$AminoTypes;

});

parcelRegister("7a0MP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromTendermintEvent = void 0;

var $94ZnX = parcelRequire("94ZnX");
/**
 * Takes a Tendermint 0.34 or 0.37 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */ function $536a13c91c102ace$var$fromTendermintEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes.map((attr)=>({
                key: typeof attr.key == "string" ? attr.key : (0, $94ZnX.fromUtf8)(attr.key, true),
                value: typeof attr.value == "string" ? attr.value : (0, $94ZnX.fromUtf8)(attr.value, true)
            }))
    };
}
module.exports.fromTendermintEvent = $536a13c91c102ace$var$fromTendermintEvent;

});

parcelRegister("c8wER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateFee = module.exports.GasPrice = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $dtY18 = parcelRequire("dtY18");
/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */ function $8d5f909b5da95868$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) throw new Error("Denom must be between 3 and 128 characters");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $8d5f909b5da95868$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $8d5f909b5da95868$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $h3uvW.Decimal.fromUserInput(amount, fractionalDigits);
        return new $8d5f909b5da95868$var$GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */ toString() {
        return this.amount.toString() + this.denom;
    }
}
module.exports.GasPrice = $8d5f909b5da95868$var$GasPrice;
function $8d5f909b5da95868$var$calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? $8d5f909b5da95868$var$GasPrice.fromString(gasPrice) : gasPrice;
    const { denom: denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new $h3uvW.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, $dtY18.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
module.exports.calculateFee = $8d5f909b5da95868$var$calculateFee;

});

parcelRegister("jqoFk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseRawLog = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $hm8y1 = parcelRequire("hm8y1");
function $e2439415d4033fef$var$parseAttribute(input) {
    if (!(0, $hm8y1.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $e2439415d4033fef$var$parseAttribute;
function $e2439415d4033fef$var$parseEvent(input) {
    if (!(0, $hm8y1.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($e2439415d4033fef$var$parseAttribute)
    };
}
module.exports.parseEvent = $e2439415d4033fef$var$parseEvent;
function $e2439415d4033fef$var$parseLog(input) {
    if (!(0, $hm8y1.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($e2439415d4033fef$var$parseEvent)
    };
}
module.exports.parseLog = $e2439415d4033fef$var$parseLog;
function $e2439415d4033fef$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($e2439415d4033fef$var$parseLog);
}
module.exports.parseLogs = $e2439415d4033fef$var$parseLogs;
function $e2439415d4033fef$var$parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events: events }, i)=>({
            msg_index: i,
            events: events,
            log: ""
        }));
    return $e2439415d4033fef$var$parseLogs(logsToParse);
}
module.exports.parseRawLog = $e2439415d4033fef$var$parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $e2439415d4033fef$var$findAttribute(logs, eventType, attrKey) {
    const firstLogs = logs.find(()=>true);
    const out = firstLogs?.events.find((event)=>event.type === eventType)?.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $e2439415d4033fef$var$findAttribute;

});

parcelRegister("6qSFW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAminoMsgCreateValidator = module.exports.isAminoMsgBeginRedelegate = module.exports.createStakingAminoConverters = module.exports.setupSlashingExtension = module.exports.isAminoMsgUnjail = module.exports.createSlashingAminoConverters = module.exports.setupMintExtension = module.exports.setupIbcExtension = module.exports.isMsgTransferEncodeObject = module.exports.ibcTypes = module.exports.isAminoMsgTransfer = module.exports.createIbcAminoConverters = module.exports.groupTypes = module.exports.createGroupAminoConverters = module.exports.setupGovExtension = module.exports.isMsgVoteWeightedEncodeObject = module.exports.isMsgVoteEncodeObject = module.exports.isMsgSubmitProposalEncodeObject = module.exports.isMsgDepositEncodeObject = module.exports.govTypes = module.exports.isAminoMsgVoteWeighted = module.exports.isAminoMsgVote = module.exports.isAminoMsgSubmitProposal = module.exports.isAminoMsgDeposit = module.exports.createGovAminoConverters = module.exports.setupFeegrantExtension = module.exports.feegrantTypes = module.exports.createFeegrantAminoConverters = module.exports.isAminoMsgSubmitEvidence = module.exports.createEvidenceAminoConverters = module.exports.setupDistributionExtension = module.exports.isMsgWithdrawDelegatorRewardEncodeObject = module.exports.distributionTypes = module.exports.isAminoMsgWithdrawValidatorCommission = module.exports.isAminoMsgWithdrawDelegatorReward = module.exports.isAminoMsgSetWithdrawAddress = module.exports.isAminoMsgFundCommunityPool = module.exports.createDistributionAminoConverters = module.exports.isAminoMsgVerifyInvariant = module.exports.createCrysisAminoConverters = module.exports.setupBankExtension = module.exports.isMsgSendEncodeObject = module.exports.bankTypes = module.exports.isAminoMsgSend = module.exports.isAminoMsgMultiSend = module.exports.createBankAminoConverters = module.exports.setupAuthzExtension = module.exports.authzTypes = module.exports.createAuthzAminoConverters = module.exports.setupAuthExtension = void 0;
module.exports.vestingTypes = module.exports.isAminoMsgCreateVestingAccount = module.exports.createVestingAminoConverters = module.exports.setupTxExtension = module.exports.setupStakingExtension = module.exports.stakingTypes = module.exports.isMsgUndelegateEncodeObject = module.exports.isMsgEditValidatorEncodeObject = module.exports.isMsgDelegateEncodeObject = module.exports.isMsgCreateValidatorEncodeObject = module.exports.isMsgBeginRedelegateEncodeObject = module.exports.isAminoMsgUndelegate = module.exports.isAminoMsgEditValidator = module.exports.isAminoMsgDelegate = void 0;

var $6ZOJ6 = parcelRequire("6ZOJ6");
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $6ZOJ6.setupAuthExtension;
    }
});

var $7xTyi = parcelRequire("7xTyi");
Object.defineProperty(module.exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $7xTyi.createAuthzAminoConverters;
    }
});

var $5iCRa = parcelRequire("5iCRa");
Object.defineProperty(module.exports, "authzTypes", {
    enumerable: true,
    get: function() {
        return $5iCRa.authzTypes;
    }
});

var $2buhN = parcelRequire("2buhN");
Object.defineProperty(module.exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $2buhN.setupAuthzExtension;
    }
});

var $lcjJ2 = parcelRequire("lcjJ2");
Object.defineProperty(module.exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $lcjJ2.createBankAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $lcjJ2.isAminoMsgMultiSend;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $lcjJ2.isAminoMsgSend;
    }
});

var $1NNEt = parcelRequire("1NNEt");
Object.defineProperty(module.exports, "bankTypes", {
    enumerable: true,
    get: function() {
        return $1NNEt.bankTypes;
    }
});
Object.defineProperty(module.exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $1NNEt.isMsgSendEncodeObject;
    }
});

var $k9boh = parcelRequire("k9boh");
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $k9boh.setupBankExtension;
    }
});

var $brqM5 = parcelRequire("brqM5");
Object.defineProperty(module.exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $brqM5.createCrysisAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $brqM5.isAminoMsgVerifyInvariant;
    }
});

var $7ok0w = parcelRequire("7ok0w");
Object.defineProperty(module.exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $7ok0w.createDistributionAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $7ok0w.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $7ok0w.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty(module.exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $7ok0w.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty(module.exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $7ok0w.isAminoMsgWithdrawValidatorCommission;
    }
});

var $3HPe5 = parcelRequire("3HPe5");
Object.defineProperty(module.exports, "distributionTypes", {
    enumerable: true,
    get: function() {
        return $3HPe5.distributionTypes;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $3HPe5.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});

var $5d4rt = parcelRequire("5d4rt");
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $5d4rt.setupDistributionExtension;
    }
});

var $kaYNR = parcelRequire("kaYNR");
Object.defineProperty(module.exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $kaYNR.createEvidenceAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $kaYNR.isAminoMsgSubmitEvidence;
    }
});

var $hXHzq = parcelRequire("hXHzq");
Object.defineProperty(module.exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $hXHzq.createFeegrantAminoConverters;
    }
});

var $2mP52 = parcelRequire("2mP52");
Object.defineProperty(module.exports, "feegrantTypes", {
    enumerable: true,
    get: function() {
        return $2mP52.feegrantTypes;
    }
});

var $hK3yh = parcelRequire("hK3yh");
Object.defineProperty(module.exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $hK3yh.setupFeegrantExtension;
    }
});

var $b0uBt = parcelRequire("b0uBt");
Object.defineProperty(module.exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $b0uBt.createGovAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $b0uBt.isAminoMsgDeposit;
    }
});
Object.defineProperty(module.exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $b0uBt.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $b0uBt.isAminoMsgVote;
    }
});
Object.defineProperty(module.exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $b0uBt.isAminoMsgVoteWeighted;
    }
});

var $aSteU = parcelRequire("aSteU");
Object.defineProperty(module.exports, "govTypes", {
    enumerable: true,
    get: function() {
        return $aSteU.govTypes;
    }
});
Object.defineProperty(module.exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $aSteU.isMsgDepositEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $aSteU.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $aSteU.isMsgVoteEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $aSteU.isMsgVoteWeightedEncodeObject;
    }
});

var $jR8YO = parcelRequire("jR8YO");
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $jR8YO.setupGovExtension;
    }
});

var $hqM2Y = parcelRequire("hqM2Y");
Object.defineProperty(module.exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $hqM2Y.createGroupAminoConverters;
    }
});

var $1m7yV = parcelRequire("1m7yV");
Object.defineProperty(module.exports, "groupTypes", {
    enumerable: true,
    get: function() {
        return $1m7yV.groupTypes;
    }
});

var $gKXS7 = parcelRequire("gKXS7");
Object.defineProperty(module.exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $gKXS7.createIbcAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $gKXS7.isAminoMsgTransfer;
    }
});

var $iZNYj = parcelRequire("iZNYj");
Object.defineProperty(module.exports, "ibcTypes", {
    enumerable: true,
    get: function() {
        return $iZNYj.ibcTypes;
    }
});
Object.defineProperty(module.exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $iZNYj.isMsgTransferEncodeObject;
    }
});

var $aODJs = parcelRequire("aODJs");
Object.defineProperty(module.exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $aODJs.setupIbcExtension;
    }
});

var $8L7fW = parcelRequire("8L7fW");
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $8L7fW.setupMintExtension;
    }
});

var $5o2o9 = parcelRequire("5o2o9");
Object.defineProperty(module.exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $5o2o9.createSlashingAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $5o2o9.isAminoMsgUnjail;
    }
});

var $7fA46 = parcelRequire("7fA46");
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $7fA46.setupSlashingExtension;
    }
});

var $2dyeo = parcelRequire("2dyeo");
Object.defineProperty(module.exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $2dyeo.createStakingAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $2dyeo.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty(module.exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $2dyeo.isAminoMsgCreateValidator;
    }
});
Object.defineProperty(module.exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $2dyeo.isAminoMsgDelegate;
    }
});
Object.defineProperty(module.exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $2dyeo.isAminoMsgEditValidator;
    }
});
Object.defineProperty(module.exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $2dyeo.isAminoMsgUndelegate;
    }
});

var $5qJBp = parcelRequire("5qJBp");
Object.defineProperty(module.exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $5qJBp.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $5qJBp.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $5qJBp.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $5qJBp.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty(module.exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $5qJBp.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty(module.exports, "stakingTypes", {
    enumerable: true,
    get: function() {
        return $5qJBp.stakingTypes;
    }
});

var $5pVOU = parcelRequire("5pVOU");
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $5pVOU.setupStakingExtension;
    }
});

var $6FZBm = parcelRequire("6FZBm");
Object.defineProperty(module.exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $6FZBm.setupTxExtension;
    }
});

var $bx8FW = parcelRequire("bx8FW");
Object.defineProperty(module.exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $bx8FW.createVestingAminoConverters;
    }
});
Object.defineProperty(module.exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $bx8FW.isAminoMsgCreateVestingAccount;
    }
});

var $lSghZ = parcelRequire("lSghZ");
Object.defineProperty(module.exports, "vestingTypes", {
    enumerable: true,
    get: function() {
        return $lSghZ.vestingTypes;
    }
});

});
parcelRegister("6ZOJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupAuthExtension = void 0;

var $ipPqV = parcelRequire("ipPqV");

var $5E3xG = parcelRequire("5E3xG");
function $517fc9c68594cfe3$var$setupAuthExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $ipPqV.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address)=>{
                const { account: account } = await queryService.Account({
                    address: address
                });
                return account ?? null;
            }
        }
    };
}
module.exports.setupAuthExtension = $517fc9c68594cfe3$var$setupAuthExtension;

});
parcelRegister("ipPqV", function(module, exports) {
"use strict";
var $d6827558f3dcfc39$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d6827558f3dcfc39$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d6827558f3dcfc39$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d6827558f3dcfc39$var$__createBinding(result, mod, k);
    }
    $d6827558f3dcfc39$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryAccountInfoResponse = module.exports.QueryAccountInfoRequest = module.exports.QueryAccountAddressByIDResponse = module.exports.QueryAccountAddressByIDRequest = module.exports.AddressStringToBytesResponse = module.exports.AddressStringToBytesRequest = module.exports.AddressBytesToStringResponse = module.exports.AddressBytesToStringRequest = module.exports.Bech32PrefixResponse = module.exports.Bech32PrefixRequest = module.exports.QueryModuleAccountByNameResponse = module.exports.QueryModuleAccountByNameRequest = module.exports.QueryModuleAccountsResponse = module.exports.QueryModuleAccountsRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.QueryAccountResponse = module.exports.QueryAccountRequest = module.exports.QueryAccountsResponse = module.exports.QueryAccountsRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $axIO3 = parcelRequire("axIO3");

var $295om = parcelRequire("295om");

var $dkaBG = parcelRequire("dkaBG");

const $d6827558f3dcfc39$var$_m0 = $d6827558f3dcfc39$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.auth.v1beta1";
function $d6827558f3dcfc39$var$createBaseQueryAccountsRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryAccountsRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountsResponse() {
    return {
        accounts: [],
        pagination: undefined
    };
}
module.exports.QueryAccountsResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        for (const v of message.accounts)$axIO3.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountRequest() {
    return {
        address: ""
    };
}
module.exports.QueryAccountRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountResponse() {
    return {
        account: undefined
    };
}
module.exports.QueryAccountResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.account !== undefined) $axIO3.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $dkaBG.isSet)(object.account) ? $axIO3.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $axIO3.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountResponse();
        message.account = object.account !== undefined && object.account !== null ? $axIO3.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $d6827558f3dcfc39$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.params !== undefined) $295om.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $295om.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $295om.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $295om.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $295om.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryModuleAccountsRequest() {
    return {};
}
module.exports.QueryModuleAccountsRequest = {
    encode (_, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountsRequest();
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryModuleAccountsResponse() {
    return {
        accounts: []
    };
}
module.exports.QueryModuleAccountsResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        for (const v of message.accounts)$axIO3.Any.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameRequest() {
    return {
        name: ""
    };
}
module.exports.QueryModuleAccountByNameRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $dkaBG.isSet)(object.name) ? String(object.name) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameRequest();
        message.name = object.name ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameResponse() {
    return {
        account: undefined
    };
}
module.exports.QueryModuleAccountByNameResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.account !== undefined) $axIO3.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $dkaBG.isSet)(object.account) ? $axIO3.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $axIO3.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryModuleAccountByNameResponse();
        message.account = object.account !== undefined && object.account !== null ? $axIO3.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseBech32PrefixRequest() {
    return {};
}
module.exports.Bech32PrefixRequest = {
    encode (_, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseBech32PrefixRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $d6827558f3dcfc39$var$createBaseBech32PrefixRequest();
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseBech32PrefixResponse() {
    return {
        bech32Prefix: ""
    };
}
module.exports.Bech32PrefixResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.bech32Prefix !== "") writer.uint32(10).string(message.bech32Prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseBech32PrefixResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bech32Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bech32Prefix: (0, $dkaBG.isSet)(object.bech32Prefix) ? String(object.bech32Prefix) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseBech32PrefixResponse();
        message.bech32Prefix = object.bech32Prefix ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseAddressBytesToStringRequest() {
    return {
        addressBytes: new Uint8Array()
    };
}
module.exports.AddressBytesToStringRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseAddressBytesToStringRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $dkaBG.isSet)(object.addressBytes) ? (0, $dkaBG.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $dkaBG.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseAddressBytesToStringRequest();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseAddressBytesToStringResponse() {
    return {
        addressString: ""
    };
}
module.exports.AddressBytesToStringResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseAddressBytesToStringResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $dkaBG.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseAddressBytesToStringResponse();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseAddressStringToBytesRequest() {
    return {
        addressString: ""
    };
}
module.exports.AddressStringToBytesRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseAddressStringToBytesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $dkaBG.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseAddressStringToBytesRequest();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseAddressStringToBytesResponse() {
    return {
        addressBytes: new Uint8Array()
    };
}
module.exports.AddressStringToBytesResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseAddressStringToBytesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $dkaBG.isSet)(object.addressBytes) ? (0, $dkaBG.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $dkaBG.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseAddressStringToBytesResponse();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDRequest() {
    return {
        id: $dkaBG.Long.ZERO,
        accountId: $dkaBG.Long.UZERO
    };
}
module.exports.QueryAccountAddressByIDRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).int64(message.id);
        if (!message.accountId.isZero()) writer.uint32(16).uint64(message.accountId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.int64();
                    break;
                case 2:
                    message.accountId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $dkaBG.isSet)(object.id) ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.ZERO,
            accountId: (0, $dkaBG.isSet)(object.accountId) ? $dkaBG.Long.fromValue(object.accountId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $dkaBG.Long.ZERO).toString());
        message.accountId !== undefined && (obj.accountId = (message.accountId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDRequest();
        message.id = object.id !== undefined && object.id !== null ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.ZERO;
        message.accountId = object.accountId !== undefined && object.accountId !== null ? $dkaBG.Long.fromValue(object.accountId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDResponse() {
    return {
        accountAddress: ""
    };
}
module.exports.QueryAccountAddressByIDResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.accountAddress !== "") writer.uint32(10).string(message.accountAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accountAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accountAddress: (0, $dkaBG.isSet)(object.accountAddress) ? String(object.accountAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountAddressByIDResponse();
        message.accountAddress = object.accountAddress ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountInfoRequest() {
    return {
        address: ""
    };
}
module.exports.QueryAccountInfoRequest = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountInfoRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $d6827558f3dcfc39$var$createBaseQueryAccountInfoResponse() {
    return {
        info: undefined
    };
}
module.exports.QueryAccountInfoResponse = {
    encode (message, writer = $d6827558f3dcfc39$var$_m0.Writer.create()) {
        if (message.info !== undefined) $295om.BaseAccount.encode(message.info, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d6827558f3dcfc39$var$_m0.Reader ? input : new $d6827558f3dcfc39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info = $295om.BaseAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: (0, $dkaBG.isSet)(object.info) ? $295om.BaseAccount.fromJSON(object.info) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.info !== undefined && (obj.info = message.info ? $295om.BaseAccount.toJSON(message.info) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d6827558f3dcfc39$var$createBaseQueryAccountInfoResponse();
        message.info = object.info !== undefined && object.info !== null ? $295om.BaseAccount.fromPartial(object.info) : undefined;
        return message;
    }
};
class $d6827558f3dcfc39$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.AccountAddressByID = this.AccountAddressByID.bind(this);
        this.Params = this.Params.bind(this);
        this.ModuleAccounts = this.ModuleAccounts.bind(this);
        this.ModuleAccountByName = this.ModuleAccountByName.bind(this);
        this.Bech32Prefix = this.Bech32Prefix.bind(this);
        this.AddressBytesToString = this.AddressBytesToString.bind(this);
        this.AddressStringToBytes = this.AddressStringToBytes.bind(this);
        this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data)=>module.exports.QueryAccountsResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    Account(request) {
        const data = module.exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data)=>module.exports.QueryAccountResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    AccountAddressByID(request) {
        const data = module.exports.QueryAccountAddressByIDRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", data);
        return promise.then((data)=>module.exports.QueryAccountAddressByIDResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    ModuleAccounts(request = {}) {
        const data = module.exports.QueryModuleAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
        return promise.then((data)=>module.exports.QueryModuleAccountsResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    ModuleAccountByName(request) {
        const data = module.exports.QueryModuleAccountByNameRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", data);
        return promise.then((data)=>module.exports.QueryModuleAccountByNameResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    Bech32Prefix(request = {}) {
        const data = module.exports.Bech32PrefixRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", data);
        return promise.then((data)=>module.exports.Bech32PrefixResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    AddressBytesToString(request) {
        const data = module.exports.AddressBytesToStringRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", data);
        return promise.then((data)=>module.exports.AddressBytesToStringResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    AddressStringToBytes(request) {
        const data = module.exports.AddressStringToBytesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", data);
        return promise.then((data)=>module.exports.AddressStringToBytesResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
    AccountInfo(request) {
        const data = module.exports.QueryAccountInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", data);
        return promise.then((data)=>module.exports.QueryAccountInfoResponse.decode(new $d6827558f3dcfc39$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $d6827558f3dcfc39$var$QueryClientImpl;

});
parcelRegister("aBpB1", function(module, exports) {
"use strict";
var $7b8136f35e6605bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7b8136f35e6605bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7b8136f35e6605bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7b8136f35e6605bf$var$__createBinding(result, mod, k);
    }
    $7b8136f35e6605bf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PageResponse = module.exports.PageRequest = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $7b8136f35e6605bf$var$_m0 = $7b8136f35e6605bf$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.base.query.v1beta1";
function $7b8136f35e6605bf$var$createBasePageRequest() {
    return {
        key: new Uint8Array(),
        offset: $dkaBG.Long.UZERO,
        limit: $dkaBG.Long.UZERO,
        countTotal: false,
        reverse: false
    };
}
module.exports.PageRequest = {
    encode (message, writer = $7b8136f35e6605bf$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7b8136f35e6605bf$var$_m0.Reader ? input : new $7b8136f35e6605bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7b8136f35e6605bf$var$createBasePageRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            offset: (0, $dkaBG.isSet)(object.offset) ? $dkaBG.Long.fromValue(object.offset) : $dkaBG.Long.UZERO,
            limit: (0, $dkaBG.isSet)(object.limit) ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO,
            countTotal: (0, $dkaBG.isSet)(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: (0, $dkaBG.isSet)(object.reverse) ? Boolean(object.reverse) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $dkaBG.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $dkaBG.Long.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial (object) {
        const message = $7b8136f35e6605bf$var$createBasePageRequest();
        message.key = object.key ?? new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $dkaBG.Long.fromValue(object.offset) : $dkaBG.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO;
        message.countTotal = object.countTotal ?? false;
        message.reverse = object.reverse ?? false;
        return message;
    }
};
function $7b8136f35e6605bf$var$createBasePageResponse() {
    return {
        nextKey: new Uint8Array(),
        total: $dkaBG.Long.UZERO
    };
}
module.exports.PageResponse = {
    encode (message, writer = $7b8136f35e6605bf$var$_m0.Writer.create()) {
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7b8136f35e6605bf$var$_m0.Reader ? input : new $7b8136f35e6605bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7b8136f35e6605bf$var$createBasePageResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextKey: (0, $dkaBG.isSet)(object.nextKey) ? (0, $dkaBG.bytesFromBase64)(object.nextKey) : new Uint8Array(),
            total: (0, $dkaBG.isSet)(object.total) ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextKey !== undefined && (obj.nextKey = (0, $dkaBG.base64FromBytes)(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7b8136f35e6605bf$var$createBasePageResponse();
        message.nextKey = object.nextKey ?? new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.UZERO;
        return message;
    }
};

});


parcelRegister("5E3xG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.longify = module.exports.decodeCosmosSdkDecFromProto = module.exports.createProtobufRpcClient = module.exports.createPagination = module.exports.QueryClient = void 0;

var $ivt3y = parcelRequire("ivt3y");
Object.defineProperty(module.exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $ivt3y.QueryClient;
    }
});

var $dBGCN = parcelRequire("dBGCN");
Object.defineProperty(module.exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $dBGCN.createPagination;
    }
});
Object.defineProperty(module.exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $dBGCN.createProtobufRpcClient;
    }
});
Object.defineProperty(module.exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $dBGCN.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty(module.exports, "longify", {
    enumerable: true,
    get: function() {
        return $dBGCN.longify;
    }
});

});
parcelRegister("ivt3y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClient = void 0;

var $fSEQr = parcelRequire("fSEQr");

var $94ZnX = parcelRequire("94ZnX");

var $6Sxan = parcelRequire("6Sxan");

var $hm8y1 = parcelRequire("hm8y1");
function $d791a93b074bfb8f$var$checkAndParseOp(op, kind, key) {
    if (op.type !== kind) throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    if (!(0, $hm8y1.arrayContentEquals)(key, op.key)) throw new Error(`Proven key different than queried key.\nQuery: ${(0, $94ZnX.toHex)(key)}\nProven: ${(0, $94ZnX.toHex)(op.key)}`);
    return $fSEQr.ics23.CommitmentProof.decode(op.data);
}
class $d791a93b074bfb8f$var$QueryClient {
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new $d791a93b074bfb8f$var$QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $hm8y1.assert)((0, $hm8y1.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $hm8y1.assert)((0, $hm8y1.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue
                };
            }
        }
        return client;
    }
    constructor(tmClient){
        this.tmClient = tmClient;
    }
    /**
     * Queries the database store with a proof, which is then verified.
     *
     * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
     */ async queryStoreVerified(store, queryKey, desiredHeight) {
        const { height: height, proof: proof, key: key, value: value } = await this.queryRawProof(store, queryKey, desiredHeight);
        const subProof = $d791a93b074bfb8f$var$checkAndParseOp(proof.ops[0], "ics23:iavl", queryKey);
        const storeProof = $d791a93b074bfb8f$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $94ZnX.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, $hm8y1.assert)(storeProof.exist);
        (0, $hm8y1.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, $hm8y1.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $fSEQr.verifyNonExistence)(subProof.nonexist, $fSEQr.iavlSpec, storeProof.exist.value, queryKey);
        } else {
            // existence check
            (0, $hm8y1.assert)(subProof.exist);
            (0, $hm8y1.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $fSEQr.verifyExistence)(subProof.exist, $fSEQr.iavlSpec, storeProof.exist.value, queryKey, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, $fSEQr.verifyExistence)(storeProof.exist, $fSEQr.tendermintSpec, header.appHash, (0, $94ZnX.toAscii)(store), storeProof.exist.value);
        return {
            key: key,
            value: value,
            height: height
        };
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        const { key: key, value: value, height: height, proof: proof, code: code, log: log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight
        });
        if (code) throw new Error(`Query failed with (${code}): ${log}`);
        if (!(0, $hm8y1.arrayContentEquals)(queryKey, key)) throw new Error(`Response key ${(0, $94ZnX.toHex)(key)} doesn't match query key ${(0, $94ZnX.toHex)(queryKey)}`);
        if (!height) throw new Error("No query height returned");
        if (!proof || proof.ops.length !== 2) throw new Error(`Expected 2 proof ops, got ${proof?.ops.length ?? 0}. Are you using stargate?`);
        // we don't need the results, but we can ensure the data is the proper format
        $d791a93b074bfb8f$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        $d791a93b074bfb8f$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $94ZnX.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [
                    ...proof.ops
                ]
            }
        };
    }
    /**
     * Performs an ABCI query to Tendermint without requesting a proof.
     *
     * If the `desiredHeight` is set, a particular height is requested. Otherwise
     * the latest height is requested. The response contains the actual height of
     * the query.
     */ async queryAbci(path, request, desiredHeight) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false,
            height: desiredHeight
        });
        if (response.code) throw new Error(`Query failed with (${response.code}): ${response.log}`);
        if (!response.height) throw new Error("No query height returned");
        return {
            value: response.value,
            height: response.height
        };
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, $hm8y1.assertDefined)(height);
        if (height === 0) throw new Error("Query returned height 0, cannot prove it");
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        } catch  {
        // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, $6Sxan.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) nextHeader = firstHeader;
        }
        while(!nextHeader){
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas.map((meta)=>meta.header).find((h)=>h.height === searchHeight);
            if (correctHeader) nextHeader = correctHeader;
            else await (0, $hm8y1.sleep)(1000);
        }
        (0, $hm8y1.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
}
module.exports.QueryClient = $d791a93b074bfb8f$var$QueryClient;

});
parcelRegister("fSEQr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyNonExistence = module.exports.verifyExistence = module.exports.tendermintSpec = module.exports.iavlSpec = module.exports.calculateExistenceRoot = module.exports.verifyNonMembership = module.exports.verifyMembership = module.exports.ics23 = void 0;

var $9cNrY = parcelRequire("9cNrY");
Object.defineProperty(module.exports, "ics23", {
    enumerable: true,
    get: function() {
        return $9cNrY.ics23;
    }
});

var $98J97 = parcelRequire("98J97");
Object.defineProperty(module.exports, "verifyMembership", {
    enumerable: true,
    get: function() {
        return $98J97.verifyMembership;
    }
});
Object.defineProperty(module.exports, "verifyNonMembership", {
    enumerable: true,
    get: function() {
        return $98J97.verifyNonMembership;
    }
});

var $kj4zP = parcelRequire("kj4zP");
Object.defineProperty(module.exports, "calculateExistenceRoot", {
    enumerable: true,
    get: function() {
        return $kj4zP.calculateExistenceRoot;
    }
});
Object.defineProperty(module.exports, "iavlSpec", {
    enumerable: true,
    get: function() {
        return $kj4zP.iavlSpec;
    }
});
Object.defineProperty(module.exports, "tendermintSpec", {
    enumerable: true,
    get: function() {
        return $kj4zP.tendermintSpec;
    }
});
Object.defineProperty(module.exports, "verifyExistence", {
    enumerable: true,
    get: function() {
        return $kj4zP.verifyExistence;
    }
});
Object.defineProperty(module.exports, "verifyNonExistence", {
    enumerable: true,
    get: function() {
        return $kj4zP.verifyNonExistence;
    }
});

});
parcelRegister("9cNrY", function(module, exports) {
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $1wC51 = parcelRequire("1wC51");
// Common aliases
var $6b3b97d1c9e74549$var$$Reader = $1wC51.Reader, $6b3b97d1c9e74549$var$$Writer = $1wC51.Writer, $6b3b97d1c9e74549$var$$util = $1wC51.util;
// Exported root namespace
var $6b3b97d1c9e74549$var$$root = $1wC51.roots["default"] || ($1wC51.roots["default"] = {});
$6b3b97d1c9e74549$var$$root.ics23 = function() {
    /**
     * Namespace ics23.
     * @exports ics23
     * @namespace
     */ var ics23 = {};
    /**
     * HashOp enum.
     * @name ics23.HashOp
     * @enum {string}
     * @property {number} NO_HASH=0 NO_HASH value
     * @property {number} SHA256=1 SHA256 value
     * @property {number} SHA512=2 SHA512 value
     * @property {number} KECCAK=3 KECCAK value
     * @property {number} RIPEMD160=4 RIPEMD160 value
     * @property {number} BITCOIN=5 BITCOIN value
     * @property {number} SHA512_256=6 SHA512_256 value
     */ ics23.HashOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_HASH"] = 0;
        values[valuesById[1] = "SHA256"] = 1;
        values[valuesById[2] = "SHA512"] = 2;
        values[valuesById[3] = "KECCAK"] = 3;
        values[valuesById[4] = "RIPEMD160"] = 4;
        values[valuesById[5] = "BITCOIN"] = 5;
        values[valuesById[6] = "SHA512_256"] = 6;
        return values;
    }();
    /**
     * LengthOp defines how to process the key and value of the LeafOp
     * to include length information. After encoding the length with the given
     * algorithm, the length will be prepended to the key and value bytes.
     * (Each one with it's own encoded length)
     * @name ics23.LengthOp
     * @enum {string}
     * @property {number} NO_PREFIX=0 NO_PREFIX value
     * @property {number} VAR_PROTO=1 VAR_PROTO value
     * @property {number} VAR_RLP=2 VAR_RLP value
     * @property {number} FIXED32_BIG=3 FIXED32_BIG value
     * @property {number} FIXED32_LITTLE=4 FIXED32_LITTLE value
     * @property {number} FIXED64_BIG=5 FIXED64_BIG value
     * @property {number} FIXED64_LITTLE=6 FIXED64_LITTLE value
     * @property {number} REQUIRE_32_BYTES=7 REQUIRE_32_BYTES value
     * @property {number} REQUIRE_64_BYTES=8 REQUIRE_64_BYTES value
     */ ics23.LengthOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_PREFIX"] = 0;
        values[valuesById[1] = "VAR_PROTO"] = 1;
        values[valuesById[2] = "VAR_RLP"] = 2;
        values[valuesById[3] = "FIXED32_BIG"] = 3;
        values[valuesById[4] = "FIXED32_LITTLE"] = 4;
        values[valuesById[5] = "FIXED64_BIG"] = 5;
        values[valuesById[6] = "FIXED64_LITTLE"] = 6;
        values[valuesById[7] = "REQUIRE_32_BYTES"] = 7;
        values[valuesById[8] = "REQUIRE_64_BYTES"] = 8;
        return values;
    }();
    ics23.ExistenceProof = function() {
        /**
         * Properties of an ExistenceProof.
         * @memberof ics23
         * @interface IExistenceProof
         * @property {Uint8Array|null} [key] ExistenceProof key
         * @property {Uint8Array|null} [value] ExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] ExistenceProof leaf
         * @property {Array.<ics23.IInnerOp>|null} [path] ExistenceProof path
         */ /**
         * Constructs a new ExistenceProof.
         * @memberof ics23
         * @classdesc ExistenceProof takes a key and a value and a set of steps to perform on it.
         * The result of peforming all these steps will provide a "root hash", which can
         * be compared to the value in a header.
         * 
         * Since it is computationally infeasible to produce a hash collission for any of the used
         * cryptographic hash functions, if someone can provide a series of operations to transform
         * a given key and value into a root hash that matches some trusted root, these key and values
         * must be in the referenced merkle tree.
         * 
         * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
         * which should be controlled by a spec. Eg. with lengthOp as NONE,
         * prefix = FOO, key = BAR, value = CHOICE
         * and
         * prefix = F, key = OOBAR, value = CHOICE
         * would produce the same value.
         * 
         * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
         * in the ProofSpec is valuable to prevent this mutability. And why all trees should
         * length-prefix the data before hashing it.
         * @implements IExistenceProof
         * @constructor
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         */ function ExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.key = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * ExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.value = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * ExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.leaf = null;
        /**
         * ExistenceProof path.
         * @member {Array.<ics23.IInnerOp>} path
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.path = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * Creates a new ExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         * @returns {ics23.ExistenceProof} ExistenceProof instance
         */ ExistenceProof.create = function create(properties) {
            return new ExistenceProof(properties);
        };
        /**
         * Encodes the specified ExistenceProof message. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $6b3b97d1c9e74549$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) for(var i = 0; i < message.path.length; ++i)$6b3b97d1c9e74549$var$$root.ics23.InnerOp.encode(message.path[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified ExistenceProof message, length delimited. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        message.path.push($6b3b97d1c9e74549$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an ExistenceProof message.
         * @function verify
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i){
                    var error = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.verify(message.path[i]);
                    if (error) return "path." + error;
                }
            }
            return null;
        };
        /**
         * Creates an ExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ExistenceProof} ExistenceProof
         */ ExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.key, message.key = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.value, message.value = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.ExistenceProof.leaf: object expected");
                message.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.ExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i){
                    if (typeof object.path[i] !== "object") throw TypeError(".ics23.ExistenceProof.path: object expected");
                    message.path[i] = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.fromObject(object.path[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from an ExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.ExistenceProof} message ExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $6b3b97d1c9e74549$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $6b3b97d1c9e74549$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.toObject(message.path[j], options);
            }
            return object;
        };
        /**
         * Converts this ExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.ExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return ExistenceProof;
    }();
    ics23.NonExistenceProof = function() {
        /**
         * Properties of a NonExistenceProof.
         * @memberof ics23
         * @interface INonExistenceProof
         * @property {Uint8Array|null} [key] NonExistenceProof key
         * @property {ics23.IExistenceProof|null} [left] NonExistenceProof left
         * @property {ics23.IExistenceProof|null} [right] NonExistenceProof right
         */ /**
         * Constructs a new NonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a NonExistenceProof.
         * @implements INonExistenceProof
         * @constructor
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         */ function NonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * NonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.key = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * NonExistenceProof left.
         * @member {ics23.IExistenceProof|null|undefined} left
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.left = null;
        /**
         * NonExistenceProof right.
         * @member {ics23.IExistenceProof|null|undefined} right
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.right = null;
        /**
         * Creates a new NonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         * @returns {ics23.NonExistenceProof} NonExistenceProof instance
         */ NonExistenceProof.create = function create(properties) {
            return new NonExistenceProof(properties);
        };
        /**
         * Encodes the specified NonExistenceProof message. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified NonExistenceProof message, length delimited. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a NonExistenceProof message.
         * @function verify
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ NonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a NonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         */ NonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.key, message.key = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.NonExistenceProof.left: object expected");
                message.left = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.NonExistenceProof.right: object expected");
                message.right = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a NonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.NonExistenceProof} message NonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ NonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $6b3b97d1c9e74549$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this NonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.NonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ NonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return NonExistenceProof;
    }();
    ics23.CommitmentProof = function() {
        /**
         * Properties of a CommitmentProof.
         * @memberof ics23
         * @interface ICommitmentProof
         * @property {ics23.IExistenceProof|null} [exist] CommitmentProof exist
         * @property {ics23.INonExistenceProof|null} [nonexist] CommitmentProof nonexist
         * @property {ics23.IBatchProof|null} [batch] CommitmentProof batch
         * @property {ics23.ICompressedBatchProof|null} [compressed] CommitmentProof compressed
         */ /**
         * Constructs a new CommitmentProof.
         * @memberof ics23
         * @classdesc Represents a CommitmentProof.
         * @implements ICommitmentProof
         * @constructor
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         */ function CommitmentProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CommitmentProof exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.exist = null;
        /**
         * CommitmentProof nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.nonexist = null;
        /**
         * CommitmentProof batch.
         * @member {ics23.IBatchProof|null|undefined} batch
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.batch = null;
        /**
         * CommitmentProof compressed.
         * @member {ics23.ICompressedBatchProof|null|undefined} compressed
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.compressed = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CommitmentProof proof.
         * @member {"exist"|"nonexist"|"batch"|"compressed"|undefined} proof
         * @memberof ics23.CommitmentProof
         * @instance
         */ Object.defineProperty(CommitmentProof.prototype, "proof", {
            get: $6b3b97d1c9e74549$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist",
                "batch",
                "compressed"
            ]),
            set: $6b3b97d1c9e74549$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CommitmentProof instance using the specified properties.
         * @function create
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         * @returns {ics23.CommitmentProof} CommitmentProof instance
         */ CommitmentProof.create = function create(properties) {
            return new CommitmentProof(properties);
        };
        /**
         * Encodes the specified CommitmentProof message. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.batch != null && message.hasOwnProperty("batch")) $6b3b97d1c9e74549$var$$root.ics23.BatchProof.encode(message.batch, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.compressed != null && message.hasOwnProperty("compressed")) $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof.encode(message.compressed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CommitmentProof message, length delimited. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.CommitmentProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.batch = $6b3b97d1c9e74549$var$$root.ics23.BatchProof.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.compressed = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CommitmentProof message.
         * @function verify
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CommitmentProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.BatchProof.verify(message.batch);
                if (error) return "batch." + error;
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof.verify(message.compressed);
                if (error) return "compressed." + error;
            }
            return null;
        };
        /**
         * Creates a CommitmentProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CommitmentProof} CommitmentProof
         */ CommitmentProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.CommitmentProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.CommitmentProof();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CommitmentProof.exist: object expected");
                message.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
                message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            if (object.batch != null) {
                if (typeof object.batch !== "object") throw TypeError(".ics23.CommitmentProof.batch: object expected");
                message.batch = $6b3b97d1c9e74549$var$$root.ics23.BatchProof.fromObject(object.batch);
            }
            if (object.compressed != null) {
                if (typeof object.compressed !== "object") throw TypeError(".ics23.CommitmentProof.compressed: object expected");
                message.compressed = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof.fromObject(object.compressed);
            }
            return message;
        };
        /**
         * Creates a plain object from a CommitmentProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.CommitmentProof} message CommitmentProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CommitmentProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                object.batch = $6b3b97d1c9e74549$var$$root.ics23.BatchProof.toObject(message.batch, options);
                if (options.oneofs) object.proof = "batch";
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                object.compressed = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof.toObject(message.compressed, options);
                if (options.oneofs) object.proof = "compressed";
            }
            return object;
        };
        /**
         * Converts this CommitmentProof to JSON.
         * @function toJSON
         * @memberof ics23.CommitmentProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CommitmentProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return CommitmentProof;
    }();
    ics23.LeafOp = function() {
        /**
         * Properties of a LeafOp.
         * @memberof ics23
         * @interface ILeafOp
         * @property {ics23.HashOp|null} [hash] LeafOp hash
         * @property {ics23.HashOp|null} [prehashKey] LeafOp prehashKey
         * @property {ics23.HashOp|null} [prehashValue] LeafOp prehashValue
         * @property {ics23.LengthOp|null} [length] LeafOp length
         * @property {Uint8Array|null} [prefix] LeafOp prefix
         */ /**
         * Constructs a new LeafOp.
         * @memberof ics23
         * @classdesc LeafOp represents the raw key-value data we wish to prove, and
         * must be flexible to represent the internal transformation from
         * the original key-value pairs into the basis hash, for many existing
         * merkle trees.
         * 
         * key and value are passed in. So that the signature of this operation is:
         * leafOp(key, value) -> output
         * 
         * To process this, first prehash the keys and values if needed (ANY means no hash in this case):
         * hkey = prehashKey(key)
         * hvalue = prehashValue(value)
         * 
         * Then combine the bytes, and hash it
         * output = hash(prefix || length(hkey) || hkey || length(hvalue) || hvalue)
         * @implements ILeafOp
         * @constructor
         * @param {ics23.ILeafOp=} [properties] Properties to set
         */ function LeafOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * LeafOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.hash = 0;
        /**
         * LeafOp prehashKey.
         * @member {ics23.HashOp} prehashKey
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashKey = 0;
        /**
         * LeafOp prehashValue.
         * @member {ics23.HashOp} prehashValue
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashValue = 0;
        /**
         * LeafOp length.
         * @member {ics23.LengthOp} length
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.length = 0;
        /**
         * LeafOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prefix = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * Creates a new LeafOp instance using the specified properties.
         * @function create
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp=} [properties] Properties to set
         * @returns {ics23.LeafOp} LeafOp instance
         */ LeafOp.create = function create(properties) {
            return new LeafOp(properties);
        };
        /**
         * Encodes the specified LeafOp message. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.prehashKey);
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.prehashValue);
            if (message.length != null && message.hasOwnProperty("length")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.length);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.prefix);
            return writer;
        };
        /**
         * Encodes the specified LeafOp message, length delimited. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.LeafOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prehashKey = reader.int32();
                        break;
                    case 3:
                        message.prehashValue = reader.int32();
                        break;
                    case 4:
                        message.length = reader.int32();
                        break;
                    case 5:
                        message.prefix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a LeafOp message.
         * @function verify
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ LeafOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) switch(message.prehashKey){
                default:
                    return "prehashKey: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) switch(message.prehashValue){
                default:
                    return "prehashValue: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.length != null && message.hasOwnProperty("length")) switch(message.length){
                default:
                    return "length: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            return null;
        };
        /**
         * Creates a LeafOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.LeafOp} LeafOp
         */ LeafOp.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.LeafOp) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.LeafOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            switch(object.prehashKey){
                case "NO_HASH":
                case 0:
                    message.prehashKey = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashKey = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashKey = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashKey = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashKey = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashKey = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashKey = 6;
                    break;
            }
            switch(object.prehashValue){
                case "NO_HASH":
                case 0:
                    message.prehashValue = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashValue = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashValue = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashValue = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashValue = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashValue = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashValue = 6;
                    break;
            }
            switch(object.length){
                case "NO_PREFIX":
                case 0:
                    message.length = 0;
                    break;
                case "VAR_PROTO":
                case 1:
                    message.length = 1;
                    break;
                case "VAR_RLP":
                case 2:
                    message.length = 2;
                    break;
                case "FIXED32_BIG":
                case 3:
                    message.length = 3;
                    break;
                case "FIXED32_LITTLE":
                case 4:
                    message.length = 4;
                    break;
                case "FIXED64_BIG":
                case 5:
                    message.length = 5;
                    break;
                case "FIXED64_LITTLE":
                case 6:
                    message.length = 6;
                    break;
                case "REQUIRE_32_BYTES":
                case 7:
                    message.length = 7;
                    break;
                case "REQUIRE_64_BYTES":
                case 8:
                    message.length = 8;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.prefix, message.prefix = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            return message;
        };
        /**
         * Creates a plain object from a LeafOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.LeafOp} message LeafOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ LeafOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                object.prehashKey = options.enums === String ? "NO_HASH" : 0;
                object.prehashValue = options.enums === String ? "NO_HASH" : 0;
                object.length = options.enums === String ? "NO_PREFIX" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $6b3b97d1c9e74549$var$$util.newBuffer(object.prefix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) object.prehashKey = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.HashOp[message.prehashKey] : message.prehashKey;
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) object.prehashValue = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.HashOp[message.prehashValue] : message.prehashValue;
            if (message.length != null && message.hasOwnProperty("length")) object.length = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.LengthOp[message.length] : message.length;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            return object;
        };
        /**
         * Converts this LeafOp to JSON.
         * @function toJSON
         * @memberof ics23.LeafOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ LeafOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return LeafOp;
    }();
    ics23.InnerOp = function() {
        /**
         * Properties of an InnerOp.
         * @memberof ics23
         * @interface IInnerOp
         * @property {ics23.HashOp|null} [hash] InnerOp hash
         * @property {Uint8Array|null} [prefix] InnerOp prefix
         * @property {Uint8Array|null} [suffix] InnerOp suffix
         */ /**
         * Constructs a new InnerOp.
         * @memberof ics23
         * @classdesc InnerOp represents a merkle-proof step that is not a leaf.
         * It represents concatenating two children and hashing them to provide the next result.
         * 
         * The result of the previous step is passed in, so the signature of this op is:
         * innerOp(child) -> output
         * 
         * The result of applying InnerOp should be:
         * output = op.hash(op.prefix || child || op.suffix)
         * 
         * where the || operator is concatenation of binary data,
         * and child is the result of hashing all the tree below this step.
         * 
         * Any special data, like prepending child with the length, or prepending the entire operation with
         * some value to differentiate from leaf nodes, should be included in prefix and suffix.
         * If either of prefix or suffix is empty, we just treat it as an empty string
         * @implements IInnerOp
         * @constructor
         * @param {ics23.IInnerOp=} [properties] Properties to set
         */ function InnerOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.hash = 0;
        /**
         * InnerOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.prefix = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * InnerOp suffix.
         * @member {Uint8Array} suffix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.suffix = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * Creates a new InnerOp instance using the specified properties.
         * @function create
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp=} [properties] Properties to set
         * @returns {ics23.InnerOp} InnerOp instance
         */ InnerOp.create = function create(properties) {
            return new InnerOp(properties);
        };
        /**
         * Encodes the specified InnerOp message. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.prefix);
            if (message.suffix != null && message.hasOwnProperty("suffix")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.suffix);
            return writer;
        };
        /**
         * Encodes the specified InnerOp message, length delimited. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.InnerOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prefix = reader.bytes();
                        break;
                    case 3:
                        message.suffix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerOp message.
         * @function verify
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            if (message.suffix != null && message.hasOwnProperty("suffix")) {
                if (!(message.suffix && typeof message.suffix.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.suffix))) return "suffix: buffer expected";
            }
            return null;
        };
        /**
         * Creates an InnerOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerOp} InnerOp
         */ InnerOp.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.InnerOp) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.InnerOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.prefix, message.prefix = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            if (object.suffix != null) {
                if (typeof object.suffix === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.suffix, message.suffix = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.suffix)), 0);
                else if (object.suffix.length) message.suffix = object.suffix;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.InnerOp} message InnerOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $6b3b97d1c9e74549$var$$util.newBuffer(object.prefix);
                }
                if (options.bytes === String) object.suffix = "";
                else {
                    object.suffix = [];
                    if (options.bytes !== Array) object.suffix = $6b3b97d1c9e74549$var$$util.newBuffer(object.suffix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            if (message.suffix != null && message.hasOwnProperty("suffix")) object.suffix = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.suffix, 0, message.suffix.length) : options.bytes === Array ? Array.prototype.slice.call(message.suffix) : message.suffix;
            return object;
        };
        /**
         * Converts this InnerOp to JSON.
         * @function toJSON
         * @memberof ics23.InnerOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return InnerOp;
    }();
    ics23.ProofSpec = function() {
        /**
         * Properties of a ProofSpec.
         * @memberof ics23
         * @interface IProofSpec
         * @property {ics23.ILeafOp|null} [leafSpec] ProofSpec leafSpec
         * @property {ics23.IInnerSpec|null} [innerSpec] ProofSpec innerSpec
         * @property {number|null} [maxDepth] ProofSpec maxDepth
         * @property {number|null} [minDepth] ProofSpec minDepth
         */ /**
         * Constructs a new ProofSpec.
         * @memberof ics23
         * @classdesc ProofSpec defines what the expected parameters are for a given proof type.
         * This can be stored in the client and used to validate any incoming proofs.
         * 
         * verify(ProofSpec, Proof) -> Proof | Error
         * 
         * As demonstrated in tests, if we don't fix the algorithm used to calculate the
         * LeafHash for a given tree, there are many possible key-value pairs that can
         * generate a given hash (by interpretting the preimage differently).
         * We need this for proper security, requires client knows a priori what
         * tree format server uses. But not in code, rather a configuration object.
         * @implements IProofSpec
         * @constructor
         * @param {ics23.IProofSpec=} [properties] Properties to set
         */ function ProofSpec(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ProofSpec leafSpec.
         * @member {ics23.ILeafOp|null|undefined} leafSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.leafSpec = null;
        /**
         * ProofSpec innerSpec.
         * @member {ics23.IInnerSpec|null|undefined} innerSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.innerSpec = null;
        /**
         * ProofSpec maxDepth.
         * @member {number} maxDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.maxDepth = 0;
        /**
         * ProofSpec minDepth.
         * @member {number} minDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.minDepth = 0;
        /**
         * Creates a new ProofSpec instance using the specified properties.
         * @function create
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec=} [properties] Properties to set
         * @returns {ics23.ProofSpec} ProofSpec instance
         */ ProofSpec.create = function create(properties) {
            return new ProofSpec(properties);
        };
        /**
         * Encodes the specified ProofSpec message. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) $6b3b97d1c9e74549$var$$root.ics23.LeafOp.encode(message.leafSpec, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) $6b3b97d1c9e74549$var$$root.ics23.InnerSpec.encode(message.innerSpec, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.maxDepth);
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.minDepth);
            return writer;
        };
        /**
         * Encodes the specified ProofSpec message, length delimited. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.ProofSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.leafSpec = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.innerSpec = $6b3b97d1c9e74549$var$$root.ics23.InnerSpec.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.maxDepth = reader.int32();
                        break;
                    case 4:
                        message.minDepth = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a ProofSpec message.
         * @function verify
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ProofSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.verify(message.leafSpec);
                if (error) return "leafSpec." + error;
            }
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.InnerSpec.verify(message.innerSpec);
                if (error) return "innerSpec." + error;
            }
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) {
                if (!$6b3b97d1c9e74549$var$$util.isInteger(message.maxDepth)) return "maxDepth: integer expected";
            }
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) {
                if (!$6b3b97d1c9e74549$var$$util.isInteger(message.minDepth)) return "minDepth: integer expected";
            }
            return null;
        };
        /**
         * Creates a ProofSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ProofSpec} ProofSpec
         */ ProofSpec.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.ProofSpec) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.ProofSpec();
            if (object.leafSpec != null) {
                if (typeof object.leafSpec !== "object") throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
                message.leafSpec = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.fromObject(object.leafSpec);
            }
            if (object.innerSpec != null) {
                if (typeof object.innerSpec !== "object") throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
                message.innerSpec = $6b3b97d1c9e74549$var$$root.ics23.InnerSpec.fromObject(object.innerSpec);
            }
            if (object.maxDepth != null) message.maxDepth = object.maxDepth | 0;
            if (object.minDepth != null) message.minDepth = object.minDepth | 0;
            return message;
        };
        /**
         * Creates a plain object from a ProofSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.ProofSpec} message ProofSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ProofSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.leafSpec = null;
                object.innerSpec = null;
                object.maxDepth = 0;
                object.minDepth = 0;
            }
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) object.leafSpec = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.toObject(message.leafSpec, options);
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) object.innerSpec = $6b3b97d1c9e74549$var$$root.ics23.InnerSpec.toObject(message.innerSpec, options);
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) object.maxDepth = message.maxDepth;
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) object.minDepth = message.minDepth;
            return object;
        };
        /**
         * Converts this ProofSpec to JSON.
         * @function toJSON
         * @memberof ics23.ProofSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ProofSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return ProofSpec;
    }();
    ics23.InnerSpec = function() {
        /**
         * Properties of an InnerSpec.
         * @memberof ics23
         * @interface IInnerSpec
         * @property {Array.<number>|null} [childOrder] InnerSpec childOrder
         * @property {number|null} [childSize] InnerSpec childSize
         * @property {number|null} [minPrefixLength] InnerSpec minPrefixLength
         * @property {number|null} [maxPrefixLength] InnerSpec maxPrefixLength
         * @property {Uint8Array|null} [emptyChild] InnerSpec emptyChild
         * @property {ics23.HashOp|null} [hash] InnerSpec hash
         */ /**
         * Constructs a new InnerSpec.
         * @memberof ics23
         * @classdesc Represents an InnerSpec.
         * @implements IInnerSpec
         * @constructor
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         */ function InnerSpec(properties) {
            this.childOrder = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerSpec childOrder.
         * @member {Array.<number>} childOrder
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childOrder = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * InnerSpec childSize.
         * @member {number} childSize
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childSize = 0;
        /**
         * InnerSpec minPrefixLength.
         * @member {number} minPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.minPrefixLength = 0;
        /**
         * InnerSpec maxPrefixLength.
         * @member {number} maxPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.maxPrefixLength = 0;
        /**
         * InnerSpec emptyChild.
         * @member {Uint8Array} emptyChild
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.emptyChild = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * InnerSpec hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.hash = 0;
        /**
         * Creates a new InnerSpec instance using the specified properties.
         * @function create
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         * @returns {ics23.InnerSpec} InnerSpec instance
         */ InnerSpec.create = function create(properties) {
            return new InnerSpec(properties);
        };
        /**
         * Encodes the specified InnerSpec message. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.childOrder != null && message.childOrder.length) {
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
                for(var i = 0; i < message.childOrder.length; ++i)writer.int32(message.childOrder[i]);
                writer.ldelim();
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.childSize);
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.minPrefixLength);
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.maxPrefixLength);
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.emptyChild);
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.hash);
            return writer;
        };
        /**
         * Encodes the specified InnerSpec message, length delimited. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.InnerSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.childOrder && message.childOrder.length)) message.childOrder = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.childOrder.push(reader.int32());
                        } else message.childOrder.push(reader.int32());
                        break;
                    case 2:
                        message.childSize = reader.int32();
                        break;
                    case 3:
                        message.minPrefixLength = reader.int32();
                        break;
                    case 4:
                        message.maxPrefixLength = reader.int32();
                        break;
                    case 5:
                        message.emptyChild = reader.bytes();
                        break;
                    case 6:
                        message.hash = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerSpec message.
         * @function verify
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.childOrder != null && message.hasOwnProperty("childOrder")) {
                if (!Array.isArray(message.childOrder)) return "childOrder: array expected";
                for(var i = 0; i < message.childOrder.length; ++i)if (!$6b3b97d1c9e74549$var$$util.isInteger(message.childOrder[i])) return "childOrder: integer[] expected";
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) {
                if (!$6b3b97d1c9e74549$var$$util.isInteger(message.childSize)) return "childSize: integer expected";
            }
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) {
                if (!$6b3b97d1c9e74549$var$$util.isInteger(message.minPrefixLength)) return "minPrefixLength: integer expected";
            }
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) {
                if (!$6b3b97d1c9e74549$var$$util.isInteger(message.maxPrefixLength)) return "maxPrefixLength: integer expected";
            }
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) {
                if (!(message.emptyChild && typeof message.emptyChild.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.emptyChild))) return "emptyChild: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            return null;
        };
        /**
         * Creates an InnerSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerSpec} InnerSpec
         */ InnerSpec.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.InnerSpec) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.InnerSpec();
            if (object.childOrder) {
                if (!Array.isArray(object.childOrder)) throw TypeError(".ics23.InnerSpec.childOrder: array expected");
                message.childOrder = [];
                for(var i = 0; i < object.childOrder.length; ++i)message.childOrder[i] = object.childOrder[i] | 0;
            }
            if (object.childSize != null) message.childSize = object.childSize | 0;
            if (object.minPrefixLength != null) message.minPrefixLength = object.minPrefixLength | 0;
            if (object.maxPrefixLength != null) message.maxPrefixLength = object.maxPrefixLength | 0;
            if (object.emptyChild != null) {
                if (typeof object.emptyChild === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.emptyChild, message.emptyChild = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.emptyChild)), 0);
                else if (object.emptyChild.length) message.emptyChild = object.emptyChild;
            }
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.InnerSpec} message InnerSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.childOrder = [];
            if (options.defaults) {
                object.childSize = 0;
                object.minPrefixLength = 0;
                object.maxPrefixLength = 0;
                if (options.bytes === String) object.emptyChild = "";
                else {
                    object.emptyChild = [];
                    if (options.bytes !== Array) object.emptyChild = $6b3b97d1c9e74549$var$$util.newBuffer(object.emptyChild);
                }
                object.hash = options.enums === String ? "NO_HASH" : 0;
            }
            if (message.childOrder && message.childOrder.length) {
                object.childOrder = [];
                for(var j = 0; j < message.childOrder.length; ++j)object.childOrder[j] = message.childOrder[j];
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) object.childSize = message.childSize;
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) object.minPrefixLength = message.minPrefixLength;
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) object.maxPrefixLength = message.maxPrefixLength;
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) object.emptyChild = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.emptyChild, 0, message.emptyChild.length) : options.bytes === Array ? Array.prototype.slice.call(message.emptyChild) : message.emptyChild;
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $6b3b97d1c9e74549$var$$root.ics23.HashOp[message.hash] : message.hash;
            return object;
        };
        /**
         * Converts this InnerSpec to JSON.
         * @function toJSON
         * @memberof ics23.InnerSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return InnerSpec;
    }();
    ics23.BatchProof = function() {
        /**
         * Properties of a BatchProof.
         * @memberof ics23
         * @interface IBatchProof
         * @property {Array.<ics23.IBatchEntry>|null} [entries] BatchProof entries
         */ /**
         * Constructs a new BatchProof.
         * @memberof ics23
         * @classdesc Represents a BatchProof.
         * @implements IBatchProof
         * @constructor
         * @param {ics23.IBatchProof=} [properties] Properties to set
         */ function BatchProof(properties) {
            this.entries = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchProof entries.
         * @member {Array.<ics23.IBatchEntry>} entries
         * @memberof ics23.BatchProof
         * @instance
         */ BatchProof.prototype.entries = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * Creates a new BatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof=} [properties] Properties to set
         * @returns {ics23.BatchProof} BatchProof instance
         */ BatchProof.create = function create(properties) {
            return new BatchProof(properties);
        };
        /**
         * Encodes the specified BatchProof message. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$6b3b97d1c9e74549$var$$root.ics23.BatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchProof message, length delimited. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.BatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($6b3b97d1c9e74549$var$$root.ics23.BatchEntry.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchProof message.
         * @function verify
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $6b3b97d1c9e74549$var$$root.ics23.BatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            return null;
        };
        /**
         * Creates a BatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchProof} BatchProof
         */ BatchProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.BatchProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.BatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.BatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.BatchProof.entries: object expected");
                    message.entries[i] = $6b3b97d1c9e74549$var$$root.ics23.BatchEntry.fromObject(object.entries[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.BatchProof} message BatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.entries = [];
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $6b3b97d1c9e74549$var$$root.ics23.BatchEntry.toObject(message.entries[j], options);
            }
            return object;
        };
        /**
         * Converts this BatchProof to JSON.
         * @function toJSON
         * @memberof ics23.BatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return BatchProof;
    }();
    ics23.BatchEntry = function() {
        /**
         * Properties of a BatchEntry.
         * @memberof ics23
         * @interface IBatchEntry
         * @property {ics23.IExistenceProof|null} [exist] BatchEntry exist
         * @property {ics23.INonExistenceProof|null} [nonexist] BatchEntry nonexist
         */ /**
         * Constructs a new BatchEntry.
         * @memberof ics23
         * @classdesc Represents a BatchEntry.
         * @implements IBatchEntry
         * @constructor
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         */ function BatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchEntry exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.exist = null;
        /**
         * BatchEntry nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * BatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.BatchEntry
         * @instance
         */ Object.defineProperty(BatchEntry.prototype, "proof", {
            get: $6b3b97d1c9e74549$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $6b3b97d1c9e74549$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new BatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         * @returns {ics23.BatchEntry} BatchEntry instance
         */ BatchEntry.create = function create(properties) {
            return new BatchEntry(properties);
        };
        /**
         * Encodes the specified BatchEntry message. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchEntry message, length delimited. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.BatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchEntry message.
         * @function verify
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a BatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchEntry} BatchEntry
         */ BatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.BatchEntry) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.BatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.BatchEntry.exist: object expected");
                message.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.BatchEntry.nonexist: object expected");
                message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.BatchEntry} message BatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $6b3b97d1c9e74549$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $6b3b97d1c9e74549$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this BatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.BatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return BatchEntry;
    }();
    ics23.CompressedBatchProof = function() {
        /**
         * Properties of a CompressedBatchProof.
         * @memberof ics23
         * @interface ICompressedBatchProof
         * @property {Array.<ics23.ICompressedBatchEntry>|null} [entries] CompressedBatchProof entries
         * @property {Array.<ics23.IInnerOp>|null} [lookupInners] CompressedBatchProof lookupInners
         */ /**
         * Constructs a new CompressedBatchProof.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchProof.
         * @implements ICompressedBatchProof
         * @constructor
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         */ function CompressedBatchProof(properties) {
            this.entries = [];
            this.lookupInners = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchProof entries.
         * @member {Array.<ics23.ICompressedBatchEntry>} entries
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.entries = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * CompressedBatchProof lookupInners.
         * @member {Array.<ics23.IInnerOp>} lookupInners
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.lookupInners = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * Creates a new CompressedBatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof instance
         */ CompressedBatchProof.create = function create(properties) {
            return new CompressedBatchProof(properties);
        };
        /**
         * Encodes the specified CompressedBatchProof message. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.lookupInners != null && message.lookupInners.length) for(var i = 0; i < message.lookupInners.length; ++i)$6b3b97d1c9e74549$var$$root.ics23.InnerOp.encode(message.lookupInners[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchProof message, length delimited. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.lookupInners && message.lookupInners.length)) message.lookupInners = [];
                        message.lookupInners.push($6b3b97d1c9e74549$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchProof message.
         * @function verify
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            if (message.lookupInners != null && message.hasOwnProperty("lookupInners")) {
                if (!Array.isArray(message.lookupInners)) return "lookupInners: array expected";
                for(var i = 0; i < message.lookupInners.length; ++i){
                    var error = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.verify(message.lookupInners[i]);
                    if (error) return "lookupInners." + error;
                }
            }
            return null;
        };
        /**
         * Creates a CompressedBatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         */ CompressedBatchProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
                    message.entries[i] = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry.fromObject(object.entries[i]);
                }
            }
            if (object.lookupInners) {
                if (!Array.isArray(object.lookupInners)) throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
                message.lookupInners = [];
                for(var i = 0; i < object.lookupInners.length; ++i){
                    if (typeof object.lookupInners[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
                    message.lookupInners[i] = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.fromObject(object.lookupInners[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.CompressedBatchProof} message CompressedBatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.lookupInners = [];
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry.toObject(message.entries[j], options);
            }
            if (message.lookupInners && message.lookupInners.length) {
                object.lookupInners = [];
                for(var j = 0; j < message.lookupInners.length; ++j)object.lookupInners[j] = $6b3b97d1c9e74549$var$$root.ics23.InnerOp.toObject(message.lookupInners[j], options);
            }
            return object;
        };
        /**
         * Converts this CompressedBatchProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return CompressedBatchProof;
    }();
    ics23.CompressedBatchEntry = function() {
        /**
         * Properties of a CompressedBatchEntry.
         * @memberof ics23
         * @interface ICompressedBatchEntry
         * @property {ics23.ICompressedExistenceProof|null} [exist] CompressedBatchEntry exist
         * @property {ics23.ICompressedNonExistenceProof|null} [nonexist] CompressedBatchEntry nonexist
         */ /**
         * Constructs a new CompressedBatchEntry.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchEntry.
         * @implements ICompressedBatchEntry
         * @constructor
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         */ function CompressedBatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchEntry exist.
         * @member {ics23.ICompressedExistenceProof|null|undefined} exist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.exist = null;
        /**
         * CompressedBatchEntry nonexist.
         * @member {ics23.ICompressedNonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CompressedBatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ Object.defineProperty(CompressedBatchEntry.prototype, "proof", {
            get: $6b3b97d1c9e74549$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $6b3b97d1c9e74549$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CompressedBatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry instance
         */ CompressedBatchEntry.create = function create(properties) {
            return new CompressedBatchEntry(properties);
        };
        /**
         * Encodes the specified CompressedBatchEntry message. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchEntry message, length delimited. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchEntry message.
         * @function verify
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedBatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         */ CompressedBatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedBatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
                message.exist = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
                message.nonexist = $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.CompressedBatchEntry} message CompressedBatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this CompressedBatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return CompressedBatchEntry;
    }();
    ics23.CompressedExistenceProof = function() {
        /**
         * Properties of a CompressedExistenceProof.
         * @memberof ics23
         * @interface ICompressedExistenceProof
         * @property {Uint8Array|null} [key] CompressedExistenceProof key
         * @property {Uint8Array|null} [value] CompressedExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] CompressedExistenceProof leaf
         * @property {Array.<number>|null} [path] CompressedExistenceProof path
         */ /**
         * Constructs a new CompressedExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedExistenceProof.
         * @implements ICompressedExistenceProof
         * @constructor
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         */ function CompressedExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.key = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.value = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.leaf = null;
        /**
         * CompressedExistenceProof path.
         * @member {Array.<number>} path
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.path = $6b3b97d1c9e74549$var$$util.emptyArray;
        /**
         * Creates a new CompressedExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof instance
         */ CompressedExistenceProof.create = function create(properties) {
            return new CompressedExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedExistenceProof message. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $6b3b97d1c9e74549$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) {
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
                for(var i = 0; i < message.path.length; ++i)writer.int32(message.path[i]);
                writer.ldelim();
            }
            return writer;
        };
        /**
         * Encodes the specified CompressedExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.path.push(reader.int32());
                        } else message.path.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i)if (!$6b3b97d1c9e74549$var$$util.isInteger(message.path[i])) return "path: integer[] expected";
            }
            return null;
        };
        /**
         * Creates a CompressedExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         */ CompressedExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.key, message.key = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.value, message.value = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
                message.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i)message.path[i] = object.path[i] | 0;
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.CompressedExistenceProof} message CompressedExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $6b3b97d1c9e74549$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $6b3b97d1c9e74549$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $6b3b97d1c9e74549$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = message.path[j];
            }
            return object;
        };
        /**
         * Converts this CompressedExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return CompressedExistenceProof;
    }();
    ics23.CompressedNonExistenceProof = function() {
        /**
         * Properties of a CompressedNonExistenceProof.
         * @memberof ics23
         * @interface ICompressedNonExistenceProof
         * @property {Uint8Array|null} [key] CompressedNonExistenceProof key
         * @property {ics23.ICompressedExistenceProof|null} [left] CompressedNonExistenceProof left
         * @property {ics23.ICompressedExistenceProof|null} [right] CompressedNonExistenceProof right
         */ /**
         * Constructs a new CompressedNonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedNonExistenceProof.
         * @implements ICompressedNonExistenceProof
         * @constructor
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         */ function CompressedNonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedNonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.key = $6b3b97d1c9e74549$var$$util.newBuffer([]);
        /**
         * CompressedNonExistenceProof left.
         * @member {ics23.ICompressedExistenceProof|null|undefined} left
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.left = null;
        /**
         * CompressedNonExistenceProof right.
         * @member {ics23.ICompressedExistenceProof|null|undefined} right
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.right = null;
        /**
         * Creates a new CompressedNonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof instance
         */ CompressedNonExistenceProof.create = function create(properties) {
            return new CompressedNonExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $6b3b97d1c9e74549$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = $6b3b97d1c9e74549$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $6b3b97d1c9e74549$var$$Reader)) reader = new $6b3b97d1c9e74549$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedNonExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedNonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $6b3b97d1c9e74549$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedNonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         */ CompressedNonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof) return object;
            var message = new $6b3b97d1c9e74549$var$$root.ics23.CompressedNonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $6b3b97d1c9e74549$var$$util.base64.decode(object.key, message.key = $6b3b97d1c9e74549$var$$util.newBuffer($6b3b97d1c9e74549$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
                message.left = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
                message.right = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedNonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.CompressedNonExistenceProof} message CompressedNonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedNonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $6b3b97d1c9e74549$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $6b3b97d1c9e74549$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $6b3b97d1c9e74549$var$$root.ics23.CompressedExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this CompressedNonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedNonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $1wC51.util.toJSONOptions);
        };
        return CompressedNonExistenceProof;
    }();
    return ics23;
}();
module.exports = $6b3b97d1c9e74549$var$$root;

});

parcelRegister("98J97", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.batchVerifyNonMembership = module.exports.batchVerifyMembership = module.exports.verifyNonMembership = module.exports.verifyMembership = void 0;

var $4Nuwk = parcelRequire("4Nuwk");

var $kj4zP = parcelRequire("kj4zP");

var $kt0dj = parcelRequire("kt0dj");
/*
This implements the client side functions as specified in
https://github.com/cosmos/ics/tree/master/spec/ics-023-vector-commitments

In particular:

  // Assumes ExistenceProof
  type verifyMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key, value: Value) => boolean

  // Assumes NonExistenceProof
  type verifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key) => boolean

  // Assumes BatchProof - required ExistenceProofs may be a subset of all items proven
  type batchVerifyMembership = (root: CommitmentRoot, proof: CommitmentProof, items: Map<Key, Value>) => boolean

  // Assumes BatchProof - required NonExistenceProofs may be a subset of all items proven
  type batchVerifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, keys: Set<Key>) => boolean

We make an adjustment to accept a Spec to ensure the provided proof is in the format of the expected merkle store.
This can avoid an range of attacks on fake preimages, as we need to be careful on how to map key, value -> leaf
and determine neighbors
*/ /**
 * verifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $6a77e178b5b29f40$var$verifyMembership(proof, spec, root, key, value) {
    const norm = (0, $4Nuwk.decompress)(proof);
    const exist = $6a77e178b5b29f40$var$getExistForKey(norm, key);
    if (!exist) return false;
    try {
        (0, $kj4zP.verifyExistence)(exist, spec, root, key, value);
        return true;
    } catch (_a) {
        return false;
    }
}
module.exports.verifyMembership = $6a77e178b5b29f40$var$verifyMembership;
/**
 * verifyNonMembership ensures proof is (contains) a valid non-existence proof for the given key
 */ function $6a77e178b5b29f40$var$verifyNonMembership(proof, spec, root, key) {
    const norm = (0, $4Nuwk.decompress)(proof);
    const nonexist = $6a77e178b5b29f40$var$getNonExistForKey(norm, key);
    if (!nonexist) return false;
    try {
        (0, $kj4zP.verifyNonExistence)(nonexist, spec, root, key);
        return true;
    } catch (_a) {
        return false;
    }
}
module.exports.verifyNonMembership = $6a77e178b5b29f40$var$verifyNonMembership;
/**
 * batchVerifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $6a77e178b5b29f40$var$batchVerifyMembership(proof, spec, root, items) {
    const norm = (0, $4Nuwk.decompress)(proof);
    for (const [key, value] of items.entries()){
        if (!$6a77e178b5b29f40$var$verifyMembership(norm, spec, root, key, value)) return false;
    }
    return true;
}
module.exports.batchVerifyMembership = $6a77e178b5b29f40$var$batchVerifyMembership;
/**
 * batchVerifyNonMembership ensures proof is (contains) a valid existence proof for the given
 */ function $6a77e178b5b29f40$var$batchVerifyNonMembership(proof, spec, root, keys) {
    const norm = (0, $4Nuwk.decompress)(proof);
    for (const key of keys){
        if (!$6a77e178b5b29f40$var$verifyNonMembership(norm, spec, root, key)) return false;
    }
    return true;
}
module.exports.batchVerifyNonMembership = $6a77e178b5b29f40$var$batchVerifyNonMembership;
function $6a77e178b5b29f40$var$getExistForKey(proof, key) {
    const match = (p)=>!!p && (0, $kt0dj.bytesEqual)(key, p.key);
    if (match(proof.exist)) return proof.exist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.exist || null).find(match);
    return undefined;
}
function $6a77e178b5b29f40$var$getNonExistForKey(proof, key) {
    const match = (p)=>{
        return !!p && (!p.left || (0, $kt0dj.bytesBefore)(p.left.key, key)) && (!p.right || (0, $kt0dj.bytesBefore)(key, p.right.key));
    };
    if (match(proof.nonexist)) return proof.nonexist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.nonexist || null).find(match);
    return undefined;
}

});
parcelRegister("4Nuwk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decompress = module.exports.compress = void 0;

var $9cNrY = parcelRequire("9cNrY");
function $37e369c1a4c76e82$var$compress(proof) {
    if (!proof.batch) return proof;
    return {
        compressed: $37e369c1a4c76e82$var$compressBatch(proof.batch)
    };
}
module.exports.compress = $37e369c1a4c76e82$var$compress;
function $37e369c1a4c76e82$var$decompress(proof) {
    if (!proof.compressed) return proof;
    return {
        batch: $37e369c1a4c76e82$var$decompressBatch(proof.compressed)
    };
}
module.exports.decompress = $37e369c1a4c76e82$var$decompress;
function $37e369c1a4c76e82$var$compressBatch(proof) {
    const centries = [];
    const lookup = [];
    const registry = new Map();
    for (const entry of proof.entries){
        if (entry.exist) {
            const centry = {
                exist: $37e369c1a4c76e82$var$compressExist(entry.exist, lookup, registry)
            };
            centries.push(centry);
        } else if (entry.nonexist) {
            const non = entry.nonexist;
            const centry = {
                nonexist: {
                    key: non.key,
                    left: $37e369c1a4c76e82$var$compressExist(non.left, lookup, registry),
                    right: $37e369c1a4c76e82$var$compressExist(non.right, lookup, registry)
                }
            };
            centries.push(centry);
        } else throw new Error("Unexpected batch entry during compress");
    }
    return {
        entries: centries,
        lookupInners: lookup
    };
}
function $37e369c1a4c76e82$var$compressExist(exist, lookup, registry) {
    if (!exist) return undefined;
    const path = exist.path.map((inner)=>{
        const sig = $9cNrY.ics23.InnerOp.encode(inner).finish();
        let idx = registry.get(sig);
        if (idx === undefined) {
            idx = lookup.length;
            lookup.push(inner);
            registry.set(sig, idx);
        }
        return idx;
    });
    return {
        key: exist.key,
        value: exist.value,
        leaf: exist.leaf,
        path: path
    };
}
function $37e369c1a4c76e82$var$decompressBatch(proof) {
    const lookup = proof.lookupInners;
    const entries = proof.entries.map((comp)=>{
        if (comp.exist) return {
            exist: $37e369c1a4c76e82$var$decompressExist(comp.exist, lookup)
        };
        else if (comp.nonexist) {
            const non = comp.nonexist;
            return {
                nonexist: {
                    key: non.key,
                    left: $37e369c1a4c76e82$var$decompressExist(non.left, lookup),
                    right: $37e369c1a4c76e82$var$decompressExist(non.right, lookup)
                }
            };
        } else throw new Error("Unexpected batch entry during compress");
    });
    return {
        entries: entries
    };
}
function $37e369c1a4c76e82$var$decompressExist(exist, lookup) {
    if (!exist) return undefined;
    const { key: key, value: value, leaf: leaf, path: path } = exist;
    const newPath = (path || []).map((idx)=>lookup[idx]);
    return {
        key: key,
        value: value,
        leaf: leaf,
        path: newPath
    };
}

});

parcelRegister("kj4zP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ensureLeftNeighbor = module.exports.ensureSpec = module.exports.calculateExistenceRoot = module.exports.verifyNonExistence = module.exports.verifyExistence = module.exports.smtSpec = module.exports.tendermintSpec = module.exports.iavlSpec = void 0;

var $9cNrY = parcelRequire("9cNrY");

var $iLcxd = parcelRequire("iLcxd");

var $kt0dj = parcelRequire("kt0dj");
module.exports.iavlSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $9cNrY.ics23.HashOp.SHA256,
        prehashValue: $9cNrY.ics23.HashOp.SHA256,
        prehashKey: $9cNrY.ics23.HashOp.NO_HASH,
        length: $9cNrY.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 4,
        maxPrefixLength: 12,
        childSize: 33,
        hash: $9cNrY.ics23.HashOp.SHA256
    }
};
module.exports.tendermintSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $9cNrY.ics23.HashOp.SHA256,
        prehashValue: $9cNrY.ics23.HashOp.SHA256,
        prehashKey: $9cNrY.ics23.HashOp.NO_HASH,
        length: $9cNrY.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 1,
        maxPrefixLength: 1,
        childSize: 32,
        hash: $9cNrY.ics23.HashOp.SHA256
    }
};
module.exports.smtSpec = {
    leafSpec: {
        hash: $9cNrY.ics23.HashOp.SHA256,
        prehashKey: $9cNrY.ics23.HashOp.NO_HASH,
        prehashValue: $9cNrY.ics23.HashOp.SHA256,
        length: $9cNrY.ics23.LengthOp.NO_PREFIX,
        prefix: Uint8Array.from([
            0
        ])
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        childSize: 32,
        minPrefixLength: 1,
        maxPrefixLength: 1,
        emptyChild: new Uint8Array(32),
        hash: $9cNrY.ics23.HashOp.SHA256
    },
    maxDepth: 256
};
// verifyExistence will throw an error if the proof doesn't link key, value -> root
// or if it doesn't fulfill the spec
function $ec8921d84a01cd55$var$verifyExistence(proof, spec, root, key, value) {
    $ec8921d84a01cd55$var$ensureSpec(proof, spec);
    const calc = $ec8921d84a01cd55$var$calculateExistenceRoot(proof);
    (0, $kt0dj.ensureBytesEqual)(calc, root);
    (0, $kt0dj.ensureBytesEqual)(key, proof.key);
    (0, $kt0dj.ensureBytesEqual)(value, proof.value);
}
module.exports.verifyExistence = $ec8921d84a01cd55$var$verifyExistence;
// Verify does all checks to ensure the proof has valid non-existence proofs,
// and they ensure the given key is not in the CommitmentState,
// throwing an error if there is an issue
function $ec8921d84a01cd55$var$verifyNonExistence(proof, spec, root, key) {
    let leftKey;
    let rightKey;
    if (proof.left) {
        $ec8921d84a01cd55$var$verifyExistence(proof.left, spec, root, proof.left.key, proof.left.value);
        leftKey = proof.left.key;
    }
    if (proof.right) {
        $ec8921d84a01cd55$var$verifyExistence(proof.right, spec, root, proof.right.key, proof.right.value);
        rightKey = proof.right.key;
    }
    if (!leftKey && !rightKey) throw new Error("neither left nor right proof defined");
    if (leftKey) (0, $kt0dj.ensureBytesBefore)(leftKey, key);
    if (rightKey) (0, $kt0dj.ensureBytesBefore)(key, rightKey);
    if (!spec.innerSpec) throw new Error("no inner spec");
    if (!leftKey) $ec8921d84a01cd55$var$ensureLeftMost(spec.innerSpec, proof.right.path);
    else if (!rightKey) $ec8921d84a01cd55$var$ensureRightMost(spec.innerSpec, proof.left.path);
    else $ec8921d84a01cd55$var$ensureLeftNeighbor(spec.innerSpec, proof.left.path, proof.right.path);
    return;
}
module.exports.verifyNonExistence = $ec8921d84a01cd55$var$verifyNonExistence;
// Calculate determines the root hash that matches the given proof.
// You must validate the result is what you have in a header.
// Returns error if the calculations cannot be performed.
function $ec8921d84a01cd55$var$calculateExistenceRoot(proof) {
    if (!proof.key || !proof.value) throw new Error("Existence proof needs key and value set");
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    const path = proof.path || [];
    let res = (0, $iLcxd.applyLeaf)(proof.leaf, proof.key, proof.value);
    for (const inner of path)res = (0, $iLcxd.applyInner)(inner, res);
    return res;
}
module.exports.calculateExistenceRoot = $ec8921d84a01cd55$var$calculateExistenceRoot;
// ensureSpec throws an Error if proof doesn't fulfill spec
function $ec8921d84a01cd55$var$ensureSpec(proof, spec) {
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    if (!spec.leafSpec) throw new Error("Spec must include leafSpec");
    if (!spec.innerSpec) throw new Error("Spec must include innerSpec");
    (0, $kt0dj.ensureLeaf)(proof.leaf, spec.leafSpec);
    const path = proof.path || [];
    if (spec.minDepth && path.length < spec.minDepth) throw new Error(`Too few inner nodes ${path.length}`);
    if (spec.maxDepth && path.length > spec.maxDepth) throw new Error(`Too many inner nodes ${path.length}`);
    for (const inner of path)(0, $kt0dj.ensureInner)(inner, spec.leafSpec.prefix, spec.innerSpec);
}
module.exports.ensureSpec = $ec8921d84a01cd55$var$ensureSpec;
function $ec8921d84a01cd55$var$ensureLeftMost(spec, path) {
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $ec8921d84a01cd55$var$getPadding(spec, 0);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$ec8921d84a01cd55$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $ec8921d84a01cd55$var$ensureRightMost(spec, path) {
    const len = spec.childOrder.length - 1;
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $ec8921d84a01cd55$var$getPadding(spec, len);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$ec8921d84a01cd55$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $ec8921d84a01cd55$var$ensureLeftNeighbor(spec, left, right) {
    const mutleft = [
        ...left
    ];
    const mutright = [
        ...right
    ];
    let topleft = mutleft.pop();
    let topright = mutright.pop();
    while((0, $kt0dj.bytesEqual)(topleft.prefix, topright.prefix) && (0, $kt0dj.bytesEqual)(topleft.suffix, topright.suffix)){
        topleft = mutleft.pop();
        topright = mutright.pop();
    }
    // now topleft and topright are the first divergent nodes
    // make sure they are left and right of each other
    if (!$ec8921d84a01cd55$var$isLeftStep(spec, topleft, topright)) throw new Error(`Not left neightbor at first divergent step`);
    // make sure the paths are left and right most possibilities respectively
    $ec8921d84a01cd55$var$ensureRightMost(spec, mutleft);
    $ec8921d84a01cd55$var$ensureLeftMost(spec, mutright);
}
module.exports.ensureLeftNeighbor = $ec8921d84a01cd55$var$ensureLeftNeighbor;
// isLeftStep assumes left and right have common parents
// checks if left is exactly one slot to the left of right
function $ec8921d84a01cd55$var$isLeftStep(spec, left, right) {
    const leftidx = $ec8921d84a01cd55$var$orderFromPadding(spec, left);
    const rightidx = $ec8921d84a01cd55$var$orderFromPadding(spec, right);
    return rightidx === leftidx + 1;
}
function $ec8921d84a01cd55$var$orderFromPadding(spec, inner) {
    for(let branch = 0; branch < spec.childOrder.length; branch++){
        const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $ec8921d84a01cd55$var$getPadding(spec, branch);
        if ($ec8921d84a01cd55$var$hasPadding(inner, minPrefix, maxPrefix, suffix)) return branch;
    }
    throw new Error(`Cannot find any valid spacing for this node`);
}
function $ec8921d84a01cd55$var$hasPadding(op, minPrefix, maxPrefix, suffix) {
    if ((op.prefix || []).length < minPrefix) return false;
    if ((op.prefix || []).length > maxPrefix) return false;
    return (op.suffix || []).length === suffix;
}
function $ec8921d84a01cd55$var$getPadding(spec, branch) {
    const idx = $ec8921d84a01cd55$var$getPosition(spec.childOrder, branch);
    // count how many children are in the prefix
    const prefix = idx * spec.childSize;
    const minPrefix = prefix + spec.minPrefixLength;
    const maxPrefix = prefix + spec.maxPrefixLength;
    // count how many children are in the suffix
    const suffix = (spec.childOrder.length - 1 - idx) * spec.childSize;
    return {
        minPrefix: minPrefix,
        maxPrefix: maxPrefix,
        suffix: suffix
    };
}
function $ec8921d84a01cd55$var$getPosition(order, branch) {
    if (branch < 0 || branch >= order.length) throw new Error(`Invalid branch: ${branch}`);
    return order.findIndex((val)=>val === branch);
}

});
parcelRegister("iLcxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doHash = module.exports.applyInner = module.exports.applyLeaf = void 0;

var $5bhDk = parcelRequire("5bhDk");

var $9mxSb = parcelRequire("9mxSb");

var $hyAd0 = parcelRequire("hyAd0");

var $9cNrY = parcelRequire("9cNrY");
function $da8656eaa352ea24$var$applyLeaf(leaf, key, value) {
    if (key.length === 0) throw new Error("Missing key");
    if (value.length === 0) throw new Error("Missing value");
    const pkey = $da8656eaa352ea24$var$prepareLeafData($da8656eaa352ea24$var$ensureHash(leaf.prehashKey), $da8656eaa352ea24$var$ensureLength(leaf.length), key);
    const pvalue = $da8656eaa352ea24$var$prepareLeafData($da8656eaa352ea24$var$ensureHash(leaf.prehashValue), $da8656eaa352ea24$var$ensureLength(leaf.length), value);
    const data = new Uint8Array([
        ...$da8656eaa352ea24$var$ensureBytes(leaf.prefix),
        ...pkey,
        ...pvalue
    ]);
    return $da8656eaa352ea24$var$doHash($da8656eaa352ea24$var$ensureHash(leaf.hash), data);
}
module.exports.applyLeaf = $da8656eaa352ea24$var$applyLeaf;
function $da8656eaa352ea24$var$applyInner(inner, child) {
    if (child.length === 0) throw new Error("Inner op needs child value");
    const preimage = new Uint8Array([
        ...$da8656eaa352ea24$var$ensureBytes(inner.prefix),
        ...child,
        ...$da8656eaa352ea24$var$ensureBytes(inner.suffix)
    ]);
    return $da8656eaa352ea24$var$doHash($da8656eaa352ea24$var$ensureHash(inner.hash), preimage);
}
module.exports.applyInner = $da8656eaa352ea24$var$applyInner;
function $da8656eaa352ea24$var$ensure(maybe, value) {
    return maybe === undefined || maybe === null ? value : maybe;
}
const $da8656eaa352ea24$var$ensureHash = (h)=>$da8656eaa352ea24$var$ensure(h, $9cNrY.ics23.HashOp.NO_HASH);
const $da8656eaa352ea24$var$ensureLength = (l)=>$da8656eaa352ea24$var$ensure(l, $9cNrY.ics23.LengthOp.NO_PREFIX);
const $da8656eaa352ea24$var$ensureBytes = (b)=>$da8656eaa352ea24$var$ensure(b, new Uint8Array([]));
function $da8656eaa352ea24$var$prepareLeafData(hashOp, lengthOp, data) {
    const h = $da8656eaa352ea24$var$doHashOrNoop(hashOp, data);
    return $da8656eaa352ea24$var$doLengthOp(lengthOp, h);
}
// doHashOrNoop will return the preimage untouched if hashOp == NONE,
// otherwise, perform doHash
function $da8656eaa352ea24$var$doHashOrNoop(hashOp, preimage) {
    if (hashOp === $9cNrY.ics23.HashOp.NO_HASH) return preimage;
    return $da8656eaa352ea24$var$doHash(hashOp, preimage);
}
// doHash will preform the specified hash on the preimage.
// if hashOp == NONE, it will return an error (use doHashOrNoop if you want different behavior)
function $da8656eaa352ea24$var$doHash(hashOp, preimage) {
    switch(hashOp){
        case $9cNrY.ics23.HashOp.SHA256:
            return (0, $9mxSb.sha256)(preimage);
        case $9cNrY.ics23.HashOp.SHA512:
            return (0, $hyAd0.sha512)(preimage);
        case $9cNrY.ics23.HashOp.RIPEMD160:
            return (0, $5bhDk.ripemd160)(preimage);
        case $9cNrY.ics23.HashOp.BITCOIN:
            return (0, $5bhDk.ripemd160)((0, $9mxSb.sha256)(preimage));
        case $9cNrY.ics23.HashOp.SHA512_256:
            return (0, $hyAd0.sha512_256)(preimage);
    }
    throw new Error(`Unsupported hashop: ${hashOp}`);
}
module.exports.doHash = $da8656eaa352ea24$var$doHash;
// doLengthOp will calculate the proper prefix and return it prepended
//   doLengthOp(op, data) -> length(data) || data
function $da8656eaa352ea24$var$doLengthOp(lengthOp, data) {
    switch(lengthOp){
        case $9cNrY.ics23.LengthOp.NO_PREFIX:
            return data;
        case $9cNrY.ics23.LengthOp.VAR_PROTO:
            return new Uint8Array([
                ...$da8656eaa352ea24$var$encodeVarintProto(data.length),
                ...data
            ]);
        case $9cNrY.ics23.LengthOp.REQUIRE_32_BYTES:
            if (data.length !== 32) throw new Error(`Length is ${data.length}, not 32 bytes`);
            return data;
        case $9cNrY.ics23.LengthOp.REQUIRE_64_BYTES:
            if (data.length !== 64) throw new Error(`Length is ${data.length}, not 64 bytes`);
            return data;
        case $9cNrY.ics23.LengthOp.FIXED32_LITTLE:
            return new Uint8Array([
                ...$da8656eaa352ea24$var$encodeFixed32Le(data.length),
                ...data
            ]);
    }
    throw new Error(`Unsupported lengthop: ${lengthOp}`);
}
function $da8656eaa352ea24$var$encodeVarintProto(n) {
    let enc = [];
    let l = n;
    while(l >= 128){
        const b = l % 128 + 128;
        enc = [
            ...enc,
            b
        ];
        l = l / 128;
    }
    enc = [
        ...enc,
        l
    ];
    return new Uint8Array(enc);
}
function $da8656eaa352ea24$var$encodeFixed32Le(n) {
    const enc = new Uint8Array(4);
    let l = n;
    for(let i = enc.length; i > 0; i--){
        enc[Math.abs(i - enc.length)] = l % 256;
        l = Math.floor(l / 256);
    }
    return enc;
}

});

parcelRegister("kt0dj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bytesBefore = module.exports.ensureBytesBefore = module.exports.bytesEqual = module.exports.ensureBytesEqual = module.exports.ensureInner = module.exports.ensureLeaf = void 0;
function $ee66ae8a7d0b35c4$var$ensureLeaf(leaf, spec) {
    if (leaf.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${leaf.hash}`);
    if (leaf.prehashKey !== spec.prehashKey) throw new Error(`Unexpected prehashKey: ${leaf.prehashKey}`);
    if (leaf.prehashValue !== spec.prehashValue) throw new Error(`Unexpected prehashValue: ${leaf.prehashValue}`);
    if (leaf.length !== spec.length) throw new Error(`Unexpected length op: ${leaf.length}`);
    $ee66ae8a7d0b35c4$var$ensurePrefix(leaf.prefix, spec.prefix);
}
module.exports.ensureLeaf = $ee66ae8a7d0b35c4$var$ensureLeaf;
function $ee66ae8a7d0b35c4$var$ensureInner(inner, prefix, spec) {
    if (inner.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${inner.hash}`);
    if (!inner.prefix) throw new Error("No prefix set for inner node");
    if ($ee66ae8a7d0b35c4$var$hasPrefix(inner.prefix, prefix)) throw new Error(`Inner node has leaf prefix`);
    if (inner.prefix.length < (spec.minPrefixLength || 0)) throw new Error(`Prefix too short: ${inner.prefix.length} bytes`);
    const maxLeftChildBytes = (spec.childOrder.length - 1) * spec.childSize;
    if (inner.prefix.length > (spec.maxPrefixLength || 0) + maxLeftChildBytes) throw new Error(`Prefix too long: ${inner.prefix.length} bytes`);
}
module.exports.ensureInner = $ee66ae8a7d0b35c4$var$ensureInner;
function $ee66ae8a7d0b35c4$var$ensurePrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return;
    if (!check) throw new Error(`Target bytes missing`);
    $ee66ae8a7d0b35c4$var$ensureBytesEqual(prefix, check.slice(0, prefix.length));
}
// ensureBytesEqual throws an error if the arrays are different
function $ee66ae8a7d0b35c4$var$ensureBytesEqual(a, b) {
    if (a.length !== b.length) throw new Error(`Different lengths ${a.length} vs ${b.length}`);
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) throw new Error(`Arrays differ at index ${i}: ${a[i]} vs ${b[i]}`);
    }
}
module.exports.ensureBytesEqual = $ee66ae8a7d0b35c4$var$ensureBytesEqual;
function $ee66ae8a7d0b35c4$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.bytesEqual = $ee66ae8a7d0b35c4$var$bytesEqual;
function $ee66ae8a7d0b35c4$var$hasPrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return false;
    if (!check) return false;
    if (check.length <= prefix.length) return false;
    for(let i = 0; i < prefix.length; i++){
        if (check[i] !== prefix[i]) return false;
    }
    throw true;
}
// ensureBytesBefore throws an error if first >= last
// we compare byte by byte
function $ee66ae8a7d0b35c4$var$ensureBytesBefore(first, last) {
    if (!$ee66ae8a7d0b35c4$var$bytesBefore(first, last)) throw new Error("first is after last");
}
module.exports.ensureBytesBefore = $ee66ae8a7d0b35c4$var$ensureBytesBefore;
function $ee66ae8a7d0b35c4$var$bytesBefore(first, last) {
    const min = first.length < last.length ? first.length : last.length;
    for(let i = 0; i < min; i++){
        if (first[i] < last[i]) return true;
        if (first[i] > last[i]) return false;
    // if they are equal, continue to next step
    }
    // if they match, ensure that last is longer than first..
    return first.length < last.length;
}
module.exports.bytesBefore = $ee66ae8a7d0b35c4$var$bytesBefore;

});




parcelRegister("6Sxan", function(module, exports) {
"use strict";
var $5021835f8cd9ef21$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5021835f8cd9ef21$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5021835f8cd9ef21$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = module.exports.toListPromise = module.exports.fromListPromise = module.exports.firstEvent = module.exports.dropDuplicates = module.exports.DefaultValueProducer = module.exports.concat = void 0;

var $d1u6H = parcelRequire("d1u6H");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $d1u6H.concat;
    }
});

var $4x6Bd = parcelRequire("4x6Bd");
Object.defineProperty(module.exports, "DefaultValueProducer", {
    enumerable: true,
    get: function() {
        return $4x6Bd.DefaultValueProducer;
    }
});

var $6D8wu = parcelRequire("6D8wu");
Object.defineProperty(module.exports, "dropDuplicates", {
    enumerable: true,
    get: function() {
        return $6D8wu.dropDuplicates;
    }
});

var $8sVN8 = parcelRequire("8sVN8");
Object.defineProperty(module.exports, "firstEvent", {
    enumerable: true,
    get: function() {
        return $8sVN8.firstEvent;
    }
});
Object.defineProperty(module.exports, "fromListPromise", {
    enumerable: true,
    get: function() {
        return $8sVN8.fromListPromise;
    }
});
Object.defineProperty(module.exports, "toListPromise", {
    enumerable: true,
    get: function() {
        return $8sVN8.toListPromise;
    }
});

$5021835f8cd9ef21$var$__exportStar((parcelRequire("118Os")), module.exports);

var $haS6T = parcelRequire("haS6T");
Object.defineProperty(module.exports, "ValueAndUpdates", {
    enumerable: true,
    get: function() {
        return $haS6T.ValueAndUpdates;
    }
});

});
parcelRegister("d1u6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $klEU5 = parcelRequire("klEU5");
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */ function $97b2b8ffe4c1702b$var$concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while(subscriptions.length > 0){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener)=>{
            streams.forEach((_)=>queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    const element = queues[streamIndex].shift();
                    if (element === undefined) return;
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index)=>{
                subscriptions.push(stream.subscribe({
                    next: (value)=>{
                        if (index === activeStreamIndex) listener.next(value);
                        else queues[index].push(value);
                    },
                    complete: ()=>{
                        completedStreams.add(index);
                        while(completedStreams.has(activeStreamIndex)){
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) listener.complete();
                        else // now active stream can have some events queued but did not yet complete
                        emitAllQueuesEvents(activeStreamIndex);
                    },
                    error: (error)=>{
                        listener.error(error);
                        reset();
                    }
                }));
            });
        },
        stop: ()=>{
            reset();
        }
    };
    return $klEU5.Stream.create(producer);
}
module.exports.concat = $97b2b8ffe4c1702b$var$concat;

});
parcelRegister("klEU5", function(module, exports) {
"use strict";
var $ed057f689976d4b9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_IL = module.exports.NO = module.exports.MemoryStream = module.exports.Stream = void 0;

var $4vEL1 = parcelRequire("4vEL1");

var $jqNhV = parcelRequire("jqNhV");
var $ed057f689976d4b9$var$$$observable = $4vEL1.default($jqNhV.getPolyfill());
var $ed057f689976d4b9$var$NO = {};
module.exports.NO = $ed057f689976d4b9$var$NO;
function $ed057f689976d4b9$var$noop() {}
function $ed057f689976d4b9$var$cp(a) {
    var l = a.length;
    var b = Array(l);
    for(var i = 0; i < l; ++i)b[i] = a[i];
    return b;
}
function $ed057f689976d4b9$var$and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function $ed057f689976d4b9$var$_try(c, t, u) {
    try {
        return c.f(t);
    } catch (e) {
        u._e(e);
        return $ed057f689976d4b9$var$NO;
    }
}
var $ed057f689976d4b9$var$NO_IL = {
    _n: $ed057f689976d4b9$var$noop,
    _e: $ed057f689976d4b9$var$noop,
    _c: $ed057f689976d4b9$var$noop
};
module.exports.NO_IL = $ed057f689976d4b9$var$NO_IL;
// mutates the input
function $ed057f689976d4b9$var$internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var $ed057f689976d4b9$var$StreamSub = /** @class */ function() {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function() {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}();
var $ed057f689976d4b9$var$Observer = /** @class */ function() {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function(value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function(err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function() {
        this._listener._c();
    };
    return Observer;
}();
var $ed057f689976d4b9$var$FromObservable = /** @class */ function() {
    function FromObservable(observable) {
        this.type = "fromObservable";
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function(out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new $ed057f689976d4b9$var$Observer(out));
        if (!this.active) this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function() {
        if (this._sub) this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}();
var $ed057f689976d4b9$var$Merge = /** @class */ function() {
    function Merge(insArr) {
        this.type = "merge";
        this.insArr = insArr;
        this.out = $ed057f689976d4b9$var$NO;
        this.ac = 0;
    }
    Merge.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for(var i = 0; i < L; i++)s[i]._add(this);
    };
    Merge.prototype._stop = function() {
        var s = this.insArr;
        var L = s.length;
        for(var i = 0; i < L; i++)s[i]._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    Merge.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._n(t);
    };
    Merge.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Merge.prototype._c = function() {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === $ed057f689976d4b9$var$NO) return;
            u._c();
        }
    };
    return Merge;
}();
var $ed057f689976d4b9$var$CombineListener = /** @class */ function() {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function(t) {
        var p = this.p, out = this.out;
        if (out === $ed057f689976d4b9$var$NO) return;
        if (p.up(t, this.i)) {
            var b = $ed057f689976d4b9$var$cp(p.vals);
            out._n(b);
        }
    };
    CombineListener.prototype._e = function(err) {
        var out = this.out;
        if (out === $ed057f689976d4b9$var$NO) return;
        out._e(err);
    };
    CombineListener.prototype._c = function() {
        var p = this.p;
        if (p.out === $ed057f689976d4b9$var$NO) return;
        if (--p.Nc === 0) p.out._c();
    };
    return CombineListener;
}();
var $ed057f689976d4b9$var$Combine = /** @class */ function() {
    function Combine(insArr) {
        this.type = "combine";
        this.insArr = insArr;
        this.out = $ed057f689976d4b9$var$NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function(t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === $ed057f689976d4b9$var$NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        } else for(var i = 0; i < n; i++){
            vals[i] = $ed057f689976d4b9$var$NO;
            s[i]._add(new $ed057f689976d4b9$var$CombineListener(i, out, this));
        }
    };
    Combine.prototype._stop = function() {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for(var i = 0; i < n; i++)s[i]._remove(ils[i]);
        this.out = $ed057f689976d4b9$var$NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}();
var $ed057f689976d4b9$var$FromArray = /** @class */ function() {
    function FromArray(a) {
        this.type = "fromArray";
        this.a = a;
    }
    FromArray.prototype._start = function(out) {
        var a = this.a;
        for(var i = 0, n = a.length; i < n; i++)out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function() {};
    return FromArray;
}();
var $ed057f689976d4b9$var$FromPromise = /** @class */ function() {
    function FromPromise(p) {
        this.type = "fromPromise";
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function(out) {
        var prod = this;
        this.on = true;
        this.p.then(function(v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function(e) {
            out._e(e);
        }).then($ed057f689976d4b9$var$noop, function(err) {
            setTimeout(function() {
                throw err;
            });
        });
    };
    FromPromise.prototype._stop = function() {
        this.on = false;
    };
    return FromPromise;
}();
var $ed057f689976d4b9$var$Periodic = /** @class */ function() {
    function Periodic(period) {
        this.type = "periodic";
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function(out) {
        var self = this;
        function intervalHandler() {
            out._n(self.i++);
        }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function() {
        if (this.intervalID !== -1) clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}();
var $ed057f689976d4b9$var$Debug = /** @class */ function() {
    function Debug(ins, arg) {
        this.type = "debug";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.s = $ed057f689976d4b9$var$noop;
        this.l = "";
        if (typeof arg === "string") this.l = arg;
        else if (typeof arg === "function") this.s = arg;
    }
    Debug.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    Debug.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var s = this.s, l = this.l;
        if (s !== $ed057f689976d4b9$var$noop) try {
            s(t);
        } catch (e) {
            u._e(e);
        }
        else if (l) console.log(l + ":", t);
        else console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Debug.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return Debug;
}();
var $ed057f689976d4b9$var$Drop = /** @class */ function() {
    function Drop(max, ins) {
        this.type = "drop";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function(out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    Drop.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        if (this.dropped++ >= this.max) u._n(t);
    };
    Drop.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Drop.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return Drop;
}();
var $ed057f689976d4b9$var$EndWhenListener = /** @class */ function() {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function() {
        this.op.end();
    };
    EndWhenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function() {
        this.op.end();
    };
    return EndWhenListener;
}();
var $ed057f689976d4b9$var$EndWhen = /** @class */ function() {
    function EndWhen(o, ins) {
        this.type = "endWhen";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.o = o;
        this.oil = $ed057f689976d4b9$var$NO_IL;
    }
    EndWhen.prototype._start = function(out) {
        this.out = out;
        this.o._add(this.oil = new $ed057f689976d4b9$var$EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function() {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = $ed057f689976d4b9$var$NO;
        this.oil = $ed057f689976d4b9$var$NO_IL;
    };
    EndWhen.prototype.end = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    EndWhen.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._n(t);
    };
    EndWhen.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    EndWhen.prototype._c = function() {
        this.end();
    };
    return EndWhen;
}();
var $ed057f689976d4b9$var$Filter = /** @class */ function() {
    function Filter(passes, ins) {
        this.type = "filter";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.f = passes;
    }
    Filter.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    Filter.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var r = $ed057f689976d4b9$var$_try(this, t, u);
        if (r === $ed057f689976d4b9$var$NO || !r) return;
        u._n(t);
    };
    Filter.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Filter.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return Filter;
}();
var $ed057f689976d4b9$var$FlattenListener = /** @class */ function() {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function(t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function() {
        this.op.inner = $ed057f689976d4b9$var$NO;
        this.op.less();
    };
    return FlattenListener;
}();
var $ed057f689976d4b9$var$Flatten = /** @class */ function() {
    function Flatten(ins) {
        this.type = "flatten";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.open = true;
        this.inner = $ed057f689976d4b9$var$NO;
        this.il = $ed057f689976d4b9$var$NO_IL;
    }
    Flatten.prototype._start = function(out) {
        this.out = out;
        this.open = true;
        this.inner = $ed057f689976d4b9$var$NO;
        this.il = $ed057f689976d4b9$var$NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function() {
        this.ins._remove(this);
        if (this.inner !== $ed057f689976d4b9$var$NO) this.inner._remove(this.il);
        this.out = $ed057f689976d4b9$var$NO;
        this.open = true;
        this.inner = $ed057f689976d4b9$var$NO;
        this.il = $ed057f689976d4b9$var$NO_IL;
    };
    Flatten.prototype.less = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        if (!this.open && this.inner === $ed057f689976d4b9$var$NO) u._c();
    };
    Flatten.prototype._n = function(s) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== $ed057f689976d4b9$var$NO && il !== $ed057f689976d4b9$var$NO_IL) inner._remove(il);
        (this.inner = s)._add(this.il = new $ed057f689976d4b9$var$FlattenListener(u, this));
    };
    Flatten.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Flatten.prototype._c = function() {
        this.open = false;
        this.less();
    };
    return Flatten;
}();
var $ed057f689976d4b9$var$Fold = /** @class */ function() {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = "fold";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.f = function(t) {
            return f(_this.acc, t);
        };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function(out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var r = $ed057f689976d4b9$var$_try(this, t, u);
        if (r === $ed057f689976d4b9$var$NO) return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Fold.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return Fold;
}();
var $ed057f689976d4b9$var$Last = /** @class */ function() {
    function Last(ins) {
        this.type = "last";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.has = false;
        this.val = $ed057f689976d4b9$var$NO;
    }
    Last.prototype._start = function(out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
        this.val = $ed057f689976d4b9$var$NO;
    };
    Last.prototype._n = function(t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Last.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        if (this.has) {
            u._n(this.val);
            u._c();
        } else u._e(new Error("last() failed because input stream completed"));
    };
    return Last;
}();
var $ed057f689976d4b9$var$MapOp = /** @class */ function() {
    function MapOp(project, ins) {
        this.type = "map";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.f = project;
    }
    MapOp.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    MapOp.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var r = $ed057f689976d4b9$var$_try(this, t, u);
        if (r === $ed057f689976d4b9$var$NO) return;
        u._n(r);
    };
    MapOp.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    MapOp.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return MapOp;
}();
var $ed057f689976d4b9$var$Remember = /** @class */ function() {
    function Remember(ins) {
        this.type = "remember";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
    }
    Remember.prototype._start = function(out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $ed057f689976d4b9$var$NO;
    };
    return Remember;
}();
var $ed057f689976d4b9$var$ReplaceError = /** @class */ function() {
    function ReplaceError(replacer, ins) {
        this.type = "replaceError";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    ReplaceError.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._n(t);
    };
    ReplaceError.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        } catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return ReplaceError;
}();
var $ed057f689976d4b9$var$StartWith = /** @class */ function() {
    function StartWith(ins, val) {
        this.type = "startWith";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.val = val;
    }
    StartWith.prototype._start = function(out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $ed057f689976d4b9$var$NO;
    };
    return StartWith;
}();
var $ed057f689976d4b9$var$Take = /** @class */ function() {
    function Take(max, ins) {
        this.type = "take";
        this.ins = ins;
        this.out = $ed057f689976d4b9$var$NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function(out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0) out._c();
        else this.ins._add(this);
    };
    Take.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $ed057f689976d4b9$var$NO;
    };
    Take.prototype._n = function(t) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        var m = ++this.taken;
        if (m < this.max) u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function(err) {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._e(err);
    };
    Take.prototype._c = function() {
        var u = this.out;
        if (u === $ed057f689976d4b9$var$NO) return;
        u._c();
    };
    return Take;
}();
var $ed057f689976d4b9$var$Stream = /** @class */ function() {
    function Stream(producer) {
        this._prod = producer || $ed057f689976d4b9$var$NO;
        this._ils = [];
        this._stopID = $ed057f689976d4b9$var$NO;
        this._dl = $ed057f689976d4b9$var$NO;
        this._d = false;
        this._target = null;
        this._err = $ed057f689976d4b9$var$NO;
    }
    Stream.prototype._n = function(t) {
        var a = this._ils;
        var L = a.length;
        if (this._d) this._dl._n(t);
        if (L == 1) a[0]._n(t);
        else if (L == 0) return;
        else {
            var b = $ed057f689976d4b9$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._n(t);
        }
    };
    Stream.prototype._e = function(err) {
        if (this._err !== $ed057f689976d4b9$var$NO) return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._e(err);
        if (L == 1) a[0]._e(err);
        else if (L == 0) return;
        else {
            var b = $ed057f689976d4b9$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._e(err);
        }
        if (!this._d && L == 0) throw this._err;
    };
    Stream.prototype._c = function() {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._c();
        if (L == 1) a[0]._c();
        else if (L == 0) return;
        else {
            var b = $ed057f689976d4b9$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._c();
        }
    };
    Stream.prototype._x = function() {
        if (this._ils.length === 0) return;
        if (this._prod !== $ed057f689976d4b9$var$NO) this._prod._stop();
        this._err = $ed057f689976d4b9$var$NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function() {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = $ed057f689976d4b9$var$NO;
        this._stopID = $ed057f689976d4b9$var$NO;
    };
    Stream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) return;
        if (this._stopID !== $ed057f689976d4b9$var$NO) {
            clearTimeout(this._stopID);
            this._stopID = $ed057f689976d4b9$var$NO;
        } else {
            var p = this._prod;
            if (p !== $ed057f689976d4b9$var$NO) p._start(this);
        }
    };
    Stream.prototype._remove = function(il) {
        var _this = this;
        var ta = this._target;
        if (ta) return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== $ed057f689976d4b9$var$NO && a.length <= 0) {
                this._err = $ed057f689976d4b9$var$NO;
                this._stopID = setTimeout(function() {
                    return _this._stopNow();
                });
            } else if (a.length === 1) this._pruneCycles();
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function() {
        if (this._hasNoSinks(this, [])) this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function(x, trace) {
        if (trace.indexOf(x) !== -1) return true;
        else if (x.out === this) return true;
        else if (x.out && x.out !== $ed057f689976d4b9$var$NO) return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for(var i = 0, N = x._ils.length; i < N; i++)if (!this._hasNoSinks(x._ils[i], trace.concat(x))) return false;
            return true;
        } else return false;
    };
    Stream.prototype.ctor = function() {
        return this instanceof $ed057f689976d4b9$var$MemoryStream ? $ed057f689976d4b9$var$MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */ Stream.prototype.addListener = function(listener) {
        listener._n = listener.next || $ed057f689976d4b9$var$noop;
        listener._e = listener.error || $ed057f689976d4b9$var$noop;
        listener._c = listener.complete || $ed057f689976d4b9$var$noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.removeListener = function(listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */ Stream.prototype.subscribe = function(listener) {
        this.addListener(listener);
        return new $ed057f689976d4b9$var$StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */ Stream.prototype[$ed057f689976d4b9$var$$$observable] = function() {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */ Stream.create = function(producer) {
        if (producer) {
            if (typeof producer.start !== "function" || typeof producer.stop !== "function") throw new Error("producer requires both start and stop functions");
            $ed057f689976d4b9$var$internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */ Stream.createWithMemory = function(producer) {
        if (producer) $ed057f689976d4b9$var$internalizeProducer(producer); // mutates the input
        return new $ed057f689976d4b9$var$MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.never = function() {
        return new Stream({
            _start: $ed057f689976d4b9$var$noop,
            _stop: $ed057f689976d4b9$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.empty = function() {
        return new Stream({
            _start: function(il) {
                il._c();
            },
            _stop: $ed057f689976d4b9$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */ Stream.throw = function(error) {
        return new Stream({
            _start: function(il) {
                il._e(error);
            },
            _stop: $ed057f689976d4b9$var$noop
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */ Stream.from = function(input) {
        if (typeof input[$ed057f689976d4b9$var$$$observable] === "function") return Stream.fromObservable(input);
        else if (typeof input.then === "function") return Stream.fromPromise(input);
        else if (Array.isArray(input)) return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */ Stream.of = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */ Stream.fromArray = function(array) {
        return new Stream(new $ed057f689976d4b9$var$FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */ Stream.fromPromise = function(promise) {
        return new Stream(new $ed057f689976d4b9$var$FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */ Stream.fromObservable = function(obs) {
        if (obs.endWhen !== undefined) return obs;
        var o = typeof obs[$ed057f689976d4b9$var$$$observable] === "function" ? obs[$ed057f689976d4b9$var$$$observable]() : obs;
        return new Stream(new $ed057f689976d4b9$var$FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */ Stream.periodic = function(period) {
        return new Stream(new $ed057f689976d4b9$var$Periodic(period));
    };
    Stream.prototype._map = function(project) {
        return new (this.ctor())(new $ed057f689976d4b9$var$MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */ Stream.prototype.map = function(project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */ Stream.prototype.mapTo = function(projectedValue) {
        var s = this.map(function() {
            return projectedValue;
        });
        var op = s._prod;
        op.type = "mapTo";
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */ Stream.prototype.filter = function(passes) {
        var p = this._prod;
        if (p instanceof $ed057f689976d4b9$var$Filter) return new Stream(new $ed057f689976d4b9$var$Filter($ed057f689976d4b9$var$and(p.f, passes), p.ins));
        return new Stream(new $ed057f689976d4b9$var$Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */ Stream.prototype.take = function(amount) {
        return new (this.ctor())(new $ed057f689976d4b9$var$Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */ Stream.prototype.drop = function(amount) {
        return new Stream(new $ed057f689976d4b9$var$Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.last = function() {
        return new Stream(new $ed057f689976d4b9$var$Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */ Stream.prototype.startWith = function(initial) {
        return new $ed057f689976d4b9$var$MemoryStream(new $ed057f689976d4b9$var$StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */ Stream.prototype.endWhen = function(other) {
        return new (this.ctor())(new $ed057f689976d4b9$var$EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */ Stream.prototype.fold = function(accumulate, seed) {
        return new $ed057f689976d4b9$var$MemoryStream(new $ed057f689976d4b9$var$Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */ Stream.prototype.replaceError = function(replace) {
        return new (this.ctor())(new $ed057f689976d4b9$var$ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.flatten = function() {
        return new Stream(new $ed057f689976d4b9$var$Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */ Stream.prototype.compose = function(operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */ Stream.prototype.remember = function() {
        return new $ed057f689976d4b9$var$MemoryStream(new $ed057f689976d4b9$var$Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */ Stream.prototype.debug = function(labelOrSpy) {
        return new (this.ctor())(new $ed057f689976d4b9$var$Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */ Stream.prototype.imitate = function(target) {
        if (target instanceof $ed057f689976d4b9$var$MemoryStream) throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
        this._target = target;
        for(var ils = this._ils, N = ils.length, i = 0; i < N; i++)target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendNext = function(value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendError = function(error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */ Stream.prototype.shamefullySendComplete = function() {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.setDebugListener = function(listener) {
        if (!listener) {
            this._d = false;
            this._dl = $ed057f689976d4b9$var$NO;
        } else {
            this._d = true;
            listener._n = listener.next || $ed057f689976d4b9$var$noop;
            listener._e = listener.error || $ed057f689976d4b9$var$noop;
            listener._c = listener.complete || $ed057f689976d4b9$var$noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */ Stream.merge = function merge() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $ed057f689976d4b9$var$Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */ Stream.combine = function combine() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $ed057f689976d4b9$var$Combine(streams));
    };
    return Stream;
}();
module.exports.Stream = $ed057f689976d4b9$var$Stream;
var $ed057f689976d4b9$var$MemoryStream = /** @class */ function(_super) {
    $ed057f689976d4b9$var$__extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function(x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has) il._n(this._v);
            return;
        }
        if (this._stopID !== $ed057f689976d4b9$var$NO) {
            if (this._has) il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = $ed057f689976d4b9$var$NO;
        } else if (this._has) il._n(this._v);
        else {
            var p = this._prod;
            if (p !== $ed057f689976d4b9$var$NO) p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function() {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function() {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function(project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function(projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function(amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function(other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function(replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function() {
        return this;
    };
    MemoryStream.prototype.debug = function(labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}($ed057f689976d4b9$var$Stream);
module.exports.MemoryStream = $ed057f689976d4b9$var$MemoryStream;
var $ed057f689976d4b9$var$xs = $ed057f689976d4b9$var$Stream;
module.exports.default = $ed057f689976d4b9$var$xs;

});
parcelRegister("4vEL1", function(module, exports) {

module.exports = (parcelRequire("gcI9X"));

});
parcelRegister("gcI9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $bcc00580b1daccce$var$symbolObservablePonyfill;
function $bcc00580b1daccce$var$symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;
    if (typeof _Symbol === "function") {
        if (_Symbol.observable) result = _Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = _Symbol["for"]("https://github.com/benlesh/symbol-observable");
            try {
                _Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});


parcelRegister("jqNhV", function(module, exports) {
"use strict";

var $eiAU9 = parcelRequire("eiAU9");

var $3ZKgN = parcelRequire("3ZKgN");

var $8gDbl = parcelRequire("8gDbl");

var $95ptU = parcelRequire("95ptU");
var $e256ad9df34d516d$var$polyfill = $8gDbl();
var $e256ad9df34d516d$var$getGlobal = function() {
    return $e256ad9df34d516d$var$polyfill;
};
$eiAU9($e256ad9df34d516d$var$getGlobal, {
    getPolyfill: $8gDbl,
    implementation: $3ZKgN,
    shim: $95ptU
});
module.exports = $e256ad9df34d516d$var$getGlobal;

});
parcelRegister("eiAU9", function(module, exports) {
"use strict";

var $dPJCs = parcelRequire("dPJCs");
var $a68f5f9ad42073c0$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $a68f5f9ad42073c0$var$toStr = Object.prototype.toString;
var $a68f5f9ad42073c0$var$concat = Array.prototype.concat;

var $326QS = parcelRequire("326QS");
var $a68f5f9ad42073c0$var$isFunction = function(fn) {
    return typeof fn === "function" && $a68f5f9ad42073c0$var$toStr.call(fn) === "[object Function]";
};

var $a68f5f9ad42073c0$var$supportsDescriptors = (parcelRequire("aszze"))();
var $a68f5f9ad42073c0$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$a68f5f9ad42073c0$var$isFunction(predicate) || !predicate()) return;
    }
    if ($a68f5f9ad42073c0$var$supportsDescriptors) $326QS(object, name, value, true);
    else $326QS(object, name, value);
};
var $a68f5f9ad42073c0$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dPJCs(map);
    if ($a68f5f9ad42073c0$var$hasSymbols) props = $a68f5f9ad42073c0$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$a68f5f9ad42073c0$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$a68f5f9ad42073c0$var$defineProperties.supportsDescriptors = !!$a68f5f9ad42073c0$var$supportsDescriptors;
module.exports = $a68f5f9ad42073c0$var$defineProperties;

});
parcelRegister("dPJCs", function(module, exports) {
"use strict";
var $a1236cd255f23260$var$slice = Array.prototype.slice;

var $ljnRB = parcelRequire("ljnRB");
var $a1236cd255f23260$var$origKeys = Object.keys;

var $a1236cd255f23260$var$keysShim = $a1236cd255f23260$var$origKeys ? function keys(o) {
    return $a1236cd255f23260$var$origKeys(o);
} : (parcelRequire("gaMM3"));
var $a1236cd255f23260$var$originalKeys = Object.keys;
$a1236cd255f23260$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($ljnRB(object)) return $a1236cd255f23260$var$originalKeys($a1236cd255f23260$var$slice.call(object));
            return $a1236cd255f23260$var$originalKeys(object);
        };
    } else Object.keys = $a1236cd255f23260$var$keysShim;
    return Object.keys || $a1236cd255f23260$var$keysShim;
};
module.exports = $a1236cd255f23260$var$keysShim;

});
parcelRegister("ljnRB", function(module, exports) {
"use strict";
var $f83de21d9fe15e87$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $f83de21d9fe15e87$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $f83de21d9fe15e87$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("gaMM3", function(module, exports) {
"use strict";
var $bc636a01cbaf8bf2$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $bc636a01cbaf8bf2$var$has = Object.prototype.hasOwnProperty;
    var $bc636a01cbaf8bf2$var$toStr = Object.prototype.toString;
    var $bc636a01cbaf8bf2$var$isArgs = (parcelRequire("ljnRB")); // eslint-disable-line global-require
    var $bc636a01cbaf8bf2$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $bc636a01cbaf8bf2$var$hasDontEnumBug = !$bc636a01cbaf8bf2$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $bc636a01cbaf8bf2$var$hasProtoEnumBug = $bc636a01cbaf8bf2$var$isEnumerable.call(function() {}, "prototype");
    var $bc636a01cbaf8bf2$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $bc636a01cbaf8bf2$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $bc636a01cbaf8bf2$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $bc636a01cbaf8bf2$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$bc636a01cbaf8bf2$var$excludedKeys["$" + k] && $bc636a01cbaf8bf2$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $bc636a01cbaf8bf2$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $bc636a01cbaf8bf2$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$bc636a01cbaf8bf2$var$hasAutomationEqualityBug) return $bc636a01cbaf8bf2$var$equalsConstructorPrototype(o);
        try {
            return $bc636a01cbaf8bf2$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $bc636a01cbaf8bf2$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $bc636a01cbaf8bf2$var$toStr.call(object) === "[object Function]";
        var isArguments = $bc636a01cbaf8bf2$var$isArgs(object);
        var isString = isObject && $bc636a01cbaf8bf2$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $bc636a01cbaf8bf2$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$bc636a01cbaf8bf2$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $bc636a01cbaf8bf2$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($bc636a01cbaf8bf2$var$hasDontEnumBug) {
            var skipConstructor = $bc636a01cbaf8bf2$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $bc636a01cbaf8bf2$var$dontEnums.length; ++k)if (!(skipConstructor && $bc636a01cbaf8bf2$var$dontEnums[k] === "constructor") && $bc636a01cbaf8bf2$var$has.call(object, $bc636a01cbaf8bf2$var$dontEnums[k])) theKeys.push($bc636a01cbaf8bf2$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $bc636a01cbaf8bf2$var$keysShim;

});



parcelRegister("3ZKgN", function(module, exports) {
/* eslint no-negated-condition: 0, no-new-func: 0 */ "use strict";
if (typeof self !== "undefined") module.exports = self;
else if (typeof window !== "undefined") module.exports = window;
else module.exports = Function("return this")();

});

parcelRegister("8gDbl", function(module, exports) {
"use strict";

var $3ZKgN = parcelRequire("3ZKgN");
module.exports = function getPolyfill() {
    if (typeof $parcel$global !== "object" || !$parcel$global || $parcel$global.Math !== Math || $parcel$global.Array !== Array) return $3ZKgN;
    return $parcel$global;
};

});

parcelRegister("95ptU", function(module, exports) {
"use strict";

var $eiAU9 = parcelRequire("eiAU9");

var $8gDbl = parcelRequire("8gDbl");
module.exports = function shimGlobal() {
    var polyfill = $8gDbl();
    if ($eiAU9.supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(polyfill, "globalThis");
        if (!descriptor || descriptor.configurable && (descriptor.enumerable || !descriptor.writable || globalThis !== polyfill)) Object.defineProperty(polyfill, "globalThis", {
            configurable: true,
            enumerable: false,
            value: polyfill,
            writable: true
        });
    } else if (typeof globalThis !== "object" || globalThis !== polyfill) polyfill.globalThis = polyfill;
    return polyfill;
};

});




parcelRegister("4x6Bd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class $34cf5cf11de93208$var$DefaultValueProducer {
    get value() {
        return this.internalValue;
    }
    constructor(value, callbacks){
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */ update(value) {
        this.internalValue = value;
        if (this.listener) this.listener.next(value);
    }
    /**
     * Produce an error
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) this.listener.error(error);
    }
    /**
     * Called by the stream. Do not call this directly.
     */ start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) this.callbacks.onStarted();
    }
    /**
     * Called by the stream. Do not call this directly.
     */ stop() {
        if (this.callbacks) this.callbacks.onStop();
        this.listener = undefined;
    }
}
module.exports.DefaultValueProducer = $34cf5cf11de93208$var$DefaultValueProducer;

});

parcelRegister("6D8wu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */ function $4d3cff151d0c6faa$var$dropDuplicates(valueToKey) {
    const operand = (instream)=>{
        const emittedKeys = new Set();
        const deduplicatedStream = instream.filter((value)=>!emittedKeys.has(valueToKey(value))).debug((value)=>emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
module.exports.dropDuplicates = $4d3cff151d0c6faa$var$dropDuplicates;

});

parcelRegister("8sVN8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstEvent = module.exports.toListPromise = module.exports.fromListPromise = void 0;

var $klEU5 = parcelRequire("klEU5");
/**
 * Emits one event for each list element as soon as the promise resolves
 */ function $629dc4744623c2f5$var$fromListPromise(promise) {
    const producer = {
        start: (listener)=>{
            // the code in `start` runs as soon as anyone listens to the stream
            promise.then((iterable)=>{
                for (const element of iterable)listener.next(element);
                listener.complete();
            }).catch((error)=>listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: ()=>{}
    };
    return $klEU5.Stream.create(producer);
}
module.exports.fromListPromise = $629dc4744623c2f5$var$fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */ async function $629dc4744623c2f5$var$toListPromise(stream, count) {
    return new Promise((resolve, reject)=>{
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event)=>{
                events.push(event);
                if (events.length === count) resolve(events);
            },
            complete: ()=>{
                reject(`Stream completed before all events could be collected. ` + `Collected ${events.length}, expected ${count}`);
            },
            error: (error)=>reject(error)
        });
    });
}
module.exports.toListPromise = $629dc4744623c2f5$var$toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */ async function $629dc4744623c2f5$var$firstEvent(stream) {
    return (await $629dc4744623c2f5$var$toListPromise(stream, 1))[0];
}
module.exports.firstEvent = $629dc4744623c2f5$var$firstEvent;

});

parcelRegister("118Os", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValue = module.exports.asArray = module.exports.countStream = module.exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class $0bdcb87bf0f6f04f$var$Reducer {
    constructor(stream, reducer, initState){
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject)=>{
            const subscription = this.stream.subscribe({
                next: (evt)=>{
                    this.state = this.reducer(this.state, evt);
                },
                complete: ()=>{
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err)=>{
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                }
            });
        });
    }
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
}
module.exports.Reducer = $0bdcb87bf0f6f04f$var$Reducer;
function $0bdcb87bf0f6f04f$var$increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function $0bdcb87bf0f6f04f$var$countStream(stream) {
    return new $0bdcb87bf0f6f04f$var$Reducer(stream, $0bdcb87bf0f6f04f$var$increment, 0);
}
module.exports.countStream = $0bdcb87bf0f6f04f$var$countStream;
function $0bdcb87bf0f6f04f$var$append(list, evt) {
    return [
        ...list,
        evt
    ];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function $0bdcb87bf0f6f04f$var$asArray(stream) {
    return new $0bdcb87bf0f6f04f$var$Reducer(stream, $0bdcb87bf0f6f04f$var$append, []);
}
module.exports.asArray = $0bdcb87bf0f6f04f$var$asArray;
function $0bdcb87bf0f6f04f$var$last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function $0bdcb87bf0f6f04f$var$lastValue(stream) {
    return new $0bdcb87bf0f6f04f$var$Reducer(stream, $0bdcb87bf0f6f04f$var$last, undefined);
}
module.exports.lastValue = $0bdcb87bf0f6f04f$var$lastValue;

});

parcelRegister("haS6T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = void 0;

var $klEU5 = parcelRequire("klEU5");
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */ class $c80d5800a270d438$var$ValueAndUpdates {
    get value() {
        return this.producer.value;
    }
    constructor(producer){
        this.producer = producer;
        this.updates = $klEU5.MemoryStream.createWithMemory(this.producer);
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */ async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value)=>value === search;
        return new Promise((resolve, reject)=>{
            const subscription = this.updates.subscribe({
                next: (newValue)=>{
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(()=>subscription.unsubscribe(), 0);
                    }
                },
                complete: ()=>{
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error)=>{
                    reject(error);
                }
            });
        });
    }
}
module.exports.ValueAndUpdates = $c80d5800a270d438$var$ValueAndUpdates;

});



parcelRegister("dBGCN", function(module, exports) {
"use strict";
var $9e7fcb6d20ec20f4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeCosmosSdkDecFromProto = module.exports.longify = module.exports.createProtobufRpcClient = module.exports.createPagination = module.exports.toAccAddress = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $aBpB1 = parcelRequire("aBpB1");

const $9e7fcb6d20ec20f4$var$long_1 = $9e7fcb6d20ec20f4$var$__importDefault((parcelRequire("3gmZQ")));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */ function $9e7fcb6d20ec20f4$var$toAccAddress(address) {
    return (0, $94ZnX.fromBech32)(address).data;
}
module.exports.toAccAddress = $9e7fcb6d20ec20f4$var$toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */ function $9e7fcb6d20ec20f4$var$createPagination(paginationKey) {
    return paginationKey ? $aBpB1.PageRequest.fromPartial({
        key: paginationKey
    }) : undefined;
}
module.exports.createPagination = $9e7fcb6d20ec20f4$var$createPagination;
function $9e7fcb6d20ec20f4$var$createProtobufRpcClient(base) {
    return {
        request: async (service, method, data)=>{
            const path = `/${service}/${method}`;
            const response = await base.queryAbci(path, data, undefined);
            return response.value;
        }
    };
}
module.exports.createProtobufRpcClient = $9e7fcb6d20ec20f4$var$createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */ function $9e7fcb6d20ec20f4$var$longify(value) {
    const checkedValue = $h3uvW.Uint64.fromString(value.toString());
    return $9e7fcb6d20ec20f4$var$long_1.default.fromBytesBE([
        ...checkedValue.toBytesBigEndian()
    ], true);
}
module.exports.longify = $9e7fcb6d20ec20f4$var$longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */ function $9e7fcb6d20ec20f4$var$decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, $94ZnX.fromAscii)(input);
    return $h3uvW.Decimal.fromAtomics(asString, 18);
}
module.exports.decodeCosmosSdkDecFromProto = $9e7fcb6d20ec20f4$var$decodeCosmosSdkDecFromProto;

});



parcelRegister("7xTyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAuthzAminoConverters = void 0;
function $57e6b4fd5353cefb$var$createAuthzAminoConverters() {
    return {
    };
}
module.exports.createAuthzAminoConverters = $57e6b4fd5353cefb$var$createAuthzAminoConverters;

});

parcelRegister("5iCRa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.authzTypes = void 0;

var $8Faxx = parcelRequire("8Faxx");
module.exports.authzTypes = [
    [
        "/cosmos.authz.v1beta1.MsgExec",
        $8Faxx.MsgExec
    ],
    [
        "/cosmos.authz.v1beta1.MsgGrant",
        $8Faxx.MsgGrant
    ],
    [
        "/cosmos.authz.v1beta1.MsgRevoke",
        $8Faxx.MsgRevoke
    ]
];

});
parcelRegister("8Faxx", function(module, exports) {
"use strict";
var $64ea5415ba75c71b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64ea5415ba75c71b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $64ea5415ba75c71b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $64ea5415ba75c71b$var$__createBinding(result, mod, k);
    }
    $64ea5415ba75c71b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgRevokeResponse = module.exports.MsgRevoke = module.exports.MsgGrantResponse = module.exports.MsgExec = module.exports.MsgExecResponse = module.exports.MsgGrant = module.exports.protobufPackage = void 0;

var $a2VlR = parcelRequire("a2VlR");

var $axIO3 = parcelRequire("axIO3");

const $64ea5415ba75c71b$var$_m0 = $64ea5415ba75c71b$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $64ea5415ba75c71b$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
module.exports.MsgGrant = {
    encode (message, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $a2VlR.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $a2VlR.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            grant: (0, $dkaBG.isSet)(object.grant) ? $a2VlR.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $a2VlR.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $64ea5415ba75c71b$var$createBaseMsgGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.grant = object.grant !== undefined && object.grant !== null ? $a2VlR.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $64ea5415ba75c71b$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
module.exports.MsgExecResponse = {
    encode (message, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            results: Array.isArray(object?.results) ? object.results.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        const message = $64ea5415ba75c71b$var$createBaseMsgExecResponse();
        message.results = object.results?.map((e)=>e) || [];
        return message;
    }
};
function $64ea5415ba75c71b$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
module.exports.MsgExec = {
    encode (message, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$axIO3.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object?.msgs) ? object.msgs.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $64ea5415ba75c71b$var$createBaseMsgExec();
        message.grantee = object.grantee ?? "";
        message.msgs = object.msgs?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};
function $64ea5415ba75c71b$var$createBaseMsgGrantResponse() {
    return {};
}
module.exports.MsgGrantResponse = {
    encode (_, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $64ea5415ba75c71b$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $64ea5415ba75c71b$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
module.exports.MsgRevoke = {
    encode (message, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgRevoke();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $dkaBG.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        const message = $64ea5415ba75c71b$var$createBaseMsgRevoke();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        return message;
    }
};
function $64ea5415ba75c71b$var$createBaseMsgRevokeResponse() {
    return {};
}
module.exports.MsgRevokeResponse = {
    encode (_, writer = $64ea5415ba75c71b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64ea5415ba75c71b$var$_m0.Reader ? input : new $64ea5415ba75c71b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64ea5415ba75c71b$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $64ea5415ba75c71b$var$createBaseMsgRevokeResponse();
        return message;
    }
};
class $64ea5415ba75c71b$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    Grant(request) {
        const data = module.exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data)=>module.exports.MsgGrantResponse.decode(new $64ea5415ba75c71b$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = module.exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data)=>module.exports.MsgExecResponse.decode(new $64ea5415ba75c71b$var$_m0.Reader(data)));
    }
    Revoke(request) {
        const data = module.exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data)=>module.exports.MsgRevokeResponse.decode(new $64ea5415ba75c71b$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $64ea5415ba75c71b$var$MsgClientImpl;

});
parcelRegister("a2VlR", function(module, exports) {
"use strict";
var $75069418f4c3caaa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75069418f4c3caaa$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $75069418f4c3caaa$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75069418f4c3caaa$var$__createBinding(result, mod, k);
    }
    $75069418f4c3caaa$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GrantQueueItem = module.exports.GrantAuthorization = module.exports.Grant = module.exports.GenericAuthorization = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $cPgyI = parcelRequire("cPgyI");

const $75069418f4c3caaa$var$_m0 = $75069418f4c3caaa$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $75069418f4c3caaa$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
module.exports.GenericAuthorization = {
    encode (message, writer = $75069418f4c3caaa$var$_m0.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $75069418f4c3caaa$var$_m0.Reader ? input : new $75069418f4c3caaa$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $75069418f4c3caaa$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msg: (0, $dkaBG.isSet)(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        const message = $75069418f4c3caaa$var$createBaseGenericAuthorization();
        message.msg = object.msg ?? "";
        return message;
    }
};
function $75069418f4c3caaa$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
module.exports.Grant = {
    encode (message, writer = $75069418f4c3caaa$var$_m0.Writer.create()) {
        if (message.authorization !== undefined) $axIO3.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $cPgyI.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $75069418f4c3caaa$var$_m0.Reader ? input : new $75069418f4c3caaa$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $75069418f4c3caaa$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authorization: (0, $dkaBG.isSet)(object.authorization) ? $axIO3.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $dkaBG.isSet)(object.expiration) ? (0, $dkaBG.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $axIO3.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $dkaBG.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $75069418f4c3caaa$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $axIO3.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $cPgyI.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $75069418f4c3caaa$var$createBaseGrantAuthorization() {
    return {
        granter: "",
        grantee: "",
        authorization: undefined,
        expiration: undefined
    };
}
module.exports.GrantAuthorization = {
    encode (message, writer = $75069418f4c3caaa$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.authorization !== undefined) $axIO3.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        if (message.expiration !== undefined) $cPgyI.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $75069418f4c3caaa$var$_m0.Reader ? input : new $75069418f4c3caaa$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $75069418f4c3caaa$var$createBaseGrantAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            authorization: (0, $dkaBG.isSet)(object.authorization) ? $axIO3.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $dkaBG.isSet)(object.expiration) ? (0, $dkaBG.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined && (obj.authorization = message.authorization ? $axIO3.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $dkaBG.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $75069418f4c3caaa$var$createBaseGrantAuthorization();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $axIO3.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $cPgyI.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $75069418f4c3caaa$var$createBaseGrantQueueItem() {
    return {
        msgTypeUrls: []
    };
}
module.exports.GrantQueueItem = {
    encode (message, writer = $75069418f4c3caaa$var$_m0.Writer.create()) {
        for (const v of message.msgTypeUrls)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $75069418f4c3caaa$var$_m0.Reader ? input : new $75069418f4c3caaa$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $75069418f4c3caaa$var$createBaseGrantQueueItem();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgTypeUrls.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgTypeUrls: Array.isArray(object?.msgTypeUrls) ? object.msgTypeUrls.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.msgTypeUrls) obj.msgTypeUrls = message.msgTypeUrls.map((e)=>e);
        else obj.msgTypeUrls = [];
        return obj;
    },
    fromPartial (object) {
        const message = $75069418f4c3caaa$var$createBaseGrantQueueItem();
        message.msgTypeUrls = object.msgTypeUrls?.map((e)=>e) || [];
        return message;
    }
};

});
parcelRegister("cPgyI", function(module, exports) {
"use strict";
var $956717b4a2a6e05b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $956717b4a2a6e05b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $956717b4a2a6e05b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $956717b4a2a6e05b$var$__createBinding(result, mod, k);
    }
    $956717b4a2a6e05b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $956717b4a2a6e05b$var$_m0 = $956717b4a2a6e05b$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $956717b4a2a6e05b$var$createBaseTimestamp() {
    return {
        seconds: $dkaBG.Long.ZERO,
        nanos: 0
    };
}
module.exports.Timestamp = {
    encode (message, writer = $956717b4a2a6e05b$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $956717b4a2a6e05b$var$_m0.Reader ? input : new $956717b4a2a6e05b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $956717b4a2a6e05b$var$createBaseTimestamp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $dkaBG.isSet)(object.seconds) ? $dkaBG.Long.fromValue(object.seconds) : $dkaBG.Long.ZERO,
            nanos: (0, $dkaBG.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $dkaBG.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $956717b4a2a6e05b$var$createBaseTimestamp();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $dkaBG.Long.fromValue(object.seconds) : $dkaBG.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};

});




parcelRegister("2buhN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupAuthzExtension = void 0;

var $aThf0 = parcelRequire("aThf0");

var $5E3xG = parcelRequire("5E3xG");
function $19741a04705241c9$var$setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    const queryService = new $aThf0.QueryClientImpl(rpc);
    return {
        authz: {
            grants: async (granter, grantee, msgTypeUrl, paginationKey)=>{
                return await queryService.Grants({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msgTypeUrl,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
            },
            granteeGrants: async (grantee, paginationKey)=>{
                return await queryService.GranteeGrants({
                    grantee: grantee,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
            },
            granterGrants: async (granter, paginationKey)=>{
                return await queryService.GranterGrants({
                    granter: granter,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
            }
        }
    };
}
module.exports.setupAuthzExtension = $19741a04705241c9$var$setupAuthzExtension;

});
parcelRegister("aThf0", function(module, exports) {
"use strict";
var $7edc6a2bec4bbab4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7edc6a2bec4bbab4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7edc6a2bec4bbab4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7edc6a2bec4bbab4$var$__createBinding(result, mod, k);
    }
    $7edc6a2bec4bbab4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryGranteeGrantsResponse = module.exports.QueryGranteeGrantsRequest = module.exports.QueryGranterGrantsResponse = module.exports.QueryGranterGrantsRequest = module.exports.QueryGrantsResponse = module.exports.QueryGrantsRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $a2VlR = parcelRequire("a2VlR");

const $7edc6a2bec4bbab4$var$_m0 = $7edc6a2bec4bbab4$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.authz.v1beta1";
function $7edc6a2bec4bbab4$var$createBaseQueryGrantsRequest() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
        pagination: undefined
    };
}
module.exports.QueryGrantsRequest = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $dkaBG.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGrantsRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7edc6a2bec4bbab4$var$createBaseQueryGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
module.exports.QueryGrantsResponse = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        for (const v of message.grants)$a2VlR.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($a2VlR.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$a2VlR.Grant.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $a2VlR.Grant.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGrantsResponse();
        message.grants = object.grants?.map((e)=>$a2VlR.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
module.exports.QueryGranterGrantsRequest = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
module.exports.QueryGranterGrantsResponse = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        for (const v of message.grants)$a2VlR.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($a2VlR.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$a2VlR.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $a2VlR.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranterGrantsResponse();
        message.grants = object.grants?.map((e)=>$a2VlR.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
module.exports.QueryGranteeGrantsRequest = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
module.exports.QueryGranteeGrantsResponse = {
    encode (message, writer = $7edc6a2bec4bbab4$var$_m0.Writer.create()) {
        for (const v of message.grants)$a2VlR.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7edc6a2bec4bbab4$var$_m0.Reader ? input : new $7edc6a2bec4bbab4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($a2VlR.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$a2VlR.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $a2VlR.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7edc6a2bec4bbab4$var$createBaseQueryGranteeGrantsResponse();
        message.grants = object.grants?.map((e)=>$a2VlR.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $7edc6a2bec4bbab4$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(request) {
        const data = module.exports.QueryGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
        return promise.then((data)=>module.exports.QueryGrantsResponse.decode(new $7edc6a2bec4bbab4$var$_m0.Reader(data)));
    }
    GranterGrants(request) {
        const data = module.exports.QueryGranterGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
        return promise.then((data)=>module.exports.QueryGranterGrantsResponse.decode(new $7edc6a2bec4bbab4$var$_m0.Reader(data)));
    }
    GranteeGrants(request) {
        const data = module.exports.QueryGranteeGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
        return promise.then((data)=>module.exports.QueryGranteeGrantsResponse.decode(new $7edc6a2bec4bbab4$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $7edc6a2bec4bbab4$var$QueryClientImpl;

});


parcelRegister("lcjJ2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createBankAminoConverters = module.exports.isAminoMsgMultiSend = module.exports.isAminoMsgSend = void 0;
function $f6ea0503170f8c5e$var$isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
module.exports.isAminoMsgSend = $f6ea0503170f8c5e$var$isAminoMsgSend;
function $f6ea0503170f8c5e$var$isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
module.exports.isAminoMsgMultiSend = $f6ea0503170f8c5e$var$isAminoMsgMultiSend;
function $f6ea0503170f8c5e$var$createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ]
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ]
                })
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                }),
            fromAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                })
        }
    };
}
module.exports.createBankAminoConverters = $f6ea0503170f8c5e$var$createBankAminoConverters;

});

parcelRegister("1NNEt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgSendEncodeObject = module.exports.bankTypes = void 0;

var $12h3v = parcelRequire("12h3v");
module.exports.bankTypes = [
    [
        "/cosmos.bank.v1beta1.MsgMultiSend",
        $12h3v.MsgMultiSend
    ],
    [
        "/cosmos.bank.v1beta1.MsgSend",
        $12h3v.MsgSend
    ]
];
function $1500e1da5392ea6d$var$isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
module.exports.isMsgSendEncodeObject = $1500e1da5392ea6d$var$isMsgSendEncodeObject;

});

parcelRegister("k9boh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupBankExtension = void 0;

var $hm8y1 = parcelRequire("hm8y1");

var $jlqho = parcelRequire("jlqho");

var $5E3xG = parcelRequire("5E3xG");
function $eaad7bdcceaebada$var$setupBankExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $jlqho.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom)=>{
                const { balance: balance } = await queryService.Balance({
                    address: address,
                    denom: denom
                });
                (0, $hm8y1.assert)(balance);
                return balance;
            },
            allBalances: async (address)=>{
                const { balances: balances } = await queryService.AllBalances({
                    address: address
                });
                return balances;
            },
            totalSupply: async (paginationKey)=>{
                const response = await queryService.TotalSupply({
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            supplyOf: async (denom)=>{
                const { amount: amount } = await queryService.SupplyOf({
                    denom: denom
                });
                (0, $hm8y1.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom)=>{
                const { metadata: metadata } = await queryService.DenomMetadata({
                    denom: denom
                });
                (0, $hm8y1.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async ()=>{
                const { metadatas: metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined
                });
                return metadatas;
            }
        }
    };
}
module.exports.setupBankExtension = $eaad7bdcceaebada$var$setupBankExtension;

});
parcelRegister("jlqho", function(module, exports) {
"use strict";
var $e1545d11f6f84d59$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e1545d11f6f84d59$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e1545d11f6f84d59$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e1545d11f6f84d59$var$__createBinding(result, mod, k);
    }
    $e1545d11f6f84d59$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QuerySendEnabledResponse = module.exports.QuerySendEnabledRequest = module.exports.QueryDenomOwnersResponse = module.exports.DenomOwner = module.exports.QueryDenomOwnersRequest = module.exports.QueryDenomMetadataResponse = module.exports.QueryDenomMetadataRequest = module.exports.QueryDenomsMetadataResponse = module.exports.QueryDenomsMetadataRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.QuerySupplyOfResponse = module.exports.QuerySupplyOfRequest = module.exports.QueryTotalSupplyResponse = module.exports.QueryTotalSupplyRequest = module.exports.QuerySpendableBalanceByDenomResponse = module.exports.QuerySpendableBalanceByDenomRequest = module.exports.QuerySpendableBalancesResponse = module.exports.QuerySpendableBalancesRequest = module.exports.QueryAllBalancesResponse = module.exports.QueryAllBalancesRequest = module.exports.QueryBalanceResponse = module.exports.QueryBalanceRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $efcGD = parcelRequire("efcGD");

var $gc7so = parcelRequire("gc7so");

const $e1545d11f6f84d59$var$_m0 = $e1545d11f6f84d59$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.bank.v1beta1";
function $e1545d11f6f84d59$var$createBaseQueryBalanceRequest() {
    return {
        address: "",
        denom: ""
    };
}
module.exports.QueryBalanceRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryBalanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryBalanceRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryBalanceResponse() {
    return {
        balance: undefined
    };
}
module.exports.QueryBalanceResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $efcGD.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryBalanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $dkaBG.isSet)(object.balance) ? $efcGD.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $efcGD.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryBalanceResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $efcGD.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryAllBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
module.exports.QueryAllBalancesRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryAllBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryAllBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryAllBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
module.exports.QueryAllBalancesResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.balances)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryAllBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryAllBalancesResponse();
        message.balances = object.balances?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
module.exports.QuerySpendableBalancesRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
module.exports.QuerySpendableBalancesResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.balances)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalancesResponse();
        message.balances = object.balances?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomRequest() {
    return {
        address: "",
        denom: ""
    };
}
module.exports.QuerySpendableBalanceByDenomRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomResponse() {
    return {
        balance: undefined
    };
}
module.exports.QuerySpendableBalanceByDenomResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $efcGD.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $dkaBG.isSet)(object.balance) ? $efcGD.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $efcGD.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySpendableBalanceByDenomResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $efcGD.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryTotalSupplyRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryTotalSupplyRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryTotalSupplyRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryTotalSupplyRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryTotalSupplyResponse() {
    return {
        supply: [],
        pagination: undefined
    };
}
module.exports.QueryTotalSupplyResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.supply)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryTotalSupplyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.supply.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            supply: Array.isArray(object?.supply) ? object.supply.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.supply) obj.supply = message.supply.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.supply = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryTotalSupplyResponse();
        message.supply = object.supply?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySupplyOfRequest() {
    return {
        denom: ""
    };
}
module.exports.QuerySupplyOfRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySupplyOfRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySupplyOfRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySupplyOfResponse() {
    return {
        amount: undefined
    };
}
module.exports.QuerySupplyOfResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.amount !== undefined) $efcGD.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySupplyOfResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: (0, $dkaBG.isSet)(object.amount) ? $efcGD.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $efcGD.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySupplyOfResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $efcGD.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e1545d11f6f84d59$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.params !== undefined) $gc7so.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $gc7so.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $gc7so.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $gc7so.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $gc7so.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryDenomsMetadataRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataResponse() {
    return {
        metadatas: [],
        pagination: undefined
    };
}
module.exports.QueryDenomsMetadataResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.metadatas)$gc7so.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadatas.push($gc7so.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadatas: Array.isArray(object?.metadatas) ? object.metadatas.map((e)=>$gc7so.Metadata.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.metadatas) obj.metadatas = message.metadatas.map((e)=>e ? $gc7so.Metadata.toJSON(e) : undefined);
        else obj.metadatas = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomsMetadataResponse();
        message.metadatas = object.metadatas?.map((e)=>$gc7so.Metadata.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomMetadataRequest() {
    return {
        denom: ""
    };
}
module.exports.QueryDenomMetadataRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomMetadataRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomMetadataResponse() {
    return {
        metadata: undefined
    };
}
module.exports.QueryDenomMetadataResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.metadata !== undefined) $gc7so.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadata = $gc7so.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadata: (0, $dkaBG.isSet)(object.metadata) ? $gc7so.Metadata.fromJSON(object.metadata) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.metadata !== undefined && (obj.metadata = message.metadata ? $gc7so.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomMetadataResponse();
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $gc7so.Metadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomOwnersRequest() {
    return {
        denom: "",
        pagination: undefined
    };
}
module.exports.QueryDenomOwnersRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomOwnersRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $dkaBG.isSet)(object.denom) ? String(object.denom) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomOwnersRequest();
        message.denom = object.denom ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseDenomOwner() {
    return {
        address: "",
        balance: undefined
    };
}
module.exports.DenomOwner = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.balance !== undefined) $efcGD.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseDenomOwner();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            balance: (0, $dkaBG.isSet)(object.balance) ? $efcGD.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined && (obj.balance = message.balance ? $efcGD.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseDenomOwner();
        message.address = object.address ?? "";
        message.balance = object.balance !== undefined && object.balance !== null ? $efcGD.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQueryDenomOwnersResponse() {
    return {
        denomOwners: [],
        pagination: undefined
    };
}
module.exports.QueryDenomOwnersResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.denomOwners)module.exports.DenomOwner.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomOwnersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomOwners.push(module.exports.DenomOwner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomOwners: Array.isArray(object?.denomOwners) ? object.denomOwners.map((e)=>module.exports.DenomOwner.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomOwners) obj.denomOwners = message.denomOwners.map((e)=>e ? module.exports.DenomOwner.toJSON(e) : undefined);
        else obj.denomOwners = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQueryDenomOwnersResponse();
        message.denomOwners = object.denomOwners?.map((e)=>module.exports.DenomOwner.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySendEnabledRequest() {
    return {
        denoms: [],
        pagination: undefined
    };
}
module.exports.QuerySendEnabledRequest = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.denoms)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySendEnabledRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denoms.push(reader.string());
                    break;
                case 99:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denoms: Array.isArray(object?.denoms) ? object.denoms.map((e)=>String(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denoms) obj.denoms = message.denoms.map((e)=>e);
        else obj.denoms = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySendEnabledRequest();
        message.denoms = object.denoms?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e1545d11f6f84d59$var$createBaseQuerySendEnabledResponse() {
    return {
        sendEnabled: [],
        pagination: undefined
    };
}
module.exports.QuerySendEnabledResponse = {
    encode (message, writer = $e1545d11f6f84d59$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)$gc7so.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e1545d11f6f84d59$var$_m0.Reader ? input : new $e1545d11f6f84d59$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e1545d11f6f84d59$var$createBaseQuerySendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($gc7so.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 99:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$gc7so.SendEnabled.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $gc7so.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e1545d11f6f84d59$var$createBaseQuerySendEnabledResponse();
        message.sendEnabled = object.sendEnabled?.map((e)=>$gc7so.SendEnabled.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $e1545d11f6f84d59$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
        this.DenomOwners = this.DenomOwners.bind(this);
        this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(request) {
        const data = module.exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data)=>module.exports.QueryBalanceResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    AllBalances(request) {
        const data = module.exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data)=>module.exports.QueryAllBalancesResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    SpendableBalances(request) {
        const data = module.exports.QuerySpendableBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
        return promise.then((data)=>module.exports.QuerySpendableBalancesResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    SpendableBalanceByDenom(request) {
        const data = module.exports.QuerySpendableBalanceByDenomRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", data);
        return promise.then((data)=>module.exports.QuerySpendableBalanceByDenomResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    TotalSupply(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data)=>module.exports.QueryTotalSupplyResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    SupplyOf(request) {
        const data = module.exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data)=>module.exports.QuerySupplyOfResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    DenomMetadata(request) {
        const data = module.exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data)=>module.exports.QueryDenomMetadataResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    DenomsMetadata(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data)=>module.exports.QueryDenomsMetadataResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    DenomOwners(request) {
        const data = module.exports.QueryDenomOwnersRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", data);
        return promise.then((data)=>module.exports.QueryDenomOwnersResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
    SendEnabled(request) {
        const data = module.exports.QuerySendEnabledRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", data);
        return promise.then((data)=>module.exports.QuerySendEnabledResponse.decode(new $e1545d11f6f84d59$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $e1545d11f6f84d59$var$QueryClientImpl;

});


parcelRegister("brqM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCrysisAminoConverters = module.exports.isAminoMsgVerifyInvariant = void 0;
function $8546fc384356d005$var$isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
module.exports.isAminoMsgVerifyInvariant = $8546fc384356d005$var$isAminoMsgVerifyInvariant;
function $8546fc384356d005$var$createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
module.exports.createCrysisAminoConverters = $8546fc384356d005$var$createCrysisAminoConverters;

});

parcelRegister("7ok0w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDistributionAminoConverters = module.exports.isAminoMsgFundCommunityPool = module.exports.isAminoMsgWithdrawValidatorCommission = module.exports.isAminoMsgWithdrawDelegatorReward = module.exports.isAminoMsgSetWithdrawAddress = void 0;
function $561a4b5580099237$var$isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
module.exports.isAminoMsgSetWithdrawAddress = $561a4b5580099237$var$isAminoMsgSetWithdrawAddress;
function $561a4b5580099237$var$isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
module.exports.isAminoMsgWithdrawDelegatorReward = $561a4b5580099237$var$isAminoMsgWithdrawDelegatorReward;
function $561a4b5580099237$var$isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
module.exports.isAminoMsgWithdrawValidatorCommission = $561a4b5580099237$var$isAminoMsgWithdrawValidatorCommission;
function $561a4b5580099237$var$isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
module.exports.isAminoMsgFundCommunityPool = $561a4b5580099237$var$isAminoMsgFundCommunityPool;
function $561a4b5580099237$var$createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                }),
            fromAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                })
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress: delegatorAddress, withdrawAddress: withdrawAddress })=>({
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, withdraw_address: withdraw_address })=>({
                    delegatorAddress: delegator_address,
                    withdrawAddress: withdraw_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress })=>({
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress: validatorAddress })=>({
                    validator_address: validatorAddress
                }),
            fromAmino: ({ validator_address: validator_address })=>({
                    validatorAddress: validator_address
                })
        }
    };
}
module.exports.createDistributionAminoConverters = $561a4b5580099237$var$createDistributionAminoConverters;

});

parcelRegister("3HPe5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgWithdrawDelegatorRewardEncodeObject = module.exports.distributionTypes = void 0;

var $4Wn4Z = parcelRequire("4Wn4Z");
module.exports.distributionTypes = [
    [
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        $4Wn4Z.MsgFundCommunityPool
    ],
    [
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        $4Wn4Z.MsgSetWithdrawAddress
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        $4Wn4Z.MsgWithdrawDelegatorReward
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        $4Wn4Z.MsgWithdrawValidatorCommission
    ]
];
function $2b2d1fb742c8c179$var$isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return object.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
module.exports.isMsgWithdrawDelegatorRewardEncodeObject = $2b2d1fb742c8c179$var$isMsgWithdrawDelegatorRewardEncodeObject;

});
parcelRegister("4Wn4Z", function(module, exports) {
"use strict";
var $398e7b5225d0b5bd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $398e7b5225d0b5bd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $398e7b5225d0b5bd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $398e7b5225d0b5bd$var$__createBinding(result, mod, k);
    }
    $398e7b5225d0b5bd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgCommunityPoolSpendResponse = module.exports.MsgCommunityPoolSpend = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgFundCommunityPoolResponse = module.exports.MsgFundCommunityPool = module.exports.MsgWithdrawValidatorCommissionResponse = module.exports.MsgWithdrawValidatorCommission = module.exports.MsgWithdrawDelegatorRewardResponse = module.exports.MsgWithdrawDelegatorReward = module.exports.MsgSetWithdrawAddressResponse = module.exports.MsgSetWithdrawAddress = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $9mYsa = parcelRequire("9mYsa");

const $398e7b5225d0b5bd$var$_m0 = $398e7b5225d0b5bd$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
function $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
module.exports.MsgSetWithdrawAddress = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: (0, $dkaBG.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
module.exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {
        amount: []
    };
}
module.exports.MsgWithdrawDelegatorRewardResponse = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawDelegatorRewardResponse();
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
module.exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {
        amount: []
    };
}
module.exports.MsgWithdrawValidatorCommissionResponse = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgWithdrawValidatorCommissionResponse();
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
module.exports.MsgFundCommunityPool = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPool();
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
module.exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
module.exports.MsgUpdateParams = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $9mYsa.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $9mYsa.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $dkaBG.isSet)(object.params) ? $9mYsa.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $9mYsa.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $9mYsa.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode (_, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpend() {
    return {
        authority: "",
        recipient: "",
        amount: []
    };
}
module.exports.MsgCommunityPoolSpend = {
    encode (message, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.recipient !== "") writer.uint32(18).string(message.recipient);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.recipient = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            recipient: (0, $dkaBG.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpend();
        message.authority = object.authority ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpendResponse() {
    return {};
}
module.exports.MsgCommunityPoolSpendResponse = {
    encode (_, writer = $398e7b5225d0b5bd$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $398e7b5225d0b5bd$var$_m0.Reader ? input : new $398e7b5225d0b5bd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $398e7b5225d0b5bd$var$createBaseMsgCommunityPoolSpendResponse();
        return message;
    }
};
class $398e7b5225d0b5bd$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(request) {
        const data = module.exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data)=>module.exports.MsgSetWithdrawAddressResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = module.exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data)=>module.exports.MsgWithdrawDelegatorRewardResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = module.exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data)=>module.exports.MsgWithdrawValidatorCommissionResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = module.exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data)=>module.exports.MsgFundCommunityPoolResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = module.exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>module.exports.MsgUpdateParamsResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
    CommunityPoolSpend(request) {
        const data = module.exports.MsgCommunityPoolSpend.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", data);
        return promise.then((data)=>module.exports.MsgCommunityPoolSpendResponse.decode(new $398e7b5225d0b5bd$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $398e7b5225d0b5bd$var$MsgClientImpl;

});
parcelRegister("9mYsa", function(module, exports) {
"use strict";
var $6d250fe34c142e57$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d250fe34c142e57$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6d250fe34c142e57$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6d250fe34c142e57$var$__createBinding(result, mod, k);
    }
    $6d250fe34c142e57$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CommunityPoolSpendProposalWithDeposit = module.exports.DelegationDelegatorReward = module.exports.DelegatorStartingInfo = module.exports.CommunityPoolSpendProposal = module.exports.FeePool = module.exports.ValidatorSlashEvents = module.exports.ValidatorSlashEvent = module.exports.ValidatorOutstandingRewards = module.exports.ValidatorAccumulatedCommission = module.exports.ValidatorCurrentRewards = module.exports.ValidatorHistoricalRewards = module.exports.Params = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $dkaBG = parcelRequire("dkaBG");

const $6d250fe34c142e57$var$_m0 = $6d250fe34c142e57$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
function $6d250fe34c142e57$var$createBaseParams() {
    return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: false
    };
}
module.exports.Params = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityTax: (0, $dkaBG.isSet)(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: (0, $dkaBG.isSet)(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: (0, $dkaBG.isSet)(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: (0, $dkaBG.isSet)(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseParams();
        message.communityTax = object.communityTax ?? "";
        message.baseProposerReward = object.baseProposerReward ?? "";
        message.bonusProposerReward = object.bonusProposerReward ?? "";
        message.withdrawAddrEnabled = object.withdrawAddrEnabled ?? false;
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorHistoricalRewards() {
    return {
        cumulativeRewardRatio: [],
        referenceCount: 0
    };
}
module.exports.ValidatorHistoricalRewards = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.cumulativeRewardRatio)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorHistoricalRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            cumulativeRewardRatio: Array.isArray(object?.cumulativeRewardRatio) ? object.cumulativeRewardRatio.map((e)=>$efcGD.DecCoin.fromJSON(e)) : [],
            referenceCount: (0, $dkaBG.isSet)(object.referenceCount) ? Number(object.referenceCount) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = object.cumulativeRewardRatio?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        message.referenceCount = object.referenceCount ?? 0;
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorCurrentRewards() {
    return {
        rewards: [],
        period: $dkaBG.Long.UZERO
    };
}
module.exports.ValidatorCurrentRewards = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.rewards)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorCurrentRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$efcGD.DecCoin.fromJSON(e)) : [],
            period: (0, $dkaBG.isSet)(object.period) ? $dkaBG.Long.fromValue(object.period) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorCurrentRewards();
        message.rewards = object.rewards?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        message.period = object.period !== undefined && object.period !== null ? $dkaBG.Long.fromValue(object.period) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorAccumulatedCommission() {
    return {
        commission: []
    };
}
module.exports.ValidatorAccumulatedCommission = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.commission)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorAccumulatedCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorAccumulatedCommission();
        message.commission = object.commission?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorOutstandingRewards() {
    return {
        rewards: []
    };
}
module.exports.ValidatorOutstandingRewards = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.rewards)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorOutstandingRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorOutstandingRewards();
        message.rewards = object.rewards?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorSlashEvent() {
    return {
        validatorPeriod: $dkaBG.Long.UZERO,
        fraction: ""
    };
}
module.exports.ValidatorSlashEvent = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorSlashEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorPeriod: (0, $dkaBG.isSet)(object.validatorPeriod) ? $dkaBG.Long.fromValue(object.validatorPeriod) : $dkaBG.Long.UZERO,
            fraction: (0, $dkaBG.isSet)(object.fraction) ? String(object.fraction) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $dkaBG.Long.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorSlashEvent();
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $dkaBG.Long.fromValue(object.validatorPeriod) : $dkaBG.Long.UZERO;
        message.fraction = object.fraction ?? "";
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseValidatorSlashEvents() {
    return {
        validatorSlashEvents: []
    };
}
module.exports.ValidatorSlashEvents = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.validatorSlashEvents)module.exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseValidatorSlashEvents();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push(module.exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorSlashEvents: Array.isArray(object?.validatorSlashEvents) ? object.validatorSlashEvents.map((e)=>module.exports.ValidatorSlashEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map((e)=>e ? module.exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseValidatorSlashEvents();
        message.validatorSlashEvents = object.validatorSlashEvents?.map((e)=>module.exports.ValidatorSlashEvent.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseFeePool() {
    return {
        communityPool: []
    };
}
module.exports.FeePool = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        for (const v of message.communityPool)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseFeePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityPool: Array.isArray(object?.communityPool) ? object.communityPool.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.communityPool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseFeePool();
        message.communityPool = object.communityPool?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposal() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: []
    };
}
module.exports.CommunityPoolSpendProposal = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $dkaBG.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseDelegatorStartingInfo() {
    return {
        previousPeriod: $dkaBG.Long.UZERO,
        stake: "",
        height: $dkaBG.Long.UZERO
    };
}
module.exports.DelegatorStartingInfo = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseDelegatorStartingInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            previousPeriod: (0, $dkaBG.isSet)(object.previousPeriod) ? $dkaBG.Long.fromValue(object.previousPeriod) : $dkaBG.Long.UZERO,
            stake: (0, $dkaBG.isSet)(object.stake) ? String(object.stake) : "",
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $dkaBG.Long.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseDelegatorStartingInfo();
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $dkaBG.Long.fromValue(object.previousPeriod) : $dkaBG.Long.UZERO;
        message.stake = object.stake ?? "";
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseDelegationDelegatorReward() {
    return {
        validatorAddress: "",
        reward: []
    };
}
module.exports.DelegationDelegatorReward = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        for (const v of message.reward)$efcGD.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseDelegationDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object?.reward) ? object.reward.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.reward = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseDelegationDelegatorReward();
        message.validatorAddress = object.validatorAddress ?? "";
        message.reward = object.reward?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposalWithDeposit() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
    };
}
module.exports.CommunityPoolSpendProposalWithDeposit = {
    encode (message, writer = $6d250fe34c142e57$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6d250fe34c142e57$var$_m0.Reader ? input : new $6d250fe34c142e57$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposalWithDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $dkaBG.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? String(object.amount) : "",
            deposit: (0, $dkaBG.isSet)(object.deposit) ? String(object.deposit) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial (object) {
        const message = $6d250fe34c142e57$var$createBaseCommunityPoolSpendProposalWithDeposit();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount ?? "";
        message.deposit = object.deposit ?? "";
        return message;
    }
};

});



parcelRegister("5d4rt", function(module, exports) {
"use strict";
var $3cb19cbc52ab192d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupDistributionExtension = void 0;

var $8CKn8 = parcelRequire("8CKn8");

const $3cb19cbc52ab192d$var$long_1 = $3cb19cbc52ab192d$var$__importDefault((parcelRequire("3gmZQ")));

var $5E3xG = parcelRequire("5E3xG");
function $3cb19cbc52ab192d$var$setupDistributionExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $8CKn8.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async ()=>{
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress)=>{
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress)=>{
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress)=>{
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress)=>{
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey)=>{
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: $3cb19cbc52ab192d$var$long_1.default.fromNumber(startingHeight, true),
                    endingHeight: $3cb19cbc52ab192d$var$long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
module.exports.setupDistributionExtension = $3cb19cbc52ab192d$var$setupDistributionExtension;

});
parcelRegister("8CKn8", function(module, exports) {
"use strict";
var $6475d7e62a3963bc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6475d7e62a3963bc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6475d7e62a3963bc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6475d7e62a3963bc$var$__createBinding(result, mod, k);
    }
    $6475d7e62a3963bc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryCommunityPoolResponse = module.exports.QueryCommunityPoolRequest = module.exports.QueryDelegatorWithdrawAddressResponse = module.exports.QueryDelegatorWithdrawAddressRequest = module.exports.QueryDelegatorValidatorsResponse = module.exports.QueryDelegatorValidatorsRequest = module.exports.QueryDelegationTotalRewardsResponse = module.exports.QueryDelegationTotalRewardsRequest = module.exports.QueryDelegationRewardsResponse = module.exports.QueryDelegationRewardsRequest = module.exports.QueryValidatorSlashesResponse = module.exports.QueryValidatorSlashesRequest = module.exports.QueryValidatorCommissionResponse = module.exports.QueryValidatorCommissionRequest = module.exports.QueryValidatorOutstandingRewardsResponse = module.exports.QueryValidatorOutstandingRewardsRequest = module.exports.QueryValidatorDistributionInfoResponse = module.exports.QueryValidatorDistributionInfoRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $9mYsa = parcelRequire("9mYsa");

var $efcGD = parcelRequire("efcGD");

var $dkaBG = parcelRequire("dkaBG");

const $6475d7e62a3963bc$var$_m0 = $6475d7e62a3963bc$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.distribution.v1beta1";
function $6475d7e62a3963bc$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6475d7e62a3963bc$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.params !== undefined) $9mYsa.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $9mYsa.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $9mYsa.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $9mYsa.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $9mYsa.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoRequest() {
    return {
        validatorAddress: ""
    };
}
module.exports.QueryValidatorDistributionInfoRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoResponse() {
    return {
        operatorAddress: "",
        selfBondRewards: [],
        commission: []
    };
}
module.exports.QueryValidatorDistributionInfoResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        for (const v of message.selfBondRewards)$efcGD.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.commission)$efcGD.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.selfBondRewards.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.commission.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $dkaBG.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            selfBondRewards: Array.isArray(object?.selfBondRewards) ? object.selfBondRewards.map((e)=>$efcGD.DecCoin.fromJSON(e)) : [],
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        if (message.selfBondRewards) obj.selfBondRewards = message.selfBondRewards.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.selfBondRewards = [];
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorDistributionInfoResponse();
        message.operatorAddress = object.operatorAddress ?? "";
        message.selfBondRewards = object.selfBondRewards?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        message.commission = object.commission?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsRequest() {
    return {
        validatorAddress: ""
    };
}
module.exports.QueryValidatorOutstandingRewardsRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsResponse() {
    return {
        rewards: undefined
    };
}
module.exports.QueryValidatorOutstandingRewardsResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.rewards !== undefined) $9mYsa.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards = $9mYsa.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: (0, $dkaBG.isSet)(object.rewards) ? $9mYsa.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rewards !== undefined && (obj.rewards = message.rewards ? $9mYsa.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $9mYsa.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionRequest() {
    return {
        validatorAddress: ""
    };
}
module.exports.QueryValidatorCommissionRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionResponse() {
    return {
        commission: undefined
    };
}
module.exports.QueryValidatorCommissionResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.commission !== undefined) $9mYsa.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission = $9mYsa.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: (0, $dkaBG.isSet)(object.commission) ? $9mYsa.ValidatorAccumulatedCommission.fromJSON(object.commission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commission !== undefined && (obj.commission = message.commission ? $9mYsa.ValidatorAccumulatedCommission.toJSON(message.commission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorCommissionResponse();
        message.commission = object.commission !== undefined && object.commission !== null ? $9mYsa.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: $dkaBG.Long.UZERO,
        endingHeight: $dkaBG.Long.UZERO,
        pagination: undefined
    };
}
module.exports.QueryValidatorSlashesRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        if (!message.startingHeight.isZero()) writer.uint32(16).uint64(message.startingHeight);
        if (!message.endingHeight.isZero()) writer.uint32(24).uint64(message.endingHeight);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: (0, $dkaBG.isSet)(object.startingHeight) ? $dkaBG.Long.fromValue(object.startingHeight) : $dkaBG.Long.UZERO,
            endingHeight: (0, $dkaBG.isSet)(object.endingHeight) ? $dkaBG.Long.fromValue(object.endingHeight) : $dkaBG.Long.UZERO,
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined && (obj.startingHeight = (message.startingHeight || $dkaBG.Long.UZERO).toString());
        message.endingHeight !== undefined && (obj.endingHeight = (message.endingHeight || $dkaBG.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $dkaBG.Long.fromValue(object.startingHeight) : $dkaBG.Long.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $dkaBG.Long.fromValue(object.endingHeight) : $dkaBG.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesResponse() {
    return {
        slashes: [],
        pagination: undefined
    };
}
module.exports.QueryValidatorSlashesResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        for (const v of message.slashes)$9mYsa.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.slashes.push($9mYsa.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            slashes: Array.isArray(object?.slashes) ? object.slashes.map((e)=>$9mYsa.ValidatorSlashEvent.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.slashes) obj.slashes = message.slashes.map((e)=>e ? $9mYsa.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.slashes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryValidatorSlashesResponse();
        message.slashes = object.slashes?.map((e)=>$9mYsa.ValidatorSlashEvent.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsRequest() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.QueryDelegationRewardsRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsResponse() {
    return {
        rewards: []
    };
}
module.exports.QueryDelegationRewardsResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        for (const v of message.rewards)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsRequest() {
    return {
        delegatorAddress: ""
    };
}
module.exports.QueryDelegationTotalRewardsRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsResponse() {
    return {
        rewards: [],
        total: []
    };
}
module.exports.QueryDelegationTotalRewardsResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        for (const v of message.rewards)$9mYsa.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.total)$efcGD.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($9mYsa.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$9mYsa.DelegationDelegatorReward.fromJSON(e)) : [],
            total: Array.isArray(object?.total) ? object.total.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $9mYsa.DelegationDelegatorReward.toJSON(e) : undefined);
        else obj.rewards = [];
        if (message.total) obj.total = message.total.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$9mYsa.DelegationDelegatorReward.fromPartial(e)) || [];
        message.total = object.total?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddress: ""
    };
}
module.exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: []
    };
}
module.exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        for (const v of message.validators)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e);
        else obj.validators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>e) || [];
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressRequest() {
    return {
        delegatorAddress: ""
    };
}
module.exports.QueryDelegatorWithdrawAddressRequest = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressResponse() {
    return {
        withdrawAddress: ""
    };
}
module.exports.QueryDelegatorWithdrawAddressResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        if (message.withdrawAddress !== "") writer.uint32(10).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            withdrawAddress: (0, $dkaBG.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryDelegatorWithdrawAddressResponse();
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryCommunityPoolRequest() {
    return {};
}
module.exports.QueryCommunityPoolRequest = {
    encode (_, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryCommunityPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6475d7e62a3963bc$var$createBaseQueryCommunityPoolRequest();
        return message;
    }
};
function $6475d7e62a3963bc$var$createBaseQueryCommunityPoolResponse() {
    return {
        pool: []
    };
}
module.exports.QueryCommunityPoolResponse = {
    encode (message, writer = $6475d7e62a3963bc$var$_m0.Writer.create()) {
        for (const v of message.pool)$efcGD.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6475d7e62a3963bc$var$_m0.Reader ? input : new $6475d7e62a3963bc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6475d7e62a3963bc$var$createBaseQueryCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool.push($efcGD.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: Array.isArray(object?.pool) ? object.pool.map((e)=>$efcGD.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pool) obj.pool = message.pool.map((e)=>e ? $efcGD.DecCoin.toJSON(e) : undefined);
        else obj.pool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6475d7e62a3963bc$var$createBaseQueryCommunityPoolResponse();
        message.pool = object.pool?.map((e)=>$efcGD.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
class $6475d7e62a3963bc$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    ValidatorDistributionInfo(request) {
        const data = module.exports.QueryValidatorDistributionInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", data);
        return promise.then((data)=>module.exports.QueryValidatorDistributionInfoResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = module.exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data)=>module.exports.QueryValidatorOutstandingRewardsResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = module.exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data)=>module.exports.QueryValidatorCommissionResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = module.exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data)=>module.exports.QueryValidatorSlashesResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    DelegationRewards(request) {
        const data = module.exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data)=>module.exports.QueryDelegationRewardsResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = module.exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data)=>module.exports.QueryDelegationTotalRewardsResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = module.exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>module.exports.QueryDelegatorValidatorsResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = module.exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data)=>module.exports.QueryDelegatorWithdrawAddressResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
    CommunityPool(request = {}) {
        const data = module.exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data)=>module.exports.QueryCommunityPoolResponse.decode(new $6475d7e62a3963bc$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $6475d7e62a3963bc$var$QueryClientImpl;

});


parcelRegister("kaYNR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createEvidenceAminoConverters = module.exports.isAminoMsgSubmitEvidence = void 0;
function $eb03e80f53276a00$var$isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
module.exports.isAminoMsgSubmitEvidence = $eb03e80f53276a00$var$isAminoMsgSubmitEvidence;
function $eb03e80f53276a00$var$createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
module.exports.createEvidenceAminoConverters = $eb03e80f53276a00$var$createEvidenceAminoConverters;

});

parcelRegister("hXHzq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFeegrantAminoConverters = void 0;
function $d139be87a43cd6a2$var$createFeegrantAminoConverters() {
    return {
    };
}
module.exports.createFeegrantAminoConverters = $d139be87a43cd6a2$var$createFeegrantAminoConverters;

});

parcelRegister("2mP52", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.feegrantTypes = void 0;

var $k2OOb = parcelRequire("k2OOb");
module.exports.feegrantTypes = [
    [
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        $k2OOb.MsgGrantAllowance
    ],
    [
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        $k2OOb.MsgRevokeAllowance
    ]
];

});
parcelRegister("k2OOb", function(module, exports) {
"use strict";
var $e97b680bd2d85f1d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e97b680bd2d85f1d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e97b680bd2d85f1d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e97b680bd2d85f1d$var$__createBinding(result, mod, k);
    }
    $e97b680bd2d85f1d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgRevokeAllowanceResponse = module.exports.MsgRevokeAllowance = module.exports.MsgGrantAllowanceResponse = module.exports.MsgGrantAllowance = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

const $e97b680bd2d85f1d$var$_m0 = $e97b680bd2d85f1d$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $e97b680bd2d85f1d$var$createBaseMsgGrantAllowance() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
module.exports.MsgGrantAllowance = {
    encode (message, writer = $e97b680bd2d85f1d$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $axIO3.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e97b680bd2d85f1d$var$_m0.Reader ? input : new $e97b680bd2d85f1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e97b680bd2d85f1d$var$createBaseMsgGrantAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $dkaBG.isSet)(object.allowance) ? $axIO3.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $axIO3.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e97b680bd2d85f1d$var$createBaseMsgGrantAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $axIO3.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $e97b680bd2d85f1d$var$createBaseMsgGrantAllowanceResponse() {
    return {};
}
module.exports.MsgGrantAllowanceResponse = {
    encode (_, writer = $e97b680bd2d85f1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e97b680bd2d85f1d$var$_m0.Reader ? input : new $e97b680bd2d85f1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e97b680bd2d85f1d$var$createBaseMsgGrantAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e97b680bd2d85f1d$var$createBaseMsgGrantAllowanceResponse();
        return message;
    }
};
function $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowance() {
    return {
        granter: "",
        grantee: ""
    };
}
module.exports.MsgRevokeAllowance = {
    encode (message, writer = $e97b680bd2d85f1d$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e97b680bd2d85f1d$var$_m0.Reader ? input : new $e97b680bd2d85f1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowanceResponse() {
    return {};
}
module.exports.MsgRevokeAllowanceResponse = {
    encode (_, writer = $e97b680bd2d85f1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e97b680bd2d85f1d$var$_m0.Reader ? input : new $e97b680bd2d85f1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e97b680bd2d85f1d$var$createBaseMsgRevokeAllowanceResponse();
        return message;
    }
};
class $e97b680bd2d85f1d$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(request) {
        const data = module.exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data)=>module.exports.MsgGrantAllowanceResponse.decode(new $e97b680bd2d85f1d$var$_m0.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = module.exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data)=>module.exports.MsgRevokeAllowanceResponse.decode(new $e97b680bd2d85f1d$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $e97b680bd2d85f1d$var$MsgClientImpl;

});


parcelRegister("hK3yh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupFeegrantExtension = void 0;

var $hld4P = parcelRequire("hld4P");

var $5E3xG = parcelRequire("5E3xG");
function $cea97ce2721640da$var$setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    const queryService = new $hld4P.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: async (granter, grantee)=>{
                const response = await queryService.Allowance({
                    granter: granter,
                    grantee: grantee
                });
                return response;
            },
            allowances: async (grantee, paginationKey)=>{
                const response = await queryService.Allowances({
                    grantee: grantee,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
module.exports.setupFeegrantExtension = $cea97ce2721640da$var$setupFeegrantExtension;

});
parcelRegister("hld4P", function(module, exports) {
"use strict";
var $c9fe8aa441743627$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9fe8aa441743627$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c9fe8aa441743627$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c9fe8aa441743627$var$__createBinding(result, mod, k);
    }
    $c9fe8aa441743627$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryAllowancesByGranterResponse = module.exports.QueryAllowancesByGranterRequest = module.exports.QueryAllowancesResponse = module.exports.QueryAllowancesRequest = module.exports.QueryAllowanceResponse = module.exports.QueryAllowanceRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $aZdrK = parcelRequire("aZdrK");

const $c9fe8aa441743627$var$_m0 = $c9fe8aa441743627$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $c9fe8aa441743627$var$createBaseQueryAllowanceRequest() {
    return {
        granter: "",
        grantee: ""
    };
}
module.exports.QueryAllowanceRequest = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowanceRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $c9fe8aa441743627$var$createBaseQueryAllowanceResponse() {
    return {
        allowance: undefined
    };
}
module.exports.QueryAllowanceResponse = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $aZdrK.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $aZdrK.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $dkaBG.isSet)(object.allowance) ? $aZdrK.Grant.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $aZdrK.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowanceResponse();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $aZdrK.Grant.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $c9fe8aa441743627$var$createBaseQueryAllowancesRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
module.exports.QueryAllowancesRequest = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c9fe8aa441743627$var$createBaseQueryAllowancesResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
module.exports.QueryAllowancesResponse = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        for (const v of message.allowances)$aZdrK.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($aZdrK.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$aZdrK.Grant.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $aZdrK.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesResponse();
        message.allowances = object.allowances?.map((e)=>$aZdrK.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
module.exports.QueryAllowancesByGranterRequest = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
module.exports.QueryAllowancesByGranterResponse = {
    encode (message, writer = $c9fe8aa441743627$var$_m0.Writer.create()) {
        for (const v of message.allowances)$aZdrK.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c9fe8aa441743627$var$_m0.Reader ? input : new $c9fe8aa441743627$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($aZdrK.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$aZdrK.Grant.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $aZdrK.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c9fe8aa441743627$var$createBaseQueryAllowancesByGranterResponse();
        message.allowances = object.allowances?.map((e)=>$aZdrK.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $c9fe8aa441743627$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(request) {
        const data = module.exports.QueryAllowanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
        return promise.then((data)=>module.exports.QueryAllowanceResponse.decode(new $c9fe8aa441743627$var$_m0.Reader(data)));
    }
    Allowances(request) {
        const data = module.exports.QueryAllowancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
        return promise.then((data)=>module.exports.QueryAllowancesResponse.decode(new $c9fe8aa441743627$var$_m0.Reader(data)));
    }
    AllowancesByGranter(request) {
        const data = module.exports.QueryAllowancesByGranterRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
        return promise.then((data)=>module.exports.QueryAllowancesByGranterResponse.decode(new $c9fe8aa441743627$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $c9fe8aa441743627$var$QueryClientImpl;

});
parcelRegister("aZdrK", function(module, exports) {
"use strict";
var $7ffa08176f52517a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7ffa08176f52517a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7ffa08176f52517a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7ffa08176f52517a$var$__createBinding(result, mod, k);
    }
    $7ffa08176f52517a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Grant = module.exports.AllowedMsgAllowance = module.exports.PeriodicAllowance = module.exports.BasicAllowance = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $cPgyI = parcelRequire("cPgyI");

var $jBPGv = parcelRequire("jBPGv");

var $axIO3 = parcelRequire("axIO3");

const $7ffa08176f52517a$var$_m0 = $7ffa08176f52517a$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $7ffa08176f52517a$var$createBaseBasicAllowance() {
    return {
        spendLimit: [],
        expiration: undefined
    };
}
module.exports.BasicAllowance = {
    encode (message, writer = $7ffa08176f52517a$var$_m0.Writer.create()) {
        for (const v of message.spendLimit)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $cPgyI.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ffa08176f52517a$var$_m0.Reader ? input : new $7ffa08176f52517a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ffa08176f52517a$var$createBaseBasicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            spendLimit: Array.isArray(object?.spendLimit) ? object.spendLimit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            expiration: (0, $dkaBG.isSet)(object.expiration) ? (0, $dkaBG.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        message.expiration !== undefined && (obj.expiration = (0, $dkaBG.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $7ffa08176f52517a$var$createBaseBasicAllowance();
        message.spendLimit = object.spendLimit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $cPgyI.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $7ffa08176f52517a$var$createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined
    };
}
module.exports.PeriodicAllowance = {
    encode (message, writer = $7ffa08176f52517a$var$_m0.Writer.create()) {
        if (message.basic !== undefined) module.exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        if (message.period !== undefined) $jBPGv.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        for (const v of message.periodSpendLimit)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.periodCanSpend)$efcGD.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.periodReset !== undefined) $cPgyI.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ffa08176f52517a$var$_m0.Reader ? input : new $7ffa08176f52517a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ffa08176f52517a$var$createBasePeriodicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.basic = module.exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            basic: (0, $dkaBG.isSet)(object.basic) ? module.exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: (0, $dkaBG.isSet)(object.period) ? $jBPGv.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object?.periodSpendLimit) ? object.periodSpendLimit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            periodCanSpend: Array.isArray(object?.periodCanSpend) ? object.periodCanSpend.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            periodReset: (0, $dkaBG.isSet)(object.periodReset) ? (0, $dkaBG.fromJsonTimestamp)(object.periodReset) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.basic !== undefined && (obj.basic = message.basic ? module.exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined && (obj.period = message.period ? $jBPGv.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) obj.periodSpendLimit = message.periodSpendLimit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.periodSpendLimit = [];
        if (message.periodCanSpend) obj.periodCanSpend = message.periodCanSpend.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.periodCanSpend = [];
        message.periodReset !== undefined && (obj.periodReset = (0, $dkaBG.fromTimestamp)(message.periodReset).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $7ffa08176f52517a$var$createBasePeriodicAllowance();
        message.basic = object.basic !== undefined && object.basic !== null ? module.exports.BasicAllowance.fromPartial(object.basic) : undefined;
        message.period = object.period !== undefined && object.period !== null ? $jBPGv.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = object.periodSpendLimit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.periodCanSpend = object.periodCanSpend?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.periodReset = object.periodReset !== undefined && object.periodReset !== null ? $cPgyI.Timestamp.fromPartial(object.periodReset) : undefined;
        return message;
    }
};
function $7ffa08176f52517a$var$createBaseAllowedMsgAllowance() {
    return {
        allowance: undefined,
        allowedMessages: []
    };
}
module.exports.AllowedMsgAllowance = {
    encode (message, writer = $7ffa08176f52517a$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $axIO3.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        for (const v of message.allowedMessages)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ffa08176f52517a$var$_m0.Reader ? input : new $7ffa08176f52517a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ffa08176f52517a$var$createBaseAllowedMsgAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $dkaBG.isSet)(object.allowance) ? $axIO3.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object?.allowedMessages) ? object.allowedMessages.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $axIO3.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) obj.allowedMessages = message.allowedMessages.map((e)=>e);
        else obj.allowedMessages = [];
        return obj;
    },
    fromPartial (object) {
        const message = $7ffa08176f52517a$var$createBaseAllowedMsgAllowance();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $axIO3.Any.fromPartial(object.allowance) : undefined;
        message.allowedMessages = object.allowedMessages?.map((e)=>e) || [];
        return message;
    }
};
function $7ffa08176f52517a$var$createBaseGrant() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
module.exports.Grant = {
    encode (message, writer = $7ffa08176f52517a$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $axIO3.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ffa08176f52517a$var$_m0.Reader ? input : new $7ffa08176f52517a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ffa08176f52517a$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $dkaBG.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $dkaBG.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $dkaBG.isSet)(object.allowance) ? $axIO3.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $axIO3.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7ffa08176f52517a$var$createBaseGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $axIO3.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};

});
parcelRegister("jBPGv", function(module, exports) {
"use strict";
var $e469908024e57e69$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e469908024e57e69$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e469908024e57e69$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e469908024e57e69$var$__createBinding(result, mod, k);
    }
    $e469908024e57e69$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $e469908024e57e69$var$_m0 = $e469908024e57e69$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $e469908024e57e69$var$createBaseDuration() {
    return {
        seconds: $dkaBG.Long.ZERO,
        nanos: 0
    };
}
module.exports.Duration = {
    encode (message, writer = $e469908024e57e69$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e469908024e57e69$var$_m0.Reader ? input : new $e469908024e57e69$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e469908024e57e69$var$createBaseDuration();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $dkaBG.isSet)(object.seconds) ? $dkaBG.Long.fromValue(object.seconds) : $dkaBG.Long.ZERO,
            nanos: (0, $dkaBG.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $dkaBG.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $e469908024e57e69$var$createBaseDuration();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $dkaBG.Long.fromValue(object.seconds) : $dkaBG.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};

});




parcelRegister("b0uBt", function(module, exports) {
"use strict";
var $80376efb56f328c5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGovAminoConverters = module.exports.isAminoMsgDeposit = module.exports.isAminoMsgVoteWeighted = module.exports.isAminoMsgVote = module.exports.isAminoMsgSubmitProposal = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $hm8y1 = parcelRequire("hm8y1");

var $9cepu = parcelRequire("9cepu");

var $axIO3 = parcelRequire("axIO3");

const $80376efb56f328c5$var$long_1 = $80376efb56f328c5$var$__importDefault((parcelRequire("3gmZQ")));

var $5E3xG = parcelRequire("5E3xG");
function $80376efb56f328c5$var$isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
module.exports.isAminoMsgSubmitProposal = $80376efb56f328c5$var$isAminoMsgSubmitProposal;
function $80376efb56f328c5$var$isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
module.exports.isAminoMsgVote = $80376efb56f328c5$var$isAminoMsgVote;
function $80376efb56f328c5$var$isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
module.exports.isAminoMsgVoteWeighted = $80376efb56f328c5$var$isAminoMsgVoteWeighted;
function $80376efb56f328c5$var$isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
module.exports.isAminoMsgDeposit = $80376efb56f328c5$var$isAminoMsgDeposit;
function $80376efb56f328c5$var$createGovAminoConverters() {
    // Gov v1 types missing, see
    // https://github.com/cosmos/cosmjs/issues/1442
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount: amount, depositor: depositor, proposalId: proposalId })=>{
                return {
                    amount: amount,
                    depositor: depositor,
                    proposal_id: proposalId.toString()
                };
            },
            fromAmino: ({ amount: amount, depositor: depositor, proposal_id: proposal_id })=>{
                return {
                    amount: Array.from(amount),
                    depositor: depositor,
                    proposalId: $80376efb56f328c5$var$long_1.default.fromString(proposal_id)
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option: option, proposalId: proposalId, voter: voter })=>{
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ option: option, proposal_id: proposal_id, voter: voter })=>{
                return {
                    option: (0, $9cepu.voteOptionFromJSON)(option),
                    proposalId: $80376efb56f328c5$var$long_1.default.fromString(proposal_id),
                    voter: voter
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: ({ options: options, proposalId: proposalId, voter: voter })=>{
                return {
                    options: options.map((o)=>({
                            option: o.option,
                            // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                            // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                            weight: (0, $5E3xG.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0")
                        })),
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ options: options, proposal_id: proposal_id, voter: voter })=>{
                return {
                    proposalId: $80376efb56f328c5$var$long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map((o)=>({
                            option: (0, $9cepu.voteOptionFromJSON)(o.option),
                            weight: $h3uvW.Decimal.fromUserInput(o.weight, 18).atomics
                        }))
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit: initialDeposit, proposer: proposer, content: content })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(content);
                let proposal;
                switch(content.typeUrl){
                    case "/cosmos.gov.v1beta1.TextProposal":
                        {
                            const textProposal = $9cepu.TextProposal.decode(content.value);
                            proposal = {
                                type: "cosmos-sdk/TextProposal",
                                value: {
                                    description: textProposal.description,
                                    title: textProposal.title
                                }
                            };
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal
                };
            },
            fromAmino: ({ initial_deposit: initial_deposit, proposer: proposer, content: content })=>{
                let any_content;
                switch(content.type){
                    case "cosmos-sdk/TextProposal":
                        {
                            const { value: value } = content;
                            (0, $hm8y1.assert)((0, $hm8y1.isNonNullObject)(value));
                            const { title: title, description: description } = value;
                            (0, $hm8y1.assert)(typeof title === "string");
                            (0, $hm8y1.assert)(typeof description === "string");
                            any_content = $axIO3.Any.fromPartial({
                                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                                value: $9cepu.TextProposal.encode($9cepu.TextProposal.fromPartial({
                                    title: title,
                                    description: description
                                })).finish()
                            });
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content
                };
            }
        }
    };
}
module.exports.createGovAminoConverters = $80376efb56f328c5$var$createGovAminoConverters;

});
parcelRegister("9cepu", function(module, exports) {
"use strict";
var $6b206998e52e0387$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6b206998e52e0387$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6b206998e52e0387$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6b206998e52e0387$var$__createBinding(result, mod, k);
    }
    $6b206998e52e0387$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.TextProposal = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $axIO3 = parcelRequire("axIO3");

var $cPgyI = parcelRequire("cPgyI");

var $jBPGv = parcelRequire("jBPGv");

var $dkaBG = parcelRequire("dkaBG");

const $6b206998e52e0387$var$_m0 = $6b206998e52e0387$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $6b206998e52e0387$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6b206998e52e0387$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $6b206998e52e0387$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $6b206998e52e0387$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $6b206998e52e0387$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $6b206998e52e0387$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $6b206998e52e0387$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $6b206998e52e0387$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6b206998e52e0387$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $6b206998e52e0387$var$voteOptionFromJSON;
function $6b206998e52e0387$var$voteOptionToJSON(object) {
    switch(object){
        case $6b206998e52e0387$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $6b206998e52e0387$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $6b206998e52e0387$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $6b206998e52e0387$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $6b206998e52e0387$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $6b206998e52e0387$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteOptionToJSON = $6b206998e52e0387$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $6b206998e52e0387$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($6b206998e52e0387$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $6b206998e52e0387$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $6b206998e52e0387$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $6b206998e52e0387$var$proposalStatusFromJSON;
function $6b206998e52e0387$var$proposalStatusToJSON(object) {
    switch(object){
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $6b206998e52e0387$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $6b206998e52e0387$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalStatusToJSON = $6b206998e52e0387$var$proposalStatusToJSON;
function $6b206998e52e0387$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
module.exports.WeightedVoteOption = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $dkaBG.isSet)(object.option) ? $6b206998e52e0387$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $dkaBG.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $6b206998e52e0387$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $6b206998e52e0387$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.TextProposal = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseTextProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseTextProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $6b206998e52e0387$var$createBaseDeposit() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        depositor: "",
        amount: []
    };
}
module.exports.Deposit = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $6b206998e52e0387$var$createBaseProposal() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
module.exports.Proposal = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $axIO3.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $cPgyI.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $cPgyI.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$efcGD.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $cPgyI.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $cPgyI.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            content: (0, $dkaBG.isSet)(object.content) ? $axIO3.Any.fromJSON(object.content) : undefined,
            status: (0, $dkaBG.isSet)(object.status) ? $6b206998e52e0387$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $dkaBG.isSet)(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $dkaBG.isSet)(object.submitTime) ? (0, $dkaBG.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $dkaBG.isSet)(object.depositEndTime) ? (0, $dkaBG.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $dkaBG.isSet)(object.votingStartTime) ? (0, $dkaBG.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $dkaBG.isSet)(object.votingEndTime) ? (0, $dkaBG.fromJsonTimestamp)(object.votingEndTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $axIO3.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $6b206998e52e0387$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $dkaBG.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $dkaBG.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $dkaBG.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $dkaBG.fromTimestamp)(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $axIO3.Any.fromPartial(object.content) : undefined;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $cPgyI.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $cPgyI.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $cPgyI.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $cPgyI.Timestamp.fromPartial(object.votingEndTime) : undefined;
        return message;
    }
};
function $6b206998e52e0387$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
module.exports.TallyResult = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yes: (0, $dkaBG.isSet)(object.yes) ? String(object.yes) : "",
            abstain: (0, $dkaBG.isSet)(object.abstain) ? String(object.abstain) : "",
            no: (0, $dkaBG.isSet)(object.no) ? String(object.no) : "",
            noWithVeto: (0, $dkaBG.isSet)(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseTallyResult();
        message.yes = object.yes ?? "";
        message.abstain = object.abstain ?? "";
        message.no = object.no ?? "";
        message.noWithVeto = object.noWithVeto ?? "";
        return message;
    }
};
function $6b206998e52e0387$var$createBaseVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        option: 0,
        options: []
    };
}
module.exports.Vote = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $dkaBG.isSet)(object.option) ? $6b206998e52e0387$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object?.options) ? object.options.map((e)=>module.exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $6b206998e52e0387$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? module.exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.options = object.options?.map((e)=>module.exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $6b206998e52e0387$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
module.exports.DepositParams = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $jBPGv.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $dkaBG.isSet)(object.maxDepositPeriod) ? $jBPGv.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $jBPGv.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $jBPGv.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $6b206998e52e0387$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
module.exports.VotingParams = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $jBPGv.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $dkaBG.isSet)(object.votingPeriod) ? $jBPGv.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $jBPGv.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $jBPGv.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $6b206998e52e0387$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
module.exports.TallyParams = {
    encode (message, writer = $6b206998e52e0387$var$_m0.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6b206998e52e0387$var$_m0.Reader ? input : new $6b206998e52e0387$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6b206998e52e0387$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $dkaBG.isSet)(object.quorum) ? (0, $dkaBG.bytesFromBase64)(object.quorum) : new Uint8Array(),
            threshold: (0, $dkaBG.isSet)(object.threshold) ? (0, $dkaBG.bytesFromBase64)(object.threshold) : new Uint8Array(),
            vetoThreshold: (0, $dkaBG.isSet)(object.vetoThreshold) ? (0, $dkaBG.bytesFromBase64)(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = (0, $dkaBG.base64FromBytes)(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = (0, $dkaBG.base64FromBytes)(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = (0, $dkaBG.base64FromBytes)(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $6b206998e52e0387$var$createBaseTallyParams();
        message.quorum = object.quorum ?? new Uint8Array();
        message.threshold = object.threshold ?? new Uint8Array();
        message.vetoThreshold = object.vetoThreshold ?? new Uint8Array();
        return message;
    }
};

});


parcelRegister("aSteU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgVoteWeightedEncodeObject = module.exports.isMsgVoteEncodeObject = module.exports.isMsgSubmitProposalEncodeObject = module.exports.isMsgDepositEncodeObject = module.exports.govTypes = void 0;

var $8xLa3 = parcelRequire("8xLa3");

var $hF12p = parcelRequire("hF12p");
module.exports.govTypes = [
    [
        "/cosmos.gov.v1.MsgDeposit",
        $8xLa3.MsgDeposit
    ],
    [
        "/cosmos.gov.v1.MsgSubmitProposal",
        $8xLa3.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1.MsgUpdateParams",
        $8xLa3.MsgUpdateParams
    ],
    [
        "/cosmos.gov.v1.MsgVote",
        $8xLa3.MsgVote
    ],
    [
        "/cosmos.gov.v1.MsgVoteWeighted",
        $8xLa3.MsgVoteWeighted
    ],
    [
        "/cosmos.gov.v1beta1.MsgDeposit",
        $hF12p.MsgDeposit
    ],
    [
        "/cosmos.gov.v1beta1.MsgSubmitProposal",
        $hF12p.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1beta1.MsgVote",
        $hF12p.MsgVote
    ],
    [
        "/cosmos.gov.v1beta1.MsgVoteWeighted",
        $hF12p.MsgVoteWeighted
    ]
];
function $7eb5a0e0597f311b$var$isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
module.exports.isMsgDepositEncodeObject = $7eb5a0e0597f311b$var$isMsgDepositEncodeObject;
function $7eb5a0e0597f311b$var$isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
module.exports.isMsgSubmitProposalEncodeObject = $7eb5a0e0597f311b$var$isMsgSubmitProposalEncodeObject;
function $7eb5a0e0597f311b$var$isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
module.exports.isMsgVoteEncodeObject = $7eb5a0e0597f311b$var$isMsgVoteEncodeObject;
function $7eb5a0e0597f311b$var$isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
module.exports.isMsgVoteWeightedEncodeObject = $7eb5a0e0597f311b$var$isMsgVoteWeightedEncodeObject;

});
parcelRegister("8xLa3", function(module, exports) {
"use strict";
var $6385fd08caa3cff9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6385fd08caa3cff9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6385fd08caa3cff9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6385fd08caa3cff9$var$__createBinding(result, mod, k);
    }
    $6385fd08caa3cff9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgExecLegacyContentResponse = module.exports.MsgExecLegacyContent = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $efcGD = parcelRequire("efcGD");

var $iC1bJ = parcelRequire("iC1bJ");

var $dkaBG = parcelRequire("dkaBG");

const $6385fd08caa3cff9$var$_m0 = $6385fd08caa3cff9$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.gov.v1";
function $6385fd08caa3cff9$var$createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initialDeposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        for (const v of message.messages)$axIO3.Any.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.title !== "") writer.uint32(42).string(message.title);
        if (message.summary !== "") writer.uint32(50).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.title = reader.string();
                    break;
                case 6:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            proposer: (0, $dkaBG.isSet)(object.proposer) ? String(object.proposer) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $dkaBG.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.messages = [];
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgSubmitProposal();
        message.messages = object.messages?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.initialDeposit = object.initialDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $dkaBG.Long.UZERO
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: ""
    };
}
module.exports.MsgExecLegacyContent = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (message.content !== undefined) $axIO3.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        if (message.authority !== "") writer.uint32(18).string(message.authority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgExecLegacyContent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $dkaBG.isSet)(object.content) ? $axIO3.Any.fromJSON(object.content) : undefined,
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $axIO3.Any.toJSON(message.content) : undefined);
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgExecLegacyContent();
        message.content = object.content !== undefined && object.content !== null ? $axIO3.Any.fromPartial(object.content) : undefined;
        message.authority = object.authority ?? "";
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgExecLegacyContentResponse() {
    return {};
}
module.exports.MsgExecLegacyContentResponse = {
    encode (_, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgExecLegacyContentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6385fd08caa3cff9$var$createBaseMsgExecLegacyContentResponse();
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        option: 0,
        metadata: ""
    };
}
module.exports.MsgVote = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $dkaBG.isSet)(object.option) ? (0, $iC1bJ.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $iC1bJ.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode (_, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
module.exports.MsgVoteWeighted = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$iC1bJ.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($iC1bJ.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$iC1bJ.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $iC1bJ.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$iC1bJ.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
module.exports.MsgVoteWeightedResponse = {
    encode (_, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6385fd08caa3cff9$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgDeposit() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        depositor: "",
        amount: []
    };
}
module.exports.MsgDeposit = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgDepositResponse() {
    return {};
}
module.exports.MsgDepositResponse = {
    encode (_, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6385fd08caa3cff9$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
module.exports.MsgUpdateParams = {
    encode (message, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $iC1bJ.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $iC1bJ.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $dkaBG.isSet)(object.params) ? $iC1bJ.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $iC1bJ.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $6385fd08caa3cff9$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $iC1bJ.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $6385fd08caa3cff9$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode (_, writer = $6385fd08caa3cff9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $6385fd08caa3cff9$var$_m0.Reader ? input : new $6385fd08caa3cff9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $6385fd08caa3cff9$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $6385fd08caa3cff9$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $6385fd08caa3cff9$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(request) {
        const data = module.exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>module.exports.MsgSubmitProposalResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
    ExecLegacyContent(request) {
        const data = module.exports.MsgExecLegacyContent.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", data);
        return promise.then((data)=>module.exports.MsgExecLegacyContentResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = module.exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Vote", data);
        return promise.then((data)=>module.exports.MsgVoteResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = module.exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", data);
        return promise.then((data)=>module.exports.MsgVoteWeightedResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = module.exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Deposit", data);
        return promise.then((data)=>module.exports.MsgDepositResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = module.exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", data);
        return promise.then((data)=>module.exports.MsgUpdateParamsResponse.decode(new $6385fd08caa3cff9$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $6385fd08caa3cff9$var$MsgClientImpl;

});
parcelRegister("iC1bJ", function(module, exports) {
"use strict";
var $d8ccb291ea321dfd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d8ccb291ea321dfd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d8ccb291ea321dfd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d8ccb291ea321dfd$var$__createBinding(result, mod, k);
    }
    $d8ccb291ea321dfd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $axIO3 = parcelRequire("axIO3");

var $cPgyI = parcelRequire("cPgyI");

var $jBPGv = parcelRequire("jBPGv");

var $dkaBG = parcelRequire("dkaBG");

const $d8ccb291ea321dfd$var$_m0 = $d8ccb291ea321dfd$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.gov.v1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $d8ccb291ea321dfd$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d8ccb291ea321dfd$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $d8ccb291ea321dfd$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d8ccb291ea321dfd$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $d8ccb291ea321dfd$var$voteOptionFromJSON;
function $d8ccb291ea321dfd$var$voteOptionToJSON(object) {
    switch(object){
        case $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $d8ccb291ea321dfd$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $d8ccb291ea321dfd$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteOptionToJSON = $d8ccb291ea321dfd$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $d8ccb291ea321dfd$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d8ccb291ea321dfd$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $d8ccb291ea321dfd$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d8ccb291ea321dfd$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $d8ccb291ea321dfd$var$proposalStatusFromJSON;
function $d8ccb291ea321dfd$var$proposalStatusToJSON(object) {
    switch(object){
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $d8ccb291ea321dfd$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $d8ccb291ea321dfd$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalStatusToJSON = $d8ccb291ea321dfd$var$proposalStatusToJSON;
function $d8ccb291ea321dfd$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
module.exports.WeightedVoteOption = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $dkaBG.isSet)(object.option) ? $d8ccb291ea321dfd$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $dkaBG.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $d8ccb291ea321dfd$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseDeposit() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        depositor: "",
        amount: []
    };
}
module.exports.Deposit = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseProposal() {
    return {
        id: $dkaBG.Long.UZERO,
        messages: [],
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: ""
    };
}
module.exports.Proposal = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        for (const v of message.messages)$axIO3.Any.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $cPgyI.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $cPgyI.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$efcGD.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $cPgyI.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $cPgyI.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(82).string(message.metadata);
        if (message.title !== "") writer.uint32(90).string(message.title);
        if (message.summary !== "") writer.uint32(98).string(message.summary);
        if (message.proposer !== "") writer.uint32(106).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.messages.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.metadata = reader.string();
                    break;
                case 11:
                    message.title = reader.string();
                    break;
                case 12:
                    message.summary = reader.string();
                    break;
                case 13:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $dkaBG.isSet)(object.id) ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            status: (0, $dkaBG.isSet)(object.status) ? $d8ccb291ea321dfd$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $dkaBG.isSet)(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $dkaBG.isSet)(object.submitTime) ? (0, $dkaBG.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $dkaBG.isSet)(object.depositEndTime) ? (0, $dkaBG.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $dkaBG.isSet)(object.votingStartTime) ? (0, $dkaBG.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $dkaBG.isSet)(object.votingEndTime) ? (0, $dkaBG.fromJsonTimestamp)(object.votingEndTime) : undefined,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $dkaBG.isSet)(object.summary) ? String(object.summary) : "",
            proposer: (0, $dkaBG.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $dkaBG.Long.UZERO).toString());
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.status !== undefined && (obj.status = $d8ccb291ea321dfd$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $dkaBG.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $dkaBG.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $dkaBG.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $dkaBG.fromTimestamp)(message.votingEndTime).toISOString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO;
        message.messages = object.messages?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $cPgyI.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $cPgyI.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $cPgyI.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $cPgyI.Timestamp.fromPartial(object.votingEndTime) : undefined;
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
module.exports.TallyResult = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $dkaBG.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $dkaBG.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $dkaBG.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $dkaBG.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
module.exports.Vote = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(42).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>module.exports.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? module.exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>module.exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
module.exports.DepositParams = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $jBPGv.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $dkaBG.isSet)(object.maxDepositPeriod) ? $jBPGv.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $jBPGv.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $jBPGv.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
module.exports.VotingParams = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $jBPGv.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $dkaBG.isSet)(object.votingPeriod) ? $jBPGv.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $jBPGv.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $jBPGv.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        vetoThreshold: ""
    };
}
module.exports.TallyParams = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        if (message.quorum !== "") writer.uint32(10).string(message.quorum);
        if (message.threshold !== "") writer.uint32(18).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(26).string(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.string();
                    break;
                case 2:
                    message.threshold = reader.string();
                    break;
                case 3:
                    message.vetoThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $dkaBG.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $dkaBG.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $dkaBG.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseTallyParams();
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        return message;
    }
};
function $d8ccb291ea321dfd$var$createBaseParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
        votingPeriod: undefined,
        quorum: "",
        threshold: "",
        vetoThreshold: "",
        minInitialDepositRatio: "",
        burnVoteQuorum: false,
        burnProposalDepositPrevote: false,
        burnVoteVeto: false
    };
}
module.exports.Params = {
    encode (message, writer = $d8ccb291ea321dfd$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$efcGD.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $jBPGv.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        if (message.votingPeriod !== undefined) $jBPGv.Duration.encode(message.votingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.quorum !== "") writer.uint32(34).string(message.quorum);
        if (message.threshold !== "") writer.uint32(42).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(50).string(message.vetoThreshold);
        if (message.minInitialDepositRatio !== "") writer.uint32(58).string(message.minInitialDepositRatio);
        if (message.burnVoteQuorum === true) writer.uint32(104).bool(message.burnVoteQuorum);
        if (message.burnProposalDepositPrevote === true) writer.uint32(112).bool(message.burnProposalDepositPrevote);
        if (message.burnVoteVeto === true) writer.uint32(120).bool(message.burnVoteVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8ccb291ea321dfd$var$_m0.Reader ? input : new $d8ccb291ea321dfd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8ccb291ea321dfd$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.quorum = reader.string();
                    break;
                case 5:
                    message.threshold = reader.string();
                    break;
                case 6:
                    message.vetoThreshold = reader.string();
                    break;
                case 7:
                    message.minInitialDepositRatio = reader.string();
                    break;
                case 13:
                    message.burnVoteQuorum = reader.bool();
                    break;
                case 14:
                    message.burnProposalDepositPrevote = reader.bool();
                    break;
                case 15:
                    message.burnVoteVeto = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $dkaBG.isSet)(object.maxDepositPeriod) ? $jBPGv.Duration.fromJSON(object.maxDepositPeriod) : undefined,
            votingPeriod: (0, $dkaBG.isSet)(object.votingPeriod) ? $jBPGv.Duration.fromJSON(object.votingPeriod) : undefined,
            quorum: (0, $dkaBG.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $dkaBG.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $dkaBG.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
            minInitialDepositRatio: (0, $dkaBG.isSet)(object.minInitialDepositRatio) ? String(object.minInitialDepositRatio) : "",
            burnVoteQuorum: (0, $dkaBG.isSet)(object.burnVoteQuorum) ? Boolean(object.burnVoteQuorum) : false,
            burnProposalDepositPrevote: (0, $dkaBG.isSet)(object.burnProposalDepositPrevote) ? Boolean(object.burnProposalDepositPrevote) : false,
            burnVoteVeto: (0, $dkaBG.isSet)(object.burnVoteVeto) ? Boolean(object.burnVoteVeto) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $jBPGv.Duration.toJSON(message.maxDepositPeriod) : undefined);
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $jBPGv.Duration.toJSON(message.votingPeriod) : undefined);
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        message.minInitialDepositRatio !== undefined && (obj.minInitialDepositRatio = message.minInitialDepositRatio);
        message.burnVoteQuorum !== undefined && (obj.burnVoteQuorum = message.burnVoteQuorum);
        message.burnProposalDepositPrevote !== undefined && (obj.burnProposalDepositPrevote = message.burnProposalDepositPrevote);
        message.burnVoteVeto !== undefined && (obj.burnVoteVeto = message.burnVoteVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $d8ccb291ea321dfd$var$createBaseParams();
        message.minDeposit = object.minDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $jBPGv.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $jBPGv.Duration.fromPartial(object.votingPeriod) : undefined;
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        message.minInitialDepositRatio = object.minInitialDepositRatio ?? "";
        message.burnVoteQuorum = object.burnVoteQuorum ?? false;
        message.burnProposalDepositPrevote = object.burnProposalDepositPrevote ?? false;
        message.burnVoteVeto = object.burnVoteVeto ?? false;
        return message;
    }
};

});


parcelRegister("hF12p", function(module, exports) {
"use strict";
var $cdb7121ba67f12e2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cdb7121ba67f12e2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cdb7121ba67f12e2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cdb7121ba67f12e2$var$__createBinding(result, mod, k);
    }
    $cdb7121ba67f12e2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $efcGD = parcelRequire("efcGD");

var $9cepu = parcelRequire("9cepu");

var $dkaBG = parcelRequire("dkaBG");

const $cdb7121ba67f12e2$var$_m0 = $cdb7121ba67f12e2$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.gov.v1beta1";
function $cdb7121ba67f12e2$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode (message, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        if (message.content !== undefined) $axIO3.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$efcGD.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $dkaBG.isSet)(object.content) ? $axIO3.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            proposer: (0, $dkaBG.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $axIO3.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $axIO3.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = object.initialDeposit?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $dkaBG.Long.UZERO
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        option: 0
    };
}
module.exports.MsgVote = {
    encode (message, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $dkaBG.isSet)(object.option) ? (0, $9cepu.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $9cepu.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial (object) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode (_, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        options: []
    };
}
module.exports.MsgVoteWeighted = {
    encode (message, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$9cepu.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($9cepu.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$9cepu.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $9cepu.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$9cepu.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
module.exports.MsgVoteWeightedResponse = {
    encode (_, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgDeposit() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        depositor: "",
        amount: []
    };
}
module.exports.MsgDeposit = {
    encode (message, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $cdb7121ba67f12e2$var$createBaseMsgDepositResponse() {
    return {};
}
module.exports.MsgDepositResponse = {
    encode (_, writer = $cdb7121ba67f12e2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cdb7121ba67f12e2$var$_m0.Reader ? input : new $cdb7121ba67f12e2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cdb7121ba67f12e2$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $cdb7121ba67f12e2$var$createBaseMsgDepositResponse();
        return message;
    }
};
class $cdb7121ba67f12e2$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(request) {
        const data = module.exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data)=>module.exports.MsgSubmitProposalResponse.decode(new $cdb7121ba67f12e2$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = module.exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data)=>module.exports.MsgVoteResponse.decode(new $cdb7121ba67f12e2$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = module.exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data)=>module.exports.MsgVoteWeightedResponse.decode(new $cdb7121ba67f12e2$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = module.exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data)=>module.exports.MsgDepositResponse.decode(new $cdb7121ba67f12e2$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $cdb7121ba67f12e2$var$MsgClientImpl;

});


parcelRegister("jR8YO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupGovExtension = void 0;

var $jXHZU = parcelRequire("jXHZU");

var $5E3xG = parcelRequire("5E3xG");
function $03baffb8cc901773$var$setupGovExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $jXHZU.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType)=>{
                const response = await queryService.Params({
                    paramsType: parametersType
                });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey)=>{
                const response = await queryService.Proposals({
                    proposalStatus: proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            proposal: async (proposalId)=>{
                const response = await queryService.Proposal({
                    proposalId: (0, $5E3xG.longify)(proposalId)
                });
                return response;
            },
            deposits: async (proposalId, paginationKey)=>{
                const response = await queryService.Deposits({
                    proposalId: (0, $5E3xG.longify)(proposalId),
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress)=>{
                const response = await queryService.Deposit({
                    proposalId: (0, $5E3xG.longify)(proposalId),
                    depositor: depositorAddress
                });
                return response;
            },
            tally: async (proposalId)=>{
                const response = await queryService.TallyResult({
                    proposalId: (0, $5E3xG.longify)(proposalId)
                });
                return response;
            },
            votes: async (proposalId, paginationKey)=>{
                const response = await queryService.Votes({
                    proposalId: (0, $5E3xG.longify)(proposalId),
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            vote: async (proposalId, voterAddress)=>{
                const response = await queryService.Vote({
                    proposalId: (0, $5E3xG.longify)(proposalId),
                    voter: voterAddress
                });
                return response;
            }
        }
    };
}
module.exports.setupGovExtension = $03baffb8cc901773$var$setupGovExtension;

});
parcelRegister("jXHZU", function(module, exports) {
"use strict";
var $e885a80648e6420d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e885a80648e6420d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e885a80648e6420d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e885a80648e6420d$var$__createBinding(result, mod, k);
    }
    $e885a80648e6420d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryTallyResultResponse = module.exports.QueryTallyResultRequest = module.exports.QueryDepositsResponse = module.exports.QueryDepositsRequest = module.exports.QueryDepositResponse = module.exports.QueryDepositRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.QueryVotesResponse = module.exports.QueryVotesRequest = module.exports.QueryVoteResponse = module.exports.QueryVoteRequest = module.exports.QueryProposalsResponse = module.exports.QueryProposalsRequest = module.exports.QueryProposalResponse = module.exports.QueryProposalRequest = module.exports.protobufPackage = void 0;

var $9cepu = parcelRequire("9cepu");

var $aBpB1 = parcelRequire("aBpB1");

var $dkaBG = parcelRequire("dkaBG");

const $e885a80648e6420d$var$_m0 = $e885a80648e6420d$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.gov.v1beta1";
function $e885a80648e6420d$var$createBaseQueryProposalRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO
    };
}
module.exports.QueryProposalRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryProposalRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryProposalRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryProposalResponse() {
    return {
        proposal: undefined
    };
}
module.exports.QueryProposalResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.proposal !== undefined) $9cepu.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposal = $9cepu.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposal: (0, $dkaBG.isSet)(object.proposal) ? $9cepu.Proposal.fromJSON(object.proposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposal !== undefined && (obj.proposal = message.proposal ? $9cepu.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryProposalResponse();
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $9cepu.Proposal.fromPartial(object.proposal) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined
    };
}
module.exports.QueryProposalsRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.proposalStatus !== 0) writer.uint32(8).int32(message.proposalStatus);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.depositor !== "") writer.uint32(26).string(message.depositor);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryProposalsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalStatus: (0, $dkaBG.isSet)(object.proposalStatus) ? (0, $9cepu.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalStatus !== undefined && (obj.proposalStatus = (0, $9cepu.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryProposalsRequest();
        message.proposalStatus = object.proposalStatus ?? 0;
        message.voter = object.voter ?? "";
        message.depositor = object.depositor ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined
    };
}
module.exports.QueryProposalsResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        for (const v of message.proposals)$9cepu.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryProposalsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposals.push($9cepu.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposals: Array.isArray(object?.proposals) ? object.proposals.map((e)=>$9cepu.Proposal.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proposals) obj.proposals = message.proposals.map((e)=>e ? $9cepu.Proposal.toJSON(e) : undefined);
        else obj.proposals = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryProposalsResponse();
        message.proposals = object.proposals?.map((e)=>$9cepu.Proposal.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryVoteRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: ""
    };
}
module.exports.QueryVoteRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryVoteRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryVoteRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryVoteResponse() {
    return {
        vote: undefined
    };
}
module.exports.QueryVoteResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.vote !== undefined) $9cepu.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.vote = $9cepu.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            vote: (0, $dkaBG.isSet)(object.vote) ? $9cepu.Vote.fromJSON(object.vote) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? $9cepu.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryVoteResponse();
        message.vote = object.vote !== undefined && object.vote !== null ? $9cepu.Vote.fromPartial(object.vote) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryVotesRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        pagination: undefined
    };
}
module.exports.QueryVotesRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryVotesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryVotesRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined
    };
}
module.exports.QueryVotesResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        for (const v of message.votes)$9cepu.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryVotesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votes.push($9cepu.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$9cepu.Vote.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $9cepu.Vote.toJSON(e) : undefined);
        else obj.votes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryVotesResponse();
        message.votes = object.votes?.map((e)=>$9cepu.Vote.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryParamsRequest() {
    return {
        paramsType: ""
    };
}
module.exports.QueryParamsRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.paramsType !== "") writer.uint32(10).string(message.paramsType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paramsType: (0, $dkaBG.isSet)(object.paramsType) ? String(object.paramsType) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryParamsRequest();
        message.paramsType = object.paramsType ?? "";
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.votingParams !== undefined) $9cepu.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        if (message.depositParams !== undefined) $9cepu.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        if (message.tallyParams !== undefined) $9cepu.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingParams = $9cepu.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = $9cepu.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = $9cepu.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingParams: (0, $dkaBG.isSet)(object.votingParams) ? $9cepu.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, $dkaBG.isSet)(object.depositParams) ? $9cepu.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, $dkaBG.isSet)(object.tallyParams) ? $9cepu.TallyParams.fromJSON(object.tallyParams) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingParams !== undefined && (obj.votingParams = message.votingParams ? $9cepu.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined && (obj.depositParams = message.depositParams ? $9cepu.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined && (obj.tallyParams = message.tallyParams ? $9cepu.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryParamsResponse();
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $9cepu.VotingParams.fromPartial(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $9cepu.DepositParams.fromPartial(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $9cepu.TallyParams.fromPartial(object.tallyParams) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryDepositRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        depositor: ""
    };
}
module.exports.QueryDepositRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryDepositRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            depositor: (0, $dkaBG.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryDepositRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryDepositResponse() {
    return {
        deposit: undefined
    };
}
module.exports.QueryDepositResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.deposit !== undefined) $9cepu.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposit = $9cepu.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposit: (0, $dkaBG.isSet)(object.deposit) ? $9cepu.Deposit.fromJSON(object.deposit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.deposit !== undefined && (obj.deposit = message.deposit ? $9cepu.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryDepositResponse();
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $9cepu.Deposit.fromPartial(object.deposit) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryDepositsRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        pagination: undefined
    };
}
module.exports.QueryDepositsRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryDepositsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryDepositsRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined
    };
}
module.exports.QueryDepositsResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        for (const v of message.deposits)$9cepu.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryDepositsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposits.push($9cepu.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposits: Array.isArray(object?.deposits) ? object.deposits.map((e)=>$9cepu.Deposit.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.deposits) obj.deposits = message.deposits.map((e)=>e ? $9cepu.Deposit.toJSON(e) : undefined);
        else obj.deposits = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e)=>$9cepu.Deposit.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryTallyResultRequest() {
    return {
        proposalId: $dkaBG.Long.UZERO
    };
}
module.exports.QueryTallyResultRequest = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryTallyResultRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryTallyResultRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $e885a80648e6420d$var$createBaseQueryTallyResultResponse() {
    return {
        tally: undefined
    };
}
module.exports.QueryTallyResultResponse = {
    encode (message, writer = $e885a80648e6420d$var$_m0.Writer.create()) {
        if (message.tally !== undefined) $9cepu.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e885a80648e6420d$var$_m0.Reader ? input : new $e885a80648e6420d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e885a80648e6420d$var$createBaseQueryTallyResultResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tally = $9cepu.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tally: (0, $dkaBG.isSet)(object.tally) ? $9cepu.TallyResult.fromJSON(object.tally) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tally !== undefined && (obj.tally = message.tally ? $9cepu.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e885a80648e6420d$var$createBaseQueryTallyResultResponse();
        message.tally = object.tally !== undefined && object.tally !== null ? $9cepu.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    }
};
class $e885a80648e6420d$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = module.exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data)=>module.exports.QueryProposalResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Proposals(request) {
        const data = module.exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data)=>module.exports.QueryProposalsResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = module.exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data)=>module.exports.QueryVoteResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Votes(request) {
        const data = module.exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data)=>module.exports.QueryVotesResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Params(request) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = module.exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data)=>module.exports.QueryDepositResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    Deposits(request) {
        const data = module.exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data)=>module.exports.QueryDepositsResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
    TallyResult(request) {
        const data = module.exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data)=>module.exports.QueryTallyResultResponse.decode(new $e885a80648e6420d$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $e885a80648e6420d$var$QueryClientImpl;

});


parcelRegister("hqM2Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGroupAminoConverters = void 0;
function $cb0a2286c5c1c30f$var$createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
module.exports.createGroupAminoConverters = $cb0a2286c5c1c30f$var$createGroupAminoConverters;

});

parcelRegister("1m7yV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.groupTypes = void 0;

var $lg7gs = parcelRequire("lg7gs");
module.exports.groupTypes = [
    [
        "/cosmos.group.v1.MsgCreateGroup",
        $lg7gs.MsgCreateGroup
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupPolicy",
        $lg7gs.MsgCreateGroupPolicy
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupWithPolicy",
        $lg7gs.MsgCreateGroupWithPolicy
    ],
    [
        "/cosmos.group.v1.MsgExec",
        $lg7gs.MsgExec
    ],
    [
        "/cosmos.group.v1.MsgLeaveGroup",
        $lg7gs.MsgLeaveGroup
    ],
    [
        "/cosmos.group.v1.MsgSubmitProposal",
        $lg7gs.MsgSubmitProposal
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupAdmin",
        $lg7gs.MsgUpdateGroupAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMembers",
        $lg7gs.MsgUpdateGroupMembers
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMetadata",
        $lg7gs.MsgUpdateGroupMetadata
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyAdmin",
        $lg7gs.MsgUpdateGroupPolicyAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy",
        $lg7gs.MsgUpdateGroupPolicyDecisionPolicy
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyMetadata",
        $lg7gs.MsgUpdateGroupPolicyMetadata
    ],
    [
        "/cosmos.group.v1.MsgVote",
        $lg7gs.MsgVote
    ],
    [
        "/cosmos.group.v1.MsgWithdrawProposal",
        $lg7gs.MsgWithdrawProposal
    ]
]; // There are no EncodeObject implementations for the new v1 message types because
 // those things don't scale (https://github.com/cosmos/cosmjs/issues/1440). We need to
 // address this more fundamentally. Users can use
 // const msg = {
 //   typeUrl: "/cosmos.group.v1.MsgCreateGroup",
 //   value: MsgCreateGroup.fromPartial({ ... })
 // }
 // in their app.

});
parcelRegister("lg7gs", function(module, exports) {
"use strict";
var $f7a0ba29e7b29011$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f7a0ba29e7b29011$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f7a0ba29e7b29011$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f7a0ba29e7b29011$var$__createBinding(result, mod, k);
    }
    $f7a0ba29e7b29011$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgLeaveGroupResponse = module.exports.MsgLeaveGroup = module.exports.MsgExecResponse = module.exports.MsgExec = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgWithdrawProposalResponse = module.exports.MsgWithdrawProposal = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.MsgUpdateGroupPolicyMetadataResponse = module.exports.MsgUpdateGroupPolicyMetadata = module.exports.MsgUpdateGroupPolicyDecisionPolicyResponse = module.exports.MsgUpdateGroupPolicyDecisionPolicy = module.exports.MsgCreateGroupWithPolicyResponse = module.exports.MsgCreateGroupWithPolicy = module.exports.MsgUpdateGroupPolicyAdminResponse = module.exports.MsgUpdateGroupPolicyAdmin = module.exports.MsgCreateGroupPolicyResponse = module.exports.MsgCreateGroupPolicy = module.exports.MsgUpdateGroupMetadataResponse = module.exports.MsgUpdateGroupMetadata = module.exports.MsgUpdateGroupAdminResponse = module.exports.MsgUpdateGroupAdmin = module.exports.MsgUpdateGroupMembersResponse = module.exports.MsgUpdateGroupMembers = module.exports.MsgCreateGroupResponse = module.exports.MsgCreateGroup = module.exports.execToJSON = module.exports.execFromJSON = module.exports.Exec = module.exports.protobufPackage = void 0;

var $iRJfk = parcelRequire("iRJfk");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $f7a0ba29e7b29011$var$_m0 = $f7a0ba29e7b29011$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.group.v1";
/** Exec defines modes of execution of a proposal on creation or on new vote. */ var $f7a0ba29e7b29011$var$Exec;
(function(Exec) {
    /**
     * EXEC_UNSPECIFIED - An empty value means that there should be a separate
     * MsgExec request for the proposal to execute.
     */ Exec[Exec["EXEC_UNSPECIFIED"] = 0] = "EXEC_UNSPECIFIED";
    /**
     * EXEC_TRY - Try to execute the proposal immediately.
     * If the proposal is not allowed per the DecisionPolicy,
     * the proposal will still be open and could
     * be executed at a later point.
     */ Exec[Exec["EXEC_TRY"] = 1] = "EXEC_TRY";
    Exec[Exec["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($f7a0ba29e7b29011$var$Exec = module.exports.Exec || (module.exports.Exec = {}));
function $f7a0ba29e7b29011$var$execFromJSON(object) {
    switch(object){
        case 0:
        case "EXEC_UNSPECIFIED":
            return $f7a0ba29e7b29011$var$Exec.EXEC_UNSPECIFIED;
        case 1:
        case "EXEC_TRY":
            return $f7a0ba29e7b29011$var$Exec.EXEC_TRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $f7a0ba29e7b29011$var$Exec.UNRECOGNIZED;
    }
}
module.exports.execFromJSON = $f7a0ba29e7b29011$var$execFromJSON;
function $f7a0ba29e7b29011$var$execToJSON(object) {
    switch(object){
        case $f7a0ba29e7b29011$var$Exec.EXEC_UNSPECIFIED:
            return "EXEC_UNSPECIFIED";
        case $f7a0ba29e7b29011$var$Exec.EXEC_TRY:
            return "EXEC_TRY";
        case $f7a0ba29e7b29011$var$Exec.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.execToJSON = $f7a0ba29e7b29011$var$execToJSON;
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroup() {
    return {
        admin: "",
        members: [],
        metadata: ""
    };
}
module.exports.MsgCreateGroup = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$iRJfk.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($iRJfk.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$iRJfk.MemberRequest.fromJSON(e)) : [],
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $iRJfk.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroup();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$iRJfk.MemberRequest.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroupResponse() {
    return {
        groupId: $dkaBG.Long.UZERO
    };
}
module.exports.MsgCreateGroupResponse = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembers() {
    return {
        admin: "",
        groupId: $dkaBG.Long.UZERO,
        memberUpdates: []
    };
}
module.exports.MsgUpdateGroupMembers = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        for (const v of message.memberUpdates)$iRJfk.MemberRequest.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembers();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.memberUpdates.push($iRJfk.MemberRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            memberUpdates: Array.isArray(object?.memberUpdates) ? object.memberUpdates.map((e)=>$iRJfk.MemberRequest.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        if (message.memberUpdates) obj.memberUpdates = message.memberUpdates.map((e)=>e ? $iRJfk.MemberRequest.toJSON(e) : undefined);
        else obj.memberUpdates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembers();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.memberUpdates = object.memberUpdates?.map((e)=>$iRJfk.MemberRequest.fromPartial(e)) || [];
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembersResponse() {
    return {};
}
module.exports.MsgUpdateGroupMembersResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMembersResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdmin() {
    return {
        admin: "",
        groupId: $dkaBG.Long.UZERO,
        newAdmin: ""
    };
}
module.exports.MsgUpdateGroupAdmin = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            newAdmin: (0, $dkaBG.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdmin();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdminResponse() {
    return {};
}
module.exports.MsgUpdateGroupAdminResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupAdminResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadata() {
    return {
        admin: "",
        groupId: $dkaBG.Long.UZERO,
        metadata: ""
    };
}
module.exports.MsgUpdateGroupMetadata = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadata();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadataResponse() {
    return {};
}
module.exports.MsgUpdateGroupMetadataResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupMetadataResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicy() {
    return {
        admin: "",
        groupId: $dkaBG.Long.UZERO,
        metadata: "",
        decisionPolicy: undefined
    };
}
module.exports.MsgCreateGroupPolicy = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.decisionPolicy !== undefined) $axIO3.Any.encode(message.decisionPolicy, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.decisionPolicy = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            decisionPolicy: (0, $dkaBG.isSet)(object.decisionPolicy) ? $axIO3.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $axIO3.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicy();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.metadata = object.metadata ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $axIO3.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicyResponse() {
    return {
        address: ""
    };
}
module.exports.MsgCreateGroupPolicyResponse = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupPolicyResponse();
        message.address = object.address ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdmin() {
    return {
        admin: "",
        groupPolicyAddress: "",
        newAdmin: ""
    };
}
module.exports.MsgUpdateGroupPolicyAdmin = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            newAdmin: (0, $dkaBG.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdmin();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdminResponse() {
    return {};
}
module.exports.MsgUpdateGroupPolicyAdminResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicy() {
    return {
        admin: "",
        members: [],
        groupMetadata: "",
        groupPolicyMetadata: "",
        groupPolicyAsAdmin: false,
        decisionPolicy: undefined
    };
}
module.exports.MsgCreateGroupWithPolicy = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$iRJfk.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.groupMetadata !== "") writer.uint32(26).string(message.groupMetadata);
        if (message.groupPolicyMetadata !== "") writer.uint32(34).string(message.groupPolicyMetadata);
        if (message.groupPolicyAsAdmin === true) writer.uint32(40).bool(message.groupPolicyAsAdmin);
        if (message.decisionPolicy !== undefined) $axIO3.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($iRJfk.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.groupMetadata = reader.string();
                    break;
                case 4:
                    message.groupPolicyMetadata = reader.string();
                    break;
                case 5:
                    message.groupPolicyAsAdmin = reader.bool();
                    break;
                case 6:
                    message.decisionPolicy = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$iRJfk.MemberRequest.fromJSON(e)) : [],
            groupMetadata: (0, $dkaBG.isSet)(object.groupMetadata) ? String(object.groupMetadata) : "",
            groupPolicyMetadata: (0, $dkaBG.isSet)(object.groupPolicyMetadata) ? String(object.groupPolicyMetadata) : "",
            groupPolicyAsAdmin: (0, $dkaBG.isSet)(object.groupPolicyAsAdmin) ? Boolean(object.groupPolicyAsAdmin) : false,
            decisionPolicy: (0, $dkaBG.isSet)(object.decisionPolicy) ? $axIO3.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $iRJfk.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.groupMetadata !== undefined && (obj.groupMetadata = message.groupMetadata);
        message.groupPolicyMetadata !== undefined && (obj.groupPolicyMetadata = message.groupPolicyMetadata);
        message.groupPolicyAsAdmin !== undefined && (obj.groupPolicyAsAdmin = message.groupPolicyAsAdmin);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $axIO3.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicy();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$iRJfk.MemberRequest.fromPartial(e)) || [];
        message.groupMetadata = object.groupMetadata ?? "";
        message.groupPolicyMetadata = object.groupPolicyMetadata ?? "";
        message.groupPolicyAsAdmin = object.groupPolicyAsAdmin ?? false;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $axIO3.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicyResponse() {
    return {
        groupId: $dkaBG.Long.UZERO,
        groupPolicyAddress: ""
    };
}
module.exports.MsgCreateGroupWithPolicyResponse = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgCreateGroupWithPolicyResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicy() {
    return {
        admin: "",
        groupPolicyAddress: "",
        decisionPolicy: undefined
    };
}
module.exports.MsgUpdateGroupPolicyDecisionPolicy = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.decisionPolicy !== undefined) $axIO3.Any.encode(message.decisionPolicy, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.decisionPolicy = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            decisionPolicy: (0, $dkaBG.isSet)(object.decisionPolicy) ? $axIO3.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $axIO3.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $axIO3.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse() {
    return {};
}
module.exports.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadata() {
    return {
        admin: "",
        groupPolicyAddress: "",
        metadata: ""
    };
}
module.exports.MsgUpdateGroupPolicyMetadata = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadata();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadataResponse() {
    return {};
}
module.exports.MsgUpdateGroupPolicyMetadataResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgSubmitProposal() {
    return {
        groupPolicyAddress: "",
        proposers: [],
        metadata: "",
        messages: [],
        exec: 0,
        title: "",
        summary: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.groupPolicyAddress !== "") writer.uint32(10).string(message.groupPolicyAddress);
        for (const v of message.proposers)writer.uint32(18).string(v);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.messages)$axIO3.Any.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        if (message.title !== "") writer.uint32(50).string(message.title);
        if (message.summary !== "") writer.uint32(58).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 2:
                    message.proposers.push(reader.string());
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.messages.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            exec: (0, $dkaBG.isSet)(object.exec) ? $f7a0ba29e7b29011$var$execFromJSON(object.exec) : 0,
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $dkaBG.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.exec !== undefined && (obj.exec = $f7a0ba29e7b29011$var$execToJSON(message.exec));
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgSubmitProposal();
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.metadata = object.metadata ?? "";
        message.messages = object.messages?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.exec = object.exec ?? 0;
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $dkaBG.Long.UZERO
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposal() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        address: ""
    };
}
module.exports.MsgWithdrawProposal = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.address = object.address ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposalResponse() {
    return {};
}
module.exports.MsgWithdrawProposalResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgWithdrawProposalResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        exec: 0
    };
}
module.exports.MsgVote = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $dkaBG.isSet)(object.option) ? (0, $iRJfk.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            exec: (0, $dkaBG.isSet)(object.exec) ? $f7a0ba29e7b29011$var$execFromJSON(object.exec) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $iRJfk.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.exec !== undefined && (obj.exec = $f7a0ba29e7b29011$var$execToJSON(message.exec));
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.exec = object.exec ?? 0;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgExec() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        executor: ""
    };
}
module.exports.MsgExec = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.executor !== "") writer.uint32(18).string(message.executor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            executor: (0, $dkaBG.isSet)(object.executor) ? String(object.executor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgExec();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.executor = object.executor ?? "";
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgExecResponse() {
    return {
        result: 0
    };
}
module.exports.MsgExecResponse = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(16).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? (0, $iRJfk.proposalExecutorResultFromJSON)(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = (0, $iRJfk.proposalExecutorResultToJSON)(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgExecResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgLeaveGroup() {
    return {
        address: "",
        groupId: $dkaBG.Long.UZERO
    };
}
module.exports.MsgLeaveGroup = {
    encode (message, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgLeaveGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgLeaveGroup();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $f7a0ba29e7b29011$var$createBaseMsgLeaveGroupResponse() {
    return {};
}
module.exports.MsgLeaveGroupResponse = {
    encode (_, writer = $f7a0ba29e7b29011$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f7a0ba29e7b29011$var$_m0.Reader ? input : new $f7a0ba29e7b29011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f7a0ba29e7b29011$var$createBaseMsgLeaveGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f7a0ba29e7b29011$var$createBaseMsgLeaveGroupResponse();
        return message;
    }
};
class $f7a0ba29e7b29011$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this);
        this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this);
        this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this);
        this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this);
        this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this);
        this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this);
        this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this);
        this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this);
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.WithdrawProposal = this.WithdrawProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Exec = this.Exec.bind(this);
        this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(request) {
        const data = module.exports.MsgCreateGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", data);
        return promise.then((data)=>module.exports.MsgCreateGroupResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupMembers(request) {
        const data = module.exports.MsgUpdateGroupMembers.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupMembersResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupAdmin(request) {
        const data = module.exports.MsgUpdateGroupAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupAdminResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupMetadata(request) {
        const data = module.exports.MsgUpdateGroupMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupMetadataResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    CreateGroupPolicy(request) {
        const data = module.exports.MsgCreateGroupPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", data);
        return promise.then((data)=>module.exports.MsgCreateGroupPolicyResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    CreateGroupWithPolicy(request) {
        const data = module.exports.MsgCreateGroupWithPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", data);
        return promise.then((data)=>module.exports.MsgCreateGroupWithPolicyResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyAdmin(request) {
        const data = module.exports.MsgUpdateGroupPolicyAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupPolicyAdminResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyDecisionPolicy(request) {
        const data = module.exports.MsgUpdateGroupPolicyDecisionPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyMetadata(request) {
        const data = module.exports.MsgUpdateGroupPolicyMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", data);
        return promise.then((data)=>module.exports.MsgUpdateGroupPolicyMetadataResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    SubmitProposal(request) {
        const data = module.exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>module.exports.MsgSubmitProposalResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    WithdrawProposal(request) {
        const data = module.exports.MsgWithdrawProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", data);
        return promise.then((data)=>module.exports.MsgWithdrawProposalResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = module.exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Vote", data);
        return promise.then((data)=>module.exports.MsgVoteResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = module.exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Exec", data);
        return promise.then((data)=>module.exports.MsgExecResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
    LeaveGroup(request) {
        const data = module.exports.MsgLeaveGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", data);
        return promise.then((data)=>module.exports.MsgLeaveGroupResponse.decode(new $f7a0ba29e7b29011$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $f7a0ba29e7b29011$var$MsgClientImpl;

});
parcelRegister("iRJfk", function(module, exports) {
"use strict";
var $dbc046310790b011$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dbc046310790b011$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dbc046310790b011$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dbc046310790b011$var$__createBinding(result, mod, k);
    }
    $dbc046310790b011$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.GroupPolicyInfo = module.exports.GroupMember = module.exports.GroupInfo = module.exports.DecisionPolicyWindows = module.exports.PercentageDecisionPolicy = module.exports.ThresholdDecisionPolicy = module.exports.MemberRequest = module.exports.Member = module.exports.proposalExecutorResultToJSON = module.exports.proposalExecutorResultFromJSON = module.exports.ProposalExecutorResult = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

var $cPgyI = parcelRequire("cPgyI");

var $jBPGv = parcelRequire("jBPGv");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $dbc046310790b011$var$_m0 = $dbc046310790b011$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.group.v1";
/** VoteOption enumerates the valid vote options for a given proposal. */ var $dbc046310790b011$var$VoteOption;
(function(VoteOption) {
    /**
     * VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines an unspecified vote option which will
     * return an error.
     */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($dbc046310790b011$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $dbc046310790b011$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $dbc046310790b011$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $dbc046310790b011$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $dbc046310790b011$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $dbc046310790b011$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $dbc046310790b011$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $dbc046310790b011$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $dbc046310790b011$var$voteOptionFromJSON;
function $dbc046310790b011$var$voteOptionToJSON(object) {
    switch(object){
        case $dbc046310790b011$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $dbc046310790b011$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $dbc046310790b011$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $dbc046310790b011$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $dbc046310790b011$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $dbc046310790b011$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteOptionToJSON = $dbc046310790b011$var$voteOptionToJSON;
/** ProposalStatus defines proposal statuses. */ var $dbc046310790b011$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - An empty value is invalid and not allowed. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /** PROPOSAL_STATUS_SUBMITTED - Initial status of a proposal when submitted. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_SUBMITTED"] = 1] = "PROPOSAL_STATUS_SUBMITTED";
    /**
     * PROPOSAL_STATUS_ACCEPTED - Final status of a proposal when the final tally is done and the outcome
     * passes the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ACCEPTED"] = 2] = "PROPOSAL_STATUS_ACCEPTED";
    /**
     * PROPOSAL_STATUS_REJECTED - Final status of a proposal when the final tally is done and the outcome
     * is rejected by the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 3] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_ABORTED - Final status of a proposal when the group policy is modified before the
     * final tally.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ABORTED"] = 4] = "PROPOSAL_STATUS_ABORTED";
    /**
     * PROPOSAL_STATUS_WITHDRAWN - A proposal can be withdrawn before the voting start time by the owner.
     * When this happens the final status is Withdrawn.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_WITHDRAWN"] = 5] = "PROPOSAL_STATUS_WITHDRAWN";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($dbc046310790b011$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $dbc046310790b011$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_SUBMITTED":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED;
        case 2:
        case "PROPOSAL_STATUS_ACCEPTED":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED;
        case 3:
        case "PROPOSAL_STATUS_REJECTED":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 4:
        case "PROPOSAL_STATUS_ABORTED":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_ABORTED;
        case 5:
        case "PROPOSAL_STATUS_WITHDRAWN":
            return $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $dbc046310790b011$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $dbc046310790b011$var$proposalStatusFromJSON;
function $dbc046310790b011$var$proposalStatusToJSON(object) {
    switch(object){
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED:
            return "PROPOSAL_STATUS_SUBMITTED";
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED:
            return "PROPOSAL_STATUS_ACCEPTED";
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_ABORTED:
            return "PROPOSAL_STATUS_ABORTED";
        case $dbc046310790b011$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN:
            return "PROPOSAL_STATUS_WITHDRAWN";
        case $dbc046310790b011$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalStatusToJSON = $dbc046310790b011$var$proposalStatusToJSON;
/** ProposalExecutorResult defines types of proposal executor results. */ var $dbc046310790b011$var$ProposalExecutorResult;
(function(ProposalExecutorResult) {
    /** PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED - An empty value is not allowed. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED"] = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
    /** PROPOSAL_EXECUTOR_RESULT_NOT_RUN - We have not yet run the executor. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_NOT_RUN"] = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
    /** PROPOSAL_EXECUTOR_RESULT_SUCCESS - The executor was successful and proposed action updated state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_SUCCESS"] = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
    /** PROPOSAL_EXECUTOR_RESULT_FAILURE - The executor returned an error and proposed action didn't update state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_FAILURE"] = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE";
    ProposalExecutorResult[ProposalExecutorResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($dbc046310790b011$var$ProposalExecutorResult = module.exports.ProposalExecutorResult || (module.exports.ProposalExecutorResult = {}));
function $dbc046310790b011$var$proposalExecutorResultFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
            return $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
        case 1:
        case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
            return $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
        case 2:
        case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
            return $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
        case 3:
        case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
            return $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $dbc046310790b011$var$ProposalExecutorResult.UNRECOGNIZED;
    }
}
module.exports.proposalExecutorResultFromJSON = $dbc046310790b011$var$proposalExecutorResultFromJSON;
function $dbc046310790b011$var$proposalExecutorResultToJSON(object) {
    switch(object){
        case $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
            return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
        case $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
            return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
        case $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
            return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
        case $dbc046310790b011$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE:
            return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
        case $dbc046310790b011$var$ProposalExecutorResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalExecutorResultToJSON = $dbc046310790b011$var$proposalExecutorResultToJSON;
function $dbc046310790b011$var$createBaseMember() {
    return {
        address: "",
        weight: "",
        metadata: "",
        addedAt: undefined
    };
}
module.exports.Member = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.addedAt !== undefined) $cPgyI.Timestamp.encode(message.addedAt, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.addedAt = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $dkaBG.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            addedAt: (0, $dkaBG.isSet)(object.addedAt) ? (0, $dkaBG.fromJsonTimestamp)(object.addedAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.addedAt !== undefined && (obj.addedAt = (0, $dkaBG.fromTimestamp)(message.addedAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseMember();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        message.addedAt = object.addedAt !== undefined && object.addedAt !== null ? $cPgyI.Timestamp.fromPartial(object.addedAt) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseMemberRequest() {
    return {
        address: "",
        weight: "",
        metadata: ""
    };
}
module.exports.MemberRequest = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseMemberRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $dkaBG.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseMemberRequest();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $dbc046310790b011$var$createBaseThresholdDecisionPolicy() {
    return {
        threshold: "",
        windows: undefined
    };
}
module.exports.ThresholdDecisionPolicy = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.threshold !== "") writer.uint32(10).string(message.threshold);
        if (message.windows !== undefined) module.exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseThresholdDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.string();
                    break;
                case 2:
                    message.windows = module.exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $dkaBG.isSet)(object.threshold) ? String(object.threshold) : "",
            windows: (0, $dkaBG.isSet)(object.windows) ? module.exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.windows !== undefined && (obj.windows = message.windows ? module.exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseThresholdDecisionPolicy();
        message.threshold = object.threshold ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? module.exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBasePercentageDecisionPolicy() {
    return {
        percentage: "",
        windows: undefined
    };
}
module.exports.PercentageDecisionPolicy = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.percentage !== "") writer.uint32(10).string(message.percentage);
        if (message.windows !== undefined) module.exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBasePercentageDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.percentage = reader.string();
                    break;
                case 2:
                    message.windows = module.exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            percentage: (0, $dkaBG.isSet)(object.percentage) ? String(object.percentage) : "",
            windows: (0, $dkaBG.isSet)(object.windows) ? module.exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.percentage !== undefined && (obj.percentage = message.percentage);
        message.windows !== undefined && (obj.windows = message.windows ? module.exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBasePercentageDecisionPolicy();
        message.percentage = object.percentage ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? module.exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseDecisionPolicyWindows() {
    return {
        votingPeriod: undefined,
        minExecutionPeriod: undefined
    };
}
module.exports.DecisionPolicyWindows = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $jBPGv.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        if (message.minExecutionPeriod !== undefined) $jBPGv.Duration.encode(message.minExecutionPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseDecisionPolicyWindows();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.minExecutionPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $dkaBG.isSet)(object.votingPeriod) ? $jBPGv.Duration.fromJSON(object.votingPeriod) : undefined,
            minExecutionPeriod: (0, $dkaBG.isSet)(object.minExecutionPeriod) ? $jBPGv.Duration.fromJSON(object.minExecutionPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $jBPGv.Duration.toJSON(message.votingPeriod) : undefined);
        message.minExecutionPeriod !== undefined && (obj.minExecutionPeriod = message.minExecutionPeriod ? $jBPGv.Duration.toJSON(message.minExecutionPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseDecisionPolicyWindows();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $jBPGv.Duration.fromPartial(object.votingPeriod) : undefined;
        message.minExecutionPeriod = object.minExecutionPeriod !== undefined && object.minExecutionPeriod !== null ? $jBPGv.Duration.fromPartial(object.minExecutionPeriod) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseGroupInfo() {
    return {
        id: $dkaBG.Long.UZERO,
        admin: "",
        metadata: "",
        version: $dkaBG.Long.UZERO,
        totalWeight: "",
        createdAt: undefined
    };
}
module.exports.GroupInfo = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(32).uint64(message.version);
        if (message.totalWeight !== "") writer.uint32(42).string(message.totalWeight);
        if (message.createdAt !== undefined) $cPgyI.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseGroupInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.version = reader.uint64();
                    break;
                case 5:
                    message.totalWeight = reader.string();
                    break;
                case 6:
                    message.createdAt = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $dkaBG.isSet)(object.id) ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO,
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $dkaBG.isSet)(object.version) ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO,
            totalWeight: (0, $dkaBG.isSet)(object.totalWeight) ? String(object.totalWeight) : "",
            createdAt: (0, $dkaBG.isSet)(object.createdAt) ? (0, $dkaBG.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $dkaBG.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $dkaBG.Long.UZERO).toString());
        message.totalWeight !== undefined && (obj.totalWeight = message.totalWeight);
        message.createdAt !== undefined && (obj.createdAt = (0, $dkaBG.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseGroupInfo();
        message.id = object.id !== undefined && object.id !== null ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO;
        message.totalWeight = object.totalWeight ?? "";
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $cPgyI.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseGroupMember() {
    return {
        groupId: $dkaBG.Long.UZERO,
        member: undefined
    };
}
module.exports.GroupMember = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.member !== undefined) module.exports.Member.encode(message.member, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseGroupMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.member = module.exports.Member.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            member: (0, $dkaBG.isSet)(object.member) ? module.exports.Member.fromJSON(object.member) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.member !== undefined && (obj.member = message.member ? module.exports.Member.toJSON(message.member) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseGroupMember();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.member = object.member !== undefined && object.member !== null ? module.exports.Member.fromPartial(object.member) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseGroupPolicyInfo() {
    return {
        address: "",
        groupId: $dkaBG.Long.UZERO,
        admin: "",
        metadata: "",
        version: $dkaBG.Long.UZERO,
        decisionPolicy: undefined,
        createdAt: undefined
    };
}
module.exports.GroupPolicyInfo = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(40).uint64(message.version);
        if (message.decisionPolicy !== undefined) $axIO3.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        if (message.createdAt !== undefined) $cPgyI.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseGroupPolicyInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.version = reader.uint64();
                    break;
                case 6:
                    message.decisionPolicy = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.createdAt = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $dkaBG.isSet)(object.groupId) ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO,
            admin: (0, $dkaBG.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $dkaBG.isSet)(object.version) ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO,
            decisionPolicy: (0, $dkaBG.isSet)(object.decisionPolicy) ? $axIO3.Any.fromJSON(object.decisionPolicy) : undefined,
            createdAt: (0, $dkaBG.isSet)(object.createdAt) ? (0, $dkaBG.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $dkaBG.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $dkaBG.Long.UZERO).toString());
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $axIO3.Any.toJSON(message.decisionPolicy) : undefined);
        message.createdAt !== undefined && (obj.createdAt = (0, $dkaBG.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseGroupPolicyInfo();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $dkaBG.Long.fromValue(object.groupId) : $dkaBG.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $axIO3.Any.fromPartial(object.decisionPolicy) : undefined;
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $cPgyI.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $dbc046310790b011$var$createBaseProposal() {
    return {
        id: $dkaBG.Long.UZERO,
        groupPolicyAddress: "",
        metadata: "",
        proposers: [],
        submitTime: undefined,
        groupVersion: $dkaBG.Long.UZERO,
        groupPolicyVersion: $dkaBG.Long.UZERO,
        status: 0,
        finalTallyResult: undefined,
        votingPeriodEnd: undefined,
        executorResult: 0,
        messages: [],
        title: "",
        summary: ""
    };
}
module.exports.Proposal = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.proposers)writer.uint32(34).string(v);
        if (message.submitTime !== undefined) $cPgyI.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (!message.groupVersion.isZero()) writer.uint32(48).uint64(message.groupVersion);
        if (!message.groupPolicyVersion.isZero()) writer.uint32(56).uint64(message.groupPolicyVersion);
        if (message.status !== 0) writer.uint32(64).int32(message.status);
        if (message.finalTallyResult !== undefined) module.exports.TallyResult.encode(message.finalTallyResult, writer.uint32(74).fork()).ldelim();
        if (message.votingPeriodEnd !== undefined) $cPgyI.Timestamp.encode(message.votingPeriodEnd, writer.uint32(82).fork()).ldelim();
        if (message.executorResult !== 0) writer.uint32(88).int32(message.executorResult);
        for (const v of message.messages)$axIO3.Any.encode(v, writer.uint32(98).fork()).ldelim();
        if (message.title !== "") writer.uint32(106).string(message.title);
        if (message.summary !== "") writer.uint32(114).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.proposers.push(reader.string());
                    break;
                case 5:
                    message.submitTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.groupVersion = reader.uint64();
                    break;
                case 7:
                    message.groupPolicyVersion = reader.uint64();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.finalTallyResult = module.exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.votingPeriodEnd = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.executorResult = reader.int32();
                    break;
                case 12:
                    message.messages.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.title = reader.string();
                    break;
                case 14:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $dkaBG.isSet)(object.id) ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO,
            groupPolicyAddress: (0, $dkaBG.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            submitTime: (0, $dkaBG.isSet)(object.submitTime) ? (0, $dkaBG.fromJsonTimestamp)(object.submitTime) : undefined,
            groupVersion: (0, $dkaBG.isSet)(object.groupVersion) ? $dkaBG.Long.fromValue(object.groupVersion) : $dkaBG.Long.UZERO,
            groupPolicyVersion: (0, $dkaBG.isSet)(object.groupPolicyVersion) ? $dkaBG.Long.fromValue(object.groupPolicyVersion) : $dkaBG.Long.UZERO,
            status: (0, $dkaBG.isSet)(object.status) ? $dbc046310790b011$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $dkaBG.isSet)(object.finalTallyResult) ? module.exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            votingPeriodEnd: (0, $dkaBG.isSet)(object.votingPeriodEnd) ? (0, $dkaBG.fromJsonTimestamp)(object.votingPeriodEnd) : undefined,
            executorResult: (0, $dkaBG.isSet)(object.executorResult) ? $dbc046310790b011$var$proposalExecutorResultFromJSON(object.executorResult) : 0,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$axIO3.Any.fromJSON(e)) : [],
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $dkaBG.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $dkaBG.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.submitTime !== undefined && (obj.submitTime = (0, $dkaBG.fromTimestamp)(message.submitTime).toISOString());
        message.groupVersion !== undefined && (obj.groupVersion = (message.groupVersion || $dkaBG.Long.UZERO).toString());
        message.groupPolicyVersion !== undefined && (obj.groupPolicyVersion = (message.groupPolicyVersion || $dkaBG.Long.UZERO).toString());
        message.status !== undefined && (obj.status = $dbc046310790b011$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? module.exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.votingPeriodEnd !== undefined && (obj.votingPeriodEnd = (0, $dkaBG.fromTimestamp)(message.votingPeriodEnd).toISOString());
        message.executorResult !== undefined && (obj.executorResult = $dbc046310790b011$var$proposalExecutorResultToJSON(message.executorResult));
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $dkaBG.Long.fromValue(object.id) : $dkaBG.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $cPgyI.Timestamp.fromPartial(object.submitTime) : undefined;
        message.groupVersion = object.groupVersion !== undefined && object.groupVersion !== null ? $dkaBG.Long.fromValue(object.groupVersion) : $dkaBG.Long.UZERO;
        message.groupPolicyVersion = object.groupPolicyVersion !== undefined && object.groupPolicyVersion !== null ? $dkaBG.Long.fromValue(object.groupPolicyVersion) : $dkaBG.Long.UZERO;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? module.exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.votingPeriodEnd = object.votingPeriodEnd !== undefined && object.votingPeriodEnd !== null ? $cPgyI.Timestamp.fromPartial(object.votingPeriodEnd) : undefined;
        message.executorResult = object.executorResult ?? 0;
        message.messages = object.messages?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $dbc046310790b011$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
module.exports.TallyResult = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $dkaBG.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $dkaBG.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $dkaBG.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $dkaBG.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $dbc046310790b011$var$createBaseVote() {
    return {
        proposalId: $dkaBG.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        submitTime: undefined
    };
}
module.exports.Vote = {
    encode (message, writer = $dbc046310790b011$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.submitTime !== undefined) $cPgyI.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dbc046310790b011$var$_m0.Reader ? input : new $dbc046310790b011$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dbc046310790b011$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.submitTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $dkaBG.isSet)(object.proposalId) ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO,
            voter: (0, $dkaBG.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $dkaBG.isSet)(object.option) ? $dbc046310790b011$var$voteOptionFromJSON(object.option) : 0,
            metadata: (0, $dkaBG.isSet)(object.metadata) ? String(object.metadata) : "",
            submitTime: (0, $dkaBG.isSet)(object.submitTime) ? (0, $dkaBG.fromJsonTimestamp)(object.submitTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $dkaBG.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $dbc046310790b011$var$voteOptionToJSON(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.submitTime !== undefined && (obj.submitTime = (0, $dkaBG.fromTimestamp)(message.submitTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $dbc046310790b011$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $dkaBG.Long.fromValue(object.proposalId) : $dkaBG.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $cPgyI.Timestamp.fromPartial(object.submitTime) : undefined;
        return message;
    }
};

});



parcelRegister("gKXS7", function(module, exports) {
"use strict";
var $c32f62813a234d38$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIbcAminoConverters = module.exports.isAminoMsgTransfer = void 0;

var $apYUm = parcelRequire("apYUm");

const $c32f62813a234d38$var$long_1 = $c32f62813a234d38$var$__importDefault((parcelRequire("3gmZQ")));
function $c32f62813a234d38$var$isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
module.exports.isAminoMsgTransfer = $c32f62813a234d38$var$isAminoMsgTransfer;
function $c32f62813a234d38$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($c32f62813a234d38$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function $c32f62813a234d38$var$createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort: sourcePort, sourceChannel: sourceChannel, token: token, sender: sender, receiver: receiver, timeoutHeight: timeoutHeight, timeoutTimestamp: timeoutTimestamp, memo: memo })=>({
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight ? {
                        revision_height: $c32f62813a234d38$var$omitDefault(timeoutHeight.revisionHeight)?.toString(),
                        revision_number: $c32f62813a234d38$var$omitDefault(timeoutHeight.revisionNumber)?.toString()
                    } : {},
                    timeout_timestamp: $c32f62813a234d38$var$omitDefault(timeoutTimestamp)?.toString(),
                    memo: $c32f62813a234d38$var$omitDefault(memo)?.toString()
                }),
            fromAmino: ({ source_port: source_port, source_channel: source_channel, token: token, sender: sender, receiver: receiver, timeout_height: timeout_height, timeout_timestamp: timeout_timestamp, memo: memo })=>$apYUm.MsgTransfer.fromPartial({
                    sourcePort: source_port,
                    sourceChannel: source_channel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeoutHeight: timeout_height ? {
                        revisionHeight: $c32f62813a234d38$var$long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: $c32f62813a234d38$var$long_1.default.fromString(timeout_height.revision_number || "0", true)
                    } : undefined,
                    timeoutTimestamp: $c32f62813a234d38$var$long_1.default.fromString(timeout_timestamp || "0", true),
                    memo: memo ?? ""
                })
        }
    };
}
module.exports.createIbcAminoConverters = $c32f62813a234d38$var$createIbcAminoConverters;

});
parcelRegister("apYUm", function(module, exports) {
"use strict";
var $795b7c4324930860$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $795b7c4324930860$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $795b7c4324930860$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $795b7c4324930860$var$__createBinding(result, mod, k);
    }
    $795b7c4324930860$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgTransferResponse = module.exports.MsgTransfer = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $h8Lhn = parcelRequire("h8Lhn");

var $dkaBG = parcelRequire("dkaBG");

const $795b7c4324930860$var$_m0 = $795b7c4324930860$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.applications.transfer.v1";
function $795b7c4324930860$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: $dkaBG.Long.UZERO,
        memo: ""
    };
}
module.exports.MsgTransfer = {
    encode (message, writer = $795b7c4324930860$var$_m0.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $efcGD.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $h8Lhn.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795b7c4324930860$var$_m0.Reader ? input : new $795b7c4324930860$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795b7c4324930860$var$createBaseMsgTransfer();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sourcePort: (0, $dkaBG.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $dkaBG.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: (0, $dkaBG.isSet)(object.token) ? $efcGD.Coin.fromJSON(object.token) : undefined,
            sender: (0, $dkaBG.isSet)(object.sender) ? String(object.sender) : "",
            receiver: (0, $dkaBG.isSet)(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: (0, $dkaBG.isSet)(object.timeoutHeight) ? $h8Lhn.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $dkaBG.isSet)(object.timeoutTimestamp) ? $dkaBG.Long.fromValue(object.timeoutTimestamp) : $dkaBG.Long.UZERO,
            memo: (0, $dkaBG.isSet)(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $efcGD.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $h8Lhn.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $dkaBG.Long.UZERO).toString());
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial (object) {
        const message = $795b7c4324930860$var$createBaseMsgTransfer();
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.token = object.token !== undefined && object.token !== null ? $efcGD.Coin.fromPartial(object.token) : undefined;
        message.sender = object.sender ?? "";
        message.receiver = object.receiver ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $h8Lhn.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $dkaBG.Long.fromValue(object.timeoutTimestamp) : $dkaBG.Long.UZERO;
        message.memo = object.memo ?? "";
        return message;
    }
};
function $795b7c4324930860$var$createBaseMsgTransferResponse() {
    return {
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.MsgTransferResponse = {
    encode (message, writer = $795b7c4324930860$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795b7c4324930860$var$_m0.Reader ? input : new $795b7c4324930860$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795b7c4324930860$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $795b7c4324930860$var$createBaseMsgTransferResponse();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
class $795b7c4324930860$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    Transfer(request) {
        const data = module.exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data)=>module.exports.MsgTransferResponse.decode(new $795b7c4324930860$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $795b7c4324930860$var$MsgClientImpl;

});
parcelRegister("h8Lhn", function(module, exports) {
"use strict";
var $c7a7dbb7040f6a2d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c7a7dbb7040f6a2d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c7a7dbb7040f6a2d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c7a7dbb7040f6a2d$var$__createBinding(result, mod, k);
    }
    $c7a7dbb7040f6a2d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Height = module.exports.UpgradeProposal = module.exports.ClientUpdateProposal = module.exports.ClientConsensusStates = module.exports.ConsensusStateWithHeight = module.exports.IdentifiedClientState = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $ax5iQ = parcelRequire("ax5iQ");

var $dkaBG = parcelRequire("dkaBG");

const $c7a7dbb7040f6a2d$var$_m0 = $c7a7dbb7040f6a2d$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.client.v1";
function $c7a7dbb7040f6a2d$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
module.exports.IdentifiedClientState = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseIdentifiedClientState();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
module.exports.ConsensusStateWithHeight = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (message.height !== undefined) module.exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = module.exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? module.exports.Height.fromJSON(object.height) : undefined,
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? module.exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? module.exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
module.exports.ClientConsensusStates = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)module.exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push(module.exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>module.exports.ConsensusStateWithHeight.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? module.exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseClientConsensusStates();
        message.clientId = object.clientId ?? "";
        message.consensusStates = object.consensusStates?.map((e)=>module.exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
module.exports.ClientUpdateProposal = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            subjectClientId: (0, $dkaBG.isSet)(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: (0, $dkaBG.isSet)(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseClientUpdateProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.subjectClientId = object.subjectClientId ?? "";
        message.substituteClientId = object.substituteClientId ?? "";
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
module.exports.UpgradeProposal = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $ax5iQ.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $axIO3.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $ax5iQ.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $dkaBG.isSet)(object.plan) ? $ax5iQ.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: (0, $dkaBG.isSet)(object.upgradedClientState) ? $axIO3.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $ax5iQ.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $axIO3.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? $ax5iQ.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $axIO3.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseHeight() {
    return {
        revisionNumber: $dkaBG.Long.UZERO,
        revisionHeight: $dkaBG.Long.UZERO
    };
}
module.exports.Height = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            revisionNumber: (0, $dkaBG.isSet)(object.revisionNumber) ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO,
            revisionHeight: (0, $dkaBG.isSet)(object.revisionHeight) ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $dkaBG.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseHeight();
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $c7a7dbb7040f6a2d$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
module.exports.Params = {
    encode (message, writer = $c7a7dbb7040f6a2d$var$_m0.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7a7dbb7040f6a2d$var$_m0.Reader ? input : new $c7a7dbb7040f6a2d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7a7dbb7040f6a2d$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowedClients: Array.isArray(object?.allowedClients) ? object.allowedClients.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c7a7dbb7040f6a2d$var$createBaseParams();
        message.allowedClients = object.allowedClients?.map((e)=>e) || [];
        return message;
    }
};

});
parcelRegister("ax5iQ", function(module, exports) {
"use strict";
var $7ab1197e28e310f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7ab1197e28e310f5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7ab1197e28e310f5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7ab1197e28e310f5$var$__createBinding(result, mod, k);
    }
    $7ab1197e28e310f5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleVersion = module.exports.CancelSoftwareUpgradeProposal = module.exports.SoftwareUpgradeProposal = module.exports.Plan = module.exports.protobufPackage = void 0;

var $cPgyI = parcelRequire("cPgyI");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $7ab1197e28e310f5$var$_m0 = $7ab1197e28e310f5$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $7ab1197e28e310f5$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: $dkaBG.Long.ZERO,
        info: "",
        upgradedClientState: undefined
    };
}
module.exports.Plan = {
    encode (message, writer = $7ab1197e28e310f5$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $axIO3.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ab1197e28e310f5$var$_m0.Reader ? input : new $7ab1197e28e310f5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ab1197e28e310f5$var$createBasePlan();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $dkaBG.isSet)(object.name) ? String(object.name) : "",
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            info: (0, $dkaBG.isSet)(object.info) ? String(object.info) : "",
            upgradedClientState: (0, $dkaBG.isSet)(object.upgradedClientState) ? $axIO3.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $axIO3.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7ab1197e28e310f5$var$createBasePlan();
        message.name = object.name ?? "";
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.info = object.info ?? "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $axIO3.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $7ab1197e28e310f5$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
module.exports.SoftwareUpgradeProposal = {
    encode (message, writer = $7ab1197e28e310f5$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) module.exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ab1197e28e310f5$var$_m0.Reader ? input : new $7ab1197e28e310f5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ab1197e28e310f5$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = module.exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $dkaBG.isSet)(object.plan) ? module.exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? module.exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7ab1197e28e310f5$var$createBaseSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? module.exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $7ab1197e28e310f5$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
module.exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $7ab1197e28e310f5$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ab1197e28e310f5$var$_m0.Reader ? input : new $7ab1197e28e310f5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ab1197e28e310f5$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $dkaBG.isSet)(object.title) ? String(object.title) : "",
            description: (0, $dkaBG.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $7ab1197e28e310f5$var$createBaseCancelSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $7ab1197e28e310f5$var$createBaseModuleVersion() {
    return {
        name: "",
        version: $dkaBG.Long.UZERO
    };
}
module.exports.ModuleVersion = {
    encode (message, writer = $7ab1197e28e310f5$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (!message.version.isZero()) writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7ab1197e28e310f5$var$_m0.Reader ? input : new $7ab1197e28e310f5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7ab1197e28e310f5$var$createBaseModuleVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $dkaBG.isSet)(object.name) ? String(object.name) : "",
            version: (0, $dkaBG.isSet)(object.version) ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7ab1197e28e310f5$var$createBaseModuleVersion();
        message.name = object.name ?? "";
        message.version = object.version !== undefined && object.version !== null ? $dkaBG.Long.fromValue(object.version) : $dkaBG.Long.UZERO;
        return message;
    }
};

});




parcelRegister("iZNYj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgTransferEncodeObject = module.exports.ibcTypes = void 0;

var $apYUm = parcelRequire("apYUm");

var $jtFBP = parcelRequire("jtFBP");

var $gGwnz = parcelRequire("gGwnz");

var $b3y8S = parcelRequire("b3y8S");
module.exports.ibcTypes = [
    [
        "/ibc.applications.transfer.v1.MsgTransfer",
        $apYUm.MsgTransfer
    ],
    [
        "/ibc.core.channel.v1.MsgAcknowledgement",
        $jtFBP.MsgAcknowledgement
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        $jtFBP.MsgChannelCloseConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseInit",
        $jtFBP.MsgChannelCloseInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenAck",
        $jtFBP.MsgChannelOpenAck
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        $jtFBP.MsgChannelOpenConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenInit",
        $jtFBP.MsgChannelOpenInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenTry",
        $jtFBP.MsgChannelOpenTry
    ],
    [
        "/ibc.core.channel.v1.MsgRecvPacket",
        $jtFBP.MsgRecvPacket
    ],
    [
        "/ibc.core.channel.v1.MsgTimeout",
        $jtFBP.MsgTimeout
    ],
    [
        "/ibc.core.channel.v1.MsgTimeoutOnClose",
        $jtFBP.MsgTimeoutOnClose
    ],
    [
        "/ibc.core.client.v1.MsgCreateClient",
        $gGwnz.MsgCreateClient
    ],
    [
        "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        $gGwnz.MsgSubmitMisbehaviour
    ],
    [
        "/ibc.core.client.v1.MsgUpdateClient",
        $gGwnz.MsgUpdateClient
    ],
    [
        "/ibc.core.client.v1.MsgUpgradeClient",
        $gGwnz.MsgUpgradeClient
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenAck",
        $b3y8S.MsgConnectionOpenAck
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        $b3y8S.MsgConnectionOpenConfirm
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenInit",
        $b3y8S.MsgConnectionOpenInit
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenTry",
        $b3y8S.MsgConnectionOpenTry
    ]
];
function $dd44afdbd70457c7$var$isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
module.exports.isMsgTransferEncodeObject = $dd44afdbd70457c7$var$isMsgTransferEncodeObject;

});
parcelRegister("jtFBP", function(module, exports) {
"use strict";
var $e2e100759ef6e408$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e2e100759ef6e408$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e2e100759ef6e408$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e2e100759ef6e408$var$__createBinding(result, mod, k);
    }
    $e2e100759ef6e408$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgAcknowledgementResponse = module.exports.MsgAcknowledgement = module.exports.MsgTimeoutOnCloseResponse = module.exports.MsgTimeoutOnClose = module.exports.MsgTimeoutResponse = module.exports.MsgTimeout = module.exports.MsgRecvPacketResponse = module.exports.MsgRecvPacket = module.exports.MsgChannelCloseConfirmResponse = module.exports.MsgChannelCloseConfirm = module.exports.MsgChannelCloseInitResponse = module.exports.MsgChannelCloseInit = module.exports.MsgChannelOpenConfirmResponse = module.exports.MsgChannelOpenConfirm = module.exports.MsgChannelOpenAckResponse = module.exports.MsgChannelOpenAck = module.exports.MsgChannelOpenTryResponse = module.exports.MsgChannelOpenTry = module.exports.MsgChannelOpenInitResponse = module.exports.MsgChannelOpenInit = module.exports.responseResultTypeToJSON = module.exports.responseResultTypeFromJSON = module.exports.ResponseResultType = module.exports.protobufPackage = void 0;

var $7Hmmy = parcelRequire("7Hmmy");

var $h8Lhn = parcelRequire("h8Lhn");

var $dkaBG = parcelRequire("dkaBG");

const $e2e100759ef6e408$var$_m0 = $e2e100759ef6e408$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */ var $e2e100759ef6e408$var$ResponseResultType;
(function(ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e2e100759ef6e408$var$ResponseResultType = module.exports.ResponseResultType || (module.exports.ResponseResultType = {}));
function $e2e100759ef6e408$var$responseResultTypeFromJSON(object) {
    switch(object){
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e2e100759ef6e408$var$ResponseResultType.UNRECOGNIZED;
    }
}
module.exports.responseResultTypeFromJSON = $e2e100759ef6e408$var$responseResultTypeFromJSON;
function $e2e100759ef6e408$var$responseResultTypeToJSON(object) {
    switch(object){
        case $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case $e2e100759ef6e408$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        case $e2e100759ef6e408$var$ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.responseResultTypeToJSON = $e2e100759ef6e408$var$responseResultTypeToJSON;
function $e2e100759ef6e408$var$createBaseMsgChannelOpenInit() {
    return {
        portId: "",
        channel: undefined,
        signer: ""
    };
}
module.exports.MsgChannelOpenInit = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $7Hmmy.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $7Hmmy.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channel: (0, $dkaBG.isSet)(object.channel) ? $7Hmmy.Channel.fromJSON(object.channel) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $7Hmmy.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenInit();
        message.portId = object.portId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $7Hmmy.Channel.fromPartial(object.channel) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenInitResponse() {
    return {
        channelId: "",
        version: ""
    };
}
module.exports.MsgChannelOpenInitResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.channelId !== "") writer.uint32(10).string(message.channelId);
        if (message.version !== "") writer.uint32(18).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channelId = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenInitResponse();
        message.channelId = object.channelId ?? "";
        message.version = object.version ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgChannelOpenTry = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $7Hmmy.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $7Hmmy.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            previousChannelId: (0, $dkaBG.isSet)(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: (0, $dkaBG.isSet)(object.channel) ? $7Hmmy.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: (0, $dkaBG.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: (0, $dkaBG.isSet)(object.proofInit) ? (0, $dkaBG.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $7Hmmy.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = (0, $dkaBG.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenTry();
        message.portId = object.portId ?? "";
        message.previousChannelId = object.previousChannelId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $7Hmmy.Channel.fromPartial(object.channel) : undefined;
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenTryResponse() {
    return {
        version: ""
    };
}
module.exports.MsgChannelOpenTryResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenTryResponse();
        message.version = object.version ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgChannelOpenAck = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: (0, $dkaBG.isSet)(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: (0, $dkaBG.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: (0, $dkaBG.isSet)(object.proofTry) ? (0, $dkaBG.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = (0, $dkaBG.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenAck();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.counterpartyChannelId = object.counterpartyChannelId ?? "";
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenAckResponse() {
    return {};
}
module.exports.MsgChannelOpenAckResponse = {
    encode (_, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenAckResponse();
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirm() {
    return {
        portId: "",
        channelId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgChannelOpenConfirm = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            proofAck: (0, $dkaBG.isSet)(object.proofAck) ? (0, $dkaBG.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = (0, $dkaBG.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
module.exports.MsgChannelOpenConfirmResponse = {
    encode (_, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelOpenConfirmResponse();
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelCloseInit() {
    return {
        portId: "",
        channelId: "",
        signer: ""
    };
}
module.exports.MsgChannelCloseInit = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseInit();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelCloseInitResponse() {
    return {};
}
module.exports.MsgChannelCloseInitResponse = {
    encode (_, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseInitResponse();
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirm() {
    return {
        portId: "",
        channelId: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgChannelCloseConfirm = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            proofInit: (0, $dkaBG.isSet)(object.proofInit) ? (0, $dkaBG.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = (0, $dkaBG.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
module.exports.MsgChannelCloseConfirmResponse = {
    encode (_, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e2e100759ef6e408$var$createBaseMsgChannelCloseConfirmResponse();
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgRecvPacket() {
    return {
        packet: undefined,
        proofCommitment: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgRecvPacket = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $7Hmmy.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgRecvPacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $7Hmmy.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $dkaBG.isSet)(object.packet) ? $7Hmmy.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: (0, $dkaBG.isSet)(object.proofCommitment) ? (0, $dkaBG.bytesFromBase64)(object.proofCommitment) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $7Hmmy.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = (0, $dkaBG.base64FromBytes)(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgRecvPacket();
        message.packet = object.packet !== undefined && object.packet !== null ? $7Hmmy.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = object.proofCommitment ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgRecvPacketResponse() {
    return {
        result: 0
    };
}
module.exports.MsgRecvPacketResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgRecvPacketResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $e2e100759ef6e408$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $e2e100759ef6e408$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgRecvPacketResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $dkaBG.Long.UZERO,
        signer: ""
    };
}
module.exports.MsgTimeout = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $7Hmmy.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgTimeout();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $7Hmmy.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $dkaBG.isSet)(object.packet) ? $7Hmmy.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $dkaBG.isSet)(object.proofUnreceived) ? (0, $dkaBG.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $dkaBG.isSet)(object.nextSequenceRecv) ? $dkaBG.Long.fromValue(object.nextSequenceRecv) : $dkaBG.Long.UZERO,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $7Hmmy.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $dkaBG.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $dkaBG.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgTimeout();
        message.packet = object.packet !== undefined && object.packet !== null ? $7Hmmy.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $dkaBG.Long.fromValue(object.nextSequenceRecv) : $dkaBG.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgTimeoutResponse() {
    return {
        result: 0
    };
}
module.exports.MsgTimeoutResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $e2e100759ef6e408$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $e2e100759ef6e408$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $dkaBG.Long.UZERO,
        signer: ""
    };
}
module.exports.MsgTimeoutOnClose = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $7Hmmy.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutOnClose();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $7Hmmy.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $dkaBG.isSet)(object.packet) ? $7Hmmy.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $dkaBG.isSet)(object.proofUnreceived) ? (0, $dkaBG.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofClose: (0, $dkaBG.isSet)(object.proofClose) ? (0, $dkaBG.bytesFromBase64)(object.proofClose) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $dkaBG.isSet)(object.nextSequenceRecv) ? $dkaBG.Long.fromValue(object.nextSequenceRecv) : $dkaBG.Long.UZERO,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $7Hmmy.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $dkaBG.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = (0, $dkaBG.base64FromBytes)(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $dkaBG.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutOnClose();
        message.packet = object.packet !== undefined && object.packet !== null ? $7Hmmy.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofClose = object.proofClose ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $dkaBG.Long.fromValue(object.nextSequenceRecv) : $dkaBG.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgTimeoutOnCloseResponse() {
    return {
        result: 0
    };
}
module.exports.MsgTimeoutOnCloseResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutOnCloseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $e2e100759ef6e408$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $e2e100759ef6e408$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgTimeoutOnCloseResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgAcknowledgement = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $7Hmmy.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $7Hmmy.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $dkaBG.isSet)(object.packet) ? $7Hmmy.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: (0, $dkaBG.isSet)(object.acknowledgement) ? (0, $dkaBG.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proofAcked: (0, $dkaBG.isSet)(object.proofAcked) ? (0, $dkaBG.bytesFromBase64)(object.proofAcked) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $7Hmmy.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $dkaBG.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = (0, $dkaBG.base64FromBytes)(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgAcknowledgement();
        message.packet = object.packet !== undefined && object.packet !== null ? $7Hmmy.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proofAcked = object.proofAcked ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $e2e100759ef6e408$var$createBaseMsgAcknowledgementResponse() {
    return {
        result: 0
    };
}
module.exports.MsgAcknowledgementResponse = {
    encode (message, writer = $e2e100759ef6e408$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2e100759ef6e408$var$_m0.Reader ? input : new $e2e100759ef6e408$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2e100759ef6e408$var$createBaseMsgAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $e2e100759ef6e408$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $e2e100759ef6e408$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $e2e100759ef6e408$var$createBaseMsgAcknowledgementResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
class $e2e100759ef6e408$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(request) {
        const data = module.exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data)=>module.exports.MsgChannelOpenInitResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = module.exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data)=>module.exports.MsgChannelOpenTryResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = module.exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data)=>module.exports.MsgChannelOpenAckResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = module.exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data)=>module.exports.MsgChannelOpenConfirmResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = module.exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data)=>module.exports.MsgChannelCloseInitResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = module.exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data)=>module.exports.MsgChannelCloseConfirmResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    RecvPacket(request) {
        const data = module.exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data)=>module.exports.MsgRecvPacketResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    Timeout(request) {
        const data = module.exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data)=>module.exports.MsgTimeoutResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = module.exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data)=>module.exports.MsgTimeoutOnCloseResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
    Acknowledgement(request) {
        const data = module.exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data)=>module.exports.MsgAcknowledgementResponse.decode(new $e2e100759ef6e408$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $e2e100759ef6e408$var$MsgClientImpl;

});
parcelRegister("7Hmmy", function(module, exports) {
"use strict";
var $59ade55c4e2eddfb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59ade55c4e2eddfb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $59ade55c4e2eddfb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $59ade55c4e2eddfb$var$__createBinding(result, mod, k);
    }
    $59ade55c4e2eddfb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Acknowledgement = module.exports.PacketId = module.exports.PacketState = module.exports.Packet = module.exports.Counterparty = module.exports.IdentifiedChannel = module.exports.Channel = module.exports.orderToJSON = module.exports.orderFromJSON = module.exports.Order = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = module.exports.protobufPackage = void 0;

var $h8Lhn = parcelRequire("h8Lhn");

var $dkaBG = parcelRequire("dkaBG");

const $59ade55c4e2eddfb$var$_m0 = $59ade55c4e2eddfb$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $59ade55c4e2eddfb$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($59ade55c4e2eddfb$var$State = module.exports.State || (module.exports.State = {}));
function $59ade55c4e2eddfb$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $59ade55c4e2eddfb$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $59ade55c4e2eddfb$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $59ade55c4e2eddfb$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $59ade55c4e2eddfb$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $59ade55c4e2eddfb$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $59ade55c4e2eddfb$var$State.UNRECOGNIZED;
    }
}
module.exports.stateFromJSON = $59ade55c4e2eddfb$var$stateFromJSON;
function $59ade55c4e2eddfb$var$stateToJSON(object) {
    switch(object){
        case $59ade55c4e2eddfb$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $59ade55c4e2eddfb$var$State.STATE_INIT:
            return "STATE_INIT";
        case $59ade55c4e2eddfb$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $59ade55c4e2eddfb$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $59ade55c4e2eddfb$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        case $59ade55c4e2eddfb$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.stateToJSON = $59ade55c4e2eddfb$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $59ade55c4e2eddfb$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($59ade55c4e2eddfb$var$Order = module.exports.Order || (module.exports.Order = {}));
function $59ade55c4e2eddfb$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $59ade55c4e2eddfb$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $59ade55c4e2eddfb$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $59ade55c4e2eddfb$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $59ade55c4e2eddfb$var$Order.UNRECOGNIZED;
    }
}
module.exports.orderFromJSON = $59ade55c4e2eddfb$var$orderFromJSON;
function $59ade55c4e2eddfb$var$orderToJSON(object) {
    switch(object){
        case $59ade55c4e2eddfb$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $59ade55c4e2eddfb$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $59ade55c4e2eddfb$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case $59ade55c4e2eddfb$var$Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.orderToJSON = $59ade55c4e2eddfb$var$orderToJSON;
function $59ade55c4e2eddfb$var$createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: ""
    };
}
module.exports.Channel = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBaseChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $dkaBG.isSet)(object.state) ? $59ade55c4e2eddfb$var$stateFromJSON(object.state) : 0,
            ordering: (0, $dkaBG.isSet)(object.ordering) ? $59ade55c4e2eddfb$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $59ade55c4e2eddfb$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $59ade55c4e2eddfb$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBaseChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: ""
    };
}
module.exports.IdentifiedChannel = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBaseIdentifiedChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $dkaBG.isSet)(object.state) ? $59ade55c4e2eddfb$var$stateFromJSON(object.state) : 0,
            ordering: (0, $dkaBG.isSet)(object.ordering) ? $59ade55c4e2eddfb$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : "",
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $59ade55c4e2eddfb$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $59ade55c4e2eddfb$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBaseIdentifiedChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBaseCounterparty() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.Counterparty = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBaseCounterparty();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBasePacket() {
    return {
        sequence: $dkaBG.Long.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: $dkaBG.Long.UZERO
    };
}
module.exports.Packet = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $h8Lhn.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBasePacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO,
            sourcePort: (0, $dkaBG.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $dkaBG.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: (0, $dkaBG.isSet)(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: (0, $dkaBG.isSet)(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            timeoutHeight: (0, $dkaBG.isSet)(object.timeoutHeight) ? $h8Lhn.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $dkaBG.isSet)(object.timeoutTimestamp) ? $dkaBG.Long.fromValue(object.timeoutTimestamp) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $h8Lhn.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBasePacket();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.destinationPort = object.destinationPort ?? "";
        message.destinationChannel = object.destinationChannel ?? "";
        message.data = object.data ?? new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $h8Lhn.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $dkaBG.Long.fromValue(object.timeoutTimestamp) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: $dkaBG.Long.UZERO,
        data: new Uint8Array()
    };
}
module.exports.PacketState = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBasePacketState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO,
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBasePacketState();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.PacketId = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBasePacketId();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBasePacketId();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $59ade55c4e2eddfb$var$createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined
    };
}
module.exports.Acknowledgement = {
    encode (message, writer = $59ade55c4e2eddfb$var$_m0.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $59ade55c4e2eddfb$var$_m0.Reader ? input : new $59ade55c4e2eddfb$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $59ade55c4e2eddfb$var$createBaseAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? (0, $dkaBG.bytesFromBase64)(object.result) : undefined,
            error: (0, $dkaBG.isSet)(object.error) ? String(object.error) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? (0, $dkaBG.base64FromBytes)(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $59ade55c4e2eddfb$var$createBaseAcknowledgement();
        message.result = object.result ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    }
};

});


parcelRegister("gGwnz", function(module, exports) {
"use strict";
var $c259af67dd2c4a4b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c259af67dd2c4a4b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c259af67dd2c4a4b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c259af67dd2c4a4b$var$__createBinding(result, mod, k);
    }
    $c259af67dd2c4a4b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgSubmitMisbehaviourResponse = module.exports.MsgSubmitMisbehaviour = module.exports.MsgUpgradeClientResponse = module.exports.MsgUpgradeClient = module.exports.MsgUpdateClientResponse = module.exports.MsgUpdateClient = module.exports.MsgCreateClientResponse = module.exports.MsgCreateClient = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

const $c259af67dd2c4a4b$var$_m0 = $c259af67dd2c4a4b$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "ibc.core.client.v1";
function $c259af67dd2c4a4b$var$createBaseMsgCreateClient() {
    return {
        clientState: undefined,
        consensusState: undefined,
        signer: ""
    };
}
module.exports.MsgCreateClient = {
    encode (message, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgCreateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgCreateClient();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgCreateClientResponse() {
    return {};
}
module.exports.MsgCreateClientResponse = {
    encode (_, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgCreateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgCreateClientResponse();
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgUpdateClient() {
    return {
        clientId: "",
        clientMessage: undefined,
        signer: ""
    };
}
module.exports.MsgUpdateClient = {
    encode (message, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientMessage !== undefined) $axIO3.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpdateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientMessage = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            clientMessage: (0, $dkaBG.isSet)(object.clientMessage) ? $axIO3.Any.fromJSON(object.clientMessage) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientMessage !== undefined && (obj.clientMessage = message.clientMessage ? $axIO3.Any.toJSON(message.clientMessage) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpdateClient();
        message.clientId = object.clientId ?? "";
        message.clientMessage = object.clientMessage !== undefined && object.clientMessage !== null ? $axIO3.Any.fromPartial(object.clientMessage) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgUpdateClientResponse() {
    return {};
}
module.exports.MsgUpdateClientResponse = {
    encode (_, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpdateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpdateClientResponse();
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: ""
    };
}
module.exports.MsgUpgradeClient = {
    encode (message, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpgradeClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: (0, $dkaBG.isSet)(object.proofUpgradeClient) ? (0, $dkaBG.bytesFromBase64)(object.proofUpgradeClient) : new Uint8Array(),
            proofUpgradeConsensusState: (0, $dkaBG.isSet)(object.proofUpgradeConsensusState) ? (0, $dkaBG.bytesFromBase64)(object.proofUpgradeConsensusState) : new Uint8Array(),
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = (0, $dkaBG.base64FromBytes)(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = (0, $dkaBG.base64FromBytes)(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpgradeClient();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        message.proofUpgradeClient = object.proofUpgradeClient ?? new Uint8Array();
        message.proofUpgradeConsensusState = object.proofUpgradeConsensusState ?? new Uint8Array();
        message.signer = object.signer ?? "";
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgUpgradeClientResponse() {
    return {};
}
module.exports.MsgUpgradeClientResponse = {
    encode (_, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpgradeClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgUpgradeClientResponse();
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviour() {
    return {
        clientId: "",
        misbehaviour: undefined,
        signer: ""
    };
}
module.exports.MsgSubmitMisbehaviour = {
    encode (message, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $axIO3.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            misbehaviour: (0, $dkaBG.isSet)(object.misbehaviour) ? $axIO3.Any.fromJSON(object.misbehaviour) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $axIO3.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $axIO3.Any.fromPartial(object.misbehaviour) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
module.exports.MsgSubmitMisbehaviourResponse = {
    encode (_, writer = $c259af67dd2c4a4b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c259af67dd2c4a4b$var$_m0.Reader ? input : new $c259af67dd2c4a4b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviourResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c259af67dd2c4a4b$var$createBaseMsgSubmitMisbehaviourResponse();
        return message;
    }
};
class $c259af67dd2c4a4b$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(request) {
        const data = module.exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data)=>module.exports.MsgCreateClientResponse.decode(new $c259af67dd2c4a4b$var$_m0.Reader(data)));
    }
    UpdateClient(request) {
        const data = module.exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data)=>module.exports.MsgUpdateClientResponse.decode(new $c259af67dd2c4a4b$var$_m0.Reader(data)));
    }
    UpgradeClient(request) {
        const data = module.exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data)=>module.exports.MsgUpgradeClientResponse.decode(new $c259af67dd2c4a4b$var$_m0.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = module.exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data)=>module.exports.MsgSubmitMisbehaviourResponse.decode(new $c259af67dd2c4a4b$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $c259af67dd2c4a4b$var$MsgClientImpl;

});

parcelRegister("b3y8S", function(module, exports) {
"use strict";
var $80ca756ded28efe0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $80ca756ded28efe0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $80ca756ded28efe0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $80ca756ded28efe0$var$__createBinding(result, mod, k);
    }
    $80ca756ded28efe0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgConnectionOpenConfirmResponse = module.exports.MsgConnectionOpenConfirm = module.exports.MsgConnectionOpenAckResponse = module.exports.MsgConnectionOpenAck = module.exports.MsgConnectionOpenTryResponse = module.exports.MsgConnectionOpenTry = module.exports.MsgConnectionOpenInitResponse = module.exports.MsgConnectionOpenInit = module.exports.protobufPackage = void 0;

var $jspzs = parcelRequire("jspzs");

var $axIO3 = parcelRequire("axIO3");

var $h8Lhn = parcelRequire("h8Lhn");

var $dkaBG = parcelRequire("dkaBG");

const $80ca756ded28efe0$var$_m0 = $80ca756ded28efe0$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.connection.v1";
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenInit() {
    return {
        clientId: "",
        counterparty: undefined,
        version: undefined,
        delayPeriod: $dkaBG.Long.UZERO,
        signer: ""
    };
}
module.exports.MsgConnectionOpenInit = {
    encode (message, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $jspzs.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $jspzs.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $jspzs.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $jspzs.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? $jspzs.Counterparty.fromJSON(object.counterparty) : undefined,
            version: (0, $dkaBG.isSet)(object.version) ? $jspzs.Version.fromJSON(object.version) : undefined,
            delayPeriod: (0, $dkaBG.isSet)(object.delayPeriod) ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $jspzs.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $jspzs.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $dkaBG.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenInit();
        message.clientId = object.clientId ?? "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $jspzs.Counterparty.fromPartial(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $jspzs.Version.fromPartial(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenInitResponse() {
    return {};
}
module.exports.MsgConnectionOpenInitResponse = {
    encode (_, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenInitResponse();
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: $dkaBG.Long.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
module.exports.MsgConnectionOpenTry = {
    encode (message, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $jspzs.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        for (const v of message.counterpartyVersions)$jspzs.Version.encode(v, writer.uint32(50).fork()).ldelim();
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $h8Lhn.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(106).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $jspzs.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($jspzs.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                case 13:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: (0, $dkaBG.isSet)(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined,
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? $jspzs.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $dkaBG.isSet)(object.delayPeriod) ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO,
            counterpartyVersions: Array.isArray(object?.counterpartyVersions) ? object.counterpartyVersions.map((e)=>$jspzs.Version.fromJSON(e)) : [],
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: (0, $dkaBG.isSet)(object.proofInit) ? (0, $dkaBG.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofClient: (0, $dkaBG.isSet)(object.proofClient) ? (0, $dkaBG.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $dkaBG.isSet)(object.proofConsensus) ? (0, $dkaBG.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $dkaBG.isSet)(object.consensusHeight) ? $h8Lhn.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $dkaBG.isSet)(object.hostConsensusStateProof) ? (0, $dkaBG.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $jspzs.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $dkaBG.Long.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map((e)=>e ? $jspzs.Version.toJSON(e) : undefined);
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = (0, $dkaBG.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $dkaBG.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $dkaBG.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $h8Lhn.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $dkaBG.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenTry();
        message.clientId = object.clientId ?? "";
        message.previousConnectionId = object.previousConnectionId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $jspzs.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO;
        message.counterpartyVersions = object.counterpartyVersions?.map((e)=>$jspzs.Version.fromPartial(e)) || [];
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $h8Lhn.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenTryResponse() {
    return {};
}
module.exports.MsgConnectionOpenTryResponse = {
    encode (_, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenTryResponse();
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
module.exports.MsgConnectionOpenAck = {
    encode (message, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $jspzs.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $h8Lhn.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(90).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $jspzs.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                case 11:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: (0, $dkaBG.isSet)(object.counterpartyConnectionId) ? String(object.counterpartyConnectionId) : "",
            version: (0, $dkaBG.isSet)(object.version) ? $jspzs.Version.fromJSON(object.version) : undefined,
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined,
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: (0, $dkaBG.isSet)(object.proofTry) ? (0, $dkaBG.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofClient: (0, $dkaBG.isSet)(object.proofClient) ? (0, $dkaBG.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $dkaBG.isSet)(object.proofConsensus) ? (0, $dkaBG.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $dkaBG.isSet)(object.consensusHeight) ? $h8Lhn.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $dkaBG.isSet)(object.hostConsensusStateProof) ? (0, $dkaBG.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $jspzs.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = (0, $dkaBG.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $dkaBG.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $dkaBG.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $h8Lhn.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $dkaBG.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenAck();
        message.connectionId = object.connectionId ?? "";
        message.counterpartyConnectionId = object.counterpartyConnectionId ?? "";
        message.version = object.version !== undefined && object.version !== null ? $jspzs.Version.fromPartial(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $h8Lhn.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenAckResponse() {
    return {};
}
module.exports.MsgConnectionOpenAckResponse = {
    encode (_, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenAckResponse();
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirm() {
    return {
        connectionId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
module.exports.MsgConnectionOpenConfirm = {
    encode (message, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : "",
            proofAck: (0, $dkaBG.isSet)(object.proofAck) ? (0, $dkaBG.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $dkaBG.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = (0, $dkaBG.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirm();
        message.connectionId = object.connectionId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
module.exports.MsgConnectionOpenConfirmResponse = {
    encode (_, writer = $80ca756ded28efe0$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $80ca756ded28efe0$var$_m0.Reader ? input : new $80ca756ded28efe0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $80ca756ded28efe0$var$createBaseMsgConnectionOpenConfirmResponse();
        return message;
    }
};
class $80ca756ded28efe0$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(request) {
        const data = module.exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data)=>module.exports.MsgConnectionOpenInitResponse.decode(new $80ca756ded28efe0$var$_m0.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = module.exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data)=>module.exports.MsgConnectionOpenTryResponse.decode(new $80ca756ded28efe0$var$_m0.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = module.exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data)=>module.exports.MsgConnectionOpenAckResponse.decode(new $80ca756ded28efe0$var$_m0.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = module.exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data)=>module.exports.MsgConnectionOpenConfirmResponse.decode(new $80ca756ded28efe0$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $80ca756ded28efe0$var$MsgClientImpl;

});
parcelRegister("jspzs", function(module, exports) {
"use strict";
var $e2a477b531a2cfa2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e2a477b531a2cfa2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e2a477b531a2cfa2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e2a477b531a2cfa2$var$__createBinding(result, mod, k);
    }
    $e2a477b531a2cfa2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Version = module.exports.ConnectionPaths = module.exports.ClientPaths = module.exports.Counterparty = module.exports.IdentifiedConnection = module.exports.ConnectionEnd = module.exports.stateToJSON = module.exports.stateFromJSON = module.exports.State = module.exports.protobufPackage = void 0;

var $43wjC = parcelRequire("43wjC");

var $dkaBG = parcelRequire("dkaBG");

const $e2a477b531a2cfa2$var$_m0 = $e2a477b531a2cfa2$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $e2a477b531a2cfa2$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e2a477b531a2cfa2$var$State = module.exports.State || (module.exports.State = {}));
function $e2a477b531a2cfa2$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $e2a477b531a2cfa2$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $e2a477b531a2cfa2$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $e2a477b531a2cfa2$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $e2a477b531a2cfa2$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e2a477b531a2cfa2$var$State.UNRECOGNIZED;
    }
}
module.exports.stateFromJSON = $e2a477b531a2cfa2$var$stateFromJSON;
function $e2a477b531a2cfa2$var$stateToJSON(object) {
    switch(object){
        case $e2a477b531a2cfa2$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $e2a477b531a2cfa2$var$State.STATE_INIT:
            return "STATE_INIT";
        case $e2a477b531a2cfa2$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $e2a477b531a2cfa2$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $e2a477b531a2cfa2$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.stateToJSON = $e2a477b531a2cfa2$var$stateToJSON;
function $e2a477b531a2cfa2$var$createBaseConnectionEnd() {
    return {
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $dkaBG.Long.UZERO
    };
}
module.exports.ConnectionEnd = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.versions)module.exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseConnectionEnd();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push(module.exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>module.exports.Version.fromJSON(e)) : [],
            state: (0, $dkaBG.isSet)(object.state) ? $e2a477b531a2cfa2$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $dkaBG.isSet)(object.delayPeriod) ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? module.exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $e2a477b531a2cfa2$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseConnectionEnd();
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>module.exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseIdentifiedConnection() {
    return {
        id: "",
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $dkaBG.Long.UZERO
    };
}
module.exports.IdentifiedConnection = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        for (const v of message.versions)module.exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) module.exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseIdentifiedConnection();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push(module.exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = module.exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $dkaBG.isSet)(object.id) ? String(object.id) : "",
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>module.exports.Version.fromJSON(e)) : [],
            state: (0, $dkaBG.isSet)(object.state) ? $e2a477b531a2cfa2$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $dkaBG.isSet)(object.counterparty) ? module.exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $dkaBG.isSet)(object.delayPeriod) ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? module.exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $e2a477b531a2cfa2$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? module.exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseIdentifiedConnection();
        message.id = object.id ?? "";
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>module.exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? module.exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $dkaBG.Long.fromValue(object.delayPeriod) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseCounterparty() {
    return {
        clientId: "",
        connectionId: "",
        prefix: undefined
    };
}
module.exports.Counterparty = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $43wjC.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $43wjC.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : "",
            prefix: (0, $dkaBG.isSet)(object.prefix) ? $43wjC.MerklePrefix.fromJSON(object.prefix) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $43wjC.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseCounterparty();
        message.clientId = object.clientId ?? "";
        message.connectionId = object.connectionId ?? "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $43wjC.MerklePrefix.fromPartial(object.prefix) : undefined;
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseClientPaths() {
    return {
        paths: []
    };
}
module.exports.ClientPaths = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        for (const v of message.paths)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseClientPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseClientPaths();
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseConnectionPaths() {
    return {
        clientId: "",
        paths: []
    };
}
module.exports.ConnectionPaths = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.paths)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseConnectionPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseConnectionPaths();
        message.clientId = object.clientId ?? "";
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseVersion() {
    return {
        identifier: "",
        features: []
    };
}
module.exports.Version = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        for (const v of message.features)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifier: (0, $dkaBG.isSet)(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object?.features) ? object.features.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map((e)=>e);
        else obj.features = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseVersion();
        message.identifier = object.identifier ?? "";
        message.features = object.features?.map((e)=>e) || [];
        return message;
    }
};
function $e2a477b531a2cfa2$var$createBaseParams() {
    return {
        maxExpectedTimePerBlock: $dkaBG.Long.UZERO
    };
}
module.exports.Params = {
    encode (message, writer = $e2a477b531a2cfa2$var$_m0.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e2a477b531a2cfa2$var$_m0.Reader ? input : new $e2a477b531a2cfa2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e2a477b531a2cfa2$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxExpectedTimePerBlock: (0, $dkaBG.isSet)(object.maxExpectedTimePerBlock) ? $dkaBG.Long.fromValue(object.maxExpectedTimePerBlock) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined && (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e2a477b531a2cfa2$var$createBaseParams();
        message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null ? $dkaBG.Long.fromValue(object.maxExpectedTimePerBlock) : $dkaBG.Long.UZERO;
        return message;
    }
};

});
parcelRegister("43wjC", function(module, exports) {
"use strict";
var $2f40826db030c991$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2f40826db030c991$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2f40826db030c991$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2f40826db030c991$var$__createBinding(result, mod, k);
    }
    $2f40826db030c991$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkleProof = module.exports.MerklePath = module.exports.MerklePrefix = module.exports.MerkleRoot = module.exports.protobufPackage = void 0;

var $kaGh3 = parcelRequire("kaGh3");

const $2f40826db030c991$var$_m0 = $2f40826db030c991$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "ibc.core.commitment.v1";
function $2f40826db030c991$var$createBaseMerkleRoot() {
    return {
        hash: new Uint8Array()
    };
}
module.exports.MerkleRoot = {
    encode (message, writer = $2f40826db030c991$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f40826db030c991$var$_m0.Reader ? input : new $2f40826db030c991$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2f40826db030c991$var$createBaseMerkleRoot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $2f40826db030c991$var$createBaseMerkleRoot();
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $2f40826db030c991$var$createBaseMerklePrefix() {
    return {
        keyPrefix: new Uint8Array()
    };
}
module.exports.MerklePrefix = {
    encode (message, writer = $2f40826db030c991$var$_m0.Writer.create()) {
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f40826db030c991$var$_m0.Reader ? input : new $2f40826db030c991$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2f40826db030c991$var$createBaseMerklePrefix();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPrefix: (0, $dkaBG.isSet)(object.keyPrefix) ? (0, $dkaBG.bytesFromBase64)(object.keyPrefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = (0, $dkaBG.base64FromBytes)(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $2f40826db030c991$var$createBaseMerklePrefix();
        message.keyPrefix = object.keyPrefix ?? new Uint8Array();
        return message;
    }
};
function $2f40826db030c991$var$createBaseMerklePath() {
    return {
        keyPath: []
    };
}
module.exports.MerklePath = {
    encode (message, writer = $2f40826db030c991$var$_m0.Writer.create()) {
        for (const v of message.keyPath)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f40826db030c991$var$_m0.Reader ? input : new $2f40826db030c991$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2f40826db030c991$var$createBaseMerklePath();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPath: Array.isArray(object?.keyPath) ? object.keyPath.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map((e)=>e);
        else obj.keyPath = [];
        return obj;
    },
    fromPartial (object) {
        const message = $2f40826db030c991$var$createBaseMerklePath();
        message.keyPath = object.keyPath?.map((e)=>e) || [];
        return message;
    }
};
function $2f40826db030c991$var$createBaseMerkleProof() {
    return {
        proofs: []
    };
}
module.exports.MerkleProof = {
    encode (message, writer = $2f40826db030c991$var$_m0.Writer.create()) {
        for (const v of message.proofs)$kaGh3.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2f40826db030c991$var$_m0.Reader ? input : new $2f40826db030c991$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2f40826db030c991$var$createBaseMerkleProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($kaGh3.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proofs: Array.isArray(object?.proofs) ? object.proofs.map((e)=>$kaGh3.CommitmentProof.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proofs) obj.proofs = message.proofs.map((e)=>e ? $kaGh3.CommitmentProof.toJSON(e) : undefined);
        else obj.proofs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $2f40826db030c991$var$createBaseMerkleProof();
        message.proofs = object.proofs?.map((e)=>$kaGh3.CommitmentProof.fromPartial(e)) || [];
        return message;
    }
};

});
parcelRegister("kaGh3", function(module, exports) {
"use strict";
var $eaf5889427cc7d5f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eaf5889427cc7d5f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eaf5889427cc7d5f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eaf5889427cc7d5f$var$__createBinding(result, mod, k);
    }
    $eaf5889427cc7d5f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CompressedNonExistenceProof = module.exports.CompressedExistenceProof = module.exports.CompressedBatchEntry = module.exports.CompressedBatchProof = module.exports.BatchEntry = module.exports.BatchProof = module.exports.InnerSpec = module.exports.ProofSpec = module.exports.InnerOp = module.exports.LeafOp = module.exports.CommitmentProof = module.exports.NonExistenceProof = module.exports.ExistenceProof = module.exports.lengthOpToJSON = module.exports.lengthOpFromJSON = module.exports.LengthOp = module.exports.hashOpToJSON = module.exports.hashOpFromJSON = module.exports.HashOp = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $eaf5889427cc7d5f$var$_m0 = $eaf5889427cc7d5f$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.ics23.v1";
var $eaf5889427cc7d5f$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($eaf5889427cc7d5f$var$HashOp = module.exports.HashOp || (module.exports.HashOp = {}));
function $eaf5889427cc7d5f$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $eaf5889427cc7d5f$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $eaf5889427cc7d5f$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $eaf5889427cc7d5f$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $eaf5889427cc7d5f$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $eaf5889427cc7d5f$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $eaf5889427cc7d5f$var$HashOp.BITCOIN;
        case 6:
        case "SHA512_256":
            return $eaf5889427cc7d5f$var$HashOp.SHA512_256;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $eaf5889427cc7d5f$var$HashOp.UNRECOGNIZED;
    }
}
module.exports.hashOpFromJSON = $eaf5889427cc7d5f$var$hashOpFromJSON;
function $eaf5889427cc7d5f$var$hashOpToJSON(object) {
    switch(object){
        case $eaf5889427cc7d5f$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $eaf5889427cc7d5f$var$HashOp.SHA256:
            return "SHA256";
        case $eaf5889427cc7d5f$var$HashOp.SHA512:
            return "SHA512";
        case $eaf5889427cc7d5f$var$HashOp.KECCAK:
            return "KECCAK";
        case $eaf5889427cc7d5f$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $eaf5889427cc7d5f$var$HashOp.BITCOIN:
            return "BITCOIN";
        case $eaf5889427cc7d5f$var$HashOp.SHA512_256:
            return "SHA512_256";
        case $eaf5889427cc7d5f$var$HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.hashOpToJSON = $eaf5889427cc7d5f$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $eaf5889427cc7d5f$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($eaf5889427cc7d5f$var$LengthOp = module.exports.LengthOp || (module.exports.LengthOp = {}));
function $eaf5889427cc7d5f$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $eaf5889427cc7d5f$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $eaf5889427cc7d5f$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $eaf5889427cc7d5f$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $eaf5889427cc7d5f$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $eaf5889427cc7d5f$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $eaf5889427cc7d5f$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $eaf5889427cc7d5f$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $eaf5889427cc7d5f$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $eaf5889427cc7d5f$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $eaf5889427cc7d5f$var$LengthOp.UNRECOGNIZED;
    }
}
module.exports.lengthOpFromJSON = $eaf5889427cc7d5f$var$lengthOpFromJSON;
function $eaf5889427cc7d5f$var$lengthOpToJSON(object) {
    switch(object){
        case $eaf5889427cc7d5f$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $eaf5889427cc7d5f$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $eaf5889427cc7d5f$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $eaf5889427cc7d5f$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $eaf5889427cc7d5f$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $eaf5889427cc7d5f$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $eaf5889427cc7d5f$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $eaf5889427cc7d5f$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $eaf5889427cc7d5f$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case $eaf5889427cc7d5f$var$LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.lengthOpToJSON = $eaf5889427cc7d5f$var$lengthOpToJSON;
function $eaf5889427cc7d5f$var$createBaseExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
module.exports.ExistenceProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) module.exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        for (const v of message.path)module.exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push(module.exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $dkaBG.isSet)(object.value) ? (0, $dkaBG.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $dkaBG.isSet)(object.leaf) ? module.exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>module.exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $dkaBG.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? module.exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e ? module.exports.InnerOp.toJSON(e) : undefined);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? module.exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>module.exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
module.exports.NonExistenceProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) module.exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) module.exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $dkaBG.isSet)(object.left) ? module.exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $dkaBG.isSet)(object.right) ? module.exports.ExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? module.exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? module.exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? module.exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? module.exports.ExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseCommitmentProof() {
    return {
        exist: undefined,
        nonexist: undefined,
        batch: undefined,
        compressed: undefined
    };
}
module.exports.CommitmentProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.exist !== undefined) module.exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) module.exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) module.exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseCommitmentProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = module.exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = module.exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $dkaBG.isSet)(object.exist) ? module.exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $dkaBG.isSet)(object.nonexist) ? module.exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: (0, $dkaBG.isSet)(object.batch) ? module.exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: (0, $dkaBG.isSet)(object.compressed) ? module.exports.CompressedBatchProof.fromJSON(object.compressed) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? module.exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? module.exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseCommitmentProof();
        message.exist = object.exist !== undefined && object.exist !== null ? module.exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? module.exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? module.exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? module.exports.CompressedBatchProof.fromPartial(object.compressed) : undefined;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseLeafOp() {
    return {
        hash: 0,
        prehashKey: 0,
        prehashValue: 0,
        length: 0,
        prefix: new Uint8Array()
    };
}
module.exports.LeafOp = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseLeafOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? $eaf5889427cc7d5f$var$hashOpFromJSON(object.hash) : 0,
            prehashKey: (0, $dkaBG.isSet)(object.prehashKey) ? $eaf5889427cc7d5f$var$hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: (0, $dkaBG.isSet)(object.prehashValue) ? $eaf5889427cc7d5f$var$hashOpFromJSON(object.prehashValue) : 0,
            length: (0, $dkaBG.isSet)(object.length) ? $eaf5889427cc7d5f$var$lengthOpFromJSON(object.length) : 0,
            prefix: (0, $dkaBG.isSet)(object.prefix) ? (0, $dkaBG.bytesFromBase64)(object.prefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $eaf5889427cc7d5f$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $eaf5889427cc7d5f$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $eaf5889427cc7d5f$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $eaf5889427cc7d5f$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = (0, $dkaBG.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseLeafOp();
        message.hash = object.hash ?? 0;
        message.prehashKey = object.prehashKey ?? 0;
        message.prehashValue = object.prehashValue ?? 0;
        message.length = object.length ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseInnerOp() {
    return {
        hash: 0,
        prefix: new Uint8Array(),
        suffix: new Uint8Array()
    };
}
module.exports.InnerOp = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseInnerOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? $eaf5889427cc7d5f$var$hashOpFromJSON(object.hash) : 0,
            prefix: (0, $dkaBG.isSet)(object.prefix) ? (0, $dkaBG.bytesFromBase64)(object.prefix) : new Uint8Array(),
            suffix: (0, $dkaBG.isSet)(object.suffix) ? (0, $dkaBG.bytesFromBase64)(object.suffix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $eaf5889427cc7d5f$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = (0, $dkaBG.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = (0, $dkaBG.base64FromBytes)(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseInnerOp();
        message.hash = object.hash ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        message.suffix = object.suffix ?? new Uint8Array();
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseProofSpec() {
    return {
        leafSpec: undefined,
        innerSpec: undefined,
        maxDepth: 0,
        minDepth: 0
    };
}
module.exports.ProofSpec = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.leafSpec !== undefined) module.exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) module.exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseProofSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = module.exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            leafSpec: (0, $dkaBG.isSet)(object.leafSpec) ? module.exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: (0, $dkaBG.isSet)(object.innerSpec) ? module.exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: (0, $dkaBG.isSet)(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: (0, $dkaBG.isSet)(object.minDepth) ? Number(object.minDepth) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? module.exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? module.exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseProofSpec();
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? module.exports.LeafOp.fromPartial(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? module.exports.InnerSpec.fromPartial(object.innerSpec) : undefined;
        message.maxDepth = object.maxDepth ?? 0;
        message.minDepth = object.minDepth ?? 0;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0
    };
}
module.exports.InnerSpec = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder)writer.int32(v);
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseInnerSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            childOrder: Array.isArray(object?.childOrder) ? object.childOrder.map((e)=>Number(e)) : [],
            childSize: (0, $dkaBG.isSet)(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: (0, $dkaBG.isSet)(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: (0, $dkaBG.isSet)(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: (0, $dkaBG.isSet)(object.emptyChild) ? (0, $dkaBG.bytesFromBase64)(object.emptyChild) : new Uint8Array(),
            hash: (0, $dkaBG.isSet)(object.hash) ? $eaf5889427cc7d5f$var$hashOpFromJSON(object.hash) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map((e)=>Math.round(e));
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined && (obj.emptyChild = (0, $dkaBG.base64FromBytes)(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $eaf5889427cc7d5f$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseInnerSpec();
        message.childOrder = object.childOrder?.map((e)=>e) || [];
        message.childSize = object.childSize ?? 0;
        message.minPrefixLength = object.minPrefixLength ?? 0;
        message.maxPrefixLength = object.maxPrefixLength ?? 0;
        message.emptyChild = object.emptyChild ?? new Uint8Array();
        message.hash = object.hash ?? 0;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseBatchProof() {
    return {
        entries: []
    };
}
module.exports.BatchProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        for (const v of message.entries)module.exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push(module.exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>module.exports.BatchEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.BatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseBatchProof();
        message.entries = object.entries?.map((e)=>module.exports.BatchEntry.fromPartial(e)) || [];
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
module.exports.BatchEntry = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.exist !== undefined) module.exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $dkaBG.isSet)(object.exist) ? module.exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $dkaBG.isSet)(object.nonexist) ? module.exports.NonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? module.exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? module.exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseCompressedBatchProof() {
    return {
        entries: [],
        lookupInners: []
    };
}
module.exports.CompressedBatchProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        for (const v of message.entries)module.exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.lookupInners)module.exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseCompressedBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push(module.exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push(module.exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>module.exports.CompressedBatchEntry.fromJSON(e)) : [],
            lookupInners: Array.isArray(object?.lookupInners) ? object.lookupInners.map((e)=>module.exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.CompressedBatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map((e)=>e ? module.exports.InnerOp.toJSON(e) : undefined);
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseCompressedBatchProof();
        message.entries = object.entries?.map((e)=>module.exports.CompressedBatchEntry.fromPartial(e)) || [];
        message.lookupInners = object.lookupInners?.map((e)=>module.exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseCompressedBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
module.exports.CompressedBatchEntry = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.exist !== undefined) module.exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) module.exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseCompressedBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = module.exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $dkaBG.isSet)(object.exist) ? module.exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $dkaBG.isSet)(object.nonexist) ? module.exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? module.exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? module.exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseCompressedBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? module.exports.CompressedExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? module.exports.CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseCompressedExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
module.exports.CompressedExistenceProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) module.exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.path)writer.int32(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseCompressedExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = module.exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $dkaBG.isSet)(object.value) ? (0, $dkaBG.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $dkaBG.isSet)(object.leaf) ? module.exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>Number(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $dkaBG.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? module.exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>Math.round(e));
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseCompressedExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? module.exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>e) || [];
        return message;
    }
};
function $eaf5889427cc7d5f$var$createBaseCompressedNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
module.exports.CompressedNonExistenceProof = {
    encode (message, writer = $eaf5889427cc7d5f$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) module.exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) module.exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eaf5889427cc7d5f$var$_m0.Reader ? input : new $eaf5889427cc7d5f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eaf5889427cc7d5f$var$createBaseCompressedNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = module.exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $dkaBG.isSet)(object.left) ? module.exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $dkaBG.isSet)(object.right) ? module.exports.CompressedExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? module.exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? module.exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eaf5889427cc7d5f$var$createBaseCompressedNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? module.exports.CompressedExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? module.exports.CompressedExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};

});





parcelRegister("aODJs", function(module, exports) {
"use strict";
var $0208374ddaeb0f7d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupIbcExtension = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $6SM29 = parcelRequire("6SM29");

var $7Hmmy = parcelRequire("7Hmmy");

var $f6hld = parcelRequire("f6hld");

var $9JMQ7 = parcelRequire("9JMQ7");

var $5J5Fw = parcelRequire("5J5Fw");

var $2uXkL = parcelRequire("2uXkL");

const $0208374ddaeb0f7d$var$long_1 = $0208374ddaeb0f7d$var$__importDefault((parcelRequire("3gmZQ")));

var $5E3xG = parcelRequire("5E3xG");
function $0208374ddaeb0f7d$var$decodeTendermintClientStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ClientState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $2uXkL.ClientState.decode(clientState.value);
}
function $0208374ddaeb0f7d$var$decodeTendermintConsensusStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ConsensusState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $2uXkL.ConsensusState.decode(clientState.value);
}
function $0208374ddaeb0f7d$var$setupIbcExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new $f6hld.QueryClientImpl(rpc);
    const clientQueryService = new $9JMQ7.QueryClientImpl(rpc);
    const connectionQueryService = new $5J5Fw.QueryClientImpl(rpc);
    const transferQueryService = new $6SM29.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId)=>channelQueryService.Channel({
                        portId: portId,
                        channelId: channelId
                    }),
                channels: async (paginationKey)=>channelQueryService.Channels({
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allChannels: async ()=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                connectionChannels: async (connection, paginationKey)=>channelQueryService.ConnectionChannels({
                        connection: connection,
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allConnectionChannels: async (connection)=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                clientState: async (portId, channelId)=>channelQueryService.ChannelClientState({
                        portId: portId,
                        channelId: channelId
                    }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight)=>channelQueryService.ChannelConsensusState({
                        portId: portId,
                        channelId: channelId,
                        revisionNumber: $0208374ddaeb0f7d$var$long_1.default.fromNumber(revisionNumber, true),
                        revisionHeight: $0208374ddaeb0f7d$var$long_1.default.fromNumber(revisionHeight, true)
                    }),
                packetCommitment: async (portId, channelId, sequence)=>channelQueryService.PacketCommitment({
                        portId: portId,
                        channelId: channelId,
                        sequence: $0208374ddaeb0f7d$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetCommitments: async (portId, channelId, paginationKey)=>channelQueryService.PacketCommitments({
                        channelId: channelId,
                        portId: portId,
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allPacketCommitments: async (portId, channelId)=>{
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        commitments.push(...response.commitments);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height
                    };
                },
                packetReceipt: async (portId, channelId, sequence)=>channelQueryService.PacketReceipt({
                        portId: portId,
                        channelId: channelId,
                        sequence: $0208374ddaeb0f7d$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgement: async (portId, channelId, sequence)=>channelQueryService.PacketAcknowledgement({
                        portId: portId,
                        channelId: channelId,
                        sequence: $0208374ddaeb0f7d$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgements: async (portId, channelId, paginationKey)=>{
                    const request = $f6hld.QueryPacketAcknowledgementsRequest.fromPartial({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    });
                    return channelQueryService.PacketAcknowledgements(request);
                },
                allPacketAcknowledgements: async (portId, channelId)=>{
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        const request = $f6hld.QueryPacketAcknowledgementsRequest.fromPartial({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        response = await channelQueryService.PacketAcknowledgements(request);
                        acknowledgements.push(...response.acknowledgements);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences)=>channelQueryService.UnreceivedPackets({
                        portId: portId,
                        channelId: channelId,
                        packetCommitmentSequences: packetCommitmentSequences.map((s)=>$0208374ddaeb0f7d$var$long_1.default.fromNumber(s, true))
                    }),
                unreceivedAcks: async (portId, channelId, packetAckSequences)=>channelQueryService.UnreceivedAcks({
                        portId: portId,
                        channelId: channelId,
                        packetAckSequences: packetAckSequences.map((s)=>$0208374ddaeb0f7d$var$long_1.default.fromNumber(s, true))
                    }),
                nextSequenceReceive: async (portId, channelId)=>channelQueryService.NextSequenceReceive({
                        portId: portId,
                        channelId: channelId
                    })
            },
            client: {
                state: async (clientId)=>clientQueryService.ClientState({
                        clientId: clientId
                    }),
                states: async (paginationKey)=>clientQueryService.ClientStates({
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allStates: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        clientStates: clientStates
                    };
                },
                consensusState: async (clientId, consensusHeight)=>clientQueryService.ConsensusState($9JMQ7.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight !== undefined ? $0208374ddaeb0f7d$var$long_1.default.fromNumber(consensusHeight, true) : undefined,
                        latestHeight: consensusHeight === undefined
                    })),
                consensusStates: async (clientId, paginationKey)=>clientQueryService.ConsensusStates({
                        clientId: clientId,
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allConsensusStates: async (clientId)=>{
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        consensusStates.push(...response.consensusStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        consensusStates: consensusStates
                    };
                },
                params: async ()=>clientQueryService.ClientParams({}),
                stateTm: async (clientId)=>{
                    const response = await clientQueryService.ClientState({
                        clientId: clientId
                    });
                    return $0208374ddaeb0f7d$var$decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey)=>{
                    const { clientStates: clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    });
                    return clientStates.map(({ clientState: clientState })=>$0208374ddaeb0f7d$var$decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return clientStates.map(({ clientState: clientState })=>$0208374ddaeb0f7d$var$decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight)=>{
                    const response = await clientQueryService.ConsensusState($9JMQ7.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight?.revisionHeight,
                        revisionNumber: consensusHeight?.revisionNumber,
                        latestHeight: consensusHeight === undefined
                    }));
                    return $0208374ddaeb0f7d$var$decodeTendermintConsensusStateAny(response.consensusState);
                }
            },
            connection: {
                connection: async (connectionId)=>connectionQueryService.Connection({
                        connectionId: connectionId
                    }),
                connections: async (paginationKey)=>connectionQueryService.Connections({
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allConnections: async ()=>{
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        connections.push(...response.connections);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height
                    };
                },
                clientConnections: async (clientId)=>connectionQueryService.ClientConnections({
                        clientId: clientId
                    }),
                clientState: async (connectionId)=>connectionQueryService.ConnectionClientState({
                        connectionId: connectionId
                    }),
                consensusState: async (connectionId, revisionHeight)=>connectionQueryService.ConnectionConsensusState($5J5Fw.QueryConnectionConsensusStateRequest.fromPartial({
                        connectionId: connectionId,
                        revisionHeight: $0208374ddaeb0f7d$var$long_1.default.fromNumber(revisionHeight, true)
                    }))
            },
            transfer: {
                denomTrace: async (hash)=>transferQueryService.DenomTrace({
                        hash: hash
                    }),
                denomTraces: async (paginationKey)=>transferQueryService.DenomTraces({
                        pagination: (0, $5E3xG.createPagination)(paginationKey)
                    }),
                allDenomTraces: async ()=>{
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, $5E3xG.createPagination)(key)
                        });
                        denomTraces.push(...response.denomTraces);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        denomTraces: denomTraces
                    };
                },
                params: async ()=>transferQueryService.Params({})
            },
            verified: {
                channel: {
                    channel: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, $94ZnX.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $7Hmmy.Channel.decode(value) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, $94ZnX.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, $94ZnX.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    nextSequenceReceive: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, $94ZnX.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $h3uvW.Uint64.fromBytes(value).toNumber() : null;
                    }
                }
            }
        }
    };
}
module.exports.setupIbcExtension = $0208374ddaeb0f7d$var$setupIbcExtension;

});
parcelRegister("6SM29", function(module, exports) {
"use strict";
var $502d0bb65f1788c0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $502d0bb65f1788c0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $502d0bb65f1788c0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $502d0bb65f1788c0$var$__createBinding(result, mod, k);
    }
    $502d0bb65f1788c0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryEscrowAddressResponse = module.exports.QueryEscrowAddressRequest = module.exports.QueryDenomHashResponse = module.exports.QueryDenomHashRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.QueryDenomTracesResponse = module.exports.QueryDenomTracesRequest = module.exports.QueryDenomTraceResponse = module.exports.QueryDenomTraceRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $Bmz1j = parcelRequire("Bmz1j");

const $502d0bb65f1788c0$var$_m0 = $502d0bb65f1788c0$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "ibc.applications.transfer.v1";
function $502d0bb65f1788c0$var$createBaseQueryDenomTraceRequest() {
    return {
        hash: ""
    };
}
module.exports.QueryDenomTraceRequest = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTraceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTraceRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryDenomTraceResponse() {
    return {
        denomTrace: undefined
    };
}
module.exports.QueryDenomTraceResponse = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.denomTrace !== undefined) $Bmz1j.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTraceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTrace = $Bmz1j.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTrace: (0, $dkaBG.isSet)(object.denomTrace) ? $Bmz1j.DenomTrace.fromJSON(object.denomTrace) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denomTrace !== undefined && (obj.denomTrace = message.denomTrace ? $Bmz1j.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTraceResponse();
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $Bmz1j.DenomTrace.fromPartial(object.denomTrace) : undefined;
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryDenomTracesRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryDenomTracesRequest = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTracesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTracesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryDenomTracesResponse() {
    return {
        denomTraces: [],
        pagination: undefined
    };
}
module.exports.QueryDenomTracesResponse = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        for (const v of message.denomTraces)$Bmz1j.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTracesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTraces.push($Bmz1j.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTraces: Array.isArray(object?.denomTraces) ? object.denomTraces.map((e)=>$Bmz1j.DenomTrace.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomTraces) obj.denomTraces = message.denomTraces.map((e)=>e ? $Bmz1j.DenomTrace.toJSON(e) : undefined);
        else obj.denomTraces = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomTracesResponse();
        message.denomTraces = object.denomTraces?.map((e)=>$Bmz1j.DenomTrace.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $502d0bb65f1788c0$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.params !== undefined) $Bmz1j.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $Bmz1j.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $Bmz1j.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $Bmz1j.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $Bmz1j.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryDenomHashRequest() {
    return {
        trace: ""
    };
}
module.exports.QueryDenomHashRequest = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.trace !== "") writer.uint32(10).string(message.trace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomHashRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            trace: (0, $dkaBG.isSet)(object.trace) ? String(object.trace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomHashRequest();
        message.trace = object.trace ?? "";
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryDenomHashResponse() {
    return {
        hash: ""
    };
}
module.exports.QueryDenomHashResponse = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomHashResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryDenomHashResponse();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryEscrowAddressRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.QueryEscrowAddressRequest = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryEscrowAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryEscrowAddressRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $502d0bb65f1788c0$var$createBaseQueryEscrowAddressResponse() {
    return {
        escrowAddress: ""
    };
}
module.exports.QueryEscrowAddressResponse = {
    encode (message, writer = $502d0bb65f1788c0$var$_m0.Writer.create()) {
        if (message.escrowAddress !== "") writer.uint32(10).string(message.escrowAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $502d0bb65f1788c0$var$_m0.Reader ? input : new $502d0bb65f1788c0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $502d0bb65f1788c0$var$createBaseQueryEscrowAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.escrowAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            escrowAddress: (0, $dkaBG.isSet)(object.escrowAddress) ? String(object.escrowAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.escrowAddress !== undefined && (obj.escrowAddress = message.escrowAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $502d0bb65f1788c0$var$createBaseQueryEscrowAddressResponse();
        message.escrowAddress = object.escrowAddress ?? "";
        return message;
    }
};
class $502d0bb65f1788c0$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
        this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(request) {
        const data = module.exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data)=>module.exports.QueryDenomTraceResponse.decode(new $502d0bb65f1788c0$var$_m0.Reader(data)));
    }
    DenomTraces(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data)=>module.exports.QueryDenomTracesResponse.decode(new $502d0bb65f1788c0$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $502d0bb65f1788c0$var$_m0.Reader(data)));
    }
    DenomHash(request) {
        const data = module.exports.QueryDenomHashRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
        return promise.then((data)=>module.exports.QueryDenomHashResponse.decode(new $502d0bb65f1788c0$var$_m0.Reader(data)));
    }
    EscrowAddress(request) {
        const data = module.exports.QueryEscrowAddressRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
        return promise.then((data)=>module.exports.QueryEscrowAddressResponse.decode(new $502d0bb65f1788c0$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $502d0bb65f1788c0$var$QueryClientImpl;

});
parcelRegister("Bmz1j", function(module, exports) {
"use strict";
var $0704f5867933bbe8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0704f5867933bbe8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0704f5867933bbe8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0704f5867933bbe8$var$__createBinding(result, mod, k);
    }
    $0704f5867933bbe8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.DenomTrace = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $0704f5867933bbe8$var$_m0 = $0704f5867933bbe8$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "ibc.applications.transfer.v1";
function $0704f5867933bbe8$var$createBaseDenomTrace() {
    return {
        path: "",
        baseDenom: ""
    };
}
module.exports.DenomTrace = {
    encode (message, writer = $0704f5867933bbe8$var$_m0.Writer.create()) {
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0704f5867933bbe8$var$_m0.Reader ? input : new $0704f5867933bbe8$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0704f5867933bbe8$var$createBaseDenomTrace();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            path: (0, $dkaBG.isSet)(object.path) ? String(object.path) : "",
            baseDenom: (0, $dkaBG.isSet)(object.baseDenom) ? String(object.baseDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial (object) {
        const message = $0704f5867933bbe8$var$createBaseDenomTrace();
        message.path = object.path ?? "";
        message.baseDenom = object.baseDenom ?? "";
        return message;
    }
};
function $0704f5867933bbe8$var$createBaseParams() {
    return {
        sendEnabled: false,
        receiveEnabled: false
    };
}
module.exports.Params = {
    encode (message, writer = $0704f5867933bbe8$var$_m0.Writer.create()) {
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0704f5867933bbe8$var$_m0.Reader ? input : new $0704f5867933bbe8$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0704f5867933bbe8$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: (0, $dkaBG.isSet)(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: (0, $dkaBG.isSet)(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $0704f5867933bbe8$var$createBaseParams();
        message.sendEnabled = object.sendEnabled ?? false;
        message.receiveEnabled = object.receiveEnabled ?? false;
        return message;
    }
};

});


parcelRegister("f6hld", function(module, exports) {
"use strict";
var $afe4de204a4c9c4d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $afe4de204a4c9c4d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $afe4de204a4c9c4d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $afe4de204a4c9c4d$var$__createBinding(result, mod, k);
    }
    $afe4de204a4c9c4d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryNextSequenceReceiveResponse = module.exports.QueryNextSequenceReceiveRequest = module.exports.QueryUnreceivedAcksResponse = module.exports.QueryUnreceivedAcksRequest = module.exports.QueryUnreceivedPacketsResponse = module.exports.QueryUnreceivedPacketsRequest = module.exports.QueryPacketAcknowledgementsResponse = module.exports.QueryPacketAcknowledgementsRequest = module.exports.QueryPacketAcknowledgementResponse = module.exports.QueryPacketAcknowledgementRequest = module.exports.QueryPacketReceiptResponse = module.exports.QueryPacketReceiptRequest = module.exports.QueryPacketCommitmentsResponse = module.exports.QueryPacketCommitmentsRequest = module.exports.QueryPacketCommitmentResponse = module.exports.QueryPacketCommitmentRequest = module.exports.QueryChannelConsensusStateResponse = module.exports.QueryChannelConsensusStateRequest = module.exports.QueryChannelClientStateResponse = module.exports.QueryChannelClientStateRequest = module.exports.QueryConnectionChannelsResponse = module.exports.QueryConnectionChannelsRequest = module.exports.QueryChannelsResponse = module.exports.QueryChannelsRequest = module.exports.QueryChannelResponse = module.exports.QueryChannelRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $7Hmmy = parcelRequire("7Hmmy");

var $h8Lhn = parcelRequire("h8Lhn");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $afe4de204a4c9c4d$var$_m0 = $afe4de204a4c9c4d$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.channel.v1";
function $afe4de204a4c9c4d$var$createBaseQueryChannelRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.QueryChannelRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelResponse() {
    return {
        channel: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryChannelResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.channel !== undefined) $7Hmmy.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channel = $7Hmmy.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channel: (0, $dkaBG.isSet)(object.channel) ? $7Hmmy.Channel.fromJSON(object.channel) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.channel !== undefined && (obj.channel = message.channel ? $7Hmmy.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelResponse();
        message.channel = object.channel !== undefined && object.channel !== null ? $7Hmmy.Channel.fromPartial(object.channel) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelsRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryChannelsRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
module.exports.QueryChannelsResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        for (const v of message.channels)$7Hmmy.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($7Hmmy.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$7Hmmy.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $7Hmmy.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelsResponse();
        message.channels = object.channels?.map((e)=>$7Hmmy.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsRequest() {
    return {
        connection: "",
        pagination: undefined
    };
}
module.exports.QueryConnectionChannelsRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.connection !== "") writer.uint32(10).string(message.connection);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $dkaBG.isSet)(object.connection) ? String(object.connection) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsRequest();
        message.connection = object.connection ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
module.exports.QueryConnectionChannelsResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        for (const v of message.channels)$7Hmmy.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($7Hmmy.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$7Hmmy.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $7Hmmy.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryConnectionChannelsResponse();
        message.channels = object.channels?.map((e)=>$7Hmmy.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.QueryChannelClientStateRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryChannelClientStateResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $h8Lhn.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $h8Lhn.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $dkaBG.isSet)(object.identifiedClientState) ? $h8Lhn.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $h8Lhn.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $h8Lhn.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateRequest() {
    return {
        portId: "",
        channelId: "",
        revisionNumber: $dkaBG.Long.UZERO,
        revisionHeight: $dkaBG.Long.UZERO
    };
}
module.exports.QueryChannelConsensusStateRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.revisionNumber.isZero()) writer.uint32(24).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(32).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            revisionNumber: (0, $dkaBG.isSet)(object.revisionNumber) ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO,
            revisionHeight: (0, $dkaBG.isSet)(object.revisionHeight) ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $dkaBG.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryChannelConsensusStateResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryChannelConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.QueryPacketCommitmentRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentResponse() {
    return {
        commitment: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryPacketCommitmentResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.commitment.length !== 0) writer.uint32(10).bytes(message.commitment);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitment: (0, $dkaBG.isSet)(object.commitment) ? (0, $dkaBG.bytesFromBase64)(object.commitment) : new Uint8Array(),
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commitment !== undefined && (obj.commitment = (0, $dkaBG.base64FromBytes)(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentResponse();
        message.commitment = object.commitment ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined
    };
}
module.exports.QueryPacketCommitmentsRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsResponse() {
    return {
        commitments: [],
        pagination: undefined,
        height: undefined
    };
}
module.exports.QueryPacketCommitmentsResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        for (const v of message.commitments)$7Hmmy.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitments.push($7Hmmy.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitments: Array.isArray(object?.commitments) ? object.commitments.map((e)=>$7Hmmy.PacketState.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commitments) obj.commitments = message.commitments.map((e)=>e ? $7Hmmy.PacketState.toJSON(e) : undefined);
        else obj.commitments = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketCommitmentsResponse();
        message.commitments = object.commitments?.map((e)=>$7Hmmy.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.QueryPacketReceiptRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptResponse() {
    return {
        received: false,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryPacketReceiptResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.received === true) writer.uint32(16).bool(message.received);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            received: (0, $dkaBG.isSet)(object.received) ? Boolean(object.received) : false,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketReceiptResponse();
        message.received = object.received ?? false;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $dkaBG.Long.UZERO
    };
}
module.exports.QueryPacketAcknowledgementRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $dkaBG.isSet)(object.sequence) ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $dkaBG.Long.fromValue(object.sequence) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementResponse() {
    return {
        acknowledgement: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryPacketAcknowledgementResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.acknowledgement.length !== 0) writer.uint32(10).bytes(message.acknowledgement);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgement: (0, $dkaBG.isSet)(object.acknowledgement) ? (0, $dkaBG.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $dkaBG.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementResponse();
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
        packetCommitmentSequences: []
    };
}
module.exports.QueryPacketAcknowledgementsRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$dkaBG.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsResponse() {
    return {
        acknowledgements: [],
        pagination: undefined,
        height: undefined
    };
}
module.exports.QueryPacketAcknowledgementsResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        for (const v of message.acknowledgements)$7Hmmy.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgements.push($7Hmmy.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgements: Array.isArray(object?.acknowledgements) ? object.acknowledgements.map((e)=>$7Hmmy.PacketState.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.acknowledgements) obj.acknowledgements = message.acknowledgements.map((e)=>e ? $7Hmmy.PacketState.toJSON(e) : undefined);
        else obj.acknowledgements = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = object.acknowledgements?.map((e)=>$7Hmmy.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsRequest() {
    return {
        portId: "",
        channelId: "",
        packetCommitmentSequences: []
    };
}
module.exports.QueryUnreceivedPacketsRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$dkaBG.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
module.exports.QueryUnreceivedPacketsResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$dkaBG.Long.fromValue(e)) : [],
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedPacketsResponse();
        message.sequences = object.sequences?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksRequest() {
    return {
        portId: "",
        channelId: "",
        packetAckSequences: []
    };
}
module.exports.QueryUnreceivedAcksRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetAckSequences.push(reader.uint64());
                    } else message.packetAckSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object?.packetAckSequences) ? object.packetAckSequences.map((e)=>$dkaBG.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) obj.packetAckSequences = message.packetAckSequences.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.packetAckSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetAckSequences = object.packetAckSequences?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
module.exports.QueryUnreceivedAcksResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$dkaBG.Long.fromValue(e)) : [],
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryUnreceivedAcksResponse();
        message.sequences = object.sequences?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
module.exports.QueryNextSequenceReceiveRequest = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $dkaBG.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $dkaBG.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveResponse() {
    return {
        nextSequenceReceive: $dkaBG.Long.UZERO,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryNextSequenceReceiveResponse = {
    encode (message, writer = $afe4de204a4c9c4d$var$_m0.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) writer.uint32(8).uint64(message.nextSequenceReceive);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $afe4de204a4c9c4d$var$_m0.Reader ? input : new $afe4de204a4c9c4d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextSequenceReceive: (0, $dkaBG.isSet)(object.nextSequenceReceive) ? $dkaBG.Long.fromValue(object.nextSequenceReceive) : $dkaBG.Long.UZERO,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextSequenceReceive !== undefined && (obj.nextSequenceReceive = (message.nextSequenceReceive || $dkaBG.Long.UZERO).toString());
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $afe4de204a4c9c4d$var$createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $dkaBG.Long.fromValue(object.nextSequenceReceive) : $dkaBG.Long.UZERO;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
class $afe4de204a4c9c4d$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(request) {
        const data = module.exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data)=>module.exports.QueryChannelResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    Channels(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data)=>module.exports.QueryChannelsResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = module.exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data)=>module.exports.QueryConnectionChannelsResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    ChannelClientState(request) {
        const data = module.exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data)=>module.exports.QueryChannelClientStateResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = module.exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data)=>module.exports.QueryChannelConsensusStateResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    PacketCommitment(request) {
        const data = module.exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data)=>module.exports.QueryPacketCommitmentResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    PacketCommitments(request) {
        const data = module.exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data)=>module.exports.QueryPacketCommitmentsResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    PacketReceipt(request) {
        const data = module.exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data)=>module.exports.QueryPacketReceiptResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = module.exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data)=>module.exports.QueryPacketAcknowledgementResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = module.exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data)=>module.exports.QueryPacketAcknowledgementsResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = module.exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data)=>module.exports.QueryUnreceivedPacketsResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = module.exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data)=>module.exports.QueryUnreceivedAcksResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = module.exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data)=>module.exports.QueryNextSequenceReceiveResponse.decode(new $afe4de204a4c9c4d$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $afe4de204a4c9c4d$var$QueryClientImpl;

});

parcelRegister("9JMQ7", function(module, exports) {
"use strict";
var $716e338a02886d66$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $716e338a02886d66$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $716e338a02886d66$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $716e338a02886d66$var$__createBinding(result, mod, k);
    }
    $716e338a02886d66$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryUpgradedConsensusStateResponse = module.exports.QueryUpgradedConsensusStateRequest = module.exports.QueryUpgradedClientStateResponse = module.exports.QueryUpgradedClientStateRequest = module.exports.QueryClientParamsResponse = module.exports.QueryClientParamsRequest = module.exports.QueryClientStatusResponse = module.exports.QueryClientStatusRequest = module.exports.QueryConsensusStateHeightsResponse = module.exports.QueryConsensusStateHeightsRequest = module.exports.QueryConsensusStatesResponse = module.exports.QueryConsensusStatesRequest = module.exports.QueryConsensusStateResponse = module.exports.QueryConsensusStateRequest = module.exports.QueryClientStatesResponse = module.exports.QueryClientStatesRequest = module.exports.QueryClientStateResponse = module.exports.QueryClientStateRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $axIO3 = parcelRequire("axIO3");

var $h8Lhn = parcelRequire("h8Lhn");

var $dkaBG = parcelRequire("dkaBG");

const $716e338a02886d66$var$_m0 = $716e338a02886d66$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.client.v1";
function $716e338a02886d66$var$createBaseQueryClientStateRequest() {
    return {
        clientId: ""
    };
}
module.exports.QueryClientStateRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStateRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientStateResponse() {
    return {
        clientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryClientStateResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $axIO3.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $dkaBG.isSet)(object.clientState) ? $axIO3.Any.fromJSON(object.clientState) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $axIO3.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStateResponse();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $axIO3.Any.fromPartial(object.clientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientStatesRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryClientStatesRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStatesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientStatesResponse() {
    return {
        clientStates: [],
        pagination: undefined
    };
}
module.exports.QueryClientStatesResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        for (const v of message.clientStates)$h8Lhn.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientStates.push($h8Lhn.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientStates: Array.isArray(object?.clientStates) ? object.clientStates.map((e)=>$h8Lhn.IdentifiedClientState.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.clientStates) obj.clientStates = message.clientStates.map((e)=>e ? $h8Lhn.IdentifiedClientState.toJSON(e) : undefined);
        else obj.clientStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStatesResponse();
        message.clientStates = object.clientStates?.map((e)=>$h8Lhn.IdentifiedClientState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStateRequest() {
    return {
        clientId: "",
        revisionNumber: $dkaBG.Long.UZERO,
        revisionHeight: $dkaBG.Long.UZERO,
        latestHeight: false
    };
}
module.exports.QueryConsensusStateRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        if (message.latestHeight === true) writer.uint32(32).bool(message.latestHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            revisionNumber: (0, $dkaBG.isSet)(object.revisionNumber) ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO,
            revisionHeight: (0, $dkaBG.isSet)(object.revisionHeight) ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO,
            latestHeight: (0, $dkaBG.isSet)(object.latestHeight) ? Boolean(object.latestHeight) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $dkaBG.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $dkaBG.Long.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateRequest();
        message.clientId = object.clientId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO;
        message.latestHeight = object.latestHeight ?? false;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStateResponse() {
    return {
        consensusState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryConsensusStateResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStatesRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
module.exports.QueryConsensusStatesRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStatesRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStatesResponse() {
    return {
        consensusStates: [],
        pagination: undefined
    };
}
module.exports.QueryConsensusStatesResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        for (const v of message.consensusStates)$h8Lhn.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStates.push($h8Lhn.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>$h8Lhn.ConsensusStateWithHeight.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $h8Lhn.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStatesResponse();
        message.consensusStates = object.consensusStates?.map((e)=>$h8Lhn.ConsensusStateWithHeight.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStateHeightsRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
module.exports.QueryConsensusStateHeightsRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateHeightsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateHeightsRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryConsensusStateHeightsResponse() {
    return {
        consensusStateHeights: [],
        pagination: undefined
    };
}
module.exports.QueryConsensusStateHeightsResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        for (const v of message.consensusStateHeights)$h8Lhn.Height.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateHeightsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStateHeights.push($h8Lhn.Height.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStateHeights: Array.isArray(object?.consensusStateHeights) ? object.consensusStateHeights.map((e)=>$h8Lhn.Height.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStateHeights) obj.consensusStateHeights = message.consensusStateHeights.map((e)=>e ? $h8Lhn.Height.toJSON(e) : undefined);
        else obj.consensusStateHeights = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryConsensusStateHeightsResponse();
        message.consensusStateHeights = object.consensusStateHeights?.map((e)=>$h8Lhn.Height.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientStatusRequest() {
    return {
        clientId: ""
    };
}
module.exports.QueryClientStatusRequest = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStatusRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStatusRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientStatusResponse() {
    return {
        status: ""
    };
}
module.exports.QueryClientStatusResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientStatusResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $dkaBG.isSet)(object.status) ? String(object.status) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientStatusResponse();
        message.status = object.status ?? "";
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientParamsRequest() {
    return {};
}
module.exports.QueryClientParamsRequest = {
    encode (_, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $716e338a02886d66$var$createBaseQueryClientParamsRequest();
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryClientParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryClientParamsResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.params !== undefined) $h8Lhn.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryClientParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $h8Lhn.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $h8Lhn.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $h8Lhn.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryClientParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $h8Lhn.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryUpgradedClientStateRequest() {
    return {};
}
module.exports.QueryUpgradedClientStateRequest = {
    encode (_, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryUpgradedClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $716e338a02886d66$var$createBaseQueryUpgradedClientStateRequest();
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryUpgradedClientStateResponse() {
    return {
        upgradedClientState: undefined
    };
}
module.exports.QueryUpgradedClientStateResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.upgradedClientState !== undefined) $axIO3.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryUpgradedClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedClientState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedClientState: (0, $dkaBG.isSet)(object.upgradedClientState) ? $axIO3.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $axIO3.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $axIO3.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
module.exports.QueryUpgradedConsensusStateRequest = {
    encode (_, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateRequest();
        return message;
    }
};
function $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateResponse() {
    return {
        upgradedConsensusState: undefined
    };
}
module.exports.QueryUpgradedConsensusStateResponse = {
    encode (message, writer = $716e338a02886d66$var$_m0.Writer.create()) {
        if (message.upgradedConsensusState !== undefined) $axIO3.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $716e338a02886d66$var$_m0.Reader ? input : new $716e338a02886d66$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedConsensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedConsensusState: (0, $dkaBG.isSet)(object.upgradedConsensusState) ? $axIO3.Any.fromJSON(object.upgradedConsensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedConsensusState !== undefined && (obj.upgradedConsensusState = message.upgradedConsensusState ? $axIO3.Any.toJSON(message.upgradedConsensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $716e338a02886d66$var$createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState = object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null ? $axIO3.Any.fromPartial(object.upgradedConsensusState) : undefined;
        return message;
    }
};
class $716e338a02886d66$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(request) {
        const data = module.exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data)=>module.exports.QueryClientStateResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ClientStates(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data)=>module.exports.QueryClientStatesResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ConsensusState(request) {
        const data = module.exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data)=>module.exports.QueryConsensusStateResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ConsensusStates(request) {
        const data = module.exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data)=>module.exports.QueryConsensusStatesResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ConsensusStateHeights(request) {
        const data = module.exports.QueryConsensusStateHeightsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
        return promise.then((data)=>module.exports.QueryConsensusStateHeightsResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ClientStatus(request) {
        const data = module.exports.QueryClientStatusRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
        return promise.then((data)=>module.exports.QueryClientStatusResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    ClientParams(request = {}) {
        const data = module.exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data)=>module.exports.QueryClientParamsResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    UpgradedClientState(request = {}) {
        const data = module.exports.QueryUpgradedClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
        return promise.then((data)=>module.exports.QueryUpgradedClientStateResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
    UpgradedConsensusState(request = {}) {
        const data = module.exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
        return promise.then((data)=>module.exports.QueryUpgradedConsensusStateResponse.decode(new $716e338a02886d66$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $716e338a02886d66$var$QueryClientImpl;

});

parcelRegister("5J5Fw", function(module, exports) {
"use strict";
var $42b58d66d4af76cf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $42b58d66d4af76cf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $42b58d66d4af76cf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $42b58d66d4af76cf$var$__createBinding(result, mod, k);
    }
    $42b58d66d4af76cf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryConnectionParamsResponse = module.exports.QueryConnectionParamsRequest = module.exports.QueryConnectionConsensusStateResponse = module.exports.QueryConnectionConsensusStateRequest = module.exports.QueryConnectionClientStateResponse = module.exports.QueryConnectionClientStateRequest = module.exports.QueryClientConnectionsResponse = module.exports.QueryClientConnectionsRequest = module.exports.QueryConnectionsResponse = module.exports.QueryConnectionsRequest = module.exports.QueryConnectionResponse = module.exports.QueryConnectionRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $jspzs = parcelRequire("jspzs");

var $h8Lhn = parcelRequire("h8Lhn");

var $axIO3 = parcelRequire("axIO3");

var $dkaBG = parcelRequire("dkaBG");

const $42b58d66d4af76cf$var$_m0 = $42b58d66d4af76cf$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.core.connection.v1";
function $42b58d66d4af76cf$var$createBaseQueryConnectionRequest() {
    return {
        connectionId: ""
    };
}
module.exports.QueryConnectionRequest = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionResponse() {
    return {
        connection: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryConnectionResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.connection !== undefined) $jspzs.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = $jspzs.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $dkaBG.isSet)(object.connection) ? $jspzs.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection ? $jspzs.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionResponse();
        message.connection = object.connection !== undefined && object.connection !== null ? $jspzs.ConnectionEnd.fromPartial(object.connection) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionsRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QueryConnectionsRequest = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionsResponse() {
    return {
        connections: [],
        pagination: undefined,
        height: undefined
    };
}
module.exports.QueryConnectionsResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        for (const v of message.connections)$jspzs.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $h8Lhn.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connections.push($jspzs.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connections: Array.isArray(object?.connections) ? object.connections.map((e)=>$jspzs.IdentifiedConnection.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $h8Lhn.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connections) obj.connections = message.connections.map((e)=>e ? $jspzs.IdentifiedConnection.toJSON(e) : undefined);
        else obj.connections = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $h8Lhn.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionsResponse();
        message.connections = object.connections?.map((e)=>$jspzs.IdentifiedConnection.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $h8Lhn.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryClientConnectionsRequest() {
    return {
        clientId: ""
    };
}
module.exports.QueryClientConnectionsRequest = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryClientConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryClientConnectionsRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryClientConnectionsResponse() {
    return {
        connectionPaths: [],
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryClientConnectionsResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        for (const v of message.connectionPaths)writer.uint32(10).string(v);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryClientConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionPaths: Array.isArray(object?.connectionPaths) ? object.connectionPaths.map((e)=>String(e)) : [],
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connectionPaths) obj.connectionPaths = message.connectionPaths.map((e)=>e);
        else obj.connectionPaths = [];
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryClientConnectionsResponse();
        message.connectionPaths = object.connectionPaths?.map((e)=>e) || [];
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateRequest() {
    return {
        connectionId: ""
    };
}
module.exports.QueryConnectionClientStateRequest = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryConnectionClientStateResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $h8Lhn.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $h8Lhn.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $dkaBG.isSet)(object.identifiedClientState) ? $h8Lhn.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $h8Lhn.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $h8Lhn.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateRequest() {
    return {
        connectionId: "",
        revisionNumber: $dkaBG.Long.UZERO,
        revisionHeight: $dkaBG.Long.UZERO
    };
}
module.exports.QueryConnectionConsensusStateRequest = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $dkaBG.isSet)(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: (0, $dkaBG.isSet)(object.revisionNumber) ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO,
            revisionHeight: (0, $dkaBG.isSet)(object.revisionHeight) ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $dkaBG.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateRequest();
        message.connectionId = object.connectionId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $dkaBG.Long.fromValue(object.revisionNumber) : $dkaBG.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $dkaBG.Long.fromValue(object.revisionHeight) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
module.exports.QueryConnectionConsensusStateResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $axIO3.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $h8Lhn.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $dkaBG.isSet)(object.consensusState) ? $axIO3.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $dkaBG.isSet)(object.proof) ? (0, $dkaBG.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $dkaBG.isSet)(object.proofHeight) ? $h8Lhn.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $axIO3.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $dkaBG.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $h8Lhn.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $axIO3.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $h8Lhn.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionParamsRequest() {
    return {};
}
module.exports.QueryConnectionParamsRequest = {
    encode (_, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionParamsRequest();
        return message;
    }
};
function $42b58d66d4af76cf$var$createBaseQueryConnectionParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryConnectionParamsResponse = {
    encode (message, writer = $42b58d66d4af76cf$var$_m0.Writer.create()) {
        if (message.params !== undefined) $h8Lhn.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42b58d66d4af76cf$var$_m0.Reader ? input : new $42b58d66d4af76cf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $h8Lhn.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $h8Lhn.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $h8Lhn.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42b58d66d4af76cf$var$createBaseQueryConnectionParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $h8Lhn.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $42b58d66d4af76cf$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
        this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(request) {
        const data = module.exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data)=>module.exports.QueryConnectionResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
    Connections(request = {
        pagination: undefined
    }) {
        const data = module.exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data)=>module.exports.QueryConnectionsResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
    ClientConnections(request) {
        const data = module.exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data)=>module.exports.QueryClientConnectionsResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = module.exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data)=>module.exports.QueryConnectionClientStateResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = module.exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data)=>module.exports.QueryConnectionConsensusStateResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
    ConnectionParams(request = {}) {
        const data = module.exports.QueryConnectionParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
        return promise.then((data)=>module.exports.QueryConnectionParamsResponse.decode(new $42b58d66d4af76cf$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $42b58d66d4af76cf$var$QueryClientImpl;

});

parcelRegister("2uXkL", function(module, exports) {
"use strict";
var $1d1c689bf31381c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d1c689bf31381c7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1d1c689bf31381c7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1d1c689bf31381c7$var$__createBinding(result, mod, k);
    }
    $1d1c689bf31381c7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Fraction = module.exports.Header = module.exports.Misbehaviour = module.exports.ConsensusState = module.exports.ClientState = module.exports.protobufPackage = void 0;

var $jBPGv = parcelRequire("jBPGv");

var $h8Lhn = parcelRequire("h8Lhn");

var $kaGh3 = parcelRequire("kaGh3");

var $cPgyI = parcelRequire("cPgyI");

var $43wjC = parcelRequire("43wjC");

var $DRMtG = parcelRequire("DRMtG");

var $5ngWm = parcelRequire("5ngWm");

var $dkaBG = parcelRequire("dkaBG");

const $1d1c689bf31381c7$var$_m0 = $1d1c689bf31381c7$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function $1d1c689bf31381c7$var$createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false
    };
}
module.exports.ClientState = {
    encode (message, writer = $1d1c689bf31381c7$var$_m0.Writer.create()) {
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) module.exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $jBPGv.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $jBPGv.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $jBPGv.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $h8Lhn.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $h8Lhn.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        for (const v of message.proofSpecs)$kaGh3.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        for (const v of message.upgradePath)writer.uint32(74).string(v);
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1d1c689bf31381c7$var$_m0.Reader ? input : new $1d1c689bf31381c7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1d1c689bf31381c7$var$createBaseClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = module.exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($kaGh3.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chainId: (0, $dkaBG.isSet)(object.chainId) ? String(object.chainId) : "",
            trustLevel: (0, $dkaBG.isSet)(object.trustLevel) ? module.exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: (0, $dkaBG.isSet)(object.trustingPeriod) ? $jBPGv.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: (0, $dkaBG.isSet)(object.unbondingPeriod) ? $jBPGv.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: (0, $dkaBG.isSet)(object.maxClockDrift) ? $jBPGv.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: (0, $dkaBG.isSet)(object.frozenHeight) ? $h8Lhn.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: (0, $dkaBG.isSet)(object.latestHeight) ? $h8Lhn.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object?.proofSpecs) ? object.proofSpecs.map((e)=>$kaGh3.ProofSpec.fromJSON(e)) : [],
            upgradePath: Array.isArray(object?.upgradePath) ? object.upgradePath.map((e)=>String(e)) : [],
            allowUpdateAfterExpiry: (0, $dkaBG.isSet)(object.allowUpdateAfterExpiry) ? Boolean(object.allowUpdateAfterExpiry) : false,
            allowUpdateAfterMisbehaviour: (0, $dkaBG.isSet)(object.allowUpdateAfterMisbehaviour) ? Boolean(object.allowUpdateAfterMisbehaviour) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? module.exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $jBPGv.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $jBPGv.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $jBPGv.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $h8Lhn.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $h8Lhn.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map((e)=>e ? $kaGh3.ProofSpec.toJSON(e) : undefined);
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map((e)=>e);
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial (object) {
        const message = $1d1c689bf31381c7$var$createBaseClientState();
        message.chainId = object.chainId ?? "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? module.exports.Fraction.fromPartial(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $jBPGv.Duration.fromPartial(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $jBPGv.Duration.fromPartial(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $jBPGv.Duration.fromPartial(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $h8Lhn.Height.fromPartial(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $h8Lhn.Height.fromPartial(object.latestHeight) : undefined;
        message.proofSpecs = object.proofSpecs?.map((e)=>$kaGh3.ProofSpec.fromPartial(e)) || [];
        message.upgradePath = object.upgradePath?.map((e)=>e) || [];
        message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry ?? false;
        message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour ?? false;
        return message;
    }
};
function $1d1c689bf31381c7$var$createBaseConsensusState() {
    return {
        timestamp: undefined,
        root: undefined,
        nextValidatorsHash: new Uint8Array()
    };
}
module.exports.ConsensusState = {
    encode (message, writer = $1d1c689bf31381c7$var$_m0.Writer.create()) {
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $43wjC.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1d1c689bf31381c7$var$_m0.Reader ? input : new $1d1c689bf31381c7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1d1c689bf31381c7$var$createBaseConsensusState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = $43wjC.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined,
            root: (0, $dkaBG.isSet)(object.root) ? $43wjC.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: (0, $dkaBG.isSet)(object.nextValidatorsHash) ? (0, $dkaBG.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? $43wjC.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $dkaBG.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $1d1c689bf31381c7$var$createBaseConsensusState();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $43wjC.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        return message;
    }
};
function $1d1c689bf31381c7$var$createBaseMisbehaviour() {
    return {
        clientId: "",
        header1: undefined,
        header2: undefined
    };
}
module.exports.Misbehaviour = {
    encode (message, writer = $1d1c689bf31381c7$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) module.exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) module.exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1d1c689bf31381c7$var$_m0.Reader ? input : new $1d1c689bf31381c7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1d1c689bf31381c7$var$createBaseMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = module.exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $dkaBG.isSet)(object.clientId) ? String(object.clientId) : "",
            header1: (0, $dkaBG.isSet)(object.header1) ? module.exports.Header.fromJSON(object.header1) : undefined,
            header2: (0, $dkaBG.isSet)(object.header2) ? module.exports.Header.fromJSON(object.header2) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? module.exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? module.exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $1d1c689bf31381c7$var$createBaseMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? module.exports.Header.fromPartial(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? module.exports.Header.fromPartial(object.header2) : undefined;
        return message;
    }
};
function $1d1c689bf31381c7$var$createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined
    };
}
module.exports.Header = {
    encode (message, writer = $1d1c689bf31381c7$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) $DRMtG.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $5ngWm.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $h8Lhn.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $5ngWm.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1d1c689bf31381c7$var$_m0.Reader ? input : new $1d1c689bf31381c7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1d1c689bf31381c7$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $DRMtG.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $5ngWm.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $h8Lhn.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $5ngWm.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $dkaBG.isSet)(object.signedHeader) ? $DRMtG.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $dkaBG.isSet)(object.validatorSet) ? $5ngWm.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: (0, $dkaBG.isSet)(object.trustedHeight) ? $h8Lhn.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: (0, $dkaBG.isSet)(object.trustedValidators) ? $5ngWm.ValidatorSet.fromJSON(object.trustedValidators) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $DRMtG.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $5ngWm.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $h8Lhn.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $5ngWm.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $1d1c689bf31381c7$var$createBaseHeader();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $DRMtG.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $5ngWm.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $h8Lhn.Height.fromPartial(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $5ngWm.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
        return message;
    }
};
function $1d1c689bf31381c7$var$createBaseFraction() {
    return {
        numerator: $dkaBG.Long.UZERO,
        denominator: $dkaBG.Long.UZERO
    };
}
module.exports.Fraction = {
    encode (message, writer = $1d1c689bf31381c7$var$_m0.Writer.create()) {
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1d1c689bf31381c7$var$_m0.Reader ? input : new $1d1c689bf31381c7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1d1c689bf31381c7$var$createBaseFraction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            numerator: (0, $dkaBG.isSet)(object.numerator) ? $dkaBG.Long.fromValue(object.numerator) : $dkaBG.Long.UZERO,
            denominator: (0, $dkaBG.isSet)(object.denominator) ? $dkaBG.Long.fromValue(object.denominator) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $dkaBG.Long.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $1d1c689bf31381c7$var$createBaseFraction();
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $dkaBG.Long.fromValue(object.numerator) : $dkaBG.Long.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $dkaBG.Long.fromValue(object.denominator) : $dkaBG.Long.UZERO;
        return message;
    }
};

});
parcelRegister("DRMtG", function(module, exports) {
"use strict";
var $077d5c6654ede61c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $077d5c6654ede61c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $077d5c6654ede61c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $077d5c6654ede61c$var$__createBinding(result, mod, k);
    }
    $077d5c6654ede61c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TxProof = module.exports.BlockMeta = module.exports.LightBlock = module.exports.SignedHeader = module.exports.Proposal = module.exports.CommitSig = module.exports.Commit = module.exports.Vote = module.exports.Data = module.exports.Header = module.exports.BlockID = module.exports.Part = module.exports.PartSetHeader = module.exports.signedMsgTypeToJSON = module.exports.signedMsgTypeFromJSON = module.exports.SignedMsgType = module.exports.blockIDFlagToJSON = module.exports.blockIDFlagFromJSON = module.exports.BlockIDFlag = module.exports.protobufPackage = void 0;

var $lXxYr = parcelRequire("lXxYr");

var $hTeH3 = parcelRequire("hTeH3");

var $cPgyI = parcelRequire("cPgyI");

var $5ngWm = parcelRequire("5ngWm");

var $dkaBG = parcelRequire("dkaBG");

const $077d5c6654ede61c$var$_m0 = $077d5c6654ede61c$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $077d5c6654ede61c$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($077d5c6654ede61c$var$BlockIDFlag = module.exports.BlockIDFlag || (module.exports.BlockIDFlag = {}));
function $077d5c6654ede61c$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $077d5c6654ede61c$var$BlockIDFlag.UNRECOGNIZED;
    }
}
module.exports.blockIDFlagFromJSON = $077d5c6654ede61c$var$blockIDFlagFromJSON;
function $077d5c6654ede61c$var$blockIDFlagToJSON(object) {
    switch(object){
        case $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $077d5c6654ede61c$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case $077d5c6654ede61c$var$BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.blockIDFlagToJSON = $077d5c6654ede61c$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $077d5c6654ede61c$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($077d5c6654ede61c$var$SignedMsgType = module.exports.SignedMsgType || (module.exports.SignedMsgType = {}));
function $077d5c6654ede61c$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $077d5c6654ede61c$var$SignedMsgType.UNRECOGNIZED;
    }
}
module.exports.signedMsgTypeFromJSON = $077d5c6654ede61c$var$signedMsgTypeFromJSON;
function $077d5c6654ede61c$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $077d5c6654ede61c$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case $077d5c6654ede61c$var$SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.signedMsgTypeToJSON = $077d5c6654ede61c$var$signedMsgTypeToJSON;
function $077d5c6654ede61c$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
module.exports.PartSetHeader = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBasePartSetHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $dkaBG.isSet)(object.total) ? Number(object.total) : 0,
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBasePartSetHeader();
        message.total = object.total ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $077d5c6654ede61c$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
module.exports.Part = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $lXxYr.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBasePart();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $lXxYr.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $dkaBG.isSet)(object.index) ? Number(object.index) : 0,
            bytes: (0, $dkaBG.isSet)(object.bytes) ? (0, $dkaBG.bytesFromBase64)(object.bytes) : new Uint8Array(),
            proof: (0, $dkaBG.isSet)(object.proof) ? $lXxYr.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = (0, $dkaBG.base64FromBytes)(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $lXxYr.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBasePart();
        message.index = object.index ?? 0;
        message.bytes = object.bytes ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $lXxYr.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
module.exports.BlockID = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) module.exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseBlockID();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = module.exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array(),
            partSetHeader: (0, $dkaBG.isSet)(object.partSetHeader) ? module.exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? module.exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseBlockID();
        message.hash = object.hash ?? new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? module.exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: $dkaBG.Long.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
module.exports.Header = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.version !== undefined) $hTeH3.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) module.exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $hTeH3.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $dkaBG.isSet)(object.version) ? $hTeH3.Consensus.fromJSON(object.version) : undefined,
            chainId: (0, $dkaBG.isSet)(object.chainId) ? String(object.chainId) : "",
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            lastBlockId: (0, $dkaBG.isSet)(object.lastBlockId) ? module.exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: (0, $dkaBG.isSet)(object.lastCommitHash) ? (0, $dkaBG.bytesFromBase64)(object.lastCommitHash) : new Uint8Array(),
            dataHash: (0, $dkaBG.isSet)(object.dataHash) ? (0, $dkaBG.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            validatorsHash: (0, $dkaBG.isSet)(object.validatorsHash) ? (0, $dkaBG.bytesFromBase64)(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: (0, $dkaBG.isSet)(object.nextValidatorsHash) ? (0, $dkaBG.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: (0, $dkaBG.isSet)(object.consensusHash) ? (0, $dkaBG.bytesFromBase64)(object.consensusHash) : new Uint8Array(),
            appHash: (0, $dkaBG.isSet)(object.appHash) ? (0, $dkaBG.bytesFromBase64)(object.appHash) : new Uint8Array(),
            lastResultsHash: (0, $dkaBG.isSet)(object.lastResultsHash) ? (0, $dkaBG.bytesFromBase64)(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: (0, $dkaBG.isSet)(object.evidenceHash) ? (0, $dkaBG.bytesFromBase64)(object.evidenceHash) : new Uint8Array(),
            proposerAddress: (0, $dkaBG.isSet)(object.proposerAddress) ? (0, $dkaBG.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $hTeH3.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? module.exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = (0, $dkaBG.base64FromBytes)(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = (0, $dkaBG.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = (0, $dkaBG.base64FromBytes)(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $dkaBG.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = (0, $dkaBG.base64FromBytes)(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = (0, $dkaBG.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = (0, $dkaBG.base64FromBytes)(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = (0, $dkaBG.base64FromBytes)(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $dkaBG.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $hTeH3.Consensus.fromPartial(object.version) : undefined;
        message.chainId = object.chainId ?? "";
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? module.exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = object.lastCommitHash ?? new Uint8Array();
        message.dataHash = object.dataHash ?? new Uint8Array();
        message.validatorsHash = object.validatorsHash ?? new Uint8Array();
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.consensusHash = object.consensusHash ?? new Uint8Array();
        message.appHash = object.appHash ?? new Uint8Array();
        message.lastResultsHash = object.lastResultsHash ?? new Uint8Array();
        message.evidenceHash = object.evidenceHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseData() {
    return {
        txs: []
    };
}
module.exports.Data = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseData();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseVote() {
    return {
        type: 0,
        height: $dkaBG.Long.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
module.exports.Vote = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? $077d5c6654ede61c$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            round: (0, $dkaBG.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $dkaBG.isSet)(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined,
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? (0, $dkaBG.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            validatorIndex: (0, $dkaBG.isSet)(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: (0, $dkaBG.isSet)(object.signature) ? (0, $dkaBG.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $077d5c6654ede61c$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $dkaBG.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = (0, $dkaBG.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseVote();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.validatorIndex = object.validatorIndex ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseCommit() {
    return {
        height: $dkaBG.Long.ZERO,
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
module.exports.Commit = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)module.exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push(module.exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            round: (0, $dkaBG.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $dkaBG.isSet)(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>module.exports.CommitSig.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? module.exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseCommit();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = object.signatures?.map((e)=>module.exports.CommitSig.fromPartial(e)) || [];
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.CommitSig = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseCommitSig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockIdFlag: (0, $dkaBG.isSet)(object.blockIdFlag) ? $077d5c6654ede61c$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? (0, $dkaBG.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $dkaBG.isSet)(object.signature) ? (0, $dkaBG.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $077d5c6654ede61c$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $dkaBG.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $dkaBG.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseCommitSig();
        message.blockIdFlag = object.blockIdFlag ?? 0;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseProposal() {
    return {
        type: 0,
        height: $dkaBG.Long.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
module.exports.Proposal = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? $077d5c6654ede61c$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            round: (0, $dkaBG.isSet)(object.round) ? Number(object.round) : 0,
            polRound: (0, $dkaBG.isSet)(object.polRound) ? Number(object.polRound) : 0,
            blockId: (0, $dkaBG.isSet)(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $dkaBG.isSet)(object.signature) ? (0, $dkaBG.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $077d5c6654ede61c$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $dkaBG.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseProposal();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.round = object.round ?? 0;
        message.polRound = object.polRound ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
module.exports.SignedHeader = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) module.exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseSignedHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = module.exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $dkaBG.isSet)(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            commit: (0, $dkaBG.isSet)(object.commit) ? module.exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? module.exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
module.exports.LightBlock = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) module.exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $5ngWm.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseLightBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = module.exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $5ngWm.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $dkaBG.isSet)(object.signedHeader) ? module.exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $dkaBG.isSet)(object.validatorSet) ? $5ngWm.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? module.exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $5ngWm.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? module.exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $5ngWm.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: $dkaBG.Long.ZERO,
        header: undefined,
        numTxs: $dkaBG.Long.ZERO
    };
}
module.exports.BlockMeta = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.blockId !== undefined) module.exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) module.exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseBlockMeta();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = module.exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = module.exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockId: (0, $dkaBG.isSet)(object.blockId) ? module.exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: (0, $dkaBG.isSet)(object.blockSize) ? $dkaBG.Long.fromValue(object.blockSize) : $dkaBG.Long.ZERO,
            header: (0, $dkaBG.isSet)(object.header) ? module.exports.Header.fromJSON(object.header) : undefined,
            numTxs: (0, $dkaBG.isSet)(object.numTxs) ? $dkaBG.Long.fromValue(object.numTxs) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? module.exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $dkaBG.Long.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? module.exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? module.exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $dkaBG.Long.fromValue(object.blockSize) : $dkaBG.Long.ZERO;
        message.header = object.header !== undefined && object.header !== null ? module.exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $dkaBG.Long.fromValue(object.numTxs) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $077d5c6654ede61c$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
module.exports.TxProof = {
    encode (message, writer = $077d5c6654ede61c$var$_m0.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $lXxYr.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $077d5c6654ede61c$var$_m0.Reader ? input : new $077d5c6654ede61c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $077d5c6654ede61c$var$createBaseTxProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $lXxYr.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rootHash: (0, $dkaBG.isSet)(object.rootHash) ? (0, $dkaBG.bytesFromBase64)(object.rootHash) : new Uint8Array(),
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            proof: (0, $dkaBG.isSet)(object.proof) ? $lXxYr.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = (0, $dkaBG.base64FromBytes)(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $lXxYr.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $077d5c6654ede61c$var$createBaseTxProof();
        message.rootHash = object.rootHash ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $lXxYr.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};

});
parcelRegister("lXxYr", function(module, exports) {
"use strict";
var $ffc97626c3b8d73a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ffc97626c3b8d73a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ffc97626c3b8d73a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ffc97626c3b8d73a$var$__createBinding(result, mod, k);
    }
    $ffc97626c3b8d73a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProofOps = module.exports.ProofOp = module.exports.DominoOp = module.exports.ValueOp = module.exports.Proof = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $ffc97626c3b8d73a$var$_m0 = $ffc97626c3b8d73a$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.crypto";
function $ffc97626c3b8d73a$var$createBaseProof() {
    return {
        total: $dkaBG.Long.ZERO,
        index: $dkaBG.Long.ZERO,
        leafHash: new Uint8Array(),
        aunts: []
    };
}
module.exports.Proof = {
    encode (message, writer = $ffc97626c3b8d73a$var$_m0.Writer.create()) {
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffc97626c3b8d73a$var$_m0.Reader ? input : new $ffc97626c3b8d73a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ffc97626c3b8d73a$var$createBaseProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $dkaBG.isSet)(object.total) ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.ZERO,
            index: (0, $dkaBG.isSet)(object.index) ? $dkaBG.Long.fromValue(object.index) : $dkaBG.Long.ZERO,
            leafHash: (0, $dkaBG.isSet)(object.leafHash) ? (0, $dkaBG.bytesFromBase64)(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object?.aunts) ? object.aunts.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || $dkaBG.Long.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $dkaBG.Long.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = (0, $dkaBG.base64FromBytes)(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ffc97626c3b8d73a$var$createBaseProof();
        message.total = object.total !== undefined && object.total !== null ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $dkaBG.Long.fromValue(object.index) : $dkaBG.Long.ZERO;
        message.leafHash = object.leafHash ?? new Uint8Array();
        message.aunts = object.aunts?.map((e)=>e) || [];
        return message;
    }
};
function $ffc97626c3b8d73a$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
module.exports.ValueOp = {
    encode (message, writer = $ffc97626c3b8d73a$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) module.exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffc97626c3b8d73a$var$_m0.Reader ? input : new $ffc97626c3b8d73a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ffc97626c3b8d73a$var$createBaseValueOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = module.exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            proof: (0, $dkaBG.isSet)(object.proof) ? module.exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? module.exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ffc97626c3b8d73a$var$createBaseValueOp();
        message.key = object.key ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? module.exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $ffc97626c3b8d73a$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
module.exports.DominoOp = {
    encode (message, writer = $ffc97626c3b8d73a$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffc97626c3b8d73a$var$_m0.Reader ? input : new $ffc97626c3b8d73a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ffc97626c3b8d73a$var$createBaseDominoOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? String(object.key) : "",
            input: (0, $dkaBG.isSet)(object.input) ? String(object.input) : "",
            output: (0, $dkaBG.isSet)(object.output) ? String(object.output) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        const message = $ffc97626c3b8d73a$var$createBaseDominoOp();
        message.key = object.key ?? "";
        message.input = object.input ?? "";
        message.output = object.output ?? "";
        return message;
    }
};
function $ffc97626c3b8d73a$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
module.exports.ProofOp = {
    encode (message, writer = $ffc97626c3b8d73a$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffc97626c3b8d73a$var$_m0.Reader ? input : new $ffc97626c3b8d73a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ffc97626c3b8d73a$var$createBaseProofOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? String(object.type) : "",
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $ffc97626c3b8d73a$var$createBaseProofOp();
        message.type = object.type ?? "";
        message.key = object.key ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $ffc97626c3b8d73a$var$createBaseProofOps() {
    return {
        ops: []
    };
}
module.exports.ProofOps = {
    encode (message, writer = $ffc97626c3b8d73a$var$_m0.Writer.create()) {
        for (const v of message.ops)module.exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ffc97626c3b8d73a$var$_m0.Reader ? input : new $ffc97626c3b8d73a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ffc97626c3b8d73a$var$createBaseProofOps();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push(module.exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ops: Array.isArray(object?.ops) ? object.ops.map((e)=>module.exports.ProofOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? module.exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ffc97626c3b8d73a$var$createBaseProofOps();
        message.ops = object.ops?.map((e)=>module.exports.ProofOp.fromPartial(e)) || [];
        return message;
    }
};

});

parcelRegister("hTeH3", function(module, exports) {
"use strict";
var $d062f8845ba550b1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d062f8845ba550b1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d062f8845ba550b1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d062f8845ba550b1$var$__createBinding(result, mod, k);
    }
    $d062f8845ba550b1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Consensus = module.exports.App = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $d062f8845ba550b1$var$_m0 = $d062f8845ba550b1$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.version";
function $d062f8845ba550b1$var$createBaseApp() {
    return {
        protocol: $dkaBG.Long.UZERO,
        software: ""
    };
}
module.exports.App = {
    encode (message, writer = $d062f8845ba550b1$var$_m0.Writer.create()) {
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d062f8845ba550b1$var$_m0.Reader ? input : new $d062f8845ba550b1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d062f8845ba550b1$var$createBaseApp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            protocol: (0, $dkaBG.isSet)(object.protocol) ? $dkaBG.Long.fromValue(object.protocol) : $dkaBG.Long.UZERO,
            software: (0, $dkaBG.isSet)(object.software) ? String(object.software) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $dkaBG.Long.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        const message = $d062f8845ba550b1$var$createBaseApp();
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $dkaBG.Long.fromValue(object.protocol) : $dkaBG.Long.UZERO;
        message.software = object.software ?? "";
        return message;
    }
};
function $d062f8845ba550b1$var$createBaseConsensus() {
    return {
        block: $dkaBG.Long.UZERO,
        app: $dkaBG.Long.UZERO
    };
}
module.exports.Consensus = {
    encode (message, writer = $d062f8845ba550b1$var$_m0.Writer.create()) {
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d062f8845ba550b1$var$_m0.Reader ? input : new $d062f8845ba550b1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d062f8845ba550b1$var$createBaseConsensus();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $dkaBG.isSet)(object.block) ? $dkaBG.Long.fromValue(object.block) : $dkaBG.Long.UZERO,
            app: (0, $dkaBG.isSet)(object.app) ? $dkaBG.Long.fromValue(object.app) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || $dkaBG.Long.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $d062f8845ba550b1$var$createBaseConsensus();
        message.block = object.block !== undefined && object.block !== null ? $dkaBG.Long.fromValue(object.block) : $dkaBG.Long.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $dkaBG.Long.fromValue(object.app) : $dkaBG.Long.UZERO;
        return message;
    }
};

});

parcelRegister("5ngWm", function(module, exports) {
"use strict";
var $3e9c3db75ae6d3a7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3e9c3db75ae6d3a7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3e9c3db75ae6d3a7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3e9c3db75ae6d3a7$var$__createBinding(result, mod, k);
    }
    $3e9c3db75ae6d3a7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleValidator = module.exports.Validator = module.exports.ValidatorSet = module.exports.protobufPackage = void 0;

var $6SnRp = parcelRequire("6SnRp");

var $dkaBG = parcelRequire("dkaBG");

const $3e9c3db75ae6d3a7$var$_m0 = $3e9c3db75ae6d3a7$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.types";
function $3e9c3db75ae6d3a7$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: $dkaBG.Long.ZERO
    };
}
module.exports.ValidatorSet = {
    encode (message, writer = $3e9c3db75ae6d3a7$var$_m0.Writer.create()) {
        for (const v of message.validators)module.exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) module.exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3e9c3db75ae6d3a7$var$_m0.Reader ? input : new $3e9c3db75ae6d3a7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3e9c3db75ae6d3a7$var$createBaseValidatorSet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>module.exports.Validator.fromJSON(e)) : [],
            proposer: (0, $dkaBG.isSet)(object.proposer) ? module.exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: (0, $dkaBG.isSet)(object.totalVotingPower) ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? module.exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $3e9c3db75ae6d3a7$var$createBaseValidatorSet();
        message.validators = object.validators?.map((e)=>module.exports.Validator.fromPartial(e)) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? module.exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $3e9c3db75ae6d3a7$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: $dkaBG.Long.ZERO,
        proposerPriority: $dkaBG.Long.ZERO
    };
}
module.exports.Validator = {
    encode (message, writer = $3e9c3db75ae6d3a7$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $6SnRp.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3e9c3db75ae6d3a7$var$_m0.Reader ? input : new $3e9c3db75ae6d3a7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3e9c3db75ae6d3a7$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $6SnRp.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? (0, $dkaBG.bytesFromBase64)(object.address) : new Uint8Array(),
            pubKey: (0, $dkaBG.isSet)(object.pubKey) ? $6SnRp.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $dkaBG.isSet)(object.votingPower) ? $dkaBG.Long.fromValue(object.votingPower) : $dkaBG.Long.ZERO,
            proposerPriority: (0, $dkaBG.isSet)(object.proposerPriority) ? $dkaBG.Long.fromValue(object.proposerPriority) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $dkaBG.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $6SnRp.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $dkaBG.Long.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $3e9c3db75ae6d3a7$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $6SnRp.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $dkaBG.Long.fromValue(object.votingPower) : $dkaBG.Long.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $dkaBG.Long.fromValue(object.proposerPriority) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $3e9c3db75ae6d3a7$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: $dkaBG.Long.ZERO
    };
}
module.exports.SimpleValidator = {
    encode (message, writer = $3e9c3db75ae6d3a7$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $6SnRp.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3e9c3db75ae6d3a7$var$_m0.Reader ? input : new $3e9c3db75ae6d3a7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3e9c3db75ae6d3a7$var$createBaseSimpleValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $6SnRp.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $dkaBG.isSet)(object.pubKey) ? $6SnRp.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $dkaBG.isSet)(object.votingPower) ? $dkaBG.Long.fromValue(object.votingPower) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $6SnRp.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $3e9c3db75ae6d3a7$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $6SnRp.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $dkaBG.Long.fromValue(object.votingPower) : $dkaBG.Long.ZERO;
        return message;
    }
};

});
parcelRegister("6SnRp", function(module, exports) {
"use strict";
var $501a4b6d12ffb25c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $501a4b6d12ffb25c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $501a4b6d12ffb25c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $501a4b6d12ffb25c$var$__createBinding(result, mod, k);
    }
    $501a4b6d12ffb25c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.protobufPackage = void 0;

/* eslint-disable */ const $501a4b6d12ffb25c$var$_m0 = $501a4b6d12ffb25c$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "tendermint.crypto";
function $501a4b6d12ffb25c$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
module.exports.PublicKey = {
    encode (message, writer = $501a4b6d12ffb25c$var$_m0.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $501a4b6d12ffb25c$var$_m0.Reader ? input : new $501a4b6d12ffb25c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $501a4b6d12ffb25c$var$createBasePublicKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ed25519: (0, $dkaBG.isSet)(object.ed25519) ? (0, $dkaBG.bytesFromBase64)(object.ed25519) : undefined,
            secp256k1: (0, $dkaBG.isSet)(object.secp256k1) ? (0, $dkaBG.bytesFromBase64)(object.secp256k1) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? (0, $dkaBG.base64FromBytes)(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? (0, $dkaBG.base64FromBytes)(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $501a4b6d12ffb25c$var$createBasePublicKey();
        message.ed25519 = object.ed25519 ?? undefined;
        message.secp256k1 = object.secp256k1 ?? undefined;
        return message;
    }
};

});





parcelRegister("8L7fW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupMintExtension = void 0;

var $hm8y1 = parcelRequire("hm8y1");

var $aq34C = parcelRequire("aq34C");

var $5E3xG = parcelRequire("5E3xG");
function $6608576d3d68db8d$var$setupMintExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $aq34C.QueryClientImpl(rpc);
    return {
        mint: {
            params: async ()=>{
                const { params: params } = await queryService.Params({});
                (0, $hm8y1.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, $5E3xG.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, $5E3xG.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, $5E3xG.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, $5E3xG.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom
                };
            },
            inflation: async ()=>{
                const { inflation: inflation } = await queryService.Inflation({});
                return (0, $5E3xG.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async ()=>{
                const { annualProvisions: annualProvisions } = await queryService.AnnualProvisions({});
                return (0, $5E3xG.decodeCosmosSdkDecFromProto)(annualProvisions);
            }
        }
    };
}
module.exports.setupMintExtension = $6608576d3d68db8d$var$setupMintExtension;

});
parcelRegister("aq34C", function(module, exports) {
"use strict";
var $795eb768bd851838$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $795eb768bd851838$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $795eb768bd851838$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $795eb768bd851838$var$__createBinding(result, mod, k);
    }
    $795eb768bd851838$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryAnnualProvisionsResponse = module.exports.QueryAnnualProvisionsRequest = module.exports.QueryInflationResponse = module.exports.QueryInflationRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.protobufPackage = void 0;

var $iBGJO = parcelRequire("iBGJO");

const $795eb768bd851838$var$_m0 = $795eb768bd851838$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.mint.v1beta1";
function $795eb768bd851838$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $795eb768bd851838$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $795eb768bd851838$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        if (message.params !== undefined) $iBGJO.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $iBGJO.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $iBGJO.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $iBGJO.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $795eb768bd851838$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $iBGJO.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $795eb768bd851838$var$createBaseQueryInflationRequest() {
    return {};
}
module.exports.QueryInflationRequest = {
    encode (_, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryInflationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $795eb768bd851838$var$createBaseQueryInflationRequest();
        return message;
    }
};
function $795eb768bd851838$var$createBaseQueryInflationResponse() {
    return {
        inflation: new Uint8Array()
    };
}
module.exports.QueryInflationResponse = {
    encode (message, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        if (message.inflation.length !== 0) writer.uint32(10).bytes(message.inflation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryInflationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $dkaBG.isSet)(object.inflation) ? (0, $dkaBG.bytesFromBase64)(object.inflation) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = (0, $dkaBG.base64FromBytes)(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $795eb768bd851838$var$createBaseQueryInflationResponse();
        message.inflation = object.inflation ?? new Uint8Array();
        return message;
    }
};
function $795eb768bd851838$var$createBaseQueryAnnualProvisionsRequest() {
    return {};
}
module.exports.QueryAnnualProvisionsRequest = {
    encode (_, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryAnnualProvisionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $795eb768bd851838$var$createBaseQueryAnnualProvisionsRequest();
        return message;
    }
};
function $795eb768bd851838$var$createBaseQueryAnnualProvisionsResponse() {
    return {
        annualProvisions: new Uint8Array()
    };
}
module.exports.QueryAnnualProvisionsResponse = {
    encode (message, writer = $795eb768bd851838$var$_m0.Writer.create()) {
        if (message.annualProvisions.length !== 0) writer.uint32(10).bytes(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $795eb768bd851838$var$_m0.Reader ? input : new $795eb768bd851838$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $795eb768bd851838$var$createBaseQueryAnnualProvisionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            annualProvisions: (0, $dkaBG.isSet)(object.annualProvisions) ? (0, $dkaBG.bytesFromBase64)(object.annualProvisions) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.annualProvisions !== undefined && (obj.annualProvisions = (0, $dkaBG.base64FromBytes)(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $795eb768bd851838$var$createBaseQueryAnnualProvisionsResponse();
        message.annualProvisions = object.annualProvisions ?? new Uint8Array();
        return message;
    }
};
class $795eb768bd851838$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $795eb768bd851838$var$_m0.Reader(data)));
    }
    Inflation(request = {}) {
        const data = module.exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data)=>module.exports.QueryInflationResponse.decode(new $795eb768bd851838$var$_m0.Reader(data)));
    }
    AnnualProvisions(request = {}) {
        const data = module.exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data)=>module.exports.QueryAnnualProvisionsResponse.decode(new $795eb768bd851838$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $795eb768bd851838$var$QueryClientImpl;

});
parcelRegister("iBGJO", function(module, exports) {
"use strict";
var $d8bcd58a8167fc99$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d8bcd58a8167fc99$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d8bcd58a8167fc99$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d8bcd58a8167fc99$var$__createBinding(result, mod, k);
    }
    $d8bcd58a8167fc99$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.Minter = module.exports.protobufPackage = void 0;

var $dkaBG = parcelRequire("dkaBG");

const $d8bcd58a8167fc99$var$_m0 = $d8bcd58a8167fc99$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.mint.v1beta1";
function $d8bcd58a8167fc99$var$createBaseMinter() {
    return {
        inflation: "",
        annualProvisions: ""
    };
}
module.exports.Minter = {
    encode (message, writer = $d8bcd58a8167fc99$var$_m0.Writer.create()) {
        if (message.inflation !== "") writer.uint32(10).string(message.inflation);
        if (message.annualProvisions !== "") writer.uint32(18).string(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8bcd58a8167fc99$var$_m0.Reader ? input : new $d8bcd58a8167fc99$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8bcd58a8167fc99$var$createBaseMinter();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $dkaBG.isSet)(object.inflation) ? String(object.inflation) : "",
            annualProvisions: (0, $dkaBG.isSet)(object.annualProvisions) ? String(object.annualProvisions) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial (object) {
        const message = $d8bcd58a8167fc99$var$createBaseMinter();
        message.inflation = object.inflation ?? "";
        message.annualProvisions = object.annualProvisions ?? "";
        return message;
    }
};
function $d8bcd58a8167fc99$var$createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: $dkaBG.Long.UZERO
    };
}
module.exports.Params = {
    encode (message, writer = $d8bcd58a8167fc99$var$_m0.Writer.create()) {
        if (message.mintDenom !== "") writer.uint32(10).string(message.mintDenom);
        if (message.inflationRateChange !== "") writer.uint32(18).string(message.inflationRateChange);
        if (message.inflationMax !== "") writer.uint32(26).string(message.inflationMax);
        if (message.inflationMin !== "") writer.uint32(34).string(message.inflationMin);
        if (message.goalBonded !== "") writer.uint32(42).string(message.goalBonded);
        if (!message.blocksPerYear.isZero()) writer.uint32(48).uint64(message.blocksPerYear);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d8bcd58a8167fc99$var$_m0.Reader ? input : new $d8bcd58a8167fc99$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d8bcd58a8167fc99$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mintDenom: (0, $dkaBG.isSet)(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: (0, $dkaBG.isSet)(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: (0, $dkaBG.isSet)(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: (0, $dkaBG.isSet)(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: (0, $dkaBG.isSet)(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: (0, $dkaBG.isSet)(object.blocksPerYear) ? $dkaBG.Long.fromValue(object.blocksPerYear) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined && (obj.blocksPerYear = (message.blocksPerYear || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $d8bcd58a8167fc99$var$createBaseParams();
        message.mintDenom = object.mintDenom ?? "";
        message.inflationRateChange = object.inflationRateChange ?? "";
        message.inflationMax = object.inflationMax ?? "";
        message.inflationMin = object.inflationMin ?? "";
        message.goalBonded = object.goalBonded ?? "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $dkaBG.Long.fromValue(object.blocksPerYear) : $dkaBG.Long.UZERO;
        return message;
    }
};

});



parcelRegister("5o2o9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSlashingAminoConverters = module.exports.isAminoMsgUnjail = void 0;
function $3ec10bf66d67fb4f$var$isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
module.exports.isAminoMsgUnjail = $3ec10bf66d67fb4f$var$isAminoMsgUnjail;
function $3ec10bf66d67fb4f$var$createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
module.exports.createSlashingAminoConverters = $3ec10bf66d67fb4f$var$createSlashingAminoConverters;

});

parcelRegister("7fA46", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupSlashingExtension = void 0;

var $498LX = parcelRequire("498LX");

var $5E3xG = parcelRequire("5E3xG");
function $5475e8e7564c3c4d$var$setupSlashingExtension(base) {
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    const queryService = new $498LX.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress)=>{
                const response = await queryService.SigningInfo({
                    consAddress: consAddress
                });
                return response;
            },
            signingInfos: async (paginationKey)=>{
                const response = await queryService.SigningInfos({
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            }
        }
    };
}
module.exports.setupSlashingExtension = $5475e8e7564c3c4d$var$setupSlashingExtension;

});
parcelRegister("498LX", function(module, exports) {
"use strict";
var $304eceb91d927561$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $304eceb91d927561$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $304eceb91d927561$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $304eceb91d927561$var$__createBinding(result, mod, k);
    }
    $304eceb91d927561$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QuerySigningInfosResponse = module.exports.QuerySigningInfosRequest = module.exports.QuerySigningInfoResponse = module.exports.QuerySigningInfoRequest = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $bptKf = parcelRequire("bptKf");

const $304eceb91d927561$var$_m0 = $304eceb91d927561$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "cosmos.slashing.v1beta1";
function $304eceb91d927561$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $304eceb91d927561$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $304eceb91d927561$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        if (message.params !== undefined) $bptKf.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $bptKf.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $bptKf.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $bptKf.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $304eceb91d927561$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $bptKf.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $304eceb91d927561$var$createBaseQuerySigningInfoRequest() {
    return {
        consAddress: ""
    };
}
module.exports.QuerySigningInfoRequest = {
    encode (message, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        if (message.consAddress !== "") writer.uint32(10).string(message.consAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQuerySigningInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consAddress: (0, $dkaBG.isSet)(object.consAddress) ? String(object.consAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $304eceb91d927561$var$createBaseQuerySigningInfoRequest();
        message.consAddress = object.consAddress ?? "";
        return message;
    }
};
function $304eceb91d927561$var$createBaseQuerySigningInfoResponse() {
    return {
        valSigningInfo: undefined
    };
}
module.exports.QuerySigningInfoResponse = {
    encode (message, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        if (message.valSigningInfo !== undefined) $bptKf.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQuerySigningInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.valSigningInfo = $bptKf.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            valSigningInfo: (0, $dkaBG.isSet)(object.valSigningInfo) ? $bptKf.ValidatorSigningInfo.fromJSON(object.valSigningInfo) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.valSigningInfo !== undefined && (obj.valSigningInfo = message.valSigningInfo ? $bptKf.ValidatorSigningInfo.toJSON(message.valSigningInfo) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $304eceb91d927561$var$createBaseQuerySigningInfoResponse();
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $bptKf.ValidatorSigningInfo.fromPartial(object.valSigningInfo) : undefined;
        return message;
    }
};
function $304eceb91d927561$var$createBaseQuerySigningInfosRequest() {
    return {
        pagination: undefined
    };
}
module.exports.QuerySigningInfosRequest = {
    encode (message, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQuerySigningInfosRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $304eceb91d927561$var$createBaseQuerySigningInfosRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $304eceb91d927561$var$createBaseQuerySigningInfosResponse() {
    return {
        info: [],
        pagination: undefined
    };
}
module.exports.QuerySigningInfosResponse = {
    encode (message, writer = $304eceb91d927561$var$_m0.Writer.create()) {
        for (const v of message.info)$bptKf.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $304eceb91d927561$var$_m0.Reader ? input : new $304eceb91d927561$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $304eceb91d927561$var$createBaseQuerySigningInfosResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info.push($bptKf.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e)=>$bptKf.ValidatorSigningInfo.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.info) obj.info = message.info.map((e)=>e ? $bptKf.ValidatorSigningInfo.toJSON(e) : undefined);
        else obj.info = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $304eceb91d927561$var$createBaseQuerySigningInfosResponse();
        message.info = object.info?.map((e)=>$bptKf.ValidatorSigningInfo.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $304eceb91d927561$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $304eceb91d927561$var$_m0.Reader(data)));
    }
    SigningInfo(request) {
        const data = module.exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data)=>module.exports.QuerySigningInfoResponse.decode(new $304eceb91d927561$var$_m0.Reader(data)));
    }
    SigningInfos(request = {
        pagination: undefined
    }) {
        const data = module.exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data)=>module.exports.QuerySigningInfosResponse.decode(new $304eceb91d927561$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $304eceb91d927561$var$QueryClientImpl;

});
parcelRegister("bptKf", function(module, exports) {
"use strict";
var $84e91a3f1d8ac916$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84e91a3f1d8ac916$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $84e91a3f1d8ac916$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $84e91a3f1d8ac916$var$__createBinding(result, mod, k);
    }
    $84e91a3f1d8ac916$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.ValidatorSigningInfo = module.exports.protobufPackage = void 0;

var $cPgyI = parcelRequire("cPgyI");

var $jBPGv = parcelRequire("jBPGv");

var $dkaBG = parcelRequire("dkaBG");

const $84e91a3f1d8ac916$var$_m0 = $84e91a3f1d8ac916$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.slashing.v1beta1";
function $84e91a3f1d8ac916$var$createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: $dkaBG.Long.ZERO,
        indexOffset: $dkaBG.Long.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: $dkaBG.Long.ZERO
    };
}
module.exports.ValidatorSigningInfo = {
    encode (message, writer = $84e91a3f1d8ac916$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.startHeight.isZero()) writer.uint32(16).int64(message.startHeight);
        if (!message.indexOffset.isZero()) writer.uint32(24).int64(message.indexOffset);
        if (message.jailedUntil !== undefined) $cPgyI.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        if (message.tombstoned === true) writer.uint32(40).bool(message.tombstoned);
        if (!message.missedBlocksCounter.isZero()) writer.uint32(48).int64(message.missedBlocksCounter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $84e91a3f1d8ac916$var$_m0.Reader ? input : new $84e91a3f1d8ac916$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $84e91a3f1d8ac916$var$createBaseValidatorSigningInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? String(object.address) : "",
            startHeight: (0, $dkaBG.isSet)(object.startHeight) ? $dkaBG.Long.fromValue(object.startHeight) : $dkaBG.Long.ZERO,
            indexOffset: (0, $dkaBG.isSet)(object.indexOffset) ? $dkaBG.Long.fromValue(object.indexOffset) : $dkaBG.Long.ZERO,
            jailedUntil: (0, $dkaBG.isSet)(object.jailedUntil) ? (0, $dkaBG.fromJsonTimestamp)(object.jailedUntil) : undefined,
            tombstoned: (0, $dkaBG.isSet)(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: (0, $dkaBG.isSet)(object.missedBlocksCounter) ? $dkaBG.Long.fromValue(object.missedBlocksCounter) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || $dkaBG.Long.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || $dkaBG.Long.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = (0, $dkaBG.fromTimestamp)(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined && (obj.missedBlocksCounter = (message.missedBlocksCounter || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $84e91a3f1d8ac916$var$createBaseValidatorSigningInfo();
        message.address = object.address ?? "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $dkaBG.Long.fromValue(object.startHeight) : $dkaBG.Long.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $dkaBG.Long.fromValue(object.indexOffset) : $dkaBG.Long.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $cPgyI.Timestamp.fromPartial(object.jailedUntil) : undefined;
        message.tombstoned = object.tombstoned ?? false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $dkaBG.Long.fromValue(object.missedBlocksCounter) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $84e91a3f1d8ac916$var$createBaseParams() {
    return {
        signedBlocksWindow: $dkaBG.Long.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array()
    };
}
module.exports.Params = {
    encode (message, writer = $84e91a3f1d8ac916$var$_m0.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) writer.uint32(8).int64(message.signedBlocksWindow);
        if (message.minSignedPerWindow.length !== 0) writer.uint32(18).bytes(message.minSignedPerWindow);
        if (message.downtimeJailDuration !== undefined) $jBPGv.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        if (message.slashFractionDoubleSign.length !== 0) writer.uint32(34).bytes(message.slashFractionDoubleSign);
        if (message.slashFractionDowntime.length !== 0) writer.uint32(42).bytes(message.slashFractionDowntime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $84e91a3f1d8ac916$var$_m0.Reader ? input : new $84e91a3f1d8ac916$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $84e91a3f1d8ac916$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedBlocksWindow: (0, $dkaBG.isSet)(object.signedBlocksWindow) ? $dkaBG.Long.fromValue(object.signedBlocksWindow) : $dkaBG.Long.ZERO,
            minSignedPerWindow: (0, $dkaBG.isSet)(object.minSignedPerWindow) ? (0, $dkaBG.bytesFromBase64)(object.minSignedPerWindow) : new Uint8Array(),
            downtimeJailDuration: (0, $dkaBG.isSet)(object.downtimeJailDuration) ? $jBPGv.Duration.fromJSON(object.downtimeJailDuration) : undefined,
            slashFractionDoubleSign: (0, $dkaBG.isSet)(object.slashFractionDoubleSign) ? (0, $dkaBG.bytesFromBase64)(object.slashFractionDoubleSign) : new Uint8Array(),
            slashFractionDowntime: (0, $dkaBG.isSet)(object.slashFractionDowntime) ? (0, $dkaBG.bytesFromBase64)(object.slashFractionDowntime) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedBlocksWindow !== undefined && (obj.signedBlocksWindow = (message.signedBlocksWindow || $dkaBG.Long.ZERO).toString());
        message.minSignedPerWindow !== undefined && (obj.minSignedPerWindow = (0, $dkaBG.base64FromBytes)(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined && (obj.downtimeJailDuration = message.downtimeJailDuration ? $jBPGv.Duration.toJSON(message.downtimeJailDuration) : undefined);
        message.slashFractionDoubleSign !== undefined && (obj.slashFractionDoubleSign = (0, $dkaBG.base64FromBytes)(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined && (obj.slashFractionDowntime = (0, $dkaBG.base64FromBytes)(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $84e91a3f1d8ac916$var$createBaseParams();
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $dkaBG.Long.fromValue(object.signedBlocksWindow) : $dkaBG.Long.ZERO;
        message.minSignedPerWindow = object.minSignedPerWindow ?? new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $jBPGv.Duration.fromPartial(object.downtimeJailDuration) : undefined;
        message.slashFractionDoubleSign = object.slashFractionDoubleSign ?? new Uint8Array();
        message.slashFractionDowntime = object.slashFractionDowntime ?? new Uint8Array();
        return message;
    }
};

});



parcelRegister("2dyeo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStakingAminoConverters = module.exports.isAminoMsgUndelegate = module.exports.isAminoMsgBeginRedelegate = module.exports.isAminoMsgDelegate = module.exports.isAminoMsgEditValidator = module.exports.isAminoMsgCreateValidator = module.exports.protoDecimalToJson = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $dtY18 = parcelRequire("dtY18");

var $hm8y1 = parcelRequire("hm8y1");
function $19d75941f433072e$var$protoDecimalToJson(decimal) {
    const parsed = $h3uvW.Decimal.fromAtomics(decimal, 18);
    const [whole, fractional] = parsed.toString().split(".");
    return `${whole}.${(fractional ?? "").padEnd(18, "0")}`;
}
module.exports.protoDecimalToJson = $19d75941f433072e$var$protoDecimalToJson;
function $19d75941f433072e$var$jsonDecimalToProto(decimal) {
    const parsed = $h3uvW.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function $19d75941f433072e$var$isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
module.exports.isAminoMsgCreateValidator = $19d75941f433072e$var$isAminoMsgCreateValidator;
function $19d75941f433072e$var$isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
module.exports.isAminoMsgEditValidator = $19d75941f433072e$var$isAminoMsgEditValidator;
function $19d75941f433072e$var$isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
module.exports.isAminoMsgDelegate = $19d75941f433072e$var$isAminoMsgDelegate;
function $19d75941f433072e$var$isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
module.exports.isAminoMsgBeginRedelegate = $19d75941f433072e$var$isAminoMsgBeginRedelegate;
function $19d75941f433072e$var$isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
module.exports.isAminoMsgUndelegate = $19d75941f433072e$var$isAminoMsgUndelegate;
function $19d75941f433072e$var$createStakingAminoConverters() {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorSrcAddress: validatorSrcAddress, validatorDstAddress: validatorDstAddress, amount: amount })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_src_address: validator_src_address, validator_dst_address: validator_dst_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorSrcAddress: validator_src_address,
                    validatorDstAddress: validator_dst_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description: description, commission: commission, minSelfDelegation: minSelfDelegation, delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, pubkey: pubkey, value: value })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(description, "missing description");
                (0, $hm8y1.assertDefinedAndNotNull)(commission, "missing commission");
                (0, $hm8y1.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, $hm8y1.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission: {
                        rate: $19d75941f433072e$var$protoDecimalToJson(commission.rate),
                        max_rate: $19d75941f433072e$var$protoDecimalToJson(commission.maxRate),
                        max_change_rate: $19d75941f433072e$var$protoDecimalToJson(commission.maxChangeRate)
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, $dtY18.decodePubkey)(pubkey),
                    value: value
                };
            },
            fromAmino: ({ description: description, commission: commission, min_self_delegation: min_self_delegation, delegator_address: delegator_address, validator_address: validator_address, pubkey: pubkey, value: value })=>{
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commission: {
                        rate: $19d75941f433072e$var$jsonDecimalToProto(commission.rate),
                        maxRate: $19d75941f433072e$var$jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: $19d75941f433072e$var$jsonDecimalToProto(commission.max_change_rate)
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, $dtY18.encodePubkey)(pubkey),
                    value: value
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description: description, commissionRate: commissionRate, minSelfDelegation: minSelfDelegation, validatorAddress: validatorAddress })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? $19d75941f433072e$var$protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress
                };
            },
            fromAmino: ({ description: description, commission_rate: commission_rate, min_self_delegation: min_self_delegation, validator_address: validator_address })=>({
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commissionRate: commission_rate ? $19d75941f433072e$var$jsonDecimalToProto(commission_rate) : "",
                    // empty string in the protobuf document means "do not change"
                    minSelfDelegation: min_self_delegation ?? "",
                    validatorAddress: validator_address
                })
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $hm8y1.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        }
    };
}
module.exports.createStakingAminoConverters = $19d75941f433072e$var$createStakingAminoConverters;

});

parcelRegister("5qJBp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgUndelegateEncodeObject = module.exports.isMsgEditValidatorEncodeObject = module.exports.isMsgDelegateEncodeObject = module.exports.isMsgCreateValidatorEncodeObject = module.exports.isMsgBeginRedelegateEncodeObject = module.exports.stakingTypes = void 0;

var $haFHP = parcelRequire("haFHP");
module.exports.stakingTypes = [
    [
        "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        $haFHP.MsgBeginRedelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgCreateValidator",
        $haFHP.MsgCreateValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgDelegate",
        $haFHP.MsgDelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgEditValidator",
        $haFHP.MsgEditValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgUndelegate",
        $haFHP.MsgUndelegate
    ]
];
function $3f42c11d4a1d0b92$var$isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
module.exports.isMsgBeginRedelegateEncodeObject = $3f42c11d4a1d0b92$var$isMsgBeginRedelegateEncodeObject;
function $3f42c11d4a1d0b92$var$isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
module.exports.isMsgCreateValidatorEncodeObject = $3f42c11d4a1d0b92$var$isMsgCreateValidatorEncodeObject;
function $3f42c11d4a1d0b92$var$isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
module.exports.isMsgDelegateEncodeObject = $3f42c11d4a1d0b92$var$isMsgDelegateEncodeObject;
function $3f42c11d4a1d0b92$var$isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
module.exports.isMsgEditValidatorEncodeObject = $3f42c11d4a1d0b92$var$isMsgEditValidatorEncodeObject;
function $3f42c11d4a1d0b92$var$isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
module.exports.isMsgUndelegateEncodeObject = $3f42c11d4a1d0b92$var$isMsgUndelegateEncodeObject;

});
parcelRegister("haFHP", function(module, exports) {
"use strict";
var $c803b8c91b1244f9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c803b8c91b1244f9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c803b8c91b1244f9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c803b8c91b1244f9$var$__createBinding(result, mod, k);
    }
    $c803b8c91b1244f9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgCancelUnbondingDelegationResponse = module.exports.MsgCancelUnbondingDelegation = module.exports.MsgUndelegateResponse = module.exports.MsgUndelegate = module.exports.MsgBeginRedelegateResponse = module.exports.MsgBeginRedelegate = module.exports.MsgDelegateResponse = module.exports.MsgDelegate = module.exports.MsgEditValidatorResponse = module.exports.MsgEditValidator = module.exports.MsgCreateValidatorResponse = module.exports.MsgCreateValidator = module.exports.protobufPackage = void 0;

var $cCCDQ = parcelRequire("cCCDQ");

var $axIO3 = parcelRequire("axIO3");

var $efcGD = parcelRequire("efcGD");

var $cPgyI = parcelRequire("cPgyI");

var $dkaBG = parcelRequire("dkaBG");

const $c803b8c91b1244f9$var$_m0 = $c803b8c91b1244f9$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.staking.v1beta1";
function $c803b8c91b1244f9$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
module.exports.MsgCreateValidator = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.description !== undefined) $cCCDQ.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $cCCDQ.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $axIO3.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $efcGD.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $cCCDQ.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $cCCDQ.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $dkaBG.isSet)(object.description) ? $cCCDQ.Description.fromJSON(object.description) : undefined,
            commission: (0, $dkaBG.isSet)(object.commission) ? $cCCDQ.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $dkaBG.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: (0, $dkaBG.isSet)(object.pubkey) ? $axIO3.Any.fromJSON(object.pubkey) : undefined,
            value: (0, $dkaBG.isSet)(object.value) ? $efcGD.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $cCCDQ.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $cCCDQ.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $axIO3.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $efcGD.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $cCCDQ.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $cCCDQ.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $axIO3.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $efcGD.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
module.exports.MsgCreateValidatorResponse = {
    encode (_, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c803b8c91b1244f9$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
module.exports.MsgEditValidator = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.description !== undefined) $cCCDQ.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $cCCDQ.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $dkaBG.isSet)(object.description) ? $cCCDQ.Description.fromJSON(object.description) : undefined,
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: (0, $dkaBG.isSet)(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: (0, $dkaBG.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $cCCDQ.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $cCCDQ.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = object.validatorAddress ?? "";
        message.commissionRate = object.commissionRate ?? "";
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgEditValidatorResponse() {
    return {};
}
module.exports.MsgEditValidatorResponse = {
    encode (_, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c803b8c91b1244f9$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgDelegate = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $efcGD.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgDelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? $efcGD.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $efcGD.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgDelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $efcGD.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgDelegateResponse() {
    return {};
}
module.exports.MsgDelegateResponse = {
    encode (_, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c803b8c91b1244f9$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
module.exports.MsgBeginRedelegate = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $efcGD.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $dkaBG.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $dkaBG.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? $efcGD.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $efcGD.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgBeginRedelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $efcGD.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $cPgyI.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $dkaBG.isSet)(object.completionTime) ? (0, $dkaBG.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $dkaBG.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $cPgyI.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
module.exports.MsgUndelegate = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $efcGD.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? $efcGD.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $efcGD.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgUndelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $efcGD.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
module.exports.MsgUndelegateResponse = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $cPgyI.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $dkaBG.isSet)(object.completionTime) ? (0, $dkaBG.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $dkaBG.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgUndelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $cPgyI.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: $dkaBG.Long.ZERO
    };
}
module.exports.MsgCancelUnbondingDelegation = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $efcGD.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (!message.creationHeight.isZero()) writer.uint32(32).int64(message.creationHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $dkaBG.isSet)(object.amount) ? $efcGD.Coin.fromJSON(object.amount) : undefined,
            creationHeight: (0, $dkaBG.isSet)(object.creationHeight) ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $efcGD.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $efcGD.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
module.exports.MsgCancelUnbondingDelegationResponse = {
    encode (_, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c803b8c91b1244f9$var$createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
module.exports.MsgUpdateParams = {
    encode (message, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $cCCDQ.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $cCCDQ.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $dkaBG.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $dkaBG.isSet)(object.params) ? $cCCDQ.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $cCCDQ.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c803b8c91b1244f9$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $cCCDQ.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $c803b8c91b1244f9$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode (_, writer = $c803b8c91b1244f9$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c803b8c91b1244f9$var$_m0.Reader ? input : new $c803b8c91b1244f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c803b8c91b1244f9$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c803b8c91b1244f9$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $c803b8c91b1244f9$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(request) {
        const data = module.exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data)=>module.exports.MsgCreateValidatorResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    EditValidator(request) {
        const data = module.exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data)=>module.exports.MsgEditValidatorResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    Delegate(request) {
        const data = module.exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data)=>module.exports.MsgDelegateResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = module.exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data)=>module.exports.MsgBeginRedelegateResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    Undelegate(request) {
        const data = module.exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data)=>module.exports.MsgUndelegateResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    CancelUnbondingDelegation(request) {
        const data = module.exports.MsgCancelUnbondingDelegation.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", data);
        return promise.then((data)=>module.exports.MsgCancelUnbondingDelegationResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = module.exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>module.exports.MsgUpdateParamsResponse.decode(new $c803b8c91b1244f9$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $c803b8c91b1244f9$var$MsgClientImpl;

});
parcelRegister("cCCDQ", function(module, exports) {
"use strict";
var $9307020ee34af96d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9307020ee34af96d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9307020ee34af96d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9307020ee34af96d$var$__createBinding(result, mod, k);
    }
    $9307020ee34af96d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValidatorUpdates = module.exports.Pool = module.exports.RedelegationResponse = module.exports.RedelegationEntryResponse = module.exports.DelegationResponse = module.exports.Params = module.exports.Redelegation = module.exports.RedelegationEntry = module.exports.UnbondingDelegationEntry = module.exports.UnbondingDelegation = module.exports.Delegation = module.exports.DVVTriplets = module.exports.DVVTriplet = module.exports.DVPairs = module.exports.DVPair = module.exports.ValAddresses = module.exports.Validator = module.exports.Description = module.exports.Commission = module.exports.CommissionRates = module.exports.HistoricalInfo = module.exports.infractionToJSON = module.exports.infractionFromJSON = module.exports.Infraction = module.exports.bondStatusToJSON = module.exports.bondStatusFromJSON = module.exports.BondStatus = module.exports.protobufPackage = void 0;

var $DRMtG = parcelRequire("DRMtG");

var $cPgyI = parcelRequire("cPgyI");

var $axIO3 = parcelRequire("axIO3");

var $jBPGv = parcelRequire("jBPGv");

var $efcGD = parcelRequire("efcGD");

var $VT2xE = parcelRequire("VT2xE");

var $dkaBG = parcelRequire("dkaBG");

const $9307020ee34af96d$var$_m0 = $9307020ee34af96d$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $9307020ee34af96d$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9307020ee34af96d$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $9307020ee34af96d$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $9307020ee34af96d$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9307020ee34af96d$var$BondStatus.UNRECOGNIZED;
    }
}
module.exports.bondStatusFromJSON = $9307020ee34af96d$var$bondStatusFromJSON;
function $9307020ee34af96d$var$bondStatusToJSON(object) {
    switch(object){
        case $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $9307020ee34af96d$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $9307020ee34af96d$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case $9307020ee34af96d$var$BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.bondStatusToJSON = $9307020ee34af96d$var$bondStatusToJSON;
/** Infraction indicates the infraction a validator commited. */ var $9307020ee34af96d$var$Infraction;
(function(Infraction) {
    /** INFRACTION_UNSPECIFIED - UNSPECIFIED defines an empty infraction. */ Infraction[Infraction["INFRACTION_UNSPECIFIED"] = 0] = "INFRACTION_UNSPECIFIED";
    /** INFRACTION_DOUBLE_SIGN - DOUBLE_SIGN defines a validator that double-signs a block. */ Infraction[Infraction["INFRACTION_DOUBLE_SIGN"] = 1] = "INFRACTION_DOUBLE_SIGN";
    /** INFRACTION_DOWNTIME - DOWNTIME defines a validator that missed signing too many blocks. */ Infraction[Infraction["INFRACTION_DOWNTIME"] = 2] = "INFRACTION_DOWNTIME";
    Infraction[Infraction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($9307020ee34af96d$var$Infraction = module.exports.Infraction || (module.exports.Infraction = {}));
function $9307020ee34af96d$var$infractionFromJSON(object) {
    switch(object){
        case 0:
        case "INFRACTION_UNSPECIFIED":
            return $9307020ee34af96d$var$Infraction.INFRACTION_UNSPECIFIED;
        case 1:
        case "INFRACTION_DOUBLE_SIGN":
            return $9307020ee34af96d$var$Infraction.INFRACTION_DOUBLE_SIGN;
        case 2:
        case "INFRACTION_DOWNTIME":
            return $9307020ee34af96d$var$Infraction.INFRACTION_DOWNTIME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $9307020ee34af96d$var$Infraction.UNRECOGNIZED;
    }
}
module.exports.infractionFromJSON = $9307020ee34af96d$var$infractionFromJSON;
function $9307020ee34af96d$var$infractionToJSON(object) {
    switch(object){
        case $9307020ee34af96d$var$Infraction.INFRACTION_UNSPECIFIED:
            return "INFRACTION_UNSPECIFIED";
        case $9307020ee34af96d$var$Infraction.INFRACTION_DOUBLE_SIGN:
            return "INFRACTION_DOUBLE_SIGN";
        case $9307020ee34af96d$var$Infraction.INFRACTION_DOWNTIME:
            return "INFRACTION_DOWNTIME";
        case $9307020ee34af96d$var$Infraction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.infractionToJSON = $9307020ee34af96d$var$infractionToJSON;
function $9307020ee34af96d$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
module.exports.HistoricalInfo = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.header !== undefined) $DRMtG.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)module.exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $DRMtG.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push(module.exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $dkaBG.isSet)(object.header) ? $DRMtG.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object?.valset) ? object.valset.map((e)=>module.exports.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $DRMtG.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? module.exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $DRMtG.Header.fromPartial(object.header) : undefined;
        message.valset = object.valset?.map((e)=>module.exports.Validator.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
module.exports.CommissionRates = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseCommissionRates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rate: (0, $dkaBG.isSet)(object.rate) ? String(object.rate) : "",
            maxRate: (0, $dkaBG.isSet)(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: (0, $dkaBG.isSet)(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseCommissionRates();
        message.rate = object.rate ?? "";
        message.maxRate = object.maxRate ?? "";
        message.maxChangeRate = object.maxChangeRate ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
module.exports.Commission = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.commissionRates !== undefined) module.exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $cPgyI.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = module.exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commissionRates: (0, $dkaBG.isSet)(object.commissionRates) ? module.exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: (0, $dkaBG.isSet)(object.updateTime) ? (0, $dkaBG.fromJsonTimestamp)(object.updateTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? module.exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = (0, $dkaBG.fromTimestamp)(message.updateTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? module.exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $cPgyI.Timestamp.fromPartial(object.updateTime) : undefined;
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
module.exports.Description = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDescription();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moniker: (0, $dkaBG.isSet)(object.moniker) ? String(object.moniker) : "",
            identity: (0, $dkaBG.isSet)(object.identity) ? String(object.identity) : "",
            website: (0, $dkaBG.isSet)(object.website) ? String(object.website) : "",
            securityContact: (0, $dkaBG.isSet)(object.securityContact) ? String(object.securityContact) : "",
            details: (0, $dkaBG.isSet)(object.details) ? String(object.details) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDescription();
        message.moniker = object.moniker ?? "";
        message.identity = object.identity ?? "";
        message.website = object.website ?? "";
        message.securityContact = object.securityContact ?? "";
        message.details = object.details ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: $dkaBG.Long.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
        unbondingOnHoldRefCount: $dkaBG.Long.ZERO,
        unbondingIds: []
    };
}
module.exports.Validator = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $axIO3.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) module.exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $cPgyI.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) module.exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(96).int64(message.unbondingOnHoldRefCount);
        writer.uint32(106).fork();
        for (const v of message.unbondingIds)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = module.exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = module.exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                case 12:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                case 13:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.unbondingIds.push(reader.uint64());
                    } else message.unbondingIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $dkaBG.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: (0, $dkaBG.isSet)(object.consensusPubkey) ? $axIO3.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: (0, $dkaBG.isSet)(object.jailed) ? Boolean(object.jailed) : false,
            status: (0, $dkaBG.isSet)(object.status) ? $9307020ee34af96d$var$bondStatusFromJSON(object.status) : 0,
            tokens: (0, $dkaBG.isSet)(object.tokens) ? String(object.tokens) : "",
            delegatorShares: (0, $dkaBG.isSet)(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: (0, $dkaBG.isSet)(object.description) ? module.exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: (0, $dkaBG.isSet)(object.unbondingHeight) ? $dkaBG.Long.fromValue(object.unbondingHeight) : $dkaBG.Long.ZERO,
            unbondingTime: (0, $dkaBG.isSet)(object.unbondingTime) ? (0, $dkaBG.fromJsonTimestamp)(object.unbondingTime) : undefined,
            commission: (0, $dkaBG.isSet)(object.commission) ? module.exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $dkaBG.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            unbondingOnHoldRefCount: (0, $dkaBG.isSet)(object.unbondingOnHoldRefCount) ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO,
            unbondingIds: Array.isArray(object?.unbondingIds) ? object.unbondingIds.map((e)=>$dkaBG.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $axIO3.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $9307020ee34af96d$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? module.exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $dkaBG.Long.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = (0, $dkaBG.fromTimestamp)(message.unbondingTime).toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? module.exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $dkaBG.Long.ZERO).toString());
        if (message.unbondingIds) obj.unbondingIds = message.unbondingIds.map((e)=>(e || $dkaBG.Long.UZERO).toString());
        else obj.unbondingIds = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $axIO3.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = object.jailed ?? false;
        message.status = object.status ?? 0;
        message.tokens = object.tokens ?? "";
        message.delegatorShares = object.delegatorShares ?? "";
        message.description = object.description !== undefined && object.description !== null ? module.exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $dkaBG.Long.fromValue(object.unbondingHeight) : $dkaBG.Long.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $cPgyI.Timestamp.fromPartial(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? module.exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO;
        message.unbondingIds = object.unbondingIds?.map((e)=>$dkaBG.Long.fromValue(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
module.exports.ValAddresses = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseValAddresses();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addresses: Array.isArray(object?.addresses) ? object.addresses.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseValAddresses();
        message.addresses = object.addresses?.map((e)=>e) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
module.exports.DVPair = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDVPair();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDVPair();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
module.exports.DVPairs = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        for (const v of message.pairs)module.exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDVPairs();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push(module.exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pairs: Array.isArray(object?.pairs) ? object.pairs.map((e)=>module.exports.DVPair.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? module.exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDVPairs();
        message.pairs = object.pairs?.map((e)=>module.exports.DVPair.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
module.exports.DVVTriplet = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDVVTriplet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $dkaBG.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $dkaBG.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDVVTriplet();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
module.exports.DVVTriplets = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        for (const v of message.triplets)module.exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDVVTriplets();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push(module.exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            triplets: Array.isArray(object?.triplets) ? object.triplets.map((e)=>module.exports.DVVTriplet.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? module.exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDVVTriplets();
        message.triplets = object.triplets?.map((e)=>module.exports.DVVTriplet.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
module.exports.Delegation = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: (0, $dkaBG.isSet)(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.shares = object.shares ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
module.exports.UnbondingDelegation = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)module.exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push(module.exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $dkaBG.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>module.exports.UnbondingDelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.entries = object.entries?.map((e)=>module.exports.UnbondingDelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: $dkaBG.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        balance: "",
        unbondingId: $dkaBG.Long.UZERO,
        unbondingOnHoldRefCount: $dkaBG.Long.ZERO
    };
}
module.exports.UnbondingDelegationEntry = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $cPgyI.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $dkaBG.isSet)(object.creationHeight) ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO,
            completionTime: (0, $dkaBG.isSet)(object.completionTime) ? (0, $dkaBG.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $dkaBG.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            balance: (0, $dkaBG.isSet)(object.balance) ? String(object.balance) : "",
            unbondingId: (0, $dkaBG.isSet)(object.unbondingId) ? $dkaBG.Long.fromValue(object.unbondingId) : $dkaBG.Long.UZERO,
            unbondingOnHoldRefCount: (0, $dkaBG.isSet)(object.unbondingOnHoldRefCount) ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $dkaBG.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $dkaBG.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $dkaBG.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $cPgyI.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.balance = object.balance ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $dkaBG.Long.fromValue(object.unbondingId) : $dkaBG.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $9307020ee34af96d$var$createBaseRedelegationEntry() {
    return {
        creationHeight: $dkaBG.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        sharesDst: "",
        unbondingId: $dkaBG.Long.UZERO,
        unbondingOnHoldRefCount: $dkaBG.Long.ZERO
    };
}
module.exports.RedelegationEntry = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $cPgyI.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $dkaBG.isSet)(object.creationHeight) ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO,
            completionTime: (0, $dkaBG.isSet)(object.completionTime) ? (0, $dkaBG.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $dkaBG.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: (0, $dkaBG.isSet)(object.sharesDst) ? String(object.sharesDst) : "",
            unbondingId: (0, $dkaBG.isSet)(object.unbondingId) ? $dkaBG.Long.fromValue(object.unbondingId) : $dkaBG.Long.UZERO,
            unbondingOnHoldRefCount: (0, $dkaBG.isSet)(object.unbondingOnHoldRefCount) ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $dkaBG.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $dkaBG.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $dkaBG.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseRedelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $dkaBG.Long.fromValue(object.creationHeight) : $dkaBG.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $cPgyI.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.sharesDst = object.sharesDst ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $dkaBG.Long.fromValue(object.unbondingId) : $dkaBG.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $dkaBG.Long.fromValue(object.unbondingOnHoldRefCount) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $9307020ee34af96d$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
module.exports.Redelegation = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)module.exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseRedelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push(module.exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $dkaBG.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $dkaBG.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $dkaBG.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>module.exports.RedelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseRedelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.entries = object.entries?.map((e)=>module.exports.RedelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: "",
        minCommissionRate: ""
    };
}
module.exports.Params = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.unbondingTime !== undefined) $jBPGv.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        if (message.minCommissionRate !== "") writer.uint32(50).string(message.minCommissionRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                case 6:
                    message.minCommissionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingTime: (0, $dkaBG.isSet)(object.unbondingTime) ? $jBPGv.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: (0, $dkaBG.isSet)(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: (0, $dkaBG.isSet)(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: (0, $dkaBG.isSet)(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: (0, $dkaBG.isSet)(object.bondDenom) ? String(object.bondDenom) : "",
            minCommissionRate: (0, $dkaBG.isSet)(object.minCommissionRate) ? String(object.minCommissionRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $jBPGv.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        message.minCommissionRate !== undefined && (obj.minCommissionRate = message.minCommissionRate);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $jBPGv.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = object.maxValidators ?? 0;
        message.maxEntries = object.maxEntries ?? 0;
        message.historicalEntries = object.historicalEntries ?? 0;
        message.bondDenom = object.bondDenom ?? "";
        message.minCommissionRate = object.minCommissionRate ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
module.exports.DelegationResponse = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.delegation !== undefined) module.exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $efcGD.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = module.exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $efcGD.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegation: (0, $dkaBG.isSet)(object.delegation) ? module.exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: (0, $dkaBG.isSet)(object.balance) ? $efcGD.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? module.exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $efcGD.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? module.exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $efcGD.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $9307020ee34af96d$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
module.exports.RedelegationEntryResponse = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.redelegationEntry !== undefined) module.exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = module.exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationEntry: (0, $dkaBG.isSet)(object.redelegationEntry) ? module.exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: (0, $dkaBG.isSet)(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? module.exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? module.exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = object.balance ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
module.exports.RedelegationResponse = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.redelegation !== undefined) module.exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)module.exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = module.exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push(module.exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegation: (0, $dkaBG.isSet)(object.redelegation) ? module.exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>module.exports.RedelegationEntryResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? module.exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? module.exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? module.exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = object.entries?.map((e)=>module.exports.RedelegationEntryResponse.fromPartial(e)) || [];
        return message;
    }
};
function $9307020ee34af96d$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
module.exports.Pool = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBasePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            notBondedTokens: (0, $dkaBG.isSet)(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: (0, $dkaBG.isSet)(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBasePool();
        message.notBondedTokens = object.notBondedTokens ?? "";
        message.bondedTokens = object.bondedTokens ?? "";
        return message;
    }
};
function $9307020ee34af96d$var$createBaseValidatorUpdates() {
    return {
        updates: []
    };
}
module.exports.ValidatorUpdates = {
    encode (message, writer = $9307020ee34af96d$var$_m0.Writer.create()) {
        for (const v of message.updates)$VT2xE.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9307020ee34af96d$var$_m0.Reader ? input : new $9307020ee34af96d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9307020ee34af96d$var$createBaseValidatorUpdates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.updates.push($VT2xE.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            updates: Array.isArray(object?.updates) ? object.updates.map((e)=>$VT2xE.ValidatorUpdate.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.updates) obj.updates = message.updates.map((e)=>e ? $VT2xE.ValidatorUpdate.toJSON(e) : undefined);
        else obj.updates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $9307020ee34af96d$var$createBaseValidatorUpdates();
        message.updates = object.updates?.map((e)=>$VT2xE.ValidatorUpdate.fromPartial(e)) || [];
        return message;
    }
};

});
parcelRegister("VT2xE", function(module, exports) {
"use strict";
var $0ae004c8701e7ec2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0ae004c8701e7ec2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0ae004c8701e7ec2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0ae004c8701e7ec2$var$__createBinding(result, mod, k);
    }
    $0ae004c8701e7ec2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponsePrepareProposal = module.exports.ResponseApplySnapshotChunk = module.exports.ResponseLoadSnapshotChunk = module.exports.ResponseOfferSnapshot = module.exports.ResponseListSnapshots = module.exports.ResponseCommit = module.exports.ResponseEndBlock = module.exports.ResponseDeliverTx = module.exports.ResponseCheckTx = module.exports.ResponseBeginBlock = module.exports.ResponseQuery = module.exports.ResponseInitChain = module.exports.ResponseInfo = module.exports.ResponseFlush = module.exports.ResponseEcho = module.exports.ResponseException = module.exports.Response = module.exports.RequestProcessProposal = module.exports.RequestPrepareProposal = module.exports.RequestApplySnapshotChunk = module.exports.RequestLoadSnapshotChunk = module.exports.RequestOfferSnapshot = module.exports.RequestListSnapshots = module.exports.RequestCommit = module.exports.RequestEndBlock = module.exports.RequestDeliverTx = module.exports.RequestCheckTx = module.exports.RequestBeginBlock = module.exports.RequestQuery = module.exports.RequestInitChain = module.exports.RequestInfo = module.exports.RequestFlush = module.exports.RequestEcho = module.exports.Request = module.exports.misbehaviorTypeToJSON = module.exports.misbehaviorTypeFromJSON = module.exports.MisbehaviorType = module.exports.responseProcessProposal_ProposalStatusToJSON = module.exports.responseProcessProposal_ProposalStatusFromJSON = module.exports.ResponseProcessProposal_ProposalStatus = module.exports.responseApplySnapshotChunk_ResultToJSON = module.exports.responseApplySnapshotChunk_ResultFromJSON = module.exports.ResponseApplySnapshotChunk_Result = module.exports.responseOfferSnapshot_ResultToJSON = module.exports.responseOfferSnapshot_ResultFromJSON = module.exports.ResponseOfferSnapshot_Result = module.exports.checkTxTypeToJSON = module.exports.checkTxTypeFromJSON = module.exports.CheckTxType = module.exports.protobufPackage = void 0;
module.exports.ABCIApplicationClientImpl = module.exports.Snapshot = module.exports.Misbehavior = module.exports.ExtendedVoteInfo = module.exports.VoteInfo = module.exports.ValidatorUpdate = module.exports.Validator = module.exports.TxResult = module.exports.EventAttribute = module.exports.Event = module.exports.ExtendedCommitInfo = module.exports.CommitInfo = module.exports.ResponseProcessProposal = void 0;

var $cPgyI = parcelRequire("cPgyI");

var $knk7y = parcelRequire("knk7y");

var $DRMtG = parcelRequire("DRMtG");

var $lXxYr = parcelRequire("lXxYr");

var $6SnRp = parcelRequire("6SnRp");

var $dkaBG = parcelRequire("dkaBG");

const $0ae004c8701e7ec2$var$_m0 = $0ae004c8701e7ec2$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.abci";
var $0ae004c8701e7ec2$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0ae004c8701e7ec2$var$CheckTxType = module.exports.CheckTxType || (module.exports.CheckTxType = {}));
function $0ae004c8701e7ec2$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $0ae004c8701e7ec2$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $0ae004c8701e7ec2$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0ae004c8701e7ec2$var$CheckTxType.UNRECOGNIZED;
    }
}
module.exports.checkTxTypeFromJSON = $0ae004c8701e7ec2$var$checkTxTypeFromJSON;
function $0ae004c8701e7ec2$var$checkTxTypeToJSON(object) {
    switch(object){
        case $0ae004c8701e7ec2$var$CheckTxType.NEW:
            return "NEW";
        case $0ae004c8701e7ec2$var$CheckTxType.RECHECK:
            return "RECHECK";
        case $0ae004c8701e7ec2$var$CheckTxType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.checkTxTypeToJSON = $0ae004c8701e7ec2$var$checkTxTypeToJSON;
var $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result = module.exports.ResponseOfferSnapshot_Result || (module.exports.ResponseOfferSnapshot_Result = {}));
function $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
module.exports.responseOfferSnapshot_ResultFromJSON = $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultFromJSON;
function $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        case $0ae004c8701e7ec2$var$ResponseOfferSnapshot_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.responseOfferSnapshot_ResultToJSON = $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultToJSON;
var $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result = module.exports.ResponseApplySnapshotChunk_Result || (module.exports.ResponseApplySnapshotChunk_Result = {}));
function $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
module.exports.responseApplySnapshotChunk_ResultFromJSON = $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultFromJSON;
function $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        case $0ae004c8701e7ec2$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.responseApplySnapshotChunk_ResultToJSON = $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultToJSON;
var $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus;
(function(ResponseProcessProposal_ProposalStatus) {
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNKNOWN"] = 0] = "UNKNOWN";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["ACCEPT"] = 1] = "ACCEPT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["REJECT"] = 2] = "REJECT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus = module.exports.ResponseProcessProposal_ProposalStatus || (module.exports.ResponseProcessProposal_ProposalStatus = {}));
function $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.ACCEPT;
        case 2:
        case "REJECT":
            return $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.REJECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.responseProcessProposal_ProposalStatusFromJSON = $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusFromJSON;
function $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusToJSON(object) {
    switch(object){
        case $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.UNKNOWN:
            return "UNKNOWN";
        case $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.ACCEPT:
            return "ACCEPT";
        case $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.REJECT:
            return "REJECT";
        case $0ae004c8701e7ec2$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.responseProcessProposal_ProposalStatusToJSON = $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusToJSON;
var $0ae004c8701e7ec2$var$MisbehaviorType;
(function(MisbehaviorType) {
    MisbehaviorType[MisbehaviorType["UNKNOWN"] = 0] = "UNKNOWN";
    MisbehaviorType[MisbehaviorType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    MisbehaviorType[MisbehaviorType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    MisbehaviorType[MisbehaviorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($0ae004c8701e7ec2$var$MisbehaviorType = module.exports.MisbehaviorType || (module.exports.MisbehaviorType = {}));
function $0ae004c8701e7ec2$var$misbehaviorTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $0ae004c8701e7ec2$var$MisbehaviorType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $0ae004c8701e7ec2$var$MisbehaviorType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $0ae004c8701e7ec2$var$MisbehaviorType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $0ae004c8701e7ec2$var$MisbehaviorType.UNRECOGNIZED;
    }
}
module.exports.misbehaviorTypeFromJSON = $0ae004c8701e7ec2$var$misbehaviorTypeFromJSON;
function $0ae004c8701e7ec2$var$misbehaviorTypeToJSON(object) {
    switch(object){
        case $0ae004c8701e7ec2$var$MisbehaviorType.UNKNOWN:
            return "UNKNOWN";
        case $0ae004c8701e7ec2$var$MisbehaviorType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $0ae004c8701e7ec2$var$MisbehaviorType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        case $0ae004c8701e7ec2$var$MisbehaviorType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.misbehaviorTypeToJSON = $0ae004c8701e7ec2$var$misbehaviorTypeToJSON;
function $0ae004c8701e7ec2$var$createBaseRequest() {
    return {
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
module.exports.Request = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.echo !== undefined) module.exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) module.exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) module.exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.initChain !== undefined) module.exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) module.exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) module.exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) module.exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) module.exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) module.exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) module.exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) module.exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) module.exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) module.exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) module.exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.prepareProposal !== undefined) module.exports.RequestPrepareProposal.encode(message.prepareProposal, writer.uint32(130).fork()).ldelim();
        if (message.processProposal !== undefined) module.exports.RequestProcessProposal.encode(message.processProposal, writer.uint32(138).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = module.exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = module.exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = module.exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = module.exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = module.exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = module.exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = module.exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = module.exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = module.exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = module.exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = module.exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = module.exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = module.exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = module.exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.prepareProposal = module.exports.RequestPrepareProposal.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.processProposal = module.exports.RequestProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            echo: (0, $dkaBG.isSet)(object.echo) ? module.exports.RequestEcho.fromJSON(object.echo) : undefined,
            flush: (0, $dkaBG.isSet)(object.flush) ? module.exports.RequestFlush.fromJSON(object.flush) : undefined,
            info: (0, $dkaBG.isSet)(object.info) ? module.exports.RequestInfo.fromJSON(object.info) : undefined,
            initChain: (0, $dkaBG.isSet)(object.initChain) ? module.exports.RequestInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $dkaBG.isSet)(object.query) ? module.exports.RequestQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $dkaBG.isSet)(object.beginBlock) ? module.exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $dkaBG.isSet)(object.checkTx) ? module.exports.RequestCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $dkaBG.isSet)(object.deliverTx) ? module.exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $dkaBG.isSet)(object.endBlock) ? module.exports.RequestEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $dkaBG.isSet)(object.commit) ? module.exports.RequestCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $dkaBG.isSet)(object.listSnapshots) ? module.exports.RequestListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $dkaBG.isSet)(object.offerSnapshot) ? module.exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $dkaBG.isSet)(object.loadSnapshotChunk) ? module.exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $dkaBG.isSet)(object.applySnapshotChunk) ? module.exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $dkaBG.isSet)(object.prepareProposal) ? module.exports.RequestPrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $dkaBG.isSet)(object.processProposal) ? module.exports.RequestProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? module.exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? module.exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? module.exports.RequestInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? module.exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? module.exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? module.exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? module.exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? module.exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? module.exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? module.exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? module.exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? module.exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? module.exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? module.exports.RequestPrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? module.exports.RequestProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequest();
        message.echo = object.echo !== undefined && object.echo !== null ? module.exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? module.exports.RequestFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? module.exports.RequestInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? module.exports.RequestInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? module.exports.RequestQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? module.exports.RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? module.exports.RequestCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? module.exports.RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? module.exports.RequestEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? module.exports.RequestCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? module.exports.RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? module.exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? module.exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? module.exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? module.exports.RequestPrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? module.exports.RequestProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestEcho() {
    return {
        message: ""
    };
}
module.exports.RequestEcho = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $dkaBG.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestFlush() {
    return {};
}
module.exports.RequestFlush = {
    encode (_, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestFlush();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestInfo() {
    return {
        version: "",
        blockVersion: $dkaBG.Long.UZERO,
        p2pVersion: $dkaBG.Long.UZERO,
        abciVersion: ""
    };
}
module.exports.RequestInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        if (message.abciVersion !== "") writer.uint32(34).string(message.abciVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                case 4:
                    message.abciVersion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : "",
            blockVersion: (0, $dkaBG.isSet)(object.blockVersion) ? $dkaBG.Long.fromValue(object.blockVersion) : $dkaBG.Long.UZERO,
            p2pVersion: (0, $dkaBG.isSet)(object.p2pVersion) ? $dkaBG.Long.fromValue(object.p2pVersion) : $dkaBG.Long.UZERO,
            abciVersion: (0, $dkaBG.isSet)(object.abciVersion) ? String(object.abciVersion) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $dkaBG.Long.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $dkaBG.Long.UZERO).toString());
        message.abciVersion !== undefined && (obj.abciVersion = message.abciVersion);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestInfo();
        message.version = object.version ?? "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $dkaBG.Long.fromValue(object.blockVersion) : $dkaBG.Long.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $dkaBG.Long.fromValue(object.p2pVersion) : $dkaBG.Long.UZERO;
        message.abciVersion = object.abciVersion ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestInitChain() {
    return {
        time: undefined,
        chainId: "",
        consensusParams: undefined,
        validators: [],
        appStateBytes: new Uint8Array(),
        initialHeight: $dkaBG.Long.ZERO
    };
}
module.exports.RequestInitChain = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) $knk7y.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        for (const v of message.validators)module.exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = $knk7y.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            chainId: (0, $dkaBG.isSet)(object.chainId) ? String(object.chainId) : "",
            consensusParams: (0, $dkaBG.isSet)(object.consensusParams) ? $knk7y.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>module.exports.ValidatorUpdate.fromJSON(e)) : [],
            appStateBytes: (0, $dkaBG.isSet)(object.appStateBytes) ? (0, $dkaBG.bytesFromBase64)(object.appStateBytes) : new Uint8Array(),
            initialHeight: (0, $dkaBG.isSet)(object.initialHeight) ? $dkaBG.Long.fromValue(object.initialHeight) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $knk7y.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = (0, $dkaBG.base64FromBytes)(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestInitChain();
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.chainId = object.chainId ?? "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $knk7y.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>module.exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appStateBytes = object.appStateBytes ?? new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $dkaBG.Long.fromValue(object.initialHeight) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestQuery() {
    return {
        data: new Uint8Array(),
        path: "",
        height: $dkaBG.Long.ZERO,
        prove: false
    };
}
module.exports.RequestQuery = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            path: (0, $dkaBG.isSet)(object.path) ? String(object.path) : "",
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            prove: (0, $dkaBG.isSet)(object.prove) ? Boolean(object.prove) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestQuery();
        message.data = object.data ?? new Uint8Array();
        message.path = object.path ?? "";
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.prove = object.prove ?? false;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestBeginBlock() {
    return {
        hash: new Uint8Array(),
        header: undefined,
        lastCommitInfo: undefined,
        byzantineValidators: []
    };
}
module.exports.RequestBeginBlock = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $DRMtG.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) module.exports.CommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        for (const v of message.byzantineValidators)module.exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $DRMtG.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = module.exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push(module.exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array(),
            header: (0, $dkaBG.isSet)(object.header) ? $DRMtG.Header.fromJSON(object.header) : undefined,
            lastCommitInfo: (0, $dkaBG.isSet)(object.lastCommitInfo) ? module.exports.CommitInfo.fromJSON(object.lastCommitInfo) : undefined,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>module.exports.Misbehavior.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $DRMtG.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? module.exports.CommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? module.exports.Misbehavior.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestBeginBlock();
        message.hash = object.hash ?? new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $DRMtG.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? module.exports.CommitInfo.fromPartial(object.lastCommitInfo) : undefined;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>module.exports.Misbehavior.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestCheckTx() {
    return {
        tx: new Uint8Array(),
        type: 0
    };
}
module.exports.RequestCheckTx = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? (0, $dkaBG.bytesFromBase64)(object.tx) : new Uint8Array(),
            type: (0, $dkaBG.isSet)(object.type) ? $0ae004c8701e7ec2$var$checkTxTypeFromJSON(object.type) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $dkaBG.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $0ae004c8701e7ec2$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestCheckTx();
        message.tx = object.tx ?? new Uint8Array();
        message.type = object.type ?? 0;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestDeliverTx() {
    return {
        tx: new Uint8Array()
    };
}
module.exports.RequestDeliverTx = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? (0, $dkaBG.bytesFromBase64)(object.tx) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $dkaBG.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestDeliverTx();
        message.tx = object.tx ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestEndBlock() {
    return {
        height: $dkaBG.Long.ZERO
    };
}
module.exports.RequestEndBlock = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestEndBlock();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestCommit() {
    return {};
}
module.exports.RequestCommit = {
    encode (_, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestCommit();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestListSnapshots() {
    return {};
}
module.exports.RequestListSnapshots = {
    encode (_, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestListSnapshots();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestOfferSnapshot() {
    return {
        snapshot: undefined,
        appHash: new Uint8Array()
    };
}
module.exports.RequestOfferSnapshot = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.snapshot !== undefined) module.exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = module.exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshot: (0, $dkaBG.isSet)(object.snapshot) ? module.exports.Snapshot.fromJSON(object.snapshot) : undefined,
            appHash: (0, $dkaBG.isSet)(object.appHash) ? (0, $dkaBG.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? module.exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = (0, $dkaBG.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestOfferSnapshot();
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? module.exports.Snapshot.fromPartial(object.snapshot) : undefined;
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestLoadSnapshotChunk() {
    return {
        height: $dkaBG.Long.UZERO,
        format: 0,
        chunk: 0
    };
}
module.exports.RequestLoadSnapshotChunk = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO,
            format: (0, $dkaBG.isSet)(object.format) ? Number(object.format) : 0,
            chunk: (0, $dkaBG.isSet)(object.chunk) ? Number(object.chunk) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunk !== undefined && (obj.chunk = Math.round(message.chunk));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestLoadSnapshotChunk();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunk = object.chunk ?? 0;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestApplySnapshotChunk() {
    return {
        index: 0,
        chunk: new Uint8Array(),
        sender: ""
    };
}
module.exports.RequestApplySnapshotChunk = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $dkaBG.isSet)(object.index) ? Number(object.index) : 0,
            chunk: (0, $dkaBG.isSet)(object.chunk) ? (0, $dkaBG.bytesFromBase64)(object.chunk) : new Uint8Array(),
            sender: (0, $dkaBG.isSet)(object.sender) ? String(object.sender) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.chunk !== undefined && (obj.chunk = (0, $dkaBG.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestApplySnapshotChunk();
        message.index = object.index ?? 0;
        message.chunk = object.chunk ?? new Uint8Array();
        message.sender = object.sender ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestPrepareProposal() {
    return {
        maxTxBytes: $dkaBG.Long.ZERO,
        txs: [],
        localLastCommit: undefined,
        misbehavior: [],
        height: $dkaBG.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
module.exports.RequestPrepareProposal = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (!message.maxTxBytes.isZero()) writer.uint32(8).int64(message.maxTxBytes);
        for (const v of message.txs)writer.uint32(18).bytes(v);
        if (message.localLastCommit !== undefined) module.exports.ExtendedCommitInfo.encode(message.localLastCommit, writer.uint32(26).fork()).ldelim();
        for (const v of message.misbehavior)module.exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestPrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTxBytes = reader.int64();
                    break;
                case 2:
                    message.txs.push(reader.bytes());
                    break;
                case 3:
                    message.localLastCommit = module.exports.ExtendedCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.misbehavior.push(module.exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxTxBytes: (0, $dkaBG.isSet)(object.maxTxBytes) ? $dkaBG.Long.fromValue(object.maxTxBytes) : $dkaBG.Long.ZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : [],
            localLastCommit: (0, $dkaBG.isSet)(object.localLastCommit) ? module.exports.ExtendedCommitInfo.fromJSON(object.localLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>module.exports.Misbehavior.fromJSON(e)) : [],
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $dkaBG.isSet)(object.nextValidatorsHash) ? (0, $dkaBG.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $dkaBG.isSet)(object.proposerAddress) ? (0, $dkaBG.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxTxBytes !== undefined && (obj.maxTxBytes = (message.maxTxBytes || $dkaBG.Long.ZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.localLastCommit !== undefined && (obj.localLastCommit = message.localLastCommit ? module.exports.ExtendedCommitInfo.toJSON(message.localLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? module.exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $dkaBG.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $dkaBG.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestPrepareProposal();
        message.maxTxBytes = object.maxTxBytes !== undefined && object.maxTxBytes !== null ? $dkaBG.Long.fromValue(object.maxTxBytes) : $dkaBG.Long.ZERO;
        message.txs = object.txs?.map((e)=>e) || [];
        message.localLastCommit = object.localLastCommit !== undefined && object.localLastCommit !== null ? module.exports.ExtendedCommitInfo.fromPartial(object.localLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>module.exports.Misbehavior.fromPartial(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseRequestProcessProposal() {
    return {
        txs: [],
        proposedLastCommit: undefined,
        misbehavior: [],
        hash: new Uint8Array(),
        height: $dkaBG.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
module.exports.RequestProcessProposal = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        if (message.proposedLastCommit !== undefined) module.exports.CommitInfo.encode(message.proposedLastCommit, writer.uint32(18).fork()).ldelim();
        for (const v of message.misbehavior)module.exports.Misbehavior.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseRequestProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                case 2:
                    message.proposedLastCommit = module.exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.misbehavior.push(module.exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : [],
            proposedLastCommit: (0, $dkaBG.isSet)(object.proposedLastCommit) ? module.exports.CommitInfo.fromJSON(object.proposedLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>module.exports.Misbehavior.fromJSON(e)) : [],
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array(),
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $dkaBG.isSet)(object.nextValidatorsHash) ? (0, $dkaBG.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $dkaBG.isSet)(object.proposerAddress) ? (0, $dkaBG.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.proposedLastCommit !== undefined && (obj.proposedLastCommit = message.proposedLastCommit ? module.exports.CommitInfo.toJSON(message.proposedLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? module.exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $dkaBG.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $dkaBG.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseRequestProcessProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        message.proposedLastCommit = object.proposedLastCommit !== undefined && object.proposedLastCommit !== null ? module.exports.CommitInfo.fromPartial(object.proposedLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>module.exports.Misbehavior.fromPartial(e)) || [];
        message.hash = object.hash ?? new Uint8Array();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponse() {
    return {
        exception: undefined,
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
module.exports.Response = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.exception !== undefined) module.exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) module.exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) module.exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) module.exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) module.exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) module.exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) module.exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) module.exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) module.exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) module.exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) module.exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) module.exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) module.exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) module.exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) module.exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        if (message.prepareProposal !== undefined) module.exports.ResponsePrepareProposal.encode(message.prepareProposal, writer.uint32(138).fork()).ldelim();
        if (message.processProposal !== undefined) module.exports.ResponseProcessProposal.encode(message.processProposal, writer.uint32(146).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = module.exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = module.exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = module.exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = module.exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = module.exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = module.exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = module.exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = module.exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = module.exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = module.exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = module.exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = module.exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = module.exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = module.exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = module.exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.prepareProposal = module.exports.ResponsePrepareProposal.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.processProposal = module.exports.ResponseProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exception: (0, $dkaBG.isSet)(object.exception) ? module.exports.ResponseException.fromJSON(object.exception) : undefined,
            echo: (0, $dkaBG.isSet)(object.echo) ? module.exports.ResponseEcho.fromJSON(object.echo) : undefined,
            flush: (0, $dkaBG.isSet)(object.flush) ? module.exports.ResponseFlush.fromJSON(object.flush) : undefined,
            info: (0, $dkaBG.isSet)(object.info) ? module.exports.ResponseInfo.fromJSON(object.info) : undefined,
            initChain: (0, $dkaBG.isSet)(object.initChain) ? module.exports.ResponseInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $dkaBG.isSet)(object.query) ? module.exports.ResponseQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $dkaBG.isSet)(object.beginBlock) ? module.exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $dkaBG.isSet)(object.checkTx) ? module.exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $dkaBG.isSet)(object.deliverTx) ? module.exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $dkaBG.isSet)(object.endBlock) ? module.exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $dkaBG.isSet)(object.commit) ? module.exports.ResponseCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $dkaBG.isSet)(object.listSnapshots) ? module.exports.ResponseListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $dkaBG.isSet)(object.offerSnapshot) ? module.exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $dkaBG.isSet)(object.loadSnapshotChunk) ? module.exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $dkaBG.isSet)(object.applySnapshotChunk) ? module.exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $dkaBG.isSet)(object.prepareProposal) ? module.exports.ResponsePrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $dkaBG.isSet)(object.processProposal) ? module.exports.ResponseProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? module.exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? module.exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? module.exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? module.exports.ResponseInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? module.exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? module.exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? module.exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? module.exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? module.exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? module.exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? module.exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? module.exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? module.exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? module.exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? module.exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? module.exports.ResponsePrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? module.exports.ResponseProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponse();
        message.exception = object.exception !== undefined && object.exception !== null ? module.exports.ResponseException.fromPartial(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? module.exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? module.exports.ResponseFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? module.exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? module.exports.ResponseInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? module.exports.ResponseQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? module.exports.ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? module.exports.ResponseCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? module.exports.ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? module.exports.ResponseEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? module.exports.ResponseCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? module.exports.ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? module.exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? module.exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? module.exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? module.exports.ResponsePrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? module.exports.ResponseProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseException() {
    return {
        error: ""
    };
}
module.exports.ResponseException = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseException();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            error: (0, $dkaBG.isSet)(object.error) ? String(object.error) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseException();
        message.error = object.error ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseEcho() {
    return {
        message: ""
    };
}
module.exports.ResponseEcho = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $dkaBG.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseFlush() {
    return {};
}
module.exports.ResponseFlush = {
    encode (_, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseFlush();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseInfo() {
    return {
        data: "",
        version: "",
        appVersion: $dkaBG.Long.UZERO,
        lastBlockHeight: $dkaBG.Long.ZERO,
        lastBlockAppHash: new Uint8Array()
    };
}
module.exports.ResponseInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $dkaBG.isSet)(object.data) ? String(object.data) : "",
            version: (0, $dkaBG.isSet)(object.version) ? String(object.version) : "",
            appVersion: (0, $dkaBG.isSet)(object.appVersion) ? $dkaBG.Long.fromValue(object.appVersion) : $dkaBG.Long.UZERO,
            lastBlockHeight: (0, $dkaBG.isSet)(object.lastBlockHeight) ? $dkaBG.Long.fromValue(object.lastBlockHeight) : $dkaBG.Long.ZERO,
            lastBlockAppHash: (0, $dkaBG.isSet)(object.lastBlockAppHash) ? (0, $dkaBG.bytesFromBase64)(object.lastBlockAppHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $dkaBG.Long.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $dkaBG.Long.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = (0, $dkaBG.base64FromBytes)(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseInfo();
        message.data = object.data ?? "";
        message.version = object.version ?? "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $dkaBG.Long.fromValue(object.appVersion) : $dkaBG.Long.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $dkaBG.Long.fromValue(object.lastBlockHeight) : $dkaBG.Long.ZERO;
        message.lastBlockAppHash = object.lastBlockAppHash ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseInitChain() {
    return {
        consensusParams: undefined,
        validators: [],
        appHash: new Uint8Array()
    };
}
module.exports.ResponseInitChain = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.consensusParams !== undefined) $knk7y.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        for (const v of message.validators)module.exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = $knk7y.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusParams: (0, $dkaBG.isSet)(object.consensusParams) ? $knk7y.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>module.exports.ValidatorUpdate.fromJSON(e)) : [],
            appHash: (0, $dkaBG.isSet)(object.appHash) ? (0, $dkaBG.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $knk7y.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = (0, $dkaBG.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseInitChain();
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $knk7y.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>module.exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseQuery() {
    return {
        code: 0,
        log: "",
        info: "",
        index: $dkaBG.Long.ZERO,
        key: new Uint8Array(),
        value: new Uint8Array(),
        proofOps: undefined,
        height: $dkaBG.Long.ZERO,
        codespace: ""
    };
}
module.exports.ResponseQuery = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $lXxYr.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $lXxYr.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $dkaBG.isSet)(object.code) ? Number(object.code) : 0,
            log: (0, $dkaBG.isSet)(object.log) ? String(object.log) : "",
            info: (0, $dkaBG.isSet)(object.info) ? String(object.info) : "",
            index: (0, $dkaBG.isSet)(object.index) ? $dkaBG.Long.fromValue(object.index) : $dkaBG.Long.ZERO,
            key: (0, $dkaBG.isSet)(object.key) ? (0, $dkaBG.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $dkaBG.isSet)(object.value) ? (0, $dkaBG.bytesFromBase64)(object.value) : new Uint8Array(),
            proofOps: (0, $dkaBG.isSet)(object.proofOps) ? $lXxYr.ProofOps.fromJSON(object.proofOps) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            codespace: (0, $dkaBG.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $dkaBG.Long.ZERO).toString());
        message.key !== undefined && (obj.key = (0, $dkaBG.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $dkaBG.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $lXxYr.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseQuery();
        message.code = object.code ?? 0;
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.index = object.index !== undefined && object.index !== null ? $dkaBG.Long.fromValue(object.index) : $dkaBG.Long.ZERO;
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $lXxYr.ProofOps.fromPartial(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseBeginBlock() {
    return {
        events: []
    };
}
module.exports.ResponseBeginBlock = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>module.exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseBeginBlock();
        message.events = object.events?.map((e)=>module.exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseCheckTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $dkaBG.Long.ZERO,
        gasUsed: $dkaBG.Long.ZERO,
        events: [],
        codespace: "",
        sender: "",
        priority: $dkaBG.Long.ZERO,
        mempoolError: ""
    };
}
module.exports.ResponseCheckTx = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        if (message.sender !== "") writer.uint32(74).string(message.sender);
        if (!message.priority.isZero()) writer.uint32(80).int64(message.priority);
        if (message.mempoolError !== "") writer.uint32(90).string(message.mempoolError);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                case 9:
                    message.sender = reader.string();
                    break;
                case 10:
                    message.priority = reader.int64();
                    break;
                case 11:
                    message.mempoolError = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $dkaBG.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $dkaBG.isSet)(object.log) ? String(object.log) : "",
            info: (0, $dkaBG.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $dkaBG.isSet)(object.gas_wanted) ? $dkaBG.Long.fromValue(object.gas_wanted) : $dkaBG.Long.ZERO,
            gasUsed: (0, $dkaBG.isSet)(object.gas_used) ? $dkaBG.Long.fromValue(object.gas_used) : $dkaBG.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>module.exports.Event.fromJSON(e)) : [],
            codespace: (0, $dkaBG.isSet)(object.codespace) ? String(object.codespace) : "",
            sender: (0, $dkaBG.isSet)(object.sender) ? String(object.sender) : "",
            priority: (0, $dkaBG.isSet)(object.priority) ? $dkaBG.Long.fromValue(object.priority) : $dkaBG.Long.ZERO,
            mempoolError: (0, $dkaBG.isSet)(object.mempoolError) ? String(object.mempoolError) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $dkaBG.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $dkaBG.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.sender !== undefined && (obj.sender = message.sender);
        message.priority !== undefined && (obj.priority = (message.priority || $dkaBG.Long.ZERO).toString());
        message.mempoolError !== undefined && (obj.mempoolError = message.mempoolError);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseCheckTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.ZERO;
        message.events = object.events?.map((e)=>module.exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        message.sender = object.sender ?? "";
        message.priority = object.priority !== undefined && object.priority !== null ? $dkaBG.Long.fromValue(object.priority) : $dkaBG.Long.ZERO;
        message.mempoolError = object.mempoolError ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseDeliverTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $dkaBG.Long.ZERO,
        gasUsed: $dkaBG.Long.ZERO,
        events: [],
        codespace: ""
    };
}
module.exports.ResponseDeliverTx = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $dkaBG.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $dkaBG.isSet)(object.log) ? String(object.log) : "",
            info: (0, $dkaBG.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $dkaBG.isSet)(object.gas_wanted) ? $dkaBG.Long.fromValue(object.gas_wanted) : $dkaBG.Long.ZERO,
            gasUsed: (0, $dkaBG.isSet)(object.gas_used) ? $dkaBG.Long.fromValue(object.gas_used) : $dkaBG.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>module.exports.Event.fromJSON(e)) : [],
            codespace: (0, $dkaBG.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $dkaBG.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $dkaBG.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseDeliverTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.ZERO;
        message.events = object.events?.map((e)=>module.exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseEndBlock() {
    return {
        validatorUpdates: [],
        consensusParamUpdates: undefined,
        events: []
    };
}
module.exports.ResponseEndBlock = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        for (const v of message.validatorUpdates)module.exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.consensusParamUpdates !== undefined) $knk7y.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        for (const v of message.events)module.exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push(module.exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = $knk7y.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push(module.exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorUpdates: Array.isArray(object?.validatorUpdates) ? object.validatorUpdates.map((e)=>module.exports.ValidatorUpdate.fromJSON(e)) : [],
            consensusParamUpdates: (0, $dkaBG.isSet)(object.consensusParamUpdates) ? $knk7y.ConsensusParams.fromJSON(object.consensusParamUpdates) : undefined,
            events: Array.isArray(object?.events) ? object.events.map((e)=>module.exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map((e)=>e ? module.exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? $knk7y.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseEndBlock();
        message.validatorUpdates = object.validatorUpdates?.map((e)=>module.exports.ValidatorUpdate.fromPartial(e)) || [];
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $knk7y.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
        message.events = object.events?.map((e)=>module.exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseCommit() {
    return {
        data: new Uint8Array(),
        retainHeight: $dkaBG.Long.ZERO
    };
}
module.exports.ResponseCommit = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            retainHeight: (0, $dkaBG.isSet)(object.retainHeight) ? $dkaBG.Long.fromValue(object.retainHeight) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseCommit();
        message.data = object.data ?? new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $dkaBG.Long.fromValue(object.retainHeight) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseListSnapshots() {
    return {
        snapshots: []
    };
}
module.exports.ResponseListSnapshots = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        for (const v of message.snapshots)module.exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push(module.exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshots: Array.isArray(object?.snapshots) ? object.snapshots.map((e)=>module.exports.Snapshot.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map((e)=>e ? module.exports.Snapshot.toJSON(e) : undefined);
        else obj.snapshots = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseListSnapshots();
        message.snapshots = object.snapshots?.map((e)=>module.exports.Snapshot.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseOfferSnapshot() {
    return {
        result: 0
    };
}
module.exports.ResponseOfferSnapshot = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $0ae004c8701e7ec2$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseOfferSnapshot();
        message.result = object.result ?? 0;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseLoadSnapshotChunk() {
    return {
        chunk: new Uint8Array()
    };
}
module.exports.ResponseLoadSnapshotChunk = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chunk: (0, $dkaBG.isSet)(object.chunk) ? (0, $dkaBG.bytesFromBase64)(object.chunk) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.chunk !== undefined && (obj.chunk = (0, $dkaBG.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseLoadSnapshotChunk();
        message.chunk = object.chunk ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseApplySnapshotChunk() {
    return {
        result: 0,
        refetchChunks: [],
        rejectSenders: []
    };
}
module.exports.ResponseApplySnapshotChunk = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        for (const v of message.refetchChunks)writer.uint32(v);
        writer.ldelim();
        for (const v of message.rejectSenders)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $dkaBG.isSet)(object.result) ? $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
            refetchChunks: Array.isArray(object?.refetchChunks) ? object.refetchChunks.map((e)=>Number(e)) : [],
            rejectSenders: Array.isArray(object?.rejectSenders) ? object.rejectSenders.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $0ae004c8701e7ec2$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map((e)=>Math.round(e));
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map((e)=>e);
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseApplySnapshotChunk();
        message.result = object.result ?? 0;
        message.refetchChunks = object.refetchChunks?.map((e)=>e) || [];
        message.rejectSenders = object.rejectSenders?.map((e)=>e) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponsePrepareProposal() {
    return {
        txs: []
    };
}
module.exports.ResponsePrepareProposal = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponsePrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $dkaBG.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $dkaBG.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponsePrepareProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseResponseProcessProposal() {
    return {
        status: 0
    };
}
module.exports.ResponseProcessProposal = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.status !== 0) writer.uint32(8).int32(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseResponseProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $dkaBG.isSet)(object.status) ? $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusFromJSON(object.status) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = $0ae004c8701e7ec2$var$responseProcessProposal_ProposalStatusToJSON(message.status));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseResponseProcessProposal();
        message.status = object.status ?? 0;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
module.exports.CommitInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)module.exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push(module.exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $dkaBG.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>module.exports.VoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? module.exports.VoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>module.exports.VoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseExtendedCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
module.exports.ExtendedCommitInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)module.exports.ExtendedVoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseExtendedCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push(module.exports.ExtendedVoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $dkaBG.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>module.exports.ExtendedVoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? module.exports.ExtendedVoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseExtendedCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>module.exports.ExtendedVoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseEvent() {
    return {
        type: "",
        attributes: []
    };
}
module.exports.Event = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)module.exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(module.exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>module.exports.EventAttribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? module.exports.EventAttribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>module.exports.EventAttribute.fromPartial(e)) || [];
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseEventAttribute() {
    return {
        key: "",
        value: "",
        index: false
    };
}
module.exports.EventAttribute = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseEventAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? String(object.key) : "",
            value: (0, $dkaBG.isSet)(object.value) ? String(object.value) : "",
            index: (0, $dkaBG.isSet)(object.index) ? Boolean(object.index) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseEventAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        message.index = object.index ?? false;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseTxResult() {
    return {
        height: $dkaBG.Long.ZERO,
        index: 0,
        tx: new Uint8Array(),
        result: undefined
    };
}
module.exports.TxResult = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) module.exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseTxResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = module.exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            index: (0, $dkaBG.isSet)(object.index) ? Number(object.index) : 0,
            tx: (0, $dkaBG.isSet)(object.tx) ? (0, $dkaBG.bytesFromBase64)(object.tx) : new Uint8Array(),
            result: (0, $dkaBG.isSet)(object.result) ? module.exports.ResponseDeliverTx.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.tx !== undefined && (obj.tx = (0, $dkaBG.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? module.exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseTxResult();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.index = object.index ?? 0;
        message.tx = object.tx ?? new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? module.exports.ResponseDeliverTx.fromPartial(object.result) : undefined;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        power: $dkaBG.Long.ZERO
    };
}
module.exports.Validator = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $dkaBG.isSet)(object.address) ? (0, $dkaBG.bytesFromBase64)(object.address) : new Uint8Array(),
            power: (0, $dkaBG.isSet)(object.power) ? $dkaBG.Long.fromValue(object.power) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $dkaBG.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $dkaBG.Long.fromValue(object.power) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseValidatorUpdate() {
    return {
        pubKey: undefined,
        power: $dkaBG.Long.ZERO
    };
}
module.exports.ValidatorUpdate = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $6SnRp.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseValidatorUpdate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $6SnRp.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $dkaBG.isSet)(object.pubKey) ? $6SnRp.PublicKey.fromJSON(object.pubKey) : undefined,
            power: (0, $dkaBG.isSet)(object.power) ? $dkaBG.Long.fromValue(object.power) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $6SnRp.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseValidatorUpdate();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $6SnRp.PublicKey.fromPartial(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $dkaBG.Long.fromValue(object.power) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false
    };
}
module.exports.VoteInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.validator !== undefined) module.exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $dkaBG.isSet)(object.validator) ? module.exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $dkaBG.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? module.exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseExtendedVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false,
        voteExtension: new Uint8Array()
    };
}
module.exports.ExtendedVoteInfo = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.validator !== undefined) module.exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        if (message.voteExtension.length !== 0) writer.uint32(26).bytes(message.voteExtension);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseExtendedVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                case 3:
                    message.voteExtension = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $dkaBG.isSet)(object.validator) ? module.exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $dkaBG.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false,
            voteExtension: (0, $dkaBG.isSet)(object.voteExtension) ? (0, $dkaBG.bytesFromBase64)(object.voteExtension) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        message.voteExtension !== undefined && (obj.voteExtension = (0, $dkaBG.base64FromBytes)(message.voteExtension !== undefined ? message.voteExtension : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseExtendedVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? module.exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        message.voteExtension = object.voteExtension ?? new Uint8Array();
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseMisbehavior() {
    return {
        type: 0,
        validator: undefined,
        height: $dkaBG.Long.ZERO,
        time: undefined,
        totalVotingPower: $dkaBG.Long.ZERO
    };
}
module.exports.Misbehavior = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) module.exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $cPgyI.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseMisbehavior();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = module.exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? $0ae004c8701e7ec2$var$misbehaviorTypeFromJSON(object.type) : 0,
            validator: (0, $dkaBG.isSet)(object.validator) ? module.exports.Validator.fromJSON(object.validator) : undefined,
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            time: (0, $dkaBG.isSet)(object.time) ? (0, $dkaBG.fromJsonTimestamp)(object.time) : undefined,
            totalVotingPower: (0, $dkaBG.isSet)(object.totalVotingPower) ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $0ae004c8701e7ec2$var$misbehaviorTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $dkaBG.fromTimestamp)(message.time).toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseMisbehavior();
        message.type = object.type ?? 0;
        message.validator = object.validator !== undefined && object.validator !== null ? module.exports.Validator.fromPartial(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $cPgyI.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $0ae004c8701e7ec2$var$createBaseSnapshot() {
    return {
        height: $dkaBG.Long.UZERO,
        format: 0,
        chunks: 0,
        hash: new Uint8Array(),
        metadata: new Uint8Array()
    };
}
module.exports.Snapshot = {
    encode (message, writer = $0ae004c8701e7ec2$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0ae004c8701e7ec2$var$_m0.Reader ? input : new $0ae004c8701e7ec2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0ae004c8701e7ec2$var$createBaseSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO,
            format: (0, $dkaBG.isSet)(object.format) ? Number(object.format) : 0,
            chunks: (0, $dkaBG.isSet)(object.chunks) ? Number(object.chunks) : 0,
            hash: (0, $dkaBG.isSet)(object.hash) ? (0, $dkaBG.bytesFromBase64)(object.hash) : new Uint8Array(),
            metadata: (0, $dkaBG.isSet)(object.metadata) ? (0, $dkaBG.bytesFromBase64)(object.metadata) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunks !== undefined && (obj.chunks = Math.round(message.chunks));
        message.hash !== undefined && (obj.hash = (0, $dkaBG.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = (0, $dkaBG.base64FromBytes)(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $0ae004c8701e7ec2$var$createBaseSnapshot();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunks = object.chunks ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        message.metadata = object.metadata ?? new Uint8Array();
        return message;
    }
};
class $0ae004c8701e7ec2$var$ABCIApplicationClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
        this.PrepareProposal = this.PrepareProposal.bind(this);
        this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(request) {
        const data = module.exports.RequestEcho.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
        return promise.then((data)=>module.exports.ResponseEcho.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    Flush(request = {}) {
        const data = module.exports.RequestFlush.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
        return promise.then((data)=>module.exports.ResponseFlush.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    Info(request) {
        const data = module.exports.RequestInfo.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
        return promise.then((data)=>module.exports.ResponseInfo.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    DeliverTx(request) {
        const data = module.exports.RequestDeliverTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
        return promise.then((data)=>module.exports.ResponseDeliverTx.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    CheckTx(request) {
        const data = module.exports.RequestCheckTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
        return promise.then((data)=>module.exports.ResponseCheckTx.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    Query(request) {
        const data = module.exports.RequestQuery.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
        return promise.then((data)=>module.exports.ResponseQuery.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    Commit(request = {}) {
        const data = module.exports.RequestCommit.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
        return promise.then((data)=>module.exports.ResponseCommit.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    InitChain(request) {
        const data = module.exports.RequestInitChain.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
        return promise.then((data)=>module.exports.ResponseInitChain.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    BeginBlock(request) {
        const data = module.exports.RequestBeginBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
        return promise.then((data)=>module.exports.ResponseBeginBlock.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    EndBlock(request) {
        const data = module.exports.RequestEndBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
        return promise.then((data)=>module.exports.ResponseEndBlock.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    ListSnapshots(request = {}) {
        const data = module.exports.RequestListSnapshots.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
        return promise.then((data)=>module.exports.ResponseListSnapshots.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    OfferSnapshot(request) {
        const data = module.exports.RequestOfferSnapshot.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
        return promise.then((data)=>module.exports.ResponseOfferSnapshot.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    LoadSnapshotChunk(request) {
        const data = module.exports.RequestLoadSnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
        return promise.then((data)=>module.exports.ResponseLoadSnapshotChunk.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    ApplySnapshotChunk(request) {
        const data = module.exports.RequestApplySnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
        return promise.then((data)=>module.exports.ResponseApplySnapshotChunk.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    PrepareProposal(request) {
        const data = module.exports.RequestPrepareProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", data);
        return promise.then((data)=>module.exports.ResponsePrepareProposal.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
    ProcessProposal(request) {
        const data = module.exports.RequestProcessProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", data);
        return promise.then((data)=>module.exports.ResponseProcessProposal.decode(new $0ae004c8701e7ec2$var$_m0.Reader(data)));
    }
}
module.exports.ABCIApplicationClientImpl = $0ae004c8701e7ec2$var$ABCIApplicationClientImpl;

});
parcelRegister("knk7y", function(module, exports) {
"use strict";
var $ed5590383a0bdfdd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ed5590383a0bdfdd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ed5590383a0bdfdd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ed5590383a0bdfdd$var$__createBinding(result, mod, k);
    }
    $ed5590383a0bdfdd$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashedParams = module.exports.VersionParams = module.exports.ValidatorParams = module.exports.EvidenceParams = module.exports.BlockParams = module.exports.ConsensusParams = module.exports.protobufPackage = void 0;

var $jBPGv = parcelRequire("jBPGv");

var $dkaBG = parcelRequire("dkaBG");

const $ed5590383a0bdfdd$var$_m0 = $ed5590383a0bdfdd$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.types";
function $ed5590383a0bdfdd$var$createBaseConsensusParams() {
    return {
        block: undefined,
        evidence: undefined,
        validator: undefined,
        version: undefined
    };
}
module.exports.ConsensusParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        if (message.block !== undefined) module.exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) module.exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) module.exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) module.exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseConsensusParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = module.exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = module.exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = module.exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = module.exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $dkaBG.isSet)(object.block) ? module.exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: (0, $dkaBG.isSet)(object.evidence) ? module.exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: (0, $dkaBG.isSet)(object.validator) ? module.exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: (0, $dkaBG.isSet)(object.version) ? module.exports.VersionParams.fromJSON(object.version) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? module.exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? module.exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? module.exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? module.exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseConsensusParams();
        message.block = object.block !== undefined && object.block !== null ? module.exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? module.exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? module.exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? module.exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
function $ed5590383a0bdfdd$var$createBaseBlockParams() {
    return {
        maxBytes: $dkaBG.Long.ZERO,
        maxGas: $dkaBG.Long.ZERO
    };
}
module.exports.BlockParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseBlockParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxBytes: (0, $dkaBG.isSet)(object.maxBytes) ? $dkaBG.Long.fromValue(object.maxBytes) : $dkaBG.Long.ZERO,
            maxGas: (0, $dkaBG.isSet)(object.maxGas) ? $dkaBG.Long.fromValue(object.maxGas) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $dkaBG.Long.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseBlockParams();
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $dkaBG.Long.fromValue(object.maxBytes) : $dkaBG.Long.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $dkaBG.Long.fromValue(object.maxGas) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $ed5590383a0bdfdd$var$createBaseEvidenceParams() {
    return {
        maxAgeNumBlocks: $dkaBG.Long.ZERO,
        maxAgeDuration: undefined,
        maxBytes: $dkaBG.Long.ZERO
    };
}
module.exports.EvidenceParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $jBPGv.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseEvidenceParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $jBPGv.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxAgeNumBlocks: (0, $dkaBG.isSet)(object.maxAgeNumBlocks) ? $dkaBG.Long.fromValue(object.maxAgeNumBlocks) : $dkaBG.Long.ZERO,
            maxAgeDuration: (0, $dkaBG.isSet)(object.maxAgeDuration) ? $jBPGv.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: (0, $dkaBG.isSet)(object.maxBytes) ? $dkaBG.Long.fromValue(object.maxBytes) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $dkaBG.Long.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $jBPGv.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseEvidenceParams();
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $dkaBG.Long.fromValue(object.maxAgeNumBlocks) : $dkaBG.Long.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $jBPGv.Duration.fromPartial(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $dkaBG.Long.fromValue(object.maxBytes) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $ed5590383a0bdfdd$var$createBaseValidatorParams() {
    return {
        pubKeyTypes: []
    };
}
module.exports.ValidatorParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        for (const v of message.pubKeyTypes)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseValidatorParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKeyTypes: Array.isArray(object?.pubKeyTypes) ? object.pubKeyTypes.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map((e)=>e);
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseValidatorParams();
        message.pubKeyTypes = object.pubKeyTypes?.map((e)=>e) || [];
        return message;
    }
};
function $ed5590383a0bdfdd$var$createBaseVersionParams() {
    return {
        app: $dkaBG.Long.UZERO
    };
}
module.exports.VersionParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        if (!message.app.isZero()) writer.uint32(8).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseVersionParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            app: (0, $dkaBG.isSet)(object.app) ? $dkaBG.Long.fromValue(object.app) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.app !== undefined && (obj.app = (message.app || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseVersionParams();
        message.app = object.app !== undefined && object.app !== null ? $dkaBG.Long.fromValue(object.app) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $ed5590383a0bdfdd$var$createBaseHashedParams() {
    return {
        blockMaxBytes: $dkaBG.Long.ZERO,
        blockMaxGas: $dkaBG.Long.ZERO
    };
}
module.exports.HashedParams = {
    encode (message, writer = $ed5590383a0bdfdd$var$_m0.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ed5590383a0bdfdd$var$_m0.Reader ? input : new $ed5590383a0bdfdd$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ed5590383a0bdfdd$var$createBaseHashedParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockMaxBytes: (0, $dkaBG.isSet)(object.blockMaxBytes) ? $dkaBG.Long.fromValue(object.blockMaxBytes) : $dkaBG.Long.ZERO,
            blockMaxGas: (0, $dkaBG.isSet)(object.blockMaxGas) ? $dkaBG.Long.fromValue(object.blockMaxGas) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $dkaBG.Long.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $ed5590383a0bdfdd$var$createBaseHashedParams();
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $dkaBG.Long.fromValue(object.blockMaxBytes) : $dkaBG.Long.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $dkaBG.Long.fromValue(object.blockMaxGas) : $dkaBG.Long.ZERO;
        return message;
    }
};

});





parcelRegister("5pVOU", function(module, exports) {
"use strict";
var $3f1c23697d76b966$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupStakingExtension = void 0;

var $3GF7W = parcelRequire("3GF7W");

const $3f1c23697d76b966$var$long_1 = $3f1c23697d76b966$var$__importDefault((parcelRequire("3gmZQ")));

var $5E3xG = parcelRequire("5E3xG");
function $3f1c23697d76b966$var$setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    const queryService = new $3GF7W.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            historicalInfo: async (height)=>{
                const response = await queryService.HistoricalInfo({
                    height: $3f1c23697d76b966$var$long_1.default.fromNumber(height, true)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            pool: async ()=>{
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey)=>{
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validator: async (validatorAddress)=>{
                const response = await queryService.Validator({
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            validators: async (status, paginationKey)=>{
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $5E3xG.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
module.exports.setupStakingExtension = $3f1c23697d76b966$var$setupStakingExtension;

});
parcelRegister("3GF7W", function(module, exports) {
"use strict";
var $2af53255ccb498fe$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2af53255ccb498fe$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2af53255ccb498fe$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2af53255ccb498fe$var$__createBinding(result, mod, k);
    }
    $2af53255ccb498fe$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueryClientImpl = module.exports.QueryParamsResponse = module.exports.QueryParamsRequest = module.exports.QueryPoolResponse = module.exports.QueryPoolRequest = module.exports.QueryHistoricalInfoResponse = module.exports.QueryHistoricalInfoRequest = module.exports.QueryDelegatorValidatorResponse = module.exports.QueryDelegatorValidatorRequest = module.exports.QueryDelegatorValidatorsResponse = module.exports.QueryDelegatorValidatorsRequest = module.exports.QueryRedelegationsResponse = module.exports.QueryRedelegationsRequest = module.exports.QueryDelegatorUnbondingDelegationsResponse = module.exports.QueryDelegatorUnbondingDelegationsRequest = module.exports.QueryDelegatorDelegationsResponse = module.exports.QueryDelegatorDelegationsRequest = module.exports.QueryUnbondingDelegationResponse = module.exports.QueryUnbondingDelegationRequest = module.exports.QueryDelegationResponse = module.exports.QueryDelegationRequest = module.exports.QueryValidatorUnbondingDelegationsResponse = module.exports.QueryValidatorUnbondingDelegationsRequest = module.exports.QueryValidatorDelegationsResponse = module.exports.QueryValidatorDelegationsRequest = module.exports.QueryValidatorResponse = module.exports.QueryValidatorRequest = module.exports.QueryValidatorsResponse = module.exports.QueryValidatorsRequest = module.exports.protobufPackage = void 0;

var $aBpB1 = parcelRequire("aBpB1");

var $cCCDQ = parcelRequire("cCCDQ");

var $dkaBG = parcelRequire("dkaBG");

const $2af53255ccb498fe$var$_m0 = $2af53255ccb498fe$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.staking.v1beta1";
function $2af53255ccb498fe$var$createBaseQueryValidatorsRequest() {
    return {
        status: "",
        pagination: undefined
    };
}
module.exports.QueryValidatorsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $dkaBG.isSet)(object.status) ? String(object.status) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorsRequest();
        message.status = object.status ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
module.exports.QueryValidatorsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.validators)$cCCDQ.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($cCCDQ.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$cCCDQ.Validator.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $cCCDQ.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorsResponse();
        message.validators = object.validators?.map((e)=>$cCCDQ.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorRequest() {
    return {
        validatorAddr: ""
    };
}
module.exports.QueryValidatorRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorResponse() {
    return {
        validator: undefined
    };
}
module.exports.QueryValidatorResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $cCCDQ.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $cCCDQ.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $dkaBG.isSet)(object.validator) ? $cCCDQ.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $cCCDQ.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $cCCDQ.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryValidatorDelegationsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
module.exports.QueryValidatorDelegationsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$cCCDQ.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($cCCDQ.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$cCCDQ.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $cCCDQ.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$cCCDQ.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryValidatorUnbondingDelegationsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
module.exports.QueryValidatorUnbondingDelegationsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$cCCDQ.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($cCCDQ.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$cCCDQ.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $cCCDQ.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$cCCDQ.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
module.exports.QueryDelegationRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegationResponse() {
    return {
        delegationResponse: undefined
    };
}
module.exports.QueryDelegationResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegationResponse !== undefined) $cCCDQ.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponse = $cCCDQ.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponse: (0, $dkaBG.isSet)(object.delegationResponse) ? $cCCDQ.DelegationResponse.fromJSON(object.delegationResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegationResponse !== undefined && (obj.delegationResponse = message.delegationResponse ? $cCCDQ.DelegationResponse.toJSON(message.delegationResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegationResponse();
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $cCCDQ.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
module.exports.QueryUnbondingDelegationRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationResponse() {
    return {
        unbond: undefined
    };
}
module.exports.QueryUnbondingDelegationResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.unbond !== undefined) $cCCDQ.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbond = $cCCDQ.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbond: (0, $dkaBG.isSet)(object.unbond) ? $cCCDQ.UnbondingDelegation.fromJSON(object.unbond) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbond !== undefined && (obj.unbond = message.unbond ? $cCCDQ.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryUnbondingDelegationResponse();
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $cCCDQ.UnbondingDelegation.fromPartial(object.unbond) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryDelegatorDelegationsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
module.exports.QueryDelegatorDelegationsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$cCCDQ.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($cCCDQ.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$cCCDQ.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $cCCDQ.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$cCCDQ.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
module.exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$cCCDQ.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($cCCDQ.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$cCCDQ.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $cCCDQ.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$cCCDQ.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryRedelegationsRequest() {
    return {
        delegatorAddr: "",
        srcValidatorAddr: "",
        dstValidatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryRedelegationsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.srcValidatorAddr !== "") writer.uint32(18).string(message.srcValidatorAddr);
        if (message.dstValidatorAddr !== "") writer.uint32(26).string(message.dstValidatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryRedelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: (0, $dkaBG.isSet)(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: (0, $dkaBG.isSet)(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryRedelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.srcValidatorAddr = object.srcValidatorAddr ?? "";
        message.dstValidatorAddr = object.dstValidatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryRedelegationsResponse() {
    return {
        redelegationResponses: [],
        pagination: undefined
    };
}
module.exports.QueryRedelegationsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.redelegationResponses)$cCCDQ.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryRedelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationResponses.push($cCCDQ.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationResponses: Array.isArray(object?.redelegationResponses) ? object.redelegationResponses.map((e)=>$cCCDQ.RedelegationResponse.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.redelegationResponses) obj.redelegationResponses = message.redelegationResponses.map((e)=>e ? $cCCDQ.RedelegationResponse.toJSON(e) : undefined);
        else obj.redelegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryRedelegationsResponse();
        message.redelegationResponses = object.redelegationResponses?.map((e)=>$cCCDQ.RedelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
module.exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
module.exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        for (const v of message.validators)$cCCDQ.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($cCCDQ.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$cCCDQ.Validator.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $cCCDQ.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>$cCCDQ.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
module.exports.QueryDelegatorValidatorRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $dkaBG.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $dkaBG.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorResponse() {
    return {
        validator: undefined
    };
}
module.exports.QueryDelegatorValidatorResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $cCCDQ.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $cCCDQ.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $dkaBG.isSet)(object.validator) ? $cCCDQ.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $cCCDQ.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryDelegatorValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $cCCDQ.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryHistoricalInfoRequest() {
    return {
        height: $dkaBG.Long.ZERO
    };
}
module.exports.QueryHistoricalInfoRequest = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryHistoricalInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryHistoricalInfoRequest();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryHistoricalInfoResponse() {
    return {
        hist: undefined
    };
}
module.exports.QueryHistoricalInfoResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.hist !== undefined) $cCCDQ.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryHistoricalInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hist = $cCCDQ.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hist: (0, $dkaBG.isSet)(object.hist) ? $cCCDQ.HistoricalInfo.fromJSON(object.hist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? $cCCDQ.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryHistoricalInfoResponse();
        message.hist = object.hist !== undefined && object.hist !== null ? $cCCDQ.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryPoolRequest() {
    return {};
}
module.exports.QueryPoolRequest = {
    encode (_, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $2af53255ccb498fe$var$createBaseQueryPoolRequest();
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryPoolResponse() {
    return {
        pool: undefined
    };
}
module.exports.QueryPoolResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.pool !== undefined) $cCCDQ.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool = $cCCDQ.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: (0, $dkaBG.isSet)(object.pool) ? $cCCDQ.Pool.fromJSON(object.pool) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? $cCCDQ.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryPoolResponse();
        message.pool = object.pool !== undefined && object.pool !== null ? $cCCDQ.Pool.fromPartial(object.pool) : undefined;
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryParamsRequest() {
    return {};
}
module.exports.QueryParamsRequest = {
    encode (_, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $2af53255ccb498fe$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $2af53255ccb498fe$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
module.exports.QueryParamsResponse = {
    encode (message, writer = $2af53255ccb498fe$var$_m0.Writer.create()) {
        if (message.params !== undefined) $cCCDQ.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $2af53255ccb498fe$var$_m0.Reader ? input : new $2af53255ccb498fe$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $2af53255ccb498fe$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $cCCDQ.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $dkaBG.isSet)(object.params) ? $cCCDQ.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $cCCDQ.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $2af53255ccb498fe$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $cCCDQ.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $2af53255ccb498fe$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    Validators(request) {
        const data = module.exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data)=>module.exports.QueryValidatorsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    Validator(request) {
        const data = module.exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data)=>module.exports.QueryValidatorResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = module.exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data)=>module.exports.QueryValidatorDelegationsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = module.exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data)=>module.exports.QueryValidatorUnbondingDelegationsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    Delegation(request) {
        const data = module.exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data)=>module.exports.QueryDelegationResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = module.exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data)=>module.exports.QueryUnbondingDelegationResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = module.exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data)=>module.exports.QueryDelegatorDelegationsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = module.exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data)=>module.exports.QueryDelegatorUnbondingDelegationsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    Redelegations(request) {
        const data = module.exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data)=>module.exports.QueryRedelegationsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = module.exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>module.exports.QueryDelegatorValidatorsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = module.exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data)=>module.exports.QueryDelegatorValidatorResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = module.exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data)=>module.exports.QueryHistoricalInfoResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    Pool(request = {}) {
        const data = module.exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data)=>module.exports.QueryPoolResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = module.exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data)=>module.exports.QueryParamsResponse.decode(new $2af53255ccb498fe$var$_m0.Reader(data)));
    }
}
module.exports.QueryClientImpl = $2af53255ccb498fe$var$QueryClientImpl;

});


parcelRegister("6FZBm", function(module, exports) {
"use strict";
var $4dc65b302a3d3d9d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupTxExtension = void 0;

var $dtY18 = parcelRequire("dtY18");

var $67U77 = parcelRequire("67U77");

var $dYD5q = parcelRequire("dYD5q");

var $bkT1A = parcelRequire("bkT1A");

const $4dc65b302a3d3d9d$var$long_1 = $4dc65b302a3d3d9d$var$__importDefault((parcelRequire("3gmZQ")));

var $5E3xG = parcelRequire("5E3xG");
function $4dc65b302a3d3d9d$var$setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $5E3xG.createProtobufRpcClient)(base);
    const queryService = new $dYD5q.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId)=>{
                const request = {
                    hash: txId
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence)=>{
                const tx = $bkT1A.Tx.fromPartial({
                    authInfo: $bkT1A.AuthInfo.fromPartial({
                        fee: $bkT1A.Fee.fromPartial({}),
                        signerInfos: [
                            {
                                publicKey: (0, $dtY18.encodePubkey)(signer),
                                sequence: $4dc65b302a3d3d9d$var$long_1.default.fromNumber(sequence, true),
                                modeInfo: {
                                    single: {
                                        mode: $67U77.SignMode.SIGN_MODE_UNSPECIFIED
                                    }
                                }
                            }
                        ]
                    }),
                    body: $bkT1A.TxBody.fromPartial({
                        messages: Array.from(messages),
                        memo: memo
                    }),
                    signatures: [
                        new Uint8Array()
                    ]
                });
                const request = $dYD5q.SimulateRequest.fromPartial({
                    txBytes: $bkT1A.Tx.encode(tx).finish()
                });
                const response = await queryService.Simulate(request);
                return response;
            }
        }
    };
}
module.exports.setupTxExtension = $4dc65b302a3d3d9d$var$setupTxExtension;

});
parcelRegister("dYD5q", function(module, exports) {
"use strict";
var $a2cf32bcdade92bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a2cf32bcdade92bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a2cf32bcdade92bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a2cf32bcdade92bf$var$__createBinding(result, mod, k);
    }
    $a2cf32bcdade92bf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServiceClientImpl = module.exports.TxDecodeAminoResponse = module.exports.TxDecodeAminoRequest = module.exports.TxEncodeAminoResponse = module.exports.TxEncodeAminoRequest = module.exports.TxEncodeResponse = module.exports.TxEncodeRequest = module.exports.TxDecodeResponse = module.exports.TxDecodeRequest = module.exports.GetBlockWithTxsResponse = module.exports.GetBlockWithTxsRequest = module.exports.GetTxResponse = module.exports.GetTxRequest = module.exports.SimulateResponse = module.exports.SimulateRequest = module.exports.BroadcastTxResponse = module.exports.BroadcastTxRequest = module.exports.GetTxsEventResponse = module.exports.GetTxsEventRequest = module.exports.broadcastModeToJSON = module.exports.broadcastModeFromJSON = module.exports.BroadcastMode = module.exports.orderByToJSON = module.exports.orderByFromJSON = module.exports.OrderBy = module.exports.protobufPackage = void 0;

var $bkT1A = parcelRequire("bkT1A");

var $aBpB1 = parcelRequire("aBpB1");

var $7q6Mz = parcelRequire("7q6Mz");

var $DRMtG = parcelRequire("DRMtG");

var $imsbT = parcelRequire("imsbT");

var $dkaBG = parcelRequire("dkaBG");

const $a2cf32bcdade92bf$var$_m0 = $a2cf32bcdade92bf$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $a2cf32bcdade92bf$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a2cf32bcdade92bf$var$OrderBy = module.exports.OrderBy || (module.exports.OrderBy = {}));
function $a2cf32bcdade92bf$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a2cf32bcdade92bf$var$OrderBy.UNRECOGNIZED;
    }
}
module.exports.orderByFromJSON = $a2cf32bcdade92bf$var$orderByFromJSON;
function $a2cf32bcdade92bf$var$orderByToJSON(object) {
    switch(object){
        case $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $a2cf32bcdade92bf$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case $a2cf32bcdade92bf$var$OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.orderByToJSON = $a2cf32bcdade92bf$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $a2cf32bcdade92bf$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - DEPRECATED: use BROADCAST_MODE_SYNC instead,
     * BROADCAST_MODE_BLOCK is not supported by the SDK from v0.47.x onwards.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a2cf32bcdade92bf$var$BroadcastMode = module.exports.BroadcastMode || (module.exports.BroadcastMode = {}));
function $a2cf32bcdade92bf$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a2cf32bcdade92bf$var$BroadcastMode.UNRECOGNIZED;
    }
}
module.exports.broadcastModeFromJSON = $a2cf32bcdade92bf$var$broadcastModeFromJSON;
function $a2cf32bcdade92bf$var$broadcastModeToJSON(object) {
    switch(object){
        case $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $a2cf32bcdade92bf$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case $a2cf32bcdade92bf$var$BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.broadcastModeToJSON = $a2cf32bcdade92bf$var$broadcastModeToJSON;
function $a2cf32bcdade92bf$var$createBaseGetTxsEventRequest() {
    return {
        events: [],
        pagination: undefined,
        orderBy: 0,
        page: $dkaBG.Long.UZERO,
        limit: $dkaBG.Long.UZERO
    };
}
module.exports.GetTxsEventRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        for (const v of message.events)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        if (!message.page.isZero()) writer.uint32(32).uint64(message.page);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetTxsEventRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                case 4:
                    message.page = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>String(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: (0, $dkaBG.isSet)(object.orderBy) ? $a2cf32bcdade92bf$var$orderByFromJSON(object.orderBy) : 0,
            page: (0, $dkaBG.isSet)(object.page) ? $dkaBG.Long.fromValue(object.page) : $dkaBG.Long.UZERO,
            limit: (0, $dkaBG.isSet)(object.limit) ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e);
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $a2cf32bcdade92bf$var$orderByToJSON(message.orderBy));
        message.page !== undefined && (obj.page = (message.page || $dkaBG.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetTxsEventRequest();
        message.events = object.events?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        message.orderBy = object.orderBy ?? 0;
        message.page = object.page !== undefined && object.page !== null ? $dkaBG.Long.fromValue(object.page) : $dkaBG.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseGetTxsEventResponse() {
    return {
        txs: [],
        txResponses: [],
        pagination: undefined,
        total: $dkaBG.Long.UZERO
    };
}
module.exports.GetTxsEventResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        for (const v of message.txs)$bkT1A.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.txResponses)$7q6Mz.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        if (!message.total.isZero()) writer.uint32(32).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetTxsEventResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($bkT1A.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($7q6Mz.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$bkT1A.Tx.fromJSON(e)) : [],
            txResponses: Array.isArray(object?.txResponses) ? object.txResponses.map((e)=>$7q6Mz.TxResponse.fromJSON(e)) : [],
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined,
            total: (0, $dkaBG.isSet)(object.total) ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $bkT1A.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map((e)=>e ? $7q6Mz.TxResponse.toJSON(e) : undefined);
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        message.total !== undefined && (obj.total = (message.total || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetTxsEventResponse();
        message.txs = object.txs?.map((e)=>$bkT1A.Tx.fromPartial(e)) || [];
        message.txResponses = object.txResponses?.map((e)=>$7q6Mz.TxResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        message.total = object.total !== undefined && object.total !== null ? $dkaBG.Long.fromValue(object.total) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseBroadcastTxRequest() {
    return {
        txBytes: new Uint8Array(),
        mode: 0
    };
}
module.exports.BroadcastTxRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseBroadcastTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $dkaBG.isSet)(object.txBytes) ? (0, $dkaBG.bytesFromBase64)(object.txBytes) : new Uint8Array(),
            mode: (0, $dkaBG.isSet)(object.mode) ? $a2cf32bcdade92bf$var$broadcastModeFromJSON(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $dkaBG.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $a2cf32bcdade92bf$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseBroadcastTxRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseBroadcastTxResponse() {
    return {
        txResponse: undefined
    };
}
module.exports.BroadcastTxResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.txResponse !== undefined) $7q6Mz.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseBroadcastTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $7q6Mz.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txResponse: (0, $dkaBG.isSet)(object.txResponse) ? $7q6Mz.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $7q6Mz.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseBroadcastTxResponse();
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $7q6Mz.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseSimulateRequest() {
    return {
        tx: undefined,
        txBytes: new Uint8Array()
    };
}
module.exports.SimulateRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $bkT1A.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseSimulateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $bkT1A.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? $bkT1A.Tx.fromJSON(object.tx) : undefined,
            txBytes: (0, $dkaBG.isSet)(object.txBytes) ? (0, $dkaBG.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $bkT1A.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = (0, $dkaBG.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $bkT1A.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseSimulateResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
module.exports.SimulateResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) $7q6Mz.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $7q6Mz.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseSimulateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $7q6Mz.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $7q6Mz.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $dkaBG.isSet)(object.gasInfo) ? $7q6Mz.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $dkaBG.isSet)(object.result) ? $7q6Mz.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $7q6Mz.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $7q6Mz.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseSimulateResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $7q6Mz.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $7q6Mz.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseGetTxRequest() {
    return {
        hash: ""
    };
}
module.exports.GetTxRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $dkaBG.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetTxRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseGetTxResponse() {
    return {
        tx: undefined,
        txResponse: undefined
    };
}
module.exports.GetTxResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $bkT1A.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $7q6Mz.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $bkT1A.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $7q6Mz.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? $bkT1A.Tx.fromJSON(object.tx) : undefined,
            txResponse: (0, $dkaBG.isSet)(object.txResponse) ? $7q6Mz.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $bkT1A.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $7q6Mz.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $bkT1A.Tx.fromPartial(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $7q6Mz.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsRequest() {
    return {
        height: $dkaBG.Long.ZERO,
        pagination: undefined
    };
}
module.exports.GetBlockWithTxsRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.pagination !== undefined) $aBpB1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = $aBpB1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsRequest();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsResponse() {
    return {
        txs: [],
        blockId: undefined,
        block: undefined,
        pagination: undefined
    };
}
module.exports.GetBlockWithTxsResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        for (const v of message.txs)$bkT1A.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.blockId !== undefined) $DRMtG.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        if (message.block !== undefined) $imsbT.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        if (message.pagination !== undefined) $aBpB1.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($bkT1A.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = $DRMtG.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = $imsbT.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = $aBpB1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$bkT1A.Tx.fromJSON(e)) : [],
            blockId: (0, $dkaBG.isSet)(object.blockId) ? $DRMtG.BlockID.fromJSON(object.blockId) : undefined,
            block: (0, $dkaBG.isSet)(object.block) ? $imsbT.Block.fromJSON(object.block) : undefined,
            pagination: (0, $dkaBG.isSet)(object.pagination) ? $aBpB1.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $bkT1A.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        message.blockId !== undefined && (obj.blockId = message.blockId ? $DRMtG.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? $imsbT.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $aBpB1.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseGetBlockWithTxsResponse();
        message.txs = object.txs?.map((e)=>$bkT1A.Tx.fromPartial(e)) || [];
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $DRMtG.BlockID.fromPartial(object.blockId) : undefined;
        message.block = object.block !== undefined && object.block !== null ? $imsbT.Block.fromPartial(object.block) : undefined;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $aBpB1.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxDecodeRequest() {
    return {
        txBytes: new Uint8Array()
    };
}
module.exports.TxDecodeRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $dkaBG.isSet)(object.txBytes) ? (0, $dkaBG.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $dkaBG.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxDecodeResponse() {
    return {
        tx: undefined
    };
}
module.exports.TxDecodeResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $bkT1A.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $bkT1A.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? $bkT1A.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $bkT1A.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $bkT1A.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxEncodeRequest() {
    return {
        tx: undefined
    };
}
module.exports.TxEncodeRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $bkT1A.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $bkT1A.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $dkaBG.isSet)(object.tx) ? $bkT1A.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $bkT1A.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $bkT1A.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxEncodeResponse() {
    return {
        txBytes: new Uint8Array()
    };
}
module.exports.TxEncodeResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $dkaBG.isSet)(object.txBytes) ? (0, $dkaBG.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $dkaBG.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeResponse();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxEncodeAminoRequest() {
    return {
        aminoJson: ""
    };
}
module.exports.TxEncodeAminoRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $dkaBG.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeAminoRequest();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxEncodeAminoResponse() {
    return {
        aminoBinary: new Uint8Array()
    };
}
module.exports.TxEncodeAminoResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $dkaBG.isSet)(object.aminoBinary) ? (0, $dkaBG.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $dkaBG.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxEncodeAminoResponse();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxDecodeAminoRequest() {
    return {
        aminoBinary: new Uint8Array()
    };
}
module.exports.TxDecodeAminoRequest = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $dkaBG.isSet)(object.aminoBinary) ? (0, $dkaBG.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $dkaBG.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeAminoRequest();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $a2cf32bcdade92bf$var$createBaseTxDecodeAminoResponse() {
    return {
        aminoJson: ""
    };
}
module.exports.TxDecodeAminoResponse = {
    encode (message, writer = $a2cf32bcdade92bf$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a2cf32bcdade92bf$var$_m0.Reader ? input : new $a2cf32bcdade92bf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $dkaBG.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $a2cf32bcdade92bf$var$createBaseTxDecodeAminoResponse();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
class $a2cf32bcdade92bf$var$ServiceClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
        this.TxDecode = this.TxDecode.bind(this);
        this.TxEncode = this.TxEncode.bind(this);
        this.TxEncodeAmino = this.TxEncodeAmino.bind(this);
        this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(request) {
        const data = module.exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data)=>module.exports.SimulateResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    GetTx(request) {
        const data = module.exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data)=>module.exports.GetTxResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    BroadcastTx(request) {
        const data = module.exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data)=>module.exports.BroadcastTxResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = module.exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data)=>module.exports.GetTxsEventResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    GetBlockWithTxs(request) {
        const data = module.exports.GetBlockWithTxsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
        return promise.then((data)=>module.exports.GetBlockWithTxsResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    TxDecode(request) {
        const data = module.exports.TxDecodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", data);
        return promise.then((data)=>module.exports.TxDecodeResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    TxEncode(request) {
        const data = module.exports.TxEncodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", data);
        return promise.then((data)=>module.exports.TxEncodeResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    TxEncodeAmino(request) {
        const data = module.exports.TxEncodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", data);
        return promise.then((data)=>module.exports.TxEncodeAminoResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
    TxDecodeAmino(request) {
        const data = module.exports.TxDecodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", data);
        return promise.then((data)=>module.exports.TxDecodeAminoResponse.decode(new $a2cf32bcdade92bf$var$_m0.Reader(data)));
    }
}
module.exports.ServiceClientImpl = $a2cf32bcdade92bf$var$ServiceClientImpl;

});
parcelRegister("7q6Mz", function(module, exports) {
"use strict";
var $567038f906f11965$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $567038f906f11965$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $567038f906f11965$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $567038f906f11965$var$__createBinding(result, mod, k);
    }
    $567038f906f11965$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SearchTxsResult = module.exports.TxMsgData = module.exports.MsgData = module.exports.SimulationResponse = module.exports.Result = module.exports.GasInfo = module.exports.Attribute = module.exports.StringEvent = module.exports.ABCIMessageLog = module.exports.TxResponse = module.exports.protobufPackage = void 0;

var $axIO3 = parcelRequire("axIO3");

var $VT2xE = parcelRequire("VT2xE");

var $dkaBG = parcelRequire("dkaBG");

const $567038f906f11965$var$_m0 = $567038f906f11965$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.base.abci.v1beta1";
function $567038f906f11965$var$createBaseTxResponse() {
    return {
        height: $dkaBG.Long.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: $dkaBG.Long.ZERO,
        gasUsed: $dkaBG.Long.ZERO,
        tx: undefined,
        timestamp: "",
        events: []
    };
}
module.exports.TxResponse = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        for (const v of message.logs)module.exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $axIO3.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        for (const v of message.events)$VT2xE.Event.encode(v, writer.uint32(106).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push(module.exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $axIO3.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($VT2xE.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $dkaBG.isSet)(object.height) ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO,
            txhash: (0, $dkaBG.isSet)(object.txhash) ? String(object.txhash) : "",
            codespace: (0, $dkaBG.isSet)(object.codespace) ? String(object.codespace) : "",
            code: (0, $dkaBG.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $dkaBG.isSet)(object.data) ? String(object.data) : "",
            rawLog: (0, $dkaBG.isSet)(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object?.logs) ? object.logs.map((e)=>module.exports.ABCIMessageLog.fromJSON(e)) : [],
            info: (0, $dkaBG.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $dkaBG.isSet)(object.gasWanted) ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.ZERO,
            gasUsed: (0, $dkaBG.isSet)(object.gasUsed) ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.ZERO,
            tx: (0, $dkaBG.isSet)(object.tx) ? $axIO3.Any.fromJSON(object.tx) : undefined,
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$VT2xE.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $dkaBG.Long.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map((e)=>e ? module.exports.ABCIMessageLog.toJSON(e) : undefined);
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $dkaBG.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $dkaBG.Long.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $axIO3.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map((e)=>e ? $VT2xE.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseTxResponse();
        message.height = object.height !== undefined && object.height !== null ? $dkaBG.Long.fromValue(object.height) : $dkaBG.Long.ZERO;
        message.txhash = object.txhash ?? "";
        message.codespace = object.codespace ?? "";
        message.code = object.code ?? 0;
        message.data = object.data ?? "";
        message.rawLog = object.rawLog ?? "";
        message.logs = object.logs?.map((e)=>module.exports.ABCIMessageLog.fromPartial(e)) || [];
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $axIO3.Any.fromPartial(object.tx) : undefined;
        message.timestamp = object.timestamp ?? "";
        message.events = object.events?.map((e)=>$VT2xE.Event.fromPartial(e)) || [];
        return message;
    }
};
function $567038f906f11965$var$createBaseABCIMessageLog() {
    return {
        msgIndex: 0,
        log: "",
        events: []
    };
}
module.exports.ABCIMessageLog = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)module.exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseABCIMessageLog();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push(module.exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgIndex: (0, $dkaBG.isSet)(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: (0, $dkaBG.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>module.exports.StringEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? module.exports.StringEvent.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseABCIMessageLog();
        message.msgIndex = object.msgIndex ?? 0;
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>module.exports.StringEvent.fromPartial(e)) || [];
        return message;
    }
};
function $567038f906f11965$var$createBaseStringEvent() {
    return {
        type: "",
        attributes: []
    };
}
module.exports.StringEvent = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)module.exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseStringEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push(module.exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $dkaBG.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>module.exports.Attribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? module.exports.Attribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseStringEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>module.exports.Attribute.fromPartial(e)) || [];
        return message;
    }
};
function $567038f906f11965$var$createBaseAttribute() {
    return {
        key: "",
        value: ""
    };
}
module.exports.Attribute = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $dkaBG.isSet)(object.key) ? String(object.key) : "",
            value: (0, $dkaBG.isSet)(object.value) ? String(object.value) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    }
};
function $567038f906f11965$var$createBaseGasInfo() {
    return {
        gasWanted: $dkaBG.Long.UZERO,
        gasUsed: $dkaBG.Long.UZERO
    };
}
module.exports.GasInfo = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseGasInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasWanted: (0, $dkaBG.isSet)(object.gasWanted) ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.UZERO,
            gasUsed: (0, $dkaBG.isSet)(object.gasUsed) ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $dkaBG.Long.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $dkaBG.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseGasInfo();
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $dkaBG.Long.fromValue(object.gasWanted) : $dkaBG.Long.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $dkaBG.Long.fromValue(object.gasUsed) : $dkaBG.Long.UZERO;
        return message;
    }
};
function $567038f906f11965$var$createBaseResult() {
    return {
        data: new Uint8Array(),
        log: "",
        events: [],
        msgResponses: []
    };
}
module.exports.Result = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$VT2xE.Event.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.msgResponses)$axIO3.Any.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($VT2xE.Event.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.msgResponses.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $dkaBG.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$VT2xE.Event.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $VT2xE.Event.toJSON(e) : undefined);
        else obj.events = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseResult();
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>$VT2xE.Event.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};
function $567038f906f11965$var$createBaseSimulationResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
module.exports.SimulationResponse = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) module.exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) module.exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseSimulationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = module.exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = module.exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $dkaBG.isSet)(object.gasInfo) ? module.exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $dkaBG.isSet)(object.result) ? module.exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? module.exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? module.exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseSimulationResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? module.exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? module.exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $567038f906f11965$var$createBaseMsgData() {
    return {
        msgType: "",
        data: new Uint8Array()
    };
}
module.exports.MsgData = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgType: (0, $dkaBG.isSet)(object.msgType) ? String(object.msgType) : "",
            data: (0, $dkaBG.isSet)(object.data) ? (0, $dkaBG.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = (0, $dkaBG.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseMsgData();
        message.msgType = object.msgType ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $567038f906f11965$var$createBaseTxMsgData() {
    return {
        data: [],
        msgResponses: []
    };
}
module.exports.TxMsgData = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        for (const v of message.data)module.exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.msgResponses)$axIO3.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseTxMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push(module.exports.MsgData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.msgResponses.push($axIO3.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: Array.isArray(object?.data) ? object.data.map((e)=>module.exports.MsgData.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$axIO3.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.data) obj.data = message.data.map((e)=>e ? module.exports.MsgData.toJSON(e) : undefined);
        else obj.data = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $axIO3.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseTxMsgData();
        message.data = object.data?.map((e)=>module.exports.MsgData.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$axIO3.Any.fromPartial(e)) || [];
        return message;
    }
};
function $567038f906f11965$var$createBaseSearchTxsResult() {
    return {
        totalCount: $dkaBG.Long.UZERO,
        count: $dkaBG.Long.UZERO,
        pageNumber: $dkaBG.Long.UZERO,
        pageTotal: $dkaBG.Long.UZERO,
        limit: $dkaBG.Long.UZERO,
        txs: []
    };
}
module.exports.SearchTxsResult = {
    encode (message, writer = $567038f906f11965$var$_m0.Writer.create()) {
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        for (const v of message.txs)module.exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $567038f906f11965$var$_m0.Reader ? input : new $567038f906f11965$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $567038f906f11965$var$createBaseSearchTxsResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push(module.exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            totalCount: (0, $dkaBG.isSet)(object.totalCount) ? $dkaBG.Long.fromValue(object.totalCount) : $dkaBG.Long.UZERO,
            count: (0, $dkaBG.isSet)(object.count) ? $dkaBG.Long.fromValue(object.count) : $dkaBG.Long.UZERO,
            pageNumber: (0, $dkaBG.isSet)(object.pageNumber) ? $dkaBG.Long.fromValue(object.pageNumber) : $dkaBG.Long.UZERO,
            pageTotal: (0, $dkaBG.isSet)(object.pageTotal) ? $dkaBG.Long.fromValue(object.pageTotal) : $dkaBG.Long.UZERO,
            limit: (0, $dkaBG.isSet)(object.limit) ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>module.exports.TxResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $dkaBG.Long.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $dkaBG.Long.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $dkaBG.Long.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $dkaBG.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $dkaBG.Long.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>e ? module.exports.TxResponse.toJSON(e) : undefined);
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $567038f906f11965$var$createBaseSearchTxsResult();
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $dkaBG.Long.fromValue(object.totalCount) : $dkaBG.Long.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $dkaBG.Long.fromValue(object.count) : $dkaBG.Long.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $dkaBG.Long.fromValue(object.pageNumber) : $dkaBG.Long.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $dkaBG.Long.fromValue(object.pageTotal) : $dkaBG.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $dkaBG.Long.fromValue(object.limit) : $dkaBG.Long.UZERO;
        message.txs = object.txs?.map((e)=>module.exports.TxResponse.fromPartial(e)) || [];
        return message;
    }
};

});

parcelRegister("imsbT", function(module, exports) {
"use strict";
var $d5e0262783402489$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5e0262783402489$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d5e0262783402489$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d5e0262783402489$var$__createBinding(result, mod, k);
    }
    $d5e0262783402489$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Block = module.exports.protobufPackage = void 0;

var $DRMtG = parcelRequire("DRMtG");

var $bHijU = parcelRequire("bHijU");

const $d5e0262783402489$var$_m0 = $d5e0262783402489$var$__importStar((parcelRequire("1wC51")));

var $dkaBG = parcelRequire("dkaBG");
module.exports.protobufPackage = "tendermint.types";
function $d5e0262783402489$var$createBaseBlock() {
    return {
        header: undefined,
        data: undefined,
        evidence: undefined,
        lastCommit: undefined
    };
}
module.exports.Block = {
    encode (message, writer = $d5e0262783402489$var$_m0.Writer.create()) {
        if (message.header !== undefined) $DRMtG.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $DRMtG.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.evidence !== undefined) $bHijU.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        if (message.lastCommit !== undefined) $DRMtG.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d5e0262783402489$var$_m0.Reader ? input : new $d5e0262783402489$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d5e0262783402489$var$createBaseBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $DRMtG.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $DRMtG.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = $bHijU.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = $DRMtG.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $dkaBG.isSet)(object.header) ? $DRMtG.Header.fromJSON(object.header) : undefined,
            data: (0, $dkaBG.isSet)(object.data) ? $DRMtG.Data.fromJSON(object.data) : undefined,
            evidence: (0, $dkaBG.isSet)(object.evidence) ? $bHijU.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: (0, $dkaBG.isSet)(object.lastCommit) ? $DRMtG.Commit.fromJSON(object.lastCommit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $DRMtG.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? $DRMtG.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $bHijU.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined && (obj.lastCommit = message.lastCommit ? $DRMtG.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d5e0262783402489$var$createBaseBlock();
        message.header = object.header !== undefined && object.header !== null ? $DRMtG.Header.fromPartial(object.header) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $DRMtG.Data.fromPartial(object.data) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $bHijU.EvidenceList.fromPartial(object.evidence) : undefined;
        message.lastCommit = object.lastCommit !== undefined && object.lastCommit !== null ? $DRMtG.Commit.fromPartial(object.lastCommit) : undefined;
        return message;
    }
};

});
parcelRegister("bHijU", function(module, exports) {
"use strict";
var $8841ebd89dcc129b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8841ebd89dcc129b$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8841ebd89dcc129b$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8841ebd89dcc129b$var$__createBinding(result, mod, k);
    }
    $8841ebd89dcc129b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvidenceList = module.exports.LightClientAttackEvidence = module.exports.DuplicateVoteEvidence = module.exports.Evidence = module.exports.protobufPackage = void 0;

var $DRMtG = parcelRequire("DRMtG");

var $cPgyI = parcelRequire("cPgyI");

var $5ngWm = parcelRequire("5ngWm");

var $dkaBG = parcelRequire("dkaBG");

const $8841ebd89dcc129b$var$_m0 = $8841ebd89dcc129b$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "tendermint.types";
function $8841ebd89dcc129b$var$createBaseEvidence() {
    return {
        duplicateVoteEvidence: undefined,
        lightClientAttackEvidence: undefined
    };
}
module.exports.Evidence = {
    encode (message, writer = $8841ebd89dcc129b$var$_m0.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) module.exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        if (message.lightClientAttackEvidence !== undefined) module.exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8841ebd89dcc129b$var$_m0.Reader ? input : new $8841ebd89dcc129b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8841ebd89dcc129b$var$createBaseEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplicateVoteEvidence = module.exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = module.exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            duplicateVoteEvidence: (0, $dkaBG.isSet)(object.duplicateVoteEvidence) ? module.exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence) : undefined,
            lightClientAttackEvidence: (0, $dkaBG.isSet)(object.lightClientAttackEvidence) ? module.exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined && (obj.duplicateVoteEvidence = message.duplicateVoteEvidence ? module.exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence) : undefined);
        message.lightClientAttackEvidence !== undefined && (obj.lightClientAttackEvidence = message.lightClientAttackEvidence ? module.exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8841ebd89dcc129b$var$createBaseEvidence();
        message.duplicateVoteEvidence = object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null ? module.exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence) : undefined;
        message.lightClientAttackEvidence = object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null ? module.exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence) : undefined;
        return message;
    }
};
function $8841ebd89dcc129b$var$createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: $dkaBG.Long.ZERO,
        validatorPower: $dkaBG.Long.ZERO,
        timestamp: undefined
    };
}
module.exports.DuplicateVoteEvidence = {
    encode (message, writer = $8841ebd89dcc129b$var$_m0.Writer.create()) {
        if (message.voteA !== undefined) $DRMtG.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        if (message.voteB !== undefined) $DRMtG.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        if (!message.validatorPower.isZero()) writer.uint32(32).int64(message.validatorPower);
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8841ebd89dcc129b$var$_m0.Reader ? input : new $8841ebd89dcc129b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8841ebd89dcc129b$var$createBaseDuplicateVoteEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.voteA = $DRMtG.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = $DRMtG.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            voteA: (0, $dkaBG.isSet)(object.voteA) ? $DRMtG.Vote.fromJSON(object.voteA) : undefined,
            voteB: (0, $dkaBG.isSet)(object.voteB) ? $DRMtG.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: (0, $dkaBG.isSet)(object.totalVotingPower) ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO,
            validatorPower: (0, $dkaBG.isSet)(object.validatorPower) ? $dkaBG.Long.fromValue(object.validatorPower) : $dkaBG.Long.ZERO,
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? $DRMtG.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? $DRMtG.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $dkaBG.Long.ZERO).toString());
        message.validatorPower !== undefined && (obj.validatorPower = (message.validatorPower || $dkaBG.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $8841ebd89dcc129b$var$createBaseDuplicateVoteEvidence();
        message.voteA = object.voteA !== undefined && object.voteA !== null ? $DRMtG.Vote.fromPartial(object.voteA) : undefined;
        message.voteB = object.voteB !== undefined && object.voteB !== null ? $DRMtG.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO;
        message.validatorPower = object.validatorPower !== undefined && object.validatorPower !== null ? $dkaBG.Long.fromValue(object.validatorPower) : $dkaBG.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $8841ebd89dcc129b$var$createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: $dkaBG.Long.ZERO,
        byzantineValidators: [],
        totalVotingPower: $dkaBG.Long.ZERO,
        timestamp: undefined
    };
}
module.exports.LightClientAttackEvidence = {
    encode (message, writer = $8841ebd89dcc129b$var$_m0.Writer.create()) {
        if (message.conflictingBlock !== undefined) $DRMtG.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        if (!message.commonHeight.isZero()) writer.uint32(16).int64(message.commonHeight);
        for (const v of message.byzantineValidators)$5ngWm.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(32).int64(message.totalVotingPower);
        if (message.timestamp !== undefined) $cPgyI.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8841ebd89dcc129b$var$_m0.Reader ? input : new $8841ebd89dcc129b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8841ebd89dcc129b$var$createBaseLightClientAttackEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.conflictingBlock = $DRMtG.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push($5ngWm.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $cPgyI.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            conflictingBlock: (0, $dkaBG.isSet)(object.conflictingBlock) ? $DRMtG.LightBlock.fromJSON(object.conflictingBlock) : undefined,
            commonHeight: (0, $dkaBG.isSet)(object.commonHeight) ? $dkaBG.Long.fromValue(object.commonHeight) : $dkaBG.Long.ZERO,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>$5ngWm.Validator.fromJSON(e)) : [],
            totalVotingPower: (0, $dkaBG.isSet)(object.totalVotingPower) ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO,
            timestamp: (0, $dkaBG.isSet)(object.timestamp) ? (0, $dkaBG.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.conflictingBlock !== undefined && (obj.conflictingBlock = message.conflictingBlock ? $DRMtG.LightBlock.toJSON(message.conflictingBlock) : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || $dkaBG.Long.ZERO).toString());
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $5ngWm.Validator.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $dkaBG.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $dkaBG.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $8841ebd89dcc129b$var$createBaseLightClientAttackEvidence();
        message.conflictingBlock = object.conflictingBlock !== undefined && object.conflictingBlock !== null ? $DRMtG.LightBlock.fromPartial(object.conflictingBlock) : undefined;
        message.commonHeight = object.commonHeight !== undefined && object.commonHeight !== null ? $dkaBG.Long.fromValue(object.commonHeight) : $dkaBG.Long.ZERO;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>$5ngWm.Validator.fromPartial(e)) || [];
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $dkaBG.Long.fromValue(object.totalVotingPower) : $dkaBG.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $cPgyI.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $8841ebd89dcc129b$var$createBaseEvidenceList() {
    return {
        evidence: []
    };
}
module.exports.EvidenceList = {
    encode (message, writer = $8841ebd89dcc129b$var$_m0.Writer.create()) {
        for (const v of message.evidence)module.exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8841ebd89dcc129b$var$_m0.Reader ? input : new $8841ebd89dcc129b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8841ebd89dcc129b$var$createBaseEvidenceList();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.evidence.push(module.exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            evidence: Array.isArray(object?.evidence) ? object.evidence.map((e)=>module.exports.Evidence.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.evidence) obj.evidence = message.evidence.map((e)=>e ? module.exports.Evidence.toJSON(e) : undefined);
        else obj.evidence = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8841ebd89dcc129b$var$createBaseEvidenceList();
        message.evidence = object.evidence?.map((e)=>module.exports.Evidence.fromPartial(e)) || [];
        return message;
    }
};

});




parcelRegister("bx8FW", function(module, exports) {
"use strict";
var $8659818e767653d6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVestingAminoConverters = module.exports.isAminoMsgCreateVestingAccount = void 0;

const $8659818e767653d6$var$long_1 = $8659818e767653d6$var$__importDefault((parcelRequire("3gmZQ")));
function $8659818e767653d6$var$isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
module.exports.isAminoMsgCreateVestingAccount = $8659818e767653d6$var$isAminoMsgCreateVestingAccount;
function $8659818e767653d6$var$createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount, endTime: endTime, delayed: delayed })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ],
                    end_time: endTime.toString(),
                    delayed: delayed
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount, end_time: end_time, delayed: delayed })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ],
                    endTime: $8659818e767653d6$var$long_1.default.fromString(end_time),
                    delayed: delayed
                })
        }
    };
}
module.exports.createVestingAminoConverters = $8659818e767653d6$var$createVestingAminoConverters;

});

parcelRegister("lSghZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.vestingTypes = void 0;

var $5CWEo = parcelRequire("5CWEo");
module.exports.vestingTypes = [
    [
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        $5CWEo.MsgCreateVestingAccount
    ]
];

});
parcelRegister("5CWEo", function(module, exports) {
"use strict";
var $418dff20164186e1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $418dff20164186e1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $418dff20164186e1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $418dff20164186e1$var$__createBinding(result, mod, k);
    }
    $418dff20164186e1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgCreatePeriodicVestingAccountResponse = module.exports.MsgCreatePeriodicVestingAccount = module.exports.MsgCreatePermanentLockedAccountResponse = module.exports.MsgCreatePermanentLockedAccount = module.exports.MsgCreateVestingAccountResponse = module.exports.MsgCreateVestingAccount = module.exports.protobufPackage = void 0;

var $efcGD = parcelRequire("efcGD");

var $de2Rr = parcelRequire("de2Rr");

var $dkaBG = parcelRequire("dkaBG");

const $418dff20164186e1$var$_m0 = $418dff20164186e1$var$__importStar((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.vesting.v1beta1";
function $418dff20164186e1$var$createBaseMsgCreateVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
        endTime: $dkaBG.Long.ZERO,
        delayed: false
    };
}
module.exports.MsgCreateVestingAccount = {
    encode (message, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreateVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $dkaBG.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $dkaBG.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : [],
            endTime: (0, $dkaBG.isSet)(object.endTime) ? $dkaBG.Long.fromValue(object.endTime) : $dkaBG.Long.ZERO,
            delayed: (0, $dkaBG.isSet)(object.delayed) ? Boolean(object.delayed) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $dkaBG.Long.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial (object) {
        const message = $418dff20164186e1$var$createBaseMsgCreateVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $dkaBG.Long.fromValue(object.endTime) : $dkaBG.Long.ZERO;
        message.delayed = object.delayed ?? false;
        return message;
    }
};
function $418dff20164186e1$var$createBaseMsgCreateVestingAccountResponse() {
    return {};
}
module.exports.MsgCreateVestingAccountResponse = {
    encode (_, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreateVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $418dff20164186e1$var$createBaseMsgCreateVestingAccountResponse();
        return message;
    }
};
function $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
module.exports.MsgCreatePermanentLockedAccount = {
    encode (message, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$efcGD.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($efcGD.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $dkaBG.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $dkaBG.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$efcGD.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $efcGD.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$efcGD.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccountResponse() {
    return {};
}
module.exports.MsgCreatePermanentLockedAccountResponse = {
    encode (_, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $418dff20164186e1$var$createBaseMsgCreatePermanentLockedAccountResponse();
        return message;
    }
};
function $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        startTime: $dkaBG.Long.ZERO,
        vestingPeriods: []
    };
}
module.exports.MsgCreatePeriodicVestingAccount = {
    encode (message, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (!message.startTime.isZero()) writer.uint32(24).int64(message.startTime);
        for (const v of message.vestingPeriods)$de2Rr.Period.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push($de2Rr.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $dkaBG.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $dkaBG.isSet)(object.toAddress) ? String(object.toAddress) : "",
            startTime: (0, $dkaBG.isSet)(object.startTime) ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>$de2Rr.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $dkaBG.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $de2Rr.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $dkaBG.Long.fromValue(object.startTime) : $dkaBG.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>$de2Rr.Period.fromPartial(e)) || [];
        return message;
    }
};
function $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccountResponse() {
    return {};
}
module.exports.MsgCreatePeriodicVestingAccountResponse = {
    encode (_, writer = $418dff20164186e1$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $418dff20164186e1$var$_m0.Reader ? input : new $418dff20164186e1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $418dff20164186e1$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        return message;
    }
};
class $418dff20164186e1$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(request) {
        const data = module.exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data)=>module.exports.MsgCreateVestingAccountResponse.decode(new $418dff20164186e1$var$_m0.Reader(data)));
    }
    CreatePermanentLockedAccount(request) {
        const data = module.exports.MsgCreatePermanentLockedAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", data);
        return promise.then((data)=>module.exports.MsgCreatePermanentLockedAccountResponse.decode(new $418dff20164186e1$var$_m0.Reader(data)));
    }
    CreatePeriodicVestingAccount(request) {
        const data = module.exports.MsgCreatePeriodicVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", data);
        return promise.then((data)=>module.exports.MsgCreatePeriodicVestingAccountResponse.decode(new $418dff20164186e1$var$_m0.Reader(data)));
    }
}
module.exports.MsgClientImpl = $418dff20164186e1$var$MsgClientImpl;

});



parcelRegister("jvj3I", function(module, exports) {
"use strict";
var $e32fb242504137d1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeMultisignedTxBytes = module.exports.makeMultisignedTx = module.exports.makeCompactBitArray = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $94ZnX = parcelRequire("94ZnX");

var $dtY18 = parcelRequire("dtY18");

var $eNZfD = parcelRequire("eNZfD");

var $67U77 = parcelRequire("67U77");

var $bkT1A = parcelRequire("bkT1A");

var $bkT1A = parcelRequire("bkT1A");

const $e32fb242504137d1$var$long_1 = $e32fb242504137d1$var$__importDefault((parcelRequire("3gmZQ")));
function $e32fb242504137d1$var$makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index)=>{
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value) bytes[bytePos] |= 1 << 7 - bitPos;
    });
    return $eNZfD.CompactBitArray.fromPartial({
        elems: bytes,
        extraBitsStored: extraBits
    });
}
module.exports.makeCompactBitArray = $e32fb242504137d1$var$makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */ function $e32fb242504137d1$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, $94ZnX.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for(let i = 0; i < multisigPubkey.value.pubkeys.length; i++){
        const signerAddress = (0, $bVJSA.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, $dtY18.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: $e32fb242504137d1$var$makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_)=>({
                        single: {
                            mode: $67U77.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    }))
            }
        },
        sequence: $e32fb242504137d1$var$long_1.default.fromNumber(sequence)
    };
    const authInfo = $bkT1A.AuthInfo.fromPartial({
        signerInfos: [
            signerInfo
        ],
        fee: {
            amount: [
                ...fee.amount
            ],
            gasLimit: $e32fb242504137d1$var$long_1.default.fromString(fee.gas)
        }
    });
    const authInfoBytes = $bkT1A.AuthInfo.encode(authInfo).finish();
    const signedTx = $bkT1A.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [
            $eNZfD.MultiSignature.encode($eNZfD.MultiSignature.fromPartial({
                signatures: signaturesList
            })).finish()
        ]
    });
    return signedTx;
}
module.exports.makeMultisignedTx = $e32fb242504137d1$var$makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */ function $e32fb242504137d1$var$makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const signedTx = $e32fb242504137d1$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from($bkT1A.TxRaw.encode(signedTx).finish());
}
module.exports.makeMultisignedTxBytes = $e32fb242504137d1$var$makeMultisignedTxBytes;

});

parcelRegister("9NBGi", function(module, exports) {
"use strict";
var $7225eb5710f45d65$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SigningStargateClient = module.exports.createDefaultAminoConverters = module.exports.defaultRegistryTypes = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $dtY18 = parcelRequire("dtY18");

var $kteII = parcelRequire("kteII");

var $hm8y1 = parcelRequire("hm8y1");

var $efcGD = parcelRequire("efcGD");

var $4Wn4Z = parcelRequire("4Wn4Z");

var $haFHP = parcelRequire("haFHP");

var $67U77 = parcelRequire("67U77");

var $bkT1A = parcelRequire("bkT1A");

var $apYUm = parcelRequire("apYUm");

const $7225eb5710f45d65$var$long_1 = $7225eb5710f45d65$var$__importDefault((parcelRequire("3gmZQ")));

var $7iLoQ = parcelRequire("7iLoQ");

var $c8wER = parcelRequire("c8wER");

var $6qSFW = parcelRequire("6qSFW");

var $6qSFW = parcelRequire("6qSFW");

var $d6b9W = parcelRequire("d6b9W");
module.exports.defaultRegistryTypes = [
    [
        "/cosmos.base.v1beta1.Coin",
        $efcGD.Coin
    ],
    ...$6qSFW.authzTypes,
    ...$6qSFW.bankTypes,
    ...$6qSFW.distributionTypes,
    ...$6qSFW.feegrantTypes,
    ...$6qSFW.govTypes,
    ...$6qSFW.groupTypes,
    ...$6qSFW.stakingTypes,
    ...$6qSFW.ibcTypes,
    ...$6qSFW.vestingTypes
];
function $7225eb5710f45d65$var$createDefaultAminoConverters() {
    return {
        ...(0, $6qSFW.createAuthzAminoConverters)(),
        ...(0, $6qSFW.createBankAminoConverters)(),
        ...(0, $6qSFW.createDistributionAminoConverters)(),
        ...(0, $6qSFW.createGovAminoConverters)(),
        ...(0, $6qSFW.createStakingAminoConverters)(),
        ...(0, $6qSFW.createIbcAminoConverters)(),
        ...(0, $6qSFW.createFeegrantAminoConverters)(),
        ...(0, $6qSFW.createVestingAminoConverters)()
    };
}
module.exports.createDefaultAminoConverters = $7225eb5710f45d65$var$createDefaultAminoConverters;
class $7225eb5710f45d65$var$SigningStargateClient extends $d6b9W.StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */ static async connectWithSigner(endpoint, signer, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $kteII.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $kteII.Tendermint34Client.connect(endpoint);
        }
        return $7225eb5710f45d65$var$SigningStargateClient.createWithSigner(tmClient, signer, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async createWithSigner(tmClient, signer, options = {}) {
        return new $7225eb5710f45d65$var$SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ static async offline(signer, options = {}) {
        return new $7225eb5710f45d65$var$SigningStargateClient(undefined, signer, options);
    }
    constructor(tmClient, signer, options){
        super(tmClient, options);
        const { registry: registry = new $dtY18.Registry(module.exports.defaultRegistryTypes), aminoTypes: aminoTypes = new $7iLoQ.AminoTypes($7225eb5710f45d65$var$createDefaultAminoConverters()) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m)=>this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $bVJSA.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence: sequence } = await this.getSequence(signerAddress);
        const { gasInfo: gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, $hm8y1.assertDefined)(gasInfo);
        return $h3uvW.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [
                    ...amount
                ]
            }
        };
        return this.signAndBroadcast(senderAddress, [
            sendMsg
        ], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: $haFHP.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            delegateMsg
        ], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: $haFHP.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            undelegateMsg
        ], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: $4Wn4Z.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            withdrawMsg
        ], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, /** timeout in seconds */ timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp ? $7225eb5710f45d65$var$long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000) : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: $apYUm.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds
            })
        };
        return this.signAndBroadcast(senderAddress, [
            transferMsg
        ], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $hm8y1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
            // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
            const multiplier = typeof fee === "number" ? fee : 1.4;
            usedFee = (0, $c8wER.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $bkT1A.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */ async signAndBroadcastSync(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $hm8y1.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, $c8wER.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $bkT1A.TxRaw.encode(txRaw).finish();
        return this.broadcastTxSync(txBytes);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */ async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) signerData = explicitSignerData;
        else {
            const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId
            };
        }
        return (0, $dtY18.isOfflineDirectSigner)(this.signer) ? this.signDirect(signerAddress, messages, fee, memo, signerData) : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $hm8y1.assert)(!(0, $dtY18.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $dtY18.encodePubkey)((0, $bVJSA.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = $67U77.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg)=>this.aminoTypes.toAmino(msg));
        const signDoc = (0, $bVJSA.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature: signature, signed: signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg)=>this.aminoTypes.fromAmino(msg)),
            memo: signed.memo
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = $h3uvW.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = $h3uvW.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, $dtY18.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: signedSequence
            }
        ], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return $bkT1A.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [
                (0, $94ZnX.fromBase64)(signature.signature)
            ]
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $hm8y1.assert)((0, $dtY18.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $dtY18.encodePubkey)((0, $bVJSA.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo
            }
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = $h3uvW.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, $dtY18.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: sequence
            }
        ], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, $dtY18.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature: signature, signed: signed } = await this.signer.signDirect(signerAddress, signDoc);
        return $bkT1A.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [
                (0, $94ZnX.fromBase64)(signature.signature)
            ]
        });
    }
}
module.exports.SigningStargateClient = $7225eb5710f45d65$var$SigningStargateClient;

});
parcelRegister("kteII", function(module, exports) {
"use strict";
var $ee71ef35214aba39$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee71ef35214aba39$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ee71ef35214aba39$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ee71ef35214aba39$var$__createBinding(result, mod, k);
    }
    $ee71ef35214aba39$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = module.exports.isTendermint37Client = module.exports.isTendermint34Client = module.exports.Tendermint37Client = module.exports.tendermint37 = module.exports.Tendermint34Client = module.exports.tendermint34 = module.exports.VoteType = module.exports.SubscriptionEventType = module.exports.Method = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.WebsocketClient = module.exports.HttpClient = module.exports.HttpBatchClient = module.exports.toSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromSeconds = module.exports.fromRfc3339WithNanoseconds = module.exports.DateTime = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = module.exports.pubkeyToRawAddress = module.exports.pubkeyToAddress = void 0;

var $ftRvM = parcelRequire("ftRvM");
Object.defineProperty(module.exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $ftRvM.pubkeyToAddress;
    }
});
Object.defineProperty(module.exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $ftRvM.pubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $ftRvM.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty(module.exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $ftRvM.rawSecp256k1PubkeyToRawAddress;
    }
});

var $hAC4f = parcelRequire("hAC4f");
Object.defineProperty(module.exports, "DateTime", {
    enumerable: true,
    get: function() {
        return $hAC4f.DateTime;
    }
});
Object.defineProperty(module.exports, "fromRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $hAC4f.fromRfc3339WithNanoseconds;
    }
});
Object.defineProperty(module.exports, "fromSeconds", {
    enumerable: true,
    get: function() {
        return $hAC4f.fromSeconds;
    }
});
Object.defineProperty(module.exports, "toRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $hAC4f.toRfc3339WithNanoseconds;
    }
});
Object.defineProperty(module.exports, "toSeconds", {
    enumerable: true,
    get: function() {
        return $hAC4f.toSeconds;
    }
});

var $lRzwx = parcelRequire("lRzwx");
Object.defineProperty(module.exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $lRzwx.HttpBatchClient;
    }
});
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $lRzwx.HttpClient;
    }
});
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $lRzwx.WebsocketClient;
    }
});

Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).SubscriptionEventType;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).VoteType;
    }
});

module.exports.tendermint34 = $ee71ef35214aba39$var$__importStar((parcelRequire("eBVDC")));

Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eBVDC")).Tendermint34Client;
    }
});

module.exports.tendermint37 = $ee71ef35214aba39$var$__importStar((parcelRequire("efVmP")));

Object.defineProperty(module.exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("efVmP")).Tendermint37Client;
    }
});

var $gdgBH = parcelRequire("gdgBH");
Object.defineProperty(module.exports, "isTendermint34Client", {
    enumerable: true,
    get: function() {
        return $gdgBH.isTendermint34Client;
    }
});
Object.defineProperty(module.exports, "isTendermint37Client", {
    enumerable: true,
    get: function() {
        return $gdgBH.isTendermint37Client;
    }
});

var $kchui = parcelRequire("kchui");
Object.defineProperty(module.exports, "BlockIdFlag", {
    enumerable: true,
    get: function() {
        return $kchui.BlockIdFlag;
    }
});

});
parcelRegister("ftRvM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyToAddress = module.exports.pubkeyToRawAddress = module.exports.rawSecp256k1PubkeyToRawAddress = module.exports.rawEd25519PubkeyToRawAddress = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");
function $b45312be3019093a$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $c162L.sha256)(pubkeyData).slice(0, 20);
}
module.exports.rawEd25519PubkeyToRawAddress = $b45312be3019093a$var$rawEd25519PubkeyToRawAddress;
function $b45312be3019093a$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $c162L.ripemd160)((0, $c162L.sha256)(pubkeyData));
}
module.exports.rawSecp256k1PubkeyToRawAddress = $b45312be3019093a$var$rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $b45312be3019093a$var$pubkeyToRawAddress(type, data) {
    switch(type){
        case "ed25519":
            return $b45312be3019093a$var$rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return $b45312be3019093a$var$rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
module.exports.pubkeyToRawAddress = $b45312be3019093a$var$pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $b45312be3019093a$var$pubkeyToAddress(type, data) {
    return (0, $94ZnX.toHex)($b45312be3019093a$var$pubkeyToRawAddress(type, data)).toUpperCase();
}
module.exports.pubkeyToAddress = $b45312be3019093a$var$pubkeyToAddress;

});

parcelRegister("hAC4f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTime = module.exports.toSeconds = module.exports.fromSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromRfc3339WithNanoseconds = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");
function $cce353dee36163ce$var$fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, $94ZnX.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
module.exports.fromRfc3339WithNanoseconds = $cce353dee36163ce$var$fromRfc3339WithNanoseconds;
function $cce353dee36163ce$var$toRfc3339WithNanoseconds(dateTime) {
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = dateTime.nanoseconds?.toString() ?? "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
module.exports.toRfc3339WithNanoseconds = $cce353dee36163ce$var$toRfc3339WithNanoseconds;
function $cce353dee36163ce$var$fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new $h3uvW.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) throw new Error("Nano seconds must not exceed 999999999");
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
module.exports.fromSeconds = $cce353dee36163ce$var$fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */ function $cce353dee36163ce$var$toSeconds(date) {
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: date.getTime() % 1000 * 1000000 + (date.nanoseconds ?? 0)
    };
}
module.exports.toSeconds = $cce353dee36163ce$var$toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */ class $cce353dee36163ce$var$DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */ static decode(dateTimeString) {
        return $cce353dee36163ce$var$fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */ static encode(dateTime) {
        return $cce353dee36163ce$var$toRfc3339WithNanoseconds(dateTime);
    }
}
module.exports.DateTime = $cce353dee36163ce$var$DateTime;

});

parcelRegister("lRzwx", function(module, exports) {
"use strict";
// This folder contains Tendermint-specific RPC clients
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = module.exports.instanceOfRpcStreamingClient = module.exports.HttpClient = module.exports.HttpBatchClient = void 0;

var $lb5zW = parcelRequire("lb5zW");
Object.defineProperty(module.exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $lb5zW.HttpBatchClient;
    }
});

var $jWZw8 = parcelRequire("jWZw8");
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $jWZw8.HttpClient;
    }
});

var $3U2Vn = parcelRequire("3U2Vn");
Object.defineProperty(module.exports, "instanceOfRpcStreamingClient", {
    enumerable: true,
    get: function() {
        return $3U2Vn.instanceOfRpcStreamingClient;
    }
});

var $fulbR = parcelRequire("fulbR");
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $fulbR.WebsocketClient;
    }
});

});
parcelRegister("lb5zW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpBatchClient = void 0;

var $kT9K3 = parcelRequire("kT9K3");

var $jDTkc = parcelRequire("jDTkc");

var $3U2Vn = parcelRequire("3U2Vn");
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
const $f6aef3e290e37634$var$defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20
};
class $f6aef3e290e37634$var$HttpBatchClient {
    constructor(endpoint, options = {}){
        this.queue = [];
        this.options = {
            batchSizeLimit: options.batchSizeLimit ?? $f6aef3e290e37634$var$defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: options.dispatchInterval ?? $f6aef3e290e37634$var$defaultHttpBatchClientOptions.dispatchInterval
        };
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $3U2Vn.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(()=>this.tick(), options.dispatchInterval);
        this.validate();
    }
    disconnect() {
        this.timer && clearInterval(this.timer);
        this.timer = undefined;
    }
    async execute(request) {
        return new Promise((resolve, reject)=>{
            this.queue.push({
                request: request,
                resolve: resolve,
                reject: reject
            });
            if (this.queue.length >= this.options.batchSizeLimit) // this train is full, let's go
            this.tick();
        });
    }
    validate() {
        if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1) throw new Error("batchSizeLimit must be a safe integer >= 1");
    }
    /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */ tick() {
        // Avoid race conditions
        const batch = this.queue.splice(0, this.options.batchSizeLimit);
        if (!batch.length) return;
        const requests = batch.map((s)=>s.request);
        const requestIds = requests.map((request)=>request.id);
        (0, $jDTkc.http)("POST", this.url, this.headers, requests).then((raw)=>{
            // Requests with a single entry return as an object
            const arr = Array.isArray(raw) ? raw : [
                raw
            ];
            arr.forEach((el)=>{
                const req = batch.find((s)=>s.request.id === el.id);
                if (!req) return;
                const { reject: reject, resolve: resolve } = req;
                const response = (0, $kT9K3.parseJsonRpcResponse)(el);
                if ((0, $kT9K3.isJsonRpcErrorResponse)(response)) reject(new Error(JSON.stringify(response.error)));
                else resolve(response);
            });
        }, (error)=>{
            for (const requestId of requestIds){
                const req = batch.find((s)=>s.request.id === requestId);
                if (!req) return;
                req.reject(error);
            }
        });
    }
}
module.exports.HttpBatchClient = $f6aef3e290e37634$var$HttpBatchClient;

});
parcelRegister("kT9K3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = module.exports.parseJsonRpcErrorResponse = module.exports.JsonRpcClient = module.exports.makeJsonRpcId = void 0;

var $fmFjk = parcelRequire("fmFjk");
Object.defineProperty(module.exports, "makeJsonRpcId", {
    enumerable: true,
    get: function() {
        return $fmFjk.makeJsonRpcId;
    }
});

var $khkhm = parcelRequire("khkhm");
Object.defineProperty(module.exports, "JsonRpcClient", {
    enumerable: true,
    get: function() {
        return $khkhm.JsonRpcClient;
    }
});

var $jklpM = parcelRequire("jklpM");
Object.defineProperty(module.exports, "parseJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $jklpM.parseJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcId", {
    enumerable: true,
    get: function() {
        return $jklpM.parseJsonRpcId;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcRequest", {
    enumerable: true,
    get: function() {
        return $jklpM.parseJsonRpcRequest;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcResponse", {
    enumerable: true,
    get: function() {
        return $jklpM.parseJsonRpcResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $jklpM.parseJsonRpcSuccessResponse;
    }
});

var $56yDU = parcelRequire("56yDU");
Object.defineProperty(module.exports, "isJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $56yDU.isJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "isJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $56yDU.isJsonRpcSuccessResponse;
    }
});
Object.defineProperty(module.exports, "jsonRpcCode", {
    enumerable: true,
    get: function() {
        return $56yDU.jsonRpcCode;
    }
});

});
parcelRegister("fmFjk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let $b2f8f485ee1a2e1d$var$counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */ function $b2f8f485ee1a2e1d$var$makeJsonRpcId() {
    return $b2f8f485ee1a2e1d$var$counter += 1;
}
module.exports.makeJsonRpcId = $b2f8f485ee1a2e1d$var$makeJsonRpcId;

});

parcelRegister("khkhm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcClient = void 0;

var $6Sxan = parcelRequire("6Sxan");

var $56yDU = parcelRequire("56yDU");
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */ class $ec35203077904450$var$JsonRpcClient {
    constructor(connection){
        this.connection = connection;
    }
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r)=>r.id === request.id);
        const pendingResponses = (0, $6Sxan.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, $56yDU.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
}
module.exports.JsonRpcClient = $ec35203077904450$var$JsonRpcClient;

});
parcelRegister("56yDU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = void 0;
function $3b786296036ebe4a$var$isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
module.exports.isJsonRpcErrorResponse = $3b786296036ebe4a$var$isJsonRpcErrorResponse;
function $3b786296036ebe4a$var$isJsonRpcSuccessResponse(response) {
    return !$3b786296036ebe4a$var$isJsonRpcErrorResponse(response);
}
module.exports.isJsonRpcSuccessResponse = $3b786296036ebe4a$var$isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */ module.exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000
    }
};

});


parcelRegister("jklpM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcErrorResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = void 0;

var $b7HyE = parcelRequire("b7HyE");
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */ function $e1207f1a6c4ec3cc$var$parseJsonRpcId(data) {
    if (!(0, $b7HyE.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") return null;
    return id;
}
module.exports.parseJsonRpcId = $e1207f1a6c4ec3cc$var$parseJsonRpcId;
function $e1207f1a6c4ec3cc$var$parseJsonRpcRequest(data) {
    if (!(0, $b7HyE.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    const id = $e1207f1a6c4ec3cc$var$parseJsonRpcId(data);
    if (id === null) throw new Error("Invalid id field");
    const method = data.method;
    if (typeof method !== "string") throw new Error("Invalid method field");
    if (!(0, $b7HyE.isJsonCompatibleArray)(data.params) && !(0, $b7HyE.isJsonCompatibleDictionary)(data.params)) throw new Error("Invalid params field");
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params
    };
}
module.exports.parseJsonRpcRequest = $e1207f1a6c4ec3cc$var$parseJsonRpcRequest;
function $e1207f1a6c4ec3cc$var$parseError(error) {
    if (typeof error.code !== "number") throw new Error("Error property 'code' is not a number");
    if (typeof error.message !== "string") throw new Error("Error property 'message' is not a string");
    let maybeUndefinedData;
    if (error.data === undefined) maybeUndefinedData = undefined;
    else if ((0, $b7HyE.isJsonCompatibleValue)(error.data)) maybeUndefinedData = error.data;
    else throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    return {
        code: error.code,
        message: error.message,
        ...maybeUndefinedData !== undefined ? {
            data: maybeUndefinedData
        } : {}
    };
}
/** Throws if data is not a JsonRpcErrorResponse */ function $e1207f1a6c4ec3cc$var$parseJsonRpcErrorResponse(data) {
    if (!(0, $b7HyE.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) throw new Error("Invalid id field");
    if (typeof data.error === "undefined" || !(0, $b7HyE.isJsonCompatibleDictionary)(data.error)) throw new Error("Invalid error field");
    return {
        jsonrpc: "2.0",
        id: id,
        error: $e1207f1a6c4ec3cc$var$parseError(data.error)
    };
}
module.exports.parseJsonRpcErrorResponse = $e1207f1a6c4ec3cc$var$parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */ function $e1207f1a6c4ec3cc$var$parseJsonRpcSuccessResponse(data) {
    if (!(0, $b7HyE.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") throw new Error("Invalid id field");
    if (typeof data.result === "undefined") throw new Error("Invalid result field");
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}
module.exports.parseJsonRpcSuccessResponse = $e1207f1a6c4ec3cc$var$parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */ function $e1207f1a6c4ec3cc$var$parseJsonRpcResponse(data) {
    let response;
    try {
        response = $e1207f1a6c4ec3cc$var$parseJsonRpcErrorResponse(data);
    } catch (_) {
        response = $e1207f1a6c4ec3cc$var$parseJsonRpcSuccessResponse(data);
    }
    return response;
}
module.exports.parseJsonRpcResponse = $e1207f1a6c4ec3cc$var$parseJsonRpcResponse;

});
parcelRegister("b7HyE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJsonCompatibleDictionary = module.exports.isJsonCompatibleArray = module.exports.isJsonCompatibleValue = void 0;
function $819222dec4eeb79f$var$isJsonCompatibleValue(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $819222dec4eeb79f$var$isJsonCompatibleArray(value) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $819222dec4eeb79f$var$isJsonCompatibleDictionary(value)) return true;
    else return false;
}
module.exports.isJsonCompatibleValue = $819222dec4eeb79f$var$isJsonCompatibleValue;
function $819222dec4eeb79f$var$isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) return false;
    for (const item of value){
        if (!$819222dec4eeb79f$var$isJsonCompatibleValue(item)) return false;
    }
    // all items okay
    return true;
}
module.exports.isJsonCompatibleArray = $819222dec4eeb79f$var$isJsonCompatibleArray;
function $819222dec4eeb79f$var$isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) // data must be a non-null object
    return false;
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") return false;
    return Object.values(data).every($819222dec4eeb79f$var$isJsonCompatibleValue);
}
module.exports.isJsonCompatibleDictionary = $819222dec4eeb79f$var$isJsonCompatibleDictionary;

});



parcelRegister("jDTkc", function(module, exports) {
"use strict";
var $e4cc93328e06a52e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.http = void 0;

const $e4cc93328e06a52e$var$axios_1 = $e4cc93328e06a52e$var$__importDefault((parcelRequire("gY9e0")));
function $e4cc93328e06a52e$var$filterBadStatus(res) {
    if (res.status >= 400) throw new Error(`Bad status on response: ${res.status}`);
    return res;
}
/**
 * Node.js 18 comes with exprimental fetch support (https://nodejs.org/de/blog/announcements/v18-release-announce/).
 * This is nice, but the implementation does not yet work wekk for us. We
 * can just stick with axios on those systems for now.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e4cc93328e06a52e$var$isExperimental(nodeJsFunc) {
    // This works because we get this info in node 18:
    //
    // > fetch.toString()
    // 'async function fetch(input, init = undefined) {\n' +
    // "    emitExperimentalWarning('The Fetch API');\n" +
    // '    return lazyUndici().fetch(input, init);\n' +
    // '  }'
    return nodeJsFunc.toString().includes("emitExperimentalWarning");
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function $e4cc93328e06a52e$var$http(method, url, headers, request) {
    if (typeof fetch === "function" && !$e4cc93328e06a52e$var$isExperimental(fetch)) {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers
            }
        };
        return fetch(url, settings).then($e4cc93328e06a52e$var$filterBadStatus).then((res)=>res.json());
    } else return $e4cc93328e06a52e$var$axios_1.default.request({
        url: url,
        method: method,
        data: request,
        headers: headers
    }).then((res)=>res.data);
}
module.exports.http = $e4cc93328e06a52e$var$http;

});
parcelRegister("gY9e0", function(module, exports) {

module.exports = (parcelRequire("hQ3TH"));

});
parcelRegister("hQ3TH", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");

var $eckSC = parcelRequire("eckSC");

var $ftNsj = parcelRequire("ftNsj");

var $7T4gl = parcelRequire("7T4gl");

var $4Irrx = parcelRequire("4Irrx");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $cfca50f1b2876293$var$createInstance(defaultConfig) {
    var context = new $ftNsj(defaultConfig);
    var instance = $eckSC($ftNsj.prototype.request, context);
    // Copy axios.prototype to instance
    $einzF.extend(instance, $ftNsj.prototype, context);
    // Copy context to instance
    $einzF.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $cfca50f1b2876293$var$axios = $cfca50f1b2876293$var$createInstance($4Irrx);
// Expose Axios class to allow class inheritance
$cfca50f1b2876293$var$axios.Axios = $ftNsj;
// Factory for creating new instances
$cfca50f1b2876293$var$axios.create = function create(instanceConfig) {
    return $cfca50f1b2876293$var$createInstance($7T4gl($cfca50f1b2876293$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$cfca50f1b2876293$var$axios.Cancel = (parcelRequire("bQwdH"));

$cfca50f1b2876293$var$axios.CancelToken = (parcelRequire("aQMOh"));

$cfca50f1b2876293$var$axios.isCancel = (parcelRequire("glyAC"));
// Expose all/spread
$cfca50f1b2876293$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$cfca50f1b2876293$var$axios.spread = (parcelRequire("f8Cfw"));

// Expose isAxiosError
$cfca50f1b2876293$var$axios.isAxiosError = (parcelRequire("kdwyj"));
module.exports = $cfca50f1b2876293$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $cfca50f1b2876293$var$axios;

});
parcelRegister("einzF", function(module, exports) {
"use strict";

var $eckSC = parcelRequire("eckSC");
// utils is a library of generic helper functions non-specific to axios
var $a68508807f22feff$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $a68508807f22feff$var$isArray(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $a68508807f22feff$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $a68508807f22feff$var$isBuffer(val) {
    return val !== null && !$a68508807f22feff$var$isUndefined(val) && val.constructor !== null && !$a68508807f22feff$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $a68508807f22feff$var$isArrayBuffer(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $a68508807f22feff$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $a68508807f22feff$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $a68508807f22feff$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $a68508807f22feff$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $a68508807f22feff$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $a68508807f22feff$var$isPlainObject(val) {
    if ($a68508807f22feff$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $a68508807f22feff$var$isDate(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $a68508807f22feff$var$isFile(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $a68508807f22feff$var$isBlob(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $a68508807f22feff$var$isFunction(val) {
    return $a68508807f22feff$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $a68508807f22feff$var$isStream(val) {
    return $a68508807f22feff$var$isObject(val) && $a68508807f22feff$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $a68508807f22feff$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $a68508807f22feff$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $a68508807f22feff$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $a68508807f22feff$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($a68508807f22feff$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $a68508807f22feff$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($a68508807f22feff$var$isPlainObject(result[key]) && $a68508807f22feff$var$isPlainObject(val)) result[key] = $a68508807f22feff$var$merge(result[key], val);
        else if ($a68508807f22feff$var$isPlainObject(val)) result[key] = $a68508807f22feff$var$merge({}, val);
        else if ($a68508807f22feff$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$a68508807f22feff$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $a68508807f22feff$var$extend(a, b, thisArg) {
    $a68508807f22feff$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $eckSC(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $a68508807f22feff$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $a68508807f22feff$var$isArray,
    isArrayBuffer: $a68508807f22feff$var$isArrayBuffer,
    isBuffer: $a68508807f22feff$var$isBuffer,
    isFormData: $a68508807f22feff$var$isFormData,
    isArrayBufferView: $a68508807f22feff$var$isArrayBufferView,
    isString: $a68508807f22feff$var$isString,
    isNumber: $a68508807f22feff$var$isNumber,
    isObject: $a68508807f22feff$var$isObject,
    isPlainObject: $a68508807f22feff$var$isPlainObject,
    isUndefined: $a68508807f22feff$var$isUndefined,
    isDate: $a68508807f22feff$var$isDate,
    isFile: $a68508807f22feff$var$isFile,
    isBlob: $a68508807f22feff$var$isBlob,
    isFunction: $a68508807f22feff$var$isFunction,
    isStream: $a68508807f22feff$var$isStream,
    isURLSearchParams: $a68508807f22feff$var$isURLSearchParams,
    isStandardBrowserEnv: $a68508807f22feff$var$isStandardBrowserEnv,
    forEach: $a68508807f22feff$var$forEach,
    merge: $a68508807f22feff$var$merge,
    extend: $a68508807f22feff$var$extend,
    trim: $a68508807f22feff$var$trim,
    stripBOM: $a68508807f22feff$var$stripBOM
};

});
parcelRegister("eckSC", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ftNsj", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");

var $hqqsL = parcelRequire("hqqsL");

var $6K6If = parcelRequire("6K6If");

var $c9HKU = parcelRequire("c9HKU");

var $7T4gl = parcelRequire("7T4gl");

var $8REBL = parcelRequire("8REBL");
var $b44fed4f38a6ddbc$var$validators = $8REBL.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $b44fed4f38a6ddbc$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $6K6If(),
        response: new $6K6If()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $b44fed4f38a6ddbc$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $7T4gl(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $8REBL.assertOptions(transitional, {
        silentJSONParsing: $b44fed4f38a6ddbc$var$validators.transitional($b44fed4f38a6ddbc$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $b44fed4f38a6ddbc$var$validators.transitional($b44fed4f38a6ddbc$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $b44fed4f38a6ddbc$var$validators.transitional($b44fed4f38a6ddbc$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $c9HKU,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $c9HKU(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$b44fed4f38a6ddbc$var$Axios.prototype.getUri = function getUri(config) {
    config = $7T4gl(this.defaults, config);
    return $hqqsL(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$einzF.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $b44fed4f38a6ddbc$var$Axios.prototype[method] = function(url, config) {
        return this.request($7T4gl(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$einzF.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $b44fed4f38a6ddbc$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($7T4gl(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $b44fed4f38a6ddbc$var$Axios;

});
parcelRegister("hqqsL", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
function $caf96461763a904e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($einzF.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $einzF.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($einzF.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $einzF.forEach(val, function parseValue(v) {
                if ($einzF.isDate(v)) v = v.toISOString();
                else if ($einzF.isObject(v)) v = JSON.stringify(v);
                parts.push($caf96461763a904e$var$encode(key) + "=" + $caf96461763a904e$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("6K6If", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
function $4e8c3ef77c5a23cc$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $4e8c3ef77c5a23cc$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $4e8c3ef77c5a23cc$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $4e8c3ef77c5a23cc$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $einzF.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $4e8c3ef77c5a23cc$var$InterceptorManager;

});

parcelRegister("c9HKU", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");

var $2Jvu8 = parcelRequire("2Jvu8");

var $glyAC = parcelRequire("glyAC");

var $4Irrx = parcelRequire("4Irrx");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $8d98443b83821cb0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $8d98443b83821cb0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $2Jvu8.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $einzF.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $einzF.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $4Irrx.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $8d98443b83821cb0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $2Jvu8.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$glyAC(reason)) {
            $8d98443b83821cb0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $2Jvu8.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("2Jvu8", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");

var $4Irrx = parcelRequire("4Irrx");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $4Irrx;
    /*eslint no-param-reassign:0*/ $einzF.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("4Irrx", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";

var $einzF = parcelRequire("einzF");

var $dG0Ev = parcelRequire("dG0Ev");

var $kg2Qz = parcelRequire("kg2Qz");
var $36f08f1cd84ac8d7$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $36f08f1cd84ac8d7$var$setContentTypeIfUnset(headers, value) {
    if (!$einzF.isUndefined(headers) && $einzF.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $36f08f1cd84ac8d7$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("l6UM9"));
    else if (typeof $ibaza !== "undefined" && Object.prototype.toString.call($ibaza) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("l6UM9"));
    return adapter;
}
function $36f08f1cd84ac8d7$var$stringifySafely(rawValue, parser, encoder) {
    if ($einzF.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $einzF.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $36f08f1cd84ac8d7$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $36f08f1cd84ac8d7$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $dG0Ev(headers, "Accept");
            $dG0Ev(headers, "Content-Type");
            if ($einzF.isFormData(data) || $einzF.isArrayBuffer(data) || $einzF.isBuffer(data) || $einzF.isStream(data) || $einzF.isFile(data) || $einzF.isBlob(data)) return data;
            if ($einzF.isArrayBufferView(data)) return data.buffer;
            if ($einzF.isURLSearchParams(data)) {
                $36f08f1cd84ac8d7$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($einzF.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $36f08f1cd84ac8d7$var$setContentTypeIfUnset(headers, "application/json");
                return $36f08f1cd84ac8d7$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $einzF.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $kg2Qz(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$36f08f1cd84ac8d7$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$einzF.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $36f08f1cd84ac8d7$var$defaults.headers[method] = {};
});
$einzF.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $36f08f1cd84ac8d7$var$defaults.headers[method] = $einzF.merge($36f08f1cd84ac8d7$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $36f08f1cd84ac8d7$var$defaults;

});
parcelRegister("dG0Ev", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $einzF.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("kg2Qz", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRegister("l6UM9", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");

var $5Ddf4 = parcelRequire("5Ddf4");

var $lVQAK = parcelRequire("lVQAK");

var $hqqsL = parcelRequire("hqqsL");

var $fDKEK = parcelRequire("fDKEK");

var $44Dou = parcelRequire("44Dou");

var $fDeZ2 = parcelRequire("fDeZ2");

var $bwBDe = parcelRequire("bwBDe");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($einzF.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $fDKEK(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $hqqsL(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $44Dou(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $5Ddf4(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($bwBDe("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($bwBDe("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($bwBDe(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($einzF.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $fDeZ2(fullPath)) && config.xsrfCookieName ? $lVQAK.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $einzF.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$einzF.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("5Ddf4", function(module, exports) {
"use strict";

var $bwBDe = parcelRequire("bwBDe");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($bwBDe("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("bwBDe", function(module, exports) {
"use strict";

var $kg2Qz = parcelRequire("kg2Qz");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $kg2Qz(error, config, code, request, response);
};

});


parcelRegister("lVQAK", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
module.exports = $einzF.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($einzF.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($einzF.isString(path)) cookie.push("path=" + path);
            if ($einzF.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("fDKEK", function(module, exports) {
"use strict";

var $kzqJH = parcelRequire("kzqJH");

var $9mfqv = parcelRequire("9mfqv");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$kzqJH(requestedURL)) return $9mfqv(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("kzqJH", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("9mfqv", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("44Dou", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $2f7617fe55d67713$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $einzF.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $einzF.trim(line.substr(0, i)).toLowerCase();
        val = $einzF.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $2f7617fe55d67713$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("fDeZ2", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
module.exports = $einzF.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $einzF.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("glyAC", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("7T4gl", function(module, exports) {
"use strict";

var $einzF = parcelRequire("einzF");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($einzF.isPlainObject(target) && $einzF.isPlainObject(source)) return $einzF.merge(target, source);
        else if ($einzF.isPlainObject(source)) return $einzF.merge({}, source);
        else if ($einzF.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$einzF.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$einzF.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $einzF.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$einzF.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $einzF.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $einzF.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$einzF.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$einzF.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $einzF.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $einzF.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRegister("8REBL", function(module, exports) {
"use strict";

var $a6D84 = parcelRequire("a6D84");
var $6742c5e6266f4ff8$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $6742c5e6266f4ff8$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $6742c5e6266f4ff8$var$deprecatedWarnings = {};
var $6742c5e6266f4ff8$var$currentVerArr = $a6D84.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $6742c5e6266f4ff8$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $6742c5e6266f4ff8$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $6742c5e6266f4ff8$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $6742c5e6266f4ff8$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $a6D84.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$6742c5e6266f4ff8$var$deprecatedWarnings[opt]) {
            $6742c5e6266f4ff8$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $6742c5e6266f4ff8$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $6742c5e6266f4ff8$var$isOlderVersion,
    assertOptions: $6742c5e6266f4ff8$var$assertOptions,
    validators: $6742c5e6266f4ff8$var$validators
};

});
parcelRegister("a6D84", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRegister("bQwdH", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $89fd8b3ae8f800be$var$Cancel(message) {
    this.message = message;
}
$89fd8b3ae8f800be$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$89fd8b3ae8f800be$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $89fd8b3ae8f800be$var$Cancel;

});

parcelRegister("aQMOh", function(module, exports) {
"use strict";

var $bQwdH = parcelRequire("bQwdH");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $7e649f5b81a40e30$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $bQwdH(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $7e649f5b81a40e30$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $7e649f5b81a40e30$var$CancelToken.source = function source() {
    var cancel;
    var token = new $7e649f5b81a40e30$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $7e649f5b81a40e30$var$CancelToken;

});

parcelRegister("f8Cfw", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kdwyj", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});




parcelRegister("3U2Vn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProtocol = module.exports.instanceOfRpcStreamingClient = void 0;
function $2d78ded0c9ca064f$var$instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
module.exports.instanceOfRpcStreamingClient = $2d78ded0c9ca064f$var$instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function $2d78ded0c9ca064f$var$hasProtocol(url) {
    return url.search("://") !== -1;
}
module.exports.hasProtocol = $2d78ded0c9ca064f$var$hasProtocol;

});


parcelRegister("jWZw8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = void 0;

var $kT9K3 = parcelRequire("kT9K3");

var $jDTkc = parcelRequire("jDTkc");

var $3U2Vn = parcelRequire("3U2Vn");
class $03bf88e3d8525395$var$HttpClient {
    constructor(endpoint){
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $3U2Vn.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    disconnect() {
    // nothing to be done
    }
    async execute(request) {
        const response = (0, $kT9K3.parseJsonRpcResponse)(await (0, $jDTkc.http)("POST", this.url, this.headers, request));
        if ((0, $kT9K3.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
}
module.exports.HttpClient = $03bf88e3d8525395$var$HttpClient;

});

parcelRegister("fulbR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = void 0;

var $kT9K3 = parcelRequire("kT9K3");

var $D395L = parcelRequire("D395L");

var $6Sxan = parcelRequire("6Sxan");

var $klEU5 = parcelRequire("klEU5");

var $3U2Vn = parcelRequire("3U2Vn");
function $02e8efe046a6dd28$var$defaultErrorHandler(error) {
    throw error;
}
function $02e8efe046a6dd28$var$toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    const jsonRpcEvent = (0, $kT9K3.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class $02e8efe046a6dd28$var$RpcEventProducer {
    constructor(request, socket){
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    /**
     * Implementation of Producer.start
     */ start(listener) {
        if (this.running) throw Error("Already started. Please stop first before restarting.");
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */ stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = {
            ...this.request,
            method: "unsubscribe"
        };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        } catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) ;
            else throw error;
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map($02e8efe046a6dd28$var$toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $kT9K3.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            }
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $kT9K3.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                } else listener.next(response.result);
            }
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error)=>{
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: ()=>{
                this.closeSubscriptions();
                listener.complete();
            }
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions)subscription.unsubscribe();
        // clear unused subscriptions
        this.subscriptions = [];
    }
}
class $02e8efe046a6dd28$var$WebsocketClient {
    constructor(baseUrl, onError = $02e8efe046a6dd28$var$defaultErrorHandler){
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, $3U2Vn.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new $D395L.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error)=>{
                onError(error);
                errorSubscription.unsubscribe();
            }
        });
        this.jsonRpcResponseStream = this.socket.events.map($02e8efe046a6dd28$var$toJsonRpcResponse);
        this.socket.connect();
    }
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, $kT9K3.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") throw new Error(`Request method must be "subscribe" to start event listening`);
        const query = request.params.query;
        if (typeof query !== "string") throw new Error("request.params.query must be a string");
        if (!this.subscriptionStreams.has(query)) {
            const producer = new $02e8efe046a6dd28$var$RpcEventProducer(request, this.socket);
            const stream = $klEU5.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response)=>response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */ async connected() {
        await this.socket.connectionStatus.waitFor($D395L.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, $6Sxan.firstEvent)(this.jsonRpcResponseStream.filter((r)=>r.id === id));
    }
}
module.exports.WebsocketClient = $02e8efe046a6dd28$var$WebsocketClient;

});
parcelRegister("D395L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = module.exports.SocketWrapper = module.exports.ReconnectingSocket = module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $8CyFN = parcelRequire("8CyFN");
Object.defineProperty(module.exports, "ConnectionStatus", {
    enumerable: true,
    get: function() {
        return $8CyFN.ConnectionStatus;
    }
});
Object.defineProperty(module.exports, "QueueingStreamingSocket", {
    enumerable: true,
    get: function() {
        return $8CyFN.QueueingStreamingSocket;
    }
});

var $65rPl = parcelRequire("65rPl");
Object.defineProperty(module.exports, "ReconnectingSocket", {
    enumerable: true,
    get: function() {
        return $65rPl.ReconnectingSocket;
    }
});

var $8UCK2 = parcelRequire("8UCK2");
Object.defineProperty(module.exports, "SocketWrapper", {
    enumerable: true,
    get: function() {
        return $8UCK2.SocketWrapper;
    }
});

var $jo14K = parcelRequire("jo14K");
Object.defineProperty(module.exports, "StreamingSocket", {
    enumerable: true,
    get: function() {
        return $jo14K.StreamingSocket;
    }
});

});
parcelRegister("8CyFN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $6Sxan = parcelRequire("6Sxan");

var $klEU5 = parcelRequire("klEU5");

var $jo14K = parcelRequire("jo14K");
var $646cc4ae95286b7b$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})($646cc4ae95286b7b$var$ConnectionStatus = module.exports.ConnectionStatus || (module.exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */ class $646cc4ae95286b7b$var$QueueingStreamingSocket {
    constructor(url, timeout = 10000, reconnectedHandler){
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $klEU5.Stream.create(eventProducer);
        this.connectionStatusProducer = new $6Sxan.DefaultValueProducer($646cc4ae95286b7b$var$ConnectionStatus.Unconnected);
        this.connectionStatus = new $6Sxan.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new $jo14K.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Disconnected)
        });
    }
    connect() {
        this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Connecting);
        this.socket.connected.then(async ()=>{
            this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Connected);
            return this.processQueue();
        }, ()=>this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new $jo14K.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($646cc4ae95286b7b$var$ConnectionStatus.Disconnected)
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(()=>{
            if (this.reconnectedHandler) this.reconnectedHandler();
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== $646cc4ae95286b7b$var$ConnectionStatus.Connected) return;
        this.isProcessingQueue = true;
        let request;
        while(request = this.queue.shift())try {
            await this.socket.send(request);
            this.isProcessingQueue = false;
        } catch (error) {
            // Probably the connection is down; will try again automatically when reconnected.
            this.queue.unshift(request);
            this.isProcessingQueue = false;
            return;
        }
    }
}
module.exports.QueueingStreamingSocket = $646cc4ae95286b7b$var$QueueingStreamingSocket;

});
parcelRegister("jo14K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = void 0;

var $klEU5 = parcelRequire("klEU5");

var $8UCK2 = parcelRequire("8UCK2");
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */ class $e1d117cee2917fc3$var$StreamingSocket {
    constructor(url, timeout = 10000){
        this.socket = new $8UCK2.SocketWrapper(url, (event)=>{
            if (this.eventProducerListener) this.eventProducerListener.next(event);
        }, (errorEvent)=>{
            if (this.eventProducerListener) this.eventProducerListener.error(errorEvent);
        }, ()=>{
        // socket opened
        }, (closeEvent)=>{
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) this.eventProducerListener.complete();
                else this.eventProducerListener.error("Socket was closed unclean");
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $klEU5.Stream.create(eventProducer);
    }
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
}
module.exports.StreamingSocket = $e1d117cee2917fc3$var$StreamingSocket;

});
parcelRegister("8UCK2", function(module, exports) {

var $ibaza = parcelRequire("ibaza");
"use strict";
var $67d19afb73d08965$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SocketWrapper = void 0;

const $67d19afb73d08965$var$isomorphic_ws_1 = $67d19afb73d08965$var$__importDefault((parcelRequire("i6u2O")));
function $67d19afb73d08965$var$environmentIsNodeJs() {
    return typeof $ibaza !== "undefined" && typeof $ibaza.versions !== "undefined" && typeof $ibaza.versions.node !== "undefined";
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */ class $67d19afb73d08965$var$SocketWrapper {
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000){
        this.closed = false;
        this.connected = new Promise((resolve, reject)=>{
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    /**
     * returns a promise that resolves when connection is open
     */ connect() {
        const socket = new $67d19afb73d08965$var$isomorphic_ws_1.default(this.url);
        socket.onerror = (error)=>{
            this.clearTimeout();
            if (this.errorHandler) this.errorHandler(error);
        };
        socket.onmessage = (messageEvent)=>{
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data
            });
        };
        socket.onopen = (_)=>{
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) this.openHandler();
        };
        socket.onclose = (closeEvent)=>{
            this.closed = true;
            if (this.closeHandler) this.closeHandler(closeEvent);
        };
        const started = Date.now();
        this.timeoutId = setTimeout(()=>{
            socket.onmessage = ()=>0;
            socket.onerror = ()=>0;
            socket.onopen = ()=>0;
            socket.onclose = ()=>0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */ disconnect() {
        if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
        this.clearTimeout();
        switch(this.socket.readyState){
            case $67d19afb73d08965$var$isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */ );
                break;
            case $67d19afb73d08965$var$isomorphic_ws_1.default.CLOSED:
                break;
            case $67d19afb73d08965$var$isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = ()=>0;
                this.socket.onclose = ()=>0;
                this.socket.onerror = ()=>0;
                this.socket.onmessage = ()=>0;
                this.socket = undefined;
                if (this.closeHandler) this.closeHandler({
                    wasClean: false,
                    code: 4001
                });
                break;
            case $67d19afb73d08965$var$isomorphic_ws_1.default.CLOSING:
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject)=>{
            if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
            if (this.closed) throw new Error("Socket was closed, so no data can be sent anymore.");
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== $67d19afb73d08965$var$isomorphic_ws_1.default.OPEN) throw new Error("Websocket is not open");
            if ($67d19afb73d08965$var$environmentIsNodeJs()) this.socket.send(data, (err)=>err ? reject(err) : resolve());
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */ clearTimeout() {
        if (!this.timeoutId) throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
}
module.exports.SocketWrapper = $67d19afb73d08965$var$SocketWrapper;

});
parcelRegister("i6u2O", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $d2e017bd0c5d8adf$var$ws = null;
if (typeof WebSocket !== "undefined") $d2e017bd0c5d8adf$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $d2e017bd0c5d8adf$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $d2e017bd0c5d8adf$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $d2e017bd0c5d8adf$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $d2e017bd0c5d8adf$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $d2e017bd0c5d8adf$var$ws;

});




parcelRegister("65rPl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReconnectingSocket = void 0;

var $klEU5 = parcelRequire("klEU5");

var $8CyFN = parcelRequire("8CyFN");
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */ class $46e8cb92ab809ec7$var$ReconnectingSocket {
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */ static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    constructor(url, timeout = 10000, reconnectedHandler){
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $klEU5.Stream.create(eventProducer);
        this.socket = new $8CyFN.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event)=>{
                if (this.eventProducerListener) this.eventProducerListener.next(event);
            },
            error: (error)=>{
                if (this.eventProducerListener) this.eventProducerListener.error(error);
            }
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status)=>{
                if (status === $8CyFN.ConnectionStatus.Connected) this.timeoutIndex = 0;
                if (status === $8CyFN.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(()=>this.socket.reconnect(), $46e8cb92ab809ec7$var$ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            }
        });
    }
    connect() {
        if (!this.unconnected) throw new Error("Cannot connect: socket has already connected");
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) throw new Error("Cannot disconnect: socket has not yet connected");
        this.socket.disconnect();
        if (this.eventProducerListener) this.eventProducerListener.complete();
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) throw new Error("Cannot queue request: socket has disconnected");
        this.socket.queueRequest(request);
    }
}
module.exports.ReconnectingSocket = $46e8cb92ab809ec7$var$ReconnectingSocket;

});




parcelRegister("eBVDC", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $92niZ = parcelRequire("92niZ");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $92niZ.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $92niZ.SubscriptionEventType;
    }
});

var $1oiuW = parcelRequire("1oiuW");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $1oiuW.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $1oiuW.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $1oiuW.VoteType;
    }
});

var $3C3Bu = parcelRequire("3C3Bu");
Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return $3C3Bu.Tendermint34Client;
    }
});

});
parcelRegister("92niZ", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $694660e47b505446$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($694660e47b505446$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $694660e47b505446$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($694660e47b505446$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $694660e47b505446$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $694660e47b505446$var$buildQuery;

});

parcelRegister("1oiuW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $103661a9352abb27$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $103661a9352abb27$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $103661a9352abb27$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $103661a9352abb27$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $103661a9352abb27$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($103661a9352abb27$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("3C3Bu", function(module, exports) {
"use strict";
var $2a17b74e9a1b5a67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a17b74e9a1b5a67$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2a17b74e9a1b5a67$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2a17b74e9a1b5a67$var$__createBinding(result, mod, k);
    }
    $2a17b74e9a1b5a67$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = void 0;

var $1YfeO = parcelRequire("1YfeO");

var $lRzwx = parcelRequire("lRzwx");

var $9s2VQ = parcelRequire("9s2VQ");

const $2a17b74e9a1b5a67$var$requests = $2a17b74e9a1b5a67$var$__importStar((parcelRequire("92niZ")));
class $2a17b74e9a1b5a67$var$Tendermint34Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $lRzwx.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $lRzwx.HttpClient(endpoint) : new $lRzwx.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $2a17b74e9a1b5a67$var$Tendermint34Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $2a17b74e9a1b5a67$var$Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $1YfeO.createJsonRpcRequest)($2a17b74e9a1b5a67$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $9s2VQ.adaptor34.params;
        this.r = $9s2VQ.adaptor34.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Subscribe,
            query: {
                type: $2a17b74e9a1b5a67$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Subscribe,
            query: {
                type: $2a17b74e9a1b5a67$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Subscribe,
            query: {
                type: $2a17b74e9a1b5a67$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $2a17b74e9a1b5a67$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $2a17b74e9a1b5a67$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $lRzwx.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint34Client = $2a17b74e9a1b5a67$var$Tendermint34Client;

});
parcelRegister("1YfeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJsonRpcRequest = void 0;
const $16f736fbf08a658a$var$numbersWithoutZero = "123456789";
/** generates a random numeric character  */ function $16f736fbf08a658a$var$randomNumericChar() {
    return $16f736fbf08a658a$var$numbersWithoutZero[Math.floor(Math.random() * $16f736fbf08a658a$var$numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */ function $16f736fbf08a658a$var$randomId() {
    return parseInt(Array.from({
        length: 12
    }).map(()=>$16f736fbf08a658a$var$randomNumericChar()).join(""), 10);
}
/** Creates a JSON-RPC request with random ID */ // eslint-disable-next-line @typescript-eslint/ban-types
function $16f736fbf08a658a$var$createJsonRpcRequest(method, params) {
    const paramsCopy = params ? {
        ...params
    } : {};
    return {
        jsonrpc: "2.0",
        id: $16f736fbf08a658a$var$randomId(),
        method: method,
        params: paramsCopy
    };
}
module.exports.createJsonRpcRequest = $16f736fbf08a658a$var$createJsonRpcRequest;

});

parcelRegister("9s2VQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor34 = void 0;

var $iUSwE = parcelRequire("iUSwE");

var $6uo8f = parcelRequire("6uo8f");

var $60MOb = parcelRequire("60MOb");
module.exports.adaptor34 = {
    params: $6uo8f.Params,
    responses: $60MOb.Responses,
    hashTx: $iUSwE.hashTx,
    hashBlock: $iUSwE.hashBlock
};

});
parcelRegister("iUSwE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $c162L = parcelRequire("c162L");

var $02WBn = parcelRequire("02WBn");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $dc57c09f5e4efe83$var$hashTx(tx) {
    return (0, $c162L.sha256)(tx);
}
module.exports.hashTx = $dc57c09f5e4efe83$var$hashTx;
function $dc57c09f5e4efe83$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $dc57c09f5e4efe83$var$hashLeaf(leaf) {
    const hash = new $c162L.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $dc57c09f5e4efe83$var$hashInner(left, right) {
    const hash = new $c162L.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $dc57c09f5e4efe83$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $dc57c09f5e4efe83$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $dc57c09f5e4efe83$var$getSplitPoint(hashes.length);
                const left = $dc57c09f5e4efe83$var$hashTree(hashes.slice(0, slicePoint));
                const right = $dc57c09f5e4efe83$var$hashTree(hashes.slice(slicePoint));
                return $dc57c09f5e4efe83$var$hashInner(left, right);
            }
    }
}
function $dc57c09f5e4efe83$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $02WBn.encodeVersion)(header.version),
        (0, $02WBn.encodeString)(header.chainId),
        (0, $02WBn.encodeUvarint)(header.height),
        (0, $02WBn.encodeTime)(header.time),
        (0, $02WBn.encodeBlockId)(header.lastBlockId),
        (0, $02WBn.encodeBytes)(header.lastCommitHash),
        (0, $02WBn.encodeBytes)(header.dataHash),
        (0, $02WBn.encodeBytes)(header.validatorsHash),
        (0, $02WBn.encodeBytes)(header.nextValidatorsHash),
        (0, $02WBn.encodeBytes)(header.consensusHash),
        (0, $02WBn.encodeBytes)(header.appHash),
        (0, $02WBn.encodeBytes)(header.lastResultsHash),
        (0, $02WBn.encodeBytes)(header.evidenceHash),
        (0, $02WBn.encodeBytes)(header.proposerAddress)
    ];
    return $dc57c09f5e4efe83$var$hashTree(encodedFields);
}
module.exports.hashBlock = $dc57c09f5e4efe83$var$hashBlock;

});
parcelRegister("02WBn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $94ZnX = parcelRequire("94ZnX");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $008da5217497e830$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $008da5217497e830$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $008da5217497e830$var$assertBoolean(value) {
    $008da5217497e830$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $008da5217497e830$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $008da5217497e830$var$assertString(value) {
    $008da5217497e830$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $008da5217497e830$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $008da5217497e830$var$assertNumber(value) {
    $008da5217497e830$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $008da5217497e830$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $008da5217497e830$var$assertArray(value) {
    $008da5217497e830$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $008da5217497e830$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $008da5217497e830$var$assertObject(value) {
    $008da5217497e830$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $008da5217497e830$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $008da5217497e830$var$assertNotEmpty(value) {
    $008da5217497e830$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $008da5217497e830$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $008da5217497e830$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $008da5217497e830$var$may;
function $008da5217497e830$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $008da5217497e830$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $008da5217497e830$var$encodeString(s) {
    const utf8 = (0, $94ZnX.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $008da5217497e830$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $008da5217497e830$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$008da5217497e830$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $008da5217497e830$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $008da5217497e830$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$008da5217497e830$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$008da5217497e830$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $008da5217497e830$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $008da5217497e830$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $008da5217497e830$var$encodeBytes;
function $008da5217497e830$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$008da5217497e830$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$008da5217497e830$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $008da5217497e830$var$encodeVersion;
function $008da5217497e830$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $008da5217497e830$var$encodeBlockId;

});


parcelRegister("6uo8f", function(module, exports) {
"use strict";
var $4b984389d3aadffb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4b984389d3aadffb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4b984389d3aadffb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4b984389d3aadffb$var$__createBinding(result, mod, k);
    }
    $4b984389d3aadffb$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $3SgOH = parcelRequire("3SgOH");

var $1YfeO = parcelRequire("1YfeO");

var $02WBn = parcelRequire("02WBn");

const $4b984389d3aadffb$var$requests = $4b984389d3aadffb$var$__importStar((parcelRequire("92niZ")));
function $4b984389d3aadffb$var$encodeHeightParam(param) {
    return {
        height: (0, $02WBn.may)($3SgOH.smallIntToApi, param.height)
    };
}
function $4b984389d3aadffb$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $02WBn.may)($3SgOH.smallIntToApi, param.minHeight),
        maxHeight: (0, $02WBn.may)($3SgOH.smallIntToApi, param.maxHeight)
    };
}
function $4b984389d3aadffb$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $4b984389d3aadffb$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $02WBn.assertNotEmpty)(params.path),
        data: (0, $94ZnX.toHex)(params.data),
        height: (0, $02WBn.may)($3SgOH.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $4b984389d3aadffb$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $94ZnX.toBase64)((0, $02WBn.assertNotEmpty)(params.tx))
    };
}
function $4b984389d3aadffb$var$encodeTxParams(params) {
    return {
        hash: (0, $94ZnX.toBase64)((0, $02WBn.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $4b984389d3aadffb$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $4b984389d3aadffb$var$encodeValidatorsParams(params) {
    return {
        height: (0, $02WBn.may)($3SgOH.smallIntToApi, params.height),
        page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $02WBn.may)($3SgOH.smallIntToApi, params.per_page)
    };
}
class $4b984389d3aadffb$var$Params {
    static encodeAbciInfo(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $4b984389d3aadffb$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $1YfeO.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $4b984389d3aadffb$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $4b984389d3aadffb$var$Params;

});
parcelRegister("3SgOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smallIntToApi = module.exports.apiToBigInt = module.exports.apiToSmallInt = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $02WBn = parcelRequire("02WBn");
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */ function $2d2375b8ab76538f$var$apiToSmallInt(input) {
    const asInt = typeof input === "number" ? new $h3uvW.Int53(input) : $h3uvW.Int53.fromString(input);
    return asInt.toNumber();
}
module.exports.apiToSmallInt = $2d2375b8ab76538f$var$apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */ function $2d2375b8ab76538f$var$apiToBigInt(input) {
    (0, $02WBn.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
    return BigInt(input);
}
module.exports.apiToBigInt = $2d2375b8ab76538f$var$apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */ function $2d2375b8ab76538f$var$smallIntToApi(num) {
    return new $h3uvW.Int53(num).toString();
}
module.exports.smallIntToApi = $2d2375b8ab76538f$var$smallIntToApi;

});


parcelRegister("60MOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $hm8y1 = parcelRequire("hm8y1");

var $hAC4f = parcelRequire("hAC4f");

var $3SgOH = parcelRequire("3SgOH");

var $kchui = parcelRequire("kchui");

var $02WBn = parcelRequire("02WBn");

var $iUSwE = parcelRequire("iUSwE");
function $46089a842eba24e0$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $02WBn.may)($3SgOH.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $02WBn.may)($94ZnX.fromBase64, data.last_block_app_hash)
    };
}
function $46089a842eba24e0$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $94ZnX.fromBase64)(op.key),
                data: (0, $94ZnX.fromBase64)(op.data)
            }))
    };
}
function $46089a842eba24e0$var$decodeAbciQuery(data) {
    return {
        key: (0, $94ZnX.fromBase64)((0, $02WBn.assertString)(data.key ?? "")),
        value: (0, $94ZnX.fromBase64)((0, $02WBn.assertString)(data.value ?? "")),
        proof: (0, $02WBn.may)($46089a842eba24e0$var$decodeQueryProof, data.proofOps),
        height: (0, $02WBn.may)($3SgOH.apiToSmallInt, data.height),
        code: (0, $02WBn.may)($3SgOH.apiToSmallInt, data.code),
        codespace: (0, $02WBn.assertString)(data.codespace ?? ""),
        index: (0, $02WBn.may)($3SgOH.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $02WBn.assertString)(data.info ?? "")
    };
}
function $46089a842eba24e0$var$decodeAttribute(attribute) {
    return {
        key: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(attribute.key)),
        value: (0, $94ZnX.fromBase64)((0, $02WBn.assertString)(attribute.value ?? ""))
    };
}
function $46089a842eba24e0$var$decodeAttributes(attributes) {
    return (0, $02WBn.assertArray)(attributes).map($46089a842eba24e0$var$decodeAttribute);
}
function $46089a842eba24e0$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $46089a842eba24e0$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $46089a842eba24e0$var$decodeEvent;
function $46089a842eba24e0$var$decodeEvents(events) {
    return (0, $02WBn.assertArray)(events).map($46089a842eba24e0$var$decodeEvent);
}
function $46089a842eba24e0$var$decodeTxData(data) {
    return {
        code: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $02WBn.may)($94ZnX.fromBase64, data.data),
        events: data.events ? $46089a842eba24e0$var$decodeEvents(data.events) : [],
        gasWanted: (0, $3SgOH.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $3SgOH.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $46089a842eba24e0$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $hm8y1.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $46089a842eba24e0$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.max_gas))
    };
}
function $46089a842eba24e0$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.max_age_duration))
    };
}
function $46089a842eba24e0$var$decodeConsensusParams(data) {
    return {
        block: $46089a842eba24e0$var$decodeBlockParams((0, $02WBn.assertObject)(data.block)),
        evidence: $46089a842eba24e0$var$decodeEvidenceParams((0, $02WBn.assertObject)(data.evidence))
    };
}
function $46089a842eba24e0$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $46089a842eba24e0$var$decodePubkey((0, $02WBn.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $46089a842eba24e0$var$decodeValidatorUpdate;
function $46089a842eba24e0$var$decodeBlockResults(data) {
    return {
        height: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($46089a842eba24e0$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($46089a842eba24e0$var$decodeValidatorUpdate),
        consensusUpdates: (0, $02WBn.may)($46089a842eba24e0$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $46089a842eba24e0$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $46089a842eba24e0$var$decodeEvents(data.end_block_events || [])
    };
}
function $46089a842eba24e0$var$decodeBlockId(data) {
    return {
        hash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $02WBn.assertNotEmpty)(data.parts.total),
            hash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $46089a842eba24e0$var$decodeBlockVersion(data) {
    return {
        block: (0, $3SgOH.apiToSmallInt)(data.block),
        app: (0, $3SgOH.apiToSmallInt)(data.app ?? 0)
    };
}
function $46089a842eba24e0$var$decodeHeader(data) {
    return {
        version: $46089a842eba24e0$var$decodeBlockVersion(data.version),
        chainId: (0, $02WBn.assertNotEmpty)(data.chain_id),
        height: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.height)),
        time: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $02WBn.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $46089a842eba24e0$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.last_commit_hash)),
        dataHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.data_hash)),
        validatorsHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.consensus_hash)),
        appHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.app_hash)),
        lastResultsHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.proposer_address))
    };
}
function $46089a842eba24e0$var$decodeBlockMeta(data) {
    return {
        blockId: $46089a842eba24e0$var$decodeBlockId(data.block_id),
        blockSize: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.block_size)),
        header: $46089a842eba24e0$var$decodeHeader(data.header),
        numTxs: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.num_txs))
    };
}
function $46089a842eba24e0$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $02WBn.assertArray)(data.block_metas).map($46089a842eba24e0$var$decodeBlockMeta)
    };
}
function $46089a842eba24e0$var$decodeBroadcastTxSync(data) {
    return {
        ...$46089a842eba24e0$var$decodeTxData(data),
        hash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.hash))
    };
}
function $46089a842eba24e0$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $3SgOH.apiToSmallInt)(data.height),
        hash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.hash)),
        checkTx: $46089a842eba24e0$var$decodeTxData((0, $02WBn.assertObject)(data.check_tx)),
        deliverTx: (0, $02WBn.may)($46089a842eba24e0$var$decodeTxData, data.deliver_tx)
    };
}
function $46089a842eba24e0$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $hm8y1.assert)(blockIdFlag in $kchui.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $46089a842eba24e0$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $hAC4f.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $46089a842eba24e0$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $46089a842eba24e0$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $94ZnX.fromHex)(data.validator_address) : undefined,
        timestamp: $46089a842eba24e0$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $94ZnX.fromBase64)(data.signature) : undefined
    };
}
function $46089a842eba24e0$var$decodeCommit(data) {
    return {
        blockId: $46089a842eba24e0$var$decodeBlockId((0, $02WBn.assertObject)(data.block_id)),
        height: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.height)),
        round: (0, $3SgOH.apiToSmallInt)(data.round),
        signatures: (0, $02WBn.assertArray)(data.signatures).map($46089a842eba24e0$var$decodeCommitSignature)
    };
}
function $46089a842eba24e0$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $02WBn.assertBoolean)(data.canonical),
        header: $46089a842eba24e0$var$decodeHeader(data.signed_header.header),
        commit: $46089a842eba24e0$var$decodeCommit(data.signed_header.commit)
    };
}
function $46089a842eba24e0$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.address)),
        pubkey: $46089a842eba24e0$var$decodePubkey((0, $02WBn.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)((0, $02WBn.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $46089a842eba24e0$var$decodeValidatorGenesis;
function $46089a842eba24e0$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $02WBn.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $02WBn.assertNotEmpty)(data.chain_id),
        consensusParams: $46089a842eba24e0$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $02WBn.assertArray)(data.validators).map($46089a842eba24e0$var$decodeValidatorGenesis) : [],
        appHash: (0, $94ZnX.fromHex)((0, $02WBn.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $46089a842eba24e0$var$decodeValidatorInfo(data) {
    return {
        pubkey: $46089a842eba24e0$var$decodePubkey((0, $02WBn.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)((0, $02WBn.assertNotEmpty)(data.voting_power)),
        address: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $3SgOH.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $46089a842eba24e0$var$decodeValidatorInfo;
function $46089a842eba24e0$var$decodeNodeInfo(data) {
    return {
        id: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.id)),
        listenAddr: (0, $02WBn.assertNotEmpty)(data.listen_addr),
        network: (0, $02WBn.assertNotEmpty)(data.network),
        version: (0, $02WBn.assertString)(data.version),
        channels: (0, $02WBn.assertNotEmpty)(data.channels),
        moniker: (0, $02WBn.assertNotEmpty)(data.moniker),
        other: (0, $02WBn.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $46089a842eba24e0$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $3SgOH.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $hAC4f.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $94ZnX.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $94ZnX.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $02WBn.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $02WBn.assertBoolean)(data.catching_up)
    };
}
function $46089a842eba24e0$var$decodeStatus(data) {
    return {
        nodeInfo: $46089a842eba24e0$var$decodeNodeInfo(data.node_info),
        syncInfo: $46089a842eba24e0$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $46089a842eba24e0$var$decodeValidatorInfo(data.validator_info)
    };
}
function $46089a842eba24e0$var$decodeTxProof(data) {
    return {
        data: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.data)),
        rootHash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.proof.total)),
            index: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $02WBn.assertArray)(data.proof.aunts).map($94ZnX.fromBase64)
        }
    };
}
function $46089a842eba24e0$var$decodeTxResponse(data) {
    return {
        tx: (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.tx)),
        result: $46089a842eba24e0$var$decodeTxData((0, $02WBn.assertObject)(data.tx_result)),
        height: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.height)),
        index: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNumber)(data.index)),
        hash: (0, $94ZnX.fromHex)((0, $02WBn.assertNotEmpty)(data.hash)),
        proof: (0, $02WBn.may)($46089a842eba24e0$var$decodeTxProof, data.proof)
    };
}
function $46089a842eba24e0$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.total_count)),
        txs: (0, $02WBn.assertArray)(data.txs).map($46089a842eba24e0$var$decodeTxResponse)
    };
}
function $46089a842eba24e0$var$decodeTxEvent(data) {
    const tx = (0, $94ZnX.fromBase64)((0, $02WBn.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $iUSwE.hashTx)(tx),
        result: $46089a842eba24e0$var$decodeTxData(data.result),
        height: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.height))
    };
}
function $46089a842eba24e0$var$decodeValidators(data) {
    return {
        blockHeight: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.block_height)),
        validators: (0, $02WBn.assertArray)(data.validators).map($46089a842eba24e0$var$decodeValidatorInfo),
        count: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.count)),
        total: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.total))
    };
}
function $46089a842eba24e0$var$decodeBlock(data) {
    return {
        header: $46089a842eba24e0$var$decodeHeader((0, $02WBn.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $46089a842eba24e0$var$decodeCommit((0, $02WBn.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $02WBn.assertArray)(data.data.txs).map($94ZnX.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $46089a842eba24e0$var$decodeBlockResponse(data) {
    return {
        blockId: $46089a842eba24e0$var$decodeBlockId(data.block_id),
        block: $46089a842eba24e0$var$decodeBlock(data.block)
    };
}
function $46089a842eba24e0$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.total_count)),
        blocks: (0, $02WBn.assertArray)(data.blocks).map($46089a842eba24e0$var$decodeBlockResponse)
    };
}
function $46089a842eba24e0$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.total)),
        totalBytes: (0, $3SgOH.apiToSmallInt)((0, $02WBn.assertNotEmpty)(data.total_bytes))
    };
}
class $46089a842eba24e0$var$Responses {
    static decodeAbciInfo(response) {
        return $46089a842eba24e0$var$decodeAbciInfo((0, $02WBn.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $46089a842eba24e0$var$decodeAbciQuery((0, $02WBn.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $46089a842eba24e0$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $46089a842eba24e0$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $46089a842eba24e0$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $46089a842eba24e0$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $46089a842eba24e0$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $46089a842eba24e0$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $46089a842eba24e0$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $46089a842eba24e0$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $46089a842eba24e0$var$decodeGenesis((0, $02WBn.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $46089a842eba24e0$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $46089a842eba24e0$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $46089a842eba24e0$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $46089a842eba24e0$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $46089a842eba24e0$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $46089a842eba24e0$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $46089a842eba24e0$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $46089a842eba24e0$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $46089a842eba24e0$var$Responses;

});
parcelRegister("kchui", function(module, exports) {
"use strict";
// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = void 0;
var $eb427e5348e0d313$var$BlockIdFlag;
(function(BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})($eb427e5348e0d313$var$BlockIdFlag = module.exports.BlockIdFlag || (module.exports.BlockIdFlag = {}));

});





parcelRegister("efVmP", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint37 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $yVAQl = parcelRequire("yVAQl");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $yVAQl.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $yVAQl.SubscriptionEventType;
    }
});

var $cp13W = parcelRequire("cp13W");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $cp13W.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $cp13W.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $cp13W.VoteType;
    }
});

var $NmJlj = parcelRequire("NmJlj");
Object.defineProperty(module.exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return $NmJlj.Tendermint37Client;
    }
});

});
parcelRegister("yVAQl", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $068fd9e8cb368109$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($068fd9e8cb368109$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $068fd9e8cb368109$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($068fd9e8cb368109$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $068fd9e8cb368109$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $068fd9e8cb368109$var$buildQuery;

});

parcelRegister("cp13W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $9078a4d2bac6409a$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $9078a4d2bac6409a$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $9078a4d2bac6409a$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $9078a4d2bac6409a$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $9078a4d2bac6409a$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($9078a4d2bac6409a$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRegister("NmJlj", function(module, exports) {
"use strict";
var $0946357d40b321b5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0946357d40b321b5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0946357d40b321b5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0946357d40b321b5$var$__createBinding(result, mod, k);
    }
    $0946357d40b321b5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = void 0;

var $1YfeO = parcelRequire("1YfeO");

var $lRzwx = parcelRequire("lRzwx");

var $4J6Da = parcelRequire("4J6Da");

const $0946357d40b321b5$var$requests = $0946357d40b321b5$var$__importStar((parcelRequire("yVAQl")));
class $0946357d40b321b5$var$Tendermint37Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $lRzwx.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $lRzwx.HttpClient(endpoint) : new $lRzwx.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $0946357d40b321b5$var$Tendermint37Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $0946357d40b321b5$var$Tendermint37Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $1YfeO.createJsonRpcRequest)($0946357d40b321b5$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $4J6Da.adaptor37.params;
        this.r = $4J6Da.adaptor37.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $0946357d40b321b5$var$requests.Method.Subscribe,
            query: {
                type: $0946357d40b321b5$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $0946357d40b321b5$var$requests.Method.Subscribe,
            query: {
                type: $0946357d40b321b5$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $0946357d40b321b5$var$requests.Method.Subscribe,
            query: {
                type: $0946357d40b321b5$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $0946357d40b321b5$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $0946357d40b321b5$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $lRzwx.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint37Client = $0946357d40b321b5$var$Tendermint37Client;

});
parcelRegister("4J6Da", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor37 = void 0;

var $jAQxc = parcelRequire("jAQxc");

var $68IGQ = parcelRequire("68IGQ");

var $9QmjM = parcelRequire("9QmjM");
module.exports.adaptor37 = {
    params: $68IGQ.Params,
    responses: $9QmjM.Responses,
    hashTx: $jAQxc.hashTx,
    hashBlock: $jAQxc.hashBlock
};

});
parcelRegister("jAQxc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $c162L = parcelRequire("c162L");

var $2QrDG = parcelRequire("2QrDG");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $e43a215d9f4fe0cc$var$hashTx(tx) {
    return (0, $c162L.sha256)(tx);
}
module.exports.hashTx = $e43a215d9f4fe0cc$var$hashTx;
function $e43a215d9f4fe0cc$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $e43a215d9f4fe0cc$var$hashLeaf(leaf) {
    const hash = new $c162L.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $e43a215d9f4fe0cc$var$hashInner(left, right) {
    const hash = new $c162L.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $e43a215d9f4fe0cc$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $e43a215d9f4fe0cc$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $e43a215d9f4fe0cc$var$getSplitPoint(hashes.length);
                const left = $e43a215d9f4fe0cc$var$hashTree(hashes.slice(0, slicePoint));
                const right = $e43a215d9f4fe0cc$var$hashTree(hashes.slice(slicePoint));
                return $e43a215d9f4fe0cc$var$hashInner(left, right);
            }
    }
}
function $e43a215d9f4fe0cc$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $2QrDG.encodeVersion)(header.version),
        (0, $2QrDG.encodeString)(header.chainId),
        (0, $2QrDG.encodeUvarint)(header.height),
        (0, $2QrDG.encodeTime)(header.time),
        (0, $2QrDG.encodeBlockId)(header.lastBlockId),
        (0, $2QrDG.encodeBytes)(header.lastCommitHash),
        (0, $2QrDG.encodeBytes)(header.dataHash),
        (0, $2QrDG.encodeBytes)(header.validatorsHash),
        (0, $2QrDG.encodeBytes)(header.nextValidatorsHash),
        (0, $2QrDG.encodeBytes)(header.consensusHash),
        (0, $2QrDG.encodeBytes)(header.appHash),
        (0, $2QrDG.encodeBytes)(header.lastResultsHash),
        (0, $2QrDG.encodeBytes)(header.evidenceHash),
        (0, $2QrDG.encodeBytes)(header.proposerAddress)
    ];
    return $e43a215d9f4fe0cc$var$hashTree(encodedFields);
}
module.exports.hashBlock = $e43a215d9f4fe0cc$var$hashBlock;

});
parcelRegister("2QrDG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $94ZnX = parcelRequire("94ZnX");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $2125e0a2a0d630df$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $2125e0a2a0d630df$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $2125e0a2a0d630df$var$assertBoolean(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $2125e0a2a0d630df$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $2125e0a2a0d630df$var$assertString(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $2125e0a2a0d630df$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $2125e0a2a0d630df$var$assertNumber(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $2125e0a2a0d630df$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $2125e0a2a0d630df$var$assertArray(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $2125e0a2a0d630df$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $2125e0a2a0d630df$var$assertObject(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $2125e0a2a0d630df$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $2125e0a2a0d630df$var$assertNotEmpty(value) {
    $2125e0a2a0d630df$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $2125e0a2a0d630df$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $2125e0a2a0d630df$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $2125e0a2a0d630df$var$may;
function $2125e0a2a0d630df$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $2125e0a2a0d630df$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $2125e0a2a0d630df$var$encodeString(s) {
    const utf8 = (0, $94ZnX.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $2125e0a2a0d630df$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $2125e0a2a0d630df$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$2125e0a2a0d630df$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $2125e0a2a0d630df$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $2125e0a2a0d630df$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$2125e0a2a0d630df$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$2125e0a2a0d630df$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $2125e0a2a0d630df$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $2125e0a2a0d630df$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $2125e0a2a0d630df$var$encodeBytes;
function $2125e0a2a0d630df$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$2125e0a2a0d630df$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$2125e0a2a0d630df$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $2125e0a2a0d630df$var$encodeVersion;
function $2125e0a2a0d630df$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $2125e0a2a0d630df$var$encodeBlockId;

});


parcelRegister("68IGQ", function(module, exports) {
"use strict";
var $478627ed844249aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $478627ed844249aa$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $478627ed844249aa$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $478627ed844249aa$var$__createBinding(result, mod, k);
    }
    $478627ed844249aa$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $3SgOH = parcelRequire("3SgOH");

var $1YfeO = parcelRequire("1YfeO");

var $2QrDG = parcelRequire("2QrDG");

const $478627ed844249aa$var$requests = $478627ed844249aa$var$__importStar((parcelRequire("yVAQl")));
function $478627ed844249aa$var$encodeHeightParam(param) {
    return {
        height: (0, $2QrDG.may)($3SgOH.smallIntToApi, param.height)
    };
}
function $478627ed844249aa$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $2QrDG.may)($3SgOH.smallIntToApi, param.minHeight),
        maxHeight: (0, $2QrDG.may)($3SgOH.smallIntToApi, param.maxHeight)
    };
}
function $478627ed844249aa$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $478627ed844249aa$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $2QrDG.assertNotEmpty)(params.path),
        data: (0, $94ZnX.toHex)(params.data),
        height: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $478627ed844249aa$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $94ZnX.toBase64)((0, $2QrDG.assertNotEmpty)(params.tx))
    };
}
function $478627ed844249aa$var$encodeTxParams(params) {
    return {
        hash: (0, $94ZnX.toBase64)((0, $2QrDG.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $478627ed844249aa$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $478627ed844249aa$var$encodeValidatorsParams(params) {
    return {
        height: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.height),
        page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.page),
        per_page: (0, $2QrDG.may)($3SgOH.smallIntToApi, params.per_page)
    };
}
class $478627ed844249aa$var$Params {
    static encodeAbciInfo(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $478627ed844249aa$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $1YfeO.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $1YfeO.createJsonRpcRequest)(req.method, $478627ed844249aa$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $478627ed844249aa$var$Params;

});

parcelRegister("9QmjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $94ZnX = parcelRequire("94ZnX");

var $hm8y1 = parcelRequire("hm8y1");

var $hAC4f = parcelRequire("hAC4f");

var $3SgOH = parcelRequire("3SgOH");

var $kchui = parcelRequire("kchui");

var $2QrDG = parcelRequire("2QrDG");

var $jAQxc = parcelRequire("jAQxc");
function $72aa4847d985ac0e$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $2QrDG.may)($3SgOH.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $2QrDG.may)($94ZnX.fromBase64, data.last_block_app_hash)
    };
}
function $72aa4847d985ac0e$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $94ZnX.fromBase64)(op.key),
                data: (0, $94ZnX.fromBase64)(op.data)
            }))
    };
}
function $72aa4847d985ac0e$var$decodeAbciQuery(data) {
    return {
        key: (0, $94ZnX.fromBase64)((0, $2QrDG.assertString)(data.key ?? "")),
        value: (0, $94ZnX.fromBase64)((0, $2QrDG.assertString)(data.value ?? "")),
        proof: (0, $2QrDG.may)($72aa4847d985ac0e$var$decodeQueryProof, data.proofOps),
        height: (0, $2QrDG.may)($3SgOH.apiToSmallInt, data.height),
        code: (0, $2QrDG.may)($3SgOH.apiToSmallInt, data.code),
        codespace: (0, $2QrDG.assertString)(data.codespace ?? ""),
        index: (0, $2QrDG.may)($3SgOH.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $2QrDG.assertString)(data.info ?? "")
    };
}
function $72aa4847d985ac0e$var$decodeEventAttribute(attribute) {
    return {
        key: (0, $2QrDG.assertNotEmpty)(attribute.key),
        value: attribute.value ?? ""
    };
}
function $72aa4847d985ac0e$var$decodeAttributes(attributes) {
    return (0, $2QrDG.assertArray)(attributes).map($72aa4847d985ac0e$var$decodeEventAttribute);
}
function $72aa4847d985ac0e$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $72aa4847d985ac0e$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $72aa4847d985ac0e$var$decodeEvent;
function $72aa4847d985ac0e$var$decodeEvents(events) {
    return (0, $2QrDG.assertArray)(events).map($72aa4847d985ac0e$var$decodeEvent);
}
function $72aa4847d985ac0e$var$decodeTxData(data) {
    return {
        code: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $2QrDG.may)($94ZnX.fromBase64, data.data),
        events: data.events ? $72aa4847d985ac0e$var$decodeEvents(data.events) : [],
        gasWanted: (0, $3SgOH.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $3SgOH.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $72aa4847d985ac0e$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $hm8y1.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $72aa4847d985ac0e$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.max_gas))
    };
}
function $72aa4847d985ac0e$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.max_age_duration))
    };
}
function $72aa4847d985ac0e$var$decodeConsensusParams(data) {
    return {
        block: $72aa4847d985ac0e$var$decodeBlockParams((0, $2QrDG.assertObject)(data.block)),
        evidence: $72aa4847d985ac0e$var$decodeEvidenceParams((0, $2QrDG.assertObject)(data.evidence))
    };
}
function $72aa4847d985ac0e$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $72aa4847d985ac0e$var$decodePubkey((0, $2QrDG.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $72aa4847d985ac0e$var$decodeValidatorUpdate;
function $72aa4847d985ac0e$var$decodeBlockResults(data) {
    return {
        height: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($72aa4847d985ac0e$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($72aa4847d985ac0e$var$decodeValidatorUpdate),
        consensusUpdates: (0, $2QrDG.may)($72aa4847d985ac0e$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $72aa4847d985ac0e$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $72aa4847d985ac0e$var$decodeEvents(data.end_block_events || [])
    };
}
function $72aa4847d985ac0e$var$decodeBlockId(data) {
    return {
        hash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $2QrDG.assertNotEmpty)(data.parts.total),
            hash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $72aa4847d985ac0e$var$decodeBlockVersion(data) {
    return {
        block: (0, $3SgOH.apiToSmallInt)(data.block),
        app: (0, $3SgOH.apiToSmallInt)(data.app ?? 0)
    };
}
function $72aa4847d985ac0e$var$decodeHeader(data) {
    return {
        version: $72aa4847d985ac0e$var$decodeBlockVersion(data.version),
        chainId: (0, $2QrDG.assertNotEmpty)(data.chain_id),
        height: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.height)),
        time: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $2QrDG.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $72aa4847d985ac0e$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.last_commit_hash)),
        dataHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.data_hash)),
        validatorsHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.consensus_hash)),
        appHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.app_hash)),
        lastResultsHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.proposer_address))
    };
}
function $72aa4847d985ac0e$var$decodeBlockMeta(data) {
    return {
        blockId: $72aa4847d985ac0e$var$decodeBlockId(data.block_id),
        blockSize: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.block_size)),
        header: $72aa4847d985ac0e$var$decodeHeader(data.header),
        numTxs: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.num_txs))
    };
}
function $72aa4847d985ac0e$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $2QrDG.assertArray)(data.block_metas).map($72aa4847d985ac0e$var$decodeBlockMeta)
    };
}
function $72aa4847d985ac0e$var$decodeBroadcastTxSync(data) {
    return {
        ...$72aa4847d985ac0e$var$decodeTxData(data),
        hash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.hash))
    };
}
function $72aa4847d985ac0e$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $3SgOH.apiToSmallInt)(data.height),
        hash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.hash)),
        checkTx: $72aa4847d985ac0e$var$decodeTxData((0, $2QrDG.assertObject)(data.check_tx)),
        deliverTx: (0, $2QrDG.may)($72aa4847d985ac0e$var$decodeTxData, data.deliver_tx)
    };
}
function $72aa4847d985ac0e$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $hm8y1.assert)(blockIdFlag in $kchui.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $72aa4847d985ac0e$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $hAC4f.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $72aa4847d985ac0e$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $72aa4847d985ac0e$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $94ZnX.fromHex)(data.validator_address) : undefined,
        timestamp: $72aa4847d985ac0e$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $94ZnX.fromBase64)(data.signature) : undefined
    };
}
function $72aa4847d985ac0e$var$decodeCommit(data) {
    return {
        blockId: $72aa4847d985ac0e$var$decodeBlockId((0, $2QrDG.assertObject)(data.block_id)),
        height: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.height)),
        round: (0, $3SgOH.apiToSmallInt)(data.round),
        signatures: (0, $2QrDG.assertArray)(data.signatures).map($72aa4847d985ac0e$var$decodeCommitSignature)
    };
}
function $72aa4847d985ac0e$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $2QrDG.assertBoolean)(data.canonical),
        header: $72aa4847d985ac0e$var$decodeHeader(data.signed_header.header),
        commit: $72aa4847d985ac0e$var$decodeCommit(data.signed_header.commit)
    };
}
function $72aa4847d985ac0e$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.address)),
        pubkey: $72aa4847d985ac0e$var$decodePubkey((0, $2QrDG.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)((0, $2QrDG.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $72aa4847d985ac0e$var$decodeValidatorGenesis;
function $72aa4847d985ac0e$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $2QrDG.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $2QrDG.assertNotEmpty)(data.chain_id),
        consensusParams: $72aa4847d985ac0e$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $2QrDG.assertArray)(data.validators).map($72aa4847d985ac0e$var$decodeValidatorGenesis) : [],
        appHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $72aa4847d985ac0e$var$decodeValidatorInfo(data) {
    return {
        pubkey: $72aa4847d985ac0e$var$decodePubkey((0, $2QrDG.assertObject)(data.pub_key)),
        votingPower: (0, $3SgOH.apiToBigInt)((0, $2QrDG.assertNotEmpty)(data.voting_power)),
        address: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $3SgOH.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $72aa4847d985ac0e$var$decodeValidatorInfo;
function $72aa4847d985ac0e$var$decodeNodeInfo(data) {
    return {
        id: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.id)),
        listenAddr: (0, $2QrDG.assertNotEmpty)(data.listen_addr),
        network: (0, $2QrDG.assertNotEmpty)(data.network),
        version: (0, $2QrDG.assertString)(data.version),
        channels: (0, $2QrDG.assertNotEmpty)(data.channels),
        moniker: (0, $2QrDG.assertNotEmpty)(data.moniker),
        other: (0, $2QrDG.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $72aa4847d985ac0e$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $3SgOH.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $hAC4f.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $94ZnX.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $94ZnX.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $hAC4f.fromRfc3339WithNanoseconds)((0, $2QrDG.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $2QrDG.assertBoolean)(data.catching_up)
    };
}
function $72aa4847d985ac0e$var$decodeStatus(data) {
    return {
        nodeInfo: $72aa4847d985ac0e$var$decodeNodeInfo(data.node_info),
        syncInfo: $72aa4847d985ac0e$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $72aa4847d985ac0e$var$decodeValidatorInfo(data.validator_info)
    };
}
function $72aa4847d985ac0e$var$decodeTxProof(data) {
    return {
        data: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.data)),
        rootHash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.proof.total)),
            index: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $2QrDG.assertArray)(data.proof.aunts).map($94ZnX.fromBase64)
        }
    };
}
function $72aa4847d985ac0e$var$decodeTxResponse(data) {
    return {
        tx: (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.tx)),
        result: $72aa4847d985ac0e$var$decodeTxData((0, $2QrDG.assertObject)(data.tx_result)),
        height: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.height)),
        index: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNumber)(data.index)),
        hash: (0, $94ZnX.fromHex)((0, $2QrDG.assertNotEmpty)(data.hash)),
        proof: (0, $2QrDG.may)($72aa4847d985ac0e$var$decodeTxProof, data.proof)
    };
}
function $72aa4847d985ac0e$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.total_count)),
        txs: (0, $2QrDG.assertArray)(data.txs).map($72aa4847d985ac0e$var$decodeTxResponse)
    };
}
function $72aa4847d985ac0e$var$decodeTxEvent(data) {
    const tx = (0, $94ZnX.fromBase64)((0, $2QrDG.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $jAQxc.hashTx)(tx),
        result: $72aa4847d985ac0e$var$decodeTxData(data.result),
        height: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.height))
    };
}
function $72aa4847d985ac0e$var$decodeValidators(data) {
    return {
        blockHeight: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.block_height)),
        validators: (0, $2QrDG.assertArray)(data.validators).map($72aa4847d985ac0e$var$decodeValidatorInfo),
        count: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.count)),
        total: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.total))
    };
}
function $72aa4847d985ac0e$var$decodeBlock(data) {
    return {
        header: $72aa4847d985ac0e$var$decodeHeader((0, $2QrDG.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $72aa4847d985ac0e$var$decodeCommit((0, $2QrDG.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $2QrDG.assertArray)(data.data.txs).map($94ZnX.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $72aa4847d985ac0e$var$decodeBlockResponse(data) {
    return {
        blockId: $72aa4847d985ac0e$var$decodeBlockId(data.block_id),
        block: $72aa4847d985ac0e$var$decodeBlock(data.block)
    };
}
function $72aa4847d985ac0e$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.total_count)),
        blocks: (0, $2QrDG.assertArray)(data.blocks).map($72aa4847d985ac0e$var$decodeBlockResponse)
    };
}
function $72aa4847d985ac0e$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.total)),
        totalBytes: (0, $3SgOH.apiToSmallInt)((0, $2QrDG.assertNotEmpty)(data.total_bytes))
    };
}
class $72aa4847d985ac0e$var$Responses {
    static decodeAbciInfo(response) {
        return $72aa4847d985ac0e$var$decodeAbciInfo((0, $2QrDG.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $72aa4847d985ac0e$var$decodeAbciQuery((0, $2QrDG.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $72aa4847d985ac0e$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $72aa4847d985ac0e$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $72aa4847d985ac0e$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $72aa4847d985ac0e$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $72aa4847d985ac0e$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $72aa4847d985ac0e$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $72aa4847d985ac0e$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $72aa4847d985ac0e$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $72aa4847d985ac0e$var$decodeGenesis((0, $2QrDG.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $72aa4847d985ac0e$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $72aa4847d985ac0e$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $72aa4847d985ac0e$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $72aa4847d985ac0e$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $72aa4847d985ac0e$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $72aa4847d985ac0e$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $72aa4847d985ac0e$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $72aa4847d985ac0e$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $72aa4847d985ac0e$var$Responses;

});




parcelRegister("gdgBH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTendermint37Client = module.exports.isTendermint34Client = void 0;

var $eBVDC = parcelRequire("eBVDC");

var $efVmP = parcelRequire("efVmP");
function $bcdabe0b7c3cd51a$var$isTendermint34Client(client) {
    return client instanceof $eBVDC.Tendermint34Client;
}
module.exports.isTendermint34Client = $bcdabe0b7c3cd51a$var$isTendermint34Client;
function $bcdabe0b7c3cd51a$var$isTendermint37Client(client) {
    return client instanceof $efVmP.Tendermint37Client;
}
module.exports.isTendermint37Client = $bcdabe0b7c3cd51a$var$isTendermint37Client;

});


parcelRegister("d6b9W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StargateClient = module.exports.BroadcastTxError = module.exports.assertIsDeliverTxFailure = module.exports.assertIsDeliverTxSuccess = module.exports.isDeliverTxSuccess = module.exports.isDeliverTxFailure = module.exports.TimeoutError = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $94ZnX = parcelRequire("94ZnX");

var $h3uvW = parcelRequire("h3uvW");

var $kteII = parcelRequire("kteII");

var $hm8y1 = parcelRequire("hm8y1");

var $7q6Mz = parcelRequire("7q6Mz");

var $kewCN = parcelRequire("kewCN");

var $7a0MP = parcelRequire("7a0MP");

var $6qSFW = parcelRequire("6qSFW");

var $5E3xG = parcelRequire("5E3xG");
class $98947de3c1d653a7$var$TimeoutError extends Error {
    constructor(message, txId){
        super(message);
        this.txId = txId;
    }
}
module.exports.TimeoutError = $98947de3c1d653a7$var$TimeoutError;
function $98947de3c1d653a7$var$isDeliverTxFailure(result) {
    return !!result.code;
}
module.exports.isDeliverTxFailure = $98947de3c1d653a7$var$isDeliverTxFailure;
function $98947de3c1d653a7$var$isDeliverTxSuccess(result) {
    return !$98947de3c1d653a7$var$isDeliverTxFailure(result);
}
module.exports.isDeliverTxSuccess = $98947de3c1d653a7$var$isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $98947de3c1d653a7$var$assertIsDeliverTxSuccess(result) {
    if ($98947de3c1d653a7$var$isDeliverTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
module.exports.assertIsDeliverTxSuccess = $98947de3c1d653a7$var$assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */ function $98947de3c1d653a7$var$assertIsDeliverTxFailure(result) {
    if ($98947de3c1d653a7$var$isDeliverTxSuccess(result)) throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
module.exports.assertIsDeliverTxFailure = $98947de3c1d653a7$var$assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */ class $98947de3c1d653a7$var$BroadcastTxError extends Error {
    constructor(code, codespace, log){
        super(`Broadcasting transaction failed with code ${code} (codespace: ${codespace}). Log: ${log}`);
        this.code = code;
        this.codespace = codespace;
        this.log = log;
    }
}
module.exports.BroadcastTxError = $98947de3c1d653a7$var$BroadcastTxError;
class $98947de3c1d653a7$var$StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */ static async connect(endpoint, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $kteII.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $kteII.Tendermint34Client.connect(endpoint);
        }
        return $98947de3c1d653a7$var$StargateClient.create(tmClient, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async create(tmClient, options = {}) {
        return new $98947de3c1d653a7$var$StargateClient(tmClient, options);
    }
    constructor(tmClient, options){
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $5E3xG.QueryClient.withExtensions(tmClient, $6qSFW.setupAuthExtension, $6qSFW.setupBankExtension, $6qSFW.setupStakingExtension, $6qSFW.setupTxExtension);
        }
        const { accountParser: accountParser = $kewCN.accountFromAny } = options;
        this.accountParser = accountParser;
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        } catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) return null;
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, $94ZnX.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new $h3uvW.Uint53(response.block.header.version.block).toString(),
                    app: new $h3uvW.Uint53(response.block.header.version.app).toString()
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, $kteII.toRfc3339WithNanoseconds)(response.block.header.time)
            },
            txs: response.block.txs
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */ async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses: delegationResponses, pagination: pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination?.nextKey;
        }while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue)=>{
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, $hm8y1.assert)(currentValue.balance);
            return previousValue !== null ? (0, $bVJSA.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        let delegatedAmount;
        try {
            delegatedAmount = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse?.balance;
        } catch (e) {
            if (e.toString().includes("key not found")) ;
            else throw e;
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return results[0] ?? null;
    }
    async searchTx(query) {
        let rawQuery;
        if (typeof query === "string") rawQuery = query;
        else if (Array.isArray(query)) rawQuery = query.map((t)=>`${t.key}='${t.value}'`).join(" AND ");
        else throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
        return this.txsQuery(rawQuery);
    }
    disconnect() {
        if (this.tmClient) this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(()=>{
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId)=>{
            if (timedOut) throw new $98947de3c1d653a7$var$TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            await (0, $hm8y1.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result ? {
                code: result.code,
                height: result.height,
                txIndex: result.txIndex,
                events: result.events,
                rawLog: result.rawLog,
                transactionHash: txId,
                msgResponses: result.msgResponses,
                gasUsed: result.gasUsed,
                gasWanted: result.gasWanted
            } : pollForTx(txId);
        };
        const transactionId = await this.broadcastTxSync(tx);
        return new Promise((resolve, reject)=>pollForTx(transactionId).then((value)=>{
                clearTimeout(txPollTimeout);
                resolve(value);
            }, (error)=>{
                clearTimeout(txPollTimeout);
                reject(error);
            }));
    }
    /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */ async broadcastTxSync(tx) {
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({
            tx: tx
        });
        if (broadcasted.code) return Promise.reject(new $98947de3c1d653a7$var$BroadcastTxError(broadcasted.code, broadcasted.codespace ?? "", broadcasted.log));
        const transactionId = (0, $94ZnX.toHex)(broadcasted.hash).toUpperCase();
        return transactionId;
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({
            query: query
        });
        return results.txs.map((tx)=>{
            const txMsgData = $7q6Mz.TxMsgData.decode(tx.result.data ?? new Uint8Array());
            return {
                height: tx.height,
                txIndex: tx.index,
                hash: (0, $94ZnX.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map($7a0MP.fromTendermintEvent),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                msgResponses: txMsgData.msgResponses,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted
            };
        });
    }
}
module.exports.StargateClient = $98947de3c1d653a7$var$StargateClient;

});



parcelRegister("44pFF", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("eqANf", function(module, exports) {
"use strict";
var $a81008ce3a9ef351$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a81008ce3a9ef351$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KyveSigning = module.exports.PendingSignedTx = module.exports.PendingTx = void 0;

var $c162L = parcelRequire("c162L");

var $94ZnX = parcelRequire("94ZnX");

var $fReUp = parcelRequire("fReUp");

var $bkT1A = parcelRequire("bkT1A");

var $2M7Hy = parcelRequire("2M7Hy");
var $a81008ce3a9ef351$var$PendingTx = /** @class */ function() {
    function PendingTx(options, executor) {
        this.tx = options.tx;
        this.executor = executor;
    }
    PendingTx.prototype.then = function(onfulfilled, onrejected) {
        return this.executor().then(onfulfilled, onrejected);
    };
    PendingTx.prototype.catch = function(onrejected) {
        return this.executor().catch(onrejected);
    };
    PendingTx.prototype.finally = function(onfinally) {
        return this.executor().finally(onfinally);
    };
    return PendingTx;
}();
module.exports.PendingTx = $a81008ce3a9ef351$var$PendingTx;
var $a81008ce3a9ef351$var$PendingSignedTx = /** @class */ function() {
    function PendingSignedTx(nativeClient, tx) {
        this.nativeClient = nativeClient;
        this.txBytes = tx.txRawBytes;
        this.fee = tx.fee;
        this.tx = tx.tx;
        this.txHash = (0, $94ZnX.toHex)((0, $c162L.sha256)(this.txBytes)).toUpperCase();
    }
    PendingSignedTx.prototype.execute = function() {
        return $a81008ce3a9ef351$var$__awaiter(this, void 0, void 0, function() {
            return $a81008ce3a9ef351$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.broadcastTx(this.txBytes)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return PendingSignedTx;
}();
module.exports.PendingSignedTx = $a81008ce3a9ef351$var$PendingSignedTx;
var $a81008ce3a9ef351$var$KyveSigning = /** @class */ function() {
    function KyveSigning(client, account, config) {
        this.nativeClient = client;
        this.account = account;
        this.config = config;
    }
    KyveSigning.prototype.getPendingSignedTx = function(tx, options) {
        return $a81008ce3a9ef351$var$__awaiter(this, void 0, void 0, function() {
            var _a, _b;
            return $a81008ce3a9ef351$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = $a81008ce3a9ef351$var$PendingSignedTx.bind;
                        _b = [
                            void 0,
                            this.nativeClient
                        ];
                        return [
                            4 /*yield*/ ,
                            this.signTx(tx, options)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            new (_a.apply($a81008ce3a9ef351$var$PendingSignedTx, _b.concat([
                                _c.sent()
                            ])))()
                        ];
                }
            });
        });
    };
    KyveSigning.prototype.signTx = function(tx, options) {
        return $a81008ce3a9ef351$var$__awaiter(this, void 0, void 0, function() {
            var txArr, gasEstimation, multiplier, fee, txRaw, gasEstimation, multiplier, fee, txRaw, txRaw;
            return $a81008ce3a9ef351$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        txArr = Array.isArray(tx) ? tx : [
                            tx
                        ];
                        if (!!options) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.simulate(this.account.address, txArr, undefined)
                        ];
                    case 1:
                        gasEstimation = _a.sent();
                        multiplier = $2M7Hy.GAS_MULTIPLIER;
                        fee = (0, $fReUp.calculateFee)(Math.round(gasEstimation * multiplier), $fReUp.GasPrice.fromString("".concat(this.config.gasPrice).concat(this.config.coinDenom)));
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.sign(this.account.address, txArr, fee, "")
                        ];
                    case 2:
                        txRaw = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                txRawBytes: $bkT1A.TxRaw.encode(txRaw).finish(),
                                fee: fee,
                                tx: txArr
                            }
                        ];
                    case 3:
                        if (!(options.fee === "auto" || typeof options.fee === "number")) return [
                            3 /*break*/ ,
                            6
                        ];
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.simulate(this.account.address, txArr, options.memo)
                        ];
                    case 4:
                        gasEstimation = _a.sent();
                        multiplier = typeof options.fee === "number" ? options.fee : $2M7Hy.GAS_MULTIPLIER;
                        fee = (0, $fReUp.calculateFee)(Math.round(gasEstimation * multiplier), $fReUp.GasPrice.fromString("".concat(this.config.gasPrice).concat(this.config.coinDenom)));
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.sign(this.account.address, txArr, fee, options.memo || "")
                        ];
                    case 5:
                        txRaw = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                txRawBytes: $bkT1A.TxRaw.encode(txRaw).finish(),
                                fee: fee,
                                tx: txArr
                            }
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            this.nativeClient.sign(this.account.address, txArr, options.fee, options.memo || "")
                        ];
                    case 7:
                        txRaw = _a.sent();
                        return [
                            2 /*return*/ ,
                            {
                                txRawBytes: $bkT1A.TxRaw.encode(txRaw).finish(),
                                tx: txArr,
                                fee: options.fee
                            }
                        ];
                }
            });
        });
    };
    return KyveSigning;
}();
module.exports.KyveSigning = $a81008ce3a9ef351$var$KyveSigning;

});
parcelRegister("2M7Hy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KYVE_LEAP_CONFIG = module.exports.KYVE_COSMOSTATION_CONFIG = module.exports.KYVE_KEPLR_CONFIG = module.exports.SUPPORTED_WALLETS = module.exports.SUPPORTED_CHAIN_CONFIGS = module.exports.COIN_TYPE = module.exports.GAS_MULTIPLIER = module.exports.GOV_AUTHORITY = module.exports.PREFIX = void 0;

var $3sP6O = parcelRequire("3sP6O");
module.exports.PREFIX = "kyve";
module.exports.GOV_AUTHORITY = "kyve10d07y265gmmuvt4z0w9aw880jnsr700jdv7nah";
module.exports.GAS_MULTIPLIER = 1.3;
module.exports.COIN_TYPE = 118;
// chains are always identified by their chain id
module.exports.SUPPORTED_CHAIN_CONFIGS = {
    "kyve-1": {
        chainId: "kyve-1",
        chainName: "KYVE",
        rpc: "https://rpc-eu-1.kyve.network",
        rest: "https://api-eu-1.kyve.network",
        coin: "KYVE",
        coinDenom: "ukyve",
        coinDecimals: 6,
        gasPrice: 0.02
    },
    "kaon-1": {
        chainId: "kaon-1",
        chainName: "KYVE Kaon",
        rpc: "https://rpc-eu-1.kaon.kyve.network",
        rest: "https://api-eu-1.kaon.kyve.network",
        coin: "KYVE",
        coinDenom: "tkyve",
        coinDecimals: 6,
        gasPrice: 0.02
    },
    "korellia-2": {
        chainId: "korellia-2",
        chainName: "KYVE Korellia",
        rpc: "https://rpc-eu-1.korellia.kyve.network",
        rest: "https://api-eu-1.korellia.kyve.network",
        coin: "KYVE",
        coinDenom: "tkyve",
        coinDecimals: 6,
        gasPrice: 0.02
    },
    "kyve-beta": {
        chainId: "kyve-beta",
        chainName: "KYVE-Beta",
        rpc: "https://rpc.beta.kyve.network",
        rest: "https://api.beta.kyve.network",
        coin: "KYVE",
        coinDenom: "tkyve",
        coinDecimals: 6,
        gasPrice: 0.02
    },
    "kyve-alpha": {
        chainId: "kyve-alpha",
        chainName: "KYVE Alpha",
        rpc: "https://rpc.alpha.kyve.network",
        rest: "https://api.alpha.kyve.network",
        coin: "KYVE",
        coinDenom: "tkyve",
        coinDecimals: 6,
        gasPrice: 0.02
    },
    "kyve-local": {
        chainId: "kyve-local",
        chainName: "KYVE Local",
        rpc: "http://0.0.0.0:26657",
        rest: "http://0.0.0.0:1317",
        coin: "KYVE",
        coinDenom: "tkyve",
        coinDecimals: 6,
        gasPrice: 0.02
    }
};
module.exports.SUPPORTED_WALLETS = {
    KEPLR: "KEPLR",
    COSMOSTATION: "COSMOSTATION",
    LEAP: "LEAP"
};
module.exports.KYVE_KEPLR_CONFIG = {
    rpc: "",
    rest: "",
    chainId: "",
    chainName: "",
    stakeCurrency: {
        coinDenom: "",
        coinMinimalDenom: "",
        coinDecimals: 0
    },
    bip44: {
        coinType: module.exports.COIN_TYPE
    },
    bech32Config: $3sP6O.Bech32Address.defaultBech32Config("kyve"),
    currencies: [],
    feeCurrencies: [],
    features: [
        "ibc-transfer",
        "ibc-go"
    ]
};
module.exports.KYVE_COSMOSTATION_CONFIG = {
    chainId: "",
    restURL: "",
    chainName: "",
    baseDenom: "",
    displayDenom: "",
    addressPrefix: module.exports.PREFIX,
    coinType: module.exports.COIN_TYPE.toString(),
    decimals: 0,
    gasRate: {
        tiny: "1",
        low: "1.5",
        average: "3"
    }
};
module.exports.KYVE_LEAP_CONFIG = {
    rpc: "",
    rest: "",
    chainId: "",
    chainName: "",
    stakeCurrency: {
        coinDenom: "",
        coinMinimalDenom: "",
        coinDecimals: 0
    },
    bip44: {
        coinType: 118
    },
    bech32Config: $3sP6O.Bech32Address.defaultBech32Config("kyve"),
    currencies: [],
    feeCurrencies: [],
    features: [
        "ibc-transfer",
        "ibc-go"
    ]
};

});



parcelRegister("bDDqC", function(module, exports) {
"use strict";
var $8791ebdcbaf32927$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8791ebdcbaf32927$var$__assign = module.exports && module.exports.__assign || function() {
    $8791ebdcbaf32927$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8791ebdcbaf32927$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jVVQx = parcelRequire("jVVQx");

var $eqANf = parcelRequire("eqANf");
var $8791ebdcbaf32927$var$KyveBundlesMethods = /** @class */ function(_super) {
    $8791ebdcbaf32927$var$__extends(KyveBundlesMethods, _super);
    function KyveBundlesMethods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveBundlesMethods.prototype.submitBundleProposal = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.submitBundleProposal($8791ebdcbaf32927$var$__assign($8791ebdcbaf32927$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveBundlesMethods.prototype.voteBundleProposal = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.voteBundleProposal($8791ebdcbaf32927$var$__assign($8791ebdcbaf32927$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveBundlesMethods.prototype.claimUploaderRole = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.claimUploaderRole($8791ebdcbaf32927$var$__assign($8791ebdcbaf32927$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveBundlesMethods.prototype.skipUploaderRole = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.skipUploaderRole($8791ebdcbaf32927$var$__assign($8791ebdcbaf32927$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    return KyveBundlesMethods;
}($eqANf.KyveSigning);
module.exports.default = $8791ebdcbaf32927$var$KyveBundlesMethods;

});
parcelRegister("jVVQx", function(module, exports) {
"use strict";
var $e8303641b75a4853$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.withTypeUrl = module.exports.encodeTxMsg = module.exports.load = module.exports.registry = void 0;

var $fReUp = parcelRequire("fReUp");

var $6Q6nf = parcelRequire("6Q6nf");

var $6Q6nf = parcelRequire("6Q6nf");

var $49ou1 = parcelRequire("49ou1");

var $49ou1 = parcelRequire("49ou1");

var $49ou1 = parcelRequire("49ou1");

var $49ou1 = parcelRequire("49ou1");

var $49ou1 = parcelRequire("49ou1");

var $gRS7H = parcelRequire("gRS7H");

var $gRS7H = parcelRequire("gRS7H");

var $gRS7H = parcelRequire("gRS7H");

var $gRS7H = parcelRequire("gRS7H");

var $gRS7H = parcelRequire("gRS7H");

var $PqUN3 = parcelRequire("PqUN3");

var $PqUN3 = parcelRequire("PqUN3");

var $5sNTy = parcelRequire("5sNTy");

var $g5lMR = parcelRequire("g5lMR");

var $g5lMR = parcelRequire("g5lMR");

var $g5lMR = parcelRequire("g5lMR");

var $g5lMR = parcelRequire("g5lMR");

var $g5lMR = parcelRequire("g5lMR");

var $g5lMR = parcelRequire("g5lMR");

var $fWkcS = parcelRequire("fWkcS");

var $fWkcS = parcelRequire("fWkcS");

var $fWkcS = parcelRequire("fWkcS");

var $fWkcS = parcelRequire("fWkcS");

var $fWkcS = parcelRequire("fWkcS");

var $fWkcS = parcelRequire("fWkcS");

var $1moS2 = parcelRequire("1moS2");

var $1moS2 = parcelRequire("1moS2");
module.exports.registry = $e8303641b75a4853$var$__spreadArray($e8303641b75a4853$var$__spreadArray([], $fReUp.defaultRegistryTypes, true), [
    /**pool **/ [
        "/kyve.pool.v1beta1.MsgCreatePool",
        $g5lMR.MsgCreatePool
    ],
    [
        "/kyve.pool.v1beta1.UpdatePool",
        $g5lMR.MsgUpdatePool
    ],
    [
        "/kyve.pool.v1beta1.MsgDisablePool",
        $g5lMR.MsgDisablePool
    ],
    [
        "/kyve.pool.v1beta1.MsgEnablePool",
        $g5lMR.MsgEnablePool
    ],
    [
        "/kyve.pool.v1beta1.MsgScheduleRuntimeUpgrade",
        $g5lMR.MsgScheduleRuntimeUpgrade
    ],
    [
        "/kyve.pool.v1beta1.MsgCancelRuntimeUpgrade",
        $g5lMR.MsgCancelRuntimeUpgrade
    ],
    /** funders **/ [
        "/kyve.funders.v1beta1.MsgCreateFunder",
        $1moS2.MsgCreateFunder
    ],
    [
        "/kyve.funders.v1beta1.MsgUpdateFunder",
        $1moS2.MsgUpdateFunder
    ],
    [
        "/kyve.funders.v1beta1.MsgFundPool",
        $PqUN3.MsgFundPool
    ],
    [
        "/kyve.funders.v1beta1.MsgDefundPool",
        $PqUN3.MsgDefundPool
    ],
    /** stakers **/ [
        "/kyve.stakers.v1beta1.MsgCreateStaker",
        $fWkcS.MsgCreateStaker
    ],
    [
        "/kyve.stakers.v1beta1.MsgUpdateMetadata",
        $fWkcS.MsgUpdateMetadata
    ],
    [
        "/kyve.stakers.v1beta1.MsgUpdateCommission",
        $fWkcS.MsgUpdateCommission
    ],
    [
        "/kyve.stakers.v1beta1.MsgClaimCommissionRewards",
        $fWkcS.MsgClaimCommissionRewards
    ],
    [
        "/kyve.stakers.v1beta1.MsgJoinPool",
        $fWkcS.MsgJoinPool
    ],
    [
        "/kyve.stakers.v1beta1.MsgLeavePool",
        $fWkcS.MsgLeavePool
    ],
    /** delegations  **/ [
        "/kyve.delegation.v1beta1.MsgDelegate",
        $gRS7H.MsgDelegate
    ],
    [
        "/kyve.delegation.v1beta1.MsgWithdrawRewards",
        $gRS7H.MsgWithdrawRewards
    ],
    [
        "/kyve.delegation.v1beta1.MsgUndelegate",
        $gRS7H.MsgUndelegate
    ],
    [
        "/kyve.delegation.v1beta1.MsgRedelegate",
        $gRS7H.MsgRedelegate
    ],
    /** bundles **/ [
        "/kyve.bundles.v1beta1.MsgSubmitBundleProposal",
        $49ou1.MsgSubmitBundleProposal
    ],
    [
        "/kyve.bundles.v1beta1.MsgVoteBundleProposal",
        $49ou1.MsgVoteBundleProposal
    ],
    [
        "/kyve.bundles.v1beta1.MsgClaimUploaderRole",
        $49ou1.MsgClaimUploaderRole
    ],
    [
        "/kyve.bundles.v1beta1.MsgSkipUploaderRole",
        $49ou1.MsgSkipUploaderRole
    ],
    /** cosmos **/ [
        "/cosmos.gov.v1.MsgSubmitProposal",
        $6Q6nf.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1.MsgVote",
        $6Q6nf.MsgVote
    ]
], false);
var $e8303641b75a4853$var$load = function(protoRegistry) {
    module.exports.registry.forEach(function(_a) {
        var typeUrl = _a[0], mod = _a[1];
        protoRegistry.register(typeUrl, mod);
    });
};
module.exports.load = $e8303641b75a4853$var$load;
module.exports.encodeTxMsg = {
    createFunder: function(value) {
        return {
            type_url: "/kyve.funders.v1beta1.MsgCreateFunder",
            value: $1moS2.MsgCreateFunder.encode(value).finish()
        };
    },
    updateFunder: function(value) {
        return {
            type_url: "/kyve.funders.v1beta1.MsgUpdateFunder",
            value: $1moS2.MsgUpdateFunder.encode(value).finish()
        };
    },
    fundPool: function(value) {
        return {
            type_url: "/kyve.funders.v1beta1.MsgFundPool",
            value: $PqUN3.MsgFundPool.encode(value).finish()
        };
    },
    defundPool: function(value) {
        return {
            type_url: "/kyve.funders.v1beta1.MsgDefundPool",
            value: $PqUN3.MsgDefundPool.encode(value).finish()
        };
    },
    createPool: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgCreatePool",
            value: $g5lMR.MsgCreatePool.encode(value).finish()
        };
    },
    updatePool: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgUpdatePool",
            value: $g5lMR.MsgUpdatePool.encode(value).finish()
        };
    },
    disablePool: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgDisablePool",
            value: $g5lMR.MsgDisablePool.encode(value).finish()
        };
    },
    enablePool: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgEnablePool",
            value: $g5lMR.MsgEnablePool.encode(value).finish()
        };
    },
    scheduleRuntimeUpgrade: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgScheduleRuntimeUpgrade",
            value: $g5lMR.MsgScheduleRuntimeUpgrade.encode(value).finish()
        };
    },
    cancelRuntimeUpgrade: function(value) {
        return {
            type_url: "/kyve.pool.v1beta1.MsgCancelRuntimeUpgrade",
            value: $g5lMR.MsgCancelRuntimeUpgrade.encode(value).finish()
        };
    },
    createStaker: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgCreateStaker",
            value: $fWkcS.MsgCreateStaker.encode(value).finish()
        };
    },
    updateMetadata: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgUpdateMetadata",
            value: $fWkcS.MsgUpdateMetadata.encode(value).finish()
        };
    },
    updateCommission: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgUpdateCommission",
            value: $fWkcS.MsgUpdateCommission.encode(value).finish()
        };
    },
    claimCommissionRewards: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgClaimCommissionRewards",
            value: $fWkcS.MsgClaimCommissionRewards.encode(value).finish()
        };
    },
    joinPool: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgJoinPool",
            value: $fWkcS.MsgJoinPool.encode(value).finish()
        };
    },
    leavePool: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgLeavePool",
            value: $fWkcS.MsgLeavePool.encode(value).finish()
        };
    },
    delegate: function(value) {
        return {
            type_url: "/kyve.delegation.v1beta1.MsgDelegate",
            value: $gRS7H.MsgDelegate.encode(value).finish()
        };
    },
    withdrawRewards: function(value) {
        return {
            type_url: "/kyve.delegation.v1beta1.MsgWithdrawRewards",
            value: $gRS7H.MsgWithdrawRewards.encode(value).finish()
        };
    },
    undelegate: function(value) {
        return {
            type_url: "/kyve.delegation.v1beta1.MsgUndelegate",
            value: $gRS7H.MsgUndelegate.encode(value).finish()
        };
    },
    redelegate: function(value) {
        return {
            type_url: "/kyve.delegation.v1beta1.MsgRedelegate",
            value: $gRS7H.MsgRedelegate.encode(value).finish()
        };
    },
    submitBundleProposal: function(value) {
        return {
            type_url: "/kyve.bundles.v1beta1.MsgSubmitBundleProposal",
            value: $49ou1.MsgSubmitBundleProposal.encode(value).finish()
        };
    },
    voteBundleProposal: function(value) {
        return {
            type_url: "/kyve.bundles.v1beta1.MsgVoteBundleProposal",
            value: $49ou1.MsgVoteBundleProposal.encode(value).finish()
        };
    },
    claimUploaderRole: function(value) {
        return {
            type_url: "/kyve.bundles.v1beta1.MsgClaimUploaderRole",
            value: $49ou1.MsgClaimUploaderRole.encode(value).finish()
        };
    },
    updateParamsStakers: function(value) {
        return {
            type_url: "/kyve.stakers.v1beta1.MsgUpdateParams",
            value: $fWkcS.MsgUpdateParams.encode(value).finish()
        };
    },
    updateParamsDelegation: function(value) {
        return {
            type_url: "/kyve.delegation.v1beta1.MsgUpdateParams",
            value: $gRS7H.MsgUpdateParams.encode(value).finish()
        };
    },
    updateParamsBundles: function(value) {
        return {
            type_url: "/kyve.bundles.v1beta1.MsgUpdateParams",
            value: $49ou1.MsgUpdateParams.encode(value).finish()
        };
    },
    updateParamsGlobal: function(value) {
        return {
            type_url: "/kyve.global.v1beta1.MsgUpdateParams",
            value: $5sNTy.MsgUpdateParams.encode(value).finish()
        };
    }
};
module.exports.withTypeUrl = {
    createFunder: function(value) {
        return {
            typeUrl: "/kyve.funders.v1beta1.MsgCreateFunder",
            value: value
        };
    },
    updateFunder: function(value) {
        return {
            typeUrl: "/kyve.funders.v1beta1.MsgUpdateFunder",
            value: value
        };
    },
    fundPool: function(value) {
        return {
            typeUrl: "/kyve.funders.v1beta1.MsgFundPool",
            value: value
        };
    },
    defundPool: function(value) {
        return {
            typeUrl: "/kyve.funders.v1beta1.MsgDefundPool",
            value: value
        };
    },
    createPool: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgCreatePool",
            value: value
        };
    },
    updatePool: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgUpdatePool",
            value: value
        };
    },
    disablePool: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgDisablePool",
            value: value
        };
    },
    enablePool: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgEnablePool",
            value: value
        };
    },
    scheduleRuntimeUpgrade: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgScheduleRuntimeUpgrade",
            value: value
        };
    },
    cancelRuntimeUpgrade: function(value) {
        return {
            typeUrl: "/kyve.pool.v1beta1.MsgCancelRuntimeUpgrade",
            value: value
        };
    },
    createStaker: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgCreateStaker",
            value: value
        };
    },
    updateMetadata: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgUpdateMetadata",
            value: value
        };
    },
    updateCommission: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgUpdateCommission",
            value: value
        };
    },
    claimCommissionRewards: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgClaimCommissionRewards",
            value: value
        };
    },
    joinPool: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgJoinPool",
            value: value
        };
    },
    leavePool: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgLeavePool",
            value: value
        };
    },
    delegate: function(value) {
        return {
            typeUrl: "/kyve.delegation.v1beta1.MsgDelegate",
            value: value
        };
    },
    withdrawRewards: function(value) {
        return {
            typeUrl: "/kyve.delegation.v1beta1.MsgWithdrawRewards",
            value: value
        };
    },
    undelegate: function(value) {
        return {
            typeUrl: "/kyve.delegation.v1beta1.MsgUndelegate",
            value: value
        };
    },
    redelegate: function(value) {
        return {
            typeUrl: "/kyve.delegation.v1beta1.MsgRedelegate",
            value: value
        };
    },
    submitBundleProposal: function(value) {
        return {
            typeUrl: "/kyve.bundles.v1beta1.MsgSubmitBundleProposal",
            value: value
        };
    },
    voteBundleProposal: function(value) {
        return {
            typeUrl: "/kyve.bundles.v1beta1.MsgVoteBundleProposal",
            value: value
        };
    },
    skipUploaderRole: function(value) {
        return {
            typeUrl: "/kyve.bundles.v1beta1.MsgSkipUploaderRole",
            value: value
        };
    },
    claimUploaderRole: function(value) {
        return {
            typeUrl: "/kyve.bundles.v1beta1.MsgClaimUploaderRole",
            value: value
        };
    },
    updateParamsStakers: function(value) {
        return {
            typeUrl: "/kyve.stakers.v1beta1.MsgUpdateParams",
            value: value
        };
    },
    updateParamsDelegation: function(value) {
        return {
            typeUrl: "/kyve.delegation.v1beta1.MsgUpdateParams",
            value: value
        };
    },
    updateParamsBundles: function(value) {
        return {
            typeUrl: "/kyve.bundles.v1beta1.MsgUpdateParams",
            value: value
        };
    },
    updateParamsGlobal: function(value) {
        return {
            typeUrl: "/kyve.global.v1beta1.MsgUpdateParams",
            value: value
        };
    }
};

});
parcelRegister("6Q6nf", function(module, exports) {
"use strict";
var $4fac8b29b679b260$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgDepositResponse = module.exports.MsgDeposit = module.exports.MsgVoteWeightedResponse = module.exports.MsgVoteWeighted = module.exports.MsgVoteResponse = module.exports.MsgVote = module.exports.MsgExecLegacyContentResponse = module.exports.MsgExecLegacyContent = module.exports.MsgSubmitProposalResponse = module.exports.MsgSubmitProposal = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $4fac8b29b679b260$var$long_1 = $4fac8b29b679b260$var$__importDefault((parcelRequire("3gmZQ")));

var $4fac8b29b679b260$var$minimal_1 = $4fac8b29b679b260$var$__importDefault((parcelRequire("1wC51")));

var $32heM = parcelRequire("32heM");

var $3q31L = parcelRequire("3q31L");

var $iAp74 = parcelRequire("iAp74");
module.exports.protobufPackage = "cosmos.gov.v1";
function $4fac8b29b679b260$var$createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initial_deposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: ""
    };
}
module.exports.MsgSubmitProposal = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        for(var _i = 0, _a = message.messages; _i < _a.length; _i++){
            var v = _a[_i];
            $32heM.Any.encode(v, writer.uint32(10).fork()).ldelim();
        }
        for(var _b = 0, _c = message.initial_deposit; _b < _c.length; _b++){
            var v = _c[_b];
            $3q31L.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.title !== "") writer.uint32(42).string(message.title);
        if (message.summary !== "") writer.uint32(50).string(message.summary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.messages.push($32heM.Any.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.initial_deposit.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.proposer = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.metadata = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.title = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.summary = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            messages: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $32heM.Any.fromJSON(e);
            }) : [],
            initial_deposit: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.initial_deposit) ? object.initial_deposit.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : [],
            proposer: $4fac8b29b679b260$var$isSet(object.proposer) ? globalThis.String(object.proposer) : "",
            metadata: $4fac8b29b679b260$var$isSet(object.metadata) ? globalThis.String(object.metadata) : "",
            title: $4fac8b29b679b260$var$isSet(object.title) ? globalThis.String(object.title) : "",
            summary: $4fac8b29b679b260$var$isSet(object.summary) ? globalThis.String(object.summary) : ""
        };
    },
    toJSON: function(message) {
        var _a, _b;
        var obj = {};
        if ((_a = message.messages) === null || _a === void 0 ? void 0 : _a.length) obj.messages = message.messages.map(function(e) {
            return $32heM.Any.toJSON(e);
        });
        if ((_b = message.initial_deposit) === null || _b === void 0 ? void 0 : _b.length) obj.initial_deposit = message.initial_deposit.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        if (message.proposer !== "") obj.proposer = message.proposer;
        if (message.metadata !== "") obj.metadata = message.metadata;
        if (message.title !== "") obj.title = message.title;
        if (message.summary !== "") obj.summary = message.summary;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSubmitProposal.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $4fac8b29b679b260$var$createBaseMsgSubmitProposal();
        message.messages = ((_a = object.messages) === null || _a === void 0 ? void 0 : _a.map(function(e) {
            return $32heM.Any.fromPartial(e);
        })) || [];
        message.initial_deposit = ((_b = object.initial_deposit) === null || _b === void 0 ? void 0 : _b.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        message.proposer = (_c = object.proposer) !== null && _c !== void 0 ? _c : "";
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : "";
        message.title = (_e = object.title) !== null && _e !== void 0 ? _e : "";
        message.summary = (_f = object.summary) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposal_id: "0"
    };
}
module.exports.MsgSubmitProposalResponse = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $4fac8b29b679b260$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $4fac8b29b679b260$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSubmitProposalResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $4fac8b29b679b260$var$createBaseMsgSubmitProposalResponse();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: ""
    };
}
module.exports.MsgExecLegacyContent = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.content !== undefined) $32heM.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        if (message.authority !== "") writer.uint32(18).string(message.authority);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgExecLegacyContent();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.content = $32heM.Any.decode(reader, reader.uint32());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.authority = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            content: $4fac8b29b679b260$var$isSet(object.content) ? $32heM.Any.fromJSON(object.content) : undefined,
            authority: $4fac8b29b679b260$var$isSet(object.authority) ? globalThis.String(object.authority) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.content !== undefined) obj.content = $32heM.Any.toJSON(message.content);
        if (message.authority !== "") obj.authority = message.authority;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgExecLegacyContent.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $4fac8b29b679b260$var$createBaseMsgExecLegacyContent();
        message.content = object.content !== undefined && object.content !== null ? $32heM.Any.fromPartial(object.content) : undefined;
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgExecLegacyContentResponse() {
    return {};
}
module.exports.MsgExecLegacyContentResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgExecLegacyContentResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgExecLegacyContentResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $4fac8b29b679b260$var$createBaseMsgExecLegacyContentResponse();
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgVote() {
    return {
        proposal_id: "0",
        voter: "",
        option: 0,
        metadata: ""
    };
}
module.exports.MsgVote = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $4fac8b29b679b260$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.voter = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.option = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.metadata = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $4fac8b29b679b260$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0",
            voter: $4fac8b29b679b260$var$isSet(object.voter) ? globalThis.String(object.voter) : "",
            option: $4fac8b29b679b260$var$isSet(object.option) ? (0, $iAp74.voteOptionFromJSON)(object.option) : 0,
            metadata: $4fac8b29b679b260$var$isSet(object.metadata) ? globalThis.String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        if (message.voter !== "") obj.voter = message.voter;
        if (message.option !== 0) obj.option = (0, $iAp74.voteOptionToJSON)(message.option);
        if (message.metadata !== "") obj.metadata = message.metadata;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVote.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $4fac8b29b679b260$var$createBaseMsgVote();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.option = (_c = object.option) !== null && _c !== void 0 ? _c : 0;
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgVoteResponse() {
    return {};
}
module.exports.MsgVoteResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVoteResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $4fac8b29b679b260$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgVoteWeighted() {
    return {
        proposal_id: "0",
        voter: "",
        options: [],
        metadata: ""
    };
}
module.exports.MsgVoteWeighted = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for(var _i = 0, _a = message.options; _i < _a.length; _i++){
            var v = _a[_i];
            $iAp74.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        }
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $4fac8b29b679b260$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.voter = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.options.push($iAp74.WeightedVoteOption.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.metadata = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $4fac8b29b679b260$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0",
            voter: $4fac8b29b679b260$var$isSet(object.voter) ? globalThis.String(object.voter) : "",
            options: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return $iAp74.WeightedVoteOption.fromJSON(e);
            }) : [],
            metadata: $4fac8b29b679b260$var$isSet(object.metadata) ? globalThis.String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        if (message.voter !== "") obj.voter = message.voter;
        if ((_a = message.options) === null || _a === void 0 ? void 0 : _a.length) obj.options = message.options.map(function(e) {
            return $iAp74.WeightedVoteOption.toJSON(e);
        });
        if (message.metadata !== "") obj.metadata = message.metadata;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVoteWeighted.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $4fac8b29b679b260$var$createBaseMsgVoteWeighted();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map(function(e) {
            return $iAp74.WeightedVoteOption.fromPartial(e);
        })) || [];
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
module.exports.MsgVoteWeightedResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVoteWeightedResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $4fac8b29b679b260$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgDeposit() {
    return {
        proposal_id: "0",
        depositor: "",
        amount: []
    };
}
module.exports.MsgDeposit = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for(var _i = 0, _a = message.amount; _i < _a.length; _i++){
            var v = _a[_i];
            $3q31L.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $4fac8b29b679b260$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.depositor = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.amount.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $4fac8b29b679b260$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0",
            depositor: $4fac8b29b679b260$var$isSet(object.depositor) ? globalThis.String(object.depositor) : "",
            amount: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        if (message.depositor !== "") obj.depositor = message.depositor;
        if ((_a = message.amount) === null || _a === void 0 ? void 0 : _a.length) obj.amount = message.amount.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDeposit.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $4fac8b29b679b260$var$createBaseMsgDeposit();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgDepositResponse() {
    return {};
}
module.exports.MsgDepositResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDepositResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $4fac8b29b679b260$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $iAp74.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.params = $iAp74.Params.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $4fac8b29b679b260$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            params: $4fac8b29b679b260$var$isSet(object.params) ? $iAp74.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.params !== undefined) obj.params = $iAp74.Params.toJSON(message.params);
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $4fac8b29b679b260$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.params = object.params !== undefined && object.params !== null ? $iAp74.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $4fac8b29b679b260$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $4fac8b29b679b260$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $4fac8b29b679b260$var$minimal_1.default.Reader ? input : $4fac8b29b679b260$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $4fac8b29b679b260$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $4fac8b29b679b260$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "cosmos.gov.v1.Msg";
var $4fac8b29b679b260$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.SubmitProposal = function(request) {
        var data = module.exports.MsgSubmitProposal.encode(request).finish();
        var promise = this.rpc.request(this.service, "SubmitProposal", data);
        return promise.then(function(data) {
            return module.exports.MsgSubmitProposalResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.ExecLegacyContent = function(request) {
        var data = module.exports.MsgExecLegacyContent.encode(request).finish();
        var promise = this.rpc.request(this.service, "ExecLegacyContent", data);
        return promise.then(function(data) {
            return module.exports.MsgExecLegacyContentResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.Vote = function(request) {
        var data = module.exports.MsgVote.encode(request).finish();
        var promise = this.rpc.request(this.service, "Vote", data);
        return promise.then(function(data) {
            return module.exports.MsgVoteResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.VoteWeighted = function(request) {
        var data = module.exports.MsgVoteWeighted.encode(request).finish();
        var promise = this.rpc.request(this.service, "VoteWeighted", data);
        return promise.then(function(data) {
            return module.exports.MsgVoteWeightedResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.Deposit = function(request) {
        var data = module.exports.MsgDeposit.encode(request).finish();
        var promise = this.rpc.request(this.service, "Deposit", data);
        return promise.then(function(data) {
            return module.exports.MsgDepositResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($4fac8b29b679b260$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $4fac8b29b679b260$var$MsgClientImpl;
function $4fac8b29b679b260$var$longToString(long) {
    return long.toString();
}
if ($4fac8b29b679b260$var$minimal_1.default.util.Long !== $4fac8b29b679b260$var$long_1.default) {
    $4fac8b29b679b260$var$minimal_1.default.util.Long = $4fac8b29b679b260$var$long_1.default;
    $4fac8b29b679b260$var$minimal_1.default.configure();
}
function $4fac8b29b679b260$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("32heM", function(module, exports) {
"use strict";
var $235eedfe8cbdfb7e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Any = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $235eedfe8cbdfb7e$var$minimal_1 = $235eedfe8cbdfb7e$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $235eedfe8cbdfb7e$var$createBaseAny() {
    return {
        type_url: "",
        value: new Uint8Array(0)
    };
}
module.exports.Any = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $235eedfe8cbdfb7e$var$minimal_1.default.Writer.create();
        if (message.type_url !== "") writer.uint32(10).string(message.type_url);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $235eedfe8cbdfb7e$var$minimal_1.default.Reader ? input : $235eedfe8cbdfb7e$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $235eedfe8cbdfb7e$var$createBaseAny();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.type_url = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.value = reader.bytes();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            type_url: $235eedfe8cbdfb7e$var$isSet(object.type_url) ? globalThis.String(object.type_url) : "",
            value: $235eedfe8cbdfb7e$var$isSet(object.value) ? $235eedfe8cbdfb7e$var$bytesFromBase64(object.value) : new Uint8Array(0)
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.type_url !== "") obj.type_url = message.type_url;
        if (message.value.length !== 0) obj.value = $235eedfe8cbdfb7e$var$base64FromBytes(message.value);
        return obj;
    },
    create: function(base) {
        return module.exports.Any.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $235eedfe8cbdfb7e$var$createBaseAny();
        message.type_url = (_a = object.type_url) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array(0);
        return message;
    }
};
function $235eedfe8cbdfb7e$var$bytesFromBase64(b64) {
    if (globalThis.Buffer) return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    else {
        var bin = globalThis.atob(b64);
        var arr = new Uint8Array(bin.length);
        for(var i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $235eedfe8cbdfb7e$var$base64FromBytes(arr) {
    if (globalThis.Buffer) return globalThis.Buffer.from(arr).toString("base64");
    else {
        var bin_1 = [];
        arr.forEach(function(byte) {
            bin_1.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin_1.join(""));
    }
}
function $235eedfe8cbdfb7e$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("3q31L", function(module, exports) {
"use strict";
var $27d625fcc2b30c16$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecProto = module.exports.IntProto = module.exports.DecCoin = module.exports.Coin = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $27d625fcc2b30c16$var$minimal_1 = $27d625fcc2b30c16$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "cosmos.base.v1beta1";
function $27d625fcc2b30c16$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.Coin = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $27d625fcc2b30c16$var$minimal_1.default.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $27d625fcc2b30c16$var$minimal_1.default.Reader ? input : $27d625fcc2b30c16$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $27d625fcc2b30c16$var$createBaseCoin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.denom = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.amount = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: $27d625fcc2b30c16$var$isSet(object.denom) ? globalThis.String(object.denom) : "",
            amount: $27d625fcc2b30c16$var$isSet(object.amount) ? globalThis.String(object.amount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.denom !== "") obj.denom = message.denom;
        if (message.amount !== "") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.Coin.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $27d625fcc2b30c16$var$createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $27d625fcc2b30c16$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
module.exports.DecCoin = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $27d625fcc2b30c16$var$minimal_1.default.Writer.create();
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $27d625fcc2b30c16$var$minimal_1.default.Reader ? input : $27d625fcc2b30c16$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $27d625fcc2b30c16$var$createBaseDecCoin();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.denom = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.amount = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            denom: $27d625fcc2b30c16$var$isSet(object.denom) ? globalThis.String(object.denom) : "",
            amount: $27d625fcc2b30c16$var$isSet(object.amount) ? globalThis.String(object.amount) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.denom !== "") obj.denom = message.denom;
        if (message.amount !== "") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.DecCoin.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $27d625fcc2b30c16$var$createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $27d625fcc2b30c16$var$createBaseIntProto() {
    return {
        int: ""
    };
}
module.exports.IntProto = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $27d625fcc2b30c16$var$minimal_1.default.Writer.create();
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $27d625fcc2b30c16$var$minimal_1.default.Reader ? input : $27d625fcc2b30c16$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $27d625fcc2b30c16$var$createBaseIntProto();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.int = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            int: $27d625fcc2b30c16$var$isSet(object.int) ? globalThis.String(object.int) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.int !== "") obj.int = message.int;
        return obj;
    },
    create: function(base) {
        return module.exports.IntProto.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $27d625fcc2b30c16$var$createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $27d625fcc2b30c16$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
module.exports.DecProto = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $27d625fcc2b30c16$var$minimal_1.default.Writer.create();
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $27d625fcc2b30c16$var$minimal_1.default.Reader ? input : $27d625fcc2b30c16$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $27d625fcc2b30c16$var$createBaseDecProto();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.dec = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            dec: $27d625fcc2b30c16$var$isSet(object.dec) ? globalThis.String(object.dec) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.dec !== "") obj.dec = message.dec;
        return obj;
    },
    create: function(base) {
        return module.exports.DecProto.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $27d625fcc2b30c16$var$createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $27d625fcc2b30c16$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("iAp74", function(module, exports) {
"use strict";
var $d87f11b85fb876bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = module.exports.TallyParams = module.exports.VotingParams = module.exports.DepositParams = module.exports.Vote = module.exports.TallyResult = module.exports.Proposal = module.exports.Deposit = module.exports.WeightedVoteOption = module.exports.proposalStatusToJSON = module.exports.proposalStatusFromJSON = module.exports.ProposalStatus = module.exports.voteOptionToJSON = module.exports.voteOptionFromJSON = module.exports.VoteOption = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $d87f11b85fb876bf$var$long_1 = $d87f11b85fb876bf$var$__importDefault((parcelRequire("3gmZQ")));

var $d87f11b85fb876bf$var$minimal_1 = $d87f11b85fb876bf$var$__importDefault((parcelRequire("1wC51")));

var $32heM = parcelRequire("32heM");

var $jhpuS = parcelRequire("jhpuS");

var $5yNOH = parcelRequire("5yNOH");

var $3q31L = parcelRequire("3q31L");
module.exports.protobufPackage = "cosmos.gov.v1";
/** Since: cosmos-sdk 0.46 */ /** VoteOption enumerates the valid vote options for a given governance proposal. */ var $d87f11b85fb876bf$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d87f11b85fb876bf$var$VoteOption = module.exports.VoteOption || (module.exports.VoteOption = {}));
function $d87f11b85fb876bf$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d87f11b85fb876bf$var$VoteOption.UNRECOGNIZED;
    }
}
module.exports.voteOptionFromJSON = $d87f11b85fb876bf$var$voteOptionFromJSON;
function $d87f11b85fb876bf$var$voteOptionToJSON(object) {
    switch(object){
        case $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $d87f11b85fb876bf$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $d87f11b85fb876bf$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteOptionToJSON = $d87f11b85fb876bf$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $d87f11b85fb876bf$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($d87f11b85fb876bf$var$ProposalStatus = module.exports.ProposalStatus || (module.exports.ProposalStatus = {}));
function $d87f11b85fb876bf$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $d87f11b85fb876bf$var$ProposalStatus.UNRECOGNIZED;
    }
}
module.exports.proposalStatusFromJSON = $d87f11b85fb876bf$var$proposalStatusFromJSON;
function $d87f11b85fb876bf$var$proposalStatusToJSON(object) {
    switch(object){
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $d87f11b85fb876bf$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $d87f11b85fb876bf$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.proposalStatusToJSON = $d87f11b85fb876bf$var$proposalStatusToJSON;
function $d87f11b85fb876bf$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
module.exports.WeightedVoteOption = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.option = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.weight = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            option: $d87f11b85fb876bf$var$isSet(object.option) ? $d87f11b85fb876bf$var$voteOptionFromJSON(object.option) : 0,
            weight: $d87f11b85fb876bf$var$isSet(object.weight) ? globalThis.String(object.weight) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.option !== 0) obj.option = $d87f11b85fb876bf$var$voteOptionToJSON(message.option);
        if (message.weight !== "") obj.weight = message.weight;
        return obj;
    },
    create: function(base) {
        return module.exports.WeightedVoteOption.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $d87f11b85fb876bf$var$createBaseWeightedVoteOption();
        message.option = (_a = object.option) !== null && _a !== void 0 ? _a : 0;
        message.weight = (_b = object.weight) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseDeposit() {
    return {
        proposal_id: "0",
        depositor: "",
        amount: []
    };
}
module.exports.Deposit = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for(var _i = 0, _a = message.amount; _i < _a.length; _i++){
            var v = _a[_i];
            $3q31L.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseDeposit();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $d87f11b85fb876bf$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.depositor = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.amount.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $d87f11b85fb876bf$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0",
            depositor: $d87f11b85fb876bf$var$isSet(object.depositor) ? globalThis.String(object.depositor) : "",
            amount: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.amount) ? object.amount.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : []
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        if (message.depositor !== "") obj.depositor = message.depositor;
        if ((_a = message.amount) === null || _a === void 0 ? void 0 : _a.length) obj.amount = message.amount.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        return obj;
    },
    create: function(base) {
        return module.exports.Deposit.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $d87f11b85fb876bf$var$createBaseDeposit();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        message.depositor = (_b = object.depositor) !== null && _b !== void 0 ? _b : "";
        message.amount = ((_c = object.amount) === null || _c === void 0 ? void 0 : _c.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseProposal() {
    return {
        id: "0",
        messages: [],
        status: 0,
        final_tally_result: undefined,
        submit_time: undefined,
        deposit_end_time: undefined,
        total_deposit: [],
        voting_start_time: undefined,
        voting_end_time: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: ""
    };
}
module.exports.Proposal = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.id !== "0") writer.uint32(8).uint64(message.id);
        for(var _i = 0, _a = message.messages; _i < _a.length; _i++){
            var v = _a[_i];
            $32heM.Any.encode(v, writer.uint32(18).fork()).ldelim();
        }
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.final_tally_result !== undefined) module.exports.TallyResult.encode(message.final_tally_result, writer.uint32(34).fork()).ldelim();
        if (message.submit_time !== undefined) $5yNOH.Timestamp.encode($d87f11b85fb876bf$var$toTimestamp(message.submit_time), writer.uint32(42).fork()).ldelim();
        if (message.deposit_end_time !== undefined) $5yNOH.Timestamp.encode($d87f11b85fb876bf$var$toTimestamp(message.deposit_end_time), writer.uint32(50).fork()).ldelim();
        for(var _b = 0, _c = message.total_deposit; _b < _c.length; _b++){
            var v = _c[_b];
            $3q31L.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        }
        if (message.voting_start_time !== undefined) $5yNOH.Timestamp.encode($d87f11b85fb876bf$var$toTimestamp(message.voting_start_time), writer.uint32(66).fork()).ldelim();
        if (message.voting_end_time !== undefined) $5yNOH.Timestamp.encode($d87f11b85fb876bf$var$toTimestamp(message.voting_end_time), writer.uint32(74).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(82).string(message.metadata);
        if (message.title !== "") writer.uint32(90).string(message.title);
        if (message.summary !== "") writer.uint32(98).string(message.summary);
        if (message.proposer !== "") writer.uint32(106).string(message.proposer);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.id = $d87f11b85fb876bf$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.messages.push($32heM.Any.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.status = reader.int32();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.final_tally_result = module.exports.TallyResult.decode(reader, reader.uint32());
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.submit_time = $d87f11b85fb876bf$var$fromTimestamp($5yNOH.Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.deposit_end_time = $d87f11b85fb876bf$var$fromTimestamp($5yNOH.Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 7:
                    if (tag !== 58) break;
                    message.total_deposit.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) break;
                    message.voting_start_time = $d87f11b85fb876bf$var$fromTimestamp($5yNOH.Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 9:
                    if (tag !== 74) break;
                    message.voting_end_time = $d87f11b85fb876bf$var$fromTimestamp($5yNOH.Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 10:
                    if (tag !== 82) break;
                    message.metadata = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) break;
                    message.title = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) break;
                    message.summary = reader.string();
                    continue;
                case 13:
                    if (tag !== 106) break;
                    message.proposer = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            id: $d87f11b85fb876bf$var$isSet(object.id) ? globalThis.String(object.id) : "0",
            messages: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.messages) ? object.messages.map(function(e) {
                return $32heM.Any.fromJSON(e);
            }) : [],
            status: $d87f11b85fb876bf$var$isSet(object.status) ? $d87f11b85fb876bf$var$proposalStatusFromJSON(object.status) : 0,
            final_tally_result: $d87f11b85fb876bf$var$isSet(object.final_tally_result) ? module.exports.TallyResult.fromJSON(object.final_tally_result) : undefined,
            submit_time: $d87f11b85fb876bf$var$isSet(object.submit_time) ? $d87f11b85fb876bf$var$fromJsonTimestamp(object.submit_time) : undefined,
            deposit_end_time: $d87f11b85fb876bf$var$isSet(object.deposit_end_time) ? $d87f11b85fb876bf$var$fromJsonTimestamp(object.deposit_end_time) : undefined,
            total_deposit: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.total_deposit) ? object.total_deposit.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : [],
            voting_start_time: $d87f11b85fb876bf$var$isSet(object.voting_start_time) ? $d87f11b85fb876bf$var$fromJsonTimestamp(object.voting_start_time) : undefined,
            voting_end_time: $d87f11b85fb876bf$var$isSet(object.voting_end_time) ? $d87f11b85fb876bf$var$fromJsonTimestamp(object.voting_end_time) : undefined,
            metadata: $d87f11b85fb876bf$var$isSet(object.metadata) ? globalThis.String(object.metadata) : "",
            title: $d87f11b85fb876bf$var$isSet(object.title) ? globalThis.String(object.title) : "",
            summary: $d87f11b85fb876bf$var$isSet(object.summary) ? globalThis.String(object.summary) : "",
            proposer: $d87f11b85fb876bf$var$isSet(object.proposer) ? globalThis.String(object.proposer) : ""
        };
    },
    toJSON: function(message) {
        var _a, _b;
        var obj = {};
        if (message.id !== "0") obj.id = message.id;
        if ((_a = message.messages) === null || _a === void 0 ? void 0 : _a.length) obj.messages = message.messages.map(function(e) {
            return $32heM.Any.toJSON(e);
        });
        if (message.status !== 0) obj.status = $d87f11b85fb876bf$var$proposalStatusToJSON(message.status);
        if (message.final_tally_result !== undefined) obj.final_tally_result = module.exports.TallyResult.toJSON(message.final_tally_result);
        if (message.submit_time !== undefined) obj.submit_time = message.submit_time.toISOString();
        if (message.deposit_end_time !== undefined) obj.deposit_end_time = message.deposit_end_time.toISOString();
        if ((_b = message.total_deposit) === null || _b === void 0 ? void 0 : _b.length) obj.total_deposit = message.total_deposit.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        if (message.voting_start_time !== undefined) obj.voting_start_time = message.voting_start_time.toISOString();
        if (message.voting_end_time !== undefined) obj.voting_end_time = message.voting_end_time.toISOString();
        if (message.metadata !== "") obj.metadata = message.metadata;
        if (message.title !== "") obj.title = message.title;
        if (message.summary !== "") obj.summary = message.summary;
        if (message.proposer !== "") obj.proposer = message.proposer;
        return obj;
    },
    create: function(base) {
        return module.exports.Proposal.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var message = $d87f11b85fb876bf$var$createBaseProposal();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "0";
        message.messages = ((_b = object.messages) === null || _b === void 0 ? void 0 : _b.map(function(e) {
            return $32heM.Any.fromPartial(e);
        })) || [];
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : 0;
        message.final_tally_result = object.final_tally_result !== undefined && object.final_tally_result !== null ? module.exports.TallyResult.fromPartial(object.final_tally_result) : undefined;
        message.submit_time = (_d = object.submit_time) !== null && _d !== void 0 ? _d : undefined;
        message.deposit_end_time = (_e = object.deposit_end_time) !== null && _e !== void 0 ? _e : undefined;
        message.total_deposit = ((_f = object.total_deposit) === null || _f === void 0 ? void 0 : _f.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        message.voting_start_time = (_g = object.voting_start_time) !== null && _g !== void 0 ? _g : undefined;
        message.voting_end_time = (_h = object.voting_end_time) !== null && _h !== void 0 ? _h : undefined;
        message.metadata = (_j = object.metadata) !== null && _j !== void 0 ? _j : "";
        message.title = (_k = object.title) !== null && _k !== void 0 ? _k : "";
        message.summary = (_l = object.summary) !== null && _l !== void 0 ? _l : "";
        message.proposer = (_m = object.proposer) !== null && _m !== void 0 ? _m : "";
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseTallyResult() {
    return {
        yes_count: "",
        abstain_count: "",
        no_count: "",
        no_with_veto_count: ""
    };
}
module.exports.TallyResult = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.yes_count !== "") writer.uint32(10).string(message.yes_count);
        if (message.abstain_count !== "") writer.uint32(18).string(message.abstain_count);
        if (message.no_count !== "") writer.uint32(26).string(message.no_count);
        if (message.no_with_veto_count !== "") writer.uint32(34).string(message.no_with_veto_count);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseTallyResult();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.yes_count = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.abstain_count = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.no_count = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.no_with_veto_count = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            yes_count: $d87f11b85fb876bf$var$isSet(object.yes_count) ? globalThis.String(object.yes_count) : "",
            abstain_count: $d87f11b85fb876bf$var$isSet(object.abstain_count) ? globalThis.String(object.abstain_count) : "",
            no_count: $d87f11b85fb876bf$var$isSet(object.no_count) ? globalThis.String(object.no_count) : "",
            no_with_veto_count: $d87f11b85fb876bf$var$isSet(object.no_with_veto_count) ? globalThis.String(object.no_with_veto_count) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.yes_count !== "") obj.yes_count = message.yes_count;
        if (message.abstain_count !== "") obj.abstain_count = message.abstain_count;
        if (message.no_count !== "") obj.no_count = message.no_count;
        if (message.no_with_veto_count !== "") obj.no_with_veto_count = message.no_with_veto_count;
        return obj;
    },
    create: function(base) {
        return module.exports.TallyResult.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $d87f11b85fb876bf$var$createBaseTallyResult();
        message.yes_count = (_a = object.yes_count) !== null && _a !== void 0 ? _a : "";
        message.abstain_count = (_b = object.abstain_count) !== null && _b !== void 0 ? _b : "";
        message.no_count = (_c = object.no_count) !== null && _c !== void 0 ? _c : "";
        message.no_with_veto_count = (_d = object.no_with_veto_count) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseVote() {
    return {
        proposal_id: "0",
        voter: "",
        options: [],
        metadata: ""
    };
}
module.exports.Vote = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.proposal_id !== "0") writer.uint32(8).uint64(message.proposal_id);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for(var _i = 0, _a = message.options; _i < _a.length; _i++){
            var v = _a[_i];
            module.exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.metadata !== "") writer.uint32(42).string(message.metadata);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseVote();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.proposal_id = $d87f11b85fb876bf$var$longToString(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.voter = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.options.push(module.exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.metadata = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            proposal_id: $d87f11b85fb876bf$var$isSet(object.proposal_id) ? globalThis.String(object.proposal_id) : "0",
            voter: $d87f11b85fb876bf$var$isSet(object.voter) ? globalThis.String(object.voter) : "",
            options: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.options) ? object.options.map(function(e) {
                return module.exports.WeightedVoteOption.fromJSON(e);
            }) : [],
            metadata: $d87f11b85fb876bf$var$isSet(object.metadata) ? globalThis.String(object.metadata) : ""
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if (message.proposal_id !== "0") obj.proposal_id = message.proposal_id;
        if (message.voter !== "") obj.voter = message.voter;
        if ((_a = message.options) === null || _a === void 0 ? void 0 : _a.length) obj.options = message.options.map(function(e) {
            return module.exports.WeightedVoteOption.toJSON(e);
        });
        if (message.metadata !== "") obj.metadata = message.metadata;
        return obj;
    },
    create: function(base) {
        return module.exports.Vote.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $d87f11b85fb876bf$var$createBaseVote();
        message.proposal_id = (_a = object.proposal_id) !== null && _a !== void 0 ? _a : "0";
        message.voter = (_b = object.voter) !== null && _b !== void 0 ? _b : "";
        message.options = ((_c = object.options) === null || _c === void 0 ? void 0 : _c.map(function(e) {
            return module.exports.WeightedVoteOption.fromPartial(e);
        })) || [];
        message.metadata = (_d = object.metadata) !== null && _d !== void 0 ? _d : "";
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseDepositParams() {
    return {
        min_deposit: [],
        max_deposit_period: undefined
    };
}
module.exports.DepositParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        for(var _i = 0, _a = message.min_deposit; _i < _a.length; _i++){
            var v = _a[_i];
            $3q31L.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.max_deposit_period !== undefined) $jhpuS.Duration.encode(message.max_deposit_period, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseDepositParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.min_deposit.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.max_deposit_period = $jhpuS.Duration.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            min_deposit: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.min_deposit) ? object.min_deposit.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : [],
            max_deposit_period: $d87f11b85fb876bf$var$isSet(object.max_deposit_period) ? $jhpuS.Duration.fromJSON(object.max_deposit_period) : undefined
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if ((_a = message.min_deposit) === null || _a === void 0 ? void 0 : _a.length) obj.min_deposit = message.min_deposit.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        if (message.max_deposit_period !== undefined) obj.max_deposit_period = $jhpuS.Duration.toJSON(message.max_deposit_period);
        return obj;
    },
    create: function(base) {
        return module.exports.DepositParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a;
        var message = $d87f11b85fb876bf$var$createBaseDepositParams();
        message.min_deposit = ((_a = object.min_deposit) === null || _a === void 0 ? void 0 : _a.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        message.max_deposit_period = object.max_deposit_period !== undefined && object.max_deposit_period !== null ? $jhpuS.Duration.fromPartial(object.max_deposit_period) : undefined;
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseVotingParams() {
    return {
        voting_period: undefined
    };
}
module.exports.VotingParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.voting_period !== undefined) $jhpuS.Duration.encode(message.voting_period, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseVotingParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.voting_period = $jhpuS.Duration.decode(reader, reader.uint32());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            voting_period: $d87f11b85fb876bf$var$isSet(object.voting_period) ? $jhpuS.Duration.fromJSON(object.voting_period) : undefined
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.voting_period !== undefined) obj.voting_period = $jhpuS.Duration.toJSON(message.voting_period);
        return obj;
    },
    create: function(base) {
        return module.exports.VotingParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var message = $d87f11b85fb876bf$var$createBaseVotingParams();
        message.voting_period = object.voting_period !== undefined && object.voting_period !== null ? $jhpuS.Duration.fromPartial(object.voting_period) : undefined;
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        veto_threshold: ""
    };
}
module.exports.TallyParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        if (message.quorum !== "") writer.uint32(10).string(message.quorum);
        if (message.threshold !== "") writer.uint32(18).string(message.threshold);
        if (message.veto_threshold !== "") writer.uint32(26).string(message.veto_threshold);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseTallyParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.quorum = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.threshold = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.veto_threshold = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            quorum: $d87f11b85fb876bf$var$isSet(object.quorum) ? globalThis.String(object.quorum) : "",
            threshold: $d87f11b85fb876bf$var$isSet(object.threshold) ? globalThis.String(object.threshold) : "",
            veto_threshold: $d87f11b85fb876bf$var$isSet(object.veto_threshold) ? globalThis.String(object.veto_threshold) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.quorum !== "") obj.quorum = message.quorum;
        if (message.threshold !== "") obj.threshold = message.threshold;
        if (message.veto_threshold !== "") obj.veto_threshold = message.veto_threshold;
        return obj;
    },
    create: function(base) {
        return module.exports.TallyParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $d87f11b85fb876bf$var$createBaseTallyParams();
        message.quorum = (_a = object.quorum) !== null && _a !== void 0 ? _a : "";
        message.threshold = (_b = object.threshold) !== null && _b !== void 0 ? _b : "";
        message.veto_threshold = (_c = object.veto_threshold) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $d87f11b85fb876bf$var$createBaseParams() {
    return {
        min_deposit: [],
        max_deposit_period: undefined,
        voting_period: undefined,
        quorum: "",
        threshold: "",
        veto_threshold: "",
        min_initial_deposit_ratio: "",
        burn_vote_quorum: false,
        burn_proposal_deposit_prevote: false,
        burn_vote_veto: false
    };
}
module.exports.Params = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $d87f11b85fb876bf$var$minimal_1.default.Writer.create();
        for(var _i = 0, _a = message.min_deposit; _i < _a.length; _i++){
            var v = _a[_i];
            $3q31L.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.max_deposit_period !== undefined) $jhpuS.Duration.encode(message.max_deposit_period, writer.uint32(18).fork()).ldelim();
        if (message.voting_period !== undefined) $jhpuS.Duration.encode(message.voting_period, writer.uint32(26).fork()).ldelim();
        if (message.quorum !== "") writer.uint32(34).string(message.quorum);
        if (message.threshold !== "") writer.uint32(42).string(message.threshold);
        if (message.veto_threshold !== "") writer.uint32(50).string(message.veto_threshold);
        if (message.min_initial_deposit_ratio !== "") writer.uint32(58).string(message.min_initial_deposit_ratio);
        if (message.burn_vote_quorum === true) writer.uint32(104).bool(message.burn_vote_quorum);
        if (message.burn_proposal_deposit_prevote === true) writer.uint32(112).bool(message.burn_proposal_deposit_prevote);
        if (message.burn_vote_veto === true) writer.uint32(120).bool(message.burn_vote_veto);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $d87f11b85fb876bf$var$minimal_1.default.Reader ? input : $d87f11b85fb876bf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $d87f11b85fb876bf$var$createBaseParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.min_deposit.push($3q31L.Coin.decode(reader, reader.uint32()));
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.max_deposit_period = $jhpuS.Duration.decode(reader, reader.uint32());
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.voting_period = $jhpuS.Duration.decode(reader, reader.uint32());
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.quorum = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.threshold = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.veto_threshold = reader.string();
                    continue;
                case 7:
                    if (tag !== 58) break;
                    message.min_initial_deposit_ratio = reader.string();
                    continue;
                case 13:
                    if (tag !== 104) break;
                    message.burn_vote_quorum = reader.bool();
                    continue;
                case 14:
                    if (tag !== 112) break;
                    message.burn_proposal_deposit_prevote = reader.bool();
                    continue;
                case 15:
                    if (tag !== 120) break;
                    message.burn_vote_veto = reader.bool();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            min_deposit: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.min_deposit) ? object.min_deposit.map(function(e) {
                return $3q31L.Coin.fromJSON(e);
            }) : [],
            max_deposit_period: $d87f11b85fb876bf$var$isSet(object.max_deposit_period) ? $jhpuS.Duration.fromJSON(object.max_deposit_period) : undefined,
            voting_period: $d87f11b85fb876bf$var$isSet(object.voting_period) ? $jhpuS.Duration.fromJSON(object.voting_period) : undefined,
            quorum: $d87f11b85fb876bf$var$isSet(object.quorum) ? globalThis.String(object.quorum) : "",
            threshold: $d87f11b85fb876bf$var$isSet(object.threshold) ? globalThis.String(object.threshold) : "",
            veto_threshold: $d87f11b85fb876bf$var$isSet(object.veto_threshold) ? globalThis.String(object.veto_threshold) : "",
            min_initial_deposit_ratio: $d87f11b85fb876bf$var$isSet(object.min_initial_deposit_ratio) ? globalThis.String(object.min_initial_deposit_ratio) : "",
            burn_vote_quorum: $d87f11b85fb876bf$var$isSet(object.burn_vote_quorum) ? globalThis.Boolean(object.burn_vote_quorum) : false,
            burn_proposal_deposit_prevote: $d87f11b85fb876bf$var$isSet(object.burn_proposal_deposit_prevote) ? globalThis.Boolean(object.burn_proposal_deposit_prevote) : false,
            burn_vote_veto: $d87f11b85fb876bf$var$isSet(object.burn_vote_veto) ? globalThis.Boolean(object.burn_vote_veto) : false
        };
    },
    toJSON: function(message) {
        var _a;
        var obj = {};
        if ((_a = message.min_deposit) === null || _a === void 0 ? void 0 : _a.length) obj.min_deposit = message.min_deposit.map(function(e) {
            return $3q31L.Coin.toJSON(e);
        });
        if (message.max_deposit_period !== undefined) obj.max_deposit_period = $jhpuS.Duration.toJSON(message.max_deposit_period);
        if (message.voting_period !== undefined) obj.voting_period = $jhpuS.Duration.toJSON(message.voting_period);
        if (message.quorum !== "") obj.quorum = message.quorum;
        if (message.threshold !== "") obj.threshold = message.threshold;
        if (message.veto_threshold !== "") obj.veto_threshold = message.veto_threshold;
        if (message.min_initial_deposit_ratio !== "") obj.min_initial_deposit_ratio = message.min_initial_deposit_ratio;
        if (message.burn_vote_quorum === true) obj.burn_vote_quorum = message.burn_vote_quorum;
        if (message.burn_proposal_deposit_prevote === true) obj.burn_proposal_deposit_prevote = message.burn_proposal_deposit_prevote;
        if (message.burn_vote_veto === true) obj.burn_vote_veto = message.burn_vote_veto;
        return obj;
    },
    create: function(base) {
        return module.exports.Params.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var message = $d87f11b85fb876bf$var$createBaseParams();
        message.min_deposit = ((_a = object.min_deposit) === null || _a === void 0 ? void 0 : _a.map(function(e) {
            return $3q31L.Coin.fromPartial(e);
        })) || [];
        message.max_deposit_period = object.max_deposit_period !== undefined && object.max_deposit_period !== null ? $jhpuS.Duration.fromPartial(object.max_deposit_period) : undefined;
        message.voting_period = object.voting_period !== undefined && object.voting_period !== null ? $jhpuS.Duration.fromPartial(object.voting_period) : undefined;
        message.quorum = (_b = object.quorum) !== null && _b !== void 0 ? _b : "";
        message.threshold = (_c = object.threshold) !== null && _c !== void 0 ? _c : "";
        message.veto_threshold = (_d = object.veto_threshold) !== null && _d !== void 0 ? _d : "";
        message.min_initial_deposit_ratio = (_e = object.min_initial_deposit_ratio) !== null && _e !== void 0 ? _e : "";
        message.burn_vote_quorum = (_f = object.burn_vote_quorum) !== null && _f !== void 0 ? _f : false;
        message.burn_proposal_deposit_prevote = (_g = object.burn_proposal_deposit_prevote) !== null && _g !== void 0 ? _g : false;
        message.burn_vote_veto = (_h = object.burn_vote_veto) !== null && _h !== void 0 ? _h : false;
        return message;
    }
};
function $d87f11b85fb876bf$var$toTimestamp(date) {
    var seconds = Math.trunc(date.getTime() / 1000).toString();
    var nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
function $d87f11b85fb876bf$var$fromTimestamp(t) {
    var millis = (globalThis.Number(t.seconds) || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function $d87f11b85fb876bf$var$fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) return o;
    else if (typeof o === "string") return new globalThis.Date(o);
    else return $d87f11b85fb876bf$var$fromTimestamp($5yNOH.Timestamp.fromJSON(o));
}
function $d87f11b85fb876bf$var$longToString(long) {
    return long.toString();
}
if ($d87f11b85fb876bf$var$minimal_1.default.util.Long !== $d87f11b85fb876bf$var$long_1.default) {
    $d87f11b85fb876bf$var$minimal_1.default.util.Long = $d87f11b85fb876bf$var$long_1.default;
    $d87f11b85fb876bf$var$minimal_1.default.configure();
}
function $d87f11b85fb876bf$var$isSet(value) {
    return value !== null && value !== undefined;
}

});
parcelRegister("jhpuS", function(module, exports) {
"use strict";
var $e093620792e17bae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Duration = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $e093620792e17bae$var$long_1 = $e093620792e17bae$var$__importDefault((parcelRequire("3gmZQ")));

var $e093620792e17bae$var$minimal_1 = $e093620792e17bae$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $e093620792e17bae$var$createBaseDuration() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Duration = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $e093620792e17bae$var$minimal_1.default.Writer.create();
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $e093620792e17bae$var$minimal_1.default.Reader ? input : $e093620792e17bae$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $e093620792e17bae$var$createBaseDuration();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.seconds = $e093620792e17bae$var$longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.nanos = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            seconds: $e093620792e17bae$var$isSet(object.seconds) ? globalThis.String(object.seconds) : "0",
            nanos: $e093620792e17bae$var$isSet(object.nanos) ? globalThis.Number(object.nanos) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.seconds !== "0") obj.seconds = message.seconds;
        if (message.nanos !== 0) obj.nanos = Math.round(message.nanos);
        return obj;
    },
    create: function(base) {
        return module.exports.Duration.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $e093620792e17bae$var$createBaseDuration();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $e093620792e17bae$var$longToString(long) {
    return long.toString();
}
if ($e093620792e17bae$var$minimal_1.default.util.Long !== $e093620792e17bae$var$long_1.default) {
    $e093620792e17bae$var$minimal_1.default.util.Long = $e093620792e17bae$var$long_1.default;
    $e093620792e17bae$var$minimal_1.default.configure();
}
function $e093620792e17bae$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("5yNOH", function(module, exports) {
"use strict";
var $40c6c5484ff74c49$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Timestamp = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $40c6c5484ff74c49$var$long_1 = $40c6c5484ff74c49$var$__importDefault((parcelRequire("3gmZQ")));

var $40c6c5484ff74c49$var$minimal_1 = $40c6c5484ff74c49$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "google.protobuf";
function $40c6c5484ff74c49$var$createBaseTimestamp() {
    return {
        seconds: "0",
        nanos: 0
    };
}
module.exports.Timestamp = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $40c6c5484ff74c49$var$minimal_1.default.Writer.create();
        if (message.seconds !== "0") writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $40c6c5484ff74c49$var$minimal_1.default.Reader ? input : $40c6c5484ff74c49$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $40c6c5484ff74c49$var$createBaseTimestamp();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 8) break;
                    message.seconds = $40c6c5484ff74c49$var$longToString(reader.int64());
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.nanos = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            seconds: $40c6c5484ff74c49$var$isSet(object.seconds) ? globalThis.String(object.seconds) : "0",
            nanos: $40c6c5484ff74c49$var$isSet(object.nanos) ? globalThis.Number(object.nanos) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.seconds !== "0") obj.seconds = message.seconds;
        if (message.nanos !== 0) obj.nanos = Math.round(message.nanos);
        return obj;
    },
    create: function(base) {
        return module.exports.Timestamp.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $40c6c5484ff74c49$var$createBaseTimestamp();
        message.seconds = (_a = object.seconds) !== null && _a !== void 0 ? _a : "0";
        message.nanos = (_b = object.nanos) !== null && _b !== void 0 ? _b : 0;
        return message;
    }
};
function $40c6c5484ff74c49$var$longToString(long) {
    return long.toString();
}
if ($40c6c5484ff74c49$var$minimal_1.default.util.Long !== $40c6c5484ff74c49$var$long_1.default) {
    $40c6c5484ff74c49$var$minimal_1.default.util.Long = $40c6c5484ff74c49$var$long_1.default;
    $40c6c5484ff74c49$var$minimal_1.default.configure();
}
function $40c6c5484ff74c49$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("49ou1", function(module, exports) {
"use strict";
var $305afe8d13dcf5d7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgSkipUploaderRoleResponse = module.exports.MsgSkipUploaderRole = module.exports.MsgClaimUploaderRoleResponse = module.exports.MsgClaimUploaderRole = module.exports.MsgVoteBundleProposalResponse = module.exports.MsgVoteBundleProposal = module.exports.MsgSubmitBundleProposalResponse = module.exports.MsgSubmitBundleProposal = module.exports.voteTypeToJSON = module.exports.voteTypeFromJSON = module.exports.VoteType = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $305afe8d13dcf5d7$var$long_1 = $305afe8d13dcf5d7$var$__importDefault((parcelRequire("3gmZQ")));

var $305afe8d13dcf5d7$var$minimal_1 = $305afe8d13dcf5d7$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.bundles.v1beta1";
/** VoteType ... */ var $305afe8d13dcf5d7$var$VoteType;
(function(VoteType) {
    /** VOTE_TYPE_UNSPECIFIED - VOTE_TYPE_UNSPECIFIED ... */ VoteType[VoteType["VOTE_TYPE_UNSPECIFIED"] = 0] = "VOTE_TYPE_UNSPECIFIED";
    /** VOTE_TYPE_VALID - VOTE_TYPE_VALID ... */ VoteType[VoteType["VOTE_TYPE_VALID"] = 1] = "VOTE_TYPE_VALID";
    /** VOTE_TYPE_INVALID - VOTE_TYPE_INVALID ... */ VoteType[VoteType["VOTE_TYPE_INVALID"] = 2] = "VOTE_TYPE_INVALID";
    /** VOTE_TYPE_ABSTAIN - VOTE_TYPE_ABSTAIN ... */ VoteType[VoteType["VOTE_TYPE_ABSTAIN"] = 3] = "VOTE_TYPE_ABSTAIN";
    VoteType[VoteType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($305afe8d13dcf5d7$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));
function $305afe8d13dcf5d7$var$voteTypeFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_TYPE_UNSPECIFIED":
            return $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_UNSPECIFIED;
        case 1:
        case "VOTE_TYPE_VALID":
            return $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_VALID;
        case 2:
        case "VOTE_TYPE_INVALID":
            return $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_INVALID;
        case 3:
        case "VOTE_TYPE_ABSTAIN":
            return $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_ABSTAIN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $305afe8d13dcf5d7$var$VoteType.UNRECOGNIZED;
    }
}
module.exports.voteTypeFromJSON = $305afe8d13dcf5d7$var$voteTypeFromJSON;
function $305afe8d13dcf5d7$var$voteTypeToJSON(object) {
    switch(object){
        case $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_UNSPECIFIED:
            return "VOTE_TYPE_UNSPECIFIED";
        case $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_VALID:
            return "VOTE_TYPE_VALID";
        case $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_INVALID:
            return "VOTE_TYPE_INVALID";
        case $305afe8d13dcf5d7$var$VoteType.VOTE_TYPE_ABSTAIN:
            return "VOTE_TYPE_ABSTAIN";
        case $305afe8d13dcf5d7$var$VoteType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
module.exports.voteTypeToJSON = $305afe8d13dcf5d7$var$voteTypeToJSON;
function $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposal() {
    return {
        creator: "",
        staker: "",
        pool_id: "0",
        storage_id: "",
        data_size: "0",
        data_hash: "",
        from_index: "0",
        bundle_size: "0",
        from_key: "",
        to_key: "",
        bundle_summary: ""
    };
}
module.exports.MsgSubmitBundleProposal = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.pool_id !== "0") writer.uint32(24).uint64(message.pool_id);
        if (message.storage_id !== "") writer.uint32(34).string(message.storage_id);
        if (message.data_size !== "0") writer.uint32(40).uint64(message.data_size);
        if (message.data_hash !== "") writer.uint32(50).string(message.data_hash);
        if (message.from_index !== "0") writer.uint32(56).uint64(message.from_index);
        if (message.bundle_size !== "0") writer.uint32(64).uint64(message.bundle_size);
        if (message.from_key !== "") writer.uint32(74).string(message.from_key);
        if (message.to_key !== "") writer.uint32(82).string(message.to_key);
        if (message.bundle_summary !== "") writer.uint32(90).string(message.bundle_summary);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.pool_id = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.storage_id = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) break;
                    message.data_size = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.data_hash = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) break;
                    message.from_index = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 8:
                    if (tag !== 64) break;
                    message.bundle_size = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 9:
                    if (tag !== 74) break;
                    message.from_key = reader.string();
                    continue;
                case 10:
                    if (tag !== 82) break;
                    message.to_key = reader.string();
                    continue;
                case 11:
                    if (tag !== 90) break;
                    message.bundle_summary = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $305afe8d13dcf5d7$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $305afe8d13dcf5d7$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            pool_id: $305afe8d13dcf5d7$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            storage_id: $305afe8d13dcf5d7$var$isSet(object.storage_id) ? globalThis.String(object.storage_id) : "",
            data_size: $305afe8d13dcf5d7$var$isSet(object.data_size) ? globalThis.String(object.data_size) : "0",
            data_hash: $305afe8d13dcf5d7$var$isSet(object.data_hash) ? globalThis.String(object.data_hash) : "",
            from_index: $305afe8d13dcf5d7$var$isSet(object.from_index) ? globalThis.String(object.from_index) : "0",
            bundle_size: $305afe8d13dcf5d7$var$isSet(object.bundle_size) ? globalThis.String(object.bundle_size) : "0",
            from_key: $305afe8d13dcf5d7$var$isSet(object.from_key) ? globalThis.String(object.from_key) : "",
            to_key: $305afe8d13dcf5d7$var$isSet(object.to_key) ? globalThis.String(object.to_key) : "",
            bundle_summary: $305afe8d13dcf5d7$var$isSet(object.bundle_summary) ? globalThis.String(object.bundle_summary) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.storage_id !== "") obj.storage_id = message.storage_id;
        if (message.data_size !== "0") obj.data_size = message.data_size;
        if (message.data_hash !== "") obj.data_hash = message.data_hash;
        if (message.from_index !== "0") obj.from_index = message.from_index;
        if (message.bundle_size !== "0") obj.bundle_size = message.bundle_size;
        if (message.from_key !== "") obj.from_key = message.from_key;
        if (message.to_key !== "") obj.to_key = message.to_key;
        if (message.bundle_summary !== "") obj.bundle_summary = message.bundle_summary;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSubmitBundleProposal.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposal();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.pool_id = (_c = object.pool_id) !== null && _c !== void 0 ? _c : "0";
        message.storage_id = (_d = object.storage_id) !== null && _d !== void 0 ? _d : "";
        message.data_size = (_e = object.data_size) !== null && _e !== void 0 ? _e : "0";
        message.data_hash = (_f = object.data_hash) !== null && _f !== void 0 ? _f : "";
        message.from_index = (_g = object.from_index) !== null && _g !== void 0 ? _g : "0";
        message.bundle_size = (_h = object.bundle_size) !== null && _h !== void 0 ? _h : "0";
        message.from_key = (_j = object.from_key) !== null && _j !== void 0 ? _j : "";
        message.to_key = (_k = object.to_key) !== null && _k !== void 0 ? _k : "";
        message.bundle_summary = (_l = object.bundle_summary) !== null && _l !== void 0 ? _l : "";
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposalResponse() {
    return {};
}
module.exports.MsgSubmitBundleProposalResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSubmitBundleProposalResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $305afe8d13dcf5d7$var$createBaseMsgSubmitBundleProposalResponse();
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposal() {
    return {
        creator: "",
        staker: "",
        pool_id: "0",
        storage_id: "",
        vote: 0
    };
}
module.exports.MsgVoteBundleProposal = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.pool_id !== "0") writer.uint32(24).uint64(message.pool_id);
        if (message.storage_id !== "") writer.uint32(34).string(message.storage_id);
        if (message.vote !== 0) writer.uint32(40).int32(message.vote);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposal();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.pool_id = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.storage_id = reader.string();
                    continue;
                case 5:
                    if (tag !== 40) break;
                    message.vote = reader.int32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $305afe8d13dcf5d7$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $305afe8d13dcf5d7$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            pool_id: $305afe8d13dcf5d7$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            storage_id: $305afe8d13dcf5d7$var$isSet(object.storage_id) ? globalThis.String(object.storage_id) : "",
            vote: $305afe8d13dcf5d7$var$isSet(object.vote) ? $305afe8d13dcf5d7$var$voteTypeFromJSON(object.vote) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.storage_id !== "") obj.storage_id = message.storage_id;
        if (message.vote !== 0) obj.vote = $305afe8d13dcf5d7$var$voteTypeToJSON(message.vote);
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVoteBundleProposal.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e;
        var message = $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposal();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.pool_id = (_c = object.pool_id) !== null && _c !== void 0 ? _c : "0";
        message.storage_id = (_d = object.storage_id) !== null && _d !== void 0 ? _d : "";
        message.vote = (_e = object.vote) !== null && _e !== void 0 ? _e : 0;
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposalResponse() {
    return {};
}
module.exports.MsgVoteBundleProposalResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposalResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgVoteBundleProposalResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $305afe8d13dcf5d7$var$createBaseMsgVoteBundleProposalResponse();
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRole() {
    return {
        creator: "",
        staker: "",
        pool_id: "0"
    };
}
module.exports.MsgClaimUploaderRole = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.pool_id !== "0") writer.uint32(24).uint64(message.pool_id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRole();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.pool_id = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $305afe8d13dcf5d7$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $305afe8d13dcf5d7$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            pool_id: $305afe8d13dcf5d7$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgClaimUploaderRole.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRole();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.pool_id = (_c = object.pool_id) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRoleResponse() {
    return {};
}
module.exports.MsgClaimUploaderRoleResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRoleResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgClaimUploaderRoleResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $305afe8d13dcf5d7$var$createBaseMsgClaimUploaderRoleResponse();
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRole() {
    return {
        creator: "",
        staker: "",
        pool_id: "0",
        from_index: "0"
    };
}
module.exports.MsgSkipUploaderRole = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.pool_id !== "0") writer.uint32(24).uint64(message.pool_id);
        if (message.from_index !== "0") writer.uint32(32).uint64(message.from_index);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRole();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.pool_id = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.from_index = $305afe8d13dcf5d7$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $305afe8d13dcf5d7$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $305afe8d13dcf5d7$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            pool_id: $305afe8d13dcf5d7$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            from_index: $305afe8d13dcf5d7$var$isSet(object.from_index) ? globalThis.String(object.from_index) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.from_index !== "0") obj.from_index = message.from_index;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSkipUploaderRole.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRole();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.pool_id = (_c = object.pool_id) !== null && _c !== void 0 ? _c : "0";
        message.from_index = (_d = object.from_index) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRoleResponse() {
    return {};
}
module.exports.MsgSkipUploaderRoleResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRoleResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgSkipUploaderRoleResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $305afe8d13dcf5d7$var$createBaseMsgSkipUploaderRoleResponse();
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $305afe8d13dcf5d7$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $305afe8d13dcf5d7$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $305afe8d13dcf5d7$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $305afe8d13dcf5d7$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $305afe8d13dcf5d7$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $305afe8d13dcf5d7$var$minimal_1.default.Reader ? input : $305afe8d13dcf5d7$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $305afe8d13dcf5d7$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $305afe8d13dcf5d7$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.bundles.v1beta1.Msg";
var $305afe8d13dcf5d7$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.SubmitBundleProposal = this.SubmitBundleProposal.bind(this);
        this.VoteBundleProposal = this.VoteBundleProposal.bind(this);
        this.ClaimUploaderRole = this.ClaimUploaderRole.bind(this);
        this.SkipUploaderRole = this.SkipUploaderRole.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.SubmitBundleProposal = function(request) {
        var data = module.exports.MsgSubmitBundleProposal.encode(request).finish();
        var promise = this.rpc.request(this.service, "SubmitBundleProposal", data);
        return promise.then(function(data) {
            return module.exports.MsgSubmitBundleProposalResponse.decode($305afe8d13dcf5d7$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.VoteBundleProposal = function(request) {
        var data = module.exports.MsgVoteBundleProposal.encode(request).finish();
        var promise = this.rpc.request(this.service, "VoteBundleProposal", data);
        return promise.then(function(data) {
            return module.exports.MsgVoteBundleProposalResponse.decode($305afe8d13dcf5d7$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.ClaimUploaderRole = function(request) {
        var data = module.exports.MsgClaimUploaderRole.encode(request).finish();
        var promise = this.rpc.request(this.service, "ClaimUploaderRole", data);
        return promise.then(function(data) {
            return module.exports.MsgClaimUploaderRoleResponse.decode($305afe8d13dcf5d7$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.SkipUploaderRole = function(request) {
        var data = module.exports.MsgSkipUploaderRole.encode(request).finish();
        var promise = this.rpc.request(this.service, "SkipUploaderRole", data);
        return promise.then(function(data) {
            return module.exports.MsgSkipUploaderRoleResponse.decode($305afe8d13dcf5d7$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($305afe8d13dcf5d7$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $305afe8d13dcf5d7$var$MsgClientImpl;
function $305afe8d13dcf5d7$var$longToString(long) {
    return long.toString();
}
if ($305afe8d13dcf5d7$var$minimal_1.default.util.Long !== $305afe8d13dcf5d7$var$long_1.default) {
    $305afe8d13dcf5d7$var$minimal_1.default.util.Long = $305afe8d13dcf5d7$var$long_1.default;
    $305afe8d13dcf5d7$var$minimal_1.default.configure();
}
function $305afe8d13dcf5d7$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("gRS7H", function(module, exports) {
"use strict";
var $c47b944b54453ce6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgRedelegateResponse = module.exports.MsgRedelegate = module.exports.MsgUndelegateResponse = module.exports.MsgUndelegate = module.exports.MsgWithdrawRewardsResponse = module.exports.MsgWithdrawRewards = module.exports.MsgDelegateResponse = module.exports.MsgDelegate = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $c47b944b54453ce6$var$long_1 = $c47b944b54453ce6$var$__importDefault((parcelRequire("3gmZQ")));

var $c47b944b54453ce6$var$minimal_1 = $c47b944b54453ce6$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.delegation.v1beta1";
function $c47b944b54453ce6$var$createBaseMsgDelegate() {
    return {
        creator: "",
        staker: "",
        amount: "0"
    };
}
module.exports.MsgDelegate = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgDelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $c47b944b54453ce6$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $c47b944b54453ce6$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $c47b944b54453ce6$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            amount: $c47b944b54453ce6$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDelegate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $c47b944b54453ce6$var$createBaseMsgDelegate();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgDelegateResponse() {
    return {};
}
module.exports.MsgDelegateResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDelegateResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $c47b944b54453ce6$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgWithdrawRewards() {
    return {
        creator: "",
        staker: ""
    };
}
module.exports.MsgWithdrawRewards = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgWithdrawRewards();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $c47b944b54453ce6$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $c47b944b54453ce6$var$isSet(object.staker) ? globalThis.String(object.staker) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgWithdrawRewards.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $c47b944b54453ce6$var$createBaseMsgWithdrawRewards();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgWithdrawRewardsResponse() {
    return {};
}
module.exports.MsgWithdrawRewardsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgWithdrawRewardsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgWithdrawRewardsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $c47b944b54453ce6$var$createBaseMsgWithdrawRewardsResponse();
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgUndelegate() {
    return {
        creator: "",
        staker: "",
        amount: "0"
    };
}
module.exports.MsgUndelegate = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.staker !== "") writer.uint32(18).string(message.staker);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $c47b944b54453ce6$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $c47b944b54453ce6$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            staker: $c47b944b54453ce6$var$isSet(object.staker) ? globalThis.String(object.staker) : "",
            amount: $c47b944b54453ce6$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.staker !== "") obj.staker = message.staker;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUndelegate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $c47b944b54453ce6$var$createBaseMsgUndelegate();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.staker = (_b = object.staker) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgUndelegateResponse() {
    return {};
}
module.exports.MsgUndelegateResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUndelegateResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $c47b944b54453ce6$var$createBaseMsgUndelegateResponse();
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgRedelegate() {
    return {
        creator: "",
        from_staker: "",
        to_staker: "",
        amount: "0"
    };
}
module.exports.MsgRedelegate = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.from_staker !== "") writer.uint32(18).string(message.from_staker);
        if (message.to_staker !== "") writer.uint32(26).string(message.to_staker);
        if (message.amount !== "0") writer.uint32(32).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgRedelegate();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.from_staker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.to_staker = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.amount = $c47b944b54453ce6$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $c47b944b54453ce6$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            from_staker: $c47b944b54453ce6$var$isSet(object.from_staker) ? globalThis.String(object.from_staker) : "",
            to_staker: $c47b944b54453ce6$var$isSet(object.to_staker) ? globalThis.String(object.to_staker) : "",
            amount: $c47b944b54453ce6$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.from_staker !== "") obj.from_staker = message.from_staker;
        if (message.to_staker !== "") obj.to_staker = message.to_staker;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgRedelegate.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $c47b944b54453ce6$var$createBaseMsgRedelegate();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.from_staker = (_b = object.from_staker) !== null && _b !== void 0 ? _b : "";
        message.to_staker = (_c = object.to_staker) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgRedelegateResponse() {
    return {};
}
module.exports.MsgRedelegateResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgRedelegateResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgRedelegateResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $c47b944b54453ce6$var$createBaseMsgRedelegateResponse();
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $c47b944b54453ce6$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $c47b944b54453ce6$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $c47b944b54453ce6$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $c47b944b54453ce6$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $c47b944b54453ce6$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $c47b944b54453ce6$var$minimal_1.default.Reader ? input : $c47b944b54453ce6$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $c47b944b54453ce6$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $c47b944b54453ce6$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.delegation.v1beta1.Msg";
var $c47b944b54453ce6$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.Delegate = this.Delegate.bind(this);
        this.WithdrawRewards = this.WithdrawRewards.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.Redelegate = this.Redelegate.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.Delegate = function(request) {
        var data = module.exports.MsgDelegate.encode(request).finish();
        var promise = this.rpc.request(this.service, "Delegate", data);
        return promise.then(function(data) {
            return module.exports.MsgDelegateResponse.decode($c47b944b54453ce6$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.WithdrawRewards = function(request) {
        var data = module.exports.MsgWithdrawRewards.encode(request).finish();
        var promise = this.rpc.request(this.service, "WithdrawRewards", data);
        return promise.then(function(data) {
            return module.exports.MsgWithdrawRewardsResponse.decode($c47b944b54453ce6$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.Undelegate = function(request) {
        var data = module.exports.MsgUndelegate.encode(request).finish();
        var promise = this.rpc.request(this.service, "Undelegate", data);
        return promise.then(function(data) {
            return module.exports.MsgUndelegateResponse.decode($c47b944b54453ce6$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.Redelegate = function(request) {
        var data = module.exports.MsgRedelegate.encode(request).finish();
        var promise = this.rpc.request(this.service, "Redelegate", data);
        return promise.then(function(data) {
            return module.exports.MsgRedelegateResponse.decode($c47b944b54453ce6$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($c47b944b54453ce6$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $c47b944b54453ce6$var$MsgClientImpl;
function $c47b944b54453ce6$var$longToString(long) {
    return long.toString();
}
if ($c47b944b54453ce6$var$minimal_1.default.util.Long !== $c47b944b54453ce6$var$long_1.default) {
    $c47b944b54453ce6$var$minimal_1.default.util.Long = $c47b944b54453ce6$var$long_1.default;
    $c47b944b54453ce6$var$minimal_1.default.configure();
}
function $c47b944b54453ce6$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("PqUN3", function(module, exports) {
"use strict";
var $09a9a4499594f24b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgDefundPoolResponse = module.exports.MsgDefundPool = module.exports.MsgFundPoolResponse = module.exports.MsgFundPool = module.exports.MsgUpdateFunderResponse = module.exports.MsgUpdateFunder = module.exports.MsgCreateFunderResponse = module.exports.MsgCreateFunder = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $09a9a4499594f24b$var$long_1 = $09a9a4499594f24b$var$__importDefault((parcelRequire("3gmZQ")));

var $09a9a4499594f24b$var$minimal_1 = $09a9a4499594f24b$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.funders.v1beta1";
function $09a9a4499594f24b$var$createBaseMsgCreateFunder() {
    return {
        creator: "",
        moniker: "",
        identity: "",
        website: "",
        contact: "",
        description: ""
    };
}
module.exports.MsgCreateFunder = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.moniker !== "") writer.uint32(18).string(message.moniker);
        if (message.identity !== "") writer.uint32(26).string(message.identity);
        if (message.website !== "") writer.uint32(34).string(message.website);
        if (message.contact !== "") writer.uint32(42).string(message.contact);
        if (message.description !== "") writer.uint32(50).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgCreateFunder();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.moniker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.identity = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.website = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.contact = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $09a9a4499594f24b$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            moniker: $09a9a4499594f24b$var$isSet(object.moniker) ? globalThis.String(object.moniker) : "",
            identity: $09a9a4499594f24b$var$isSet(object.identity) ? globalThis.String(object.identity) : "",
            website: $09a9a4499594f24b$var$isSet(object.website) ? globalThis.String(object.website) : "",
            contact: $09a9a4499594f24b$var$isSet(object.contact) ? globalThis.String(object.contact) : "",
            description: $09a9a4499594f24b$var$isSet(object.description) ? globalThis.String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.moniker !== "") obj.moniker = message.moniker;
        if (message.identity !== "") obj.identity = message.identity;
        if (message.website !== "") obj.website = message.website;
        if (message.contact !== "") obj.contact = message.contact;
        if (message.description !== "") obj.description = message.description;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateFunder.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $09a9a4499594f24b$var$createBaseMsgCreateFunder();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.moniker = (_b = object.moniker) !== null && _b !== void 0 ? _b : "";
        message.identity = (_c = object.identity) !== null && _c !== void 0 ? _c : "";
        message.website = (_d = object.website) !== null && _d !== void 0 ? _d : "";
        message.contact = (_e = object.contact) !== null && _e !== void 0 ? _e : "";
        message.description = (_f = object.description) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgCreateFunderResponse() {
    return {};
}
module.exports.MsgCreateFunderResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgCreateFunderResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateFunderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $09a9a4499594f24b$var$createBaseMsgCreateFunderResponse();
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgUpdateFunder() {
    return {
        creator: "",
        moniker: "",
        identity: "",
        website: "",
        contact: "",
        description: ""
    };
}
module.exports.MsgUpdateFunder = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.moniker !== "") writer.uint32(18).string(message.moniker);
        if (message.identity !== "") writer.uint32(26).string(message.identity);
        if (message.website !== "") writer.uint32(34).string(message.website);
        if (message.contact !== "") writer.uint32(42).string(message.contact);
        if (message.description !== "") writer.uint32(50).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateFunder();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.moniker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.identity = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.website = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.contact = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $09a9a4499594f24b$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            moniker: $09a9a4499594f24b$var$isSet(object.moniker) ? globalThis.String(object.moniker) : "",
            identity: $09a9a4499594f24b$var$isSet(object.identity) ? globalThis.String(object.identity) : "",
            website: $09a9a4499594f24b$var$isSet(object.website) ? globalThis.String(object.website) : "",
            contact: $09a9a4499594f24b$var$isSet(object.contact) ? globalThis.String(object.contact) : "",
            description: $09a9a4499594f24b$var$isSet(object.description) ? globalThis.String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.moniker !== "") obj.moniker = message.moniker;
        if (message.identity !== "") obj.identity = message.identity;
        if (message.website !== "") obj.website = message.website;
        if (message.contact !== "") obj.contact = message.contact;
        if (message.description !== "") obj.description = message.description;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateFunder.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateFunder();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.moniker = (_b = object.moniker) !== null && _b !== void 0 ? _b : "";
        message.identity = (_c = object.identity) !== null && _c !== void 0 ? _c : "";
        message.website = (_d = object.website) !== null && _d !== void 0 ? _d : "";
        message.contact = (_e = object.contact) !== null && _e !== void 0 ? _e : "";
        message.description = (_f = object.description) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgUpdateFunderResponse() {
    return {};
}
module.exports.MsgUpdateFunderResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateFunderResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateFunderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateFunderResponse();
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgFundPool() {
    return {
        creator: "",
        pool_id: "0",
        amount: "0",
        amount_per_bundle: "0"
    };
}
module.exports.MsgFundPool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        if (message.amount_per_bundle !== "0") writer.uint32(32).uint64(message.amount_per_bundle);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgFundPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $09a9a4499594f24b$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $09a9a4499594f24b$var$longToString(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.amount_per_bundle = $09a9a4499594f24b$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $09a9a4499594f24b$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $09a9a4499594f24b$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            amount: $09a9a4499594f24b$var$isSet(object.amount) ? globalThis.String(object.amount) : "0",
            amount_per_bundle: $09a9a4499594f24b$var$isSet(object.amount_per_bundle) ? globalThis.String(object.amount_per_bundle) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.amount !== "0") obj.amount = message.amount;
        if (message.amount_per_bundle !== "0") obj.amount_per_bundle = message.amount_per_bundle;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgFundPool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $09a9a4499594f24b$var$createBaseMsgFundPool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        message.amount_per_bundle = (_d = object.amount_per_bundle) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgFundPoolResponse() {
    return {};
}
module.exports.MsgFundPoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgFundPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgFundPoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $09a9a4499594f24b$var$createBaseMsgFundPoolResponse();
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgDefundPool() {
    return {
        creator: "",
        pool_id: "0",
        amount: "0"
    };
}
module.exports.MsgDefundPool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgDefundPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $09a9a4499594f24b$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $09a9a4499594f24b$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $09a9a4499594f24b$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $09a9a4499594f24b$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            amount: $09a9a4499594f24b$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDefundPool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $09a9a4499594f24b$var$createBaseMsgDefundPool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgDefundPoolResponse() {
    return {};
}
module.exports.MsgDefundPoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgDefundPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDefundPoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $09a9a4499594f24b$var$createBaseMsgDefundPoolResponse();
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $09a9a4499594f24b$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $09a9a4499594f24b$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $09a9a4499594f24b$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $09a9a4499594f24b$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $09a9a4499594f24b$var$minimal_1.default.Reader ? input : $09a9a4499594f24b$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $09a9a4499594f24b$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.funders.v1beta1.Msg";
var $09a9a4499594f24b$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.CreateFunder = this.CreateFunder.bind(this);
        this.UpdateFunder = this.UpdateFunder.bind(this);
        this.FundPool = this.FundPool.bind(this);
        this.DefundPool = this.DefundPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.CreateFunder = function(request) {
        var data = module.exports.MsgCreateFunder.encode(request).finish();
        var promise = this.rpc.request(this.service, "CreateFunder", data);
        return promise.then(function(data) {
            return module.exports.MsgCreateFunderResponse.decode($09a9a4499594f24b$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateFunder = function(request) {
        var data = module.exports.MsgUpdateFunder.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateFunder", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateFunderResponse.decode($09a9a4499594f24b$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.FundPool = function(request) {
        var data = module.exports.MsgFundPool.encode(request).finish();
        var promise = this.rpc.request(this.service, "FundPool", data);
        return promise.then(function(data) {
            return module.exports.MsgFundPoolResponse.decode($09a9a4499594f24b$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.DefundPool = function(request) {
        var data = module.exports.MsgDefundPool.encode(request).finish();
        var promise = this.rpc.request(this.service, "DefundPool", data);
        return promise.then(function(data) {
            return module.exports.MsgDefundPoolResponse.decode($09a9a4499594f24b$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($09a9a4499594f24b$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $09a9a4499594f24b$var$MsgClientImpl;
function $09a9a4499594f24b$var$longToString(long) {
    return long.toString();
}
if ($09a9a4499594f24b$var$minimal_1.default.util.Long !== $09a9a4499594f24b$var$long_1.default) {
    $09a9a4499594f24b$var$minimal_1.default.util.Long = $09a9a4499594f24b$var$long_1.default;
    $09a9a4499594f24b$var$minimal_1.default.configure();
}
function $09a9a4499594f24b$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("5sNTy", function(module, exports) {
"use strict";
var $3fa6455f7a40b0d5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $3fa6455f7a40b0d5$var$minimal_1 = $3fa6455f7a40b0d5$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.global.v1beta1";
function $3fa6455f7a40b0d5$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $3fa6455f7a40b0d5$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3fa6455f7a40b0d5$var$minimal_1.default.Reader ? input : $3fa6455f7a40b0d5$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3fa6455f7a40b0d5$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $3fa6455f7a40b0d5$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $3fa6455f7a40b0d5$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $3fa6455f7a40b0d5$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $3fa6455f7a40b0d5$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $3fa6455f7a40b0d5$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $3fa6455f7a40b0d5$var$minimal_1.default.Reader ? input : $3fa6455f7a40b0d5$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $3fa6455f7a40b0d5$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $3fa6455f7a40b0d5$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.global.v1beta1.Msg";
var $3fa6455f7a40b0d5$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($3fa6455f7a40b0d5$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $3fa6455f7a40b0d5$var$MsgClientImpl;
function $3fa6455f7a40b0d5$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("g5lMR", function(module, exports) {
"use strict";
var $bb5e03730506efb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgCancelRuntimeUpgradeResponse = module.exports.MsgCancelRuntimeUpgrade = module.exports.MsgScheduleRuntimeUpgradeResponse = module.exports.MsgScheduleRuntimeUpgrade = module.exports.MsgEnablePoolResponse = module.exports.MsgEnablePool = module.exports.MsgDisablePoolResponse = module.exports.MsgDisablePool = module.exports.MsgUpdatePoolResponse = module.exports.MsgUpdatePool = module.exports.MsgCreatePoolResponse = module.exports.MsgCreatePool = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $bb5e03730506efb4$var$long_1 = $bb5e03730506efb4$var$__importDefault((parcelRequire("3gmZQ")));

var $bb5e03730506efb4$var$minimal_1 = $bb5e03730506efb4$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.pool.v1beta1";
function $bb5e03730506efb4$var$createBaseMsgCreatePool() {
    return {
        authority: "",
        name: "",
        runtime: "",
        logo: "",
        config: "",
        start_key: "",
        upload_interval: "0",
        inflation_share_weight: "0",
        min_delegation: "0",
        max_bundle_size: "0",
        version: "",
        binaries: "",
        storage_provider_id: 0,
        compression_id: 0
    };
}
module.exports.MsgCreatePool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.name !== "") writer.uint32(18).string(message.name);
        if (message.runtime !== "") writer.uint32(26).string(message.runtime);
        if (message.logo !== "") writer.uint32(34).string(message.logo);
        if (message.config !== "") writer.uint32(42).string(message.config);
        if (message.start_key !== "") writer.uint32(50).string(message.start_key);
        if (message.upload_interval !== "0") writer.uint32(56).uint64(message.upload_interval);
        if (message.inflation_share_weight !== "0") writer.uint32(64).uint64(message.inflation_share_weight);
        if (message.min_delegation !== "0") writer.uint32(72).uint64(message.min_delegation);
        if (message.max_bundle_size !== "0") writer.uint32(80).uint64(message.max_bundle_size);
        if (message.version !== "") writer.uint32(90).string(message.version);
        if (message.binaries !== "") writer.uint32(98).string(message.binaries);
        if (message.storage_provider_id !== 0) writer.uint32(104).uint32(message.storage_provider_id);
        if (message.compression_id !== 0) writer.uint32(112).uint32(message.compression_id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgCreatePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.runtime = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.logo = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.config = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.start_key = reader.string();
                    continue;
                case 7:
                    if (tag !== 56) break;
                    message.upload_interval = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 8:
                    if (tag !== 64) break;
                    message.inflation_share_weight = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 9:
                    if (tag !== 72) break;
                    message.min_delegation = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 10:
                    if (tag !== 80) break;
                    message.max_bundle_size = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 11:
                    if (tag !== 90) break;
                    message.version = reader.string();
                    continue;
                case 12:
                    if (tag !== 98) break;
                    message.binaries = reader.string();
                    continue;
                case 13:
                    if (tag !== 104) break;
                    message.storage_provider_id = reader.uint32();
                    continue;
                case 14:
                    if (tag !== 112) break;
                    message.compression_id = reader.uint32();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            name: $bb5e03730506efb4$var$isSet(object.name) ? globalThis.String(object.name) : "",
            runtime: $bb5e03730506efb4$var$isSet(object.runtime) ? globalThis.String(object.runtime) : "",
            logo: $bb5e03730506efb4$var$isSet(object.logo) ? globalThis.String(object.logo) : "",
            config: $bb5e03730506efb4$var$isSet(object.config) ? globalThis.String(object.config) : "",
            start_key: $bb5e03730506efb4$var$isSet(object.start_key) ? globalThis.String(object.start_key) : "",
            upload_interval: $bb5e03730506efb4$var$isSet(object.upload_interval) ? globalThis.String(object.upload_interval) : "0",
            inflation_share_weight: $bb5e03730506efb4$var$isSet(object.inflation_share_weight) ? globalThis.String(object.inflation_share_weight) : "0",
            min_delegation: $bb5e03730506efb4$var$isSet(object.min_delegation) ? globalThis.String(object.min_delegation) : "0",
            max_bundle_size: $bb5e03730506efb4$var$isSet(object.max_bundle_size) ? globalThis.String(object.max_bundle_size) : "0",
            version: $bb5e03730506efb4$var$isSet(object.version) ? globalThis.String(object.version) : "",
            binaries: $bb5e03730506efb4$var$isSet(object.binaries) ? globalThis.String(object.binaries) : "",
            storage_provider_id: $bb5e03730506efb4$var$isSet(object.storage_provider_id) ? globalThis.Number(object.storage_provider_id) : 0,
            compression_id: $bb5e03730506efb4$var$isSet(object.compression_id) ? globalThis.Number(object.compression_id) : 0
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.name !== "") obj.name = message.name;
        if (message.runtime !== "") obj.runtime = message.runtime;
        if (message.logo !== "") obj.logo = message.logo;
        if (message.config !== "") obj.config = message.config;
        if (message.start_key !== "") obj.start_key = message.start_key;
        if (message.upload_interval !== "0") obj.upload_interval = message.upload_interval;
        if (message.inflation_share_weight !== "0") obj.inflation_share_weight = message.inflation_share_weight;
        if (message.min_delegation !== "0") obj.min_delegation = message.min_delegation;
        if (message.max_bundle_size !== "0") obj.max_bundle_size = message.max_bundle_size;
        if (message.version !== "") obj.version = message.version;
        if (message.binaries !== "") obj.binaries = message.binaries;
        if (message.storage_provider_id !== 0) obj.storage_provider_id = Math.round(message.storage_provider_id);
        if (message.compression_id !== 0) obj.compression_id = Math.round(message.compression_id);
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreatePool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var message = $bb5e03730506efb4$var$createBaseMsgCreatePool();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.name = (_b = object.name) !== null && _b !== void 0 ? _b : "";
        message.runtime = (_c = object.runtime) !== null && _c !== void 0 ? _c : "";
        message.logo = (_d = object.logo) !== null && _d !== void 0 ? _d : "";
        message.config = (_e = object.config) !== null && _e !== void 0 ? _e : "";
        message.start_key = (_f = object.start_key) !== null && _f !== void 0 ? _f : "";
        message.upload_interval = (_g = object.upload_interval) !== null && _g !== void 0 ? _g : "0";
        message.inflation_share_weight = (_h = object.inflation_share_weight) !== null && _h !== void 0 ? _h : "0";
        message.min_delegation = (_j = object.min_delegation) !== null && _j !== void 0 ? _j : "0";
        message.max_bundle_size = (_k = object.max_bundle_size) !== null && _k !== void 0 ? _k : "0";
        message.version = (_l = object.version) !== null && _l !== void 0 ? _l : "";
        message.binaries = (_m = object.binaries) !== null && _m !== void 0 ? _m : "";
        message.storage_provider_id = (_o = object.storage_provider_id) !== null && _o !== void 0 ? _o : 0;
        message.compression_id = (_p = object.compression_id) !== null && _p !== void 0 ? _p : 0;
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgCreatePoolResponse() {
    return {};
}
module.exports.MsgCreatePoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgCreatePoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreatePoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgCreatePoolResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgUpdatePool() {
    return {
        authority: "",
        id: "0",
        payload: ""
    };
}
module.exports.MsgUpdatePool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.id !== "0") writer.uint32(16).uint64(message.id);
        if (message.payload !== "") writer.uint32(26).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdatePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.id = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            id: $bb5e03730506efb4$var$isSet(object.id) ? globalThis.String(object.id) : "0",
            payload: $bb5e03730506efb4$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.id !== "0") obj.id = message.id;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdatePool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdatePool();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "0";
        message.payload = (_c = object.payload) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgUpdatePoolResponse() {
    return {};
}
module.exports.MsgUpdatePoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdatePoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdatePoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgUpdatePoolResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgDisablePool() {
    return {
        authority: "",
        id: "0"
    };
}
module.exports.MsgDisablePool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.id !== "0") writer.uint32(16).uint64(message.id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgDisablePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.id = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            id: $bb5e03730506efb4$var$isSet(object.id) ? globalThis.String(object.id) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.id !== "0") obj.id = message.id;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDisablePool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $bb5e03730506efb4$var$createBaseMsgDisablePool();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgDisablePoolResponse() {
    return {};
}
module.exports.MsgDisablePoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgDisablePoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDisablePoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgDisablePoolResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgEnablePool() {
    return {
        authority: "",
        id: "0"
    };
}
module.exports.MsgEnablePool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.id !== "0") writer.uint32(16).uint64(message.id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgEnablePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.id = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            id: $bb5e03730506efb4$var$isSet(object.id) ? globalThis.String(object.id) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.id !== "0") obj.id = message.id;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgEnablePool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $bb5e03730506efb4$var$createBaseMsgEnablePool();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.id = (_b = object.id) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgEnablePoolResponse() {
    return {};
}
module.exports.MsgEnablePoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgEnablePoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgEnablePoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgEnablePoolResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgrade() {
    return {
        authority: "",
        runtime: "",
        version: "",
        scheduled_at: "0",
        duration: "0",
        binaries: ""
    };
}
module.exports.MsgScheduleRuntimeUpgrade = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.runtime !== "") writer.uint32(18).string(message.runtime);
        if (message.version !== "") writer.uint32(26).string(message.version);
        if (message.scheduled_at !== "0") writer.uint32(32).uint64(message.scheduled_at);
        if (message.duration !== "0") writer.uint32(40).uint64(message.duration);
        if (message.binaries !== "") writer.uint32(50).string(message.binaries);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgrade();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.runtime = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.version = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.scheduled_at = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 5:
                    if (tag !== 40) break;
                    message.duration = $bb5e03730506efb4$var$longToString(reader.uint64());
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.binaries = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            runtime: $bb5e03730506efb4$var$isSet(object.runtime) ? globalThis.String(object.runtime) : "",
            version: $bb5e03730506efb4$var$isSet(object.version) ? globalThis.String(object.version) : "",
            scheduled_at: $bb5e03730506efb4$var$isSet(object.scheduled_at) ? globalThis.String(object.scheduled_at) : "0",
            duration: $bb5e03730506efb4$var$isSet(object.duration) ? globalThis.String(object.duration) : "0",
            binaries: $bb5e03730506efb4$var$isSet(object.binaries) ? globalThis.String(object.binaries) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.runtime !== "") obj.runtime = message.runtime;
        if (message.version !== "") obj.version = message.version;
        if (message.scheduled_at !== "0") obj.scheduled_at = message.scheduled_at;
        if (message.duration !== "0") obj.duration = message.duration;
        if (message.binaries !== "") obj.binaries = message.binaries;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgScheduleRuntimeUpgrade.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgrade();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.runtime = (_b = object.runtime) !== null && _b !== void 0 ? _b : "";
        message.version = (_c = object.version) !== null && _c !== void 0 ? _c : "";
        message.scheduled_at = (_d = object.scheduled_at) !== null && _d !== void 0 ? _d : "0";
        message.duration = (_e = object.duration) !== null && _e !== void 0 ? _e : "0";
        message.binaries = (_f = object.binaries) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgradeResponse() {
    return {};
}
module.exports.MsgScheduleRuntimeUpgradeResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgradeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgScheduleRuntimeUpgradeResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgScheduleRuntimeUpgradeResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgrade() {
    return {
        authority: "",
        runtime: ""
    };
}
module.exports.MsgCancelRuntimeUpgrade = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.runtime !== "") writer.uint32(18).string(message.runtime);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgrade();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.runtime = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            runtime: $bb5e03730506efb4$var$isSet(object.runtime) ? globalThis.String(object.runtime) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.runtime !== "") obj.runtime = message.runtime;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCancelRuntimeUpgrade.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgrade();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.runtime = (_b = object.runtime) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgradeResponse() {
    return {};
}
module.exports.MsgCancelRuntimeUpgradeResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgradeResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCancelRuntimeUpgradeResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgCancelRuntimeUpgradeResponse();
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $bb5e03730506efb4$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $bb5e03730506efb4$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $bb5e03730506efb4$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $bb5e03730506efb4$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $bb5e03730506efb4$var$minimal_1.default.Reader ? input : $bb5e03730506efb4$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $bb5e03730506efb4$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $bb5e03730506efb4$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.pool.v1beta1.Msg";
var $bb5e03730506efb4$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.CreatePool = this.CreatePool.bind(this);
        this.UpdatePool = this.UpdatePool.bind(this);
        this.DisablePool = this.DisablePool.bind(this);
        this.EnablePool = this.EnablePool.bind(this);
        this.ScheduleRuntimeUpgrade = this.ScheduleRuntimeUpgrade.bind(this);
        this.CancelRuntimeUpgrade = this.CancelRuntimeUpgrade.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.CreatePool = function(request) {
        var data = module.exports.MsgCreatePool.encode(request).finish();
        var promise = this.rpc.request(this.service, "CreatePool", data);
        return promise.then(function(data) {
            return module.exports.MsgCreatePoolResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdatePool = function(request) {
        var data = module.exports.MsgUpdatePool.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdatePool", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdatePoolResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.DisablePool = function(request) {
        var data = module.exports.MsgDisablePool.encode(request).finish();
        var promise = this.rpc.request(this.service, "DisablePool", data);
        return promise.then(function(data) {
            return module.exports.MsgDisablePoolResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.EnablePool = function(request) {
        var data = module.exports.MsgEnablePool.encode(request).finish();
        var promise = this.rpc.request(this.service, "EnablePool", data);
        return promise.then(function(data) {
            return module.exports.MsgEnablePoolResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.ScheduleRuntimeUpgrade = function(request) {
        var data = module.exports.MsgScheduleRuntimeUpgrade.encode(request).finish();
        var promise = this.rpc.request(this.service, "ScheduleRuntimeUpgrade", data);
        return promise.then(function(data) {
            return module.exports.MsgScheduleRuntimeUpgradeResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.CancelRuntimeUpgrade = function(request) {
        var data = module.exports.MsgCancelRuntimeUpgrade.encode(request).finish();
        var promise = this.rpc.request(this.service, "CancelRuntimeUpgrade", data);
        return promise.then(function(data) {
            return module.exports.MsgCancelRuntimeUpgradeResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($bb5e03730506efb4$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $bb5e03730506efb4$var$MsgClientImpl;
function $bb5e03730506efb4$var$longToString(long) {
    return long.toString();
}
if ($bb5e03730506efb4$var$minimal_1.default.util.Long !== $bb5e03730506efb4$var$long_1.default) {
    $bb5e03730506efb4$var$minimal_1.default.util.Long = $bb5e03730506efb4$var$long_1.default;
    $bb5e03730506efb4$var$minimal_1.default.configure();
}
function $bb5e03730506efb4$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("fWkcS", function(module, exports) {
"use strict";
var $b9abf270ca15cfdf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgLeavePoolResponse = module.exports.MsgLeavePool = module.exports.MsgJoinPoolResponse = module.exports.MsgJoinPool = module.exports.MsgClaimCommissionRewardsResponse = module.exports.MsgClaimCommissionRewards = module.exports.MsgUpdateCommissionResponse = module.exports.MsgUpdateCommission = module.exports.MsgUpdateMetadataResponse = module.exports.MsgUpdateMetadata = module.exports.MsgCreateStakerResponse = module.exports.MsgCreateStaker = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $b9abf270ca15cfdf$var$long_1 = $b9abf270ca15cfdf$var$__importDefault((parcelRequire("3gmZQ")));

var $b9abf270ca15cfdf$var$minimal_1 = $b9abf270ca15cfdf$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.stakers.v1beta1";
function $b9abf270ca15cfdf$var$createBaseMsgCreateStaker() {
    return {
        creator: "",
        amount: "0",
        commission: ""
    };
}
module.exports.MsgCreateStaker = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "0") writer.uint32(16).uint64(message.amount);
        if (message.commission !== "") writer.uint32(26).string(message.commission);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgCreateStaker();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.amount = $b9abf270ca15cfdf$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.commission = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            amount: $b9abf270ca15cfdf$var$isSet(object.amount) ? globalThis.String(object.amount) : "0",
            commission: $b9abf270ca15cfdf$var$isSet(object.commission) ? globalThis.String(object.commission) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.amount !== "0") obj.amount = message.amount;
        if (message.commission !== "") obj.commission = message.commission;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateStaker.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $b9abf270ca15cfdf$var$createBaseMsgCreateStaker();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "0";
        message.commission = (_c = object.commission) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgCreateStakerResponse() {
    return {};
}
module.exports.MsgCreateStakerResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgCreateStakerResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateStakerResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgCreateStakerResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadata() {
    return {
        creator: "",
        moniker: "",
        website: "",
        identity: "",
        security_contact: "",
        details: ""
    };
}
module.exports.MsgUpdateMetadata = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.moniker !== "") writer.uint32(18).string(message.moniker);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.identity !== "") writer.uint32(34).string(message.identity);
        if (message.security_contact !== "") writer.uint32(42).string(message.security_contact);
        if (message.details !== "") writer.uint32(50).string(message.details);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadata();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.moniker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.website = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.identity = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.security_contact = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.details = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            moniker: $b9abf270ca15cfdf$var$isSet(object.moniker) ? globalThis.String(object.moniker) : "",
            website: $b9abf270ca15cfdf$var$isSet(object.website) ? globalThis.String(object.website) : "",
            identity: $b9abf270ca15cfdf$var$isSet(object.identity) ? globalThis.String(object.identity) : "",
            security_contact: $b9abf270ca15cfdf$var$isSet(object.security_contact) ? globalThis.String(object.security_contact) : "",
            details: $b9abf270ca15cfdf$var$isSet(object.details) ? globalThis.String(object.details) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.moniker !== "") obj.moniker = message.moniker;
        if (message.website !== "") obj.website = message.website;
        if (message.identity !== "") obj.identity = message.identity;
        if (message.security_contact !== "") obj.security_contact = message.security_contact;
        if (message.details !== "") obj.details = message.details;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateMetadata.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadata();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.moniker = (_b = object.moniker) !== null && _b !== void 0 ? _b : "";
        message.website = (_c = object.website) !== null && _c !== void 0 ? _c : "";
        message.identity = (_d = object.identity) !== null && _d !== void 0 ? _d : "";
        message.security_contact = (_e = object.security_contact) !== null && _e !== void 0 ? _e : "";
        message.details = (_f = object.details) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadataResponse() {
    return {};
}
module.exports.MsgUpdateMetadataResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadataResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateMetadataResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateMetadataResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateCommission() {
    return {
        creator: "",
        commission: ""
    };
}
module.exports.MsgUpdateCommission = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.commission !== "") writer.uint32(18).string(message.commission);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateCommission();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.commission = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            commission: $b9abf270ca15cfdf$var$isSet(object.commission) ? globalThis.String(object.commission) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.commission !== "") obj.commission = message.commission;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateCommission.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateCommission();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.commission = (_b = object.commission) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateCommissionResponse() {
    return {};
}
module.exports.MsgUpdateCommissionResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateCommissionResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateCommissionResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateCommissionResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewards() {
    return {
        creator: "",
        amount: "0"
    };
}
module.exports.MsgClaimCommissionRewards = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.amount !== "0") writer.uint32(16).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewards();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.amount = $b9abf270ca15cfdf$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            amount: $b9abf270ca15cfdf$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgClaimCommissionRewards.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewards();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewardsResponse() {
    return {};
}
module.exports.MsgClaimCommissionRewardsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewardsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgClaimCommissionRewardsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgClaimCommissionRewardsResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgJoinPool() {
    return {
        creator: "",
        pool_id: "0",
        valaddress: "",
        amount: "0"
    };
}
module.exports.MsgJoinPool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        if (message.valaddress !== "") writer.uint32(26).string(message.valaddress);
        if (message.amount !== "0") writer.uint32(32).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgJoinPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $b9abf270ca15cfdf$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.valaddress = reader.string();
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.amount = $b9abf270ca15cfdf$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $b9abf270ca15cfdf$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            valaddress: $b9abf270ca15cfdf$var$isSet(object.valaddress) ? globalThis.String(object.valaddress) : "",
            amount: $b9abf270ca15cfdf$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.valaddress !== "") obj.valaddress = message.valaddress;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgJoinPool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $b9abf270ca15cfdf$var$createBaseMsgJoinPool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        message.valaddress = (_c = object.valaddress) !== null && _c !== void 0 ? _c : "";
        message.amount = (_d = object.amount) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgJoinPoolResponse() {
    return {};
}
module.exports.MsgJoinPoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgJoinPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgJoinPoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgJoinPoolResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgLeavePool() {
    return {
        creator: "",
        pool_id: "0"
    };
}
module.exports.MsgLeavePool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgLeavePool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $b9abf270ca15cfdf$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $b9abf270ca15cfdf$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $b9abf270ca15cfdf$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgLeavePool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $b9abf270ca15cfdf$var$createBaseMsgLeavePool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgLeavePoolResponse() {
    return {};
}
module.exports.MsgLeavePoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgLeavePoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgLeavePoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgLeavePoolResponse();
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $b9abf270ca15cfdf$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $b9abf270ca15cfdf$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $b9abf270ca15cfdf$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $b9abf270ca15cfdf$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $b9abf270ca15cfdf$var$minimal_1.default.Reader ? input : $b9abf270ca15cfdf$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $b9abf270ca15cfdf$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.stakers.v1beta1.Msg";
var $b9abf270ca15cfdf$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.CreateStaker = this.CreateStaker.bind(this);
        this.UpdateMetadata = this.UpdateMetadata.bind(this);
        this.UpdateCommission = this.UpdateCommission.bind(this);
        this.ClaimCommissionRewards = this.ClaimCommissionRewards.bind(this);
        this.JoinPool = this.JoinPool.bind(this);
        this.LeavePool = this.LeavePool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.CreateStaker = function(request) {
        var data = module.exports.MsgCreateStaker.encode(request).finish();
        var promise = this.rpc.request(this.service, "CreateStaker", data);
        return promise.then(function(data) {
            return module.exports.MsgCreateStakerResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateMetadata = function(request) {
        var data = module.exports.MsgUpdateMetadata.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateMetadata", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateMetadataResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateCommission = function(request) {
        var data = module.exports.MsgUpdateCommission.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateCommission", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateCommissionResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.ClaimCommissionRewards = function(request) {
        var data = module.exports.MsgClaimCommissionRewards.encode(request).finish();
        var promise = this.rpc.request(this.service, "ClaimCommissionRewards", data);
        return promise.then(function(data) {
            return module.exports.MsgClaimCommissionRewardsResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.JoinPool = function(request) {
        var data = module.exports.MsgJoinPool.encode(request).finish();
        var promise = this.rpc.request(this.service, "JoinPool", data);
        return promise.then(function(data) {
            return module.exports.MsgJoinPoolResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.LeavePool = function(request) {
        var data = module.exports.MsgLeavePool.encode(request).finish();
        var promise = this.rpc.request(this.service, "LeavePool", data);
        return promise.then(function(data) {
            return module.exports.MsgLeavePoolResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($b9abf270ca15cfdf$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $b9abf270ca15cfdf$var$MsgClientImpl;
function $b9abf270ca15cfdf$var$longToString(long) {
    return long.toString();
}
if ($b9abf270ca15cfdf$var$minimal_1.default.util.Long !== $b9abf270ca15cfdf$var$long_1.default) {
    $b9abf270ca15cfdf$var$minimal_1.default.util.Long = $b9abf270ca15cfdf$var$long_1.default;
    $b9abf270ca15cfdf$var$minimal_1.default.configure();
}
function $b9abf270ca15cfdf$var$isSet(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("1moS2", function(module, exports) {
"use strict";
var $0fdb234a73084c88$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MsgClientImpl = module.exports.MsgServiceName = module.exports.MsgUpdateParamsResponse = module.exports.MsgUpdateParams = module.exports.MsgDefundPoolResponse = module.exports.MsgDefundPool = module.exports.MsgFundPoolResponse = module.exports.MsgFundPool = module.exports.MsgUpdateFunderResponse = module.exports.MsgUpdateFunder = module.exports.MsgCreateFunderResponse = module.exports.MsgCreateFunder = module.exports.protobufPackage = void 0;

/* eslint-disable */ var $0fdb234a73084c88$var$long_1 = $0fdb234a73084c88$var$__importDefault((parcelRequire("3gmZQ")));

var $0fdb234a73084c88$var$minimal_1 = $0fdb234a73084c88$var$__importDefault((parcelRequire("1wC51")));
module.exports.protobufPackage = "kyve.funders.v1beta1";
function $0fdb234a73084c88$var$createBaseMsgCreateFunder() {
    return {
        creator: "",
        moniker: "",
        identity: "",
        website: "",
        contact: "",
        description: ""
    };
}
module.exports.MsgCreateFunder = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.moniker !== "") writer.uint32(18).string(message.moniker);
        if (message.identity !== "") writer.uint32(26).string(message.identity);
        if (message.website !== "") writer.uint32(34).string(message.website);
        if (message.contact !== "") writer.uint32(42).string(message.contact);
        if (message.description !== "") writer.uint32(50).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgCreateFunder();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.moniker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.identity = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.website = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.contact = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $0fdb234a73084c88$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            moniker: $0fdb234a73084c88$var$isSet(object.moniker) ? globalThis.String(object.moniker) : "",
            identity: $0fdb234a73084c88$var$isSet(object.identity) ? globalThis.String(object.identity) : "",
            website: $0fdb234a73084c88$var$isSet(object.website) ? globalThis.String(object.website) : "",
            contact: $0fdb234a73084c88$var$isSet(object.contact) ? globalThis.String(object.contact) : "",
            description: $0fdb234a73084c88$var$isSet(object.description) ? globalThis.String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.moniker !== "") obj.moniker = message.moniker;
        if (message.identity !== "") obj.identity = message.identity;
        if (message.website !== "") obj.website = message.website;
        if (message.contact !== "") obj.contact = message.contact;
        if (message.description !== "") obj.description = message.description;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateFunder.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $0fdb234a73084c88$var$createBaseMsgCreateFunder();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.moniker = (_b = object.moniker) !== null && _b !== void 0 ? _b : "";
        message.identity = (_c = object.identity) !== null && _c !== void 0 ? _c : "";
        message.website = (_d = object.website) !== null && _d !== void 0 ? _d : "";
        message.contact = (_e = object.contact) !== null && _e !== void 0 ? _e : "";
        message.description = (_f = object.description) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgCreateFunderResponse() {
    return {};
}
module.exports.MsgCreateFunderResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgCreateFunderResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgCreateFunderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $0fdb234a73084c88$var$createBaseMsgCreateFunderResponse();
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgUpdateFunder() {
    return {
        creator: "",
        moniker: "",
        identity: "",
        website: "",
        contact: "",
        description: ""
    };
}
module.exports.MsgUpdateFunder = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.moniker !== "") writer.uint32(18).string(message.moniker);
        if (message.identity !== "") writer.uint32(26).string(message.identity);
        if (message.website !== "") writer.uint32(34).string(message.website);
        if (message.contact !== "") writer.uint32(42).string(message.contact);
        if (message.description !== "") writer.uint32(50).string(message.description);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateFunder();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.moniker = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) break;
                    message.identity = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) break;
                    message.website = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) break;
                    message.contact = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) break;
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $0fdb234a73084c88$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            moniker: $0fdb234a73084c88$var$isSet(object.moniker) ? globalThis.String(object.moniker) : "",
            identity: $0fdb234a73084c88$var$isSet(object.identity) ? globalThis.String(object.identity) : "",
            website: $0fdb234a73084c88$var$isSet(object.website) ? globalThis.String(object.website) : "",
            contact: $0fdb234a73084c88$var$isSet(object.contact) ? globalThis.String(object.contact) : "",
            description: $0fdb234a73084c88$var$isSet(object.description) ? globalThis.String(object.description) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.moniker !== "") obj.moniker = message.moniker;
        if (message.identity !== "") obj.identity = message.identity;
        if (message.website !== "") obj.website = message.website;
        if (message.contact !== "") obj.contact = message.contact;
        if (message.description !== "") obj.description = message.description;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateFunder.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d, _e, _f;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateFunder();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.moniker = (_b = object.moniker) !== null && _b !== void 0 ? _b : "";
        message.identity = (_c = object.identity) !== null && _c !== void 0 ? _c : "";
        message.website = (_d = object.website) !== null && _d !== void 0 ? _d : "";
        message.contact = (_e = object.contact) !== null && _e !== void 0 ? _e : "";
        message.description = (_f = object.description) !== null && _f !== void 0 ? _f : "";
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgUpdateFunderResponse() {
    return {};
}
module.exports.MsgUpdateFunderResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateFunderResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateFunderResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateFunderResponse();
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgFundPool() {
    return {
        creator: "",
        pool_id: "0",
        amount: "0",
        amount_per_bundle: "0"
    };
}
module.exports.MsgFundPool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        if (message.amount_per_bundle !== "0") writer.uint32(32).uint64(message.amount_per_bundle);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgFundPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $0fdb234a73084c88$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $0fdb234a73084c88$var$longToString(reader.uint64());
                    continue;
                case 4:
                    if (tag !== 32) break;
                    message.amount_per_bundle = $0fdb234a73084c88$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $0fdb234a73084c88$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $0fdb234a73084c88$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            amount: $0fdb234a73084c88$var$isSet(object.amount) ? globalThis.String(object.amount) : "0",
            amount_per_bundle: $0fdb234a73084c88$var$isSet(object.amount_per_bundle) ? globalThis.String(object.amount_per_bundle) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.amount !== "0") obj.amount = message.amount;
        if (message.amount_per_bundle !== "0") obj.amount_per_bundle = message.amount_per_bundle;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgFundPool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c, _d;
        var message = $0fdb234a73084c88$var$createBaseMsgFundPool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        message.amount_per_bundle = (_d = object.amount_per_bundle) !== null && _d !== void 0 ? _d : "0";
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgFundPoolResponse() {
    return {};
}
module.exports.MsgFundPoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgFundPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgFundPoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $0fdb234a73084c88$var$createBaseMsgFundPoolResponse();
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgDefundPool() {
    return {
        creator: "",
        pool_id: "0",
        amount: "0"
    };
}
module.exports.MsgDefundPool = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        if (message.creator !== "") writer.uint32(10).string(message.creator);
        if (message.pool_id !== "0") writer.uint32(16).uint64(message.pool_id);
        if (message.amount !== "0") writer.uint32(24).uint64(message.amount);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgDefundPool();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.creator = reader.string();
                    continue;
                case 2:
                    if (tag !== 16) break;
                    message.pool_id = $0fdb234a73084c88$var$longToString(reader.uint64());
                    continue;
                case 3:
                    if (tag !== 24) break;
                    message.amount = $0fdb234a73084c88$var$longToString(reader.uint64());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            creator: $0fdb234a73084c88$var$isSet(object.creator) ? globalThis.String(object.creator) : "",
            pool_id: $0fdb234a73084c88$var$isSet(object.pool_id) ? globalThis.String(object.pool_id) : "0",
            amount: $0fdb234a73084c88$var$isSet(object.amount) ? globalThis.String(object.amount) : "0"
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.creator !== "") obj.creator = message.creator;
        if (message.pool_id !== "0") obj.pool_id = message.pool_id;
        if (message.amount !== "0") obj.amount = message.amount;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDefundPool.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b, _c;
        var message = $0fdb234a73084c88$var$createBaseMsgDefundPool();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool_id = (_b = object.pool_id) !== null && _b !== void 0 ? _b : "0";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "0";
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgDefundPoolResponse() {
    return {};
}
module.exports.MsgDefundPoolResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgDefundPoolResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgDefundPoolResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $0fdb234a73084c88$var$createBaseMsgDefundPoolResponse();
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        payload: ""
    };
}
module.exports.MsgUpdateParams = {
    encode: function(message, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.payload !== "") writer.uint32(18).string(message.payload);
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            var tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if (tag !== 10) break;
                    message.authority = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) break;
                    message.payload = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(object) {
        return {
            authority: $0fdb234a73084c88$var$isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: $0fdb234a73084c88$var$isSet(object.payload) ? globalThis.String(object.payload) : ""
        };
    },
    toJSON: function(message) {
        var obj = {};
        if (message.authority !== "") obj.authority = message.authority;
        if (message.payload !== "") obj.payload = message.payload;
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(object) {
        var _a, _b;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $0fdb234a73084c88$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
module.exports.MsgUpdateParamsResponse = {
    encode: function(_, writer) {
        if (writer === void 0) writer = $0fdb234a73084c88$var$minimal_1.default.Writer.create();
        return writer;
    },
    decode: function(input, length) {
        var reader = input instanceof $0fdb234a73084c88$var$minimal_1.default.Reader ? input : $0fdb234a73084c88$var$minimal_1.default.Reader.create(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            var tag = reader.uint32();
            tag;
            if ((tag & 7) === 4 || tag === 0) break;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON: function(_) {
        return {};
    },
    toJSON: function(_) {
        var obj = {};
        return obj;
    },
    create: function(base) {
        return module.exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function(_) {
        var message = $0fdb234a73084c88$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
module.exports.MsgServiceName = "kyve.funders.v1beta1.Msg";
var $0fdb234a73084c88$var$MsgClientImpl = /** @class */ function() {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || module.exports.MsgServiceName;
        this.rpc = rpc;
        this.CreateFunder = this.CreateFunder.bind(this);
        this.UpdateFunder = this.UpdateFunder.bind(this);
        this.FundPool = this.FundPool.bind(this);
        this.DefundPool = this.DefundPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    MsgClientImpl.prototype.CreateFunder = function(request) {
        var data = module.exports.MsgCreateFunder.encode(request).finish();
        var promise = this.rpc.request(this.service, "CreateFunder", data);
        return promise.then(function(data) {
            return module.exports.MsgCreateFunderResponse.decode($0fdb234a73084c88$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateFunder = function(request) {
        var data = module.exports.MsgUpdateFunder.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateFunder", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateFunderResponse.decode($0fdb234a73084c88$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.FundPool = function(request) {
        var data = module.exports.MsgFundPool.encode(request).finish();
        var promise = this.rpc.request(this.service, "FundPool", data);
        return promise.then(function(data) {
            return module.exports.MsgFundPoolResponse.decode($0fdb234a73084c88$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.DefundPool = function(request) {
        var data = module.exports.MsgDefundPool.encode(request).finish();
        var promise = this.rpc.request(this.service, "DefundPool", data);
        return promise.then(function(data) {
            return module.exports.MsgDefundPoolResponse.decode($0fdb234a73084c88$var$minimal_1.default.Reader.create(data));
        });
    };
    MsgClientImpl.prototype.UpdateParams = function(request) {
        var data = module.exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function(data) {
            return module.exports.MsgUpdateParamsResponse.decode($0fdb234a73084c88$var$minimal_1.default.Reader.create(data));
        });
    };
    return MsgClientImpl;
}();
module.exports.MsgClientImpl = $0fdb234a73084c88$var$MsgClientImpl;
function $0fdb234a73084c88$var$longToString(long) {
    return long.toString();
}
if ($0fdb234a73084c88$var$minimal_1.default.util.Long !== $0fdb234a73084c88$var$long_1.default) {
    $0fdb234a73084c88$var$minimal_1.default.util.Long = $0fdb234a73084c88$var$long_1.default;
    $0fdb234a73084c88$var$minimal_1.default.configure();
}
function $0fdb234a73084c88$var$isSet(value) {
    return value !== null && value !== undefined;
}

});



parcelRegister("8XE2k", function(module, exports) {
"use strict";
var $6862e3dd57d6c7fc$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6862e3dd57d6c7fc$var$__assign = module.exports && module.exports.__assign || function() {
    $6862e3dd57d6c7fc$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6862e3dd57d6c7fc$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jVVQx = parcelRequire("jVVQx");

var $eqANf = parcelRequire("eqANf");
var $6862e3dd57d6c7fc$var$KyveDelegationMethods = /** @class */ function(_super) {
    $6862e3dd57d6c7fc$var$__extends(KyveDelegationMethods, _super);
    function KyveDelegationMethods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveDelegationMethods.prototype.delegate = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.delegate($6862e3dd57d6c7fc$var$__assign($6862e3dd57d6c7fc$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveDelegationMethods.prototype.withdrawRewards = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.withdrawRewards($6862e3dd57d6c7fc$var$__assign($6862e3dd57d6c7fc$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveDelegationMethods.prototype.undelegate = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.undelegate($6862e3dd57d6c7fc$var$__assign($6862e3dd57d6c7fc$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveDelegationMethods.prototype.redelegate = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.redelegate($6862e3dd57d6c7fc$var$__assign($6862e3dd57d6c7fc$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    return KyveDelegationMethods;
}($eqANf.KyveSigning);
module.exports.default = $6862e3dd57d6c7fc$var$KyveDelegationMethods;

});

parcelRegister("9ZslP", function(module, exports) {
"use strict";
var $745fcd7a18b0b27c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $745fcd7a18b0b27c$var$__assign = module.exports && module.exports.__assign || function() {
    $745fcd7a18b0b27c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $745fcd7a18b0b27c$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jVVQx = parcelRequire("jVVQx");

var $eqANf = parcelRequire("eqANf");
var $745fcd7a18b0b27c$var$KyveFundersMethods = /** @class */ function(_super) {
    $745fcd7a18b0b27c$var$__extends(KyveFundersMethods, _super);
    function KyveFundersMethods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveFundersMethods.prototype.createFunder = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.createFunder($745fcd7a18b0b27c$var$__assign($745fcd7a18b0b27c$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveFundersMethods.prototype.updateFunder = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.updateFunder($745fcd7a18b0b27c$var$__assign($745fcd7a18b0b27c$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveFundersMethods.prototype.fundPool = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.fundPool($745fcd7a18b0b27c$var$__assign($745fcd7a18b0b27c$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveFundersMethods.prototype.defundPool = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.defundPool($745fcd7a18b0b27c$var$__assign($745fcd7a18b0b27c$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    return KyveFundersMethods;
}($eqANf.KyveSigning);
module.exports.default = $745fcd7a18b0b27c$var$KyveFundersMethods;

});

parcelRegister("iEKS9", function(module, exports) {
"use strict";
var $d95052536e6f990b$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $d95052536e6f990b$var$__assign = module.exports && module.exports.__assign || function() {
    $d95052536e6f990b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d95052536e6f990b$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fReUp = parcelRequire("fReUp");

var $iAp74 = parcelRequire("iAp74");

var $2M7Hy = parcelRequire("2M7Hy");

var $jVVQx = parcelRequire("jVVQx");

var $eqANf = parcelRequire("eqANf");
var $d95052536e6f990b$var$KyveGovMsg = /** @class */ function(_super) {
    $d95052536e6f990b$var$__extends(KyveGovMsg, _super);
    function KyveGovMsg() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveGovMsg.prototype.createGovTx = function(content, deposit, title, summary, metadata) {
        return {
            typeUrl: "/cosmos.gov.v1.MsgSubmitProposal",
            value: {
                messages: [
                    content
                ],
                initial_deposit: (0, $fReUp.coins)(deposit.toString(), this.config.coinDenom),
                proposer: this.account.address,
                title: title,
                summary: summary,
                metadata: metadata
            }
        };
    };
    KyveGovMsg.prototype.createPool = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.createPool($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.updatePool = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.updatePool($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.disablePool = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.disablePool($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.enablePool = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.enablePool($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.scheduleRuntimeUpgrade = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.scheduleRuntimeUpgrade($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.cancelRuntimeUpgrade = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.cancelRuntimeUpgrade($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.updateParamsStakers = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.updateParamsStakers($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.updateParamsDelegation = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.updateParamsDelegation($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.updateParamsBundles = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.updateParamsBundles($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.updateParamsGlobal = function(value, deposit, title, summary, metadata, options) {
        var _this = this;
        var tx = this.createGovTx($jVVQx.encodeTxMsg.updateParamsGlobal($d95052536e6f990b$var$__assign($d95052536e6f990b$var$__assign({}, value), {
            authority: $2M7Hy.GOV_AUTHORITY
        })), deposit, title, summary, metadata);
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveGovMsg.prototype.vote = function(id, voteOption, options) {
        var _this = this;
        var _option = $iAp74.VoteOption.VOTE_OPTION_UNSPECIFIED;
        switch(voteOption){
            case "Yes":
                _option = $iAp74.VoteOption.VOTE_OPTION_YES;
                break;
            case "Abstain":
                _option = $iAp74.VoteOption.VOTE_OPTION_ABSTAIN;
                break;
            case "No":
                _option = $iAp74.VoteOption.VOTE_OPTION_NO;
                break;
            case "NoWithVeto":
                _option = $iAp74.VoteOption.VOTE_OPTION_NO_WITH_VETO;
                break;
        }
        var tx = {
            typeUrl: "/cosmos.gov.v1.MsgVote",
            value: {
                proposal_id: id,
                voter: this.account.address,
                option: _option
            }
        };
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    return KyveGovMsg;
}($eqANf.KyveSigning);
module.exports.default = $d95052536e6f990b$var$KyveGovMsg;

});

parcelRegister("h4Gqo", function(module, exports) {
"use strict";
var $c6e3b80892b5534a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c6e3b80892b5534a$var$__assign = module.exports && module.exports.__assign || function() {
    $c6e3b80892b5534a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c6e3b80892b5534a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jVVQx = parcelRequire("jVVQx");

var $eqANf = parcelRequire("eqANf");
var $c6e3b80892b5534a$var$KyveStakersMethods = /** @class */ function(_super) {
    $c6e3b80892b5534a$var$__extends(KyveStakersMethods, _super);
    function KyveStakersMethods() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KyveStakersMethods.prototype.createStaker = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.createStaker($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveStakersMethods.prototype.updateMetadata = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.updateMetadata($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveStakersMethods.prototype.updateCommission = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.updateCommission($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveStakersMethods.prototype.claimCommissionRewards = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.claimCommissionRewards($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveStakersMethods.prototype.joinPool = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.joinPool($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    KyveStakersMethods.prototype.leavePool = function(value, options) {
        var _this = this;
        var tx = $jVVQx.withTypeUrl.leavePool($c6e3b80892b5534a$var$__assign($c6e3b80892b5534a$var$__assign({}, value), {
            creator: this.account.address
        }));
        return new $eqANf.PendingTx({
            tx: [
                tx
            ]
        }, function() {
            return _this.getPendingSignedTx(tx, options);
        });
    };
    return KyveStakersMethods;
}($eqANf.KyveSigning);
module.exports.default = $c6e3b80892b5534a$var$KyveStakersMethods;

});


parcelRegister("dgeoZ", function(module, exports) {
"use strict";
var $9a77f0ecec464228$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9a77f0ecec464228$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9a77f0ecec464228$var$client_1 = $9a77f0ecec464228$var$__importDefault((parcelRequire("1oIL0")));
var $9a77f0ecec464228$var$KyveWebClient = /** @class */ function(_super) {
    $9a77f0ecec464228$var$__extends(KyveWebClient, _super);
    function KyveWebClient(client, account, config, aminoSigner, walletName) {
        var _this = _super.call(this, client, account, config, aminoSigner) || this;
        _this.walletName = walletName;
        return _this;
    }
    KyveWebClient.prototype.getWalletName = function() {
        return this.walletName;
    };
    return KyveWebClient;
}($9a77f0ecec464228$var$client_1.default);
module.exports.default = $9a77f0ecec464228$var$KyveWebClient;

});

parcelRegister("43j8s", function(module, exports) {
"use strict";
var $2f36491ee9b6bf43$var$__assign = module.exports && module.exports.__assign || function() {
    $2f36491ee9b6bf43$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f36491ee9b6bf43$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createBundlesAminoConverters = void 0;

var $5PpAs = parcelRequire("5PpAs");
var $2f36491ee9b6bf43$var$createBundlesAminoConverters = function() {
    return {
        "/kyve.bundles.v1beta1.MsgSubmitBundleProposal": {
            aminoType: "kyve/bundles/MsgSubmitBundleProposal",
            toAmino: function(msg) {
                return $2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                }), (0, $5PpAs.isNotEmpty)(msg.storage_id) && {
                    storage_id: msg.storage_id
                }), (0, $5PpAs.isNotEmpty)(msg.data_size) && {
                    data_size: msg.data_size
                }), (0, $5PpAs.isNotEmpty)(msg.data_hash) && {
                    data_hash: msg.data_hash
                }), (0, $5PpAs.isNotEmpty)(msg.from_index) && {
                    from_index: msg.from_index
                }), (0, $5PpAs.isNotEmpty)(msg.bundle_size) && {
                    bundle_size: msg.bundle_size
                }), (0, $5PpAs.isNotEmpty)(msg.from_key) && {
                    from_key: msg.from_key
                }), (0, $5PpAs.isNotEmpty)(msg.to_key) && {
                    to_key: msg.to_key
                }), (0, $5PpAs.isNotEmpty)(msg.bundle_summary) && {
                    bundle_summary: msg.bundle_summary
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    pool_id: msg.pool_id,
                    storage_id: msg.storage_id,
                    data_size: msg.data_size,
                    data_hash: msg.data_hash,
                    from_index: msg.from_index,
                    bundle_size: msg.bundle_size,
                    from_key: msg.from_key,
                    to_key: msg.to_key,
                    bundle_summary: msg.bundle_summary
                };
            }
        },
        "/kyve.bundles.v1beta1.MsgVoteBundleProposal": {
            aminoType: "kyve/bundles/MsgVoteBundleProposal",
            toAmino: function(msg) {
                return $2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                }), (0, $5PpAs.isNotEmpty)(msg.storage_id) && {
                    storage_id: msg.storage_id
                }), {
                    vote: msg.vote
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    pool_id: msg.pool_id,
                    storage_id: msg.storage_id,
                    vote: msg.vote
                };
            }
        },
        "/kyve.bundles.v1beta1.MsgClaimUploaderRole": {
            aminoType: "kyve/bundles/MsgClaimUploaderRole",
            toAmino: function(msg) {
                return $2f36491ee9b6bf43$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    pool_id: msg.pool_id
                };
            }
        },
        "/kyve.bundles.v1beta1.MsgSkipUploaderRole": {
            aminoType: "kyve/bundles/MsgSkipUploaderRole",
            toAmino: function(msg) {
                return $2f36491ee9b6bf43$var$__assign($2f36491ee9b6bf43$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                }), (0, $5PpAs.isNotEmpty)(msg.from_index) && {
                    from_index: msg.from_index
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    pool_id: msg.pool_id,
                    from_index: msg.from_index
                };
            }
        }
    };
};
module.exports.createBundlesAminoConverters = $2f36491ee9b6bf43$var$createBundlesAminoConverters;

});
parcelRegister("5PpAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNotEmpty = void 0;
var $43e59034e88cd73c$var$isNotEmpty = function(val) {
    return !!val && val !== "0";
};
module.exports.isNotEmpty = $43e59034e88cd73c$var$isNotEmpty;

});


parcelRegister("dqNBs", function(module, exports) {
"use strict";
var $9c742e32e5f0c25e$var$__assign = module.exports && module.exports.__assign || function() {
    $9c742e32e5f0c25e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9c742e32e5f0c25e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createDelegationAminoConverters = void 0;

var $5PpAs = parcelRequire("5PpAs");
var $9c742e32e5f0c25e$var$createDelegationAminoConverters = function() {
    return {
        "/kyve.delegation.v1beta1.MsgDelegate": {
            aminoType: "kyve/delegation/MsgDelegate",
            toAmino: function(msg) {
                return $9c742e32e5f0c25e$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    amount: msg.amount
                };
            }
        },
        "/kyve.delegation.v1beta1.MsgWithdrawRewards": {
            aminoType: "kyve/delegation/MsgWithdrawRewards",
            toAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker
                };
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker
                };
            }
        },
        "/kyve.delegation.v1beta1.MsgRedelegate": {
            aminoType: "kyve/delegation/MsgRedelegate",
            toAmino: function(msg) {
                return $9c742e32e5f0c25e$var$__assign({
                    creator: msg.creator,
                    from_staker: msg.from_staker,
                    to_staker: msg.to_staker
                }, (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    from_staker: msg.from_staker,
                    to_staker: msg.to_staker,
                    amount: msg.amount
                };
            }
        },
        "/kyve.delegation.v1beta1.MsgUndelegate": {
            aminoType: "kyve/delegation/MsgUndelegate",
            toAmino: function(msg) {
                return $9c742e32e5f0c25e$var$__assign({
                    creator: msg.creator,
                    staker: msg.staker
                }, (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    staker: msg.staker,
                    amount: msg.amount
                };
            }
        }
    };
};
module.exports.createDelegationAminoConverters = $9c742e32e5f0c25e$var$createDelegationAminoConverters;

});

parcelRegister("03DMb", function(module, exports) {
"use strict";
var $00af22a4187382df$var$__assign = module.exports && module.exports.__assign || function() {
    $00af22a4187382df$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $00af22a4187382df$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFundersAminoConverters = void 0;

var $5PpAs = parcelRequire("5PpAs");
var $00af22a4187382df$var$createFundersAminoConverters = function() {
    return {
        "/kyve.funders.v1beta1.MsgFundPool": {
            aminoType: "kyve/funders/MsgFundPool",
            toAmino: function(msg) {
                return $00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                }), (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                }), (0, $5PpAs.isNotEmpty)(msg.amount_per_bundle) && {
                    amount_per_bundle: msg.amount_per_bundle
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    pool_id: msg.pool_id,
                    amount: msg.amount,
                    amount_per_bundle: msg.amount_per_bundle
                };
            }
        },
        "/kyve.funders.v1beta1.MsgDefundPool": {
            aminoType: "kyve/funders/MsgDefundPool",
            toAmino: function(msg) {
                return $00af22a4187382df$var$__assign($00af22a4187382df$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    id: msg.pool_id
                }), (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    pool_id: msg.pool_id,
                    amount: msg.amount
                };
            }
        },
        "/kyve.funders.v1beta1.MsgCreateFunder": {
            aminoType: "kyve/funders/MsgCreateFunder",
            toAmino: function(msg) {
                return $00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.moniker) && {
                    moniker: msg.moniker
                }), (0, $5PpAs.isNotEmpty)(msg.description) && {
                    description: msg.description
                }), (0, $5PpAs.isNotEmpty)(msg.website) && {
                    website: msg.website
                }), (0, $5PpAs.isNotEmpty)(msg.identity) && {
                    identity: msg.identity
                }), (0, $5PpAs.isNotEmpty)(msg.contact) && {
                    contact: msg.contact
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    moniker: msg.moniker,
                    description: msg.description,
                    website: msg.website,
                    identity: msg.identity,
                    contact: msg.contact
                };
            }
        },
        "/kyve.funders.v1beta1.MsgUpdateFunder": {
            aminoType: "kyve/funders/MsgUpdateFunder",
            toAmino: function(msg) {
                return $00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign($00af22a4187382df$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.moniker) && {
                    moniker: msg.moniker
                }), (0, $5PpAs.isNotEmpty)(msg.description) && {
                    description: msg.description
                }), (0, $5PpAs.isNotEmpty)(msg.website) && {
                    website: msg.website
                }), (0, $5PpAs.isNotEmpty)(msg.identity) && {
                    identity: msg.identity
                }), (0, $5PpAs.isNotEmpty)(msg.contact) && {
                    contact: msg.contact
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    moniker: msg.moniker,
                    description: msg.description,
                    website: msg.website,
                    identity: msg.identity,
                    contact: msg.contact
                };
            }
        }
    };
};
module.exports.createFundersAminoConverters = $00af22a4187382df$var$createFundersAminoConverters;

});

parcelRegister("2eLVD", function(module, exports) {
"use strict";
var $1a12113762727a2d$var$__assign = module.exports && module.exports.__assign || function() {
    $1a12113762727a2d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a12113762727a2d$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGovV1AminoConverters = void 0;

var $5PpAs = parcelRequire("5PpAs");
var $1a12113762727a2d$var$createGovV1AminoConverters = function() {
    return {
        "/cosmos.gov.v1.MsgVote": {
            aminoType: "cosmos-sdk/v1/MsgVote",
            toAmino: function(msg) {
                return $1a12113762727a2d$var$__assign({
                    proposal_id: msg.proposal_id,
                    voter: msg.voter,
                    option: msg.option
                }, (0, $5PpAs.isNotEmpty)(msg.metadata) && {
                    metadata: msg.metadata
                });
            },
            fromAmino: function(msg) {
                return {
                    proposal_id: msg.proposal_id,
                    voter: msg.voter,
                    option: msg.option,
                    metadata: msg.metadata
                };
            }
        }
    };
};
module.exports.createGovV1AminoConverters = $1a12113762727a2d$var$createGovV1AminoConverters;

});

parcelRegister("bfoKj", function(module, exports) {
"use strict";
var $83044a78f635aa27$var$__assign = module.exports && module.exports.__assign || function() {
    $83044a78f635aa27$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $83044a78f635aa27$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createStakersAminoConverters = void 0;

var $h3uvW = parcelRequire("h3uvW");

var $5PpAs = parcelRequire("5PpAs");
function $83044a78f635aa27$var$protoDecimalToJson(decimal) {
    var parsed = $h3uvW.Decimal.fromAtomics(decimal, 18);
    var _a = parsed.toString().split("."), whole = _a[0], fractional = _a[1];
    return "".concat(whole, ".").concat((fractional !== null && fractional !== void 0 ? fractional : "").padEnd(18, "0"));
}
function $83044a78f635aa27$var$jsonDecimalToProto(decimal) {
    var parsed = $h3uvW.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
var $83044a78f635aa27$var$createStakersAminoConverters = function() {
    return {
        "/kyve.stakers.v1beta1.MsgCreateStaker": {
            aminoType: "kyve/stakers/MsgCreateStaker",
            toAmino: function(msg) {
                return $83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                }), {
                    commission: $83044a78f635aa27$var$protoDecimalToJson(msg.commission)
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    amount: msg.amount,
                    commission: $83044a78f635aa27$var$jsonDecimalToProto(msg.commission)
                };
            }
        },
        "/kyve.stakers.v1beta1.MsgUpdateMetadata": {
            aminoType: "kyve/stakers/MsgUpdateMetadata",
            toAmino: function(msg) {
                return $83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.moniker) && {
                    moniker: msg.moniker
                }), (0, $5PpAs.isNotEmpty)(msg.website) && {
                    website: msg.website
                }), (0, $5PpAs.isNotEmpty)(msg.identity) && {
                    identity: msg.identity
                }), (0, $5PpAs.isNotEmpty)(msg.security_contact) && {
                    security_contact: msg.security_contact
                }), (0, $5PpAs.isNotEmpty)(msg.details) && {
                    details: msg.details
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    moniker: msg.moniker,
                    website: msg.website,
                    identity: msg.identity,
                    security_contact: msg.security_contact,
                    details: msg.details
                };
            }
        },
        "/kyve.stakers.v1beta1.MsgUpdateCommission": {
            aminoType: "kyve/stakers/MsgUpdateCommission",
            toAmino: function(msg) {
                return {
                    creator: msg.creator,
                    commission: $83044a78f635aa27$var$protoDecimalToJson(msg.commission)
                };
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    commission: $83044a78f635aa27$var$jsonDecimalToProto(msg.commission)
                };
            }
        },
        "/kyve.stakers.v1beta1.MsgClaimCommissionRewards": {
            aminoType: "kyve/stakers/MsgClaimCommissionRewards",
            toAmino: function(msg) {
                return $83044a78f635aa27$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    amount: msg.amount
                };
            }
        },
        "/kyve.stakers.v1beta1.MsgJoinPool": {
            aminoType: "kyve/stakers/MsgJoinPool",
            toAmino: function(msg) {
                return $83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign($83044a78f635aa27$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                }), {
                    valaddress: msg.valaddress
                }), (0, $5PpAs.isNotEmpty)(msg.amount) && {
                    amount: msg.amount
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    pool_id: msg.pool_id,
                    valaddress: msg.valaddress,
                    amount: msg.amount
                };
            }
        },
        "/kyve.stakers.v1beta1.MsgLeavePool": {
            aminoType: "kyve/stakers/MsgLeavePool",
            toAmino: function(msg) {
                return $83044a78f635aa27$var$__assign({
                    creator: msg.creator
                }, (0, $5PpAs.isNotEmpty)(msg.pool_id) && {
                    pool_id: msg.pool_id
                });
            },
            fromAmino: function(msg) {
                return {
                    creator: msg.creator,
                    pool_id: msg.pool_id
                };
            }
        }
    };
};
module.exports.createStakersAminoConverters = $83044a78f635aa27$var$createStakersAminoConverters;

});

// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$recordQueue = [];
var $f347e48613385d9c$var$willProcessRecordQueue = false;
function $f347e48613385d9c$var$flushObserver() {
    $f347e48613385d9c$var$recordQueue = $f347e48613385d9c$var$recordQueue.concat($f347e48613385d9c$var$observer.takeRecords());
    if ($f347e48613385d9c$var$recordQueue.length && !$f347e48613385d9c$var$willProcessRecordQueue) {
        $f347e48613385d9c$var$willProcessRecordQueue = true;
        queueMicrotask(()=>{
            $f347e48613385d9c$var$processRecordQueue();
            $f347e48613385d9c$var$willProcessRecordQueue = false;
        });
    }
}
function $f347e48613385d9c$var$processRecordQueue() {
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$recordQueue);
    $f347e48613385d9c$var$recordQueue.length = 0;
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = [];
    let addedAttributes = new Map();
    let removedAttributes = new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].addedNodes.forEach((node)=>node.nodeType === 1 && addedNodes.push(node));
            mutations[i].removedNodes.forEach((node)=>node.nodeType === 1 && removedNodes.push(node));
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.includes(node)) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
        if (node._x_cleanups) while(node._x_cleanups.length)node._x_cleanups.pop()();
    }
    addedNodes.forEach((node)=>{
        node._x_ignoreSelf = true;
        node._x_ignore = true;
    });
    for (let node of addedNodes){
        if (removedNodes.includes(node)) continue;
        if (!node.isConnected) continue;
        delete node._x_ignoreSelf;
        delete node._x_ignore;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
        node._x_ignore = true;
        node._x_ignoreSelf = true;
    }
    addedNodes.forEach((node)=>{
        delete node._x_ignoreSelf;
        delete node._x_ignore;
    });
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    let thisProxy = new Proxy({}, {
        ownKeys: ()=>{
            return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
        },
        has: (target, name)=>{
            return objects.some((obj)=>obj.hasOwnProperty(name));
        },
        get: (target, name)=>{
            return (objects.find((obj)=>{
                if (obj.hasOwnProperty(name)) {
                    let descriptor = Object.getOwnPropertyDescriptor(obj, name);
                    if (descriptor.get && descriptor.get._x_alreadyBound || descriptor.set && descriptor.set._x_alreadyBound) return true;
                    if ((descriptor.get || descriptor.set) && descriptor.enumerable) {
                        let getter = descriptor.get;
                        let setter = descriptor.set;
                        let property = descriptor;
                        getter = getter && getter.bind(thisProxy);
                        setter = setter && setter.bind(thisProxy);
                        if (getter) getter._x_alreadyBound = true;
                        if (setter) setter._x_alreadyBound = true;
                        Object.defineProperty(obj, name, {
                            ...property,
                            get: getter,
                            set: setter
                        });
                    }
                    return true;
                }
                return false;
            }) || {})[name];
        },
        set: (target, name, value)=>{
            let closestObjectWithKey = objects.find((obj)=>obj.hasOwnProperty(name));
            if (closestObjectWithKey) closestObjectWithKey[name] = value;
            else objects[objects.length - 1][name] = value;
            return true;
        }
    });
    return thisProxy;
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        let memoizedUtilities = null;
        function getUtilities() {
            if (memoizedUtilities) return memoizedUtilities;
            else {
                let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
                memoizedUtilities = {
                    interceptor: $f347e48613385d9c$var$interceptor,
                    ...utilities
                };
                $f347e48613385d9c$var$onElRemoved(el, cleanup2);
                return memoizedUtilities;
            }
        }
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, getUtilities());
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    Object.assign(error2, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression) || /^(let|const)\s/.test(expression) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            return new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn("Cannot find directive `${directive}`. `${name}` will use the default order of execution");
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors())).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root) {
    $f347e48613385d9c$var$walk(root, (el)=>$f347e48613385d9c$var$cleanupAttributes(el));
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        enter: (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        leave: (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if (el.type === "radio") {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
    } else if (el.type === "checkbox") {
        if (Number.isInteger(value)) el.value = value;
        else if (!Number.isInteger(value) && !Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    const booleanAttributes = [
        "disabled",
        "checked",
        "required",
        "readonly",
        "hidden",
        "open",
        "selected",
        "autofocus",
        "itemscope",
        "multiple",
        "novalidate",
        "allowfullscreen",
        "allowpaymentrequest",
        "formnovalidate",
        "autoplay",
        "controls",
        "loop",
        "muted",
        "playsinline",
        "default",
        "ismap",
        "reversed",
        "async",
        "defer",
        "nomodule"
    ];
    return booleanAttributes.includes(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.12.3",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: $f347e48613385d9c$var$transition,
    setStyles: $f347e48613385d9c$var$setStyles,
    mutateDom: $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
var $f347e48613385d9c$var$slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$extend = Object.assign;
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$shallowGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(false, true);
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$shallowReadonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true, true);
var $f347e48613385d9c$var$arrayInstrumentations = {};
[
    "includes",
    "indexOf",
    "lastIndexOf"
].forEach((key)=>{
    const method = Array.prototype[key];
    $f347e48613385d9c$var$arrayInstrumentations[key] = function(...args) {
        const arr = $f347e48613385d9c$var$toRaw(this);
        for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
        const res = method.apply(arr, args);
        if (res === -1 || res === false) return method.apply(arr, args.map($f347e48613385d9c$var$toRaw));
        else return res;
    };
});
[
    "push",
    "pop",
    "shift",
    "unshift",
    "splice"
].forEach((key)=>{
    const method = Array.prototype[key];
    $f347e48613385d9c$var$arrayInstrumentations[key] = function(...args) {
        $f347e48613385d9c$var$pauseTracking();
        const res = method.apply(this, args);
        $f347e48613385d9c$var$resetTracking();
        return res;
    };
});
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
var $f347e48613385d9c$var$shallowSet = /* @__PURE__ */ $f347e48613385d9c$var$createSetter(true);
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$shallowReactiveHandlers = $f347e48613385d9c$var$extend({}, $f347e48613385d9c$var$mutableHandlers, {
    get: $f347e48613385d9c$var$shallowGet,
    set: $f347e48613385d9c$var$shallowSet
});
var $f347e48613385d9c$var$shallowReadonlyHandlers = $f347e48613385d9c$var$extend({}, $f347e48613385d9c$var$readonlyHandlers, {
    get: $f347e48613385d9c$var$shallowReadonlyGet
});
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
var $f347e48613385d9c$var$mutableInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key);
    },
    get size () {
        return $f347e48613385d9c$var$size(this);
    },
    has: $f347e48613385d9c$var$has$1,
    add: $f347e48613385d9c$var$add,
    set: $f347e48613385d9c$var$set$1,
    delete: $f347e48613385d9c$var$deleteEntry,
    clear: $f347e48613385d9c$var$clear,
    forEach: $f347e48613385d9c$var$createForEach(false, false)
};
var $f347e48613385d9c$var$shallowInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, false, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this);
    },
    has: $f347e48613385d9c$var$has$1,
    add: $f347e48613385d9c$var$add,
    set: $f347e48613385d9c$var$set$1,
    delete: $f347e48613385d9c$var$deleteEntry,
    clear: $f347e48613385d9c$var$clear,
    forEach: $f347e48613385d9c$var$createForEach(false, true)
};
var $f347e48613385d9c$var$readonlyInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this, true);
    },
    has (key) {
        return $f347e48613385d9c$var$has$1.call(this, key, true);
    },
    add: $f347e48613385d9c$var$createReadonlyMethod("add"),
    set: $f347e48613385d9c$var$createReadonlyMethod("set"),
    delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
    clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
    forEach: $f347e48613385d9c$var$createForEach(true, false)
};
var $f347e48613385d9c$var$shallowReadonlyInstrumentations = {
    get (key) {
        return $f347e48613385d9c$var$get$1(this, key, true, true);
    },
    get size () {
        return $f347e48613385d9c$var$size(this, true);
    },
    has (key) {
        return $f347e48613385d9c$var$has$1.call(this, key, true);
    },
    add: $f347e48613385d9c$var$createReadonlyMethod("add"),
    set: $f347e48613385d9c$var$createReadonlyMethod("set"),
    delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
    clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
    forEach: $f347e48613385d9c$var$createForEach(true, true)
};
var $f347e48613385d9c$var$iteratorMethods = [
    "keys",
    "values",
    "entries",
    Symbol.iterator
];
$f347e48613385d9c$var$iteratorMethods.forEach((method)=>{
    $f347e48613385d9c$var$mutableInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
    $f347e48613385d9c$var$readonlyInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
    $f347e48613385d9c$var$shallowInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
    $f347e48613385d9c$var$shallowReadonlyInstrumentations[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
});
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$shallowCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(false, true)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
var $f347e48613385d9c$var$shallowReadonlyCollectionHandlers = {
    get: $f347e48613385d9c$var$createInstrumentationGetter(true, true)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = new WeakMap();
var $f347e48613385d9c$var$readonlyMap = new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, effect: effect3 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let firstTime = true;
        let oldValue;
        let effectReference = effect3(()=>evaluate2((value)=>{
                JSON.stringify(value);
                if (!firstTime) queueMicrotask(()=>{
                    callback(value, oldValue);
                    oldValue = value;
                });
                else oldValue = value;
                firstTime = false;
            }));
        el._x_effects.delete(effectReference);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    let currentEl = el;
    while(currentEl){
        if (currentEl._x_refs) refObjects.push(currentEl._x_refs);
        currentEl = currentEl.parentNode;
    }
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el)=>(name, key = null)=>{
        let root = $f347e48613385d9c$var$closestIdRoot(el, name);
        let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
        return key ? `${name}-${id}-${key}` : `${name}-${id}`;
    });
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash, innerHash, outerHashLatest, innerHashLatest;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer, inner;
        if (firstRun) {
            outer = outerGet();
            innerSet(outer);
            inner = innerGet();
            firstRun = false;
        } else {
            outer = outerGet();
            inner = innerGet();
            outerHashLatest = JSON.stringify(outer);
            innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) {
                inner = innerGet();
                innerSet(outer);
                inner = outer;
            } else {
                outerSet(inner);
                outer = inner;
            }
        }
        outerHash = JSON.stringify(outer);
        innerHash = JSON.stringify(inner);
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                __placeholder: val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    $f347e48613385d9c$var$mutateDom(()=>{
        if (modifiers.includes("prepend")) target.parentNode.insertBefore(clone2, target);
        else if (modifiers.includes("append")) target.parentNode.insertBefore(clone2, target.nextSibling);
        else target.appendChild(clone2);
        $f347e48613385d9c$var$initTree(clone2);
        clone2._x_ignore = true;
    });
    cleanup2(()=>clone2.remove());
});
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", (el, { expression: expression }, { effect: effect3 })=>effect3($f347e48613385d9c$var$evaluateLater(el, expression)));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isKeyEvent(event)) {
            if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        }
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        ctrl: "control",
        slash: "/",
        space: " ",
        spacebar: " ",
        cmd: "meta",
        esc: "escape",
        up: "arrow-up",
        down: "arrow-down",
        left: "arrow-left",
        right: "arrow-right",
        period: ".",
        equal: "=",
        minus: "-",
        underscore: "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                __placeholder: value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill") && [
        null,
        ""
    ].includes(getValue())) el.dispatchEvent(new Event(event, {}));
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set(el.value));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        value = value === void 0 ? getValue() : value;
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail ?? event.target.value;
        else if (el.type === "checkbox") {
            if (Array.isArray(currentValue)) {
                let newValue = modifiers.includes("number") ? $f347e48613385d9c$var$safeParseNumber(event.target.value) : event.target.value;
                return event.target.checked ? currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) return modifiers.includes("number") ? Array.from(event.target.selectedOptions).map((option)=>{
            let rawValue = option.value || option.text;
            return $f347e48613385d9c$var$safeParseNumber(rawValue);
        }) : Array.from(event.target.selectedOptions).map((option)=>{
            return option.value || option.text;
        });
        else {
            let rawValue = event.target.value;
            return modifiers.includes("number") ? $f347e48613385d9c$var$safeParseNumber(rawValue) : modifiers.includes("trim") ? rawValue.trim() : rawValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { cleanup: cleanup2 })=>{
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
}));
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>el2.remove());
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>keys.push(value2), {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>keys.push(value), {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!!lookup[key]._x_effects) lookup[key]._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            lookup[key].remove();
            lookup[key] = null;
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$initTree(clone2);
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$initTree(clone2);
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$walk(clone2, (node)=>{
                if (!!node._x_effects) node._x_effects.forEach($f347e48613385d9c$var$dequeueJob);
            });
            clone2.remove();
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                $event: e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName2, slug) {
    $f347e48613385d9c$var$directive(directiveName2, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName2}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$var$src_default = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$var$src_default;


var $91754c5df1e647b3$exports = {};
const $91754c5df1e647b3$var$DECIMAL = 6;
const $91754c5df1e647b3$var$formatNumber = (amount)=>{
    if (amount) return `${amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
    return "0";
};
const $91754c5df1e647b3$var$toHumamReadable = (amount)=>{
    if (amount) return (Number(BigInt(amount) * BigInt(100) / BigInt(10 ** $91754c5df1e647b3$var$DECIMAL)) / 100).toFixed(2).toString();
    return "0";
};
const $91754c5df1e647b3$var$formatProcent = (procent)=>{
    const formatProcent = procent * 100;
    return formatProcent.toFixed(2).toString();
};
const $91754c5df1e647b3$var$formatAddress = (address)=>{
    if (!address) return "-";
    if (address) return `${address.slice(0, 10)}...${address.slice(address.length - 6)}`;
};
$91754c5df1e647b3$exports = {
    formatNumber: $91754c5df1e647b3$var$formatNumber,
    toHumamReadable: $91754c5df1e647b3$var$toHumamReadable,
    formatProcent: $91754c5df1e647b3$var$formatProcent,
    formatAddress: $91754c5df1e647b3$var$formatAddress
};


var $3c80d7d6fc6c2271$exports = {};
$3c80d7d6fc6c2271$exports = function CosmosApi(baseUrl, reqFetch = fetch) {
    const makeRequest = (subUrl, queryParams = null)=>{
        const filteredObject = queryParams && Object.keys(queryParams).reduce((acc, key)=>{
            if (queryParams[key] !== undefined) acc[key] = queryParams[key];
            return acc;
        }, {});
        const url = new URL(subUrl, baseUrl);
        const urlToReq = filteredObject ? `${url}?${new URLSearchParams({
            ...filteredObject
        })}` : url;
        return reqFetch(urlToReq).then((res)=>res.json());
    };
    return {
        getPermissionsByGranterAndGrantee: (granter, grantee, msgTypeUrl)=>makeRequest("/cosmos/authz/v1beta1/grants", {
                grantee: grantee,
                granter: granter,
                msg_type_url: msgTypeUrl
            }),
        findSendedTrx: (address)=>makeRequest("/cosmos/tx/v1beta1/txs", {
                order_by: "2",
                events: `message.sender='${address}'`
            }),
        getPermissionsByGrantee: (granteeAddress)=>makeRequest(`/cosmos/authz/v1beta1/grants/grantee/${granteeAddress}`)
    };
};


var $d61586ebf0f399fa$exports = {};
"use strict";
Object.defineProperty($d61586ebf0f399fa$exports, "__esModule", {
    value: true
});
function $d61586ebf0f399fa$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $d61586ebf0f399fa$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $d61586ebf0f399fa$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d61586ebf0f399fa$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d61586ebf0f399fa$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $d61586ebf0f399fa$var$_extends() {
    $d61586ebf0f399fa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d61586ebf0f399fa$var$_extends.apply(this, arguments);
}
function $d61586ebf0f399fa$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $d61586ebf0f399fa$var$_setPrototypeOf(subClass, superClass);
}
function $d61586ebf0f399fa$var$_getPrototypeOf(o) {
    $d61586ebf0f399fa$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d61586ebf0f399fa$var$_getPrototypeOf(o);
}
function $d61586ebf0f399fa$var$_setPrototypeOf(o, p) {
    $d61586ebf0f399fa$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d61586ebf0f399fa$var$_setPrototypeOf(o, p);
}
function $d61586ebf0f399fa$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d61586ebf0f399fa$var$_construct(Parent, args, Class) {
    if ($d61586ebf0f399fa$var$_isNativeReflectConstruct()) $d61586ebf0f399fa$var$_construct = Reflect.construct.bind();
    else $d61586ebf0f399fa$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $d61586ebf0f399fa$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $d61586ebf0f399fa$var$_construct.apply(null, arguments);
}
function $d61586ebf0f399fa$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $d61586ebf0f399fa$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $d61586ebf0f399fa$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$d61586ebf0f399fa$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $d61586ebf0f399fa$var$_construct(Class, arguments, $d61586ebf0f399fa$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $d61586ebf0f399fa$var$_setPrototypeOf(Wrapper, Class);
    };
    return $d61586ebf0f399fa$var$_wrapNativeSuper(Class);
}
function $d61586ebf0f399fa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d61586ebf0f399fa$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d61586ebf0f399fa$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d61586ebf0f399fa$var$_arrayLikeToArray(o, minLen);
}
function $d61586ebf0f399fa$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d61586ebf0f399fa$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d61586ebf0f399fa$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d61586ebf0f399fa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d61586ebf0f399fa$var$_toPropertyKey(arg) {
    var key = $d61586ebf0f399fa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $d61586ebf0f399fa$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $d61586ebf0f399fa$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $d61586ebf0f399fa$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $d61586ebf0f399fa$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $d61586ebf0f399fa$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $d61586ebf0f399fa$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($d61586ebf0f399fa$var$LuxonError);
/**
 * @private
 */ var $d61586ebf0f399fa$var$n = "numeric", $d61586ebf0f399fa$var$s = "short", $d61586ebf0f399fa$var$l = "long";
var $d61586ebf0f399fa$var$DATE_SHORT = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$n,
    day: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATE_MED = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$s,
    day: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATE_MED_WITH_WEEKDAY = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$s,
    day: $d61586ebf0f399fa$var$n,
    weekday: $d61586ebf0f399fa$var$s
};
var $d61586ebf0f399fa$var$DATE_FULL = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATE_HUGE = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n,
    weekday: $d61586ebf0f399fa$var$l
};
var $d61586ebf0f399fa$var$TIME_SIMPLE = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$TIME_WITH_SECONDS = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$TIME_WITH_SHORT_OFFSET = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$s
};
var $d61586ebf0f399fa$var$TIME_WITH_LONG_OFFSET = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$l
};
var $d61586ebf0f399fa$var$TIME_24_SIMPLE = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    hourCycle: "h23"
};
var $d61586ebf0f399fa$var$TIME_24_WITH_SECONDS = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    hourCycle: "h23"
};
var $d61586ebf0f399fa$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    hourCycle: "h23",
    timeZoneName: $d61586ebf0f399fa$var$s
};
var $d61586ebf0f399fa$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    hourCycle: "h23",
    timeZoneName: $d61586ebf0f399fa$var$l
};
var $d61586ebf0f399fa$var$DATETIME_SHORT = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$n,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$n,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATETIME_MED = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$s,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATETIME_MED_WITH_SECONDS = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$s,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$s,
    day: $d61586ebf0f399fa$var$n,
    weekday: $d61586ebf0f399fa$var$s,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n
};
var $d61586ebf0f399fa$var$DATETIME_FULL = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$s
};
var $d61586ebf0f399fa$var$DATETIME_FULL_WITH_SECONDS = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$s
};
var $d61586ebf0f399fa$var$DATETIME_HUGE = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n,
    weekday: $d61586ebf0f399fa$var$l,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$l
};
var $d61586ebf0f399fa$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $d61586ebf0f399fa$var$n,
    month: $d61586ebf0f399fa$var$l,
    day: $d61586ebf0f399fa$var$n,
    weekday: $d61586ebf0f399fa$var$l,
    hour: $d61586ebf0f399fa$var$n,
    minute: $d61586ebf0f399fa$var$n,
    second: $d61586ebf0f399fa$var$n,
    timeZoneName: $d61586ebf0f399fa$var$l
};
/**
 * @interface
 */ var $d61586ebf0f399fa$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $d61586ebf0f399fa$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $d61586ebf0f399fa$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $d61586ebf0f399fa$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $d61586ebf0f399fa$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $d61586ebf0f399fa$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $d61586ebf0f399fa$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d61586ebf0f399fa$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $d61586ebf0f399fa$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($d61586ebf0f399fa$var$singleton$1 === null) $d61586ebf0f399fa$var$singleton$1 = new SystemZone();
                return $d61586ebf0f399fa$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($d61586ebf0f399fa$var$Zone);
var $d61586ebf0f399fa$var$dtfCache = {};
function $d61586ebf0f399fa$var$makeDTF(zone) {
    if (!$d61586ebf0f399fa$var$dtfCache[zone]) $d61586ebf0f399fa$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $d61586ebf0f399fa$var$dtfCache[zone];
}
var $d61586ebf0f399fa$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $d61586ebf0f399fa$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $d61586ebf0f399fa$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $d61586ebf0f399fa$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$d61586ebf0f399fa$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $d61586ebf0f399fa$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $d61586ebf0f399fa$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $d61586ebf0f399fa$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$d61586ebf0f399fa$var$ianaZoneCache[name]) $d61586ebf0f399fa$var$ianaZoneCache[name] = new IANAZone(name);
        return $d61586ebf0f399fa$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $d61586ebf0f399fa$var$ianaZoneCache = {};
        $d61586ebf0f399fa$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $d61586ebf0f399fa$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d61586ebf0f399fa$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $d61586ebf0f399fa$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $d61586ebf0f399fa$var$partsOffset(dtf, date) : $d61586ebf0f399fa$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $d61586ebf0f399fa$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $d61586ebf0f399fa$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($d61586ebf0f399fa$var$Zone);
var $d61586ebf0f399fa$var$_excluded = [
    "base"
], $d61586ebf0f399fa$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $d61586ebf0f399fa$var$intlLFCache = {};
function $d61586ebf0f399fa$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $d61586ebf0f399fa$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $d61586ebf0f399fa$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $d61586ebf0f399fa$var$intlDTCache = {};
function $d61586ebf0f399fa$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $d61586ebf0f399fa$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $d61586ebf0f399fa$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $d61586ebf0f399fa$var$intlNumCache = {};
function $d61586ebf0f399fa$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $d61586ebf0f399fa$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $d61586ebf0f399fa$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $d61586ebf0f399fa$var$intlRelCache = {};
function $d61586ebf0f399fa$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $d61586ebf0f399fa$var$_objectWithoutPropertiesLoose(_opts, $d61586ebf0f399fa$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $d61586ebf0f399fa$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $d61586ebf0f399fa$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $d61586ebf0f399fa$var$sysLocaleCache = null;
function $d61586ebf0f399fa$var$systemLocale() {
    if ($d61586ebf0f399fa$var$sysLocaleCache) return $d61586ebf0f399fa$var$sysLocaleCache;
    else {
        $d61586ebf0f399fa$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $d61586ebf0f399fa$var$sysLocaleCache;
    }
}
function $d61586ebf0f399fa$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $d61586ebf0f399fa$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $d61586ebf0f399fa$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $d61586ebf0f399fa$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $d61586ebf0f399fa$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $d61586ebf0f399fa$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $d61586ebf0f399fa$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $d61586ebf0f399fa$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $d61586ebf0f399fa$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $d61586ebf0f399fa$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $d61586ebf0f399fa$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $d61586ebf0f399fa$var$_objectWithoutPropertiesLoose(opts, $d61586ebf0f399fa$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $d61586ebf0f399fa$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $d61586ebf0f399fa$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $d61586ebf0f399fa$var$roundTo(i, 3);
            return $d61586ebf0f399fa$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $d61586ebf0f399fa$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $d61586ebf0f399fa$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $d61586ebf0f399fa$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $d61586ebf0f399fa$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $d61586ebf0f399fa$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $d61586ebf0f399fa$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $d61586ebf0f399fa$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $d61586ebf0f399fa$var$hasRelative()) this.rtf = $d61586ebf0f399fa$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $d61586ebf0f399fa$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $d61586ebf0f399fa$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $d61586ebf0f399fa$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $d61586ebf0f399fa$var$systemLocale());
        var numberingSystemR = numberingSystem || $d61586ebf0f399fa$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $d61586ebf0f399fa$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $d61586ebf0f399fa$var$sysLocaleCache = null;
        $d61586ebf0f399fa$var$intlDTCache = {};
        $d61586ebf0f399fa$var$intlNumCache = {};
        $d61586ebf0f399fa$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $d61586ebf0f399fa$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $d61586ebf0f399fa$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($d61586ebf0f399fa$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($d61586ebf0f399fa$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $d61586ebf0f399fa$var$listStuff(this, length, defaultOK, $d61586ebf0f399fa$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $d61586ebf0f399fa$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this3 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $d61586ebf0f399fa$var$listStuff(this, length, defaultOK, $d61586ebf0f399fa$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $d61586ebf0f399fa$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $d61586ebf0f399fa$var$listStuff(this, undefined, defaultOK, function() {
            return $d61586ebf0f399fa$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $d61586ebf0f399fa$var$DateTime.utc(2016, 11, 13, 9),
                    $d61586ebf0f399fa$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this5 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $d61586ebf0f399fa$var$listStuff(this, length, defaultOK, $d61586ebf0f399fa$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $d61586ebf0f399fa$var$DateTime.utc(-40, 1, 1),
                $d61586ebf0f399fa$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $d61586ebf0f399fa$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $d61586ebf0f399fa$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $d61586ebf0f399fa$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $d61586ebf0f399fa$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $d61586ebf0f399fa$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $d61586ebf0f399fa$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $d61586ebf0f399fa$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $d61586ebf0f399fa$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $d61586ebf0f399fa$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($d61586ebf0f399fa$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $d61586ebf0f399fa$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $d61586ebf0f399fa$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $d61586ebf0f399fa$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $d61586ebf0f399fa$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($d61586ebf0f399fa$var$singleton === null) $d61586ebf0f399fa$var$singleton = new FixedOffsetZone(0);
                return $d61586ebf0f399fa$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($d61586ebf0f399fa$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $d61586ebf0f399fa$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $d61586ebf0f399fa$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $d61586ebf0f399fa$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($d61586ebf0f399fa$var$Zone);
/**
 * @private
 */ function $d61586ebf0f399fa$var$normalizeZone(input, defaultZone) {
    if ($d61586ebf0f399fa$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $d61586ebf0f399fa$var$Zone) return input;
    else if ($d61586ebf0f399fa$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $d61586ebf0f399fa$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $d61586ebf0f399fa$var$FixedOffsetZone.utcInstance;
        else return $d61586ebf0f399fa$var$FixedOffsetZone.parseSpecifier(lowered) || $d61586ebf0f399fa$var$IANAZone.create(input);
    } else if ($d61586ebf0f399fa$var$isNumber(input)) return $d61586ebf0f399fa$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $d61586ebf0f399fa$var$InvalidZone(input);
}
var $d61586ebf0f399fa$var$now = function now() {
    return Date.now();
}, $d61586ebf0f399fa$var$defaultZone = "system", $d61586ebf0f399fa$var$defaultLocale = null, $d61586ebf0f399fa$var$defaultNumberingSystem = null, $d61586ebf0f399fa$var$defaultOutputCalendar = null, $d61586ebf0f399fa$var$twoDigitCutoffYear = 60, $d61586ebf0f399fa$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $d61586ebf0f399fa$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $d61586ebf0f399fa$var$Locale.resetCache();
        $d61586ebf0f399fa$var$IANAZone.resetCache();
    };
    $d61586ebf0f399fa$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $d61586ebf0f399fa$var$now;
            },
            set: function set(n) {
                $d61586ebf0f399fa$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $d61586ebf0f399fa$var$normalizeZone($d61586ebf0f399fa$var$defaultZone, $d61586ebf0f399fa$var$SystemZone.instance);
            },
            set: function set(zone) {
                $d61586ebf0f399fa$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $d61586ebf0f399fa$var$defaultLocale;
            },
            set: function set(locale) {
                $d61586ebf0f399fa$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $d61586ebf0f399fa$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $d61586ebf0f399fa$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $d61586ebf0f399fa$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $d61586ebf0f399fa$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $d61586ebf0f399fa$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $d61586ebf0f399fa$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $d61586ebf0f399fa$var$throwOnInvalid;
            },
            set: function set(t) {
                $d61586ebf0f399fa$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $d61586ebf0f399fa$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $d61586ebf0f399fa$var$isNumber(o) {
    return typeof o === "number";
}
function $d61586ebf0f399fa$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $d61586ebf0f399fa$var$isString(o) {
    return typeof o === "string";
}
function $d61586ebf0f399fa$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $d61586ebf0f399fa$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $d61586ebf0f399fa$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $d61586ebf0f399fa$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $d61586ebf0f399fa$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $d61586ebf0f399fa$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $d61586ebf0f399fa$var$integerBetween(thing, bottom, top) {
    return $d61586ebf0f399fa$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $d61586ebf0f399fa$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $d61586ebf0f399fa$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $d61586ebf0f399fa$var$parseInteger(string) {
    if ($d61586ebf0f399fa$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $d61586ebf0f399fa$var$parseFloating(string) {
    if ($d61586ebf0f399fa$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $d61586ebf0f399fa$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($d61586ebf0f399fa$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $d61586ebf0f399fa$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $d61586ebf0f399fa$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $d61586ebf0f399fa$var$daysInYear(year) {
    return $d61586ebf0f399fa$var$isLeapYear(year) ? 366 : 365;
}
function $d61586ebf0f399fa$var$daysInMonth(year, month) {
    var modMonth = $d61586ebf0f399fa$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $d61586ebf0f399fa$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $d61586ebf0f399fa$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $d61586ebf0f399fa$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $d61586ebf0f399fa$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $d61586ebf0f399fa$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $d61586ebf0f399fa$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $d61586ebf0f399fa$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $d61586ebf0f399fa$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $d61586ebf0f399fa$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $d61586ebf0f399fa$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($d61586ebf0f399fa$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $d61586ebf0f399fa$var$asNumber(v);
    }
    return normalized;
}
function $d61586ebf0f399fa$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $d61586ebf0f399fa$var$padStart(hours, 2) + ":" + $d61586ebf0f399fa$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $d61586ebf0f399fa$var$padStart(hours, 2) + $d61586ebf0f399fa$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $d61586ebf0f399fa$var$timeObject(obj) {
    return $d61586ebf0f399fa$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $d61586ebf0f399fa$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $d61586ebf0f399fa$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $d61586ebf0f399fa$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $d61586ebf0f399fa$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($d61586ebf0f399fa$var$monthsNarrow);
        case "short":
            return [].concat($d61586ebf0f399fa$var$monthsShort);
        case "long":
            return [].concat($d61586ebf0f399fa$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $d61586ebf0f399fa$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $d61586ebf0f399fa$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $d61586ebf0f399fa$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $d61586ebf0f399fa$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($d61586ebf0f399fa$var$weekdaysNarrow);
        case "short":
            return [].concat($d61586ebf0f399fa$var$weekdaysShort);
        case "long":
            return [].concat($d61586ebf0f399fa$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $d61586ebf0f399fa$var$meridiems = [
    "AM",
    "PM"
];
var $d61586ebf0f399fa$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $d61586ebf0f399fa$var$erasShort = [
    "BC",
    "AD"
];
var $d61586ebf0f399fa$var$erasNarrow = [
    "B",
    "A"
];
function $d61586ebf0f399fa$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($d61586ebf0f399fa$var$erasNarrow);
        case "short":
            return [].concat($d61586ebf0f399fa$var$erasShort);
        case "long":
            return [].concat($d61586ebf0f399fa$var$erasLong);
        default:
            return null;
    }
}
function $d61586ebf0f399fa$var$meridiemForDateTime(dt) {
    return $d61586ebf0f399fa$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $d61586ebf0f399fa$var$weekdayForDateTime(dt, length) {
    return $d61586ebf0f399fa$var$weekdays(length)[dt.weekday - 1];
}
function $d61586ebf0f399fa$var$monthForDateTime(dt, length) {
    return $d61586ebf0f399fa$var$months(length)[dt.month - 1];
}
function $d61586ebf0f399fa$var$eraForDateTime(dt, length) {
    return $d61586ebf0f399fa$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $d61586ebf0f399fa$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $d61586ebf0f399fa$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $d61586ebf0f399fa$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $d61586ebf0f399fa$var$_macroTokenToFormatOpts = {
    D: $d61586ebf0f399fa$var$DATE_SHORT,
    DD: $d61586ebf0f399fa$var$DATE_MED,
    DDD: $d61586ebf0f399fa$var$DATE_FULL,
    DDDD: $d61586ebf0f399fa$var$DATE_HUGE,
    t: $d61586ebf0f399fa$var$TIME_SIMPLE,
    tt: $d61586ebf0f399fa$var$TIME_WITH_SECONDS,
    ttt: $d61586ebf0f399fa$var$TIME_WITH_SHORT_OFFSET,
    tttt: $d61586ebf0f399fa$var$TIME_WITH_LONG_OFFSET,
    T: $d61586ebf0f399fa$var$TIME_24_SIMPLE,
    TT: $d61586ebf0f399fa$var$TIME_24_WITH_SECONDS,
    TTT: $d61586ebf0f399fa$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $d61586ebf0f399fa$var$TIME_24_WITH_LONG_OFFSET,
    f: $d61586ebf0f399fa$var$DATETIME_SHORT,
    ff: $d61586ebf0f399fa$var$DATETIME_MED,
    fff: $d61586ebf0f399fa$var$DATETIME_FULL,
    ffff: $d61586ebf0f399fa$var$DATETIME_HUGE,
    F: $d61586ebf0f399fa$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $d61586ebf0f399fa$var$DATETIME_MED_WITH_SECONDS,
    FFF: $d61586ebf0f399fa$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $d61586ebf0f399fa$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $d61586ebf0f399fa$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $d61586ebf0f399fa$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $d61586ebf0f399fa$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $d61586ebf0f399fa$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $d61586ebf0f399fa$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(interval.start, $d61586ebf0f399fa$var$_extends({}, this.opts, opts));
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $d61586ebf0f399fa$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $d61586ebf0f399fa$var$padStart(n, p);
        var opts = $d61586ebf0f399fa$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $d61586ebf0f399fa$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $d61586ebf0f399fa$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $d61586ebf0f399fa$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $d61586ebf0f399fa$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $d61586ebf0f399fa$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $d61586ebf0f399fa$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $d61586ebf0f399fa$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $d61586ebf0f399fa$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $d61586ebf0f399fa$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $d61586ebf0f399fa$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $d61586ebf0f399fa$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $d61586ebf0f399fa$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $d61586ebf0f399fa$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $d61586ebf0f399fa$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $d61586ebf0f399fa$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $d61586ebf0f399fa$var$isoExtendedZone = "(?:" + $d61586ebf0f399fa$var$offsetRegex.source + "?(?:\\[(" + $d61586ebf0f399fa$var$ianaRegex.source + ")\\])?)?";
var $d61586ebf0f399fa$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $d61586ebf0f399fa$var$isoTimeRegex = RegExp("" + $d61586ebf0f399fa$var$isoTimeBaseRegex.source + $d61586ebf0f399fa$var$isoExtendedZone);
var $d61586ebf0f399fa$var$isoTimeExtensionRegex = RegExp("(?:T" + $d61586ebf0f399fa$var$isoTimeRegex.source + ")?");
var $d61586ebf0f399fa$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $d61586ebf0f399fa$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $d61586ebf0f399fa$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $d61586ebf0f399fa$var$extractISOWeekData = $d61586ebf0f399fa$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $d61586ebf0f399fa$var$extractISOOrdinalData = $d61586ebf0f399fa$var$simpleParse("year", "ordinal");
var $d61586ebf0f399fa$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $d61586ebf0f399fa$var$sqlTimeRegex = RegExp($d61586ebf0f399fa$var$isoTimeBaseRegex.source + " ?(?:" + $d61586ebf0f399fa$var$offsetRegex.source + "|(" + $d61586ebf0f399fa$var$ianaRegex.source + "))?");
var $d61586ebf0f399fa$var$sqlTimeExtensionRegex = RegExp("(?: " + $d61586ebf0f399fa$var$sqlTimeRegex.source + ")?");
function $d61586ebf0f399fa$var$int(match, pos, fallback) {
    var m = match[pos];
    return $d61586ebf0f399fa$var$isUndefined(m) ? fallback : $d61586ebf0f399fa$var$parseInteger(m);
}
function $d61586ebf0f399fa$var$extractISOYmd(match, cursor) {
    var item = {
        year: $d61586ebf0f399fa$var$int(match, cursor),
        month: $d61586ebf0f399fa$var$int(match, cursor + 1, 1),
        day: $d61586ebf0f399fa$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $d61586ebf0f399fa$var$extractISOTime(match, cursor) {
    var item = {
        hours: $d61586ebf0f399fa$var$int(match, cursor, 0),
        minutes: $d61586ebf0f399fa$var$int(match, cursor + 1, 0),
        seconds: $d61586ebf0f399fa$var$int(match, cursor + 2, 0),
        milliseconds: $d61586ebf0f399fa$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $d61586ebf0f399fa$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $d61586ebf0f399fa$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $d61586ebf0f399fa$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $d61586ebf0f399fa$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $d61586ebf0f399fa$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $d61586ebf0f399fa$var$isoTimeOnly = RegExp("^T?" + $d61586ebf0f399fa$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $d61586ebf0f399fa$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $d61586ebf0f399fa$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($d61586ebf0f399fa$var$parseFloating(yearStr)),
            months: maybeNegate($d61586ebf0f399fa$var$parseFloating(monthStr)),
            weeks: maybeNegate($d61586ebf0f399fa$var$parseFloating(weekStr)),
            days: maybeNegate($d61586ebf0f399fa$var$parseFloating(dayStr)),
            hours: maybeNegate($d61586ebf0f399fa$var$parseFloating(hourStr)),
            minutes: maybeNegate($d61586ebf0f399fa$var$parseFloating(minuteStr)),
            seconds: maybeNegate($d61586ebf0f399fa$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($d61586ebf0f399fa$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $d61586ebf0f399fa$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $d61586ebf0f399fa$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $d61586ebf0f399fa$var$untruncateYear($d61586ebf0f399fa$var$parseInteger(yearStr)) : $d61586ebf0f399fa$var$parseInteger(yearStr),
        month: $d61586ebf0f399fa$var$monthsShort.indexOf(monthStr) + 1,
        day: $d61586ebf0f399fa$var$parseInteger(dayStr),
        hour: $d61586ebf0f399fa$var$parseInteger(hourStr),
        minute: $d61586ebf0f399fa$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $d61586ebf0f399fa$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $d61586ebf0f399fa$var$weekdaysLong.indexOf(weekdayStr) + 1 : $d61586ebf0f399fa$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $d61586ebf0f399fa$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $d61586ebf0f399fa$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $d61586ebf0f399fa$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $d61586ebf0f399fa$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $d61586ebf0f399fa$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $d61586ebf0f399fa$var$FixedOffsetZone(offset)
    ];
}
function $d61586ebf0f399fa$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $d61586ebf0f399fa$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $d61586ebf0f399fa$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $d61586ebf0f399fa$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $d61586ebf0f399fa$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $d61586ebf0f399fa$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $d61586ebf0f399fa$var$FixedOffsetZone.utcInstance
    ];
}
function $d61586ebf0f399fa$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $d61586ebf0f399fa$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $d61586ebf0f399fa$var$FixedOffsetZone.utcInstance
    ];
}
var $d61586ebf0f399fa$var$isoYmdWithTimeExtensionRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$isoYmdRegex, $d61586ebf0f399fa$var$isoTimeExtensionRegex);
var $d61586ebf0f399fa$var$isoWeekWithTimeExtensionRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$isoWeekRegex, $d61586ebf0f399fa$var$isoTimeExtensionRegex);
var $d61586ebf0f399fa$var$isoOrdinalWithTimeExtensionRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$isoOrdinalRegex, $d61586ebf0f399fa$var$isoTimeExtensionRegex);
var $d61586ebf0f399fa$var$isoTimeCombinedRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$isoTimeRegex);
var $d61586ebf0f399fa$var$extractISOYmdTimeAndOffset = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOYmd, $d61586ebf0f399fa$var$extractISOTime, $d61586ebf0f399fa$var$extractISOOffset, $d61586ebf0f399fa$var$extractIANAZone);
var $d61586ebf0f399fa$var$extractISOWeekTimeAndOffset = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOWeekData, $d61586ebf0f399fa$var$extractISOTime, $d61586ebf0f399fa$var$extractISOOffset, $d61586ebf0f399fa$var$extractIANAZone);
var $d61586ebf0f399fa$var$extractISOOrdinalDateAndTime = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOOrdinalData, $d61586ebf0f399fa$var$extractISOTime, $d61586ebf0f399fa$var$extractISOOffset, $d61586ebf0f399fa$var$extractIANAZone);
var $d61586ebf0f399fa$var$extractISOTimeAndOffset = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOTime, $d61586ebf0f399fa$var$extractISOOffset, $d61586ebf0f399fa$var$extractIANAZone);
/*
 * @private
 */ function $d61586ebf0f399fa$var$parseISODate(s) {
    return $d61586ebf0f399fa$var$parse(s, [
        $d61586ebf0f399fa$var$isoYmdWithTimeExtensionRegex,
        $d61586ebf0f399fa$var$extractISOYmdTimeAndOffset
    ], [
        $d61586ebf0f399fa$var$isoWeekWithTimeExtensionRegex,
        $d61586ebf0f399fa$var$extractISOWeekTimeAndOffset
    ], [
        $d61586ebf0f399fa$var$isoOrdinalWithTimeExtensionRegex,
        $d61586ebf0f399fa$var$extractISOOrdinalDateAndTime
    ], [
        $d61586ebf0f399fa$var$isoTimeCombinedRegex,
        $d61586ebf0f399fa$var$extractISOTimeAndOffset
    ]);
}
function $d61586ebf0f399fa$var$parseRFC2822Date(s) {
    return $d61586ebf0f399fa$var$parse($d61586ebf0f399fa$var$preprocessRFC2822(s), [
        $d61586ebf0f399fa$var$rfc2822,
        $d61586ebf0f399fa$var$extractRFC2822
    ]);
}
function $d61586ebf0f399fa$var$parseHTTPDate(s) {
    return $d61586ebf0f399fa$var$parse(s, [
        $d61586ebf0f399fa$var$rfc1123,
        $d61586ebf0f399fa$var$extractRFC1123Or850
    ], [
        $d61586ebf0f399fa$var$rfc850,
        $d61586ebf0f399fa$var$extractRFC1123Or850
    ], [
        $d61586ebf0f399fa$var$ascii,
        $d61586ebf0f399fa$var$extractASCII
    ]);
}
function $d61586ebf0f399fa$var$parseISODuration(s) {
    return $d61586ebf0f399fa$var$parse(s, [
        $d61586ebf0f399fa$var$isoDuration,
        $d61586ebf0f399fa$var$extractISODuration
    ]);
}
var $d61586ebf0f399fa$var$extractISOTimeOnly = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOTime);
function $d61586ebf0f399fa$var$parseISOTimeOnly(s) {
    return $d61586ebf0f399fa$var$parse(s, [
        $d61586ebf0f399fa$var$isoTimeOnly,
        $d61586ebf0f399fa$var$extractISOTimeOnly
    ]);
}
var $d61586ebf0f399fa$var$sqlYmdWithTimeExtensionRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$sqlYmdRegex, $d61586ebf0f399fa$var$sqlTimeExtensionRegex);
var $d61586ebf0f399fa$var$sqlTimeCombinedRegex = $d61586ebf0f399fa$var$combineRegexes($d61586ebf0f399fa$var$sqlTimeRegex);
var $d61586ebf0f399fa$var$extractISOTimeOffsetAndIANAZone = $d61586ebf0f399fa$var$combineExtractors($d61586ebf0f399fa$var$extractISOTime, $d61586ebf0f399fa$var$extractISOOffset, $d61586ebf0f399fa$var$extractIANAZone);
function $d61586ebf0f399fa$var$parseSQL(s) {
    return $d61586ebf0f399fa$var$parse(s, [
        $d61586ebf0f399fa$var$sqlYmdWithTimeExtensionRegex,
        $d61586ebf0f399fa$var$extractISOYmdTimeAndOffset
    ], [
        $d61586ebf0f399fa$var$sqlTimeCombinedRegex,
        $d61586ebf0f399fa$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $d61586ebf0f399fa$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $d61586ebf0f399fa$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $d61586ebf0f399fa$var$casualMatrix = $d61586ebf0f399fa$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $d61586ebf0f399fa$var$lowOrderMatrix), $d61586ebf0f399fa$var$daysInYearAccurate = 365.2425, $d61586ebf0f399fa$var$daysInMonthAccurate = 30.436875, $d61586ebf0f399fa$var$accurateMatrix = $d61586ebf0f399fa$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $d61586ebf0f399fa$var$daysInYearAccurate / 7,
        days: $d61586ebf0f399fa$var$daysInYearAccurate,
        hours: $d61586ebf0f399fa$var$daysInYearAccurate * 24,
        minutes: $d61586ebf0f399fa$var$daysInYearAccurate * 1440,
        seconds: $d61586ebf0f399fa$var$daysInYearAccurate * 86400,
        milliseconds: $d61586ebf0f399fa$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $d61586ebf0f399fa$var$daysInYearAccurate / 28,
        days: $d61586ebf0f399fa$var$daysInYearAccurate / 4,
        hours: $d61586ebf0f399fa$var$daysInYearAccurate * 24 / 4,
        minutes: $d61586ebf0f399fa$var$daysInYearAccurate * 1440 / 4,
        seconds: $d61586ebf0f399fa$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $d61586ebf0f399fa$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $d61586ebf0f399fa$var$daysInMonthAccurate / 7,
        days: $d61586ebf0f399fa$var$daysInMonthAccurate,
        hours: $d61586ebf0f399fa$var$daysInMonthAccurate * 24,
        minutes: $d61586ebf0f399fa$var$daysInMonthAccurate * 1440,
        seconds: $d61586ebf0f399fa$var$daysInMonthAccurate * 86400,
        milliseconds: $d61586ebf0f399fa$var$daysInMonthAccurate * 86400000
    }
}, $d61586ebf0f399fa$var$lowOrderMatrix);
// units ordered by size
var $d61586ebf0f399fa$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $d61586ebf0f399fa$var$reverseUnits = $d61586ebf0f399fa$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $d61586ebf0f399fa$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $d61586ebf0f399fa$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $d61586ebf0f399fa$var$Duration(conf);
}
function $d61586ebf0f399fa$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
}
// NB: mutates parameters
function $d61586ebf0f399fa$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $d61586ebf0f399fa$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
}
// NB: mutates parameters
function $d61586ebf0f399fa$var$normalizeValues(matrix, vals) {
    $d61586ebf0f399fa$var$reverseUnits.reduce(function(previous, current) {
        if (!$d61586ebf0f399fa$var$isUndefined(vals[current])) {
            if (previous) $d61586ebf0f399fa$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $d61586ebf0f399fa$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $d61586ebf0f399fa$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $d61586ebf0f399fa$var$accurateMatrix : $d61586ebf0f399fa$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $d61586ebf0f399fa$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $d61586ebf0f399fa$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $d61586ebf0f399fa$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $d61586ebf0f399fa$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($d61586ebf0f399fa$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $d61586ebf0f399fa$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $d61586ebf0f399fa$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $d61586ebf0f399fa$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d61586ebf0f399fa$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $d61586ebf0f399fa$var$Invalid ? reason : new $d61586ebf0f399fa$var$Invalid(reason, explanation);
        if ($d61586ebf0f399fa$var$Settings.throwOnInvalid) throw new $d61586ebf0f399fa$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $d61586ebf0f399fa$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $d61586ebf0f399fa$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $d61586ebf0f399fa$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $d61586ebf0f399fa$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $d61586ebf0f399fa$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($d61586ebf0f399fa$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($d61586ebf0f399fa$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($d61586ebf0f399fa$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $d61586ebf0f399fa$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $d61586ebf0f399fa$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $d61586ebf0f399fa$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $d61586ebf0f399fa$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($d61586ebf0f399fa$var$hasOwnProperty(dur.values, k) || $d61586ebf0f399fa$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $d61586ebf0f399fa$var$asNumber(fn(this.values[k], k));
        }
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $d61586ebf0f399fa$var$_extends({}, this.values, $d61586ebf0f399fa$var$normalizeObject(values, Duration.normalizeUnit));
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $d61586ebf0f399fa$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $d61586ebf0f399fa$var$normalizeValues(this.matrix, vals);
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $d61586ebf0f399fa$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $d61586ebf0f399fa$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($d61586ebf0f399fa$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
                // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($d61586ebf0f399fa$var$orderedUnits$1.indexOf(down) > $d61586ebf0f399fa$var$orderedUnits$1.indexOf(k)) $d61586ebf0f399fa$var$convert(this.matrix, vals, down, built, k);
            // otherwise, keep it in the wings to boil it later
            } else if ($d61586ebf0f399fa$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: built
        }, true).normalize();
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $d61586ebf0f399fa$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $d61586ebf0f399fa$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $d61586ebf0f399fa$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $d61586ebf0f399fa$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $d61586ebf0f399fa$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $d61586ebf0f399fa$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $d61586ebf0f399fa$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $d61586ebf0f399fa$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $d61586ebf0f399fa$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d61586ebf0f399fa$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $d61586ebf0f399fa$var$Invalid ? reason : new $d61586ebf0f399fa$var$Invalid(reason, explanation);
        if ($d61586ebf0f399fa$var$Settings.throwOnInvalid) throw new $d61586ebf0f399fa$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $d61586ebf0f399fa$var$friendlyDateTime(start), builtEnd = $d61586ebf0f399fa$var$friendlyDateTime(end);
        var validateError = $d61586ebf0f399fa$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $d61586ebf0f399fa$var$Duration.fromDurationLike(duration), dt = $d61586ebf0f399fa$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $d61586ebf0f399fa$var$Duration.fromDurationLike(duration), dt = $d61586ebf0f399fa$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $d61586ebf0f399fa$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $d61586ebf0f399fa$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $d61586ebf0f399fa$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $d61586ebf0f399fa$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ ;
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($d61586ebf0f399fa$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $d61586ebf0f399fa$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $d61586ebf0f399fa$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $d61586ebf0f399fa$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $d61586ebf0f399fa$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $d61586ebf0f399fa$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $d61586ebf0f399fa$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $d61586ebf0f399fa$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $d61586ebf0f399fa$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $d61586ebf0f399fa$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $d61586ebf0f399fa$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $d61586ebf0f399fa$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $d61586ebf0f399fa$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $d61586ebf0f399fa$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $d61586ebf0f399fa$var$Settings.defaultZone;
        var proto = $d61586ebf0f399fa$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $d61586ebf0f399fa$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $d61586ebf0f399fa$var$normalizeZone(input, $d61586ebf0f399fa$var$Settings.defaultZone);
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $d61586ebf0f399fa$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $d61586ebf0f399fa$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $d61586ebf0f399fa$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $d61586ebf0f399fa$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $d61586ebf0f399fa$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $d61586ebf0f399fa$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $d61586ebf0f399fa$var$hasRelative()
        };
    };
    return Info;
}();
function $d61586ebf0f399fa$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($d61586ebf0f399fa$var$Duration.fromMillis(ms).as("days"));
}
function $d61586ebf0f399fa$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $d61586ebf0f399fa$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $d61586ebf0f399fa$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                results[unit]--;
                cursor = earlier.plus(results);
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $d61586ebf0f399fa$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $d61586ebf0f399fa$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $d61586ebf0f399fa$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $d61586ebf0f399fa$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $d61586ebf0f399fa$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $d61586ebf0f399fa$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $d61586ebf0f399fa$var$hanidecChars = $d61586ebf0f399fa$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $d61586ebf0f399fa$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($d61586ebf0f399fa$var$numberingSystems.hanidec) !== -1) value += $d61586ebf0f399fa$var$hanidecChars.indexOf(str[i]);
            else for(var key in $d61586ebf0f399fa$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $d61586ebf0f399fa$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $d61586ebf0f399fa$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $d61586ebf0f399fa$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $d61586ebf0f399fa$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $d61586ebf0f399fa$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($d61586ebf0f399fa$var$parseDigits(s));
        }
    };
}
var $d61586ebf0f399fa$var$NBSP = String.fromCharCode(160);
var $d61586ebf0f399fa$var$spaceOrNBSP = "[ " + $d61586ebf0f399fa$var$NBSP + "]";
var $d61586ebf0f399fa$var$spaceOrNBSPRegExp = new RegExp($d61586ebf0f399fa$var$spaceOrNBSP, "g");
function $d61586ebf0f399fa$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($d61586ebf0f399fa$var$spaceOrNBSPRegExp, $d61586ebf0f399fa$var$spaceOrNBSP);
}
function $d61586ebf0f399fa$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($d61586ebf0f399fa$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $d61586ebf0f399fa$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($d61586ebf0f399fa$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $d61586ebf0f399fa$var$stripInsensitivities(s) === $d61586ebf0f399fa$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $d61586ebf0f399fa$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $d61586ebf0f399fa$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $d61586ebf0f399fa$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $d61586ebf0f399fa$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $d61586ebf0f399fa$var$unitForToken(token, loc) {
    var one = $d61586ebf0f399fa$var$digitRegex(loc), two = $d61586ebf0f399fa$var$digitRegex(loc, "{2}"), three = $d61586ebf0f399fa$var$digitRegex(loc, "{3}"), four = $d61586ebf0f399fa$var$digitRegex(loc, "{4}"), six = $d61586ebf0f399fa$var$digitRegex(loc, "{6}"), oneOrTwo = $d61586ebf0f399fa$var$digitRegex(loc, "{1,2}"), oneToThree = $d61586ebf0f399fa$var$digitRegex(loc, "{1,3}"), oneToSix = $d61586ebf0f399fa$var$digitRegex(loc, "{1,6}"), oneToNine = $d61586ebf0f399fa$var$digitRegex(loc, "{1,9}"), twoToFour = $d61586ebf0f399fa$var$digitRegex(loc, "{2,4}"), fourToSix = $d61586ebf0f399fa$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($d61586ebf0f399fa$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $d61586ebf0f399fa$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $d61586ebf0f399fa$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $d61586ebf0f399fa$var$intUnit(oneToSix);
            case "yy":
                return $d61586ebf0f399fa$var$intUnit(twoToFour, $d61586ebf0f399fa$var$untruncateYear);
            case "yyyy":
                return $d61586ebf0f399fa$var$intUnit(four);
            case "yyyyy":
                return $d61586ebf0f399fa$var$intUnit(fourToSix);
            case "yyyyyy":
                return $d61586ebf0f399fa$var$intUnit(six);
            // months
            case "M":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "MM":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "MMM":
                return $d61586ebf0f399fa$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $d61586ebf0f399fa$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "LL":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "LLL":
                return $d61586ebf0f399fa$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $d61586ebf0f399fa$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "dd":
                return $d61586ebf0f399fa$var$intUnit(two);
            // ordinals
            case "o":
                return $d61586ebf0f399fa$var$intUnit(oneToThree);
            case "ooo":
                return $d61586ebf0f399fa$var$intUnit(three);
            // time
            case "HH":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "H":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "hh":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "h":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "mm":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "m":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "q":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "qq":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "s":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "ss":
                return $d61586ebf0f399fa$var$intUnit(two);
            case "S":
                return $d61586ebf0f399fa$var$intUnit(oneToThree);
            case "SSS":
                return $d61586ebf0f399fa$var$intUnit(three);
            case "u":
                return $d61586ebf0f399fa$var$simple(oneToNine);
            case "uu":
                return $d61586ebf0f399fa$var$simple(oneOrTwo);
            case "uuu":
                return $d61586ebf0f399fa$var$intUnit(one);
            // meridiem
            case "a":
                return $d61586ebf0f399fa$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $d61586ebf0f399fa$var$intUnit(four);
            case "kk":
                return $d61586ebf0f399fa$var$intUnit(twoToFour, $d61586ebf0f399fa$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $d61586ebf0f399fa$var$intUnit(oneOrTwo);
            case "WW":
                return $d61586ebf0f399fa$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $d61586ebf0f399fa$var$intUnit(one);
            case "EEE":
                return $d61586ebf0f399fa$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $d61586ebf0f399fa$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $d61586ebf0f399fa$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $d61586ebf0f399fa$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $d61586ebf0f399fa$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $d61586ebf0f399fa$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $d61586ebf0f399fa$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $d61586ebf0f399fa$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $d61586ebf0f399fa$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $d61586ebf0f399fa$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $d61586ebf0f399fa$var$tokenForPart(part, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    var val = $d61586ebf0f399fa$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $d61586ebf0f399fa$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $d61586ebf0f399fa$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($d61586ebf0f399fa$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $d61586ebf0f399fa$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$d61586ebf0f399fa$var$isUndefined(matches.z)) zone = $d61586ebf0f399fa$var$IANAZone.create(matches.z);
    if (!$d61586ebf0f399fa$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $d61586ebf0f399fa$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$d61586ebf0f399fa$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$d61586ebf0f399fa$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$d61586ebf0f399fa$var$isUndefined(matches.u)) matches.S = $d61586ebf0f399fa$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $d61586ebf0f399fa$var$dummyDateTimeCache = null;
function $d61586ebf0f399fa$var$getDummyDateTime() {
    if (!$d61586ebf0f399fa$var$dummyDateTimeCache) $d61586ebf0f399fa$var$dummyDateTimeCache = $d61586ebf0f399fa$var$DateTime.fromMillis(1555555555555);
    return $d61586ebf0f399fa$var$dummyDateTimeCache;
}
function $d61586ebf0f399fa$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $d61586ebf0f399fa$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $d61586ebf0f399fa$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $d61586ebf0f399fa$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $d61586ebf0f399fa$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $d61586ebf0f399fa$var$explainFromTokens(locale, input, format) {
    var tokens = $d61586ebf0f399fa$var$expandMacroTokens($d61586ebf0f399fa$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $d61586ebf0f399fa$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $d61586ebf0f399fa$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $d61586ebf0f399fa$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $d61586ebf0f399fa$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($d61586ebf0f399fa$var$hasOwnProperty(matches, "a") && $d61586ebf0f399fa$var$hasOwnProperty(matches, "H")) throw new $d61586ebf0f399fa$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $d61586ebf0f399fa$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $d61586ebf0f399fa$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $d61586ebf0f399fa$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $d61586ebf0f399fa$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($d61586ebf0f399fa$var$getDummyDateTime());
    return parts.map(function(p) {
        return $d61586ebf0f399fa$var$tokenForPart(p, formatOpts);
    });
}
var $d61586ebf0f399fa$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $d61586ebf0f399fa$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $d61586ebf0f399fa$var$unitOutOfRange(unit, value) {
    return new $d61586ebf0f399fa$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $d61586ebf0f399fa$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $d61586ebf0f399fa$var$computeOrdinal(year, month, day) {
    return day + ($d61586ebf0f399fa$var$isLeapYear(year) ? $d61586ebf0f399fa$var$leapLadder : $d61586ebf0f399fa$var$nonLeapLadder)[month - 1];
}
function $d61586ebf0f399fa$var$uncomputeOrdinal(year, ordinal) {
    var table = $d61586ebf0f399fa$var$isLeapYear(year) ? $d61586ebf0f399fa$var$leapLadder : $d61586ebf0f399fa$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $d61586ebf0f399fa$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $d61586ebf0f399fa$var$computeOrdinal(year, month, day), weekday = $d61586ebf0f399fa$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $d61586ebf0f399fa$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $d61586ebf0f399fa$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $d61586ebf0f399fa$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $d61586ebf0f399fa$var$timeObject(gregObj));
}
function $d61586ebf0f399fa$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $d61586ebf0f399fa$var$dayOfWeek(weekYear, 1, 4), yearInDays = $d61586ebf0f399fa$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $d61586ebf0f399fa$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $d61586ebf0f399fa$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $d61586ebf0f399fa$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $d61586ebf0f399fa$var$_extends({
        year: year,
        month: month,
        day: day
    }, $d61586ebf0f399fa$var$timeObject(weekData));
}
function $d61586ebf0f399fa$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $d61586ebf0f399fa$var$computeOrdinal(year, month, day);
    return $d61586ebf0f399fa$var$_extends({
        year: year,
        ordinal: ordinal
    }, $d61586ebf0f399fa$var$timeObject(gregData));
}
function $d61586ebf0f399fa$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $d61586ebf0f399fa$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $d61586ebf0f399fa$var$_extends({
        year: year,
        month: month,
        day: day
    }, $d61586ebf0f399fa$var$timeObject(ordinalData));
}
function $d61586ebf0f399fa$var$hasInvalidWeekData(obj) {
    var validYear = $d61586ebf0f399fa$var$isInteger(obj.weekYear), validWeek = $d61586ebf0f399fa$var$integerBetween(obj.weekNumber, 1, $d61586ebf0f399fa$var$weeksInWeekYear(obj.weekYear)), validWeekday = $d61586ebf0f399fa$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $d61586ebf0f399fa$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $d61586ebf0f399fa$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $d61586ebf0f399fa$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $d61586ebf0f399fa$var$hasInvalidOrdinalData(obj) {
    var validYear = $d61586ebf0f399fa$var$isInteger(obj.year), validOrdinal = $d61586ebf0f399fa$var$integerBetween(obj.ordinal, 1, $d61586ebf0f399fa$var$daysInYear(obj.year));
    if (!validYear) return $d61586ebf0f399fa$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $d61586ebf0f399fa$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $d61586ebf0f399fa$var$hasInvalidGregorianData(obj) {
    var validYear = $d61586ebf0f399fa$var$isInteger(obj.year), validMonth = $d61586ebf0f399fa$var$integerBetween(obj.month, 1, 12), validDay = $d61586ebf0f399fa$var$integerBetween(obj.day, 1, $d61586ebf0f399fa$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $d61586ebf0f399fa$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $d61586ebf0f399fa$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $d61586ebf0f399fa$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $d61586ebf0f399fa$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $d61586ebf0f399fa$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $d61586ebf0f399fa$var$integerBetween(minute, 0, 59), validSecond = $d61586ebf0f399fa$var$integerBetween(second, 0, 59), validMillisecond = $d61586ebf0f399fa$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $d61586ebf0f399fa$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $d61586ebf0f399fa$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $d61586ebf0f399fa$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $d61586ebf0f399fa$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $d61586ebf0f399fa$var$INVALID = "Invalid DateTime";
var $d61586ebf0f399fa$var$MAX_DATE = 8.64e15;
function $d61586ebf0f399fa$var$unsupportedZone(zone) {
    return new $d61586ebf0f399fa$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
}
// we cache week data on the DT object and this intermediates the cache
function $d61586ebf0f399fa$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $d61586ebf0f399fa$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $d61586ebf0f399fa$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $d61586ebf0f399fa$var$DateTime($d61586ebf0f399fa$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $d61586ebf0f399fa$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $d61586ebf0f399fa$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $d61586ebf0f399fa$var$objToTS(obj, offset, zone) {
    return $d61586ebf0f399fa$var$fixOffset($d61586ebf0f399fa$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $d61586ebf0f399fa$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $d61586ebf0f399fa$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $d61586ebf0f399fa$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $d61586ebf0f399fa$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $d61586ebf0f399fa$var$objToLocalTS(c);
    var _fixOffset = $d61586ebf0f399fa$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $d61586ebf0f399fa$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $d61586ebf0f399fa$var$DateTime.fromObject(parsed, $d61586ebf0f399fa$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $d61586ebf0f399fa$var$DateTime.invalid(new $d61586ebf0f399fa$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $d61586ebf0f399fa$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $d61586ebf0f399fa$var$Formatter.create($d61586ebf0f399fa$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $d61586ebf0f399fa$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $d61586ebf0f399fa$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $d61586ebf0f399fa$var$padStart(o.c.month);
        c += "-";
        c += $d61586ebf0f399fa$var$padStart(o.c.day);
    } else {
        c += $d61586ebf0f399fa$var$padStart(o.c.month);
        c += $d61586ebf0f399fa$var$padStart(o.c.day);
    }
    return c;
}
function $d61586ebf0f399fa$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $d61586ebf0f399fa$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $d61586ebf0f399fa$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $d61586ebf0f399fa$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $d61586ebf0f399fa$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $d61586ebf0f399fa$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $d61586ebf0f399fa$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $d61586ebf0f399fa$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $d61586ebf0f399fa$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $d61586ebf0f399fa$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $d61586ebf0f399fa$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $d61586ebf0f399fa$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $d61586ebf0f399fa$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $d61586ebf0f399fa$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $d61586ebf0f399fa$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $d61586ebf0f399fa$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $d61586ebf0f399fa$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $d61586ebf0f399fa$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $d61586ebf0f399fa$var$quickDT(obj, opts) {
    var zone = $d61586ebf0f399fa$var$normalizeZone(opts.zone, $d61586ebf0f399fa$var$Settings.defaultZone), loc = $d61586ebf0f399fa$var$Locale.fromObject(opts), tsNow = $d61586ebf0f399fa$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$d61586ebf0f399fa$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $d61586ebf0f399fa$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($d61586ebf0f399fa$var$isUndefined(obj[u])) obj[u] = $d61586ebf0f399fa$var$defaultUnitValues[u];
        }
        var invalid = $d61586ebf0f399fa$var$hasInvalidGregorianData(obj) || $d61586ebf0f399fa$var$hasInvalidTimeData(obj);
        if (invalid) return $d61586ebf0f399fa$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $d61586ebf0f399fa$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $d61586ebf0f399fa$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $d61586ebf0f399fa$var$diffRelative(start, end, opts) {
    var round = $d61586ebf0f399fa$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $d61586ebf0f399fa$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $d61586ebf0f399fa$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $d61586ebf0f399fa$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $d61586ebf0f399fa$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $d61586ebf0f399fa$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $d61586ebf0f399fa$var$Invalid("invalid input") : null) || (!zone.isValid ? $d61586ebf0f399fa$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $d61586ebf0f399fa$var$isUndefined(config.ts) ? $d61586ebf0f399fa$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $d61586ebf0f399fa$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $d61586ebf0f399fa$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $d61586ebf0f399fa$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $d61586ebf0f399fa$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $d61586ebf0f399fa$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $d61586ebf0f399fa$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $d61586ebf0f399fa$var$FixedOffsetZone.utcInstance;
        return $d61586ebf0f399fa$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $d61586ebf0f399fa$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $d61586ebf0f399fa$var$normalizeZone(options.zone, $d61586ebf0f399fa$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($d61586ebf0f399fa$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $d61586ebf0f399fa$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$d61586ebf0f399fa$var$isNumber(milliseconds)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$d61586ebf0f399fa$var$MAX_DATE || milliseconds > $d61586ebf0f399fa$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $d61586ebf0f399fa$var$normalizeZone(options.zone, $d61586ebf0f399fa$var$Settings.defaultZone),
            loc: $d61586ebf0f399fa$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$d61586ebf0f399fa$var$isNumber(seconds)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $d61586ebf0f399fa$var$normalizeZone(options.zone, $d61586ebf0f399fa$var$Settings.defaultZone),
            loc: $d61586ebf0f399fa$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $d61586ebf0f399fa$var$normalizeZone(opts.zone, $d61586ebf0f399fa$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($d61586ebf0f399fa$var$unsupportedZone(zoneToUse));
        var tsNow = $d61586ebf0f399fa$var$Settings.now(), offsetProvis = !$d61586ebf0f399fa$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $d61586ebf0f399fa$var$normalizeObject(obj, $d61586ebf0f399fa$var$normalizeUnit), containsOrdinal = !$d61586ebf0f399fa$var$isUndefined(normalized.ordinal), containsGregorYear = !$d61586ebf0f399fa$var$isUndefined(normalized.year), containsGregorMD = !$d61586ebf0f399fa$var$isUndefined(normalized.month) || !$d61586ebf0f399fa$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $d61586ebf0f399fa$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $d61586ebf0f399fa$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $d61586ebf0f399fa$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $d61586ebf0f399fa$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $d61586ebf0f399fa$var$orderedWeekUnits;
            defaultValues = $d61586ebf0f399fa$var$defaultWeekUnitValues;
            objNow = $d61586ebf0f399fa$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $d61586ebf0f399fa$var$orderedOrdinalUnits;
            defaultValues = $d61586ebf0f399fa$var$defaultOrdinalUnitValues;
            objNow = $d61586ebf0f399fa$var$gregorianToOrdinal(objNow);
        } else {
            units = $d61586ebf0f399fa$var$orderedUnits;
            defaultValues = $d61586ebf0f399fa$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $d61586ebf0f399fa$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$d61586ebf0f399fa$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $d61586ebf0f399fa$var$hasInvalidWeekData(normalized) : containsOrdinal ? $d61586ebf0f399fa$var$hasInvalidOrdinalData(normalized) : $d61586ebf0f399fa$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $d61586ebf0f399fa$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $d61586ebf0f399fa$var$weekToGregorian(normalized) : containsOrdinal ? $d61586ebf0f399fa$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $d61586ebf0f399fa$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $d61586ebf0f399fa$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $d61586ebf0f399fa$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $d61586ebf0f399fa$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $d61586ebf0f399fa$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $d61586ebf0f399fa$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $d61586ebf0f399fa$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($d61586ebf0f399fa$var$isUndefined(text) || $d61586ebf0f399fa$var$isUndefined(fmt)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $d61586ebf0f399fa$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $d61586ebf0f399fa$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $d61586ebf0f399fa$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $d61586ebf0f399fa$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $d61586ebf0f399fa$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {DateTime} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $d61586ebf0f399fa$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $d61586ebf0f399fa$var$Invalid ? reason : new $d61586ebf0f399fa$var$Invalid(reason, explanation);
        if ($d61586ebf0f399fa$var$Settings.throwOnInvalid) throw new $d61586ebf0f399fa$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $d61586ebf0f399fa$var$formatOptsToTokens(formatOpts, $d61586ebf0f399fa$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $d61586ebf0f399fa$var$expandMacroTokens($d61586ebf0f399fa$var$Formatter.parseFormat(fmt), $d61586ebf0f399fa$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $d61586ebf0f399fa$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($d61586ebf0f399fa$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($d61586ebf0f399fa$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $d61586ebf0f399fa$var$normalizeZone(zone, $d61586ebf0f399fa$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($d61586ebf0f399fa$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $d61586ebf0f399fa$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $d61586ebf0f399fa$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $d61586ebf0f399fa$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $d61586ebf0f399fa$var$normalizeObject(values, $d61586ebf0f399fa$var$normalizeUnit), settingWeekStuff = !$d61586ebf0f399fa$var$isUndefined(normalized.weekYear) || !$d61586ebf0f399fa$var$isUndefined(normalized.weekNumber) || !$d61586ebf0f399fa$var$isUndefined(normalized.weekday), containsOrdinal = !$d61586ebf0f399fa$var$isUndefined(normalized.ordinal), containsGregorYear = !$d61586ebf0f399fa$var$isUndefined(normalized.year), containsGregorMD = !$d61586ebf0f399fa$var$isUndefined(normalized.month) || !$d61586ebf0f399fa$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $d61586ebf0f399fa$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $d61586ebf0f399fa$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $d61586ebf0f399fa$var$weekToGregorian($d61586ebf0f399fa$var$_extends({}, $d61586ebf0f399fa$var$gregorianToWeek(this.c), normalized));
        else if (!$d61586ebf0f399fa$var$isUndefined(normalized.ordinal)) mixed = $d61586ebf0f399fa$var$ordinalToGregorian($d61586ebf0f399fa$var$_extends({}, $d61586ebf0f399fa$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $d61586ebf0f399fa$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($d61586ebf0f399fa$var$isUndefined(normalized.day)) mixed.day = Math.min($d61586ebf0f399fa$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $d61586ebf0f399fa$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $d61586ebf0f399fa$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $d61586ebf0f399fa$var$Duration.fromDurationLike(duration);
        return $d61586ebf0f399fa$var$clone(this, $d61586ebf0f399fa$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $d61586ebf0f399fa$var$Duration.fromDurationLike(duration).negate();
        return $d61586ebf0f399fa$var$clone(this, $d61586ebf0f399fa$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $d61586ebf0f399fa$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $d61586ebf0f399fa$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $d61586ebf0f399fa$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $d61586ebf0f399fa$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $d61586ebf0f399fa$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $d61586ebf0f399fa$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $d61586ebf0f399fa$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $d61586ebf0f399fa$var$_toISODate(this, ext);
        c += "T";
        c += $d61586ebf0f399fa$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $d61586ebf0f399fa$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $d61586ebf0f399fa$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $d61586ebf0f399fa$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $d61586ebf0f399fa$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $d61586ebf0f399fa$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $d61586ebf0f399fa$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $d61586ebf0f399fa$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $d61586ebf0f399fa$var$INVALID;
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $d61586ebf0f399fa$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $d61586ebf0f399fa$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $d61586ebf0f399fa$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $d61586ebf0f399fa$var$maybeArray(unit).map($d61586ebf0f399fa$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $d61586ebf0f399fa$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $d61586ebf0f399fa$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $d61586ebf0f399fa$var$diffRelative(base, this.plus(padding), $d61586ebf0f399fa$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $d61586ebf0f399fa$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $d61586ebf0f399fa$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $d61586ebf0f399fa$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $d61586ebf0f399fa$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $d61586ebf0f399fa$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $d61586ebf0f399fa$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $d61586ebf0f399fa$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $d61586ebf0f399fa$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $d61586ebf0f399fa$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $d61586ebf0f399fa$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $d61586ebf0f399fa$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $d61586ebf0f399fa$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $d61586ebf0f399fa$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $d61586ebf0f399fa$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $d61586ebf0f399fa$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $d61586ebf0f399fa$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $d61586ebf0f399fa$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $d61586ebf0f399fa$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $d61586ebf0f399fa$var$friendlyDateTime(dateTimeish) {
    if ($d61586ebf0f399fa$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $d61586ebf0f399fa$var$isNumber(dateTimeish.valueOf())) return $d61586ebf0f399fa$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $d61586ebf0f399fa$var$DateTime.fromObject(dateTimeish);
    else throw new $d61586ebf0f399fa$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $d61586ebf0f399fa$var$VERSION = "3.3.0";
$d61586ebf0f399fa$exports.DateTime = $d61586ebf0f399fa$var$DateTime;
$d61586ebf0f399fa$exports.Duration = $d61586ebf0f399fa$var$Duration;
$d61586ebf0f399fa$exports.FixedOffsetZone = $d61586ebf0f399fa$var$FixedOffsetZone;
$d61586ebf0f399fa$exports.IANAZone = $d61586ebf0f399fa$var$IANAZone;
$d61586ebf0f399fa$exports.Info = $d61586ebf0f399fa$var$Info;
$d61586ebf0f399fa$exports.Interval = $d61586ebf0f399fa$var$Interval;
$d61586ebf0f399fa$exports.InvalidZone = $d61586ebf0f399fa$var$InvalidZone;
$d61586ebf0f399fa$exports.Settings = $d61586ebf0f399fa$var$Settings;
$d61586ebf0f399fa$exports.SystemZone = $d61586ebf0f399fa$var$SystemZone;
$d61586ebf0f399fa$exports.VERSION = $d61586ebf0f399fa$var$VERSION;
$d61586ebf0f399fa$exports.Zone = $d61586ebf0f399fa$var$Zone;


function $1b5dc67d14d9d1a0$export$3c9771e664da2834(isoDate) {
    const expiryDate = (0, $d61586ebf0f399fa$exports.DateTime).fromISO(isoDate);
    const now = (0, $d61586ebf0f399fa$exports.DateTime).now();
    const diff = expiryDate.diff(now);
    const duration = diff.shiftTo("years", "months", "days", "hours");
    let toPlural = (num, text)=>num > 1 ? text : text.slice(0, -1);
    const { years: years, months: months, days: days, hours: hours, minutes: minutes, seconds: seconds } = duration;
    for (let [typeOfTime, value] of Object.entries({
        years: years,
        months: months,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
    })){
        if (value > 0) return {
            message: `${value} ${toPlural(value, typeOfTime)}`,
            type: typeOfTime,
            value: value
        };
    }
    return {
        message: null,
        type: null,
        value: null
    };
}


var $70af30925d1fdc8d$exports = {};
"use strict";
var $70af30925d1fdc8d$var$__createBinding = $70af30925d1fdc8d$exports && $70af30925d1fdc8d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $70af30925d1fdc8d$var$__setModuleDefault = $70af30925d1fdc8d$exports && $70af30925d1fdc8d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $70af30925d1fdc8d$var$__exportStar = $70af30925d1fdc8d$exports && $70af30925d1fdc8d$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $70af30925d1fdc8d$var$__createBinding(exports1, m, p);
};
var $70af30925d1fdc8d$var$__importStar = $70af30925d1fdc8d$exports && $70af30925d1fdc8d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $70af30925d1fdc8d$var$__createBinding(result, mod, k);
    }
    $70af30925d1fdc8d$var$__setModuleDefault(result, mod);
    return result;
};
var $70af30925d1fdc8d$var$__importDefault = $70af30925d1fdc8d$exports && $70af30925d1fdc8d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($70af30925d1fdc8d$exports, "__esModule", {
    value: true
});
$70af30925d1fdc8d$exports.default = $70af30925d1fdc8d$exports.registry = $70af30925d1fdc8d$exports.constants = $70af30925d1fdc8d$exports.KyveWebClient = $70af30925d1fdc8d$exports.KyveClient = void 0;

$70af30925d1fdc8d$var$__exportStar((parcelRequire("jlosq")), $70af30925d1fdc8d$exports);

var $1oIL0 = parcelRequire("1oIL0");
Object.defineProperty($70af30925d1fdc8d$exports, "KyveClient", {
    enumerable: true,
    get: function() {
        return $70af30925d1fdc8d$var$__importDefault($1oIL0).default;
    }
});

var $dgeoZ = parcelRequire("dgeoZ");
Object.defineProperty($70af30925d1fdc8d$exports, "KyveWebClient", {
    enumerable: true,
    get: function() {
        return $70af30925d1fdc8d$var$__importDefault($dgeoZ).default;
    }
});

$70af30925d1fdc8d$exports.constants = $70af30925d1fdc8d$var$__importStar((parcelRequire("2M7Hy")));

var $jVVQx = parcelRequire("jVVQx");
Object.defineProperty($70af30925d1fdc8d$exports, "registry", {
    enumerable: true,
    get: function() {
        return $jVVQx.registry;
    }
});
var $4aaa8994ca4b1c65$exports = {};
"use strict";
var $4aaa8994ca4b1c65$var$__assign = $4aaa8994ca4b1c65$exports && $4aaa8994ca4b1c65$exports.__assign || function() {
    $4aaa8994ca4b1c65$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4aaa8994ca4b1c65$var$__assign.apply(this, arguments);
};
var $4aaa8994ca4b1c65$var$__awaiter = $4aaa8994ca4b1c65$exports && $4aaa8994ca4b1c65$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4aaa8994ca4b1c65$var$__generator = $4aaa8994ca4b1c65$exports && $4aaa8994ca4b1c65$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($4aaa8994ca4b1c65$exports, "__esModule", {
    value: true
});
$4aaa8994ca4b1c65$exports.KyveSDK = void 0;

var $bVJSA = parcelRequire("bVJSA");

var $94ZnX = parcelRequire("94ZnX");

var $dtY18 = parcelRequire("dtY18");

var $3sP6O = parcelRequire("3sP6O");
var $4f809ed9447b15e3$exports = {};
"use strict";
var $4f809ed9447b15e3$var$__assign = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__assign || function() {
    $4f809ed9447b15e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4f809ed9447b15e3$var$__assign.apply(this, arguments);
};
var $4f809ed9447b15e3$var$__createBinding = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4f809ed9447b15e3$var$__setModuleDefault = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4f809ed9447b15e3$var$__importStar = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4f809ed9447b15e3$var$__createBinding(result, mod, k);
    }
    $4f809ed9447b15e3$var$__setModuleDefault(result, mod);
    return result;
};
var $4f809ed9447b15e3$var$__awaiter = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4f809ed9447b15e3$var$__generator = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $4f809ed9447b15e3$var$__spreadArray = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $4f809ed9447b15e3$var$__importDefault = $4f809ed9447b15e3$exports && $4f809ed9447b15e3$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4f809ed9447b15e3$exports, "__esModule", {
    value: true
});
$4f809ed9447b15e3$exports.getSigningKyveClient = void 0;

var $dtY18 = parcelRequire("dtY18");

var $fReUp = parcelRequire("fReUp");

var $fReUp = parcelRequire("fReUp");
var $cb6d7114b9091b48$exports = {};
"use strict";
var $cb6d7114b9091b48$var$__createBinding = $cb6d7114b9091b48$exports && $cb6d7114b9091b48$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb6d7114b9091b48$var$__exportStar = $cb6d7114b9091b48$exports && $cb6d7114b9091b48$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cb6d7114b9091b48$var$__createBinding(exports1, m, p);
};
Object.defineProperty($cb6d7114b9091b48$exports, "__esModule", {
    value: true
});

$cb6d7114b9091b48$var$__exportStar((parcelRequire("43j8s")), $cb6d7114b9091b48$exports);

$cb6d7114b9091b48$var$__exportStar((parcelRequire("dqNBs")), $cb6d7114b9091b48$exports);

$cb6d7114b9091b48$var$__exportStar((parcelRequire("03DMb")), $cb6d7114b9091b48$exports);

$cb6d7114b9091b48$var$__exportStar((parcelRequire("2eLVD")), $cb6d7114b9091b48$exports);

$cb6d7114b9091b48$var$__exportStar((parcelRequire("bfoKj")), $cb6d7114b9091b48$exports);



var $4f809ed9447b15e3$var$KyveRegistryTx = $4f809ed9447b15e3$var$__importStar((parcelRequire("jVVQx")));

var $4f809ed9447b15e3$var$client_1 = $4f809ed9447b15e3$var$__importDefault((parcelRequire("1oIL0")));

var $4f809ed9447b15e3$var$web_client_1 = $4f809ed9447b15e3$var$__importDefault((parcelRequire("dgeoZ")));
function $4f809ed9447b15e3$var$getSigningKyveClient(config, signer, aminoSigner, walletName) {
    return $4f809ed9447b15e3$var$__awaiter(this, void 0, void 0, function() {
        var registry, gasPrice, client, account;
        return $4f809ed9447b15e3$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    registry = new $dtY18.Registry($4f809ed9447b15e3$var$__spreadArray([], $4f809ed9447b15e3$var$KyveRegistryTx.registry, true));
                    gasPrice = $fReUp.GasPrice.fromString("".concat(config.gasPrice).concat(config.coinDenom));
                    return [
                        4 /*yield*/ ,
                        $fReUp.SigningStargateClient.connectWithSigner(config.rpc, signer, {
                            registry: registry,
                            gasPrice: gasPrice,
                            aminoTypes: new $fReUp.AminoTypes($4f809ed9447b15e3$var$__assign($4f809ed9447b15e3$var$__assign($4f809ed9447b15e3$var$__assign($4f809ed9447b15e3$var$__assign($4f809ed9447b15e3$var$__assign($4f809ed9447b15e3$var$__assign({}, (0, $fReUp.createDefaultAminoConverters)()), (0, $cb6d7114b9091b48$exports.createGovV1AminoConverters)()), (0, $cb6d7114b9091b48$exports.createFundersAminoConverters)()), (0, $cb6d7114b9091b48$exports.createStakersAminoConverters)()), (0, $cb6d7114b9091b48$exports.createDelegationAminoConverters)()), (0, $cb6d7114b9091b48$exports.createBundlesAminoConverters)()))
                        })
                    ];
                case 1:
                    client = _a.sent();
                    return [
                        4 /*yield*/ ,
                        signer.getAccounts()
                    ];
                case 2:
                    account = _a.sent()[0];
                    if (typeof walletName === "string") return [
                        2 /*return*/ ,
                        new $4f809ed9447b15e3$var$web_client_1.default(client, account, config, aminoSigner, walletName)
                    ];
                    return [
                        2 /*return*/ ,
                        new $4f809ed9447b15e3$var$client_1.default(client, account, config, aminoSigner)
                    ];
            }
        });
    });
}
$4f809ed9447b15e3$exports.getSigningKyveClient = $4f809ed9447b15e3$var$getSigningKyveClient;



var $jlosq = parcelRequire("jlosq");

var $2M7Hy = parcelRequire("2M7Hy");
var $ba910473acbe1b80$exports = {};
"use strict";
var $ba910473acbe1b80$var$__awaiter = $ba910473acbe1b80$exports && $ba910473acbe1b80$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba910473acbe1b80$var$__generator = $ba910473acbe1b80$exports && $ba910473acbe1b80$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($ba910473acbe1b80$exports, "__esModule", {
    value: true
});
$ba910473acbe1b80$exports.CosmostationSigner = $ba910473acbe1b80$exports.cosmostationMethods = void 0;

var $dtY18 = parcelRequire("dtY18");
$ba910473acbe1b80$exports.cosmostationMethods = {
    getSupportedChains: function() {
        return window.cosmostation.tendermint.request({
            method: "ten_supportedChainNames"
        });
    },
    addChain: function(params) {
        return window.cosmostation.tendermint.request({
            method: "ten_addChain",
            params: params
        });
    },
    requestAccount: function(chainId) {
        return window.cosmostation.tendermint.request({
            method: "ten_requestAccount",
            params: {
                chainName: chainId
            }
        });
    },
    signDirect: function(chainName, doc, options) {
        return window.cosmostation.tendermint.request({
            method: "ten_signDirect",
            params: {
                chainName: chainName,
                doc: doc,
                isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo),
                isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee)
            }
        });
    },
    signAmino: function(chainName, doc, options) {
        return window.cosmostation.tendermint.request({
            method: "ten_signAmino",
            params: {
                chainName: chainName,
                doc: doc,
                isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo),
                isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee),
                gasRate: options === null || options === void 0 ? void 0 : options.gasRate
            }
        });
    }
};
var $ba910473acbe1b80$var$CosmostationSigner = /** @class */ function() {
    function CosmostationSigner(cosmostationAccount, config, cosmostationOption) {
        this.config = config;
        this.cosmostationAccount = cosmostationAccount;
        this.cosmostationOption = cosmostationOption;
    }
    CosmostationSigner.prototype.getAccounts = function() {
        return $ba910473acbe1b80$var$__awaiter(this, void 0, void 0, function() {
            return $ba910473acbe1b80$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    [
                        {
                            address: this.cosmostationAccount.address,
                            // Currently, only secp256k1 is supported.
                            algo: "secp256k1",
                            pubkey: this.cosmostationAccount.publicKey
                        }
                    ]
                ];
            });
        });
    };
    CosmostationSigner.prototype.signDirect = function(signerAddress, signDoc) {
        return $ba910473acbe1b80$var$__awaiter(this, void 0, void 0, function() {
            var signedResult, currentAccountAddress;
            return $ba910473acbe1b80$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.signDirect(this.config.chainId, {
                                chain_id: signDoc.chainId,
                                body_bytes: signDoc.bodyBytes,
                                auth_info_bytes: signDoc.authInfoBytes,
                                account_number: signDoc.accountNumber.toString()
                            }, this.cosmostationOption)
                        ];
                    case 1:
                        signedResult = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.requestAccount(this.config.chainId)
                        ];
                    case 2:
                        currentAccountAddress = _a.sent();
                        if (this.cosmostationAccount.address !== currentAccountAddress.address) throw new Error("Unknown signer address");
                        return [
                            2 /*return*/ ,
                            {
                                signed: (0, $dtY18.makeSignDoc)(signedResult.signed_doc.body_bytes, signedResult.signed_doc.auth_info_bytes, signedResult.signed_doc.chain_id, Number(signedResult.signed_doc.account_number)),
                                signature: {
                                    pub_key: signedResult.pub_key,
                                    signature: signedResult.signature
                                }
                            }
                        ];
                }
            });
        });
    };
    return CosmostationSigner;
}();
$ba910473acbe1b80$exports.CosmostationSigner = $ba910473acbe1b80$var$CosmostationSigner;


var $6a8706ce3d339deb$exports = {};
"use strict";
var $6a8706ce3d339deb$var$__awaiter = $6a8706ce3d339deb$exports && $6a8706ce3d339deb$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6a8706ce3d339deb$var$__generator = $6a8706ce3d339deb$exports && $6a8706ce3d339deb$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty($6a8706ce3d339deb$exports, "__esModule", {
    value: true
});
$6a8706ce3d339deb$exports.KeplrAminoSigner = void 0;
var $6a8706ce3d339deb$var$KeplrAminoSigner = /** @class */ function() {
    function KeplrAminoSigner(keplr, config) {
        this.keplr = keplr;
        this.config = config;
    }
    KeplrAminoSigner.prototype.getAccounts = function() {
        return $6a8706ce3d339deb$var$__awaiter(this, void 0, void 0, function() {
            var key;
            return $6a8706ce3d339deb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.keplr.getKey(this.config.chainId)
                        ];
                    case 1:
                        key = _a.sent();
                        return [
                            2 /*return*/ ,
                            [
                                {
                                    address: key.bech32Address,
                                    // Currently, only secp256k1 is supported.
                                    algo: "secp256k1",
                                    pubkey: key.pubKey
                                }
                            ]
                        ];
                }
            });
        });
    };
    KeplrAminoSigner.prototype.signAmino = function(signerAddress, signDoc) {
        return $6a8706ce3d339deb$var$__awaiter(this, void 0, void 0, function() {
            var key;
            return $6a8706ce3d339deb$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!(signDoc.msgs[0].type === "sign/MsgSignData")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.keplr.signAmino(this.config.chainId, signerAddress, signDoc)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 2:
                        if (this.config.chainId !== signDoc.chain_id) throw new Error("Unmatched chain id with the offline signer");
                        return [
                            4 /*yield*/ ,
                            this.keplr.getKey(this.config.chainId)
                        ];
                    case 3:
                        key = _a.sent();
                        if (key.bech32Address !== signerAddress) throw new Error("Unknown signer address");
                        return [
                            4 /*yield*/ ,
                            this.keplr.signAmino(this.config.chainId, signerAddress, signDoc)
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return KeplrAminoSigner;
}();
$6a8706ce3d339deb$exports.KeplrAminoSigner = $6a8706ce3d339deb$var$KeplrAminoSigner;


/** Class representing a KyveSDK. */ var $4aaa8994ca4b1c65$var$KyveSDK = /** @class */ function() {
    /**
     * Create sdk instance.
     * @param chainId - The chainId of the chain the sdk should connect to [default = kyve-1]
     * @param options - The default config of the sdk can be overwritten here
     */ function KyveSDK(chainId, options) {
        if (chainId === void 0) chainId = "kyve-1";
        this.walletSupports = new Set();
        if (!$2M7Hy.SUPPORTED_CHAIN_CONFIGS[chainId]) throw new Error('ChainId "'.concat(chainId, '" not supported.'));
        this.config = $4aaa8994ca4b1c65$var$__assign({}, $2M7Hy.SUPPORTED_CHAIN_CONFIGS[chainId]);
        if (options === null || options === void 0 ? void 0 : options.chainName) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            chainName: options.chainName
        });
        if (options === null || options === void 0 ? void 0 : options.rpc) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            rpc: options.rpc.replace(/\/$/, "")
        });
        if (options === null || options === void 0 ? void 0 : options.rest) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            rest: options.rest.replace(/\/$/, "")
        });
        if (options === null || options === void 0 ? void 0 : options.coin) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            coin: options.coin
        });
        if (options === null || options === void 0 ? void 0 : options.coinDenom) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            coinDenom: options.coinDenom
        });
        if (options === null || options === void 0 ? void 0 : options.coinDecimals) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            coinDecimals: options.coinDecimals
        });
        if (options === null || options === void 0 ? void 0 : options.gasPrice) this.config = $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, this.config), {
            gasPrice: options.gasPrice
        });
    }
    /**
     * Create a client from mnemonic
     * @param mnemonic
     * @return Promise<KyveClient>
     */ KyveSDK.prototype.fromMnemonic = function(mnemonic) {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var aminoSigner, signedClient;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $bVJSA.Secp256k1HdWallet.fromMnemonic(mnemonic, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 1:
                        aminoSigner = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $dtY18.DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 2:
                        signedClient = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, signedClient, aminoSigner)
                        ];
                }
            });
        });
    };
    /**
     * create a client from private key
     * @param privateKey - hex privateKey
     * @return Promise<KyveClient>
     */ KyveSDK.prototype.fromPrivateKey = function(privateKey) {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var formattedKey, signedClient, aminoSigner;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        formattedKey = (0, $94ZnX.fromHex)(privateKey.startsWith("0x") ? privateKey.slice(2) : privateKey);
                        return [
                            4 /*yield*/ ,
                            $dtY18.DirectSecp256k1Wallet.fromKey(formattedKey, $2M7Hy.PREFIX)
                        ];
                    case 1:
                        signedClient = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $bVJSA.Secp256k1Wallet.fromKey(formattedKey, $2M7Hy.PREFIX)
                        ];
                    case 2:
                        aminoSigner = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, signedClient, aminoSigner)
                        ];
                }
            });
        });
    };
    /**
     * create a client from offline signers
     * @param offlineSigner - offline signer
     * @param offlineAminoSigner - offline amino signer
     * @param walletName - optinal wallet name
     * @return Promise<KyveClient>
     */ KyveSDK.prototype.fromOfflineSigner = function(offlineSigner, offlineAminoSigner, walletName) {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, offlineSigner, offlineAminoSigner, walletName)
                ];
            });
        });
    };
    /**
     * Create a client from Keplr wallet if installed
     * @return Promise<KyveWebClient>
     */ KyveSDK.prototype.fromKeplr = function() {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var KYVE_COIN, signer, walletName, keplr, keplrAminoSigner, client;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof window === "undefined") throw new Error("Unsupported.");
                        if (!window.keplr) throw new Error("Please install Keplr.");
                        KYVE_COIN = {
                            coinDenom: this.config.coin,
                            coinMinimalDenom: this.config.coinDenom,
                            coinDecimals: this.config.coinDecimals
                        };
                        return [
                            4 /*yield*/ ,
                            window.keplr.experimentalSuggestChain($4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, $2M7Hy.KYVE_KEPLR_CONFIG), {
                                chainName: this.config.chainName,
                                chainId: this.config.chainId,
                                rpc: this.config.rpc,
                                rest: this.config.rest,
                                stakeCurrency: KYVE_COIN,
                                currencies: [
                                    KYVE_COIN
                                ],
                                feeCurrencies: [
                                    $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, KYVE_COIN), {
                                        gasPriceStep: {
                                            low: this.config.gasPrice,
                                            average: this.config.gasPrice * 1.5,
                                            high: this.config.gasPrice * 3
                                        }
                                    })
                                ]
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.keplr.enable(this.config.chainId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.keplr.getOfflineSignerAuto(this.config.chainId)
                        ];
                    case 3:
                        signer = _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.keplr.getKey(this.config.chainId)
                        ];
                    case 4:
                        walletName = _a.sent().name;
                        keplr = window.keplr;
                        keplrAminoSigner = new $6a8706ce3d339deb$exports.KeplrAminoSigner(keplr, this.config);
                        return [
                            4 /*yield*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, signer, keplrAminoSigner, walletName)
                        ];
                    case 5:
                        client = _a.sent();
                        this.walletSupports.add($2M7Hy.SUPPORTED_WALLETS.KEPLR);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * Create a client from Cosmostaion wallet if installed
     * @return Promise<KyveWebClient>
     */ KyveSDK.prototype.fromCosmostation = function() {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var chain, cosmostationAccount, cosmostationSigner, client;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof window === "undefined") throw new Error("Unsupported.");
                        if (!window.cosmostation) throw new Error("Please install cosmostation.");
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.getSupportedChains()
                        ];
                    case 1:
                        chain = _a.sent();
                        if (!chain.unofficial.includes(this.config.chainName.toLowerCase().trim())) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.requestAccount(this.config.chainName)
                        ];
                    case 2:
                        cosmostationAccount = _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.addChain($4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, $2M7Hy.KYVE_COSMOSTATION_CONFIG), {
                                restURL: this.config.rest,
                                chainId: this.config.chainId,
                                chainName: this.config.chainName,
                                displayDenom: this.config.coin,
                                baseDenom: this.config.coinDenom,
                                decimals: this.config.coinDecimals,
                                gasRate: {
                                    tiny: this.config.gasPrice.toString(),
                                    low: (this.config.gasPrice * 1.5).toString(),
                                    average: (this.config.gasPrice * 3).toString()
                                }
                            }))
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            $ba910473acbe1b80$exports.cosmostationMethods.requestAccount(this.config.chainName)
                        ];
                    case 5:
                        cosmostationAccount = _a.sent();
                        _a.label = 6;
                    case 6:
                        cosmostationSigner = new $ba910473acbe1b80$exports.CosmostationSigner(cosmostationAccount, this.config, {
                            memo: true,
                            fee: true
                        });
                        return [
                            4 /*yield*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, cosmostationSigner, null, cosmostationAccount.name)
                        ];
                    case 7:
                        client = _a.sent();
                        this.walletSupports.add($2M7Hy.SUPPORTED_WALLETS.COSMOSTATION);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * Create a client from Leap wallet if installed
     * @return Promise<KyveWebClient>
     */ KyveSDK.prototype.fromLeap = function() {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var KYVE_COIN, signer, walletName, leap, keplrAminoSigner, client;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof window === "undefined") throw new Error("Unsupported.");
                        if (!window.leap) throw new Error("Please install Leap.");
                        KYVE_COIN = {
                            coinDenom: this.config.coin,
                            coinMinimalDenom: this.config.coinDenom,
                            coinDecimals: this.config.coinDecimals
                        };
                        return [
                            4 /*yield*/ ,
                            window.leap.experimentalSuggestChain($4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, $2M7Hy.KYVE_LEAP_CONFIG), {
                                chainName: this.config.chainName,
                                chainId: this.config.chainId,
                                rpc: this.config.rpc,
                                rest: this.config.rest,
                                stakeCurrency: KYVE_COIN,
                                currencies: [
                                    KYVE_COIN
                                ],
                                feeCurrencies: [
                                    $4aaa8994ca4b1c65$var$__assign($4aaa8994ca4b1c65$var$__assign({}, KYVE_COIN), {
                                        gasPriceStep: {
                                            low: this.config.gasPrice,
                                            average: this.config.gasPrice * 1.5,
                                            high: this.config.gasPrice * 3
                                        }
                                    })
                                ]
                            }))
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.leap.enable(this.config.chainId)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.leap.getOfflineSigner(this.config.chainId)
                        ];
                    case 3:
                        signer = _a.sent();
                        return [
                            4 /*yield*/ ,
                            window.leap.getKey(this.config.chainId)
                        ];
                    case 4:
                        walletName = _a.sent().name;
                        leap = window.leap;
                        keplrAminoSigner = new $6a8706ce3d339deb$exports.KeplrAminoSigner(leap, this.config);
                        return [
                            4 /*yield*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, signer, keplrAminoSigner, walletName)
                        ];
                    case 5:
                        client = _a.sent();
                        this.walletSupports.add($2M7Hy.SUPPORTED_WALLETS.LEAP);
                        return [
                            2 /*return*/ ,
                            client
                        ];
                }
            });
        });
    };
    /**
     * Listener to detect if account in wallet changed, support fromKeplr and fromCosmostation  instances
     * @param cb
     */ KyveSDK.prototype.onAccountChange = function(cb) {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                if (this.walletSupports.has($2M7Hy.SUPPORTED_WALLETS.KEPLR)) return [
                    2 /*return*/ ,
                    window.addEventListener("keplr_keystorechange", cb)
                ];
                if (this.walletSupports.has($2M7Hy.SUPPORTED_WALLETS.COSMOSTATION)) return [
                    2 /*return*/ ,
                    window.cosmostation.tendermint.on("accountChanged", cb)
                ];
                if (this.walletSupports.has($2M7Hy.SUPPORTED_WALLETS.LEAP)) return [
                    2 /*return*/ ,
                    window.addEventListener("leap_keystorechange", cb)
                ];
                throw new Error("Need to initiate from wallet");
            });
        });
    };
    /**
     * create LCD client to get data from Rest api
     */ KyveSDK.prototype.createLCDClient = function() {
        return (0, $jlosq.createKyveLCDClient)(this.config.rest);
    };
    /**
     * generate KyveClient instance without mnemonic
     */ KyveSDK.prototype.generate = function() {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var signer, aminoSigner;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $dtY18.DirectSecp256k1HdWallet.generate(24, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 1:
                        signer = _a.sent();
                        return [
                            4 /*yield*/ ,
                            $bVJSA.Secp256k1HdWallet.fromMnemonic(signer.mnemonic, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 2:
                        aminoSigner = _a.sent();
                        return [
                            2 /*return*/ ,
                            (0, $4f809ed9447b15e3$exports.getSigningKyveClient)(this.config, signer, aminoSigner)
                        ];
                }
            });
        });
    };
    KyveSDK.generateMnemonic = function() {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var signer;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $dtY18.DirectSecp256k1HdWallet.generate(24, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 1:
                        signer = _a.sent();
                        return [
                            2 /*return*/ ,
                            signer.mnemonic
                        ];
                }
            });
        });
    };
    KyveSDK.getAddressFromPubKey = function(pubKey) {
        return (0, $bVJSA.pubkeyToAddress)({
            type: "tendermint/PubKeySecp256k1",
            value: pubKey
        }, $2M7Hy.PREFIX);
    };
    KyveSDK.getAddressFromMnemonic = function(mnemonic) {
        return $4aaa8994ca4b1c65$var$__awaiter(this, void 0, void 0, function() {
            var aminoSigner, account;
            return $4aaa8994ca4b1c65$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            $bVJSA.Secp256k1HdWallet.fromMnemonic(mnemonic, {
                                prefix: $2M7Hy.PREFIX
                            })
                        ];
                    case 1:
                        aminoSigner = _a.sent();
                        return [
                            4 /*yield*/ ,
                            aminoSigner.getAccounts()
                        ];
                    case 2:
                        account = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            account.address
                        ];
                }
            });
        });
    };
    KyveSDK.verifyString = function(signature, data, pubKey) {
        return (0, $3sP6O.verifyADR36Amino)($2M7Hy.PREFIX, KyveSDK.getAddressFromPubKey(pubKey), new TextEncoder().encode(data), (0, $94ZnX.fromBase64)(pubKey), (0, $94ZnX.fromBase64)(signature));
    };
    return KyveSDK;
}();
$4aaa8994ca4b1c65$exports.KyveSDK = $4aaa8994ca4b1c65$var$KyveSDK;


Object.defineProperty($70af30925d1fdc8d$exports, "default", {
    enumerable: true,
    get: function() {
        return $4aaa8994ca4b1c65$exports.KyveSDK;
    }
});


const $bd21f3bc281d311c$var$sdk = new (0, (/*@__PURE__*/$parcel$interopDefault($70af30925d1fdc8d$exports)))("kyve-1");
var $bd21f3bc281d311c$export$2e2bcd8739ae039 = (dataValidator)=>Alpine.store("wallet", {
        text: "Connect Wallet",
        client: null,
        apiClient: null,
        balance: null,
        delegated: null,
        rewards: null,
        restakeData: {
            isAlive: null,
            expiration: null
        },
        async connect (walletType, valAddress) {
            if (walletType === "keplr") this.client = await $bd21f3bc281d311c$var$sdk.fromKeplr();
            else if (walletType === "leap") this.client = await $bd21f3bc281d311c$var$sdk.fromLeap();
            else if (walletType === "cosmostation") this.client = await $bd21f3bc281d311c$var$sdk.fromCosmostation();
            this.apiClient = $bd21f3bc281d311c$var$sdk.createLCDClient();
            localStorage.setItem("_connected", walletType);
            this.balance = await this.client.getKyveBalance();
            this.text = formatAddress(this.client.account.address);
            const response = await this.apiClient.kyve.query.v1beta1.stakersByDelegator({
                delegator: this.client.account.address
            });
            const staker = response.stakers.find((st)=>st.staker.address === valAddress);
            const cosmosAPI = (0, (/*@__PURE__*/$parcel$interopDefault($3c80d7d6fc6c2271$exports)))(this.client.config.rest);
            this.delegated = staker?.delegation_amount ?? 0;
            this.rewards = staker?.current_reward ?? 0;
            const result = await cosmosAPI.getPermissionsByGranterAndGrantee(this.client.account.address, dataValidator.dataset.grantAddress, "/kyve.delegation.v1beta1.MsgDelegate").catch((error)=>{
                return false;
            });
            console.log(result.grants);
            this.restakeData = {
                isAlive: result?.grants ? new Date(result.grants[0].expiration).getTime() >= Date.now() : undefined,
                expiration: result?.grants ? result.grants[0].expiration : undefined
            };
            $bd21f3bc281d311c$var$sdk.onAccountChange(async ()=>{
                this.clearState();
                location.reload();
            });
        },
        disconnect () {
            this.clearState();
            localStorage.removeItem("_connected");
        },
        restakeExpireAfter () {
            if (!this.restakeData.expiration) return {
                message: null,
                type: null
            };
            const parsedDate = (0, $1b5dc67d14d9d1a0$export$3c9771e664da2834)(this.restakeData.expiration);
            if (parsedDate.type === "hours" || parsedDate.type === "days" && parsedDate.value <= 7) return {
                message: `(${parsedDate.message})`,
                type: "warning"
            };
            return {
                message: `(${(0, $1b5dc67d14d9d1a0$export$3c9771e664da2834)(this.restakeData.expiration).message})`,
                type: "ok"
            };
        },
        clearState () {
            this.text = "Connect Wallet";
            this.client = null;
            this.apiClient = null;
            this.balance = null;
            this.delegated = null;
            this.rewards = null;
            this.restakeData = {
                isAlive: null,
                expiration: null
            };
        }
    });



var $44pFF = parcelRequire("44pFF");
var $1588a0e285317570$export$2e2bcd8739ae039 = ()=>Alpine.data("delegation", (valAddress)=>({
            busy: false,
            amount: 0,
            async delegate (amount) {
                const client = Alpine.store("wallet").client;
                if (client) {
                    this.busy = true;
                    try {
                        const realAmount = (0, (/*@__PURE__*/$parcel$interopDefault($44pFF)))(amount).times(10 ** 6).toString();
                        const result = await client.kyve.delegation.v1beta1.delegate({
                            amount: realAmount,
                            staker: valAddress
                        });
                        Notify.fire({
                            icon: "info",
                            title: "Broadcasting transaction",
                            text: "Please wait",
                            showConfirmButton: false,
                            timer: 20000,
                            timerProgressBar: true
                        });
                        const a = await result.execute().finally((data)=>{
                            this.busy = false;
                        });
                        Notify.fire({
                            icon: "success",
                            title: "Sucess!",
                            html: `Trascation sucessfully broadcast: <a href="https://ping.pub/kyve/tx/${result.txHash}" target=\u{201D}_blank\u{201D}>${result.txHash}</a>`
                        }).then((result)=>{
                            if (result.isConfirmed) location.href = "/";
                        });
                    } finally{
                        this.busy = false;
                    }
                }
            }
        }));



var $a2VlR = parcelRequire("a2VlR");

var $gRS7H = parcelRequire("gRS7H");

var $cPgyI = parcelRequire("cPgyI");
var $6981d81b11ac90e2$export$2e2bcd8739ae039 = ()=>Alpine.data("restake", ()=>({
            amount: null,
            date: null,
            busyRestake: false,
            busyRevoke: false,
            validateDate (date) {
                if (Alpine.store("wallet").delegated !== null && Alpine.store("wallet").delegated <= 0) return "You must delegate tokens to validator first before they can restake for you";
                if (!date) return "Please select a date";
                if (new Date(date) < new Date()) return "Please select a date in the future";
                return false;
            },
            restakeToolTip () {
                if (!Alpine.store("wallet").client?.account?.address) return "Please connect wallet";
                const isDateInvalid = this.validateDate(this.date);
                if (isDateInvalid) return isDateInvalid;
                return null;
            },
            async saveRestake (granteeAddress) {
                const client = Alpine.store("wallet").client;
                if (client) {
                    const unixDate = Math.floor(new Date(this.date).getTime() / 1000);
                    this.busyRestake = true;
                    try {
                        const grantDelegateRewards = {
                            typeUrl: "/cosmos.authz.v1beta1.MsgGrant",
                            value: {
                                granter: client.account.address,
                                grantee: granteeAddress,
                                grant: {
                                    authorization: {
                                        typeUrl: "/cosmos.authz.v1beta1.GenericAuthorization",
                                        value: (0, $a2VlR.GenericAuthorization).encode({
                                            msg: "/kyve.delegation.v1beta1.MsgDelegate",
                                            value: (0, $gRS7H.MsgDelegate).encode({
                                                amount: "1000000",
                                                staker: granteeAddress,
                                                creator: client.account.address
                                            }).finish()
                                        }).finish()
                                    },
                                    expiration: (0, $cPgyI.Timestamp).fromPartial({
                                        seconds: unixDate,
                                        nanos: 0
                                    })
                                }
                            }
                        };
                        Notify.fire({
                            icon: "info",
                            title: "Broadcasting transaction",
                            text: "Please wait",
                            showConfirmButton: false,
                            timer: 20000,
                            timerProgressBar: true
                        });
                        const result = await client.nativeClient.signAndBroadcast(client.account.address, [
                            grantDelegateRewards
                        ], "auto");
                        Notify.fire({
                            icon: "success",
                            title: "Sucess!",
                            html: `Trascation sucessfully broadcasted: <a href="https://ping.pub/kyve/tx/${result.transactionHash}" target=\u{201D}_blank\u{201D}>${result.transactionHash}</a>`
                        }).then((result)=>{
                            if (result.isConfirmed) location.href = "/";
                        });
                    } finally{
                        this.busyRestake = false;
                    }
                }
            },
            async revokeRestake (grantAddress) {
                const client = Alpine.store("wallet").client;
                if (client) {
                    this.busyRevoke = true;
                    try {
                        const revokeGrantDelegate = {
                            typeUrl: "/cosmos.authz.v1beta1.MsgRevoke",
                            value: {
                                granter: client.account.address,
                                grantee: grantAddress,
                                msgTypeUrl: "/kyve.delegation.v1beta1.MsgDelegate"
                            }
                        };
                        Notify.fire({
                            icon: "info",
                            title: "Broadcasting transaction",
                            text: "Please wait",
                            showConfirmButton: false,
                            timer: 20000,
                            timerProgressBar: true
                        });
                        const result = await client.nativeClient.signAndBroadcast(client.account.address, [
                            revokeGrantDelegate
                        ], "auto");
                        Notify.fire({
                            icon: "success",
                            title: "Success!",
                            html: `Trascation sucessfully broadcasted: <a href="https://ping.pub/kyve/tx/${result.transactionHash}" target=\u{201D}_blank\u{201D}>${result.transactionHash}</a>`
                        }).then((result)=>{
                            if (result.isConfirmed) location.href = "/";
                        });
                    } finally{
                        this.busyRevoke = false;
                    }
                }
            }
        }));


/** setup global **/ window.formatNumber = (0, $91754c5df1e647b3$exports.formatNumber);
window.toHumamReadable = (0, $91754c5df1e647b3$exports.toHumamReadable);
window.formatAddress = (0, $91754c5df1e647b3$exports.formatAddress);
window.Alpine = (0, $f347e48613385d9c$export$2e2bcd8739ae039);
// console.log = () => {}
/** end setup global **/ document.addEventListener("readystatechange", ()=>{
    window.onerror = function(event, souce, lineno, colon, error) {
        console.error(error);
        Notify.fire({
            icon: "error",
            title: "Error!",
            text: error.message
        });
    };
    const dataValidator = document.querySelector("body");
    window.Notify = Swal.mixin({
        icon: "error",
        toast: true,
        position: "bottom-end",
        customClass: {
            popup: "colored-toast"
        }
    });
    // init component
    (0, $bd21f3bc281d311c$export$2e2bcd8739ae039)(dataValidator);
    (0, $1588a0e285317570$export$2e2bcd8739ae039)();
    (0, $6981d81b11ac90e2$export$2e2bcd8739ae039)();
    const isConnectedType = localStorage.getItem("_connected");
    if (isConnectedType) (0, $f347e48613385d9c$export$2e2bcd8739ae039).store("wallet").connect(isConnectedType, dataValidator.dataset.validatorAddress);
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).start();
});

})();
//# sourceMappingURL=main.js.map
